/* "use strict"; */
angular.module("ngModules", [
  "ngCookies",
  "ngSanitize",
  "ngMessages",
  "ngResource",
  "ngAnimate"
]);
angular.module("ui.bootstap.fam", ["ui.bootstrap", "ui.bootstrap.position"]);
angular.module("minovate", [
  "ngTouch",
  "picardy.fontawesome",
  "angular-loading-bar",
  "angular-momentjs",
  "monospaced.qrcode",
  "FBAngular",
  "angularBootstrapNavTree",
  "oc.lazyLoad",
  "ui.select",
  "ui.tree",
  /* "textAngular", */
  "colorpicker.module",
  "angularFileUpload",
  "ngImgCrop",
/*   "datatables",
  "datatables.bootstrap",
  "datatables.colreorder",
  "datatables.colvis",
  "datatables.tabletools",
  "datatables.scroller",
  "datatables.columnfilter", */
  "ui.grid",
  "ui.grid.resizeColumns",
  "ui.grid.edit",
  "ui.grid.moveColumns",
  /* "ngTable", */
  /* "smart-table", */
  "angular-flot",
  /* "angular-rickshaw", */
  "easypiechart",
/*   "uiGmapgoogle-maps", */
  "ui.calendar",
  "ngTagsInput",
  "ngMaterial",
  "localytics.directives",
  "leaflet-directive",
/*   "wu.masonry", */
  "ipsum",
  "angular-intro",
  "dragularModule",

  "formly",
  "formlyBootstrap",
  "chart.js",
  "treeGrid"
]);
angular.module("utils", [
  "ui.router",
  "ui.router.state.events",
  "toastr",
  "pascalprecht.translate",
  "ui.utils"
]);

var webapp = angular.module("salevis4-web", [
  "ngModules",
  "ui.bootstap.fam",
  "minovate",
  "utils",
  "AuthServices",
  "as.sortable",
  "fa.directive.borderLayout"
]);


webapp
  .run([
    "$rootScope",
    "$state",
    "$stateParams",
    "$window",
    "$translate",
    "$http",
    "$transitions",
    "Auth",
    "$filter",
    function($rootScope, $state, $stateParams, $window, $translate, $http, $transitions, Auth, $filter) {
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;
      $rootScope.safeApply = safeApply;

      if (!$window.sessionStorage.getItem("layoutBoard")) {
        $window.sessionStorage.setItem("layoutBoard", 'H');// Layout 기본을 N에서 H로 변경
      }

      if (!$window.sessionStorage.getItem("layoutBoardSize")) {
        $window.sessionStorage.setItem("layoutBoardSize", "40% + 2px");
      }

      $rootScope.gVariable = {
        totalItemChatComm: 0,
        totalItemTaskComm: 0,
        totalItemNotiComm: 0,
        totalItemComm: 0,
        alertMessage: "",
        UserId: $window.sessionStorage.getItem("loginUserIdx"),
        UserName: $window.sessionStorage.getItem("loginUserName"),
        TenantId: $window.sessionStorage.getItem("loginTenantId"),
        DeptId: $window.sessionStorage.getItem("loginUserDeptId"),
        DeptNm: $window.sessionStorage.getItem("loginUserDeptNm"),
        SysAdminYN: $window.sessionStorage.getItem("loginSysAdminYN"),
        TenantName: $window.sessionStorage.getItem("loginTenantName"),
        TenantDir: $window.sessionStorage.getItem("loginTenantDir"),
        Email: $window.sessionStorage.getItem("loginEmail"),
        Mobile: $window.sessionStorage.getItem("loginMobile"),
        TelNo: $window.sessionStorage.getItem("loginTelNo"),
        userType: $window.sessionStorage.getItem("loginUserType"),
        userKey: $window.sessionStorage.getItem("userkey") + '-' + $window.sessionStorage.getItem("loginTenantId"),
        autoUpdate: false,
        selectedShop: null,
        srchTenantId: $window.sessionStorage.getItem("srchTenantId"),
        srchTenantName: $window.sessionStorage.getItem("srchTenantName"),
        layoutBoard:$window.sessionStorage.getItem("layoutBoard"),
        layoutBoardSize:$window.sessionStorage.getItem("layoutBoardSize"),
        dataGroupId: $window.sessionStorage.getItem("dataGroupId"),
        dataGroupNm: $window.sessionStorage.getItem("dataGroupNm"),
        dataActionId: $window.sessionStorage.getItem("dataActionId"),
        dataActionNm: $window.sessionStorage.getItem("dataActionNm"),
        noHeader: $window.sessionStorage.getItem("noHeader"),
        mainPage: $window.sessionStorage.getItem("mainPage"),
        mainPageSrch: $window.sessionStorage.getItem("mainPageSrch"),
        listKeyId : null
      };

      $rootScope.getSelectShopDescription = function() {
        if ($rootScope.gVariable.selectedShop) {
          return $rootScope.gVariable.selectedShop.DatagroupNm + ':' + $filter('utcToLocal')($rootScope.gVariable.selectedShop.BeginDate,'yyyy-MM-dd h:mm a') + '~' + $filter('utcToLocal')($rootScope.gVariable.selectedShop.EndDate,'yyyy-MM-dd h:mm a');
        }

        return "";
      };

      $rootScope.dataloader = false;

      $rootScope.$on('$viewContentLoaded', function(event, viewName, viewContent){
        angular.element("html, body, #content").animate({
            scrollTop: 0
          }, 200);

        setTimeout(function() {
          angular.element("#wrap").css("visibility", "visible");

          if (!angular.element(".dropdown").hasClass("open")) {
            angular.element(".dropdown").find(">ul").slideUp();
          }
        }, 200);
      });

      $transitions.onSuccess({}, function(event, toState) {
        $http.defaults.headers.common["Content-Type"] = "application/json; charset=utf-8";
        $http.defaults.headers.common['Accept'] = "application/json, text/html";
      });

      $rootScope.$on("$stateChangeSuccess", function(event, toState) {
        //console.log('$stateChangeSuccess toState=', toState);
      });

      $rootScope.$on("$locationChangeStart", function(event, next) {
        //console.log('$locationChangeStart next=', next);
      });

      $rootScope.$on('$stateChangeStart', function(event, next, current) {
        //console.log('$stateChangeStart next=', next);
        // 모바일 중간보고를 위한 임시 처리
        // 모바일 경우 세션이 없을 경우에도 페이지를 열어야하기 때문에
        // 방법을 모색해야함
        if(!checkMobile()) {
          var URL = location.href.toString();
          if(URL.indexOf("#/m/") == -1 && URL.indexOf("#/apps/") == -1) {
            if (!Auth.checkPermissionForView(next)){
              event.preventDefault();
              alert('cannot access : ' + next.name);
            }
          }
        }
      });

      $rootScope.changeLanguage = function(langKey) {
        $translate.use(langKey);
        $rootScope.currentLanguage = langKey;
        $window.sessionStorage.setItem("currentLanguage", langKey);
      };
      $rootScope.currentLanguage =
        $translate.proposedLanguage() ||
        $translate.use() ||
        $window.sessionStorage.getItem("currentLanguage");

      if ($rootScope.currentLanguage == null || $rootScope.currentLanguage == "") {
        $rootScope.changeLanguage("ko");
      }

      $rootScope.changeLayout = function(layout) {
        $window.sessionStorage.setItem("layoutBoard", layout);
        $rootScope.gVariable.layoutBoard = layout;
        $window.sessionStorage.setItem("layoutBoardSize", "40% + 2px");
        $rootScope.gVariable.layoutBoardSize = "40% + 2px";
      };

      $rootScope.setGVariable = function(key, value) {
        $window.sessionStorage.setItem(key, value);
        $rootScope.gVariable[key] = value;
      };

      function safeApply(fn) {
        var phase = this.$root.$$phase;
        if (phase !== "$digest" && phase !== "$apply") {
          this.$apply(fn);
          return;
        }
        if (fn && typeof fn === "function") fn();
      }

      $rootScope.getImageUrl = function(fileName, tenantId, filePath) {
        if (!fileName) return "";

        return API_HTTP_PROTOCOL + '//' + API_SERVER_DOMAIN + ':' +
          API_SERVER_PORT + '/openapi/attach/' + tenantId + '/' + filePath + '/' + fileName + '/image.do';
      };

      // 엑셀 설정
      // 다중 시트 기능 추가 2020-01-20 hansol
      $rootScope.excelDown = function(exportData, fileName, sheetNames) {

        function datenum(v, date1904) {
          if (date1904) v+=1462;
          var epoch = Date.parse(v);
          var gmt = 0.375;
          return ((epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000))+gmt;
        }


        function getSheet(data, opts) {
          var ws = {};
          var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
          var mergeList = [];

          for(var R = 0; R != data.length; ++R) {
            for(var C = 0; C != data[R].length; ++C) {

              if(range.s.r > R) range.s.r = R;
              if(range.s.c > C) range.s.c = C;
              if(range.e.r < R) range.e.r = R;
              if(range.e.c < C) range.e.c = C;

              var cell = {v: data[R][C] };
              if(cell.v == null) continue;

              var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

              // 셀병합 기능 추가 2020-01-22 hansol
              var doMerge = false;
              var chgVal = false;
              var sR = R, sC = C, eR = R, eC = C;
              switch(cell.v){
                case 'rspan_up' : doMerge = (R > 0); sR = R-1; break;
                case 'rspan_dw' : doMerge = (R < data.length);  chgVal = true; eR = R+1; break;
                case 'cspan_lf' : doMerge = (C > 0); sC = C-1; break;
                case 'cspan_rt' : doMerge = (C < data[R].length); chgVal = true; break;
              }
              if(cell.v == 'cspan_lf' || cell.v == 'cspan_rt') {
                for(var col = C+1; col != data[R].length; ++col){
                  if(data[R][col] == 'cspan_lf') {
                    ++eC;
                    data[R][col] = ''; // 값을 비우지 않으면 엑셀 다운로드시 오류 발생
                  }
                  else break;
                }
              }
              if(doMerge) mergeList.push({s: {r:sR, c:sC}, e: {r:eR, c:eC}});
              if(chgVal) cell.v = data[eR][eC];

              if(typeof cell.v === 'number') cell.t = 'n';
              else if(typeof cell.v === 'boolean') cell.t = 'b';
              else if(cell.v instanceof Date) {
                cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
              }
              else cell.t = 's';

              ws[cell_ref] = cell;
            }
          }

          // 셀병합 기능 추가 2020-01-22 hansol
          // 시트 생성 후 병합 정보 추가
          if(mergeList != []){ mergeList.forEach(function (m){
            if ( ! ws['!merges']) ws['!merges'] = [];
            ws['!merges'].push(m);
          });
        }

        if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
          return ws;
        }

        function Workbook() {
          if(!(this instanceof Workbook)) return new Workbook();
          this.SheetNames = [];
          this.Sheets = [];
        }

        var wb = new Workbook();
        var ws;

        /* add worksheet to workbook */

        // 시트가 여러개인 경우
        if (sheetNames != null && sheetNames.length > 1) {
          wb.SheetNames = sheetNames;
          exportData.forEach(function(d,i){
            ws = getSheet(d);
            wb.Sheets[sheetNames[i]] = ws;
          });
        }
        // 시트가 하나인 경우
        else {
          var shNm = (sheetNames != null && sheetNames.length == 1 ? sheetNames[0] : fileName);
          wb.SheetNames.push(shNm);
          ws = getSheet(exportData);
          wb.Sheets[shNm] = ws;
        }

        var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});

        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        }

        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), fileName+'.xlsx');
      };
    }
  ])

  .config([
    "uiSelectConfig",
    function(uiSelectConfig) {
      uiSelectConfig.theme = "bootstrap";
    }
  ])

  .config([
    "$mdThemingProvider",
    function($mdThemingProvider) {
      var agent = navigator.userAgent.toLowerCase();
      if ( (navigator.appName == 'Netscape' && agent.indexOf('trident') != -1) || (agent.indexOf("msie") != -1)) {
        $mdThemingProvider.alwaysWatchTheme(false);    // ie일 경우
        $mdThemingProvider.disableTheming(true);
      }

    }
  ])

  .config(function inputDirectiveConfig($provide) {
    //키 입력 이벤트는 compostionstart->compostionupdate->compositonend로 진행된다.
    $provide.decorator('inputDirective', function($delegate, $log) {
      var directive = $delegate[0];
      angular.extend(directive.link, {
        post : function(scope, element, attr, ctrls) {
          element.on('compositionupdate', function(event) {
            //                  $log.debug('composition update 이벤트 발생, 강제 종료');
            element.triggerHandler('compositionend');
          });
        }
      });
      return $delegate;
    });
  })

  //angular-language
  .config([
    "$translateProvider",
    function($translateProvider) {
      $translateProvider.useStaticFilesLoader({
        prefix: "languages/",
        suffix: ".data"
      });
      $translateProvider.useLocalStorage();
      $translateProvider.preferredLanguage("ko");
      $translateProvider.useSanitizeValueStrategy(null);
    }
  ])
  ;

webapp.directive("krInput", ["$parse", function($parse) {
    return {
      priority: 2,
      restrict: "A",
      compile: function(element) {
        element.on("compositionstart", function(e) { e.stopImmediatePropagation(); });
      }
    };
  }
]);

webapp.directive("krTextarea", ["$parse", function($parse) {
  return {
    restrict: "E",
    compile: function(element) {
      element.on("compositionstart", function(e) { e.stopImmediatePropagation(); });
      //element.on('compositionupdate', function(e) { e.triggerHandler('compositionend'); }); // 위에꺼 안되면 이걸로 시도
    }
  };
}
]);

/**
 * 숫자와 하이픈(-)만 입력 가능하도록 처리 (e.g. 전화번호)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자와 하이픈 값만 추출하여 반환
 */
webapp.directive('numbersHyphen', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^0-9_-]/g, "");
          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }

      ngModelCtrl.$parsers.push(fromUser);
    }
  };
});

/**
 * 숫자만 입력 가능하도록 처리 (e.g. 금액)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자 값만 추출하여 반환
 */
webapp.directive('numbersOnly', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^0-9]/g, '');

          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }

      ngModelCtrl.$parsers.push(fromUser);
    }
  };
});

/**
 * 숫자 입력시 3자리 마다 콤마 처리 (e.g. 금액)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자 값에 콤마처리 하여 반환
 */
webapp.directive('comma', function ($filter) {
  'use strict';
  return {
    scope: {
      ngModel: "=",
      ngBind: "="
    },
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      if (!ctrl) return;

      function checkValidate(P) {
        var splitSize = P.split(".").length;
        if (splitSize > 2) return false;

        var diff = P.replaceAll(".", "").replaceAll(",", "");
        var transformedInput = P.replace(/[^0-9]/g, '');

        if (transformedInput !== diff) return false;
        else return true;
      }

      function nf(T) {
        T = T.replace(/[^0-9]/g, '').toString();
        //T = Number(T)
        return T.toString();
      }

      function setComma(T) {
        return T.replace(/[^\d]+/g, '').replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,').toString();
      }

      ctrl.$formatters.unshift(function (viewValue) {

        if (viewValue) {
          var checkMinus = false;
          if (viewValue.toString().charAt(0) == "-") checkMinus = true;

          var result, parts;
          parts = viewValue.split(".");
          result = nf(parts[0]);
          result = setComma(result);
          if (parts.length > 1) {

            result += "." + nf(parts[1]).substring(0, 2);
            //result +=  "." + parts[1].substring(0,2);
          }

          if (checkMinus) result = "-" + result;

          var b = result;
          elem.val(b);
          return result;
        }
      });

      ctrl.$parsers.unshift(function (viewValue) {
        var temp, result = "", parts;
        parts = viewValue.split(".");
        temp = nf(parts[0]);
        temp = setComma(temp);
        if (parts.length > 1) temp += "." + nf(parts[1]).substring(0, 2);
        for (var i = 0; i < temp.length; i++) {
          var atChar = temp.charAt(i);
          if (atChar == "," || atChar == "." || !isNaN(atChar)) {
            result += "" + atChar;
          }
        }

        var b = result;
        elem.val(b);
        return result.replaceAll(",", "");
      });
    }
  };
}).directive('comma3', function ($filter) {
  'use strict';
  return {
    scope: {
      ngModel: "=",
      ngBind: "="
    },
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      if (!ctrl) return;

      function checkValidate(P) {
        var splitSize = P.split(".").length;
        if (splitSize > 2) return false;

        var diff = P.replaceAll(".", "").replaceAll(",", "");
        var transformedInput = P.replace(/[^0-9]/g, '');

        if (transformedInput !== diff) return false;
        else return true;
      }

      function nf(T) {
        T = T.replace(/[^0-9]/g, '').toString();
        //T = Number(T)
        return T.toString();
      }

      function setComma(T) {
        return T.replace(/[^\d]+/g, '').replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,').toString();
      }

      ctrl.$formatters.unshift(function (viewValue) {
        if (viewValue) {
          var result, parts;
          parts = viewValue.split(".");
          result = nf(parts[0]);
          result = setComma(result);
          if (parts.length > 1) {

            result += "." + nf(parts[1]).substring(0, 3);
            //result +=  "." + parts[1].substring(0,2);
          }

          var b = result;
          elem.val(b);
          return result;
        }
      });

      ctrl.$parsers.unshift(function (viewValue) {
        var temp, result = "", parts;
        parts = viewValue.split(".");
        temp = nf(parts[0]);
        temp = setComma(temp);
        if (parts.length > 1) temp += "." + nf(parts[1]).substring(0, 2);
        for (var i = 0; i < temp.length; i++) {
          var atChar = temp.charAt(i);
          if (atChar == "," || atChar == "." || !isNaN(atChar)) {
            result += "" + atChar;
          }
        }

        var b = result;
        elem.val(b);
        return result.replaceAll(",", "");
      });
    }
  };
}).directive('commaBind', function () {
  'use strict';
  return {
    restrict: 'A',
    scope: {
      ngBind: '='
    },
    link: function (scope, elem) {

      function checkValidate(P) {

        var splitSize = P.split(".").length;
        if (splitSize > 2) return false;

        var diff = P.replaceAll(".", "").replaceAll(",", "");
        var transformedInput = P.replace(/[^0-9]/g, '');

        if (transformedInput !== diff) return false;
        else return true;
      }

      function nf(T) {
        return T.replace(/[^0-9]/g, '').toString();
      }

      function setComma(T) {
        return T.replace(/[^\d]+/g, '').replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,').toString();
      }

      scope.$watch('ngBind', function (newVal) {

        if (newVal !== undefined && newVal !== null) {

          var checkMinus = false;
          if (newVal.toString().charAt(0) == "-") checkMinus = true;
          var parts;
          parts = newVal.toString().split(".");
          var temp = parts[0].toString().replace(/[^\d]+/g, '').replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
          if (parts.length > 1) temp += '.' + nf(parts[1]).substring(0, 2);
          if (checkMinus) temp = "-" + temp;
          if ($(elem).is("input")) angular.element(elem).val(temp);
          else angular.element(elem).html(temp);
        }
      });
    }
  };
});

/**
 * 자동 하이픈 처리 (e.g. 휴대번호)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자 값에 하이픈처리 하여 반환
 */
webapp.directive('autoHyphen', function ($filter) {
  'use strict';
  return {
    scope: {
      ngModel: "=",
      ngBind: "="
    },
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      if (!ctrl) return;

      function checkValidate(P) {
        var splitSize = P.length;
        if (splitSize > 14) return false;

        var diff = P.replaceAll("-", "");
        var transformedInput = P.replace(/[^0-9]/g, '');

        if (transformedInput !== diff) return false;
        else return true;
      }

      function nf(str) {
        str = str.replace(/[^0-9]/g, '').toString();
        //T = Number(T)
        return str.toString();
      }

      function autoHypenPhone(str){
        str = str.replace(/[^0-9]/g, '');
        var tmp = '';
        if( str.length < 4){
          return str;
        }else if(str.length < 7){
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3);
          return tmp;
        }else if(str.length < 11){
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3, 3);
          tmp += '-';
          tmp += str.substr(6);
          return tmp;
        }else{
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3, 4);
          tmp += '-';
          tmp += str.substr(7);
          return tmp;
        }
      }

      ctrl.$formatters.unshift(function (viewValue) {
        if (viewValue) {
          var result;
          result = nf(viewValue);
          result = autoHypenPhone(result);

          var b = result;
          elem.val(b);
          $(elem).attr('maxlength', 13);
          return result;
        }
      });

      ctrl.$parsers.unshift(function (viewValue) {
        var temp, result = "";
        temp = nf(viewValue);
        temp = autoHypenPhone(temp);
        for (var i = 0; i < temp.length; i++) {
          var atChar = temp.charAt(i);
          if (atChar == "-" || !isNaN(atChar)) {
            result += "" + atChar;
          }
        }

        var b = result;
        elem.val(b);
        return result.replaceAll("-", "");
      });
    }
  };
});


webapp.run(function ($rootScope, $window, $resource, StaticVariable, GLOBAL_CONSTANT, $mdToast, $filter) {
  $rootScope.windowOpen = function (url, name, w, h) {
    //TODO : your custom code here.
    if (angular.isUndefined(w)) w = 1000;
    if (angular.isUndefined(h)) h = 800;

    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;

    if (left < 0) left = 0;
    if (top < 0) top = 0;

    console.log('$window.open(', 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left + ')');
    $window.open(url, name, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
  };

//yyyy-mm-dd > new Date 형태로 변환
  $rootScope.getDateFormat = function(dateStr) {
    var dateArr;

    if (typeof(dateStr) == "undefined") {
      return null;
    }
    else {
      dateArr = dateStr.split("-");
    }

    if (dateArr.length == 3) {
      return new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2]);
    }
    else {
      return null;
    }
  };

  $rootScope.getDate = function(date) {
    if (!date) return null;

    return new Date(date);
  };

  $rootScope.setUserSession = function(data) {
    $window.sessionStorage['isLoggedIn'] = 'Y';
    $window.sessionStorage['loginUserId'] = data.loginId;
    $window.sessionStorage['loginUserIdx'] = data.userId;
    $window.sessionStorage['loginSysAdminYN'] = data.sysAdminYN;
    $window.sessionStorage['loginUserName'] = data.userName;
    $window.sessionStorage['loginUserGbn'] = data.userGroupId;
    $window.sessionStorage['loginUserDeptNm'] = data.DeptNm;
    $window.sessionStorage['loginUserDeptId'] = data.DeptId;
    $window.sessionStorage['loginComGbn'] = data.company;
    $window.sessionStorage['loginUserType'] = data.userType;
    $window.sessionStorage['loginUserEmail'] = data.email;
    $window.sessionStorage['loginTenantId'] = data.TenantId == null ? 0 : data.TenantId;
    $window.sessionStorage['loginTenantName'] = data.TenantName;
    $window.sessionStorage['loginTenantDir'] = data.TenantDir == null ? null : data.TenantDir;
    $window.sessionStorage['loginEmail'] = data.Email;
    $window.sessionStorage['loginTelNo'] = data.TelNo;
    $window.sessionStorage['loginMobile'] = data.Mobile;
    $window.sessionStorage['noHeader'] = data.noHeader == null ? false : data.noHeader;
    $window.sessionStorage['mainPage'] = data.mainpage == null ? 'app.dashboard' : data.mainpage;
    $window.sessionStorage['mainPageSrch'] = data.mainpagesrch == null ? '' : data.mainpagesrch;

    $window.sessionStorage['loginComUserId'] = $window.sessionStorage['loginComUserId'] == null ? data.ComUserId : $window.sessionStorage['loginComUserId'];
    $window.sessionStorage['loginCounselorCode'] = $window.sessionStorage['loginCounselorCode'] == null ? data.CounselorCode : $window.sessionStorage['loginCounselorCode'];

    $rootScope.gVariable.UserId = $window.sessionStorage['loginUserIdx'];
    $rootScope.gVariable.TenantId = $window.sessionStorage['loginTenantId'];
    $rootScope.gVariable.TenantName = $window.sessionStorage['loginTenantName'];
    $rootScope.gVariable.TenantDir = $window.sessionStorage['loginTenantDir'];
    $rootScope.gVariable.SysAdminYN = $window.sessionStorage['loginSysAdminYN'];
    $rootScope.gVariable.Email = $window.sessionStorage['loginEmail'];
    $rootScope.gVariable.TelNo = $window.sessionStorage['loginTelNo'];
    $rootScope.gVariable.UserName = $window.sessionStorage['loginUserName'];
    $rootScope.gVariable.userType = $window.sessionStorage['loginUserType'];
    $rootScope.gVariable.DeptNm = $window.sessionStorage['loginUserDeptNm'];
    $rootScope.gVariable.DeptId = $window.sessionStorage['loginUserDeptId'];
    $rootScope.gVariable.Mobile = $window.sessionStorage['loginMobile'];
    $rootScope.gVariable.noHeader = $window.sessionStorage['noHeader'];
    $rootScope.gVariable.mainPage = $window.sessionStorage['mainPage'];
    $rootScope.gVariable.mainPageSrch = $window.sessionStorage['mainPageSrch'];
    if (data.userkey) {
      $window.sessionStorage['userkey'] = data.userkey;
      $rootScope.gVariable.userKey = $window.sessionStorage['userkey'] + '-' + $window.sessionStorage['loginTenantId'];
    }
    //console.log($window.sessionStorage);
  };

  $rootScope.setDefaultSelectedShop = function() {
    var srch = {viewSize:1, page:1, UseYN:'Y'};

    var prms = $resource(StaticVariable.getUrl('/select/MaDatagroup.getDatagroupList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction()).post(srch).$promise;

    prms.then(
    function(data) {
      if (data.responseVO.header.status == GLOBAL_CONSTANT.HttpStatus.OK) {
        // select한 datatable 바인딩
        $rootScope.gVariable.selectedShop = data.responseVO.body.docs[0];
      }
    },
    function(error) {
      //console.error('fail', status, data);
      console.error("Error> setDefaultSelectedShop()");
      console.table(error);
    });
  };

  $rootScope.showSimpleToast = function(msg, p1, p2) {
    var position = "";
    var delay = 1200;
    if(p1 == undefined) {
      var classTx = "header-toast";
      $mdToast.show(
        $mdToast.simple({
          template: '<md-toast class="md-toast ' + classTx +'">' +
          '<div class="md-toast-content">' + msg + '</div></md-toast>',
          position: "top left",
          hideDelay : delay
        })
      );
    } else if(p1.indexOf("#") > -1) {
      if(p2 != undefined) p2 = position;
      else p2 = "top left";
      $mdToast.show(
        $mdToast.simple()
        .parent(angular.element(document.querySelector(p1)))
        .content(msg)
        .position(p2)
        .hideDelay(delay)
      );
    } else {
      var classTx = "";
      if (p1 == undefined) {
        classTx = "header";
      } else if(p1.toLowerCase() == "header" || p1.toLowerCase() == "footer") {
        classTx = p1 + "-toast";
      } else {
        position = p1;
      }

      if(classTx == "") {
        $mdToast.show(
          $mdToast.simple()
          .content(msg)
          .position(position)
          .hideDelay(delay)
        );
      } else {
        var position = "";
        if(p1.toLowerCase() == "footer") position = "bottom left";
        else position = "top left";
        $mdToast.show(
          $mdToast.simple({
            template: '<md-toast class="md-toast ' + classTx +'">' +
            '<div class="md-toast-content">' + msg + '</div></md-toast>',
            position: position,
            hideDelay : delay
          })
        );
      }
    }
  };

  $rootScope.listColumFilter = function(liCol) {
    if (liCol.ListColumnShowLevel == 'showlevel0') {
      return false;
    }

    return true;
  };
});

(function () {
  'use strict';

  angular
    .module('salevis4-web')
    .config(toastrConfig)
    .config(translateConfig)
    .config(formlyConfig);

  /** @ngInject */
  function toastrConfig($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

  /** @ngInject */
  function translateConfig($translateProvider) {
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
    $translateProvider.useStaticFilesLoader({
      prefix: '/assets/i18n/lang-',
      suffix: '.data'
    });
    $translateProvider.preferredLanguage('ko');
  }
   /** @ngInject */
  function formlyConfig(formlyConfigProvider) {
    // Replace formlyBootstrap bootstrapLabel wrapper to implement horizontal forms
    formlyConfigProvider.removeWrapperByName('bootstrapLabel');
    formlyConfigProvider.setWrapper({
      name : 'bootstrapLabel',
      templateUrl : 'label-wrapper.html'
    });

    // Replace formlyBootstrap input field type to implement read-only forms
    formlyConfigProvider.setType({
      name : 'readOnly',
      templateUrl : 'input-template.html',
      wrapper : [ 'bootstrapLabel', 'bootstrapHasError' ],
      overwriteOk : true
    });
  }

})();

(function() {
  "use strict";

  webapp.constant("MAIN", {
    APP_NAME: "Salevis4-web Manager"
  });
})();

(function () {
  "use strict";

  //var checkdTarget = window.location.href.split('//')[1].split("/")[1].replace("#","");
  var checkdTarget;
  var checkMobile = false;

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $windowProvider, $translateProvider) {
    var $window = $windowProvider.$get();
    if(location.href.indexOf("/app") > -1) {
      if (!angular.isUndefined($window.sessionStorage['isLoggedIn']) && $window.sessionStorage['isLoggedIn'] === 'Y') {
        var mainPage = $window.sessionStorage.getItem("mainPage");
        $urlRouterProvider.otherwise(function($injector, $location) {
          $injector.get('$state').go(mainPage, { srch: '' });
        });
      } else {
        $window.location.replace('/');
      }
    } else {
      $.ajax({
        url: 'https://ipapi.co/json/',
        async: false,
        success: function(data){
            var country = data.country;
            var lang = "en";
            if(country == "KR") lang = "ko";
            else if(country == "US") lang = "en";
            else if(country == "RU") lang = "ru";
            else if(country == "DE") lang = "de";
            $translateProvider.preferredLanguage(lang);
            $urlRouterProvider.otherwise('/' + lang + '/home/main');

            var dataInterval = setInterval(function() {

                if($('html').hasClass("ng-scope")) {
                    if($("#section--content").height() > 0) {
                        $('html').removeClass('cloak');
                        clearInterval(dataInterval);
                    }
                }
            }, 10);
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.log("no");
            $urlRouterProvider.otherwise('/en/home/main');

            var dataInterval = setInterval(function() {

                if($('html').hasClass("ng-scope")) {
                    if($("#section--content").height() > 0) {
                        $('html').removeClass('cloak');
                        clearInterval(dataInterval);
                    }
                }
            }, 10);
        }
      });
    }

    $stateProvider
      .state("app",     { url: "/app",component: "app"})
      .state("m",       { url: "/m", component: "mApp"})
      .state("home",     { url: "/:lang/home",component: "home"})
      .state("login",   { url: "/login", component: "login"})
      .state("salemeet",   { url: "/salemeet", component: "salemeet"})
      .state("winnersjm",   { url: "/winnersjm", component: "winnersjm"})
      .state("logout",   { url: "/logout", component: "logout"})
      .state("salemeetlogout",   { url: "/salemeetlogout", component: "salemeetlogout"})
      .state("winnersjmlogout",   { url: "/winnersjmlogout", component: "winnersjmlogout"})
      .state("signup",  { url: "/signup", component: "signupStepOne"})
      .state("salemeetsignup",  { url: "/salemeetsignup", component: "salemeetSignupStepOne"})
      .state("signup2", { url: "/signup/:tenantId", component: "signupStepTwo"})
      .state("salemeetsignup2", { url: "/salemeetsignup/:tenantId", component: "salemeetSignupStepTwo"})
      .state("reserve", { url: "/reserve", component: "reserve"})
      .state("survey",   { url: "/survey/:keyId/:tgtId", component: "survey"})
      .state("counsel",   { url: "/counsel/:tgtId", component: "counsel"})
      .state("emaildeny",   { url: "/emaildeny/:tgtId/:workType", component: "emaildeny"})
      .state("apps",    { url: "/apps/:targetApp", component: "branchApps" })
      .state("loginbycafe24",   { url: "/loginbycafe24/:state", component: "loginbycafe24"});
  }

})();

(function() {
  "use strict";

  webapp.run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $translate, $transitions, $http, $timeout) {
    // $http.defaults.withCredentials = true;
    $http.defaults.headers.common["Content-Type"] =
      "application/json; charset=utf-8";
    $http.defaults.headers.common.Accept = "application/json, text/html";

    $transitions.onStart({}, onStart);
    $transitions.onSuccess({}, onSuccess);

    /** @ngInject */
    function onStart(trans) {
      var $state = trans.router.stateService;
      //$log.info("[onStart name]::", $state.current.name);
      $rootScope.dataloader = true;
      //console.log('onStart');
    }

    /** @ngInject */
    function onSuccess(trans) {
      var $state = trans.router.stateService;
      $state.getCurrentPath().forEach(function(element) {
       // $log.info("[onSuccess name]::", element.state.name);
      });

      if($("body").attr("nav-state") == undefined) {
        if( !$("html").hasClass("isOnlyDevice") )
        initPageNavState();
      }

      $timeout(function(){
        initViewLoadedInputBoxStyle();
        initPageContentMinHeight();
        initLabelTitle();
      });

      setTimeout(function() {
        $rootScope.dataloader = false;
        $rootScope.title = $translate.instant('PRODUCT.TITLE');
      }, 600);

      //console.log('onStop');
    }
  }

  function initPageNavState() {
    var winWidth = $(window).width();
    if (winWidth < 560) $("body").attr("nav-state", "xs-off");
    else if (winWidth < 768) $("body").attr("nav-state", "sm-off");
    else if (winWidth > 767 ) {
      var localStorage = window.localStorage;
      var navState = localStorage.getItem("navMenuMdSizeState");

      if(navState == null || navState == undefined || navState == "on" || navState == "off") {
        navState = "l";
        localStorage.setItem('navMenuMdSizeState', navState);
      }
      $("body").attr("nav-state", "md-" + navState);
    }
    //setToggleImage();
  }
})();
// ui-router login example
// $transitions.onStart( { to: 'auth.**' }, function(trans) {
//     var $state = trans.router.stateService;
//     var MyAuthService = trans.injector().get('MyAuthService');
//     // If the user is not authenticated
//     if (!MyAuthService.isAuthenticated()) {
//       // Then return a promise for a successful login.
//       // The transition will wait for this promise to settle
//       return MyAuthService.authenticate().catch(function() {
//         // If the authenticate() method failed for whatever reason,
//         // redirect to a 'guest' state which doesn't require auth.
//         return $state.target("guest");
//       });
//     }
//   });

!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

/* 'use strict'; */

var szNavCustomType = "LEFT";
var szNavStyle;

//var SHOP_DOMAIN_ADDRESSS = 'http://m.civasatr4473.godomall.com';
var SHOP_DOMAIN_ADDRESSS = 'https://m.mall.pharmesthetic.com';

(function ($) {

/*   szNavStyle = {

    init : function(){
    }
  };
  szNavStyle.init(); */

})(jQuery);

(function ($) {

  if (typeof String.prototype.replaceAll !== "function") {
    String.prototype.replaceAll = function (target, replacement) {
      return this.split(target).join(replacement);
    };
  }

  if (typeof String.prototype.trim !== "function") {
    String.prototype.trim = function () {
      return this.replace(/(^\s*)|(\s*$)/gi, "");
    };
  }

  if (typeof String.prototype.comma !== "function") {
    String.prototype.comma = function () {
      return this.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    };
  }

  if (typeof Number.prototype.comma !== "function") {
    Number.prototype.comma = function () {

      return this.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    };
  }

  if (typeof String.prototype.fillStr !== "function") {
    String.prototype.fillStr = function (str, len) {
      var orgStr = this.toString();
      while (orgStr.toString().length < len) {
        orgStr = str + orgStr;
      }
      return orgStr;
    };
  }

  if (typeof String.prototype.left !== "function") {
    String.prototype.left = function (len) {
      var orgStr = this.toString();
      return orgStr.substring(0, len);
    };
  }

  if (typeof String.prototype.right !== "function") {
    String.prototype.right = function (len) {
      var orgStr = this.toString();
      return orgStr.substring(orgStr.length - len, orgStr.length);
    };
  }

  if (typeof String.prototype.isNull !== "function") {

    String.prototype.isNull = function () {
      try {
        var orgStr = this.toString();
        if (orgStr == undefined || orgStr == "undefined" || orgStr == null || orgStr == "null" || orgStr.length == 0 || orgStr == " ") return true;
        else return false;
      } catch (e) {
        return true;
      }
    };
  }

  if (typeof $.prototype.hasAttr !== "function") {
    $.prototype.hasAttr = function (name) {
      try {
        var attr = $(this).attr(name);
        if (typeof attr !== typeof undefined && attr !== false) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    };
  }

  var Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function (input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        }
        else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output +
          this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
          this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
      }
      return output;
    },
    decode: function (input) {
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9+/=]/g, "");
      while (i < input.length) {
        enc1 = this._keyStr.indexOf(input.charAt(i++));
        enc2 = this._keyStr.indexOf(input.charAt(i++));
        enc3 = this._keyStr.indexOf(input.charAt(i++));
        enc4 = this._keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      return output;
    }
  };

})(jQuery);

function makeDateUUID() {

  // ex : 14 61 20 90 04 27 72 7; : length = 15
  // [년, 월, 일](4) + 요일(1) + 시간(2) + 분(2) + 초(2) + 밀리세컨드(2) + 랜덤숫자(2);
  var date = new Date();
  var year = date.getFullYear();
  var month = String(date.getMonth()+1);
  var day = String(date.getDate());
  var gday = String(date.getDay());
  var hh = String(date.getHours()).fillStr(0,2);
  var mm = String(date.getMinutes()).fillStr(0,2);
  var dd = String(date.getMinutes()).fillStr(0,2);
  var ss = String(date.getSeconds()).fillStr(0,2);
  var ms = String(date.getMilliseconds()).fillStr(0,2).left(2);
  var rand = String(Math.floor(Math.random() * 100)).fillStr(0,2);
  var uuid = year + Number(month) + Number(day) + gday + hh + dd + ss+ ms + rand;
  if(uuid.length != 15) {
    var size = 15 - uuid.length;
    uuid += String(Math.floor(Math.random() * 10000000)+1111111).left(size);
  }
  return uuid;
}

function replacer(key, value) {
  if (!value)
    return undefined;

  return value;
}

function checkMobile() {

  // 모바일 전용
  //if(navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)){

  // 모바일(태블릿 포함)
  if(navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)){
    return true;
  }

  return false;
}

function enableUploadComponent() {
  var word;
  var agent = navigator.userAgent.toLowerCase();
  var result = false;
  // IE old version ( IE 10 or Lower )
  if (navigator.appName == "Microsoft Internet Explorer") word = "msie ";
  // IE 11
  else if (agent.search("trident") > -1) word = "trident/.*rv:";
  // Microsoft Edge
  else if (agent.search("edge/") > -1) word = "edge/";
  // 그외, IE가 아니라면 ( If it's not IE or Edge )
  else return true;

  var reg = new RegExp(word + "([0-9]{1,})(\\.{0,}[0-9]{0,1})");
  if (reg.exec(agent) != null) {
    if (parseFloat(RegExp.$1 + RegExp.$2) > 10) return true;
    else return false;
  }
  return true;
}

function initPageContentMinHeight() {
  var headerHeight = 0;
  if($(".navbar-header").height() == null) headerHeight = 55;
  else headerHeight = $(".navbar-header").height();

  var checkPageInterval = setInterval(function(){
    var offset = $(".page ").eq(0).offset();
    if(offset != undefined) {
      $(".page ").eq(0).css("min-height", $(window).height() - offset.top );
      clearInterval(checkPageInterval);
    }

  }, 300);

}

function initViewLoadedInputBoxStyle() {

  var timerCount = 0;
  var timer = setInterval(function(){
    var input = $(".form-inner-label input");

    if( $(input).length == 0 ) {
      timerCount++;
      if(timerCount == 5) clearInterval(timer);
    } else {
      clearInterval(timer);
      for(var i = 0; i < input.length; i++) {
        var id = $(input).eq(i).attr("id");
        var convId = '';
        if( id == null) id = $(input).eq(i).attr("ng-model");
        if(id == null) continue;
        id = id.split(".");
        for(var j = 0; j < id.length; j++)
          convId += id[j].charAt(0).toUpperCase() + id[j].substring(1, id[j].length);
        convId = convId+ "_" + i;
        if( $(input).eq(i).attr("id")  != "" && $(input).eq(i).attr("id")  != undefined) {
          convId = $(input).eq(i).attr("id") ;
        }
        var placeholder = "";
        if($(input).eq(i).next().length > 0 && $(input).eq(i).next().get(0).tagName.toLowerCase() == "label") {
          $(input).eq(i).next().attr("for", convId);
          $(input).eq(i).attr("id", convId);
          $(input).eq(i).attr("placeholder", " ");
          continue;
        } else if ($(input).eq(i).attr("placeholder") != "" && $(input).eq(i).attr("placeholder") != undefined) {
          placeholder = $(input).eq(i).attr("placeholder");
        } else if($(input).eq(i).prev().get(0) && $(input).eq(i).prev().get(0).tagName.toLowerCase() == "label") {
          placeholder = $(input).eq(i).prev().get(0).textContent;
          $(input).eq(i).prev().detach();
        }
        $(input).eq(i).attr("id", convId);
        $(input).eq(i).attr("placeholder", " ");
        var label = $("<label>" + placeholder + "</label>", {for : convId,class : "ng-binding"});
        $(input).eq(i).after(label.clone());
        $(input).eq(i).next().attr("for", convId);
      }
    }
  }, 500);
}

function initLabelTitle() {
  setTimeout(function(){
    var label = $(".pagecontent label");
    for(var i= 0; i < label.length; i++) {
      $(label).eq(i).attr("title", $(label).eq(i).text());
    }
  }, 500);
}

function uploadVaultFile(vault) {
  if (vault != null) {
    vault.uploader.send();
//    vault.data.upload();
  }
}

function initVaultComponent (id, callback, bOpenApi, exts, maxCnt) {
  var korean = {
    add: "파일추가",
    browse: "파일찾기",
    cancel: "취소",
    clear: "초기화",
    clearAll: "전체 초기화",
    download: "다운로드",
    dragAndDrop: "",
    filesOrFoldersHere: "첨부 파일을 마우스로 끌어놓으세요.",
    or: "",
    upload: ""
  };
  var sessionStorage = window.sessionStorage;
  var userkey = sessionStorage.getItem("userkey") + '-' + sessionStorage.getItem("loginTenantId");
  var iCheck = 0;

  var checkVaultInterval = setInterval(function() {
    if (iCheck > 10) {
      clearInterval(checkVaultInterval);
      return;
    }
    iCheck++;
    if($('#' + id).length > 0) {
      clearInterval(checkVaultInterval);
      var vault = new dhx.Vault(id, {
          mode: "list",
          uploader: {
              target: API_HTTP_PROTOCOL + "//" + API_SERVER_DOMAIN + ":" + API_SERVER_PORT + (bOpenApi? "/openapi": "") + "/attach/temp/upload.do?userkey=" + userkey,
              autosend: false
          }
      });

      var activeCheck = "mp3, mp4, doc, docx, xls, xlsx, ppt, pptx, hwp, pdf, txt, gul, jpg, gif, png, bmp, dib, tif, tiff, zip, alz, rar, 7z, mm, dwg, dxf";//확장자 제한
      if (exts) {
        activeCheck = exts;
      }
      var sizeLimit = 104857600; // 100mb 제한
      var filesCountValue = document.getElementById("files-count-value");
      var filesSizeValue = document.getElementById("files-size-value");
      var filesSizeText = document.getElementById("files-size-text");
      var maxUploadFileCnt = 20;
      var isErrMaxUploadFileCnt = false;

      if(maxCnt){
        maxUploadFileCnt = maxCnt;
      }

      vault.events.on("beforeAdd", function (item) {
        if (vault.data.getLength() >= maxUploadFileCnt) {
            if(!isErrMaxUploadFileCnt) {
              alert("파일 첨부는 "+ maxUploadFileCnt +"개 까지만 가능합니다.");
              isErrMaxUploadFileCnt = true;
            }
            return false;
        }
        var extension = item.file.name.split(".").pop();
        var size = item.file.size;
        var predicate = activeCheck.indexOf(extension.toLowerCase()) > -1 && size < sizeLimit;
        if (!predicate) {
          alert(activeCheck + " 파일만 가능합니다.");
          var $obj = $(".dhx-dropable-area.drop-files-here");
          $obj.closest(".layout_y").removeClass('dhx-dragin');
        }
        return predicate;
      });
      vault.events.on("AfterAdd", function(item) {
        vault.toolbar.hide("upload");
      });

      vault.events.on("UploadFile", function (file) {
          //console.log(file);
          //alert(file.fileDuplication);
          //alert(file.file.name);
      });
      vault.events.on("uploadComplete", function (data) {
        if (data != null && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].responseVO != null) {
              var result = {};
              result.header = data[i].responseVO.header;
              result.body = data[i].responseVO.body;

              callback.onFileUploaded(id, result);
            }
          }
        }

        callback.onFileUploadComplete(id);
        vault.data.removeAll(); // 초기화
      });
      dhx.i18n.setLocale('vault', korean);

      if (callback)
        callback.onLoaded(id, vault);
    }
  }, 100);
}

function setBreakPoint(obj) {
  var size = ['xs', 'sm', 'md', 'lg', 'xl'];
  for(var i = 0; i < size.length; i++) {
    if(obj != "" && size[i] == obj) {
      obj =  "";
      for(var j = 0; j < i; j++) obj +=  size[j] + " ";
    }
  }
  return obj;
}


function initFootableEvent(vm, ft, callback) {
  var $el = ft.$el;
  var key = ft.o.key;
  var row = ft.o.rows;
  var $tr = $el.find("tbody tr");
  var link = ft.o.link;
  var srch = ft.o.srch;
  var FreeBoardId = ft.o.FreeBoardId;
  $tr.find("td").css("cursor", "pointer");
  for(var i = 0; i < $tr.length; i++) {
    $tr.eq(i).attr("data-key", row[i][key]);
    $tr.eq(i).attr("data-idx", i);
  }

  $tr.bind("click", function(){
    if( $(this).find(".footable-toggle").length == 0) {
      srch[key] = $(this).attr("data-key");
      var localStorage = window.localStorage;
      var dockMode = localStorage.getItem("dockMode");

      var type = {v: "vertical", h: "horizon", d: "default"};
      if(dockMode == null || dockMode== type.d) {
//        console.log(location.origin + "/#/app/bbspost/h0102-slist/" + encodeURIComponent(JSON.stringify(srch, replacer)) + "/detail/" + FreeBoardId);
        location.hash = "app/bbspost/h0102-slist/" + encodeURIComponent(JSON.stringify(srch, replacer)) + "/detail/" + FreeBoardId;
//        ft.o.ctrState.go(link, {srch : encodeURIComponent(JSON.stringify(srch, replacer)), FreeBoardId:FreeBoardId });
      } else {

       /*  var e ={}
        e.ft = ft;
        e.dockMode = dockMode;
        e.eventState = "click";
        callback(e); */
        var url = location.origin + "/#/app/bbspost/h0102-slist/" + encodeURIComponent(JSON.stringify(srch, replacer)) + "/" + FreeBoardId;
        if(dockMode == type.v) {

          $("#dockTop iframe").attr("src", url);
        } else {
          //console.log("clci");
          $("#dockbottom iframe").attr("src", url);
        }
      }
    }
  });
}

function setDockView($compile, $scope, mode, callback) {
  // mode 대신 필요한 정보를 object 형식으로 받을 수 있도록 수정 필요
  var setDocViewInterval = setInterval(function() {


    var $docWrap = $("#dockWrap");

    if($docWrap.length > 0) {

      var $docBackup = $("#dockBackupWrap");

      clearInterval(setDocViewInterval);
      var type = {v: "vertical", h: "horizon", d: "default"};
      var localStorage = window.localStorage;
      if(mode.type == null) localStorage.setItem("dockMode", "default");
      else localStorage.setItem("dockMode", mode.type);

      if($docBackup.length == 0) {
        $docWrap.after("<div id='dockBackupWrap'></div>");
        $docBackup = $("#dockBackupWrap");
        $docBackup.append($docWrap.children().clone(true, true, true));
      }
      var $docWrapChild = $docBackup.children().clone(true, true, true);
      $("#dockWrap").empty().html('');
      if(mode.type == null || mode.type == type.d) {
        //$("#dockWrap").append("<div id='dockLeft' dock=\"'left'\"><div class='dock-content'></div></div>");
      } else if(mode.type == type.v) {
        $("#dockWrap").append("<div id='dockLeft' dock=\"'left'\" dock-ref=\"\" dock-resizable ><div class='dock-content'></div></div>");
        $("#dockWrap").append("<div id='dockTop' dock=\"'fill'\" dock-ref=\"\" ><div class='dock-content'><iframe>리스트를 클릭하여주세요.</iframe></div></div>");


      } else {
       // $("#dockWrap").append("<div id='dockLeft' dock=\"'left'\" dock-resizable><div class='dock-content'></div></div>");

        $("#dockWrap").append("<div id='dockbottom' dock=\"'bottom'\" dock-resizable ><div class='dock-content'><iframe>리스트를 클릭하여주세요.</iframe></div></div>");
        $("#dockWrap").append("<div id='dockTop' dock=\"'fill'\" dock-ref=\"\"     ><div class='dock-content'></div></div>");

      }

      var $view = {l: $("#dockLeft"), t: $("#dockTop"), b: $("#dockbottom") };
      var offset = $docWrap.offset();
      var viewHeight =$(window).height() - (offset.top+5);
      if(mode.type == null || mode.type == type.d) {

      } else {

        //console.log(offset.top, $(window).height())

        $docWrap.css("height", viewHeight );
      }
      $docWrap.attr("dock-ref","");

      if(mode.type == null || mode.type == type.d) {
       /*  $view.l.css("width","100%");
        $view.l.css("height","100%"); */
      } else if(mode.type == type.v) {
        $view.l.css("width","50%");
        $view.t.css("height","100%");
      } else {
        $("#dockbottom").css("height",viewHeight/2);
      }

      $compile($docWrap)($scope);

      if(mode.type == null || mode.type == type.d) {
        //$("#dockLeft .dock-content").append($docWrapChild);
        $("#dockWrap").empty().html($docWrapChild);
      } else if(mode.type == type.v) {
        $("#dockLeft .dock-content").append($docWrapChild);
      } else {
        $("#dockTop .dock-content").append($docWrapChild);
      }

      callback();

    }
  }, 500);

}


/**
 * Null or Empty 검사
 * !value 하면 생기는 논리적 오류를 제거하기 위해 명시적으로 value == 사용 [], {} 도 빈값으로 처리
 * @param value - 검사할 값
 * @return true or false
 */
function isNullOrEmpty(value) {
  return value === "" || value === " " || value === '0.00' || value === null || value === undefined || (value != null && typeof value === "object" && !Object.keys(value).length);
}

/**
 * Email 검사
 * @param value - 검사할 값
 * @return true or false
 */
function isValidEmail(value) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(value);
}

/**
 * 날짜 검사
 * @param value - 검사할 값
 * @return true or false
 */
function isValidDate(value) {
  return value instanceof Date && !isNaN(value) && value != undefined;
}

function fnOpenLayer(width) {
  //console.log($(".search-detail-wrap"));
  var position = $(".search-detail-wrap").css('position');

  var pos = position == 'absolute' ? $(".search_layer").position() : $(".search_layer").offset();
  var h = $(".search_layer").height();

  setTimeout(function(){
    $(".search-detail-wrap").css("left", (pos.left) + 10);
    $(".search-detail-wrap").css("top", (pos.top) + 31);
    if (width) {
      $(".search-detail-wrap").css("width", width);
    }

    if ($(".search-detail-wrap").is(":visible")) {
      $(".search-detail-wrap").hide();
    } else {
      $(".search-detail-wrap").show();
    }
  }, 1);

  return false;
}

function fnCloseLayer() {
  $(".search-detail-wrap").hide();
  return false;
}

function date2str(x, y) {
  var z = {
      M: x.getMonth() + 1,
      d: x.getDate(),
      h: x.getHours(),
      m: x.getMinutes(),
      s: x.getSeconds()
  };
  y = y.replace(/(M+|d+|h+|m+|s+)/g, function(v) {
      return ((v.length > 1 ? "0" : "") + eval('z.' + v.slice(-1))).slice(-2);
  });

  return y.replace(/(y+)/g, function(v) {
      return x.getFullYear().toString().slice(-v.length);
  });
}

function getSearchConditionStr(count, columnMap, srch) {
  var countStr = count? count : 0;

  var searchConditionStr = '<b>검색결과 <font color=red>' + Number(countStr).toLocaleString('en') + '</font>건</b> ';

  var str = [];
  for (var key in srch) {
    if (key == 'page' || key == 'viewSize' || key == 'tableNm' || key == 'sortDirect' || key == 'sortColumn' || key == 'userkey' || key == 'selectType' || key == 'srchTenantId')
      continue;

    var name = key;
    var value = srch[key];

    if (columnMap[key]) {
      name = columnMap[key].ColumnLogicalNm;

      if (columnMap[key].ColumnLogicalDataType == "50") {
        if (columnMap[key].CodeList) {
          columnMap[key].CodeList.forEach(function (v) {
            if (v.Code == value) {
              value = v.CodeValue;
              return;
            }
          });
        }
      }

      str.push(name + ':' + value);
    }
  }

  searchConditionStr += str.join(',');

  return searchConditionStr;
}

var Base64={
  _keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode:function(e)
  {
      var t="";
      var n,r,i,s,o,u,a;
      var f=0;
      e=Base64._utf8_encode(e);

      while(f<e.length)
      {
          n=e.charCodeAt(f++);
          r=e.charCodeAt(f++);
          i=e.charCodeAt(f++);
          s=n>>2;
          o=(n&3)<<4|r>>4;
          u=(r&15)<<2|i>>6;
          a=i&63;

          if(isNaN(r))
          {
              u=a=64;
          }
          else if(isNaN(i))
          {
              a=64;
          }

          t=t+this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
      }

      return t;
  },
  decode:function(e)
  {
      var t="";
      var n,r,i;
      var s,o,u,a;
      var f=0;
      e=e.replace(/[^A-Za-z0-9+/=]/g,"");

      while(f<e.length)
      {
          s=this._keyStr.indexOf(e.charAt(f++));
          o=this._keyStr.indexOf(e.charAt(f++));
          u=this._keyStr.indexOf(e.charAt(f++));
          a=this._keyStr.indexOf(e.charAt(f++));
          n=s<<2|o>>4;
          r=(o&15)<<4|u>>2;
          i=(u&3)<<6|a;
          t=t+String.fromCharCode(n);

          if(u!=64)
          {
              t=t+String.fromCharCode(r);
          }

          if(a!=64)
          {
              t=t+String.fromCharCode(i);
          }
      }

      t=Base64._utf8_decode(t);

      return t;
  },
  _utf8_encode:function(e)
  {
      e=e.replace(/rn/g,"n");
      var t="";

      for(var n=0;n<e.length;n++)
      {
          var r=e.charCodeAt(n);

          if(r<128)
          {
              t+=String.fromCharCode(r);
          }
          else if(r>127&&r<2048)
          {
              t+=String.fromCharCode(r>>6|192);
              t+=String.fromCharCode(r&63|128);
          }
          else
          {
              t+=String.fromCharCode(r>>12|224);
              t+=String.fromCharCode(r>>6&63|128);
              t+=String.fromCharCode(r&63|128);
          }
      }

      return t;
  },
  _utf8_decode:function(e)
  {
      var t="";
      var n=0;
      var r=c1=c2=0;

      while(n<e.length)
      {
          r=e.charCodeAt(n);
          if(r<128)
          {
              t+=String.fromCharCode(r);
              n++;
          }
          else if(r>191&&r<224)
          {
              c2=e.charCodeAt(n+1);
              t+=String.fromCharCode((r&31)<<6|c2&63);
              n+=2;
          }
          else
          {
              c2=e.charCodeAt(n+1);
              c3=e.charCodeAt(n+2);
              t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);
              n+=3;
          }
      }
      return t;
  }
};

function binary2text(encodedString) {
  var word;
  var agent = navigator.userAgent.toLowerCase();
  // IE old version ( IE 10 or Lower )
  if (navigator.appName == "Microsoft Internet Explorer") {
    console.log("Microsoft Internet Explorer (IE 10 or Lower)");
    word = "msie ";
    return Base64.decode(encodedString);
  } else if (agent.search("trident") > -1) {
    word = "trident/.*rv:";
  // Microsoft Edge
  } else if (agent.search("edge/") > -1) {
    word = "edge/";
  // 그외, IE가 아니라면 ( If it's not IE or Edge )
  } else {
  }

//  return atob(encodedString);

  return Base64.decode(encodedString);
}

function drawWordCloud(data, divId) {
  var weight = 3,   // change me
  width = $("#" + divId).width(),
  height = 300;

//  var data = [{text:'word', size:100},{text:'cloud', size:50},{text:'워드', size:50}];

  var fill = d3.scale.category20();
  d3.layout.cloud().size([width, height]).words(data)
    //.rotate(function() { return ~~(Math.random() * 2) * 90; })
    .rotate(0)
    .font("Impact")
    .fontSize(function(d) { return d.size; })
    .on("end", draw)
    .start();

  function draw(words) {
    d3.select("svg").selectAll("text")
      .style("font-size", function(d, i) { });

    d3.select("#" + divId)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", "translate(" + width/2 + "," + height/2 + ")")
      .selectAll("text")
      .data(words)
      .enter().append("text")
      .style("font-size", function(d) { return d.size + "px"; })
      .style("font-family", "Impact")
      .style("fill", function(d, i) { return fill(i); })
      .attr("text-anchor", "middle")
      .attr("transform", function(d) {
        return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
      })
      .text(function(d) { return d.text; });
  }
}

function fnTelMobileNoCheck(telNo) {
  var errMsg = "입력된 번호를 확인해 주십시오.";
  var result = false;
  var regExp = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

  if (telNo == "") {
      alert(errMsg);
      return false;
  } else if (telNo.length < 7 || telNo.length > 14) {
      alert(errMsg);
      return false;
  }

  result = regExp.test(telNo);

  if (!result)
      alert(errMsg);

  return result;
}


/*
@license

dhtmlxVault v.3.0.0 Professional

This software is covered by DHTMLX Enterprise License.
Usage without proper license is prohibited.

(c) Dinamenta, UAB.

*/
if (window.dhx){ window.dhx_legacy = dhx; delete window.dhx; }(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["dhx"] = factory();
	else
		root["dhx"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/codebase/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 27);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom = __webpack_require__(43);
exports.el = dom.defineElement;
exports.sv = dom.defineSvgElement;
exports.view = dom.defineView;
exports.create = dom.createView;
exports.inject = dom.injectView;
function disableHelp() {
    dom.DEVMODE.mutations = false;
    dom.DEVMODE.warnings = false;
    dom.DEVMODE.verbose = false;
    dom.DEVMODE.UNKEYED_INPUT = false;
}
exports.disableHelp = disableHelp;
function resizer(handler) {
    return exports.el("iframe", {
        _hooks: {
            didInsert: function (node) {
                var activeHandler = function () {
                    var height = node.el.offsetHeight;
                    var width = node.el.offsetWidth;
                    handler(width, height);
                };
                node.el.contentWindow.onresize = activeHandler;
                activeHandler();
            }
        },
        style: "position:absolute;left:0;top:-100%;width:100%;height:100%;margin:1px 0 0;border:none;opacity:0;visibility:hidden;pointer-events:none;",
    });
}
exports.resizer = resizer;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(37);
function toNode(node) {
    if (typeof node === "string") {
        node = (document.getElementById(node) || document.querySelector(node));
    }
    return node || document.body;
}
exports.toNode = toNode;
function eventHandler(prepare, hash) {
    var keys = Object.keys(hash);
    return function (ev) {
        var data = prepare(ev);
        var node = ev.target;
        while (node) {
            var cssstring = node.getAttribute ? (node.getAttribute("class") || "") : "";
            if (cssstring.length) {
                var css = cssstring.split(" ");
                for (var j = 0; j < keys.length; j++) {
                    if (css.indexOf(keys[j]) > -1) {
                        return hash[keys[j]](ev, data);
                    }
                }
            }
            node = node.parentNode;
        }
        return true;
    };
}
exports.eventHandler = eventHandler;
function locate(target, attr) {
    if (attr === void 0) { attr = "dhx_id"; }
    var node = locateNode(target, attr);
    return node ? node.getAttribute(attr) : "";
}
exports.locate = locate;
function locateNode(target, attr) {
    if (attr === void 0) { attr = "dhx_id"; }
    if (target instanceof Event) {
        target = target.target;
    }
    while (target && target.getAttribute) {
        if (target.getAttribute(attr)) {
            return target;
        }
        target = target.parentNode;
    }
}
exports.locateNode = locateNode;
function getBox(elem) {
    var box = elem.getBoundingClientRect();
    var body = document.body;
    var scrollTop = window.pageYOffset || body.scrollTop;
    var scrollLeft = window.pageXOffset || body.scrollLeft;
    var top = box.top + scrollTop;
    var left = box.left + scrollLeft;
    var right = body.offsetWidth - box.right;
    var bottom = body.offsetHeight - box.bottom;
    var width = box.right - box.left;
    var height = box.bottom - box.top;
    return { top: top, left: left, right: right, bottom: bottom, width: width, height: height };
}
exports.getBox = getBox;
var scrollWidth = -1;
function getScrollbarWidth() {
    if (scrollWidth > -1) {
        return scrollWidth;
    }
    var scrollDiv = document.createElement("div");
    document.body.appendChild(scrollDiv);
    scrollDiv.style.cssText = "position: absolute;left: -99999px;overflow:scroll;width: 100px;height: 100px;";
    scrollWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollWidth;
}
exports.getScrollbarWidth = getScrollbarWidth;
function fitPosition(target, mode, width, height) {
    var right = target.left + target.width;
    var bottom = target.top + target.height;
    if (mode === "bottom") {
        var left = window.innerWidth < target.left + width ? right - width : target.left;
        var top_1 = bottom + height > window.innerHeight ? target.top - height + window.scrollY : bottom + window.scrollY;
        return {
            position: "absolute",
            left: left,
            top: top_1,
            minWidth: width
        };
    }
    else {
        var overflow = void 0;
        var top_2 = target.top + window.scrollY;
        var left = window.innerWidth < right + width ? target.left - width : right;
        if (bottom + height > window.innerHeight) {
            if (bottom - height > 0) {
                top_2 = bottom - height + window.scrollY;
            }
            else {
                overflow = "scroll";
                height = (window.innerHeight - target.top) * 0.8;
            }
        }
        return {
            position: "absolute",
            left: left,
            top: top_2,
            minWidth: width,
            overflow: overflow,
            height: height
        };
    }
}
exports.fitPosition = fitPosition;
function isIE() {
    var ua = window.navigator.userAgent;
    return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
}
exports.isIE = isIE;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var types_1 = __webpack_require__(4);
function getCss(item) {
    var className = "";
    if (item.type !== types_1.ItemType.button && item.size) {
        className += " " + item.size;
    }
    if (item.active) {
        className += " active";
    }
    if (item.$disabled) {
        className += " disabled";
    }
    if (item.css) {
        className += " " + item.css;
    }
    return className;
}
exports.getCss = getCss;
function getButtonCss(item) {
    var className = " ";
    className += item.name === "link" ? "dhx_btn--link" : "dhx_btn--flat";
    className += item.size === "large" ? " dhx_btn--large" : " dhx_btn--small";
    switch (item.usage) {
        case "danger":
            className += " dhx_btn--danger";
            break;
        case "secondary":
            className += " dhx_btn--secondary";
            break;
        case "success":
            className += " dhx_btn--success";
            break;
        case "primary":
        default:
            break;
    }
    return className;
}
exports.getButtonCss = getButtonCss;
function counter(item) {
    if (item.count) {
        return dom_1.el(".counter", item.count);
    }
}
exports.counter = counter;
function icon(iconName) {
    if (iconName === void 0) { iconName = ""; }
    var className = "dhx-icon-block ";
    if (iconName.slice(0, 3) === "dxi") {
        className += "dxi ";
    }
    return dom_1.el("div", {
        class: className + iconName
    });
}
exports.icon = icon;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var counter = (new Date()).valueOf();
function uid() {
    return "u" + (counter++);
}
exports.uid = uid;
function extend(target, source, deep) {
    if (deep === void 0) { deep = true; }
    if (source) {
        for (var key in source) {
            var sobj = source[key];
            var tobj = target[key];
            if (deep && typeof tobj === "object" && !(tobj instanceof Date) && !(tobj instanceof Array)) {
                extend(tobj, sobj);
            }
            else {
                target[key] = sobj;
            }
        }
    }
    return target;
}
exports.extend = extend;
function copy(source) {
    var result = {};
    for (var key in source) {
        result[key] = source[key];
    }
    return result;
}
exports.copy = copy;
function naturalSort(arr) {
    return arr.sort(function (a, b) {
        var nn = typeof a === "string" ? a.localeCompare(b) : a - b;
        return nn;
    });
}
exports.naturalSort = naturalSort;
function findIndex(arr, predicate) {
    var len = arr.length;
    for (var i = 0; i < len; i++) {
        if (predicate(arr[i])) {
            return i;
        }
    }
    return -1;
}
exports.findIndex = findIndex;
function isEqualString(from, to) {
    if (from.length > to.length) {
        return false;
    }
    for (var i = 0; i < from.length; i++) {
        if (from[i].toLowerCase() !== to[i].toLowerCase()) {
            return false;
        }
    }
    return true;
}
exports.isEqualString = isEqualString;
function singleOuterClick(fn) {
    var click = function (e) {
        if (fn(e)) {
            document.removeEventListener("click", click);
        }
    };
    document.addEventListener("click", click);
}
exports.singleOuterClick = singleOuterClick;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(5);
exports.DataEvents = types_1.DataEvents;
var ItemType;
(function (ItemType) {
    ItemType["button"] = "button";
    ItemType["input"] = "input";
    ItemType["separator"] = "separator";
    ItemType["text"] = "text";
    ItemType["iconButton"] = "iconButton";
    ItemType["imageButton"] = "imageButton";
    ItemType["spacer"] = "spacer";
    ItemType["menuItem"] = "menuItem";
    ItemType["imageButtonText"] = "imageButtonText";
    ItemType["block"] = "block";
    ItemType["customHTMLButton"] = "customButton";
    ItemType["selectButton"] = "selectButton";
    ItemType["dhxButton"] = "dhx-button";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var ToolbarEvents;
(function (ToolbarEvents) {
    ToolbarEvents["inputCreated"] = "inputcreated";
    ToolbarEvents["click"] = "click";
})(ToolbarEvents = exports.ToolbarEvents || (exports.ToolbarEvents = {}));
var NavigationType;
(function (NavigationType) {
    NavigationType["pointer"] = "pointer";
    NavigationType["click"] = "click";
})(NavigationType = exports.NavigationType || (exports.NavigationType = {}));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DataEvents;
(function (DataEvents) {
    DataEvents["afterAdd"] = "afteradd";
    DataEvents["beforeAdd"] = "beforeadd";
    DataEvents["removeAll"] = "removeall";
    DataEvents["beforeRemove"] = "beforeremove";
    DataEvents["afterRemove"] = "afterremove";
    DataEvents["change"] = "change";
    DataEvents["load"] = "load";
})(DataEvents = exports.DataEvents || (exports.DataEvents = {}));
var DragEvents;
(function (DragEvents) {
    DragEvents["beforeDrag"] = "beforedrag";
    DragEvents["beforeDrop"] = "beforeDrop";
    DragEvents["dragStart"] = "dragstart";
    DragEvents["dragEnd"] = "dragend";
    DragEvents["canDrop"] = "candrop";
    DragEvents["cancelDrop"] = "canceldrop";
    DragEvents["dropComplete"] = "dropcomplete";
    DragEvents["dragOut"] = "dragOut";
    DragEvents["dragIn"] = "dragIn";
})(DragEvents = exports.DragEvents || (exports.DragEvents = {}));
var DragMode;
(function (DragMode) {
    DragMode["target"] = "target";
    DragMode["both"] = "both";
    DragMode["source"] = "source";
})(DragMode = exports.DragMode || (exports.DragMode = {}));
var DragBehaviour;
(function (DragBehaviour) {
    DragBehaviour["child"] = "child";
    DragBehaviour["sibling"] = "sibling";
    DragBehaviour["complex"] = "complex";
})(DragBehaviour = exports.DragBehaviour || (exports.DragBehaviour = {}));
var SelectionEvents;
(function (SelectionEvents) {
    SelectionEvents["beforeUnSelect"] = "beforeunselect";
    SelectionEvents["afterUnSelect"] = "afterunselect";
    SelectionEvents["beforeSelect"] = "beforeselect";
    SelectionEvents["afterSelect"] = "afterselect";
})(SelectionEvents = exports.SelectionEvents || (exports.SelectionEvents = {}));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(5);
exports.DataEvents = types_1.DataEvents;
exports.DragBehaviour = types_1.DragBehaviour;
exports.DragMode = types_1.DragMode;
var TreeFilterType;
(function (TreeFilterType) {
    TreeFilterType[TreeFilterType["all"] = 1] = "all";
    TreeFilterType[TreeFilterType["specific"] = 2] = "specific";
    TreeFilterType[TreeFilterType["leafs"] = 3] = "leafs";
})(TreeFilterType = exports.TreeFilterType || (exports.TreeFilterType = {}));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dataproxy_1 = __webpack_require__(11);
var CsvDriver_1 = __webpack_require__(21);
var JsonDriver_1 = __webpack_require__(22);
function isEqualObj(a, b) {
    for (var key in a) {
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
exports.isEqualObj = isEqualObj;
function naturalCompare(a, b) {
    var ax = [];
    var bx = [];
    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]); });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]); });
    while (ax.length && bx.length) {
        var an = ax.shift();
        var bn = bx.shift();
        var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
        if (nn) {
            return nn;
        }
    }
    return ax.length - bx.length;
}
exports.naturalCompare = naturalCompare;
function findByConf(item, conf) {
    if (typeof conf === "function") {
        if (conf.call(this, item)) {
            return item;
        }
    }
    else if (conf.by && conf.match) {
        if (item[conf.by] === conf.match) {
            return item;
        }
    }
}
exports.findByConf = findByConf;
function isDebug() {
    var dhx = window.dhx;
    if (typeof dhx !== "undefined") {
        return typeof (dhx.debug) !== "undefined" && dhx.debug;
    }
    // return typeof DHX_DEBUG_MODE !== "undefined" && DHX_DEBUG_MODE;
}
exports.isDebug = isDebug;
function dhxWarning(msg) {
    // tslint:disable-next-line:no-console
    console.warn(msg);
}
exports.dhxWarning = dhxWarning;
function dhxError(msg) {
    throw new Error(msg);
}
exports.dhxError = dhxError;
function toProxy(proxy) {
    var type = typeof proxy;
    if (type === "string") {
        return new dataproxy_1.DataProxy(proxy);
    }
    else if (type === "object") {
        return proxy;
    }
}
exports.toProxy = toProxy;
function toDataDriver(driver) {
    var type = typeof driver;
    if (type === "string") {
        switch (driver) {
            case "csv":
                return new CsvDriver_1.CsvDriver();
            case "json":
                return new JsonDriver_1.JsonDriver();
            default:
                // tslint:disable-next-line:no-console
                console.warn("incorrect driver type", driver);
                break;
        }
    }
    else if (typeof driver === "object") {
        return driver;
    }
}
exports.toDataDriver = toDataDriver;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(6));
__export(__webpack_require__(19));
__export(__webpack_require__(23));
__export(__webpack_require__(36));
__export(__webpack_require__(11));
__export(__webpack_require__(7));
__export(__webpack_require__(21));
__export(__webpack_require__(22));
__export(__webpack_require__(39));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EventSystem = /** @class */ (function () {
    function EventSystem(context) {
        this.events = {};
        this.context = context || this;
    }
    EventSystem.prototype.on = function (name, callback, context) {
        var event = name.toLowerCase();
        this.events[event] = this.events[event] || [];
        this.events[event].push({ callback: callback, context: context || this.context });
    };
    EventSystem.prototype.detach = function (name, context) {
        var event = name.toLowerCase();
        var eStack = this.events[event];
        if (context) {
            for (var i = eStack.length - 1; i >= 0; i--) {
                if (eStack[i].context === context) {
                    eStack.splice(i, 1);
                }
            }
        }
        else {
            this.events[event] = [];
        }
    };
    EventSystem.prototype.fire = function (name, args) {
        if (typeof args === "undefined") {
            args = [];
        }
        var event = name.toLowerCase();
        if (this.events[event]) {
            var res = this.events[event].map(function (e) { return e.callback.apply(e.context, args); });
            return res.indexOf(false) < 0;
        }
        return true;
    };
    return EventSystem;
}());
exports.EventSystem = EventSystem;
function EventsMixin(obj) {
    obj = obj || {};
    var eventSystem = new EventSystem(obj);
    obj.detachEvent = eventSystem.detach.bind(eventSystem);
    obj.attachEvent = eventSystem.on.bind(eventSystem);
    obj.callEvent = eventSystem.fire.bind(eventSystem);
}
exports.EventsMixin = EventsMixin;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {(function () {
  global = this

  var queueId = 1
  var queue = {}
  var isRunningTask = false

  if (!global.setImmediate)
    global.addEventListener('message', function (e) {
      if (e.source == global){
        if (isRunningTask)
          nextTick(queue[e.data])
        else {
          isRunningTask = true
          try {
            queue[e.data]()
          } catch (e) {}

          delete queue[e.data]
          isRunningTask = false
        }
      }
    })

  function nextTick(fn) {
    if (global.setImmediate) setImmediate(fn)
    // if inside of web worker
    else if (global.importScripts) setTimeout(fn)
    else {
      queueId++
      queue[queueId] = fn
      global.postMessage(queueId, '*')
    }
  }

  Deferred.resolve = function (value) {
    if (!(this._d == 1))
      throw TypeError()

    if (value instanceof Deferred)
      return value

    return new Deferred(function (resolve) {
        resolve(value)
    })
  }

  Deferred.reject = function (value) {
    if (!(this._d == 1))
      throw TypeError()

    return new Deferred(function (resolve, reject) {
        reject(value)
    })
  }

  Deferred.all = function (arr) {
    if (!(this._d == 1))
      throw TypeError()

    if (!(arr instanceof Array))
      return Deferred.reject(TypeError())

    var d = new Deferred()

    function done(e, v) {
      if (v)
        return d.resolve(v)

      if (e)
        return d.reject(e)

      var unresolved = arr.reduce(function (cnt, v) {
        if (v && v.then)
          return cnt + 1
        return cnt
      }, 0)

      if(unresolved == 0)
        d.resolve(arr)

      arr.map(function (v, i) {
        if (v && v.then)
          v.then(function (r) {
            arr[i] = r
            done()
            return r
          }, done)
      })
    }

    done()

    return d
  }

  Deferred.race = function (arr) {
    if (!(this._d == 1))
      throw TypeError()

    if (!(arr instanceof Array))
      return Deferred.reject(TypeError())

    if (arr.length == 0)
      return new Deferred()

    var d = new Deferred()

    function done(e, v) {
      if (v)
        return d.resolve(v)

      if (e)
        return d.reject(e)

      var unresolved = arr.reduce(function (cnt, v) {
        if (v && v.then)
          return cnt + 1
        return cnt
      }, 0)

      if(unresolved == 0)
        d.resolve(arr)

      arr.map(function (v, i) {
        if (v && v.then)
          v.then(function (r) {
            done(null, r)
          }, done)
      })
    }

    done()

    return d
  }

  Deferred._d = 1


  /**
   * @constructor
   */
  function Deferred(resolver) {
    'use strict'
    if (typeof resolver != 'function' && resolver != undefined)
      throw TypeError()

    if (typeof this != 'object' || (this && this.then))
      throw TypeError()

    // states
    // 0: pending
    // 1: resolving
    // 2: rejecting
    // 3: resolved
    // 4: rejected
    var self = this,
      state = 0,
      val = 0,
      next = [],
      fn, er;

    self['promise'] = self

    self['resolve'] = function (v) {
      fn = self.fn
      er = self.er
      if (!state) {
        val = v
        state = 1

        nextTick(fire)
      }
      return self
    }

    self['reject'] = function (v) {
      fn = self.fn
      er = self.er
      if (!state) {
        val = v
        state = 2

        nextTick(fire)

      }
      return self
    }

    self['_d'] = 1

    self['then'] = function (_fn, _er) {
      if (!(this._d == 1))
        throw TypeError()

      var d = new Deferred()

      d.fn = _fn
      d.er = _er
      if (state == 3) {
        d.resolve(val)
      }
      else if (state == 4) {
        d.reject(val)
      }
      else {
        next.push(d)
      }

      return d
    }

    self['catch'] = function (_er) {
      return self['then'](null, _er)
    }

    var finish = function (type) {
      state = type || 4
      next.map(function (p) {
        state == 3 && p.resolve(val) || p.reject(val)
      })
    }

    try {
      if (typeof resolver == 'function')
        resolver(self['resolve'], self['reject'])
    } catch (e) {
      self['reject'](e)
    }

    return self

    // ref : reference to 'then' function
    // cb, ec, cn : successCallback, failureCallback, notThennableCallback
    function thennable (ref, cb, ec, cn) {
      // Promises can be rejected with other promises, which should pass through
      if (state == 2) {
        return cn()
      }
      if ((typeof val == 'object' || typeof val == 'function') && typeof ref == 'function') {
        try {

          // cnt protects against abuse calls from spec checker
          var cnt = 0
          ref.call(val, function (v) {
            if (cnt++) return
            val = v
            cb()
          }, function (v) {
            if (cnt++) return
            val = v
            ec()
          })
        } catch (e) {
          val = e
          ec()
        }
      } else {
        cn()
      }
    };

    function fire() {

      // check if it's a thenable
      var ref;
      try {
        ref = val && val.then
      } catch (e) {
        val = e
        state = 2
        return fire()
      }

      thennable(ref, function () {
        state = 1
        fire()
      }, function () {
        state = 2
        fire()
      }, function () {
        try {
          if (state == 1 && typeof fn == 'function') {
            val = fn(val)
          }

          else if (state == 2 && typeof er == 'function') {
            val = er(val)
            state = 1
          }
        } catch (e) {
          val = e
          return finish()
        }

        if (val == self) {
          val = TypeError()
          finish()
        } else thennable(ref, function () {
            finish(3)
          }, finish, function () {
            finish(state == 1 && 3)
          })

      })
    }


  }

  // Export our library object, either for node.js or as a globally scoped variable
  if (true) {
    module['exports'] = Deferred
  } else {}
})()

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20), __webpack_require__(32).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var DataProxy = /** @class */ (function () {
    function DataProxy(url) {
        this.url = url;
    }
    DataProxy.prototype.load = function () {
        return this._ajax(this.url);
    };
    DataProxy.prototype.save = function (data, mode) {
        var modes = {
            insert: "POST",
            delete: "DELETE",
            update: "POST"
        };
        return this._ajax(this.url, data, modes[mode] || "POST");
    };
    DataProxy.prototype._ajax = function (url, data, method) {
        if (method === void 0) { method = "GET"; }
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.response || xhr.responseText);
                }
                else {
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            };
            xhr.open(method, url);
            xhr.setRequestHeader("Content-Type", "application/json");
            switch (method) {
                case "POST":
                case "DELETE":
                case "PUT":
                    xhr.send(JSON.stringify(data));
                    break;
                case "GET":
                    xhr.send();
                    break;
                default:
                    xhr.send();
                    break;
            }
        });
    };
    return DataProxy;
}());
exports.DataProxy = DataProxy;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var html_1 = __webpack_require__(1);
var View = /** @class */ (function () {
    function View(_container, config) {
        this._uid = core_1.uid();
        this.config = config || {};
    }
    View.prototype.mount = function (container, vnode) {
        if (vnode) {
            this._view = vnode;
        }
        if (container && this._view && this._view.mount) {
            // init view inside of HTML container
            this._container = html_1.toNode(container);
            if (this._container.tagName) {
                this._view.mount(this._container);
            }
            else if (this._container.attach) {
                this._container.attach(this);
            }
        }
    };
    View.prototype.getRootView = function () {
        return this._view;
    };
    View.prototype.paint = function () {
        if (this._view && ( // was mounted
        this._view.node || // already rendered node
            this._container || // not rendered, but has container
            !this._view.mount)) { // fake cell node
            this._doNotRepaint = false;
            this._view.redraw();
        }
    };
    return View;
}());
exports.View = View;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getRealPosition(node) {
    var rects = node.getBoundingClientRect();
    return {
        left: rects.left + window.pageXOffset,
        right: rects.right + window.pageXOffset,
        top: rects.top + window.pageYOffset,
        bottom: rects.bottom + window.pageYOffset
    };
}
exports.getRealPosition = getRealPosition;
function calculatePosition(pos, config) {
    var rightBorder = window.pageXOffset + window.innerWidth;
    var bottomBorder = window.pageYOffset + window.innerHeight;
    var style = {
        left: null,
        top: null,
        minWidth: config.width + "px",
        position: "absolute"
    };
    if (config.mode === "bottom") {
        if (pos.left + config.width > rightBorder) {
            style.left = pos.left - config.width + "px";
        }
        else {
            style.left = pos.left + "px";
        }
        if (pos.bottom + config.height > bottomBorder) {
            style.top = pos.top - config.height + "px";
        }
        else {
            style.top = pos.bottom + "px";
        }
    }
    else {
        if (pos.right + config.width > rightBorder) {
            style.left = pos.left - config.width + "px";
        }
        else {
            style.left = pos.right + "px";
        }
        if (pos.top + config.height > bottomBorder) {
            style.top = pos.bottom - config.height + "px";
        }
        else {
            style.top = pos.top + "px";
        }
    }
    return style;
}
exports.calculatePosition = calculatePosition;
function addInGroups(groups, item) {
    if (groups[item.group]) {
        if (item.active) {
            groups[item.group].active = item.id;
        }
        groups[item.group].elements.push(item.id);
    }
    else {
        groups[item.group] = {
            active: item.active ? item.id : null,
            elements: [item.id]
        };
    }
}
exports.addInGroups = addInGroups;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var locale = {
    dragAndDrop: "Drag & drop",
    or: "or",
    browse: "Browse files",
    filesOrFoldersHere: "files or folders here",
    cancel: "Cancel",
    clearAll: "Clear all",
    clear: "Clear",
    add: "Add",
    upload: "Upload",
    download: "Download",
    error: "error",
    byte: "B",
    kilobyte: "KB",
    megabyte: "MB",
    gigabyte: "GB"
};
exports["default"] = locale;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(5);
var types_2 = __webpack_require__(5);
exports.DataEvents = types_2.DataEvents;
var FileStatus;
(function (FileStatus) {
    FileStatus["queue"] = "queue";
    FileStatus["uploaded"] = "uploaded";
    FileStatus["failed"] = "failed";
    FileStatus["inprogress"] = "inprogress";
})(FileStatus = exports.FileStatus || (exports.FileStatus = {}));
var UploaderEvents;
(function (UploaderEvents) {
    UploaderEvents["uploadBegin"] = "uploadbegin";
    UploaderEvents["beforeUploadFile"] = "beforeuploadfile";
    UploaderEvents["uploadFile"] = "uploadfile";
    UploaderEvents["uploadFail"] = "uploadfail";
    UploaderEvents["uploadComplete"] = "uploadcomplete";
    UploaderEvents["uploadProgress"] = "uploadprogress";
})(UploaderEvents = exports.UploaderEvents || (exports.UploaderEvents = {}));
var ProgressBarEvents;
(function (ProgressBarEvents) {
    ProgressBarEvents["cancel"] = "cancel";
})(ProgressBarEvents = exports.ProgressBarEvents || (exports.ProgressBarEvents = {}));
var VaultMode;
(function (VaultMode) {
    VaultMode["grid"] = "grid";
    VaultMode["list"] = "list";
})(VaultMode = exports.VaultMode || (exports.VaultMode = {}));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(24));
__export(__webpack_require__(40));
__export(__webpack_require__(25));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var button_1 = __webpack_require__(49);
var customHTMLButton_1 = __webpack_require__(50);
var dhx_button_1 = __webpack_require__(51);
var iconButton_1 = __webpack_require__(52);
var imageButton_1 = __webpack_require__(53);
var imageButtonText_1 = __webpack_require__(54);
var input_1 = __webpack_require__(55);
var menuItem_1 = __webpack_require__(56);
var separator_1 = __webpack_require__(57);
var spacer_1 = __webpack_require__(58);
var text_1 = __webpack_require__(59);
var types_1 = __webpack_require__(4);
function itemfactory(item, events) {
    if (item.$hidden) {
        return null;
    }
    switch (item.type) {
        case types_1.ItemType.button:
            return button_1.button(item);
        case types_1.ItemType.text:
            return text_1.text(item);
        case types_1.ItemType.separator:
            return separator_1.separator(item);
        case types_1.ItemType.spacer:
            return spacer_1.spacer(item);
        case types_1.ItemType.input:
            return input_1.input(item, events);
        case types_1.ItemType.imageButton:
            return imageButton_1.imageButton(item);
        case types_1.ItemType.iconButton:
            return iconButton_1.iconButton(item);
        case types_1.ItemType.selectButton:
        case types_1.ItemType.menuItem:
            return menuItem_1.menuItem(item);
        case types_1.ItemType.imageButtonText:
            return imageButtonText_1.imageButtonText(item);
        case types_1.ItemType.customHTMLButton:
            return customHTMLButton_1.customHTMLButton(item);
        case types_1.ItemType.dhxButton:
            return dhx_button_1.dhx_button(item);
        case types_1.ItemType.block:
        default:
            throw new Error("unknown item type");
    }
}
exports.itemfactory = itemfactory;
function createFactory(defaultType, forbiddenTypes) {
    if (forbiddenTypes === void 0) { forbiddenTypes = []; }
    var forbidden = {};
    forbiddenTypes.forEach(function (type) { return forbidden[type] = true; });
    return function (item, events) {
        item.type = item.type || defaultType;
        if (forbidden[item.type]) {
            item.type = defaultType;
        }
        return itemfactory(item, events);
    };
}
exports.createFactory = createFactory;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var events_1 = __webpack_require__(9);
var hotkeys_1 = __webpack_require__(60);
var html_1 = __webpack_require__(1);
var view_1 = __webpack_require__(12);
var ts_data_1 = __webpack_require__(8);
var helper_1 = __webpack_require__(13);
var itemfactory_1 = __webpack_require__(17);
var types_1 = __webpack_require__(4);
var MenuBase = /** @class */ (function (_super) {
    __extends(MenuBase, _super);
    function MenuBase(element, config) {
        var _this = _super.call(this, element, core_1.extend({
            popupWidth: 175
        }, config)) || this;
        _this._isContextMenu = false;
        _this._documentHaveListener = false;
        _this.events = new events_1.EventSystem();
        _this.data = new ts_data_1.TreeCollection({}, _this.events);
        _this._documentClick = function (e) {
            if (html_1.locate(e, "dhx_widget_id") !== _this._uid && _this._documentHaveListener) {
                document.removeEventListener("click", _this._documentClick);
                _this._documentHaveListener = false;
                _this._close();
            }
        };
        _this._currentRoot = _this.data.getRoot();
        _this._factory = itemfactory_1.createFactory(types_1.ItemType.menuItem);
        _this._init();
        _this._initHandlers();
        _this._initEvents();
        return _this;
    }
    MenuBase.prototype.paint = function () {
        _super.prototype.paint.call(this);
        this._vpopups.redraw();
    };
    MenuBase.prototype.disable = function (ids) {
        this._setProp(ids, "$disabled", true);
    };
    MenuBase.prototype.enable = function (ids) {
        this._setProp(ids, "$disabled", false);
    };
    MenuBase.prototype.show = function (ids) {
        this._setProp(ids, "$hidden", false);
    };
    MenuBase.prototype.hide = function (ids) {
        this._setProp(ids, "$hidden", true);
    };
    MenuBase.prototype.destructor = function () {
        hotkeys_1.keyManager.removeHotKey(null, this);
    };
    MenuBase.prototype._close = function () {
        if (this.config.navigationType === types_1.NavigationType.click) {
            this._isActive = false;
        }
        clearTimeout(this._currentTimeout);
        this._activeMenu = null;
        this.paint();
    };
    MenuBase.prototype._init = function () {
        var _this = this;
        var render = function () { return dom_1.el("div", __assign({ dhx_widget_id: _this._uid, class: "menu-popups" + (_this._isContextMenu ? " context-menu" : "") }, _this._handlers), _this._drawPopups()); };
        this._vpopups = dom_1.create({
            render: render
        });
        this._vpopups.mount(document.body);
    };
    MenuBase.prototype._initHandlers = function () {
        var _this = this;
        /*
            for navigation type click:
            first click open menu, _isActive = true
            after navigation use mousemove
            can be closed after outer click or menu leaf item click
        */
        this._isActive = this.config.navigationType !== types_1.NavigationType.click;
        this._handlers = {
            onmousemove: function (e) {
                if (!_this._isActive) {
                    return;
                }
                var elem = html_1.locateNode(e);
                if (!elem) {
                    _this._activeItemChange(null);
                    return;
                }
                var id = elem.getAttribute("dhx_id");
                if (_this._activeMenu !== id) {
                    _this._activeMenu = id;
                    if (_this.data.haveChilds(id)) {
                        var position = helper_1.getRealPosition(elem);
                        _this.data.update(id, { $position: position }, false);
                    }
                    _this._activeItemChange(id);
                }
            },
            onmouseleave: function () {
                if (_this.config.navigationType !== types_1.NavigationType.click) { // maybe all time when mouse leave close menu
                    _this._activeItemChange(null);
                }
            },
            onclick: function (e) {
                var element = html_1.locateNode(e);
                if (!element) {
                    return;
                }
                var id = element.getAttribute("dhx_id");
                var item = _this.data.getItem(id);
                switch (item.type) {
                    case types_1.ItemType.selectButton:
                    case types_1.ItemType.menuItem:
                        if (id === _this._currentRoot) {
                            _this._close();
                            return;
                        }
                        if (!_this._isActive) {
                            _this._isActive = true;
                        }
                        _this._setRoot(id);
                        _this._activeMenu = id;
                        if (_this.data.haveChilds(id)) {
                            var position = helper_1.getRealPosition(element);
                            _this.data.update(id, { $position: position }, false);
                            _this._activeItemChange(id);
                        }
                        else {
                            _this._onMenuItemClick(id, e);
                        }
                        break;
                    case types_1.ItemType.dhxButton:
                    case types_1.ItemType.imageButtonText:
                    case types_1.ItemType.iconButton:
                    case types_1.ItemType.imageButton:
                    case types_1.ItemType.button:
                    case types_1.ItemType.customHTMLButton:
                        if (item.twoState) {
                            _this.data.update(item.id, { active: !item.active });
                        }
                        _this.events.fire(types_1.ToolbarEvents.click, [id, e]);
                    case types_1.ItemType.separator:
                    case types_1.ItemType.input:
                    case types_1.ItemType.text:
                    case types_1.ItemType.spacer:
                        _this._close();
                    default:
                        return;
                }
            }
        };
    };
    MenuBase.prototype._initEvents = function () {
        var _this = this;
        var timeout = null;
        this.data.events.on(types_1.DataEvents.change, function () {
            _this.paint();
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                _this._normalizeData();
                _this._resetHotkeys();
                timeout = null;
                _this.paint();
            }, 100);
        });
        this.events.on(types_1.ToolbarEvents.click, function (id) {
            var item = _this.data.getItem(id);
            var parent = _this.data.getItem(item.parent);
            if (parent && parent.type === types_1.ItemType.selectButton) {
                _this.data.update(item.parent, { value: item.value, icon: item.icon });
            }
            if (item.group) {
                var group = _this._groups[item.group];
                if (group.active) {
                    _this.data.update(group.active, { active: false });
                }
                group.active = item.id;
                _this.data.update(item.id, { active: true });
            }
        });
    };
    MenuBase.prototype._drawPopups = function () {
        var _this = this;
        var id = this._activeMenu;
        if (!this._isContextMenu && !id) {
            return null;
        }
        var root = this._currentRoot;
        if (this._isContextMenu && !this._activePosition) {
            return null;
        }
        var parentIds = this._getParents(id, root);
        return parentIds.map(function (itemId) {
            if (!_this.data.haveChilds(itemId)) {
                return null;
            }
            var item = _this.data.getItem(itemId) || {}; // for root item
            var count = 0;
            var separators = 0;
            _this.data.eachChild(itemId, function (child) {
                if (child.$hidden) {
                    return;
                }
                if (child.type === "separator" || child.separator) {
                    separators++;
                }
                else {
                    count++;
                }
            }, false);
            var width = item.width || _this.config.popupWidth;
            var position = (_this._isContextMenu && _this._activePosition && itemId === root) ? _this._activePosition : item.$position;
            var mode = _this._getMode(item, root, position === _this._activePosition);
            var height = (position.bottom - position.top) * count + separators * 5; // separator 5px
            return dom_1.el("div", {
                class: "dhx_widget menu-popup",
                style: helper_1.calculatePosition(position, { mode: mode, width: width, height: height })
            }, _this._drawMenuItems(itemId));
        }).reverse();
    };
    MenuBase.prototype._onMenuItemClick = function (id, e) {
        var item = this.data.getItem(id);
        if (item.$disabled) {
            return;
        }
        this.events.fire(types_1.ToolbarEvents.click, [id, e]);
        this._close();
    };
    MenuBase.prototype._activeItemChange = function (id) {
        var _this = this;
        if (id && !this._documentHaveListener) {
            this._listenOuterClick();
        }
        if (id && this.data.haveChilds(id)) {
            this._activeMenu = id;
            clearTimeout(this._currentTimeout);
            this.paint();
        }
        else {
            this._activeMenu = id;
            clearTimeout(this._currentTimeout);
            this._currentTimeout = setTimeout(function () { return _this.paint(); }, 400);
        }
    };
    MenuBase.prototype._resetHotkeys = function () {
        var _this = this;
        hotkeys_1.keyManager.removeHotKey(null, this);
        this.data.map(function (item) {
            if (item.hotkey) {
                hotkeys_1.keyManager.addHotKey(item.hotkey, function () { return _this._onMenuItemClick(item.id, null); }, _this);
            }
        });
    };
    MenuBase.prototype._listenOuterClick = function () {
        document.addEventListener("click", this._documentClick);
        this._documentHaveListener = true;
    };
    MenuBase.prototype._getMode = function (item, root, _active) {
        if (_active === void 0) { _active = false; }
        return item.parent === root ? "bottom" : "right";
    };
    MenuBase.prototype._drawMenuItems = function (id) {
        var _this = this;
        return this.data.map(function (item) { return _this._factory(item, _this.events); }, id, false);
    };
    MenuBase.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        var groups = {};
        this.data.eachChild(root, function (item) {
            if (_this.data.haveChilds(item.id) && item.parent !== _this.data.getRoot()) {
                item.$openIcon = "right";
            }
            if (item.group) {
                helper_1.addInGroups(groups, item);
            }
        }, true);
        this._groups = groups;
    };
    MenuBase.prototype._setRoot = function (_id) {
        return; // need only for toolbar
    };
    MenuBase.prototype._getParents = function (id, root) {
        var parentIds = [];
        var afterRoot = false;
        var currentItem = this.data.getItem(id);
        var disabled = currentItem && currentItem.$disabled;
        this.data.eachParent(id, function (item) {
            if (item.id === root) {
                parentIds.push(item.id);
                afterRoot = true;
            }
            else if (!afterRoot) {
                parentIds.push(item.id);
            }
        }, !disabled);
        if (this._isContextMenu && this._activePosition) {
            parentIds.push(root);
        }
        return parentIds;
    };
    MenuBase.prototype._setProp = function (id, key, value) {
        var _this = this;
        var _a;
        if (Array.isArray(id)) {
            id.forEach(function (itemId) {
                var _a;
                return _this.data.update(itemId, (_a = {}, _a[key] = value, _a));
            });
        }
        else {
            this.data.update(id, (_a = {}, _a[key] = value, _a));
        }
    };
    return MenuBase;
}(view_1.View));
exports.MenuBase = MenuBase;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(9);
var loader_1 = __webpack_require__(31);
var sort_1 = __webpack_require__(35);
var dataproxy_1 = __webpack_require__(11);
var helpers_1 = __webpack_require__(7);
var types_1 = __webpack_require__(6);
var core_1 = __webpack_require__(3);
var DataCollection = /** @class */ (function () {
    function DataCollection(config, events) {
        this._order = [];
        this._pull = {};
        this._changes = {
            order: []
        };
        this._initOrder = null;
        this.config = config || {};
        this._sort = new sort_1.Sort();
        this._loader = new loader_1.Loader(this, this._changes);
        this.events = events || new events_1.EventSystem(this);
    }
    DataCollection.prototype.add = function (obj, index) {
        if (!this.events.fire(types_1.DataEvents.beforeAdd, [obj])) {
            return;
        }
        this._addCore(obj, index);
        this._onChange("add", obj.id, obj);
        this.events.fire(types_1.DataEvents.afterAdd, [obj]);
    };
    DataCollection.prototype.remove = function (id) {
        var obj = this._pull[id];
        if (obj) {
            if (!this.events.fire(types_1.DataEvents.beforeRemove, [obj])) {
                return;
            }
            this._removeCore(obj.id);
            this._onChange("remove", id, obj);
        }
        this.events.fire(types_1.DataEvents.afterRemove, [obj]);
    };
    DataCollection.prototype.removeAll = function () {
        this._removeAll();
        this.events.fire(types_1.DataEvents.removeAll);
        this.events.fire(types_1.DataEvents.change);
    };
    DataCollection.prototype.exists = function (id) {
        return !!this._pull[id];
    };
    DataCollection.prototype.getNearId = function (id) {
        var item = this._pull[id];
        if (!item) {
            return this._order[0].id || "";
        }
    };
    DataCollection.prototype.getItem = function (id) {
        return this._pull[id];
    };
    DataCollection.prototype.update = function (id, obj, silent) {
        var item = this.getItem(id);
        if (item) {
            if (helpers_1.isEqualObj(obj, item)) {
                return;
            }
            if (obj.id && id !== obj.id) {
                helpers_1.dhxWarning("this method doesn't allow change id");
                if (helpers_1.isDebug()) {
                    // tslint:disable-next-line:no-debugger
                    debugger;
                }
            }
            else {
                core_1.extend(this._pull[id], obj, false);
                if (this.config.update) {
                    this.config.update(this._pull[id]);
                }
                if (!silent) {
                    this._onChange("update", id, this._pull[id]);
                }
            }
        }
        else {
            helpers_1.dhxWarning("item not found");
        }
    };
    DataCollection.prototype.getIndex = function (id) {
        var res = core_1.findIndex(this._order, function (item) { return item.id === id; });
        if (this._pull[id] && res >= 0) {
            return res;
        }
        return -1;
    };
    DataCollection.prototype.getId = function (index) {
        if (!this._order[index]) {
            return;
        }
        return this._order[index].id;
    };
    DataCollection.prototype.getLength = function () {
        return this._order.length;
    };
    DataCollection.prototype.filter = function (rule, config) {
        var _this = this;
        config = core_1.extend({
            add: false,
            multiple: true
        }, config);
        if (!config.add) {
            this._order = this._initOrder || this._order;
            this._initOrder = null;
        }
        this._filters = this._filters || {};
        if (!config.multiple || !rule) {
            this._filters = {};
        }
        if (rule) {
            if (typeof rule === "function") {
                var f = "_";
                this._filters[f] = {
                    match: f,
                    compare: rule
                };
            }
            else {
                if (!rule.match) {
                    delete this._filters[rule.by];
                }
                else {
                    rule.compare = rule.compare || (function (val, match) { return val === match; });
                    this._filters[rule.by] = rule;
                }
            }
            var fOrder = this._order.filter(function (item) {
                return Object.keys(_this._filters).every(function (key) {
                    return item[key] ?
                        _this._filters[key].compare(item[key], _this._filters[key].match, item)
                        : _this._filters[key].compare(item);
                });
            });
            if (!this._initOrder) {
                this._initOrder = this._order;
                this._order = fOrder;
            }
        }
        this.events.fire(types_1.DataEvents.change);
    };
    DataCollection.prototype.find = function (conf) {
        for (var key in this._pull) {
            var res = helpers_1.findByConf(this._pull[key], conf);
            if (res) {
                return res;
            }
        }
        return null;
    };
    DataCollection.prototype.findAll = function (conf) {
        var res = [];
        for (var key in this._pull) {
            var item = helpers_1.findByConf(this._pull[key], conf);
            if (item) {
                res.push(item);
            }
        }
        return res;
    };
    DataCollection.prototype.sort = function (by) {
        this._sort.sort(this._order, by);
        if (this._initOrder && this._initOrder.length) {
            this._sort.sort(this._initOrder, by);
        }
        this.events.fire(types_1.DataEvents.change);
    };
    DataCollection.prototype.copy = function (id, index, target, targetId) {
        if (!this.exists(id)) {
            return null;
        }
        var newid = core_1.uid();
        if (target) {
            if (targetId) {
                target.add(__assign({}, this.getItem(id)), index, targetId);
                return;
            }
            if (target.exists(id)) {
                target.add(__assign({}, this.getItem(id), { id: newid }), index);
                return newid;
            }
            else {
                target.add(this.getItem(id), index);
                return id;
            }
        }
        this.add(__assign({}, this.getItem(id), { id: newid }), index);
        return newid;
    };
    DataCollection.prototype.move = function (id, index, target, targetId) {
        if (target && target !== this && this.exists(id)) {
            var item = this.getItem(id);
            if (target.exists(id)) {
                item.id = core_1.uid();
            }
            if (targetId) {
                item.parent = targetId;
            }
            target.add(item, index);
            // remove data from original collection
            this.remove(item.id);
            return item.id;
        }
        if (this.getIndex(id) === index) {
            return null;
        }
        // move other elements
        var spliced = this._order.splice(this.getIndex(id), 1)[0];
        if (index === -1) {
            index = this._order.length;
        }
        this._order.splice(index, 0, spliced);
        this.events.fire(types_1.DataEvents.change); // if target not this, it trigger add and remove
        return id;
    };
    DataCollection.prototype.load = function (url, driver) {
        if (typeof url === "string") {
            url = new dataproxy_1.DataProxy(url);
        }
        return this._loader.load(url, driver);
    };
    DataCollection.prototype.parse = function (data, driver) {
        this._removeAll();
        return this._loader.parse(data, driver);
    };
    DataCollection.prototype.$parse = function (data) {
        var apx = this.config.approximate;
        if (apx) {
            data = this._approximate(data, apx.value, apx.maxNum);
        }
        this._parse_data(data);
        this.events.fire(types_1.DataEvents.change);
        this.events.fire(types_1.DataEvents.load);
    };
    DataCollection.prototype.save = function (url) {
        this._loader.save(url);
    };
    // todo: loop through the array and check saved statuses
    DataCollection.prototype.isSaved = function () {
        return !this._changes.order.length; // todo: bad solution, errors and holded elments are missed...
    };
    DataCollection.prototype.map = function (cb) {
        var result = [];
        for (var i = 0; i < this._order.length; i++) {
            result.push(cb.call(this, this._order[i], i));
        }
        return result;
    };
    DataCollection.prototype.reduce = function (cb, acc) {
        for (var i = 0; i < this._order.length; i++) {
            acc = cb.call(this, acc, this._order[i], i);
        }
        return acc;
    };
    DataCollection.prototype.serialize = function () {
        return this.map(function (item) {
            var newItem = __assign({}, item);
            Object.keys(newItem).forEach(function (key) {
                if (key[0] === "$") {
                    delete newItem[key];
                }
            });
            return newItem;
        });
    };
    DataCollection.prototype.getInitialData = function () {
        return this._initOrder;
    };
    DataCollection.prototype._removeAll = function () {
        this._pull = {};
        this._order = [];
        this._changes.order = [];
        this._initOrder = null;
    };
    DataCollection.prototype._addCore = function (obj, index) {
        if (this.config.init) {
            obj = this.config.init(obj);
        }
        obj.id = obj.id ? obj.id.toString() : core_1.uid();
        if (this._pull[obj.id]) {
            helpers_1.dhxError("Item already exist");
        }
        // todo: not ideal solution
        if (this._initOrder && this._initOrder.length) {
            this._addToOrder(this._initOrder, obj, index);
        }
        this._addToOrder(this._order, obj, index);
    };
    DataCollection.prototype._removeCore = function (id) {
        if (this.getIndex(id) >= 0) {
            this._order = this._order.filter(function (el) { return el.id !== id; });
            delete this._pull[id];
        }
        if (this._initOrder && this._initOrder.length) {
            this._initOrder = this._initOrder.filter(function (el) { return el.id !== id; });
        }
    };
    DataCollection.prototype._parse_data = function (data) {
        var index = this._order.length;
        if (this.config.prep) {
            data = this.config.prep(data);
        }
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var obj = data_1[_i];
            if (this.config.init) {
                obj = this.config.init(obj);
            }
            obj.id = obj.id || core_1.uid();
            this._pull[obj.id] = obj;
            this._order[index++] = obj;
        }
    };
    DataCollection.prototype._approximate = function (data, values, maxNum) {
        var len = data.length;
        var vlen = values.length;
        var rlen = Math.floor(len / maxNum);
        var newData = Array(Math.ceil(len / rlen));
        var index = 0;
        for (var i = 0; i < len; i += rlen) {
            var newItem = core_1.copy(data[i]);
            var end = Math.min(len, i + rlen);
            for (var j = 0; j < vlen; j++) {
                var sum = 0;
                for (var z = i; z < end; z++) {
                    sum += data[z][values[j]];
                }
                newItem[values[j]] = sum / (end - i);
            }
            newData[index++] = newItem;
        }
        return newData;
    };
    DataCollection.prototype._onChange = function (status, id, obj) {
        for (var _i = 0, _a = this._changes.order; _i < _a.length; _i++) {
            var item = _a[_i];
            // update pending item if previous state is "saving" or if item not saved yet
            if (item.id === id && !item.saving) {
                // update item
                if (item.error) {
                    item.error = false;
                }
                item = __assign({}, item, { obj: obj, status: status });
                this.events.fire(types_1.DataEvents.change, [id, status, obj]);
                return;
            }
        }
        this._changes.order.push({ id: id, status: status, obj: __assign({}, obj), saving: false });
        this.events.fire(types_1.DataEvents.change, [id, status, obj]);
    };
    DataCollection.prototype._addToOrder = function (array, obj, index) {
        if (index >= 0 && array[index]) {
            this._pull[obj.id] = obj;
            array.splice(index, 0, obj);
        }
        else {
            this._pull[obj.id] = obj;
            array.push(obj);
        }
    };
    return DataCollection;
}());
exports.DataCollection = DataCollection;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var CsvDriver = /** @class */ (function () {
    function CsvDriver(config) {
        if (config === void 0) { config = {}; }
        var initConfig = {
            skipHeader: 0,
            nameByHeader: false,
            row: "\n",
            column: ",",
        };
        this.config = __assign({}, initConfig, config);
        if (this.config.nameByHeader) {
            this.config.skipHeader = 1;
        }
    }
    CsvDriver.prototype.getFields = function (row, headers) {
        var parts = row.trim().split(this.config.column);
        var obj = {};
        for (var i = 0; i < parts.length; i++) {
            obj[headers ? headers[i] : i + 1] = parts[i];
        }
        return obj;
    };
    CsvDriver.prototype.getRows = function (data) {
        return data.trim().split(this.config.row);
    };
    CsvDriver.prototype.toJsonArray = function (data) {
        var _this = this;
        var rows = this.getRows(data);
        var names = this.config.names;
        if (this.config.skipHeader) {
            var top_1 = rows.splice(0, this.config.skipHeader);
            if (this.config.nameByHeader) {
                names = top_1[0].trim().split(this.config.column);
            }
        }
        return rows.map(function (row) { return _this.getFields(row, names); });
    };
    return CsvDriver;
}());
exports.CsvDriver = CsvDriver;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var JsonDriver = /** @class */ (function () {
    function JsonDriver() {
    }
    JsonDriver.prototype.toJsonArray = function (data) {
        return this.getRows(data);
    };
    JsonDriver.prototype.getFields = function (row) {
        return row;
    };
    JsonDriver.prototype.getRows = function (data) {
        return typeof data === "string" ? JSON.parse(data) : data;
    };
    return JsonDriver;
}());
exports.JsonDriver = JsonDriver;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var datacollection_1 = __webpack_require__(19);
var dataproxy_1 = __webpack_require__(11);
var helpers_1 = __webpack_require__(7);
var types_1 = __webpack_require__(6);
function addToOrder(store, obj, parent, index) {
    if (index !== undefined && index !== -1 && store[parent] && store[parent][index]) {
        store[parent].splice(index, 0, obj);
    }
    else {
        if (!store[parent]) {
            store[parent] = [];
        }
        store[parent].push(obj);
    }
}
var TreeCollection = /** @class */ (function (_super) {
    __extends(TreeCollection, _super);
    function TreeCollection(config, events) {
        var _a;
        var _this = _super.call(this, config, events) || this;
        var root = _this._root = "_ROOT_" + core_1.uid();
        _this._childs = (_a = {}, _a[root] = [], _a);
        _this._initChilds = null;
        return _this;
    }
    TreeCollection.prototype.add = function (obj, index, parent) {
        if (index === void 0) { index = -1; }
        if (parent === void 0) { parent = this._root; }
        if (typeof obj !== "object") {
            obj = {
                value: obj
            };
        }
        obj.parent = obj.parent ? obj.parent.toString() : parent;
        _super.prototype.add.call(this, obj, index);
    };
    TreeCollection.prototype.getRoot = function () {
        return this._root;
    };
    TreeCollection.prototype.getParent = function (id, asObj) {
        if (asObj === void 0) { asObj = false; }
        if (!this._pull[id]) {
            return null;
        }
        var parent = this._pull[id].parent;
        return asObj ? this._pull[parent] : parent;
    };
    TreeCollection.prototype.getChilds = function (id) {
        if (this._childs && this._childs[id]) {
            return this._childs[id];
        }
        return [];
    };
    TreeCollection.prototype.getLength = function (id) {
        if (id === void 0) { id = this._root; }
        if (!this._childs[id]) {
            return null;
        }
        return this._childs[id].length;
    };
    TreeCollection.prototype.removeAll = function (id) {
        var _a;
        if (id) {
            var childs = this._childs[id].slice();
            for (var _i = 0, childs_1 = childs; _i < childs_1.length; _i++) {
                var child = childs_1[_i];
                this.remove(child.id);
            }
        }
        else {
            _super.prototype.removeAll.call(this);
            var root = this._root;
            this._initChilds = null;
            this._childs = (_a = {}, _a[root] = [], _a);
        }
    };
    TreeCollection.prototype.getIndex = function (id) {
        var parent = this.getParent(id);
        if (!parent || !this._childs[parent]) {
            return -1;
        }
        return core_1.findIndex(this._childs[parent], function (item) { return item.id === id; });
    };
    TreeCollection.prototype.sort = function (conf) {
        var childs = this._childs;
        for (var key in childs) {
            this._sort.sort(childs[key], conf);
        }
        this.events.fire(types_1.DataEvents.change);
    };
    TreeCollection.prototype.map = function (cb, parent, direct) {
        if (parent === void 0) { parent = this._root; }
        if (direct === void 0) { direct = true; }
        var result = [];
        if (!this.haveChilds(parent)) {
            return result;
        }
        for (var i = 0; i < this._childs[parent].length; i++) {
            result.push(cb.call(this, this._childs[parent][i], i));
            if (direct) {
                var childResult = this.map(cb, this._childs[parent][i].id, direct);
                result = result.concat(childResult);
            }
        }
        return result;
    };
    TreeCollection.prototype.filter = function (conf) {
        if (!conf) {
            this.restoreOrder();
            return;
        }
        if (!this._initChilds) {
            this._initChilds = this._childs;
        }
        conf.type = conf.type || types_1.TreeFilterType.all;
        var newChilds = {};
        this._recursiveFilter(conf, this._root, 0, newChilds);
        this._childs = newChilds;
        this.events.fire(types_1.DataEvents.change);
    };
    TreeCollection.prototype.restoreOrder = function () {
        if (this._initChilds) {
            this._childs = this._initChilds;
            this._initChilds = null;
        }
        this.events.fire(types_1.DataEvents.change);
    };
    TreeCollection.prototype.copy = function (id, index, target, targetId) {
        if (target === void 0) { target = this; }
        if (targetId === void 0) { targetId = this._root; }
        if (!this.exists(id)) {
            return null;
        }
        var childs = __assign({}, this._childs);
        var currentChilds = childs[id];
        if (target === this && !this.canCopy(id, targetId)) {
            return null;
        }
        if (!(target instanceof TreeCollection)) { // copy to datacollection
            target.add(this._pull[id]);
            return;
        }
        if (this.exists(id)) {
            var item = __assign({}, this.getItem(id));
            if (target.exists(id)) {
                item.id = core_1.uid();
            }
            else {
                item.id = id;
            }
            item.parent = targetId;
            target.add(item, index);
            id = item.id;
        }
        if (currentChilds) {
            for (var _i = 0, currentChilds_1 = currentChilds; _i < currentChilds_1.length; _i++) {
                var child = currentChilds_1[_i];
                var childId = child.id;
                var childIndex = this.getIndex(childId);
                this.copy(childId, childIndex, target, id);
            }
        }
        return id;
    };
    TreeCollection.prototype.move = function (id, index, target, targetId) {
        if (target === void 0) { target = this; }
        if (targetId === void 0) { targetId = this._root; }
        if (!this.exists(id)) {
            return null;
        }
        if (target !== this) {
            if (!(target instanceof TreeCollection)) { // move to datacollection
                target.add(this._pull[id]);
                this.remove(id);
                return;
            }
            var returnId = this.copy(id, index, target, targetId);
            this.remove(id);
            return returnId;
        }
        // move inside
        if (!this.canCopy(id, targetId)) {
            return null;
        }
        var parent = this.getParent(id);
        var parentIndex = this.getIndex(id);
        // get item from parent array and move to target array
        var spliced = this._childs[parent].splice(parentIndex, 1)[0];
        spliced.parent = targetId; // need for next moving, ... not best solution, may be full method for get item
        if (!this._childs[parent].length) {
            delete this._childs[parent];
        }
        if (!this.haveChilds(targetId)) {
            this._childs[targetId] = [];
        }
        if (index === -1) {
            index = this._childs[targetId].push(spliced);
        }
        else {
            this._childs[targetId].splice(index, 0, spliced);
        }
        this.events.fire(types_1.DataEvents.change);
        return id;
    };
    TreeCollection.prototype.eachChild = function (id, cb, direct) {
        if (direct === void 0) { direct = true; }
        if (!this.haveChilds(id)) {
            return;
        }
        for (var i = 0; i < this._childs[id].length; i++) {
            cb.call(this, this._childs[id][i], i);
            if (direct && this.getItem(this._childs[id][i].id).$opened !== false) {
                this.eachChild(this._childs[id][i].id, cb, direct);
            }
        }
    };
    TreeCollection.prototype.getNearId = function (id) {
        return id; // for selection
    };
    TreeCollection.prototype.loadChilds = function (id, driver) {
        var _this = this;
        if (driver === void 0) { driver = "json"; }
        var url = this.config.autoload + "?id=" + id;
        var proxy = new dataproxy_1.DataProxy(url);
        proxy.load().then(function (data) {
            driver = helpers_1.toDataDriver(driver);
            data = driver.toJsonArray(data);
            _this._parse_data(data, id);
            _this.events.fire(types_1.DataEvents.change);
        });
    };
    TreeCollection.prototype.refreshChilds = function (id, driver) {
        if (driver === void 0) { driver = "json"; }
        this.removeAll(id);
        this.loadChilds(id, driver);
    };
    TreeCollection.prototype.eachParent = function (id, cb, self) {
        if (self === void 0) { self = false; }
        var item = this.getItem(id);
        if (!item) {
            return;
        }
        if (self) {
            cb.call(this, item);
        }
        if (item.parent === this._root) {
            return;
        }
        var parent = this.getItem(item.parent);
        cb.call(this, parent);
        this.eachParent(item.parent, cb);
    };
    TreeCollection.prototype.haveChilds = function (id) {
        return id in this._childs;
    };
    TreeCollection.prototype.canCopy = function (id, target) {
        if (id === target) {
            return false;
        }
        var canCopy = true;
        this.eachParent(target, function (item) { return item.id === id ? canCopy = false : null; }); // locate return string
        return canCopy;
    };
    TreeCollection.prototype.serialize = function (fn) {
        return this._serialize(this._root, fn);
    };
    TreeCollection.prototype.getId = function (index, parent) {
        if (parent === void 0) { parent = this._root; }
        if (!this._childs[parent] || !this._childs[parent][index]) {
            return;
        }
        return this._childs[parent][index].id;
    };
    TreeCollection.prototype._removeAll = function (id) {
        var _a;
        if (id) {
            var childs = this._childs[id].slice();
            for (var _i = 0, childs_2 = childs; _i < childs_2.length; _i++) {
                var child = childs_2[_i];
                this.remove(child.id);
            }
        }
        else {
            _super.prototype._removeAll.call(this);
            var root = this._root;
            this._initChilds = null;
            this._childs = (_a = {}, _a[root] = [], _a);
        }
    };
    TreeCollection.prototype._removeCore = function (id) {
        if (this._pull[id]) {
            var parent_1 = this.getParent(id);
            this._childs[parent_1] = this._childs[parent_1].filter(function (item) { return item.id !== id; });
            if (parent_1 !== this._root && !this._childs[parent_1].length) {
                delete this._childs[parent_1];
            }
            if (this._initChilds && this._initChilds[parent_1]) {
                this._initChilds[parent_1] = this._initChilds[parent_1].filter(function (item) { return item.id !== id; });
                if (parent_1 !== this._root && !this._initChilds[parent_1].length) {
                    delete this._initChilds[parent_1];
                }
            }
            this._fastDeleteChilds(this._childs, id);
            if (this._initChilds) {
                this._fastDeleteChilds(this._initChilds, id);
            }
        }
    };
    TreeCollection.prototype._addToOrder = function (_order, obj, index) {
        var childs = this._childs;
        var initChilds = this._initChilds;
        var parent = obj.parent;
        this._pull[obj.id] = obj;
        addToOrder(childs, obj, parent, index);
        if (initChilds) {
            addToOrder(initChilds, obj, parent, index);
        }
    };
    TreeCollection.prototype._parse_data = function (data, parent) {
        if (parent === void 0) { parent = this._root; }
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var obj = data_1[_i];
            if (this.config.init) {
                obj = this.config.init(obj);
            }
            if (typeof obj !== "object") {
                obj = {
                    value: obj
                };
            }
            obj.id = obj.id ? obj.id.toString() : core_1.uid();
            obj.parent = obj.parent ? obj.parent.toString() : parent;
            this._pull[obj.id] = obj;
            if (!this._childs[obj.parent]) {
                this._childs[obj.parent] = [];
            }
            this._childs[obj.parent].push(obj);
            if (obj.childs && obj.childs instanceof Object) {
                this._parse_data(obj.childs, obj.id);
            }
        }
    };
    TreeCollection.prototype._fastDeleteChilds = function (target, id) {
        if (this._pull[id]) {
            delete this._pull[id];
        }
        if (!target[id]) {
            return;
        }
        for (var i = 0; i < target[id].length; i++) {
            this._fastDeleteChilds(target, target[id][i].id);
        }
        delete target[id];
    };
    TreeCollection.prototype._recursiveFilter = function (conf, current, level, newChilds) {
        var _this = this;
        var childs = this._childs[current];
        if (!childs) {
            return;
        }
        var condition = function (item) {
            switch (conf.type) {
                case types_1.TreeFilterType.all: {
                    return true;
                }
                case types_1.TreeFilterType.specific: {
                    return level === conf.specific;
                }
                case types_1.TreeFilterType.leafs: {
                    return !_this.haveChilds(item.id);
                }
            }
        };
        if (conf.by && conf.match) {
            var customRule = function (item) { return !condition(item) || item[conf.by].toString().toLowerCase().indexOf(conf.match.toString().toLowerCase()) !== -1; };
            newChilds[current] = childs.filter(customRule);
        }
        else if (conf.rule && typeof conf.rule === "function") {
            var customRule = function (item) { return !condition(item) || conf.rule(item); };
            var filtered = childs.filter(customRule);
            if (filtered.length) {
                newChilds[current] = filtered;
            }
        }
        for (var _i = 0, childs_3 = childs; _i < childs_3.length; _i++) {
            var child = childs_3[_i];
            this._recursiveFilter(conf, child.id, level + 1, newChilds);
        }
    };
    TreeCollection.prototype._serialize = function (parent, fn) {
        var _this = this;
        if (parent === void 0) { parent = this._root; }
        return this.map(function (item) {
            var itemCopy = {};
            for (var key in item) {
                if (key === "parent" || key === "childs") {
                    continue;
                }
                itemCopy[key] = item[key];
            }
            if (fn) {
                itemCopy = fn(itemCopy);
            }
            if (_this.haveChilds(item.id)) {
                itemCopy.childs = _this._serialize(item.id, fn);
            }
            return itemCopy;
        }, parent, false);
    };
    return TreeCollection;
}(datacollection_1.DataCollection));
exports.TreeCollection = TreeCollection;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var tooltip_1 = __webpack_require__(25);
var Position;
(function (Position) {
    Position["right"] = "right";
    Position["bottom"] = "bottom";
    Position["center"] = "center";
})(Position = exports.Position || (exports.Position = {}));
var nodeTimeout = new WeakMap();
var messageStack = [];
var messageContainer = document.createElement("div");
messageContainer.className = "dhx-message-container";
function onExpire(node, fromClick) {
    if (fromClick) {
        clearTimeout(nodeTimeout.get(node));
    }
    var index = messageStack.indexOf(node);
    if (index < 0) { // node in body
        document.body.removeChild(node);
        return;
    }
    messageContainer.removeChild(node);
    messageStack.splice(index, 1);
    if (messageStack.length === 0) {
        document.body.removeChild(messageContainer);
    }
}
function message(props) {
    if (typeof props === "string") {
        props = { text: props };
    }
    var messageBox = document.createElement("div");
    messageBox.className = "dhx-message " + (props.css || "");
    messageBox.innerHTML = "<span class=\"message-text\">" + props.text + "</span> <div class=\"dxi " + props.icon + "\"></div>";
    if (props.at) {
        messageBox.style.position = "absolute";
        var _a = props.at, node = _a.node, position = _a.position;
        var elem = html_1.toNode(node);
        var rects = elem.getBoundingClientRect();
        document.body.appendChild(messageBox); // for calc bounings
        var _b = messageBox.getBoundingClientRect(), width = _b.width, height = _b.height;
        var _c = tooltip_1.findPosition(rects, position, width, height), left = _c.left, top_1 = _c.top, pos = _c.pos;
        messageBox.className += " " + pos;
        messageBox.style.left = left + "px";
        messageBox.style.top = top_1 + "px";
    }
    else {
        if (messageStack.length === 0) {
            document.body.appendChild(messageContainer);
        }
        messageStack.push(messageBox);
        messageContainer.appendChild(messageBox);
    }
    if (props.expire) {
        var timeout = setTimeout(function () { return onExpire(messageBox); }, props.expire);
        nodeTimeout.set(messageBox, timeout);
    }
    messageBox.onclick = function () { return onExpire(messageBox, true); };
}
exports.message = message;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var message_1 = __webpack_require__(24);
var RealPosition;
(function (RealPosition) {
    RealPosition["left"] = "left";
    RealPosition["right"] = "right";
    RealPosition["top"] = "top";
    RealPosition["bottom"] = "bottom";
    RealPosition["center"] = "center";
})(RealPosition = exports.RealPosition || (exports.RealPosition = {}));
function findPosition(targetRect, position, width, height) {
    var margin = 8; // margin top/bot, left/right
    var pos;
    var left;
    var top;
    switch (position) {
        case message_1.Position.center:
            left = targetRect.left + window.pageXOffset + (targetRect.width - width) / 2;
            if (left + margin < window.pageXOffset) {
                left = targetRect.left + window.pageXOffset;
            }
            top = targetRect.top + window.pageYOffset + (targetRect.height - height) / 2;
            pos = RealPosition.center;
            return { left: left, top: top, pos: pos };
        case message_1.Position.right:
            pos = RealPosition.right;
            left = targetRect.right + window.pageXOffset;
            if (left + width + margin > window.innerWidth + window.pageXOffset) { // set left
                left = window.pageXOffset + targetRect.left - width;
                pos = RealPosition.left;
            }
            top = window.pageYOffset + targetRect.top + (targetRect.height - height) / 2;
            return { left: left, top: top, pos: pos };
        case message_1.Position.bottom:
            left = window.pageXOffset + targetRect.left + (targetRect.width - width) / 2;
            if (left < window.pageXOffset) {
                left = window.pageXOffset + targetRect.left;
            }
            pos = RealPosition.bottom;
            top = window.pageYOffset + targetRect.bottom;
            if (top + height + margin > window.innerHeight + window.pageYOffset) { // set top
                top = window.pageYOffset + targetRect.top - height;
                pos = RealPosition.top;
            }
            return { left: left, top: top, pos: pos };
    }
}
exports.findPosition = findPosition;
// tooltip init
var tooltipBox = document.createElement("div");
var tooltipText = document.createElement("span");
tooltipText.className = "tooltip-text";
tooltipBox.appendChild(tooltipText);
tooltipBox.style.position = "absolute";
var timeoutId = null;
var lastNode = null;
var isActive = false;
var hideTimeout = null;
function showTooltip(node, text, position, css, force) {
    if (force === void 0) { force = false; }
    var rects = node.getBoundingClientRect();
    tooltipText.textContent = text;
    document.body.appendChild(tooltipBox);
    tooltipBox.className = "dhx-tooltip" + (force ? " forced" : "");
    var _a = tooltipBox.getBoundingClientRect(), width = _a.width, height = _a.height;
    var _b = findPosition(rects, position, width, height), left = _b.left, top = _b.top, pos = _b.pos;
    switch (pos) {
        case RealPosition.bottom:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.top:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.left:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.right:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.center:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
    }
    tooltipBox.className += " " + pos + " " + (css || "");
    isActive = true;
    if (!force) {
        setTimeout(function () {
            tooltipBox.className += " animate-tooltip";
        });
    }
}
function hideTooltip() {
    if (lastNode) {
        hideTimeout = setTimeout(function () {
            document.body.removeChild(tooltipBox);
            isActive = false;
            hideTimeout = null;
        }, 200);
    }
}
function addListners(node, text, position, css, force) {
    if (force === void 0) { force = false; }
    var mousemove = function () {
        if (isActive) {
            return;
        }
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(function () {
            showTooltip(node, text, position, css);
        }, 750);
    };
    var mouseout = function () {
        if (isActive) {
            hideTooltip();
        }
        clearTimeout(timeoutId);
        if (!force) {
            document.removeEventListener("mousemove", mousemove);
        }
        document.removeEventListener("mouseout", mouseout);
        document.removeEventListener("click", mouseout);
        lastNode = null;
    };
    if (force) {
        showTooltip(node, text, position, css, force);
    }
    else {
        document.addEventListener("mousemove", mousemove);
    }
    document.addEventListener("mouseout", mouseout);
    document.addEventListener("click", mouseout);
}
// default
function tooltip(text, at) {
    var node = html_1.toNode(at.node);
    if (node === lastNode) {
        return;
    }
    lastNode = node;
    if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
        addListners(node, text, at.position, at.css, true);
    }
    else {
        addListners(node, text, at.position || message_1.Position.bottom, at.css);
    }
}
exports.tooltip = tooltip;
function enableTooltip() {
    document.addEventListener("mousemove", _mousemove);
}
exports.enableTooltip = enableTooltip;
function disableTooltip() {
    document.removeEventListener("mousemove", _mousemove);
}
exports.disableTooltip = disableTooltip;
function _mousemove(e) {
    var node = html_1.locateNode(e, "dhx_tooltip_text");
    if (!node) {
        return;
    }
    tooltip(node.getAttribute("dhx_tooltip_text"), {
        position: node.getAttribute("dhx_tooltip_position") || message_1.Position.bottom,
        node: node
    });
}


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var html_1 = __webpack_require__(1);
var ts_message_1 = __webpack_require__(16);
var types_1 = __webpack_require__(4);
var helper_1 = __webpack_require__(13);
var itemfactory_1 = __webpack_require__(17);
var MenuBase_1 = __webpack_require__(18);
var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(element, config) {
        var _this = _super.call(this, element, core_1.extend({
            navigationType: "click"
        }, config)) || this;
        _this._currentRoot = null;
        _this._factory = itemfactory_1.createFactory(types_1.ItemType.button);
        var render = function () { return _this._draw(); };
        _this.mount(element, dom_1.create({ render: render }));
        return _this;
    }
    Toolbar.prototype.getValues = function () {
        var state = {};
        this.data.eachChild(this.data.getRoot(), function (item) {
            if (item.twoState) {
                state[item.id] = item.active;
            }
            else if (item.type === types_1.ItemType.input) {
                state[item.id] = item.value;
            }
        }, false);
        for (var key in this._groups) {
            if (this._groups[key].active) {
                state[key] = this._groups[key].active;
            }
        }
        return state;
    };
    Toolbar.prototype.setValues = function (state) {
        for (var key in state) {
            if (this._groups[key]) {
                if (this._groups[key].active) {
                    this.data.update(this._groups[key].active, { active: false });
                    this._groups[key].active = state[key];
                    this.data.update(state[key], { active: true });
                }
            }
            else {
                var item = this.data.getItem(key);
                if (item.type === types_1.ItemType.input) {
                    this.data.update(key, { value: state[key] });
                }
                else {
                    this.data.update(key, { active: state[key] });
                }
            }
        }
    };
    Toolbar.prototype._initHandlers = function () {
        var _this = this;
        _super.prototype._initHandlers.call(this);
        this._onInput = function (e) {
            var id = html_1.locate(e);
            _this.data.update(id, { value: e.target.value });
        };
        this._showTooltip = function (e) {
            var elem = html_1.locateNode(e);
            if (!elem) {
                return;
            }
            var id = elem.getAttribute("dhx_id");
            var item = _this.data.getItem(id);
            if (item.tooltip) {
                ts_message_1.tooltip(item.tooltip, {
                    node: elem,
                    position: ts_message_1.Position.bottom
                });
            }
        };
    };
    Toolbar.prototype._draw = function () {
        var _this = this;
        return dom_1.el(".toolbar.dhx_widget" + (this.config.css ? "." + this.config.css : ""), {
            dhx_widget_id: this._uid,
            onclick: this._handlers.onclick,
            oninput: this._onInput,
            onmouseover: this._showTooltip
        }, this.data.map(function (item) { return _this._factory(item, _this.events); }, this.data.getRoot(), false));
    };
    Toolbar.prototype._getMode = function (item, root) {
        return item.id === root ? "bottom" : "right";
    };
    Toolbar.prototype._close = function () {
        this._activeMenu = null;
        this._activePosition = null;
        this._currentRoot = null;
        this.paint();
    };
    Toolbar.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        var groups = {};
        this.data.eachChild(root, function (item) {
            if (item.type === types_1.ItemType.menuItem || item.type === types_1.ItemType.selectButton) {
                if (_this.data.haveChilds(item.id)) {
                    _this.data.eachChild(item.id, function (child) { return child.type = child.type || types_1.ItemType.menuItem; }, false);
                    if (item.parent !== root) {
                        item.$openIcon = "right";
                    }
                    else {
                        item.$openIcon = "bot";
                    }
                }
            }
            if (item.group) {
                helper_1.addInGroups(groups, item);
            }
        }, true);
        this._groups = groups;
    };
    Toolbar.prototype._setRoot = function (id) {
        if (this.data.getParent(id) === this.data.getRoot()) { // if we clicked on item which not belong root, we cant set it as root item
            this._currentRoot = id;
        }
    };
    return Toolbar;
}(MenuBase_1.MenuBase));
exports.Toolbar = Toolbar;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(28);
var ts_data_1 = __webpack_require__(8);
exports.DataCollection = ts_data_1.DataCollection;
var ts_message_1 = __webpack_require__(16);
exports.message = ts_message_1.message;
__export(__webpack_require__(42));
__export(__webpack_require__(15));
var en_1 = __webpack_require__(14);
exports.i18n = {};
exports.i18n.setLocale = function (component, value) {
    var target = exports.i18n[component];
    for (var key in value) {
        target[key] = value[key];
    }
};
exports.i18n.vault = exports.i18n.vault || en_1.default;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __webpack_require__(7);
var Loader = /** @class */ (function () {
    function Loader(parent, changes) {
        this._parent = parent;
        this._changes = changes; // todo: [dirty] mutation
    }
    Loader.prototype.load = function (url, driver) {
        var _this = this;
        return this._parent.loadData = url.load().then(function (data) {
            _this._parent.removeAll();
            _this.parse(data, driver);
        });
    };
    Loader.prototype.parse = function (data, driver) {
        if (driver === void 0) { driver = "json"; }
        driver = helpers_1.toDataDriver(driver);
        data = driver.toJsonArray(data);
        this._parent.$parse(data);
    };
    Loader.prototype.save = function (url) {
        var _this = this;
        var _loop_1 = function (el) {
            if (el.saving || el.pending) {
                helpers_1.dhxWarning("item is saving");
            }
            else {
                var prevEl_1 = this_1._findPrevState(el.id);
                if (prevEl_1 && prevEl_1.saving) {
                    var pending = new Promise(function (res, rej) {
                        prevEl_1.promise.then(function () {
                            el.pending = false;
                            res(_this._setPromise(el, url));
                        }).catch(function (err) {
                            _this._removeFromOrder(prevEl_1);
                            _this._setPromise(el, url);
                            helpers_1.dhxWarning(err);
                            rej(err);
                        });
                    });
                    this_1._addToChain(pending);
                    el.pending = true;
                }
                else {
                    this_1._setPromise(el, url);
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = this._changes.order; _i < _a.length; _i++) {
            var el = _a[_i];
            _loop_1(el);
        }
        this._parent.saveData.then(function () {
            _this._saving = false;
        });
    };
    Loader.prototype._setPromise = function (el, url) {
        var _this = this;
        el.promise = url.save(el.obj, el.status);
        el.promise.then(function () {
            _this._removeFromOrder(el);
        }).catch(function (err) {
            el.saving = false;
            el.error = true;
            helpers_1.dhxError(err);
        });
        el.saving = true;
        this._saving = true;
        this._addToChain(el.promise);
        return el.promise;
    };
    Loader.prototype._addToChain = function (promise) {
        // tslint:disable-next-line:prefer-conditional-expression
        if (this._parent.saveData && this._saving) {
            this._parent.saveData = this._parent.saveData.then(function () { return promise; });
        }
        else {
            this._parent.saveData = promise;
        }
    };
    Loader.prototype._findPrevState = function (id) {
        for (var _i = 0, _a = this._changes.order; _i < _a.length; _i++) {
            var el = _a[_i];
            if (el.id === id) {
                return el;
            }
        }
        return null;
    };
    Loader.prototype._removeFromOrder = function (el) {
        this._changes.order = this._changes.order.filter(function (item) { return !helpers_1.isEqualObj(item, el); });
    };
    return Loader;
}());
exports.Loader = Loader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(33);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20), __webpack_require__(34)))

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __webpack_require__(7);
var Sort = /** @class */ (function () {
    function Sort() {
    }
    Sort.prototype.sort = function (array, by) {
        var _this = this;
        if (by.rule && typeof by.rule === "function") {
            this._sort(array, by);
        }
        else if (by.by) {
            by.rule = function (a, b) {
                var aa = _this._checkVal(by.as, a[by.by]);
                var bb = _this._checkVal(by.as, b[by.by]);
                return helpers_1.naturalCompare(aa.toString(), bb.toString()); // didnt work with numbers
            };
            this._sort(array, by);
        }
    };
    Sort.prototype._checkVal = function (method, val) {
        return method ? method.call(this, val) : val;
    };
    Sort.prototype._sort = function (arr, conf) {
        var _this = this;
        var dir = {
            asc: 1,
            desc: -1
        };
        return arr.sort(function (a, b) {
            return conf.rule.call(_this, a, b) * (dir[conf.dir] || dir.asc);
        });
    };
    return Sort;
}());
exports.Sort = Sort;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var types_1 = __webpack_require__(5);
var CollectionStore_1 = __webpack_require__(38);
var treecollection_1 = __webpack_require__(23);
var types_2 = __webpack_require__(6);
var DropPosition;
(function (DropPosition) {
    DropPosition[DropPosition["top"] = 0] = "top";
    DropPosition[DropPosition["bot"] = 1] = "bot";
    DropPosition[DropPosition["in"] = 2] = "in";
})(DropPosition || (DropPosition = {}));
function getParentElement(target) {
    if (target instanceof Event) {
        target = target.target;
    }
    while (target && target.getAttribute) {
        var id = target.getAttribute("dhx_id");
        if (id) {
            return target;
        }
        target = target.parentNode;
    }
}
function getPosition(ev) {
    var y = ev.y;
    var element = getParentElement(ev); // may be use domvm refs
    if (!element) {
        return null;
    }
    var treeLine = element.childNodes[0];
    var _a = treeLine.getBoundingClientRect(), top = _a.top, height = _a.height;
    return (y - top) / height;
}
function dragEventContent(item) {
    var ghost = document.createElement("div");
    ghost.textContent = item.value || item.text;
    ghost.className = "drag-ghost"; // need pointer-events: none
    return ghost;
}
var DragManager = /** @class */ (function () {
    function DragManager() {
        var _this = this;
        this._transferData = {};
        this._canMove = true;
        this._ghostTopPadding = -17;
        this._onMouseMove = function (e) {
            if (!_this._transferData.id) {
                return;
            }
            var pageX = e.pageX, pageY = e.pageY;
            if (!_this._transferData.ghost) {
                if (Math.abs(_this._transferData.x - pageX) < 3 && Math.abs(_this._transferData.y - pageY) < 3) {
                    return;
                }
                else {
                    var ghost = _this._onDragStart(_this._transferData.id, _this._transferData.targetId);
                    if (!ghost) {
                        _this._endDrop();
                        return;
                    }
                    else {
                        _this._transferData.ghost = ghost;
                        document.body.appendChild(_this._transferData.ghost);
                    }
                }
            }
            _this._moveGhost(pageX, pageY);
            _this._onDrag(e);
        };
        this._onMouseUp = function () {
            if (!_this._transferData.x) {
                return;
            }
            if (_this._transferData.ghost) {
                _this._removeGhost();
                _this._onDrop();
            }
            else {
                _this._endDrop();
            }
            document.removeEventListener("mousemove", _this._onMouseMove);
            document.removeEventListener("mouseup", _this._onMouseUp);
        };
    }
    DragManager.prototype.setItem = function (id, item, config) {
        // const collection = document.querySelector(`[dhx_collection_id=${id}]`); // use it for add onmousedown here
        CollectionStore_1.collectionStore.setItem(id, item, config);
    };
    DragManager.prototype.onMouseDown = function (e) {
        if (e.which !== 1) {
            return;
        }
        document.addEventListener("mousemove", this._onMouseMove);
        document.addEventListener("mouseup", this._onMouseUp);
        var id = html_1.locate(e, "dhx_id");
        var targetId = html_1.locate(e, "dhx_collection_id");
        if (id && targetId) {
            this._transferData.x = e.x;
            this._transferData.y = e.y;
            this._transferData.targetId = targetId;
            this._transferData.id = id;
        }
    };
    DragManager.prototype._moveGhost = function (x, y) {
        if (this._transferData.ghost) {
            var width = this._transferData.ghost.offsetWidth / 2;
            this._transferData.ghost.style.left = x - width + "px";
            this._transferData.ghost.style.top = y + this._ghostTopPadding + "px";
        }
    };
    DragManager.prototype._removeGhost = function () {
        document.body.removeChild(this._transferData.ghost);
    };
    DragManager.prototype._onDrop = function () {
        if (!this._canMove) {
            this._endDrop();
            return;
        }
        var target = CollectionStore_1.collectionStore.getItem(this._lastCollectionId);
        var config = CollectionStore_1.collectionStore.getItemConfig(this._lastCollectionId);
        if (!target || config.mode === types_2.DragMode.source) {
            this._endDrop();
            return;
        }
        var to = {
            id: this._lastId,
            target: target
        };
        var from = {
            id: this._transferData.id,
            target: this._transferData.target
        };
        if (from.target.events.fire(types_1.DragEvents.beforeDrop, [from, to])) {
            this._move(from, to);
            to.target.events.fire(types_1.DragEvents.dropComplete, [to.id, this._transferData.dropPosition]);
        }
        this._endDrop();
    };
    DragManager.prototype._onDragStart = function (id, targetId) {
        var target = CollectionStore_1.collectionStore.getItem(targetId);
        var config = CollectionStore_1.collectionStore.getItemConfig(targetId);
        if (config.dragMode === types_2.DragMode.target) {
            return null;
        }
        var item = target.data.getItem(id);
        target.events.fire(types_1.DragEvents.dragStart); // we need it for cancel selection
        var ghost = dragEventContent(item);
        var ans = target.events.fire(types_1.DragEvents.beforeDrag, [item, ghost]);
        if (!ans || !id) {
            return null;
        }
        this._toggleTextSelection(true);
        this._transferData.target = target;
        this._transferData.dragConfig = config;
        return ghost;
    };
    DragManager.prototype._onDrag = function (e) {
        var x = e.x, y = e.y;
        var element = document.elementFromPoint(x, y);
        var id = html_1.locate(element, "dhx_id");
        if (!id) {
            this._cancelCanDrop();
            return;
        }
        var collectionId = html_1.locate(element, "dhx_collection_id");
        if (this._transferData.dragConfig.behaviour === types_2.DragBehaviour.complex) {
            var pos = getPosition(e);
            if (pos <= 0.25) {
                this._transferData.dropPosition = DropPosition.top;
            }
            else if (pos >= 0.75) {
                this._transferData.dropPosition = DropPosition.bot;
            }
            else {
                this._transferData.dropPosition = DropPosition.in;
            }
        }
        else if (this._lastId === id && this._lastCollectionId === collectionId) {
            return;
        }
        var eventArgs;
        var from;
        var targetTo;
        if ((!id || !collectionId) && this._canMove) {
            this._cancelCanDrop();
            return;
        }
        else {
            from = {
                id: this._transferData.id,
                target: this._transferData.target
            };
            targetTo = CollectionStore_1.collectionStore.getItem(collectionId);
            eventArgs = [from, {
                    id: id,
                    target: targetTo
                }];
            from.target.events.fire(types_1.DragEvents.dragOut, eventArgs);
        }
        if (collectionId !== this._transferData.targetId || !(from.target.data instanceof treecollection_1.TreeCollection) ||
            (from.target.data instanceof treecollection_1.TreeCollection && from.target.data.canCopy(from.id, id))) {
            // handle cursor or something, can drop
            this._cancelCanDrop(); // clear last
            this._lastId = id;
            this._lastCollectionId = collectionId;
            eventArgs.push(this._transferData.dropPosition);
            var canMove = from.target.events.fire(types_1.DragEvents.dragIn, eventArgs);
            if (canMove) {
                this._canDrop();
            }
        }
        else {
            this._cancelCanDrop();
        }
    };
    DragManager.prototype._move = function (from, to) {
        var fromData = from.target.data;
        var toData = to.target.data;
        var index = 0;
        var targetId = to.id;
        var behaviour = this._transferData.dragConfig.behaviour;
        switch (behaviour) {
            case types_2.DragBehaviour.child:
                break;
            case types_2.DragBehaviour.sibling:
                targetId = toData.getParent(targetId);
                index = toData.getIndex(to.id) + 1;
                break;
            case types_2.DragBehaviour.complex:
                var dropPosition = this._transferData.dropPosition;
                if (dropPosition === DropPosition.top) {
                    targetId = toData.getParent(targetId);
                    index = toData.getIndex(to.id);
                }
                else if (dropPosition === DropPosition.bot) {
                    targetId = toData.getParent(targetId);
                    index = toData.getIndex(to.id) + 1;
                }
                break;
        }
        if (this._transferData.dragConfig.copy) {
            fromData.copy(from.id, index, toData, targetId);
        }
        else {
            fromData.move(from.id, index, toData, targetId);
        }
    };
    DragManager.prototype._endDrop = function () {
        this._toggleTextSelection(false);
        if (this._transferData.target) {
            this._transferData.target.events.fire(types_1.DragEvents.dragEnd);
        }
        this._cancelCanDrop();
        this._canMove = true;
        this._transferData = {};
        this._lastId = null;
        this._lastCollectionId = null;
    };
    DragManager.prototype._cancelCanDrop = function () {
        this._canMove = false;
        var collection = CollectionStore_1.collectionStore.getItem(this._lastCollectionId);
        if (collection && this._lastId) {
            collection.events.fire(types_1.DragEvents.cancelDrop, [this._lastId]);
        }
    };
    DragManager.prototype._canDrop = function () {
        this._canMove = true;
        var collection = CollectionStore_1.collectionStore.getItem(this._lastCollectionId);
        if (collection && this._lastId) {
            collection.events.fire(types_1.DragEvents.canDrop, [this._lastId, this._transferData.dropPosition]);
        }
    };
    DragManager.prototype._toggleTextSelection = function (add) {
        if (add) {
            document.body.classList.add("dhx-no-select");
        }
        else {
            document.body.classList.remove("dhx-no-select");
        }
    };
    return DragManager;
}());
exports.dragManager = new DragManager();


/***/ }),
/* 37 */
/***/ (function(module, exports) {

if (Element && !Element.prototype.matches) {
    var proto = Element.prototype;
    proto.matches = proto.matchesSelector ||
        proto.mozMatchesSelector || proto.msMatchesSelector ||
        proto.oMatchesSelector || proto.webkitMatchesSelector;
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CollectionStore = /** @class */ (function () {
    function CollectionStore() {
        this._store = {};
    }
    CollectionStore.prototype.setItem = function (id, target, config) {
        this._store[id] = {
            target: target,
            config: config
        };
    };
    CollectionStore.prototype.getItem = function (id) {
        if (!this._store[id]) {
            return null;
        }
        return this._store[id].target;
    };
    CollectionStore.prototype.getItemConfig = function (id) {
        if (!this._store[id]) {
            return null;
        }
        return this._store[id].config;
    };
    return CollectionStore;
}());
exports.collectionStore = new CollectionStore();


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(9);
var types_1 = __webpack_require__(5);
var types_2 = __webpack_require__(6);
var Selection = /** @class */ (function () {
    function Selection(_config, data, events) {
        var _this = this;
        this.events = events || (new events_1.EventSystem());
        this._data = data;
        this._data.events.on(types_2.DataEvents.removeAll, function () {
            _this._selected = null;
        });
        this._data.events.on(types_2.DataEvents.change, function () {
            if (_this._selected) {
                var near = _this._data.getNearId(_this._selected);
                if (near !== _this._selected) {
                    _this._selected = null;
                    if (near) {
                        _this.add(near);
                    }
                }
            }
        });
    }
    Selection.prototype.getId = function () {
        return this._selected;
    };
    Selection.prototype.getItem = function () {
        if (this._selected) {
            return this._data.getItem(this._selected);
        }
        return null;
    };
    Selection.prototype.remove = function (id) {
        id = id || this._selected;
        if (!id) {
            return true;
        }
        if (this.events.fire(types_1.SelectionEvents.beforeUnSelect, [id])) {
            this._data.update(id, { $selected: false });
            this._selected = null;
            this.events.fire(types_1.SelectionEvents.afterUnSelect, [id]);
            return true;
        }
        return false;
    };
    Selection.prototype.add = function (id) {
        if (this._selected === id) {
            return;
        }
        this.remove();
        if (this.events.fire(types_1.SelectionEvents.beforeSelect, [id])) {
            this._selected = id;
            this._data.update(id, { $selected: true });
            this.events.fire(types_1.SelectionEvents.afterSelect, [id]);
        }
    };
    return Selection;
}());
exports.Selection = Selection;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var en_1 = __webpack_require__(41);
function blockKeys(e) {
    var active = document.activeElement;
    if (!active.classList.contains("apply-button") && !active.classList.contains("reject-button")) {
        e.preventDefault();
    }
}
function blockScreen(css) {
    var blocker = document.createElement("div");
    blocker.className = "dhx-blocker " + (css || "");
    document.body.appendChild(blocker);
    document.addEventListener("keydown", blockKeys);
    return function () {
        document.body.removeChild(blocker);
        document.removeEventListener("keydown", blockKeys);
    };
}
exports.blockScreen = blockScreen;
function alert(props) {
    var apply = props.buttons && props.buttons[0] ? props.buttons[0] : en_1.default.apply;
    var unblock = blockScreen(props.blockerCss);
    return new Promise(function (res) {
        var alertBox = document.createElement("div");
        alertBox.className = "dhx-alert " + (props.css || "");
        alertBox.innerHTML = "\n\t\t\t<div class=\"message-box-header\">\n\t\t\t\t<div class=\"mesage-box-title\">" + props.header + "</div>\n\t\t\t</div>\n\t\t\t<div class=\"alert-message\">" + props.text + "</div>\n\t\t\t<div class=\"action-button " + (props.buttonsAlignment ? props.buttonsAlignment : "") + "\">\n\t\t\t\t<button class=\"apply-button alert-btn dhx_btn dhx_btn--flat\">" + apply + "</button>\n\t\t\t</div>";
        document.body.appendChild(alertBox);
        alertBox.querySelector(".apply-button").focus();
        alertBox.querySelector("button").addEventListener("click", function () {
            unblock();
            document.body.removeChild(alertBox);
            res(true);
        });
    });
}
exports.alert = alert;
function confirm(props) {
    var apply = props.buttons && props.buttons[1] ? props.buttons[1] : en_1.default.apply;
    var reject = props.buttons && props.buttons[0] ? props.buttons[0] : en_1.default.reject;
    var unblock = blockScreen(props.blockerCss);
    return new Promise(function (res) {
        var answer = function (val) {
            unblock();
            confirmBox.removeEventListener("click", clickHandler);
            document.body.removeChild(confirmBox);
            res(val);
        };
        var confirmBox = document.createElement("div");
        confirmBox.className = "dhx-confirm " + (props.css || "");
        confirmBox.innerHTML = "\n\t\t\t<div class=\"message-box-header\">\n\t\t\t\t<div class=\"mesage-box-title\">" + props.header + "</div>\n\t\t\t</div>\n\t\t\t<div class=\"confirm-message\">" + props.text + "</div>\n\t\t\t<div class=\"action-button " + (props.buttonsAlignment ? props.buttonsAlignment : "") + "\">\n\t\t\t\t<button class=\"reject-button dhx_btn dhx_btn--link\">" + reject + "</button>\n\t\t\t\t<button class=\"apply-button dhx_btn dhx_btn--flat\">" + apply + "</button>\n\t\t\t</div>";
        document.body.appendChild(confirmBox);
        confirmBox.querySelector(".reject-button").focus();
        var clickHandler = function (e) {
            if (e.target.tagName === "BUTTON") {
                answer(e.target.classList.contains("apply-button"));
            }
        };
        confirmBox.addEventListener("click", clickHandler);
    });
}
exports.confirm = confirm;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var locale = {
    apply: "apply",
    reject: "reject"
};
exports.default = locale;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var events_1 = __webpack_require__(9);
var html_1 = __webpack_require__(1);
var scrollView_1 = __webpack_require__(44);
var view_1 = __webpack_require__(12);
var ts_data_1 = __webpack_require__(8);
var ts_layout_1 = __webpack_require__(45);
var ts_message_1 = __webpack_require__(16);
var ts_toolbar_1 = __webpack_require__(48);
var en_1 = __webpack_require__(14);
var types_1 = __webpack_require__(15);
var Uploader_1 = __webpack_require__(64);
var configs_1 = __webpack_require__(65);
var helper_1 = __webpack_require__(66);
var ProgressBar_1 = __webpack_require__(67);
var ReadStackPreview_1 = __webpack_require__(68);
var Vault = /** @class */ (function (_super) {
    __extends(Vault, _super);
    function Vault(container, config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, null, core_1.extend({
            mode: types_1.VaultMode.list,
            toolbar: true,
            updateFromResponse: true,
            scaleFactor: 4,
            customScroll: true,
            uploader: {},
            progressBar: {}
        }, config)) || this;
        if (!_this.config.toolbar) {
            _this.config.uploader.autosend = true;
        }
        if (config.data) {
            _this.data = config.data;
            _this.events = config.data.events;
            _this.events.context = _this;
        }
        else {
            _this.events = new events_1.EventSystem(_this);
            _this.data = new ts_data_1.DataCollection({}, _this.events);
        }
        _this.data.config.init = function (obj) {
            obj.status = obj.status || types_1.FileStatus.uploaded;
            if (obj.file) {
                obj.size = obj.file.size;
                obj.name = obj.file.name;
            }
            else {
                obj.size = obj.size || 0;
                obj.name = obj.name || "";
            }
            if (_this.config.mode === types_1.VaultMode.grid && obj.file && helper_1.isImage(obj)) {
                _this._readStack.add(obj, _this.uploader.config.autosend);
            }
            return obj;
        };
        _this._readStack = new ReadStackPreview_1.ReadStackPreview(_this.data);
        _this.uploader = new Uploader_1.Uploader(_this.config.uploader, _this.data, _this.events);
        _this._scrollView = new scrollView_1.ScrollView(function () { return _this.getRootView(); });
        _this._progressBar = new ProgressBar_1.ProgressBar(_this.events, _this.config.progressBar);
        _this.events.on(types_1.UploaderEvents.uploadProgress, function (progress, current, total) { return _this._progressBar.setState(progress, { current: current, total: total }); });
        _this._initHandlers();
        _this._initUI(container);
        _this._initEvents();
        return _this;
    }
    Vault.prototype.destructor = function () {
        this.toolbar.destructor();
        this._readStack.stop();
        this.uploader.unlinkDropArea();
        this.uploader.abort();
    };
    Vault.prototype._initUI = function (container) {
        var _this = this;
        var cfg = this.config.toolbar ? configs_1.layoutConfig : configs_1.layoutConfigWithoutTopbar;
        cfg.on = this._getDragEvents();
        var layout = this._layout = new ts_layout_1.Layout(container, cfg);
        var toolbar = this.toolbar = new ts_toolbar_1.Toolbar(null, { css: "vault-toolbar" });
        var defaultButtons = [
            {
                id: "add",
                tooltip: en_1.default.add,
                type: ts_toolbar_1.ItemType.iconButton,
                icon: "dxi-plus"
            },
            {
                id: "upload",
                tooltip: en_1.default.upload,
                type: ts_toolbar_1.ItemType.iconButton,
                icon: "dxi icon-upload" // Custom Web Font Icon
            },
            {
                type: "spacer"
            },
            {
                id: "remove-all",
                tooltip: en_1.default.clearAll,
                type: ts_toolbar_1.ItemType.iconButton,
                icon: "dxi-delete-forever"
            }
        ];
        this.toolbar.data.parse(defaultButtons);
        this._hideUploadAndDeleteButtons();
        var render = function () { return _this._draw(); };
        this.mount(null, dom_1.create({ render: render }));
        if (this.config.toolbar) {
            layout.cell("topbar").attach(toolbar);
        }
        layout.cell("vault").attach(this);
    };
    Vault.prototype._initHandlers = function () {
        var _this = this;
        this._handlers = {
            onclick: {
                ".action-add": function () { return _this.uploader.selectFile(); },
                ".action-remove-file": function (e) {
                    var id = html_1.locate(e);
                    if (!id) {
                        return;
                    }
                    _this.data.update(id, { $toRemove: true });
                    setTimeout(function () {
                        _this.data.update(id, { $toRemove: false }, true);
                        _this.data.remove(id);
                    }, 200);
                }
            },
            onmouseover: {
                ".action-download": function (e) {
                    ts_message_1.tooltip(en_1.default.download, {
                        node: e.target,
                        position: ts_message_1.Position.bottom
                    });
                },
                ".action-remove-file": function (e) {
                    ts_message_1.tooltip(en_1.default.clear, {
                        node: e.target,
                        position: ts_message_1.Position.bottom
                    });
                },
                ".title-content, .dhx-file-name": function (e) {
                    var id = html_1.locate(e);
                    var item = _this.data.getItem(id);
                    ts_message_1.tooltip(item.name, {
                        node: e.target,
                        position: ts_message_1.Position.bottom,
                        css: "tooltip-light"
                    });
                }
            }
        };
    };
    Vault.prototype._getDragEvents = function () {
        var _this = this;
        var rect = {
            left: null,
            top: null,
            width: null,
            height: null
        };
        return {
            dragleave: function (e) {
                if (!_this._canDrop) {
                    return;
                }
                if (e.pageX > rect.left + rect.width - 1 || e.pageX < rect.left || e.pageY > rect.top + rect.height - 1 || e.pageY < rect.top) {
                    _this._canDrop = false;
                    if (_this.config.toolbar) {
                        _this._layout.cell("topbar").show();
                    }
                    _this._layout.config.css = "vault-layout";
                    _this._layout.paint();
                }
            },
            dragenter: function (e) {
                e.preventDefault();
                if (_this.uploader.isActive || _this._canDrop) {
                    return;
                }
                var types = e.dataTransfer.types;
                for (var _i = 0, types_2 = types; _i < types_2.length; _i++) {
                    var type = types_2[_i];
                    if (type !== "Files" && type !== "application/x-moz-file") {
                        _this._canDrop = false;
                        return;
                    }
                }
                _this._canDrop = true;
                var clientRect = _this._layout.getRootView().node.el.getBoundingClientRect();
                rect.left = clientRect.left + window.pageXOffset;
                rect.top = clientRect.top + window.pageYOffset;
                rect.width = clientRect.width;
                rect.height = clientRect.height;
                _this._canDrop = true;
                if (_this.config.toolbar) {
                    _this._layout.cell("topbar").hide();
                }
                _this._layout.config.css = "vault-layout dhx-dragin";
                _this._layout.paint();
            },
            dragover: function (e) {
                e.preventDefault();
            },
            drop: function (e) {
                e.preventDefault();
                if (!_this._canDrop) {
                    return;
                }
                var dataTransfer = e.dataTransfer;
                _this.uploader.parseFiles(dataTransfer);
                _this._canDrop = false;
                if (_this.config.toolbar) {
                    _this._layout.cell("topbar").show();
                }
                _this._layout.config.css = "vault-layout";
                _this._layout.paint();
            }
        };
    };
    Vault.prototype._hideUploadAndDeleteButtons = function () {
        this.toolbar.hide(["upload", "remove-all"]);
    };
    Vault.prototype._showUploadAndDeleteButtons = function () {
        if (this.uploader.config.autosend) {
            this.toolbar.show("remove-all");
        }
        else {
            this.toolbar.show(["upload", "remove-all"]);
        }
    };
    Vault.prototype._initEvents = function () {
        var _this = this;
        this.data.events.on(types_1.DataEvents.change, function () {
            if (!_this.data.getLength()) {
                _this._hideUploadAndDeleteButtons();
            }
            else {
                _this._showUploadAndDeleteButtons();
            }
            _this.paint();
        });
        this.events.on(types_1.UploaderEvents.uploadBegin, function () {
            if (_this.config.toolbar) {
                _this._layout.cell("topbar").attach(_this._progressBar);
            }
        });
        this.events.on(types_1.UploaderEvents.uploadComplete, function () {
            if (_this.config.mode === types_1.VaultMode.grid && _this.uploader.config.autosend) {
                _this._readStack.read();
            }
            if (_this.config.toolbar) {
                _this._layout.cell("topbar").attach(_this.toolbar);
            }
        });
        this.toolbar.events.on(ts_toolbar_1.ToolbarEvents.click, function (id) {
            switch (id) {
                case "add":
                    _this.uploader.selectFile();
                    break;
                case "remove-all":
                    _this.data.removeAll();
                    break;
                case "upload":
                    _this.uploader.send();
                    break;
            }
        });
        this.events.on(types_1.ProgressBarEvents.cancel, function () {
            _this.uploader.abort();
            _this.paint();
        });
    };
    Vault.prototype._draw = function () {
        var isEmpty = !this.data.getLength();
        var files = this.config.mode === types_1.VaultMode.grid ? this._drawGrid() : this._drawList();
        return dom_1.el("div", __assign({ class: "vault dhx_widget" + (this._canDrop ? " drop-here" : "") }, this._handlers, { dhx_widget_id: this._uid }), [
            this._canDrop || isEmpty ? this._drawDropableArea() :
                this.config.customScroll ? this._scrollView.render(files) : files
        ]);
    };
    Vault.prototype._getFileActions = function (file) {
        var defaultActions = [];
        var hoverActions = [];
        var actions = [
            dom_1.el(".dhx-default-actions", defaultActions),
            dom_1.el(".dhx-hover-actions", hoverActions)
        ];
        if (file.status === types_1.FileStatus.inprogress) {
            return actions;
        }
        if (file.status !== types_1.FileStatus.failed && file.link) {
            var link = (this.config.downloadURL || "") + file.link;
            var downloadName = link.split("/").pop().split("?")[0];
            var download = dom_1.el("a", {
                download: downloadName,
                class: "download-link",
                href: link
            }, [
                dom_1.el(".icon-btn.dxi.dxi-download.action-download")
            ]);
            hoverActions.push(download);
        }
        var remove = dom_1.el(".icon-btn.dxi.dxi-delete-forever.action-remove-file");
        hoverActions.push(remove);
        if (file.status === types_1.FileStatus.failed) {
            var warn = dom_1.el(".dxi.dxi-alert-circle.warning-status");
            defaultActions.push(warn);
        }
        if (file.status === types_1.FileStatus.uploaded) {
            var uploadComplete = dom_1.el(".dxi.dxi-checkbox-marked-circle.uploaded-status");
            defaultActions.push(uploadComplete);
        }
        return actions;
    };
    Vault.prototype._drawList = function () {
        var _this = this;
        return dom_1.el(".dhx-files-block.dhx-webkit-scroll", this.data.map(function (item) {
            var isError = item.status === types_1.FileStatus.failed && item.request;
            var inProgress = item.status === types_1.FileStatus.inprogress;
            var inQueue = item.status === types_1.FileStatus.queue;
            var notUploaded = item.status !== types_1.FileStatus.uploaded;
            return dom_1.el("div", {
                class: "dhx-file-item" + (item.$toRemove ? " to-remove" : "") + (inQueue ? " in-queue" : ""),
                dhx_id: item.id,
                _key: item.id
            }, [
                dom_1.el(".dhx-file-icon", [
                    dom_1.el("div", {
                        class: "dhx-file-type " + helper_1.getFileClassName(item) + (notUploaded ? " not-loaded" : "")
                    })
                ]),
                dom_1.el(".dhx-file-title", [
                    dom_1.el(".dhx-title-content", item.name),
                    dom_1.el(".dhx-file-info", [
                        isError && dom_1.el(".warn-message", item.request.statusText || en_1.default.error),
                        inProgress ? dom_1.el(".progress-value", (item.progress * 100).toFixed(1) + "%")
                            : dom_1.el(".dhx-size" + (isError && ".dhx-size-error" || ""), helper_1.getBasis(item.size))
                    ])
                ]),
                inProgress && dom_1.el(".dhx-download-progress", {
                    style: {
                        width: (item.progress * 100).toFixed(1) + "%"
                    }
                }),
                !inProgress && dom_1.el(".dhx-file-action", _this._getFileActions(item))
            ]);
        }));
    };
    Vault.prototype._drawDropableArea = function () {
        return dom_1.el(".dhx-dropable-area.drop-files-here", [
            dom_1.el(".dhx-big-icon-block", [
                dom_1.el(".dxi.icon-upload") // Custom Web Font Icon
            ]),
            !this._canDrop && dom_1.el(".drop-area-bold-text", en_1.default.dragAndDrop),
            !this._canDrop && dom_1.el(".drop-area-bold-text", en_1.default.filesOrFoldersHere),
            !this._canDrop && dom_1.el(".drop-area-light-text", en_1.default.or),
            !this._canDrop && dom_1.el("button.dhx_btn.dhx_btn--flat.dhx_btn--small.action-add", en_1.default.browse)
        ]);
    };
    Vault.prototype._drawGrid = function () {
        var _this = this;
        return dom_1.el("div", {
            class: "dhx-files-grid dhx-webkit-scroll"
        }, [
            dom_1.el(".dhx-grid-content", this.data.map(function (item) {
                var inProgress = item.status === types_1.FileStatus.inprogress;
                var inQueue = item.status === types_1.FileStatus.queue;
                var isError = item.status === types_1.FileStatus.failed;
                return dom_1.el("div", {
                    class: "dhx-file-grid-item" + (inProgress ? " in-progress" : "")
                        + (item.$toRemove ? " to-remove" : "") + (inQueue ? " in-queue" : "") + (isError ? " failed" : ""),
                    dhx_id: item.id,
                    _key: item.id
                }, [
                    dom_1.el(".dhx-preview-wrapper", [
                        item.preview ? dom_1.el(".dhx-server-file-preview", [
                            dom_1.el("img", { src: item.preview })
                        ]) :
                            item.image ? dom_1.el("canvas", {
                                width: 98 * _this.config.scaleFactor,
                                height: 98 * _this.config.scaleFactor,
                                _hooks: {
                                    didInsert: function (node) {
                                        var _a = helper_1.calculateCover(item.image), dx = _a.dx, dy = _a.dy, sx = _a.sx, sy = _a.sy, sHeight = _a.sHeight, sWidth = _a.sWidth;
                                        var ctx = node.el.getContext("2d");
                                        ctx.drawImage(item.image, sx, sy, sWidth, sHeight, dx, dy, 98 * _this.config.scaleFactor, 98 * _this.config.scaleFactor);
                                    }
                                }
                            }) : dom_1.el("div", {
                                class: "dhx-file-preview dhx-file-type " + helper_1.getFileClassName(item)
                            }),
                        inProgress && _this._drawCircle(item.progress)
                    ].concat(_this._getFileActions(item), [
                        dom_1.el(".dhx-file-info", [
                            isError && dom_1.el(".warn-message", item.request.statusText || en_1.default.error),
                            !inProgress && dom_1.el(".dhx-size" + (isError && ".dhx-size-error" || ""), helper_1.getBasis(item.size))
                        ])
                    ])),
                    dom_1.el(".dhx-file-name", helper_1.truncateWord(item.name))
                ]);
            }))
        ]);
    };
    Vault.prototype._drawCircle = function (progress) {
        return dom_1.el(".progress-layout", [
            dom_1.el(".progress-amount", (progress * 100).toFixed(1) + "%"),
            dom_1.sv("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "progress-circle",
                viewBox: "0 0 60 60",
            }, [
                dom_1.sv("circle", {
                    "cx": 30,
                    "cy": 30,
                    "r": 28,
                    "stroke-width": 4,
                    "class": "progress-bar-background",
                }),
                dom_1.sv("circle.active-circle", {
                    "cx": 30,
                    "cy": 30,
                    "r": 28,
                    "stroke-width": 4,
                    "stroke-dasharray": "175.9 175.9",
                    "stroke-dashoffset": (1 - progress) * 175.9,
                    "class": "progress-bar-active",
                }),
            ])
        ]);
    };
    return Vault;
}(view_1.View));
exports.Vault = Vault;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/**
* Copyright (c) 2017, Leon Sorokin
* All rights reserved. (MIT Licensed)
*
* domvm.js (DOM ViewModel)
* A thin, fast, dependency-free vdom view layer
* @preserve https://github.com/leeoniya/domvm (v3.2.6, micro build)
*/

(function (global, factory) {
	 true ? module.exports = factory() :
	undefined;
}(this, (function () { 'use strict';

// NOTE: if adding a new *VNode* type, make it < COMMENT and renumber rest.
// There are some places that test <= COMMENT to assert if node is a VNode

// VNode types
var ELEMENT	= 1;
var TEXT		= 2;
var COMMENT	= 3;

// placeholder types
var VVIEW		= 4;
var VMODEL		= 5;

var ENV_DOM = typeof window !== "undefined";
var win = ENV_DOM ? window : {};
var rAF = win.requestAnimationFrame;

var emptyObj = {};

function noop() {}

var isArr = Array.isArray;

function isSet(val) {
	return val != null;
}

function isPlainObj(val) {
	return val != null && val.constructor === Object;		//  && typeof val === "object"
}

function insertArr(targ, arr, pos, rem) {
	targ.splice.apply(targ, [pos, rem].concat(arr));
}

function isVal(val) {
	var t = typeof val;
	return t === "string" || t === "number";
}

function isFunc(val) {
	return typeof val === "function";
}

function isProm(val) {
	return typeof val === "object" && isFunc(val.then);
}



function assignObj(targ) {
	var args = arguments;

	for (var i = 1; i < args.length; i++)
		{ for (var k in args[i])
			{ targ[k] = args[i][k]; } }

	return targ;
}

// export const defProp = Object.defineProperty;

function deepSet(targ, path, val) {
	var seg;

	while (seg = path.shift()) {
		if (path.length === 0)
			{ targ[seg] = val; }
		else
			{ targ[seg] = targ = targ[seg] || {}; }
	}
}

/*
export function deepUnset(targ, path) {
	var seg;

	while (seg = path.shift()) {
		if (path.length === 0)
			targ[seg] = val;
		else
			targ[seg] = targ = targ[seg] || {};
	}
}
*/

function sliceArgs(args, offs) {
	var arr = [];
	for (var i = offs; i < args.length; i++)
		{ arr.push(args[i]); }
	return arr;
}

function cmpObj(a, b) {
	for (var i in a)
		{ if (a[i] !== b[i])
			{ return false; } }

	return true;
}

function cmpArr(a, b) {
	var alen = a.length;

	if (b.length !== alen)
		{ return false; }

	for (var i = 0; i < alen; i++)
		{ if (a[i] !== b[i])
			{ return false; } }

	return true;
}

// https://github.com/darsain/raft
// rAF throttler, aggregates multiple repeated redraw calls within single animframe
function raft(fn) {
	if (!rAF)
		{ return fn; }

	var id, ctx, args;

	function call() {
		id = 0;
		fn.apply(ctx, args);
	}

	return function() {
		ctx = this;
		args = arguments;
		if (!id) { id = rAF(call); }
	};
}

function curry(fn, args, ctx) {
	return function() {
		return fn.apply(ctx, args);
	};
}

/*
export function prop(val, cb, ctx, args) {
	return function(newVal, execCb) {
		if (newVal !== undefined && newVal !== val) {
			val = newVal;
			execCb !== false && isFunc(cb) && cb.apply(ctx, args);
		}

		return val;
	};
}
*/

/*
// adapted from https://github.com/Olical/binary-search
export function binaryKeySearch(list, item) {
    var min = 0;
    var max = list.length - 1;
    var guess;

	var bitwise = (max <= 2147483647) ? true : false;
	if (bitwise) {
		while (min <= max) {
			guess = (min + max) >> 1;
			if (list[guess].key === item) { return guess; }
			else {
				if (list[guess].key < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	} else {
		while (min <= max) {
			guess = Math.floor((min + max) / 2);
			if (list[guess].key === item) { return guess; }
			else {
				if (list[guess].key < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	}

    return -1;
}
*/

// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
// impl borrowed from https://github.com/ivijs/ivi
function longestIncreasingSubsequence(a) {
	var p = a.slice();
	var result = [];
	result.push(0);
	var u;
	var v;

	for (var i = 0, il = a.length; i < il; ++i) {
		var j = result[result.length - 1];
		if (a[j] < a[i]) {
			p[i] = j;
			result.push(i);
			continue;
		}

		u = 0;
		v = result.length - 1;

		while (u < v) {
			var c = ((u + v) / 2) | 0;
			if (a[result[c]] < a[i]) {
				u = c + 1;
			} else {
				v = c;
			}
		}

		if (a[i] < a[result[u]]) {
			if (u > 0) {
				p[i] = result[u - 1];
			}
			result[u] = i;
		}
	}

	u = result.length;
	v = result[u - 1];

	while (u-- > 0) {
		result[u] = v;
		v = p[v];
	}

	return result;
}

// based on https://github.com/Olical/binary-search
function binaryFindLarger(item, list) {
	var min = 0;
	var max = list.length - 1;
	var guess;

	var bitwise = (max <= 2147483647) ? true : false;
	if (bitwise) {
		while (min <= max) {
			guess = (min + max) >> 1;
			if (list[guess] === item) { return guess; }
			else {
				if (list[guess] < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	} else {
		while (min <= max) {
			guess = Math.floor((min + max) / 2);
			if (list[guess] === item) { return guess; }
			else {
				if (list[guess] < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	}

	return (min == list.length) ? null : min;

//	return -1;
}

function isEvProp(name) {
	return name[0] === "o" && name[1] === "n";
}

function isSplProp(name) {
	return name[0] === "_";
}

function isStyleProp(name) {
	return name === "style";
}

function repaint(node) {
	node && node.el && node.el.offsetHeight;
}

function isHydrated(vm) {
	return vm.node != null && vm.node.el != null;
}

// tests interactive props where real val should be compared
function isDynProp(tag, attr) {
//	switch (tag) {
//		case "input":
//		case "textarea":
//		case "select":
//		case "option":
			switch (attr) {
				case "value":
				case "checked":
				case "selected":
//				case "selectedIndex":
					return true;
			}
//	}

	return false;
}

function getVm(n) {
	n = n || emptyObj;
	while (n.vm == null && n.parent)
		{ n = n.parent; }
	return n.vm;
}

function VNode() {}

var VNodeProto = VNode.prototype = {
	constructor: VNode,

	type:	null,

	vm:		null,

	// all this stuff can just live in attrs (as defined) just have getters here for it
	key:	null,
	ref:	null,
	data:	null,
	hooks:	null,
	ns:		null,

	el:		null,

	tag:	null,
	attrs:	null,
	body:	null,

	flags:	0,

	_class:	null,
	_diff:	null,

	// pending removal on promise resolution
	_dead:	false,
	// part of longest increasing subsequence?
	_lis:	false,

	idx:	null,
	parent:	null,

	/*
	// break out into optional fluent module
	key:	function(val) { this.key	= val; return this; },
	ref:	function(val) { this.ref	= val; return this; },		// deep refs
	data:	function(val) { this.data	= val; return this; },
	hooks:	function(val) { this.hooks	= val; return this; },		// h("div").hooks()
	html:	function(val) { this.html	= true; return this.body(val); },

	body:	function(val) { this.body	= val; return this; },
	*/
};

function defineText(body) {
	var node = new VNode;
	node.type = TEXT;
	node.body = body;
	return node;
}

// creates a one-shot self-ending stream that redraws target vm
// TODO: if it's already registered by any parent vm, then ignore to avoid simultaneous parent & child refresh

var tagCache = {};

var RE_ATTRS = /\[(\w+)(?:=(\w+))?\]/g;

function cssTag(raw) {
	{
		var cached = tagCache[raw];

		if (cached == null) {
			var tag, id, cls, attr;

			tagCache[raw] = cached = {
				tag:	(tag	= raw.match( /^[-\w]+/))		?	tag[0]						: "div",
				id:		(id		= raw.match( /#([-\w]+)/))		? 	id[1]						: null,
				class:	(cls	= raw.match(/\.([-\w.]+)/))		?	cls[1].replace(/\./g, " ")	: null,
				attrs:	null,
			};

			while (attr = RE_ATTRS.exec(raw)) {
				if (cached.attrs == null)
					{ cached.attrs = {}; }
				cached.attrs[attr[1]] = attr[2] || "";
			}
		}

		return cached;
	}
}

// (de)optimization flags

// forces slow bottom-up removeChild to fire deep willRemove/willUnmount hooks,
var DEEP_REMOVE = 1;
// prevents inserting/removing/reordering of children
var FIXED_BODY = 2;
// enables fast keyed lookup of children via binary search, expects homogeneous keyed body
var KEYED_LIST = 4;
// indicates an vnode match/diff/recycler function for body
var LAZY_LIST = 8;

function initElementNode(tag, attrs, body, flags) {
	var node = new VNode;

	node.type = ELEMENT;

	if (isSet(flags))
		{ node.flags = flags; }

	node.attrs = attrs;

	var parsed = cssTag(tag);

	node.tag = parsed.tag;

	// meh, weak assertion, will fail for id=0, etc.
	if (parsed.id || parsed.class || parsed.attrs) {
		var p = node.attrs || {};

		if (parsed.id && !isSet(p.id))
			{ p.id = parsed.id; }

		if (parsed.class) {
			node._class = parsed.class;		// static class
			p.class = parsed.class + (isSet(p.class) ? (" " + p.class) : "");
		}
		if (parsed.attrs) {
			for (var key in parsed.attrs)
				{ if (!isSet(p[key]))
					{ p[key] = parsed.attrs[key]; } }
		}

//		if (node.attrs !== p)
			node.attrs = p;
	}

	var mergedAttrs = node.attrs;

	if (isSet(mergedAttrs)) {
		if (isSet(mergedAttrs._key))
			{ node.key = mergedAttrs._key; }

		if (isSet(mergedAttrs._ref))
			{ node.ref = mergedAttrs._ref; }

		if (isSet(mergedAttrs._hooks))
			{ node.hooks = mergedAttrs._hooks; }

		if (isSet(mergedAttrs._data))
			{ node.data = mergedAttrs._data; }

		if (isSet(mergedAttrs._flags))
			{ node.flags = mergedAttrs._flags; }

		if (!isSet(node.key)) {
			if (isSet(node.ref))
				{ node.key = node.ref; }
			else if (isSet(mergedAttrs.id))
				{ node.key = mergedAttrs.id; }
			else if (isSet(mergedAttrs.name))
				{ node.key = mergedAttrs.name + (mergedAttrs.type === "radio" || mergedAttrs.type === "checkbox" ? mergedAttrs.value : ""); }
		}
	}

	if (body != null)
		{ node.body = body; }

	return node;
}

function setRef(vm, name, node) {
	var path = ["refs"].concat(name.split("."));
	deepSet(vm, path, node);
}

function setDeepRemove(node) {
	while (node = node.parent)
		{ node.flags |= DEEP_REMOVE; }
}

// vnew, vold
function preProc(vnew, parent, idx, ownVm) {
	if (vnew.type === VMODEL || vnew.type === VVIEW)
		{ return; }

	vnew.parent = parent;
	vnew.idx = idx;
	vnew.vm = ownVm;

	if (vnew.ref != null)
		{ setRef(getVm(vnew), vnew.ref, vnew); }

	var nh = vnew.hooks,
		vh = ownVm && ownVm.hooks;

	if (nh && (nh.willRemove || nh.didRemove) ||
		vh && (vh.willUnmount || vh.didUnmount))
		{ setDeepRemove(vnew); }

	if (isArr(vnew.body))
		{ preProcBody(vnew); }
	else {}
}

function preProcBody(vnew) {
	var body = vnew.body;

	for (var i = 0; i < body.length; i++) {
		var node2 = body[i];

		// remove false/null/undefined
		if (node2 === false || node2 == null)
			{ body.splice(i--, 1); }
		// flatten arrays
		else if (isArr(node2)) {
			insertArr(body, node2, i--, 1);
		}
		else {
			if (node2.type == null)
				{ body[i] = node2 = defineText(""+node2); }

			if (node2.type === TEXT) {
				// remove empty text nodes
				if (node2.body == null || node2.body === "")
					{ body.splice(i--, 1); }
				// merge with previous text node
				else if (i > 0 && body[i-1].type === TEXT) {
					body[i-1].body += node2.body;
					body.splice(i--, 1);
				}
				else
					{ preProc(node2, vnew, i, null); }
			}
			else
				{ preProc(node2, vnew, i, null); }
		}
	}
}

var unitlessProps = {
	animationIterationCount: true,
	boxFlex: true,
	boxFlexGroup: true,
	boxOrdinalGroup: true,
	columnCount: true,
	flex: true,
	flexGrow: true,
	flexPositive: true,
	flexShrink: true,
	flexNegative: true,
	flexOrder: true,
	gridRow: true,
	gridColumn: true,
	order: true,
	lineClamp: true,

	borderImageOutset: true,
	borderImageSlice: true,
	borderImageWidth: true,
	fontWeight: true,
	lineHeight: true,
	opacity: true,
	orphans: true,
	tabSize: true,
	widows: true,
	zIndex: true,
	zoom: true,

	fillOpacity: true,
	floodOpacity: true,
	stopOpacity: true,
	strokeDasharray: true,
	strokeDashoffset: true,
	strokeMiterlimit: true,
	strokeOpacity: true,
	strokeWidth: true
};

function autoPx(name, val) {
	{
		// typeof val === 'number' is faster but fails for numeric strings
		return !isNaN(val) && !unitlessProps[name] ? (val + "px") : val;
	}
}

// assumes if styles exist both are objects or both are strings
function patchStyle(n, o) {
	var ns =     (n.attrs || emptyObj).style;
	var os = o ? (o.attrs || emptyObj).style : null;

	// replace or remove in full
	if (ns == null || isVal(ns))
		{ n.el.style.cssText = ns; }
	else {
		for (var nn in ns) {
			var nv = ns[nn];

			if (os == null || nv != null && nv !== os[nn])
				{ n.el.style[nn] = autoPx(nn, nv); }
		}

		// clean old
		if (os) {
			for (var on in os) {
				if (ns[on] == null)
					{ n.el.style[on] = ""; }
			}
		}
	}
}

var didQueue = [];

function fireHook(hooks, name, o, n, immediate) {
	if (hooks != null) {
		var fn = o.hooks[name];

		if (fn) {
			if (name[0] === "d" && name[1] === "i" && name[2] === "d") {	// did*
				//	console.log(name + " should queue till repaint", o, n);
				immediate ? repaint(o.parent) && fn(o, n) : didQueue.push([fn, o, n]);
			}
			else {		// will*
				//	console.log(name + " may delay by promise", o, n);
				return fn(o, n);		// or pass  done() resolver
			}
		}
	}
}

function drainDidHooks(vm) {
	if (didQueue.length) {
		repaint(vm.node);

		var item;
		while (item = didQueue.shift())
			{ item[0](item[1], item[2]); }
	}
}

var doc = ENV_DOM ? document : null;

function closestVNode(el) {
	while (el._node == null)
		{ el = el.parentNode; }
	return el._node;
}

function createElement(tag, ns) {
	if (ns != null)
		{ return doc.createElementNS(ns, tag); }
	return doc.createElement(tag);
}

function createTextNode(body) {
	return doc.createTextNode(body);
}

function createComment(body) {
	return doc.createComment(body);
}

// ? removes if !recycled
function nextSib(sib) {
	return sib.nextSibling;
}

// ? removes if !recycled
function prevSib(sib) {
	return sib.previousSibling;
}

// TODO: this should collect all deep proms from all hooks and return Promise.all()
function deepNotifyRemove(node) {
	var vm = node.vm;

	var wuRes = vm != null && fireHook(vm.hooks, "willUnmount", vm, vm.data);

	var wrRes = fireHook(node.hooks, "willRemove", node);

	if ((node.flags & DEEP_REMOVE) === DEEP_REMOVE && isArr(node.body)) {
		for (var i = 0; i < node.body.length; i++)
			{ deepNotifyRemove(node.body[i]); }
	}

	return wuRes || wrRes;
}

function _removeChild(parEl, el, immediate) {
	var node = el._node, vm = node.vm;

	if (isArr(node.body)) {
		if ((node.flags & DEEP_REMOVE) === DEEP_REMOVE) {
			for (var i = 0; i < node.body.length; i++)
				{ _removeChild(el, node.body[i].el); }
		}
		else
			{ deepUnref(node); }
	}

	delete el._node;

	parEl.removeChild(el);

	fireHook(node.hooks, "didRemove", node, null, immediate);

	if (vm != null) {
		fireHook(vm.hooks, "didUnmount", vm, vm.data, immediate);
		vm.node = null;
	}
}

// todo: should delay parent unmount() by returning res prom?
function removeChild(parEl, el) {
	var node = el._node;

	// already marked for removal
	if (node._dead) { return; }

	var res = deepNotifyRemove(node);

	if (res != null && isProm(res)) {
		node._dead = true;
		res.then(curry(_removeChild, [parEl, el, true]));
	}
	else
		{ _removeChild(parEl, el); }
}

function deepUnref(node) {
	var obody = node.body;

	for (var i = 0; i < obody.length; i++) {
		var o2 = obody[i];
		delete o2.el._node;

		if (o2.vm != null)
			{ o2.vm.node = null; }

		if (isArr(o2.body))
			{ deepUnref(o2); }
	}
}

function clearChildren(parent) {
	var parEl = parent.el;

	if ((parent.flags & DEEP_REMOVE) === 0) {
		isArr(parent.body) && deepUnref(parent);
		parEl.textContent = null;
	}
	else {
		var el = parEl.firstChild;

		do {
			var next = nextSib(el);
			removeChild(parEl, el);
		} while (el = next);
	}
}

// todo: hooks
function insertBefore(parEl, el, refEl) {
	var node = el._node, inDom = el.parentNode != null;

	// el === refEl is asserted as a no-op insert called to fire hooks
	var vm = (el === refEl || !inDom) ? node.vm : null;

	if (vm != null)
		{ fireHook(vm.hooks, "willMount", vm, vm.data); }

	fireHook(node.hooks, inDom ? "willReinsert" : "willInsert", node);
	parEl.insertBefore(el, refEl);
	fireHook(node.hooks, inDom ? "didReinsert" : "didInsert", node);

	if (vm != null)
		{ fireHook(vm.hooks, "didMount", vm, vm.data); }
}

function insertAfter(parEl, el, refEl) {
	insertBefore(parEl, el, refEl ? nextSib(refEl) : null);
}

var onemit = {};

function emitCfg(cfg) {
	assignObj(onemit, cfg);
}

function emit(evName) {
	var targ = this,
		src = targ;

	var args = sliceArgs(arguments, 1).concat(src, src.data);

	do {
		var evs = targ.onemit;
		var fn = evs ? evs[evName] : null;

		if (fn) {
			fn.apply(targ, args);
			break;
		}
	} while (targ = targ.parent());

	if (onemit[evName])
		{ onemit[evName].apply(targ, args); }
}

var onevent = noop;

function config(newCfg) {
	onevent = newCfg.onevent || onevent;

	{
		if (newCfg.onemit)
			{ emitCfg(newCfg.onemit); }
	}


}

function bindEv(el, type, fn) {
	el[type] = fn;
}

function exec(fn, args, e, node, vm) {
	var out = fn.apply(vm, args.concat([e, node, vm, vm.data]));

	// should these respect out === false?
	vm.onevent(e, node, vm, vm.data, args);
	onevent.call(null, e, node, vm, vm.data, args);

	if (out === false) {
		e.preventDefault();
		e.stopPropagation();
	}
}

function handle(e) {
	var node = closestVNode(e.target);
	var vm = getVm(node);

	var evDef = e.currentTarget._node.attrs["on" + e.type], fn, args;

	if (isArr(evDef)) {
		fn = evDef[0];
		args = evDef.slice(1);
		exec(fn, args, e, node, vm);
	}
	else {
		for (var sel in evDef) {
			if (e.target.matches(sel)) {
				var evDef2 = evDef[sel];

				if (isArr(evDef2)) {
					fn = evDef2[0];
					args = evDef2.slice(1);
				}
				else {
					fn = evDef2;
					args = [];
				}

				exec(fn, args, e, node, vm);
			}
		}
	}
}

function patchEvent(node, name, nval, oval) {
	if (nval === oval)
		{ return; }

	var el = node.el;

	if (nval == null || isFunc(nval))
		{ bindEv(el, name, nval); }
	else if (oval == null)
		{ bindEv(el, name, handle); }
}

function remAttr(node, name, asProp) {
	if (name[0] === ".") {
		name = name.substr(1);
		asProp = true;
	}

	if (asProp)
		{ node.el[name] = ""; }
	else
		{ node.el.removeAttribute(name); }
}

// setAttr
// diff, ".", "on*", bool vals, skip _*, value/checked/selected selectedIndex
function setAttr(node, name, val, asProp, initial) {
	var el = node.el;

	if (val == null)
		{ !initial && remAttr(node, name, false); }		// will also removeAttr of style: null
	else if (node.ns != null)
		{ el.setAttribute(name, val); }
	else if (name === "class")
		{ el.className = val; }
	else if (name === "id" || typeof val === "boolean" || asProp)
		{ el[name] = val; }
	else if (name[0] === ".")
		{ el[name.substr(1)] = val; }
	else
		{ el.setAttribute(name, val); }
}

function patchAttrs(vnode, donor, initial) {
	var nattrs = vnode.attrs || emptyObj;
	var oattrs = donor.attrs || emptyObj;

	if (nattrs === oattrs) {

	}
	else {
		for (var key in nattrs) {
			var nval = nattrs[key];
			var isDyn = isDynProp(vnode.tag, key);
			var oval = isDyn ? vnode.el[key] : oattrs[key];

			if (nval === oval) {}
			else if (isStyleProp(key))
				{ patchStyle(vnode, donor); }
			else if (isSplProp(key)) {}
			else if (isEvProp(key))
				{ patchEvent(vnode, key, nval, oval); }
			else
				{ setAttr(vnode, key, nval, isDyn, initial); }
		}

		// TODO: bench style.cssText = "" vs removeAttribute("style")
		for (var key in oattrs) {
			!(key in nattrs) &&
			!isSplProp(key) &&
			remAttr(vnode, key, isDynProp(vnode.tag, key) || isEvProp(key));
		}
	}
}

function createView(view, data, key, opts) {
	if (view.type === VVIEW) {
		data	= view.data;
		key		= view.key;
		opts	= view.opts;
		view	= view.view;
	}

	return new ViewModel(view, data, key, opts);
}

//import { XML_NS, XLINK_NS } from './defineSvgElement';
function hydrateBody(vnode) {
	for (var i = 0; i < vnode.body.length; i++) {
		var vnode2 = vnode.body[i];
		var type2 = vnode2.type;

		// ELEMENT,TEXT,COMMENT
		if (type2 <= COMMENT)
			{ insertBefore(vnode.el, hydrate(vnode2)); }		// vnode.el.appendChild(hydrate(vnode2))
		else if (type2 === VVIEW) {
			var vm = createView(vnode2.view, vnode2.data, vnode2.key, vnode2.opts)._redraw(vnode, i, false);		// todo: handle new data updates
			type2 = vm.node.type;
			insertBefore(vnode.el, hydrate(vm.node));
		}
		else if (type2 === VMODEL) {
			var vm = vnode2.vm;
			vm._redraw(vnode, i);					// , false
			type2 = vm.node.type;
			insertBefore(vnode.el, vm.node.el);		// , hydrate(vm.node)
		}
	}
}

//  TODO: DRY this out. reusing normal patch here negatively affects V8's JIT
function hydrate(vnode, withEl) {
	if (vnode.el == null) {
		if (vnode.type === ELEMENT) {
			vnode.el = withEl || createElement(vnode.tag, vnode.ns);

		//	if (vnode.tag === "svg")
		//		vnode.el.setAttributeNS(XML_NS, 'xmlns:xlink', XLINK_NS);

			if (vnode.attrs != null)
				{ patchAttrs(vnode, emptyObj, true); }

			if ((vnode.flags & LAZY_LIST) === LAZY_LIST)	// vnode.body instanceof LazyList
				{ vnode.body.body(vnode); }

			if (isArr(vnode.body))
				{ hydrateBody(vnode); }
			else if (vnode.body != null && vnode.body !== "")
				{ vnode.el.textContent = vnode.body; }
		}
		else if (vnode.type === TEXT)
			{ vnode.el = withEl || createTextNode(vnode.body); }
		else if (vnode.type === COMMENT)
			{ vnode.el = withEl || createComment(vnode.body); }
	}

	vnode.el._node = vnode;

	return vnode.el;
}

// prevent GCC from inlining some large funcs (which negatively affects Chrome's JIT)
//window.syncChildren = syncChildren;
window.lisMove = lisMove;

function nextNode(node, body) {
	return body[node.idx + 1];
}

function prevNode(node, body) {
	return body[node.idx - 1];
}

function parentNode(node) {
	return node.parent;
}

var BREAK = 1;
var BREAK_ALL = 2;

function syncDir(advSib, advNode, insert, sibName, nodeName, invSibName, invNodeName, invInsert) {
	return function(node, parEl, body, state, convTest, lis) {
		var sibNode, tmpSib;

		if (state[sibName] != null) {
			// skip dom elements not created by domvm
			if ((sibNode = state[sibName]._node) == null) {
				state[sibName] = advSib(state[sibName]);
				return;
			}

			if (parentNode(sibNode) !== node) {
				tmpSib = advSib(state[sibName]);
				sibNode.vm != null ? sibNode.vm.unmount(true) : removeChild(parEl, state[sibName]);
				state[sibName] = tmpSib;
				return;
			}
		}

		if (state[nodeName] == convTest)
			{ return BREAK_ALL; }
		else if (state[nodeName].el == null) {
			insert(parEl, hydrate(state[nodeName]), state[sibName]);	// should lis be updated here?
			state[nodeName] = advNode(state[nodeName], body);		// also need to advance sib?
		}
		else if (state[nodeName].el === state[sibName]) {
			state[nodeName] = advNode(state[nodeName], body);
			state[sibName] = advSib(state[sibName]);
		}
		// head->tail or tail->head
		else if (!lis && sibNode === state[invNodeName]) {
			tmpSib = state[sibName];
			state[sibName] = advSib(tmpSib);
			invInsert(parEl, tmpSib, state[invSibName]);
			state[invSibName] = tmpSib;
		}
		else {
			if (lis && state[sibName] != null)
				{ return lisMove(advSib, advNode, insert, sibName, nodeName, parEl, body, sibNode, state); }

			return BREAK;
		}
	};
}

function lisMove(advSib, advNode, insert, sibName, nodeName, parEl, body, sibNode, state) {
	if (sibNode._lis) {
		insert(parEl, state[nodeName].el, state[sibName]);
		state[nodeName] = advNode(state[nodeName], body);
	}
	else {
		// find closest tomb
		var t = binaryFindLarger(sibNode.idx, state.tombs);
		sibNode._lis = true;
		var tmpSib = advSib(state[sibName]);
		insert(parEl, state[sibName], t != null ? body[state.tombs[t]].el : t);

		if (t == null)
			{ state.tombs.push(sibNode.idx); }
		else
			{ state.tombs.splice(t, 0, sibNode.idx); }

		state[sibName] = tmpSib;
	}
}

var syncLft = syncDir(nextSib, nextNode, insertBefore, "lftSib", "lftNode", "rgtSib", "rgtNode", insertAfter);
var syncRgt = syncDir(prevSib, prevNode, insertAfter, "rgtSib", "rgtNode", "lftSib", "lftNode", insertBefore);

function syncChildren(node, donor) {
	var obody	= donor.body,
		parEl	= node.el,
		body	= node.body,
		state = {
			lftNode:	body[0],
			rgtNode:	body[body.length - 1],
			lftSib:		((obody)[0] || emptyObj).el,
			rgtSib:		(obody[obody.length - 1] || emptyObj).el,
		};

	converge:
	while (1) {
//		from_left:
		while (1) {
			var l = syncLft(node, parEl, body, state, null, false);
			if (l === BREAK) { break; }
			if (l === BREAK_ALL) { break converge; }
		}

//		from_right:
		while (1) {
			var r = syncRgt(node, parEl, body, state, state.lftNode, false);
			if (r === BREAK) { break; }
			if (r === BREAK_ALL) { break converge; }
		}

		sortDOM(node, parEl, body, state);
		break;
	}
}

// TODO: also use the state.rgtSib and state.rgtNode bounds, plus reduce LIS range
function sortDOM(node, parEl, body, state) {
	var kids = Array.prototype.slice.call(parEl.childNodes);
	var domIdxs = [];

	for (var k = 0; k < kids.length; k++) {
		var n = kids[k]._node;

		if (n.parent === node)
			{ domIdxs.push(n.idx); }
	}

	// list of non-movable vnode indices (already in correct order in old dom)
	var tombs = longestIncreasingSubsequence(domIdxs).map(function (i) { return domIdxs[i]; });

	for (var i = 0; i < tombs.length; i++)
		{ body[tombs[i]]._lis = true; }

	state.tombs = tombs;

	while (1) {
		var r = syncLft(node, parEl, body, state, null, true);
		if (r === BREAK_ALL) { break; }
	}
}

function alreadyAdopted(vnode) {
	return vnode.el._node.parent !== vnode.parent;
}

function takeSeqIndex(n, obody, fromIdx) {
	return obody[fromIdx];
}

function findSeqThorough(n, obody, fromIdx) {		// pre-tested isView?
	for (; fromIdx < obody.length; fromIdx++) {
		var o = obody[fromIdx];

		if (o.vm != null) {
			// match by key & viewFn || vm
			if (n.type === VVIEW && o.vm.view === n.view && o.vm.key === n.key || n.type === VMODEL && o.vm === n.vm)
				{ return o; }
		}
		else if (!alreadyAdopted(o) && n.tag === o.tag && n.type === o.type && n.key === o.key && (n.flags & ~DEEP_REMOVE) === (o.flags & ~DEEP_REMOVE))
			{ return o; }
	}

	return null;
}

function findHashKeyed(n, obody, fromIdx) {
	return obody[obody._keys[n.key]];
}

/*
// list must be a sorted list of vnodes by key
function findBinKeyed(n, list) {
	var idx = binaryKeySearch(list, n.key);
	return idx > -1 ? list[idx] : null;
}
*/

// have it handle initial hydrate? !donor?
// types (and tags if ELEM) are assumed the same, and donor exists
function patch(vnode, donor) {
	fireHook(donor.hooks, "willRecycle", donor, vnode);

	var el = vnode.el = donor.el;

	var obody = donor.body;
	var nbody = vnode.body;

	el._node = vnode;

	// "" => ""
	if (vnode.type === TEXT && nbody !== obody) {
		el.nodeValue = nbody;
		return;
	}

	if (vnode.attrs != null || donor.attrs != null)
		{ patchAttrs(vnode, donor, false); }

	// patch events

	var oldIsArr = isArr(obody);
	var newIsArr = isArr(nbody);
	var lazyList = (vnode.flags & LAZY_LIST) === LAZY_LIST;

//	var nonEqNewBody = nbody != null && nbody !== obody;

	if (oldIsArr) {
		// [] => []
		if (newIsArr || lazyList)
			{ patchChildren(vnode, donor); }
		// [] => "" | null
		else if (nbody !== obody) {
			if (nbody != null)
				{ el.textContent = nbody; }
			else
				{ clearChildren(donor); }
		}
	}
	else {
		// "" | null => []
		if (newIsArr) {
			clearChildren(donor);
			hydrateBody(vnode);
		}
		// "" | null => "" | null
		else if (nbody !== obody) {
			if (el.firstChild)
				{ el.firstChild.nodeValue = nbody; }
			else
				{ el.textContent = nbody; }
		}
	}

	fireHook(donor.hooks, "didRecycle", donor, vnode);
}

// larger qtys of KEYED_LIST children will use binary search
//const SEQ_FAILS_MAX = 100;

// TODO: modify vtree matcher to work similar to dom reconciler for keyed from left -> from right -> head/tail -> binary
// fall back to binary if after failing nri - nli > SEQ_FAILS_MAX
// while-advance non-keyed fromIdx
// [] => []
function patchChildren(vnode, donor) {
	var nbody		= vnode.body,
		nlen		= nbody.length,
		obody		= donor.body,
		olen		= obody.length,
		isLazy		= (vnode.flags & LAZY_LIST) === LAZY_LIST,
		isFixed		= (vnode.flags & FIXED_BODY) === FIXED_BODY,
		isKeyed		= (vnode.flags & KEYED_LIST) === KEYED_LIST,
		domSync		= !isFixed && vnode.type === ELEMENT,
		doFind		= true,
		find		= (
			isKeyed ? findHashKeyed :				// keyed lists/lazyLists
			isFixed || isLazy ? takeSeqIndex :		// unkeyed lazyLists and FIXED_BODY
			findSeqThorough							// more complex stuff
		);

	if (isKeyed) {
		var keys = {};
		for (var i = 0; i < obody.length; i++)
			{ keys[obody[i].key] = i; }
		obody._keys = keys;
	}

	if (domSync && nlen === 0) {
		clearChildren(donor);
		if (isLazy)
			{ vnode.body = []; }	// nbody.tpl(all);
		return;
	}

	var donor2,
		node2,
		foundIdx,
		patched = 0,
		everNonseq = false,
		fromIdx = 0;		// first unrecycled node (search head)

	if (isLazy) {
		var fnode2 = {key: null};
		var nbodyNew = Array(nlen);
	}

	for (var i = 0; i < nlen; i++) {
		if (isLazy) {
			var remake = false;
			var diffRes = null;

			if (doFind) {
				if (isKeyed)
					{ fnode2.key = nbody.key(i); }

				donor2 = find(fnode2, obody, fromIdx);
			}

			if (donor2 != null) {
                foundIdx = donor2.idx;
				diffRes = nbody.diff(i, donor2);

				// diff returns same, so cheaply adopt vnode without patching
				if (diffRes === true) {
					node2 = donor2;
					node2.parent = vnode;
					node2.idx = i;
					node2._lis = false;
				}
				// diff returns new diffVals, so generate new vnode & patch
				else
					{ remake = true; }
			}
			else
				{ remake = true; }

			if (remake) {
				node2 = nbody.tpl(i);			// what if this is a VVIEW, VMODEL, injected element?
				preProc(node2, vnode, i);

				node2._diff = diffRes != null ? diffRes : nbody.diff(i);

				if (donor2 != null)
					{ patch(node2, donor2); }
			}
			else {
				// TODO: flag tmp FIXED_BODY on unchanged nodes?

				// domSync = true;		if any idx changes or new nodes added/removed
			}

			nbodyNew[i] = node2;
		}
		else {
			var node2 = nbody[i];
			var type2 = node2.type;

			// ELEMENT,TEXT,COMMENT
			if (type2 <= COMMENT) {
				if (donor2 = doFind && find(node2, obody, fromIdx)) {
					patch(node2, donor2);
					foundIdx = donor2.idx;
				}
			}
			else if (type2 === VVIEW) {
				if (donor2 = doFind && find(node2, obody, fromIdx)) {		// update/moveTo
					foundIdx = donor2.idx;
					var vm = donor2.vm._update(node2.data, vnode, i);		// withDOM
				}
				else
					{ var vm = createView(node2.view, node2.data, node2.key, node2.opts)._redraw(vnode, i, false); }	// createView, no dom (will be handled by sync below)

				type2 = vm.node.type;
			}
			else if (type2 === VMODEL) {
				// if the injected vm has never been rendered, this vm._update() serves as the
				// initial vtree creator, but must avoid hydrating (creating .el) because syncChildren()
				// which is responsible for mounting below (and optionally hydrating), tests .el presence
				// to determine if hydration & mounting are needed
				var withDOM = isHydrated(node2.vm);

				var vm = node2.vm._update(node2.data, vnode, i, withDOM);
				type2 = vm.node.type;
			}
		}

		// found donor & during a sequential search ...at search head
		if (!isKeyed && donor2 != null) {
			if (foundIdx === fromIdx) {
				// advance head
				fromIdx++;
				// if all old vnodes adopted and more exist, stop searching
				if (fromIdx === olen && nlen > olen) {
					// short-circuit find, allow loop just create/init rest
					donor2 = null;
					doFind = false;
				}
			}
			else
				{ everNonseq = true; }

			if (olen > 100 && everNonseq && ++patched % 10 === 0)
				{ while (fromIdx < olen && alreadyAdopted(obody[fromIdx]))
					{ fromIdx++; } }
		}
	}

	// replace List w/ new body
	if (isLazy)
		{ vnode.body = nbodyNew; }

	domSync && syncChildren(vnode, donor);
}

// view + key serve as the vm's unique identity
function ViewModel(view, data, key, opts) {
	var vm = this;

	vm.view = view;
	vm.data = data;
	vm.key = key;

	if (opts) {
		vm.opts = opts;
		vm.config(opts);
	}

	var out = isPlainObj(view) ? view : view.call(vm, vm, data, key, opts);

	if (isFunc(out))
		{ vm.render = out; }
	else {
		vm.render = out.render;
		vm.config(out);
	}

	// these must be wrapped here since they're debounced per view
	vm._redrawAsync = raft(function (_) { return vm.redraw(true); });
	vm._updateAsync = raft(function (newData) { return vm.update(newData, true); });

	vm.init && vm.init.call(vm, vm, vm.data, vm.key, opts);
}

var ViewModelProto = ViewModel.prototype = {
	constructor: ViewModel,

	_diff:	null,	// diff cache

	init:	null,
	view:	null,
	key:	null,
	data:	null,
	state:	null,
	api:	null,
	opts:	null,
	node:	null,
	hooks:	null,
	onevent: noop,
	refs:	null,
	render:	null,

	mount: mount,
	unmount: unmount,
	config: function(opts) {
		var t = this;

		if (opts.init)
			{ t.init = opts.init; }
		if (opts.diff)
			{ t.diff = opts.diff; }
		if (opts.onevent)
			{ t.onevent = opts.onevent; }

		// maybe invert assignment order?
		if (opts.hooks)
			{ t.hooks = assignObj(t.hooks || {}, opts.hooks); }

		{
			if (opts.onemit)
				{ t.onemit = assignObj(t.onemit || {}, opts.onemit); }
		}
	},
	parent: function() {
		return getVm(this.node.parent);
	},
	root: function() {
		var p = this.node;

		while (p.parent)
			{ p = p.parent; }

		return p.vm;
	},
	redraw: function(sync) {
		var vm = this;
		sync ? vm._redraw(null, null, isHydrated(vm)) : vm._redrawAsync();
		return vm;
	},
	update: function(newData, sync) {
		var vm = this;
		sync ? vm._update(newData, null, null, isHydrated(vm)) : vm._updateAsync(newData);
		return vm;
	},

	_update: updateSync,
	_redraw: redrawSync,
	_redrawAsync: null,
	_updateAsync: null,
};

function mount(el, isRoot) {
	var vm = this;

	if (isRoot) {
		clearChildren({el: el, flags: 0});

		vm._redraw(null, null, false);

		// if placeholder node doesnt match root tag
		if (el.nodeName.toLowerCase() !== vm.node.tag) {
			hydrate(vm.node);
			insertBefore(el.parentNode, vm.node.el, el);
			el.parentNode.removeChild(el);
		}
		else
			{ insertBefore(el.parentNode, hydrate(vm.node, el), el); }
	}
	else {
		vm._redraw(null, null);

		if (el)
			{ insertBefore(el, vm.node.el); }
	}

	if (el)
		{ drainDidHooks(vm); }

	return vm;
}

// asSub means this was called from a sub-routine, so don't drain did* hook queue
function unmount(asSub) {
	var vm = this;

	var node = vm.node;
	var parEl = node.el.parentNode;

	// edge bug: this could also be willRemove promise-delayed; should .then() or something to make sure hooks fire in order
	removeChild(parEl, node.el);

	if (!asSub)
		{ drainDidHooks(vm); }
}

function reParent(vm, vold, newParent, newIdx) {
	if (newParent != null) {
		newParent.body[newIdx] = vold;
		vold.idx = newIdx;
		vold.parent = newParent;
		vold._lis = false;
	}
	return vm;
}

function redrawSync(newParent, newIdx, withDOM) {
	var isRedrawRoot = newParent == null;
	var vm = this;
	var isMounted = vm.node && vm.node.el && vm.node.el.parentNode;

	var vold = vm.node, oldDiff, newDiff;

	if (vm.diff != null) {
		oldDiff = vm._diff;
		vm._diff = newDiff = vm.diff(vm, vm.data);

		if (vold != null) {
			var cmpFn = isArr(oldDiff) ? cmpArr : cmpObj;
			var isSame = oldDiff === newDiff || cmpFn(oldDiff, newDiff);

			if (isSame)
				{ return reParent(vm, vold, newParent, newIdx); }
		}
	}

	isMounted && fireHook(vm.hooks, "willRedraw", vm, vm.data);

	var vnew = vm.render.call(vm, vm, vm.data, oldDiff, newDiff);

	if (vnew === vold)
		{ return reParent(vm, vold, newParent, newIdx); }

	// todo: test result of willRedraw hooks before clearing refs
	vm.refs = null;

	// always assign vm key to root vnode (this is a de-opt)
	if (vm.key != null && vnew.key !== vm.key)
		{ vnew.key = vm.key; }

	vm.node = vnew;

	if (newParent) {
		preProc(vnew, newParent, newIdx, vm);
		newParent.body[newIdx] = vnew;
	}
	else if (vold && vold.parent) {
		preProc(vnew, vold.parent, vold.idx, vm);
		vold.parent.body[vold.idx] = vnew;
	}
	else
		{ preProc(vnew, null, null, vm); }

	if (withDOM !== false) {
		if (vold) {
			// root node replacement
			if (vold.tag !== vnew.tag || vold.key !== vnew.key) {
				// hack to prevent the replacement from triggering mount/unmount
				vold.vm = vnew.vm = null;

				var parEl = vold.el.parentNode;
				var refEl = nextSib(vold.el);
				removeChild(parEl, vold.el);
				insertBefore(parEl, hydrate(vnew), refEl);

				// another hack that allows any higher-level syncChildren to set
				// reconciliation bounds using a live node
				vold.el = vnew.el;

				// restore
				vnew.vm = vm;
			}
			else
				{ patch(vnew, vold); }
		}
		else
			{ hydrate(vnew); }
	}

	isMounted && fireHook(vm.hooks, "didRedraw", vm, vm.data);

	if (isRedrawRoot && isMounted)
		{ drainDidHooks(vm); }

	return vm;
}

// this also doubles as moveTo
// TODO? @withRedraw (prevent redraw from firing)
function updateSync(newData, newParent, newIdx, withDOM) {
	var vm = this;

	if (newData != null) {
		if (vm.data !== newData) {
			fireHook(vm.hooks, "willUpdate", vm, newData);
			vm.data = newData;


		}
	}

	return vm._redraw(newParent, newIdx, withDOM);
}

function defineElement(tag, arg1, arg2, flags) {
	var attrs, body;

	if (arg2 == null) {
		if (isPlainObj(arg1))
			{ attrs = arg1; }
		else
			{ body = arg1; }
	}
	else {
		attrs = arg1;
		body = arg2;
	}

	return initElementNode(tag, attrs, body, flags);
}

//export const XML_NS = "http://www.w3.org/2000/xmlns/";
var SVG_NS = "http://www.w3.org/2000/svg";

function defineSvgElement(tag, arg1, arg2, flags) {
	var n = defineElement(tag, arg1, arg2, flags);
	n.ns = SVG_NS;
	return n;
}

function defineComment(body) {
	var node = new VNode;
	node.type = COMMENT;
	node.body = body;
	return node;
}

// placeholder for declared views
function VView(view, data, key, opts) {
	this.view = view;
	this.data = data;
	this.key = key;
	this.opts = opts;
}

VView.prototype = {
	constructor: VView,

	type: VVIEW,
	view: null,
	data: null,
	key: null,
	opts: null,
};

function defineView(view, data, key, opts) {
	return new VView(view, data, key, opts);
}

// placeholder for injected ViewModels
function VModel(vm) {
	this.vm = vm;
}

VModel.prototype = {
	constructor: VModel,

	type: VMODEL,
	vm: null,
};

function injectView(vm) {
//	if (vm.node == null)
//		vm._redraw(null, null, false);

//	return vm.node;

	return new VModel(vm);
}

function injectElement(el) {
	var node = new VNode;
	node.type = ELEMENT;
	node.el = node.key = el;
	return node;
}

function lazyList(items, cfg) {
	var len = items.length;

	var self = {
		items: items,
		length: len,
		// defaults to returning item identity (or position?)
		key: function(i) {
			return cfg.key(items[i], i);
		},
		// default returns 0?
		diff: function(i, donor) {
			var newVals = cfg.diff(items[i], i);
			if (donor == null)
				{ return newVals; }
			var oldVals = donor._diff;
			var same = newVals === oldVals || isArr(oldVals) ? cmpArr(newVals, oldVals) : cmpObj(newVals, oldVals);
			return same || newVals;
		},
		tpl: function(i) {
			return cfg.tpl(items[i], i);
		},
		map: function(tpl) {
			cfg.tpl = tpl;
			return self;
		},
		body: function(vnode) {
			var nbody = Array(len);

			for (var i = 0; i < len; i++) {
				var vnode2 = self.tpl(i);

			//	if ((vnode.flags & KEYED_LIST) === KEYED_LIST && self. != null)
			//		vnode2.key = getKey(item);

				vnode2._diff = self.diff(i);			// holds oldVals for cmp

				nbody[i] = vnode2;

				// run preproc pass (should this be just preProc in above loop?) bench
				preProc(vnode2, vnode, i);
			}

			// replace List with generated body
			vnode.body = nbody;
		}
	};

	return self;
}

var nano = {
	config: config,

	ViewModel: ViewModel,
	VNode: VNode,

	createView: createView,

	defineElement: defineElement,
	defineSvgElement: defineSvgElement,
	defineText: defineText,
	defineComment: defineComment,
	defineView: defineView,

	injectView: injectView,
	injectElement: injectElement,

	lazyList: lazyList,

	FIXED_BODY: FIXED_BODY,
	DEEP_REMOVE: DEEP_REMOVE,
	KEYED_LIST: KEYED_LIST,
	LAZY_LIST: LAZY_LIST,
};

function protoPatch(n, doRepaint) {
	patch$1(this, n, doRepaint);
}

// newNode can be either {class: style: } or full new VNode
// will/didPatch hooks?
function patch$1(o, n, doRepaint) {
	if (n.type != null) {
		// no full patching of view roots, just use redraw!
		if (o.vm != null)
			{ return; }

		preProc(n, o.parent, o.idx, null);
		o.parent.body[o.idx] = n;
		patch(n, o);
		doRepaint && repaint(n);
		drainDidHooks(getVm(n));
	}
	else {
		// TODO: re-establish refs

		// shallow-clone target
		var donor = Object.create(o);
		// fixate orig attrs
		donor.attrs = assignObj({}, o.attrs);
		// assign new attrs into live targ node
		var oattrs = assignObj(o.attrs, n);
		// prepend any fixed shorthand class
		if (o._class != null) {
			var aclass = oattrs.class;
			oattrs.class = aclass != null && aclass !== "" ? o._class + " " + aclass : o._class;
		}

		patchAttrs(o, donor);

		doRepaint && repaint(o);
	}
}

VNodeProto.patch = protoPatch;

function nextSubVms(n, accum) {
	var body = n.body;

	if (isArr(body)) {
		for (var i = 0; i < body.length; i++) {
			var n2 = body[i];

			if (n2.vm != null)
				{ accum.push(n2.vm); }
			else
				{ nextSubVms(n2, accum); }
		}
	}

	return accum;
}

function defineElementSpread(tag) {
	var args = arguments;
	var len = args.length;
	var body, attrs;

	if (len > 1) {
		var bodyIdx = 1;

		if (isPlainObj(args[1])) {
			attrs = args[1];
			bodyIdx = 2;
		}

		if (len === bodyIdx + 1 && (isVal(args[bodyIdx]) || isArr(args[bodyIdx]) || attrs && (attrs._flags & LAZY_LIST) === LAZY_LIST))
			{ body = args[bodyIdx]; }
		else
			{ body = sliceArgs(args, bodyIdx); }
	}

	return initElementNode(tag, attrs, body);
}

function defineSvgElementSpread() {
	var n = defineElementSpread.apply(null, arguments);
	n.ns = SVG_NS;
	return n;
}

ViewModelProto.emit = emit;
ViewModelProto.onemit = null;

ViewModelProto.body = function() {
	return nextSubVms(this.node, []);
};

nano.defineElementSpread = defineElementSpread;
nano.defineSvgElementSpread = defineSvgElementSpread;

return nano;

})));
//# sourceMappingURL=domvm.micro.js.map


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var html_1 = __webpack_require__(1);
var ScrollView = /** @class */ (function () {
    function ScrollView(getRootView, config) {
        var _a;
        if (config === void 0) { config = {}; }
        var _this = this;
        this.config = core_1.extend({
            speed: 20
        }, config);
        this._wheelName = html_1.isIE() ? "onmousewheel" : "onwheel";
        this._getRootView = getRootView;
        this._scrollTop = 0;
        this._runnerTop = 0;
        this._runnerHeight = 0;
        this._visibleArea = 1;
        this._scrollWidth = html_1.getScrollbarWidth();
        this._handlers = (_a = {
                onscroll: function () {
                    _this._update();
                }
            },
            _a[this._wheelName] = function (e) {
                e.preventDefault();
                var sign = (e.deltaY || -e.wheelDelta) > 0 ? 1 : -1;
                var delta = sign * _this.config.speed;
                var area = _this._getRefs().area;
                var maxBottom = area.scrollHeight - _this._runnerHeight;
                var newScrollTop = _this._scrollTop + delta;
                if (newScrollTop < 0) {
                    area.scrollTop = 0;
                }
                else if (newScrollTop > maxBottom) {
                    area.scrollTop = maxBottom;
                }
                else {
                    area.scrollTop = newScrollTop;
                }
                _this._update();
            },
            _a.onmousedownRunner = function (mouseDownEv) {
                mouseDownEv.preventDefault();
                var _a = _this._getRefs(), area = _a.area, runner = _a.runner;
                var rect = area.getBoundingClientRect();
                var top = rect.top + window.pageYOffset;
                var bottom = rect.bottom + window.pageYOffset;
                var maxBottom = area.scrollHeight - _this._runnerHeight;
                var delta = mouseDownEv.pageY - runner.getBoundingClientRect().top - window.pageYOffset;
                var mouseMove = function (e) {
                    var y = e.pageY - delta;
                    if (y <= top) {
                        area.scrollTop = 0;
                    }
                    else if (y > bottom) {
                        area.scrollTop = maxBottom;
                    }
                    else {
                        area.scrollTop = (y - top) / _this._visibleArea;
                    }
                    _this._update();
                };
                var mouseUp = function () {
                    document.removeEventListener("mousemove", mouseMove);
                    document.removeEventListener("mouseup", mouseUp);
                    document.body.classList.remove("dhx-no-select");
                };
                document.body.classList.add("dhx-no-select");
                document.addEventListener("mousemove", mouseMove);
                document.addEventListener("mouseup", mouseUp);
            },
            _a.onmousedownTrack = function (e) {
                if (e.target.classList.contains("scroll-runner")) {
                    return;
                }
                e.preventDefault();
                var mouseUp = function () {
                    document.removeEventListener("mouseup", mouseUp);
                    window.clearInterval(mousePressed); // typescript bug
                };
                var area = _this._getRefs().area;
                var top = e.target.getBoundingClientRect().top + window.pageYOffset;
                var maxBottom = area.scrollHeight - _this._runnerHeight;
                var y = e.pageY;
                var updateScroll = function () {
                    var scrollTop;
                    if (y < top + _this._runnerTop) {
                        scrollTop = _this._scrollTop - area.clientHeight;
                        if (scrollTop < 0) {
                            scrollTop = 0;
                        }
                    }
                    else if (y > top + _this._runnerTop + _this._runnerHeight) {
                        scrollTop = _this._scrollTop + area.clientHeight;
                        if (scrollTop > maxBottom) {
                            scrollTop = maxBottom;
                        }
                    }
                    else {
                        return;
                    }
                    area.scrollTop = scrollTop;
                    _this._update();
                };
                updateScroll();
                var mousePressed = setInterval(updateScroll, 100);
                document.addEventListener("mouseup", mouseUp);
            },
            _a);
    }
    ScrollView.prototype.render = function (element) {
        var _this = this;
        var _a;
        if (this._scrollWidth === 0) {
            return element;
        }
        return dom_1.el(".scroll-view-wrapper", {
            style: {
                width: "100%",
                height: "100%",
                overflow: "hidden",
                position: "relative"
            }
        }, [
            dom_1.el(".scroll-view", {
                onscroll: this._handlers.onscroll,
                _ref: "scroll-view",
                _hooks: {
                    didInsert: function () {
                        _this._update();
                    },
                    didRecycle: function () {
                        _this._update();
                    }
                },
                style: {
                    "height": "100%",
                    "width": "calc(100% + " + this._scrollWidth + "px)",
                    "overflowY": "scroll",
                    "-ms-overflow-style": "scrollbar"
                },
            }, [element]),
            dom_1.el(".y-scroll", (_a = {
                    onmousedown: this._handlers.onmousedownTrack
                },
                _a[this._wheelName] = this._handlers[this._wheelName],
                _a.style = {
                    width: "10px",
                    height: "100%",
                    right: 0,
                    top: 0,
                    position: "absolute"
                },
                _a), [
                dom_1.el(".scroll-runner", {
                    _ref: "scroll-runner",
                    onmousedown: this._handlers.onmousedownRunner,
                    style: {
                        height: this._runnerHeight + "px",
                        right: "2px",
                        top: this._runnerTop,
                        width: "6px",
                        position: "absolute"
                    }
                })
            ])
        ]);
    };
    ScrollView.prototype._update = function () {
        var refs = this._getRefs();
        if (!refs) {
            return;
        }
        var area = refs.area, runner = refs.runner;
        this._visibleArea = area.clientHeight / area.scrollHeight;
        this._scrollTop = area.scrollTop;
        this._runnerTop = this._scrollTop * this._visibleArea;
        if (this._visibleArea < 1) {
            this._runnerHeight = area.clientHeight * this._visibleArea;
        }
        else {
            this._runnerHeight = 0;
        }
        // update dom
        runner.style.top = this._runnerTop + "px";
        runner.style.height = this._runnerHeight + "px";
    };
    ScrollView.prototype._getRefs = function () {
        var rootView = this._getRootView();
        if (rootView.refs && rootView.refs["scroll-view"] && rootView.refs["scroll-runner"]) {
            return {
                area: rootView.refs["scroll-view"].el,
                runner: rootView.refs["scroll-runner"].el
            };
        }
    };
    return ScrollView;
}());
exports.ScrollView = ScrollView;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(46));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Cell_1 = __webpack_require__(47);
var dom_1 = __webpack_require__(0);
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(parent, config) {
        var _this = _super.call(this, parent, config) || this;
        if (_this.config.views) {
            _this.config.activeView = _this.config.activeView || 0;
            _this._isViewLayout = true;
        }
        _this._all = {};
        _this._parseConfig();
        _this._css += _this._xLayout ? "layout_x" : "layout_y";
        if (!(parent instanceof Layout)) {
            var view = dom_1.create({ render: function () { return _this.toVDOM(); } }, _this);
            _this.mount(parent, view);
        }
        return _this;
    }
    Layout.prototype.cell = function (id) {
        return this._all[id];
    };
    Layout.prototype.updateActiveView = function (id) {
        for (var i = 0; i < this._cells.length; i++) {
            if (this._cells[i].id === id) {
                if (this.config.activeView !== i) {
                    this.config.activeView = i;
                    this.paint();
                }
                return;
            }
        }
    };
    Layout.prototype.getActiveView = function () {
        return this._cells[this.config.activeView];
    };
    Layout.prototype.toVDOM = function () {
        if (this._isViewLayout) {
            return _super.prototype.toVDOM.call(this, [this.getActiveView().toVDOM()]);
        }
        var nodes = [];
        this._cells.forEach(function (cell) {
            var node = cell.toVDOM();
            if (Array.isArray(node)) {
                nodes.push.apply(nodes, node);
            }
            else {
                nodes.push(node);
            }
        });
        return _super.prototype.toVDOM.call(this, nodes, this._isTopParent);
    };
    Layout.prototype.removeCell = function (id) {
        var topParent = this.getTopParent();
        if (topParent._all[id]) {
            var parent_1 = topParent._all[id].getParent();
            delete topParent._all[id];
            var cells = parent_1._cells;
            var deleteIndex = -1;
            for (var i = 0; i < cells.length; i++) {
                if (cells[i].id === id) {
                    deleteIndex = i;
                    break;
                }
            }
            if (deleteIndex !== -1) {
                cells.splice(deleteIndex, 1);
            }
            this.paint();
        }
    };
    Layout.prototype.addCell = function (config, index) {
        if (index === void 0) { index = -1; }
        var topParent = this.getTopParent();
        var view = this._parseView(config, topParent);
        if (index < 0) {
            index = this._cells.length + index + 1;
        }
        this._cells.splice(index, 0, view);
        this.paint();
    };
    Layout.prototype.getId = function (index) {
        if (index < 0) {
            index = this._cells.length + index;
        }
        return this._cells[index] ? this._cells[index].id : undefined;
    };
    Layout.prototype._parseConfig = function () {
        var _this = this;
        var config = this.config;
        var topParent = this.getTopParent();
        var cells = config.rows || config.cols || config.views;
        this._xLayout = !config.rows;
        this._cells = cells.map(function (a) { return _this._parseView(a, topParent); });
    };
    Layout.prototype._createUi = function (cell) {
        if (cell.rows || cell.cols || cell.views) {
            return new Layout(this, cell);
        }
        else {
            return new Cell_1.Cell(this, cell);
        }
    };
    Layout.prototype._parseView = function (raw, topParent) {
        var view = this._createUi(raw);
        if (raw.id) {
            topParent._all[raw.id] = view;
        }
        return view;
    };
    return Layout;
}(Cell_1.Cell));
exports.Layout = Layout;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var view_1 = __webpack_require__(12);
var resizeMode;
(function (resizeMode) {
    resizeMode[resizeMode["unknown"] = 0] = "unknown";
    resizeMode[resizeMode["percents"] = 1] = "percents";
    resizeMode[resizeMode["pixels"] = 2] = "pixels";
    resizeMode[resizeMode["mixedpx1"] = 3] = "mixedpx1";
    resizeMode[resizeMode["mixedpx2"] = 4] = "mixedpx2";
    resizeMode[resizeMode["mixedperc1"] = 5] = "mixedperc1";
    resizeMode[resizeMode["mixedperc2"] = 6] = "mixedperc2";
})(resizeMode || (resizeMode = {}));
function getResizeMode(dir, conf1, conf2) {
    var field = dir ? "width" : "height";
    var is1perc = conf1[field] && conf1[field].indexOf("%") !== -1;
    var is2perc = conf2[field] && conf2[field].indexOf("%") !== -1;
    var is1px = conf1[field] && conf1[field].indexOf("px") !== -1;
    var is2px = conf2[field] && conf2[field].indexOf("px") !== -1;
    if (is1perc && is2perc) {
        return resizeMode.percents;
    }
    if (is1px && is2px) {
        return resizeMode.pixels;
    }
    if (is1px && !is2px) {
        return resizeMode.mixedpx1;
    }
    if (is2px && !is1px) {
        return resizeMode.mixedpx2;
    }
    if (is1perc) {
        return resizeMode.mixedperc1;
    }
    if (is2perc) {
        return resizeMode.mixedperc2;
    }
    return resizeMode.unknown;
}
function getBlockRange(block1, block2, isXLayout) {
    if (isXLayout === void 0) { isXLayout = true; }
    if (isXLayout) {
        return {
            min: block1.left + window.pageXOffset,
            max: block2.right + window.pageXOffset
        };
    }
    return {
        min: block1.top + window.pageYOffset,
        max: block2.bottom + window.pageYOffset
    };
}
var Cell = /** @class */ (function (_super) {
    __extends(Cell, _super);
    function Cell(parent, config) {
        var _this = _super.call(this, parent, config) || this;
        _this._parent = parent;
        _this._isTopParent = !(parent instanceof Cell);
        _this._initHandlers();
        _this.mount(parent, { redraw: function () {
                parent.paint();
            } });
        _this.id = _this.config.id;
        _this._css = "";
        return _this;
    }
    Cell.prototype.isVisible = function () {
        return !this.config.hidden;
    };
    Cell.prototype.isView = function () {
        return !!this._parent.config.views;
    };
    Cell.prototype.hide = function () {
        this.config.hidden = true;
        this.paint();
    };
    Cell.prototype.show = function (_forced) {
        if (this.isView()) {
            this._parent.updateActiveView(this.id);
            return;
        }
        if (this._parent && !this._parent.isVisible()) {
            this._parent.show();
        }
        this.config.hidden = false;
        this.paint();
    };
    Cell.prototype.getParent = function () {
        return this._parent;
    };
    Cell.prototype.getTopParent = function () {
        if (this._isTopParent) {
            return this;
        }
        var parent = this.getParent();
        while (parent) {
            if (parent._isTopParent) {
                return parent;
            }
            parent = parent.getParent();
        }
    };
    Cell.prototype.destructor = function () {
        this.config = null;
    };
    Cell.prototype.getWidget = function () {
        return this._ui;
    };
    Cell.prototype.attach = function (name, config) {
        if (typeof name === "object") {
            this._ui = name;
        }
        else if (typeof name === "string") {
            this._ui = new window.dhx[name](null, config);
        }
        else if (typeof name === "function") {
            if (name.prototype instanceof view_1.View) {
                this._ui = new name(null, config);
            }
            else {
                this._ui = {
                    getRootView: function () {
                        return name(config);
                    }
                };
            }
        }
        this.paint();
        return this._ui;
    };
    Cell.prototype.toVDOM = function (nodes, isTopParent) {
        if (isTopParent === void 0) { isTopParent = false; }
        var conf = this.config;
        if (conf.hidden) {
            return;
        }
        var css = this._css + " " + (this.config.css || "") + (isTopParent ? " dhx_widget" : "");
        var style = this._calculateStyle();
        var kids;
        if (this.config.html) {
            kids = [dom_1.el("div", { ".innerHTML": this.config.html })];
        }
        else if (this._ui) {
            var view = this._ui.getRootView();
            if (view.render) {
                view = dom_1.inject(view);
            }
            kids = [view];
        }
        else {
            kids = nodes || null;
        }
        var resizer = this.config.canResize && !this._isLastCell() ?
            dom_1.el(".resizer." + (this._isXDirection() ? "x" : "y"), __assign({}, this._resizerHandlers, { _ref: "resizer_" + this._uid }), [dom_1.el("div", {
                    class: "dxi " + (this._isXDirection() ? "dxi-dots-vertical" : "dxi-dots-horizontal")
                })]) : null;
        var handlers = {};
        if (this.config.on) {
            for (var key in this.config.on) {
                handlers["on" + key] = this.config.on[key];
            }
        }
        var cell = dom_1.el("div", __assign({ _key: this._uid, style: style, _ref: this._uid }, handlers, { class: "dhx_cell " + css + (this.config.collapsed ? " collapsed" : "") }), [
            this.config.header ? dom_1.el("div", {
                class: "dhx_cell_header",
                onclick: this._handlers.collapse
            }, [
                dom_1.el(".header-text", this.config.header),
                dom_1.el(".header-action-icon", [
                    dom_1.el("div", {
                        class: "dxi " + this.config.headerIcon
                    })
                ])
            ]) : null,
            !this.config.collapsed ? dom_1.el("div", {
                class: "dhx_cell_content"
            }, kids) : null,
            this.config.footer ? dom_1.el("div", {
                class: "dhx_cell_footer",
            }, this.config.footer) : null
        ]);
        return resizer ? [
            cell,
            resizer
        ] : cell;
    };
    Cell.prototype._initHandlers = function () {
        var _this = this;
        var blockOpts = {
            left: null,
            top: null,
            isActive: false,
            range: null,
            xLayout: null,
            nextCell: null,
            size: null,
            resizerLength: null,
            mode: null,
            percentsum: null
        };
        var mouseUp = function () {
            blockOpts.isActive = false;
            document.body.classList.remove("dhx-no-select");
            document.removeEventListener("mouseup", mouseUp);
            document.removeEventListener("mousemove", mouseMove);
        };
        var mouseMove = function (e) {
            if (!blockOpts.isActive || blockOpts.mode === resizeMode.unknown) {
                return;
            }
            var newValue = blockOpts.xLayout ? e.x - blockOpts.range.min - window.pageXOffset :
                e.y - blockOpts.range.min - window.pageYOffset;
            var prop = blockOpts.xLayout ? "width" : "height";
            if (newValue < 0) {
                newValue = blockOpts.resizerLength / 2;
            }
            else if (newValue > blockOpts.size) {
                newValue = blockOpts.size - blockOpts.resizerLength;
            }
            switch (blockOpts.mode) {
                case resizeMode.pixels:
                    _this.config[prop] = newValue - blockOpts.resizerLength / 2 + "px";
                    blockOpts.nextCell.config[prop] = blockOpts.size - newValue - blockOpts.resizerLength / 2 + "px";
                    break;
                case resizeMode.mixedpx1:
                    _this.config[prop] = newValue - blockOpts.resizerLength / 2 + "px";
                    break;
                case resizeMode.mixedpx2:
                    blockOpts.nextCell.config[prop] = blockOpts.size - newValue - blockOpts.resizerLength / 2 + "px";
                    break;
                case resizeMode.percents:
                    _this.config[prop] = newValue / blockOpts.size * blockOpts.percentsum + "%";
                    blockOpts.nextCell.config[prop] = (blockOpts.size - newValue) / blockOpts.size * blockOpts.percentsum + "%";
                    break;
                case resizeMode.mixedperc1:
                    _this.config[prop] = newValue / blockOpts.size * blockOpts.percentsum + "%";
                    break;
                case resizeMode.mixedperc2:
                    blockOpts.nextCell.config[prop] = (blockOpts.size - newValue) / blockOpts.size * blockOpts.percentsum + "%";
                    break;
            }
            _this.paint();
        };
        this._handlers = {
            collapse: function () {
                if (!_this.config.canCollapse) {
                    return;
                }
                _this.config.collapsed = !_this.config.collapsed;
                _this.paint();
            }
        };
        this._resizerHandlers = {
            onmousedown: function (e) {
                if (e.which === 3) {
                    return;
                }
                if (blockOpts.isActive) {
                    mouseUp();
                }
                document.body.classList.add("dhx-no-select");
                var block = _this._getCellView();
                var nextCell = _this._getNextCell();
                var nextBlock = nextCell._getCellView();
                var resizerBlock = _this._getResizerView();
                var blockOffsets = block.el.getBoundingClientRect();
                var resizerOffsets = resizerBlock.el.getBoundingClientRect();
                var nextBlockOffsets = nextBlock.el.getBoundingClientRect();
                blockOpts.xLayout = _this._isXDirection();
                blockOpts.left = blockOffsets.left + window.pageXOffset;
                blockOpts.top = blockOffsets.top + window.pageYOffset;
                blockOpts.range = getBlockRange(blockOffsets, nextBlockOffsets, blockOpts.xLayout);
                blockOpts.size = blockOpts.range.max - blockOpts.range.min;
                blockOpts.isActive = true;
                blockOpts.nextCell = nextCell;
                blockOpts.resizerLength = blockOpts.xLayout ? resizerOffsets.width : resizerOffsets.height;
                blockOpts.mode = getResizeMode(blockOpts.xLayout, _this.config, nextCell.config);
                if (blockOpts.mode === resizeMode.percents) {
                    var field = blockOpts.xLayout ? "width" : "height";
                    blockOpts.percentsum = parseFloat(_this.config[field]) + parseFloat(nextCell.config[field]);
                }
                if (blockOpts.mode === resizeMode.mixedperc1) {
                    var field = blockOpts.xLayout ? "width" : "height";
                    blockOpts.percentsum = 1 / (blockOffsets[field] / (blockOpts.size - blockOpts.resizerLength)) * parseFloat(_this.config[field]);
                }
                if (blockOpts.mode === resizeMode.mixedperc2) {
                    var field = blockOpts.xLayout ? "width" : "height";
                    blockOpts.percentsum = 1 / (nextBlockOffsets[field] / (blockOpts.size - blockOpts.resizerLength)) * parseFloat(nextCell.config[field]);
                }
                document.addEventListener("mouseup", mouseUp);
                document.addEventListener("mousemove", mouseMove);
            },
            ondragstart: function (e) { return e.preventDefault(); }
        };
    };
    Cell.prototype._isLastCell = function () {
        var parent = this._parent;
        return parent && parent._cells.indexOf(this) === parent._cells.length - 1;
    };
    Cell.prototype._getNextCell = function () {
        var parent = this._parent;
        var index = parent._cells.indexOf(this);
        return parent._cells[index + 1];
    };
    Cell.prototype._getCellView = function () {
        return this.getTopParent().getRootView().refs[this._uid];
    };
    Cell.prototype._getResizerView = function () {
        return this.getTopParent().getRootView().refs["resizer_" + this._uid];
    };
    Cell.prototype._isXDirection = function () {
        return this._parent && this._parent._xLayout;
    };
    Cell.prototype._calculateStyle = function () {
        var conf = this.config;
        var style = {};
        if (this._isXDirection()) {
            if (this.config.width !== undefined) {
                style.flex = "0 0 " + conf.width;
            }
            if (conf.height !== undefined) {
                style.height = conf.height;
            }
        }
        else {
            if (this.config.height !== undefined) {
                style.flex = "0 0 " + conf.height;
            }
            if (conf.width !== undefined) {
                style.width = conf.width;
            }
        }
        return style;
    };
    return Cell;
}(view_1.View));
exports.Cell = Cell;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(26));
__export(__webpack_require__(61));
__export(__webpack_require__(62));
__export(__webpack_require__(63));
__export(__webpack_require__(17));
var types_1 = __webpack_require__(4);
exports.ToolbarEvents = types_1.ToolbarEvents;
exports.ItemType = types_1.ItemType;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function button(item) {
    return dom_1.el("div", {
        class: "button-container main-btn element" + helpers_1.getCss(item) + (item.value ? "" : " no-text"),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        item.icon ? helpers_1.icon(item.icon) : null,
        item.value ? dom_1.el(".button-text", item.value) : null
    ]);
}
exports.button = button;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function customHTMLButton(item) {
    return dom_1.el("div", {
        class: "button-container custom-html-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        dom_1.el(".html-content", {
            ".innerHTML": item.html
        }),
        item.value ? dom_1.el(".button-text", item.value) : null
    ]);
}
exports.customHTMLButton = customHTMLButton;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function dhx_button(item) {
    return dom_1.el("button", {
        class: "dhx_btn" + helpers_1.getCss(item) + helpers_1.getButtonCss(item),
        dhx_id: item.id
    }, [
        item.icon ? helpers_1.icon(item.icon) : null,
        item.value ? dom_1.el(".item-value", item.value) : null
    ]);
}
exports.dhx_button = dhx_button;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function iconButton(item) {
    return dom_1.el("div", {
        class: "icon-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        helpers_1.icon(item.icon),
        item.css && item.css.indexOf("ripple") !== -1 ? dom_1.el(".ripple-container-outside") : null
    ]);
}
exports.iconButton = iconButton;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function imageButton(item) {
    return dom_1.el("div", {
        class: "button-container img-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        dom_1.el(".img-button-wrapper", [
            dom_1.el("img.img-button", {
                src: item.src
            })
        ])
    ]);
}
exports.imageButton = imageButton;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function imageButtonText(item) {
    return dom_1.el("div", {
        class: "button-container img-text-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        dom_1.el("img.img-button", {
            src: item.src
        }),
        dom_1.el(".button-text", item.value)
    ]);
}
exports.imageButtonText = imageButtonText;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var types_1 = __webpack_require__(4);
var helpers_1 = __webpack_require__(2);
function input(item, events) {
    return dom_1.el("div", {
        dhx_id: item.id,
        class: "input-container element" + helpers_1.getCss(item)
    }, [
        dom_1.el(".input-wrapper", [
            dom_1.el("input.text-input", {
                placeholder: item.placeholder,
                value: item.value,
                style: {
                    width: item.width ? item.width : null
                },
                _hooks: {
                    didInsert: function (node) {
                        if (events) {
                            events.fire(types_1.ToolbarEvents.inputCreated, [item.id, node.el]);
                        }
                    }
                },
                _key: item.id
            }),
            dom_1.el(".input-animation")
        ]),
        item.icon ? helpers_1.icon(item.icon) : null
    ]);
}
exports.input = input;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function menuItem(item) {
    return dom_1.el("div", {
        class: "menu-item element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        item.icon ? helpers_1.icon(item.icon) : null,
        item.value ? dom_1.el("span.menu-item-content", item.value) : null,
        item.$openIcon ? dom_1.el(".dhx-icon.sub-menu-opener", [
            dom_1.el(".dxi." + (item.$openIcon === "right" ? ".dxi-menu-right" : ".dxi-menu-down"))
        ]) : null,
        item.hotkey ? dom_1.el(".hotkey", item.hotkey) : null
    ]);
}
exports.menuItem = menuItem;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
function separator(_item) {
    return dom_1.el(".separator");
}
exports.separator = separator;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
function spacer(_item) {
    return dom_1.el(".spacer");
}
exports.spacer = spacer;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function text(item) {
    return dom_1.el("div", {
        class: "text element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, item.value);
}
exports.text = text;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getHotKeyCode(code) {
    var matches = code.toLowerCase().match(/\w+/g);
    var comp = 0;
    var key = "";
    for (var i = 0; i < matches.length; i++) {
        var check = matches[i];
        if (check === "ctrl") {
            comp += 4;
        }
        else if (check === "shift") {
            comp += 2;
        }
        else if (check === "alt") {
            comp += 1;
        }
        else {
            key = check;
        }
    }
    return comp + key;
}
var KeyManager = /** @class */ (function () {
    function KeyManager() {
        var _this = this;
        this._keysStorage = {};
        document.addEventListener("keydown", function (e) {
            var comp = (e.ctrlKey ? 4 : 0) + (e.shiftKey ? 2 : 0) + (e.altKey ? 1 : 0);
            if(e.key != null && e.key != undefined && e.key !="") {
              var code = comp + e.key.toLowerCase();
              var action = _this._keysStorage[code];
              if (action) {
                  action.handler(e);
              }
            }
        });
    }
    KeyManager.prototype.addHotKey = function (key, handler, scope) {
        var code = getHotKeyCode(key);
        this._keysStorage[code] = {
            handler: handler,
            scope: scope
        };
    };
    KeyManager.prototype.removeHotKey = function (key, scope) {
        var keyStorage = this._keysStorage;
        if (key) {
            var code = getHotKeyCode(key);
            delete keyStorage[code];
        }
        if (scope) {
            for (var code in keyStorage) {
                if (keyStorage[code].scope === scope) {
                    delete keyStorage[code];
                }
            }
        }
    };
    KeyManager.prototype.exist = function (key) {
        var code = getHotKeyCode(key);
        return !!this._keysStorage[code];
    };
    return KeyManager;
}());
exports.keyManager = new KeyManager();


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var helper_1 = __webpack_require__(13);
var MenuBase_1 = __webpack_require__(18);
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isContextMenu = true;
        return _this;
    }
    ContextMenu.prototype.showAt = function (elem, showAt) {
        if (showAt === void 0) { showAt = "bottom"; }
        if (elem instanceof MouseEvent) {
            this._changeActivePosition({
                left: window.pageXOffset + elem.x + 1,
                right: window.pageXOffset + elem.x + 1,
                top: window.pageYOffset + elem.y,
                bottom: window.pageYOffset + elem.y
            }, showAt);
        }
        else {
            var node = html_1.toNode(elem);
            this._changeActivePosition(helper_1.getRealPosition(node), showAt);
        }
    };
    ContextMenu.prototype._close = function () {
        this._activeMenu = null;
        this._changeActivePosition(null, null);
    };
    ContextMenu.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        this.data.eachChild(root, function (item) {
            if (_this.data.haveChilds(item.id)) {
                item.$openIcon = "right";
            }
        }, true);
    };
    ContextMenu.prototype._getMode = function (_item, _root, active) {
        return active ? this._mode : "right";
    };
    ContextMenu.prototype._changeActivePosition = function (position, mode) {
        this._activePosition = position;
        this._mode = mode;
        this._listenOuterClick();
        this.paint();
    };
    return ContextMenu;
}(MenuBase_1.MenuBase));
exports.ContextMenu = ContextMenu;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var MenuBase_1 = __webpack_require__(18);
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(element, config) {
        var _this = _super.call(this, element, config) || this;
        var render = function () { return _this._draw(); };
        _this.mount(element, dom_1.create({ render: render }));
        return _this;
    }
    Menu.prototype._draw = function () {
        return dom_1.el("div", __assign({ dhx_widget_id: this._uid, class: "main-menu" }, this._handlers), this._drawMenuItems(this.data.getRoot()));
    };
    return Menu;
}(MenuBase_1.MenuBase));
exports.Menu = Menu;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helper_1 = __webpack_require__(13);
var Toolbar_1 = __webpack_require__(26);
var types_1 = __webpack_require__(4);
var Ribbon = /** @class */ (function (_super) {
    __extends(Ribbon, _super);
    function Ribbon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ribbon.prototype._draw = function () {
        var _this = this;
        return dom_1.el(".ribbon.dhx_widget", {
            dhx_widget_id: this._uid,
            onclick: this._handlers.onclick
        }, this.data.map(function (block) { return _this._drawBlock(block.id); }, this.data.getRoot(), false));
    };
    Ribbon.prototype._setRoot = function (id) {
        var parentId = this.data.getParent(id);
        if (this.data.getItem(parentId).type === types_1.ItemType.block) {
            this._currentRoot = id;
        }
    };
    Ribbon.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        var groups = {};
        this.data.eachChild(root, function (item) {
            if (item.type === types_1.ItemType.menuItem) {
                if (_this.data.haveChilds(item.id)) {
                    _this.data.eachChild(item.id, function (child) { return child.type = child.type || types_1.ItemType.menuItem; }, false);
                    var parentId = _this.data.getParent(item.id);
                    var parent_1 = _this.data.getItem(parentId);
                    item.$openIcon = parent_1.type === types_1.ItemType.block ? "bot" : "right";
                }
            }
            if (item.group) {
                helper_1.addInGroups(groups, item);
            }
        }, true);
        this._groups = groups;
    };
    Ribbon.prototype._drawBlock = function (id) {
        var _this = this;
        var block = this.data.getItem(id);
        if (!block) {
            return null;
        }
        var direction = block.direction === "row" ? " ribbon-row" : " ribbon-cols";
        var childs = this.data.map(function (child) {
            if (child.type === types_1.ItemType.block) {
                return _this._drawBlock(child.id);
            }
            return _this._factory(child);
        }, id, false);
        return dom_1.el("div", {
            class: "ribbon-item-block" + direction
        }, [
            dom_1.el(".block-content", childs),
            block.label ? dom_1.el(".block-label", [dom_1.el("span", block.label)]) : null
        ]);
    };
    return Ribbon;
}(Toolbar_1.Toolbar));
exports.Ribbon = Ribbon;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var html_1 = __webpack_require__(1);
var ts_data_1 = __webpack_require__(8);
var types_1 = __webpack_require__(15);
var Uploader = /** @class */ (function () {
    function Uploader(config, data, events) {
        if (config === void 0) { config = {}; }
        this.config = core_1.extend({
            autosend: true,
            updateFromResponse: true,
            fieldName: "file"
        }, config);
        this.data = data || new ts_data_1.DataCollection();
        this.events = events || this.data.events;
        this.isActive = false;
        this._fileInput = document.createElement("input");
        this._fileInput.type = "file";
        this._fileInput.multiple = true;
        this._initEvents();
        this._dropAreas = new Map();
    }
    Uploader.prototype.selectFile = function () {
        this._fileInput.click();
    };
    Uploader.prototype.linkDropArea = function (element) {
        var _this = this;
        var node = html_1.toNode(element);
        var mouseover = function () { return node.style.cursor = "pointer"; };
        var dragover = function (e) { return e.preventDefault(); };
        var drop = function (e) {
            e.preventDefault();
            _this.parseFiles(e.dataTransfer);
        };
        node.addEventListener("mouseover", mouseover);
        node.addEventListener("dragover", dragover);
        node.addEventListener("drop", drop);
        this._dropAreas.set(node, {
            mouseover: mouseover,
            dragover: dragover,
            drop: drop
        });
    };
    Uploader.prototype.unlinkDropArea = function (element) {
        var _this = this;
        if (!element) {
            this._dropAreas.forEach(function (_, node) {
                _this._unlinkDropArea(node);
            });
            this._dropAreas.clear();
        }
        else {
            var node = html_1.toNode(element);
            this._unlinkDropArea(node);
            this._dropAreas.delete(node);
        }
    };
    Uploader.prototype.parseFiles = function (dataTransfer) {
        if (!dataTransfer.items || !dataTransfer.items[0] || !dataTransfer.items[0].webkitGetAsEntry) {
            var files = dataTransfer.files;
            for (var i = 0; i < files.length; i++) {
                this._addFile(files[i]);
            }
            if (this.config.autosend) {
                this.send();
            }
        }
        else {
            this._parseAsWebkitEntry(dataTransfer.items);
        }
    };
    Uploader.prototype.send = function (params) {
        var _this = this;
        if (this._uploadInfo && this.isActive) {
            // cancel two active sends
            return;
        }
        var all = this.data.findAll(function (item) { return item.status === types_1.FileStatus.queue || item.status === types_1.FileStatus.failed; });
        var files = all.filter(function (file) { return _this.events.fire(types_1.UploaderEvents.beforeUploadFile, [file]); });
        if (!files.length) {
            return;
        }
        this.isActive = true;
        this._uploadInfo = {
            files: files,
            count: files.length,
            size: files.reduce(function (s, f) { return s + f.file.size; }, 0)
        };
        this.events.fire(types_1.UploaderEvents.uploadBegin, [files]);
        this.events.fire(types_1.UploaderEvents.uploadProgress, [0, 0, this._uploadInfo.size]);
        if (this.config.singleRequest) {
            this._xhrSend(files, params);
        }
        else {
            for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                var fileWrapper = files_1[_i];
                this._xhrSend([fileWrapper], params);
            }
        }
    };
    Uploader.prototype.abort = function (id) {
        if (!id) {
            if (!this._uploadInfo || !this._uploadInfo.files) {
                return;
            }
            for (var _i = 0, _a = this._uploadInfo.files; _i < _a.length; _i++) {
                var fileWrapper = _a[_i];
                this.abort(fileWrapper.id);
            }
            return;
        }
        else {
            var item = this.data.getItem(id);
            if (!item || !item.request || item.request.readyState === 4) {
                return;
            }
            item.request.abort();
        }
    };
    Uploader.prototype._unlinkDropArea = function (node) {
        var handlers = this._dropAreas.get(node);
        if (!handlers) {
            return;
        }
        var mouseover = handlers.mouseover, dragover = handlers.dragover, drop = handlers.drop;
        node.removeEventListener("mouseover", mouseover);
        node.removeEventListener("dragover", dragover);
        node.removeEventListener("drop", drop);
    };
    Uploader.prototype._initEvents = function () {
        var _this = this;
        this._fileInput.addEventListener("change", function () {
            var files = _this._fileInput.files;
            for (var i = 0; i < files.length; i++) {
                _this._addFile(files[i]);
            }
            if (_this.config.autosend) {
                _this.send();
            }
            _this._fileInput.value = null; // clear file input after get info about files
        });
    };
    Uploader.prototype._xhrSend = function (fileWrappers, params) {
        var _this = this;
        var formData = this._createFormData(fileWrappers, params);
        var request = new XMLHttpRequest();
        for (var _i = 0, fileWrappers_1 = fileWrappers; _i < fileWrappers_1.length; _i++) {
            var fileWrapper = fileWrappers_1[_i];
            this.data.update(fileWrapper.id, {
                request: request,
                status: types_1.FileStatus.inprogress,
                progress: 0
            });
        }
        request.open("POST", this.config.target);
        request.upload.onprogress = function (ev) {
            for (var _i = 0, fileWrappers_2 = fileWrappers; _i < fileWrappers_2.length; _i++) {
                var fileWrapper = fileWrappers_2[_i];
                _this.data.update(fileWrapper.id, {
                    progress: ev.loaded / ev.total,
                    status: types_1.FileStatus.inprogress
                });
            }
            var current = _this._uploadInfo.files.reduce(function (tot, file) { return tot + file.size * file.progress; }, 0) || 0;
            var total = _this._uploadInfo.size;
            var progress = current / _this._uploadInfo.size * 100 || 0;
            _this.events.fire(types_1.UploaderEvents.uploadProgress, [progress, current, total]);
        };
        request.onloadend = function () {
            _this._uploadInfo.count = _this.config.singleRequest ? 0 : _this._uploadInfo.count - 1;
            var status = request.status === 200 ? types_1.FileStatus.uploaded : types_1.FileStatus.failed;
            var extra = request.status === 200 && request.response ? JSON.parse(request.response) : null;
            for (var _i = 0, fileWrappers_3 = fileWrappers; _i < fileWrappers_3.length; _i++) {
                var fileWrapper = fileWrappers_3[_i];
                _this.data.update(fileWrapper.id, { status: status });
                if (status === types_1.FileStatus.uploaded) {
                    if (_this.config.updateFromResponse && extra) {
                        if (_this.config.singleRequest && extra[fileWrapper.id]) {
                            _this.data.update(fileWrapper.id, extra[fileWrapper.id]);
                        }
                        else if (!_this.config.singleRequest) {
                            _this.data.update(fileWrapper.id, extra);
                        }
                    }
                    _this.events.fire(types_1.UploaderEvents.uploadFile, [fileWrapper, extra]);
                }
                else {
                    _this.events.fire(types_1.UploaderEvents.uploadFail, [fileWrapper]);
                }
            }
            if (_this._uploadInfo.count === 0) {
                _this.isActive = false;
                _this.events.fire(types_1.UploaderEvents.uploadComplete, [_this._uploadInfo.files]);
            }
        };
        request.send(formData);
    };
    Uploader.prototype._parseAsWebkitEntry = function (items) {
        var _this = this;
        var reads = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i].webkitGetAsEntry();
            reads.push(this._traverseFileTree(item));
        }
        Promise.all(reads).then(function () {
            if (_this.config.autosend) {
                _this.send();
            }
        });
    };
    Uploader.prototype._createFormData = function (fileWrappers, params) {
        var fieldName = this.config.fieldName;
        var formData = new FormData();
        var extraParams = this.config.params;
        if (params) {
            for (var key in params) {
                formData.append(key, params[key]);
            }
        }
        if (extraParams) {
            for (var key in extraParams) {
                formData.append(key, extraParams[key]);
            }
        }
        var brackets = fileWrappers.length > 1 ? "[]" : "";
        for (var _i = 0, fileWrappers_4 = fileWrappers; _i < fileWrappers_4.length; _i++) {
            var fileWrapper = fileWrappers_4[_i];
            formData.append(fieldName + brackets, fileWrapper.file, fileWrapper.file.name);
            formData.append(fieldName + "_fullname" + brackets, fileWrapper.path + fileWrapper.file.name);
            formData.append(fieldName + "_id" + brackets, fileWrapper.id);
        }
        return formData;
    };
    Uploader.prototype._addFile = function (file, path) {
        if (path === void 0) { path = ""; }
        var fileWrapper = {
            id: core_1.uid(),
            file: file,
            progress: 0,
            status: types_1.FileStatus.queue,
            src: null,
            path: path
        };
        this.data.add(fileWrapper);
    };
    Uploader.prototype._traverseFileTree = function (item) {
        var _this = this;
        return new Promise(function (res) {
            var count = 0;
            var readEntry = function (entry, path) {
                if (entry.isFile) {
                    count++;
                    entry.file(function (file) {
                        count--;
                        _this._addFile(file, path);
                        if (count === 0) {
                            res();
                        }
                    });
                }
                else if (entry.isDirectory) {
                    var reader = entry.createReader();
                    readDirectory(reader, path + entry.name + "/");
                }
            };
            var readDirectory = function (reader, path) {
                count++;
                reader.readEntries(function (entries) {
                    count--;
                    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                        var entry = entries_1[_i];
                        readEntry(entry, path);
                    }
                    if (count === 0) {
                        res();
                    }
                });
            };
            readEntry(item, "");
        });
    };
    return Uploader;
}());
exports.Uploader = Uploader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutConfig = {
    css: "vault-layout",
    rows: [
        {
            id: "topbar",
            css: "vault-topbar"
        },
        {
            id: "vault",
            css: "vault-file-grid"
        }
    ]
};
exports.layoutConfigWithoutTopbar = {
    css: "vault-layout",
    rows: [
        {
            id: "vault",
            css: "vault-file-grid"
        }
    ]
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var en_1 = __webpack_require__(14);
var basis = [
    "byte",
    "kilobyte",
    "megabyte",
    "gigabyte"
];
function getBasis(size, current) {
    if (size === void 0) { size = 0; }
    if (current === void 0) { current = 0; }
    return size < 1024 ? size + " " + en_1.default[basis[current]] : this.getBasis(Math.round(size / 1024), current + 1);
}
exports.getBasis = getBasis;
var MAX_WORD_LENGTH = 13;
function truncateWord(word, len) {
    if (len === void 0) { len = MAX_WORD_LENGTH; }
    var start;
    var end;
    if (word.length <= len) {
        return word;
    }
    var dotIndex = word.lastIndexOf(".");
    if (dotIndex === -1) {
        end = word.substr(word.length - 4);
        start = word.substr(0, len - 7);
    }
    else {
        var endStartFrom = dotIndex - 3;
        end = word.substr(endStartFrom);
        start = word.substr(0, len - (word.length - endStartFrom));
    }
    return start + "..." + end;
}
exports.truncateWord = truncateWord;
function calculateCover(image) {
    var width = image.width, height = image.height;
    var imageAspectRatio = width / height;
    var sHeight;
    var sWidth;
    var sx;
    var sy;
    if (imageAspectRatio > 1) {
        // width > height
        sWidth = height;
        sHeight = height;
        sx = (width - sWidth) / 2;
        sy = 0;
    }
    else if (imageAspectRatio < 1) {
        // width < height
        sWidth = width;
        sHeight = width;
        sx = 0;
        sy = (height - sHeight) / 2;
    }
    else {
        // width == height
        sHeight = width;
        sWidth = width;
        sx = 0;
        sy = 0;
    }
    return {
        sx: sx,
        sy: sy,
        sWidth: sWidth,
        sHeight: sHeight,
        dx: 0,
        dy: 0
    };
}
exports.calculateCover = calculateCover;
var FileType;
(function (FileType) {
    FileType["image"] = "image";
    FileType["video"] = "video";
    FileType["archive"] = "archive";
    FileType["table"] = "table";
    FileType["document"] = "document";
    FileType["presentation"] = "presentation";
    FileType["application"] = "application";
    FileType["web"] = "web";
    FileType["apple"] = "apple";
    FileType["pdf"] = "pdf";
    FileType["psd"] = "psd";
    FileType["audio"] = "audio";
    FileType["other"] = "other";
    FileType["text"] = "text";
})(FileType = exports.FileType || (exports.FileType = {}));
function getMimeAndExtension(fileWrapper) {
    var extension = fileWrapper.name.split(".").pop() || "none";
    var mime = fileWrapper.file ? fileWrapper.file.type : "";
    return {
        extension: extension,
        mime: mime
    };
}
function getFileType(extension, mime) {
    switch (extension) {
        case "jpg":
        case "jpeg":
        case "gif":
        case "png":
        case "bmp":
        case "tiff":
        case "pcx":
        case "svg":
        case "ico":
            return FileType.image;
        case "avi":
        case "mpg":
        case "mpeg":
        case "rm":
        case "move":
        case "mov":
        case "mkv":
        case "flv":
        case "f4v":
        case "mp4":
        case "3gp":
        case "wmv":
        case "webm":
        case "vob":
            return FileType.video;
        case "rar":
        case "zip":
        case "tar":
        case "tgz":
        case "arj":
        case "gzip":
        case "bzip2":
        case "7z":
        case "ace":
        case "apk":
        case "deb":
        case "zipx":
        case "cab":
        case "tar-gz":
        case "rpm":
        case "xar":
            return FileType.archive;
        case "xlr":
        case "xls":
        case "xlsm":
        case "xlsx":
        case "ods":
        case "csv":
        case "tsv":
            return FileType.table;
        case "doc":
        case "docx":
        case "docm":
        case "dot":
        case "dotx":
        case "odt":
        case "wpd":
        case "wps":
        case "pages":
            return FileType.document;
        case "wav":
        case "aiff":
        case "au":
        case "mp3":
        case "aac":
        case "wma":
        case "ogg":
        case "flac":
        case "ape":
        case "wv":
        case "m4a":
        case "mid":
        case "midi":
            return FileType.audio;
        case "pot":
        case "potm":
        case "potx":
        case "pps":
        case "ppsm":
        case "ppsx":
        case "ppt":
        case "pptx":
        case "pptm":
        case "odp":
            return FileType.presentation;
        case "html":
        case "htm":
        case "eml":
            return FileType.web;
        case "exe":
            return FileType.application;
        case "dmg":
            return FileType.apple;
        case "pdf":
        case "ps":
        case "eps":
            return FileType.pdf;
        case "psd":
            return FileType.psd;
        case "txt":
        case "djvu":
        case "nfo":
        case "xml":
            return FileType.text;
        default:
            var type = mime.split("/")[0];
            switch (type) {
                case "image":
                    return FileType.image;
                case "audio":
                    return FileType.audio;
                case "video":
                    return FileType.video;
                default:
                    return FileType.other;
            }
    }
}
exports.getFileType = getFileType;
function getFileClassName(fileWrapper) {
    var _a = getMimeAndExtension(fileWrapper), mime = _a.mime, extension = _a.extension;
    return getFileType(extension, mime) + " extension-" + extension;
}
exports.getFileClassName = getFileClassName;
function isImage(fileWrapper) {
    var _a = getMimeAndExtension(fileWrapper), mime = _a.mime, extension = _a.extension;
    var fileType = getFileType(extension, mime);
    return fileType === FileType.image;
}
exports.isImage = isImage;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var view_1 = __webpack_require__(12);
var en_1 = __webpack_require__(14);
var types_1 = __webpack_require__(15);
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar(events, config) {
        var _this = _super.call(this, null, config) || this;
        _this.events = events;
        _this._progress = 0;
        var render = function () { return _this._draw(); };
        _this.mount(null, dom_1.create({
            render: render
        }));
        _this._abortUpload = function () {
            _this.events.fire(types_1.ProgressBarEvents.cancel);
        };
        return _this;
    }
    ProgressBar.prototype.setState = function (progress, extra) {
        this._progress = progress;
        if (this.config.template) {
            this._progressText = this.config.template(progress, extra);
        }
        else {
            this._progressText = this._progress.toFixed(1) + "%";
        }
        this.paint();
    };
    ProgressBar.prototype._draw = function () {
        return dom_1.el(".progress-bar", {
            _key: this._uid
        }, [
            dom_1.el(".progress-indicator", {
                style: {
                    width: this._progress + "%"
                }
            }),
            dom_1.el(".progress-text", {
                ".innerHTML": this._progressText
            }),
            dom_1.el("button", {
                class: "dhx_btn dhx_btn--flat dhx_btn_small action-abort-all",
                onclick: this._abortUpload
            }, en_1.default.cancel)
        ]);
    };
    return ProgressBar;
}(view_1.View));
exports.ProgressBar = ProgressBar;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReadStackPreview = /** @class */ (function () {
    function ReadStackPreview(data) {
        this._readerStack = [];
        this._isActive = false;
        this._data = data;
    }
    ReadStackPreview.prototype.add = function (fileWrapper, wait) {
        if (wait === void 0) { wait = false; }
        this._readerStack.push(fileWrapper);
        if (!wait) {
            this.read();
        }
    };
    ReadStackPreview.prototype.read = function () {
        var _this = this;
        if (!this._readerStack.length || this._isActive) {
            return;
        }
        var fileWrapper = this._readerStack.shift();
        this._isActive = true;
        var reader = new FileReader();
        reader.readAsDataURL(fileWrapper.file);
        reader.onload = function (e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function () {
                if (_this._data.exists(fileWrapper.id)) {
                    _this._data.update(fileWrapper.id, { image: image });
                }
                _this._isActive = false;
                _this.read();
            };
        };
        reader.onerror = function () {
            _this._isActive = false;
            _this.read();
        };
    };
    ReadStackPreview.prototype.stop = function () {
        this._readerStack = [];
    };
    return ReadStackPreview;
}());
exports.ReadStackPreview = ReadStackPreview;


/***/ })
/******/ ]);
});if (window.dhx_legacy) { if (window.dhx){ for (var key in dhx) dhx_legacy[key] = dhx[key]; } window.dhx = dhx_legacy; delete window.dhx_legacy; }

//Loads the correct sidebar on window load,
//collapses the sidebar on window resize.
// Sets the min-height of #page-wrapper to window size
angular.element(function() {
  angular.element(window).bind("load resize", function() {
    var topOffset = 50;
    var width =
      this.window.innerWidth > 0 ? this.window.innerWidth : this.screen.width;
    if (width < 768) {
      angular.element("div.navbar-collapse").addClass("collapse");
      topOffset = 100; // 2-row-menu
    } else {
      angular.element("div.navbar-collapse").removeClass("collapse");
    }

    var height =
      (this.window.innerHeight > 0
        ? this.window.innerHeight
        : this.screen.height) - 1;
    height = height - topOffset;
    if (height < 1) height = 1;
    if (height > topOffset) {
      angular.element("#page-wrapper").css("min-height", height + "px");
    }
  });

  var url = angular.element(window).location;
  var element = angular
    .element("ul.nav a")
    .filter(function() {
      return this.href == url || (url.href && url.href.indexOf(this.href) == 0);
    })
    .addClass("active")
    .parent()
    .parent()
    .addClass("in")
    .parent();
  if (element.is("li")) {
    element.addClass("active");
  }
});

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */

    /** @ngInject */
    var AppController = function ($log, $window) {
        var vm = this;
        vm.awesomeThings = [];
        vm.classAnimation = '';
        vm.creationDate = 1532423437610;
        //$log.log(vm.creationDate);

        if ($window.sessionStorage.getItem("noHeader") == 'true') {
          $("html").addClass("noheader");
        }
    };

    var app = {
        templateUrl: 'app/app.html',
        controller: AppController
    };

    webapp.component('app', app);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    // $urlRouterProvider.otherwise('/');
    $stateProvider
      .state("app.panelsWells", {
        url: "/panels-wells",
        component: "panelsWells"
      })
      .state("app.buttons", {
        url: "/buttons",
        component: "buttons"
      })
      .state("app.chart", {
        url: "/chart",
        templateUrl: "app/chart/chart.html"
      });
  }
})();

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('ContactsCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', '$compile', 'modalFactory', '$translate', '$filter',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} gAlert - gAlert Module
   */
  function ContactsCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, postApi, gAlert, $compile, modalFactory, $translate, $filter) {

    var vm = this;

    vm.srch = {};
    vm.srch.title = "사업문의";
    vm.srch.srchTenantId = '8LETQJJ81A';
    vm.srch.serviceId=3;
    vm.srch.mapCode="insertApp";

    function submit() {
      if(vm.validation()){

        var data = angular.copy(vm.srch);
        postApi.openApi(data, function(result) {
          if(result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("","신청이 완료되었습니다.");
            $state.go('home.contacts', {}, {reload : true});
        }
      },
        function(error) {
          console.error('fail', status, data);
        });
      }
    }

    function validation(){

      if($scope.theForm.company.$invalid || $scope.theForm.name.$invalid || $scope.theForm.mobile.$invalid){
        gAlert("","필수항목을 입력해주세요.");
        return false;
      }else {
        var date = new Date();
        if(!vm.srch.email) vm.srch.email='';
        if(!vm.srch.department) vm.srch.department='';
        if(!vm.srch.memo) vm.srch.memo='';


        vm.srch.content = "<p>등록일시 : " + date.getFullYear() + "년 " + (date.getMonth()+1) + "월 " + date.getDate() + "일 " + date.getHours() + "시 " + date.getMinutes() + "분</p>"
                        + "<p>회사명 : " + vm.srch.company + "</p><p>담당부서 : " + vm.srch.department + "</p><p>고객명 : " + vm.srch.name
                        + "</p><p>연락처 : " + vm.srch.mobile + "</p><p>이메일 : " + vm.srch.email + "</p><p>요청사항 : " + vm.srch.memo + "</p>";
        vm.srch.To = 'dataCenter';
        return true;
      }
    }


    vm.submit = submit;
    vm.validation = validation;
  }


]);


(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */

    /** @ngInject */
    var HomeController = function ($log, $window, $stateParams, $translate, $rootScope, $scope) {
        var vm = this;
        vm.awesomeThings = [];
        vm.classAnimation = '';
        vm.creationDate = 1532423437610;
        //$log.log(vm.creationDate);

        var lang = $stateParams.lang != null ? $stateParams.lang : 'ko';
        console.log(lang);
        $translate.use(lang);
        $rootScope.currentLanguage = lang;
        $window.sessionStorage['currentLanguage'] = lang;

        $scope.location = $window.location;
        $scope.$watch('location.href', function(newVal){
          var target = angular.element('.link--gnb');
          target.removeClass('active');
          var arr = newVal.split('/');
          var link = arr[6];
          switch(link){
            case 'about' : target.eq(0).addClass('active');
            break;
            case 'business' : target.eq(1).addClass('active');
            break;
            case 'prcenter' : target.eq(2).addClass('active');
            break;
            case 'contacts' : target.eq(3).addClass('active');
            break;
          }
        });
    };

    var home = {
        templateUrl: 'home/home.html',
        controller: HomeController
    };

    webapp.component('home', home);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('home.main', {
      url : '/main',
      component : 'main'
    }).state('home.about', {
      url : '/about',
      templateUrl : 'home/about.html'
    }).state('home.business', {
      url : '/business',
      templateUrl : 'home/business.html'
    }).state('home.prcenter', {
      url : '/prcenter',
      templateUrl : 'home/prcenter.html'
    }).state('home.prcenter-view', {
      url : '/prcenter-view/:srch',
      templateUrl : 'home/prcenter-view.html'
    }).state('home.contacts', {
      url : '/contacts',
      templateUrl : 'home/contacts.html'
    });
  }
})();

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.bbspost:h0102-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("PrCentreCtrl", [
  "$window",  "$scope",  "$location",  "$state",  "$stateParams",  "$rootScope",  "GLOBAL_CONSTANT",  "postApi",  "$compile",  "modalFactory",
  "$translate",  "$filter",

  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function PrCentreCtrl(
    $window,    $scope,    $location,    $state,    $stateParams,    $rootScope,    CONSTANT,    postApi,    $compile,    modalFactory,
    $translate,    $filter  ){
    var vm = this;
    vm.srch = {};
    vm.lists = [];

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : 9,
        tableNm : 'bbspost',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm =  'bbspost';
      vm.currentPage = vm.srch.page;
    }

    vm.srch.srchTenantId = '8LETQJJ81A';
    vm.srch.viewSize = 5;
    vm.srch.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
    vm.srch.BbsMasterId = "6Y024Q3ILI";
    vm.srch.tableNm = "board.notice";
    vm.srch.CodeType = "HdcBoardType";

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {

      var data = angular.copy(vm.srch);
      data.uploadFileList = [];
      data.mapCode = "getNotice";
      data.selectType = "List"; // For CustomColumn
      data.offSet = vm.srch.viewSize * (vm.srch.page - 1);
      postApi.openApi(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if(result.body.docs.length > 0){
            var lists = result.body.docs;
            angular.forEach(lists, function(item) {
              var regDate = $filter('utcToLocal')(item.RegDate,'yyyy-MM-dd h:mm a');
              item.year = regDate.split('-')[0];
              item.month = regDate.split('-')[1];
              item.date = regDate.split('-')[2].split(' ')[0];
            });
            vm.lists = lists;
          }else {
            vm.lists = {};
          }
          console.log(vm.lists);
        }else {
          console.error("Error> list-ctrl> getList()", status, error);
        }
      },
      function (error) {
        console.error("Error> list-ctrl> getList()", status, error);
      });
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.mapCode = "BbsPost.getBbsPostListCnt";
      postApi.select(
        data,
        function (result) {
          /* console.log("type C", result.header);
        console.log("type c", result.body); */
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getListCnt()", status, error);
        }
      );
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "home.prcenter",
        { srch: srch },
        { reload: true }
      );
    }

    function goDetail(BbsPostId) {
      //vm.srch.BbsPostId = BbsPostId;
      vm.srch.BbsPostId = BbsPostId;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go("home.prcenter-view", {
          srch: srch
        });
    }


    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.goDetail = goDetail;

    // 데이터 조회
    getList();
  },
]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @description
 * # 공지사항 리스트
 */
webapp.controller('PrCenterViewCtrl',
  ['$scope', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'StaticVariable', '$state', '$stateParams', '$window', '$rootScope',
  function PrCenterViewCtrl($scope, CONSTANT, postApi, gAlert, StaticVariable, $state,  $stateParams, $window, $rootScope) {
    // View Model
    var vm = this;
    vm.srch={};
    vm.content = null;
    vm.noticeData = {};
    vm.showOverBtn = false;

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'board.notice',
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }


    function getNotice() {
      var request = angular.copy(vm.srch);
      request.uploadFileList = []; // For CustomColumn and FileAttachment
      request.mapCode = 'getNoticeDetail';

      postApi.openApi(request, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.noticTotalCount = result.body.docs.totalCount;
          vm.noticListCount = result.body.docs.length;
          vm.noticeData = result.body.docs;
          console.log("data", vm.noticeData);
        }
        // vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
      });
    }

    function goList() {
      $state.go('home.prcenter', {srch : $stateParams.srch});
    }

    getNotice();

    vm.goList = goList;
    vm.getNotice = getNotice;

  }
]);

})();

webapp.controller('MeetingDailyModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function MeetingDailyModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;

      vm.data = toModalData;

      (function MeetingDailyModalCtrl() {
        getList();
      })();

      function cancel(item) {
        $uibModalInstance.dismiss('cancel');
      }

      $scope.col_defs = [
        /* { field: "T09", displayName: "09"},
        { field: "T10", displayName: "10"},
        { field: "T11", displayName: "11"},
        { field: "T12", displayName: "12"},
        { field: "T13", displayName: "13"},
        { field: "T14", displayName: "14"},
        { field: "T15", displayName: "15"},
        { field: "T16", displayName: "16"},
        { field: "T17", displayName: "17"},
        { field: "T18", displayName: "18"},
        { field: "T19", displayName: "19"},
        { field: "T20", displayName: "20"},
        { field: "T21", displayName: "21"},
        { field: "T22", displayName: "22"},
        { field: "T23", displayName: "23"} */
      ];

      $scope.expanding_property = {
        field: "label",
        displayName: "회의실",
        cellTemplate: "<i>{{row.branch[expandingProperty.field]}}</i>"
      };

      var tree;
      $scope.my_tree = tree = {};

      $scope.my_tree_handler = function (branch) {
        console.log('you clicked on', branch);
      };

      function getList() {
        $scope.tree_data = [];

        // 로케이션관리 select 검색실행함
        vm.data.selectType = 'List'; // For CustomColumn
        vm.data.mapCode = 'Calendar.getReserveStatistics';
        postApi.select(vm.data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;

              var topItem = result.body.docs[0];

              var arrlist = [];

              //var checkStr = 'V';
              var checkStr = '<i class="glyphicon glyphicon-check"></i>';

              // for문으로 다시 json 구조로 변환함.
              angular.forEach(vm.lists, function(item, key) {
                var data = {};
                data.label = item.CodeValue;
                data.guid = item.CommonCodeId;
                data.parent = topItem.CodeLevel == item.CodeLevel ? null : item.ParentCommonCodeId;
                data.T00 = item.T00 == '0'? '' : checkStr;
                data.T01 = item.T01 == '0'? '' : checkStr;
                data.T02 = item.T02 == '0'? '' : checkStr;
                data.T03 = item.T03 == '0'? '' : checkStr;
                data.T04 = item.T04 == '0'? '' : checkStr;
                data.T05 = item.T05 == '0'? '' : checkStr;
                data.T06 = item.T06 == '0'? '' : checkStr;
                data.T07 = item.T07 == '0'? '' : checkStr;
                data.T08 = item.T08 == '0'? '' : checkStr;
                data.T09 = item.T09 == '0'? '' : checkStr;
                data.T10 = item.T10 == '0'? '' : checkStr;
                data.T11 = item.T11 == '0'? '' : checkStr;
                data.T12 = item.T12 == '0'? '' : checkStr;
                data.T13 = item.T13 == '0'? '' : checkStr;
                data.T14 = item.T14 == '0'? '' : checkStr;
                data.T15 = item.T15 == '0'? '' : checkStr;
                data.T16 = item.T16 == '0'? '' : checkStr;
                data.T17 = item.T17 == '0'? '' : checkStr;
                data.T18 = item.T18 == '0'? '' : checkStr;
                data.T19 = item.T19 == '0'? '' : checkStr;
                data.T20 = item.T20 == '0'? '' : checkStr;
                data.T21 = item.T21 == '0'? '' : checkStr;
                data.T22 = item.T22 == '0'? '' : checkStr;
                data.T23 = item.T23 == '0'? '' : checkStr;
                arrlist.push(data);
              });

//              setTree(arrlist, "guid", "parent");

              // 계층형 json 구조로 변환함
              var recursiveArray = unflatten(arrlist);
              // guid, parent 제외 변환함
              traverse(recursiveArray);

              // 트리구조에 바인딩
              $scope.tree_data = recursiveArray;
            } else {
              vm.lists = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> getList', status, error);
          vm.dataloader = false;
        });
      }

      function findObject(obj, key, value) {
        for (var i = 0; i < obj.length; i++) {
          for (var objKey in obj[i]) {
            if (objKey == key) {
              if (obj[i][objKey] == value) {
                return obj[i];
              }
            }
          }
          if (obj[i]["children"].length > 0) {
            var result = findObject(obj[i]["children"], key, value);
            if (result != false) return result;
          }
        }
        return false;
      }

      function setTree(data) {
        if (!data || data.length == 0 ) {
          return [];
        }
        var test = $scope.tree_data;
        var temp;
        var i = 0;
        var len = data.length;
        var check = true;

        var interval = $interval(function(){
          if (check) {
            check = false;

            var item = data[i];

            if (!item.parent) {
              item.children = [];
              $scope.tree_data.push(item);
            } else {
              var obj = findObject($scope.tree_data, "guid", item.parent);

              //if(!obj.children) obj.children =[];
              if (obj.children) {
                item.children = [];
                obj.children.push(item);
              }
            }
            i++;

            if (len == i) {
              $interval.cancel(interval);
            }
            check = true;
          }
        }, 0);
      }

      function getTree(data, primaryIdName, parentIdName) {
        if (!data || data.length == 0 || !primaryIdName ||!parentIdName) {
          return [];
        }

        var tree = [];
        tree = $scope.tree_data;
        var rootIds = [];
        var treeObjs = [];
        var parentId = null;
        var parent = null;
        var len = data.length;
        var item = {};
        var i = 0;

        while (i < len) {
          item = data[i];

          primaryKey = item.guid;
          treeObjs[i] = item;
          parentId = item[parentIdName];

          if (parentId) {
            a = 0;
            while (a < len) {
              if (data[a].guid ==  treeObjs[i].parent) {
                parent =  data[a];
                break;
              }
              a++;
            }

            if (parent.children) {
              parent.children.push(item);
            } else {
              parent.children = [];
              parent.children.push(item);
            }
          } else {
            rootIds.push(primaryKey);
          }
          vm.tree_data.push(item);
          i++;
        }

        for (i = 0; i < rootIds.length; i++) {
          vm.tree_data.push(treeObjs[i]);
        }
        return tree;
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {
        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {};
          angular.copy(jsonObj[i], newItem);
          newItem.children = jsonObj[i].children;
          jsonObj[i] = newItem;
        }
      }

      function getMeetingRole() {
        var srch = {};
        srch.CodeType = 'SALEMEET';
        srch.mapCode = 'CommonProperties.getCommonPropertiesList';
        postApi.select(srch, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0] !== undefined) {
              angular.forEach(result.body.docs, function(item) {
                if (item.Code == 'reserve.starttime') {
                  vm.data.STARTTIME = parseInt(item.CodeValue);
                } else if (item.Code == 'reserve.endtime') {
                  vm.data.ENDTIME = parseInt(item.CodeValue);
                }
              });

              for (i = vm.data.STARTTIME; i <= vm.data.ENDTIME; i++) {
                var j = i;
                if (i < 10) j = "0" + j;
                $scope.col_defs.push({ field: "T" + j, displayName: j});
              }
            }
          }
        }, function(error) {
          console.error('Error> getMeetingRole()', error);
          vm.dataloader = false;
        });
      }

      getMeetingRole();
      getList();

    } ]);

webapp.controller('MeetingDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', '$filter', '$compile', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory',
    'postApi', 'gAlert', 'gConfirm', '$timeout', 'Auth',
    function MeetingDetailCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, $filter, $compile, CONSTANT, StaticVariable, modalWindow, postApi, gAlert, gConfirm, $timeout, Auth) {
      var vm = this;

      vm.getList = getList;
      vm.getSearch = getSearch;
      vm.resetSearch = resetSearch;
      vm.saveDetail = saveDetail;
      vm.goCalendar = goCalendar;
      vm.viewDetail = viewDetail;
      vm.openDaily = openDaily;
      vm.openRoomImgModal = openRoomImgModal;
      vm.getUploadFileList = getUploadFileList;
      vm.myReserveList = myReserveList;

      if(window.outerWidth < 600) {
        vm.monthlyReserve="월별 예약";
      }else {
        vm.monthlyReserve="월별예약 현황";
      }

      $(window).resize(function ($scope) {
        var widN = this.outerWidth;
        if(widN < 600) {
          this.angular.element('.monthR').text('월별 예약');
        }else {
          this.angular.element('.monthR').text('월별예약 현황');
        }
      });

      vm.srch = {CalDt : ''};
      if ($stateParams.srch != null && $stateParams.srch != '') {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));

        if(vm.srch.CalDt != null || vm.srch.CalDt !="")
          vm.tmCalDt = $rootScope.getDateFormat(vm.srch.CalDt);
        else
          vm.tmCalDt = new Date();
      } else {
        vm.tmCalDt = new Date();
      }

      vm.DataDelete = DataDelete;
      vm.DataDeleteAction = DataDeleteAction;

      vm.loginUserName = $window.sessionStorage['loginUserName'];

      vm.checkTime = checkTime;

      vm.data = {};
      vm.selectId = null;
      vm.reserveYN = null;

      vm.data.DeptNm = $window.sessionStorage['loginUserDeptNm'];
      vm.data.DeptId = $window.sessionStorage['loginUserDeptId'];
      vm.data.Company = $window.sessionStorage['loginTenantName'];
      vm.data.Mobile = $window.sessionStorage['loginMobile'];
      vm.data.TelNo = $window.sessionStorage['loginTelNo'];
      vm.data.userName = vm.loginUserName;

      if (vm.data.DeptNm == "undefined" || vm.data.DeptNm == "null") {
        vm.data.DeptNm = "";
      }
      if (vm.data.DeptId == "undefined" || vm.data.DeptId == "null") {
        vm.data.DeptId = "";
      }
      if (vm.data.Company == "undefined" || vm.data.Company == "null") {
        vm.data.Company = "";
      }
      if (vm.data.Mobile == "undefined" || vm.data.Mobile == "null") {
        vm.data.Mobile = "";
      }
      if (vm.data.TelNo == "undefined" || vm.data.TelNo == "null") {
        vm.data.TelNo = "";
      }

      vm.vault = null;
      // 업로드 파일 목록
      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // my_tree 반드시 선언하기
      var tree;
      $scope.my_tree = tree = {};

      vm.data2 = {};

      function DataDelete(ReserveId, RegUser) {
        if (RegUser != $rootScope.gVariable.UserId) {
          return;
        }

        gConfirm('알림', '예약취소 하시곘습니까?', {
          btn : '',
          fn : function() {
            DataDeleteAction(ReserveId);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function DataDeleteAction(ReserveId) {
        var srch = {'ReserveId' : ReserveId};

        srch.mapCode = 'Calendar.updateDelete';
        postApi.update(srch, function(result){
          vm.dataloader = false;

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.showSimpleToast('삭제되었습니다.', '#toastContainer');
            getList();
          }
        }, function(error) {
          console.error("Error> DataDeleteAction()", error);
          gAlert("", error);
        });
      }

      vm.dataloader = true;

      /* 예약된 시간 가져오기 */
      function getList() {
        vm.timeList = [
          /* { str : '09:00~10:00', strTime : '09' },
          { str : '10:00~11:00', strTime : '10' },
          { str : '11:00~12:00', strTime : '11' },
          { str : '12:00~13:00', strTime : '12' },
          { str : '13:00~14:00', strTime : '13' },
          { str : '14:00~15:00', strTime : '14' },
          { str : '15:00~16:00', strTime : '15' },
          { str : '16:00~17:00', strTime : '16' },
          { str : '17:00~18:00', strTime : '17' },
          { str : '18:00~19:00', strTime : '18' },
          { str : '19:00~20:00', strTime : '19' },
          { str : '20:00~21:00', strTime : '20' },
          { str : '21:00~22:00', strTime : '21' },
          { str : '22:00~23:00', strTime : '22' },
          { str : '23:00~24:00', strTime : '23' }, */
        ];

        for (i = vm.data2.STARTTIME; i <= vm.data2.ENDTIME; i++) {
          var j = i;
          var k;
          if (i < 10) {
              j = "0" + i;
              k = parseInt(i) + 1;
              if (k < 10) k = "0" + k;
          }
          else k = parseInt(i) + 1;

          vm.timeList.push({ str : j + ':00~' + k + ':00', strTime : j });
        }

        if (!vm.srch.MeetingRoom) {
          return;
        }

        angular.forEach(vm.lists, function(item) {
          if (vm.srch.MeetingRoom == item.CodeValue01) {
            vm.selectId = item.CommonCodeId;
            return;
          }
        });

        vm.dataloader = true;

        vm.srch.CalDt = moment(vm.tmCalDt).format('YYYY-MM-DD');
        var data = vm.srch;
        data.selectType = 'List'; // For CustomColumn
        data.mapCode = 'Calendar.getTimeList';
        postApi.select(data, function(result){
          vm.dataloader = false;

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.reservLists = result.body.docs;
            angular.forEach(vm.timeList, function(timeItem) {
              angular.forEach(vm.reservLists, function(item) {
                if (timeItem.strTime == item.ReserveTime) {
                  timeItem.CompanyNm = item.CompanyNm;
                  timeItem.Company = item.Company;
                  timeItem.Comment = item.Comment;
                  timeItem.Mobile = item.Mobile;
                  timeItem.TelNo = item.TelNo;
                  timeItem.RegUser = item.RegUser;
                  timeItem.UserNm = item.UserNm;
                  timeItem.ReserveId = item.ReserveId;
                  timeItem.Reserved = 'Y';
                  timeItem.ApprYN = item.ApprYN;
                  timeItem.DeptNm = item.DeptNm;
                  timeItem.RowCSS = "";
                  timeItem.Status = "";

                  if (timeItem.ApprYN == "A") {
                	  timeItem.RowCSS = "sz_timebox";
                	  timeItem.Status = "승인완료";
                  } else if (timeItem.ApprYN == "W") {
                	  timeItem.RowCSS = "sz_timebox2";
                	  timeItem.Status = "승인대기";
                  } else if (timeItem.ApprYN == "H") {
                	  timeItem.RowCSS = "sz_timebox2";
                	  timeItem.Status = "보류";
                  }
                }
              });
            });
            getReserveCnt();
          }
        }, function(error) {
          console.error("Error> user-edit-ctrl> setData()", error);
          gAlert("", error);
        });

        getUploadFileList('MeetingRoom', '');
      }

      function getSearch() {
        vm.srch.CalDt = moment(vm.tmCalDt).format('YYYY-MM-DD');

        $state.go('reserve.meeting-detail.meeting-daily', {
          srch : encodeURIComponent(JSON.stringify(vm.srch))
        }, {reload: 'reserve.meeting-detail.meeting-daily'});
      }

      function resetSearch() {
        $state.go('reserve.meeting-detail.meeting-daily', {
          srch : ''
        }, {reload: 'reserve.meeting-detail.meeting-daily'});
      }

      function checkTime(index) {
        if (vm.reserveYN == "N") {
          gAlert("선택한 회의실은 예약할 수 없습니다.");
          $("#"+index).attr("checked", false);
          vm.timeList[index].Reserv = 'N';
          return false;
        }

        if (!Auth.userHasPermission('app.reserve.reserve-list:button01')) {
          if(vm.reserveCnt >= vm.data2.DAILYMAXTIME) {
            gAlert("금일 예약 가능 시간이 초과되었습니다.");
            $("#"+index).attr("checked", false);
            vm.timeList[index].Reserv = 'N';
            return false;
          }
          else {
            if(vm.reserveCnt + $("input[name='ch']:checked").length > vm.data2.DAILYMAXTIME){
              gAlert("최대 예약 시간을 초과하였습니다.\n하루 최대 예약 가능 시간은 " + vm.data2.DAILYMAXTIME + "시간 입니다.");
              $("#"+index).attr("checked", false);
              vm.timeList[index].Reserv = 'N';
              return false;
            }
          }
        }
      }

      function saveDetail() {
        var d = new Date();
        vm.oriDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0);

        var diff = Math.round((vm.tmCalDt.getTime() - vm.oriDate.getTime()) / (1000*60*60*24));

        // if (diff < 0) {
        //   gAlert("현재일 기준 이전일은 예약할 수 없습니다.");
        //   return;
        // }

        var data = { dataArr : [] };
        angular.forEach(vm.timeList, function(timeItem) {
          if (timeItem.Reserv != null && timeItem.Reserv == 'Y') {
            data.dataArr.push(timeItem.strTime);
          }
        });

        if (isNullOrEmpty(vm.srch.MeetingRoom)) {
          gAlert('', '회의실을 선택하세요.');
          return;
        }

        if (data.dataArr.length == 0) {
          gAlert('', '선택된 예약시간이 없습니다.', {
            btn : '',
            fn : function() {
            }
          });
          return;
        }

        if (!$scope.form1.$valid) {
          return false;
        }

        // if (typeof(vm.data.Mobile) != "undefined" && vm.data.Mobile != "") {
        //   if (!fnTelMobileNoCheck(vm.data.Mobile)) {
        //     return;
        //   }
        // }

        vm.data.ReserveTime = data.dataArr;
        vm.data.CalDt = moment(vm.tmCalDt).format('YYYY-MM-DD');
        vm.data.MeetingRoom = vm.srch.MeetingRoom;
        vm.data.ApprYN = "A"; // 기본값 승인

        vm.data.mapCode = 'Calendar.insertDetail';
        postApi.insert(vm.data, function(result){
          vm.dataloader = false;

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docCnt > 0 && !result.body.docs.errMessage) {
              vm.res = result.body.docs;
              gAlert('', '예약되었습니다', {
                btn : '',
                fn : function() {
                  getList();
                }
              });
            } else {
              gAlert('', '예약되지 않았습니다.');
            }
          } else {
            gAlert('', '예약되지 않았습니다.', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function(error) {
          console.error("Error> user-edit-ctrl> setData()", error);
          gAlert("", error);
        });
      }

      function goCalendar() {
        var srch = { MeetingRoom : vm.srch.MeetingRoom};
        $state.go('reserve.meeting-room', {
          srch : encodeURIComponent(JSON.stringify(srch))
        });
      }

      function myReserveList() {
        var srch = {MeetingRoom:vm.srch.MeetingRoom};
        $state.go('reserve.my-reserve-list', {srch:encodeURIComponent(JSON.stringify(srch))});
      }

      function getMeetingRoomList() {
        var data = {};
        data.CodeType = 'MEETINGROOM';
        data.selectType = 'List'; // For CustomColumn
        data.mapCode = 'CommonCode.getCommonCodeValue';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.meetingRoomLists = result.body.docs;
//            if (vm.srch.MeetingRoom == null) {
//              vm.srch.MeetingRoom = vm.meetingRoomLists[0].Code; // 기본값 세팅, 다른방식은 그 어떠한 것도 작동하지 않음
//            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> h0102-list-ctrl> getList()', status, error);
          vm.dataloader = false;
        });
      }

      function getMeetingRoleId() {
        vm.srch.mapCode = 'MeetingroomRole.getMeetingRoleId';
        postApi.select(vm.srch, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0] !== undefined) {
              vm.data.meetingRoleId = result.body.docs[0].MeetingRoleId;
              getMeetingRole();
              return;
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> h0102-list-ctrl> getList()', status, error);
          vm.dataloader = false;
        });
      }

      function getMeetingRole() {
        var srch = {};
        srch.CodeType = 'SALEMEET';
        srch.mapCode = 'CommonProperties.getCommonPropertiesList';
        postApi.select(srch, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0] !== undefined) {
              angular.forEach(result.body.docs, function(item) {
                if (item.Code == 'reserve.dailymaxtime') {
                  vm.data2.DAILYMAXTIME = parseInt(item.CodeValue);
                } else if (item.Code == 'reserve.reserveperm') {
                  vm.data2.RESERVEPERMIT = parseInt(item.CodeValue);
                } else if (item.Code == 'reserve.starttime') {
                  vm.data2.STARTTIME = parseInt(item.CodeValue);
                } else if (item.Code == 'reserve.endtime') {
                  vm.data2.ENDTIME = parseInt(item.CodeValue);
                }
              });

              vm.timeList = [];

              for (i = vm.data2.STARTTIME; i <= vm.data2.ENDTIME; i++) {
                var j = i;
                var k;
                if (i < 10) {
                    j = "0" + i;
                    k = parseInt(i) + 1;
                    if (k < 10) k = "0" + k;
                }
                else k = parseInt(i) + 1;

                vm.timeList.push({ str : j + ':00~' + k + ':00', strTime : j });
              }
            }
          }
        }, function(error) {
          console.error('Error> getMeetingRole()', error);
          vm.dataloader = false;
        });
      }

      function getReserveCnt() {
        var srch = {
          CalDt : moment(vm.tmCalDt).format('YYYY-MM-DD'),
          MeetingRoom : vm.srch.MeetingRoom
        };

        srch.mapCode = 'Calendar.getReserveCnt';
        postApi.select(srch, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.reserveCnt = result.body.docs[0].ReserveCnt;
            return;
          }
        }, function(error) {
          console.error('Error> getMeetingRole()', error);
          vm.dataloader = false;
        });
      }

      function viewDetail(li) {
        var modalInstance = modalWindow.open('md', 'reserve/meeting-detail-modal.html', 'MeetingDetailModalCtrl as vc', li);
        modalInstance.result.then(function(result) {
        });
      }

      function openDaily() {
        var data = {CalDt: moment(vm.tmCalDt).format('YYYY-MM-DD')};
        var modalInstance = modalWindow.open('lg', 'reserve/meeting-daily-modal.html', 'MeetingDailyModalCtrl as vc', data);
        modalInstance.result.then(function(result) {
        });
      }

      function getTreeList() {
        vm.dataloader = true;
        // 사전에 트리 선언함.(중요포인트)
        $scope.my_data = [];

        // 로케이션관리 select 검색실행함
        var data = {CodeType:'MEETINGROOM'};
        data.mapCode = 'CommonCode.getCommonCodeTreeValue';
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length == 0) {
              return;
            }

            // select한 datatable 바인딩
            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            angular.forEach(vm.lists, function(item) {
              if (vm.srch.MeetingRoom && vm.srch.MeetingRoom == item.CodeValue01) {
                vm.selectId = item.CommonCodeId;
                return;
              }
            });

            refreshTree();
          }
        }, function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {

        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {
            "label" : jsonObj[i].label,
            "data" : jsonObj[i].guid,
            "children" : jsonObj[i].children,
            "classes" : jsonObj[i].classes,
          };
          jsonObj[i] = newItem;
        }
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = [];

        // for문으로 다시 json 구조로 변환함.
        angular.forEach(vm.lists, function(item) {
          var data = {};

          data.label = $translate.instant(item.CodeValue);
          data.guid = item.CommonCodeId;
          data.parent = item.ParentCommonCodeId == undefined || item.ParentCommonCodeId == 0 || item.CodeLevel == vm.topItem.CodeLevel ? null : item.ParentCommonCodeId;

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);
        });

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
        $timeout(function() {
          return tree.expand_init();
        }, 1);

      }

      // 트리 목록에서 조회값
      $scope.my_tree_handler = function(branch) {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId && vm.srch.MeetingRoom != item.CodeValue01) {
            vm.srch.MeetingRoom = item.CodeValue01;
            vm.reserveYN = item.CodeValue02;
//            getUploadFileList('commoncode', item.CommonCodeId);
            getSearch();
            return;
          }
        });
      };

      // 휴대폰 validation 체크
      function fnTelMobileNoCheck(telNo) {
        var errMsg = "입력된 번호 형식이 잘못되었습니다.<br/ >휴대폰 번호는 000-0000-0000 형식으로<br />입력해 주세요.";
        var result = false;
        var regExp = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/;

        if (telNo == "") {
          gAlert('', errMsg);
          return false;
        } else if (telNo.length < 10 || telNo.length > 14) {
          gAlert('', errMsg);
          return false;
        }

        result = regExp.test(telNo);

        if (!result)
          gAlert('', errMsg);

        return result;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList(type, commonCodeId) {
        var data = vm.srch;
        if (type == 'commoncode') {
          data.mapCode = 'FileAttach.getFileList';
          data.TableId = commonCodeId;
          data.tableNm = "commoncode";
        } else {
          data.mapCode = 'FileAttach.getMeetRoomFileList';
        }

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {
              var innerHtml = "";
              var innerHtml2 = "";
              var uploadFileList = [];
              // 첨부파일 목록 설정
              vm.uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id : item.fileId,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                };

                uploadFileList.push(obj);

                // 동적으로 회의실 사진 생성
                innerHtml += '<div class="selector"><img ng-src="' + obj.link + '" ng-click="vc.openRoomImgModal(' + '\'' + obj.link + '\'' + ')"></div>';
                // 컨트롤러에서 동적으로 생성한 html에 ng-click같은 이벤트를 사용할때는 컴파일을 해줘야함
                innerHtml2 = $compile(innerHtml)($scope);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

              // 초기화
              $(".roomImgList").html("");
              $(".roomImgList").append(innerHtml2);

              // slick 초기화
              destroyCarousel();
              // slick 설정
              slickCarousel();

              // 회의실 사진이 없을때는 회의실 사진 height 0
              if (vm.uploadFileList.length == 0) {
                $("#topDiv").css("height", "367px");
                $("#bottomDiv").css("height", "0px");
              }
              else {
                $("#topDiv").css("height", "270px");
                $("#bottomDiv").css("height", "97px");
              }
            //}
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      // slick 설정
      function slickCarousel() {
        $('.roomImgList').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
        });
      }

      // slick 초기화
      function destroyCarousel() {
        $('.roomImgList').removeClass("slick-initialized slick-slider");
      }

      function openRoomImgModal(imageUrl) {
        var modalInstance = modalWindow.open('md', 'reserve/meeting-roomimage-modal.html', 'MeetingRoomimageModalCtrl as vc', imageUrl);
        modalInstance.result.then(function(result) {
        });
      }

      getMeetingRole();
      getTreeList();
      //getMeetingRoleId();

    } ]);

webapp.controller('MeetingDetailModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function MeetingDetailModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;

      vm.srch = {
		    ReserveId : ''
      };

      vm.data = toModalData;

      if (vm.data.str != undefined) {
        vm.data.ReserveTime = vm.data.str;
      }

      if (vm.data.Status != undefined) {
        vm.data.ApprYN = vm.data.Status;
      }

      (function MeetingDetailModalCtrl() {
      })();

      function cancel() {
        $uibModalInstance.dismiss('cancel');
      }
    } ]);

webapp.controller('MeetingDetail2Ctrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', '$filter', 'GLOBAL_CONSTANT', 'modalFactory',
    'MeetingRoomAPISrv', 'gAlert', 'gConfirm',
    function MeetingDetailCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, $filter, CONSTANT, modalWindow, api, gAlert, gConfirm) {
      var vm = this;

      vm.getList = getList;
      vm.saveDetail = saveDetail;
      vm.goCalendar = goCalendar;
      vm.getDetail = getDetail;
      vm.tmCalDt = $rootScope.getDateFormat($stateParams.target);

      vm.DataDelete = DataDelete;
      vm.DataDeleteAction = DataDeleteAction;
      vm.loginUserName = ($window.sessionStorage['loginUserName'] !== null) ? $window.sessionStorage['loginUserName'] : '';

      vm.MeetingRoom = $stateParams.room;
      vm.strToday = moment(new Date()).format('YYYY-MM-DD');

      vm.checkTime = checkTime;

      vm.srch = {
        CalDt : '',
      }

      vm.data = {};

      function DataDelete(ReserveId) {
        gConfirm('', '삭제하시겠습니까?', {
          btn : '',
          fn : function() {
            DataDeleteAction(ReserveId);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function DataDeleteAction(ReserveId) {
        var srch = {'ReserveId' : ReserveId};
        var prms = api.doReservDelete().post(srch).$promise;
        prms.then(

        function(data) {
          vm.dataloader = false;

          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            $rootScope.showSimpleToast('삭제되었습니다.', '#toastContainer');
            getList();
          }
        },
        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

      }

      /* 예약된 시간 가져오기 */
      function getList() {
        vm.timeList = [
          { str : '09:00~10:00', strTime : '09' },
          { str : '10:00~11:00', strTime : '10' },
          { str : '11:00~12:00', strTime : '11' },
          { str : '12:00~13:00', strTime : '12' },
          { str : '13:00~14:00', strTime : '13' },
          { str : '14:00~15:00', strTime : '14' },
          { str : '15:00~16:00', strTime : '15' },
          { str : '16:00~17:00', strTime : '16' },
          { str : '17:00~18:00', strTime : '17' },
          { str : '18:00~19:00', strTime : '18' },
          { str : '19:00~20:00', strTime : '19' },
          { str : '20:00~21:00', strTime : '20' },
          { str : '21:00~22:00', strTime : '21' },
          { str : '22:00~23:00', strTime : '22' },
          { str : '23:00~24:00', strTime : '23' },
        ]

        vm.dataloader = true;
        var srch = {
          CalDt : moment(vm.tmCalDt).format('YYYY-MM-DD'),
          MeetingRoom : vm.MeetingRoom
        };
        var prms = api.doReservData().post(srch).$promise;
        prms.then(

        function(data) {
          vm.dataloader = false;

          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.reservLists = data.responseVO.body.docs;
            angular.forEach(vm.timeList, function(timeItem) {
              angular.forEach(vm.reservLists, function(item) {
                if (timeItem.strTime == item.ReserveTime) {
                  timeItem.Company = item.Company;
                  timeItem.Comment = item.Comment;
                  timeItem.Mobile = item.Mobile;
                  timeItem.TelNo = item.TelNo;
                  timeItem.RegUser = item.RegUser;
                  timeItem.UserNm = item.UserNm;
                  timeItem.ReserveId = item.ReserveId;
                  timeItem.Reserved = 'Y';
                }
              });
            });
          }
        },
        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      function checkTime(index) {
        if($("input[name='ch']:checked").length > 3){

          alert('3시간 이하로 예약해 주세요');
          $("#"+index).attr("checked",false);
          return false;
        }
      }

      function saveDetail() {
        var data = { dataArr : [] };
        angular.forEach(vm.timeList, function(timeItem) {
          if (timeItem.Reserv != null && timeItem.Reserv == 'Y') {
            data.dataArr.push(timeItem.strTime);
          }
        });

        if (data.dataArr.length == 0) {
          gAlert('', '선택된 예약시간이 없습니다.', {
            btn : '',
            fn : function() {
            }
          });
          return;
        }

        if(!$scope.form1.$valid) {
          return false;
        }

        if (typeof(vm.data.Company) == "undefined" || vm.data.Company == "") {
          gAlert('', '소속지점을 입력하세요.');
          return;
        }

        if (typeof(vm.data.Mobile) == "undefined" || vm.data.Mobile == "") {
          gAlert('', '핸드폰을 입력하세요.');
          return;
        }

        if (typeof(vm.data.Comment) == "undefined" || vm.data.Comment == "") {
          gAlert('', '이용목적을 입력하세요.');
          return;
        }

        vm.data.ReserverTime = data.dataArr;
        vm.data.CalDt = moment.utc(vm.tmCalDt,'yyyy-MM-dd');
        vm.data.MeetingRoom = vm.MeetingRoom;

        var prms = api.doInsertDetail().post(vm.data).$promise;

        prms.then(function(data) {
          vm.dataloader = false;

          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docCnt > 0) {
              vm.res = data.responseVO.body.docs;
              gAlert('', '예약되었습니다.');
              getList();
            } else {
              gAlert('', '예약되지 않았습니다.');
            }
          }
        }, function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

      }

      function goCalendar() {
        var srch = { MeetingRoom : vm.MeetingRoom};
        $state.go('reserve.meeting-room', {
          srch : encodeURIComponent(JSON.stringify(srch))
        });
      }


      function getDetail(date) {
        $state.go('reserve.meeting-detail', {
          //target : date,
          //room : vm.srch.MeetingRoom,
          target : date,
          room : '10',
          srch : encodeURIComponent(JSON.stringify(vm.srch))
        });
      }


      getList();

    } ]);

webapp.service('MeetingRoomAPISrv', [ '$resource', 'StaticVariable', '$rootScope', function MeetingRoomAPISrv($resource, StaticVariable, $rootScope) {
  var api = {
    doList : function() {
      return $resource(StaticVariable.getUrl('/select/Calendar.getCalendarList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doYearsList : function() {
      return $resource(StaticVariable.getUrl('/select/Calendar.getYearsList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doTimeList : function() {
      return $resource(StaticVariable.getUrl('/select/Calendar.getTimeList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doInsertDetail : function() {
      return $resource(StaticVariable.getUrl('/insert/Calendar.insertDetail/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doReservData : function() {
      return $resource(StaticVariable.getUrl('/select/Calendar.getTimeList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doReservDelete : function() {
      return $resource(StaticVariable.getUrl('/select/Calendar.updateDelete/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    getMeetingRoomList : function() {
      return $resource(StaticVariable.getUrl('/select/Calendar.getMeetingRoomList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    getReserveCnt : function() {
      return $resource(StaticVariable.getUrl('/select/Calendar.getReserveCnt/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doMeetingRoleId: function() {
      return $resource(StaticVariable.getUrl('/select/MeetingroomRole.getMeetingRoleId/action.json'), {userkey:$rootScope.gVariable.userKey},StaticVariable.getRequestActions.defaultAction());
    },
    doMeetingRoleDetail: function() {
      return $resource(StaticVariable.getUrl('/select/MeetingroomRole.getMeetingRoleDetail/action.json'), {userkey:$rootScope.gVariable.userKey},StaticVariable.getRequestActions.defaultAction());
    },
    doInsertMeetingRoleDetail: function() {
      return $resource(StaticVariable.getUrl('/insert/MeetingroomRole.insertMeetingRoleDetail/action.json'), {userkey:$rootScope.gVariable.userKey},StaticVariable.getRequestActions.defaultAction());
    },
    doUpdateMeetingRoleDetail: function() {
      return $resource(StaticVariable.getUrl('/update/MeetingroomRole.updateMeetingRoleDetail/action.json'), {userkey:$rootScope.gVariable.userKey},StaticVariable.getRequestActions.defaultAction());
    }
  };
  return api;
} ]);

webapp.controller('MeetingRoomCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', '$filter', '$interval', '$compile', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm', 'Auth', 'StaticVariable',
    function MeetingRoomCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, $filter, $interval, $compile, CONSTANT, modalWindow, postApi, gAlert, gConfirm, Auth, StaticVariable) {
     // View Model
      var vm = this;

      vm.save = save;
      vm.status = status;
      vm.srch = {};
      vm.setToday = setToday;

      if ($stateParams.srch != null && $stateParams.srch != '') {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      var today = new Date();

      if (vm.srch.TargetYear == null) {
        vm.srch.TargetYear = moment(today).format('YYYY');
      }

      if (vm.srch.TargetMonth == null) {
        vm.srch.TargetMonth = moment(today).format('MM');
      }

      vm.srch.TargetDay = moment(today).format('DD');

      vm.data = {};
      vm.getList = getList;
      vm.getSearch = getSearch;
      vm.getReservData = getReservData;
      vm.resetSearch = resetSearch;
      vm.saveData = saveData;
      vm.getYearsList = getYearsList;
      vm.getDetail = getDetail;
      vm.getDetail2 = getDetail2;
      vm.myReserveList = myReserveList;
      vm.checkUsed = checkUsed;

      vm.totalMonth = 12;
      vm.calDtList = [];
      vm.strToday = moment(today).format('YYYY-MM-DD');
      vm.CalDt = vm.srch.CalDt? vm.srch.CalDt : vm.strToday;

      vm.data2 = {};

      if(window.outerWidth < 600) {
        vm.monthlyReserve="월별 예약";
      }else {
        vm.monthlyReserve="월별예약 현황";
      }

      $(window).resize(function ($scope) {
        var widN = this.outerWidth;
        if(widN < 600) {
          this.angular.element('.monthR').text('월별 예약');
        }else {
          this.angular.element('.monthR').text('월별예약 현황');
        }
      });

      function getSearch() {
        $state.go('reserve.meeting-room', {
          srch : encodeURIComponent(JSON.stringify(vm.srch))
        }, {reload: 'reserve.meeting-room'});
      }

      function resetSearch() {
        $state.go('reserve.meeting-room', {
          srch : ''
        }, {reload: 'reserve.meeting-room'});
      }

      function setToday() {
        var today = new Date();
        vm.srch.TargetYear = moment(today).format('YYYY');
        vm.srch.TargetMonth = moment(today).format('MM');

        getSearch();
      }

      function getList() {
        vm.srch.TargetDate = vm.srch.TargetYear +'-'+vm.srch.TargetMonth+'-01';
        vm.dataloader = true;

        var data = vm.srch;
        data.selectType = 'List';
        data.mapCode = 'Calendar.getCalendarList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.lists = result.body.docs;
            vm.lists2 = [];

            var weeklyItem = {};
            var i = 0;
            angular.forEach(vm.data.lists, function(item) {
              if (item.CalDt == vm.strToday) {
                item.isToday = 'Y';
              }

              switch (item.Day) {
              case 1:
                weeklyItem = {};
                weeklyItem.Sun = parseInt(item.Date);
                weeklyItem.SunIndex = i;
                break;
              case 2:
                weeklyItem.Mon = parseInt(item.Date);
                weeklyItem.MonIndex = i;
                break;
              case 3:
                weeklyItem.Tue = parseInt(item.Date);
                weeklyItem.TueIndex = i;
                break;
              case 4:
                weeklyItem.Wed = parseInt(item.Date);
                weeklyItem.WedIndex = i;
                break;
              case 5:
                weeklyItem.Thu = parseInt(item.Date);
                weeklyItem.ThuIndex = i;
                break;
              case 6:
                weeklyItem.Fri = parseInt(item.Date);
                weeklyItem.FriIndex = i;
                break;
              case 7:
                weeklyItem.Sat = parseInt(item.Date);
                weeklyItem.SatIndex = i;
                vm.lists2.push(weeklyItem);
                weeklyItem = null;
                break;
              }
              i++;
            });
            if (weeklyItem != null)
              vm.lists2.push(weeklyItem);

            vm.data.TargetYear = vm.srch.TargetYear;

            getReservData();
            getReservData(vm.CalDt);
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> h0102-list-ctrl> getList()', status, error);
          vm.dataloader = false;
        });

        getUploadFileList();
      }

      function getReservData(CalDt) {
        if (!vm.srch.MeetingRoom) {
          return;
        }

        if (CalDt) {
          vm.CalDt = CalDt;
        }

        var data = angular.copy(vm.srch);
        data.CalDt = CalDt;
        data.selectType = 'List'; // For CustomColumn
        data.mapCode = 'Calendar.getTimeList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (CalDt) {
              vm.calDtList = [];
              angular.forEach(result.body.docs, function(item) {
                var i = item.ReserveTime;
                var j = i;
                var k;
                if (item.ReserveTime < 10) {
                    j = i;
                    k = parseInt(i) + 1;
                    if (k < 10) k = "0" + k;
                }
                else k = parseInt(i) + 1;

                item.str = j + ':00~' + k + ':00';
                vm.calDtList.push(item);
              });
            }

            var reservLists = result.body.docs;
            angular.forEach(vm.data.lists, function(dateItem) {
              if (!CalDt || CalDt == dateItem.CalDt) {
                dateItem.timeList = [];
              }

              angular.forEach(reservLists, function(item) {
                if (item.CalDt == dateItem.CalDt) {
                  dateItem.timeList.push(item);
                }
              });
            });
          }
        }, function(error) {
          console.error('Error> h0102-list-ctrl> getList()', status, error);
        });
      }

      function getYearsList() {
        vm.dataLoader = true;

        var data = {};
        data.selectType = 'List'; // For CustomColumn
        data.mapCode = 'Calendar.getYearsList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docCnt > 0) {
              vm.yearsList = result.body.docs;

              if (parseInt(vm.yearsList[vm.yearsList.length - 1].TargetYear) < (new Date()).getFullYear() + 1) {
                vm.yearsList.push({TargetYear:(new Date()).getFullYear() + 1});
              }
            } else {
              vm.yearsList = [{TargetYear:(new Date()).getFullYear()}, {TargetYear:(new Date()).getFullYear() + 1}];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> h0102-list-ctrl> getList()', status, error);
          vm.dataloader = false;
        });
      }

      function saveData() {
        vm.dataLoader = true;

        var prms = api.doUpdateDetailBatch().post(vm.data).$promise;

        prms.then(function(data) {
          vm.dataloader = false;
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', '저장되었습니다', {
              btn : '',
              fn : function() {
              }
            });
          }
        },
        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      function getDetail(date) {
        vm.srch.CalDt = date;

        // var d = new Date();
        // var d2 = new Date(date);
        // vm.oriDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0);
        // vm.clkDate = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate(), 0, 0, 0);
        // vm.diff = Math.round((vm.clkDate.getTime() - vm.oriDate.getTime()) / (1000*60*60*24));
        //
        // if (vm.diff < 0) {
        //   gAlert("현재일 기준 이전일은 예약할 수 없습니다.");
        //   return false;
        // } else {
        //   if (parseInt(vm.data2.RESERVEPERMIT) < vm.diff) {
        //     gAlert("해당일은 예약 가능 기간 범위가 아닙니다.\n현재일 기준으로 " + vm.data2.RESERVEPERMIT + "일 이내만 예약이 가능합니다.");
        //     return false;
        //   }

          $state.go('reserve.meeting-detail.meeting-daily', {
            srch : encodeURIComponent(JSON.stringify(vm.srch))
          });
        // }
      }

      function getDetail2(date) {
        $state.go('reserve.meeting-detail2', {
          target : date,
          room : vm.srch.MeetingRoom,
          srch : encodeURIComponent(JSON.stringify(vm.srch))
        });
      }

      function myReserveList() {
        var srch = {MeetingRoom:vm.srch.MeetingRoom};
        $state.go('reserve.my-reserve-list', {srch:encodeURIComponent(JSON.stringify(srch))});
      }

      function save() {
        var res = '';
        var ctrl = 'MeetingSaveModalCtrl as vc';
        var paramData = {room:vm.srch.MeetingRoom};
        var modalInstance = modalWindow.open('dialog', 'views/modal/meeting-save-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
        }, function(cancelData) {
        });
      }

      function status() {
        var res = '';
        var ctrl = 'MeetingStatusModalCtrl as vc';
        var paramData = {};
        var modalInstance = modalWindow.open('dialog', 'views/modal/meeting-status-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
        }, function(cancelData) {
        });
      }

      vm.getDateClass = function(index) {
        if (vm.data.lists == null || vm.data.lists[index] == null)
          return '';

        if (vm.srch.TargetMonth != vm.data.lists[index].Month) {
          return 'gray';
        }

        if (vm.data.lists[index].isToday == 'Y')
          return 'today';
        else if (vm.data.lists[index].HolidayYN == 'Y')
          return 'text-danger';

        return '';
      };

      vm.getDateCellClass = function(CalDt) {
        if (vm.CalDt != CalDt)
          return '';

        return 'bd-b2';
      };


      function getMeetingRoleId() {

        var data = vm.srch;
        data.selectType = 'List'; // For CustomColumn
        data.mapCode = 'MeetingroomRole.getMeetingRoleId';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0] !== undefined) {
              vm.data.meetingRoleId = result.body.docs[0].MeetingRoleId;
              getMeetingRole();
              return;
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> h0102-list-ctrl> getList()', status, error);
          vm.dataloader = false;
        });
      }

      /* function getMeetingRole() {
        var data = vm.data;
        data.selectType = 'Detail'; // For CustomColumn
        data.mapCode = 'MeetingroomRole.getMeetingRoleDetail';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.data2 = result.body.docs[0];
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> h0102-list-ctrl> getList()', status, error);
          vm.dataloader = false;
        });
      } */

      function getMeetingRole() {
        var srch = {};
        srch.CodeType = 'SALEMEET';
        srch.mapCode = 'CommonProperties.getCommonPropertiesList';
        postApi.select(srch, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0] !== undefined) {
              angular.forEach(result.body.docs, function(item) {
                if (item.Code == 'reserve.dailymaxtime') {
                  vm.data2.DAILYMAXTIME = parseInt(item.CodeValue);
                } else if (item.Code == 'reserve.reserveperm') {
                  vm.data2.RESERVEPERMIT = parseInt(item.CodeValue);
                }
              });
            }
          }
        }, function(error) {
          console.error('Error> getMeetingRole()', error);
          vm.dataloader = false;
        });
      }

      function checkUsed(ReserveId) {
        if (!Auth.userHasPermission('app.reserve.reserve-list:button01')) {
          gAlert('', '회의실계정으로만 사용가능합니다.', {
            btn : '',
            fn : function() {
            }
          });
          return;
        }

        var data = {ReserveId: ReserveId};

        gConfirm('', '사용하시겠습니까?', {
          btn : '',
          fn : function() {
            data.mapCode = 'Calendar.checkUsed';
            postApi.update(data, function(result){
              vm.dataloader = false;
              $rootScope.showSimpleToast('사용되었습니다.', '#toastContainer');
              getReservData(vm.CalDt);
            }, function(error) {
              console.error('Error> checkUsed()', error);
              vm.dataloader = false;
            });
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      var interval = null;

      // stops the interval
      $scope.$on("$destroy", function() {
        console.log('$scope.on $destroy');
        $interval.cancel(interval);
        interval = null;
      });

      function execInterval() {
        getReservData(vm.CalDt);
      }

      if (interval == null) {
        interval = $interval(execInterval, 10000);
      }

      function getUploadFileList() {
        var data = vm.srch;
        data.mapCode = 'FileAttach.getMeetRoomFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {
              var innerHtml = "";
              var innerHtml2 = "";
              var uploadFileList = [];
              // 첨부파일 목록 설정
              vm.uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id : item.fileId,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                };

                uploadFileList.push(obj);

                // 동적으로 회의실 사진 생성
                innerHtml += '<div class="selector"><img ng-src="' + obj.link + '" ng-click="vc.openRoomImgModal(' + '\'' + obj.link + '\'' + ')"></div>';
                // 컨트롤러에서 동적으로 생성한 html에 ng-click같은 이벤트를 사용할때는 컴파일을 해줘야함
                innerHtml2 = $compile(innerHtml)($scope);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

              // 초기화
              $(".roomImgList").html("");
              $(".roomImgList").append(innerHtml2);

              // slick 초기화
              destroyCarousel();
              // slick 설정
              slickCarousel();

              // 회의실 사진이 없을때는 회의실 사진 height 0
              if (vm.uploadFileList.length == 0) {
                $("#topDiv").css("height", "547px");
                $("#bottomDiv").css("height", "0px");
              }
              else {
                $("#topDiv").css("height", "450px");
                $("#bottomDiv").css("height", "97px");
              }
            //}
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      // slick 설정
      function slickCarousel() {
        $('.roomImgList').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
        });
      }

      // slick 초기화
      function destroyCarousel() {
        $('.roomImgList').removeClass("slick-initialized slick-slider");
      }

      function openRoomImgModal(imageUrl) {
        var modalInstance = modalWindow.open('md', 'reserve/meeting-roomimage-modal.html', 'MeetingRoomimageModalCtrl as vc', imageUrl);
        modalInstance.result.then(function(result) {
        });
      }

      getList();
      getYearsList();
      getMeetingRole();
      //getMeetingRoleId();
    }, ]);

webapp.controller('MeetingRoomimageModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'StaticVariable', 'GLOBAL_CONSTANT', 'postApi',
    function MeetingRoomimageModalCtrl($window, $scope, $uibModalInstance, toModalData, StaticVariable, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;

      vm.data = toModalData;

      (function MeetingRoomimageModalCtrl() {
      })();

      function cancel(item) {
        $uibModalInstance.dismiss('cancel');
      }

    } ]);

webapp.controller('MyReserveListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', '$filter', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm',
    function MyReserveListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, $filter, CONSTANT, modalWindow, postApi, gAlert, gConfirm) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      if(window.outerWidth < 600) {
        vm.monthlyReserve="월별 예약";
      }else {
        vm.monthlyReserve="월별예약 현황";
      }

      $(window).resize(function ($scope) {
        var widN = this.outerWidth;
        if(widN < 600) {
          this.angular.element('.monthR').text('월별 예약');
        }else {
          this.angular.element('.monthR').text('월별예약 현황');
        }
      });

      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'reserve',
          sortDirect : '',
          sortColumn : '',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'reserve';
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
        vm.currentPage = vm.srch.page;
      }

      vm.listSize = [ 10, 25, 50, 100 ];

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.anchor = "";
      vm.reloadSeq = 0;

      // 전역상수 선언
      vm.viewSize = vm.srch.viewSize;
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;

      /* Sorting Methods */
      function tablesort(sortkey, sortable){
        if (sortable == 'N') return;

        if (vm.srch.sortColumn != sortkey) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortkey;
        getSearch();
      }

      function sortClass(sortkey){
        if (sortkey != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      function getListCnt(gubun) {
        var data = angular.copy(vm.srch);
        data.mapCode = 'Calendar.getReserveCount2';
        data.NowStartTime = "";
        data.NowEndTime = "";
        data.DelYN = "";
        data.Gubun = "";
        data.MeetingRoom = null;

        var d = new Date();
        var time = d.getHours();
        var month = d.getMonth() + 1;
        var today = d.getFullYear() + "-" + month + "-" + d.getDate();

        if (gubun == "all") {
          vm.srch.gubun = "all";
          data.DelYN = "N";
        }
        else if (gubun == "ing") {
          data.Gubun = "ing";
          data.Today = today;
          data.NowStartTime = time;
          data.DelYN = "N";
          vm.srch.gubun = "ing";
        }
        else if (gubun == "end") {
          data.Gubun = "end";
          data.Today = today;
          data.NowEndTime = time;
          data.DelYN = "N";
          vm.srch.gubun = "end";
        }
        else if (gubun == "cancel") {
          data.DelYN = "Y";
          vm.srch.gubun = "cancel";
        }

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        }, function(error) {
          console.error('Error> getListCnt', status, error);
        });
      }

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getList(gubun, init) {
        console.log('getList(',gubun,',',init,')');
        vm.dataloader = true;
        vm.viewSize = vm.srch.viewSize;

        setMenuColor(gubun);

        if (init != "") {
          vm.currentPage = 1;
          vm.srch.page = 1;
        }

        getReserveGubunCnt();

        if (gubun == "all") { getListCnt("all"); }
        else if (gubun == "ing") { getListCnt("ing"); }
        if (gubun == "end") { getListCnt("end"); }
        if (gubun == "cancel") { getListCnt("cancel"); }

        var data = angular.copy(vm.srch);
        data.selectType = 'List'; // For CustomColumn
        data.mapCode = 'Calendar.getReserveList2';
        data.NowStartTime = "";
        data.NowEndTime = "";
        data.DelYN = "";
        data.Gubun = "";
        data.MeetingRoom = null;

        var d = new Date();
        var time = d.getHours();
        var month = d.getMonth() + 1;
        var today = d.getFullYear() + "-" + month + "-" + d.getDate();

        if (gubun == "all") {
          data.DelYN = "N";
        } else if (gubun == "ing") {
          data.Gubun = "ing";
          data.Today = today;
          data.NowStartTime = time;
          data.DelYN = "N";
        } else if (gubun == "end") {
          data.Gubun = "end";
          data.Today = today;
          data.NowEndTime = time;
          data.DelYN = "N";
        }
        else if (gubun == "cancel") {
          data.DelYN = "Y";
        }

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
            } else {
              vm.lists = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> getList', status, error);
          vm.dataloader = false;
        });
      }

      /**
       * 전체, 이용예정, 이용완료, 취소 카운트 조회
       *
       * @param
       * @return
       * @author 김진혁
       */
      function getReserveGubunCnt() {
        var data = angular.copy(vm.srch);
        data.MeetingRoom = null;
        data.mapCode = 'Calendar.getReserveGubunCnt';

        var d = new Date();
        var month = d.getMonth() + 1;
        var today = d.getFullYear() + "-" + month + "-" + d.getDate();
        data.NowTime = d.getHours();
        data.Today = today;

        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.reserveAllCnt = result.body.docs[0].ReserveAllCnt;
              vm.reserveIngCnt = result.body.docs[0].ReserveIngCnt;
              vm.reserveEndCnt = result.body.docs[0].ReserveEndCnt;
              vm.reserveCancelCnt = result.body.docs[0].ReserveCancelCnt;
            } else {
              gAlert('', 'Menu.NODATA');
            }
          }
        }, function(error) {
          console.error('fail', status, error);
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      function setResponsive(dockMode) {
        var rows =  vm.lists;
        var columns = [];
        var o = {};
        o.breakpoints = ["", "md","lg", "md","xs", "lg", "xs", "md", "lg"];
        //o.formatString = [""];
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function(item) {
          var column = {};
          column.name = item.ColumnPhysicalNm;
          column.title = item.ColumnLogicalNm;
          if(o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }
          if(item.ColumnPhysicalDataType == "40") {
            column.type = "date";
            column.formatString="YYYY-MM-DD";
          }
          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 번호 변경시 데이터 조회 함수 호출
       * @param
       * @return
       * @author 최원영
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go('reserve.my-reserve-list', {srch:srch}, {reload:'reserve.my-reserve-list'});
      }

      function changeViewSize() {
        vm.currentPage = 1;
        vm.viewSize = vm.srch.viewSize;
        getSearch();
      }

      function getSearch() {
        vm.srch.page = 1;
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go('reserve.my-reserve-list', {srch:srch}, {reload:'reserve.my-reserve-list'});
      }

      function viewDetail(li) {
        var modalInstance = modalWindow.open('md', 'reserve/meeting-detail-modal.html', 'MeetingDetailModalCtrl as vc', li);
        modalInstance.result.then(function(result) {
        });
      }

      function setMenuColor(gubun) {
        if (gubun == "all"){
          $("#menu1").addClass("menuActive");
          $("#menu2").removeClass("menuActive");
          $("#menu3").removeClass("menuActive");
          $("#menu4").removeClass("menuActive");
        }
        else if (gubun == "ing") {
          $("#menu2").addClass("menuActive");
          $("#menu1").removeClass("menuActive");
          $("#menu3").removeClass("menuActive");
          $("#menu4").removeClass("menuActive");
        }
        else if (gubun == "end") {
          $("#menu3").addClass("menuActive");
          $("#menu1").removeClass("menuActive");
          $("#menu2").removeClass("menuActive");
          $("#menu4").removeClass("menuActive");
        }
        else if (gubun == "cancel") {
          $("#menu4").addClass("menuActive");
          $("#menu1").removeClass("menuActive");
          $("#menu2").removeClass("menuActive");
          $("#menu3").removeClass("menuActive");
        }
      }

      vm.openMeetingRoom = function() {
        $state.go('reserve.meeting-room', {
          srch : ''
        });
      };

      vm.openMeetingDetail = function() {
        $state.go('reserve.meeting-detail.meeting-daily', {
          srch : ''
        });
      };

      function resetSearch() {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'reserve',
          sortDirect : '',
          sortColumn : '',
          gubun : vm.srch.gubun,
        };

        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go('reserve.my-reserve-list', {srch:srch}, {reload:'reserve.my-reserve-list'});
      }

      function getDetail() {
        var today = new Date();
        var strToday = moment(today).format('YYYY-MM-DD');
        var srch = {CalDt : strToday};
        var json = {MeetingRoom : vm.srch.MeetingRoom};
        var srch2 = angular.merge({}, srch, json);

        $state.go('reserve.meeting-detail.meeting-daily', {
          srch : encodeURIComponent(JSON.stringify(srch2))
        });
      }

      function goMain() {
        var json = {MeetingRoom : vm.srch.MeetingRoom};

        $state.go($rootScope.gVariable.mainPage, {
          srch : encodeURIComponent(JSON.stringify(json))
        });
      }

      function goCalendar() {
        var srch = { MeetingRoom : vm.srch.MeetingRoom};
        $state.go('reserve.meeting-room', {
          srch : encodeURIComponent(JSON.stringify(srch))
        });
      }

      // 함수 선언
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.changeViewSize = changeViewSize;
      vm.sortClass = sortClass;
      vm.tablesort = tablesort;
      vm.getSearch = getSearch;
      vm.viewDetail = viewDetail;
      vm.resetSearch = resetSearch;
      vm.getDetail = getDetail;
      vm.goMain = goMain;
      vm.goCalendar = goCalendar;

      // 전체, 이용예정, 이용완료, 취소 카운트 조회
      getReserveGubunCnt();
      // 데이터 조회
      if (vm.srch.gubun == undefined || vm.srch.gubun == "all") { getList("all", ""); }
      else if (vm.srch.gubun == "ing") { getList("ing", ""); }
      else if (vm.srch.gubun == "end") { getList("end", ""); }
      else if (vm.srch.gubun == "cancel") { getList("cancel", ""); }

    }, ]);

(function() {
  "use strict";
  ReserveController.$inject = ['$window',
  '$scope',
  '$location',
  '$state',
  '$stateParams',
  '$rootScope',
  '$translate',
  'GLOBAL_CONSTANT',
  'gAlert',
  'LoginAPISrv',
  'StaticVariable',
  '$interval',
  'Auth',
  'toastr', 'toastrConfig', '$timeout', 'modalFactory'];

  /** @ngInject */
  function ReserveController($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, gAlert, loginApi, StaticVariable, $interval, Auth, toastr, toastrConfig, $timeout, modalFactory) {
    var vm = this;

    vm.srch = {};
    vm.logoClick = logoClick;
    vm.isLoginUser = isLoginUser;
    vm.isLoginAdmin = isLoginAdmin;
    vm.doLogout2 = doLogout2;
    vm.doUserInfo2 = doUserInfo2;
    vm.goLogin = goLogin;
    vm.goManager = goManager;
    vm.doCheckSession = doCheckSession;
    vm.myPage = myPage;
    vm.myReservation = myReservation;
    vm.bbspost = bbspost;

    function logoClick() {
      if ($window.sessionStorage['isLoggedIn'] === 'Y')
        $state.go("reserve.meeting-room");
      else
        $state.go("reserve.login");
    }

    function isLoginUser() {
      return $window.sessionStorage['isLoggedIn'] === 'Y' && $window.sessionStorage['isLoggedIn'] !== undefined && $window.sessionStorage['loginUserId'].indexOf('@com') > -1;
    }

    function isLoginAdmin() {
      return $window.sessionStorage['isLoggedIn'] === 'Y' && $window.sessionStorage['isLoggedIn'] !== undefined && $window.sessionStorage['loginUserId'].indexOf('@com') == -1;
    }

    function doLogout2() {
      $window.sessionStorage.removeItem('isLoggedIn');
      $window.sessionStorage.removeItem('loginUserId');
      $window.sessionStorage.removeItem('loginUserName');
      $window.sessionStorage.removeItem('loginUserType');
      $window.sessionStorage.removeItem('loginSysAdminYN');
      $window.sessionStorage.removeItem('loginTenantId');
      $window.sessionStorage.removeItem('loginTenantName');
      $window.sessionStorage['app'] = 'reserve';

      var prms = loginApi.doLogout().post().$promise;

      prms.then(function(json) {
        gAlert('', 'Menu.SIGNEDOUT', {
          btn : '',
          fn : function() {
            $state.go('salemeet');
          }
        });
      }, function(error) {
        console.error('fail', status);
      });
    }

    function goLogin() {
      $window.sessionStorage['app'] = '';
      $state.go('login');
    }

    function doUserInfo2() {
      $state.go('reserve.reserve-user-myinfo-before');
    }

    function goManager() {
      $state.go('app.system.user-list', {srch:''});
    }

    function doCheckSession() {
      var prms = loginApi.doCheckSession().post().$promise;

      prms.then(function(json) {
        if (json.responseVO.header.status == CONSTANT.HttpStatus.OK && json.responseVO.body.docs != null && json.responseVO.body.docs != '') {
          $rootScope.setUserSession(json.responseVO.body.docs[0]);

          Auth.init(json.responseVO.body.docs[0].permissions);

          vm.userNm = $window.sessionStorage['loginUserName'];
          vm.userGbn = $window.sessionStorage['loginUserGbn'];
          vm.userTerm = $window.sessionStorage['loginUserTerm'];

        } else {
          StaticVariable.sessionExpire();
        }
        // gAlert("로그아웃 되었습니다.");
      }, function(error) {
        console.error('fail', status);
      });
    }

    /**
     * 내정보 수정 팝업 호출
     *
     */
    function myPage() {
      var ctrl = 'MyPageModalCtrl as modalCtrl';
      var paramData = {UserId : $rootScope.gVariable.UserId, TenantId: $window.sessionStorage["loginTenantId"]};
      var modalInstance = modalFactory.open("lg", "components/modal/mypage/mypage-modal.html", ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          //성공
        },
        function (cancelData) {
          // 취소
        }
      );
    }

    /**
     * 내 예약 페이지
     *
     */
    function myReservation() {
      $state.go('reserve.my-reserve-list', {srch:''});
    }

    function bbspost() {
      $state.go('app.bbspost.h0102-list', {srch:'', BbsMasterId:'4XYJAL1ZSS'});
    }

    doCheckSession();
  }

  webapp.component("reserve", {
    transclude: true,
    bindings: {},
    controller: ReserveController,
    controllerAs: "hc",
    templateUrl: "reserve/reserve.html"
  });
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('reserve.meeting-room', {
      url : '/meeting-room/:srch',
      templateUrl : 'reserve/meeting-room.html'
    }).state('reserve.meeting-detail', {
      url : '/meeting-detail',
      templateUrl : 'reserve/meeting-detail.html'
    }).state('reserve.meeting-detail.meeting-daily', {
      url : '/meeting-daily/:srch',
      templateUrl : 'reserve/meeting-daily.html'
    }).state('reserve.meeting-detail2', {
      url : '/meeting-detail2/:target/:room',
      templateUrl : 'reserve/meeting-detail2.html'
    }).state('reserve.my-reserve-list', {
      url : '/my-reserve-list/:srch',
      templateUrl : 'reserve/my-reserve-list.html'
    });
  }
})();

/**
 * @ngdoc function
 * @name app.basic:mng-calendar-ctrl
 * @description # 캘린더 설정
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 */
webapp.controller('MngCalendarCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', '$filter', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm',
    function MngCalendarCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, $filter, CONSTANT, modalWindow, postApi, gAlert, gConfirm) {
     // View Model
      var vm = this;

      if ($stateParams.srch == null || $stateParams.srch == '') {
        vm.srch = {
          TargetYear : String((new Date()).getFullYear()),
          TargetMonth : (new Date()).getMonth() + 1 < 10 ? '0' + String((new Date()).getMonth() + 1) : String((new Date()).getMonth() + 1),
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.data = {};
      vm.getList = getList;
      vm.saveData = saveData;
      vm.getYearsList = getYearsList;
      vm.totalMonth = 12;
      vm.targetMonth = String((new Date()).getMonth() + 1);
      vm.strToday = moment(new Date()).format('YYYY-MM-DD');
      $scope.TargetMonth = vm.srch.TargetMonth;

      vm.date = new Date();
      vm.year = vm.srch.TargetYear;
      vm.month = vm.srch.TargetMonth;
      vm.yearMonth = vm.srch.TargetYear + "년 " + vm.srch.TargetMonth + "월";

      $scope.$watch('TargetMonth', function(current) {
        vm.srch.TargetMonth = current;
        getList();
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      function getList() {
        vm.dataloader = true;

        vm.lists2 = [];
        var data = vm.srch;
        data.mapCode = 'Calendar.getCalendarList';
        postApi.select(data, function(result){
          vm.dataloader = false;

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data.lists = result.body.docs;

              var weeklyItem = {};
              angular.forEach(vm.data.lists, function(item, key) {
                if (item.CalDt == vm.strToday) {
                  item.isToday = 'Y';
                }

                switch (item.Day) {
                case 1:
                  weeklyItem = {};
                  weeklyItem.Sun = parseInt(item.Date);
                  weeklyItem.SunIndex = key;
                  break;
                case 2:
                  weeklyItem.Mon = parseInt(item.Date);
                  weeklyItem.MonIndex = key;
                  break;
                case 3:
                  weeklyItem.Tue = parseInt(item.Date);
                  weeklyItem.TueIndex = key;
                  break;
                case 4:
                  weeklyItem.Wed = parseInt(item.Date);
                  weeklyItem.WedIndex = key;
                  break;
                case 5:
                  weeklyItem.Thu = parseInt(item.Date);
                  weeklyItem.ThuIndex = key;
                  break;
                case 6:
                  weeklyItem.Fri = parseInt(item.Date);
                  weeklyItem.FriIndex = key;
                  break;
                case 7:
                  weeklyItem.Sat = parseInt(item.Date);
                  weeklyItem.SatIndex = key;
                  vm.lists2.push(weeklyItem);
                  weeklyItem = null;
                  break;
                }
              });
              if (weeklyItem != null) {
                vm.lists2.push(weeklyItem);
              }

              vm.data.TargetYear = vm.srch.TargetYear;
            }
          }
        }, function(error) {
          vm.dataloader = false;
          console.error('Error> getList> getCalendarList()', error);
        });
      }

      function getYearsList() {
        vm.dataLoader = true;

        var data = vm.srch;
        data.mapCode = 'Calendar.getYearsList';
        postApi.select(data, function(result){
          vm.dataloader = false;

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.yearsList = result.body.docs;
              if (parseInt(vm.yearsList[vm.yearsList.length - 1].TargetYear) < (new Date()).getFullYear() + 1) {
                vm.yearsList.push({TargetYear:(new Date()).getFullYear() + 1});
              }
            } else {
              vm.yearsList = [{TargetYear:(new Date()).getFullYear()}, {TargetYear:(new Date()).getFullYear() + 1}];
            }
          }
        }, function(error) {
          vm.dataloader = false;
          console.error('Error> getYearsList> getYearsList()', error);
        });
      }

      vm.getDateClass = function(index) {
        if (vm.data.lists == null || vm.data.lists[index] == null)
          return '';

        if (vm.srch.TargetMonth != vm.data.lists[index].Month) {
          return 'gray';
        }

        if (vm.data.lists[index].isToday == 'Y')
          return 'title-header today';
        else if (vm.data.lists[index].HolidayYN == 'Y')
          return 'title-header text-danger';

        return 'title-header';
      };

      function saveData() {
        vm.dataLoader = true;

        var data = vm.data;
        data.mapCode = 'Calendar.insertCalendarBatch';
        postApi.update(data, function(result){
          vm.dataloader = false;

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '저장되었습니다.', {
              btn : '',
              fn : function() {
              }
            });
          } else {
            console.error(result.body.docs[0].errMessage);
            gAlert('', '저장되지 않았습니다.', {
              btn : '',
              fn : function() {
              }
            });
          }
        }, function(error) {
          vm.dataloader = false;
          console.error('Error> saveData()', error);
        });
      }

      // 오늘 버튼을 클릭하였을 경우
      $("button.fc-today-button").on('click', function() {
        if(!$('.fc-today-button').hasClass("fc-state-disabled")) {
          var curYear = String((new Date()).getFullYear());
          var curMonth = (new Date()).getMonth() + 1 < 10 ? '0' + String((new Date()).getMonth() + 1) : String((new Date()).getMonth() + 1);

          vm.year = curYear;
          vm.month = curMonth;

          vm.yearMonth = curYear + "년 " + curMonth + "월";
          vm.srch.TargetYear = curYear;
          vm.srch.TargetMonth = curMonth;

          getList();

          $('.fc-today-button').addClass('fc-state-disabled');
        }
      });

      // 왼쪽 버튼을 클릭하였을 경우
      $("button.fc-prev-button").on('click', function() {
        vm.month = parseInt(vm.month) - 1;

        if (vm.month == 0) {
          vm.year = parseInt(vm.year) - 1;
          vm.month = 12;
        }

        vm.yearMonth = vm.year + "년 " + vm.month + "월";
        vm.srch.TargetYear = vm.year;
        vm.srch.TargetMonth = vm.month;

        getList();

        var curYear = String((new Date()).getFullYear());
        var curMonth = (new Date()).getMonth() + 1 < 10 ? '0' + String((new Date()).getMonth() + 1) : String((new Date()).getMonth() + 1);

        if (curYear == vm.year && curMonth == vm.month) {
          $('.fc-today-button').addClass('fc-state-disabled');
        }
        else {
          $('.fc-today-button').removeClass('fc-state-disabled');
        }
      });

      // 오른쪽 버튼을 클릭하였을 경우
      $("button.fc-next-button").on('click', function() {
        vm.month = parseInt(vm.month) + 1;

        if (vm.month == 13) {
          vm.year = parseInt(vm.year) + 1;
          vm.month = 1;
        }

        vm.yearMonth = vm.year + "년 " + vm.month + "월";
        vm.srch.TargetYear = vm.year;
        vm.srch.TargetMonth = vm.month;

        getList();

        var curYear = String((new Date()).getFullYear());
        var curMonth = (new Date()).getMonth() + 1 < 10 ? '0' + String((new Date()).getMonth() + 1) : String((new Date()).getMonth() + 1);

        if (curYear == vm.year && curMonth == vm.month) {
          $('.fc-today-button').addClass('fc-state-disabled');
        }
        else {
          $('.fc-today-button').removeClass('fc-state-disabled');
        }
      });

      // getYearsList();
    }, ]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.basic', {
      url : '/basic',
      template : '<div ui-view></div>'
    }).state('app.basic.mng-calendar', {
      url: '/mng-calendar/:srch',
      templateUrl: 'app/basic/mng-calendar.html',
      requiresAuthentication: true,
    });
  }
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.application', {
      url : '/application',
      template : '<div ui-view></div>'
    }).state('app.application.EAPB-list', {
      url: '/EAPB-list/:srch' ,
      templateUrl: 'app/application/EAP-business-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.application.EAPB-list.edit', {
      url: '/EAPB-edit/:srch/:keyId/:cKeyId',
      templateUrl: 'app/application/EAP-business-edit.html'
    }).state('app.application.EAPB-list-edit', {
      url: '/EAPB-edit/:srch/:keyId/:cKeyId',
      templateUrl: 'app/application/EAP-business-edit.html'
    }).state('app.application.EAPC-list', {
      url: '/counsel-list/:srch' ,
      templateUrl: 'app/application/EAP-counsel-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.application.EAPC-list.edit', {
      url: '/edit/:srch/:keyId/:cKeyId',
      templateUrl: 'app/application/EAP-counsel-edit.html'
    }).state('app.application.EAPC-list-edit', {
      url: '/edit/:srch/:keyId/:cKeyId',
      templateUrl: 'app/application/EAP-counsel-edit.html'
    }).state('app.application.expert-list', {
    url: '/expert-list/:srch' ,
    templateUrl: 'app/application/expert-list.html',
    requiresAuthentication: true,
    resolve : {
      plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
        return $ocLazyLoad.load([
          '/assets/app/vendor/footable/js/footable.js',
          '/assets/app/vendor/footable/css/footable.core.min.css',
         ]);
      } ],
    }
  }).state('app.application.expert-list.edit', {
    url: '/edit/:srch/:keyId/:cKeyId',
    templateUrl: 'app/application/expert-edit.html'
  }).state('app.application.expert-list-edit', {
    url: '/edit/:srch/:keyId/:cKeyId',
    templateUrl: 'app/application/expert-edit.html'
  });
  }
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('WjmEAPBEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function WjmEAPBEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmApplication.insertApp'; // 등록 SQL
      var UPDATE_SQL = 'WjmApplication.updateApplication'; // 수정 SQL
      var VIEW_SQL = 'WjmApplication.getApplicationList'; // 조회 SQL
      var DEL_SQL = 'WjmApplication.deleteAppDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.application.EAPB-list'; // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.application.EAPB-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.application.EAPB-list-edit'; // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.EAPB'; // 조회용 테이블명
      var KEY_COLUMN_NM = 'ImgId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      //vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = KEY_COLUMN_NM; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
              vm.uploadFileList.push(obj);
              }
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          /*
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
          $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback

      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      /**
       * 초기 세팅
       * @param
       * @return
       */
      function init(){
        // 문항 목록 체크박스 설정
        /*
        vm.qstChkHead = false;
        $scope.qstChkRowChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            if (!vm.qstLists[i].isChecked) {
              vm.qstChkHead = fal se;
              return;
            }
          }
          vm.qstChkHead = true;
        };

        $scope.qstChkHeadChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            vm.qstLists[i].qstChkRow = vm.qstChkHead;
          }
        };
        */
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData(type) {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        //vm.showUploader = enableUploadComponent();
        //initVaultComponent('vault', vm.onFileCallback);
        //initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.counselNum)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        if($window.sessionStorage.loginTenantId == "9SLLC9KELG"){
          data.serviceId = 0;
        }else {
          data.serviceId = 3;
        }

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              console.log(vm.allColumns);
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              //Date형식 처리
              if (!isNullOrEmpty(vm.data.RegDate)) vm.RegDate = moment(vm.data.RegDate).toDate();

              // 기본값 (no data 때문에 이쪽으로 들어오는 듯)
              if (isNullOrEmpty(vm.data.keyId)) {
                vm.data.CounselNum = "자동생성";
              }

              //getUploadFileList();
            } else {
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.data.RegDate)) {
          errMsg = errMsg + '- 신청일을 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.CounselStatus)) {
          errMsg = errMsg + '- 상태를 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Name)) {
          errMsg = errMsg + '- 고객명을 입력해주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 첨부파일 목록 조회
       *
       *
       *
       */
      /*
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.tableNm = KEY_TABLE_NM;
        data.TableId = vm.srch.keyId;
        data.mapCode = 'FileAttach.getFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {

            var uploadFileList = [];

            angular.forEach(result.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalFolderNm + "&fileName=" + item.LogicalFileNm),
                src: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                typeId: 'file',
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
                delState: ''
              };

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);

          }
          //}
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }
      */

      /**
       * 데이터 저장
       *
       *
       *
       */
      function setData() {
        if (!getIsValidData()) return;

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        /*
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        */

        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        vm.data.RegDate = moment(vm.data.RegDate).format('YYYY-MM-DD');

        // 에디터 내용 삽입
        //oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        //vm.data.TopCont = $("#strHtml").val();

        // 라디오박스 처리
        //if (isNullOrEmpty(vm.data.QstPassYN)) vm.data.QstPassYN = "Y";

        var data = vm.data; // 사용자 입력 데이터
        data.serviceId=0;
        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            //result.body.docs[0].KeyId !== null || result.body.docs[0].NewKeyId !== null
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            vm.data.keyId = result.body.docs[0].RelateDataId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
      }else{
        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }
    }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              //keyId: vm.data.KeyId
              keyId: vm.data.keyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.keyId});
          //$state.go(LIST_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        /*
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;
        */

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, { srch: srch }, {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }
      */

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;

      getData();
      init();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('EAPBusinessListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function EAPBusinessListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmApplication.getApplicationListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmApplication.getApplicationList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmApplication.getApplicationExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmApplication.deleteApplicationList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.application.EAPB-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.application.EAPB-list.edit';         // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.application.EAPB-list-edit';         // 조회 화면
      var EDIT_PAGE_URL = 'app.application.EAPB-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.EAPB'; // 작업 테이블명
      var EXCEL_TITLE = 'EAP 사업문의 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김


      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.currentPage = 1;
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.CounselDateFrom = $rootScope.getDateFormat(vm.srch.CounselDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.CounselDateTo = $rootScope.getDateFormat(vm.srch.CounselDateTo); // YYYY-MM-DD 를 date type 으로 변환
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        if($window.sessionStorage.loginTenantId == "9SLLC9KELG"){
          vm.srch.serviceId = 0;
        }else {
          vm.srch.serviceId = 3;
        }
        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();

      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 설문작성 화면
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: '',
          cKeyId: ''
        });
      }

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          //if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getList();
            }
          });
          //}
          /*
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
          */
        });
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        console.log(data);

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('EAPCounselEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function EAPCounselEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmApplication.insertApp'; // 등록 SQL
      var UPDATE_SQL = 'WjmApplication.updateApplication'; // 수정 SQL
      var VIEW_SQL = 'WjmApplication.getApplicationList'; // 조회 SQL
      var DEL_SQL = 'WjmApplication.deleteAppDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.application.EAPC-list'; // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.application.EAPC-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.application.EAPC-list.edit'; // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.EAPC'; // 조회용 테이블명
      var KEY_COLUMN_NM = 'ImgId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      //vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = KEY_COLUMN_NM; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
              vm.uploadFileList.push(obj);
              }
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          /*
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
          $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback

      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      /**
       * 초기 세팅
       * @param
       * @return
       */
      function init(){
        // 문항 목록 체크박스 설정
        /*
        vm.qstChkHead = false;
        $scope.qstChkRowChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            if (!vm.qstLists[i].isChecked) {
              vm.qstChkHead = fal se;
              return;
            }
          }
          vm.qstChkHead = true;
        };

        $scope.qstChkHeadChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            vm.qstLists[i].qstChkRow = vm.qstChkHead;
          }
        };
        */
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData(type) {

        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        //vm.showUploader = enableUploadComponent();
        //initVaultComponent('vault', vm.onFileCallback);
        //initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.counselNum)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        data.serviceId =1;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              //Date형식 처리
              if (!isNullOrEmpty(vm.data.RegDate)) vm.RegDate = moment(vm.data.RegDate).toDate();

              // 기본값 (no data 때문에 이쪽으로 들어오는 듯)
              if (isNullOrEmpty(vm.data.keyId)) {
                vm.data.CounselNum = "자동생성";
              }

              //getUploadFileList();
            } else {
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.data.RegDate)) {
          errMsg = errMsg + '- 신청일을 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.CounselStatus)) {
          errMsg = errMsg + '- 상태를 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Name)) {
          errMsg = errMsg + '- 고객명을 입력해주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 첨부파일 목록 조회
       *
       *
       *
       */
      /*
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.tableNm = KEY_TABLE_NM;
        data.TableId = vm.srch.keyId;
        data.mapCode = 'FileAttach.getFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {

            var uploadFileList = [];

            angular.forEach(result.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalFolderNm + "&fileName=" + item.LogicalFileNm),
                src: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                typeId: 'file',
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
                delState: ''
              };

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);

          }
          //}
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }
      */

      /**
       * 데이터 저장
       *
       *
       *
       */
      function setData() {
        if (!getIsValidData()) return;

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        /*
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        */

        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        vm.data.RegDate = moment(vm.data.RegDate).format('YYYY-MM-DD');

        // 에디터 내용 삽입
        //oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        //vm.data.TopCont = $("#strHtml").val();

        // 라디오박스 처리
        //if (isNullOrEmpty(vm.data.QstPassYN)) vm.data.QstPassYN = "Y";

        var data = vm.data; // 사용자 입력 데이터
        data.serviceId=1;
        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            //result.body.docs[0].KeyId !== null || result.body.docs[0].NewKeyId !== null
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            vm.data.keyId = result.body.docs[0].RelateDataId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
      }else{
        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }
    }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              //keyId: vm.data.KeyId
              keyId: vm.data.keyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.keyId});
          //$state.go(LIST_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        /*
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;
        */

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, { srch: srch }, {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }
      */

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;

      getData();
      init();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('EAPCounselListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function EAPCounselListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmApplication.getApplicationListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmApplication.getApplicationList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmApplication.getApplicationExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmApplication.deleteApplicationList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.application.EAPC-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.application.EAPC-list.edit';         // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.application.EAPC-list-edit';       // 조회 화면
      var EDIT_PAGE_URL = 'app.application.EAPC-list-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.EAPC'; // 작업 테이블명
      var EXCEL_TITLE = 'EAP 상담신청 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김


      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.CounselDateFrom = $rootScope.getDateFormat(vm.srch.CounselDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.CounselDateTo = $rootScope.getDateFormat(vm.srch.CounselDateTo); // YYYY-MM-DD 를 date type 으로 변환
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        vm.srch.serviceId = 1;

        getListCnt(); // 목록 건수 조회

        console.log("vm.srch", vm.srch);
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();

      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 설문작성 화면
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: '',
          cKeyId: ''
        });
      }

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          //if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getList();
            }
          });
          //}
          /*
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
          */
        });
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        console.log(data);

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('ExpertEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function ExpertEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmApplication.insertApp'; // 등록 SQL
      var UPDATE_SQL = 'WjmApplication.updateApplication'; // 수정 SQL
      var VIEW_SQL = 'WjmApplication.getApplicationList'; // 조회 SQL
      var DEL_SQL = 'WjmApplication.deleteAppDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.application.expert-list'; // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.application.expert-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.application.expert-list.edit'; // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.expert'; // 조회용 테이블명
      var KEY_COLUMN_NM = 'ImgId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      //vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = KEY_COLUMN_NM; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
              vm.uploadFileList.push(obj);
              }
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          /*
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
          $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback

      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      /**
       * 초기 세팅
       * @param
       * @return
       */
      function init(){
        // 문항 목록 체크박스 설정
        /*
        vm.qstChkHead = false;
        $scope.qstChkRowChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            if (!vm.qstLists[i].isChecked) {
              vm.qstChkHead = fal se;
              return;
            }
          }
          vm.qstChkHead = true;
        };

        $scope.qstChkHeadChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            vm.qstLists[i].qstChkRow = vm.qstChkHead;
          }
        };
        */
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData(type) {

        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        //vm.showUploader = enableUploadComponent();
        //initVaultComponent('vault', vm.onFileCallback);
        //initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.counselNum)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        data.serviceId =2;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              console.log(vm.data);
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              //Date형식 처리
              if (!isNullOrEmpty(vm.data.RegDate)) vm.RegDate = moment(vm.data.RegDate).toDate();

              // 기본값 (no data 때문에 이쪽으로 들어오는 듯)
              if (isNullOrEmpty(vm.data.keyId)) {
                vm.data.CounselNum = "자동생성";
              }

              //getUploadFileList();
            } else {
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.data.RegDate)) {
          errMsg = errMsg + '- 신청일을 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.CounselStatus)) {
          errMsg = errMsg + '- 상태를 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Name)) {
          errMsg = errMsg + '- 고객명을 입력해주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 첨부파일 목록 조회
       *
       *
       *
       */
      /*
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.tableNm = KEY_TABLE_NM;
        data.TableId = vm.srch.keyId;
        data.mapCode = 'FileAttach.getFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {

            var uploadFileList = [];

            angular.forEach(result.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalFolderNm + "&fileName=" + item.LogicalFileNm),
                src: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                typeId: 'file',
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
                delState: ''
              };

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);

          }
          //}
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }
      */

      /**
       * 데이터 저장
       *
       *
       *
       */
      function setData() {
        if (!getIsValidData()) return;

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        /*
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        */

        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        vm.data.RegDate = moment(vm.data.RegDate).format('YYYY-MM-DD');

        // 에디터 내용 삽입
        //oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        //vm.data.TopCont = $("#strHtml").val();

        // 라디오박스 처리
        //if (isNullOrEmpty(vm.data.QstPassYN)) vm.data.QstPassYN = "Y";

        var data = vm.data; // 사용자 입력 데이터
        data.serviceId=2;
        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            //result.body.docs[0].KeyId !== null || result.body.docs[0].NewKeyId !== null
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            vm.data.keyId = result.body.docs[0].RelateDataId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
      }else{
        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }
    }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              //keyId: vm.data.KeyId
              keyId: vm.data.keyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.keyId});
          //$state.go(LIST_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        /*
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;
        */

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, { srch: srch }, {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }
      */

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;

      getData();
      init();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('ExpertListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function ExpertListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmApplication.getApplicationListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmApplication.getApplicationList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmApplication.getApplicationExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmApplication.deleteApplicationList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.application.expert-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.application.expert-list.edit';         // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.application.expert-list-edit';         // 조회 화면
      var EDIT_PAGE_URL = 'app.application.expert-list-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.expert'; // 작업 테이블명
      var EXCEL_TITLE = '전문가협약 신청 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김


      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.CounselDateFrom = $rootScope.getDateFormat(vm.srch.CounselDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.CounselDateTo = $rootScope.getDateFormat(vm.srch.CounselDateTo); // YYYY-MM-DD 를 date type 으로 변환
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        vm.srch.serviceId = 2;

        getListCnt(); // 목록 건수 조회

        console.log("vm.srch", vm.srch);
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              angular.forEach(vm.lists, function(item) {
                if(item.ConvId == 1){
                  item.ConvId = '상담센터';
                }else {
                  item.ConvId = '상담사';
                }
              });


              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();

      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 설문작성 화면
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: '',
          cKeyId: ''
        });
      }

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          //if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getList();
            }
          });
          //}
          /*
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
          */
        });
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      setInitData();
    }]);
})();

webapp.service('BoardMngAPISrv', [ '$resource', 'StaticVariable','$rootScope', function BoardMngAPISrv($resource, staticVariable,$rootScope) {
  return {
    getBoardMngApi : function() {
      return $resource(staticVariable.getUrl('/api/boardmng/metatables/:tableNm') + '.json', {
        tableNm : '@tableNm', userkey:$rootScope.gVariable.userKey, srchCustomColumns : '@srchCustomColumns', srchTenantId : '@srchTenantId'
      }, staticVariable.getRequestActions.defaultAction());
    },
    getUsingMetaTableNm : function() {
      return $resource(staticVariable.getUrl('/api/boardmng/metatables/:tableNm/info') + '.json', {
        tableNm : '@tableNm',userkey:$rootScope.gVariable.userKey
      }, staticVariable.getRequestActions.defaultAction());
    },
    doModuleTypeList: function() {
      return $resource(staticVariable.getUrl('/select/CommonCode.getCommonCodeValue/action.json'), {userkey:$rootScope.gVariable.userKey},
        staticVariable.getRequestActions.defaultAction());
    },

  };
}, ]);

webapp.controller('BoardMngDetailCtrl', [ '$scope', '$state', '$stateParams', 'BoardMngAPISrv', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert', '$rootScope','$location','$window','gConfirm','$translate',
    function BoardMngDetailCtrl($scope, $state, $stateParams, boardMngApi, postApi, modalFactory, CONSTANT, gAlert, $rootScope,$location,$window,gConfirm,$translate) {

      var vm = this;
      vm.COLUMN_EDIT_STATE_DELETE = 'D';
      vm.COLUMN_EDIT_STATE_ADD = 'A';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      vm.COLUMN_EDIT_STATE_PENDING = '';
      vm.saveMetaTable = saveMetaTable;
      vm.addColumn = addColumn;
      vm.deleteColumn = deleteColumn;
      vm.openAttrSetup = openAttrSetup;
      vm.openSortMetaColumn = openSortMetaColumn;
      vm.showColumnInfo = showColumnInfo;
      vm.goModifyMetaTable = goModifyMetaTable;
      vm.checkStateChange = checkStateChange;
      vm.showFieldNameRule = showFieldNameRule;
      vm.getTableColumns = getTableColumns;
      $scope.srchTenantId = $window.sessionStorage['srchTenantId'];
      vm.deleteColumns = [];
      vm.metaColumnYN = 'N';

      (function BoardMngDetailCtrl() {
        console.info('currentActionView:', $stateParams.currentActionView);
        vm.currentActionView = $stateParams.currentActionView;
        if (angular.isDefined($stateParams.tableNm)) {
          getMetaTableDetail();
        } else {
          vm.metaTable = {
            metaTableId : '',
            tableNm : '',
            moduleType : '',
            tableDesc : '',
            metaColumns : [],
          };
          vm.usingTableId = '';
          $scope.$watch(function() {
            return vm.metaTable.tableNm;
          }, checkTableNm);
        }

      })();

      function getMetaTableDetail() {
        var res = boardMngApi.getBoardMngApi().get({
          tableNm : $stateParams.tableNm,
          srchTenantId : $window.sessionStorage['srchTenantId']
        }).$promise;
        res.then(function(json) {
          vm.metaTable = json.responseVO.body.docs[0];
          vm.metaTable.metaColumns.forEach(function(elm, idx) {
            elm.columnValid = true;
            elm.dirty = vm.COLUMN_EDIT_STATE_PENDING;
          });

          if(json.responseVO.body.docs[0].metaColumns.length > 0)
            vm.metaColumnYN = 'Y';
        });
      }

      function addColumn() {
        var newLine = {
          metaColumnId : '',
          columnPhysicalNm : '',
          columnLogicalNm : '',
          columnSection : '',
          columnPhysicalDataType : '10',
          columnLogicalDataType : '10',
          columnPhysicalDataSize : '',
          listColumnWidth : '20%',
          listColumnTextAlign : 'text-center',
          listColumnSort : vm.metaTable.metaColumns.length + 1,
          listColumnShowYN : 'Y',
          listColumnShowLevel : '3',
          editColumnWidth : 'col-lg-4 col-md-6',
          editColumnSort : vm.metaTable.metaColumns.length + 1,
          editColumnShowYN : 'Y',
          editColumnHeight : '',
          columnDesc : '',
          columnCodeValue : '',
          customColumnYN : 'Y',
          keyColumnYN : 'Y',
          dirty : vm.COLUMN_EDIT_STATE_ADD,
          columnValid : false,
        };
        vm.metaTable.metaColumns.push(newLine);
      }

      function checkStateChange(column) {
        if (column.dirty != vm.COLUMN_EDIT_STATE_ADD)
          column.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
      }

      function checkTableNm(nval, oval) {
        if (angular.isUndefined(nval) || nval == '') {
          return;
        }

        var res = boardMngApi.getUsingMetaTableNm().post({
          tableNm : nval
        }).$promise;
        res.then(function(json) {
          if (json.responseVO.body.docs.length > 0) {
            vm.usingTableNm = json.responseVO.body.docs[0].tableNm;
          } else {
            vm.usingTableNm = '';
          }
        });
      }

      function saveMetaTable() {
        if(vm.metaColumnYN == 'N'){
          vm.currentActionView = 'add';
        }
        var data = vm.metaTable;
        data.currentActionView = vm.currentActionView;
        if(vm.currentActionView == 'modify') {
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              console.log('result.header.status');
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
          }, function(error) {
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }else if(vm.currentActionView == 'add'){
          $stateParams.tableNm = vm.metaTable.tableNm;
          data.deleteColumns = vm.deleteColumns;
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
          }, function(error) {
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      function saveAction(promise) {
        promise.then(function(json) {
          goModifyMetaTable();
        });
      }

      function deleteColumn(selectedColumn) {
        if (selectedColumn.dirty == vm.COLUMN_EDIT_STATE_PENDING || selectedColumn.dirty == vm.COLUMN_EDIT_STATE_MODIFY) {
          selectedColumn.dirty = vm.COLUMN_EDIT_STATE_DELETE;
        } else {
          vm.metaTable.metaColumns.splice(vm.metaTable.metaColumns.indexOf(selectedColumn), 1);
        }
      }

      function openAttrSetup(column) {
        if (column.columnLogicalNm == '' && column.columnPhysicalNm == '') {
          gAlert('', 'Menu.EM710VA04');
          return;
        }
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-setup.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
        modalInstance.result.then(function(result) {
          if (result.dirty == vm.COLUMN_EDIT_STATE_PENDING) {
            result.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
          }
          result.columnValid = true;
        });
      }

      function openSortMetaColumn() {
        if (isEmptyColumnNm()) {
          gAlert('', 'Menu.EM710VA05');
        } else {
          var delColumns = [];
          var columns = vm.metaTable.metaColumns.filter(function(elm, idx) {
            if (elm.dirty == vm.COLUMN_EDIT_STATE_DELETE) {
              delColumns.push(elm);
            }
            return elm.dirty != vm.COLUMN_EDIT_STATE_DELETE;
          });
          var modalInstance = modalFactory.open('md', 'app/boardmng/modal_attr_reorder.html', 'ColumnAttrReorderCtrl as reorderCtrl', columns);
          modalInstance.result.then(function(result) {
            vm.metaTable.metaColumns = [];
            angular.copy(result, vm.metaTable.metaColumns);
            delColumns.forEach(function(elm, idx) {
              vm.metaTable.metaColumns.push(elm);
            });
          });
        }
      }

      function showColumnInfo(column) {
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-detail.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
      }

      function showFieldNameRule() {
        var modalInstance = modalFactory.open('fn', 'app/boardmng/modal_attr_fieldnamerule.html', 'ColumnAttrReorderCtrl as reorderCtrl', '');
      }

      function isEmptyColumnNm() {
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.columnLogicalNm == null || item.columnLogicalNm.trim() == '') {
            return true;
          }
        });
        return false;
      }

      function getTableColumns() {
        if(vm.metaColumnYN == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){
              vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';
              vm.currentActionView = 'add';

              var data = vm.metaTable;
              postApi.select('MetaColumn.getTableColumns', data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.metaTable.metaColumns = result.body.docs;
                }
              }, function(error) {
                console.error('Error> h0102-list-ctrl> getList()', status, error);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        }else{
          var data = vm.metaTable;
          postApi.select('MetaColumn.getTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.metaTable.metaColumns = result.body.docs;
            }
          }, function(error) {
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      $scope.$on('broadcastSetChangeTenantID', function(event, args) {
        getMetaTableDetail();
      });

      function goModifyMetaTable() {
        $state.go('app.boardmng.modify', {
          tableNm : $stateParams.tableNm
        });
      }
    }, ]);

webapp.controller('BoardMngEditCtrl', [ '$scope', '$state', '$stateParams', 'BoardMngAPISrv', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert', '$rootScope','$location','$window','gConfirm','$translate', 'SystemCodeAPISrv',
    function BoardMngEditCtrl($scope, $state, $stateParams, boardMngApi, postApi, modalFactory, CONSTANT, gAlert, $rootScope, $location, $window, gConfirm, $translate, systemCodeAPISrv) {

      var vm = this;
      vm.COLUMN_EDIT_STATE_DELETE = 'D';
      vm.COLUMN_EDIT_STATE_ADD = 'A';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      vm.COLUMN_EDIT_STATE_PENDING = '';
      vm.ChangeCustomColumn = ChangeCustomColumn;
      vm.saveMetaTable = saveMetaTable;
      vm.addColumn = addColumn;
      vm.deleteColumn = deleteColumn;
      vm.openAttrSetup = openAttrSetup;
      vm.openSortMetaColumn = openSortMetaColumn;
      vm.showColumnInfo = showColumnInfo;
      vm.goModifyMetaTable = goModifyMetaTable;
      vm.checkStateChange = checkStateChange;
      vm.showFieldNameRule = showFieldNameRule;
      vm.getTableColumns = getTableColumns;
      vm.makeSrch = makeSrch;
      vm.addDelCustomColumns = addDelCustomColumns;

      vm.deleteColumns = [];
      vm.metaColumnYN = 'N';
      vm.dataloader = false;
      vm.changeColumn = 'N';
      vm.srchTenantId = $rootScope.gVariable.srchTenantId;

      vm.srch = {srchCustomColumns : 'N'};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          srchCustomColumns : 'N'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      (function BoardMngEditCtrl() {
        getModuleTypeList();
        if (angular.isDefined($stateParams.tableNm) && $stateParams.tableNm != '') {
          vm.currentActionView = 'modify';
          getMetaTableDetail();
        } else {
          vm.currentActionView = 'add';
          vm.metaTable = {
            metaTableId : '',
            tableNm : '',
            moduleType : '',
            tableDesc : '',
            metaColumns : [],
          };
          vm.usingTableId = '';
          $scope.$watch(function() {
            return vm.metaTable.tableNm;
          }, checkTableNm);
        }
      })();

      console.log(vm.layout);

      vm.onSelectCallback = function(data) {
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.metaColumnId == data.CallbackTarget) {
            item.columnPhysicalNm = data.Code;
            return;
          }
        });
      };

      function makeSrch(){
        return encodeURIComponent(JSON.stringify(vm.srch, replacer));
      }
      function getMetaTableDetail() {
        vm.dataloader = true;
        var res = boardMngApi.getBoardMngApi().get({
          tableNm : $stateParams.tableNm,
          srchTenantId : $rootScope.gVariable.srchTenantId,
          srchCustomColumns : vm.srch.srchCustomColumns
        }).$promise;
        res.then(function(json) {
          vm.metaTable = json.responseVO.body.docs[0];
          if (vm.metaTable) {
            vm.metaTable.metaColumns.forEach(function(elm, idx) {
              elm.columnValid = true;
              elm.dirty = vm.COLUMN_EDIT_STATE_PENDING;
              if (elm.customColumnYN == 'Y') {
                elm.type = 'add';
                elm.commoncodeDATA = {
                  CallbackTarget : elm.metaColumnId,
                  CodeType : 'METACOLUMN',
                  Code : elm.columnPhysicalNm,
                  ReloadSeq : 1
                }
              } else if (elm.customColumnYN == 'N') {
                elm.type = 'old';
              }
            });

            if(vm.metaTable.metaColumns.length > 0)
              vm.metaColumnYN = 'Y';
          }

          vm.dataloader = false;
        });
      }

      function addColumn(type) {
        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);

        var newLine = {
          metaColumnId : newnum.toString(36),
          columnPhysicalNm : '',
          columnLogicalNm : '',
          columnSection : '',
          columnPhysicalDataType : '10',
          columnLogicalDataType : '10',
          columnPhysicalDataSize : '',
          listColumnWidth : '10%',
          listColumnTextAlign : 'text-center',
          listColumnSort : vm.metaTable.metaColumns.length + 1,
          listColumnShowYN : 'Y',
          listColumnShowLevel : '3',
          editColumnWidth : 'col-lg-4 col-md-6',
          editColumnSort : vm.metaTable.metaColumns.length + 1,
          editColumnShowYN : 'Y',
          editColumnHeight : '',
          columnDesc : '',
          columnCodeValue : '',
          codeType : '',
          customColumnYN : type == 'add' ? 'Y' : 'N',
          keyColumnYN : 'Y',
          dirty : vm.COLUMN_EDIT_STATE_ADD,
          columnValid : false,
          commoncodeDATA : {
            CallbackTarget : newnum.toString(36),
            CodeType : 'METACOLUMN',
            ReloadSeq : 1
          },
          type : type
        };
        vm.metaTable.metaColumns.push(newLine);
      }

      function checkStateChange(column) {
        if (column.dirty != vm.COLUMN_EDIT_STATE_ADD)
          column.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
      }

      function checkTableNm(nval, oval) {
        if (angular.isUndefined(nval) || nval == '') {
          return;
        }

        var res = boardMngApi.getUsingMetaTableNm().post({
          tableNm : nval
        }).$promise;
        res.then(function(json) {
          if (json.responseVO.body.docs.length > 0) {
            vm.usingTableNm = json.responseVO.body.docs[0].tableNm;
          } else {
            vm.usingTableNm = '';
          }
        });
      }

      function saveMetaTable() {
        vm.dataloader = true;

        if(!validateCheck()){
          return false;
        }

        var data = vm.metaTable;
        data.currentActionView = vm.currentActionView;
        data.deleteColumns = vm.deleteColumns;

        postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              goModifyMetaTable();
            } else {
              $rootScope.showSimpleToast('failed to save');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          vm.dataloader = false;
          $rootScope.showSimpleToast('failed to save');
          console.error('Error> h0102-list-ctrl> getList()', status, error);
        });

    /*         if(vm.currentActionView == 'modify') {
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              console.log('result.header.status');
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }else if(vm.currentActionView == 'add'){
          $stateParams.tableNm = vm.metaTable.tableNm;
          data.deleteColumns = vm.deleteColumns;
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        } */
      }

      function saveAction(promise) {
        promise.then(function(json) {
          goModifyMetaTable();
        });
      }

      function deleteColumn(selectedColumn) {
          vm.metaTable.metaColumns.splice(vm.metaTable.metaColumns.indexOf(selectedColumn), 1);
          vm.deleteColumns.push(selectedColumn);
      }

      function openAttrSetup(column) {
        if (column.columnLogicalNm == '' && column.columnPhysicalNm == '') {
          gAlert('', 'Menu.EM710VA04');
          return;
        }
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-setup.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
        modalInstance.result.then(function(result) {
          if (result.dirty == vm.COLUMN_EDIT_STATE_PENDING) {
            result.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
          }
          result.columnValid = true;
        });
      }

      function openSortMetaColumn() {
        if (isEmptyColumnNm()) {
          gAlert('', 'Menu.EM710VA05');
        } else {
          var delColumns = [];
          var columns = vm.metaTable.metaColumns.filter(function(elm, idx) {
            if (elm.dirty == vm.COLUMN_EDIT_STATE_DELETE) {
              delColumns.push(elm);
            }
            return elm.dirty != vm.COLUMN_EDIT_STATE_DELETE;
          });
          var modalInstance = modalFactory.open('md', 'app/boardmng/modal_attr_reorder.html', 'ColumnAttrReorderCtrl as reorderCtrl', columns);
          modalInstance.result.then(function(result) {
            vm.metaTable.metaColumns = [];
            angular.copy(result, vm.metaTable.metaColumns);
            delColumns.forEach(function(elm, idx) {
              vm.metaTable.metaColumns.push(elm);
            });
          });
        }
      }

      function showColumnInfo(column) {
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-detail.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
      }

      function showFieldNameRule() {
        var modalInstance = modalFactory.open('fn', 'app/boardmng/modal_attr_fieldnamerule.html', 'ColumnAttrReorderCtrl as reorderCtrl', '');
      }

      function isEmptyColumnNm() {
        var res = false;
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.columnLogicalNm == null || item.columnLogicalNm.trim() == '') {
            res = true;
          }
        });
        return res;
      }

      function validateCheck(){
        if(vm.currentActionView == 'add'){
          if(vm.usingTableNm.length != 0){
            gAlert('','Menu.EM710VA03');
            vm.dataloader = false;
            return false;
          }
        }

        return true;
      }

      function getTableColumns() {
        vm.dataloader = true;
        if(vm.metaColumnYN == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){

              vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';

              var data = vm.metaTable;
              postApi.select('MetaColumn.getTableColumns', data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  var newnum = 0;
                  result.body.docs.forEach(function(elm,indx){

                    newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                    elm.metaColumnId = newnum.toString(36);
                    if (elm.customColumnYN == "N") {
                      elm.columnSection = "";

                      if (elm.dataType == "varchar") {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      } else if (elm.dataType == "datetime" || elm.dataType == "date") {
                        elm.columnPhysicalDataType = "40";
                        elm.columnLogicalDataType = "40";
                      } else if (elm.dataType == "int") {
                        elm.columnPhysicalDataType = "20";
                        elm.columnLogicalDataType = "20";
                      } else if (elm.dataType == "bigint") {
                        elm.columnPhysicalDataType = "20";
                        elm.columnLogicalDataType = "20";
                      } else if (elm.dataType == "char") {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      } else {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      }
                      elm.columnPhysicalDataSize = "";
                      elm.listColumnWidth = "20%";
                      elm.listColumnTextAlign = "text-center";
                      elm.listColumnShowYN = "Y";
                      elm.listColumnShowLevel = "3";
                      elm.editColumnWidth = "col-lg-4 col-md-6";
                      elm.editColumnShowYN = "Y";
                      elm.editColumnHeight = "";
                      elm.columnDesc = "";
                      elm.columnCodeValue = "";
                      elm.codeType = "";
                      elm.dirty = "";
                    }

                    if (elm.customColumnYN == 'Y') {
                      elm.commoncodeDATA = {
                        CallbackTarget : elm.metaColumnId,
                        CodeType : 'METACOLUMN',
                        Code : elm.columnPhysicalNm,
                        ReloadSeq : 1
                      };
                    }
                  });
                  vm.metaTable.metaColumns = result.body.docs;
                }
                vm.dataloader = false;
              }, function(error) {
                vm.dataloader = false;
                console.error('Error> h0102-list-ctrl> getList()', status, error);
              });
            }
          }, {
            btn : '',
            fn : function(){
              vm.dataloader = false;
            }
          });
        }else{
          var data = vm.metaTable;
          postApi.select('MetaColumn.getTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var newnum = 0;
              result.body.docs.forEach(function(elm,indx){
                newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                elm.metaColumnId = newnum.toString(36);

                if(elm.customColumnYN == 'N'){
                  elm.columnSection = '';
                  if(elm.dataType =="varchar"){

                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';

                  }else if(elm.dataType =="datetime"){

                    elm.columnPhysicalDataType = '40';
                    elm.columnLogicalDataType = '40';

                  }else if(elm.dataType =="int"){

                    elm.columnPhysicalDataType = '20';
                    elm.columnLogicalDataType = '20';

                  }else if(elm.dataType =="bigint"){

                    elm.columnPhysicalDataType = '20';
                    elm.columnLogicalDataType = '20';

                  }else if(elm.dataType =="char"){

                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';

                  }else{
                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';
                  }
                  elm.columnPhysicalDataSize = '';
                  elm.listColumnWidth = '10%';
                  elm.listColumnTextAlign = 'text-center';
                  elm.listColumnShowYN = 'Y';
                  elm.listColumnShowLevel = '3';
                  elm.editColumnWidth = 'col-lg-4 col-md-6';
                  elm.editColumnShowYN = 'Y';
                  elm.editColumnHeight = '';
                  elm.columnDesc = '';
                  elm.columnCodeValue = '';
                  elm.codeType = '';
                  elm.keyColumnYN = 'Y';
                }
                if (elm.customColumnYN == 'Y') {
                  elm.commoncodeDATA = {
                    CallbackTarget : elm.metaColumnId,
                    CodeType : 'METACOLUMN',
                    Code : elm.columnPhysicalNm,
                    ReloadSeq : 1
                  }
                }
              });
              vm.metaTable.metaColumns = result.body.docs;
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      $scope.$on('broadcastSetChangeTenantID', function(event, args) {
        vm.srchTenantId = $rootScope.gVariable.srchTenantId;
        vm.metaColumnYN = 'N';
        vm.changeColumn = 'N';
        getMetaTableDetail();
      });

      function goModifyMetaTable() {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (vm.metaTable.tableNm == null) {
            $state.go("app.boardmng.list", { srch: srch, tableNm: ''}, {reload:"app.boardmng.list"});
          } else {
            // 조회 화면 이동
            $state.go("app.boardmng.list.modify", {
              srch: srch,
              tableNm : vm.metaTable.tableNm
            });
          }
        } else {
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          $state.go("app.boardmng.list.modify", {srch: srch, tableNm: vm.metaTable.tableNm});
        }
      }

      function ChangeCustomColumn() {
        getMetaTableDetail();
      }

      function getModuleTypeList () {
        var res = boardMngApi.doModuleTypeList().post({
          CodeType : 'MODULETYPE',
          srchTenantId : $rootScope.gVariable.srchTenantId
        }).$promise;
        res.then(function(json) {
          vm.moduleTypeList = json.responseVO.body.docs;
        });
      }

      function addDelCustomColumns() {
        vm.dataloader = true;

        if(!validateCheck()){
          return false;
        }

        var data = vm.metaTable;
        data.currentActionView = vm.currentActionView;
        data.deleteColumns = vm.deleteColumns;

        postApi.sendPostApi('api/boardmng/metacolumns', vm.metaTable.tableNm, data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              goModifyMetaTable();
            } else {
              $rootScope.showSimpleToast('failed to save');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          vm.dataloader = false;
          $rootScope.showSimpleToast('failed to save');
          console.error('Error> h0102-list-ctrl> getList()', status, error);
        });
      }

    }, ]);

webapp.controller('BoardMngListCtrl', [ '$window', '$filter', 'GLOBAL_CONSTANT', 'BoardMngAPISrv','$stateParams','$scope','$state','$rootScope', 'postApi', 'gAlert',
  function BoardListCtrl($window, $filter, CONSTANT, boardMngApi, $stateParams, $scope, $state, $rootScope, postApi, gAlert) {
    var vm = this;// View Model

    vm.tablesort = tablesort;
    vm.sortClass = sortClass;
    vm.getSearch = getSearch;
    vm.makeSrch = makeSrch;
    vm.resetSearch = resetSearch;
    vm.pageChanged = pageChanged;

    var KEY_TABLE_NM = 'metatable';

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: ''          // 정렬컬럼명
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
    }

    $scope.selectedRow = $stateParams.tableNm;
    vm.currentPage = vm.srch.page;
    vm.viewSize = vm.srch.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
    vm.anchor = "";
    setLayout(vm.layout); // 화면분할 모드 설정

    //pagination
    vm.totalCount = 0;
    vm.viewSizePerPage = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.viewSizePerPageList = CONSTANT.PAGINATION.OPTION_VIEWSIZE;
    vm.dataloader = false;
    // 검색 선택 옵션
    vm.searchFieldTypeList = [ {
      optionId : 'all',
      optionName : '전체'
    }, {
      optionId : 'table',
      optionName: '물리 테이블명'
    }, {
      optionId : 'column',
      optionName: '물리 컬럼명'
    }, ];

    vm.changeViewSize = changeViewSize;
    vm.getMetaTableList = getMetaTableList;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;

    (function BoardListCtrl() {
      // 페이징
      vm.TenantId = $window.sessionStorage['loginTenantId'];
      vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
      getMetaTableList();
    })();

    function changeViewSize() {
      vm.srch.page = 1;
      vm.srch.viewSize = vm.viewSize;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.boardmng.list', {srch:srch}, {reload:'app.boardmng.list'});
    }

    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getMetaTableList();
    });

    /**
     * 화면 분할 모드 설정
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function setLayout(layout) {

      // 분할 모드 지정
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          // 수평
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          // 수직
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          // 기본
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    /**
     * 화면 분할 모드 변경
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function changeLayout(layout) {
      // 분할 모드 설정값 저장
      $rootScope.changeLayout(layout);

      var srch = $stateParams.srch; // 검색 옵션

      $state.go('app.boardmng.list', {
        srch: makeSrch(),
        tableNm: ''
      }, {reload: 'app.boardmng.list'});
    }

    function getMetaTableList() {
      vm.srch.page = vm.currentPage;
      vm.dataloader = true;
      var data = vm.srch;
      data.mapCode = "boardmng/metatables";
      postApi.api(
        data,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.boardList = result.body.docs;
              vm.currentPage = vm.boardList[0].page;
              vm.totalCount = vm.boardList[0].totalCount;
              vm.boardList.splice(0, 1);
              vm.dataloader = false;
            } else {
              vm.dataloader = false;
              var errMsg = result.body.docs.errMessage;
              gAlert("Menu.ERROR", errMsg);
              console.error("ErrorCode : ", result.body.docs.errCode, "ErrorMsg : ", result.body.docs.errMessage);
            }
          }
          vm.columnMap = '';
          vm.SearchConditionStr = getSearchConditionStr(vm.totalCount, vm.columnMap, vm.srch);
          vm.dataloader = false;
        },
        function(error) {
          console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
        vm.sortDirect = vm.srch.sortDirect ;
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.sortDirect = vm.srch.sortDirect ;
      }

      vm.srch.sortColumn = sortkey;
      vm.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.boardmng.list', {srch:srch}, {reload:'app.boardmng.list'});
    }
    function makeSrch(){
      return encodeURIComponent(JSON.stringify(vm.srch, replacer));
    }

    function resetSearch() {
      $state.go('app.boardmng.list', {
        srch : ''
      }, {reload: 'app.boardmng.list'});
    }

    function goDetail(tableNm) {
      var srch = $stateParams.srch; // 검색 옵션
      $scope.selectedRow = tableNm;

      if (vm.layout == 'N') {
        // 조회 화면 이동
        $state.go('app.boardmng.modify', {
          srch: srch,
          tableNm: tableNm
        });
      } else {
        // 목록 조회 화면 이동
        $state.go('app.boardmng.list.modify', {
          srch: srch,
          tableNm: tableNm
        });
      }
    }

    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.boardmng.list', {srch:srch}, {reload:'app.boardmng.list'});
    }
}, ]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.boardmng', {
      url: '/boardmng',
      template: '<div ui-view></div>',
    }).state('app.boardmng.list', {
      url: '/list/:srch',
      templateUrl: 'app/boardmng/boardmng-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.list.add', {
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'add'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.list.modify', {
      url: '/modify/:tableNm',
      templateUrl: 'app/boardmng/boardmng-edit.html',
      params:{
        currentActionView: 'modify'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.add', {
      url: '/add/:srch',
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'add'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.modify', {
      url: '/modify/:srch/:tableNm',
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'modify'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    });
  }
})();

webapp.controller('ColumnAttrReorderCtrl', [ '$scope', '$uibModalInstance', '$filter', 'sortArrayFactory', 'toModalData',
    function ObjectTypeReorderController($scope, $uibModalInstance, $filter, sorts, toModalData) {
      var vm = this;
      var COLUMN_EDIT_STATE_MODIFY = 'M';
      var COLUMN_EDIT_STATE_PENDING = '';
      vm.selectedIdx = 0;
      vm.objModel = [];

      vm.onSelect = onSelect;
      vm.moveUp = moveUp;
      vm.moveDown = moveDown;
      vm.moveTop = moveTop;
      vm.moveBottom = moveBottom;
      vm.move = move;
      vm.onSave = onSave;
      vm.onClose = onClose;
      vm.title = '사용자 속성 정렬';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      angular.copy(sorts.sortArrayObject(toModalData, toModalData.ListColumnSort), vm.objModel);
      vm.objModelLen = vm.objModel.length;

      function onSelect(idx) {
        vm.selectedIdx = idx;
      }

      function moveUp() {
        var destIdx = vm.selectedIdx - 1;
        if (destIdx == -1) {
          return;
        }

        vm.move(vm.selectedIdx, destIdx);
        vm.selectedIdx = destIdx;
      }

      function moveDown() {
        var destIdx = vm.selectedIdx + 1;
        if (destIdx == vm.objModelLen) {
          return;
        }

        vm.move(vm.selectedIdx, destIdx);
        vm.selectedIdx = destIdx;
      }

      function moveTop() { // 맨위
        var temp = vm.objModel[vm.selectedIdx];
        vm.objModel.splice(vm.selectedIdx, 1);
        vm.objModel.unshift(temp);
        vm.selectedIdx = 0;
      }

      function moveBottom() { // 맨아래
        var temp = vm.objModel[vm.selectedIdx];
        vm.objModel.splice(vm.selectedIdx, 1);
        vm.objModel.push(temp);
        vm.selectedIdx = vm.objModelLen - 1;
      }

      function move(orgIdx, destIdx) {
        var temp = vm.objModel[destIdx];
        vm.objModel[destIdx] = vm.objModel[orgIdx];
        vm.objModel[orgIdx] = temp;
      }

      // 순서 변경 저장
      function onSave() {
        var reorderList = [];
        angular.forEach(vm.objModel, function(node, idx) {
          node.listColumnSort = idx;
          if (node.dirty == COLUMN_EDIT_STATE_PENDING) {
            node.dirty = COLUMN_EDIT_STATE_MODIFY;
          }
        });
        $uibModalInstance.close(vm.objModel);
      }

      // 취소|닫기 버튼
      function onClose() {
        $uibModalInstance.dismiss('cancel');
      }
    } ]);

webapp.controller('ColumnAttrSetupCtrl', ['$scope', '$uibModalInstance', 'SystemCodeAPISrv', 'GLOBAL_CONSTANT', 'toModalData',
  function ColumnAttrSetupCtrl($scope, $uibModalInstance, systemCodeAPISrv, CONST, toModalData) {
    var vm = this;
    var backupColumn = {};
    vm.isSizableData = isSizableData;
    vm.onCancelClick = onCancelClick;
    vm.onAddClick = onAddClick;

    (function ColumnAttrSetupCtrl(){
      getSystemCodeList();
      vm.column = toModalData;
      angular.copy(toModalData, backupColumn);
      vm.selectedPhysicalDataType = {
          code: vm.column.columnPhysicalDataType
      };
      vm.selectedLogicalDataType = {
          code: vm.column.columnLogicalDataType
      };
      vm.title = vm.column.columnLogicalNm + "(" + vm.column.columnPhysicalNm + ")";
    })();

    function onCancelClick(){
      angular.copy(backupColumn, vm.column);
        $uibModalInstance.dismiss('cancel');
    }

    function onAddClick(){
      vm.column.columnPhysicalDataType = vm.selectedPhysicalDataType.code;
      vm.column.columnLogicalDataType = vm.selectedLogicalDataType.code;

      $uibModalInstance.close(vm.column);
    }

    function getSystemCodeList(){
      systemCodeAPISrv.getSystemCodeList().getList({parentCommonCodeId:CONST.CODE_GROUP.COLUMN_DATA_TYPE}).$promise
      .then(function(json){
        vm.codeList = json.responseVO.body.docs;
      });
    }

    function isSizableData(){
      return ['40', '50'].indexOf(vm.selectedPhysicalDataType.code) < 0;
    }
  }]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost.bbs-master-detail-ctrl
 * @description # 게시판관리 상세보기 Controller
 */

webapp.controller('BbsMasterDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state - state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - Alert Module *
 */

  function BbsMasterDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, postApi, gAlert, gConfirm) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId : $stateParams.srch.BbsMasterId ? $stateParams.srch.BbsMasterId  : '',
        TenantId : vm.TenantId,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbsmaster',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.BbsMasterId != '') {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    }

    vm.srchDetail = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      BbsMasterId : $stateParams.BbsMasterId,
      TenantId : vm.TenantId,
      tableNm : 'bbsmaster',
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getData() {
      vm.dataloader = true;
      var data = vm.srchDetail;

      data.mapCode = 'BbsMaster.getBbsMasterDetail';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
          }
        }
        vm.dataloader = false;
      },function(error) {
        console.error('Error> role-edit-ctrl> getData()', error);
        vm.dataloader = false;
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function deleteDetail() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteDetailAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteDetailAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      console.log("before delete", vm.data);

      var data = vm.data;
      data.mapCode = 'BbsMaster.deleteBbsMasterDetail';
      postApi.update(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go('app.bbspost.bbs-master-list', {
                srch:srch
              }, {reload:'app.bbspost.bbs-master-list'});
            }
          });
          return;
        }
      }, function(error) {
        console.error('Error> role-detail-ctrl> deleteDataAction()', error);
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function goList() {
      var srch = $stateParams.srch;
      $state.go('app.bbspost.bbs-master-list', {
        srch : srch
      });
    }

    function goEdit() {
      var srch = $stateParams.srch;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.bbs-master-edit', {
          srch : srch, BbsMasterId : vm.data.BbsMasterId
        });
      } else {
        $state.go('app.bbspost.bbs-master-list.edit', {
          srch : srch, BbsMasterId : vm.data.BbsMasterId
        });
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.deleteDetail = deleteDetail;
    vm.goList = goList;
    vm.goEdit = goEdit;

    // 데이터 조회
    getData();
  }, ]);
})();

/**
 * @ngdoc function
 * @name app.bbspost.bbs-master-edit-ctrl
 * @description
 * # 게시판관리 등록/수정
 * Controller of the 게시판관리
 */
webapp.controller('BbsMasterEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - Alert Module
 */

  function BbsMasterEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm) {
    // View Model
    var vm = this;
    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId : $stateParams.srch.BbsMasterId ? $stateParams.srch.BbsMasterId : '',
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'Users',
        TenantId : vm.TenantId,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.BbsMasterId) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    }

    vm.srchDetail = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      BbsMasterId : vm.srch.BbsMasterId != null ? $stateParams.BbsMasterId : '',
      TenantId : vm.TenantId,
      tableNm : vm.srch.tableNm,
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author rohbi
    */
    function getData() {
      vm.dataloader = true;
      if (vm.srch.BbsMasterId == null || vm.srch.BbsMasterId == '') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srchDetail;
      data.mapCode = 'BbsMaster.getBbsMasterDetail';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];

            vm.dataloader = false;
            return;
          }
        } else {
          vm.dataloader = false;
        }
        console.table(result);
      }, function(error) {
        console.table(error);
        vm.dataloader = false;

      });
    }

    /**
     * 데이터 저장
     *
     * @param
     * @return
     * @author 최원영
    */
    function setData() {
      // 내용
      vm.data.tableNm = vm.srch.tableNm;
      vm.data.TableId = vm.data.BbsMasterId;

      var data = vm.data;

      if (vm.data.BbsMasterId == null || vm.data.BbsMasterId == '') {
        // 등록
        data.mapcode = "BbsMaster.insertBbsMasterDetail";
        postApi.insert(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      } else {
        // 수정
        data.mapCode = "BbsMaster.updateBbsMasterDetail";
        postApi.update(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (result.body.docs[0].BbsMasterId !== null || result.body.docs[0].TableId !== null) {
          // KeyId 조회
          vm.data.BbsMasterId = result.body.docs[0].BbsMasterId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              var srch = $stateParams.srch;

              if (vm.layout == 'N') {
                if (vm.srch.BbsMasterId == null || vm.srch.BbsMasterId == '') {
                  $state.go("app.bbspost.bbs-master-list", { srch: srch });
                } else {
                  // 조회 화면 이동
                  $state.go("app.bbspost.bbs-master-detail", {
                    srch: srch,
                    BbsMasterId: vm.data.BbsMasterId
                  });
                }
              } else {
                vm.srch.BbsMasterId = "";
                vm.srch.reload = (new Date()).getTime();
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.bbspost.bbs-master-list.detail", { srch: srch, BbsMasterId:vm.data.BbsMasterId });
              }
            }
          });
          return;
        }
      }
      console.table(result);
    }

    function goList() {
      vm.srch.BbsMasterId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go("app.bbspost.bbs-master-list", { srch: srch });
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 조회
    getData();

    }, ]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost.bbs-master-list-ctrl
 * @description
 * # 게시판관리 목록
 * Controller of the 게시판관리 목록
 */

webapp.controller('BbsMasterListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
/**
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param postApi - postApi Module
 */
  function BbsMasterListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'bbsmaster',
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        CustType : '',
        UseYN : '',
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'bbsmaster';
      if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.BbsMasterId;
    vm.listSize = [ 10, 25, 50, 100 ];


    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.srch.layout);

    // 회원사 변경 설정
    $scope.$on('broadcastSetChangeTenantID', function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.bbs-master-list', {srch:srch}, {reload:'app.bbspost.bbs-master-list'});
    }

    function resetSearch() {
      $state.go('app.bbspost.bbs-master-list', {srch : ''}, {reload:'app.bbspost.bbs-master-list'});
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getList() {
      vm.dataloader = true;
      vm.srch.page = vm.currentPage;

      getListCount();

      var data = vm.srch;
      data.mapCode = 'BbsMaster.getBbsMasterList';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getListCount() {
      var data = vm.srch;
      data.mapCode = 'BbsMaster.getBbsMasterListCnt';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error-getList', error);
      });
    }

    function goDetail(BbsMasterId) {
      var srch = $stateParams.srch;
      vm.keyId = BbsMasterId;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.bbs-master-detail', {
          srch : srch,
          BbsMasterId : BbsMasterId,
        });
      } else {
        $state.go('app.bbspost.bbs-master-list.detail', {
          srch : srch,
          BbsMasterId : BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.bbs-master-edit', {
          srch : srch,
          BbsMasterId : ''
        });
      } else {
        $state.go('app.bbspost.bbs-master-list.edit', {
          srch : srch,
          BbsMasterId : ''
        });
      }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.bbs-master-list', {srch:srch}, {reload:'app.bbspost.bbs-master-list'});
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.bbspost.bbs-master-list', {srch : srch}, {reload:'app.bbspost.bbs-master-list'});
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.resetSearch = resetSearch;
    vm.sortClass = sortClass;
    vm.tablesort = tablesort;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;

    // 데이터 조회
    getList();
  }, ]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.bbspost', {
      url : '/bbspost',
      template : '<div ui-view></div>',
    }).state('app.bbspost.h0101-list', {
      url : '/h0101-list/:BoardId',
      templateUrl : 'app/board/h0101-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.min.css',
          ]);
        }],
      },
    }).state('app.bbspost.h0101-detail', {
      url : '/h0101-detail/:BoardId/:FreeBoardId',
      templateUrl : 'app/board/h0101-detail.html',
    }).state('app.bbspost.h0101-edit', {
      url : '/h0101-edit/:BoardId/:FreeBoardId',
      templateUrl : 'app/board/h0101-edit.html',
    }).state('app.bbspost.h0102-list', {
      url : '/h0102-list/:srch/:BbsMasterId',
      templateUrl : 'app/board/h0102-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.h0102-edit', {
      url : '/h0102-edit/:srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    }).state('app.bbspost.h0102-detail', {
      url : '/h0102-detail/:srch/:BbsPostId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list.detail', {
      url : '/detail/:BbsPostId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list.edit', {
      url : '/edit/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    }).state('app.bbspost.bbs-master-list', {
      url : '/bbs-master-list/:srch',
      templateUrl : 'app/board/bbs-master-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.bbs-master-edit', {
      url : '/bbs-master-edit/:srch/:BbsMasterId',
      templateUrl : 'app/board/bbs-master-edit.html',
    }).state('app.bbspost.bbs-master-detail', {
      url : '/bbs-master-detail/:srch/:BbsMasterId',
      templateUrl : 'app/board/bbs-master-detail.html',
    }).state('app.bbspost.bbs-master-list.detail', {
      url : '/detail/:BbsMasterId',
      templateUrl : 'app/board/bbs-master-detail.html',
    }).state('app.bbspost.bbs-master-list.edit', {
      url : '/edit/:BbsMasterId',
      templateUrl : 'app/board/bbs-master-edit.html',
    })

    .state('app.bbspost.splitter', {
      url : '/splitter',
      templateUrl : 'app/board/splitter.html',
    })

    /* S : 고객상담관리/고객관리>고객등록 */
    .state('app.bbspost.h0103-list', {
      url : '/h0103-list/:srch',
      templateUrl : 'app/board/h0103-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.h0103-edit', {
      url : '/h0103-edit/:srch/:BbsPostId',
      templateUrl : 'app/board/h0103-edit.html',
    }).state('app.bbspost.h0103-detail', {
      url : '/h0103-detail/:srch/:BbsPostId',
      templateUrl : 'app/board/h0103-detail.html',
    }).state('app.bbspost.h0103-list.detail', {
      url : '/detail/:BbsPostId',
      templateUrl : 'app/board/h0103-detail.html',
    }).state('app.bbspost.h0103-list.edit', {
      url : '/edit/:BbsPostId',
      templateUrl : 'app/board/h0103-edit.html',
    })
    /* E : 고객상담관리/고객관리>고객등록 */
    /* 모달팝업 목록 */
    .state('app.bbspost.popup-list', {
      url : '/popup-list/:srch',
      templateUrl : 'app/board/popup-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.notice-board', {
      url : '/notice-board/:srch/:BbsMasterId',
      templateUrl : 'app/board/notice-board.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.notice-board.edit', {
      url : '/edit/:srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/notice-board-edit.html',
    }).state('app.bbspost.notice-board.detail', {
      url : '/detail/:srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/notice-board-detail.html',
    })
  }
})();

webapp.service('H0102APISrv', ['$resource', 'StaticVariable', '$rootScope',
  function H0102APISrv($resource, StaticVariable, $rootScope) {
    var bbspostApi = {
      doSelectListColumns: function() {
        return $resource(StaticVariable.getUrl('/select/MetaColumn.getSelectListColumns/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostListCnt/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doExcel: function() {
        return $resource(StaticVariable.getUrl('/excel/BbsPost.getExcelBbsPostList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostDetail/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.deleteBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSelectEditColumns: function() {
        return $resource(StaticVariable.getUrl('/select/MetaColumn.getSelectEditColumns/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/BbsPost.insertBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.updateBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcInsert.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcUpdate.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcDelete.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doFileList: function() {
        return $resource(StaticVariable.getUrl('/select/FileAttach.getFileList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveAttachFile: function() {
        return $resource(StaticVariable.getUrl('/attach/saveAttachFile.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      attachFileDelete: function() {
        return $resource(StaticVariable.getUrl('/attach/file/delete.do'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doReply: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveReply: function() {
        return $resource(StaticVariable.getUrl('/insert/BbsPost.insertBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteReply: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.deleteBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateReply: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.updateBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return bbspostApi;
  },
]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:h0102-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('H0102DetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'H0102APISrv', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          H0102APISvr - H0102APISvr Module
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function H0102DetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'board.notice', // For CustomColumn and FileAttachment
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if($window.sessionStorage.loginTenantId == "9SLLC9KELG"){
        vm.srch.BbsMasterId = "68VHJKH7TN";
      }else {
        vm.srch.BbsMasterId = "6Y024Q3ILI";
      }

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment
      vm.srchDetail.CodeType = "HdcBoardType";

      // 조회 데이터
      vm.data = {
        TableNm : vm.srchDetail.TableNm,
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      // 댓글
      vm.comment = {};

      // 댓글 조회 조건
      vm.srchReply = {
        BbsMasterId : vm.srch.BbsMasterId != '' ? vm.srch.BbsMasterId : 1,
        tableNm : 'bbspostcomm', // For CustomColumn and FileAttachment
        BbsPostId : vm.srch.BbsPostId,
        TableId : vm.srch.BbsPostId,
        IdName : 'BbsPostCommId', // For CustomColumn and FileAttachment
        viewSize : 100,
        LastId : 0,
      };
      // 옵션
      vm.items = [ {
        name : '공유',
        icon : 'zmdi zmdi-share'
      }, {
        name : '업로드',
        icon : 'zmdi zmdi-upload'
      }, {
        name : '복사',
        icon : 'zmdi zmdi-copy'
      }, {
        name : '현재 페이지 인쇄',
        icon : 'zmdi zmdi-print'
      }, ];

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];
      vm.uploadFileListReply = [];

      (function H0102DetailCtrl() {
        console.log('H0102DetailCtrl:');
      })();

      /**
       * 조회수 증가
       *
       * @param
       * @return
       */
      function updateReadCnt() {
        //doUpdateReadCnt없ㅇ므
        var prms = h0102Api.doUpdateReadCnt().post(vm.srch).$promise;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getFileList() {

        var data = vm.srchDetail;
        data.viewColumns = {};
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var uploadFileList = [];

              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              return;
            }
          }
        },function(error) {
          console.error('Error> h0102-detail-ctrl> getFileList()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }
      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        console.log("srchDetail", vm.srchDetail);
        postApi.select('BbsPost.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              console.log(vm.data);

              console.log($filter('utcToLocal')(vm.data.RegDate,'yyyy-MM-dd h:mm a'));

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> h0102-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      // 원본 이벤트
      var originatorEv;

      /**
       * 평점 표시
       *
       * @param {object}
       *          $mdOpenMenu - Open Menu Object
       * @param {object}
       *          ev - ev Object
       * @return
       */
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'BbsPost.deleteBbsPost';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.bbspost.h0102-list', {
                  srch:srch,
                  BbsMasterId : vm.srch.BbsMasterId
                }, {reload:'app.bbspost.h0102-list'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      }

      /**
       * 댓글 조회
       *
       * @param
       * @return
       */
      function getComment() {


        var data = vm.srchReply;
        data.mapCode = 'BbsPost.getBoardComment';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (vm.comment.lists == null) {
                vm.comment.lists = result.body.docs;
              } else {
                vm.comment.lists.append(result.body.docs);
              }
              vm.srchReply.LastId = result.body.docs[result.body.docs.length - 1].BbsPostCommId;
              return;
            }
          }
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> getReply()', status, error);
          gAlert('', result.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go('app.bbspost.h0102-list', {
                srch : srch
              });
            }
          });
        });
      }

      /**
       * 댓글 저장
       *
       * @param
       * @return
       */
      function saveComment() {
        if (angular.isUndefined(vm.srchReply.Contents) || vm.srchReply.Contents == null || vm.srchReply.Contents == '') {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        // 업로드 파일 목록
        vm.srchReply['uploadFileList'] = vm.uploadFileListReply;

        var data = vm.srchReply;
        data.mapCode = 'BbsPost.insertBoardComment';
        postApi.insert(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (result.body.docs[0].BbsPostCommId != 0) {
                vm.srchReply.Contents = '';
                vm.srchReply.uploadFileList = [];
                vm.uploadFileListReply = [];
                // 댓글 조회
                getComment();
                return;
              }
            }
          }
          console.error('Error> h0102-detail-ctrl> saveComment()', status, data);
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> saveComment()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }

      // 파일 삭제
      vm.setDeleteFileToggle = setDeleteFileToggle;

      /**
       * 파일 삭제
       *
       * @param
       * @return
       */
      function setDeleteFileToggle(replyObj) {
        var idx = -1;

        angular.forEach(vm.comment.lists, function(val, key) {
          if (val == replyObj) {
            idx = key;
            return;
          }
        });

        if (vm.comment.lists[idx].delState === '') {
          vm.comment.lists[idx].delState = 'delete';
        } else {
          vm.comment.lists[idx].delState = '';
        }
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteComment(replyObj) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteCommentAction(replyObj);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          tableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : 'delete',
            typeId : 'file',
          };
          uploadFileList.push(obj);
          srch['uploadFileList'] = uploadFileList;
        }
        var data = srch;
        data.mapCode = 'BbsPost.deleteBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            console.log('result',result);
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId == replyObj.BbsPostCommId) {
                  object.splice(index, 1);
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        },  function(error) {
          console.error('Error> h0102-detail-ctrl> deleteCommentAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editComment(BbsPostCommId) {
        vm.comment.editid = BbsPostCommId;

        vm.comment.lists.forEach(function(item, index, object) {
          if (item.BbsPostCommId === BbsPostCommId) {
            vm.comment.editContents = item.Contents;
          }
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          Contents : vm.comment.editContents,
          TableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId,
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : replyObj.delState,
            typeId : "file",
          }
          uploadFileList.push(obj);

          srch['uploadFileList'] = uploadFileList;
        }

        var data = srch;
        data.mapCode = 'BbsPost.updateBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId === replyObj.BbsPostCommId) {
                  item.Contents = result.body.docs[0].Contents;
                  vm.comment.editid = null;

                  if (item.delState === 'delete') {
                    item.AttachmentId = '';
                    item.PhysicalFileNm = '';
                    item.PhysicalFolderNm = '';
                    item.LogicalFileNm = '';
                    item.FileSize = '';
                    item.DownloadCnt = '';
                    item.delState = '';
                  }
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> editCommentAction()', status, error)
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정 취소
       *
       * @param
       * @return
       */
      function editCommentCancel() {
        vm.comment.editid = null;
        vm.comment.editContents = null;
      }

      vm.openDilalog = openDilalog;

      /**
       * 첨부파일 오픈 다이얼로그
       *
       * @param
       * @return
       */
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function() {
        uploadFiles(fileElement[0].files);
      });

      vm.uploadFiles = uploadFiles;

      /**
       * 첨부파일 업로드
       *
       * @param {object}
       *          files - 첨부 파일
       * @return
       */
      function uploadFiles(files) {
        var tempIds = [];

        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;

          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : fileUploadId,
                delState : ''
              };

              tempIds.push(obj);

              if (vm.uploadFileListReply == null)
                vm.uploadFileListReply = new Array();
              vm.uploadFileListReply.push(angular.copy(obj));
              fileUploadId++;
            }
          });

          if (hasZeroByteFile) {
            gAlert('', 'Menu.NOCONTENTS');
            return;
          }

          var request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
            });

            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.uploadFileListReply, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.tmpFileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?userkey=" + $rootScope.gVariable.userKey + "&fileName=" + item.encFileName);
                    obj.delState = '';
                  }
                });
              });

              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              vm.showLoading = false;
            }, function(error) {
              console.error('Error> h0102-detail-ctrl> uploadFiles()', status, error);
            });
          } catch (error) {
            console.error('Error> h0102-detail-ctrl> uploadFiles()', status, error);
          }
        });
      }
      ;

      vm.onDelete = onDelete;

      /**
       * 첨부파일 삭제 이벤트
       *
       * @param
       * @return
       */
      function onDelete(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.uploadFileListReply[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete().get({
              attachId : vm.uploadFileListReply[idx].tmpFileKey
            }).$promise;

            prms.then(function(data) {
              console.log('Success> h0102-detail-ctrl> onDelete()', data);
            }, function(error) {
              console.error('Error> h0102-detail-ctrl> onDelete()', status, error);
            })
            vm.uploadFileListReply.splice(idx, 1);
          } else if (vm.callback) {
            vm.uploadFileListReply[idx].delState = 'delete';
          }
        }
      }
      ;

      vm.onDeleteCancel = onDeleteCancel;

      /**
       * 첨부파일 삭제 취소 이벤트
       *
       * @param
       * @return
       */
      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.uploadFileListReply[idx].delState = '';
        }
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.bbspost.h0102-list', {
          srch : srch,
          BbsMasterId : vm.srch.BbsMasterId
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.bbspost.h0102-edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        } else {
          $state.go('app.bbspost.h0102-list.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      // 함수 선언
      vm.getData = getData;
      vm.getComment = getComment;
      vm.deleteData = deleteData;
      vm.saveComment = saveComment;
      vm.deleteComment = deleteComment;
      vm.editComment = editComment;
      vm.editCommentAction = editCommentAction;
      vm.editCommentCancel = editCommentCancel;
      vm.openMenu = openMenu;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;

      // 데이터 조회
      getData();

      getComment();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.bbspost:h0102-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("H0102EditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "H0102APISrv", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} H0102APISvr - H0102APISvr Module
   * @param {object} gAlert - Alert Module
   */
  function H0102EditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, postApi, customFieldApi, $rootScope, $timeout) {
    // View Model
    var LIST_PAGE_URL = 'app.bbspost.h0102-list';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.bbspost.h0102-list.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.bbspost.h0102-detail';           // 상세 화면

    var vm = this;
    vm.vault = null;

    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'board.notice', // For CustomColumn and FileAttachment
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } else {
      vm.srch.BbsMasterId = '6Y024Q3ILI';
    }

    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
    vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId
    };

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = h0102Api.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 사용자정의 컬럼 모델 설정
     *
     */
    function setUdcModel() {
      angular.forEach(Object.keys(vm.data), function(item) {
        // 사용자정의 컬럼 모델
        if (vm.udcDataType[item] == "40") {
          vm.udcModel[item] = $filter("date")(vm.data[item], "yyyy-MM-dd");
        } else {
          vm.udcModel[item] = vm.data[item];
        }
      });
    }

    /**
     * 첨부파일 목록 조회
     * @param
     * @return
     */
    function getFileList() {
      if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == '0') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srch;
      data.mapCode = "FileAttach.getFileList";
      postApi.select(data,
        function(result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {
              // AngularJS Version
              var uploadFileList = [];
              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    "/attach/file/" +
                      item.PhysicalFileNm +
                      "/download.do?path=" +
                      item.PhysicalPath +
                      "&fileName=" +
                      item.LogicalFileNm
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: "file",
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ""
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment

      postApi.select("BbsPost.getBbsPostDetail", vm.srchDetail, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {

      if(valid()){
        // 내용
        vm.dataloader = true;
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

        vm.data.BbsMasterId = vm.srch.BbsMasterId;
        vm.data.Contents = $("#strHtml").val();
        vm.data.tableNm = vm.srch.tableNm;
        vm.data.RelateDataId = vm.data.BbsPostId;
        vm.data.IdName = "BbsPostId";
        vm.data.uploadFileList = vm.uploadFileList;
        vm.data.userkey = vm.srch.userkey;

        var data = vm.data;
        if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
          // 등록
          data.mapCode = "BbsPost.insertBbsPost";
          postApi.insert(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        } else {
          // 수정
          data.mapCode = "BbsPost.updateBbsPost";
          postApi.update(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        }
    }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch, BbsMasterId : vm.srch.BbsMasterId });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch; // 검색 옵션

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch, BbsMasterId : vm.srch.BbsMasterId}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsPostId: vm.data.BbsPostId
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsPostId: vm.data.BbsPostId});
      }
    }

    function valid(){
      if(isNullOrEmpty(vm.data.Title)){
        gAlert("","제목을 입력해주세요.");
        return false;
      }else if(isNullOrEmpty(vm.data.BoardType)){
        gAlert("","게시판유형을 선택해주세요.");
        return false;
      }else if(isNullOrEmpty(vm.data.PublicYN)){
        gAlert("","공개여부를 선택해주세요.");
        return false;
      }else if(isNullOrEmpty(vm.data.NoticeYN)){
        gAlert("","공지여부를 선택해주세요.");
        return false;
      }else {
        return true;
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getData();
  }
]);

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.bbspost:h0102-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("H0102ListCtrl", [
  "$window",
  "$scope",
  "$location",
  "$state",
  "$stateParams",
  "$rootScope",
  "GLOBAL_CONSTANT",
  "postApi",
  "$compile",
  "modalFactory",
  "$translate",
  "$filter",
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function H0102ListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    postApi,
    $compile,
    modalFactory,
    $translate,
    $filter
  ) {
    var vm = this;
    vm.dataloader = false;

    vm.openModalUser = openModalUser;
    vm.clearUser = clearUser;

    if (!$stateParams.srch) {
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        tableNm: "board.notice", // For CustomColumn and FileAttachment
        sortDirect: "",
        sortColumn: "",
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = "board.notice"; // For CustomColumn and FileAttachment
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.BbsPostId;
    $scope.selectedRow = $stateParams.BbsPostId;
    if($window.sessionStorage.loginTenantId == "9SLLC9KELG"){
      vm.srch.BbsMasterId = "68VHJKH7TN";
    }else {
      vm.srch.BbsMasterId = "6Y024Q3ILI";
    }

    vm.srch.CodeType = "HdcBoardType";
    vm.BbsNm = "공지사항 게시판";

    //    $compile($('#pane'))($scope);

    vm.listSize = [10, 25, 50, 100];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    // 회원사 변경 설정
    $scope.$on("broadcastSetChangeTenantID", function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant("MSG.LISTUPDATED"));
    });

    // 엑셀
    vm.excel = {
      downFileName: "BbsPost",
      subject: "자유게시판 리스트",
      header: [
        {
          field: "BbsPostId",
          title: "번호",
          width: "5",
          format: "number",
        },
        {
          field: "Title",
          title: "제목",
          width: "20",
          format: "string",
        },
        {
          field: "RegUserNm",
          title: "등록자",
          width: "10",
          format: "string",
        },
        {
          field: "RegDate",
          title: "등록일자",
          width: "10",
          format: "date",
        },
        {
          field: "ReadCnt",
          title: "조회수",
          width: "5",
          format: "string",
        },
        {
          field: "Reviewer",
          title: "평가자",
          width: "5",
          format: "string",
        },
      ],
    };

    /*
    if ($window.sessionStorage.getItem('h0102-list-ctrl') !== null) {
      if ($rootScope.previousPage !== null &&
        ($rootScope.previousPage.indexOf('/app/bbspost/detail') !== -1 ||
        $rootScope.previousPage.indexOf('/app/bbspost/edit') !== -1)) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('h0102-list-ctrl'));
        vm.currentPage = vm.srch.page;
      }
    }
     */

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.getAddressInfo = getAddressInfo;
    $scope.showDetail = function (li) {
      $location.url("/" + li.BbsPostId);
    };
    vm.srch.ZipCode = "";
    vm.srch.Addr1 = "";
    /* 다음 주소검색 */
    function getAddressInfo() {
      new daum.Postcode({
        oncomplete: function (data) {
          vm.zipCode = data.zonecode;
          vm.addr1 =
            data.buildingName != ""
              ? data.address + " " + data.buildingName
              : data.address;
          $("#zipCode").val(vm.zipCode);
          $("#addr1").val(vm.addr1);
        },
      }).open();
    }

    /* 사용자검색 */
    function openModalUser() {
      var ctrl = "UserModalCtrl as modalCtrl";
      var paramData = { srchTenantId: $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open(
        "md",
        "components/modal/users/user-modal.html",
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (res) {
          vm.srch.UserNm = res.UserNm;
          vm.srch.UserId = res.UserId;
        },
        function (cancelData) {}
      );
    }
    /* 사용자검색- 지우기 */
    function clearUser() {
      vm.srch.UserNm = "";
      vm.srch.UserId = "";
    }

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == "N") return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getSearch();
    }

    function sortClass(sortkey) {
      if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

      var rtnval = "";

      if (vm.srch.sortDirect == "ASC") {
        rtnval = "fa fa-caret-down";
      } else {
        rtnval = "fa fa-caret-up";
      }
      return rtnval;
    }

    /* 단품(제품)조회 */
    function openModalPrd() {
      var ctrl = "ProductModalCtrl as modalCtrl";
      var paramData = { srchTenantId: $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open(
        "md",
        "components/modal/product/product-modal.html",
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (res) {
          vm.srch.ProductNm = res.ProductNm;
          vm.srch.ProductId = res.ProductId;
        },
        function (cancelData) {}
      );
    }
    /* 단품(제품)조회- 지우기 */
    function clearPrd() {
      vm.srch.ProductId = "";
      vm.srch.ProductNm = "";
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      vm.dataloader = true;
      vm.viewSize = vm.srch.viewSize;

      getListCnt();

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.selectType = "List"; // For CustomColumn
      data.mapCode = "BbsPost.getBbsPostList";
      console.log(data);
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
              console.log(vm.lists);
            } else {
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(
            vm.totalItems,
            vm.columnMap,
            vm.srch
          );
          vm.dataloader = false;
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.mapCode = "BbsPost.getBbsPostListCnt";
      postApi.select(data, function (result) {
          /* console.log("type C", result.header);
        console.log("type c", result.body); */
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getListCnt()", status, error);
        }
      );
    }

    function setResponsive(dockMode) {
      var rows = vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if (item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });

      // if(!checkMobile()) {
      //   var mode = {};
      //   var localStorage = window.localStorage;
      //   (dockMode == undefined) ?
      //     mode.type = localStorage.getItem("dockMode") : mode.type = dockMode;
      //   setDockView($compile, $scope, mode, function(){
      //     $('#searchTextResults').footable({
      //       "columns": columns,
      //       "rows": rows,
      //       "ctrState" : $state,
      //       "key" : "BbsPostId",
      //       "link" : "app.bbspost.h0102-slist.detail",
      //       "srch" : vm.srch,
      //       "FreeBoardId" : 'W'
      //     }, function(ft) {
      //       initFootableEvent(vm,ft, function(e){

      //         var url = "http://localhost:3000/#/app/bbspost/h0102-detail/%257B%2522page%2522%253A1%252C%2522viewSize%2522%253A25%252C%2522BbsMasterId%2522%253A1%252C%2522tableNm%2522%253A%2522bbspost%2522%252C%2522searchColumns%2522%253A%257B%2522Title%2522%253Atrue%252C%2522ExtVarchar01%2522%253Atrue%252C%2522ExtInt01%2522%253Atrue%252C%2522ExtInt02%2522%253Atrue%252C%2522ExtDate01%2522%253Atrue%252C%2522ExtVarchar02%2522%253Atrue%252C%2522ExtDate02%2522%253Atrue%252C%2522RegDate%2522%253Atrue%252C%2522ExtVarchar03%2522%253Atrue%257D%252C%2522userkey%2522%253A%25225GU7YVI51O%2522%252C%2522totalItems%2522%253A%255B32%255D%252C%2522BbsPostId%2522%253A%2522W%2522%257D";
      //         console.log(url);
      //         vm.detailContent = jQuery.get(url);
      //           console.log(vm.detailContent)

      //       });
      //     });
      //   });
      // }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.bbspost.h0102-list",
        { srch: srch },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    /**
     * 엑셀파일 다운로드
     * @param
     * @return
     * @author 최원영
     */
    function getExcel() {
      vm.excel.param = vm.srch;
      var data = vm.excel;

      data.mapCode = "BbsPost.getExcelBbsPostList";
      postApi.excel(
        data,
        function (result) {
          console.log("type C", result.header);
          console.log("type c", result.body);
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getExcel()", status, error);
        }
      );
      /*
      vm.excel.param = vm.srch;

      var prms = h0102Api.doExcel().post(vm.excel).$promise;

      prms.then(function(data) {
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getExcel()', status, error);
      }); */
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.bbspost.h0102-list",
        { srch: srch },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    function resetSearch() {
      $state.go(
        "app.bbspost.h0102-list",
        { srch: "" },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    function goDetail(BbsPostId) {
      //vm.srch.BbsPostId = BbsPostId;
      var srch = $stateParams.srch;
      vm.keyId = BbsPostId;
      $scope.selectedRow = BbsPostId;
      if (vm.layout == "N") {
        $state.go("app.bbspost.h0102-detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.bbspost.h0102-list.detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      vm.keyId = "";
      if (vm.layout == "N") {
        $state.go("app.bbspost.h0102-edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.bbspost.h0102-list.edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }
    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem("layoutBoard", layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go(
        "app.bbspost.h0102-list",
        {
          srch: srch,
        },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    function getBbsNm() {
      var data = { BbsMasterId: vm.srch.BbsMasterId };
      data.mapCode = "BbsMaster.getBbsMasterDetail";
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.BbsNm = result.body.docs[0].BbsNm;
            }
          }
          vm.dataloader = false;
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.getExcel = getExcel;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.setSortColumn = setSortColumn;
    vm.sortClass = sortClass;
    vm.clearPrd = clearPrd;
    vm.openModalPrd = openModalPrd;

    // 데이터 조회
    getBbsNm();
    getList();
  },
]);

webapp.service('H0102APISrv', ['$resource', 'StaticVariable', '$rootScope',
  function H0102APISrv($resource, StaticVariable, $rootScope) {
    var bbspostApi = {
      doSelectListColumns: function() {
        return $resource(StaticVariable.getUrl('/select/MetaColumn.getSelectListColumns/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostListCnt/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doExcel: function() {
        return $resource(StaticVariable.getUrl('/excel/BbsPost.getExcelBbsPostList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostDetail/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.deleteBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSelectEditColumns: function() {
        return $resource(StaticVariable.getUrl('/select/MetaColumn.getSelectEditColumns/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/BbsPost.insertBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.updateBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcInsert.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcUpdate.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcDelete.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doFileList: function() {
        return $resource(StaticVariable.getUrl('/select/FileAttach.getFileList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveAttachFile: function() {
        return $resource(StaticVariable.getUrl('/attach/saveAttachFile.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      attachFileDelete: function() {
        return $resource(StaticVariable.getUrl('/attach/file/delete.do'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doReply: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveReply: function() {
        return $resource(StaticVariable.getUrl('/insert/BbsPost.insertBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteReply: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.deleteBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateReply: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.updateBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return bbspostApi;
  },
]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:h0102-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('H0103DetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'H0102APISrv', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          H0102APISvr - H0102APISvr Module
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function H0103DetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;

      $scope.visbile = true;
      $scope.visbile2 = false;
      $scope.visbile3 = false;
      $scope.visbile4 = false;
      $scope.visbile5 = false;
      $scope.visbile6 = false;

      vm.srch = {};
      // 페이징
      if ($stateParams.srch) {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      if (vm.srch.layout == null)
        vm.layout = 'N';
      else
        vm.layout = vm.srch.layout;

      if ($stateParams.BbsPostId) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = [];

      // 조회 데이터
      vm.data = {
        TableNm : vm.srchDetail.TableNm,
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      console.log('vm.srchDetail=', vm.srchDetail);

      // 사용자정의 컬럼 폼
      vm.udcForm = {};

      // 사용자정의 컬럼 모델
      vm.udcModel = {};

      // 사용자정의 컬럼 데이터 타입
      vm.udcDataType = {};

      // 사용자정의 컬럼정보
      vm.udcColumns = [];

      // 사용자정의 컬럼 옵션
      vm.udcOptions = {
        formState : {
          horizontalLabelClass : '',
          horizontalFieldClass : '',
          readOnly : true
        }
      };

      // 사용자정의 컬럼 데이터
      vm.udcData = [];

      // 댓글
      vm.comment = {};

      // 댓글 조회 조건
      vm.srchReply = {
        BbsMasterId : vm.srch.BbsMasterId != '' ? vm.srch.BbsMasterId : 1,
        tableNm : vm.srch.tableNm !== null ? vm.srch.tableNm : 'bbspost',
        BbsPostId : vm.srch.BbsPostId,
        TableId : vm.srch.BbsPostId,
        viewSize : 100,
        LastId : 0,
      };
      // 옵션
      vm.items = [ {
        name : '공유',
        icon : 'zmdi zmdi-share'
      }, {
        name : '업로드',
        icon : 'zmdi zmdi-upload'
      }, {
        name : '복사',
        icon : 'zmdi zmdi-copy'
      }, {
        name : '현재 페이지 인쇄',
        icon : 'zmdi zmdi-print'
      }, ];

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];
      vm.uploadFileListReply = [];

      /**
       * 사용자정의 컬럼 모델 설정
       *
       */
      function setUdcModel() {
        angular.forEach(Object.keys(vm.data), function(item) {
          // 사용자정의 컬럼 모델
          if (vm.udcModel[item] !== undefined) {
            if (vm.udcDataType[item] == '40') {
              vm.udcModel[item] = $filter('date')(vm.data[item],'yyyy-MM-dd');
            } else {
              vm.udcModel[item] = vm.data[item];
            }
          }
        });
      }

      /**
       * 1) 화면 표시 컬럼 목록 2) 사용자정의 컬럼 모델 정보 3) 사용자정의 컬럼 정보
       *
       * @param
       * @return
       */
      function getSelectViewColumns() {
        var data = vm.srchDetail;
        data.viewColumns = {};
        data.mapCode = 'MetaColumn.getSelectEditColumns';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.allColumns = result.body.docs;

              angular.forEach(vm.allColumns, function(item) {

                // 화면 표시 컬럼 목록
                if (item.EditColumnShowYN === 'Y') {
                  vm.srchDetail.viewColumns[item.ColumnPhysicalNm] = true;
                }

                // 사용자정의 컬럼 모델 정보
                if (item.CustomColumnYN === 'Y') {
                  vm.udcModel[item.ColumnPhysicalNm] = '';
                  vm.udcDataType[item.ColumnPhysicalNm] = item.ColumnPhysicalDataType;
                }
              });

              // 사용자정의 컬럼 정보
              //setUdcColumns();
              vm.udcColumns = customFieldApi.setReadOnlyUdcColumns(vm.allColumns);

              // 데이터 조회
              getData();
            }
          }
        }, function(error) {
          console.table(error);
        });
      }

      /**
       * 조회수 증가
       *
       * @param
       * @return
       */
      function updateReadCnt() {
        //doUpdateReadCnt없ㅇ므
        var prms = h0102Api.doUpdateReadCnt().post(vm.srch).$promise;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getFileList() {

        var data = vm.srchDetail;
        data.viewColumns = {};
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var uploadFileList = [];

              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        },function(error) {
          console.table(error);
        });
      }
      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        postApi.select('BbsPost.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              // 사용자정의 컬럼 모델 적용
              if (vm.udcColumns.length > 0)
                setUdcModel();

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function(error) {
          console.table(error);
        });
      }

      // 원본 이벤트
      var originatorEv;

      /**
       * 평점 표시
       *
       * @param {object}
       *          $mdOpenMenu - Open Menu Object
       * @param {object}
       *          ev - ev Object
       * @return
       */
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data === null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.data;
        data.mapCode = 'BbsPost.deleteBbsPost';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                vm.srch.BbsPostId = '';
                var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go('app.bbspost.h0103-list', {
                  srch:srch
                }, {reload:'app.bbspost.h0103-list'});
              }
            });

          }
        }, function(error) {
          console.table(error);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      };

      /**
       * 댓글 조회
       *
       * @param
       * @return
       */
      function getComment() {


        var data = vm.srchReply;
        data.mapCode = 'BbsPost.getBoardComment';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (vm.comment.lists == null) {
                vm.comment.lists = result.body.docs;
              } else {
                vm.comment.lists.append(result.body.docs);
              }
              vm.srchReply.LastId = result.body.docs[result.body.docs.length - 1].BbsPostCommId;

            }
          }
        }, function(error) {
          console.table(error);
        });
      }

      /**
       * 댓글 저장
       *
       * @param
       * @return
       */
      function saveComment() {
        if (angular.isUndefined(vm.srchReply.Contents) || vm.srchReply.Contents == null || vm.srchReply.Contents == '') {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        // 업로드 파일 목록
        vm.srchReply['uploadFileList'] = vm.uploadFileListReply;

        var data = vm.srchReply;
        data.mapCode = 'BbsPost.insertBoardComment';
        postApi.insert(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (result.body.docs[0].BbsPostCommId != 0) {
                vm.srchReply.Contents = '';
                vm.srchReply.uploadFileList = [];
                vm.uploadFileListReply = [];
                // 댓글 조회
                getComment();
                return;
              }
            }
          }
          console.table(result);
        }, function(error) {
          console.table(error);
        });
      }

      // 파일 삭제
      vm.setDeleteFileToggle = setDeleteFileToggle;

      /**
       * 파일 삭제
       *
       * @param
       * @return
       */
      function setDeleteFileToggle(replyObj) {
        var idx = -1;

        angular.forEach(vm.comment.lists, function(val, key) {
          if (val == replyObj) {
            idx = key;

          }
        });

        if (vm.comment.lists[idx].delState === '') {
          vm.comment.lists[idx].delState = 'delete';
        } else {
          vm.comment.lists[idx].delState = '';
        }
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteComment(replyObj) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteCommentAction(replyObj);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          tableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : 'delete',
            typeId : 'file',
          };
          uploadFileList.push(obj);
          srch['uploadFileList'] = uploadFileList;
        }
        var data = srch;
        data.mapCode = 'BbsPost.deleteBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            console.log('result',result);
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId == replyObj.BbsPostCommId) {
                  object.splice(index, 1);
                }
              });
              return;
            }
          }
          console.table(result);
        },  function(error) {
          console.table(error);
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editComment(BbsPostCommId) {
        vm.comment.editid = BbsPostCommId;

        vm.comment.lists.forEach(function(item, index, object) {
          if (item.BbsPostCommId === BbsPostCommId) {
            vm.comment.editContents = item.Contents;
          }
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          Contents : vm.comment.editContents,
          TableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId,
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : replyObj.delState,
            typeId : "file",
          };
          uploadFileList.push(obj);

          srch['uploadFileList'] = uploadFileList;
        }

        var data = srch;
        data.mapCode = 'BbsPost.updateBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId === replyObj.BbsPostCommId) {
                  item.Contents = result.body.docs[0].Contents;
                  vm.comment.editid = null;

                  if (item.delState === 'delete') {
                    item.AttachmentId = '';
                    item.PhysicalFileNm = '';
                    item.PhysicalFolderNm = '';
                    item.LogicalFileNm = '';
                    item.FileSize = '';
                    item.DownloadCnt = '';
                    item.delState = '';
                  }
                }
              });
              return;
            }
          }
          console.table(result);
        }, function(error) {
          console.table(error);
        });
      }

      /**
       * 댓글 수정 취소
       *
       * @param
       * @return
       */
      function editCommentCancel() {
        vm.comment.editid = null;
        vm.comment.editContents = null;
      }

      vm.openDilalog = openDilalog;

      /**
       * 첨부파일 오픈 다이얼로그
       *
       * @param
       * @return
       */
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function() {
        uploadFiles(fileElement[0].files);
      });

      vm.uploadFiles = uploadFiles;

      /**
       * 첨부파일 업로드
       *
       * @param {object}
       *          files - 첨부 파일
       * @return
       */
      function uploadFiles(files) {
        var tempIds = [];

        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;

          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : fileUploadId,
                delState : ''
              };

              tempIds.push(obj);

              if (vm.uploadFileListReply == null)
                vm.uploadFileListReply = [];
              vm.uploadFileListReply.push(angular.copy(obj));
              fileUploadId++;
            }
          });

          if (hasZeroByteFile) {
            gAlert('', 'Menu.NOCONTENTS');
            return;
          }

          request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
            });

            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.uploadFileListReply, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.fileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?fileName=" + item.encFileName);
                    obj.delState = '';
                  }
                });
              });

              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              vm.showLoading = false;
            }, function(error) {
              console.table(error);
            });
          } catch (error) {
            console.table(error);
          }
        });
      }
      vm.onDelete = onDelete;

      /**
       * 첨부파일 삭제 이벤트
       *
       * @param
       * @return
       */
      function onDelete(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;

          }
        });

        if (idx != -1) {
          if (vm.uploadFileListReply[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete().get({
              attachId : vm.uploadFileListReply[idx].fileKey
            }).$promise;

            prms.then(function(data) {
              console.table(data);
            }, function(error) {
              console.table(error);
            });
            vm.uploadFileListReply.splice(idx, 1);
          } else if (vm.callback) {
            vm.uploadFileListReply[idx].delState = 'delete';
          }
        }
      }
      vm.onDeleteCancel = onDeleteCancel;

      /**
       * 첨부파일 삭제 취소 이벤트
       *
       * @param
       * @return
       */
      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;

          }
        });

        if (idx != -1) {
          vm.uploadFileListReply[idx].delState = '';
        }
      }

      function goList() {
        vm.srch.BbsPostId = '';
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go('app.bbspost.h0103-list', {
          srch : srch
        });
      }

      function goEdit() {
        vm.srch.BbsPostId = '';
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        if (vm.layout == 'N') {
          $state.go('app.bbspost.h0103-edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId
          });
        } else {
          $state.go('app.bbspost.h0103-list.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId
          });
        }
      }

      function setChangeTab(num){

        if (num == 0) {
          $scope.visbile = true;
          $scope.visbile1 = false;
          $scope.visbile2 = false;
          $scope.visbile3 = false;
          $scope.visbile4 = false;
        }
        else if (num == 1) {
          $scope.visbile = false;
          $scope.visbile1 = true;
          $scope.visbile2 = false;
          $scope.visbile3 = false;
          $scope.visbile4 = false;
        }
        else if (num == 2) {
          $scope.visbile = false;
          $scope.visbile1 = false;
          $scope.visbile2 = true;
          $scope.visbile3 = false;
          $scope.visbile4 = false;
        }
        else if (num == 3) {
          $scope.visbile = false;
          $scope.visbile2 = false;
          $scope.visbile3 = true;
          $scope.visbile4 = false;
          $scope.visbile5 = false;
        }
        else if (num == 4) {
          $scope.visbile = false;
          $scope.visbile2 = false;
          $scope.visbile3 = false;
          $scope.visbile4 = true;
          $scope.visbile5 = false;
        }
        else if (num == 5) {
          $scope.visbile = false;
          $scope.visbile2 = false;
          $scope.visbile3 = false;
          $scope.visbile4 = false;
          $scope.visbile5 = true;
        }
      }

      // 함수 선언
      vm.getData = getData;
      vm.getComment = getComment;
      vm.deleteData = deleteData;
      vm.saveComment = saveComment;
      vm.deleteComment = deleteComment;
      vm.editComment = editComment;
      vm.editCommentAction = editCommentAction;
      vm.editCommentCancel = editCommentCancel;
      vm.openMenu = openMenu;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.setChangeTab = setChangeTab;

      // 데이터 조회
      getSelectViewColumns();

      getComment();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.bbspost:h0102-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("H0103EditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "H0102APISrv", "gAlert", "postApi", "customFieldApi", "$rootScope",
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} H0102APISvr - H0102APISvr Module
   * @param {object} gAlert - Alert Module
   */
  function H0103EditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, postApi, customFieldApi, $rootScope) {
    // View Model
    var vm = this;

    vm.srch = {};
    // 페이징
    if ($stateParams.srch) {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    if (vm.srch.layout == null) vm.layout = "N";
    else vm.layout = vm.srch.layout;

    if ($stateParams.BbsPostId) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.srchDetail = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = [];

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 등록/수정 표시용 컬럼 목록
    vm.srchDetail.editColumns = {};
    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId
    };

    // 사용자정의 컬럼 폼
    vm.udcForm = {};

    // 사용자정의 컬럼 모델
    vm.udcModel = {};
    vm.udcDataType = {};

    // 사용자정의 컬럼정보
    vm.udcColumns = [];

    // 사용자정의 컬럼 옵션
    vm.udcOptions = {
      formState: {
        horizontalLabelClass: "",
        horizontalFieldClass: "",
        readOnly: false
      }
    };

    // 사용자정의 컬럼 데이터
    vm.udcData = [];

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploadComplete: function() {
        console.log("file items::", vm.uploadFileList);
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = h0102Api.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          console.log(data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      }
    };

    /**
     * 사용자정의 컬럼 모델 설정
     *
     */
    function setUdcModel() {
      angular.forEach(Object.keys(vm.data), function(item) {
        // 사용자정의 컬럼 모델
        if (vm.udcDataType[item] == "40") {
          vm.udcModel[item] = $filter("date")(vm.data[item], "yyyy-MM-dd");
        } else {
          vm.udcModel[item] = vm.data[item];
        }
      });
    }

    /**
     * 1) 화면 표시 컬럼 목록
     * 2) 사용자정의 컬럼 모델 정보
     * 3) 사용자정의 컬럼 정보
     * @param
     * @return
     */
    function getSelectEditColumns() {
      var data = vm.srchDetail;
      data.uploadFileList = [];
      data.viewColumns = {};
      data.mapCode = "MetaColumn.getSelectEditColumns";
      postApi.select(
        data,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.allColumns = result.body.docs;

              angular.forEach(vm.allColumns, function(item) {
                // 화면 표시 컬럼 목록
                if (item.EditColumnShowYN === "Y") {
                  vm.srchDetail.viewColumns[item.ColumnPhysicalNm] = true;
                }

                // 사용자정의 컬럼 모델 정보
                if (item.CustomColumnYN === "Y") {
                  vm.udcModel[item.ColumnPhysicalNm] = "";
                  vm.udcDataType[item.ColumnPhysicalNm] =
                    item.ColumnPhysicalDataType;
                }
              });

              // 사용자정의 컬럼 정보
              //setUdcColumns();
              vm.udcColumns = customFieldApi.setEditableUdcColumns(
                vm.allColumns
              );

              // 데이터 조회
              getData();
            }
          }
        },
        function(error) {
          console.error(
            "Error> h0103-detail-ctrl> getSelectViewColumns()",
            status,
            error
          );
        }
      );
    }

    /**
     * 첨부파일 목록 조회
     * @param
     * @return
     */
    function getFileList() {
      vm.showUploader = enableUploadComponent();

      if (vm.srch.BbsPostId === null || vm.srch.BbsPostId === 0) {
        return;
      }

      var data = vm.srch;
      data.mapCode = "FileAttach.getFileList";
      postApi.select(
        data,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {
              // AngularJS Version
              var uploadFileList = [];
              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    "/attach/file/" +
                      item.PhysicalFileNm +
                      "/download.do?path=" +
                      item.PhysicalPath +
                      "&fileName=" +
                      item.LogicalFileNm
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: "file",
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ""
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              return;
            } else {
              // JS Component Version
              initVaultComponent();
            }
          }
        },
        function(error) {
          console.error("Error> h0103-edit-ctrl> getFileList()", status, error);
          gAlert("", error.responseVO.body.docs[0].errMessage);
        }
      );
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == "0") {
        return;
      }

      postApi.select("BbsPost.getBbsPostDetail", vm.srchDetail,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              // 사용자정의 컬럼 모델 적용
              if (vm.udcColumns.length > 0) setUdcModel();

              // 첨부파일 목록 조회
              getFileList();

              return;
            }
          }
          gAlert("", result.body.docs[0].errMessage);
        },
        function(error) {
          console.error("Error> h0102-edit-ctrl> getData()", status, error);
          gAlert("", error.responseVO.body.docs[0].errMessage);
        }
      );
    }

    /**
     * 사용자정의 컬럼 데이터 저장
     */
    function setUdcData() {
      vm.data.udcData = [];

      angular.forEach(vm.udcColumns, function(items) {
        angular.forEach(items.fieldGroup, function(item) {
          var row = {};

          var udcCols = vm.allColumns.filter(function(x) {
            return x.ColumnPhysicalNm === item.key;
          })[0];

          //          var udcCols = vm.allColumns.filter(x => x.ColumnPhysicalNm === item.key)[0];

          if (udcCols !== undefined) {
            row.MetaTableId = udcCols.MetaTableId;
            row.MetaColumnId = udcCols.MetaColumnId;
            row.RelateDataId = vm.data.BbsPostId;
            row.TextValue = udcCols.ColumnPhysicalDataType === "10" || udcCols.ColumnPhysicalDataType === "50"? vm.udcModel[item.key] : "";
            row.IntegerValue = udcCols.ColumnPhysicalDataType === "20"? vm.udcModel[item.key] : "0";
            row.DoubleValue = udcCols.ColumnPhysicalDataType === "30"? vm.udcModel[item.key] : "0";
            row.DateValue = udcCols.ColumnPhysicalDataType === "40"? vm.udcModel[item.key] : "";

            vm.data.udcData.push(row);
          }
        });
      });

      var prms = null;

      if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == "0") {
        // 등록
        prms = h0102Api.doInsertUdcDetail().post(vm.data).$promise;
      } else {
        // 수정
        console.log("test,udc");
        prms = h0102Api.doUpdateUdcDetail().post(vm.data).$promise;
      }

      prms.then(
        function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            console.log(vm.srch);

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function() {
                if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == "0") {
                  $state.go("app.bbspost.h0103-list", {
                    tableNm: vm.data.tableNm,
                    BbsMasterId: vm.data.BbsMasterId,
                    srch: ""
                  });
                } else {
                  // 조회 화면 이동
                  $state.go("app.bbspost.h0103-detail", {
                    tableNm: vm.data.tableNm,
                    BbsMasterId: vm.data.BbsMasterId,
                    BbsPostId: vm.data.BbsPostId
                  });
                }
              }
            });
            return;
          }
          gAlert("", data.responseVO.body.docs[0].errMessage);
        },
        function(error) {
          console.error("Error> h0103-edit-ctrl> setData()", status, error);
          gAlert("", error.responseVO.body.docs[0].errMessage);
        }
      );
    }

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {
      // 내용
      oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

      vm.data.Contents = $("#strHtml").val();
      vm.data.tableNm = vm.srch.tableNm;
      vm.data.TableId = vm.data.BbsPostId;
      vm.data.IdName = "BbsPostId";
      vm.data.uploadFileList = vm.uploadFileList;
      vm.data.userkey = vm.srch.userkey;

      vm.data.udcData = [];

      angular.forEach(vm.udcColumns, function(items) {
        angular.forEach(items.fieldGroup, function(item) {
          var udcCols = vm.allColumns.filter(function(x) {
            return x.ColumnPhysicalNm === item.key;
          })[0];

          //          var udcCols = vm.allColumns.filter(x => x.ColumnPhysicalNm === item.key)[0];

          if (udcCols !== undefined) {
            vm.data[udcCols.ColumnPhysicalNm] = vm.udcModel[item.key];
          }
        });
      });

      var data = vm.data;
      console.log("data ::", vm.data);
      if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
        // 등록
        data.mapCode = "BbsPost.insertBbsPost";
        postApi.insert(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            console.error("Error> h0103-edit-ctrl> setData()", status, error);
            gAlert("", result.responseVO.body.docs[0].errMessage);
          }
        );
      } else {
        // 수정
        data.mapCode = "BbsPost.updateBbsPost";
        postApi.update(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            console.error("Error> h0103-edit-ctrl> setData()", status, error);
            gAlert("", result.responseVO.body.docs[0].errMessage);
          }
        );
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].BbsPostId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              var srch = "";

              if (vm.layout == 'N') {
                if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == "0") {
                  vm.srch.BbsPostId = "";
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  $state.go("app.bbspost.h0103-list", { srch: srch });
                } else {
                  // 조회 화면 이동
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  $state.go("app.bbspost.h0103-detail", {
                    srch: srch,
                    BbsPostId: vm.data.BbsPostId
                  });
                }
              } else {
                vm.srch.BbsPostId = "";
                vm.srch.reload = (new Date()).getTime();
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.bbspost.h0103-list.detail", { srch: srch, BbsPostId:vm.data.BbsPostId });
              }
            }
          });
          return;
        }
      }
      gAlert("", result.body.docs[0].errMessage);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go("app.bbspost.h0103-list", { srch: srch });
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getSelectEditColumns();
  }
]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost:h0102-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('H0103ListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', 'DTOptionsBuilder', 'DTColumnBuilder', '$compile',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function H0103ListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, postApi,DTOptionsBuilder, DTColumnBuilder, $compile) {

    var vm = this;
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId : $stateParams.srch.BbsMasterId ? $stateParams.srch.BbsMasterId : 1,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbspost',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.BbsMasterId = vm.srch.BbsMasterId ? vm.srch.BbsMasterId : 1;
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'bbspost';
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

//    $compile($('#pane'))($scope);

    vm.listSize = [ 10, 25, 50, 100 ];

    // 검색 조건 표시용 컬럼 목록
    vm.srch.searchColumns = {};
    vm.layout = 'N';
    vm.anchor = "";
    setLayout(vm.srch.layout);

    // 엑셀
    vm.excel = {
      downFileName : 'BbsPost',
      subject : '자유게시판 리스트',
      header : [ {
        field : 'BbsPostId',
        title : '번호',
        width : '5',
        format : 'number'
      }, {
        field : 'Title',
        title : '제목',
        width : '20',
        format : 'string'
      }, {
        field : 'RegUserNm',
        title : '등록자',
        width : '10',
        format : 'string'
      }, {
        field : 'RegDate',
        title : '등록일자',
        width : '10',
        format : 'date'
      }, {
        field : 'ReadCnt',
        title : '조회수',
        width : '5',
        format : 'string'
      }, {
        field : 'Reviewer',
        title : '평가자',
        width : '5',
        format : 'string'
      } ],
    };

    /*
    if ($window.sessionStorage.getItem('h0102-list-ctrl') !== null) {
      if ($rootScope.previousPage !== null &&
        ($rootScope.previousPage.indexOf('/app/bbspost/detail') !== -1 ||
        $rootScope.previousPage.indexOf('/app/bbspost/edit') !== -1)) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('h0102-list-ctrl'));
        vm.currentPage = vm.srch.page;
      }
    }
     */

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;

    $scope.showDetail = function(li) {
      $location.url('/' + li.BbsPostId);
    };

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {

      vm.viewSize = vm.srch.viewSize;

      getListCnt();

      var data = vm.srch;
      data.mapCode = 'BbsPost.getBbsPostList';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
            setResponsive();
          } else {
            vm.lists = {};
          }
        }
      }, function(error) {
        console.error('Error> h0103-list-ctrl> getList()', status, error);
      });

    }

    function getListCnt() {

      var data = vm.srch;
      data.mapCode = 'BbsPost.getBbsPostListCnt';
      postApi.select(data, function(result){
        /* console.log("type C", result.header);
        console.log("type c", result.body); */
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getListCnt()', status, error);
      });
    }

    function setResponsive(dockMode) {
      var rows =  vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md","lg", "md","xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function(item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if(o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if(item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString="YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });

      // if(!checkMobile()) {
      //   var mode = {};
      //   var localStorage = window.localStorage;
      //   (dockMode == undefined) ?
      //     mode.type = localStorage.getItem("dockMode") : mode.type = dockMode;
      //   setDockView($compile, $scope, mode, function(){
      //     $('#searchTextResults').footable({
      //       "columns": columns,
      //       "rows": rows,
      //       "ctrState" : $state,
      //       "key" : "BbsPostId",
      //       "link" : "app.bbspost.h0102-slist.detail",
      //       "srch" : vm.srch,
      //       "FreeBoardId" : 'W'
      //     }, function(ft) {
      //       initFootableEvent(vm,ft, function(e){

      //         var url = "http://localhost:3000/#/app/bbspost/h0102-detail/%257B%2522page%2522%253A1%252C%2522viewSize%2522%253A25%252C%2522BbsMasterId%2522%253A1%252C%2522tableNm%2522%253A%2522bbspost%2522%252C%2522searchColumns%2522%253A%257B%2522Title%2522%253Atrue%252C%2522ExtVarchar01%2522%253Atrue%252C%2522ExtInt01%2522%253Atrue%252C%2522ExtInt02%2522%253Atrue%252C%2522ExtDate01%2522%253Atrue%252C%2522ExtVarchar02%2522%253Atrue%252C%2522ExtDate02%2522%253Atrue%252C%2522RegDate%2522%253Atrue%252C%2522ExtVarchar03%2522%253Atrue%257D%252C%2522userkey%2522%253A%25225GU7YVI51O%2522%252C%2522totalItems%2522%253A%255B32%255D%252C%2522BbsPostId%2522%253A%2522W%2522%257D";
      //         console.log(url);
      //         vm.detailContent = jQuery.get(url);
      //           console.log(vm.detailContent)

      //       });
      //     });
      //   });
      // }
    }

    /**
     * 목록 화면에 표시할 컬럼 목록
     * @param
     * @return
     * @author 최원영
     */
    function getSelectListColumnList() {

      var data = vm.srch;
      data.mapCode = 'MetaColumn.getSelectListColumns';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.listColumns = result.body.docs;
            angular.forEach(vm.listColumns, function(item) {
              vm.srch.searchColumns[item.ColumnPhysicalNm] = true;
            });

            getList();

          }
        }
      }, function(error) {
        console.error('Error> h0103-list-ctrl> getListCnt()', status, error);
      });
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.h0103-list', {srch:srch}, {reload:'app.bbspost.h0103-list'});
    }

    /**
     * 엑셀파일 다운로드
     * @param
     * @return
     * @author 최원영
     */
    function getExcel() {

      vm.excel.param = vm.srch;
      var data = vm.excel;

      data.mapCode = 'BbsPost.getExcelBbsPostList';
      postApi.excel(data, function(result){
        console.log("type C", result.header);
        console.log("type c", result.body);
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getExcel()', status, error);
      });
/*
      vm.excel.param = vm.srch;

      var prms = h0102Api.doExcel().post(vm.excel).$promise;

      prms.then(function(data) {
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getExcel()', status, error);
      }); */
    }

    function changeViewSize() {

      console.log('11');
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      console.log('srch :: ch ::',vm.viewSize);
      getSearch();
    }

    function getSearch() {
//      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      console.log('srch :: ch ::',srch);
      $state.go('app.bbspost.h0103-list', {srch:srch}, {reload:'app.bbspost.h0103-list'});
    }

    vm.test = test;
    function test(id) {
      return "/app/bbspost/h0102-list/bbspost//"+id;
    }

    function goDetail(BbsPostId) {
      //vm.srch.BbsPostId = BbsPostId;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      if (vm.layout == 'N') {
        $state.go('app.bbspost.h0103-detail', {
          srch : srch,
          BbsPostId : BbsPostId,
        });
      } else {
        $state.go('app.bbspost.h0103-list.detail', {
          srch : srch,
          BbsPostId : BbsPostId,
        });
      }
    }

    function goEdit() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      if (vm.layout == 'N') {
        $state.go('app.bbspost.h0103-edit', {
          srch : srch, BbsPostId : ''
        });
      } else {
        $state.go('app.bbspost.h0103-list.edit', {
          srch : srch, BbsPostId : ''
        });
      }
    }

    function resetSearch() {
      $state.go('app.bbspost.h0103-list', {
        srch : ''
      }, {reload: 'app.bbspost.h0103-list'});
    }

    function setLayout(layout) {
      switch (layout) {
        case "H":
          vm.layout = "H";
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.layout = "V";
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.layout = "N";
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
        default:
          vm.layout = "N";
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      vm.srch.layout = layout;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.h0103-list', {
        srch : srch
      }, {reload: 'app.bbspost.h0103-list'});
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.getExcel = getExcel;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;


    // 데이터 조회
    getSelectListColumnList();

  },
]);
})();

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.bbspost:h0102-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('NoticeBoardCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', '$compile', 'modalFactory', '$translate', '$filter',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function NoticeBoardCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, postApi, $compile, modalFactory, $translate, $filter) {

          // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Tenant.getTenantCount'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Tenant.getTenantList';    // 목록 조회 SQL
      var EXCEL_SQL = 'BbsPost.getExcelBbsPostList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.bbspost.notice-board';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.company-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.company-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.company-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.company-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'tenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'TenantId'; // Primary Key Column
      var EXCEL_TITLE = '공지사항 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의





    var vm = this;
    vm.dataloader = false;

    vm.openModalUser = openModalUser;
    vm.clearUser = clearUser;

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'bbspost', // For CustomColumn and FileAttachment
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'bbspost'; // For CustomColumn and FileAttachment
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.BbsPostId;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } else {
      vm.srch.BbsMasterId = 1;
    }

    vm.BbsNm = '위너스 홈페이지 공지사항';

//    $compile($('#pane'))($scope);

    vm.listSize = [ 10, 25, 50, 100 ];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    // 회원사 변경 설정
    $scope.$on('broadcastSetChangeTenantID', function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    // // 엑셀
    // vm.excel = {
    //   downFileName : 'BbsPost',
    //   subject : '공지사항 리스트',
    //   header : [ {
    //     field : 'BbsPostId',
    //     title : '번호',
    //     width : '5',
    //     format : 'number'
    //   }, {
    //     field : 'Title',
    //     title : '제목',
    //     width : '20',
    //     format : 'string'
    //   }, {
    //     field : 'RegUserNm',
    //     title : '등록자',
    //     width : '10',
    //     format : 'string'
    //   }, {
    //     field : 'RegDate',
    //     title : '등록일자',
    //     width : '10',
    //     format : 'date'
    //   }, {
    //     field : 'ReadCnt',
    //     title : '조회수',
    //     width : '5',
    //     format : 'string'
    //   }, {
    //     field : 'Reviewer',
    //     title : '평가자',
    //     width : '5',
    //     format : 'string'
    //   } ],
    // };

    /*
    if ($window.sessionStorage.getItem('h0102-list-ctrl') !== null) {
      if ($rootScope.previousPage !== null &&
        ($rootScope.previousPage.indexOf('/app/bbspost/detail') !== -1 ||
        $rootScope.previousPage.indexOf('/app/bbspost/edit') !== -1)) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('h0102-list-ctrl'));
        vm.currentPage = vm.srch.page;
      }
    }
     */

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.getAddressInfo = getAddressInfo;
    $scope.showDetail = function(li) {
      $location.url('/' + li.BbsPostId);
    };
    vm.srch.ZipCode = "";
    vm.srch.Addr1 = "";
    /* 다음 주소검색 */
    function getAddressInfo(){
      new daum.Postcode({
        oncomplete: function(data) {
          vm.zipCode = data.zonecode;
          vm.addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
          $('#zipCode').val(vm.zipCode);
          $('#addr1').val(vm.addr1);
        },
      }).open();
   }

    /* 사용자검색 */
    function openModalUser() {
      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/users/user-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.UserNm = res.UserNm;
        vm.srch.UserId = res.UserId;
      }, function(cancelData) {
      });
    }
    /* 사용자검색- 지우기 */
    function clearUser() {
      vm.srch.UserNm = '';
      vm.srch.UserId = '';
    }

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }


    /* 단품(제품)조회 */
    function openModalPrd() {
      var ctrl = 'ProductModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.ProductNm = res.ProductNm;
        vm.srch.ProductId = res.ProductId;
      }, function(cancelData) {
      });
    }
    /* 단품(제품)조회- 지우기 */
    function clearPrd() {
      vm.srch.ProductId = '';
      vm.srch.ProductNm = '';
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      getListCnt();
      vm.dataloader = true;
      vm.viewSize = vm.srch.viewSize;

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
      data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
      data.selectType = 'List'; // For CustomColumn
      data.mapCode = 'BbsPost.getBbsPostList';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.listColumns = result.body.desc;
            angular.forEach(vm.listColumns, function(item) {
              vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }

          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
            setResponsive();
          } else {
            vm.lists = {};
          }
        }
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getList()', status, error);
        vm.dataloader = false;
      });

    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
      data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
      data.mapCode = 'BbsPost.getBbsPostListCnt';
      postApi.select(data, function(result){
        /* console.log("type C", result.header);
        console.log("type c", result.body); */
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getListCnt()', status, error);
      });
    }

    function setResponsive(dockMode) {
      var rows =  vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md","lg", "md","xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function(item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if(o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if(item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString="YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });

      // if(!checkMobile()) {
      //   var mode = {};
      //   var localStorage = window.localStorage;
      //   (dockMode == undefined) ?
      //     mode.type = localStorage.getItem("dockMode") : mode.type = dockMode;
      //   setDockView($compile, $scope, mode, function(){
      //     $('#searchTextResults').footable({
      //       "columns": columns,
      //       "rows": rows,
      //       "ctrState" : $state,
      //       "key" : "BbsPostId",
      //       "link" : "app.bbspost.h0102-slist.detail",
      //       "srch" : vm.srch,
      //       "FreeBoardId" : 'W'
      //     }, function(ft) {
      //       initFootableEvent(vm,ft, function(e){

      //         var url = "http://localhost:3000/#/app/bbspost/h0102-detail/%257B%2522page%2522%253A1%252C%2522viewSize%2522%253A25%252C%2522BbsMasterId%2522%253A1%252C%2522tableNm%2522%253A%2522bbspost%2522%252C%2522searchColumns%2522%253A%257B%2522Title%2522%253Atrue%252C%2522ExtVarchar01%2522%253Atrue%252C%2522ExtInt01%2522%253Atrue%252C%2522ExtInt02%2522%253Atrue%252C%2522ExtDate01%2522%253Atrue%252C%2522ExtVarchar02%2522%253Atrue%252C%2522ExtDate02%2522%253Atrue%252C%2522RegDate%2522%253Atrue%252C%2522ExtVarchar03%2522%253Atrue%257D%252C%2522userkey%2522%253A%25225GU7YVI51O%2522%252C%2522totalItems%2522%253A%255B32%255D%252C%2522BbsPostId%2522%253A%2522W%2522%257D";
      //         console.log(url);
      //         vm.detailContent = jQuery.get(url);
      //           console.log(vm.detailContent)

      //       });
      //     });
      //   });
      // }
    }


    /**
     * 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
    }

    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      getSearch();
    }

    function getSearch() {
//      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.notice-board', {srch:srch}, {reload:'app.bbspost.notice-board'});
    }

    function resetSearch() {
      $state.go('app.bbspost.notice-board', {srch : ''}, {reload:'app.bbspost.notice-board'});
    }

    vm.test = test;
    function test(id) {
      return "/app/bbspost/h0102-list/bbspost//"+id;
    }

    function goDetail(BbsPostId) {
      //vm.srch.BbsPostId = BbsPostId;
      var srch = $stateParams.srch;
      vm.keyId = BbsPostId;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.notice-board.detail', {
          srch : srch,
          BbsPostId : BbsPostId,
          BbsMasterId : vm.srch.BbsMasterId
        });
      } else {
        $state.go('app.bbspost.notice-board.detail', {
          srch : srch,
          BbsPostId : BbsPostId,
          BbsMasterId : vm.srch.BbsMasterId
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      vm.keyId = '';
      if (vm.layout == 'N') {
        $state.go('app.bbspost.notice-board.edit', {
          srch : srch, BbsPostId : '', BbsMasterId : 1
        });
      } else {
        $state.go('app.bbspost.notice-board.edit', {
          srch : srch, BbsPostId : '', BbsMasterId : 1
        });
      }
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.bbspost.notice-board', {
        srch : srch
      }, {reload: 'app.bbspost.notice-board'});
    }

    function getBbsNm() {
      var data = {BbsMasterId:vm.srch.BbsMasterId};
      data.mapCode = 'BbsMaster.getBbsMasterDetail';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.BbsNm = result.body.docs[0].BbsNm;
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error> notice-board-ctrl> getList()', status, error);
        vm.dataloader = false;
      });
    }

/**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        console.log(data);

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

    // 함수 선언
    vm.getList = getList;
    vm.getExcelFile = getExcelFile;
    vm.setChangeViewSize = setChangeViewSize;
    vm.setPageChanged = setPageChanged;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.tablesort = tablesort;
    vm.sortClass = sortClass;
    vm.clearPrd = clearPrd;
    vm.openModalPrd = openModalPrd;

    // 데이터 조회
    getBbsNm();
    getList();

  }
]);


(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:h0102-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('NoticeBoardDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'H0102APISrv', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          H0102APISvr - H0102APISvr Module
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function NoticeBoardDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbspost', // For CustomColumn and FileAttachment
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if (!isNullOrEmpty($stateParams.BbsMasterId)) {
        vm.srch.BbsMasterId = $stateParams.BbsMasterId;
      } else {
        vm.srch.BbsMasterId = 1;
      }

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        TableNm : vm.srchDetail.TableNm,
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      // 댓글
      vm.comment = {};

      // 댓글 조회 조건
      vm.srchReply = {
        BbsMasterId : vm.srch.BbsMasterId != '' ? vm.srch.BbsMasterId : 1,
        tableNm : 'bbspostcomm', // For CustomColumn and FileAttachment
        BbsPostId : vm.srch.BbsPostId,
        TableId : vm.srch.BbsPostId,
        IdName : 'BbsPostCommId', // For CustomColumn and FileAttachment
        viewSize : 100,
        LastId : 0,
      };
      // 옵션
      vm.items = [ {
        name : '공유',
        icon : 'zmdi zmdi-share'
      }, {
        name : '업로드',
        icon : 'zmdi zmdi-upload'
      }, {
        name : '복사',
        icon : 'zmdi zmdi-copy'
      }, {
        name : '현재 페이지 인쇄',
        icon : 'zmdi zmdi-print'
      }, ];

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];
      vm.uploadFileListReply = [];

      (function NoticeBoardDetailCtrl() {
        console.log('NoticeBoardDetailCtrl:');
      })();

      /**
       * 조회수 증가
       *
       * @param
       * @return
       */
      function updateReadCnt() {
        //doUpdateReadCnt없ㅇ므
        var prms = h0102Api.doUpdateReadCnt().post(vm.srch).$promise;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getFileList() {

        var data = vm.srchDetail;
        data.viewColumns = {};
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var uploadFileList = [];

              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              return;
            }
          }
        },function(error) {
          console.error('Error> Notice-Board-detail-ctrl> getFileList()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }
      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('BbsPost.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              console.log($filter('utcToLocal')(vm.data.RegDate,'yyyy-MM-dd h:mm a'));

              var uploadFileList = [];
              console.log("File", vm.data);
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> Notice-Board-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      // 원본 이벤트
      var originatorEv;

      /**
       * 평점 표시
       *
       * @param {object}
       *          $mdOpenMenu - Open Menu Object
       * @param {object}
       *          ev - ev Object
       * @return
       */
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'BbsPost.deleteBbsPost';
        console.log(data);
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.bbspost.notice-board', {
                  srch:srch
                }, {reload:'app.bbspost.notice-board'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> notice-board-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      }

      /**
       * 댓글 조회
       *
       * @param
       * @return
       */
      function getComment() {


        var data = vm.srchReply;
        data.mapCode = 'BbsPost.getBoardComment';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (vm.comment.lists == null) {
                vm.comment.lists = result.body.docs;
              } else {
                vm.comment.lists.append(result.body.docs);
              }
              vm.srchReply.LastId = result.body.docs[result.body.docs.length - 1].BbsPostCommId;
              return;
            }
          }
        }, function(error) {
          console.error('Error> notice-board-detail-ctrl> getReply()', status, error);
          gAlert('', result.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go('app.bbspost.notice-board', {
                srch : srch
              });
            }
          });
        });
      }

      /**
       * 댓글 저장
       *
       * @param
       * @return
       */
      function saveComment() {
        if (angular.isUndefined(vm.srchReply.Contents) || vm.srchReply.Contents == null || vm.srchReply.Contents == '') {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        // 업로드 파일 목록
        vm.srchReply['uploadFileList'] = vm.uploadFileListReply;

        var data = vm.srchReply;
        data.mapCode = 'BbsPost.insertBoardComment';
        postApi.insert(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (result.body.docs[0].BbsPostCommId != 0) {
                vm.srchReply.Contents = '';
                vm.srchReply.uploadFileList = [];
                vm.uploadFileListReply = [];
                // 댓글 조회
                getComment();
                return;
              }
            }
          }
          console.error('Error> notice-board-detail-ctrl> saveComment()', status, data);
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> notice-board-detail-ctrl> saveComment()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }

      // 파일 삭제
      vm.setDeleteFileToggle = setDeleteFileToggle;

      /**
       * 파일 삭제
       *
       * @param
       * @return
       */
      function setDeleteFileToggle(replyObj) {
        var idx = -1;

        angular.forEach(vm.comment.lists, function(val, key) {
          if (val == replyObj) {
            idx = key;
            return;
          }
        });

        if (vm.comment.lists[idx].delState === '') {
          vm.comment.lists[idx].delState = 'delete';
        } else {
          vm.comment.lists[idx].delState = '';
        }
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteComment(replyObj) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteCommentAction(replyObj);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          tableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : 'delete',
            typeId : 'file',
          };
          uploadFileList.push(obj);
          srch['uploadFileList'] = uploadFileList;
        }
        var data = srch;
        data.mapCode = 'BbsPost.deleteBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            console.log('result',result);
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId == replyObj.BbsPostCommId) {
                  object.splice(index, 1);
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        },  function(error) {
          console.error('Error> notice-board-detail-ctrl> deleteCommentAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editComment(BbsPostCommId) {
        vm.comment.editid = BbsPostCommId;

        vm.comment.lists.forEach(function(item, index, object) {
          if (item.BbsPostCommId === BbsPostCommId) {
            vm.comment.editContents = item.Contents;
          }
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          Contents : vm.comment.editContents,
          TableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId,
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : replyObj.delState,
            typeId : "file",
          }
          uploadFileList.push(obj);

          srch['uploadFileList'] = uploadFileList;
        }

        var data = srch;
        data.mapCode = 'BbsPost.updateBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId === replyObj.BbsPostCommId) {
                  item.Contents = result.body.docs[0].Contents;
                  vm.comment.editid = null;

                  if (item.delState === 'delete') {
                    item.AttachmentId = '';
                    item.PhysicalFileNm = '';
                    item.PhysicalFolderNm = '';
                    item.LogicalFileNm = '';
                    item.FileSize = '';
                    item.DownloadCnt = '';
                    item.delState = '';
                  }
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> notice-board-detail-ctrl> editCommentAction()', status, error)
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정 취소
       *
       * @param
       * @return
       */
      function editCommentCancel() {
        vm.comment.editid = null;
        vm.comment.editContents = null;
      }

      vm.openDilalog = openDilalog;

      /**
       * 첨부파일 오픈 다이얼로그
       *
       * @param
       * @return
       */
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function() {
        uploadFiles(fileElement[0].files);
      });

      vm.uploadFiles = uploadFiles;

      /**
       * 첨부파일 업로드
       *
       * @param {object}
       *          files - 첨부 파일
       * @return
       */
      function uploadFiles(files) {
        var tempIds = [];

        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;

          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : fileUploadId,
                delState : ''
              };

              tempIds.push(obj);

              if (vm.uploadFileListReply == null)
                vm.uploadFileListReply = new Array();
              vm.uploadFileListReply.push(angular.copy(obj));
              fileUploadId++;
            }
          });

          if (hasZeroByteFile) {
            gAlert('', 'Menu.NOCONTENTS');
            return;
          }

          var request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
            });

            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.uploadFileListReply, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.tmpFileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?userkey=" + $rootScope.gVariable.userKey + "&fileName=" + item.encFileName);
                    obj.delState = '';
                  }
                });
              });

              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              vm.showLoading = false;
            }, function(error) {
              console.error('Error> notice-board-detail-ctrl> uploadFiles()', status, error);
            });
          } catch (error) {
            console.error('Error> notice-board-detail-ctrl> uploadFiles()', status, error);
          }
        });
      }
      ;

      vm.onDelete = onDelete;

      /**
       * 첨부파일 삭제 이벤트
       *
       * @param
       * @return
       */
      function onDelete(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.uploadFileListReply[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete().get({
              attachId : vm.uploadFileListReply[idx].tmpFileKey
            }).$promise;

            prms.then(function(data) {
              console.log('Success> notice-board-detail-ctrl> onDelete()', data);
            }, function(error) {
              console.error('Error> notice-board-detail-ctrl> onDelete()', status, error);
            })
            vm.uploadFileListReply.splice(idx, 1);
          } else if (vm.callback) {
            vm.uploadFileListReply[idx].delState = 'delete';
          }
        }
      }
      ;

      vm.onDeleteCancel = onDeleteCancel;

      /**
       * 첨부파일 삭제 취소 이벤트
       *
       * @param
       * @return
       */
      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.uploadFileListReply[idx].delState = '';
        }
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.bbspost.notice-board', {
          srch : srch
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.bbspost.notice-board.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : 1
          });
        } else {
          $state.go('app.bbspost.notice-board.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : 1
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      // 함수 선언
      vm.getData = getData;
      vm.getComment = getComment;
      vm.deleteData = deleteData;
      vm.saveComment = saveComment;
      vm.deleteComment = deleteComment;
      vm.editComment = editComment;
      vm.editCommentAction = editCommentAction;
      vm.editCommentCancel = editCommentCancel;
      vm.openMenu = openMenu;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;

      // 데이터 조회
      getData();

      getComment();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.bbspost:h0102-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("NoticeBoardEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "H0102APISrv", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} H0102APISvr - H0102APISvr Module
   * @param {object} gAlert - Alert Module
   */
  function NoticeBoardEditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, postApi, customFieldApi, $rootScope, $timeout) {
    // View Model
    var LIST_PAGE_URL = 'app.bbspost.notice-board';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.bbspost.notice-board.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.bbspost.notice-board.detail';           // 상세 화면

    var vm = this;
    vm.vault = null;

    vm.dataloader = false;
    vm.boardTypes = ["공지사항", "NewsLetter", "위너스 소식"];


    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbspost', // For CustomColumn and FileAttachment
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } else {
      vm.srch.BbsMasterId = 1;
    }

    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
    vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId
    };

    (function H0102EditCtrl() {
      console.log('notice-board.Ctrl:');
    })();

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = h0102Api.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          console.log(data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 사용자정의 컬럼 모델 설정
     *
     */
    function setUdcModel() {
      angular.forEach(Object.keys(vm.data), function(item) {
        // 사용자정의 컬럼 모델
        if (vm.udcDataType[item] == "40") {
          vm.udcModel[item] = $filter("date")(vm.data[item], "yyyy-MM-dd");
        } else {
          vm.udcModel[item] = vm.data[item];
        }
      });
    }

    /**
     * 첨부파일 목록 조회
     * @param
     * @return
     */
    function getFileList() {
      if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == '0') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srch;
      data.mapCode = "FileAttach.getFileList";
      postApi.select(data,
        function(result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {
              // AngularJS Version
              var uploadFileList = [];
              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    "/attach/file/" +
                      item.PhysicalFileNm +
                      "/download.do?path=" +
                      item.PhysicalPath +
                      "&fileName=" +
                      item.LogicalFileNm
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: "file",
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ""
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment

      postApi.select("BbsPost.getBbsPostDetail", vm.srchDetail,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
            console.log("map",vm.columnMap);
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {
      // 내용
      vm.dataloader = true;
      oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

      vm.data.BbsMasterId = vm.srch.BbsMasterId;
      vm.data.Contents = $("#strHtml").val();
      vm.data.tableNm = 'bbspost';
      vm.data.RelateDataId = vm.data.BbsPostId;
      vm.data.IdName = "BbsPostId";
      vm.data.uploadFileList = vm.uploadFileList;
      vm.data.userkey = vm.srch.userkey;

      var data = vm.data;
      if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
        // 등록
        data.mapCode = "BbsPost.insertBbsPost";
        postApi.insert(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      } else {
        // 수정
        data.mapCode = "BbsPost.updateBbsPost";
        postApi.update(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch; // 검색 옵션

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsPostId: vm.data.BbsPostId,
            BbsMasterId : 1
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsPostId: vm.data.BbsPostId, BbsMasterId : 1});
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getData();
  }
]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost:popup-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('PopupListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', 'DTOptionsBuilder', 'DTColumnBuilder', '$compile', 'modalFactory',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function PopupListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, postApi,DTOptionsBuilder, DTColumnBuilder, $compile, modalFactory) {

    var vm = this;
    /* 사용자검색 */
    function openModalUser() {
      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.UserNm = res.UserNm;
        vm.srch.UserId = res.UserId;
      }, function(cancelData) {
      });
    }
    /* 사용자검색- 지우기 */
    function clearUser() {
      vm.srch.UserNm = '';
      vm.srch.UserId = '';
    }

    vm.srch = {
      ZipCode : "",
      Addr1 : ""
    }

    /* 다음 주소검색 */
    function getAddressInfo(){
      new daum.Postcode({
        oncomplete: function(data) {
          vm.zipCode = data.zonecode;
          vm.addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
          $('#zipCode').val(vm.zipCode);
          $('#addr1').val(vm.addr1);
        },
      }).open();

    }

    /* 단품(제품)조회 */
    function openModalPrd() {
      var ctrl = 'ProductModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.ProductNm = res.ProductNm;
        vm.srch.ProductId = res.ProductId;
      }, function(cancelData) {
      });
    }
    /* 단품(제품)조회- 지우기 */
    function clearPrd() {
      vm.srch.ProductId = '';
      vm.srch.ProductNm = '';
    }

    /* 관리권 검색 */
    vm.srch = {
      CareTktNm : '',
      CareTktId : ''
    }
    function openModalCareTkt() {
      var ctrl = 'CareTktModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {

        vm.srch.CareTktNm = res.CareTktNm;
        vm.srch.CareTktId = res.KeyId;

      }, function(cancelData) {
      });
    }
    /* 관리권검색- 지우기 */
    function clearCareTkt() {
      vm.srch.CareTktNm = '';
      vm.srch.CareTktId = '';
    }


    /* 고객검색 */
    function openModalCustomer() {
      var ctrl = 'CustomerModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('lg', 'components/modal/customer/customer-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.CustNm = res.CustNm;
        vm.srch.CustId = res.CustId;
      }, function(cancelData) {
      });
    }
    /* 고객검색- 지우기 */
    function clearCustomer() {
      vm.srch.CustNm = '';
      vm.srch.CustId = '';
    }

    // 함수 선언

    vm.clearPrd = clearPrd;
    vm.openModalPrd = openModalPrd;
    vm.openModalUser = openModalUser;
    vm.clearUser = clearUser;
    vm.getAddressInfo = getAddressInfo;
    vm.openModalCareTkt = openModalCareTkt;
    vm.clearCareTkt = clearCareTkt;
    vm.clearCustomer = clearCustomer;
    vm.openModalCustomer = openModalCustomer;
  },
]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.cafe24', {
      url: '/cafe24',
      template: '<div ui-view></div>',
    }).state('app.cafe24.product-list', {
      url: '/product-list/:srch',
      templateUrl: 'app/cafe24/product-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.cafe24.product-list.product-detail', {
      url: '/product-detail/:mall_id/:product_no',
      templateUrl: 'app/cafe24/product-detail.html',
    }).state('app.cafe24.product-detail', {
      url: '/product-detail/:srch/:mall_id/:product_no',
      templateUrl: 'app/cafe24/product-detail.html',
    }).state('app.cafe24.customer-list', {
      url: '/customer-list/:srch',
      templateUrl: 'app/cafe24/customer-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.cafe24.customer-list.customer-detail', {
      url: '/customer-detail/:member_id',
      templateUrl: 'app/cafe24/customer-detail.html',
    }).state('app.cafe24.customer-detail', {
      url: '/customer-detail/:srch/:member_id',
      templateUrl: 'app/cafe24/customer-detail.html',
    }).state('app.cafe24.order-list', {
      url: '/order-list/:srch',
      templateUrl: 'app/cafe24/order-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.cafe24.order-list.order-detail', {
      url: '/order-detail/:order_id',
      templateUrl: 'app/cafe24/order-detail.html',
    }).state('app.cafe24.order-detail', {
      url: '/order-detail/:srch/:order_id',
      templateUrl: 'app/cafe24/order-detail.html',
    }).state('app.cafe24.chart-list', {
      url: '/chart-list',
      templateUrl: 'app/cafe24/chart-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.cafe24.manage-ui', {
      url: '/manage-ui',
      templateUrl: 'app/cafe24/manage-ui.html',
    }).state('app.cafe24.log-list', {
      url: '/log-list/:srch',
      templateUrl: 'app/cafe24/log-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.cafe24.log-list.log-detail', {
      url: '/log-detail/:LogId',
      templateUrl: 'app/cafe24/log-detail.html',
    }).state('app.cafe24.log-detail', {
      url: '/log-detail/:srch/:LogId',
      templateUrl: 'app/cafe24/log-detail.html',
    }).state('app.cafe24.subscribe-list', {
      url: '/subscribe-list/:srch',
      templateUrl: 'app/cafe24/subscribe-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.cafe24.subscribe-list.subscribe-detail', {
      url: '/subscribe-detail/:subscribeId',
      templateUrl: 'app/cafe24/subscribe-detail.html',
    }).state('app.cafe24.subscribe-detail', {
      url: '/subscribe-detail/:srch/:subscribeId',
      templateUrl: 'app/cafe24/subscribe-detail.html',
    })
      .state('app.cafe24.subscribe-customer-list', {
      url: '/subscribe-customer-list/:srch',
      templateUrl: 'app/cafe24/subscribe-customer-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.cafe24.subscribe-customer-list.subscribe-customer-detail', {
      url: '/subscribe-customer-detail/:memberId',
      templateUrl: 'app/cafe24/subscribe-customer-detail.html',
    }).state('app.cafe24.subscribe-customer-detail', {
      url: '/subscribe-customer-detail/:srch/:memberId',
      templateUrl: 'app/cafe24/subscribe-customer-detail.html',
    })

    .state('app.cafe24.subscribe-prd-list', {
      url: '/subscribe-prd-list/:srch',
      templateUrl: 'app/cafe24/subscribe-prd-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.cafe24.subscribe-prd-list.subscribe-prd-detail', {
      url: '/subscribe-prd-detail/:productNo',
      templateUrl: 'app/cafe24/subscribe-prd-detail.html',
    }).state('app.cafe24.subscribe-prd-detail', {
      url: '/subscribe-prd-detail/:srch/:productNo',
      templateUrl: 'app/cafe24/subscribe-prd-detail.html',
    });
  }
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:chart-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('Cafe24ChartListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$filter', 'GLOBAL_CONSTANT', 'modalFactory', 'gAlert', 'gConfirm', '$interval',
  function Cafe24ChartListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $filter, CONSTANT, modalFactory, gAlert, gConfirm, $interval) {

    var vm = this;
    vm.data = {};
    vm.maintab = '1';

    vm.totalItem = { VocRegCnt : 0, VocCmCnt : 0 };

    vm.getGeneralinquiriesList = getGeneralinquiriesList;
    vm.getImpList = getImpList;
    vm.getContactcomplaintList = getContactcomplaintList;
    vm.getAdvancenotivocList = getAdvancenotivocList;
    vm.getDepartmentAvgList = getDepartmentAvgList;
    vm.getUpsurgeVocCntList = getUpsurgeVocCntList;
    vm.getNormalVocCntList = getNormalVocCntList;
    vm.getDisconVocCntList = getDisconVocCntList;
    vm.getPraiseVocCntList = getPraiseVocCntList;
    vm.getCoreVocCntList = getCoreVocCntList;
    vm.getMomUpsurgeVocCntList = getMomUpsurgeVocCntList;
    vm.getAvgVocCntList = getAvgVocCntList;
    vm.getVocEvCntList = getVocEvCntList;
    vm.getVocUseList = getVocUseList;
    vm.getEpeopleVocCntList = getEpeopleVocCntList;

    //vm.previousDay = moment(year+'-02').subtract(1, 'moths').endOf('month').format('YYYY-MM-DD');
    $scope.scrollTo = function (hash) {
      $location.hash(hash);
    };
    var today = new Date();
    var yesterday = new Date(today.valueOf() - (24*60*60*1000));
    var day = yesterday.getDate();

    vm.gi = {}, vm.imp = {}, vm.cmp = {}, vm.adnoti = {}, vm.dpavg = {}, vm.nor = {}, vm.dis = {}, vm.pra = {}, vm.core = {}, vm.avg = {}, vm.ev = {}

    vm.gi.StartDat = today.getFullYear() + '-01-01';
    vm.gi.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.imp.StartDat = today.getFullYear() + '-01-01';
    vm.imp.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.cmp.StartDat = today.getFullYear() + '-01-01';
    vm.cmp.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.adnoti.StartDat = today.getFullYear() + '-01-01';
    vm.adnoti.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.dpavg.StartDat = today.getFullYear() + '-01-01';
    vm.dpavg.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.nor.StartDat = today.getFullYear() + '-01-01';
    vm.nor.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.dis.StartDat = today.getFullYear() + '-01-01';
    vm.dis.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.pra.StartDat = today.getFullYear() + '-01-01';
    vm.pra.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.core.StartDat = today.getFullYear() + '-01-01';
    vm.core.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.avg.StartDat = today.getFullYear() + '-01-01';
    vm.avg.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    vm.ev.StartDat = today.getFullYear() + '-01-01';
    vm.ev.EndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

    // 파이차트 옵션
    vm.chartOptions = {
      series: {
        pie: {
          show: true,
          innerRadius: 0,
          stroke: {
            width: 0
          },
          label: {
            show: true,
            threshold: 0.05,
          },
        }
      },
      colors: ['#428bca','#5cb85c','#f0ad4e','#d9534f','#5bc0de','#616f77'],
      grid: {
        hoverable: true,
        clickable: true,
        borderWidth: 0,
        color: '#ccc'
      },
      tooltip: true,
      tooltipOpts: { content: '%s: %p.0%' }
    };

    vm.BarChart = {};

    vm.monthvoc = {};

    // Bar 차트 단일
    vm.monthvoc.options = {
      scales: {
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          display: true,
          position: 'left',
          ticks: {
            beginAtZero: true,
            ShowGridLines : true
          }
        }]
      },
      legend: {
        display : true,
        position : 'bottom'
      },
      tooltips: {
        callbacks : {
          label : function(tooltipItem, data) {
            label = tooltipItem.yLabel + '개';
            return label;
          }
        }
      }
    };

    // Bar 차트 다중
    vm.BarChart.mixcolors = ['#428bca','#f0ad4e'];
    vm.BarChart.mixdatasetOverride = [
      {
        label: "기한내 ",
        backgroundColor: [
          '#428bca',
          '#428bca',
          '#428bca',
          '#428bca',
          '#428bca',
          '#428bca'
        ],
        borderColor: [
          '#428bca',
          '#428bca',
          '#428bca',
          '#428bca',
          '#428bca',
          '#428bca'
        ],
        borderWidth: 2,
        type: 'bar',
        yAxisID: 'y-axis-2',
      },
      {
        label: "기한내 처리 건수",
        backgroundColor: [
          '#f0ad4e',
          '#f0ad4e',
          '#f0ad4e',
          '#f0ad4e',
          '#f0ad4e',
          '#f0ad4e'
        ],
        borderColor: [
          '#f0ad4e',
          '#f0ad4e',
          '#f0ad4e',
          '#f0ad4e',
          '#f0ad4e',
          '#f0ad4e'
        ],
        borderWidth: 2,
        type: 'bar',
        yAxisID: 'y-axis-3',
      }
    ];
    vm.BarChart.options = {

      scales: {
        yAxes: [
          {
            id: 'y-axis-2',
            type: 'linear',
            display: true,
            position: 'left',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            },
            scaleLabel: {
              display: true,
              labelString: '판매완료 건수'
            }
          },
          {
            id: 'y-axis-3',
            scaleLabel: {
              display: true,
              labelString: '우수판매 건수'
            },
            position: 'right',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            },
            gridLines : {
            display : false
          }
          }
        ]
      },
      legend: {
        display : true,
        position : 'bottom'
      },
      tooltips: {
        callbacks : {
          label : function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';

            if (label) {
              label = label + ': ' + tooltipItem.yLabel;
            }
            return label;
          }
        }
      }
    };

    $scope.dashboardMain = true;
    $scope.dashboardVocType = true;
    $scope.dashboardVocDept = true;
    $scope.dashboardStatistics = true;

    // 탭 클릭 이벤트
    $scope.fnClkTab = function(tabNum) {
      // Main
      if (tabNum == "1") {
        $scope.dashboardMain = true;
        $scope.dashboardVocType = true;
        $scope.dashboardVocDept = true;
        $scope.dashboardStatistics = true;
      }
      // VOC 분류별
      else if (tabNum == "2") {
        $scope.dashboardMain = false;
        $scope.dashboardVocType = true;
        $scope.dashboardVocDept = false;
        $scope.dashboardStatistics = false;
      }
      // VOC 부서별
      else if (tabNum == "3") {
        $scope.dashboardMain = false;
        $scope.dashboardVocType = false;
        $scope.dashboardVocDept = true;
        $scope.dashboardStatistics = false;
      }
      // 지표 관련
      else if (tabNum == "4") {
        $scope.dashboardMain = false;
        $scope.dashboardVocType = false;
        $scope.dashboardVocDept = false;
        $scope.dashboardStatistics = true;
      }
    }

    // 데이터조회
    vm.showListModal = function(data) {
      var ctrl = 'DashboardListModalCtrl as modalCtrl';

      var modalInstance = modalFactory.open('lg', 'views/modal/dashboard-list-modal.html', ctrl, data);

      modalInstance.result.then(function(okData) {
      }, function(cancelData) {
      });
    }

    var interval = null;

    // stops the interval
    /*$scope.$on("$destroy", function() {
      console.log('$scope.on $destroy');
      $interval.cancel(interval);
      interval = null;
    });*/

    /*function execInterval() {
      if ($window.sessionStorage['isLoggedIn'] == 'Y' && $rootScope.gVariable.autoUpdate == true) {
        getList();
      }
    }*/

    function getList() {
      vm.currenttime = moment().format('YYYY-MM-DD H:mm:ss');

      getInquiriesList();
      getGeneralinquiriesList();
      getContactcomplaintList();
      getImpList();
      getPraiseList();
      getCorevocList();
      getDeadlineComplievocList();
      getReanswerevocList();
      getMonthVocCnt();
      getAdvancenotivocList();
      getAvgcpdat();
      getDepartmentAvgList();
      getUpsurgeVocCntList();
      getNormalVocCntList();
      getDisconVocCntList();
      getPraiseVocCntList();
      getCoreVocCntList();
      getMomUpsurgeVocCntList();
      getAvgVocCntList();
      getVocEvCntList();
      getVocUseList();
      getEpeopleVocCntList();
    }

    if (interval == null && $window.sessionStorage['isLoggedIn'] == 'Y') {
      getList();
     // interval = $interval(execInterval, 180000);
    }

    function getInquiriesList() {
      var srch = {StartDat:'2018-12-31', EndDat:'SYSDATE'};

      vm.data.list0100 = [{Cnt1:34, Cnt2:18, Cnt3:15, Cnt4:4}];

      $scope.dataset0100 = [
        { label: '일반', data: vm.data.list0100[0].Cnt1 },
        { label: '기획', data: vm.data.list0100[0].Cnt2 },
        { label: '온라인', data: vm.data.list0100[0].Cnt3 },
        { label: '오프라인', data: vm.data.list0100[0].Cnt4 }
      ];
    }

    /* pie Chart 시작 - voc 유형별 분류 */
    $scope.options0100 = vm.chartOptions;
    /* pie Chart 종료 */

    /* pie Chart 시작 - voc 유형별 분류  - 부서별 칭찬 VOC 접수 현황 */
    function getPraiseList() {
      var srch = {StartDat:'2018-12-31', EndDat:'SYSDATE'};

      vm.dataloader = true;

      vm.data.list0104 = [
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 1,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10020",
          VocCnt: 2,
          DY: 1,
          ORGCHT_NM: "영업부",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10021",
          VocCnt: 1,
          ORGCHT_NM: "영업1팀",
          RCCnt: 0,
          DSCnt: 1
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10031",
          VocCnt: 1,
          ORGCHT_NM: "지원1팀",
          RCCnt: 0,
          DSCnt: 1
        },
        { VocCnt: 0, ORGCHT_NM: "기타" }
      ];

      $scope.dataset0104 = [];
      angular.forEach(vm.data.list0104, function(item) {
        var data = { label : item.ORGCHT_NM, data : item.VocCnt };
        $scope.dataset0104.push(data);
      });
    }

    $scope.options0104 = vm.chartOptions;
    /* pie Chart 종료 */

    /* 두번째 row pie chart 시작*/
    /* pie Chart 시작 - voc - 핵심 VOC */
    function getCorevocList() {
      var srch = {StartDat:'2018-12-31', EndDat:'SYSDATE'};

      vm.dataloader = true;

      vm.data.list0201 = [
        {
          APCnt: 2,
          OVCnt: 0,
          CPCnt: 2,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 1,
          CPBCnt: 1,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10020",
          VocCnt: 5,
          DY: 8,
          ORGCHT_NM: "영업부",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10021",
          VocCnt: 3,
          ORGCHT_NM: "영업1팀",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10022",
          VocCnt: 3,
          ORGCHT_NM: "영업2팀",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 1,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10031",
          VocCnt: 5,
          DY: 2,
          ORGCHT_NM: "지원1팀",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "103111",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "103112",
          VocCnt: 2,
          DY: 2,
          ORGCHT_NM: "지원2팀",
          RCCnt: 0,
          DSCnt: 1
        },
        {
          RGCnt: 0,
          CPGCnt: 4,
          APCnt: 0,
          OVCnt: 0,
          VocCnt: 6,
          DY: 8,
          ORGCHT_NM: "기타",
          CPCnt: 4,
          PRCnt: 0,
          RCCnt: 0,
          DSCnt: 2,
          CPBCnt: 0
        }
      ];

      $scope.dataset0201 = [];
      angular.forEach(vm.data.list0201, function(item) {
        var data = { label: item.ORGCHT_NM, data: item.VocCnt };
        $scope.dataset0201.push(data);
      });
    }

    $scope.options0201 = vm.chartOptions;

    /* bar Chart 시작 - 기한내 처리 건수 */
    function getDeadlineComplievocList() {
      var srch = {StartDat:'2018-12-31', EndDat:'SYSDATE'};

      vm.dataloader = true;

      vm.data.list0202 = [
        {
          APCnt: 5,
          OVCnt: 0,
          CPCnt: 81,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 3,
          CPBCnt: 15,
          RGCnt: 0,
          Rnum: 1,
          CPGCnt: 61,
          ORGCHT_CODE: "10020",
          VocCnt: 93,
          DY: 650,
          ORGCHT_NM: "영업부",
          RCCnt: 0,
          DSCnt: 4
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 3,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          Rnum: 2,
          CPGCnt: 3,
          ORGCHT_CODE: "10031",
          VocCnt: 5,
          DY: 5,
          ORGCHT_NM: "지원1팀",
          RCCnt: 0,
          DSCnt: 2
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "103113",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          Rnum: 3,
          CPGCnt: 1,
          ORGCHT_CODE: "103114",
          VocCnt: 1,
          DY: 2,
          ORGCHT_NM: "지원2팀",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          Rnum: 4,
          CPGCnt: 1,
          ORGCHT_CODE: "103111",
          VocCnt: 1,
          DY: 2,
          ORGCHT_NM: "지원3팀",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          Rnum: 5,
          CPGCnt: 1,
          ORGCHT_CODE: "10030",
          VocCnt: 4,
          DY: 1,
          ORGCHT_NM: "고객지원부",
          RCCnt: 0,
          DSCnt: 3
        }
      ];

      vm.BarChart.mixlabels = new Array();
      vm.BarChart.mixdata = new Array(new Array(1));

      angular.forEach(vm.data.list0202, function(item, index) {
        if(vm.data.list0202[index].Rnum == 1){
          vm.BarChart.options.scales.yAxes[0].ticks.max = vm.data.list0202[index].CPCnt + 1;
          vm.BarChart.options.scales.yAxes[1].ticks.max = vm.data.list0202[index].CPCnt + 1;
        }
        vm.BarChart.mixlabels[index] = item.ORGCHT_NM;

        var temp = new Array(new Array(1));

        vm.BarChart.mixdata[0][index] = item.CPCnt;
      });
    }

    /* pie Chart 시작 - 재처리율*/
    function getReanswerevocList() {
      var srch = {StartDat:'2018-12-31', EndDat:'SYSDATE'};

      vm.dataloader = true;

      vm.data.list0203 = [{ VocCnt: 0, ORGCHT_NM: "기타" }];

      $scope.dataset0203 = [];
      angular.forEach(vm.data.list0203, function(item) {
        var data = { label : item.ORGCHT_NM, data : item.VocCnt };
        $scope.dataset0203.push(data);
      });
    }

    $scope.options0203 = vm.chartOptions;
    /* pie Chart 종료 */

    /* bar Chart 시작 - 1. 월별 접수 건수(건) */
    function getMonthVocCnt() {
      vm.monthvoc.colors = ['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'];

      vm.monthvoc.datasetOverride = [
        {
          label: "월별 판매 건수(건) ",
          backgroundColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
          borderColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
          borderWidth: 2,
          type: 'bar',
          yAxisID: 'y-axis-1',
        }
      ];

      var today = new Date()
      var year = String(today.getFullYear());
      var lastyear = String(today.getFullYear()-1);
      var monthNames = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
      var data = {lists : []};

      var i = 1
      if (today.getMonth()+1 == 1) {
        while (i < 13){
          var lastDay = ( new Date( year, i, 0) ).getDate();
          data.lists.push({StrDate : lastyear+'-'+i+'-01', EndDate : lastyear+'-'+i+'-'+lastDay, Name : monthNames[i-1]});
          i++;
        }
      } else {
        while (i < today.getMonth()+1){
          var lastDay = String((new Date( year, i, 0)).getDate());
          data.lists.push({StrDate : year+'-'+i+'-01', EndDate : year+'-'+i+'-'+lastDay, Name : monthNames[i-1]});
          i++;
        }
      }

      var lists = {
        JUL: 30,
        FEB: 10,
        JUN: 1,
        APR: 6,
        AUG: 46,
        MAY: 2,
        JAN: 1,
        MAR: 10
      };

      vm.monthvoc.options.scales.yAxes[0].ticks.max = 0;

      vm.monthvoc.data = new Array(new Array(1));

      vm.monthvoc.labels = ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'];
      vm.monthvoc.data[0][0] = lists.JAN;
      vm.monthvoc.data[0][1] = lists.FEB;
      vm.monthvoc.data[0][2] = lists.MAR;
      vm.monthvoc.data[0][3] = lists.APR;
      vm.monthvoc.data[0][4] = lists.MAY;
      vm.monthvoc.data[0][5] = lists.JUN;
      vm.monthvoc.data[0][6] = lists.JUL;
      vm.monthvoc.data[0][7] = lists.AUG;
      vm.monthvoc.data[0][8] = lists.SEP;
      vm.monthvoc.data[0][9] = lists.OCT;
      vm.monthvoc.data[0][10] = lists.NOV;
      vm.monthvoc.data[0][11] = lists.DEC;

      angular.forEach(vm.monthvoc.data[0], function(item,index){
        if (vm.monthvoc.options.scales.yAxes[0].ticks.max < vm.monthvoc.data[0][index]+5) {
          vm.monthvoc.options.scales.yAxes[0].ticks.max = vm.monthvoc.data[0][index] + 5;
        }
      });
    }

    /* bar Chart 시작 - 2. 전월대비 문의 증가 유형(Top3) */
    function getMomUpsurgeVocCntList() {
      var today = new Date();
      var NowStrDat  = today.getFullYear() + '-' + (today.getMonth()) + '-' + (today.getDate());
      var NowEndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + (today.getDate()-1);

      var LastStrDat = today.getFullYear() + '-' + (today.getMonth()-1) + '-' + (today.getDate());
      var LastEndDat = today.getFullYear() + '-' + (today.getMonth()) + '-' + (today.getDate()-1);

      vm.momupgvoc = {};
      vm.momupgvoc.colors = ['#47a4f1','#ffa14b'];
      vm.momupgvoc.datasetOverride = [
        {
          label: today.getMonth()+'월',
          backgroundColor: ['#47a4f1', '#47a4f1', '#47a4f1'],
          borderColor: ['#47a4f1', '#47a4f1', '#47a4f1'],
          borderWidth: 2,
          type: 'bar',
          yAxisID: 'y-axis-1',
        },
        {
          label: (today.getMonth()+1)+'월',
          backgroundColor: ['#ffa14b', '#ffa14b', '#ffa14b'],
          borderColor: ['#ffa14b', '#ffa14b', '#ffa14b'],
          borderWidth: 2,
          type: 'bar',
          yAxisID: 'y-axis-2',
        }
      ];

      vm.momupgvoc.options = {
        scales: {
          yAxes: [
            {
              id: 'y-axis-1',
              type: 'linear',
              display: true,
              position: 'left',
              ticks: {
                beginAtZero: true,
                ShowGridLines : true
              }
            },
            {
              id: 'y-axis-2',
              position: 'right',
              display:false,
              ticks: {
                beginAtZero: true,
                ShowGridLines : true
              },
              gridLines : {
              display : false
            }
            }
          ],
          xAxes: [
            {
              id: 'x-axis-1',
              ticks: {
                multiline: true,
                autoSkip: false
              }
            }
          ]
        },
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                label = label + ': ' + tooltipItem.yLabel+'건';
              }
              return label;
            }
          }
        }
      };

      vm.dataloader = true;
      vm.momupgvoc.data = new Array(new Array(),new Array());
      vm.momupgvoc.labels = [];

      var nowsrch = {NowStrDat:NowStrDat, NowEndDat:NowEndDat};
      vm.data.momlastupglist = new Array(new Array());

      vm.data.momnowupglist = [
        {
           Rnum:1,
           VOCSERVICEPCD2:"VSP01",
           VOCSERVICEPCD2NM:"P00000CF",
           VOCSERVICEPCD1:"VSP01",
           VOCSERVICEPCD1NM:"P00000CD",
           VOCSERVICEPCD:"VSP01",
           VOCSERVICEPCDNM:"P00000CC"
        },
        {
           Rnum:1,
           VOCSERVICEPCD2:"VSP01",
           VOCSERVICEPCD2NM:"P00000BW",
           VOCSERVICEPCD1:"VSP01",
           VOCSERVICEPCD1NM:"P00000BV",
           VOCSERVICEPCD:"VSP01",
           VOCSERVICEPCDNM:"P00000CZ"
        }
      ];
      var ymax1 = 0;
      var ymax2 = 0;

      if (vm.data.momnowupglist.length > 0) {
        angular.forEach(vm.data.momnowupglist, function(item, index) {
          if (item.VOCSERVICEPCD1NM != undefined && item.VOCSERVICEPCD2NM == undefined) {
            vm.momupgvoc.labels[index] = [item.VOCSERVICEPCD1NM]
          } else if (item.VOCSERVICEPCD1NM != undefined && item.VOCSERVICEPCD2NM != undefined) {
            vm.momupgvoc.labels[index] = [item.VOCSERVICEPCD1NM, "- " + item.VOCSERVICEPCD2NM]
          }
          vm.momupgvoc.data[0][index] = 120;
          vm.momupgvoc.data[1][index] = 100;

        });

        angular.forEach(vm.momupgvoc.data[1], function(item,index){
          if (ymax2 < vm.momupgvoc.data[1][index]+5) {
            ymax2 = vm.momupgvoc.data[1][index] + 5;
          }
        });

        if (ymax1 > ymax2) {
          vm.momupgvoc.options.scales.yAxes[0].ticks.max = ymax1
          vm.momupgvoc.options.scales.yAxes[1].ticks.max = ymax1
        } else {
          vm.momupgvoc.options.scales.yAxes[0].ticks.max = ymax2
          vm.momupgvoc.options.scales.yAxes[1].ticks.max = ymax2
        }

      } else {
        vm.momupgvoc.data[1][0] = 0;
        vm.momupgvoc.labels = '';
      }
    }

    /* bar Chart 시작 - 3. 실시간 문의 급증 유형(Top5) */
    function getUpsurgeVocCntList() {
      var today = new Date();
      var daysago = 3;
      var oldday = new Date(today-(3600000*24*daysago));
      var UpgStrDat = oldday.getFullYear() + '-' + (oldday.getMonth()+1) + '-' + oldday.getDate();
      var UpgEndDat = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();

      var srch = {StartDat:UpgStrDat, EndDat:UpgEndDat};

      vm.upgvoc = {};
      vm.upgvoc.colors = ['#a7df56','#dfc556','#ed9c58','#ed6958','#ca60ee'];
      vm.upgvoc.datasetOverride = [
        {
          backgroundColor:['#a7df56','#dfc556','#ed9c58','#ed6958','#ca60ee'],
          borderColor:['#a7df56','#dfc556','#ed9c58','#ed6958','#ca60ee'],
          borderWidth: 1,
          type: 'doughnut'
        }
      ];

      vm.upgvoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.data.upglist = [
        {
          Rnum: 1,
          VOCSERVICEPCD2NM: "P00000CF",
          VOCSERVICEPCD1NM: "상품1",
          VOCCNT: 10,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 2,
          VOCSERVICEPCD2NM: "P00000CD",
          VOCSERVICEPCD1NM: "상품2",
          VOCCNT: 15,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 3,
          VOCSERVICEPCD2NM: "P00000CG",
          VOCSERVICEPCD1NM: "상품3",
          VOCCNT: 30,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 4,
          VOCSERVICEPCD2NM: "P00000DF",
          VOCSERVICEPCD1NM: "상품4",
          VOCCNT: 23,
          VOCSERVICEPCDNM: "분류2"
        },
        {
          Rnum: 5,
          VOCSERVICEPCD2NM: "P00000DG",
          VOCSERVICEPCD1NM: "상품5",
          VOCCNT: 21,
          VOCSERVICEPCDNM: "분류2"
        }
      ];

      vm.upgvoc.data = new Array(new Array(1));
      vm.upgvoc.labels = [];

      if (vm.data.upglist.length > 0) {
        angular.forEach(vm.data.upglist, function(item, index) {
          if (item.VOCSERVICEPCD2NM != undefined) {
            vm.upgvoc.labels[index] = [item.VOCSERVICEPCD1NM + "  - " + item.VOCSERVICEPCD2NM]
          } else {
            vm.upgvoc.labels[index] = [item.VOCSERVICEPCD1NM]
          }
          vm.upgvoc.data[0][index] = 100;
        });

      } else {
        vm.upgvoc.data[0][0] = 100;
        vm.upgvoc.data[0][1] = 100;
        vm.upgvoc.data[0][2] = 100;
        vm.upgvoc.data[0][3] = 100;
        vm.upgvoc.data[0][4] = 100;
        vm.upgvoc.labels = '';
      }

      console.log(vm.upgvoc);
    }

    /* bar Chart 시작 - 4. VOC 분류별 일반문의(Top5) */
    function getNormalVocCntList() {
      $scope.norStDate = $rootScope.getDateFormat(vm.nor.StartDat);
      $scope.norEdDate = $rootScope.getDateFormat(vm.nor.EndDat);
      var srch = {StartDat:vm.nor.StartDat, EndDat:vm.nor.EndDat};

      vm.norvoc = {};
      vm.norvoc.colors = ['#6d7cef','#6d9cef','#6dbcef','#70daec','#74e7d0'];
      vm.norvoc.datasetOverride = [
        {
          backgroundColor:['#6d7cef','#6d9cef','#6dbcef','#70daec','#74e7d0'],
          borderColor:['#6d7cef','#6d9cef','#6dbcef','#70daec','#74e7d0'],
          borderWidth: 1,
          type: 'doughnut',
        }
      ];

      vm.norvoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.dataloader = true;

      vm.data.norlist = [
        {
          Rnum: 1,
          VOCSERVICEPCD2NM: "P00000CF",
          VOCSERVICEPCD1NM: "상품1",
          VOCCNT: 19,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 2,
          VOCSERVICEPCD2NM: "P00000CD",
          VOCSERVICEPCD1NM: "상품2",
          VOCCNT: 5,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 3,
          VOCSERVICEPCD2NM: "P00000CG",
          VOCSERVICEPCD1NM: "상품3",
          VOCCNT: 3,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 4,
          VOCSERVICEPCD2NM: "P00000DF",
          VOCSERVICEPCD1NM: "상품4",
          VOCCNT: 3,
          VOCSERVICEPCDNM: "분류2"
        },
        {
          Rnum: 5,
          VOCSERVICEPCD2NM: "P00000DG",
          VOCSERVICEPCD1NM: "상품5",
          VOCCNT: 2,
          VOCSERVICEPCDNM: "분류2"
        }
      ];
      //vm.norvoc.options.scales.yAxes[0].ticks.max = 0;

      vm.norvoc.data = new Array(new Array(1));
      vm.norvoc.labels = [];

      angular.forEach(vm.data.norlist, function(item, index) {
        if (item.VOCSERVICEPCD2NM != undefined) {
          vm.norvoc.labels[index] = [item.VOCSERVICEPCD1NM + "  - " + item.VOCSERVICEPCD2NM]
        } else {
          vm.norvoc.labels[index] = [item.VOCSERVICEPCD1NM]
        }
        vm.norvoc.data[0][index] = item.VOCCNT;
      });

    }

    /* bar Chart 시작 - 4. VOC 분류별 불만(Top5) */
    function getDisconVocCntList() {
      $scope.disStDate = $rootScope.getDateFormat(vm.dis.StartDat);
      $scope.disEdDate = $rootScope.getDateFormat(vm.dis.EndDat);
      var srch = {StartDat:vm.dis.StartDat, EndDat:vm.dis.EndDat};

      vm.disvoc = {};
      vm.disvoc.colors = ['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'];
      vm.disvoc.datasetOverride = [
        {
          backgroundColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
          borderColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
          borderWidth: 1,
          type: 'doughnut'
        }
      ];

      vm.disvoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.data.dislist = [
        {
          Rnum: 1,
          VOCSERVICEPCD2NM: "P00000CF",
          VOCSERVICEPCD1NM: "상품1",
          VOCCNT: 19,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 2,
          VOCSERVICEPCD2NM: "P00000CD",
          VOCSERVICEPCD1NM: "상품2",
          VOCCNT: 5,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 3,
          VOCSERVICEPCD2NM: "P00000CG",
          VOCSERVICEPCD1NM: "상품3",
          VOCCNT: 3,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 4,
          VOCSERVICEPCD2NM: "P00000DF",
          VOCSERVICEPCD1NM: "상품4",
          VOCCNT: 3,
          VOCSERVICEPCDNM: "분류2"
        },
        {
          Rnum: 5,
          VOCSERVICEPCD2NM: "P00000DG",
          VOCSERVICEPCD1NM: "상품5",
          VOCCNT: 2,
          VOCSERVICEPCDNM: "분류2"
        }
      ];

      vm.disvoc.data = new Array(new Array(1));
      vm.disvoc.labels = [];

      angular.forEach(vm.data.dislist, function(item, index) {
        if (item.VOCSERVICEPCD2NM != undefined) {
          vm.disvoc.labels[index] = [item.VOCSERVICEPCD1NM + "  - " + item.VOCSERVICEPCD2NM]
        } else {
          vm.disvoc.labels[index] = [item.VOCSERVICEPCD1NM]
        }
        vm.disvoc.data[0][index] = item.VOCCNT;
      });
    }

    /* 부서별로 보여주기 위해 주석처리 후 수정 / 2019-08-29 / 김진혁 */
    /* bar Chart 시작 - 4. VOC 분류별 칭찬(Top5)
    function getPraiseVocCntList() {
      $scope.praStDate = $rootScope.getDateFormat(vm.pra.StartDat);
      $scope.praEdDate = $rootScope.getDateFormat(vm.pra.EndDat);
      var srch = {StartDat:vm.pra.StartDat, EndDat:vm.pra.EndDat};

      vm.pravoc = {};
      vm.pravoc.colors = ['#20c997','#22b6bc','#228fbc','#2268bc','#264ec5'];
      vm.pravoc.datasetOverride = [
        {
          backgroundColor:['#20c997','#22b6bc','#228fbc','#2268bc','#264ec5'],
          borderColor:['#20c997','#22b6bc','#228fbc','#2268bc','#264ec5'],
          borderWidth: 1,
          type: 'doughnut'
        }
      ];

      vm.pravoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.dataloader = true;

      var prms = api.getPraiseVocList().post(srch).$promise;
      prms.then(function(data) {
        vm.dataloader = false;
        if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.data.pralist = data.responseVO.body.docs;

          vm.pravoc.data = new Array(new Array(1));
          vm.pravoc.labels = [];

          angular.forEach(vm.data.pralist, function(item, index) {
            if (item.VOCSERVICEPCD2NM != undefined) {
              vm.pravoc.labels[index] = [item.VOCSERVICEPCD1NM + "  - " + item.VOCSERVICEPCD2NM]
            } else {
              vm.pravoc.labels[index] = [item.VOCSERVICEPCD1NM]
            }
            vm.pravoc.data[0][index] = item.VOCCNT;
          });
        }
      },function(error) {
        vm.dataloader = false;
        console.error('fail', status, data);
      });
    }*/

    /* bar Chart 시작 - 4. VOC 분류별 핵심VOC(Top5) */
    function getCoreVocCntList() {
      $scope.coreStDate = $rootScope.getDateFormat(vm.core.StartDat);
      $scope.coreEdDate = $rootScope.getDateFormat(vm.core.EndDat);
      var srch = {StartDat:vm.core.StartDat, EndDat:vm.core.EndDat};

      vm.corevoc = {};
      vm.corevoc.colors = ['#d37cd2','#a878d5','#7877e0','#6ea2e9','#6ecfe9'];
      vm.corevoc.datasetOverride = [
        {
          backgroundColor:['#d37cd2','#a878d5','#7877e0','#6ea2e9','#6ecfe9'],
          borderColor:['#d37cd2','#a878d5','#7877e0','#6ea2e9','#6ecfe9'],
          borderWidth: 1,
          type: 'doughnut'
        }
      ];

      vm.corevoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.dataloader = true;

      vm.data.corelist = [
        {
          APCnt: 2,
          OVCnt: 0,
          CPCnt: 2,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 1,
          CPBCnt: 1,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10020",
          VocCnt: 5,
          DY: 8,
          ORGCHT_NM: "영업부",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10021",
          VocCnt: 3,
          ORGCHT_NM: "영업1팀",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10022",
          VocCnt: 3,
          ORGCHT_NM: "영업2팀",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 1,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10031",
          VocCnt: 5,
          DY: 2,
          ORGCHT_NM: "지원1팀",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "103111",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "103112",
          VocCnt: 2,
          DY: 2,
          ORGCHT_NM: "유지보수1팀",
          RCCnt: 0,
          DSCnt: 1
        },
        {
          RGCnt: 0,
          CPGCnt: 4,
          APCnt: 0,
          OVCnt: 0,
          VocCnt: 6,
          DY: 8,
          ORGCHT_NM: "기타",
          CPCnt: 4,
          PRCnt: 0,
          RCCnt: 0,
          DSCnt: 2,
          CPBCnt: 0
        }
      ];

      vm.corevoc.data = new Array(new Array(1));
      vm.corevoc.labels = [];

      angular.forEach(vm.data.corelist, function(item, index) {
        if (item.ORGCHT_CODE != undefined) {
          vm.corevoc.labels[index] = [item.ORGCHT_CODE + "  - " + item.ORGCHT_NM]
        } else {
          vm.corevoc.labels[index] = [item.ORGCHT_NM]
        }
        vm.corevoc.data[0][index] = item.VocCnt;
      });
    }

    /* bar Chart 시작 - 5. 월별 평균 처리일 */
    function getAvgcpdat() {
      vm.avgcpdat = {};

      vm.avgcpdat.colors = ['#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca'];

      vm.avgcpdat.datasetOverride = [
        {
          label: "월별 평균 처리일 ",
          backgroundColor:['#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca','#428bca'],
          borderColor:['#428bca'],
          borderWidth: 2,
          type: 'line',
          yAxisID: 'y-axis-1',
          fill: false,
        }
      ];

      vm.avgcpdat.options = {
        scales: {
          yAxes: [{
            id: 'y-axis-1',
            type: 'linear',
            display: true,
            position: 'left',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            },
          }]
        },
        annotation: {
          annotations: [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-1',
              borderColor: '#DF0101',
              borderWidth: 2,
              label: {
                enabled: true,
                position: 'right',
                fontColor: '#000',
                fontSize: 11,
                borderColor: '#fff',
                backgroundColor: '#fff',
                xAdjust: -4,
                yAdjust: -11,
              }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-1',
            borderColor: '#DF0101',
            borderWidth: 2,
            label: {
              enabled: true,
              content: 'UCL',
              position: 'right',
              fontColor: '#000',
              fontSize: 11,
              borderColor: '#fff',
              backgroundColor: '#fff',
              xAdjust: -4,
              yAdjust: -11,
            }
          }],
        },
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.datasets[0].data[tooltipItem.index] + '일';
              var test = data.datasets[0].data[tooltipItem.index];
              return label;
            }
          }
        }
      };
      var today = new Date()
      var year = String(today.getFullYear());
      var lastyear = String(today.getFullYear()-1);
      var monthNames = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
      var data = {lists : []};

      var i = 1
      if (today.getMonth()+1 == 1) {
        while (i < 13){
          var lastDay = ( new Date( year, i, 0) ).getDate();
          data.lists.push({StrDate : lastyear+'-'+i+'-01', EndDate : lastyear+'-'+i+'-'+lastDay, DYName : monthNames[i-1]+"DY", CNTName : monthNames[i-1]+"CNT"});
          i++;
        }
      } else {
        while (i < today.getMonth()+1){
          var lastDay = String((new Date( year, i, 0)).getDate());
          data.lists.push({StrDate : year+'-'+i+'-01', EndDate : year+'-'+i+'-'+lastDay, DYName : monthNames[i-1]+"DY", CNTName : monthNames[i-1]+"CNT"});
          i++;
        }
      }

      var lists = {
        APRDY: 142,
        MAYDY: 0,
        FEBDY: 5,
        JUNDY: 1,
        MAYCNT: 1,
        MARDY: 1,
        JULDY: 17,
        AUGCNT: 6,
        JANCNT: 0,
        AUGDY: 17,
        MARCNT: 10,
        FEBCNT: 9,
        JANDY: 0,
        APRCNT: 3,
        JUNCNT: 1,
        JULCNT: 12
      };

      vm.avgcpdat.options.scales.yAxes[0].ticks.max = 0;

      vm.avgcpdat.data = new Array(new Array(1));
      vm.avgcpdat.labels = ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'];
      vm.avgcpdat.data[0][0] = (lists.JANDY != 0 && lists.JANCNT != 0) ? $filter('number')(lists.JANDY / lists.JANCNT, 1) : 0;
      vm.avgcpdat.data[0][1] = (lists.FEBDY != 0 && lists.FEBCNT != 0) ? $filter('number')(lists.FEBDY / lists.FEBCNT, 1) : 0;
      vm.avgcpdat.data[0][2] = (lists.MARDY != 0 && lists.MARCNT != 0) ? $filter('number')(lists.MARDY / lists.MARCNT, 1) : 0;
      vm.avgcpdat.data[0][3] = (lists.APRDY != 0 && lists.APRCNT != 0) ? $filter('number')(lists.APRDY / lists.APRCNT, 1) : 0;
      vm.avgcpdat.data[0][4] = (lists.MAYDY != 0 && lists.MAYCNT != 0) ? $filter('number')(lists.MAYDY / lists.MAYCNT, 1) : 0;
      vm.avgcpdat.data[0][5] = (lists.JUNDY != 0 && lists.JUNCNT != 0) ? $filter('number')(lists.JUNDY / lists.JUNCNT, 1) : 0;
      vm.avgcpdat.data[0][6] = (lists.JULDY != 0 && lists.JULCNT != 0) ? $filter('number')(lists.JULDY / lists.JULCNT, 1) : 0;
      vm.avgcpdat.data[0][7] = (lists.AUGDY != 0 && lists.AUGCNT != 0) ? $filter('number')(lists.AUGDY / lists.AUGCNT, 1) : 0;
      vm.avgcpdat.data[0][8] = (lists.SEPDY != 0 && lists.SEPCNT != 0) ? $filter('number')(lists.SEPDY / lists.SEPCNT, 1) : 0;
      vm.avgcpdat.data[0][9] = (lists.OCTDY != 0 && lists.OCTCNT != 0) ? $filter('number')(lists.OCTDY / lists.OCTCNT, 1) : 0;
      vm.avgcpdat.data[0][10] = (lists.NOVDY != 0 && lists.NOVCNT != 0) ? $filter('number')(lists.NOVDY / lists.NOVCNT, 1) : 0;
      vm.avgcpdat.data[0][11] = (lists.DECDY != 0 && lists.DECCNT != 0) ? $filter('number')(lists.DECDY / lists.DECCNT, 1) : 0;

      var maxdata = 0;
      angular.forEach(vm.avgcpdat.data[0], function(item,index){
        if (maxdata < Number(vm.avgcpdat.data[0][index])+ 5) {
          maxdata = Number(vm.avgcpdat.data[0][index]) + 5;
        }
      });
      vm.avgcpdat.options.scales.yAxes[0].ticks.max = Math.ceil(maxdata);
      if (today.getMonth()+1 == 1) {
        var srchdate = {StrDate : lastyear+'-01-01', EndDate : lastyear+'12-31'};
      } else {
        var lastMonth = String(today.getMonth());
        var lastDay = String((new Date( year, lastMonth, 0)).getDate());
        var srchdate = {StrDate : year+'-01-01', EndDate : year+'-'+lastMonth+'-' + lastDay};
      }
      var sumdata = 0;
      var num = 0;

      vm.data.dylist = [
        { DY: 0 },
        { DY: 0 },
        { DY: 0 },
        { DY: 0 },
        { DY: 0 },
        { DY: 0 },
        { DY: 0 },
        { DY: 0 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 1 },
        { DY: 2 },
        { DY: 2 },
        { DY: 2 },
        { DY: 2 },
        { DY: 2 },
        { DY: 6 },
        { DY: 7 },
        { DY: 9 },
        { DY: 61 },
        { DY: 72 },
        { DY: 0 },
        { DY: 0 },
        { DY: 0 },
        { DY: 0 },
        { DY: 0 },
        { DY: 0 }
      ];
      var srch = {};
      vm.data.propertiesList = [
        {
          CodeId: "1",
          CodeValue: "70",
          Code: "UPPER",
          OprtDttm: "2019-09-03 16:02",
          Remark: "Upper",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "2",
          CodeValue: "88",
          Code: "LOWER",
          OprtDttm: "2019-08-29 15:10",
          Remark: "Lower",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "3",
          CodeValue: "1",
          Code: "RECODEDATE",
          OprtDttm: "2019-09-03 15:57",
          Remark: "목표기준일",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "4",
          CodeValue: "2018년 4분기",
          Code: "STARTQUARTER",
          OprtDttm: "2019-09-03 15:35",
          Remark: "시작분기",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "5",
          CodeValue: "현재분기",
          Code: "ENDQUARTER",
          OprtDttm: "2019-09-03 15:43",
          Remark: "현재분기",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "6",
          CodeValue: "20",
          Code: "VOCUSESRATE",
          OprtDttm: "2019-08-29 15:08",
          Remark: "고객의소리활용률",
          RegiDttm: "2019-08-09 13:17"
        }
      ];
      angular.forEach(vm.data.propertiesList, function(item) {
        if (item.CodeId == '1') {
          var UCL = item.CodeValue;
          var UCLData = 100-UCL;
          var lowData = Math.ceil((num * Number((UCLData/10),1)) / 2);

          var i = 0;

          while(lowData > i) {
            if (vm.data.dylist[i] != undefined) {
              sumdata = sumdata - vm.data.dylist[i].DY;
              sumdata = sumdata - vm.data.dylist[(num-1)-i].DY;
            }
            i++;
          }
          vm.avgcpdat.options.annotation.annotations[1].value = (sumdata / (num-(lowData*2))).toFixed(2);
        } else if (item.CodeId == '3') {
          vm.avgcpdat.options.annotation.annotations[0].value = item.CodeValue;
          vm.avgcpdat.options.annotation.annotations[0].label.content = item.CodeValue+'일';
        }
      });

      angular.forEach(vm.data.dylist, function(item) {
        sumdata = sumdata + item.DY
      });
      num = vm.data.dylist.length;
    }
    /* bar Chart 종료 */

    /* bar Chart 시작 - 6. 부서별 VOC 접수 현황 일반문의(Top5) */
    function getGeneralinquiriesList() {
      $scope.giStDate = $rootScope.getDateFormat(vm.gi.StartDat);
      $scope.giEdDate = $rootScope.getDateFormat(vm.gi.EndDat);
      var srch = {StartDat:vm.gi.StartDat, EndDat:vm.gi.EndDat};

      vm.givoc = {};
      vm.givoc.colors = ['#6d7cef','#6d9cef','#6dbcef','#70daec','#74e7d0'];
      vm.givoc.datasetOverride = [
        {
          backgroundColor:['#6d7cef','#6d9cef','#6dbcef','#70daec','#74e7d0'],
          borderColor:['#6d7cef','#6d9cef','#6dbcef','#70daec','#74e7d0'],
          borderWidth: 1,
          type: 'doughnut'
        }
      ];

      vm.givoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.data.list0101 = [
        {
          APCnt: 2,
          OVCnt: 0,
          CPCnt: 24,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 2,
          CPBCnt: 3,
          RGCnt: 0,
          CPGCnt: 16,
          ORGCHT_CODE: "10020",
          VocCnt: 29,
          DY: 151,
          ORGCHT_NM: "영업부",
          RCCnt: 0,
          DSCnt: 1
        },
        {
          APCnt: 1,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10031",
          VocCnt: 2,
          DY: 1,
          ORGCHT_NM: "지원1팀",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10022",
          VocCnt: 1,
          DY: 1,
          ORGCHT_NM: "영업2팀",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10021",
          VocCnt: 1,
          DY: 0,
          ORGCHT_NM: "영업1팀",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10030",
          VocCnt: 1,
          ORGCHT_NM: "고객지원부",
          RCCnt: 0,
          DSCnt: 1
        }
      ];

      vm.givoc.data = new Array(new Array(1));
      vm.givoc.labels = [];

      angular.forEach(vm.data.list0101, function(item, index) {
        vm.givoc.labels[index] = item.ORGCHT_NM;
        vm.givoc.data[0][index] = item.VocCnt;
      });
    }

    /* bar Chart 시작 - 6. 부서별 VOC 접수 현황 개선요청 및 건의(Top 5) */
    function getImpList() {
      $scope.impStDate = $rootScope.getDateFormat(vm.imp.StartDat);
      $scope.impEdDate = $rootScope.getDateFormat(vm.imp.EndDat);
      var srch = {StartDat:vm.imp.StartDat, EndDat:vm.imp.EndDat};

      vm.impvoc = {};
      vm.impvoc.colors = ['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'];
      vm.impvoc.datasetOverride = [
        {
          backgroundColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
          borderColor:['#ff6b6b','#ff906b','#ffb56b','#ffda6b','#fff26b'],
          borderWidth: 1,
          type: 'doughnut'
        }
      ];

      vm.impvoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.data.list0103 = [
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10022",
          VocCnt: 3,
          ORGCHT_NM: "영업2팀",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 1,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 0,
          CPBCnt: 1,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10020",
          VocCnt: 3,
          DY: 7,
          ORGCHT_NM: "영업부",
          RCCnt: 0,
          DSCnt: 1
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10021",
          VocCnt: 3,
          ORGCHT_NM: "영업1팀",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 1,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10031",
          VocCnt: 2,
          DY: 2,
          ORGCHT_NM: "지원1팀",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          APCnt: 2,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10032",
          VocCnt: 2,
          ORGCHT_NM: "지원2팀",
          RCCnt: 0,
          DSCnt: 0
        }
      ];
      vm.impvoc.data = new Array(new Array(1));
      vm.impvoc.labels = [];

      if (vm.data.list0103.length > 0) {
        angular.forEach(vm.data.list0103, function(item, index) {
          vm.impvoc.labels[index] = item.ORGCHT_NM;
          vm.impvoc.data[0][index] = item.VocCnt;
        });
      } else {
        vm.impvoc.labels[0] = '';
        vm.impvoc.data[0][0] = 0;
      }
    }
    /* bar Chart 종료 */

    /* bar Chart 시작 - 6. 부서별 VOC 접수 현황 불만(Top 5) */
    function getContactcomplaintList() {
      $scope.cmpStDate = $rootScope.getDateFormat(vm.cmp.StartDat);
      $scope.cmpEdDate = $rootScope.getDateFormat(vm.cmp.EndDat);
      var srch = {StartDat:vm.cmp.StartDat, EndDat:vm.cmp.EndDat};

      vm.cmpvoc = {};
      vm.cmpvoc.colors = ['#20c997','#22b6bc','#228fbc','#2268bc','#264ec5'];
      vm.cmpvoc.datasetOverride = [
        {
          backgroundColor:['#20c997','#22b6bc','#228fbc','#2268bc','#264ec5'],
          borderColor:['#20c997','#22b6bc','#228fbc','#2268bc','#264ec5'],
          borderWidth: 1,
          type: 'doughnut'
        }
      ];

      vm.cmpvoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.data.list0102 = [
        {
          APCnt: 1,
          OVCnt: 0,
          CPCnt: 9,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 1,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 9,
          ORGCHT_CODE: "10020",
          VocCnt: 12,
          DY: 5,
          ORGCHT_NM: "영업부",
          RCCnt: 0,
          DSCnt: 1
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10030",
          VocCnt: 3,
          ORGCHT_NM: "고객지원부",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10031",
          VocCnt: 2,
          ORGCHT_NM: "지원1팀",
          RCCnt: 0,
          DSCnt: 2
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10021",
          VocCnt: 1,
          ORGCHT_NM: "영업1팀",
          RCCnt: 0,
          DSCnt: 1
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10032",
          VocCnt: 1,
          ORGCHT_NM: "지원2팀",
          RCCnt: 0,
          DSCnt: 1
        }
      ];
      vm.cmpvoc.data = new Array(new Array(1));
      vm.cmpvoc.labels = [];

      if (vm.data.list0102.length > 0) {
        angular.forEach(vm.data.list0102, function(item, index) {
          vm.cmpvoc.labels[index] = item.ORGCHT_NM;
          vm.cmpvoc.data[0][index] = item.VocCnt;
        });
      } else {
        vm.cmpvoc.labels[0] = '';
        vm.cmpvoc.data[0][0] = 0;
      }
    }
    /* bar Chart 종료 */

    /* bar Chart 시작 - 6. 부서별 VOC 접수 현황 칭찬(Top 5) */
    function getPraiseVocCntList() {
      $scope.praStDate = $rootScope.getDateFormat(vm.pra.StartDat);
      $scope.praEdDate = $rootScope.getDateFormat(vm.pra.EndDat);
      var srch = {StartDat:vm.pra.StartDat, EndDat:vm.pra.EndDat};

      vm.pravoc = {};
      vm.pravoc.colors = ['#20c997','#22b6bc','#228fbc','#2268bc','#264ec5'];
      vm.pravoc.datasetOverride = [
        {
          backgroundColor:['#20c997','#22b6bc','#228fbc','#2268bc','#264ec5'],
          borderColor:['#20c997','#22b6bc','#228fbc','#2268bc','#264ec5'],
          borderWidth: 1,
          type: 'doughnut'
        }
      ];

      vm.pravoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.data.list0102 = [
        {
          Rnum: 1,
          VOCSERVICEPCD2NM: "P00000CF",
          VOCSERVICEPCD1NM: "상품1",
          VOCCNT: 19,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 2,
          VOCSERVICEPCD2NM: "P00000CD",
          VOCSERVICEPCD1NM: "상품2",
          VOCCNT: 5,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 3,
          VOCSERVICEPCD2NM: "P00000CG",
          VOCSERVICEPCD1NM: "상품3",
          VOCCNT: 3,
          VOCSERVICEPCDNM: "분류1"
        },
        {
          Rnum: 4,
          VOCSERVICEPCD2NM: "P00000DF",
          VOCSERVICEPCD1NM: "상품4",
          VOCCNT: 3,
          VOCSERVICEPCDNM: "분류2"
        },
        {
          Rnum: 5,
          VOCSERVICEPCD2NM: "P00000DG",
          VOCSERVICEPCD1NM: "상품5",
          VOCCNT: 2,
          VOCSERVICEPCDNM: "분류2"
        }
      ];
      vm.pravoc.data = new Array(new Array(1));
      vm.pravoc.labels = [];

      if (vm.data.list0102.length > 0) {
        angular.forEach(vm.data.list0102, function(item, index) {
          vm.pravoc.labels[index] = item.VOCSERVICEPCD2NM;
          vm.pravoc.data[0][index] = item.VOCCNT;
        });
      } else {
        vm.pravoc.labels[0] = '';
        vm.pravoc.data[0][0] = 0;
      }
    }
    /* bar Chart 종료 */

    /* bar Chart 시작 - 6. 부서별 VOC 접수 현황 사전예고(Top 5) */
    function getAdvancenotivocList() {
      $scope.adnotiStDate = $rootScope.getDateFormat(vm.adnoti.StartDat);
      $scope.adnotiEdDate = $rootScope.getDateFormat(vm.adnoti.EndDat);
      var srch = {StartDat:vm.adnoti.StartDat, EndDat:vm.adnoti.EndDat};

      vm.adnotivoc = {};
      vm.adnotivoc.colors = ['#d37cd2','#a878d5','#7877e0','#6ea2e9','#6ecfe9'];
      vm.adnotivoc.datasetOverride = [
        {
          backgroundColor:['#d37cd2','#a878d5','#7877e0','#6ea2e9','#6ecfe9'],
          borderColor:['#d37cd2','#a878d5','#7877e0','#6ea2e9','#6ecfe9'],
          borderWidth: 1,
          type: 'doughnut'
        }
      ];

      vm.adnotivoc.options = {
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = data.labels[tooltipItem.index] + ' : ' + data.datasets[0].data[tooltipItem.index] + '건';
              return label;
            }
          }
        }
      };

      vm.data.adnotilist = [
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "1",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 1,
          ORGCHT_CODE: "10020",
          VocCnt: 5,
          DY: 1,
          ORGCHT_NM: "영업부",
          RCCnt: 0,
          DSCnt: 4
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10021",
          VocCnt: 4,
          ORGCHT_NM: "영업1팀",
          RCCnt: 0,
          DSCnt: 4
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10020",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10022",
          VocCnt: 3,
          ORGCHT_NM: "영업2팀",
          RCCnt: 0,
          DSCnt: 3
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 0,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 0,
          CPBCnt: 0,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10031",
          VocCnt: 2,
          ORGCHT_NM: "지원1팀",
          RCCnt: 0,
          DSCnt: 2
        },
        {
          APCnt: 0,
          OVCnt: 0,
          CPCnt: 1,
          UPPER_ORGCHT_CODE: "10030",
          PRCnt: 0,
          CPBCnt: 1,
          RGCnt: 0,
          CPGCnt: 0,
          ORGCHT_CODE: "10032",
          VocCnt: 1,
          DY: 6,
          ORGCHT_NM: "지원2팀",
          RCCnt: 0,
          DSCnt: 0
        }
      ];
      vm.adnotivoc.data = new Array(new Array(1));
      vm.adnotivoc.labels = [];

      if (vm.data.adnotilist.length > 0) {
        angular.forEach(vm.data.adnotilist, function(item, index) {
          vm.adnotivoc.labels[index] = item.ORGCHT_NM;
          vm.adnotivoc.data[0][index] = item.VocCnt;
        });
      } else {
        vm.adnotivoc.labels[0] = '';
        vm.adnotivoc.data[0][0] = 0;
      }
    }
    /* bar Chart 종료 */

    /* bar Chart 시작 - 7. 부서별 평균처리 시간 */
    function getDepartmentAvgList() {
      $scope.dpavgStDate = $rootScope.getDateFormat(vm.dpavg.StartDat);
      $scope.dpavgEdDate = $rootScope.getDateFormat(vm.dpavg.EndDat);
      var srch = {StartDat:vm.dpavg.StartDat, EndDat:vm.dpavg.EndDat};

      vm.dpavgvoc = {};
      vm.dpavgvoc.colors = ['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1', '#47a4f1'];
      vm.dpavgvoc.datasetOverride = [
        {
          label: "부서별 평균 처리 시간 ",
          backgroundColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1', '#47a4f1'],
          borderColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1', '#47a4f1'],
          borderWidth: 2,
          type: 'bar',
          yAxisID: 'y-axis-1',

        }
      ];

      vm.dpavgvoc.options = {
        scales: {
          yAxes: [{
            id: 'y-axis-1',
            type: 'linear',
            display: true,
             position: 'left',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            }
          }]
        },
        annotation: {
          annotations: [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-1',
              value: 1,
              borderColor: '#DF0101',
              borderWidth: 2,
              label: {
                enabled: true,
                position: 'right',
                fontColor: '#000',
                borderColor: '#fff',
                backgroundColor: '#fff',
                xAdjust: -4,

              }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-1',
            value: 3,
            borderColor: '#DF0101',
            borderWidth: 2,
            label: {
              enabled: true,
              content: 'UCL',
              position: 'right',
              fontColor: '#000',
              borderColor: '#fff',
              backgroundColor: '#fff',
              xAdjust: -4,
            }
        }],
          //drawTime: "afterDraw" // (default)
        },
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = tooltipItem.yLabel + '일';
              return label;
            }
          }
        }
      };

      vm.dataloader = true;

      vm.dpavgvoc.data = new Array(new Array(1));
      vm.dpavgvoc.labels = [];
      vm.dpavgvoc.options.scales.yAxes[0].ticks.max = 0;
      var lowData = 0;
      var sumdata = 0;

      vm.data.dpavglist = [
        {
          VocAvg: 7.4,
          APCnt: 4,
          OVCnt: 0,
          Deptnm: "영업부",
          CPCnt: 22,
          PRCnt: 1,
          Deptid: "10020",
          CPBCnt: 4,
          RGCnt: 0,
          RNUM: 1,
          CPGCnt: 18,
          VocCnt: 27,
          DY: 164,
          Parentdeptid: "1",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 6,
          APCnt: 2,
          OVCnt: 0,
          Deptnm: "지원2팀",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "10032",
          CPBCnt: 1,
          RGCnt: 0,
          RNUM: 2,
          CPGCnt: 0,
          VocCnt: 3,
          DY: 6,
          Parentdeptid: "10030",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 2,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "유지보수팀",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "103111",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 3,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 2,
          Parentdeptid: "1",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 2,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "유지보수1팀",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "103112",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 4,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 2,
          Parentdeptid: "103111",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 2,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "국내사무소",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "103113",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 5,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 2,
          Parentdeptid: "1",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 2,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "강원사무소",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "103114",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 6,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 2,
          Parentdeptid: "103113",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 1.5,
          APCnt: 1,
          OVCnt: 0,
          Deptnm: "지원1팀",
          CPCnt: 2,
          PRCnt: 0,
          Deptid: "10031",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 7,
          CPGCnt: 2,
          VocCnt: 3,
          DY: 3,
          Parentdeptid: "10030",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 1,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "영업2팀",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "10022",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 8,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 1,
          Parentdeptid: "10020",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 1,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "고객지원부",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "10030",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 9,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 1,
          Parentdeptid: "1",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 0,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "영업1팀",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "10021",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 10,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 0,
          Parentdeptid: "10020",
          RCCnt: 0,
          DSCnt: 0
        }
      ];
      if (vm.data.dpavglist.length > 0) {
        angular.forEach(vm.data.dpavglist, function(item, index) {
          sumdata = sumdata + Number(item.VocAvg);
        });
        var cnt = vm.data.dpavglist.length;

        vm.dpavgvoc.options.annotation.annotations[0].value = (sumdata / cnt).toFixed(2);
        vm.data.propertiesList = [
          {
            CodeId: "1",
            CodeValue: "70",
            Code: "UPPER",
            OprtDttm: "2019-09-03 16:02",
            Remark: "Upper",
            RegiDttm: "2019-08-09 13:17"
          },
          {
            CodeId: "2",
            CodeValue: "88",
            Code: "LOWER",
            OprtDttm: "2019-08-29 15:10",
            Remark: "Lower",
            RegiDttm: "2019-08-09 13:17"
          },
          {
            CodeId: "3",
            CodeValue: "1",
            Code: "RECODEDATE",
            OprtDttm: "2019-09-03 15:57",
            Remark: "목표기준일",
            RegiDttm: "2019-08-09 13:17"
          },
          {
            CodeId: "4",
            CodeValue: "2018년 4분기",
            Code: "STARTQUARTER",
            OprtDttm: "2019-09-03 15:35",
            Remark: "시작분기",
            RegiDttm: "2019-08-09 13:17"
          },
          {
            CodeId: "5",
            CodeValue: "현재분기",
            Code: "ENDQUARTER",
            OprtDttm: "2019-09-03 15:43",
            Remark: "현재분기",
            RegiDttm: "2019-08-09 13:17"
          },
          {
            CodeId: "6",
            CodeValue: "20",
            Code: "VOCUSESRATE",
            OprtDttm: "2019-08-29 15:08",
            Remark: "고객의소리활용률",
            RegiDttm: "2019-08-09 13:17"
          }
        ];
        angular.forEach(vm.data.propertiesList, function(item) {
          if (item.CodeId == '1') {
            var UCL = item.CodeValue;
            var UCLData = 100-UCL;

            lowData = Math.ceil((cnt * Number((UCLData/10),1)) / 2);

            var i = 0;
            while(lowData > i) {
              if (vm.data.dpavglist[i] != undefined) {
                sumdata = sumdata - vm.data.dpavglist[i].VocAvg;
                sumdata = sumdata - vm.data.dpavglist[(cnt-1)-i].VocAvg;
              }
              i++;
            }
            vm.dpavgvoc.options.annotation.annotations[1].value = (sumdata / (cnt-(lowData*2))).toFixed(2);
          } else if (item.CodeId == '3') {
            vm.dpavgvoc.options.annotation.annotations[0].value = item.CodeValue;
            vm.dpavgvoc.options.annotation.annotations[0].label.content = item.CodeValue+'일';
          }
        });
      }

      vm.data.dpavgdesclist = [
        {
          VocAvg: 7.45454545454545454545454545454545454545,
          APCnt: 4,
          OVCnt: 0,
          Deptnm: "영업부",
          CPCnt: 22,
          PRCnt: 1,
          Deptid: "10020",
          CPBCnt: 4,
          RGCnt: 0,
          RNUM: 1,
          CPGCnt: 18,
          VocCnt: 27,
          DY: 164,
          Parentdeptid: "1",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 6,
          APCnt: 2,
          OVCnt: 0,
          Deptnm: "지원2팀",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "10032",
          CPBCnt: 1,
          RGCnt: 0,
          RNUM: 2,
          CPGCnt: 0,
          VocCnt: 3,
          DY: 6,
          Parentdeptid: "10030",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 2,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "유지보수팀",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "103111",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 3,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 2,
          Parentdeptid: "1",
          RCCnt: 0,
          DSCnt: 0
        }
      ];
      if (vm.data.dpavgdesclist.length > 0) {
        angular.forEach(vm.data.dpavgdesclist, function(item, index) {
          vm.dpavgvoc.labels[index] = item.Deptnm;
          vm.dpavgvoc.data[0][index] = $filter('number')( item.VocAvg, 2);
        });

        vm.dpavgvoc.options.scales.yAxes[0].ticks.max = Math.ceil(Number(vm.dpavgvoc.data[0][0]) + 5);
      } else {
        vm.dpavgvoc.labels[0] = '';
        vm.dpavgvoc.data[0][0] = 0;
      }
      vm.dpavgvoc.labels[3] = ''
      vm.dpavgvoc.data[0][3] = 0

      vm.data.dpavgasclist = [
        {
          VocAvg: 0,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "영업1팀",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "10021",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 1,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 0,
          Parentdeptid: "10020",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 1,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "영업2팀",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "10022",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 2,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 1,
          Parentdeptid: "10020",
          RCCnt: 0,
          DSCnt: 0
        },
        {
          VocAvg: 1,
          APCnt: 0,
          OVCnt: 0,
          Deptnm: "고객지원부",
          CPCnt: 1,
          PRCnt: 0,
          Deptid: "10030",
          CPBCnt: 0,
          RGCnt: 0,
          RNUM: 3,
          CPGCnt: 1,
          VocCnt: 1,
          DY: 1,
          Parentdeptid: "1",
          RCCnt: 0,
          DSCnt: 0
        }
      ];
      if (vm.data.dpavgasclist.length > 0) {
        angular.forEach(vm.data.dpavgasclist, function(item, index) {
          vm.dpavgvoc.labels[6-index] = item.Deptnm;
          vm.dpavgvoc.data[0][6-index] = item.VocAvg;
        });

      } else {
        vm.dpavgvoc.labels[0] = '';
        vm.dpavgvoc.data[0][0] = 0;
      }
    }
    /* bar Chart 종료 */

    /* bar Chart 시작 - 8. 답변만족도 우수 부서(Top5) */
    function getVocEvCntList() {
      $scope.evStDate = $rootScope.getDateFormat(vm.ev.StartDat);
      $scope.evEdDate = $rootScope.getDateFormat(vm.ev.EndDat);
      var srch = {StartDat:vm.ev.StartDat, EndDat:vm.ev.EndDat};

      vm.evvoc = {};
      vm.evvoc.colors = ['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'];
      vm.evvoc.datasetOverride = [
        {
          label: "답변만족도 ",
          backgroundColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
          borderColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
          borderWidth: 2,
          type: 'bar',
          yAxisID: 'y-axis-1',
        }
      ];

      vm.evvoc.options = {
        scales: {
          yAxes: [{
            id: 'y-axis-1',
            type: 'linear',
            display: true,
             position: 'left',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            }
          }]
        },
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = tooltipItem.yLabel + '점';
              return label;
            }
          }
        }
      };

      vm.data.evvocList = [
        {
          RNUM: 1,
          ORGCHT_CODE: "10020",
          VocCnt: 24,
          VocEv: 110,
          ORGCHT_NM: "영업부",
          UPPER_ORGCHT_CODE: "1",
          VocEvAvg: 4.58333333333333333333333333333333333333
        },
        {
          RNUM: 2,
          ORGCHT_CODE: "10021",
          VocCnt: 1,
          VocEv: 3,
          ORGCHT_NM: "영업1팀",
          UPPER_ORGCHT_CODE: "10020",
          VocEvAvg: 3
        },
        {
          RNUM: 3,
          ORGCHT_CODE: "10022",
          VocCnt: 1,
          VocEv: 2,
          ORGCHT_NM: "영업2팀",
          UPPER_ORGCHT_CODE: "10020",
          VocEvAvg: 2
        }
      ];
      vm.evvoc.options.scales.yAxes[0].ticks.max = 0;

      vm.evvoc.data = new Array(new Array(1));
      vm.evvoc.labels = [];

      angular.forEach(vm.data.evvocList, function(item, index) {
        vm.evvoc.labels[index] = item.ORGCHT_NM;
        vm.evvoc.data[0][index] = Math.ceil(item.VocEvAvg);
      });

      angular.forEach(vm.evvoc.data[0], function(item,index){
        if (vm.evvoc.options.scales.yAxes[0].ticks.max < vm.evvoc.data[0][index]+5) {
          vm.evvoc.options.scales.yAxes[0].ticks.max = vm.evvoc.data[0][index] + 5;
        }
      });
    }

    /* bar Chart 시작 - 9. 처리일 3일 이상 처리 건 유형(Top5) */
    function getAvgVocCntList() {
      $scope.avgStDate = $rootScope.getDateFormat(vm.avg.StartDat);
      $scope.avgEdDate = $rootScope.getDateFormat(vm.avg.EndDat);
      var srch = {StartDat:vm.avg.StartDat, EndDat:vm.avg.EndDat};

      vm.avgvoc = {};
      vm.avgvoc.colors = ['#ffa14b','#47a4f1' ];
      vm.avgvoc.datasetOverride = [
        {
          label: "처리일",
          borderWidth: 2,
          type: 'line',
          yAxisID: 'y-axis-2',
          fill: false,
        },
        {
          label: '처리 건수',
          backgroundColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
          borderColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
          borderWidth: 2,
          type: 'bar',
          yAxisID: 'y-axis-1',
          xAxisID: 'x-axis-1'
        }
      ];

      vm.avgvoc.options = {
        scales: {
          yAxes: [{
            id: 'y-axis-2',
            type: 'linear',
            display: true,
            position: 'right',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            },
            gridLines : {
              display : false
            }
          },
          {
            id: 'y-axis-1',
            type: 'linear',
            display: true,
             position: 'left',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            }
          }],
          xAxes: [{
            id: 'x-axis-1',
            ticks: {
              /*maxRotation: 0,*/
              autoSkip: false
            }
          },
          ]
        },
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                if (label == '처리일') {
                  label = label + ': ' + tooltipItem.yLabel+'일';
                } else {
                  label = label + ': ' + tooltipItem.yLabel+'건';
                }
              }
              return label;
            }
          }
        }
      };

      vm.data.avglist = [
        {
          Rnum: 1,
          VOCSERVICEPCD2NM: "P00000CF",
          VOCSERVICEPCD1NM: "상품1",
          VOCCNT: 19,
          VOCSERVICEPCDNM: "분류1",
          VOCPSDAT: 169
        },
        {
          Rnum: 2,
          VOCSERVICEPCD2NM: "P00000CD",
          VOCSERVICEPCD1NM: "상품2",
          VOCCNT: 5,
          VOCSERVICEPCDNM: "분류1",
          VOCPSDAT: 200
        },
        {
          Rnum: 3,
          VOCSERVICEPCD2NM: "P00000CG",
          VOCSERVICEPCD1NM: "상품3",
          VOCCNT: 3,
          VOCSERVICEPCDNM: "분류1",
          VOCPSDAT: 271
        },
        {
          Rnum: 4,
          VOCSERVICEPCD2NM: "P00000DF",
          VOCSERVICEPCD1NM: "상품4",
          VOCCNT: 3,
          VOCSERVICEPCDNM: "분류2",
          VOCPSDAT: 38
        },
        {
          Rnum: 5,
          VOCSERVICEPCD2NM: "P00000DG",
          VOCSERVICEPCD1NM: "상품5",
          VOCCNT: 2,
          VOCSERVICEPCDNM: "분류2",
          VOCPSDAT: 20
        }
      ];
      vm.avgvoc.options.scales.yAxes[0].ticks.max = 0;
      vm.avgvoc.options.scales.yAxes[1].ticks.max = 0;

      vm.avgvoc.data = new Array(new Array(),new Array());
      vm.avgvoc.labels = [];

      angular.forEach(vm.data.avglist, function(item, index) {
        if (item.VOCSERVICEPCD1NM != undefined && item.VOCSERVICEPCD2NM == undefined) {
          vm.avgvoc.labels[index] = [item.VOCSERVICEPCD1NM]
        } else if (item.VOCSERVICEPCD1NM != undefined && item.VOCSERVICEPCD2NM != undefined) {
          vm.avgvoc.labels[index] = [item.VOCSERVICEPCD1NM, "- " + item.VOCSERVICEPCD2NM]
        }
        var data = (item.VOCPSDAT / item.VOCCNT).toFixed(2);
        vm.avgvoc.data[0][index] = data;
        vm.avgvoc.data[1][index] = item.VOCCNT;
      });

      angular.forEach(vm.avgvoc.data[1], function(item,index){
        if (vm.avgvoc.options.scales.yAxes[1].ticks.max < vm.avgvoc.data[1][index]+5) {
          vm.avgvoc.options.scales.yAxes[1].ticks.max = vm.avgvoc.data[1][index] + 5;
          vm.avgvoc.options.scales.yAxes[0].ticks.max = vm.avgvoc.data[1][index] + 5;
        }
      });
    }

    /* bar Chart 시작 - 10. 고객의 소리(VOC)활용률(%) */
    function getVocUseList() {
      var srch = {}

      vm.usevoc = {};
      vm.usevoc.colors = ['#47a4f1'];
      vm.usevoc.datasetOverride = [
        {
          backgroundColor:['#47a4f1'],
          borderColor:['#47a4f1'],
          borderWidth: 2,
          type: 'bar',
          yAxisID: 'y-axis-1',
        }
      ];

      vm.usevoc.options = {
        scales: {
          yAxes: [{
            id: 'y-axis-1',
            type: 'linear',
            display: true,
             position: 'left',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            }
          }]
        },
        annotation: {
          annotations: [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-1',
              borderColor: '#DF0101',
              borderWidth: 2,
              label: {
                enabled: true,
                content: 'LCL',
                position: 'right',
                fontColor: '#000',
                fontSize: 11,
                borderColor: '#fff',
                backgroundColor: '#fff',
                xAdjust: -4,
                yAdjust: -11,
              }
          }]
        },
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              label = tooltipItem.yLabel + '%';
              return label;
            }
          }
        }
      };

      vm.usevoc.options.scales.yAxes[0].ticks.max = 100;

      vm.data.usevocList = [
        {
          CodeId: "1",
          CodeValue: "70",
          Code: "UPPER",
          OprtDttm: "2019-09-03 16:02",
          Remark: "Upper",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "2",
          CodeValue: "88",
          Code: "LOWER",
          OprtDttm: "2019-08-29 15:10",
          Remark: "Lower",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "3",
          CodeValue: "1",
          Code: "RECODEDATE",
          OprtDttm: "2019-09-03 15:57",
          Remark: "목표기준일",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "4",
          CodeValue: "2018년 4분기",
          Code: "STARTQUARTER",
          OprtDttm: "2019-09-03 15:35",
          Remark: "시작분기",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "5",
          CodeValue: "현재분기",
          Code: "ENDQUARTER",
          OprtDttm: "2019-09-03 15:43",
          Remark: "현재분기",
          RegiDttm: "2019-08-09 13:17"
        },
        {
          CodeId: "6",
          CodeValue: "20",
          Code: "VOCUSESRATE",
          OprtDttm: "2019-08-29 15:08",
          Remark: "고객의소리활용률",
          RegiDttm: "2019-08-09 13:17"
        }
      ];
      vm.usevoc.data = new Array(new Array(1));
      vm.usevoc.labels = [];
      var labels = ''
      angular.forEach(vm.data.usevocList, function(item, index) {
        if (item.CodeId == '2') {
          vm.usevoc.options.annotation.annotations[0].value = item.CodeValue;
        }

        if (item.CodeId == '4') {
          labels = item.CodeValue;
        } else if (item.CodeId == 5) {
          labels = labels + ' ~ ' + item.CodeValue;
        }
        if (item.CodeId == '6') {
          vm.usevoc.data[0][0] = item.CodeValue;
        }
      });
      vm.usevoc.labels[0] = labels;
      vm.usevoc.datasetOverride[0].label = labels;
    }

    /* bar Chart 시작 - 11. 국민신문고 접수 추이 (월별) */
    function getEpeopleVocCntList() {
      vm.epeoplevoc = {};
      vm.epeoplevoc.colors = ['#ffa14b','#47a4f1'];
      vm.epeoplevoc.datasetOverride = [
        {
          label: "월별 접수 건수",
          borderWidth: 2,
          type: 'line',
          yAxisID: 'y-axis-2',
          fill: false,
        },
        {
          label: '누적 접수건',
          backgroundColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
          borderColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
          borderWidth: 2,
          type: 'bar',
          yAxisID: 'y-axis-1',
          xAxisID: 'x-axis-1'
        }
      ];

      vm.epeoplevoc.options = {
        scales: {
          yAxes: [{
            id: 'y-axis-2',
            type: 'linear',
            display: false,
            position: 'right',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            },
            gridLines : {
              display : false
            }
          },
          {
            id: 'y-axis-1',
            type: 'linear',
            display: true,
             position: 'left',
            ticks: {
              beginAtZero: true,
              ShowGridLines : true
            }
          }],
          xAxes: [{
            id: 'x-axis-1',
            ticks: {
            maxRotation: 0,
            autoSkip: false
             }
          },
          ]
        },
        legend: {
          display : true,
          position : 'bottom'
        },
        tooltips: {
          callbacks : {
            label : function(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                label = label + ': ' + tooltipItem.yLabel+'건';
              }
              return label;
            }
          }
        }
      };

      vm.dataloader = true;

      var today = new Date();
      var year = String(today.getFullYear());
      var lastyear = String(today.getFullYear()-1);
      var monthNames = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
      var data = {lists : [], total : []};

      var i = 1;
      if (today.getMonth()+1 == 1) {
        while (i < 13){
          var lastDay = ( new Date( year, i, 0) ).getDate();
          data.lists.push({StrDate : lastyear+'-'+i+'-01', EndDate : lastyear+'-'+i+'-'+lastDay, Name : monthNames[i-1]});
          data.total.push({StrDate : lastyear+'-01-01', EndDate : lastyear+'-'+i+'-'+lastDay, Name : monthNames[i-1]});
          i++;
        }
      } else {
        while (i < today.getMonth()+1){
          var lastDay = String((new Date( year, i, 0)).getDate());
          data.lists.push({StrDate : year+'-'+i+'-01', EndDate : year+'-'+i+'-'+lastDay, Name : monthNames[i-1]});
          data.total.push({StrDate : year+'-01-01', EndDate : year+'-'+i+'-'+lastDay, Name : monthNames[i-1]+"CNT"});
          i++;
        }
      }

      var lists = {
        JAN: 20,
        FEB: 40,
        MAR: 58,
        APR: 74,
        MAY: 99,
        JUN: 121,
        JUL: 145,
        AUG: 172,
        SEP: 209,
        OCT: 246,
        NOV: 258,
        DEC: 274,
        JANCNT: 20,
        FEBCNT: 20,
        MARCNT: 18,
        APRCNT: 16,
        MAYCNT: 25,
        JUNCNT: 19,
        JULCNT: 22,
        AUGCNT: 24,
        SEPCNT: 27,
        OCTCNT: 37,
        NOVCNT: 12,
        DECCNT: 16
      };

      vm.epeoplevoc.options.scales.yAxes[0].ticks.max = 0;
      vm.epeoplevoc.options.scales.yAxes[1].ticks.max = 0;

      vm.epeoplevoc.data = new Array(new Array(),new Array());

      vm.epeoplevoc.labels = ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'];

      vm.epeoplevoc.data[0][0] = lists.JAN;
      vm.epeoplevoc.data[0][1] = lists.FEB;
      vm.epeoplevoc.data[0][2] = lists.MAR;
      vm.epeoplevoc.data[0][3] = lists.APR;
      vm.epeoplevoc.data[0][4] = lists.MAY;
      vm.epeoplevoc.data[0][5] = lists.JUN;
      vm.epeoplevoc.data[0][6] = lists.JUL;
      vm.epeoplevoc.data[0][7] = lists.AUG;
      vm.epeoplevoc.data[0][8] = lists.SEP;
      vm.epeoplevoc.data[0][9] = lists.OCT;
      vm.epeoplevoc.data[0][10] = lists.NOV;
      vm.epeoplevoc.data[0][11] = lists.DEC;

      vm.epeoplevoc.data[1][0] = lists.JANCNT;
      vm.epeoplevoc.data[1][1] = lists.FEBCNT;
      vm.epeoplevoc.data[1][2] = lists.MARCNT;
      vm.epeoplevoc.data[1][3] = lists.APRCNT;
      vm.epeoplevoc.data[1][4] = lists.MAYCNT;
      vm.epeoplevoc.data[1][5] = lists.JUNCNT;
      vm.epeoplevoc.data[1][6] = lists.JULCNT;
      vm.epeoplevoc.data[1][7] = lists.AUGCNT;
      vm.epeoplevoc.data[1][8] = lists.SEPCNT;
      vm.epeoplevoc.data[1][9] = lists.OCTCNT;
      vm.epeoplevoc.data[1][10] = lists.NOVCNT;
      vm.epeoplevoc.data[1][11] = lists.DECCNT;
      angular.forEach(vm.epeoplevoc.data[0], function(item,index){
        if (vm.epeoplevoc.options.scales.yAxes[0].ticks.max < vm.epeoplevoc.data[0][index]+5) {
          vm.epeoplevoc.options.scales.yAxes[0].ticks.max = vm.epeoplevoc.data[0][index] + 5;
        }
      });

      angular.forEach(vm.epeoplevoc.data[1], function(item,index){
        if (vm.epeoplevoc.options.scales.yAxes[1].ticks.max < vm.epeoplevoc.data[1][index]+5) {
          vm.epeoplevoc.options.scales.yAxes[1].ticks.max = vm.epeoplevoc.data[1][index] + 5;
        }
      });
    }

    $scope.options0101 = vm.chartOptions;
    /* bar Chart 종료 */

  }, ]);



})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:customer-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('Cafe24CustomerDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function Cafe24CustomerDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.customer-list';           // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.customer-list.customer-detail'; // 목록 상세 화면
      var DETAIL_PAGE_URL = 'app.cafe24.customer-detail';       // 상세 화면

      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm: 'cafe24.customers'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.member_id)) {
        vm.srch.member_id = $stateParams.member_id;
      }

      vm.srchDetail = angular.copy(vm.srch);
      vm.columnMap = {};
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        member_id: vm.srchDetail.member_id,  // Primary Key Data
      };

      // 첨부파일 목록
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        var data = angular.copy(vm.srchDetail); // 검색 옵션 설정
        data.mapcode = 'cafe24/cafecustomerdetail';

        postApi.api(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 조회 정보 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              // 조회 데이터 표시
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;

              vm.dataloader = false; // Progressbar 숨김
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }

      /**
       * 등록/수정 화면 이동
       *
       * @param
       * @return
       */
      function goDetail() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch, member_id: vm.data.member_id
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch, member_id: vm.data.member_id
          });
        }
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goList = goList;                       // 목록 화면 이동
      vm.goDetail = goDetail;                       // 등록/수정 화면 이동

      // 데이터 조회
      getData();

    }]);


})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('Cafe24CustomerListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate', '$filter',

    function Cafe24CustomerListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate, $filter) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.customer-list.customer-detail';  // 목록 조회  화면
      var DETAIL_PAGE_URL = 'app.cafe24.customer-detail';       // 조회 화면

      var GROUP_LIST_SQL = 'Cafe24.getCustGroupCodeList';
      var CODE_LIST_SQL = 'CommonCode.getCommonCodeList';
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.GroupAndAction = 'AbdcDd';
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: 'cafe24.customers',
          //created_date: date2str(new Date(), "yyyy-MM-dd")
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'cafe24.customers'; // For CustomColumn and FileAttachment
        vm.currentPage = vm.srch.page;
      }

      vm.RegDate = $rootScope.getDateFormat(vm.srch.created_date); // YYYY-MM-DD 를 date type 으로 변환
      vm.SearchConditionStr = '';
      vm.lists = [];

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      $scope.selectedRow = $stateParams.member_id;  // initialize our variable to null

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = '';
        data.mapcode = 'cafe24/cafecustomercnt';

        postApi.api(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapcode = 'cafe24/cafecustomer';

        postApi.api(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });

              getCodeList(); //코드 목록 호출

            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }

            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(member_id) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = member_id;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch,
            member_id: member_id
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            member_id: member_id
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            customer_no: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {

        getCommonCodeList();

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      function getCodeList() {
        var data = vm.srch;
        data.mapCode = GROUP_LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.columnMap['group_name'].CodeList = result.body.docs;
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      function getCommonCodeList () {
        var data = vm.srch;
        data.mapCode = CODE_LIST_SQL;
        data.CodeType = '1000'
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.codeList = result.body.docs;
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.getCodeList = getCodeList;
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.getCommonCodeList = getCommonCodeList;   // 공통코드 (지역)

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:log-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('Cafe24LogDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate',

    function Cafe24LogDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.log-list';           // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.log-list.log-detail'; // 목록 상세 화면
      var DETAIL_PAGE_URL = 'app.cafe24.log-detail';       // 상세 화면

      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm: 'cafe24.log'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.LogId)) {
        vm.srch.logId = $stateParams.LogId;
      }

      vm.srchDetail = angular.copy(vm.srch);
      vm.columnMap = {};
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        logId: vm.srchDetail.logId,  // Primary Key Data
      };

      // 첨부파일 목록
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        var data = angular.copy(vm.srchDetail); // 검색 옵션 설정
        data.mapcode = 'cafe24/cafelogdetail';

        postApi.api(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 조회 정보 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              // 조회 데이터 표시
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;

              vm.dataloader = false; // Progressbar 숨김
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }

      /**
       * 등록/수정 화면 이동
       *
       * @param
       * @return
       */
      function goDetail() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch, member_id: vm.data.member_id
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch, member_id: vm.data.member_id
          });
        }
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goList = goList;                       // 목록 화면 이동
      vm.goDetail = goDetail;                       // 등록/수정 화면 이동

      // 데이터 조회
      getData();

    }]);


})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:log-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('Cafe24LogListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function Cafe24LogListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.log-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.log-list.log-detail';  // 목록 조회  화면
      var DETAIL_PAGE_URL = 'app.cafe24.log-detail';       // 조회 화면

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: 'cafe24.log'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'cafe24.products'; // For CustomColumn and FileAttachment
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.LogId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정
      vm.SearchConditionStr = '';
      vm.RegDateStr = $rootScope.getDateFormat(vm.srch.regDateStr); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateEnd = $rootScope.getDateFormat(vm.srch.regDateEnd); // YYYY-MM-DD 를 date type 으로 변환

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }


      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = '';
        data.mapcode = 'cafe24/cafelogcnt';

        postApi.api(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapcode = 'cafe24/cafelog';

        postApi.api(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(LogId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = LogId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch,
            LogId: LogId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            LogId: LogId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            product_no: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

webapp.service('LoginByCafe24APISrv', [ '$resource', '$rootScope', 'StaticVariable', function LoginByCafe24APISrv($resource, $rootScope, StaticVariable) {
  var loginApi = {
    doLogin : function(obj) {
      return $resource(StaticVariable.getUrl('/login/loginbycafe24.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doLogout : function(obj) {
      return $resource(StaticVariable.getUrl('/login/logout.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
  };
  return loginApi;
} ]);

(function() {
  "use strict";
  LoginByCafe24Controller.$inject = ['$log', '$state', '$stateParams', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginByCafe24APISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate', 'modalFactory', 'Auth'];

  /** @ngInject */
  function LoginByCafe24Controller($log, $state, $stateParams, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    vm.loginInfo.state = $stateParams.state;

    var translate = $filter("translate");
    vm.language = $rootScope.currentLanguage;
    console.log('$rootScope.currentLanguage=', $rootScope.currentLanguage);
    vm.placeholder = {
      id: translate("LOGIN.LABEL.ID"),
      pw: translate("LOGIN.LABEL.PW")
    };
    $log.info("console log info translate::", translate("LOGIN.BTN.LOGIN"));

    vm.findIdPwd = findIdPwd;
    vm.doLogin = doLogin;
    vm.onChangeHandler = onChangeHandler;

    function doLogin() {
      vm.appName = MAIN.APP_NAME;

      var prms = loginApi.doLogin().post(vm.loginInfo).$promise;

      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          if (data.responseVO.body.docCnt > 0) {
            setUserSession(vm, data);

            console.log(data.responseVO.body.docs[0]);

            if (!data.responseVO.body.docs[0].MainPage) {
              gAlert('', 'Cannot find MainPage data.');
              return;
            }

            $state.go(data.responseVO.body.docs[0].MainPage, { srch: '' });
//            $window.location.replace('/' + CONSTANT.URL.CONTEXT);

            // Auth.init(data.permissions);

            // 이메일, 전화번호 추가
            // $window.sessionStorage['loginUserEmail'] =
            // json.responseVO.body.docs[0].email;

            // $window.location.replace('/app/dashboard');
            // $state.reload("home");
            //$window.location.replace('/');
            // $state.go("app.dashboard");

          } else {
            gAlert('', 'Menu.INVALIEDIDPASSWORD');
          }
        } else {

          if(data.responseVO.body.docs.length > 0 && data.responseVO.body.docs[0].checkApproval == "N") {
            gAlert('', data.responseVO.body.docs[0].MSG, {
              btn: '확인', fn: function () { }
            });
          } else {
            gAlert('', '로그인에 실패하였습니다. 다시 시도하여주세요.', {
              btn: '확인', fn: function () { }
            });
          }
        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });

      $log.info("account::", vm.loginInfo.account);
      $log.info("secureCode::", vm.loginInfo.secureCode);
      // $state.go("app.dashboard");
    }

    function onChangeHandler() {
      console.log('language=', vm.language);
      $rootScope.changeLanguage(vm.language);
    }

    function setUserSession(vm, json) {
      if (vm.loginInfo.saveId == '1') {
        var now = new Date();
        var cookieExp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());

        $cookies.put('mySavedId', vm.loginInfo.loginId);

      } else {
        $cookies.remove('mySavedId');
      }

      $rootScope.setUserSession(json.responseVO.body.docs[0]);

      Auth.init(json.responseVO.body.docs[0].permissions);

      // 이메일, 전화번호 추가
      // $window.sessionStorage['loginUserEmail'] =
      // json.responseVO.body.docs[0].email;

      // $window.location.replace('/app/dashboard');
      // $state.reload("home");

      // $state.go("app.dashboard");
    }

    function findIdPwd(find){
      var ctrl = 'FindIdPwdModalCtrl as modalCtrl';
      var paramData = { find : find };
      var modalInstance = modalFactory.open('modal', 'components/modal/findIdPwd/findIdPwd-modal.html', ctrl, paramData);
    }

    doLogin();
  }

  webapp.component("loginbycafe24", {
    transclude: true,
    bindings: {},
    controller: LoginByCafe24Controller,
    controllerAs: "login",
    templateUrl: "app/cafe24/loginbycafe24.html"
  });
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:order-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('Cafe24OrderDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate',

    function Cafe24OrderDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.order-list';           // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.order-list.order-detail'; // 목록 상세 화면
      var DETAIL_PAGE_URL = 'app.cafe24.order-detail';       // 상세 화면

      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm: 'cafe24.orders'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.order_id)) {
        vm.srch.order_id = $stateParams.order_id;
      }

      vm.srchDetail = angular.copy(vm.srch);
      vm.columnMap = {};
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        order_id: vm.srchDetail.order_id,  // Primary Key Data
      };

      // 첨부파일 목록
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        var data = angular.copy(vm.srchDetail); // 검색 옵션 설정
        data.mapcode = 'cafe24/cafeorderdetail';

        postApi.api(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 조회 정보 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              // 조회 데이터 표시
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;

              vm.dataloader = false; // Progressbar 숨김
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getData()");
          console.table(error);
        });
      }

      function getItems() {
        vm.dataloader = true; // Progressbar 표시

        var data = angular.copy(vm.srchDetail); // 검색 옵션 설정
        data.mapcode = 'Cafe24.getCafe24OrderItems';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.listItems = result.body.docs;
            } else {
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }

      /**
       * 등록/수정 화면 이동
       *
       * @param
       * @return
       */
      function goDetail() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch, member_id: vm.data.member_id
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch, member_id: vm.data.member_id
          });
        }
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goList = goList;                       // 목록 화면 이동
      vm.goDetail = goDetail;                       // 등록/수정 화면 이동

      // 데이터 조회
      getItems();
      getData();

    }]);


})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:order-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('Cafe24OrderListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate', '$filter',

    function Cafe24OrderListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate, $filter) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.order-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.order-list.order-detail';  // 목록 조회  화면
      var DETAIL_PAGE_URL = 'app.cafe24.order-detail';       // 조회 화면

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: 'cafe24.orders',
          start_date: moment().subtract(3, 'months').format( "YYYY-MM-DD"),
          end_date: moment().format( "YYYY-MM-DD"),
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'cafe24.orders'; // For CustomColumn and FileAttachment
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.order_id;

      vm.OrderDateStr = $rootScope.getDateFormat(vm.srch.order_date_str); // YYYY-MM-DD 를 date type 으로 변환
      vm.OrderDateEnd = $rootScope.getDateFormat(vm.srch.order_date_end); // YYYY-MM-DD 를 date type 으로 변환
      vm.SearchConditionStr = '';
      vm.lists = [];

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = '';
        data.mapcode = 'cafe24/cafeordercnt';

        postApi.api(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapcode = 'cafe24/cafeorder';

        postApi.api(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }

            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(order_id) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = order_id;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch,
            order_id: order_id
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            order_id: order_id
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            order_no: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:product-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('Cafe24ProductDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function Cafe24ProductDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.product-list';           // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.product-list.product-detail'; // 목록 상세 화면
      var DETAIL_PAGE_URL = 'app.cafe24.product-detail';       // 상세 화면

      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm: 'cafe24.products',
          mall_id: !isNullOrEmpty($stateParams.mall_id) ? $stateParams.mall_id : '',
          product_no: !isNullOrEmpty($stateParams.product_no) ? $stateParams.product_no : ''
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.mall_id = $stateParams.mall_id;
        vm.srch.product_no = $stateParams.product_no;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      vm.srchDetail = angular.copy(vm.srch);
      vm.columnMap = {};
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 첨부파일 목록
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        var data = angular.copy(vm.srchDetail); // 검색 옵션 설정
        data.mapcode = 'cafe24/cafeproductdetail';

        postApi.api(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 조회 정보 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              // 조회 데이터 표시
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;

              vm.dataloader = false; // Progressbar 숨김
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goList = goList;                       // 목록 화면 이동

      // 데이터 조회
      getData();

    }]);


})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:product-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('Cafe24ProductListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function Cafe24ProductListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.product-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.product-list.product-detail';  // 목록 조회  화면
      var DETAIL_PAGE_URL = 'app.cafe24.product-detail';       // 조회 화면

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: 'cafe24.products'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'cafe24.products'; // For CustomColumn and FileAttachment
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.product_no;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정
      vm.SearchConditionStr = '';

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }


      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = '';
        data.mapcode = 'cafe24/cafeproductcnt';

        postApi.api(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapcode = 'cafe24/cafeproduct';

        postApi.api(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(mall_id, product_no) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = product_no;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch,
            mall_id: mall_id,
            product_no: product_no
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            mall_id: mall_id,
            product_no: product_no
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            product_no: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
  "use strict";
 /**
 * @ngdoc function
 * @name app.dataanalysis:sales-detail-ctrl
 * @description # 회원사 조회 Controller of the 회원사관리
 */
webapp.controller('Cafe24SubscribeCustomerDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'CompanyAPISrv', 'postApi',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService',

    /**
     * 판매데이터관리 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function Cafe24SubscribeCustomerDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, postApi, customFieldApi, gAlert, gConfirm, fileUploadService) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.subscribe-customer-list';           // 목록 화면

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          memberId : $stateParams.srch.memberId ? $stateParams.srch.memberId : 1,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'cafe24.subscribe.customers.detail',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = 'cafe24.subscribe.customers.detail';
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if ($stateParams.memberId) {
        vm.srch.memberId = $stateParams.memberId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'MASalesId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "List"; // For CustomColumn and FileAttachment
      vm.srchDetail.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srchDetail.ActionId = $rootScope.gVariable.dataActionId;

      // 조회 데이터
      vm.data = {
        tableNm : 'cafe24.subscribe.customer.detail',
        memberId : vm.srch.memberId,
      };

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.memberId = vm.data.memberId;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('Cafe24.getCafeSubscribeCustDetail', vm.srchDetail, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            } else {
              vm.totalItems = 0;
            }

          } else {
            gAlert('알림', data.responseVO.body.docs[0].errMessage);
          }
        },function(data) {
          vm.dataloader = false;
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }


      // 함수 선언
      vm.getData = getData;
      vm.goList = goList;

      // 데이터 조회
      getData();
  } ]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:subscribe-customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('Cafe24SubscribeCustomerListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function Cafe24SubscribeCustomerListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.subscribe-customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.subscribe-customer-list.subscribe-customer-detail';  // 목록 조회  화면
      var DETAIL_PAGE_URL = 'app.cafe24.subscribe-customer-detail';       // 조회 화면

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: 'cafe24.subscribe.customers'
        };
      } else {

        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'cafe24.subscribe.customers'; // For CustomColumn and FileAttachment
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.LogId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정
      vm.SearchConditionStr = '';/*
      vm.StartDate = $rootScope.getDateFormat(vm.srch.StartDate); // YYYY-MM-DD 를 date type 으로 변환
      vm.EndDate = $rootScope.getDateFormat(vm.srch.EndDate); // YYYY-MM-DD 를 date type 으로 변환
 */
      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }


      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
/*
        data.StartDate = $filter('localToUtc')(data.StartDate, 'from');
        data.EndDate = $filter('localToUtc')(data.EndDate, 'to'); */
        data.selectType = '';
        data.mapcode = 'Cafe24.getCafeSubscribeCustCnt';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
/*
        data.StartDate = $filter('localToUtc')(data.StartDate, 'from');
        data.EndDate = $filter('localToUtc')(data.EndDate, 'to'); */

        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapcode = 'Cafe24.getCafeSubscribeCust';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(memberId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = memberId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch,
            memberId: memberId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            memberId: memberId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            product_no: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:subscribe-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('Cafe24SubscribeDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function Cafe24SubscribeDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.subscribe-list';           // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.subscribe-list.subscribe-detail'; // 목록 상세 화면
      var DETAIL_PAGE_URL = 'app.cafe24.subscribe-detail';       // 상세 화면

      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm: 'cafe24.subscribe'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.subscribeId)) {
        vm.srch.subscribeId = $stateParams.subscribeId;
      }

      vm.srchDetail = angular.copy(vm.srch);
      vm.columnMap = {};
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        subscribeId: vm.srchDetail.subscribeId,  // Primary Key Data
      };

      // 첨부파일 목록
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        var data = angular.copy(vm.srchDetail); // 검색 옵션 설정
        data.mapcode = 'Cafe24.getCafeSubscribeDetail';

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 조회 정보 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              // 조회 데이터 표시
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;

              vm.dataloader = false; // Progressbar 숨김
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }

      /**
       * 등록/수정 화면 이동
       *
       * @param
       * @return
       */
      function goDetail() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch, subscribeId: vm.data.subscribeId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch, subscribeId: vm.data.subscribeId
          });
        }
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goList = goList;                       // 목록 화면 이동
      vm.goDetail = goDetail;                       // 등록/수정 화면 이동

      // 데이터 조회
      getData();

    }]);


})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:subscribe-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('Cafe24SubscribeListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function Cafe24SubscribeListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.subscribe-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.subscribe-list.subscribe-detail';  // 목록 조회  화면
      var DETAIL_PAGE_URL = 'app.cafe24.subscribe-detail';       // 조회 화면

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: 'cafe24.subscribe'
        };
      } else {

        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'cafe24.products'; // For CustomColumn and FileAttachment
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.subscribeId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정
      vm.SearchConditionStr = '';
      vm.StartDate = $rootScope.getDateFormat(vm.srch.StartDate); // YYYY-MM-DD 를 date type 으로 변환
      vm.EndDate = $rootScope.getDateFormat(vm.srch.EndDate); // YYYY-MM-DD 를 date type 으로 변환

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }


      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.StartDate = $filter('localToUtc')(data.StartDate, 'from');
        data.EndDate = $filter('localToUtc')(data.EndDate, 'to');
        data.selectType = '';
        data.mapcode = 'Cafe24.getCafeSubscribeCnt';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.StartDate = $filter('localToUtc')(data.StartDate, 'from');
        data.EndDate = $filter('localToUtc')(data.EndDate, 'to');

        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapcode = 'Cafe24.getCafeSubscribe';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(SubscribeId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = SubscribeId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch,
            subscribeId: SubscribeId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            subscribeId: SubscribeId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            product_no: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
  "use strict";
 /**
 * @ngdoc function
 * @name app.dataanalysis:sales-detail-ctrl
 * @description # 회원사 조회 Controller of the 회원사관리
 */
webapp.controller('Cafe24SubscribePrdDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'CompanyAPISrv', 'postApi',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService',

    /**
     * 판매데이터관리 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function Cafe24SubscribePrdDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, postApi, customFieldApi, gAlert, gConfirm, fileUploadService) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.subscribe-prd-list';           // 목록 화면

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          productNo : $stateParams.srch.productNo ? $stateParams.srch.productNo : 1,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'cafe24.subscribe.prd.detail',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = 'cafe24.subscribe.prd.detail';
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if ($stateParams.productNo) {
        vm.srch.productNo = $stateParams.productNo;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'MASalesId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "List"; // For CustomColumn and FileAttachment
      vm.srchDetail.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srchDetail.ActionId = $rootScope.gVariable.dataActionId;

      // 조회 데이터
      vm.data = {
        tableNm : 'cafe24.subscribe.prd.detail',
        productNo : vm.srch.productNo,
      };

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.productNo = vm.data.productNo;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('Cafe24.getCafeSubscribePrdDetail', vm.srchDetail, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            } else {
              vm.totalItems = 0;
            }

          } else {
            gAlert('알림', data.responseVO.body.docs[0].errMessage);
          }
        },function(data) {
          vm.dataloader = false;
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.goList = goList;

      // 데이터 조회
      getData();
  } ]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:subscribe-prd-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('Cafe24SubscribePrdListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function Cafe24SubscribePrdListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.subscribe-prd-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.subscribe-prd-list.subscribe-prd-detail';  // 목록 조회  화면
      var DETAIL_PAGE_URL = 'app.cafe24.subscribe-prd-detail';       // 조회 화면

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: 'cafe24.subscribe.prd'
        };
      } else {

        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'cafe24.subscribe.prd'; // For CustomColumn and FileAttachment
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.LogId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정
      vm.SearchConditionStr = '';
/*       vm.StartDate = $rootScope.getDateFormat(vm.srch.StartDate); // YYYY-MM-DD 를 date type 으로 변환
      vm.EndDate = $rootScope.getDateFormat(vm.srch.EndDate); // YYYY-MM-DD 를 date type 으로 변환 */

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }


      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

/*         data.StartDate = $filter('localToUtc')(data.StartDate, 'from');
        data.EndDate = $filter('localToUtc')(data.EndDate, 'to'); */
        data.selectType = '';
        data.mapcode = 'Cafe24.getCafeSubscribePrdCnt';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정

/*         data.StartDate = $filter('localToUtc')(data.StartDate, 'from');
        data.EndDate = $filter('localToUtc')(data.EndDate, 'to');
 */
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapcode = 'Cafe24.getCafeSubscribePrd';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(productNo) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = productNo;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch,
            productNo: productNo
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            productNo: productNo
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            product_no: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.campaign', {
      url: '/campaign',
      template: '<div ui-view></div>'
    }).state('app.campaign.single-list', {
      url: '/single-list/:srch',
      templateUrl: 'app/campaign/single-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.campaign.single-edit', {
      url: '/single-edit/:srch/:keyId/:tabId',
      templateUrl: 'app/campaign/single-edit.html',
    }).state('app.campaign.single-list.edit', {
      url: '/edit/:keyId/:tabId',
      templateUrl: 'app/campaign/single-edit.html',
    }).state('app.campaign.monitoring-list', {
      url: '/monitoring-list/:srch',
      templateUrl: 'app/campaign/monitoring-list.html',
      requiresAuthentication: true,
      resolve: {
        plugins: ['$ocLazyLoad', function ($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        }]
      }
    }).state('app.campaign.monitoring-detail', {
      url: '/monitoring-detail/:srch/:sendDate/:sendType/:sendDtType',
      templateUrl: 'app/campaign/monitoring-detail.html',
      requiresAuthentication: true
    }).state('app.campaign.monitoring-list.detail', {
      url: '/detail/:sendDate/:sendType/:sendDtType',
      templateUrl: 'app/campaign/monitoring-detail.html',
      requiresAuthentication: true
    }).state('app.campaign.group-list', {
      url: '/group-list/',
      templateUrl: 'app/campaign/group-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.campaign.happycall-edit', {
      url: '/happycall-edit/',
      templateUrl: 'app/campaign/happycall-edit.html'
    });
  }
})();

webapp.controller('GroupListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
  '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', function GroupListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, api, modalFactory, $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate) {

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};
    vm.maxGrpId = 0;
    vm.lists = [];
    vm.saveYn = true;
    vm.data = {CustomCode: 0};

    $scope.toggleLeft = buildToggler('left');
    $scope.toggleRight = buildToggler('right');


    // --------------------------------------------------------- 그룹고객 관련 소스 ---------------------------------------------------------
    // SQL Mapper Id 정의
    var LIST_CNT_SQL = 'Campaign.getGroupcustomerListCnt'; // 그룹고객 목록 건수 조회 SQL
    var LIST_SQL = 'Campaign.getGroupcustomerList';    // 그룹고객 목록 조회 SQL
    var EXCEL_SQL = 'Campaign.getGroupcustomerExcelList'; // 그룹고객 엑셀다운로드 SQL
    var DELETE_LIST_SQL = 'Campaign.deleteGroupcustomerList'; // 그룹고객 목록에서 삭제
    var DELETEALL_LIST_SQL = 'Campaign.deleteAllGroupcustomerList'; // 그룹고객 목록에서 전체삭제
    var ADDGRPCUSTALL_SQL = 'Campaign.insertAllGroupcustomer'; // 그룹고객 목록에서 고객전체추가

    // 관련 테이블 정의
    var KEY_TABLE_NM = 'groupcustomer'; // 그룹고객 작업 테이블명
    var KEY_COLUMN_NM = 'CustId'; // 그룹고객 Primary Key Column
    var EXCEL_TITLE = '그룹고객목록'; // 그룹고객 엑셀파일 이름
    // #endregion 상수 정의

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: 'CustRegDt' // 정렬컬럼명
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
      vm.currentPage = vm.srch.page;
    }

    vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    //vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
    vm.anchor = "";
    //setLayout(vm.layout); // 화면분할 모드 설정

    /**
     * 전체고객 추가
     *
     * @param
     * @return
     */
    function addGrpcustAll() {
      var data;

      data = vm.srch;
      data.GrpId = vm.data.GrpId;

      data.mapCode = ADDGRPCUSTALL_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn : '',
            fn : function() {
              getGrpcustList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> addGrpcustAll()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 삭제
     *
     * @param
     * @return
     */
    function deleteGrpcust(type) {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteGrpcustAction(type);
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteGrpcustAction(type) {
      vm.srch.KeyIdList = [];
      var data;

      if (type == "") {
        for (var i = 0; i < vm.grpcustLists.length; i++) {
          if (vm.grpcustLists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.grpcustLists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }
      }

      data = vm.srch;
      data.GrpId = vm.data.GrpId;

      if (type == "ALL") data.mapCode = DELETEALL_LIST_SQL;
      else data.mapCode = DELETE_LIST_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getGrpcustList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteGrpcustAction()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 건수 조회
     *
     * @param
     * @return
     */
    function getGrpcustListCnt() {

      var data = vm.srch; // 검색 옵션 설정
      data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

      data.GrpId = vm.data.GrpId;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          if (result.body.docs.length > 0) {
            // 총 목록 건수 설정
            vm.grpcustTotalItems = result.body.docs;
          } else {
            // 조회 실패
            vm.grpcustTotalItems = 0;
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getGrpcustListCnt()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 조회
     *
     * @param
     * @return
     */
    function getGrpcustList() {
      vm.dataloader = true; // Progressbar 표시
      vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

      getGrpcustListCnt(); // 목록 건수 조회

      var data = vm.srch; // 검색 옵션 설정
      data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
      data.mapCode = LIST_SQL;

      data.GrpId = vm.data.GrpId;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          // MetaColumn 사용
          if (result.body.desc.length > 0) {
            // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
            vm.grpcustListColumns = result.body.desc;
            angular.forEach(vm.grpcustListColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          } else {
            console.error('Error> getGrpcustList()> MetaColumn 정보 조회 오류');
            console.table(data);
          }

          if (result.body.docs.length > 0 && !isNullOrEmpty(vm.grpcustListColumns)) {
            // 목록 데이터 표시
            vm.grpcustLists = result.body.docs;
            // 목록 화면 구성
            setResponsive();
          } else {
            // 데이터 조회 실패
            vm.grpcustLists = {};
          }
        }

        vm.dataloader = false; // Progressbar 숨김

      }, function (error) {
        vm.dataloader = false; // Progressbar 숨김

        // 조회 중 오류 발생
        console.error("Error> getGrpcustList()");
        console.table(error);

      });
    }

    /**
     * 그룹고객 목록 비우기
     *
     * @param
     * @return
     */
    function getGrpcustListClear() {
      vm.grpcustLists = null;
      vm.grpcustTotalItems = 0;
    }

    /**
     * 그룹고객 목록 화면 구성
     *
     * @param
     * @return
     */
    function setResponsive() {
      var columns = [];
      var o = {};

      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.grpcustListColumns, function (item) {
        var column = {};

        column.name = item.ColumnPhysicalNm; // 물리 컬럼명
        column.title = item.ColumnLogicalNm; // 논리 컬럼명

        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }

        if (item.ColumnPhysicalDataType == "40") {
          // 날짜형 데이터 처리
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }

        index++;
        columns.push(column);
      });
    }

    /**
     * 그룹고객 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      //var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});

      getGrpcustList();
    }

    /**
     * 그룹고객 목록 당 조회 건수 변경
     * @param
     * @return
     */
    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      //getSearch();
      getGrpcustList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {

      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      //getSearch();
      getGrpcustList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    function setSortDirect(sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    /**
     * 그룹고객 Excel 파일 다운로드
     * @param
     * @return
     */
    function getExcelFile() {

      if (vm.grpcustLists.length == undefined) {
        gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
        return;
      }

      if (vm.grpcustLists.length == 0) {
        gAlert("", "Menu.데이터가 없습니다.");
        return;
      }

      var a = document.createElement("a");
      document.body.appendChild(a);

      var data = vm.srch;
      data.mapCode = EXCEL_SQL;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          $scope.jsonToExport = result.body.docs;
          $scope.fileName = EXCEL_TITLE;
          $scope.exportData = [];

          var obj = [];

          angular.forEach(vm.columnMap, function (item) {
            obj.push(item.ColumnLogicalNm);
          });
          $scope.exportData.push(obj);

          // Data:
          angular.forEach($scope.jsonToExport, function (value) {
            obj = [];
            angular.forEach(vm.columnMap, function (item) {
              if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              }
              else {
                obj.push(value[item.ColumnPhysicalNm]);
              }
            });
            $scope.exportData.push(obj);
          });

          $rootScope.excelDown($scope.exportData, $scope.fileName);
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getExcelFile()");
        console.table(error);
      });
    }

    /**
     * 그룹고객추가 팝업 호출
     *
     * @param {string}
     * @return {boolean}
     */
    vm.srchGrpcustModal = function () {
      var ctrl = 'GrpcustModalCtrl as vc';

      var paramData = {keyId: vm.data.GrpId};
      var modalInstance = modalFactory.open('modal', 'components/modal/campaign/grpcust-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        getGrpcustList();
      }, function (cancelData) {
      });
    };

    // --------------------------------------------------------- /그룹고객 관련 소스 ---------------------------------------------------------

    /**
     * SMS발송 팝업 호출
     *
     * @param {string}
     * @return {boolean}
     */
    vm.addSmsModal = function () {
      var ctrl = 'SmsModalCtrl as vc';

      var paramData = {keyId: vm.data.GrpId};
      var modalInstance = modalFactory.open('modal', 'components/modal/campaign/sms-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
      }, function (cancelData) {
      });
    };

    // 회원사 변경 설정
    $scope.$on('broadcastSetChangeTenantID', function (event, data) {
      getTreeList();
      getGrpcustList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수


    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildToggler(navID) {
      var debounceFn = $mdUtil.debounce(function() {
        $mdSidenav(navID).toggle().then(function() {
          console.debug("toggle " + navID + " is done");
        });
      }, 200);
      return debounceFn;
    }

    $scope.init = function() {
      // check if there is query in url
      // and fire search in case its value is not empty
    };

    // stops the interval
    $scope.$on("$destroy", function() {
    });

    $scope.$on('broadcastSetChangeTenantID', function(event, data) {
      resetList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.grpcustLists.length; i++) {
        if (!vm.grpcustLists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }
      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.grpcustLists.length; i++) {
        vm.grpcustLists[i].chkRow = vm.chkHead;
      }
    };

    /*
    function resetSearch() {
      vm.srch.GrpNm = '';
      vm.data = {CustomCode: 0};
      tree.select_branch(null);
    }
    */

    function resetList() {
      //resetSearch();

      getTreeList();
      getGrpcustListClear();
    }

    /*
    vm.nextSearch = function() {
      tree.next_search_text();
    };
    */

    // 함수 선언
    //vm.resetSearch = resetSearch;
    vm.resetList = resetList;
    vm.getTreeList = getTreeList;
    vm.delNode = delNode;
    vm.delNodeCancel = delNodeCancel;
    vm.saveData = saveData;
    vm.onChangeGrpNm = onChangeGrpNm;
    //vm.onChangeCode = onChangeCode;
    vm.onChanged = onChanged;
    //vm.ChangeCustomCode = ChangeCustomCode;
    vm.deleteGrpcust = deleteGrpcust;
    vm.addGrpcustAll = addGrpcustAll;

    vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
    vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
    vm.setSortColumn = setSortColumn;           // 정렬 설정
    vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시


    // my_tree 반드시 선언하기
    var tree;
    $scope.my_tree = tree = {};

    vm.topItem = null;

    /*
    vm.UseYNData = {
      CallbackTarget : '0000',
      CodeType : 'USEYN',
      Code : vm.data.UseYN,
      ReloadSeq : 1
    };
    */

    /*
    vm.onSelectCallback = function(data) {
      if (data.CallbackTarget == '0000') {
        vm.data.UseYN = data.Code;
      }
    };
    */

    getTreeList();

    function getTreeList() {
      // 사전에 트리 선언함.(중요포인트)
      vm.dataloader = true;
      $scope.my_data = [];

      // 로케이션관리 select 검색실행함
      var data = vm.srch;
      data.mapCode = 'Campaign.getGroupList';
      postApi.select(data, function(result) {
        vm.dataloader = false;

        if (result.header.status == CONSTANT.HttpStatus.OK) {

          if (result.body.docs.length == 0) {
            return;
          }

          // select한 datatable 바인딩
          vm.lists = result.body.docs;

          vm.topItem = result.body.docs[0];

          refreshTree();

          // 트리 펼치기
          $timeout(function() {
            return tree.expand_init();
          }, 1);

          console.log('vm.topItem', vm.topItem);
        }
      }, function(error) {
        vm.dataloader = false;
        console.error('fail', status, data);
      });
    }

    // 계층형 json 구조로 변환
    function unflatten(items) {
      // 다시 설정(배치)하는 부분
      return items.reduce(insert, {
        res : [],
        map : {}
      }).res;
    }

    // 계층형 json 부모/자식 구분하여 구조 변환
    function insert(obj, item) {
      var parent = item.parent; // 부모값
      var map = obj.map;
      map[item.guid] = item; // 아이템 구성함

      if (parent === null)
        obj.res.push(item); // 부모값 생성
      else {
        var parentItem = map[parent];
        // 자식값 생성
        if (parentItem != null) {
          if (parentItem.hasOwnProperty("children"))
            parentItem.children.push(item);
          else
            parentItem.children = [ item ];
        }
      }

      return obj;
    }

    // guid, parent 제외한 계층형 json 구조 변환하기
    function traverse(jsonObj) {

      for (var i = 0; i < jsonObj.length; i++) {
        if (jsonObj[i].children == null) {
        } else {
          traverse(jsonObj[i].children);
        }

        // label, children 만 추가함
        var newItem = {
          "label" : jsonObj[i].label,
          "data" : jsonObj[i].guid,
          "children" : jsonObj[i].children,
          "classes" : jsonObj[i].classes,
        }
        jsonObj[i] = newItem;
      }
    }

    // 트리 목록에서 조회값
    $scope.my_tree_handler = function(branch) {
      angular.forEach(vm.lists, function(item) {
        if (branch.data == item.GrpId.toString()) {
          vm.data = item;

          if (vm.data.New != 'Y' && vm.data.GrpId != null) {
            getGrpcustList();
          }
          /*
          vm.UseYNData = {
            CallbackTarget : '0000',
            CodeType : 'USEYN',
            Code : vm.data.UseYN,
            ReloadSeq : (new Date()).getTime()
          };
          */
          return;
        }
      });
    };

    $scope.try_adding_a_branch = function() {

      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
      var grpId = newnum.toString(36);

      var branch = tree.get_selected_branch();
      if (branch == null) {
        var grpInfo = {
          'GrpNm' : '새로운 코드',
          'GrpId' : grpId,
          'ParentGrpId' : 0,
          'GrpLevel' : 1,
          //'UseYN' : 'Y',
          'New' : 'Y',
          //'CodeType' : '',
          'TenantId' : $rootScope.gVariable.srchTenantId,
          //'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1
        };
        vm.lists.push(grpInfo);
      } else {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.GrpId.toString()) {
            var grpInfo = {
              'GrpNm' : '새로운 코드',
              'GrpId' : grpId,
              'ParentGrpId' : branch.data,
              'GrpLevel' : item.GrpLevel + 1,
              //'UseYN' : 'Y',
              'New' : 'Y',
              //'CodeType' : item.CodeType,
              'TenantId' : $rootScope.gVariable.srchTenantId,
              'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1
            };
            vm.lists.push(grpInfo);
            return;
          }
        });

        getGrpcustListClear();
      }

      var code = {};
      if ($rootScope.gVariable.srchTenantId == 0) {
        code = {label: '[*]새로운 코드', data: grpId};
      } else {
        //code = {label: '[*]새로운 코드', data: grpId, classes: ['color-red']};
        code = {label: '[*]새로운 코드', data: grpId};
      }
      var new_branch = tree.add_branch(branch, code);
      tree.select_branch(new_branch);
    };

    function delNode() {
      var grpId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
        $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
        return;
      }

      gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
        btn : '',
        fn : function(){
          if (vm.data.New == 'Y'){
            deleteNodeTree();
          }else {
            vm.data.DelYN = 'Y';
            saveData();
          }
        }
      }, {
        btn : '',
        fn : function(){
        }
      });
    }

    function deleteNodeTree() {
      var grpId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      angular.forEach(vm.lists, function(item) {
        if (branch.data == item.GrpId.toString()) {
          var index = vm.lists.indexOf(item);
          vm.lists.splice(index, 1);

          var parent = tree.select_parent_branch();
          if(parent){
            parent.children.splice(parent.children.indexOf(branch),1);
          } else {
            refreshTree();
          }

          return;
        }
      });

      tree.select_branch(null);
      vm.data = {CustomCode: 0};
    }

    function refreshTree() {

      // 리스트 생성
      var arrlist = [];

      // for문으로 다시 json 구조로 변환함.
      angular.forEach(vm.lists, function(item) {
        // 객체 생성
        var data = {};

        data.label = $translate.instant(item.GrpNm);
        data.guid = item.GrpId;
        data.parent = item.ParentGrpId == undefined || item.ParentGrpId == 0 ? null : item.ParentGrpId;
        data.classes = [];
        //data.classes.push(item.TenantId == '0' ? '' : 'color-red');

        // 리스트에 생성된 객체 삽입
        arrlist.push(data);

        if (item.GrpId > vm.maxGrpId)
          vm.maxGrpId = item.GrpId;
      });

      // 계층형 json 구조로 변환함
      var recursiveArray = unflatten(arrlist);

      // guid, parent 제외 변환함
      traverse(recursiveArray);

      // 트리구조에 바인딩
      $scope.my_data = recursiveArray;

      // 트리 펼치기
//        $timeout(function() {
//          return tree.expand_all();
//        }, 1);

    }

    function onChangeGrpNm() {
      onChanged();
      var branch = tree.get_selected_branch();
      if (branch == null) return;
      branch.label = '[*]' + vm.data.GrpNm;
    }

    /*
    function onChangeCode() {
      onChanged();
      if (vm.data.New == 'Y') {
      }
    }
    */

    function onChanged() {
      if (vm.data.New == null || vm.data.New != 'Y') {
        vm.data.Edit = 'Y';
      }
    }

    function removeNode(jsonObj, grpId) {
      for (var i = 0; i < jsonObj.length; i++) {
        console.log('jsonObj[i]=', jsonObj[i]);
        console.log('GrpId=', grpId);

        if (jsonObj[i].data == grpId) {
          jsonObj[i].children = [];
          return true;
        }

        if (jsonObj[i].children == null) {
        } else {
          if (removeNode(jsonObj[i].children, grpId) == true)
            break;
        }
      }
    }

    function delNodeCancel() {
      var grpId = '';
      var branch = tree.get_selected_branch();
      angular.forEach(vm.lists, function(item) {
        if (branch.data == item.GrpId.toString()) {
          item.DelYN = 'N';
          branch.label = branch.label.replace(/^\[X\]/,"");;
          return;
        }
      });
    }

    function saveData() {
      vm.dataloader = true;
      var data = {lists : []};
      data.mapCode = 'Campaign.insertGroup';

      if (isNullOrEmpty(vm.data.SortSeq)) vm.data.SortSeq = 0;

      data.lists.push(vm.data);
      postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            var branch = tree.get_selected_branch();
            branch.label = branch.label.replace(/^\[\*\]/,"");

            if (vm.data.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.New = '';
            } else if (vm.data.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.Edit = '';
            }
//            getTreeList();
          }
        },

        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

    }

    /*
    function ChangeCustomCode() {
      console.log($rootScope.gVariable);
      if (vm.data.CustomCode == 0) {
        gConfirm('', $translate.instant('MSG.CUSTOMCODESTART'), {
          btn : '',
          fn : function(){
            var data = vm.data;
            var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
            data.NewGrpId = newnum.toString(36);
            data.mapCode = 'CommonCode.makeCustomCommonCode';
            postApi.insert(data, function(result) {
              if (result.header.status == CONSTANT.HttpStatus.OK) {
                getTreeList();
                vm.data.CustomCode = 1;
              }
            }, function(error) {
              console.error('fail', status, data);
            });
          }
        }, {
          btn : '',
          fn : function(){
          }
        });
      } else {
        gConfirm('', $translate.instant('MSG.CUSTOMCODESTOP'), {
          btn : '',
          fn : function(){
            var data = vm.data;
            data.mapCode = 'CommonCode.removeCustomCommonCode';
            postApi.update(data, function(result) {
              if (result.header.status == CONSTANT.HttpStatus.OK) {
                getTreeList();
                vm.data.CustomCode = 0;
              }
            }, function(error) {
              console.error('fail', status, data);
            });
          }
        }, {
          btn : '',
          fn : function(){
          }
        });
      }
    }
    */

    // 목록 조회
    getGrpcustList();
  } ]);



(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:happycall-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('HappycallEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function HappycallEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign.insertAutohappycall';     // 등록 SQL
      var UPDATE_SQL = 'Campaign.updateAutohappycall';     // 수정 SQL
      var VIEW_SQL = 'Campaign.getAutohappycallDetail'; // 조회 SQL
      //var GETID_SQL = 'checkLoginId';         //아이디중복 SQL
      //var DEL_SQL = 'User.deleteUserDetail';  // 삭제 SQL

      // 관련 화면 정의
      //var LIST_PAGE_URL = 'app.system.user-list';             // 목록 화면
      //var LIST_VIEW_PAGE_URL = 'app.system.user-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.campaign.happycall-edit';           // 수정 화면

      // 관련 테이블 정의
      //var KEY_TABLE_NM = 'cvsautohappycall'; // 작업 테이블명
      //var KEY_COLUMN_NM = 'AutoHappyCallId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.SendMessageBytes_10 = "0";
      vm.SendMessageBytes_20 = "0";
      vm.SendMessageBytes_30 = "0";
      vm.SendMessageBytes_40 = "0";
      vm.SendMessageBytes_50 = "0";
      vm.SendMessageBytes_60 = "0";

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          //page: 1, // 현재 조회 페이지 번호
          //viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          //keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          //tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          //srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */
      //vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      /*
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }
      */

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      //vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      //vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      //vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      //vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      //vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        //KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        //tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };
      vm.data.keyId_10 = 0;
      vm.data.keyId_20 = 0;
      vm.data.keyId_30 = 0;
      vm.data.keyId_40 = 0;
      vm.data.keyId_50 = 0;
      vm.data.keyId_60 = 0;

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getData();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );
        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback

      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.chkSendMessage = function (happyCallType) {
        var msg = "";
        var bytes = 0;

        msg = vm.data["SendMessage_" + happyCallType];
        bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

        if (bytes > 90) {
          vm.data["SendMessage_" + happyCallType] = fnCutMsg(msg, 90);
          bytes = 90;
        }

        vm["SendMessageBytes_" + happyCallType] = bytes;
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        getDataType("10");
      }

      /**
       * 타입별 데이터 조회
       * @param
       * @return
       */
      function getDataType(happyCallType) {
        if (!happyCallType) return;

        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        //vm.showUploader = enableUploadComponent();
        //initVaultComponent('vault', vm.onFileCallback);
        //initVaultComponent('vault2', vm.onFileCallback);

        /*
        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        */

        //vm.srchDetail.viewColumns = {}; // 조회 컬럼
        vm.srchDetail.HappyCallType = happyCallType;
        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            /*
            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            */

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              //vm.data = result.body.docs[0];
              //vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              vm.data["keyId_" + happyCallType] = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              vm.data["SendTelno_" + happyCallType] = result.body.docs[0].SendTelno != null ? result.body.docs[0].SendTelno : '';
              vm.data["UseYN_" + happyCallType] = result.body.docs[0].UseYN != null ? result.body.docs[0].UseYN : '';
              vm.data["SendTime_" + happyCallType] = result.body.docs[0].SendTime != null ? result.body.docs[0].SendTime : '';
              vm.data["SendMessage_" + happyCallType] = result.body.docs[0].SendMessage != null ? result.body.docs[0].SendMessage : '';

              // 역할 설정
              /*
              vm.data.UserRoles = [];

              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });
              */

              //Date형식 처리
              /*
              if (vm.data.BirthDay != null && vm.data.BirthDay != "") vm.BirthDay = moment(vm.data.BirthDay).toDate();
              if (vm.data.EntryDt != null && vm.data.EntryDt != "") vm.EntryDt = moment(vm.data.EntryDt).toDate();
              if (vm.data.RetireDt != null && vm.data.RetireDt != "") vm.RetireDt = moment(vm.data.RetireDt).toDate();
              */

              // 첨부파일 목록 설정
              /*
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
              */
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];

              // 데이터가 없을 경우 기본값 삽입
              vm.data["SendTelno_" + happyCallType] = "010-0000-0000";
              vm.data["SendTime_" + happyCallType] = "09";

              switch (happyCallType) {
                case "10":
                  vm.data.SendMessage_10 = "{고객명}님, {예약일시}에 방문이 예약되어 있습니다.";
                  break;
                case "20":
                  vm.data.SendMessage_20 = "{고객명}님, 저희 서비스에 대해서 만족하시는지요?";
                  vm.data.SendTime_20 = "21";
                  break;
                case "30":
                  vm.data.SendMessage_30 = "{고객명}님, 방문 후 3일이 지났습니다.";
                  break;
                case "40":
                  vm.data.SendMessage_40 = "{고객명}님, 방문 후 7일이 지났습니다.";
                  break;
                case "50":
                  vm.data.SendMessage_50 = "{고객명}님, 방문하신지 2주가 지났습니다.";
                  break;
                case "60":
                  vm.data.SendMessage_60 = "{고객명}님, 방문하신지 4주가 지났습니다.";
                  break;

                default : break;
              }
            }

            // bytes 표시
            vm.chkSendMessage(happyCallType);

          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

          // 다음 해피콜타입의 데이터 조회
          getDataType(fnNextHappyCallType(happyCallType));

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      /*
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }
      */

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile() {
        if (isValidInput() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */
      /*
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 유효성 검사
       * @param
       * @return
       */
      /*
      function isValidInput() {
        var errMsg = '';
        if (isNullOrEmpty(vm.data.LoginId)) {
          errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.keyId)) {
          if (isNullOrEmpty(vm.data.checkedLoginId)) {
            errMsg = errMsg + '- 아이디 중복체크를 해 주세요.<br/>';
          }
        }

        if (isNullOrEmpty(vm.data.UserNm)) {
          errMsg = errMsg + '- 사용자명을 입력하세요.<br/>';
        }

        if (vm.data.Password != vm.data.Password2) {
          errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
        }

        if (!isNullOrEmpty(vm.data.Password)) {
          if (!chkPass()) {
            errMsg = errMsg + '- 비밀번호 형식을 확인해 주세요.<br/>';
          }
        }
        if (isNullOrEmpty(vm.data.UseYN)) {
          errMsg = errMsg + '- 사용여부를 선택하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }
      */

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      /*
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }
      */

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        //if (isValidInput() == false) return;

        setDataType("10");
      }

      /**
       * 타입별 데이터 저장
       *
       * @param
       * @return
       */
      function setDataType(happyCallType) {

        // 모든 해피콜타입의 데이터가 저장되었다면
        if (!happyCallType) {
          InsertUpdateDetail();
          return;
        }

        //vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        //vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        /*
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        */
        //vm.data.userkey = vm.srch.userkey; // 사용자 식별 키
        //vm.data.BirthDay = moment(vm.data.BirthDay).format('YYYY-MM-DD');
        //vm.data.EntryDt = moment(vm.data.EntryDt).format('YYYY-MM-DD');
        //vm.data.RetireDt = moment(vm.data.RetireDt).format('YYYY-MM-DD');

        vm.data.HappyCallType = happyCallType;
        vm.data.keyId = vm.data["keyId_" + happyCallType];
        vm.data.SendTelno = vm.data["SendTelno_" + happyCallType];
        vm.data.UseYN = vm.data["UseYN_" + happyCallType];
        vm.data.SendTime = vm.data["SendTime_" + happyCallType];
        vm.data.SendMessage = vm.data["SendMessage_" + happyCallType];

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            //InsertUpdateDetail(result);

            // 다음 해피콜타입의 데이터 저장
            setDataType(fnNextHappyCallType(happyCallType));
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            //InsertUpdateDetail(result);

            // 다음 해피콜타입의 데이터 저장
            setDataType(fnNextHappyCallType(happyCallType));
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function InsertUpdateDetail() {
      //function InsertUpdateDetail(result) {
        /*
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
        */
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                //goNextPage(true);
                //$state.go(VIEW_PAGE_URL, {});
                getData();
              }
            });
            return;
            /*
          }
        }

        console.error("Error> InsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
        */
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      /*
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }
      */

      /*
      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId,
              tabId: vm.tabId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
        }
      }
      */

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      /*
      function delData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            delDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }
      */

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      /*
      function delDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }
      */

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        goNextPage(false);
      }
      */

      /**
       * 발송시간 호출후 적용
       *
       * @param
       * @return
       */
      function getSendTimeList() {
        vm.sendTimeList = [
            {value:"08", text:"오전 8시"}
            , {value:"09", text:"오전 9시"}
            , {value:"10", text:"오전 10시"}
            , {value:"11", text:"오전 11시"}
            , {value:"12", text:"낮 12시"}
            , {value:"13", text:"오후 1시"}
            , {value:"14", text:"오후 2시"}
            , {value:"15", text:"오후 3시"}
            , {value:"16", text:"오후 4시"}
            , {value:"17", text:"오후 5시"}
            , {value:"18", text:"오후 6시"}
            , {value:"19", text:"오후 7시"}
            , {value:"20", text:"오후 8시"}
            , {value:"21", text:"오후 9시"}
        ];
      }

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      /**
       * 다음 해피콜 타입 호출
       * @param
       * @return
       */
      function fnNextHappyCallType(happyCallType) {
        switch (happyCallType) {
          case "10": happyCallType = "20"; break;
          case "20": happyCallType = "30"; break;
          case "30": happyCallType = "40"; break;
          case "40": happyCallType = "50"; break;
          case "50": happyCallType = "60"; break;
          default : happyCallType = ""; break;
        }

        return happyCallType;
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      //vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      //vm.goList = goList;                       // 목록 화면 이동
      //vm.delData = delData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;

      // 데이터 조회
      getData();
      getSendTimeList();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('MonitoringDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function MonitoringDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      //var VIEW_SQL = 'Campaign.getMonitoringDetail'; // 조회 SQL
      //var DEL_SQL = 'User.deleteUserDetail';  // 삭제 SQL
      var LIST_CNT_SQL = 'Campaign.getMonitoringDetailListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign.getMonitoringDetailList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign.monitoring-list';           // 목록 화면
      //var LIST_EDIT_PAGE_URL = 'app.system.user-list.edit'; // 목록 등록/수정 화면
      //var EDIT_PAGE_URL = 'app.system.user-edit';           // 등록/수정 화면

      // 관련 테이블 정의
      //var KEY_TABLE_NM = 'Users'; // 작업 테이블명
      //var KEY_COLUMN_NM = 'UserId'; // Primary Key Column

      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          //keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          sendDate: !isNullOrEmpty($stateParams.srch.sendDate) ? $stateParams.srch.sendDate : '',
          sendType: !isNullOrEmpty($stateParams.srch.sendType) ? $stateParams.srch.sendType : '',
          sendDtType: !isNullOrEmpty($stateParams.srch.sendDtType) ? $stateParams.srch.sendDtType: '',
          //tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          //uploadFileList: [], // 첨부파일 목록
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.currentPage = vm.srch.page;
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      //if (!isNullOrEmpty($stateParams.keyId)) vm.srch.keyId = $stateParams.keyId;
      if (!isNullOrEmpty($stateParams.sendDate)) vm.srch.sendDate = $stateParams.sendDate;
      if (!isNullOrEmpty($stateParams.sendType)) vm.srch.sendType = $stateParams.sendType;
      if (!isNullOrEmpty($stateParams.sendDtType)) vm.srch.sendDtType = $stateParams.sendDtType;

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      //vm.srchDetail.uploadFileList = [];    // 첨부파일 목록
      //vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      //vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        //KeyId: vm.srchDetail.hKeyId,  // Primary Key Data
        //tableNm: KEY_TABLE_NM         // 작업 테이블명
      };

      // 첨부파일 목록
      //vm.uploadFileList = [];

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      /*
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        //vm.srchDetail.viewColumns = {}; // 사용자정의 컬럼 정보 설정

        var data = vm.srchDetail; // 검색 옵션 설정
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 조회 정보 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              // 조회 데이터 표시
              vm.data = result.body.docs[0];
              //vm.data.RelateDataId = vm.data.KeyId;

              // 첨부파일 목록 표시
              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

              vm.dataloader = false; // Progressbar 숨김
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getData()");
          console.table(error);
        });
      }
      */

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      /*
      function getUploadFileList() {

        var data = vm.srchDetail; // 검색 옵션 설정
        data.viewColumns = {};
        data.mapCode = 'FileAttach.getFileList';

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // 첨부파일 목록 표시
            var uploadFileList = [];
            angular.forEach(result.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt
              };
              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);


          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }
      */

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      /*
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }
      */

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      /*
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> setDelDataAction()");
          console.table(error);
        });
      }
      */

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }

      /**
       * 등록/수정 화면 이동
       *
       * @param
       * @return
       */
      /*
      function goEdit() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch, keyId: vm.data.KeyId, tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch, keyId: vm.data.KeyId, tabId: 1
          });
        }
      }
      */

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        //var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});

        getList();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        //getSearch();
        getList();
      }

      // 함수 정의
      //vm.getData = getData;                     // 데이터 조회
      vm.getList = getList;
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      //vm.setDelData = setDelData;                     // 데이터 삭제 확인

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      //vm.setSortColumn = setSortColumn;           // 정렬 설정
      //vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goList = goList;                       // 목록 화면 이동
      //vm.goEdit = goEdit;                       // 등록/수정 화면 이동

      // 데이터 조회
      getList();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:monitoring-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('MonitoringListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function MonitoringListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign.getMonitoringListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign.getMonitoringList';    // 목록 조회 SQL
      //var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      //var DELETE_LIST_SQL = 'User.deleteUserList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign.monitoring-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.campaign.monitoring-list.detail';  // 목록 조회  화면
      //var LIST_EDIT_PAGE_URL = 'app.system.user-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.campaign.monitoring-detail';       // 조회 화면
      //var EDIT_PAGE_URL = 'app.system.user-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'smshist'; // 작업 테이블명
      //var KEY_COLUMN_NM = 'UserId'; // Primary Key Column
      //var EXCEL_TITLE = '사용자 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 추가 변수
      //vm.keyId = 0;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.SendDateFrom = $rootScope.getDateFormat(vm.srch.SendDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.SendDateTo = $rootScope.getDateFormat(vm.srch.SendDateTo);
        vm.currentPage = vm.srch.page;
      }

      $scope.sendDate = $stateParams.sendDate;
      $scope.sendType = $stateParams.sendType;
      $scope.sendDtType = $stateParams.sendDtType;

      vm.listSize = [10, 25, 50, 100]; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            console.log("re", result);
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramSendDate, paramSendType, paramSendDtType) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.sendDate = paramSendDate;
        $scope.sendType = paramSendType;
        $scope.sendDtType = paramSendDtType;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            sendDate: paramSendDate,
            sendType: paramSendType,
            sendDtType: paramSendDtType
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            sendDate: paramSendDate,
            sendType: paramSendType,
            sendDtType: paramSendDtType
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      /*
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }
      */

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      /*
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }
      */

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function changeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      /*
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }
      */

      /**
       * 초기 세팅
       *
       * @param
       * @return
       */
      function init(){

        // 목록 체크박스 로직 설정
        /*
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
        */
      }

      /**
       * 목록 삭제
       *
       * @param
       * @return
       */
      /*
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }
      */

      /*
      function deleteListAction() {
        vm.srch.ContentsIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.ContentsIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.ContentsIdList == null || vm.srch.ContentsIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
        });
      }
      */

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      //vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      //vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.changeLayout = changeLayout;       // 화면모드 설정
      //vm.deleteList = deleteList;                 // 목록 삭제
      //vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      init();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:single-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */

  webapp.controller('SingleEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function SingleEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign.insertSMSHist';   // 등록 SQL
      //var UPDATE_SQL = 'Campaign.updateSingle';     // 수정 SQL
      //var VIEW_SQL = 'Campaign.getSingleDetail'; // 조회 SQL
      //var DEL_SQL = 'Campaign.deleteSingleDetail';  // 삭제 SQL

      var FRELIST_SQL = 'Campaign.getFrequsedmsgList';    // 문제 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign.single-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.campaign.single-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.campaign.single-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'smshist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'SMSHistId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트

      vm.SendMessageBytes = "0";

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      //vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      //vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        keyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        //tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      vm.data.SendHour = "09";
      vm.data.SendMin = "00";

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback

      /**
       * 자주 사용하는 메세지 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchFreModal = function (keyId) {
        var ctrl = 'FreModalCtrl as vc';
        var message = "";

        if (isNullOrEmpty(keyId)) {
          message = vm.data.SendMessage;
        }

        var paramData = {keyId: keyId, message: message};
        var modalInstance = modalFactory.open('modal', 'components/modal/campaign/fre-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getFreList();
        }, function (cancelData) {
        });
      };

      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        msg = vm.data.SendMessage;
        bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

        if (bytes > 90) {
          vm.data.SendMessage = fnCutMsg(msg, 90);
          bytes = 90;
        }

        vm.SendMessageBytes = bytes;
      };

      /**
       * 초기 세팅
       *
       * @param
       * @return
       */
      function init(){

        // 자주 사용하는 메세지 목록 체크박스 로직 설정
        /*
        vm.freChkHead = false;
        $scope.freChkRowChg = function () {
          for (var i = 0; i < vm.freLists.length; i++) {
            if (!vm.freLists[i].isChecked) {
              vm.freChkHead = false;
              return;
            }
          }
          vm.freChkHead = true;
        };

        $scope.freChkHeadChg = function () {
          for (var i = 0; i < vm.freLists.length; i++) {
            vm.freLists[i].freChkRow = vm.freChkHead;
          }
        };
        */
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      /*
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              // 역할 설정
              vm.data.UserRoles = [];

              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });

              //Date형식 처리
              if (vm.data.BirthDay != null && vm.data.BirthDay != "") vm.BirthDay = moment(vm.data.BirthDay).toDate();
              if (vm.data.EntryDt != null && vm.data.EntryDt != "") vm.EntryDt = moment(vm.data.EntryDt).toDate();
              if (vm.data.RetireDt != null && vm.data.RetireDt != "") vm.RetireDt = moment(vm.data.RetireDt).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }
      */

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      /*
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }
      */
      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.data.keyId)) {
          errMsg = errMsg + '- 대상고객이 없습니다.<br/>';
        }

        if (isNullOrEmpty(vm.data.SendTelno)) {
          errMsg = errMsg + '- 발신번호를 입력하세요.<br/>';
        }

        if (vm.data.SendDateType == "200") {
          if (isNullOrEmpty(vm.data.SendDt)) {
            errMsg = errMsg + '- 발송일을 선택하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.SendHour)) {
            errMsg = errMsg + '- 발송시간(시)을 선택하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.SendMin)) {
            errMsg = errMsg + '- 발송시간(분)을 선택하세요.<br/>';
          }
        }

        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 발송내용을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      /*
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }
      */

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (getIsValidData() == false) {
          return;
        }

        // 내용
        //vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        //vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        /*
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        */

        //vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        /*
        vm.data.BirthDay = moment(vm.data.BirthDay).format('YYYY-MM-DD');
        vm.data.EntryDt = moment(vm.data.EntryDt).format('YYYY-MM-DD');
        vm.data.RetireDt = moment(vm.data.RetireDt).format('YYYY-MM-DD');
        */

        var data = vm.data; // 사용자 입력 데이터
        data.CustId = vm.data.keyId;
        data.SendType = "10";
        data.SendDtType = "";

        if (data.SendDateType == "200") data.SendDate = data.SendDt + " " + data.SendHour + ":" + data.SendMin + ":00";

        //if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
          /*
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
        */
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          /*
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
          */
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;

            //gAlert("", "Menu.SAVED", {
            gAlert("", "발송되었습니다.", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          //}
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          //if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
            /*
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId,
              tabId: vm.tabId
            }, {reload:VIEW_PAGE_URL});
          }
          */
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      /*
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }
      */

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      /*
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }
      */

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }
      */

      /**
       * 자주 사용하는 메세지 목록 조회
       *
       * @param
       * @return
       */
      function getFreList() {
        vm.dataloader = true; // Progressbar 표시

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = FRELIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            //console.log("re", result);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.freLists = result.body.docs;
              vm.freTotalItems = vm.freLists.length;
            } else {
              // 데이터 조회 실패
              vm.freLists = {};
              vm.freTotalItems = 0;
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getFreList()");
          console.table(error);
        });
      }

      /**
       * 발송시간 코드
       *
       * @param
       * @return
       */
      function setFreMessage(message) {
        vm.data.SendMessage = message;

      }

      /**
       * 발송시간 코드
       *
       * @param
       * @return
       */
      function getSendHourList() {
        vm.sendHourList = [
          {time:"09"}
          , {time:"10"}
          , {time:"11"}
          , {time:"12"}
          , {time:"13"}
          , {time:"14"}
          , {time:"15"}
          , {time:"16"}
          , {time:"17"}
          , {time:"18"}
          , {time:"19"}
          , {time:"20"}
        ];
      }

      /**
       * 발송분 코드 목록
       *
       * @param
       * @return
       */
      function getSendTimeList() {
        vm.sendMinList = [
          {time:"00"}
          , {time:"10"}
          , {time:"20"}
          , {time:"30"}
          , {time:"40"}
          , {time:"50"}
        ];
      }

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      // 함수 정의
      //vm.getData = getData;                     // 데이터 조회
      //vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.setFreMessage = setFreMessage;
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      //vm.setDelData = setDelData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;

      // 데이터 조회
      //getData();
      init();
      getFreList();
      getSendHourList();
      getSendTimeList();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:single-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객조회
   */
  webapp.controller('SingleListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function SingleListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {


      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Customer.getCustomerListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Customer.getCustomerList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Customer.getExcelList'; // 엑셀다운로드 SQL
      //var DELETE_LIST_SQL = 'Customer.deleteCustomerList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign.single-list';         // 목록 화면
      //var LIST_DETAIL_PAGE_URL = 'app.customer.customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.campaign.single-list.edit';    // 목록 등록/수정 화면
      //var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.campaign.single-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CustId'; // Primary Key Column
      var EXCEL_TITLE = '고객목록'; //고객 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'CustRegDt' // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      // #region 담당자 검색 팝업 호출

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };

      // #endregion 담당자 검색 팝업 호출


      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      /*
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }
      */

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      /*
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        }
      }
      */

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {


        // 목록 체크박스 로직 설정
        /*
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
        */
      }

      // 목록 삭제
      /*
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            setDelListAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }
      */
      /*
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }
      */

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      //vm.goDetail = goDetail;                     // 조회 화면 이동
      //vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      //vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // Layout 설정
      // setChangeLayout('H');

      // 목록 조회
      getList();

      // 초기 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:form-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('CampaignEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CampaignEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign2.insertCampaign';     // 등록 SQL
      var UPDATE_SQL = 'Campaign2.updateCampaign';     // 수정 SQL
      var VIEW_SQL = 'Campaign2.getCampaignDetail';   // 조회 SQL
      var DEL_SQL = 'Campaign2.deleteCampaign';  // 삭제 SQL
      var GET_GRUOP_CUST_CNT_SQL = 'Campaign2.getGroupCustomerList2';                  //수긴그룹 대상고객 조회

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.campaign-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.campaign2.campaign-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.campaign2.campaign-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.info2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // View Model
      var vm = this;          // View Model

      vm.formType = $stateParams.formType;
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.Contents = "0";
      vm.srchDetail = {};
      vm.columnMap = {};
      
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType,
          cmpgnType: $stateParams.cmpgnType
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.formType = $stateParams.formType;
        vm.srch.tableNm = KEY_TABLE_NM;
        vm.srch.cmpgnType = "AUTO";
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }
      
      //arrSendTypeExclude
      vm.arrSendTypeExclude = [];
      if(vm.srch.cmpgnType != 'AUTO'){
        vm.arrSendTypeExclude.push('REPEAT');
      }
      
      // 조회 데이터 설정
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};
      
      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };
      
      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.data.ManagerNm = okData.UserNm;
          vm.data.ManagerId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.ManagerId = "";
      };
      
      
      /**
       * 수신자그룹 호출
       *
       * @param
       * @return
       */
      vm.srchGroupModal = function () {
        var ctrl = 'TreeModalCtrl as modalCtrl';
        var paramData = {};

        var modalInstance = modalFactory.open('md', 'components/modal/campaign/tree-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.GrpNm = okData.GrpNm;
          vm.data.GrpId = okData.GrpId;
          setGroupCustCnt(okData.GrpId);

        }, function (cancelData) {
          // 취소
        });
      };
      
      function setGroupCustCnt(GrpId) {
        var data ;
        data = vm.srch;
        data.GrpId = GrpId;
        data.mapCode = GET_GRUOP_CUST_CNT_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.data.GrpTotal = result.body.docs.length;
              vm.data.GrpCustList = result.body.docs;
              
              //sms / lms / mms에 따라서 가격 변경
//              if(isNullOrEmpty(vm.data.SendType) || vm.data.SendType =='Null') {
//                gAlert('발송유형을 선택하세요.')
//                return false;
//              } else {
//                vm.data.Amt = vm.data.GrpTotal * vm.sendFee[vm.data.SendType];
//              }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteGrpcustAction()");
          console.table(error);
        });
      }
      
      /**
       * 대상자 편집
       *
       * @param
       * @return
       */
      function alertMsg() {
        gAlert('준비중입니다.');
      }
      
      /**
       * 수신자그룹 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseGroup = function () {
        vm.data.GrpNm = "";
        vm.data.GrpId = "";
        vm.data.GrpTotal = 0;
        vm.data.GrpCustList = null;
      };
      
      
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        
        
        //발신인증번호
        vm.sendNumberVerifyList = [
          {Code : '010-2998-0603', CodeValue : '010-2998-0603'},
          {Code : '010-2998-0603', CodeValue : '010-2998-0603'}
        ]

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              vm.srch.cmpgnType = vm.data.CmpgnType

              //Date형식 처리
              if (vm.data.StartDate != null && vm.data.StartDate != ""){
                //$filter('utcToLocal')(vm.data.StartDate,'yyyy-MM-dd');
                vm.StartDate = moment(vm.data.StartDate).toDate();  
              }
              
              if (vm.data.EndDate != null && vm.data.EndDate != ""){
                vm.EndDate = moment(vm.data.EndDate).toDate();
              }
              
              if (vm.data.SendType === 'RESERVE' && vm.data.SendDay != null && vm.data.SendDay != ""){
                vm.SendDay = moment(vm.data.SendDay).toDate();
              }
            } else {
              vm.data.FormType = vm.formType;
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
              vm.data.CmpgnStatus = 'TEMP';
              vm.data.ManagerNm = $window.sessionStorage["loginUserName"];
              vm.data.ManagerId = $window.sessionStorage["loginUserIdx"];
              vm.data.CmpgnType = vm.srch.cmpgnType
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      
      function uploadFile() {
//      if(vm.formType == 'EMAIL') {
//        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
//        vm.data.Contents = $("#strHtml").val();
//      }

        if (getIsValidData() == false) {
          return;
        }

        // 데이터 저장
        setData();
      }
      
      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';
//        if (isNullOrEmpty(vm.data.Contents)) {
//          console.log(vm.data.Contents);
//          errMsg = errMsg + '- 내용을 입력하세요.<br/>';
//        }
        if (isNullOrEmpty(vm.data.FormNm)) {
          errMsg = errMsg + '- 서식을 선택해 주세요.<br/>';
        }
        
        if(vm.StartDate != null ) vm.data.StartDate = moment(vm.StartDate).format('YYYY-MM-DD'); //$filter('localToUtc')(vm.StartDate, 'yyyy-MM-dd');
        if(vm.EndDate != null ) vm.data.EndDate = moment(vm.EndDate).format('YYYY-MM-DD'); //$filter('localToUtc')(vm.EndDate, 'yyyy-MM-dd');
        
        if(vm.data.SendType === 'RESERVE'){
          if(vm.SendDay != null ){
            vm.data.SendDay = moment(vm.SendDay).format('YYYY-MM-DD'); //$filter('localToUtc')(vm.EndDate, 'yyyy-MM-dd');
            vm.data.SendMinute = '00';
          }else{
            errMsg = errMsg + '- 예약시간을 입력하세요.<br/>';
          }
        } else if(vm.data.SendType === 'REPEAT'){
          //
        } else if(vm.data.SendType === 'DIRECT'){
          vm.data.SendDay = '';
          vm.data.SendHour = '';
          vm.data.SendMinute = '';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }


      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        //TODO 
        vm.data.TermOpr = 'ALL';
        
        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              cmpgnType: vm.data.CmpgnType,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch,formType:vm.formType, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }


      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        msg = vm.data['Contents'];
        bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

        if (bytes > 2000) {
          vm.data['Contents'] = fnCutMsg(msg, 2000);
          bytes = 2000;
        }

        vm["Contents"] = bytes;
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      
      /**
       * 미리보기 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.contentsModal = function () {
        var ctrl = 'ContentsModalCtrl as modalCtrl';
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        var Contents = $("#strHtml").val();
        var paramData = {Contents:Contents};

        var modalInstance = modalFactory.open("lg","components/modal/contents/contents-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
          },
          function (cancelData) {
            // 취소
          }
        );
      };

      /**
       * 서식 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchFormModal = function () {
        var ctrl = 'FormModal2Ctrl as modalCtrl';
        var paramData = { 'srchTenantId' : $rootScope.gVariable.srchTenantId , 'FormType' : vm.data.CmpgnChannel};
        var modalInstance = modalFactory.open('md', 'components/modal/campaign/form-modal2.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
//          RegUser: "시스템관리자"
//            Contents: "<p><br></p>"
//            RegDate: 1578873902000
//            FormNm: "서식 이메일~33"
//            FormType: "E-Mail"
//            KeyId: "8O4XS8J6ZT"
//            FormTypeId: "EMAIL"
//            $$hashKey: "object:438"
          vm.data.FormNm = res.FormNm;
          vm.data.FormId = res.KeyId;
          vm.data.SendMessage = res.Contents;
          vm.data.CmpgnChannel = res.FormTypeId
          /**
          if(vm.data.CmpgnChannel =='EMAIL') {
            oEditors.getById["strHtml"].exec("SET_IR", ['']);
            oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.SendMessage]);
            $('#strHtml').hide();
            $('#smart_editor2').show();
          }else{
            $('#strHtml').show();
            $('#smart_editor2').hide();
          }
          **/
        }, function(cancelData) {
          //cancle
        });
      }
      
      /**
       * 설문지 초기화
       *
       * @param
       * @return
       */
      vm.eraseForm = function () {
        vm.data.FormId = '';
        vm.data.FormNm = '';
      }
      
      vm.TermId = '';
      vm.TermOpr = '';
      function chkTermChg(){
        console.log('function-chkTermChg');
      }

      /**
       * 대상자 편집
       *
       * @param
       * @return
       */
      function editGrpTarget() {
        var ctrl = 'surveyTargetEdit2Ctrl as modalCtrl';
        var paramData = {GrpId : vm.data.GrpId ,GrpTotalList:vm.data.GrpCustList};
        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('lg', 'components/modal/campaign/survey-target-edit-modal2.html', ctrl, paramData);
        
        modalInstance.result.then(function (okData) {
          vm.data.GrpTotal = okData.length;
          vm.data.GrpCustList = okData;
        }, function (cancelData) {
          // 취소
        });
      }
      
      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.setData = setData;                     // 데이터 저장
      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제
      vm.chkTermChg = chkTermChg;
      vm.uploadFile = uploadFile;
      vm.editGrpTarget = editGrpTarget;
      vm.alertMsg = alertMsg;
      
      // 데이터 조회
      getData();

    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.campaign2:campaign-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the campaign 목록
   */
  webapp.controller('CampaignListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CampaignListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getCampaignListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getCampaignList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Campaign2.deleteCampaignList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.campaign-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.campaign2.campaign-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.campaign2.campaign-list.edit';    // 목록 등록/수정 화면
      var LIST_EDIT_AUTO_PAGE_URL = 'app.campaign2.campaign-list.auto-edit';    // 목록 등록/수정 화면

      var VIEW_PAGE_URL = 'app.campaign2.campaign-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.campaign2.campaign-edit';         // 등록/수정 화면
      var EDIT_AUTO_PAGE_URL = 'app.campaign2.campaign-auto-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.info2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var EXCEL_TITLE = '사용자관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.StartDate = $rootScope.getDateFormat(vm.srch.StartDate); // YYYY-MM-DD 를 date type 으로 변환
        vm.EndDate = $rootScope.getDateFormat(vm.srch.EndDate);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      
      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.ManagerId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.ManagerId = "";
      };
      

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.StartDate = $filter('localToUtc')(data.StartDate, 'from');
        data.EndDate = $filter('localToUtc')(data.EndDate, 'to');
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.StartDate = $filter('localToUtc')(data.StartDate, 'from');
        data.EndDate = $filter('localToUtc')(data.EndDate, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId, cmpgnType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            cmpgnType: cmpgnType,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            cmpgnType: cmpgnType,
            keyId: paramKeyId
          });
        }
      }
      

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd(cmpgnType) {
        vm.keyId = '';
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';

        if (vm.layout == 'N') {
          if(cmpgnType == 'GROUP'){
            pageUrl = EDIT_PAGE_URL;
          }else{
            pageUrl = EDIT_AUTO_PAGE_URL;
          }
        } else {
          if(cmpgnType == 'GROUP'){
            pageUrl = LIST_EDIT_PAGE_URL;
          }else{
            pageUrl = LIST_EDIT_AUTO_PAGE_URL;
          }
        }
        
        $state.go(pageUrl, {
          srch: srch,
          formType: '',
          cmpgnType : cmpgnType,
          keyId: ''
        });
      }
      
      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, cmpgnType) {
        var bAuto = false;
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';
        
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          pageUrl = EDIT_PAGE_URL;
        } else {
          pageUrl = LIST_EDIT_PAGE_URL;
        }
        
        $state.go(pageUrl, {
          srch: srch,
          cmpgnType: cmpgnType,
          keyId: paramKeyId
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.campaign2', {
      url: '/campaign2',
      template: '<div ui-view></div>'
    }).state('app.campaign2.group-list', {
      url: '/group-list/',
      templateUrl: 'app/campaign2/group-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    })
    
    .state('app.campaign2.campaign-list', {
      url: '/campaign-list/:srch',
      templateUrl: 'app/campaign2/campaign-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.campaign2.campaign-edit', {
      url: '/campaign-edit/:srch/:cmpgnType/:keyId',
      templateUrl: 'app/campaign2/campaign-edit.html',
    }).state('app.campaign2.campaign-list.edit', {
      url: '/edit/:cmpgnType/:keyId',
      templateUrl: 'app/campaign2/campaign-edit.html',
    }).state('app.campaign2.campaign-auto-edit', {
      url: '/campaign-auto-edit/:srch/:cmpgnType/:keyId',
      templateUrl: 'app/campaign2/campaign-edit.html',
    }).state('app.campaign2.campaign-list.auto-edit', {
      url: '/auto-edit/:cmpgnType/:keyId',
      templateUrl: 'app/campaign2/campaign-edit.html',
    })

    .state('app.campaign2.campaignimpl-list', {
      url: '/campaignimpl-list/:srch',
      templateUrl: 'app/campaign2/campaignimpl-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.campaign2.campaignimpl-detail', {
      url: '/campaignimpl-detail/:srch/:keyId',
      templateUrl: 'app/campaign2/campaignimpl-detail.html',
    }).state('app.campaign2.campaignimpl-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/campaign2/campaignimpl-detail.html',
    })
    
    .state('app.campaign2.form-list', {
      url: '/form-list/:srch',
      templateUrl: 'app/campaign2/form-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.campaign2.form-edit', {
      url: '/form-edit/:srch/:formType/:keyId',
      templateUrl: 'app/campaign2/form-edit.html',
    }).state('app.campaign2.form-list.edit', {
      url: '/edit/:formType/:keyId',
      templateUrl: 'app/campaign2/form-edit.html',
    })

    .state('app.campaign2.form-sms-list', {
      url: '/form-sms-list/:srch',
      templateUrl: 'app/campaign2/form-sms-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.campaign2.form-sms-edit', {
      url: '/form-sms-edit/:srch/:keyId',
      templateUrl: 'app/campaign2/form-sms-edit.html',
    }).state('app.campaign2.form-sms-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/campaign2/form-sms-edit.html',
    })
    
    .state('app.campaign2.form-email-list', {
      url: '/form-email-list/:srch',
      templateUrl: 'app/campaign2/form-email-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.campaign2.form-email-edit', {
      url: '/form-email-edit/:srch/:keyId',
      templateUrl: 'app/campaign2/form-email-edit.html',
    }).state('app.campaign2.form-email-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/campaign2/form-email-edit.html',
    });
  }
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:campaignimp-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('CampaignImplDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CampaignImplDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var VIEW_SQL = 'Campaign2.getCampaignImplDetail'; // 조회 SQL
      var LIST_CNT_SQL = 'Campaign2.getCampaignImplCustomerListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getCampaignImplCustomerList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.campaignimpl-list';           // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaignImpl'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM, // 작업 테이블명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.tableNm = KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = [];    // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김
      
      // 조회 데이터
      vm.data = {
          KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // 첨부파일 목록
      //vm.uploadFileList = [];

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        //vm.srchDetail.viewColumns = {}; // 사용자정의 컬럼 정보 설정

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            
            vm.dataloader = false; // Progressbar 숨김

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 조회 정보 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } 

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (vm.data.StartDate != null && vm.data.StartDate != ""){
                //$filter('utcToLocal')(vm.data.StartDate,'yyyy-MM-dd');
                vm.StartDate = moment(vm.data.StartDate).toDate();  
              }
              
              if (vm.data.EndDate != null && vm.data.EndDate != ""){
                vm.EndDate = moment(vm.data.EndDate).toDate();
              }
            } else {
              vm.data.FormType = vm.formType;
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }


      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }


      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        //var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});

        getList();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        //getSearch();
        getList();
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
//      vm.getList = getList;
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      //vm.setDelData = setDelData;                     // 데이터 삭제 확인

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      //vm.setSortColumn = setSortColumn;           // 정렬 설정
      //vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      //vm.goEdit = goEdit;                       // 등록/수정 화면 이동

      // 데이터 조회
//      getList();
      getData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:campaignimpl-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('CampaignImplListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CampaignImplListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getCampaignImplListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getCampaignImplList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.campaignimpl-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.campaign2.campaignimpl-list.detail';  // 목록 조회  화면
      var VIEW_PAGE_URL = 'app.campaign2.campaignimpl-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaignImpl'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      //var EXCEL_TITLE = '사용자 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.SendDateFrom = $rootScope.getDateFormat(vm.srch.SendDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.SendDateTo = $rootScope.getDateFormat(vm.srch.SendDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            console.log("re", result);
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function changeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 초기 세팅
       *
       * @param
       * @return
       */
      function init(){
        
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.changeLayout = changeLayout;             // 화면모드 설정

      // 목록 조회
      getList();
      
      init();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:form-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('FormEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function FormEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign2.insertForm';     // 등록 SQL
      var UPDATE_SQL = 'Campaign2.updateForm';     // 수정 SQL
      var VIEW_SQL = 'Campaign2.getFormDetail'; // 조회 SQL
      var GETID_SQL = 'checkLoginId';         //아이디중복 SQL
      var DEL_SQL = 'Campaign2.deleteFormDetail';  // 삭제 SQL
      var UPDATE_AGREE_MSG_SQL = 'Campaign2.updateAgreeMsg'; //수신동의메세지 update

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.form-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.campaign2.form-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.campaign2.form-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'form.sms'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model

      vm.formType = $stateParams.formType;
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.Contents = "0";

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.formType = $stateParams.formType;
        vm.srch.tableNm = KEY_TABLE_NM;
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      // #region 부서 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (vm.data.RegDateDate != null && vm.data.RegDateDate != "") vm.RegDateDate = moment(vm.data.RegDateDate).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {

              vm.data.FormType = vm.formType;
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
      if(vm.formType == 'EMAIL') {
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.Contents = $("#strHtml").val();
      }

        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.Contents)) {
          errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.FormNm)) {
          errMsg = errMsg + '- 서식명을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }


      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              formType: vm.formType,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch,formType:vm.formType, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }


      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        msg = vm.data['Contents'];
        bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

        if (bytes > 2000) {
          vm.data['Contents'] = fnCutMsg(msg, 2000);
          bytes = 2000;
        }

        vm["Contents"] = bytes;
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      /**
       * 회원수신동의 문구 저장
       * @param
       * @return
       */
      function setFromAgreeMsg() {
        var data = angular.copy(vm.data);
        data.mapCode = UPDATE_AGREE_MSG_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "회원수신동의 문구가 저장되었습니다.");
          }
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      /**
       * 서식 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchFormModal = function () {
        var ctrl = 'FormModalCtrl as modalCtrl';
        var paramData = {formType: vm.formType};
        var modalInstance = modalFactory.open("modal", "components/modal/campaign/form-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            vm.data.FormNm = okData.FormNm;
            vm.data.FormType = vm.formType;
            if(vm.formType =='EMAIL') {
              vm.data.Contents = okData.Contents;
              oEditors.getById["strHtml"].exec("SET_IR", ['']);
              oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.Contents]);
            }
            // 서식 선택
            /* vm.data.DeptNm = okData.label;
            vm.data.DeptId = okData.data; */
          },
          function (cancelData) {
            // 취소
          }
        );
      };

      /**
       * 미리보기 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.contentsModal = function () {
        var ctrl = 'ContentsModalCtrl as modalCtrl';
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        var Contents = $("#strHtml").val();
        var paramData = {Contents:Contents};

        var modalInstance = modalFactory.open("lg","components/modal/contents/contents-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
          },
          function (cancelData) {
            // 취소
          }
        );
      };

      /**
       * 설문지 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchSurveyModal = function () {
        var ctrl = 'SurveyModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/survey/survey-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.SurveyNm = res.SvyNm;
          vm.data.SurveyId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 설문지 초기화
       *
       * @param
       * @return
       */
      vm.eraseSurvey = function () {
        vm.data.SurveyId = '';
        vm.data.SurveyNm = '';
      }


      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제
      vm.setFromAgreeMsg = setFromAgreeMsg;
      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:form-email-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('FormEmailEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function FormEmailEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign2.insertForm';     // 등록 SQL
      var UPDATE_SQL = 'Campaign2.updateForm';     // 수정 SQL
      var VIEW_SQL = 'Campaign2.getFormDetail'; // 조회 SQL
      var GETID_SQL = 'checkLoginId';         //아이디중복 SQL
      var DEL_SQL = 'Campaign2.deleteFormDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.form-email-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.campaign2.form-email-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.campaign2.form-email-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'form.email'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.Contents = "0";
      vm.formType = 'EMAIL';

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: 'EMAIL'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      // #region 부서 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (vm.data.RegDateDate != null && vm.data.RegDateDate != "") vm.RegDateDate = moment(vm.data.RegDateDate).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {

              vm.data.FormType = vm.formType;
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.Contents)) {
          errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.FormNm)) {
          errMsg = errMsg + '- 서식명을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }


      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }


      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        msg = vm.data['Contents'];
        bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

        if (bytes > 2000) {
          vm.data['Contents'] = fnCutMsg(msg, 2000);
          bytes = 2000;
        }

        vm["Contents"] = bytes;
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.campaign2:form-email-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the EMAIL서식 목록
   */
  webapp.controller('FormEmailListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function FormEmailListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getFormListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getFormList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Campaign2.deleteFormList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.form-email-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.campaign2.form-email-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.campaign2.form-email-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.campaign2.form-email-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.campaign2.form-email-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'form.email'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var EXCEL_TITLE = '사용자관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          formType: 'EMAIL'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'RegDate') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.campaign2:form-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('FormListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function FormListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getFormListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getFormList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Campaign2.deleteFormList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.form-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.campaign2.form-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.campaign2.form-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.campaign2.form-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.campaign2.form-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'form.sms'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var EXCEL_TITLE = '사용자관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId,formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd(formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, formType) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'RegDate') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:form-sms-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('FormSmsEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function FormSmsEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign2.insertForm';     // 등록 SQL
      var UPDATE_SQL = 'Campaign2.updateForm';     // 수정 SQL
      var VIEW_SQL = 'Campaign2.getFormDetail'; // 조회 SQL
      var GETID_SQL = 'checkLoginId';         //아이디중복 SQL
      var DEL_SQL = 'Campaign2.deleteFormDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.form-sms-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.campaign2.form-sms-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.campaign2.form-sms-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'form.sms'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.Contents = "0";
      vm.formType = 'SMS';

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: 'SMS'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      // #region 부서 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (vm.data.RegDateDate != null && vm.data.RegDateDate != "") vm.RegDateDate = moment(vm.data.RegDateDate).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {

              vm.data.FormType = vm.formType;
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.Contents)) {
          errMsg = errMsg + '- SMS 내용을 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.FormNm)) {
          errMsg = errMsg + '- 서식명을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }


      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }


      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        msg = vm.data['Contents'];
        bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

        if (bytes > 2000) {
          vm.data['Contents'] = fnCutMsg(msg, 2000);
          bytes = 2000;
        }

        vm["Contents"] = bytes;
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.campaign2:form-sms-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the SMS서식 목록
   */
  webapp.controller('FormSmsListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function FormSmsListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getFormListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getFormList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Campaign2.deleteFormList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.campaign2.form-sms-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.campaign2.form-sms-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.campaign2.form-sms-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.campaign2.form-sms-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.campaign2.form-sms-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'form.sms'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var EXCEL_TITLE = '사용자관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          formType: 'SMS'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'RegDate') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

webapp.controller('CustGroupListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
  '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', function CustGroupListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, api, modalFactory, $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate) {

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};
    vm.maxGrpId = 0;
    vm.lists = [];
    vm.saveYn = true;
    vm.data = {CustomCode: 0};

    $scope.toggleLeft = buildToggler('left');
    $scope.toggleRight = buildToggler('right');


    // --------------------------------------------------------- 그룹고객 관련 소스 ---------------------------------------------------------
    // SQL Mapper Id 정의
    var LIST_CNT_SQL = 'Campaign2.getGroupcustomerListCnt'; // 그룹고객 목록 건수 조회 SQL
    var LIST_SQL = 'Campaign2.getGroupcustomerList';    // 그룹고객 목록 조회 SQL
    var EXCEL_SQL = 'Campaign2.getGroupcustomerExcelList'; // 그룹고객 엑셀다운로드 SQL
    var DELETE_LIST_SQL = 'Campaign2.deleteGroupcustomerList'; // 그룹고객 목록에서 삭제
    var DELETEALL_LIST_SQL = 'Campaign2.deleteAllGroupcustomerList'; // 그룹고객 목록에서 전체삭제
    var ADDGRPCUSTALL_SQL = 'Campaign2.insertAllGroupcustomer'; // 그룹고객 목록에서 고객전체추가
    var MOVE_CUST_SQL = 'Campaign2.updateCustGrpId'; // 고객 수신자그룹이동

    // 관련 테이블 정의
    var KEY_TABLE_NM = 'campaign.groupcustomer'; // 그룹고객 작업 테이블명
    var KEY_COLUMN_NM = 'CustId'; // 그룹고객 Primary Key Column
    var EXCEL_TITLE = '그룹고객목록'; // 그룹고객 엑셀파일 이름
    // #endregion 상수 정의

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: 'CustRegDt' // 정렬컬럼명
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
      vm.currentPage = vm.srch.page;
    }

    vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    //vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
    vm.anchor = "";
    //setLayout(vm.layout); // 화면분할 모드 설정
    vm.srch.KeyIdList = [];

    /**
     * 전체고객 추가
     *
     * @param
     * @return
     */
    function addGrpcustAll() {
      var data;

      data = vm.srch;
      data.GrpId = vm.data.GrpId;

      data.mapCode = ADDGRPCUSTALL_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn : '',
            fn : function() {
              getGrpcustList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> addGrpcustAll()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 삭제
     *
     * @param
     * @return
     */
    function deleteGrpcust(type) {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteGrpcustAction(type);
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteGrpcustAction(type) {
      var data;

      if (type == "") {
        for (var i = 0; i < vm.grpcustLists.length; i++) {
          if (vm.grpcustLists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.grpcustLists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }
      }

      data = vm.srch;
      data.GrpId = vm.data.GrpId;

      if (type == "ALL") data.mapCode = DELETEALL_LIST_SQL;
      else data.mapCode = DELETE_LIST_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getGrpcustList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteGrpcustAction()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 건수 조회
     *
     * @param
     * @return
     */
    function getGrpcustListCnt() {

      var data = vm.srch; // 검색 옵션 설정
      data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

      data.GrpId = vm.data.GrpId;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          if (result.body.docs.length > 0) {
            // 총 목록 건수 설정
            vm.grpcustTotalItems = result.body.docs;
          } else {
            // 조회 실패
            vm.grpcustTotalItems = 0;
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getGrpcustListCnt()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 조회
     *
     * @param
     * @return
     */
    function getGrpcustList() {
      vm.dataloader = true; // Progressbar 표시
      vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

      getGrpcustListCnt(); // 목록 건수 조회

      var data = vm.srch; // 검색 옵션 설정
      data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
      data.mapCode = LIST_SQL;
      data.GrpId = vm.data.GrpId;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          // MetaColumn 사용
          if (result.body.desc.length > 0) {
            // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
            vm.grpcustListColumns = result.body.desc;
            angular.forEach(vm.grpcustListColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          } else {
            console.error('Error> getGrpcustList()> MetaColumn 정보 조회 오류');
            console.table(data);
          }

          if (result.body.docs.length > 0 && !isNullOrEmpty(vm.grpcustListColumns)) {
            // 목록 데이터 표시
            vm.grpcustLists = result.body.docs;
            // 목록 화면 구성
            setResponsive();
          } else {
            // 데이터 조회 실패
            vm.grpcustLists = {};
          }
        }

        vm.dataloader = false; // Progressbar 숨김

      }, function (error) {
        vm.dataloader = false; // Progressbar 숨김

        // 조회 중 오류 발생
        console.error("Error> getGrpcustList()");
        console.table(error);

      });
    }

    /**
     * 그룹고객 목록 비우기
     *
     * @param
     * @return
     */
    function getGrpcustListClear() {
      vm.grpcustLists = null;
      vm.grpcustTotalItems = 0;
    }

    /**
     * 그룹고객 목록 화면 구성
     *
     * @param
     * @return
     */
    function setResponsive() {
      var columns = [];
      var o = {};

      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.grpcustListColumns, function (item) {
        var column = {};

        column.name = item.ColumnPhysicalNm; // 물리 컬럼명
        column.title = item.ColumnLogicalNm; // 논리 컬럼명

        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }

        if (item.ColumnPhysicalDataType == "40") {
          // 날짜형 데이터 처리
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }

        index++;
        columns.push(column);
      });
    }

    /**
     * 그룹고객 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      //var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});

      getGrpcustList();
    }

    /**
     * 그룹고객 목록 당 조회 건수 변경
     * @param
     * @return
     */
    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      //getSearch();
      getGrpcustList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {

      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      //getSearch();
      getGrpcustList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    function setSortDirect(sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    /**
     * 그룹고객 Excel 파일 다운로드
     * @param
     * @return
     */
    function getExcelFile() {

      if (vm.grpcustLists.length == undefined) {
        gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
        return;
      }

      if (vm.grpcustLists.length == 0) {
        gAlert("", "Menu.데이터가 없습니다.");
        return;
      }

      var a = document.createElement("a");
      document.body.appendChild(a);

      var data = vm.srch;
      data.mapCode = EXCEL_SQL;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          $scope.jsonToExport = result.body.docs;
          $scope.fileName = EXCEL_TITLE;
          $scope.exportData = [];

          var obj = [];

          angular.forEach(vm.columnMap, function (item) {
            obj.push(item.ColumnLogicalNm);
          });
          $scope.exportData.push(obj);

          // Data:
          angular.forEach($scope.jsonToExport, function (value) {
            obj = [];
            angular.forEach(vm.columnMap, function (item) {
              if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              }
              else {
                obj.push(value[item.ColumnPhysicalNm]);
              }
            });
            $scope.exportData.push(obj);
          });

          $rootScope.excelDown($scope.exportData, $scope.fileName);
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getExcelFile()");
        console.table(error);
      });
    }

    /**
     * 그룹고객추가 팝업 호출
     *
     * @param {string}
     * @return {boolean}
     */
    vm.srchGrpcustModal = function () {
      var ctrl = 'SrchCustModalCtrl as modalCtrl';

      var paramData = {GrpId: vm.data.GrpId};
      var modalInstance = modalFactory.open('modal', 'components/modal/campaign/srch-cust-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        getGrpcustList();
      }, function (cancelData) {
        //
      });
    };

    // --------------------------------------------------------- /그룹고객 관련 소스 ---------------------------------------------------------

    /**
     * SMS발송 팝업 호출
     *
     * @param {string}
     * @return {boolean}
     */
    vm.addSmsModal = function () {
      var ctrl = 'SmsModalCtrl as vc';

      var paramData = {keyId: vm.data.GrpId};
      var modalInstance = modalFactory.open('modal', 'components/modal/campaign/sms-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
      }, function (cancelData) {
      });
    };

    // 회원사 변경 설정
    $scope.$on('broadcastSetChangeTenantID', function (event, data) {
      getTreeList();
      getGrpcustList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수


    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildToggler(navID) {
      var debounceFn = $mdUtil.debounce(function() {
        $mdSidenav(navID).toggle().then(function() {
          console.debug("toggle " + navID + " is done");
        });
      }, 200);
      return debounceFn;
    }

    $scope.init = function() {
      // check if there is query in url
      // and fire search in case its value is not empty
    };

    // stops the interval
    $scope.$on("$destroy", function() {
    });

    $scope.$on('broadcastSetChangeTenantID', function(event, data) {
      resetList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.grpcustLists.length; i++) {
        if (!vm.grpcustLists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }
      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.grpcustLists.length; i++) {
        vm.grpcustLists[i].chkRow = vm.chkHead;
      }
    };

    /*
    function resetSearch() {
      vm.srch.GrpNm = '';
      vm.data = {CustomCode: 0};
      tree.select_branch(null);
    }
    */

    function resetList() {
      //resetSearch();

      getTreeList();
      getGrpcustListClear();
    }

    /*
    vm.nextSearch = function() {
      tree.next_search_text();
    };
    */

    // 함수 선언
    //vm.resetSearch = resetSearch;
    vm.resetList = resetList;
    vm.getTreeList = getTreeList;
    vm.delNode = delNode;
    vm.delNodeCancel = delNodeCancel;
    vm.saveData = saveData;
    vm.onChangeGrpNm = onChangeGrpNm;
    //vm.onChangeCode = onChangeCode;
    vm.onChanged = onChanged;
    //vm.ChangeCustomCode = ChangeCustomCode;
    vm.deleteGrpcust = deleteGrpcust;
    vm.addGrpcustAll = addGrpcustAll;

    vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
    vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
    vm.setSortColumn = setSortColumn;           // 정렬 설정
    vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시


    // my_tree 반드시 선언하기
    var tree;
    $scope.my_tree = tree = {};

    vm.topItem = null;

    /*
    vm.UseYNData = {
      CallbackTarget : '0000',
      CodeType : 'USEYN',
      Code : vm.data.UseYN,
      ReloadSeq : 1
    };
    */

    /*
    vm.onSelectCallback = function(data) {
      if (data.CallbackTarget == '0000') {
        vm.data.UseYN = data.Code;
      }
    };
    */

    getTreeList();

    function getTreeList() {
      // 사전에 트리 선언함.(중요포인트)
      vm.dataloader = true;
      $scope.my_data = [];

      // 로케이션관리 select 검색실행함
      var data = vm.srch;
      data.mapCode = 'Campaign.getGroupList';
      postApi.select(data, function(result) {
        vm.dataloader = false;

        if (result.header.status == CONSTANT.HttpStatus.OK) {

          if (result.body.docs.length == 0) {
            return;
          }

          // select한 datatable 바인딩
          vm.lists = result.body.docs;

          vm.topItem = result.body.docs[0];

          refreshTree();

          // 트리 펼치기
          $timeout(function() {
            return tree.expand_init();
          }, 1);

        }
      }, function(error) {
        vm.dataloader = false;
        console.error('fail', status, data);
      });
    }

    // 계층형 json 구조로 변환
    function unflatten(items) {
      // 다시 설정(배치)하는 부분
      return items.reduce(insert, {
        res : [],
        map : {}
      }).res;
    }

    // 계층형 json 부모/자식 구분하여 구조 변환
    function insert(obj, item) {
      var parent = item.parent; // 부모값
      var map = obj.map;
      map[item.guid] = item; // 아이템 구성함

      if (parent === null)
        obj.res.push(item); // 부모값 생성
      else {
        var parentItem = map[parent];
        // 자식값 생성
        if (parentItem != null) {
          if (parentItem.hasOwnProperty("children"))
            parentItem.children.push(item);
          else
            parentItem.children = [ item ];
        }
      }

      return obj;
    }

    // guid, parent 제외한 계층형 json 구조 변환하기
    function traverse(jsonObj) {

      for (var i = 0; i < jsonObj.length; i++) {
        if (jsonObj[i].children == null) {
        } else {
          traverse(jsonObj[i].children);
        }

        // label, children 만 추가함
        var newItem = {
          "label" : jsonObj[i].label,
          "data" : jsonObj[i].guid,
          "children" : jsonObj[i].children,
          "classes" : jsonObj[i].classes,
        }
        jsonObj[i] = newItem;
      }
    }

    // 트리 목록에서 조회값
    $scope.my_tree_handler = function(branch) {
      angular.forEach(vm.lists, function(item) {
        if (branch.data == item.GrpId.toString()) {
          vm.data = item;

          if (vm.data.New != 'Y' && vm.data.GrpId != null) {
            getGrpcustList();
          }
          /*
          vm.UseYNData = {
            CallbackTarget : '0000',
            CodeType : 'USEYN',
            Code : vm.data.UseYN,
            ReloadSeq : (new Date()).getTime()
          };
          */
          return;
        }
      });
    };

    $scope.try_adding_a_branch = function() {

      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
      var grpId = newnum.toString(36);

      var branch = tree.get_selected_branch();
      if (branch == null) {
        var grpInfo = {
          'GrpNm' : '새로운 코드',
          'GrpId' : grpId,
          'ParentGrpId' : 0,
          'GrpLevel' : 1,
          //'UseYN' : 'Y',
          'New' : 'Y',
          //'CodeType' : '',
          'TenantId' : $rootScope.gVariable.srchTenantId,
          //'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1
        };
        vm.lists.push(grpInfo);
      } else {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.GrpId.toString()) {
            var grpInfo = {
              'GrpNm' : '새로운 코드',
              'GrpId' : grpId,
              'ParentGrpId' : branch.data,
              'GrpLevel' : item.GrpLevel + 1,
              //'UseYN' : 'Y',
              'New' : 'Y',
              //'CodeType' : item.CodeType,
              'TenantId' : $rootScope.gVariable.srchTenantId,
              'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1
            };
            vm.lists.push(grpInfo);
            return;
          }
        });

        getGrpcustListClear();
      }

      var code = {};
      if ($rootScope.gVariable.srchTenantId == 0) {
        code = {label: '[*]새로운 코드', data: grpId};
      } else {
        //code = {label: '[*]새로운 코드', data: grpId, classes: ['color-red']};
        code = {label: '[*]새로운 코드', data: grpId};
      }
      var new_branch = tree.add_branch(branch, code);
      tree.select_branch(new_branch);
    };

    function delNode() {
      var grpId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
        $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
        return;
      }

      gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
        btn : '',
        fn : function(){
          if (vm.data.New == 'Y'){
            deleteNodeTree();
          }else {
            vm.data.DelYN = 'Y';
            saveData();
          }
        }
      }, {
        btn : '',
        fn : function(){
        }
      });
    }

    function deleteNodeTree() {
      var grpId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      angular.forEach(vm.lists, function(item) {
        if (branch.data == item.GrpId.toString()) {
          var index = vm.lists.indexOf(item);
          vm.lists.splice(index, 1);

          var parent = tree.select_parent_branch();
          if(parent){
            parent.children.splice(parent.children.indexOf(branch),1);
          } else {
            refreshTree();
          }

          return;
        }
      });

      tree.select_branch(null);
      vm.data = {CustomCode: 0};
    }

    function refreshTree() {

      // 리스트 생성
      var arrlist = [];

      // for문으로 다시 json 구조로 변환함.
      angular.forEach(vm.lists, function(item) {
        // 객체 생성
        var data = {};

        data.label = $translate.instant(item.GrpNm);
        data.guid = item.GrpId;
        data.parent = item.ParentGrpId == undefined || item.ParentGrpId == 0 ? null : item.ParentGrpId;
        data.classes = [];
        //data.classes.push(item.TenantId == '0' ? '' : 'color-red');

        // 리스트에 생성된 객체 삽입
        arrlist.push(data);

        if (item.GrpId > vm.maxGrpId)
          vm.maxGrpId = item.GrpId;
      });

      // 계층형 json 구조로 변환함
      var recursiveArray = unflatten(arrlist);

      // guid, parent 제외 변환함
      traverse(recursiveArray);

      // 트리구조에 바인딩
      $scope.my_data = recursiveArray;

      // 트리 펼치기
//        $timeout(function() {
//          return tree.expand_all();
//        }, 1);

    }

    function onChangeGrpNm() {
      onChanged();
      var branch = tree.get_selected_branch();
      if (branch == null) return;
      branch.label = '[*]' + vm.data.GrpNm;
    }

    /*
    function onChangeCode() {
      onChanged();
      if (vm.data.New == 'Y') {
      }
    }
    */

    function onChanged() {
      if (vm.data.New == null || vm.data.New != 'Y') {
        vm.data.Edit = 'Y';
      }
    }

    function removeNode(jsonObj, grpId) {
      for (var i = 0; i < jsonObj.length; i++) {
        console.log('jsonObj[i]=', jsonObj[i]);
        console.log('GrpId=', grpId);

        if (jsonObj[i].data == grpId) {
          jsonObj[i].children = [];
          return true;
        }

        if (jsonObj[i].children == null) {
        } else {
          if (removeNode(jsonObj[i].children, grpId) == true)
            break;
        }
      }
    }

    function delNodeCancel() {
      var grpId = '';
      var branch = tree.get_selected_branch();
      angular.forEach(vm.lists, function(item) {
        if (branch.data == item.GrpId.toString()) {
          item.DelYN = 'N';
          branch.label = branch.label.replace(/^\[X\]/,"");;
          return;
        }
      });
    }

    function saveData() {
      vm.dataloader = true;
      var data = {lists : []};
      data.mapCode = 'Campaign.insertGroup';

      if (isNullOrEmpty(vm.data.SortSeq)) vm.data.SortSeq = 0;

      data.lists.push(vm.data);
      postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            var branch = tree.get_selected_branch();
            branch.label = branch.label.replace(/^\[\*\]/,"");

            if (vm.data.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.New = '';
            } else if (vm.data.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.Edit = '';
            }
//            getTreeList();
          }
        },

        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

    }

    /**
     * 트리 호출
     *
     * @param
     * @return
     */
    vm.srchTreeModal = function () {
      var ctrl = 'TreeModalCtrl as modalCtrl';
      var paramData = {};

      // 부서 검색 팝업 호출
      var modalInstance = modalFactory.open('md', 'components/modal/campaign/tree-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        // 부서 선택

        if(!isNullOrEmpty(okData.GrpId)) {
          gConfirm('', '선택된 고객의 수신자그룹을 변경 하겠습니까?', {
            btn: '',
            fn: function () {
              updateCustTree(okData.GrpId);
            }
          }, {
            btn: '',
            fn: function () {
            }
          });

        }
      }, function (cancelData) {
        // 취소
      });
    };

    function updateCustTree(GrpId) {
      var data;

      for (var i = 0; i < vm.grpcustLists.length; i++) {
        if (vm.grpcustLists[i].chkRow) {
          vm.srch.KeyIdList.push(vm.grpcustLists[i].GrpCustId);
        }
      }
      if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
        gAlert('', 'Menu.DELETENODATA');
        return false;
      }
      data = vm.srch;
      data.GrpId = GrpId;
      data.mapCode = MOVE_CUST_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '이동되었습니다.', {
            btn : '',
            fn : function() {
              getGrpcustList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteGrpcustAction()");
        console.table(error);
      });
    }


    vm.getGrpcustList = getGrpcustList;

    // 목록 조회
    getGrpcustList();
  } ]);


(function() {
  "use strict";
  /**
   * @ngdoc function
   * @name sbAdminApp.controller:MainCtrl
   * @description
   * # MainCtrl
   * Controller of the sbAdminApp
   */
  webapp.controller("ChartCtrl", [
    "$scope",
    "$timeout",
    function($scope, $timeout) {
      var vm = this;

      vm.chartOptions = {
        series: {
          pie: {
            show: true,
            innerRadius: 0,
            stroke: {
              width: 0
            },
            label: {
              show: true,
              threshold: 0.05,
            },
          }
        },
        colors: ['#428bca','#5cb85c','#f0ad4e','#d9534f','#5bc0de','#616f77'],
        grid: {
          hoverable: true,
          clickable: true,
          borderWidth: 0,
          color: '#ccc'
        },
        tooltip: true,
        tooltipOpts: { content: '%s: %p.0%' }
      };

      $scope.dataset0100 = [
        { label: '1분기', data: 20 },
        { label: '2분기', data: 30 },
        { label: '3분기', data: 10 },
        { label: '4분기', data: 40 }
      ];

      $scope.options0101 = vm.chartOptions;

      $scope.line = {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July"
        ],
        series: ["Series A", "Series B"],
        data: [[65, 59, 80, 81, 56, 55, 40], [28, 48, 40, 19, 86, 27, 90]],
        onClick: function(points, evt) {
          console.log(points, evt);
        }
      };

      $scope.bar = {
        labels: ["2006", "2007", "2008", "2009", "2010", "2011", "2012"],
        series: ["Series A", "Series B"],

        data: [[65, 59, 80, 81, 56, 55, 40], [28, 48, 40, 19, 86, 27, 90]]
      };

      $scope.donut = {
        labels: ["Download Sales", "In-Store Sales", "Mail-Order Sales"],
        data: [300, 500, 100]
      };

      $scope.radar = {
        labels: [
          "Eating",
          "Drinking",
          "Sleeping",
          "Designing",
          "Coding",
          "Cycling",
          "Running"
        ],

        data: [[65, 59, 90, 81, 56, 55, 40], [28, 48, 40, 19, 96, 27, 100]]
      };

      $scope.pie = {
        labels: ["Download Sales", "In-Store Sales", "Mail-Order Sales"],
        data: [300, 500, 100]
      };

      $scope.polar = {
        labels: [
          "Download Sales",
          "In-Store Sales",
          "Mail-Order Sales",
          "Tele Sales",
          "Corporate Sales"
        ],
        data: [300, 500, 100, 40, 120]
      };

      $scope.dynamic = {
        labels: [
          "Download Sales",
          "In-Store Sales",
          "Mail-Order Sales",
          "Tele Sales",
          "Corporate Sales"
        ],
        data: [300, 500, 100, 40, 120],
        type: "PolarArea",

        toggle: function() {
          this.type = this.type === "PolarArea" ? "Pie" : "PolarArea";
        }
      };
    }
  ]);
})();

webapp.service('CommunityAPISrv', ['$resource', 'StaticVariable', '$rootScope',
  function H0102APISrv($resource, StaticVariable, $rootScope) {
    var communityApi = {
      attachFileDelete: function() {
        return $resource(StaticVariable.getUrl('/attach/file/delete.do'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return communityApi;
  },
]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.community', {
      url : '/community',
      template : '<div ui-view></div>'

    }).state('app.community.notice-list', {
      url: '/notice-list/:srch/:BbsMasterId',
      templateUrl: 'app/community/notice-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.community.notice-edit', {
      url: '/notice-edit/:srch/:BbsMasterId/:BbsPostId',
      templateUrl: 'app/community/notice-edit.html',
    }).state('app.community.notice-list.edit', {
      url: '/edit/:BbsMasterId/:BbsPostId',
      templateUrl: 'app/community/notice-edit.html',
    }).state('app.community.notice-detail', {
      url : '/notice-detail/:srch/:BbsMasterId/:BbsPostId',
      templateUrl : 'app/community/notice-detail.html',
    }).state('app.community.notice-list.detail', {
      url : '/detail/:BbsMasterId/:BbsPostId',
      templateUrl : 'app/community/notice-detail.html',



    }).state('app.community.news-list', {
      url: '/news-list/:srch/:BbsMasterId',
      templateUrl: 'app/community/news-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.community.news-edit', {
      url: '/news-edit/:srch/:BbsMasterId/:BbsPostId',
      templateUrl: 'app/community/news-edit.html',
    }).state('app.community.news-list.edit', {
      url: '/edit/:BbsMasterId/:BbsPostId',
      templateUrl: 'app/community/news-edit.html',
    }).state('app.community.news-detail', {
      url : '/news-detail/:srch/:BbsMasterId/:BbsPostId',
      templateUrl : 'app/community/news-detail.html',
    }).state('app.community.news-list.detail', {
      url : '/detail/:BbsMasterId/:BbsPostId',
      templateUrl : 'app/community/news-detail.html',



    }).state('app.community.winners-list', {
      url: '/winners-list/:srch/:BbsMasterId',
      templateUrl: 'app/community/winners-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.community.winners-edit', {
      url: '/winners-edit/:srch/:BbsMasterId/:BbsPostId',
      templateUrl: 'app/community/winners-edit.html',
    }).state('app.community.winners-list.edit', {
      url: '/edit/:BbsMasterId/:BbsPostId',
      templateUrl: 'app/community/winners-edit.html',
    }).state('app.community.winners-detail', {
      url : '/winners-detail/:srch/:BbsMasterId/:BbsPostId',
      templateUrl : 'app/community/winners-detail.html',
    }).state('app.community.winners-list.detail', {
      url : '/detail/:BbsMasterId/:BbsPostId',
      templateUrl : 'app/community/winners-detail.html',


    });
  }
})();

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:news-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('NewsDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function NewsDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'community.news', // For CustomColumn and FileAttachment
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.srch.BbsMasterId = $stateParams.BbsMasterId;

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        TableNm : vm.srchDetail.TableNm,
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      // 업로드 파일 목록
      vm.uploadFileList = [];

      (function NewsDetailCtrl() {
        console.log('NewsDetailCtrl:');
      })();

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        console.log("srchDetail", vm.srchDetail);
        postApi.select('WjmHome.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              console.log(vm.data);

              console.log($filter('utcToLocal')(vm.data.RegDate,'yyyy-MM-dd h:mm a'));

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> news-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'WjmHome.deleteBbsPost';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.community.news-list', {
                  srch:srch,
                  BbsMasterId : vm.srch.BbsMasterId
                }, {reload:'app.community.news-list'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> news-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.community.news-list', {
          srch : srch,
          BbsMasterId : vm.srch.BbsMasterId
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.community.news-edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        } else {
          $state.go('app.community.news-list.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      // 함수 선언
      vm.getData = getData;
      vm.deleteData = deleteData;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;

      // 데이터 조회
      getData();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.community:news-edit-ctrl
 * @description
 * 커뮤니티 뉴스레터
 */
webapp.controller("NewsEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', 'CommunityAPISrv',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function NewsEditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, postApi, customFieldApi, $rootScope, $timeout, CommunityAPISrv) {
    // View Model
    var LIST_PAGE_URL = 'app.community.news-list';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.community.news-list.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.community.news-detail';           // 상세 화면

    var vm = this;
    vm.vault = null;

    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'community.news', // For CustomColumn and FileAttachment
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    vm.srch.BbsMasterId = $stateParams.BbsMasterId;

    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
    vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId,
    };

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = CommunityAPISrv.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment

      postApi.select("WjmHome.getBbsPostDetail", vm.srchDetail, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

              if ( ! isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.data.PublicYN = "Y";
              }

            }
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {

      if(valid()){
        // 내용
        vm.dataloader = true;
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

        vm.data.BbsMasterId = vm.srch.BbsMasterId;
        vm.data.Contents = $("#strHtml").val();
        vm.data.tableNm = vm.srch.tableNm;
        vm.data.RelateDataId = vm.data.BbsPostId;
        vm.data.IdName = "BbsPostId";
        vm.data.uploadFileList = vm.uploadFileList;
        vm.data.userkey = vm.srch.userkey;

        var data = vm.data;
        if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
          // 등록
          data.mapCode = "WjmHome.insertBbsPost";
          postApi.insert(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        } else {
          // 수정
          data.mapCode = "WjmHome.updateBbsPost";
          postApi.update(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        }
    }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch, BbsMasterId : vm.srch.BbsMasterId });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch; // 검색 옵션

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch, BbsMasterId : vm.srch.BbsMasterId}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsMasterId: vm.srch.BbsMasterId,
            BbsPostId: vm.data.BbsPostId,
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsMasterId : vm.data.BbsMasterId, BbsPostId: vm.data.BbsPostId});
      }
    }

    function valid(){
      if(isNullOrEmpty(vm.data.Title)){
        gAlert("","제목을 입력해주세요.");
        return false;
      }else {
        return true;
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getData();
  }
]);

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.community:news-list-ctrl
 * @description
 * 커뮤니티 뉴스레터
 */
 webapp.controller("NewsListCtrl", [
  "$window",
  "$scope",
  "$location",
  "$state",
  "$stateParams",
  "$rootScope",
  "GLOBAL_CONSTANT",
  "postApi",
  "$compile",
  "modalFactory",
  "$translate",
  "$filter",
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   */
  function NewsListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    postApi,
    $compile,
    modalFactory,
    $translate,
    $filter
  ) {
    var vm = this;
    vm.dataloader = false;

    if (!$stateParams.srch) {
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        tableNm: "community.news", // For CustomColumn and FileAttachment
        sortDirect: "",
        sortColumn: "",
        srchTenantId: $rootScope.gVariable.srchTenantId
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = "community.news"; // For CustomColumn and FileAttachment
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.BbsPostId;
    $scope.selectedRow = $stateParams.BbsPostId;
    vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    vm.listSize = [10, 25, 50, 100];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    $scope.showDetail = function (li) {
      $location.url("/" + li.BbsPostId);
    };

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == "N") return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getSearch();
    }

    function sortClass(sortkey) {
      if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

      var rtnval = "";

      if (vm.srch.sortDirect == "ASC") {
        rtnval = "fa fa-caret-down";
      } else {
        rtnval = "fa fa-caret-up";
      }
      return rtnval;
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author
     */
    function getList() {
      vm.dataloader = true;
      vm.viewSize = vm.srch.viewSize;

      getListCnt();

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.selectType = "List"; // For CustomColumn
      data.mapCode = "WjmHome.getBbsPostList";
      console.log(data);
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
              console.log(vm.lists);
            } else {
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(
            vm.totalItems,
            vm.columnMap,
            vm.srch
          );
          vm.dataloader = false;
        },
        function (error) {
          console.error("Error> news-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.mapCode = "BbsPost.getBbsPostListCnt";
      postApi.select(data, function (result) {
          /* console.log("type C", result.header);
        console.log("type c", result.body); */
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        },
        function (error) {
          console.error("Error> news-list-ctrl> getListCnt()", status, error);
        }
      );
    }

    function setResponsive(dockMode) {
      var rows = vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if (item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.community.news-list",
        { srch: srch },
        { reload: "app.community.news-list" }
      );
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.community.news-list",
        { srch: srch },
        { reload: "app.community.news-list" }
      );
    }

    function resetSearch() {
      $state.go(
        "app.community.news-list",
        { srch: "" },
        { reload: "app.community.news-list" }
      );
    }

    function goDetail(BbsPostId) {
      var srch = $stateParams.srch;
      vm.keyId = BbsPostId;
      $scope.selectedRow = BbsPostId;
      if (vm.layout == "N") {
        $state.go("app.community.news-detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.community.news-list.detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      vm.keyId = "";
      if (vm.layout == "N") {
        $state.go("app.community.news-edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.community.news-list.edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }
    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem("layoutBoard", layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go(
        "app.community.news-list",
        {
          srch: srch,
        },
        { reload: "app.community.news-list" }
      );
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.setSortColumn = setSortColumn;
    vm.sortClass = sortClass;

    // 데이터 조회
    getList();
  },
]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:notice-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('NoticeDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function NoticeDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'community.notice', // For CustomColumn and FileAttachment
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.srch.BbsMasterId = $stateParams.BbsMasterId;

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        TableNm : vm.srchDetail.TableNm,
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      // 업로드 파일 목록
      vm.uploadFileList = [];

      (function NoticeDetailCtrl() {
        console.log('NoticeDetailCtrl:');
      })();

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        console.log("srchDetail", vm.srchDetail);
        postApi.select('WjmHome.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              console.log(vm.data);

              console.log($filter('utcToLocal')(vm.data.RegDate,'yyyy-MM-dd h:mm a'));

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> notice-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'WjmHome.deleteBbsPost';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.community.notice-list', {
                  srch:srch,
                  BbsMasterId : vm.srch.BbsMasterId
                }, {reload:'app.community.notice-list'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> notice-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.community.notice-list', {
          srch : srch,
          BbsMasterId : vm.srch.BbsMasterId
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.community.notice-edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        } else {
          $state.go('app.community.notice-list.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      // 함수 선언
      vm.getData = getData;
      vm.deleteData = deleteData;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;

      // 데이터 조회
      getData();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.community:notice-edit-ctrl
 * @description
 * 커뮤니티 공지사항
 */
webapp.controller("NoticeEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', 'CommunityAPISrv',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function NoticeEditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, postApi, customFieldApi, $rootScope, $timeout, CommunityAPISrv) {
    // View Model
    var LIST_PAGE_URL = 'app.community.notice-list';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.community.notice-list.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.community.notice-detail';           // 상세 화면

    var vm = this;
    vm.vault = null;

    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'community.notice', // For CustomColumn and FileAttachment
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    vm.srch.BbsMasterId = $stateParams.BbsMasterId;

    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
    vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId,
    };

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = CommunityAPISrv.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment

      postApi.select("WjmHome.getBbsPostDetail", vm.srchDetail, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

              if ( ! isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.data.PublicYN = "Y";
                vm.data.NoticeYN = "N";
              }

            }
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {

      if(valid()){
        // 내용
        vm.dataloader = true;
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

        vm.data.BbsMasterId = vm.srch.BbsMasterId;
        vm.data.Contents = $("#strHtml").val();
        vm.data.tableNm = vm.srch.tableNm;
        vm.data.RelateDataId = vm.data.BbsPostId;
        vm.data.IdName = "BbsPostId";
        vm.data.uploadFileList = vm.uploadFileList;
        vm.data.userkey = vm.srch.userkey;

        var data = vm.data;
        if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
          // 등록
          data.mapCode = "WjmHome.insertBbsPost";
          postApi.insert(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        } else {
          // 수정
          data.mapCode = "WjmHome.updateBbsPost";
          postApi.update(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        }
    }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch, BbsMasterId : vm.srch.BbsMasterId });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch; // 검색 옵션

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch, BbsMasterId : vm.srch.BbsMasterId}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsMasterId: vm.srch.BbsMasterId,
            BbsPostId: vm.data.BbsPostId,
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.BbsMasterId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsMasterId : vm.data.BbsMasterId, BbsPostId: vm.data.BbsPostId});
      }
    }

    function valid(){
      if(isNullOrEmpty(vm.data.Title)){
        gAlert("","제목을 입력해주세요.");
        return false;
      }else {
        return true;
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getData();
  }
]);

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.community:notice-list-ctrl
 * @description
 * 커뮤니티 공지사항
 */
 webapp.controller("NoticeListCtrl", [
  "$window",
  "$scope",
  "$location",
  "$state",
  "$stateParams",
  "$rootScope",
  "GLOBAL_CONSTANT",
  "postApi",
  "$compile",
  "modalFactory",
  "$translate",
  "$filter",
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   */
  function NoticeListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    postApi,
    $compile,
    modalFactory,
    $translate,
    $filter
  ) {
    var vm = this;
    vm.dataloader = false;

    if (!$stateParams.srch) {
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        tableNm: "community.notice", // For CustomColumn and FileAttachment
        sortDirect: "",
        sortColumn: "",
        srchTenantId: $rootScope.gVariable.srchTenantId
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = "community.notice"; // For CustomColumn and FileAttachment
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.BbsPostId;
    $scope.selectedRow = $stateParams.BbsPostId;
    vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    vm.listSize = [10, 25, 50, 100];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    $scope.showDetail = function (li) {
      $location.url("/" + li.BbsPostId);
    };

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == "N") return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getSearch();
    }

    function sortClass(sortkey) {
      if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

      var rtnval = "";

      if (vm.srch.sortDirect == "ASC") {
        rtnval = "fa fa-caret-down";
      } else {
        rtnval = "fa fa-caret-up";
      }
      return rtnval;
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author
     */
    function getList() {
      vm.dataloader = true;
      vm.viewSize = vm.srch.viewSize;

      getListCnt();

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.selectType = "List"; // For CustomColumn
      data.mapCode = "WjmHome.getBbsPostList";
      console.log(data);
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
              console.log(vm.lists);
            } else {
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(
            vm.totalItems,
            vm.columnMap,
            vm.srch
          );
          vm.dataloader = false;
        },
        function (error) {
          console.error("Error> notice-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.mapCode = "BbsPost.getBbsPostListCnt";
      postApi.select(data, function (result) {
          /* console.log("type C", result.header);
        console.log("type c", result.body); */
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        },
        function (error) {
          console.error("Error> notice-list-ctrl> getListCnt()", status, error);
        }
      );
    }

    function setResponsive(dockMode) {
      var rows = vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if (item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.community.notice-list",
        { srch: srch },
        { reload: "app.community.notice-list" }
      );
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.community.notice-list",
        { srch: srch },
        { reload: "app.community.notice-list" }
      );
    }

    function resetSearch() {
      $state.go(
        "app.community.notice-list",
        { srch: "" },
        { reload: "app.community.notice-list" }
      );
    }

    function goDetail(BbsPostId) {
      var srch = $stateParams.srch;
      vm.keyId = BbsPostId;
      $scope.selectedRow = BbsPostId;
      if (vm.layout == "N") {
        $state.go("app.community.notice-detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.community.notice-list.detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      vm.keyId = "";
      if (vm.layout == "N") {
        $state.go("app.community.notice-edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.community.notice-list.edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }
    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem("layoutBoard", layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go(
        "app.community.notice-list",
        {
          srch: srch,
        },
        { reload: "app.community.notice-list" }
      );
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.setSortColumn = setSortColumn;
    vm.sortClass = sortClass;

    // 데이터 조회
    getList();
  },
]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:winners-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('WinnersDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function WinnersDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'community.winners', // For CustomColumn and FileAttachment
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.srch.BbsMasterId = $stateParams.BbsMasterId;

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        TableNm : vm.srchDetail.TableNm,
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      // 업로드 파일 목록
      vm.uploadFileList = [];

      (function WinnersDetailCtrl() {
        console.log('WinnersDetailCtrl:');
      })();

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        console.log("srchDetail", vm.srchDetail);
        postApi.select('WjmHome.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              console.log(vm.data);

              console.log($filter('utcToLocal')(vm.data.RegDate,'yyyy-MM-dd h:mm a'));

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> winners-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'WjmHome.deleteBbsPost';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.community.winners-list', {
                  srch:srch,
                  BbsMasterId : vm.srch.BbsMasterId
                }, {reload:'app.community.winners-list'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> winners-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.community.winners-list', {
          srch : srch,
          BbsMasterId : vm.srch.BbsMasterId
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.community.winners-edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        } else {
          $state.go('app.community.winners-list.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      // 함수 선언
      vm.getData = getData;
      vm.deleteData = deleteData;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;

      // 데이터 조회
      getData();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.community:winners-edit-ctrl
 * @description
 * 커뮤니티 위너스소식
 */
webapp.controller("WinnersEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', 'CommunityAPISrv',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function WinnersEditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, postApi, customFieldApi, $rootScope, $timeout, CommunityAPISrv) {
    // View Model
    var LIST_PAGE_URL = 'app.community.winners-list';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.community.winners-list.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.community.winners-detail';           // 상세 화면

    var vm = this;
    vm.vault = null;

    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'community.winners', // For CustomColumn and FileAttachment
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    vm.srch.BbsMasterId = $stateParams.BbsMasterId;

    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
    vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId,
    };

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = CommunityAPISrv.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment

      postApi.select("WjmHome.getBbsPostDetail", vm.srchDetail, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

              if ( ! isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.data.PublicYN = "Y";
              }

            }
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {

      if(valid()){
        // 내용
        vm.dataloader = true;
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

        vm.data.BbsMasterId = vm.srch.BbsMasterId;
        vm.data.Contents = $("#strHtml").val();
        vm.data.tableNm = vm.srch.tableNm;
        vm.data.RelateDataId = vm.data.BbsPostId;
        vm.data.IdName = "BbsPostId";
        vm.data.uploadFileList = vm.uploadFileList;
        vm.data.userkey = vm.srch.userkey;

        var data = vm.data;
        if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
          // 등록
          data.mapCode = "WjmHome.insertBbsPost";
          postApi.insert(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        } else {
          // 수정
          data.mapCode = "WjmHome.updateBbsPost";
          postApi.update(
            data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              dataloader = false;
              console.table(error);
            }
          );
        }
    }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch, BbsMasterId : vm.srch.BbsMasterId });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch; // 검색 옵션

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch, BbsMasterId : vm.srch.BbsMasterId}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsMasterId: vm.srch.BbsMasterId,
            BbsPostId: vm.data.BbsPostId,
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsMasterId : vm.data.BbsMasterId, BbsPostId: vm.data.BbsPostId});
      }
    }

    function valid(){
      if(isNullOrEmpty(vm.data.Title)){
        gAlert("","제목을 입력해주세요.");
        return false;
      }else {
        return true;
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getData();
  }
]);

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.community:winners-list-ctrl
 * @description
 * 커뮤니티 위너스소식
 */
 webapp.controller("WinnersListCtrl", [
  "$window",
  "$scope",
  "$location",
  "$state",
  "$stateParams",
  "$rootScope",
  "GLOBAL_CONSTANT",
  "postApi",
  "$compile",
  "modalFactory",
  "$translate",
  "$filter",
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   */
  function WinnersListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    postApi,
    $compile,
    modalFactory,
    $translate,
    $filter
  ) {
    var vm = this;
    vm.dataloader = false;

    if (!$stateParams.srch) {
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        tableNm: "community.winners", // For CustomColumn and FileAttachment
        sortDirect: "",
        sortColumn: "",
        srchTenantId: $rootScope.gVariable.srchTenantId
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = "community.winners"; // For CustomColumn and FileAttachment
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.BbsPostId;
    $scope.selectedRow = $stateParams.BbsPostId;
    vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    vm.listSize = [10, 25, 50, 100];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    $scope.showDetail = function (li) {
      $location.url("/" + li.BbsPostId);
    };

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == "N") return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getSearch();
    }

    function sortClass(sortkey) {
      if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

      var rtnval = "";

      if (vm.srch.sortDirect == "ASC") {
        rtnval = "fa fa-caret-down";
      } else {
        rtnval = "fa fa-caret-up";
      }
      return rtnval;
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author
     */
    function getList() {
      vm.dataloader = true;
      vm.viewSize = vm.srch.viewSize;

      getListCnt();

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.selectType = "List"; // For CustomColumn
      data.mapCode = "WjmHome.getBbsPostList";
      console.log(data);
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
              console.log(vm.lists);
            } else {
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(
            vm.totalItems,
            vm.columnMap,
            vm.srch
          );
          vm.dataloader = false;
        },
        function (error) {
          console.error("Error> winners-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.mapCode = "BbsPost.getBbsPostListCnt";
      postApi.select(data, function (result) {
          /* console.log("type C", result.header);
        console.log("type c", result.body); */
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        },
        function (error) {
          console.error("Error> winners-list-ctrl> getListCnt()", status, error);
        }
      );
    }

    function setResponsive(dockMode) {
      var rows = vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if (item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.community.winners-list",
        { srch: srch },
        { reload: "app.community.winners-list" }
      );
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.community.winners-list",
        { srch: srch },
        { reload: "app.community.winners-list" }
      );
    }

    function resetSearch() {
      $state.go(
        "app.community.winners-list",
        { srch: "" },
        { reload: "app.community.winners-list" }
      );
    }

    function goDetail(BbsPostId) {
      var srch = $stateParams.srch;
      vm.keyId = BbsPostId;
      $scope.selectedRow = BbsPostId;
      if (vm.layout == "N") {
        $state.go("app.community.winners-detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.community.winners-list.detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      vm.keyId = "";
      if (vm.layout == "N") {
        $state.go("app.community.winners-edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.community.winners-list.edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }
    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem("layoutBoard", layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go(
        "app.community.winners-list",
        {
          srch: srch,
        },
        { reload: "app.community.winners-list" }
      );
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.setSortColumn = setSortColumn;
    vm.sortClass = sortClass;

    // 데이터 조회
    getList();
  },
]);

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-add-batch-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   * @description Controller of the 고객정보
   */
  webapp.controller('CustomerAddBatchCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CustomerAddBatchCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      console.log('CustomerAddBatchCtrl');
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Customer.insertCustomer';   // 등록 SQL
      var UPDATE_SQL = 'Customer.updateCustomer';   // 수정 SQL
      var VIEW_SQL = 'Customer.getCustomerDetail';  // 조회 SQL
      var VIEW_PRODUCT_SQL = 'Product.getProductListByTenant';  // 품목 목록 조회 SQL
      var VIEW_CVSMNGPRSCRPTN_SQL = 'Customer.getCvsMngPrscrptnList';  // 관리처방 선택 목록 조회 SQL
      var CODE_SQL = 'User.getRecomendrCd'; // 추천인코드 존재여부

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.customer.customer-list.detail.tab1';  // 목록 조회 화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';  // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면
      var MY_CODE_SQL = 'User.getMyRecomendrCd'; // 추천인 코드 중복 확인
      var CODE_UPDATE_SQL = 'Customer.updateMyRecomendrCd'; //추천인 코드 저장

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vaultCust = null;    // 고객관리 첨부파일 컴포넌트
      vm.vaultCounsel = null; // 상담이력 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileListCust = [];     // 고객관리 첨부파일 목록
      vm.uploadFileListCounsel = [];  // 상담이력 첨부파일 목록

      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.productList = []; // 품목 목록

      vm.cvsMngPrscrptn = []; // 관리처방 목록

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 공통코드 정의

      // 고객등급
      vm.CustGradeData = {
        CallbackTarget: 'CustGrade',
        CodeType: 'CustGrade',
        Code: vm.data.CustGrade,
        ReloadSeq: 1
      };

      // 공통코드 선택시 처리
      vm.onSelectCallback = function (data) {
        if (data.CallbackTarget == 'CustGrade') {
          vm.data.CustGrade = data.Code;
        }
      };
      // #endregion 공통코드 정의


      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;

              if (id == 'vaultCust') {
                vm.uploadFileListCust.push(obj);
              } else {
                obj.grpId = 2;
                vm.uploadFileListCounsel.push(obj);
              }
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vaultCust') {
            $timeout(uploadFileCounsel, 1);
          } else if (id == 'vaultCounsel') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      // #endregion 첨부파일 Callback


      // #region 우편번호 검색 팝업 호출

      /**
       * 우편번호 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchZipCodeModal = function () {
        new daum.Postcode({
          oncomplete: function (data) {
            vm.data.ZipCode = data.zonecode;
            vm.data.Addr1 = data.buildingName != "" ? data.address + " " + data.buildingName : data.address;
            $('#ZipCode').val(vm.data.ZipCode);
            $('#Addr1').val(vm.data.Addr1);
            $('#Addr2').focus();
          }
        }).open();
      };
      // #endregion 우편번호 검색 팝업 호출

      // #region 담당자 검색 팝업 호출

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      // #endregion 담당자 검색 팝업 호출

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vaultCust', vm.onFileCallback, false, 'jpg, gif, png, bmp, dib, tif, tiff');
        initVaultComponent('vaultCounsel', vm.onFileCallback);

        // 초기 데이터 설정
        setInitData();

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }

        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;


        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              vm.RecomendrCd = vm.data.RecomendrCd;
              // 날짜 데이터 설정
              if (!isNullOrEmpty(vm.data.AgreeDt))
                vm.AgreeDt = moment(vm.data.AgreeDt).toDate();

              if (!isNullOrEmpty(vm.data.BirthDay))
                vm.BirthDay = moment(vm.data.BirthDay).toDate();

              if (!isNullOrEmpty(vm.data.CustRegDt))
                vm.CustRegDt = moment(vm.data.CustRegDt).toDate();

              // Sign 표시
              $timeout(setSignDataAll, 1000);

              // 공통코드 데이터 설정
              vm.CustGradeData.Code = vm.data.CustGrade;


              // 관리처방 목록 조회
              var data = vm.srchDetail;
              data.mapCode = VIEW_CVSMNGPRSCRPTN_SQL;

              postApi.select(data, function (result) {
                  if (result.header.status == CONSTANT.HttpStatus.OK) {

                    if (result.body.docs.length > 0) {
                      angular.forEach(result.body.docs, function (item) {
                        var obj = {
                          'ProductId': item.ProductId,
                          'ProductNm': item.ProductNm,
                          'ProductAmt': item.ProductAmt,
                          'MngCnt': item.MngCnt
                        };

                        // 선택 품목
                        vm.cvsMngPrscrptn.push(obj);
                      });
                    }
                  }
                }
              );


              // 첨부파일 목록 설정
              var uploadFileListCust = [];
              var uploadFileListCounsel = [];


              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId: item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt
                };

                if (item.GrpId == 1) {
                  vm.uploadFileListCust.push(obj);
                } else {
                  vm.uploadFileListCounsel.push(obj);
                }
              });

              //angular.copy(uploadFileList, vm.uploadFileList);
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");


          }


          // 픔목 목록 조회
          var param = {};
          param.mapCode = VIEW_PRODUCT_SQL;

          postApi.select(param, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              // 데이터 조회 성공
              vm.dataloader = false; // Progressbar 숨김

              if (result.body.docs.length > 0) {
                // 조회 데이터 설정
                angular.forEach(result.body.docs, function (item) {
                  var obj = {
                    ProductId: item.GoodsNo,
                    ProductNm: item.GoodsNm,
                    ProductAmt: item.GoodsPrice
                  };

                  vm.productList.push(obj);
                });

              }
            } else {
              vm.dataloader = false; // Progressbar 숨김

              console.error("Error> getData()");


            }
          }, function (error) {
            console.error("Error> getData()");
            console.table(error);
          });


        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      /**
       * Sign Data 표시
       *
       * @param
       * @return
       */
      function setSignDataAll() {

          $window.fnSetSignData('A', vm.data.SignImage);

          $window.fnSetSignData('F', vm.data.FaceImage);
      }
      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {

        // 날짜 컬럼 초기값
        vm.AgreeDt = new moment().toDate();
        vm.BirthDay = $rootScope.getDateFormat('');
        vm.CustRegDt = new moment().toDate();
        vm.CounselDt = new moment().toDate();

        // 신규 등록
        if (isNullOrEmpty(vm.data.keyId)) {
          // 성별 : 여
          if (isNullOrEmpty(vm.data.Gender))
            vm.data.Gender = 'F';

          // SMS수신동의 : SMS수신동의
          if (isNullOrEmpty(vm.data.SmsYN))
            vm.data.SmsYN = 'Y';

          // 음력양력구분 : 양력
          if (isNullOrEmpty(vm.data.LnrSlrType))
            vm.data.LnrSlrType = 'S';

          // 담당자 - 로그인 사용자
          if (isNullOrEmpty(vm.data.Manager)) {
            vm.data.Manager = $rootScope.gVariable.UserId;
            vm.data.ManagerNm = $rootScope.gVariable.UserName;
          }

          // 과거관리 및 시술이력 - 부작용 여부
          if (isNullOrEmpty(vm.data.TrtmtHist01SdEftYN))
            vm.data.TrtmtHist01SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist02SdEftYN))
            vm.data.TrtmtHist02SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist03SdEftYN))
            vm.data.TrtmtHist03SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist04SdEftYN))
            vm.data.TrtmtHist04SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist05SdEftYN))
            vm.data.TrtmtHist05SdEftYN = 'N';


          // 홈 케어 정보 - 제품명, 사용방법
          if (isNullOrEmpty(vm.data.HomeCare01YN))
            vm.data.HomeCare01YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare02YN))
            vm.data.HomeCare02YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare03YN))
            vm.data.HomeCare03YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare04YN))
            vm.data.HomeCare04YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare05YN))
            vm.data.HomeCare05YN = 'N';


        }

      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      vm.uploadFile = function () {
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      };

      /**
       * 고객관리 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFileCust() {

        // #region 입력값 설정

        // 날짜 데이터 설정
        if (isValidDate(vm.AgreeDt))
          vm.data.AgreeDt = moment(vm.AgreeDt).format('YYYY-MM-DD');

        if (isValidDate(vm.BirthDay))
          vm.data.BirthDay = moment(vm.BirthDay).format('YYYY-MM-DD');

        if (isValidDate(vm.CustRegDt))
          vm.data.CustRegDt = moment(vm.CustRegDt).format('YYYY-MM-DD');

        if (isValidDate(vm.CounselDt))
          vm.data.CounselDt = moment(vm.CounselDt).format('YYYY-MM-DD');

        vm.data.SignImage = $window.fnGetSignData('A'); // 서명
        vm.data.FaceImage = $window.fnGetSignData('F'); // 섹터별특징 - 얼굴

        // #endregion 입력값 설정

        // #region 필수항목 & Validation Check 체크
        if (!getIsValidData()) {
          return;
        }
        // #endregion 필수항목 & Validation Check 체크

        if (vm.vaultCust != null && vm.vaultCust.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vaultCust);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 상담 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFileCounsel() {
        if (vm.vaultCounsel != null && vm.vaultCounsel.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vaultCounsel);
        } else {
          // 데이터 저장
          setData();
        }
      }


      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }


      /**
       * 인쇄
       *
       * @param
       * @return
       */
      function setPrint() {
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: $stateParams.srch, keyId: vm.data.KeyId});
      }

      /**
       * PDF 저장
       *
       * @param
       * @return
       */
      function setSaveToPdf() {
        gAlert('', 'MSG.TODO_FEATURE');
      }

      /**
       * 필수 입력 & Validation Check
       *
       * @param
       * @return
       */
      function getIsValidData() {

        // #region 필수항목 체크
        var errMsg = '';

        if (!vm.AgreeDt)
          errMsg = errMsg + '- 동의일을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.CustNm))
          errMsg = errMsg + '- 고객명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.SignImage))
          errMsg = errMsg + '- 서명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.Mobile))
          errMsg = errMsg + '- 연락처를 입력하세요.<br/>';

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        // #endregion 필수항목 체크

        //#region Validation Check

        if (!isNullOrEmpty(vm.data.Email))
          if (!isValidEmail(vm.data.Email)) {
            gAlert('', 'Email 주소를 확인하세요.');
            return false;
          }

        return true;
        //#endregion Validation Check
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {

        // #region 입력값 설정

        /*   // 날짜 데이터 설정
           if (isValidDate(vm.AgreeDt))
             vm.data.AgreeDt = moment(vm.AgreeDt).format('YYYY-MM-DD');

           if (isValidDate(vm.BirthDay))
             vm.data.BirthDay = moment(vm.BirthDay).format('YYYY-MM-DD');

           if (isValidDate(vm.CustRegDt))
             vm.data.CustRegDt = moment(vm.CustRegDt).format('YYYY-MM-DD');

           if (isValidDate(vm.CounselDt))
             vm.data.CounselDt = moment(vm.CounselDt).format('YYYY-MM-DD');

           vm.data.SignImage = $window.fnGetSignData('A'); // 서명
           vm.data.FaceImage = $window.fnGetSignData('F'); // 섹터별특징 - 얼굴*/

        // #endregion 입력값 설정

        // #region 필수항목 & Validation Check 체크
        /*  if (!getIsValidData())
            return false;*/
        //#endregion 필수항목 & Validation Check 체크


        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];                // 첨부파일
        angular.forEach(vm.uploadFileListCust, function (item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileListCounsel, function (item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        vm.data.cvsMngPrscrptn = vm.cvsMngPrscrptn;  // 관리처방

        var data = vm.data; // 사용자 입력 데이터
        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', error.body.docs[0].errMessage);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', result.responseVO.body.docs[0].errMessage);
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        console.table(vm.data);
        gAlert("", result.body.docs[0].errMessage);
      }

      /**
       * 관리처방 추가
       *
       * @param {object} li - Product Item
       * @return
       */
      function setAddProduct(li) {
        var obj = {
          'ProductId': li.ProductId,
          'ProductNm': li.ProductNm,
          'ProductAmt': li.ProductAmt,
          'MngCnt': 1
        };


        // 중복 존재시 관리횟수 증가
        var chkPrd = $filter('filter')(vm.cvsMngPrscrptn, {ProductId: li.ProductId})[0];

        if (isNullOrEmpty(chkPrd)) {
          // 신규 등록
          vm.cvsMngPrscrptn.push(obj);
        } else {
          // 관리 횟수 증가
          chkPrd.MngCnt = chkPrd.MngCnt + 1;
        }


      }

      /**
       * 관리처방 삭제
       *
       * @param {object} li - Product Item
       * @return
       */
      function setDelProduct(li) {

        for (var i in vm.cvsMngPrscrptn) {
          if (vm.cvsMngPrscrptn[i].ProductId === li.ProductId) {
            vm.cvsMngPrscrptn.splice(i, 1);
          }
        }

      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      /**
       * Tab 변경 후 화면 이동
       *
       * @param
       * @return
       */
      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload: VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * Tab 변경
       *
       * @param
       * @return
       */
      function setChangeTab(tabId) {
        vm.tabId = tabId;

        goNextPage(false);
      }

            /**
       * 추천인 코드 생성
       *
       * @param
       * @return
       */
      function setCode() {
        var s = '';
        var start = true;
        var intSum = '';
        var stringSum = '';
        var randomchar = function() {
        var n = Math.floor(Math.random() * 35);

        if(s.length == 0) {

          n = Math.floor(Math.random() * 26);
          stringSum += String.fromCharCode(n + 55);

          return String.fromCharCode(n + 65)
        }

          if (n < 10 && intSum.length < 3) {

            intSum += n;
            return n;
          }
            //1-10
          if (n < 36 &&  stringSum.length < 3) {

            stringSum += String.fromCharCode(n + 55);
            return String.fromCharCode(n + 55); //A-Z
          }
          if( n < 10 && n > 36) {
            retrun ;
          }

        };
        var t ='';
        while (s.length < 6) {

          t = randomchar();
          if(t != undefined) {
            s += t;
          }
        }
        getIsDupMyCd(s);

      }

      /**
       * 추천인 코드 중복확인
       *
       * @param
       * @return
       */
      function getIsDupMyCd(newCode) {

        var data = vm.srchDetail;
        data.mapCode = MY_CODE_SQL;
        data.MyRecomendrCd = newCode;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공

            if (result.body.docs.length > 0) {
              getIsDupMyCd();
            } else {
              vm.data.MyRecomendrCd = newCode;
              setMyRecomendrCd();
            }
          } else {
            console.error("Error> getMyRecomendrCd()");

          }
        }, function (error) {
          console.error("Error> getMyRecomendrCd()");
          console.table(error);
        });
      }


      /**
       * 추천인 코드 저장
       *
       * @param
       * @return
       */
      function setMyRecomendrCd (){

        var data = vm.srchDetail;
        data.mapCode = CODE_UPDATE_SQL;

        postApi.update(data, function (result) {

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            if (result.body.docs.length > 0) {
              gAlert('추천인 코드가 저장되었습니다.');
            } else {
              gAlert('추천인 코드 저장 실패');
            }
          } else {
            console.error("Error> getMyRecomendrCd()");

          }
        }, function (error) {
          console.error("Error> getMyRecomendrCd()");
          console.table(error);
        });

      }
      /* 추천인코드 존재여부 */
      function checkedRecomendrCd() {
        var data = angular.copy(vm.srchDetail);

        data.mapCode = CODE_SQL;
        data.RecomendrCd = vm.RecomendrCd;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            if (result.body.docs.length > 0) {
              vm.data.RecomendrCd = vm.RecomendrCd;
              vm.tmpRecomendrCd = vm.RecomendrCd;
            } else {
              gAlert('','- 추천인코드를 확인해주세요.')
            }
          } else {
            console.error("Error> getMyRecomendrCd()");
          }
        }, function (error) {
          console.error("Error> getMyRecomendrCd()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setPrint = setPrint;                   // 인쇄
      vm.setSaveToPdf = setSaveToPdf;           // PDF
      vm.setData = setData;                     // 데이터 저장
      vm.uploadFileCust = uploadFileCust;       // 고객관리사진
      vm.uploadFileCounsel = uploadFileCounsel; // 상담사진

      vm.setAddProduct = setAddProduct;         // 관리처방 추가
      vm.setDelProduct = setDelProduct;         // 관리처방 삭제
      vm.setChangeTab = setChangeTab;
      vm.goList = goList;                       // 목록 화면 이동
      vm.setChangeTab = setChangeTab;           // Tab 변경
      vm.setCode = setCode;
      vm.checkedRecomendrCd = checkedRecomendrCd;

      // 데이터 조회
      getData();

      // Sign Pad 초기화
      $timeout($window.fnSetInitSignPad, 1000);

    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-detail-tab1-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   * @description Controller of the 고객정보
   */
  webapp.controller('CustomerDetailTab1Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CustomerDetailTab1Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Customer.insertCustomer';   // 등록 SQL
      var UPDATE_SQL = 'Customer.updateCustomer';   // 수정 SQL
      var VIEW_SQL = 'Customer.getCustomerDetail';  // 조회 SQL
      var VIEW_PRODUCT_SQL = 'Product.getProductListByTenant';  // 품목 목록 조회 SQL
      var VIEW_CVSMNGPRSCRPTN_SQL = 'Customer.getCvsMngPrscrptnList';  // 관리처방 선택 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.customer.customer-list.detail';  // 목록 조회 화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';  // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vaultCust = null;    // 고객관리 첨부파일 컴포넌트
      vm.vaultCounsel = null; // 상담이력 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileListCust = [];     // 고객관리 첨부파일 목록
      vm.uploadFileListCounsel = [];  // 상담이력 첨부파일 목록

      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.productList = []; // 품목 목록

      vm.cvsMngPrscrptn = []; // 관리처방 목록

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 공통코드 정의

      // 고객등급
      vm.CustGradeData = {
        CallbackTarget: 'CustGrade',
        CodeType: 'CustGrade',
        Code: vm.data.CustGrade,
        ReloadSeq: 1
      };

      // 공통코드 선택시 처리
      vm.onSelectCallback = function (data) {
        if (data.CallbackTarget == 'CustGrade') {
          vm.data.CustGrade = data.Code;
        }
      };
      // #endregion 공통코드 정의

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;

              if (id == 'vaultCust') {
                vm.uploadFileListCust.push(obj);
              } else {
                obj.grpId = 2;
                vm.uploadFileListCounsel.push(obj);
              }
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vaultCust') {
            $timeout(uploadFileCounsel, 1);
          } else if (id == 'vaultCounsel') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      // #endregion 첨부파일 Callback


      // #region 우편번호 검색 팝업 호출

      /**
       * 우편번호 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchZipCodeModal = function () {
        new daum.Postcode({
          oncomplete: function (data) {
            vm.data.ZipCode = data.zonecode;
            vm.data.Addr1 = data.buildingName != "" ? data.address + " " + data.buildingName : data.address;
            $('#ZipCode').val(vm.data.ZipCode);
            $('#Addr1').val(vm.data.Addr1);
            $('#Addr2').focus();
          }
        }).open();
      };
      // #endregion 우편번호 검색 팝업 호출

      // #region 담당자 검색 팝업 호출

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      // #endregion 담당자 검색 팝업 호출

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vaultCust', vm.onFileCallback);
        initVaultComponent('vaultCounsel', vm.onFileCallback);

        // 초기 데이터 설정
        setInitData();

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }

        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;


        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              // 날짜 데이터 설정
              if (!isNullOrEmpty(vm.data.AgreeDt))
                vm.AgreeDt = moment(vm.data.AgreeDt).toDate();

              if (!isNullOrEmpty(vm.data.BirthDay))
                vm.BirthDay = moment(vm.data.BirthDay).toDate();

              if (!isNullOrEmpty(vm.data.CustRegDt))
                vm.CustRegDt = moment(vm.data.CustRegDt).toDate();

              // Sign 표시
              $timeout(setSignDataAll, 1000);

              // 공통코드 데이터 설정
              vm.CustGradeData.Code = vm.data.CustGrade;


              // 관리처방 목록 조회
              var data = vm.srchDetail;
              data.mapCode = VIEW_CVSMNGPRSCRPTN_SQL;

              postApi.select(data, function (result) {
                  if (result.header.status == CONSTANT.HttpStatus.OK) {

                    if (result.body.docs.length > 0) {
                      angular.forEach(result.body.docs, function (item) {
                        var obj = {
                          'ProductId': item.ProductId,
                          'ProductNm': item.ProductNm,
                          'ProductAmt': item.ProductAmt,
                          'MngCnt': item.MngCnt
                        };

                        // 선택 품목
                        vm.cvsMngPrscrptn.push(obj);
                      });
                    }
                  }
                }
              );


              // 첨부파일 목록 설정
              var uploadFileListCust = [];
              var uploadFileListCounsel = [];


              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId: item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt
                };

                if (item.GrpId == 1) {
                  vm.uploadFileListCust.push(obj);
                } else {
                  vm.uploadFileListCounsel.push(obj);
                }
              });

              //angular.copy(uploadFileList, vm.uploadFileList);

              // 인쇄


            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");


          }


          // 픔목 목록 조회
          var param = {};
          param.mapCode = VIEW_PRODUCT_SQL;

          postApi.select(param, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              // 데이터 조회 성공
              vm.dataloader = false; // Progressbar 숨김

              if (result.body.docs.length > 0) {
                // 조회 데이터 설정
                angular.forEach(result.body.docs, function (item) {
                  var obj = {
                    ProductId: item.ProductId,
                    ProductNm: item.ProductNm,
                    ProductAmt: item.ProductAmt
                  };

                  vm.productList.push(obj);
                });

              }
            } else {
              vm.dataloader = false; // Progressbar 숨김

              console.error("Error> getData()");


            }
          }, function (error) {
            console.error("Error> getData()");
            console.table(error);
          });


        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      /**
       * Sign Data 표시
       *
       * @param
       * @return
       */
      function setSignDataAll() {

        //$window.fnSetSignData('A', vm.data.SignImage);

        $window.fnSetSignData('F', vm.data.FaceImage);
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {

        // 날짜 컬럼 초기값
        vm.AgreeDt = new moment().toDate();
        vm.BirthDay = $rootScope.getDateFormat('');
        vm.CustRegDt = new moment().toDate();
        vm.CounselDt = new moment().toDate();

        // 신규 등록
        if (isNullOrEmpty(vm.data.keyId)) {
          // 성별 : 여
          if (isNullOrEmpty(vm.data.Gender))
            vm.data.Gender = 'F';

          // SMS수신동의 : SMS수신동의
          if (isNullOrEmpty(vm.data.SmsYN))
            vm.data.SmsYN = 'Y';

          // 음력양력구분 : 양력
          if (isNullOrEmpty(vm.data.LnrSlrType))
            vm.data.LnrSlrType = 'S';

          // 담당자 - 로그인 사용자
          if (isNullOrEmpty(vm.data.Manager)) {
            vm.data.Manager = $rootScope.gVariable.UserId;
            vm.data.ManagerNm = $rootScope.gVariable.UserName;
          }

          // 과거관리 및 시술이력 - 부작용 여부
          if (isNullOrEmpty(vm.data.TrtmtHist01SdEftYN))
            vm.data.TrtmtHist01SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist02SdEftYN))
            vm.data.TrtmtHist02SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist03SdEftYN))
            vm.data.TrtmtHist03SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist04SdEftYN))
            vm.data.TrtmtHist04SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist05SdEftYN))
            vm.data.TrtmtHist05SdEftYN = 'N';


          // 홈 케어 정보 - 제품명, 사용방법
          if (isNullOrEmpty(vm.data.HomeCare01YN))
            vm.data.HomeCare01YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare02YN))
            vm.data.HomeCare02YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare03YN))
            vm.data.HomeCare03YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare04YN))
            vm.data.HomeCare04YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare05YN))
            vm.data.HomeCare05YN = 'N';


        }

      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      vm.uploadFile = function () {
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      };

      /**
       * 고객관리 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFileCust() {

        // #region 입력값 설정

        // 날짜 데이터 설정
        if (isValidDate(vm.AgreeDt))
          vm.data.AgreeDt = moment(vm.AgreeDt).format('YYYY-MM-DD');

        if (isValidDate(vm.BirthDay))
          vm.data.BirthDay = moment(vm.BirthDay).format('YYYY-MM-DD');

        if (isValidDate(vm.CustRegDt))
          vm.data.CustRegDt = moment(vm.CustRegDt).format('YYYY-MM-DD');

        if (isValidDate(vm.CounselDt))
          vm.data.CounselDt = moment(vm.CounselDt).format('YYYY-MM-DD');

        vm.data.SignImage = $window.fnGetSignData('A'); // 서명
        vm.data.FaceImage = $window.fnGetSignData('F'); // 섹터별특징 - 얼굴

        // #endregion 입력값 설정

        // #region 필수항목 & Validation Check 체크
        if (!getIsValidData()) {
          return;
        }
        // #endregion 필수항목 & Validation Check 체크

        if (vm.vaultCust != null && vm.vaultCust.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vaultCust);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 상담 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFileCounsel() {
        if (vm.vaultCounsel != null && vm.vaultCounsel.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vaultCounsel);
        } else {
          // 데이터 저장
          setData();
        }
      }


      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }


      /**
       * 인쇄
       *
       * @param
       * @return
       */
      function setPrint() {


      }

      /**
       * PDF 저장
       *
       * @param
       * @return
       */
      function setSaveToPdf() {
        gAlert('', 'MSG.TODO_FEATURE');
      }


      /**
       * 필수 입력 & Validation Check
       *
       * @param
       * @return
       */
      function getIsValidData() {

        // #region 필수항목 체크
        var errMsg = '';

        if (!vm.AgreeDt)
          errMsg = errMsg + '- 동의일을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.CustNm))
          errMsg = errMsg + '- 고객명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.SignImage))
          errMsg = errMsg + '- 서명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.Mobile))
          errMsg = errMsg + '- 연락처를 입력하세요.<br/>';

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        // #endregion 필수항목 체크

        //#region Validation Check

        if (!isNullOrEmpty(vm.data.Email))
          if (!isValidEmail(vm.data.Email)) {
            gAlert('', 'Email 주소를 확인하세요.');
            return false;
          }

        return true;
        //#endregion Validation Check
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {

        // #region 입력값 설정

        /*   // 날짜 데이터 설정
           if (isValidDate(vm.AgreeDt))
             vm.data.AgreeDt = moment(vm.AgreeDt).format('YYYY-MM-DD');

           if (isValidDate(vm.BirthDay))
             vm.data.BirthDay = moment(vm.BirthDay).format('YYYY-MM-DD');

           if (isValidDate(vm.CustRegDt))
             vm.data.CustRegDt = moment(vm.CustRegDt).format('YYYY-MM-DD');

           if (isValidDate(vm.CounselDt))
             vm.data.CounselDt = moment(vm.CounselDt).format('YYYY-MM-DD');

           vm.data.SignImage = $window.fnGetSignData('A'); // 서명
           vm.data.FaceImage = $window.fnGetSignData('F'); // 섹터별특징 - 얼굴*/

        // #endregion 입력값 설정

        // #region 필수항목 & Validation Check 체크
        /*  if (!getIsValidData())
            return false;*/
        //#endregion 필수항목 & Validation Check 체크


        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];                // 첨부파일
        angular.forEach(vm.uploadFileListCust, function (item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileListCounsel, function (item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        vm.data.cvsMngPrscrptn = vm.cvsMngPrscrptn;  // 관리처방

        var data = vm.data; // 사용자 입력 데이터
        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', error.body.docs[0].errMessage);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', result.responseVO.body.docs[0].errMessage);
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        console.table(vm.data);
        gAlert("", result.body.docs[0].errMessage);
      }

      /**
       * 관리처방 추가
       *
       * @param {object} li - Product Item
       * @return
       */
      function setAddProduct(li) {
        var obj = {
          'ProductId': li.ProductId,
          'ProductNm': li.ProductNm,
          'ProductAmt': li.ProductAmt,
          'MngCnt': 1
        };


        // 중복 존재시 관리횟수 증가
        var chkPrd = $filter('filter')(vm.cvsMngPrscrptn, {ProductId: li.ProductId})[0];

        if (isNullOrEmpty(chkPrd)) {
          // 신규 등록
          vm.cvsMngPrscrptn.push(obj);
        } else {
          // 관리 횟수 증가
          chkPrd.MngCnt = chkPrd.MngCnt + 1;
        }


      }

      /**
       * 관리처방 삭제
       *
       * @param {object} li - Product Item
       * @return
       */
      function setDelProduct(li) {

        for (var i in vm.cvsMngPrscrptn) {
          if (vm.cvsMngPrscrptn[i].ProductId === li.ProductId) {
            vm.cvsMngPrscrptn.splice(i, 1);
          }
        }

      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      /**
       * Edit 화면 이동
       *
       * @param
       * @return
       */
      $scope.goEdit = function () {
        goNextPage(false);
      };

      /**
       * Tab 변경 후 화면 이동
       *
       * @param
       * @return
       */
      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload: VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * Tab 변경
       *
       * @param
       * @return
       */
      function setChangeTab(tabId) {
        vm.tabId = tabId;

        goNextPage(false);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setPrint = setPrint;                   // 인쇄
      vm.setSaveToPdf = setSaveToPdf;           // PDF
      vm.setData = setData;                     // 데이터 저장
      vm.uploadFileCust = uploadFileCust;       // 고객관리사진
      vm.uploadFileCounsel = uploadFileCounsel; // 상담사진

      vm.setAddProduct = setAddProduct;         // 관리처방 추가
      vm.setDelProduct = setDelProduct;         // 관리처방 삭제
      vm.setChangeTab = setChangeTab;
      vm.goList = goList;                       // 목록 화면 이동
      vm.setChangeTab = setChangeTab;           // Tab 변경


      // 데이터 조회
      getData();

      // Sign Pad 초기화
      $timeout($window.fnSetInitSignPad, 1000);

      // 인쇄
      $timeout(fnSetPrint, 2000);

      // PDF 저장 -> 인쇄 팝업에서 PDF로 저장하는 방식으로 변경
      //$timeout(fnSetPdf, 2000);

    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-detail2-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $stateParams - state Parameter object
   * @description Controller of the 고객정보 등록/수정
   */
  webapp.controller('CustomerDetail2Ctrl', ['$window', '$rootScope', '$stateParams', '$state',
    function CustomerDetail2Ctrl($window, $rootScope, $stateParams, $state) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.customer.customer-list.detail2';  // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail2';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.url = $state.current.url;
      vm.keyId = $stateParams.keyId;

      /**
       * Tab변경
       *
       * @param {string} tabId - 조회할 TabId
       * @return {boolean}
       */
      function setChangeTab(tabId) {
        var viewPageUrl = '';

        if (vm.layout == 'N') {
          viewPageUrl = VIEW_PAGE_URL + '.' + tabId;
          // 수정
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId, loginId: $stateParams.loginId}, {reload:viewPageUrl});
        } else {
          viewPageUrl = LIST_VIEW_PAGE_URL + '.' + tabId;
          // 목록.수정 화면 이동
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId, loginId: $stateParams.loginId}, {reload: viewPageUrl});
        }
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }

      // 함수 정의
      vm.setChangeTab = setChangeTab;
      vm.goList = goList;
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-detail2-tab1-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   * @description Controller of the 고객정보
   */
  webapp.controller('CustomerDetail2Tab1Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CustomerDetail2Tab1Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var VIEW_SQL = 'Customer.getCustomerDetail';  // 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.customer.customer-list.detail.tab1';  // 목록 조회 화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';  // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vaultCust = null;    // 고객관리 첨부파일 컴포넌트
      vm.vaultCounsel = null; // 상담이력 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          loginId: !isNullOrEmpty($stateParams.loginId) ? $stateParams.loginId : '', // 로그인 ID
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.loginId = $stateParams.loginId;
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileListCust = [];     // 고객관리 첨부파일 목록
      vm.uploadFileListCounsel = [];  // 상담이력 첨부파일 목록

      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.productList = []; // 품목 목록

      vm.cvsMngPrscrptn = []; // 관리처방 목록

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 공통코드 정의

      // 고객등급
      vm.CustGradeData = {
        CallbackTarget: 'CustGrade',
        CodeType: 'CustGrade',
        Code: vm.data.CustGrade,
        ReloadSeq: 1
      };

      // 공통코드 선택시 처리
      vm.onSelectCallback = function (data) {
        if (data.CallbackTarget == 'CustGrade') {
          vm.data.CustGrade = data.Code;
        }
      };
      // #endregion 공통코드 정의
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vaultCust', vm.onFileCallback, false, 'jpg, gif, png, bmp, dib, tif, tiff');
        initVaultComponent('vaultCounsel', vm.onFileCallback);

        // 초기 데이터 설정
        setInitData();

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }

        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;


        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              vm.RecomendrCd = vm.data.RecomendrCd;
              // 날짜 데이터 설정
              if (!isNullOrEmpty(vm.data.AgreeDt))
                vm.AgreeDt = moment(vm.data.AgreeDt).toDate();

              if (!isNullOrEmpty(vm.data.BirthDay))
                vm.BirthDay = moment(vm.data.BirthDay).toDate();

              if (!isNullOrEmpty(vm.data.CustRegDt))
                vm.CustRegDt = moment(vm.data.CustRegDt).toDate();

              // 공통코드 데이터 설정
              vm.CustGradeData.Code = vm.data.CustGrade;

              //angular.copy(uploadFileList, vm.uploadFileList);
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김
            console.error("Error> getData()");
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {

        // 날짜 컬럼 초기값
        vm.AgreeDt = new moment().toDate();
        vm.BirthDay = $rootScope.getDateFormat('');
        vm.CustRegDt = new moment().toDate();
        vm.CounselDt = new moment().toDate();

        // 신규 등록
        if (isNullOrEmpty(vm.data.keyId)) {
          // 성별 : 여
          if (isNullOrEmpty(vm.data.Gender))
            vm.data.Gender = 'F';

          // SMS수신동의 : SMS수신동의
          if (isNullOrEmpty(vm.data.SmsYN))
            vm.data.SmsYN = 'Y';

          // 음력양력구분 : 양력
          if (isNullOrEmpty(vm.data.LnrSlrType))
            vm.data.LnrSlrType = 'S';

          // 담당자 - 로그인 사용자
          if (isNullOrEmpty(vm.data.Manager)) {
            vm.data.Manager = $rootScope.gVariable.UserId;
            vm.data.ManagerNm = $rootScope.gVariable.UserName;
          }

          // 과거관리 및 시술이력 - 부작용 여부
          if (isNullOrEmpty(vm.data.TrtmtHist01SdEftYN))
            vm.data.TrtmtHist01SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist02SdEftYN))
            vm.data.TrtmtHist02SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist03SdEftYN))
            vm.data.TrtmtHist03SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist04SdEftYN))
            vm.data.TrtmtHist04SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist05SdEftYN))
            vm.data.TrtmtHist05SdEftYN = 'N';


          // 홈 케어 정보 - 제품명, 사용방법
          if (isNullOrEmpty(vm.data.HomeCare01YN))
            vm.data.HomeCare01YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare02YN))
            vm.data.HomeCare02YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare03YN))
            vm.data.HomeCare03YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare04YN))
            vm.data.HomeCare04YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare05YN))
            vm.data.HomeCare05YN = 'N';


        }

      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수 입력 & Validation Check
       *
       * @param
       * @return
       */
      function getIsValidData() {

        // #region 필수항목 체크
        var errMsg = '';

        if (!vm.AgreeDt)
          errMsg = errMsg + '- 동의일을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.CustNm))
          errMsg = errMsg + '- 고객명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.SignImage))
          errMsg = errMsg + '- 서명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.Mobile))
          errMsg = errMsg + '- 연락처를 입력하세요.<br/>';

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        // #endregion 필수항목 체크

        //#region Validation Check

        if (!isNullOrEmpty(vm.data.Email))
          if (!isValidEmail(vm.data.Email)) {
            gAlert('', 'Email 주소를 확인하세요.');
            return false;
          }

        return true;
        //#endregion Validation Check
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        console.table(vm.data);
        gAlert("", result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      /**
       * Tab 변경 후 화면 이동
       *
       * @param
       * @return
       */
      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload: VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * Tab 변경
       *
       * @param
       * @return
       */
      function setChangeTab(tabId) {
        vm.tabId = tabId;

        goNextPage(false);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인

      vm.setChangeTab = setChangeTab;
      vm.goList = goList;                       // 목록 화면 이동
      vm.setChangeTab = setChangeTab;           // Tab 변경

      // 데이터 조회
      getData();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-detail2-tab2-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   * @description Controller of the 고객정보
   */
  webapp.controller('CustomerDetail2Tab2Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CustomerDetail2Tab2Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Cafe24.getCafe24OrdersListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Cafe24.getCafe24OrdersList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.customer.customer-list.detail.tab1';  // 목록 조회 화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';  // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cafe24.orders'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vaultCust = null;    // 고객관리 첨부파일 컴포넌트
      vm.vaultCounsel = null; // 상담이력 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          loginId: !isNullOrEmpty($stateParams.loginId) ? $stateParams.loginId : '', // 로그인 ID
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.loginId = $stateParams.loginId;
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "List"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileListCust = [];     // 고객관리 첨부파일 목록
      vm.uploadFileListCounsel = [];  // 상담이력 첨부파일 목록

      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.productList = []; // 품목 목록

      vm.cvsMngPrscrptn = []; // 관리처방 목록

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      // #region 공통코드 정의

      // 고객등급
      vm.CustGradeData = {
        CallbackTarget: 'CustGrade',
        CodeType: 'CustGrade',
        Code: vm.data.CustGrade,
        ReloadSeq: 1
      };

      // 공통코드 선택시 처리
      vm.onSelectCallback = function (data) {
        if (data.CallbackTarget == 'CustGrade') {
          vm.data.CustGrade = data.Code;
        }
      };

      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getData();
      }

      // #endregion 공통코드 정의
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }

        getCount();

        var data = vm.srchDetail;
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김
            console.error("Error> getData()");
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      function getCount() {
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = LIST_CNT_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.totalItems = result.body.docs[0];
          } else {
            vm.totalItems = 0;
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수 입력 & Validation Check
       *
       * @param
       * @return
       */
      function getIsValidData() {

        // #region 필수항목 체크
        var errMsg = '';

        if (!vm.AgreeDt)
          errMsg = errMsg + '- 동의일을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.CustNm))
          errMsg = errMsg + '- 고객명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.SignImage))
          errMsg = errMsg + '- 서명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.Mobile))
          errMsg = errMsg + '- 연락처를 입력하세요.<br/>';

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        // #endregion 필수항목 체크

        //#region Validation Check

        if (!isNullOrEmpty(vm.data.Email))
          if (!isValidEmail(vm.data.Email)) {
            gAlert('', 'Email 주소를 확인하세요.');
            return false;
          }

        return true;
        //#endregion Validation Check
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        console.table(vm.data);
        gAlert("", result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      /**
       * Tab 변경 후 화면 이동
       *
       * @param
       * @return
       */
      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload: VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * Tab 변경
       *
       * @param
       * @return
       */
      function setChangeTab(tabId) {
        vm.tabId = tabId;

        goNextPage(false);
      }

      function showDetail(order_id) {
        var ctrl = 'CustomerDetail2Tab2ModalCtrl as vc';
        var paramData = {order_id: order_id};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('lg', 'app/customer/customer-detail2-tab2-modal.html', ctrl, paramData);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인

      vm.setChangeTab = setChangeTab;
      vm.goList = goList;                       // 목록 화면 이동
      vm.setChangeTab = setChangeTab;           // Tab 변경

      vm.setChangeViewSize = setChangeViewSize;
      vm.showDetail = showDetail;

      // 데이터 조회
      getData();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-detail2-tab2-modal-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   * @description Controller of the 고객정보
   */
  webapp.controller('CustomerDetail2Tab2ModalCtrl', ['$window', '$rootScope', '$scope', '$uibModalInstance', 'toModalData', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CustomerDetail2Tab2ModalCtrl($window, $rootScope, $scope, $uibModalInstance, toModalData, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'Cafe24.getCafe24OrderItems';    // 목록 조회 SQL

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cafe24.orders'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 조회 데이터 설정
      vm.srch = {
        order_id:toModalData.order_id,
        selectType:'Detail',
        tableNm:KEY_TABLE_NM
      };
      vm.columnMap = {};
      vm.srch.srchTenantId = vm.srch.srchTenantId != null ? vm.srch.srchTenantId : $rootScope.gVariable.srchTenantId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      vm.srch.viewSize = vm.viewSize;

      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getData();
      }

      // #endregion 공통코드 정의
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }

        var data = vm.srch;
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.listItems = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김
            console.error("Error> getData()");
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수 입력 & Validation Check
       *
       * @param
       * @return
       */
      function getIsValidData() {

        // #region 필수항목 체크
        var errMsg = '';

        if (!vm.AgreeDt)
          errMsg = errMsg + '- 동의일을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.CustNm))
          errMsg = errMsg + '- 고객명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.SignImage))
          errMsg = errMsg + '- 서명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.Mobile))
          errMsg = errMsg + '- 연락처를 입력하세요.<br/>';

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        // #endregion 필수항목 체크

        //#region Validation Check

        if (!isNullOrEmpty(vm.data.Email))
          if (!isValidEmail(vm.data.Email)) {
            gAlert('', 'Email 주소를 확인하세요.');
            return false;
          }

        return true;
        //#endregion Validation Check
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        console.table(vm.data);
        gAlert("", result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * Tab 변경
       *
       * @param
       * @return
       */
      function setChangeTab(tabId) {
        vm.tabId = tabId;

        goNextPage(false);
      }

      function showDetail() {
        var ctrl = 'CustomerDetail2Tab2ModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'app/customer/customer-detail2-tab2-modal.html', ctrl, paramData);
      }

      vm.cancel = cancel;
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      vm.ok = ok;
      function ok(){
        $uibModalInstance.close(vm.selectItem);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인

      vm.setChangeViewSize = setChangeViewSize;
      vm.showDetail = showDetail;

      // 데이터 조회
      getData();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-detail2-tab2-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   * @description Controller of the 고객정보
   */
  webapp.controller('CustomerDetail2Tab3Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CustomerDetail2Tab3Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Cafe24.getCafeSubscribeCustListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Cafe24.getCafeSubscribeCustLists';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.customer.customer-list.detail.tab1';  // 목록 조회 화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';  // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cafe24.subscribe.customers.detail'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vaultCust = null;    // 고객관리 첨부파일 컴포넌트
      vm.vaultCounsel = null; // 상담이력 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          loginId: !isNullOrEmpty($stateParams.loginId) ? $stateParams.loginId : '', // 로그인 ID
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.loginId = $stateParams.loginId;
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "List"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileListCust = [];     // 고객관리 첨부파일 목록
      vm.uploadFileListCounsel = [];  // 상담이력 첨부파일 목록

      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.productList = []; // 품목 목록

      vm.cvsMngPrscrptn = []; // 관리처방 목록

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      // #region 공통코드 정의

      // 고객등급
      vm.CustGradeData = {
        CallbackTarget: 'CustGrade',
        CodeType: 'CustGrade',
        Code: vm.data.CustGrade,
        ReloadSeq: 1
      };

      // 공통코드 선택시 처리
      vm.onSelectCallback = function (data) {
        if (data.CallbackTarget == 'CustGrade') {
          vm.data.CustGrade = data.Code;
        }
      };

      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getData();
      }

      // #endregion 공통코드 정의
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }

        getCount();

        var data = vm.srchDetail;
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김
            console.error("Error> getData()");
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      function getCount() {
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = LIST_CNT_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.totalItems = result.body.docs[0];
          } else {
            vm.totalItems = 0;
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }


      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      /**
       * Tab 변경 후 화면 이동
       *
       * @param
       * @return
       */
      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload: VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * Tab 변경
       *
       * @param
       * @return
       */
      function setChangeTab(tabId) {
        vm.tabId = tabId;

        goNextPage(false);
      }

      function showDetail() {
        var ctrl = 'DataGroupActionModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/dataanalysis/data-group-action-modal.html', ctrl, paramData);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인

      vm.setChangeTab = setChangeTab;
      vm.goList = goList;                       // 목록 화면 이동
      vm.setChangeTab = setChangeTab;           // Tab 변경

      vm.setChangeViewSize = setChangeViewSize;
      vm.showDetail = showDetail;

      // 데이터 조회
      getData();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-detail2-tab2-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   * @description Controller of the 고객정보
   */
  webapp.controller('CustomerDetail2Tab4Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CustomerDetail2Tab3Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Cafe24.getCafeSubscribeCustListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Cafe24.getCafeSubscribeCustLists';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.customer.customer-list.detail.tab1';  // 목록 조회 화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';  // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cafe24.subscribe.customers.detail'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vaultCust = null;    // 고객관리 첨부파일 컴포넌트
      vm.vaultCounsel = null; // 상담이력 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          loginId: !isNullOrEmpty($stateParams.loginId) ? $stateParams.loginId : '', // 로그인 ID
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.loginId = $stateParams.loginId;
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "List"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      vm.srchDetail.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srchDetail.ActionId = $rootScope.gVariable.dataActionId;

      vm.uploadFileListCust = [];     // 고객관리 첨부파일 목록
      vm.uploadFileListCounsel = [];  // 상담이력 첨부파일 목록

      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.productList = []; // 품목 목록

      vm.cvsMngPrscrptn = []; // 관리처방 목록

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      // #region 공통코드 정의

      // 고객등급
      vm.CustGradeData = {
        CallbackTarget: 'CustGrade',
        CodeType: 'CustGrade',
        Code: vm.data.CustGrade,
        ReloadSeq: 1
      };

      // 공통코드 선택시 처리
      vm.onSelectCallback = function (data) {
        if (data.CallbackTarget == 'CustGrade') {
          vm.data.CustGrade = data.Code;
        }
      };

      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getData();
      }

      // #endregion 공통코드 정의
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }

        var data = angular.copy(vm.srchDetail);
        data.CustomerCode = vm.srchDetail.loginId;

        postApi.sendPostApi('api/dataanalysis', 'getCustomerRecommend', data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data.similarities = result.body.docs[0].similarities;
              vm.data.recommended = result.body.docs[0].recommended;

              var data = [];
              angular.forEach(vm.data.recommended, function(item) {
                var word = {text:item.ProductName, size:(item.freq < 5 ? item.freq : 5) * 10};
                data.push(word);
              });

              drawWordCloud(data, 'wordcloud');

              vm.data.RelateDataId = result.body.docs[0].RelateDataId != null ? result.body.docs[0].RelateDataId : '';
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }


      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }


      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      /**
       * Tab 변경 후 화면 이동
       *
       * @param
       * @return
       */
      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload: VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * Tab 변경
       *
       * @param
       * @return
       */
      function setChangeTab(tabId) {
        vm.tabId = tabId;

        goNextPage(false);
      }

      function showDetail() {
        var ctrl = 'DataGroupActionModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/dataanalysis/data-group-action-modal.html', ctrl, paramData);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인

      vm.setChangeTab = setChangeTab;
      vm.goList = goList;                       // 목록 화면 이동
      vm.setChangeTab = setChangeTab;           // Tab 변경

      vm.setChangeViewSize = setChangeViewSize;
      vm.showDetail = showDetail;

      // 데이터 조회
      getData();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $stateParams - state Parameter object
   * @description Controller of the 고객정보 등록/수정
   */
  webapp.controller('CustomerEditCtrl', ['$window', '$rootScope', '$stateParams', '$state',
    function CustomerEditCtrl($window, $rootScope, $stateParams, $state) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.customer.customer-list.edit';  // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.customer.customer-edit';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.url = $state.current.url;
      vm.keyId = $stateParams.keyId;

      $rootScope.gVariable.listKeyId = vm.keyId;

      /**
       * Tab변경
       *
       * @param {string} tabId - 조회할 TabId
       * @return {boolean}
       */
      function setChangeTab(tabId) {
        var viewPageUrl = '';

        if (vm.layout == 'N') {
          viewPageUrl = VIEW_PAGE_URL + '.' + tabId;
          // 수정
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
        } else {
          viewPageUrl = LIST_VIEW_PAGE_URL + '.' + tabId;
          // 목록.수정 화면 이동
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload: viewPageUrl});
        }
      }

      // 함수 정의
      vm.setChangeTab = setChangeTab;
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-edit-tab1-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   * @description Controller of the 고객정보
   */
  webapp.controller('CustomerEditTab1Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CustomerEditTab1Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Customer.insertCustomer';   // 등록 SQL
      var UPDATE_SQL = 'Customer.updateCustomer';   // 수정 SQL
      var VIEW_SQL = 'Customer.getCustomerDetail';  // 조회 SQL
      var VIEW_PRODUCT_SQL = 'Product.getProductListByTenant';  // 품목 목록 조회 SQL
      var VIEW_CVSMNGPRSCRPTN_SQL = 'Customer.getCvsMngPrscrptnList';  // 관리처방 선택 목록 조회 SQL
      var CODE_SQL = 'User.getRecomendrCd'; // 추천인코드 존재여부

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.customer.customer-list.detail.tab1';  // 목록 조회 화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';  // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면
      var MY_CODE_SQL = 'User.getMyRecomendrCd'; // 추천인 코드 중복 확인
      var CODE_UPDATE_SQL = 'Customer.updateMyRecomendrCd'; //추천인 코드 저장

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId';   // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vaultCust = null;    // 고객관리 첨부파일 컴포넌트
      vm.vaultCounsel = null; // 상담이력 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileListCust = [];     // 고객관리 첨부파일 목록
      vm.uploadFileListCounsel = [];  // 상담이력 첨부파일 목록

      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.productList = []; // 품목 목록

      vm.cvsMngPrscrptn = []; // 관리처방 목록

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 공통코드 정의

      // 고객등급
      vm.CustGradeData = {
        CallbackTarget: 'CustGrade',
        CodeType: 'CustGrade',
        Code: vm.data.CustGrade,
        ReloadSeq: 1
      };

      // 공통코드 선택시 처리
      vm.onSelectCallback = function (data) {
        if (data.CallbackTarget == 'CustGrade') {
          vm.data.CustGrade = data.Code;
        }
      };
      // #endregion 공통코드 정의


      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;

              if (id == 'vaultCust') {
                vm.uploadFileListCust.push(obj);
              } else {
                obj.grpId = 2;
                vm.uploadFileListCounsel.push(obj);
              }
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vaultCust') {
            $timeout(uploadFileCounsel, 1);
          } else if (id == 'vaultCounsel') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      // #endregion 첨부파일 Callback


      // #region 우편번호 검색 팝업 호출

      /**
       * 우편번호 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchZipCodeModal = function () {
        new daum.Postcode({
          oncomplete: function (data) {
            vm.data.ZipCode = data.zonecode;
            vm.data.Addr1 = data.buildingName != "" ? data.address + " " + data.buildingName : data.address;
            $('#ZipCode').val(vm.data.ZipCode);
            $('#Addr1').val(vm.data.Addr1);
            $('#Addr2').focus();
          }
        }).open();
      };
      // #endregion 우편번호 검색 팝업 호출

      // #region 담당자 검색 팝업 호출

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      // #endregion 담당자 검색 팝업 호출

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vaultCust', vm.onFileCallback, false, 'jpg, gif, png, bmp, dib, tif, tiff');
        initVaultComponent('vaultCounsel', vm.onFileCallback);

        // 초기 데이터 설정
        setInitData();

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }

        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;


        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              vm.RecomendrCd = vm.data.RecomendrCd;
              // 날짜 데이터 설정
              if (!isNullOrEmpty(vm.data.AgreeDt))
                vm.AgreeDt = moment(vm.data.AgreeDt).toDate();

              if (!isNullOrEmpty(vm.data.BirthDay))
                vm.BirthDay = moment(vm.data.BirthDay).toDate();

              if (!isNullOrEmpty(vm.data.CustRegDt))
                vm.CustRegDt = moment(vm.data.CustRegDt).toDate();

              // Sign 표시
              $timeout(setSignDataAll, 1000);

              // 공통코드 데이터 설정
              vm.CustGradeData.Code = vm.data.CustGrade;


              // 관리처방 목록 조회
              var data = vm.srchDetail;
              data.mapCode = VIEW_CVSMNGPRSCRPTN_SQL;

              postApi.select(data, function (result) {
                  if (result.header.status == CONSTANT.HttpStatus.OK) {

                    if (result.body.docs.length > 0) {
                      angular.forEach(result.body.docs, function (item) {
                        var obj = {
                          'ProductId': item.ProductId,
                          'ProductNm': item.ProductNm,
                          'ProductAmt': item.ProductAmt,
                          'MngCnt': item.MngCnt
                        };

                        // 선택 품목
                        vm.cvsMngPrscrptn.push(obj);
                      });
                    }
                  }
                }
              );


              // 첨부파일 목록 설정
              var uploadFileListCust = [];
              var uploadFileListCounsel = [];


              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId: item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt
                };

                if (item.GrpId == 1) {
                  vm.uploadFileListCust.push(obj);
                } else {
                  vm.uploadFileListCounsel.push(obj);
                }
              });

              //angular.copy(uploadFileList, vm.uploadFileList);
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");


          }


          // 픔목 목록 조회
          var param = {};
          param.mapCode = VIEW_PRODUCT_SQL;

          postApi.select(param, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              // 데이터 조회 성공
              vm.dataloader = false; // Progressbar 숨김

              if (result.body.docs.length > 0) {
                // 조회 데이터 설정
                angular.forEach(result.body.docs, function (item) {
                  var obj = {
                    ProductId: item.GoodsNo,
                    ProductNm: item.GoodsNm,
                    ProductAmt: item.GoodsPrice
                  };

                  vm.productList.push(obj);
                });

              }
            } else {
              vm.dataloader = false; // Progressbar 숨김

              console.error("Error> getData()");


            }
          }, function (error) {
            console.error("Error> getData()");
            console.table(error);
          });


        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      /**
       * Sign Data 표시
       *
       * @param
       * @return
       */
      function setSignDataAll() {

          $window.fnSetSignData('A', vm.data.SignImage);

          $window.fnSetSignData('F', vm.data.FaceImage);
      }
      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {

        // 날짜 컬럼 초기값
        vm.AgreeDt = new moment().toDate();
        vm.BirthDay = $rootScope.getDateFormat('');
        vm.CustRegDt = new moment().toDate();
        vm.CounselDt = new moment().toDate();

        // 신규 등록
        if (isNullOrEmpty(vm.data.keyId)) {
          // 성별 : 여
          if (isNullOrEmpty(vm.data.Gender))
            vm.data.Gender = 'F';

          // SMS수신동의 : SMS수신동의
          if (isNullOrEmpty(vm.data.SmsYN))
            vm.data.SmsYN = 'Y';

          // 음력양력구분 : 양력
          if (isNullOrEmpty(vm.data.LnrSlrType))
            vm.data.LnrSlrType = 'S';

          // 담당자 - 로그인 사용자
          if (isNullOrEmpty(vm.data.Manager)) {
            vm.data.Manager = $rootScope.gVariable.UserId;
            vm.data.ManagerNm = $rootScope.gVariable.UserName;
          }

          // 과거관리 및 시술이력 - 부작용 여부
          if (isNullOrEmpty(vm.data.TrtmtHist01SdEftYN))
            vm.data.TrtmtHist01SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist02SdEftYN))
            vm.data.TrtmtHist02SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist03SdEftYN))
            vm.data.TrtmtHist03SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist04SdEftYN))
            vm.data.TrtmtHist04SdEftYN = 'N';
          if (isNullOrEmpty(vm.data.TrtmtHist05SdEftYN))
            vm.data.TrtmtHist05SdEftYN = 'N';


          // 홈 케어 정보 - 제품명, 사용방법
          if (isNullOrEmpty(vm.data.HomeCare01YN))
            vm.data.HomeCare01YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare02YN))
            vm.data.HomeCare02YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare03YN))
            vm.data.HomeCare03YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare04YN))
            vm.data.HomeCare04YN = 'N';
          if (isNullOrEmpty(vm.data.HomeCare05YN))
            vm.data.HomeCare05YN = 'N';


        }

      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      vm.uploadFile = function () {
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      };

      /**
       * 고객관리 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFileCust() {

        // #region 입력값 설정

        // 날짜 데이터 설정
        if (isValidDate(vm.AgreeDt))
          vm.data.AgreeDt = moment(vm.AgreeDt).format('YYYY-MM-DD');

        if (isValidDate(vm.BirthDay))
          vm.data.BirthDay = moment(vm.BirthDay).format('YYYY-MM-DD');

        if (isValidDate(vm.CustRegDt))
          vm.data.CustRegDt = moment(vm.CustRegDt).format('YYYY-MM-DD');

        if (isValidDate(vm.CounselDt))
          vm.data.CounselDt = moment(vm.CounselDt).format('YYYY-MM-DD');

        vm.data.SignImage = $window.fnGetSignData('A'); // 서명
        vm.data.FaceImage = $window.fnGetSignData('F'); // 섹터별특징 - 얼굴

        // #endregion 입력값 설정

        // #region 필수항목 & Validation Check 체크
        if (!getIsValidData()) {
          return;
        }
        // #endregion 필수항목 & Validation Check 체크

        if (vm.vaultCust != null && vm.vaultCust.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vaultCust);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 상담 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFileCounsel() {
        if (vm.vaultCounsel != null && vm.vaultCounsel.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vaultCounsel);
        } else {
          // 데이터 저장
          setData();
        }
      }


      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }


      /**
       * 인쇄
       *
       * @param
       * @return
       */
      function setPrint() {
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: $stateParams.srch, keyId: vm.data.KeyId});
      }

      /**
       * PDF 저장
       *
       * @param
       * @return
       */
      function setSaveToPdf() {
        gAlert('', 'MSG.TODO_FEATURE');
      }

      /**
       * 필수 입력 & Validation Check
       *
       * @param
       * @return
       */
      function getIsValidData() {

        // #region 필수항목 체크
        var errMsg = '';

        if (!vm.AgreeDt)
          errMsg = errMsg + '- 동의일을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.CustNm))
          errMsg = errMsg + '- 고객명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.SignImage))
          errMsg = errMsg + '- 서명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.Mobile))
          errMsg = errMsg + '- 연락처를 입력하세요.<br/>';

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        // #endregion 필수항목 체크

        //#region Validation Check

        if (!isNullOrEmpty(vm.data.Email))
          if (!isValidEmail(vm.data.Email)) {
            gAlert('', 'Email 주소를 확인하세요.');
            return false;
          }

        return true;
        //#endregion Validation Check
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {

        // #region 입력값 설정

        /*   // 날짜 데이터 설정
           if (isValidDate(vm.AgreeDt))
             vm.data.AgreeDt = moment(vm.AgreeDt).format('YYYY-MM-DD');

           if (isValidDate(vm.BirthDay))
             vm.data.BirthDay = moment(vm.BirthDay).format('YYYY-MM-DD');

           if (isValidDate(vm.CustRegDt))
             vm.data.CustRegDt = moment(vm.CustRegDt).format('YYYY-MM-DD');

           if (isValidDate(vm.CounselDt))
             vm.data.CounselDt = moment(vm.CounselDt).format('YYYY-MM-DD');

           vm.data.SignImage = $window.fnGetSignData('A'); // 서명
           vm.data.FaceImage = $window.fnGetSignData('F'); // 섹터별특징 - 얼굴*/

        // #endregion 입력값 설정

        // #region 필수항목 & Validation Check 체크
        /*  if (!getIsValidData())
            return false;*/
        //#endregion 필수항목 & Validation Check 체크


        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];                // 첨부파일
        angular.forEach(vm.uploadFileListCust, function (item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileListCounsel, function (item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        vm.data.cvsMngPrscrptn = vm.cvsMngPrscrptn;  // 관리처방

        var data = vm.data; // 사용자 입력 데이터
        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', error.body.docs[0].errMessage);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', result.responseVO.body.docs[0].errMessage);
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        console.table(vm.data);
        gAlert("", result.body.docs[0].errMessage);
      }

      /**
       * 관리처방 추가
       *
       * @param {object} li - Product Item
       * @return
       */
      function setAddProduct(li) {
        var obj = {
          'ProductId': li.ProductId,
          'ProductNm': li.ProductNm,
          'ProductAmt': li.ProductAmt,
          'MngCnt': 1
        };


        // 중복 존재시 관리횟수 증가
        var chkPrd = $filter('filter')(vm.cvsMngPrscrptn, {ProductId: li.ProductId})[0];

        if (isNullOrEmpty(chkPrd)) {
          // 신규 등록
          vm.cvsMngPrscrptn.push(obj);
        } else {
          // 관리 횟수 증가
          chkPrd.MngCnt = chkPrd.MngCnt + 1;
        }


      }

      /**
       * 관리처방 삭제
       *
       * @param {object} li - Product Item
       * @return
       */
      function setDelProduct(li) {

        for (var i in vm.cvsMngPrscrptn) {
          if (vm.cvsMngPrscrptn[i].ProductId === li.ProductId) {
            vm.cvsMngPrscrptn.splice(i, 1);
          }
        }

      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      /**
       * Tab 변경 후 화면 이동
       *
       * @param
       * @return
       */
      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload: VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * Tab 변경
       *
       * @param
       * @return
       */
      function setChangeTab(tabId) {
        vm.tabId = tabId;

        goNextPage(false);
      }

            /**
       * 추천인 코드 생성
       *
       * @param
       * @return
       */
      function setCode() {
        var s = '';
        var start = true;
        var intSum = '';
        var stringSum = '';
        var randomchar = function() {
        var n = Math.floor(Math.random() * 35);

        if(s.length == 0) {

          n = Math.floor(Math.random() * 26);
          stringSum += String.fromCharCode(n + 55);

          return String.fromCharCode(n + 65)
        }

          if (n < 10 && intSum.length < 3) {

            intSum += n;
            return n;
          }
            //1-10
          if (n < 36 &&  stringSum.length < 3) {

            stringSum += String.fromCharCode(n + 55);
            return String.fromCharCode(n + 55); //A-Z
          }
          if( n < 10 && n > 36) {
            retrun ;
          }

        };
        var t ='';
        while (s.length < 6) {

          t = randomchar();
          if(t != undefined) {
            s += t;
          }
        }
        getIsDupMyCd(s);

      }

      /**
       * 추천인 코드 중복확인
       *
       * @param
       * @return
       */
      function getIsDupMyCd(newCode) {

        var data = vm.srchDetail;
        data.mapCode = MY_CODE_SQL;
        data.MyRecomendrCd = newCode;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공

            if (result.body.docs.length > 0) {
              getIsDupMyCd();
            } else {
              vm.data.MyRecomendrCd = newCode;
              setMyRecomendrCd();
            }
          } else {
            console.error("Error> getMyRecomendrCd()");

          }
        }, function (error) {
          console.error("Error> getMyRecomendrCd()");
          console.table(error);
        });
      }


      /**
       * 추천인 코드 저장
       *
       * @param
       * @return
       */
      function setMyRecomendrCd (){

        var data = vm.srchDetail;
        data.mapCode = CODE_UPDATE_SQL;

        postApi.update(data, function (result) {

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            if (result.body.docs.length > 0) {
              gAlert('추천인 코드가 저장되었습니다.');
            } else {
              gAlert('추천인 코드 저장 실패');
            }
          } else {
            console.error("Error> getMyRecomendrCd()");

          }
        }, function (error) {
          console.error("Error> getMyRecomendrCd()");
          console.table(error);
        });

      }
      /* 추천인코드 존재여부 */
      function checkedRecomendrCd() {
        var data = angular.copy(vm.srchDetail);

        data.mapCode = CODE_SQL;
        data.RecomendrCd = vm.RecomendrCd;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            if (result.body.docs.length > 0) {
              vm.data.RecomendrCd = vm.RecomendrCd;
              vm.tmpRecomendrCd = vm.RecomendrCd;
            } else {
              gAlert('','- 추천인코드를 확인해주세요.')
            }
          } else {
            console.error("Error> getMyRecomendrCd()");
          }
        }, function (error) {
          console.error("Error> getMyRecomendrCd()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setPrint = setPrint;                   // 인쇄
      vm.setSaveToPdf = setSaveToPdf;           // PDF
      vm.setData = setData;                     // 데이터 저장
      vm.uploadFileCust = uploadFileCust;       // 고객관리사진
      vm.uploadFileCounsel = uploadFileCounsel; // 상담사진

      vm.setAddProduct = setAddProduct;         // 관리처방 추가
      vm.setDelProduct = setDelProduct;         // 관리처방 삭제
      vm.setChangeTab = setChangeTab;
      vm.goList = goList;                       // 목록 화면 이동
      vm.setChangeTab = setChangeTab;           // Tab 변경
      vm.setCode = setCode;
      vm.checkedRecomendrCd = checkedRecomendrCd;

      // 데이터 조회
      getData();

      // Sign Pad 초기화
      $timeout($window.fnSetInitSignPad, 1000);

    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-edit-tab2-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객-상담이력
   */
  webapp.controller('CustomerEditTab2Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CustomerEditTab2Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {


      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Customer.getCounselHistListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Customer.getCounselHistList';    // 목록 조회 SQL
      var EXCEL_SQL = ''; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Customer.deleteCounselHistList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.customer.customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.customer.customer-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'CustTabCounselHist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CounselHistId'; // Primary Key Column
      var EXCEL_TITLE = '상담이력목록'; //고객 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortColumn: 'CounselDt', // 정렬컬럼명
          sortDirect: 'DESC'     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));

        // 목록에서 vm.srch값 조회시 정렬 컬럼 변경
        if (vm.srch.tableNm == 'Customer')
        {
          vm.srch.sortColumn = 'CounselDt';
          vm.srch.sortDirect = 'DESC';
        }

        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.srch.keyId = !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : ''; // Primary Key Data
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      vm.keyId = ''; // 상담이력 KeyId

      /**
       * 상담이력 팝업 호출
       * @param {string}
       * @return {boolean}
       */
      function srchCounseHistModal() {
        var ctrl = 'CounselHistModalCtrl as vc';
        var paramData = {custId: vm.srch.keyId, keyId: vm.keyId};
        var modalInstance = modalFactory.open("lg", "components/modal/customer/counselhist-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            // 저장 or 삭제
            getList();
          },
          function (cancelData) {
            // 취소
          }
        );
      }
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }


      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
        getList();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        vm.keyId = '';

        // 상담이력 팝업 호출
        srchCounseHistModal();
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        // 상담이력 KeyId
        vm.keyId = paramKeyId;

        // 상담이력 팝업 호출
        srchCounseHistModal();
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {


        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            setDelListAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드


      // 목록 조회
      getList();

      // 초기 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-edit-tab3-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객-구매이력
   */
  webapp.controller('CustomerEditTab3Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CustomerEditTab3Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {


      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Customer.getPurchHistListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Customer.getPurchHistList';    // 목록 조회 SQL
      var EXCEL_SQL = ''; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = ''; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.customer.customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.customer.customer-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'CustTabPurchHist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'PurchHistId'; // Primary Key Column
      var EXCEL_TITLE = '구매이력목록'; //고객 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortColumn: 'PurchDate', // 정렬컬럼명
          sortDirect: 'DESC'     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));

        // 목록에서 vm.srch값 조회시 정렬 컬럼 변경
        if (vm.srch.tableNm == 'Customer')
        {
          vm.srch.sortColumn = 'PurchDate';
          vm.srch.sortDirect = 'DESC';
        }

        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.srch.keyId = !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : ''; // Primary Key Data
      }


      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              // 영수증 사진 다운로드 링크 설정
              angular.forEach(vm.lists, function (item) {
                if (!isNullOrEmpty(item.ReceiptImg))
                {
                  item.ReceiptImg = StaticVariable.getFileDownloadUrl(item.ReceiptImg);
                }
                else
                {
                  item.ReceiptImg = '';
                }
              });

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
        getList();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-edit-tab4-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객-예약이력
   */
  webapp.controller('CustomerEditTab4Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CustomerEditTab4Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {


      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Customer.getCvsReservHistListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Customer.getCvsReservHistList';    // 목록 조회 SQL
      var EXCEL_SQL = ''; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = ''; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.customer.customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.customer.customer-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'CustTabCvsReservHist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'ReservHistId'; // Primary Key Column
      var EXCEL_TITLE = '예약이력목록'; //고객 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortColumn: 'ReservDate', // 정렬컬럼명
          sortDirect: 'DESC'     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));

        // 목록에서 vm.srch값 조회시 정렬 컬럼 변경
        if (vm.srch.tableNm == 'Customer')
        {
          vm.srch.sortColumn = 'ReservDate';
          vm.srch.sortDirect = 'DESC';
        }

        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.srch.keyId = !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : ''; // Primary Key Data
      }


      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        console.log(vm.srch.sortColumn);
        console.log(vm.srch.sortDirect);

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
        getList();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-edit-tab5-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객-SMS이력
   */
  webapp.controller('CustomerEditTab5Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CustomerEditTab5Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {


      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Customer.getSmsHistListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Customer.getSmsHistList';    // 목록 조회 SQL
      var EXCEL_SQL = ''; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = ''; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.customer.customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.customer.customer-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'CustTabSmsHist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'SMSHistId'; // Primary Key Column
      var EXCEL_TITLE = 'SMS이력목록'; //고객 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortColumn: 'SendDate', // 정렬컬럼명
          sortDirect: 'DESC'     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));

        // 목록에서 vm.srch값 조회시 정렬 컬럼 변경
        if (vm.srch.tableNm == 'Customer')
        {
          vm.srch.sortColumn = 'SendDate';
          vm.srch.sortDirect = 'DESC';
        }

        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.srch.keyId = !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : ''; // Primary Key Data
      }


      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        console.log(vm.srch.sortColumn);
        console.log(vm.srch.sortDirect);

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
        getList();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-edit-tab6-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객-설문이력
   */
  webapp.controller('CustomerEditTab6Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CustomerEditTab6Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {


      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Customer.getSurveyRespHistListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Customer.getSurveyRespHistList';    // 목록 조회 SQL
      var EXCEL_SQL = ''; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = ''; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.customer.customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.customer.customer-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'CustTabSurveyRespHist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'SvyRespHistId'; // Primary Key Column
      var EXCEL_TITLE = '설문이력목록'; //고객 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortColumn: 'RegDate', // 정렬컬럼명
          sortDirect: 'DESC'     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));

        // 목록에서 vm.srch값 조회시 정렬 컬럼 변경
        if (vm.srch.tableNm == 'Customer')
        {
          vm.srch.sortColumn = 'RegDate';
          vm.srch.sortDirect = 'DESC';
        }

        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.srch.keyId = !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : ''; // Primary Key Data
      }


      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        console.log(vm.srch.sortColumn);
        console.log(vm.srch.sortDirect);

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
        getList();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 고객조회
   */
  webapp.controller('CustomerListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CustomerListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {


      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Customer.getCustomerListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Customer.getCustomerList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Customer.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Customer.deleteCustomerList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.customer.customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';    // 목록 등록/수정 화면
      var DETAIL_PAGE_URL = 'app.customer.customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.customer.customer-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CustId'; // Primary Key Column
      var EXCEL_TITLE = '고객목록'; //고객 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'CustRegDt' // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      $rootScope.gVariable.listKeyId = vm.keyId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      // #region 담당자 검색 팝업 호출

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };

      // #endregion 담당자 검색 팝업 호출


      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }

            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
                // 등록/수정 화면 이동
                $state.go(EDIT_PAGE_URL, {
                  srch: srch,
                  keyId: ''
                });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, detailPageUrl, listDetailPageUrl, loginId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
            // 등록/수정 화면 이동
            $state.go(detailPageUrl == null ? EDIT_PAGE_URL : detailPageUrl, {
              srch: srch,
              keyId: paramKeyId,
              loginId: loginId
            });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(listDetailPageUrl == null ? LIST_EDIT_PAGE_URL : listDetailPageUrl, {
            srch: srch,
            keyId: paramKeyId,
            loginId: loginId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if (item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDate')

                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }

                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {


        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', '선택한 고객 정보를 삭제하시겠습니까?<br/>삭제한 고객 정보는 복구할 수 없습니다.', {
          btn: '',
          fn: function () {
            setDelListAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 설정
      setInitData();
    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.customer', {
      url: '/customer',
      template: '<div ui-view></div>'
    }).state('app.customer.customer-list', {
      url: '/customer-list/:srch',
      templateUrl: 'app/customer/customer-list.html',
      requiresAuthentication: true,
      resolve: {
        plugins: ['$ocLazyLoad', function ($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }]
      }
    }).state('app.customer.customer-detail', {
      url: '/customer-detail/:srch/:keyId',
      templateUrl: 'app/customer/customer-detail-tab1.html',
      requiresAuthentication: true
    }).state('app.customer.customer-detail2', {
      url: '/customer-detail2/:srch/:keyId/:loginId',
      templateUrl: 'app/customer/customer-detail2.html',
      requiresAuthentication: true
    }).state('app.customer.customer-detail2.tab1', {
      url: '/tab1',
      templateUrl: 'app/customer/customer-detail2-tab1.html'
    }).state('app.customer.customer-detail2.tab2', {
      url: '/tab2',
      templateUrl: 'app/customer/customer-detail2-tab2.html'
    }).state('app.customer.customer-detail2.tab3', {
      url: '/tab3',
      templateUrl: 'app/customer/customer-detail2-tab3.html'
    }).state('app.customer.customer-detail2.tab4', {
      url: '/tab4',
      templateUrl: 'app/customer/customer-detail2-tab4.html'
    }).state('app.customer.customer-edit', {
      url: '/customer-edit/:srch/:keyId',
      templateUrl: 'app/customer/customer-edit.html'
    }).state('app.customer.customer-edit.tab1', {
      url: '/tab1',
      templateUrl: 'app/customer/customer-edit-tab1.html'
    }).state('app.customer.customer-edit.tab2', {
      url: '/tab2',
      templateUrl: 'app/customer/customer-edit-tab2.html'
    }).state('app.customer.customer-edit.tab3', {
      url: '/tab3',
      templateUrl: 'app/customer/customer-edit-tab3.html'
    }).state('app.customer.customer-edit.tab4', {
      url: '/tab4',
      templateUrl: 'app/customer/customer-edit-tab4.html'
    }).state('app.customer.customer-edit.tab5', {
      url: '/tab5',
      templateUrl: 'app/customer/customer-edit-tab5.html'
    }).state('app.customer.customer-edit.tab6', {
      url: '/tab6',
      templateUrl: 'app/customer/customer-edit-tab6.html'
    }).state('app.customer.customer-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/customer/customer-detail-tab1.html',
      requiresAuthentication: true
    }).state('app.customer.customer-list.detail2', {
      url: '/detail2/:keyId/:loginId',
      templateUrl: 'app/customer/customer-detail2.html',
      requiresAuthentication: true
    }).state('app.customer.customer-list.detail2.tab1', {
      url: '/tab1',
      templateUrl: 'app/customer/customer-detail2-tab1.html',
    }).state('app.customer.customer-list.detail2.tab2', {
      url: '/tab2',
      templateUrl: 'app/customer/customer-detail2-tab2.html',
    }).state('app.customer.customer-list.detail2.tab3', {
      url: '/tab3',
      templateUrl: 'app/customer/customer-detail2-tab3.html',
    }).state('app.customer.customer-list.detail2.tab4', {
      url: '/tab4',
      templateUrl: 'app/customer/customer-detail2-tab4.html',
    }).state('app.customer.customer-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/customer/customer-edit.html'
    }).state('app.customer.customer-list.edit.tab1', {
      url: '/tab1',
      templateUrl: 'app/customer/customer-edit-tab1.html'
    }).state('app.customer.customer-list.edit.tab2', {
      url: '/tab2',
      templateUrl: 'app/customer/customer-edit-tab2.html'
    }).state('app.customer.customer-list.edit.tab3', {
      url: '/tab3',
      templateUrl: 'app/customer/customer-edit-tab3.html'
    }).state('app.customer.customer-list.edit.tab4', {
      url: '/tab4',
      templateUrl: 'app/customer/customer-edit-tab4.html'
    }).state('app.customer.customer-list.edit.tab5', {
      url: '/tab5',
      templateUrl: 'app/customer/customer-edit-tab5.html'
    }).state('app.customer.customer-list.edit.tab6', {
      url: '/tab6',
      templateUrl: 'app/customer/customer-edit-tab6.html'
    }).state('app.customer.customer-view', {
      url: '/customer-edit/:srch/:keyId',
      templateUrl: 'app/customer/customer-detail-tab1.html'
    }).state('app.customer.customer-list.detail.tab1', {
      url: '/tab1',
      templateUrl: 'app/customer/customer-detail-tab1.html'
    });
  }
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cvsreserv:cvsreserv-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('CvsreservEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CvsreservEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'User.insertUser';     // 등록 SQL
      var UPDATE_SQL = 'CvsReserv.updateReservDay';     // 수정 SQL
      var VIEW_SQL = 'CvsReserv.getReservInfoList'; // 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.user-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.user-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.user-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvsreservhist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      var MODAL_TYPE_ADD = 'add';
     // var MODAL_TYPE_NEW = 'new';
      var MODAL_TYPE_EDIT = 'edit';
      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.addEvent = false;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          ReservDateFrom : $filter('localToUtc')(moment(moment().startOf('month')).format('YYYY-MM-DD'),'from'),
          ReservDateTo : $filter('localToUtc')(moment(moment().endOf('month')).format('YYYY-MM-DD'),'to'),
        };
        vm.defaultDate = moment(moment().startOf('month')).format('YYYY-MM-DD');

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.custId)) {
        vm.custId = $stateParams.custId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 예약정보 팝업 호출

      /**
       * 예약정보 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */

      function srchReservInfoModal (chkDate,type) {
        var ctrl = 'CvsReservInfoModalCtrl as vc';

        var paramData = {chkDate : chkDate, type : type, custId : vm.custId, keyId : vm.keyId};
        var modalInstance = modalFactory.open("lg", "components/modal/cvsreserv/cvsreserv-info-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {

            if(type === 'add') {
              $('#calendar').fullCalendar('renderEvent',
              {
                  title : okData.title,
                  start : okData.reservDate,
                  id : okData.keyId,
              });
            } else if(type === 'edit') {
              $('#calendar').fullCalendar('removeEvents',okData.keyId)
            }

            if(type == 'edit' && okData.res =='E') {
              $('#calendar').fullCalendar('renderEvent',
              {
                  title : okData.title,
                  start : okData.reservDate,
                  id : okData.keyId,
              });
            }
          },
          function (cancelData) {
            vm.modal = '';
          }
        );
      };


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.lists = result.body.docs;

              vm.reservList = [];
              var row ={};
              var reservDay = '';
              var reservTime = '';
              var tmpDate = '';
              angular.forEach(vm.lists, function(item) {
                row = {};

                reservDay = moment(item.ReservDate).format('YYYY-MM-DD');
                reservTime = moment(item.ReservDate).format('HH:mm');

                row.id = item.KeyId;
                row.start = reservDay;
                row.end = reservDay;
                row.title = reservTime + '/' + item.CustNm + '/';
                if (!isNullOrEmpty(item.CareTktNm)) {
                  row.title = row.title + item.CareTktNm+'/';
                }
                if (!isNullOrEmpty(item.MngCnt)) {
                  row.title = row.title + item.MngCnt+'회차/';
                }
                row.title = row.title + item.ManagerNm;
                vm.reservList.push(row);

              });

              if(!vm.addEvent) {
                getCalendar(vm.reservList);
              }
              if(vm.addEvent){
                $('#calendar').fullCalendar( 'removeEventSources');
                $('#calendar').fullCalendar( 'addEventSource', vm.reservList);
              }

            } else {

              getCalendar(vm.reservList);

              vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            $('#calendar').fullCalendar('updateEvent', event);
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 캘린터 셋팅
       *
       * @param
       * @return
       */
      function getCalendar(list) {

        $('#calendar').fullCalendar({
          locale : "ko",
          header: { left: 'today,prev,next', center: 'title', right: '' },
          //header: {  center: 'title' },
          defaultDate: vm.defaultDate,
          editable: true,
          displayEventTime : false,
          slotMinutes: 1,
          minTime : '07:00:00',
          events: list,
          eventRender: function(event, element){
            element.popover({
                animation:true,
                delay: 300,
                placement:'auto',
                content: "<div style='font-size:8pt;'>"+event.title,
                trigger: 'hover',
                html:true,
            });
          },
          dayClick: function(date, jsEvent, view,resourceObj) {

            srchReservInfoModal(date.format(),MODAL_TYPE_ADD);
          },
          eventClick: function(data, element, event) { //데이터 클릭했을 때 이벤트!

            vm.keyId = data.id;

            srchReservInfoModal('',MODAL_TYPE_EDIT);
            $('#calendar').fullCalendar('updateEvent', event);
          },

/*           eventDrop: function(event,dayDelta,minuteDelta,allDay,revertFunc,date) {
            console.log(event.start.format('YYYY-MM-DD'));
            gConfirm('', '예약 날짜를 변경하시겠습니까?', {
              btn: '',
              fn: function () {
                var data = {
                  keyId : event.id,
                  ReservDate : $filter("localToUtc")(event.start, 'yyyy-MM-dd'),
                  mapCode : UPDATE_SQL,
                }

                postApi.update(data, function (result) {
                  setInsertUpdateDetail(result);
                }, function (error) {
                  console.error("Error> setData()");
                  gAlert('', 'Menu.EXCEPTIONOCCURED');
                });
              }
            }, {
              btn: '',
              fn: function () {
                revertFunc();
              }
            });
            } */
          });
        // 왼쪽 버튼을 클릭하였을 경우
        $("button.fc-prev-button").click(function() {
          vm.addEvent = true;
          var date = $("#calendar").fullCalendar("getDate");
          vm.srchDetail.ReservDateFrom = $filter('localToUtc')(moment(date).startOf('month').format('YYYY-MM-DD'),'from');
          vm.srchDetail.ReservDateTo = $filter('localToUtc')(moment(date).endOf('month').format('YYYY-MM-DD'),'to');
          vm.defaultDate = moment(date).startOf('month').format('YYYY-MM-DD');
        getData();
        });

        // 오른쪽 버튼을 클릭하였을 경우
        $("button.fc-next-button").click(function() {
          vm.addEvent = true;
          var date = $("#calendar").fullCalendar("getDate");
          vm.srchDetail.ReservDateFrom = $filter('localToUtc')(moment(date).startOf('month').format('YYYY-MM-DD'),'from');
          vm.srchDetail.ReservDateTo = $filter('localToUtc')(moment(date).endOf('month').format('YYYY-MM-DD'),'to');
          vm.defaultDate = moment(date).startOf('month').format('YYYY-MM-DD');
        getData();

        });


      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.srchReservInfoModal = srchReservInfoModal; // 예약정보 모달 팝업

      // 데이터 조회
      getData();

    }]);

})();




(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cvsreserv:cvsreserv-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 예약 등록
   */
  webapp.controller('CvsreservListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CvsreservListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {


      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'CvsReserv.getCvsReservListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'CvsReserv.getCvsReservList';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReserv.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'CvsReserv.deleteCvsReservList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvsreserv.cvsreserv-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cvsreserv.cvsreserv-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.cvsreserv.cvsreserv-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.cvsreserv.cvsreserv-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.cvsreserv.cvsreserv-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'customerreservehist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CustId'; // Primary Key Column
      var EXCEL_TITLE = '예약고객 목록'; //고객 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.ReservDateFrom = '';
      //vm.ReservDateTo = '';


      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };

        if(!isNullOrEmpty(vm.ReservDateTo)) {

          vm.srch.ReservDateTo =  moment(vm.ReservDateTo).format('YYYY-MM-DD');
        }
        if(!isNullOrEmpty(vm.ReservDateFrom)) {
          vm.srch.ReservDateFrom = moment(vm.ReservDateFrom).format('YYYY-MM-DD');
        }

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.ReservDateFrom = isNullOrEmpty(vm.srch.ReservDateFrom) ? '' : moment(vm.srch.ReservDateFrom).toDate();
        vm.ReservDateTo = isNullOrEmpty(vm.srch.ReservDateTo) ? '' :moment(vm.srch.ReservDateTo).toDate();
      }

      vm.keyId = $stateParams.custId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정
      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회
        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            custId: paramKeyId,
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            custId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function changeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if (item.ColumnPhysicalNm == 'ReservDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }else if (item.ColumnPhysicalNm == 'VisitDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }else if (item.ColumnPhysicalNm == 'CustRegDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 담당자 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm. srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.ManagerNm = res.UserNm;
          vm.srch.Manager = res.UserId;
        }, function(cancelData) {
        });
      }

      /**
       * 사용자 초기화
       *
       * @param
       * @return
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = '';
        vm.srch.Manager = '';
      }

      function init(){

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 목록 삭제
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.ContentsIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.ContentsIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.ContentsIdList == null || vm.srch.ContentsIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.changeLayout = changeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      init();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cvsreserv:cvsreserv-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('CvsreservViewCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi', '$filter',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function CvsreservViewCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi,$filter, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'User.insertUser';     // 등록 SQL
      var UPDATE_SQL = 'CvsReserv.updateReservDay';     // 수정 SQL
      var VIEW_SQL = 'CvsReserv.getReservInfoList'; // 조회 SQL
      var LIST_SQL = 'CvsReserv.getInactCustList'; // 휴면고객 조회 SQL
      var LIST_CNT_SQL = 'CvsReserv.getReservInfoListCnt'; // 예약 건수 조회 SQL
      var LIST_MNG_SQL = 'CvsReserv.getReservManagerList';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvsreserv.cvsreserv-view';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.cvsreserv.cvsreserv-view'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.cvsreserv.cvsreserv-view';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvsreservhist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      var MODAL_TYPE_ADD = 'add';
      var MODAL_TYPE_EDIT = 'edit';
      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.addEvent = false;
      vm.inactColumnMap = {};

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          ReservDateFrom : $filter('localToUtc')(moment(moment().startOf('month')).format('YYYY-MM-DD'),'from'),
          ReservDateTo : $filter('localToUtc')(moment(moment().endOf('month')).format('YYYY-MM-DD'),'to'),
        };
        vm.defaultDate = moment(moment().startOf('month')).format('YYYY-MM-DD');
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.custId)) {
        vm.custId = $stateParams.custId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "List"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // #region 예약정보 팝업 호출

      /**
       * 예약정보 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */

      function srchReservInfoModal (chkDate,type) {
        var ctrl = 'CvsReservInfoModalCtrl as vc';
        var paramData = {chkDate : chkDate, type : type, custId : vm.custId, keyId : vm.keyId};
        var modalInstance = modalFactory.open("lg", "components/modal/cvsreserv/cvsreserv-info-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            if(type === 'add') {
              $('#calendar').fullCalendar('renderEvent',
              {
                  title : okData.title,
                  start : okData.reservDate,
                  id : okData.keyId,
              });
            } else if(type === 'edit') {
              $('#calendar').fullCalendar('removeEvents',okData.keyId)
            }

            if(type == 'edit' && okData.res =='E') {
              $('#calendar').fullCalendar('renderEvent',
              {
                  title : okData.title,
                  start : okData.reservDate,
                  id : okData.keyId,
              });
            }
          },
          function (cancelData) {
            vm.modal = '';
          }
        );
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }


      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }



       /**
       * 휴면고객 조회
       *
       * @param
       * @return
       */
      function getInactCustList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var dataInact = angular.copy(vm.srchDetail); // 검색 옵션 설정
        dataInact.mapCode = LIST_SQL;
        dataInact.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        //dataInact.mapCode = LIST_SQL;
        dataInact.tableNm = 'cvsinactcustomer';
        postApi.select(dataInact, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.inactListColumns = result.body.desc;
              angular.forEach(vm.inactListColumns, function (item) {
                vm.inactColumnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.inactListColumns)) {
              // 목록 데이터 표시
              vm.inactLists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.inactLists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        getListCnt();
        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼
        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        data.tableNm = "cvsreservhist";

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            getInactCustList();
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });

            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.lists = result.body.docs;
              vm.reservList = [];
              var row ={};
              var reservDay = '';
              var reservTime = '';

              angular.forEach(vm.lists, function(item) {
                row = {};


                reservDay = moment(item.ReservDate).format('YYYY-MM-DD');
                reservTime = moment(item.ReservDate).format('HH:mm');

                row.id = item.KeyId;
                row.start = reservDay;
                row.end = reservDay;
                row.title = reservTime + '/' + item.CustNm + '/';

                if (!isNullOrEmpty(item.CareTktNm)) {
                  row.title = row.title + item.CareTktNm+'/';
                }
                if (!isNullOrEmpty(item.MngCnt)) {
                  row.title = row.title + item.MngCnt+'회차/';
                }
                row.title = row.title + item.ManagerNm;

                row.dow ='';

                vm.reservList.push(row);

              });

            } else {
              vm.lists = {};
            }
            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

          if(!vm.addEvent) {
            getCalendar(vm.reservList);
            getReservMngList();
          }
          if(vm.addEvent){
            $('#calendar').fullCalendar( 'removeEventSources');
            $('#calendar').fullCalendar( 'addEventSource', vm.reservList);
            getReservMngList();
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            $('#calendar').fullCalendar('updateEvent', event);
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 캘린터 셋팅
       *
       * @param
       * @return
       */
      function getCalendar(list) {

        $('#calendar').fullCalendar({
          locale : "ko",
          header: { left: 'today,prev,next', center: 'title', right: 'month,agendaWeek,agendaDay,reservList' },
          //header: {  center: 'title' },
          defaultDate: vm.defaultDate,
          editable: true,
          displayEventTime : false,
          minTime : '07:00:00',
          events: list,
          eventRender: function(event, element){
            element.popover({
                animation:true,
                delay: 300,
                placement:'auto',
                content: "<div style='font-size:4px;'>"+event.title,
                trigger: 'hover',
                html:true,
            });
          },
          customButtons: {
            reservList: {
              text: '목록',
              click: function() {
                getReservList();
              }
            }
          },
          dayClick: function(date, jsEvent, view,resourceObj) {

            srchReservInfoModal(date.format(),MODAL_TYPE_ADD);
          },
          eventClick: function(data, element, event) { //데이터 클릭했을 때 이벤트!

            vm.keyId = data.id;
            srchReservInfoModal('',MODAL_TYPE_EDIT);
            $('#calendar').fullCalendar('updateEvent', event);
          },

/*           eventDrop: function(event,dayDelta,minuteDelta,allDay,revertFunc,date) {

            gConfirm('', '예약 날짜를 변경하시겠습니까?', {
              btn: '',
              fn: function () {
                var data = {
                  keyId : event.id,
                  ReservDate : event.start.format('YYYY-MM-DD'),
                  mapCode : UPDATE_SQL,
                }
                postApi.update(data, function (result) {
                  setInsertUpdateDetail(result);
                }, function (error) {
                  console.error("Error> setData()");
                  gAlert('', 'Menu.EXCEPTIONOCCURED');
                });
              }
            }, {
              btn: '',
              fn: function () {
              }
            });
            } */
          });
          // 왼쪽 버튼을 클릭하였을 경우
          $("button.fc-prev-button").on('click', function() {
            event.stopPropagation();

            vm.addEvent = true;
            var date = moment($("#calendar").fullCalendar("getDate")).format('YYYY-MM-DD');
            vm.srchDetail.ReservDateFrom = $filter('localToUtc')(moment(date).startOf('month').format('YYYY-MM-DD'),'from');
            vm.srchDetail.ReservDateTo = $filter('localToUtc')(moment(date).endOf('month').format('YYYY-MM-DD'),'to');
            vm.defaultDate = moment(date).startOf('month').format('YYYY-MM-DD');
            getData();
          });

          // 오른쪽 버튼을 클릭하였을 경우
          $("button.fc-next-button").on('click', function() {
            event.stopPropagation();
            vm.addEvent = true;
            var date = moment($("#calendar").fullCalendar("getDate")).format('YYYY-MM-DD');
            vm.srchDetail.ReservDateFrom = $filter('localToUtc')(moment(date).startOf('month').format('YYYY-MM-DD'),'from');
            vm.srchDetail.ReservDateTo = $filter('localToUtc')(moment(date).endOf('month').format('YYYY-MM-DD'),'to');
            vm.defaultDate = moment(date).startOf('month').format('YYYY-MM-DD');
            getData();

          });

          $("button.fc-agendaDay-button").click(function() {
            $('.fc-reservList-button').removeClass('fc-state-active');
            $(".fc-view-container").show();
            $("#reservList").hide();
          });
          $("button.fc-agendaWeek-button").click(function() {
            $('.fc-reservList-button').removeClass('fc-state-active');
            $(".fc-view-container").show();
            $("#reservList").hide();
          });
          $(".fc-month-button").click(function() {
            $('.fc-reservList-button').removeClass('fc-state-active');
            $('.fc-month-button').addClass('fc-state-active');
            $(".fc-view-container").show();
            $("#reservList").hide();
          });

          $("#reservList").hide();
        }

      function getReservList() {
        $('#calendar').fullCalendar('changeView', 'month');
        $(".fc-month-button").removeClass('fc-state-active');
        $('.fc-reservList-button').addClass('fc-state-active');
        $("#reservList").show();
        $(".fc-view-container").hide();
      }


        function getReservMngList() {
          vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

          var data = vm.srchDetail; // 검색 옵션 설정
          var chkInterval = false;


          data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
          data.mapCode = LIST_MNG_SQL;
          data.tableNm = 'cvsinactcustomer';
          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {

              if (result.body.docs.length > 0 && !isNullOrEmpty(vm.inactListColumns)) {
              // 목록 데이터 표시
              chkInterval = true;
              vm.mngLists = result.body.docs;

              var week = [];
              var row = {};
              var list = [];
              var reservTime = '';

              angular.forEach(vm.mngLists, function(item){
                week = [];
                row = {};

                if(item.SunWorkYN =='Y'){
                  week.push(0);
                }
                if(item.MonWorkYN =='Y'){
                  week.push(1);
                }
                if(item.TueWorkYN =='Y'){
                  week.push(2);
                }
                if(item.WedWorkYN =='Y'){
                  week.push(3);
                }
                if(item.ThuWorkYN =='Y'){
                  week.push(4);
                }
                if(item.FriWorkYN =='Y'){
                  week.push(5);
                }
                if(item.SatWorkYN =='Y'){
                  week.push(6);
                }

                if(! isNullOrEmpty(week)) {
                  reservTime = item.AttendTime+':00-'+item.OffWorkTime+':00';

                  row.start = '07:00';
                  row.title = reservTime + '/' + item.UserNm + ' 관리사';
                  row.dow = week;
                  row.color = 'pink';

                  list.push(row);
                }
              });
              $('#calendar').fullCalendar('addEventSource',list);
            } else {
              // 데이터 조회 실패
              vm.mngLists = {};
            }

          }

        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getReservMngList()");
          console.table(error);

        });
      }

      /**
       * 담당자 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm. srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.ManagerNm = res.UserNm;
          vm.srch.Manager = res.UserId;
        }, function(cancelData) {
        });
      }

      /**
       * 사용자 초기화
       *
       * @param
       * @return
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = '';
        vm.srch.Manager = '';
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getData = getData;                     // 데이터 조회
      vm.getInactCustList = getInactCustList;

      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.srchReservInfoModal = srchReservInfoModal; // 예약정보 모달 팝업

      // 데이터 조회
      getData();
    }]);

})();




(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cvsreserv:cvsreserv-view-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 예약 등록
   */
  webapp.controller('CvsreservViewListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CvsreservViewListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {


      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'CvsReserv.getCvsReservListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'CvsReserv.getCvsReservList';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReserv.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'CvsReserv.deleteCvsReservList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvsreserv.cvsreserv-view-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cvsreserv.cvsreserv-view-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.cvsreserv.cvsreserv-view-list.view';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.cvsreserv.cvsreserv-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.cvsreserv.cvsreserv-view';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'customerreservehist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CustId'; // Primary Key Column
      var EXCEL_TITLE = '예약고객 목록'; //고객 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.ReservDateFrom = moment(moment().startOf('month')).toDate();
      //vm.ReservDateTo = moment(moment().endOf('month')).toDate();


      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };

        if(!isNullOrEmpty(vm.ReservDateTo)) {
          vm.srch.ReservDateTo =  moment(vm.ReservDateTo).format('YYYY-MM-DD');
        }
        if(!isNullOrEmpty(vm.ReservDateFrom)) {
          vm.srch.ReservDateFrom = moment(vm.ReservDateFrom).format('YYYY-MM-DD');
        }

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.ReservDateFrom = isNullOrEmpty(vm.srch.ReservDateFrom) ? '' : moment(vm.srch.ReservDateFrom).toDate();
        vm.ReservDateTo = isNullOrEmpty(vm.srch.ReservDateTo) ? '' :moment(vm.srch.ReservDateTo).toDate();
      }

      vm.keyId = $stateParams.custId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회
        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;


        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            custId: paramKeyId,
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            custId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function changeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if (item.ColumnPhysicalNm == 'ReservDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }else if (item.ColumnPhysicalNm == 'VisitDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }else if (item.ColumnPhysicalNm == 'CustRegDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 담당자 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm. srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.ManagerNm = res.UserNm;
          vm.srch.Manager = res.UserId;
        }, function(cancelData) {
        });
      }

      /**
       * 사용자 초기화
       *
       * @param
       * @return
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = '';
        vm.srch.Manager = '';
      }

      function init(){

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 목록 삭제
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.ContentsIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.ContentsIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.ContentsIdList == null || vm.srch.ContentsIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.changeLayout = changeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      init();
    }]);
})();

(function() {
  ("use strict");

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state("app.cvsreserv", {
      url: "/cvsreserv",
      template: "<div ui-view></div>",
      controler: "cvsreservCtrl"
    }).state("app.cvsreserv.cvsreserv-list", {
      url: "/cvsreserv-list/:srch",
      templateUrl: "app/cvsreserv/cvsreserv-list.html",
      resolve: {
        plugins: [
          "$ocLazyLoad",
          function($ocLazyLoad) {
            return $ocLazyLoad.load([
              "/assets/app/vendor/footable/js/footable.js",
              "/assets/app/vendor/footable/css/footable.core.min.css"
            ]);
          }
        ]
      }
    }).state("app.cvsreserv.cvsreserv-edit", {
      url: "/user-edit/:srch/:custId",
      templateUrl: "app/cvsreserv/cvsreserv-edit.html"
    }).state("app.cvsreserv.cvsreserv-list.edit", {
      url: "/edit/:custId",
      templateUrl: "app/cvsreserv/cvsreserv-edit.html"
    }).state("app.cvsreserv.cvsreserv-view-list", {
      url: "/cvsreserv-view-list/:srch",
      templateUrl: "app/cvsreserv/cvsreserv-view-list.html",
      resolve: {
        plugins: [
          "$ocLazyLoad",
          function($ocLazyLoad) {
            return $ocLazyLoad.load([
              "/assets/app/vendor/footable/js/footable.js",
              "/assets/app/vendor/footable/css/footable.core.min.css"
            ]);
          }
        ]
      }
    }).state("app.cvsreserv.cvsreserv-view", {
      url: "/user-view/:srch/:custId",
      templateUrl: "app/cvsreserv/cvsreserv-view.html"
    }).state("app.cvsreserv.cvsreserv-view-list.view", {
      url: "/view/:custId",
      templateUrl: "app/cvsreserv/cvsreserv-view.html"
    });
  }
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:cvssales-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 정산 등록/수정
   */

  webapp.controller('CvsSalesDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CvsSalesDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'PurchHist.insertPurchHist';     // 등록 SQL
      var UPDATE_SQL = 'PurchHist.updatePurchHist';     // 수정 SQL
      var VIEW_SQL = 'PurchHist.getPurchHistDetail'; // 조회 SQL
      var CUST_SQL = 'Customer.getCustomerDetail'; // 고객조회 SQL
      var UPDATE_STATUS_SQL = 'PurchHist.updateStatus';
      var DEL_SQL = 'PurchHist.deletePurchDetail';
      var DEL_STOCK_SQL = 'PurchHist.deletePurchDetailStock';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssales-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.cvssales.cvssales-list.detail'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.cvssales.cvssales-detail';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'purchHist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var SALES_TYPE = '100' //매출유형 (정산 : 100)

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;

      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              getCustId();

              //Date형식 처리
              vm.data.PurchDate = $filter('utcToLocal')(vm.data.PurchDate,'yyyy-MM-dd')

              //단가/금액 계산을 위해 기존 저장된 데이터 넣어둠
              vm.goodsPriceTmp = vm.data.ProductAmt;
              vm.productUnitPrcTmp = vm.data.ProductUnitPrc;
              vm.goodsNoTmp = vm.data.ProductId;

              vm.careKtkTmp = vm.data.CareKtkAmt;
              vm.careKtkUnitPrcTmp = vm.data.CareKtkUnitPrc;
              vm.careKtkIdTmp = vm.data.CareKtkId;


              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {
              getCustId();
              vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';

        if (isNullOrEmpty(vm.data.PurchDate)) {
          errMsg = errMsg + '- 매출일자를 선택 하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.PayMeth)) {
          errMsg = errMsg + '- 결제수단을 선택 하세요.<br/>';
        }

        if(vm.data.SalesType == '100') {
          if (isNullOrEmpty(vm.data.PurchType)) {
            errMsg = errMsg + '- 구매유형을 선택 하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.ProductId)) {
            errMsg = errMsg + '- 제품을 선택 하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.ProductQty)) {
            errMsg = errMsg + '- 제품 수량을 입력 하세요.<br/>';
          }

        } else if (vm.data.SalesType == '200') {

          if (isNullOrEmpty(vm.data.CareTktId)) {
            errMsg = errMsg + '- 관리권을 선택 하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.CareTktQty)) {
            errMsg = errMsg + '- 관리권 수량을 입력 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.SellerId)) {
            errMsg = errMsg + '- 판매자를 선택 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.SptUserId)) {
            errMsg = errMsg + '- 서포터를 선택 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.ProductBarCdNo)) {
            errMsg = errMsg + '- 제품 바코드를 입력하세요.<br/>';
          }
          if (vm.data.PayMeth == '200') {
            if (isNullOrEmpty(vm.data.PayAprvNo)) {
              errMsg = errMsg + '-승인번호를 입력하세요<br/>';
            }
            if (isNullOrEmpty(vm.data.CardNo4Digits)) {
              errMsg = errMsg + '-카드번호 4자리를 입력하세요<br/>';
            }
          }
        }else if(vm.data.SALES_TYPE){
          if (isNullOrEmpty(vm.data.SellType)) {
            errMsg = errMsg + '- 판매유형을 선택 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.ProductId)) {
            errMsg = errMsg + '- 제품을 선택 하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.ProductQty)) {
            errMsg = errMsg + '- 제품 수량을 입력 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.ProductBarCdNo)) {
            errMsg = errMsg + '- 제품 바코드를 입력하세요.<br/>';
          }
          if (vm.data.PayMeth == '200') {
            if (isNullOrEmpty(vm.data.PayAprvNo)) {
              errMsg = errMsg + '-승인번호를 입력하세요<br/>';
            }
            if (isNullOrEmpty(vm.data.CardNo4Digits)) {
              errMsg = errMsg + '-카드번호 4자리를 입력하세요<br/>';
            }
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }
        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];

        if(isNullOrEmpty(vm.data.SalesType)){
          vm.data.SalesType = SALES_TYPE;
        }

        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');
        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.KeyId = !isNullOrEmpty(result.body.docs[0].RelateDataId) ? result.body.docs[0].RelateDataId : result.body.docs[0].KeyId;
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId,
              tabId: vm.tabId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {

        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = angular.copy(vm.data);
        data.StockType = 100;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });
          } else {
            getDelStock();
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }


      function getDelStock() {

        var data = angular.copy(vm.data);

        data.mapCode = DEL_STOCK_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if(result.body.docs.length >= 2) {
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  // 삭제 성공
                  var srch = $stateParams.srch;

                  // 목록 화면 이동
                  $state.go(LIST_PAGE_URL, {
                      srch: srch
                    },
                    {reload: LIST_PAGE_URL});
                }
              });
            }
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

       /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          if(res.TotalStock == 0 && $rootScope.gVariable.srchTenantId != 0) {
            gAlert('', '재고 수량을 확인 하세요.');
          } else {
            vm.data.GoodsNm = res.GoodsNm;
            vm.data.ProductId = res.GoodsNo;
            vm.data.ProductUnitPrc = res.GoodsPrice;

            if(vm.goodsNoTmp  == res.GoodsNo) {
              vm.data.ProductUnitPrc = vm.productUnitPrcTmp;
            }
            changePrdAmt();
          }

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.data.ProductId = '';
        vm.data.GoodsNm = '';
      }


      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.data.CareTktNm = res.CareTktNm;
          vm.data.CareTktId = res.KeyId;
          vm.data.CareTktUnitPrc = res.Price;

          if(vm.careTktIdTmp  == res.KeyId) {
            vm.data.CareTktUnitPrc = vm.careTktUnitPrcTmp;
          }
          changeTktAmt();
        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.data.CareTktId = '';
        vm.data.CareTktNm = '';
      }

      /**
       * 판매자 검색
       *
       * @param
       * @return
       */
      vm.srchSellerModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.SellerNm = res.UserNm;
          vm.data.SellerId = res.UserId;
        }, function(cancelData) {
        });
      }
      /**
       * 판매자 초기화
       *
       * @param
       * @return
       */
      vm.eraseSeller = function () {
        vm.data.SellerNm = '';
        vm.data.SellerId = '';
      }

      /**
       * 서포터 검색
       *
       * @param
       * @return
       */
      vm.srchSptUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.SptUserNm = res.UserNm;
          vm.data.SptUserId = res.UserId;
        }, function(cancelData) {
        });
      }
        /**
         * 서포터 초기화
         *
         * @param
         * @return
         */
      vm.eraseSptUser = function () {
        vm.data.SptUserNm = '';
        vm.data.SptUserId = '';
      }

      /**
       * 제품 금액 계산
       *
       * @param
       * @return
       */
      function changePrdAmt () {
        if(!isNullOrEmpty(vm.data.ProductQty)){
          vm.data.ProductAmt = vm.data.ProductUnitPrc * vm.data.ProductQty;
        } else {
          vm.data.ProductQty = 0;
          vm.data.ProductAmt = 0;
        }
      }

            /**
       * 관리권 금액 계산
       *
       * @param
       * @return
       */
      function changeTktAmt () {
        if(!isNullOrEmpty(vm.data.CareTktQty)){
          vm.data.CareTktAmt = vm.data.CareTktUnitPrc * vm.data.CareTktQty;
        } else {
          vm.data.CareTktQty = 0;
          vm.data.CareTktAmt = 0;
        }
      }

      function getCustId () {
        var data = vm.srchDetail;
        data.keyId = vm.data.CustId;
        data.mapCode = CUST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data.CustId = result.body.docs[0].KeyId;
              vm.CustomerNm = result.body.docs[0].CustNm;
            } else {
              vm.data.CustId = '';
              vm.CustomerNm = '';
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getCustId()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getCustId()");
          console.table(error);
        });
      }


      function updateStatus() {
         var data = vm.srchDetail;

        data.RelateDataId = $stateParams.keyId;
        data.mapCode = UPDATE_STATUS_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // KeyId 조회
            vm.data.KeyId = !isNullOrEmpty(result.body.docs[0].RelateDataId) ? result.body.docs[0].RelateDataId : result.body.docs[0].KeyId;
            gAlert("", "승인되었습니다.", {
              btn: "",
              fn: function () {
                // 수정 -> 조회 화면 이동
                var srch = $stateParams.srch;

                $state.go(LIST_VIEW_PAGE_URL, {
                  srch: srch,
                  keyId: data.RelateDataId,
                  tabId : 1
                }, {reload:LIST_VIEW_PAGE_URL});
              }
            });
            return;
          }
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제
      vm.changeTktAmt = changeTktAmt;
      vm.changePrdAmt = changePrdAmt;
      vm.getCustId = getCustId;
      vm.updateStatus = updateStatus;
      // 데이터 조회
      getData();

    }]);

})();



(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:cvssales-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 정산 등록/수정
   */

  webapp.controller('CvsSalesEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CvsSalesEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'PurchHist.insertPurchHist';     // 등록 SQL
      var UPDATE_SQL = 'PurchHist.updatePurchHist';     // 수정 SQL
      var VIEW_SQL = 'PurchHist.getPurchHistDetail'; // 조회 SQL
      var CUST_SQL = 'Customer.getCustomerDetail'; // 고객조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssales-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.cvssales.cvssales-list.detail'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.cvssales.cvssales-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'purchHist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var SALES_TYPE = '100' //매출유형 (정산 : 100)

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      vm.PurchDate = moment().toDate();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId, // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = angular.copy(vm.srchDetail);
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              vm.data.AprvStatusNm = '대기';
              vm.data.AprvStatus = 'W';

              getCustId();

              //Date형식 처리
              if (!isValidDate(vm.data.PurchDate) && vm.data.PurchDate != undefined ) {
                vm.PurchDate = moment(vm.data.PurchDate).toDate();
              }
              //단가/금액 계산을 위해 기존 저장된 데이터 넣어둠
              vm.goodsPriceTmp = vm.data.ProductAmt;
              vm.productUnitPrcTmp = vm.data.ProductUnitPrc;
              vm.goodsNoTmp = vm.data.ProductId;

              vm.careKtkTmp = vm.data.CareKtkAmt;
              vm.careKtkUnitPrcTmp = vm.data.CareKtkUnitPrc;
              vm.careKtkIdTmp = vm.data.CareKtkId;


              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {
              getCustId();
              vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';

        vm.data.PurchDate = $filter('localToUtc')(vm.PurchDate);

        if (isNullOrEmpty(vm.data.PurchDate)) {
          errMsg = errMsg + '- 매출일자를 선택 하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.PayMeth)) {
          errMsg = errMsg + '- 결제수단을 선택 하세요.<br/>';
        }

        if(vm.data.SalesType == '100') {
          if (isNullOrEmpty(vm.data.PurchType)) {
            errMsg = errMsg + '- 구매유형을 선택 하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.ProductId)) {
            errMsg = errMsg + '- 제품을 선택 하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.ProductQty)) {
            errMsg = errMsg + '- 제품 수량을 입력 하세요.<br/>';
          }

        } else if (vm.data.SalesType == '200') {

          if (isNullOrEmpty(vm.data.CareTktId)) {
            errMsg = errMsg + '- 관리권을 선택 하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.CareTktQty)) {
            errMsg = errMsg + '- 관리권 수량을 입력 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.SellerId)) {
            errMsg = errMsg + '- 판매자를 선택 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.SptUserId)) {
            errMsg = errMsg + '- 서포터를 선택 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.ProductBarCdNo)) {
            errMsg = errMsg + '- 제품 바코드를 입력하세요.<br/>';
          }
          if (vm.data.PayMeth == '200') {
            if (isNullOrEmpty(vm.data.PayAprvNo)) {
              errMsg = errMsg + '-승인번호를 입력하세요<br/>';
            }
            if (isNullOrEmpty(vm.data.CardNo4Digits)) {
              errMsg = errMsg + '-카드번호 4자리를 입력하세요<br/>';
            }
          }
        }else if(vm.data.SALES_TYPE){
          if (isNullOrEmpty(vm.data.SellType)) {
            errMsg = errMsg + '- 판매유형을 선택 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.ProductId)) {
            errMsg = errMsg + '- 제품을 선택 하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.ProductQty)) {
            errMsg = errMsg + '- 제품 수량을 입력 하세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.ProductBarCdNo)) {
            errMsg = errMsg + '- 제품 바코드를 입력하세요.<br/>';
          }
          if (vm.data.PayMeth == '200') {
            if (isNullOrEmpty(vm.data.PayAprvNo)) {
              errMsg = errMsg + '-승인번호를 입력하세요<br/>';
            }
            if (isNullOrEmpty(vm.data.CardNo4Digits)) {
              errMsg = errMsg + '-카드번호 4자리를 입력하세요<br/>';
            }
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }
        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        if(isNullOrEmpty(vm.data.SalesType)){
          vm.data.SalesType = SALES_TYPE;
        }

        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        var data = angular.copy(vm.data); // 사용자 입력 데이터

        data.DelivType = 500;
        data.StockType = 200;

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.KeyId = !isNullOrEmpty(result.body.docs[0].RelateDataId) ? result.body.docs[0].RelateDataId : result.body.docs[0].KeyId;
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId,
              tabId: vm.tabId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = angular.copy(vm.data);
        data.mapCode = DEL_SQL;
        data.StockType = 100;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

       /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.totalStock = res.TotalStock;
          vm.stockFl = res.StockFl;
          if(res.TotalStock <= 0 && (($rootScope.gVariable.srchTenantId == 0 && vm.stockFl != 'n')||$rootScope.gVariable.srchTenantId != 0)) {
            gAlert('', '재고 수량을 확인 하세요.');
          } else {
            vm.data.GoodsNm = res.GoodsNm;
            vm.data.ProductId = res.GoodsNo;
            vm.data.ProductUnitPrc = res.GoodsPrice;

            if(vm.goodsNoTmp  == res.GoodsNo) {
              vm.data.ProductUnitPrc = vm.productUnitPrcTmp;
            }
            changePrdAmt();
          }

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.data.ProductId = '';
        vm.data.GoodsNm = '';
      }


      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.data.CareTktNm = res.CareTktNm;
          vm.data.CareTktId = res.KeyId;
          vm.data.CareTktUnitPrc = res.Price;

          if(vm.careTktIdTmp  == res.KeyId) {
            vm.data.CareTktUnitPrc = vm.careTktUnitPrcTmp;
          }
          changeTktAmt();
        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.data.CareTktId = '';
        vm.data.CareTktNm = '';
      }

      /**
       * 판매자 검색
       *
       * @param
       * @return
       */
      vm.srchSellerModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.SellerNm = res.UserNm;
          vm.data.SellerId = res.UserId;
        }, function(cancelData) {
        });
      }
      /**
       * 판매자 초기화
       *
       * @param
       * @return
       */
      vm.eraseSeller = function () {
        vm.data.SellerNm = '';
        vm.data.SellerId = '';
      }

      /**
       * 서포터 검색
       *
       * @param
       * @return
       */
      vm.srchSptUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.SptUserNm = res.UserNm;
          vm.data.SptUserId = res.UserId;
        }, function(cancelData) {
        });
      }
        /**
         * 서포터 초기화
         *
         * @param
         * @return
         */
      vm.eraseSptUser = function () {
        vm.data.SptUserNm = '';
        vm.data.SptUserId = '';
      }

      /**
       * 제품 금액 계산
       *
       * @param
       * @return
       */
      function changePrdAmt () {
        if(!isNullOrEmpty(vm.data.ProductQty)){
          if((vm.totalStock-vm.data.ProductQty)>= 0 || (vm.stockFl == 'n' && $rootScope.gVariable.srchTenantId == 0)){
            vm.data.ProductAmt = vm.data.ProductUnitPrc * vm.data.ProductQty;
          } else {
            gAlert('','재고 수량을 확인해 주세요');
            vm.data.ProductQty = 0;
            vm.data.ProductAmt = 0;
          }
        } else {
          vm.data.ProductQty = 0;
          vm.data.ProductAmt = 0;
        }

      }

      /**
       * 관리권 금액 계산
       *
       * @param
       * @return
       */
      function changeTktAmt () {
        if(!isNullOrEmpty(vm.data.CareTktQty)){
          vm.data.CareTktAmt = vm.data.CareTktUnitPrc * vm.data.CareTktQty;
        } else {
          vm.data.CareTktQty = 0;
          vm.data.CareTktAmt = 0;
        }
      }

      function getCustId () {
        var data = vm.srchDetail;
        data.keyId = vm.data.CustId;
        data.mapCode = CUST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data.CustId = result.body.docs[0].KeyId;
              vm.CustomerNm = result.body.docs[0].CustNm;
            } else {
              vm.data.CustId = '';
              vm.CustomerNm = '';
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getCustId()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getCustId()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제
      vm.changeTktAmt = changeTktAmt;
      vm.changePrdAmt = changePrdAmt;
      vm.getCustId = getCustId;

      // 데이터 조회
      getData();

    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cvssales:cvssales-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 정산 목록
   */
  webapp.controller('CvsSalesListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CvsSalesListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'PurchHist.getPurchHistListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'PurchHist.getPurchHistList';    // 목록 조회 SQL
      var EXCEL_SQL = 'PurchHist.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'PurchHist.deletePurchHistList'; // 목록에서 삭제
      var DELETE_STOCK_LIST_SQL = 'PurchHist.deletePurchHistListStock';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssales-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cvssales.cvssales-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.cvssales.cvssales-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.cvssales.cvssales-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.cvssales.cvssales-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'purchhist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'PurchHistId'; // Primary Key Column
      var EXCEL_TITLE = '정산 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.PurchDtFrom = moment().toDate();
        vm.PurchDtTo = moment().toDate();
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          PurchDtFrom: moment().format('YYYY-MM-DD'),
          PurchDtTo: moment().format('YYYY-MM-DD'),
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));

        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;

        if(!isNullOrEmpty(vm.srch.PurchDtFrom)&& vm.srch.PurchDtFrom != undefined) {
          vm.PurchDtFrom = moment(vm.srch.PurchDtFrom).toDate();
          vm.srch.PurchDtFrom = moment(vm.srch.PurchDtFrom).format('YYYY-MM-DD');
        }
        if(!isNullOrEmpty(vm.srch.PurchDtTo)&& vm.srch.PurchDtTo != undefined) {
          vm.PurchDtTo = moment(vm.srch.PurchDtTo).toDate();
          vm.srch.PurchDtTo = moment(vm.srch.PurchDtTo).format('YYYY-MM-DD');
        }

        vm.currentPage = vm.srch.page;

      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      vm.keyId = $stateParams.keyId;

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        if(!isNullOrEmpty(vm.srch.PurchDtFrom) && vm.srch.PurchDtFrom != undefined) {
          data.PurchDtFrom = $filter('localToUtc')(vm.srch.PurchDtFrom,'from') ;
          data.PurchDtTo = $filter('localToUtc')(vm.srch.PurchDtTo,'to') ;
        } else {
          data.PurchDtFrom = $filter('localToUtc')(vm.PurchDtFrom,'from') ;
          data.PurchDtTo = $filter('localToUtc')(vm.PurchDtTo,'to') ;
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        if(!isNullOrEmpty(vm.srch.PurchDtFrom) && vm.srch.PurchDtFrom != undefined) {
          data.PurchDtFrom = $filter('localToUtc')(vm.srch.PurchDtFrom,'from') ;
          data.PurchDtTo = $filter('localToUtc')(vm.srch.PurchDtTo,'to') ;
        } else {
          data.PurchDtFrom = $filter('localToUtc')(vm.PurchDtFrom,'from') ;
          data.PurchDtTo = $filter('localToUtc')(vm.PurchDtTo,'to') ;
        }

        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });

            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'PurchDate') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.GoodsNm = res.GoodsNm;
          vm.srch.GoodsNo = res.GoodsNo;
        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.GoodsNo = '';
        vm.srch.GoodsNm = '';
      }

      /**
       * 관리권 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.CareTktNm = res.CareTktNm;
          vm.srch.CareTktId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 관리권 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.srch.CareTktNm = '';
        vm.srch.CareTktId = '';
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function (row) {

          if(row.AprvStatus == '승인') {
            gAlert('','승인된 매출입니다.')
            row.chkRow = false;
          } else {
            for (var i = 0; i < vm.lists.length; i++) {
              if (!vm.lists[i].isChecked) {
                vm.chkHead = false;
                return;
              }
            }
            vm.chkHead = true;
          }
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }

        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];
        var lists = {};
        for (var i = 0; i < vm.lists.length; i++) {

          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i]);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = angular.copy(vm.srch);

        data.StockType = 100;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });
          } else {
            getDelStock();
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      function getDelStock() {
        var data = angular.copy(vm.srch);
        data.mapCode = DELETE_STOCK_LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if(result.body.docs.length >= 2) {
              gAlert('', 'Menu.DELETED', {
                btn : '',
                fn : function() {
                  getList();
                }
              });
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
    "use strict";

    webapp.config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider.state('app.cvssales', {
            url: '/cvssales',
            template: '<div ui-view></div>',
            controler: "cvssalesCtrl"
        }).state('app.cvssales.cvssales-list', {
            url: '/cvssales-list/:srch',
            templateUrl: 'app/cvssales/cvssales-list.html',
            resolve: {
                plugins: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        '/assets/app/vendor/footable/js/footable.js',
                        '/assets/app/vendor/footable/css/footable.core.min.css',
                    ]);
                }]
            },
        }).state('app.cvssales.cvssales-edit', {
          url: '/cvssales-edit/:srch/:tabId',
          templateUrl: 'app/cvssales/cvssales-edit.html',
        }).state('app.cvssales.cvssales-list.edit', {
          url: '/edit/:tabId',
          templateUrl: 'app/cvssales/cvssales-edit.html',
        })
        .state('app.cvssales.cvssales-detail', {
          url: '/cvssales-detail/:srch/:keyId/:tabId',
          templateUrl: 'app/cvssales/cvssales-detail.html',
        }).state('app.cvssales.cvssales-list.detail', {
          url: '/detail/:keyId/:tabId',
          templateUrl: 'app/cvssales/cvssales-detail.html',
        }).state('app.cvssales.cvssalestkt-list', {
          url: '/cvssalestkt-list/:srch',
          templateUrl: 'app/cvssales/cvssalestkt-list.html',
          resolve: {
              plugins: ['$ocLazyLoad', function($ocLazyLoad) {
                  return $ocLazyLoad.load([
                      '/assets/app/vendor/footable/js/footable.js',
                      '/assets/app/vendor/footable/css/footable.core.min.css',
                  ]);
              }]
          },
        }).state('app.cvssales.cvssalestkt-edit', {
          url: '/cvssales-edit/:srch/:custId',
          templateUrl: 'app/cvssales/cvssalestkt-edit.html',
        }).state('app.cvssales.cvssalestkt-list.edit', {
          url: '/edit/:custId',
          templateUrl: 'app/cvssales/cvssalestkt-edit.html',
        }).state('app.cvssales.cvssalesgen-list', {
          url: '/cvssalesgen-list/:srch',
          templateUrl: 'app/cvssales/cvssalesgen-list.html',
          resolve: {
              plugins: ['$ocLazyLoad', function($ocLazyLoad) {
                  return $ocLazyLoad.load([
                      '/assets/app/vendor/footable/js/footable.js',
                      '/assets/app/vendor/footable/css/footable.core.min.css',
                  ]);
              }]
          },
      }).state('app.cvssales.cvssalesgen-edit', {
        url: '/cvssales-edit/:srch/:custId',
        templateUrl: 'app/cvssales/cvssalesgen-edit.html',
      }).state('app.cvssales.cvssalesgen-list.edit', {
        url: '/edit/:custId',
        templateUrl: 'app/cvssales/cvssalesgen-edit.html',

      }).state('app.cvssales.cvssalesstock-list', {
        url: '/cvssalesstock-list/:srch',
        templateUrl: 'app/cvssales/cvssalesstock-list.html',
        resolve: {
          plugins: ['$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load([
              '/assets/app/vendor/footable/js/footable.js',
              '/assets/app/vendor/footable/css/footable.core.min.css',
            ]);
          }]
        }
      }).state('app.cvssales.cvssalesstock-list.edit', {
        url: '/edit/:goodsNo/:goodsNm',
        templateUrl: 'app/cvssales/cvssalesstock-edit.html',
      }).state('app.cvssales.cvssalesstock-edit', {
        url: '/cvssalesstock-edit/:srch/:goodsNo/:goodsNm',
        templateUrl: 'app/cvssales/cvssalesstock-edit.html',
      }).state('app.cvssales.cvssalesorder-list', {
        url: '/cvssalesorder-list/:srch',
        templateUrl: 'app/cvssales/cvssalesorder-list.html',
        resolve: {
          plugins: ['$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load([
              '/assets/app/vendor/footable/js/footable.js',
              '/assets/app/vendor/footable/css/footable.core.min.css',
            ]);
          }]
        }
      });
    }
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:cvssalesgen-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 정산 등록/수정
   */

  webapp.controller('CvsSalesGenEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CvsSalesGenEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'PurchHist.insertPurchHist';     // 등록 SQL
      var UPDATE_SQL = 'PurchHist.updatePurchHist';     // 수정 SQL
      var VIEW_SQL = 'PurchHist.getPurchHistDetail'; // 조회 SQL
      var CUST_SQL = 'Customer.getCustomerDetail'; // 고객조회 SQL


      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssalesgen-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.cvssales.cvssalesgen-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.cvssales.cvssalesgen-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'purchHist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var SALES_TYPE = '300' //매출유형 (일반 : 200)
      var PURCH_TYPE = '100' // 구매유형 (판매 : 100)

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      vm.PurchDate = moment().toDate();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = KEY_TABLE_NM;
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      // Key Data 설정
      if (!isNullOrEmpty($stateParams.custId)) {
        vm.srch.custId = $stateParams.custId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        userId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {

              getCustId();
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (!isValidDate(vm.data.PurchDate) && vm.data.PurchDate != undefined ) {
                vm.PurchDate = moment(vm.data.PurchDate).toDate();
              }
              //단가/금액 계산을 위해 기존 저장된 데이터 넣어둠
              vm.productAmtTmp = vm.data.ProductAmt;
              vm.productUnitPrcTmp = vm.data.ProductUnitPrc;
              vm.productIdTmp = vm.data.ProductId;

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {
              getCustId();
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';

        vm.data.PurchDate = $filter('localToUtc')(vm.PurchDate);
        if (isNullOrEmpty(vm.data.PurchDate)) {
          errMsg = errMsg + '- 매출일자를 선택 하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.SellType)) {
          errMsg = errMsg + '- 판매유형을 선택 하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ProductId)) {
          errMsg = errMsg + '- 제품을 선택 하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.ProductQty)) {
          errMsg = errMsg + '- 제품 수량을 입력 하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.PayMeth)) {
          errMsg = errMsg + '- 결제수단을 선택 하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.ProductBarCdNo)) {
          errMsg = errMsg + '- 제품 바코드를 입력하세요.<br/>';
        }
        if (vm.data.PayMeth == '200') {
          if (isNullOrEmpty(vm.data.PayAprvNo)) {
            errMsg = errMsg + '-승인번호를 입력하세요<br/>';
          }
          if (isNullOrEmpty(vm.data.CardNo4Digits)) {
            errMsg = errMsg + '-카드번호 4자리를 입력하세요<br/>';
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];

        vm.data.SalesType = SALES_TYPE;
        vm.data.PurchType = PURCH_TYPE;
        vm.data.UserId = vm.srch.userId;
        vm.data.AprvStatus = 'W';

        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');
        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.KeyId = !isNullOrEmpty(result.body.docs[0].RelateDataId) ? result.body.docs[0].RelateDataId : result.body.docs[0].KeyId;
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId,
              tabId: vm.tabId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

       /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          if(res.TotalStock == 0 && $rootScope.gVariable.srchTenantId != 0) {
            gAlert('', '재고 수량을 확인 하세요.');
          } else {
            vm.data.GoodsNm = res.GoodsNm;
            vm.data.ProductId = res.GoodsNo;
            vm.data.ProductUnitPrc = res.GoodsPrice;

            if(vm.productIdTmp  == res.GoodsNo) {
              vm.data.ProductUnitPrc = vm.productUnitPrcTmp;
            }
            changePrdAmt();
          }
        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.data.GoodsId = '';
        vm.data.GoodsNm = '';
      }




      /**
       * 제품 금액 계산
       *
       * @param
       * @return
       */
      function changePrdAmt () {
        if(!isNullOrEmpty(vm.data.ProductQty)){

          vm.data.ProductAmt = vm.data.ProductUnitPrc * vm.data.ProductQty;

        } else {
          vm.data.ProductQty = 0;
          vm.data.ProductAmt = 0;
        }
      }

      function getCustId () {
        var data = vm.srchDetail;
        data.keyId = data.custId;
        data.mapCode = CUST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data.CustId = result.body.docs[0].KeyId;
              vm.CustomerNm = result.body.docs[0].CustNm;
            } else {
              vm.data.CustId = '';
              vm.CustomerNm = '';
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getCustId()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getCustId()");
          console.table(error);
        });
      }


      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      vm.getCustId = getCustId;

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제
      vm.changePrdAmt = changePrdAmt;

      // 데이터 조회
      getData();

    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cvssales:cvssalesgen-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 정산 목록
   */
  webapp.controller('CvsSalesGenListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CvsSalesGenListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Customer.getCustomerListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Customer.getCustomerList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Customer.getExcelList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssalesgen-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cvssales.cvssalesgen-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.cvssales.cvssalesgen-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.cvssales.cvssalesgen-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.cvssales.cvssalesgen-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'custId'; // Primary Key Column
      var EXCEL_TITLE = '고객목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.PurchDtFrom = $rootScope.getDateFormat(vm.srch.PurchDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PurchDtTo = $rootScope.getDateFormat(vm.srch.PurchDtTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.custId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {

        if(isNullOrEmpty($stateParams.custId)) {
          gAlert("","고객을 선택해 주세요.");
          return;
        }
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            custId: $stateParams.custId
          }, {reload:EDIT_PAGE_URL});
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            custId: $stateParams.custId
          }, {reload:LIST_EDIT_PAGE_URL});
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            custId: paramKeyId,
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            custId: paramKeyId,
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ListColumnShowLevel != "showlevel0") {
                  if (item.ColumnPhysicalNm == 'LastVisitDate') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  }else if (item.ColumnPhysicalNm == 'CustRegDt') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.ProductNm = res.ProductNm;
          vm.srch.ProductId = res.ProductId;
        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.ProductId = '';
        vm.srch.ProductNm = '';
      }

      /**
       * 관리권 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.CareTktNm = res.CareTktNm;
          vm.srch.CareTktId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 관리권 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.srch.CareTktNm = '';
        vm.srch.CareTktId = '';
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('CvssalesorderListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CvssalesorderListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Stock.getCvssalesorderListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Stock.getCvssalesorderList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Stock.getCvssalesorderExcelList'; // 엑셀다운로드 SQL
      //var DELETE_LIST_SQL = 'Survey.deleteSurveyList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssalesorder-list';         // 목록 화면
      //var LIST_DETAIL_PAGE_URL = 'app.system.survey-list.detail';  // 목록 조회  화면
      //var LIST_EDIT_PAGE_URL = 'app.system.survey-list.edit';    // 목록 등록/수정 화면
      //var VIEW_PAGE_URL = 'app.system.survey-detail';       // 조회 화면
      //var EDIT_PAGE_URL = 'app.system.survey-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvsshoporder'; // 작업 테이블명
      var KEY_COLUMN_NM = 'ShopOrderId'; // Primary Key Column
      var EXCEL_TITLE = '주문 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 추가 변수
      vm.keyId = 0;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDtFrom = $rootScope.getDateFormat(vm.srch.RegDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDtTo = $rootScope.getDateFormat(vm.srch.RegDtTo);
        vm.deliveryCompleteDtFrom = $rootScope.getDateFormat(vm.srch.deliveryCompleteDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.deliveryCompleteDtTo = $rootScope.getDateFormat(vm.srch.deliveryCompleteDtTo);
        vm.currentPage = vm.srch.page;
      }

      vm.listSize = [10, 25, 50, 100]; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      //vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      //setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            //console.log("re", result);
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      /*
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }
      */

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      /*
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        }
      }
      */

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      /*
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }
      */

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      /*
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }
      */

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      /*
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }
      */

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 배송추적 팝업 호출
       *
       * @param
       * @return
       */
      vm.popInvoice = function (invoiceNo) {

        // 팝업 창 표시
        $window.open("https://www.doortodoor.co.kr/parcel/doortodoor.do?fsp_action=PARC_ACT_002&fsp_cmd=retrieveInvNoACT&invc_no=" + invoiceNo, "popInvoice", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=800px, height=600px");
      };

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductallModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/productall-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.GoodsNm = res.GoodsNm;
          vm.srch.GoodsNo = res.GoodsNo;
        }, function(cancelData) {
        });
      };

      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.GoodsNo = '';
        vm.srch.GoodsNm = '';
      };

      /**
       * 초기 세팅
       *
       * @param
       * @return
       */
      function init(){
        /*
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
        */
      }

      /**
       * 목록 삭제
       *
       * @param
       * @return
       */
      /*
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
        });
      }
      */

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      //vm.goDetail = goDetail;                     // 조회 화면 이동
      //vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      //vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      //vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      //vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      init();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('CvssalesstockEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', 'ifProxy', '$sce',

    function CvssalesstockEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, ifProxy, $sce) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Stock.updateCvssalesstock';     // 등록 SQL
      //var UPDATE_SQL = 'Survey.updateSurvey';     // 수정 SQL
      //var VIEW_SQL = 'Survey.getSurveyDetail'; // 조회 SQL
      //var DEL_SQL = 'Survey.deleteSurveyDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssalesstock-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.cvssales.cvssalesstock-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.cvssales.cvssalesstock-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvsinvntry'; // 작업 테이블명
      //var KEY_COLUMN_NM = 'InvntryId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          //keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          goodsId: !isNullOrEmpty($stateParams.srch.goodsId) ? $stateParams.srch.goodsId : '',
          goodsNm: !isNullOrEmpty($stateParams.srch.goodsNm) ? $stateParams.srch.goodsNm : '',
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.goodsNo)) {
        //vm.srch.keyId = $stateParams.keyId;
        vm.srch.goodsNo = $stateParams.goodsNo;
        vm.srch.goodsNm = $stateParams.goodsNm;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      //vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      //vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      //vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        //keyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM,                                      // 작업 테이블명
        GoodsNo: vm.srch.goodsNo,
        GoodsNm: vm.srch.goodsNm
      };

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductallModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/productall-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.GoodsNm = res.GoodsNm;
          vm.data.GoodsNo = res.GoodsNo;
        }, function(cancelData) {
        });
      };

      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.data.GoodsNo = '';
        vm.data.GoodsNm = '';
      };

      // ifProxy 초기화 후 콜백
      vm.frameInitComplete = function(porthole) {
        //alert("frameInitComplete");
      };

      // Iframe의 Dom 이 로드 된 후 콜백
      vm.contentChangeSuccess = function () {
        //alert("contentChangeSuccess");

        var request = {};
        //request.tenantId = $window.sessionStorage['loginTenantId'];
        request.goodsNo = vm.data.GoodsNo;
        request.stockType = vm.data.StockType;
        request.totalStock = vm.data.TotalStock;
        ifProxy.authApi("setGoodsStock", request);
      };

      // Iframe으로부터 받은 데이터
      vm.onMessage = function (msg) {
        //alert("onMessage");
        //console.log("cvssalesstock-edit-ctrl > shopConn result", msg);

        if (msg.data["resultCode"] != "200") {
          gAlert("", "쇼핑몰과 통신중 오류가 발생하였습니다.");
        }
        else {
          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function () {
              // 화면 분할 모드에 따른 이동
              goNextPage(true);
            }
          });
        }
      };

      // ifProxy Init
      vm.userType = ""; //값이 없어도 된다고 함
      var ifProxyOption = {
        porthole : vm.porthole,
        scope : $scope,
        targetId : 'shopFrame',
        url : $sce.trustAsResourceUrl(SHOP_DOMAIN_ADDRESSS + '/remote/remote.php?user_type=' + vm.userType),
        callback : {
          completInit : vm.frameInitComplete,
          contentChangeSuccess : vm.contentChangeSuccess,
          onMessage : vm.onMessage
        }
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      /*
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              // 역할 설정
              vm.data.UserRoles = [];

              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });

              //Date형식 처리
              if (vm.data.BirthDay != null && vm.data.BirthDay != "") vm.BirthDay = moment(vm.data.BirthDay).toDate();
              if (vm.data.EntryDt != null && vm.data.EntryDt != "") vm.EntryDt = moment(vm.data.EntryDt).toDate();
              if (vm.data.RetireDt != null && vm.data.RetireDt != "") vm.RetireDt = moment(vm.data.RetireDt).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }
      */

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      /*
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }
      */

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.data.GoodsNo)) {
          errMsg = errMsg + '- 제품을 선택하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.TotalStock)) {
          errMsg = errMsg + '- 수량을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.StockType)) {
          errMsg = errMsg + '- 구분을 선택하세요.<br/>';
        }

        if (vm.srch.srchTenantId != 0) {
          if (isNullOrEmpty(vm.data.InvntryDate)) {
            errMsg = errMsg + '- 일자을 입력하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.ProductBarCdNo)) {
            errMsg = errMsg + '- 제품바코드를 입력하세요.<br/>';
          }

          if (vm.data.StockType == "200" && isNullOrEmpty(vm.data.DelivType)) {
            errMsg = errMsg + '- 출고구분을 선택하세요.<br/>';
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      /*
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }
      */

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (getIsValidData() == false) {
          return;
        }

        // 본사인 경우 쇼핑몰 사이트의 재고를 업데이트 해준다.
        // 이후 쇼핑몰에 업데이트된 재고정보는 추후 배치를 통해 CRM에 전달된다.
        var msg = "";
        if (vm.srch.srchTenantId == 0) {
          msg += "- 본사의 입/출고 처리는 쇼핑몰과 연동을 통해 쇼핑몰 재고에 우선 반영 후 이후 CRM에 반영됨으로 최종 결과 확인까지 시간이 소요될 수 있습니다.<br />";
          msg += "- 쇼핑몰의 해당 제품이 삭제되었거나 재고가 무한으로 설정된 경우 또는 출고시 남은 재고가 0보다 작은경우에는 반영되지 않습니다.<br />";
          msg += "계속 진행하시겠습니까?<br />";

          gConfirm('', msg, {
            btn: '',
            fn: function () {
              // http://m.civasan1.godomall.com/remote/remote.php?user_type=203
              ifProxy.init(ifProxyOption);
            }
          }, {
            btn: '',
            fn: function () {
            }
          });
        }
        else {
          msg += "- 출고시 남은 재고가 0보다 작은경우에는 반영되지 않습니다.";
          gAlert('', msg, {
            btn: '',
            fn: function () {
              vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
              vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

              var data = vm.data; // 사용자 입력 데이터
              data.mapCode = INSERT_SQL;

              postApi.insert(data, function (result) {
                setInsertUpdateDetail(result);
              }, function (error) {
                console.error("Error> setData()");
                console.table(error);
              });
            }
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          /*
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
          */
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          //}
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        //vm.srch.keyId = "";
        vm.srch.goodNo = "";
        vm.srch.goodNm = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              //keyId: vm.data.KeyId,
              //tabId: vm.tabId
              goodsNo: vm.data.GoodsNo,
              goodsNm: vm.data.GoodsNm
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.goodsNo = "";
            vm.srch.goodsNm = "";
            //vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, goodsNo: vm.data.GoodsNo, goodsNm: vm.data.GoodsNm});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      /*
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }
      */

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      /*
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }
      */

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }
      */

      /**
       * 구분 코드 목록
       *
       * @param
       * @return
       */
      function getStockTypeCodeList() {
        var data = vm.srch;

        if (!isNullOrEmpty(vm.StockTypeCodeList)) return;

        vm.srch.CodeType = "STOCKTYPE";
        data.mapCode = 'CommonCode.getCommonCodeList';

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.StockTypeCodeList = result.body.docs;

            getDelivTypeCodeList();
          }
        });
      }

      /**
       * 출고구분 코드 목록
       *
       * @param
       * @return
       */
      function getDelivTypeCodeList() {
        var data = vm.srch;

        if (!isNullOrEmpty(vm.DelivTypeCodeList)) return;

        vm.srch.CodeType = "DELIVTYPE";
        data.mapCode = 'CommonCode.getCommonCodeList';

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.DelivTypeCodeList = result.body.docs;
          }
        });
      }

      // 함수 정의
      //vm.getData = getData;                     // 데이터 조회
      //vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      //vm.setDelData = setDelData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;

      // 데이터 조회
      //getData();

      getStockTypeCodeList();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('CvssalesstockListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CvssalesstockListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Stock.getCvssalesstockListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Stock.getCvssalesstockList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Stock.getCvssalesstockExcelList'; // 엑셀다운로드 SQL
      //var DELETE_LIST_SQL = 'Survey.deleteSurveyList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssalesstock-list';         // 목록 화면
      //var LIST_DETAIL_PAGE_URL = 'app.system.survey-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.cvssales.cvssalesstock-list.edit';    // 목록 등록/수정 화면
      //var VIEW_PAGE_URL = 'app.system.survey-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.cvssales.cvssalesstock-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvsinvntry'; // 작업 테이블명
      var KEY_COLUMN_NM = 'InvntryId'; // Primary Key Column
      var EXCEL_TITLE = '재고 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 추가 변수
      vm.keyId = 0;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.StockInDateFrom = $rootScope.getDateFormat(vm.srch.StockInDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.StockInDateTo = $rootScope.getDateFormat(vm.srch.StockInDateTo);
        vm.StockOutDateFrom = $rootScope.getDateFormat(vm.srch.StockOutDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.StockOutDateTo = $rootScope.getDateFormat(vm.srch.StockOutDateTo);
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.goodsNo;

      vm.listSize = [10, 25, 50, 100]; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            //console.log("re", result);
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      /*
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }
      */

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        $scope.selectedRow = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            goodsNo: '',
            goodsNm: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            goodsNo: '',
            goodsNm: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(goodNo, goodNm) {
        var srch = $stateParams.srch; // 검색 옵션
        $scope.selectedRow = goodNo;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            goodsNo: goodNo,
            goodsNm: goodNm
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            goodsNo: goodNo,
            goodsNm: goodNm
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function changeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductallModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/productall-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.GoodsNm = res.GoodsNm;
          vm.srch.GoodsNo = res.GoodsNo;
        }, function(cancelData) {
        });
      };
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.GoodsNo = '';
        vm.srch.GoodsNm = '';
      };

      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      /*
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };
      */

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      /*
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };
      */

      function init(){
        /*
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
        */
      }

      // 목록 삭제
      /*
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
        });
      }
      */

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      //vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.changeLayout = changeLayout;       // 화면모드 설정
      //vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      init();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:cvssalestkt-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 정산 등록/수정
   */

  webapp.controller('CvsSalesTktEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CvsSalesTktGenEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'PurchHist.insertPurchHist';     // 등록 SQL
      var UPDATE_SQL = 'PurchHist.updatePurchHist';     // 수정 SQL
      var VIEW_SQL = 'PurchHist.getPurchHistDetail'; // 조회 SQL
      var CUST_SQL = 'Customer.getCustomerDetail'; // 고객조회 SQL


      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssalestkt-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.cvssales.cvssalestkt-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.cvssales.cvssalestkt-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'purchHist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var SALES_TYPE = '200' //매출유형 (관리권 : 200)
      var PURCH_TYPE = '100' // 구매유형 (판매 : 100)

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      vm.PurchDate = moment().toDate();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = KEY_TABLE_NM;
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      // Key Data 설정
      if (!isNullOrEmpty($stateParams.custId)) {
        vm.srch.custId = $stateParams.custId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        userId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {

              getCustId();
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (!isValidDate(vm.data.PurchDate) && vm.data.PurchDate != undefined ) {
                vm.PurchDate = moment(vm.data.PurchDate).toDate();
              }
              //단가/금액 계산을 위해 기존 저장된 데이터 넣어둠
              vm.productAmtTmp = vm.data.ProductAmt;
              vm.productUnitPrcTmp = vm.data.ProductUnitPrc;
              vm.productIdTmp = vm.data.ProductId;

              vm.careKtkTmp = vm.data.CareKtkAmt;
              vm.careKtkUnitPrcTmp = vm.data.CareKtkUnitPrc;
              vm.careKtkIdTmp = vm.data.CareKtkId;

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {
              getCustId();
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';

        vm.data.PurchDate = $filter('localToUtc')(vm.PurchDate);
        if (isNullOrEmpty(vm.data.PurchDate)) {
          errMsg = errMsg + '- 매출일자를 선택 하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.CareTktId)) {
          errMsg = errMsg + '- 관리권을 선택 하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.CareTktQty)) {
          errMsg = errMsg + '- 관리권 수량을 입력 하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.PayMeth)) {
          errMsg = errMsg + '- 결제수단을 선택 하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.SellerId)) {
          errMsg = errMsg + '- 판매자를 선택 하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.SptUserId)) {
          errMsg = errMsg + '- 서포터를 선택 하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ProductBarCdNo)) {
          errMsg = errMsg + '- 제품 바코드를 입력하세요.<br/>';
        }
        if (vm.data.PayMeth == '200') {
          if (isNullOrEmpty(vm.data.PayAprvNo)) {
            errMsg = errMsg + '-승인번호를 입력하세요<br/>';
          }
          if (isNullOrEmpty(vm.data.CardNo4Digits)) {
            errMsg = errMsg + '-카드번호 4자리를 입력하세요<br/>';
          }
        }



        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];

        vm.data.SalesType = SALES_TYPE;
        vm.data.PurchType = PURCH_TYPE;
        vm.data.UserId = vm.srch.userId;
        vm.data.AprvStatus = 'W';
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');
        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.KeyId = !isNullOrEmpty(result.body.docs[0].RelateDataId) ? result.body.docs[0].RelateDataId : result.body.docs[0].KeyId;
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId,
              tabId: vm.tabId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

       /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          if(res.TotalStock == 0 && $rootScope.gVariable.srchTenantId != 0) {
            gAlert('', '재고 수량을 확인 하세요.');
          } else {
            vm.data.GoodsNm = res.GoodsNm;
            vm.data.ProductId = res.GoodsNo;
            vm.data.ProductUnitPrc = res.GoodsPrice;

            if(vm.productIdTmp  == res.GoodsNo) {
              vm.data.ProductUnitPrc = vm.productUnitPrcTmp;
            }
            changePrdAmt();
          }
        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.data.ProductId = '';
        vm.data.GoodsNm = '';
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.data.CareTktNm = res.CareTktNm;
          vm.data.CareTktId = res.KeyId;
          vm.data.CareTktUnitPrc = res.Price;

          if(vm.careTktIdTmp  == res.KeyId) {
            vm.data.CareTktUnitPrc = vm.careTktUnitPrcTmp;
          }
          changeTktAmt();
        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.data.CareTktId = '';
        vm.data.CareTktNm = '';
      }

      /**
       * 판매자 검색
       *
       * @param
       * @return
       */
      vm.srchSellerModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.SellerNm = res.UserNm;
          vm.data.SellerId = res.UserId;
        }, function(cancelData) {
        });
      }
      /**
       * 판매자 초기화
       *
       * @param
       * @return
       */
      vm.eraseSeller = function () {
        vm.data.SellerNm = '';
        vm.data.SellerId = '';
      }

      /**
       * 서포터 검색
       *
       * @param
       * @return
       */
      vm.srchSptUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.SptUserNm = res.UserNm;
          vm.data.SptUserId = res.UserId;
        }, function(cancelData) {
        });
      }
        /**
         * 서포터 초기화
         *
         * @param
         * @return
         */
      vm.eraseSptUser = function () {
        vm.data.SptUserNm = '';
        vm.data.SptUserId = '';
      }



      /**
       * 제품 금액 계산
       *
       * @param
       * @return
       */
      function changePrdAmt () {
        if(!isNullOrEmpty(vm.data.ProductQty)){
          vm.data.ProductAmt = vm.data.ProductUnitPrc * vm.data.ProductQty;
        } else {
          vm.data.ProductQty = 0;
          vm.data.ProductAmt = 0;
        }
      }

      /**
       * 관리권 금액 계산
       *
       * @param
       * @return
       */
      function changeTktAmt () {
        if(!isNullOrEmpty(vm.data.CareTktQty)){
          vm.data.CareTktAmt = vm.data.CareTktUnitPrc * vm.data.CareTktQty;
        } else {
          vm.data.CareTktQty = 0;
          vm.data.CareTktAmt = 0;
        }
      }

      function getCustId () {
        var data = vm.srchDetail;
        data.keyId = data.custId;
        data.mapCode = CUST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data.CustId = result.body.docs[0].KeyId;
              vm.CustomerNm = result.body.docs[0].CustNm;
            } else {
              vm.data.CustId = '';
              vm.CustomerNm = '';
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getCustId()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getCustId()");
          console.table(error);
        });
      }


      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      vm.getCustId = getCustId;

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제
      vm.changePrdAmt = changePrdAmt;
      vm.changeTktAmt = changeTktAmt;

      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cvssales:cvssalesktk-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 정산 목록
   */
  webapp.controller('CvsSalesTktListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CvsSalesTktListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Customer.getCustomerListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Customer.getCustomerList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Customer.getExcelList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cvssales.cvssalestkt-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cvssales.cvssalestkt-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.cvssales.cvssalestkt-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.cvssales.cvssalestkt-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.cvssales.cvssalestkt-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'custId'; // Primary Key Column
      var EXCEL_TITLE = '고객목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.PurchDtFrom = $rootScope.getDateFormat(vm.srch.PurchDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PurchDtTo = $rootScope.getDateFormat(vm.srch.PurchDtTo);
        vm.currentPage = vm.srch.page;
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      vm.keyId = $stateParams.custId;

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        if(isNullOrEmpty($stateParams.custId)) {
          gAlert("","고객을 선택해 주세요.");
          return;
        }
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            custId: $stateParams.custId
          }, {reload:EDIT_PAGE_URL});
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            custId: $stateParams.custId
          }, {reload:LIST_EDIT_PAGE_URL});
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            custId: paramKeyId,
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            custId: paramKeyId,
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if (item.ColumnPhysicalNm == 'LastVisitDate') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  }else if (item.ColumnPhysicalNm == 'CustRegDt') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.ProductNm = res.ProductNm;
          vm.srch.ProductId = res.ProductId;
        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.ProductId = '';
        vm.srch.ProductNm = '';
      }

      /**
       * 관리권 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.CareTktNm = res.CareTktNm;
          vm.srch.CareTktId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 관리권 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.srch.CareTktNm = '';
        vm.srch.CareTktId = '';
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = angular.copy(vm.srch);
        data.mapCode = DELETE_LIST_SQL;
        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dashboard:cafe24dashboard-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @description Controller of the Dashboard
   */
  webapp.controller('Cafe24dashboardCtrl',
    ['$window', '$rootScope', '$scope', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'postApi', 'gAlert', 'gConfirm', '$timeout', '$filter',
    function Cafe24dashboardCtrl($window, $rootScope, $scope, $state, $stateParams, CONSTANT, StaticVariable, postApi, gAlert, gConfirm, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'DataAnalysis.getAnalysisRfmcentroidsList';

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        srchTenantId: $rootScope.gVariable.srchTenantId // 검색 TenantId
      };

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = [{}, {}];
      vm.data = {cnt:[0, 0, 0, 0]};
      vm.listColumns = [];
      vm.totalItems = 0;
      vm.lists = [];
      vm.dataloader = false;  // Progressbar 숨김
      vm.chart = {};
      vm.chart.mixdata = [];
      vm.chart.mixlabels = [];
      vm.chart.mixdata2 = [];
      vm.chart.mixlabels2 = [];

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.GroupAndAction = vm.srch.DatagroupId + "." + vm.srch.ActionId; // for select UI

      (function Cafe24dashboardCtrl() {
        vm.dataloader = true; // Progressbar 표시

        getCount();

        getChart();
        // 초기 데이터 설정
        getDatagroupAndAction();
      })();

      function getDatagroupAndAction() {
        var srch = {};
        srch.mapCode = "MaDatagroup.getDatagroupAndAction";

        var prms = postApi.select(srch, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length == 0) {
              $rootScope.setGVariable('dataGroupId', '');
              $rootScope.setGVariable('dataActionId', '');
              $rootScope.setGVariable('dataGroupNm', '');
              $rootScope.setGVariable('dataActionNm', '');
            } else {
              var data = result.body.docs[0];
              $rootScope.setGVariable('dataGroupId', data.DatagroupId);
              $rootScope.setGVariable('dataActionId', data.ActionId);
              $rootScope.setGVariable('dataGroupNm', data.DatagroupNm);
              if (data.ActionId) {
                $rootScope.setGVariable('dataActionNm', data.ActionNm + ' (' + $filter('utcToLocal')(data.ABeginDate,'yyyy-MM-dd') + '~' + $filter('utcToLocal')(data.AEndDate,'yyyy-MM-dd') + ')');
              }

              vm.srch.DatagroupId = data.DatagroupId;
              vm.srch.ActionId = data.ActionId;
              vm.GroupAndAction = vm.srch.DatagroupId + "." + vm.srch.ActionId;
            }
          }

          // 목록 조회
          getList();
          getDataGroupAndActionList();
        }, function(error) {
          console.table(error);
        });
      }

      function getChart() {
        vm.chart.mixcolors = ['#45b7cd', '#ff8e72'];
        vm.chart.mixdatasetOverride = [
          {
            label: "Series A",
            type: 'line',
            yAxisID: 'y-axis-1'
          },
          {
            label: "Series B",
            type: 'line',
            yAxisID: 'y-axis-1'
          }
        ];

        vm.chart.options = {
          scales: {
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                display: true,
                position: 'left',
                scaleLabel: {
                  display: true,
                  labelString: '금액(백만원)'
                },
                ticks: {
                  beginAtZero: true,
                  userCallback: function(item) {
                    return $filter('number')(Math.round(item/1000000), 0);
                  },
                }
              }
            ]
          },
          elements: {
            point: {
              borderColor: '#45b7cd'
            },
            line: {
              fill: false,
              borderWidth: 1,
              borderColor: '#45b7cd',
              backgroundColor: '#45b7cd'
            }
          },
          tooltips: {
            callbacks : {
              label : function(tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || '';

                if (label) {
                  label += ': ';
                }

                if (tooltipItem.datasetIndex == 0 || tooltipItem.datasetIndex == 2)
                  label += $filter('numberWithCommas')(Math.round((tooltipItem.yLabel / 1000000 * 100) / 100));
                else
                  label += tooltipItem.yLabel;

                return label;
              }
            }
          },
          maintainAspectRatio: false
        };
      }

      function getCount() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = 'Cafe24.getCafe24DataCount';
        //vm.lists[num] = {};
        //vm.listColumns[num] = {};

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.cafe24data = result.body.docs[0];

            } else {
              // 데이터 조회 실패
              vm.cafe24data = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function getList() {
        console.log('getList()' + vm.srch.DatagroupId + ',' + vm.srch.ActionId);

        getChartData();
        getChartData2();
        getRfmList(0, 'rfmCluster3d');
        getRfmList(11, 'productTagWordCloud');

        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        var daId = vm.GroupAndAction.split('.');
        data.DatagroupId = daId[0];
        data.ActionId = daId[1];
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        //vm.lists[num] = {};
        //vm.listColumns[num] = {};

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docCnt;
              // 목록 데이터 표시
              vm.lists = result.body.docs;

            } else {
              vm.totalItems = 0;
              // 데이터 조회 실패
              vm.lists = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });

        getListCnt(data, 'DataAnalysis.getGoodsListFromSalesListCnt', 0);
        getListCnt(data, 'DataAnalysis.getCustomerListFromSalesListCnt', 1);
        getListCnt(data, 'DataAnalysis.getTotalSalesMonetary', 2);
        //getListCnt(data, 'DataAnalysis.getAnalysisRecommendListCnt', num, 3);
      }

      function getListCnt(data, mapCode, cntNo) {
        data.tableNm = null;
        data.mapCode = mapCode;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.data.cnt[cntNo] = result.body.docs[0];
            } else {
              // 데이터 조회 실패
              cnt = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getDataGroupAndActionList()");
          console.table(error);
        });
      }

      function getDataGroupAndActionList() {
        var data = {};
        data.selectType = 'List';
        data.mapCode = 'MaDatagroup.getDatagroupAndActionList';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.dagrouplists = result.body.docs;
            } else {
              // 데이터 조회 실패
              vm.dagrouplists = {};
            }
          }

          vm.dataloader = false;
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getDataGroupAndActionList()");
          console.table(error);

          vm.dataloader = false;
        });
      }

      function getChartData() {
        vm.chart.mixdata = [];

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        var daId = vm.GroupAndAction.split('.');
        data.DatagroupId = daId[0];
        data.ActionId = daId[1];
        data.mapCode = 'DataAnalysis.getStatisticsMonthlySales';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              var list = result.body.docs;
              angular.forEach(list, function(item, index) {
                vm.chart.mixdata[index] = item.PaymentTotal;
                vm.chart.mixlabels[index] = item.DT;
              });

            } else {
              // 데이터 조회 실패
              vm.chart.mixdata = [];
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      function getChartData2() {
        //        vm.daily.mixdata = new Array(new Array(size), new Array(size));
        vm.chart.mixdata2 = [];

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        var daId = vm.GroupAndAction.split('.');
        data.DatagroupId = daId[0];
        data.ActionId = daId[1];
        data.mapCode = 'DataAnalysis.getStatisticsWeeklySales';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              var list = result.body.docs;
              angular.forEach(list, function(item, index) {
                vm.chart.mixdata2[index] = item.PaymentTotal;
                vm.chart.mixlabels2[index] = item.DT;
              });

            } else {
              // 데이터 조회 실패
              vm.chart.mixdata2 = [];
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function getRfmList(divIdNum, resultType) {
        var data = angular.copy(vm.srch);

        data.tableNm = null;
        data.selectType = null;
        data.ResultType = resultType;
        data.mapCode = 'DataAnalysis.getMaExeResult';

        postApi.select(data, function (result) {
        //postApi.sendPostApi('api/dataanalysis', 'getRfmList', data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.rfmlist = binary2text(result.body.docs[0].ResultContents);
              $('#regTitle' + divIdNum).html(vm.rfmlist);
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getDataGroupAndActionList()");
          console.table(error);
        });
      }

      vm.getList = getList;

      // end of body
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dashboard:dashboard-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @description Controller of the Dashboard
   */
  webapp.controller('DashboardCtrl',
    ['$window', '$rootScope', '$scope', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'postApi', 'gAlert', 'gConfirm', '$timeout',
    function DashboardCtrl($window, $rootScope, $scope, $state, $stateParams, CONSTANT, StaticVariable, postApi, gAlert, gConfirm, $timeout) {
      $state.go("app.survey-dashboard", {srch: ""}, {reload: "app.survey-dashboard"});
      return false;
      
      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_NOTICE_SQL = 'Dashboard.getNoticeList';              // 공지사항 목록 조회 SQL
      var LIST_VISITPATH_SQL = 'Dashboard.getVisitPathList';        // 신규고객분석 조회 SQL
      var LIST_RESERV_SQL = 'Dashboard.getReservList';              // 고객예약현황 조회 SQL
      var LIST_HAPPYCALL_SQL = 'Dashboard.getHappyCallList';        // 해피콜 조회 SQL
      var LIST_STOCK_SQL = 'Dashboard.getStockList';                // 재고/발주 조회 SQL
      var LIST_NETINCOME_SQL = 'Dashboard.getThisMonthNetIncome';   // 예약현황 - 당월 순이익 조회 SQL
      var LIST_CARETKT_SQL = 'Dashboard.getCareTkt';                // 예약현황 - 티켓팅(관리권) 조회 SQL
      var LIST_SALESAMT_SQL = 'Dashboard.getSalesAmt';              // 예약현황 - 판매매출 조회 SQL
      var LIST_RETICKETINGCUST_SQL = 'Dashboard.getReTicketingCust';// 당월 재티켓팅 대상고객

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.customer.customer-list'; // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.customer.customer-list.edit.tab1';    // 목록 등록/수정 화면
      var EDIT_PAGE_URL = 'app.customer.customer-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Customer'; // 작업 테이블명
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: 'CustRegDt', // 정렬컬럼명
        srchTenantId: $rootScope.gVariable.srchTenantId, // 검색 TenantId
        selectType: 'List',
        srchColumn: 'Mobile', // 검색 대상 컬럼
        srchValue: '', // 검색 값
        Mobile: '',
        CustNm: '',
        srchKeyword: ''
      };


      // 고객예약현황
      vm.reservDateBase = moment().toDate();
      vm.reservDate = moment().format("YYYY-MM-DD");

      (function DashboardCtrl() {

      })();

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {

        if (vm.srch.srchColumn == "Mobile") {
          vm.srch.Mobile = vm.srch.srchValue;
        } else {
          vm.srch.CustNm = vm.srch.srchValue;
        }

        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function eraseSrchValue() {
        vm.srch.srchValue = "";
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = ''; // 검색 옵션

        // 등록/수정 화면 이동
        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: ''
        });
      }

      /**
       * 공지사항 조회
       *
       * @param
       * @return
       */
      function getNoticeList() {
        vm.dataloader = true; // Progressbar 표시

        var data = {
          selectType: 'List',
          mapCode: LIST_NOTICE_SQL
        };                 // 검색 옵션 설정

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.listsNotice = result.body.docs;

            } else {
              // 데이터 조회 실패
              vm.listsNotice = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getNoticeList()");
          console.table(error);

        });
      }

      /**
       * 공지사항 조회 화면 이동
       * @param
       * @return
       */
      function goViewNotice(paramKeyId) {

        // 공지사항 조회 화면 이동
        $state.go('app.bbspost.h0102-list.detail', {
          srch: '',
          BbsPostId: paramKeyId,
          BbsMasterId: '1'
        });
      }


      /**
       * 신규고객분석 조회
       *
       * @param
       * @return
       */
      function getVisitPathList() {
        vm.dataloader = true; // Progressbar 표시

        var data = {
          selectType: 'List',
          mapCode: LIST_VISITPATH_SQL
        };                 // 검색 옵션 설정

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.listsVisitPath = result.body.docs[0];

            } else {
              // 데이터 조회 실패
              vm.listsVisitPath = {
                BaseYM: ''
                , VNULL: 0
                , V100: 0
                , V200: 0
                , V300: 0
                , V400: 0
                , V500: 0
                , Total: 0
              };
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getVisitPathList()");
          console.table(error);

        });
      }

      /**
       * 고객예약현황 기준일 변경
       *
       * @param dayType - 날짜 증/감유형
       * @return
       */
      function setReservDate(dayType) {

        if (dayType == "A") {
          vm.reservDateBase = moment(vm.reservDate).add(1, 'd').toDate();
        } else if (dayType == "S") {
          vm.reservDateBase = moment(vm.reservDate).subtract(1, 'd').toDate();
        } else {
          vm.reservDateBase = moment(dayType).toDate();
        }

        vm.reservDate = moment(vm.reservDateBase).format("YYYY-MM-DD");

        // 조회
        getReservList();
      }

      /**
       * 고객예약현황 조회
       *
       * @param
       * @return
       */
      function getReservList() {
        vm.dataloader = true; // Progressbar 표시

        var data = {
          selectType: 'List',
          mapCode: LIST_RESERV_SQL,
          reservDate: vm.reservDate
        };                 // 검색 옵션 설정

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.listsReserv = result.body.docs;

            } else {
              // 데이터 조회 실패
              vm.listsReserv = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getReservList()");
          console.table(error);

        });
      }

      /**
       * 해피콜 조회
       *
       * @param
       * @return
       */
      function getHappyCallList() {
        vm.dataloader = true; // Progressbar 표시

        var data = {
          selectType: 'List',
          mapCode: LIST_HAPPYCALL_SQL
        };                 // 검색 옵션 설정

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.listsHappyCall = result.body.docs[0];

            } else {
              // 데이터 조회 실패
              vm.listsHappyCall = {
                BatchDate: ''
                , PreVisit: 0
                , MngAft3Days: 0
                , MngAft7Days: 0
                , ExpectLeaveCust: 0
              };
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getHappyCallList()");
          console.table(error);

        });
      }

      /**
       * 재고/발주 조회
       *
       * @param
       * @return
       */
      function getStockList() {
        vm.dataloader = true; // Progressbar 표시

        var data = {
          selectType: 'List',
          mapCode: LIST_STOCK_SQL
        };                 // 검색 옵션 설정

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.listsStock = result.body.docs;

            } else {
              // 데이터 조회 실패
              var obj = {
                GoodsNo: ''
                , GoodsNm: ''
                , TotalStock: 0
                , OrderAmt: ''
              };

              vm.listsStock.push(obj);
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getStockList()");
          console.table(error);

        });
      }

      /**
       * 예약현황 - 당월 순이익
       *
       * @param
       * @return
       */
      function getThisMonthNetIncome() {
        vm.dataloader = true; // Progressbar 표시

        var data = {
          selectType: 'List',
          mapCode: LIST_NETINCOME_SQL
        };                 // 검색 옵션 설정

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.listsThisMonthNetIncome = result.body.docs[0];

            } else {
              // 데이터 조회 실패
              vm.listsThisMonthNetIncome = {
                PrevTotNetIncome: 0
                , ThisTotNetIncome: 0
                , RateChange: 0
                , WorkingDays: 0
              };
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getThisMonthNetIncome()");
          console.table(error);

        });
      }

      /**
       * 예약현황 - 티켓팅(관리권)
       *
       * @param
       * @return
       */
      function getCareTkt() {
        vm.dataloader = true; // Progressbar 표시

        var data = {
          selectType: 'List',
          mapCode: LIST_CARETKT_SQL
        };                 // 검색 옵션 설정

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.listsCareTkt = result.body.docs[0];

            } else {
              // 데이터 조회 실패
              vm.listsCareTkt = {
                CareTktNewAmt: 0
                , CareTktOldAmt: 0
                , TotCareTktAmt: 0
              };
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getCareTkt()");
          console.table(error);

        });
      }

      /**
       * 예약현황 - 판매매출
       *
       * @param
       * @return
       */
      function getSalesAmt() {
        vm.dataloader = true; // Progressbar 표시

        var data = {
          selectType: 'List',
          mapCode: LIST_SALESAMT_SQL
        };                 // 검색 옵션 설정

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.listsSalesAmt = result.body.docs[0];

            } else {
              // 데이터 조회 실패
              vm.listsSalesAmt = {
                SalesNewAmt: 0
                , SalesOldAmt: 0
                , TotSalesAmt: 0
              };
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getSalesAmt()");
          console.table(error);

        });
      }

      /**
       * 당월 재티켓팅 대상고객
       *
       * @param
       * @return
       */
      function getReTicketingCust() {
        vm.dataloader = true; // Progressbar 표시

        var data = {
          selectType: 'List',
          mapCode: LIST_RETICKETINGCUST_SQL
        };                 // 검색 옵션 설정

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.listsReticketingCust = result.body.docs[0];

            } else {
              // 데이터 조회 실패
              vm.listsReticketingCust = {
                CompleteCustCnt: 0
                , IncompleteCustCnt: 0
              };
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getReTicketingCust()");
          console.table(error);

        });
      }

      /**
       * 고객예약현황 날짜 클릭시 DatePicker 보여주기
       *
       * @param
       * @return
       */
      vm.showReservDatePicker = function() {
        console.log("click")
        $timeout(function(){
          $("#reservDateBaseWrap .input-group .input-group-btn").find("button").click();
        });
      };

      // 함수 정의
      vm.getSearch = getSearch;                           // 연락처/고객명 검색
      vm.eraseSrchValue = eraseSrchValue;                 // 검색값 초기화
      vm.goAdd = goAdd;                                   // 신규등록 화면 이동
      vm.getNoticeList = getNoticeList;                   // 공지사항 목록 조회
      vm.goViewNotice = goViewNotice;                     // 공지사항 조회
      vm.getVisitPathList = getVisitPathList;             // 신규고객분석 조회
      vm.setReservDate = setReservDate;                   // 고객예약 기준일 변경
      vm.getReservList = getReservList;                   // 고객예약현황 조회
      vm.getHappyCallList = getHappyCallList;             // 해피콜 조회
      vm.getStockList = getStockList;                     // 재고/발주 조회
      vm.getThisMonthNetIncome = getThisMonthNetIncome;   // 예약현황 - 당월 순수익 조회
      vm.getCareTkt = getCareTkt;                         // 예약현황 - 티켓팅(관리권) 조회
      vm.getSalesAmt = getSalesAmt;                       // 예약현황 - 판매매출 조회
      vm.getReTicketingCust = getReTicketingCust;         // 당월 재 티켓팅 대상고객

      // 조회
      getNoticeList();
      getVisitPathList();
      getReservList();
      getHappyCallList();
      getStockList();
      getThisMonthNetIncome();
      getCareTkt();
      getSalesAmt();
      getReTicketingCust();

      // end of body
    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.dashboard', {
      url : '/dashboard',
      templateUrl: 'app/dashboard/dashboard.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.cafe24dashboard', {
      url : '/cafe24dashboard',
      templateUrl: 'app/dashboard/cafe24dashboard.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.survey-dashboard', {
      url: '/survey-dashboard/:srch',
      templateUrl: 'app/dashboard/survey-dashboard.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    });
  }
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dashboard:dashboard-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @description Controller of the Dashboard
   */
  webapp.controller('WjmDashboardCtrl',
    ['$window', '$rootScope', '$scope', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'postApi', 'gAlert', 'gConfirm', '$timeout', 'modalFactory', '$filter',
      function WjmDashboardCtrl($window, $rootScope, $scope, $state, $stateParams, CONSTANT, StaticVariable, postApi, gAlert, gConfirm, $timeout, modalFactory, $filter) {
        // #region 상수 정의

        // SQL Mapper Id 정의
        var LIST_SURVEY_SQL = 'WjmDashboard.getSurveyList'; // 목록 조회 SQL
        var LIST_CNT_SQL = 'WjmDashboard.getProjectListCnt'; // 목록 건수 조회 SQL
        var LIST_SQL = 'WjmDashboard.getProjectList';    // 목록 조회 SQL
        var DELETE_LIST_SQL = 'WjmDashboard.deleteProjectList'; // 목록에서 삭제
        var LIST_COUNSELOR_SQL = 'WjmDashboard.getCounselorList';

        // 관련 화면 정의
        var LIST_PAGE_URL = 'app.survey-dashboard'; // 목록 화면
        //var LIST_EDIT_PAGE_URL = 'app.survey.survey-list.edit'; // 목록 등록/수정 화면
        var EDIT_PAGE_URL = 'app.survey.survey-edit'; // 등록/수정 화면

        // 관련 테이블 정의
        var KEY_TABLE_NM = 'wjm.dashboard.project'; // 작업 테이블명
        // #endregion 상수 정의

        var vm = this;          // View Model
        vm.dataloader = false;  // Progressbar 숨김

        // 검색 옵션 설정
        if (!$stateParams.srch) {
          vm.srch = {
            page: 1, // 현재 조회 페이지 번호
            viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
            tableNm: KEY_TABLE_NM,  // 작업 테이블명
            sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
            sortColumn: 'RegDate'          // 정렬컬럼명
          };
        } else {
          vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
          //vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
          vm.currentPage = vm.srch.page;
          vm.SvyBeginDate = $rootScope.getDateFormat(vm.srch.SvyBeginDate);
          vm.SvyEndDate = $rootScope.getDateFormat(vm.srch.SvyEndDate);
        }

        vm.srch.loginComUserId = $window.sessionStorage['loginComUserId'];
        vm.srch.loginCounselorCode = $window.sessionStorage['loginCounselorCode'];

        vm.srch2 = {};
        vm.srchList = {};
        vm.columnMap = {};
        angular.copy(vm.srch, vm.srchList);
        vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
        vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

        //vm.userType = $window.sessionStorage["loginUserType"];
        vm.userNm = $window.sessionStorage["loginUserName"];
        vm.userIdx = $window.sessionStorage["loginUserIdx"];
        vm.userId = $window.sessionStorage["loginUserId"];
        //console.log("$window.sessionStorage", $window.sessionStorage);

        // 차트관련
        vm.chart = {};
        vm.chart.series1 = [];
        vm.chart.series2 = [];
        vm.chart.series3 = [];
        vm.chart.series4 = [];
        vm.chart.data1 = [];
        vm.chart.data2 = [];
        vm.chart.data3 = [];
        vm.chart.data4 = [];
        vm.chart.labels1 = [];
        vm.chart.labels2 = [];
        vm.chart.labels3 = [];
        vm.chart.labels4 = [];

        // 업체 검색
        vm.srchUserModal = function () {
          var ctrl = 'WjmUserModalCtrl as modalCtrl';
          var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
          var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);

          modalInstance.result.then(function (okData) {
            vm.srch.ManagerNm = okData.UserNm;
            vm.srch.Manager = okData.UserId;
          }, function (cancelData) {
            // 취소
          });
        };
        vm.eraseUser = function () {
          vm.srch.ManagerNm = "";
          vm.srch.Manager = "";
        };

        /**
         * 업체 대시보드이미지 조회
         *
         * @param
         * @return
         */
        function getDashImg() {
          var data = {};
          data.tableNm = "users";
          data.TableId = vm.userIdx;
          data.grpId = "2";
          data.mapCode = 'FileAttach.getFileListOri';

          postApi.select(data, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.dashImgSrc = StaticVariable.getUrl('/attach/file/' + result.body.docs[0].PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey);
              }
            }
          }, function (error) {
            console.error("Error> getDashImg()");
            console.table(error);
          });
        }

        /**
         * 설문 조회
         *
         * @param
         * @return
         */
        function getSvyList() {
          vm.dataloader = true; // Progressbar 표시

          var data = angular.copy(vm.srch);
          data.mapCode = LIST_SURVEY_SQL;

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                // 목록 데이터 표시
                vm.svyLists = result.body.docs;

              } else {
                // 데이터 조회 실패
                vm.svyLists = {};
              }
            }

            vm.dataloader = false; // Progressbar 숨김

          }, function (error) {
            vm.dataloader = false; // Progressbar 숨김

            // 조회 중 오류 발생
            console.error("Error> getSvyData()");
            console.table(error);
          });
        }

        /**
         * 상담사별 상담건수 조회
         *
         * @param
         * @return
         */
        function getCounselorList() {
          vm.dataloader = true; // Progressbar 표시

          var data = angular.copy(vm.srch);
          data.mapCode = LIST_COUNSELOR_SQL;
          data.roleType = vm.roleType;

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                // 목록 데이터 표시
                vm.counselorLists = result.body.docs;
              } else {
                // 데이터 조회 실패
                vm.counselorLists = {};
              }
            }

            vm.dataloader = false; // Progressbar 숨김

          }, function (error) {
            vm.dataloader = false; // Progressbar 숨김

            // 조회 중 오류 발생
            console.error("Error> getSvyData()");
            console.table(error);
          });
        }

        /**
         * 프로젝트 검색
         * @param
         * @return
         */
        function getSearch() {
          // 검색 옵션
          var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

          // 데이터 조회
          $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
        }

        /**
         * 프로젝트 검색값 초기화
         * @param
         * @return
         */
        function setResetSearch() {
          $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
        }

        /**
         * 프로젝트 목록 건수 조회
         *
         * @param
         * @return
         */
        function getListCnt() {

          var data = angular.copy(vm.srch); // 검색 옵션 설정

          data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
          data.roleType = vm.roleType;

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                // 총 목록 건수 설정
                vm.totalItems = result.body.docs;
              } else {
                // 조회 실패
                vm.totalItems = 0;
              }
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> getListCnt()");
            console.table(error);
          });
        }

        /**
         * 프로젝트 목록 조회
         *
         * @param
         * @return
         */
        function getList() {
          vm.dataloader = true; // Progressbar 표시
          vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

          getListCnt(); // 목록 건수 조회

          var data = angular.copy(vm.srch); // 검색 옵션 설정
          data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
          data.mapCode = LIST_SQL;
          data.roleType = vm.roleType;

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              // MetaColumn 사용
              if (result.body.desc.length > 0) {
                // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
                vm.listColumns = result.body.desc;

                angular.forEach(vm.listColumns, function (item) {
                  vm.columnMap[item.ColumnPhysicalNm] = item;
                });
              } else {
                console.error('Error> getList()> MetaColumn 정보 조회 오류');
                console.table(data);
              }

              if (result.body.docs.length > 0) {
                // 목록 데이터 표시
                vm.lists = result.body.docs;
                /*
                vm.lists.forEach(function(item) {
                  item.No = vm.totalItems - item.rowNum + 1;
                });
                */

                // 목록 화면 구성
                setResponsive();
              } else {
                // 데이터 조회 실패
                vm.lists = {};
              }
            }

            vm.dataloader = false; // Progressbar 숨김
            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }, function (error) {
            vm.dataloader = false; // Progressbar 숨김

            // 조회 중 오류 발생
            console.error("Error> getList()");
            console.table(error);

          });
        }

        /**
         * 목록 화면 구성
         *
         * @param
         * @return
         */
        function setResponsive() {
          var columns = [];
          var o = {};

          o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
          o.type = [];
          o.style = [];

          var index = 0;
          angular.forEach(vm.listColumns, function (item) {
            var column = {};

            column.name = item.ColumnPhysicalNm; // 물리 컬럼명
            column.title = item.ColumnLogicalNm; // 논리 컬럼명

            if (o.breakpoints[index] != "") {
              column.breakpoints = setBreakPoint(o.breakpoints[index]);
            }

            if (item.ColumnPhysicalDataType == "40") {
              // 날짜형 데이터 처리
              column.type = "date";
              column.formatString = "YYYY-MM-DD";
            }

            index++;
            columns.push(column);
          });
        }

        /**
         * 페이지 변경시 데이터 조회
         * @param
         * @return
         */
        function setPageChanged() {
          vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

          // 검색 옵션
          var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          // 해당 페이지 데이터 조회
          $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
        }

        /**
         * 목록 당 조회 건수 변경
         * @param
         * @return
         */
        function setChangeViewSize() {
          vm.currentPage = 1; // 1페이지 부터 조회
          vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

          // 데이터 조회
          getSearch();
        }

        /**
         * 정렬 컬럼 설정
         *
         * @param {string} sortColumn  - 정렬 컬럼명
         * @param {string} isSortable - 정렬가능 여부
         * @return
         */
        function setSortColumn(sortColumn, isSortable) {

          // 정렬이 불가한 컬럼은 미 반영
          if (isSortable == 'N') return;

          // 정렬순서(오름차순, 내림차순) 설정
          if (vm.srch.sortColumn != sortColumn) {
            vm.srch.sortDirect = "ASC";
          } else {
            vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
          }

          vm.srch.sortColumn = sortColumn;

          // 조회
          getSearch();
        }

        /**
         * 정렬 컬럼 설정에 따른 Grid header Icon 표시
         *
         * @param {string} sortColumn  - 정렬 컬럼명
         * @return
         */
        function setSortDirect(sortColumn) {
          // 정렬이 되지 않은 컬럼 표시
          if (sortColumn != vm.srch.sortColumn) {
            return 'fa fa-sort';
          }

          var rtnval = '';

          // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
          if (vm.srch.sortDirect == 'ASC') {
            rtnval = 'fa fa-caret-down';
          } else {
            rtnval = 'fa fa-caret-up';
          }
          return rtnval;
        }

        /**
         * 신규 추가 - 등록/수정 화면 이동
         * @param
         * @return
         */
        function goAdd() {
          //var srch = $stateParams.srch; // 검색 옵션
          //vm.keyId = '';

          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: [],
            keyId: '',
            cKeyId: ''
          });
        }

        /**
         * 설문 목록 화면 이동
         *
         * @param
         * @return
         */
        function goSvyList(svyStatus) {
          $rootScope.gVariable.layoutBoard = "N"; // 타메뉴 조회로 바로 접근하기때문에 분할상태인경우 UI가 정상적이지 않아 기본으로 강제변경

          var srch = {
            page: 1,
            viewSize: 25,
            keyId: "",
            tableNm: "wjm.survey",
            //srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId,
            SvyStatus: svyStatus
          };

          $state.go("app.survey.survey-list", {srch: encodeURIComponent(JSON.stringify(srch, replacer))});
        }

        /**
         * 조회 화면 이동
         *
         * @param
         * @return
         */
        function goView(colNm, li) {
          $rootScope.gVariable.layoutBoard = "N"; // 타메뉴 조회로 바로 접근하기때문에 분할상태인경우 UI가 정상적이지 않아 기본으로 강제변경

          //console.log("colNm", colNm);
          //console.log("li", li);
          if (vm.roleType != "ADM") return;

          var srch = {
            page: 1,
            viewSize: 25,
            //keyId: '',
            tableNm: ''
          };

          switch (colNm) {
            case "ManagerNm":
              srch.tableNm = "wjm.client";

              if (!isNullOrEmpty(li.Manager)) {
                $state.go("app.survey.client-edit", {
                  srch: encodeURIComponent(JSON.stringify(srch, replacer)),
                  keyId: li.Manager
                });
              }
              break;

            case "SvyNm":
              srch.tableNm = "wjm.surveyresult";

              if (!isNullOrEmpty(li.KeyId)) {
                $state.go("app.survey.result-detail", {
                  srch: encodeURIComponent(JSON.stringify(srch, replacer)),
                  keyId: li.KeyId
                });
              }
              break;

            case "RespNewCnt":
              srch.tableNm = "wjm.targetresult";
              srch.RespNew = "Y";
              srch.SvyId = li.KeyId;
              srch.SvyNm = li.SvyNm;
              srch.RespStatus = "R";

              var today = moment(new Date()).add(-1,"d").format('YYYY-MM-DD');
              srch.RespBeginDate = today;
              srch.RespEndDate = today;

              if (!isNullOrEmpty(li.KeyId)) {
                $state.go("app.survey.target-result-list", {
                  srch: encodeURIComponent(JSON.stringify(srch, replacer))
                });
              }
              break;

            case "SendCnt":
              srch.tableNm = "wjm.surveytarget";
              srch.SvyId = li.KeyId;
              srch.SvyNm = li.SvyNm;

              if (!isNullOrEmpty(li.KeyId)) {
                $state.go("app.survey.survey-send-result-list", {
                  srch: encodeURIComponent(JSON.stringify(srch, replacer))
                });
              }
              break;

            default: break;
          }
        }

        /**
         * 프로젝트 목록 삭제 확인
         * @param
         * @return
         */
        function setDelList() {
          gConfirm('', '선택한 정보를 삭제하시겠습니까?', {
            btn: '',
            fn: function () {
              setDelListAction();
            }
          }, {
            btn: '',
            fn: function () {
            }
          });
        }

        /**
         * 프로젝트 목록 삭제
         * @param
         * @return
         */
        function setDelListAction() {
          vm.srch.KeyIdList = [];

          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].chkRow) {
              vm.srch.KeyIdList.push(vm.lists[i].KeyId);
            }
          }

          if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
            gAlert('', 'Menu.DELETENODATA');
            return false;
          }

          var data = vm.srch;
          data.mapCode = DELETE_LIST_SQL;

          postApi.update(data, function (result) {
            //if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
            //}
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> setDelListAction()");
            console.table(error);
          });
        }

        /**
         * 차트: 진단 진행(건수별) 추이
         * @param
         * @return
         */
        function getChartData1() {
          var list = [];
          var dt = [];
          var data = angular.copy(vm.srch);

          data.SvyId = vm.srch2.SurveyId;
          data.mapCode = 'WjmDashboard.getChart1';
          vm.chart.series1 = [];
          vm.chart.data1 = [];
          vm.chart.labels1 = [];

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {

              // 임시데이터
              /*
              list.push({ data: "80", series: "위너스제이엠", labels: "2020-04-01" });
              list.push({ data: "40", series: "위너스제이엠", labels: "2020-04-02" });
              list.push({ data: "60", series: "위너스제이엠", labels: "2020-04-03" });
              list.push({ data: "20", series: "제이엠커리어", labels: "2020-04-01" });
              list.push({ data: "25", series: "제이엠커리어", labels: "2020-04-02" });
              list.push({ data: "30", series: "제이엠커리어", labels: "2020-04-03" });
              list.push({ data: "15", series: "외부진단", labels: "2020-04-01" });
              list.push({ data: "90", series: "외부진단", labels: "2020-04-02" });
              list.push({ data: "100", series: "외부진단", labels: "2020-04-03" });
              result.body.docs.length = list.length;
              */

              if (result.body.docs.length > 0) {
                // 목록 데이터 표시
                list = result.body.docs;

                // 차트 설정
                vm.chart.mixdatasetOverride1 = [{ type: 'line', yAxisID: 'y-axis-1' }];
                vm.chart.options1 = {
                  legend: { display: true },
                  responsive: true,
                  scales: {
                    yAxes: [{ id: 'y-axis-1', type: 'linear', display: true, position: 'left', ticks: { beginAtZero: true} }]
                  },
                  maintainAspectRatio: false
                };

                // series, labels 데이터 생성
                angular.forEach(list, function(item, index) {
                  if (index == 0) {
                    vm.chart.series1.push(item.series);
                    vm.chart.labels1.push(item.labels);
                  }
                  else {
                    if (vm.chart.series1.indexOf(item.series) == -1) vm.chart.series1.push(item.series);
                    if (vm.chart.labels1.indexOf(item.labels) == -1) vm.chart.labels1.push(item.labels);
                  }
                });

                // data 데이터 생성
                angular.forEach(vm.chart.series1, function(item, index) {
                  dt = $filter('filter')(list, {series: item}, true);
                  vm.chart.data1[index] = [];

                  angular.forEach(dt, function(item2, index2) {
                    vm.chart.data1[index][index2] = item2.data;
                  });
                });

                //console.log("vm.chart.series1", vm.chart.series1);
                //console.log("vm.chart.labels1", vm.chart.labels1);
                //console.log("vm.chart.data1", vm.chart.data1);
                //console.log("list", list);
              } else {
                // 데이터 조회 실패
                vm.chart.data1 = [];
              }
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> getChartData1()");
            console.table(error);
          });
        }

        /**
         * 차트: 진단 진행(타입별) 추이
         * @param
         * @return
         */
        function getChartData2() {
          var list = [];
          var dt = [];
          var data = angular.copy(vm.srch);

          data.mapCode = 'WjmDashboard.getChart2';
          vm.chart.series2 = [];
          vm.chart.data2 = [];
          vm.chart.labels2 = [];

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {

              // 임시데이터
              /*
              list.push({ data: "80", series: "위너스제이엠", labels: "스트레스 진단" });
              list.push({ data: "40", series: "위너스제이엠", labels: "직장내 괴롭힘" });
              list.push({ data: "30", series: "제이엠커리어", labels: "스트레스 진단" });
              list.push({ data: "55", series: "제이엠커리어", labels: "직장내 괴롭힘" });
              list.push({ data: "15", series: "외부진단", labels: "스트레스 진단" });
              list.push({ data: "90", series: "외부진단", labels: "직장내 괴롭힘" });
              result.body.docs.length = list.length;
              */

              if (result.body.docs.length > 0) {
                // 목록 데이터 표시
                list = result.body.docs;

                // 차트 설정
                vm.chart.mixdatasetOverride2 = [{ type: 'bar', yAxisID: 'y-axis-1' }];
                vm.chart.options2 = {
                  legend: { display: true },
                  responsive: true,
                  scales: {
                    yAxes: [{ id: 'y-axis-1', type: 'linear', display: true, position: 'left', ticks: { beginAtZero: true} }]
                  },
                  maintainAspectRatio: false
                };

                // series, labels 데이터 생성
                angular.forEach(list, function(item, index) {
                  if (index == 0) {
                    vm.chart.series2.push(item.series);
                    vm.chart.labels2.push(item.labels);
                  }
                  else {
                    if (vm.chart.series2.indexOf(item.series) == -1) vm.chart.series2.push(item.series);
                    if (vm.chart.labels2.indexOf(item.labels) == -1) vm.chart.labels2.push(item.labels);
                  }
                });

                // data 데이터 생성
                angular.forEach(vm.chart.series2, function(item, index) {
                  dt = $filter('filter')(list, {series: item}, true);
                  vm.chart.data2[index] = [];

                  angular.forEach(dt, function(item2, index2) {
                    vm.chart.data2[index][index2] = item2.data;
                  });
                });

                //console.log("vm.chart.series2", vm.chart.series2);
                //console.log("vm.chart.labels2", vm.chart.labels2);
                //console.log("vm.chart.data2", vm.chart.data2);
                //console.log("list", list);
              } else {
                // 데이터 조회 실패
                vm.chart.data2 = [];
              }
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> getChartData2()");
            console.table(error);
          });
        }

        /**
         * 차트: 진단 인원 증가 추이
         * @param
         * @return
         */
        function getChartData3() {
          var list = [];
          var dt = [];
          var data = angular.copy(vm.srch);

          data.mapCode = 'WjmDashboard.getChart3';
          data.roleType = vm.roleType;

          vm.chart.series3 = [];
          vm.chart.data3 = [];
          vm.chart.labels3 = [];

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {

              // 임시데이터
              /*
              list.push({ data: "20", series: "스트레스진단", labels: "2020-04-01" });
              list.push({ data: "30", series: "스트레스진단", labels: "2020-04-02" });
              list.push({ data: "50", series: "스트레스진단", labels: "2020-04-03" });
              list.push({ data: "25", series: "직장내괴롭힘", labels: "2020-04-02" });
              list.push({ data: "60", series: "직장내괴롭힘", labels: "2020-04-02" });
              list.push({ data: "40", series: "직장내괴롭힘", labels: "2020-04-03" });
              result.body.docs.length = list.length;
              */

              if (result.body.docs.length > 0) {
                // 목록 데이터 표시
                list = result.body.docs;

                // 차트 설정
                vm.chart.mixdatasetOverride3 = [{ type: 'line', yAxisID: 'y-axis-1' }];
                vm.chart.options3 = {
                  legend: { display: true },
                  responsive: true,
                  scales: {
                    yAxes: [{ id: 'y-axis-1', type: 'linear', display: true, position: 'left', ticks: { beginAtZero: true} }]
                  },
                  maintainAspectRatio: false
                };

                // series, labels 데이터 생성
                angular.forEach(list, function(item, index) {
                  if (index == 0) {
                    vm.chart.series3.push(item.series);
                    vm.chart.labels3.push(item.labels);
                  }
                  else {
                    if (vm.chart.series3.indexOf(item.series) == -1) vm.chart.series3.push(item.series);
                    if (vm.chart.labels3.indexOf(item.labels) == -1) vm.chart.labels3.push(item.labels);
                  }
                });

                // data 데이터 생성
                angular.forEach(vm.chart.series3, function(item, index) {
                  dt = $filter('filter')(list, {series: item}, true);
                  vm.chart.data3[index] = [];

                  angular.forEach(dt, function(item2, index2) {
                    vm.chart.data3[index][index2] = item2.data;
                  });
                });

                /*
                console.log("vm.chart.series3", vm.chart.series3);
                console.log("vm.chart.labels3", vm.chart.labels3);
                console.log("vm.chart.data3", vm.chart.data3);
                console.log("list", list);
                */
              } else {
                // 데이터 조회 실패
                vm.chart.data3 = [];
              }
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> getChartData3()");
            console.table(error);
          });
        }

        /**
         * 초기데이터 설정
         * @param
         * @return
         */
        function init() {

          // 목록 체크박스 로직 설정
          vm.chkHead = false;
          $scope.chkRowChg = function () {
            for (var i = 0; i < vm.lists.length; i++) {
              if (!vm.lists[i].isChecked) {
                vm.chkHead = false;
                return;
              }
            }
            vm.chkHead = true;
          };

          $scope.chkHeadChg = function () {
            for (var i = 0; i < vm.lists.length; i++) {
              if (vm.lists[i].SvyStatusCd == "1") vm.lists[i].chkRow = vm.chkHead;
            }
          };
        }

        /**
         * 사용자 역할 조회
         * @param
         * @return
         */
        function getRoleType() {
          var data = {};
          vm.dataloader = true;
          data.mapCode = "WjmSystem.getRoleType";

          postApi.select(data, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              vm.dataloader = false;

              if (result.body.docs.length > 0) {
                // 조회 데이터 설정
                vm.roleType = result.body.docs[0].RoleType;

                getList();

                // 관리자인 경우
                if (vm.roleType == "ADM") {
                  getSvyList();
                  getChartData1();
                  getChartData2();
                }
                // 상담사 or 업체인 경우
                else {
                  getCounselorList();
                  getChartData3();
                  getChartData4();
                }
              } else {
              }
            } else {
              vm.dataloader = false;
              console.error("Error> getRoleType()");

              if (!isNullOrEmpty(result.body.docs)) {
                gAlert('', result.body.docs[0].errMessage);
              }
            }
          }, function (error) {
            console.error("Error> getRoleType()");
            console.table(error);
          });
        }

        // 설문 검색
        vm.srchSurveyModal = function () {
          var ctrl = 'WjmSurveyModalCtrl as modalCtrl';
          var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

          var modalInstance = modalFactory.open('md', 'components/modal/survey/wjm-survey-modal.html', ctrl, paramData);
          modalInstance.result.then(function(res) {
            vm.srch2.SurveyNm = res.SvyNm;
            vm.srch2.SurveyId = res.SvyId;
            getChartData1();
          }, function(cancelData) {
          });
        };
        vm.eraseSurvey = function () {
          vm.srch2.SurveyId = '';
          vm.srch2.SurveyNm = '';
          getChartData1();
        };

        /* ------------------------------------------------ 분산 그래프 관련 소스 (시작) -------------------------------------------------- */
        function createTextCanvas(text, color, font, size) {
          size = size || 16;
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          var fontStr = size + "px " + (font || "Arial");
          ctx.font = fontStr;
          var w = ctx.measureText(text).width;
          var h = Math.ceil(size);
          canvas.width = w;
          canvas.height = h;
          ctx.font = fontStr;
          ctx.fillStyle = color || "black";
          ctx.fillText(text, 0, Math.ceil(size * 0.8));
          return canvas;
        }

        function createText2D(text, color, font, size, segW, segH) {
          var canvas = createTextCanvas(text, color, font, size);
          var plane = new THREE.PlaneGeometry(canvas.width, canvas.height, segW, segH);
          var tex = new THREE.Texture(canvas);
          tex.needsUpdate = true;
          var planeMat = new THREE.MeshBasicMaterial({
            map: tex,
            color: 0xffffff,
            transparent: true
          });
          var mesh = new THREE.Mesh(plane, planeMat);
          mesh.scale.set(0.5, 0.5, 0.5);
          mesh.doubleSided = true;
          return mesh;
        }

        // from http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
        function hexToRgb(hex) { //TODO rewrite with vector output
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }

        var renderer = new THREE.WebGLRenderer({
          antialias: true
        });
        var w = 400;
        var h = 400;
        renderer.setSize(w, h);
        $('#container').append(renderer.domElement);

        renderer.setClearColor(15658734, 1.0);
        //renderer.setClearColorHex(0xEEEEEE, 1.0);

        var camera = new THREE.PerspectiveCamera(45, w / h, 1, 10000);
        camera.position.x = 150;
        camera.position.y = 100;
        camera.position.z = 200;

        function v(x, y, z) {
          return new THREE.Vector3(x, y, z);
        }

        var format = d3.format(",r");

        var colorCluster = [
          [0,128,0], // Green
          [0,0,255], // Blue
          [255,255,0], // Yellow
          [255,0,0], // Red
          [1,1,1]
        ];

        //vm.colorMark = ['46bfbd', '97bbcd', 'fdb45c', 'f7464a', 'dddddd'];
        //vm.showCluster = ['N', 'N', 'N', 'N', 'N'];

        var xScale = null;
        var yScale = null;
        var zScale = null;
        var vpts = null;

        function getChartData4() {
          var list = [];
          var data = angular.copy(vm.srch);
          var colorNo = "";

          data.mapCode = 'WjmDashboard.getChart4';
          data.roleType = vm.roleType;

          // 시작 기준포인트 (기준라인 구성시 필요)
          list.push({
            Recency: 0 //x
            , Monetary: 0 //y
            , Frequency: 0 //z
            , ClusterNo: "4" //g
            , Cnt: 1 //s
          });

          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                // data 데이터 생성
                angular.forEach(result.body.docs, function(item, index) {
                  switch (item.LvCd) {
                    case "Green": colorNo = "0"; break;
                    case "Blue": colorNo = "1"; break;
                    case "Yellow": colorNo = "2"; break;
                    case "Red": colorNo = "3"; break;
                    default: colorNo = "4"; break;
                  }

                  list.push({
                    Recency: parseInt(item.Score01) //x 스트레스원인
                    , Monetary: parseInt(item.Score02) //y 스트레스증상
                    , Frequency: parseInt(item.Score03) //z 회복탄력성
                    , ClusterNo: colorNo //g
                    , Cnt: 1 //s
                  });
                });

                //console.log("list", list);
              } else {
                // 데이터 조회 실패
                // 종료 기준포인트 (기준라인 구성시 필요)
                list.push({
                  Recency: 100 //x
                  , Monetary: 100 //y
                  , Frequency: 100 //z
                  , ClusterNo: "4" //g
                  , Cnt: 1 //s
                });

                drawPlot(list);
              }

              drawPlot(list);
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> getChartData4()");
            console.table(error);
          });
        }

        function makeLine(v1, v2, propSca) {
          var lineSca = new THREE.Geometry();
          lineSca.vertices.push(
            v1, v2
          );
          var threeLineSca = new THREE.Line(lineSca, propSca);
          return threeLineSca;
        }

        function drawPlot(lists) {
          if (lists == null || lists.length == 0) {
            return;
          }

          //var pointSize = 15/Math.log10(lists.length);
          var pointSize = Math.round(4 / Math.log10(lists.length));

          var unfiltered = [];

          var scene = new THREE.Scene();

          var scatterPlot = new THREE.Object3D();
          scene.add(scatterPlot);
          scatterPlot.rotation.y = 0;

          var index = 0;
          angular.forEach(lists, function (item) {
            if (item.ClusterNo != null) {
              unfiltered[index] = {
                x: item.Recency,
                y: item.Monetary,
                z: item.Frequency,
                g: item.ClusterNo,
                s: item.Cnt
              };
              index++;
            }
          });

          var xExent = d3.extent(unfiltered, function (d) {return d.x; }),
            yExent = d3.extent(unfiltered, function (d) {return d.y; }),
            zExent = d3.extent(unfiltered, function (d) {return d.z; });

          if (vpts == null) {
            vpts = {
              xMax: xExent[1],
              xCen1: (xExent[1] + xExent[0]) * 1 / 5,
              xCen2: (xExent[1] + xExent[0]) * 2 / 5,
              xCen3: (xExent[1] + xExent[0]) * 3 / 5,
              xCen4: (xExent[1] + xExent[0]) * 4 / 5,
              xMin: xExent[0],
              yMax: yExent[1],
              yCen1: (yExent[1] + yExent[0]) * 1 / 5,
              yCen2: (yExent[1] + yExent[0]) * 2 / 5,
              yCen3: (yExent[1] + yExent[0]) * 3 / 5,
              yCen4: (yExent[1] + yExent[0]) * 4 / 5,
              yMin: yExent[0],
              zMax: zExent[1],
              zCen1: (zExent[1] + zExent[0]) * 1 / 5,
              zCen2: (zExent[1] + zExent[0]) * 2 / 5,
              zCen3: (zExent[1] + zExent[0]) * 3 / 5,
              zCen4: (zExent[1] + zExent[0]) * 4 / 5,
              zMin: zExent[0]
            };
          }

          vm.srch.maxR = xExent[1];
          vm.srch.maxM = yExent[1];
          vm.srch.maxF = zExent[1];

          //var colour = d3.scale.category20c();
          if (xScale == null) {
            xScale = d3.scale.linear().domain(xExent).range([50,-50]);
          }
          if (yScale == null) {
            yScale = d3.scale.linear().domain(yExent).range([-50,50]);
          }
          if (zScale == null) {
            zScale = d3.scale.linear().domain(zExent).range([50,-50]);
          }

          var propGeo = new THREE.LineBasicMaterial({
            color: 0x000000,
            lineWidth: 1
          });
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMin)), propGeo));
          scatterPlot.add(makeLine(v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMax)), propGeo));
          scatterPlot.add(makeLine(v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMax)), propGeo));

          var propSca = new THREE.LineBasicMaterial({
            color: 0xAAAAAA,
            lineWidth: 0.5
          });
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen1)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zCen1)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen2)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zCen2)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen3)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zCen3)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen4)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zCen4)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen1), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yCen1), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen2), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yCen2), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen3), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yCen3), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen4), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yCen4), zScale(vpts.zMax)), propSca));

          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen1)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zCen1)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen2)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zCen2)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen3)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zCen3)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen4)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zCen4)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xCen1), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xCen1), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xCen2), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xCen2), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xCen3), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xCen3), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xCen4), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xCen4), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));

          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen1), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yCen1), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen2), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yCen2), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen3), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yCen3), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen4), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yCen4), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xCen1), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xCen1), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xCen2), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xCen2), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xCen3), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xCen3), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xCen4), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xCen4), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));

          scatterPlot.add(makeLine(v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMin)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMin)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));

          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));

          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMin)), propSca));
          scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));

          // 수치 표시
          var titleXmax = createText2D(format(xExent[1]));
          titleXmax.position.x = xScale(vpts.xMax);
          titleXmax.position.y = yScale(vpts.yMin);
          titleXmax.position.z = zScale(vpts.zMin) + 5;
          scatterPlot.add(titleXmax);

          var numXmin = createText2D(format(xExent[0]));
          numXmin.position.x = xScale(vpts.xMin);
          numXmin.position.y = yScale(vpts.yMin);
          numXmin.position.z = zScale(vpts.zMin) + 5;
          scatterPlot.add(numXmin);

          var numY = createText2D(format(yExent[1]));
          numY.position.x = xScale(vpts.xMin);
          numY.position.y = yScale(vpts.yMax) + 5;
          numY.position.z = zScale(vpts.zMax);
          scatterPlot.add(numY);

          var numZ = createText2D(format(zExent[1]));
          numZ.position.x = xScale(vpts.xMin) + 10;
          numZ.position.y = yScale(vpts.yMin);
          numZ.position.z = zScale(vpts.zMax);
          scatterPlot.add(numZ);

          var titX = createText2D("스트레스원인");
          titX.position.x = xScale(vpts.xMax / 2) - 10;
          titX.position.y = yScale(vpts.yMin);
          titX.position.z = zScale(vpts.zMin);
          scatterPlot.add(titX);

          var titY = createText2D("스트레스증상");
          titY.position.x = xScale(vpts.xMax);
          titY.position.y = yScale(vpts.yMax / 2) + 20;
          titY.position.z = zScale(vpts.zMax);
          scatterPlot.add(titY);

          var titZ = createText2D("회복탄력성");
          titZ.position.x = xScale(vpts.xMin);
          titZ.position.y = yScale(vpts.yMin);
          titZ.position.z = zScale(vpts.zMax / 2) - 15;
          scatterPlot.add(titZ);


          var mat = new THREE.ParticleBasicMaterial({
            vertexColors: true,
            size: pointSize
          });

          var pointCount = unfiltered.length;
          var pointGeo = new THREE.Geometry();
          for (var i = 0; i < pointCount; i ++) {
            var x = xScale(unfiltered[i].x);
            var y = yScale(unfiltered[i].y);
            var z = zScale(unfiltered[i].z);

            pointGeo.vertices.push(new THREE.Vector3(x, y, z));
            //pointGeo.vertices[i].angle = Math.atan2(z, x);
            //pointGeo.vertices[i].radius = Math.sqrt(x * x + z * z);
            //pointGeo.vertices[i].speed = (z / 100) * (x / 100);
            //var c = unfiltered[i].g % 5;
            var c = unfiltered[i].g % 5;
            pointGeo.colors.push(new THREE.Color().setRGB(
              colorCluster[c][0], colorCluster[c][1], colorCluster[c][2]
            ));
          }
          var points = new THREE.ParticleSystem(pointGeo, mat);
          scatterPlot.add(points);

          renderer.render(scene, camera);
          var paused = false;
          var last = new Date().getTime();
          var down = false;
          var sx = 0,
            sy = 0;

          $('#container').mousedown(function(ev) {
            down = true;
            sx = ev.clientX;
            sy = ev.clientY;
          });
          $('#container').mouseup(function() {
            down = false;
          });
          $('#container').mousemove(function(ev) {
            if (down) {
              var dx = ev.clientX - sx;
              var dy = ev.clientY - sy;
              scatterPlot.rotation.y += dx * 0.005;
              camera.position.y += dy;
              sx += dx;
              sy += dy;
            }
          });
          var animating = false;
          window.ondblclick = function() {
            animating = !animating;
          };

          function animate(t) {
            if (!paused) {
              last = t;
              if (animating) {
                var v = pointGeo.vertices;
                for (var i = 0; i < v.length; i++) {
                  var u = v[i];
                  u.angle += u.speed * 0.01;
                  u.x = Math.cos(u.angle) * u.radius;
                  u.z = Math.sin(u.angle) * u.radius;
                }
                pointGeo.__dirtyVertices = true;
              }
              renderer.clear();
              camera.lookAt(scene.position);
              renderer.render(scene, camera);
            }
            window.requestAnimationFrame(animate, renderer.domElement);
          }
          animate(new Date().getTime());
          onmessage = function(ev) {
            paused = (ev.data == 'pause');
          };
        }
        /* ------------------------------------------------ 분산 그래프 관련 소스 (끝) -------------------------------------------------- */


        // 함수 정의
        vm.getSearch = getSearch;                   // 데이터 조회
        vm.setResetSearch = setResetSearch;         // 검색값 초기화
        vm.getList = getList;                       // 목록 조회

        vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
        vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

        vm.setSortColumn = setSortColumn;           // 정렬 설정
        vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

        vm.goAdd = goAdd;                       // 신규추가 - 등록/수정 화면 이동
        vm.goView = goView;                         // 조회 화면 이동
        vm.goSvyList = goSvyList;

        //vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
        vm.setDelList = setDelList;                 // 목록 삭제
        //vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

        // 조회
        init();

        getRoleType();
        getDashImg();
      }]);
})();

(function () {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.message', {
      url: '/message',
      template: '<div ui-view></div>'
    }).state('app.message.sms-send-number-save', {
      url: '/sms-send-number-save/:srch',
      templateUrl: 'app/message/sms-send-number-save.html',
      requiresAuthentication: true
    }).state('app.message.sms-send-number-list', {
      url: '/sms-send-number-list/:srch',
      templateUrl: 'app/message/sms-send-number-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.message.sms-send-number-edit', {
      url: '/sms-send-number-edit/:srch/:keyId',
      templateUrl: 'app/message/sms-send-number-edit.html',
    }).state('app.message.sms-send-number-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/message/sms-send-number-edit.html',
    });
  }
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('SmsSendNumberEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function SmsSendNumberEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var UPDATE_SQL = "SendNumberVerify.updateSendNumberVerify";   // 인증 승인
      var VIEW_SQL = 'SendNumberVerify.getSendNumberVerifyDetail'; // 조회 SQL
      var DEL_SQL = 'SendNumberVerify.deleteSendNumberVerify';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.sms-send-number-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.message.sms-send-number-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.message.sms-send-number-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'SendNumberVerify'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model

      vm.formType = $stateParams.formType;
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.Contents = "0";

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          KeyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.KeyId = $stateParams.keyId;
        vm.srch.formType = $stateParams.formType;
        vm.srch.tableNm = KEY_TABLE_NM;
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.KeyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.KeyId) ? vm.srch.KeyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      // #region 부서 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.KeyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.KeyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (vm.data.RegDateDate != null && vm.data.RegDateDate != "") vm.RegDateDate = moment(vm.data.RegDateDate).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };

                vm.uploadFileList.push(obj);
              });
            } else {

              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if(vm.formType == 'EMAIL') {
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
          vm.data.Contents = $("#strHtml").val();
        }

        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.Contents)) {
          errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.FormNm)) {
          errMsg = errMsg + '- 서식명을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }


      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.KeyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });

//        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        var data = angular.copy(vm.data); // 사용자 입력 데이터

        // 수정
        data.RelateDataId = data.KeyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.KeyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              formType: vm.formType,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.KeyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch,formType:vm.formType, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }


      /**
       * 인증 확인
       * @param
       * @return
       */
      function setUpdate() {
        gConfirm('', '인증승인을 하시겠습니까?', {
          btn : '',
          fn : function() {
            seUpdateAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function seUpdateAction() {
        var data = vm.srch;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '인증승인 처리가 완료 되었습니다.', {
              btn : '',
              fn : function() {
                getData();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }


      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;               // 데이터 삭제
      vm.setUpdate = setUpdate;                   // 인증승인
      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('SmsSendNumberListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SmsSendNumberListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'SendNumberVerify.insertSendNumberVerify';     // 등록 SQL
      var LIST_CNT_SQL = 'SendNumberVerify.getSendNumberVerifyListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'SendNumberVerify.getSendNumberVerifyList';    // 목록 조회 SQL
      var DELETE_LIST_SQL = 'SendNumberVerify.deleteSendNumberVerify'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.sms-send-number-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.sms-send-number-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.sms-send-number-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.message.sms-send-number-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.sms-send-number-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'SendNumberVerify'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
          //RegDateFrom : '',
          //RegDateTo : '',
          //SendNumber : '',
          //CertType : '',
          //CertYN : ''
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId,formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }
      


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('SmsSendNumberSaveCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SmsSendNumberListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'SendNumberVerify.insertSendNumberVerify';     // 등록 SQL
      var LIST_CNT_SQL = 'SendNumberVerify.getSendNumberVerifyListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'SendNumberVerify.getSendNumberVerifyList';    // 목록 조회 SQL
      var DELETE_LIST_SQL = 'SendNumberVerify.deleteSendNumberVerify'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.sms-send-number-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.sms-send-number-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.sms-send-number-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.message.sms-send-number-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.sms-send-number-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'SendNumberVerify'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      vm.data = {
        tableNm : KEY_TABLE_NM, SendNumber : '', CertType : 'MOBILE', SiteId : 'WJM',
        srchTenantId : $rootScope.gVariable.srchTenantId
      };

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수


      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );
        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId,formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /*
       * 2두리로 만들기
       */
      function setZero(val){
        return val > 10 ?  '' + val : '0' + val ;
      };

      /*
       * 요청ID생성
       */
      function setMerchantUID() {
        var d = new Date();
        var rndNum = Math.floor(10 + Math.random() * d.getTime());
        return "CID_" + (d.getFullYear() + "").substring(2, 4) + "" + setZero(d.getMonth() + 1) + "" + setZero(d.getDate()) + "" + setZero(d.getHours()) + "" + setZero(d.getMinutes()) + "_" + rndNum;;
      }

      function setVerifyData() {

        var errMsg = '';

        if (isNullOrEmpty(vm.data.SendNumber)) {
          errMsg = errMsg + '-전화번호를 입력해 주세요.';
        }

        if(vm.data.CertType != 'MOBILE' ){
          if (isNullOrEmpty(vm.uploadFileList)) {
            errMsg = errMsg + '<br/>-첨부파일을 업로드 해주세요.';
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        if(vm.data.CertType =='MOBILE' )
        {
          /*
           * 본인인증은 SSCRM용을 사용한다.
           */
          IMP.init("imp86263784");
          IMP.certification({
            merchant_uid: setMerchantUID()
            ,phone: vm.data.SendNumber
          }, function (certifyResult) {
            console.table(certifyResult);

            if (certifyResult.success) {
              postApi.openApi('personalCertify', certifyResult, function (result) {
                setPaymentCertify(result);
              }, function (error) {
                console.error("Error : personalCertify");
                console.table(error);
              });
            } else {
              alert("본인인증에 실패하였습니다.(" + certifyResult.error_msg + ")");
            }
          });

        }else{
          var data = angular.copy(vm.data); // 검색 옵션 설정
          data.mapCode = INSERT_SQL;

          data.uploadFileList = [];
          angular.forEach(vm.uploadFileList, function(item) {
            data.uploadFileList.push(item);
          });

          postApi.insert(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if ( result.body.docs[0].RelateDataId !== null ) {
                gAlert("", "Menu.SAVED", {
                  btn: "",
                  fn: function () {
                    getList();
                  }
                });
                return;
              }
            }else{
              gAlert('', result.body.docs[0].errMessage);
            }
          }, function (error) {
            console.error("Error : personalCertify");
            console.table(error);
          });
        }
      }

      /**
       * 결제 처리후 process
       */
      /* function setPaymentCertify(result) {
        var data = angular.copy(vm.data);
        data.mapcode = INSERT_SQL;
        console.log('result', result);
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs[0].RelateDataId !== null && result.body.docs[0].errCd != 'DUP') {
            postApi.insert(data,function (result) {
              alert("발신번호가 인증되었습니다.\n승인 대기.");
              getList();
            }, function (error) {
              console.error("Error : personalCertify");
              console.table(error);
            });
          } else {
            if(result.body.docs[0].errCd && result.body.docs[0].errCd == 'DUP'){
              alert("발신번호가 중복되었습니다.");
            }else{
              alert("본인인증에 오류가 발생하였습니다.\n고객센터에 문의해주세요.");
            }
            gAlert('', result.body.docs[0].errMessage);
            return false;
          }
        }
      } */

      /**
       * 결제 처리후 process
       */
      function setPaymentCertify(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if ( result.body.docs[0].status ) {
            alert("발신번호가 인증되었습니다.");
            getList();
          }else{
            if(result.body.docs[0].errCd && result.body.docs[0].errCd == 'DUP'){
              alert("발신번호가 중복되었습니다.");
            }else{
              alert("본인인증에 오류가 발생하였습니다.\n고객센터에 문의해주세요.");
            }
            return false;
          }
        }
      }


      function setChangeRadioBtn(_data) {
        vm.data.CertType = _data;
        if(_data == "MOBILE") {
          vm.showUploader = false;
        } else {
          vm.showUploader = true;
        }
      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
      vm.setVerifyData = setVerifyData;
      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.setChangeRadioBtn = setChangeRadioBtn;

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:analysis-action-compare-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('AnalysisActionCompareCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',
    function AnalysisActionCompareCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'DataAnalysis.getAnalysisRfmcentroidsListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'DataAnalysis.getAnalysisRfmcentroidsList';    // 목록 조회 SQL
      var EXCEL_SQL = 'MaDatagroup.getExcelList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-customerrank-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.analysis-customerrank-list.analysis-customerrank-detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.dataanalysis.analysis-customerrank-list.analysis-customerrank-edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-customerrank-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.dataanalysis.analysis-customerrank-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'mlrfmcentroids'; // 작업 테이블명
      var KEY_COLUMN_NM = 'RelateDataId'; // Primary Key Column
      var EXCEL_TITLE = '고객등급_분석결과_목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: 25, // 페이지당 조회건수
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = [{}, {}];
      vm.data = [{cnt:[0, 0, 0, 0]}, {cnt:[0, 0, 0, 0]}];
      vm.listColumns = [[], []];
      vm.totalItems = [0, 0];
      vm.lists = [[], []];
      vm.GroupAndAction = ['', ''];
      vm.dataloader = [false, false];  // Progressbar 숨김
      vm.chart = {};
      vm.chart.mixdata = [[], []];
      vm.chart.mixlabels = [];
      vm.chart.mixdata2 = [[], []];
      vm.chart.mixlabels2 = [];

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.GroupAndAction[0] = vm.srch.DatagroupId + "." + vm.srch.ActionId;
      vm.GroupAndAction[1] = vm.srch.DatagroupId + "." + vm.srch.ActionId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      vm.reloadSeq = 0;

      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      (function AnalysisActionCompareCtrl() {
        getChart();

        // 목록 조회
        getList(0);
        getList(1);

        // 초기 데이터 설정
        setInitData();
        getDataGroupAndActionList();
      })();

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList(0);
        getList(1);

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      vm.getList0 = function(code) {
        vm.getList(0);
      };

      vm.getList1 = function(code) {
        vm.getList(1);
      };
      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList(num) {
        console.log('getList(' + num + ')');
        vm.dataloader[num] = true; // Progressbar 표시

        getChartData(num);
        getChartData2(num);

        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        var daId = vm.GroupAndAction[num].split('.');
        data.DatagroupId = daId[0];
        data.ActionId = daId[1];
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        //vm.lists[num] = {};
        //vm.listColumns[num] = {};

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              vm.totalItems[num] = result.body.docCnt;
              // 목록 데이터 표시
              vm.lists[num] = result.body.docs;

            } else {
              // 데이터 조회 실패
              vm.lists[num] = {};
            }
          }

          vm.dataloader[num] = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader[num] = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });

        getListCnt(data, 'DataAnalysis.getGoodsListFromSalesListCnt', num, 0);
        getListCnt(data, 'DataAnalysis.getCustomerListFromSalesListCnt', num, 1);
        getListCnt(data, 'DataAnalysis.getTotalSalesMonetary', num, 2);
        //getListCnt(data, 'DataAnalysis.getAnalysisRecommendListCnt', num, 3);
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {
        if (vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하세요.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap1, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap1, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      function getDataGroupAndActionList() {
        var data = {};
        data.selectType = 'List';
        data.mapCode = 'MaDatagroup.getDatagroupAndActionList';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.dagrouplists = result.body.docs;
            } else {
              // 데이터 조회 실패
              vm.dagrouplists = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getDataGroupAndActionList()");
          console.table(error);
        });
      }

      function getListCnt(data, mapCode, num, cntNo) {
        data.tableNm = null;
        data.mapCode = mapCode;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            console.log(result.body.docs[0]);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.data[num].cnt[cntNo] = result.body.docs[0];
            } else {
              // 데이터 조회 실패
              cnt = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getDataGroupAndActionList()");
          console.table(error);
        });
      }

      function getChart() {
        vm.chart.mixcolors = ['#45b7cd', '#ff8e72'];
        vm.chart.mixdatasetOverride = [
          {
            label: "Series A",
            borderWidth: 1,
            type: 'line',
            fill: false,
            yAxisID: 'y-axis-1'
          },
          {
            label: "Series B",
            borderWidth: 1,
            type: 'line',
            fill: false,
            yAxisID: 'y-axis-1'
          }
        ];

        vm.chart.options = {
          scales: {
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                display: true,
                position: 'left',
                scaleLabel: {
                  display: true,
                  labelString: '금액(백만원)'
                },
                ticks: {
                  beginAtZero: true,
                  userCallback: function(item) {
                    return $filter('number')(Math.round(item/1000000), 0);
                  },
                }
              }
            ]
          },
          tooltips: {
            callbacks : {
              label : function(tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || '';

                if (label) {
                  label += ': ';
                }

                if (tooltipItem.datasetIndex == 0 || tooltipItem.datasetIndex == 2)
                  label += $filter('numberWithCommas')(Math.round((tooltipItem.yLabel / 1000000 * 100) / 100));
                else
                  label += tooltipItem.yLabel;

                return label;
              }
            }
          },
          maintainAspectRatio: false
        };
      }

      function getChartData(num) {

//        vm.daily.mixdata = new Array(new Array(size), new Array(size));
        vm.chart.mixdata[num] = [];

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        var daId = vm.GroupAndAction[num].split('.');
        data.DatagroupId = daId[0];
        data.ActionId = daId[1];
        data.mapCode = 'DataAnalysis.getStatisticsMonthlySales';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              var list = result.body.docs;
              angular.forEach(list, function(item, index) {
                vm.chart.mixdata[num][index] = item.PaymentTotal;

                if (num == 0) {
                  vm.chart.mixlabels[index] = item.DT;
                }
              });

            } else {
              // 데이터 조회 실패
              vm.chart.mixdata[num] = [];
            }
          }

          vm.dataloader[num] = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader[num] = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function getChartData2(num) {

//        vm.daily.mixdata = new Array(new Array(size), new Array(size));
        vm.chart.mixdata2[num] = [];

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        var daId = vm.GroupAndAction[num].split('.');
        data.DatagroupId = daId[0];
        data.ActionId = daId[1];
        data.mapCode = 'DataAnalysis.getStatisticsWeeklySales';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              var list = result.body.docs;
              angular.forEach(list, function(item, index) {
                vm.chart.mixdata2[num][index] = item.PaymentTotal;

                if (num == 0) {
                  vm.chart.mixlabels2[index] = item.DT;
                }
              });

            } else {
              // 데이터 조회 실패
              vm.chart.mixdata2[num] = [];
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }
      /* bar Chart 종료 */

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드


    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:analysis-action-compare-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('AnalysisClusterCompareCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',
    function AnalysisClusterCompareCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'DataAnalysis.getAnalysisRfmcentroidsListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'DataAnalysis.getAnalysisRfmcentroidsList';    // 목록 조회 SQL
      var EXCEL_SQL = 'MaDatagroup.getExcelList'; // 엑셀다운로드 SQL
      var COMPARE_SQL = 'DataAnalysis.getClusterCompare'; // 클러스터 비교 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-cluster-compare';         // 목록 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-cluster-compare-result';       // 조회 화면
      var LIST_CUSTOMER_RANK_URL = 'app.dataanalysis.analysis-cluster-compare.result'; // 고객등급 출력화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'mlrfmcentroids'; // 작업 테이블명
      var KEY_COLUMN_NM = 'RelateDataId'; // Primary Key Column
      var EXCEL_TITLE = '고객등급_분석결과_목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model


      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: 25, // 페이지당 조회건수
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = [{}, {}];
      vm.data = [{cnt:[0, 0, 0, 0]}, {cnt:[0, 0, 0, 0]}];
      vm.listColumns = [[], []];
      vm.totalItems = [0, 0];
      vm.lists = [[], []];
      vm.GroupAndAction = ['', ''];
      vm.dataloader = [false, false];  // Progressbar 숨김

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.GroupAndAction[0] = vm.srch.DatagroupId + "." + vm.srch.ActionId;
      vm.GroupAndAction[1] = vm.srch.DatagroupId + "." + vm.srch.ActionId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      vm.reloadSeq = 0;

      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      (function AnalysisClusterCompareCtrl() {

        // 목록 조회
        getList(0);
        getList(1);

        // 초기 데이터 설정
        setInitData();
        getDataGroupAndActionList();
      })();

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList(0);
        getList(1);

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      vm.getList0 = function(code) {
        vm.getList(0);
      };

      vm.getList1 = function(code) {
        vm.getList(1);
      };

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList(num) {
        if (vm.dataloader[num] == true) return;

        console.log('getList(' + num + ')');
        vm.dataloader[num] = true; // Progressbar 표시

        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        var daId = vm.GroupAndAction[num].split('.');
        data.DatagroupId = daId[0];
        data.ActionId = daId[1];
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        //vm.lists[num] = {};
        //vm.listColumns[num] = {};

        // 체크박스 설정
        // for (var i = 0; i < vm.lists.length; i++) {
        //   if (vm.lists[0][i].chkRow)
        //   {
        //     vm.srch.KeyIdList.push(vm.lists[0][i].ActionId);
        //   }
        // }

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              vm.totalItems[num] = result.body.docCnt;
              // 목록 데이터 표시
              vm.lists[num] = result.body.docs;
              vm.lists[num].ActionId = daId[1];
            } else {
              // 데이터 조회 실패
              vm.lists[num] = {};
            }
          }

          vm.dataloader[num] = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader[num] = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });

        getListCnt(data, 'DataAnalysis.getGoodsListFromSalesListCnt', num, 0);
        getListCnt(data, 'DataAnalysis.getCustomerListFromSalesListCnt', num, 1);
        getListCnt(data, 'DataAnalysis.getTotalSalesMonetary', num, 2);
        //getListCnt(data, 'DataAnalysis.getAnalysisRecommendListCnt', num, 3);
      }

      /**
       * getList(0), getList(1) 비교 후 사용자 조회
       * parameter 세팅 완료 -> 자바 적용단계
       *
       */
      function getCompareResult() {
        console.log(vm.srch);
        vm.srch.ClusterDetailList = [];
        for (var a=0; a<2; a++) {
          vm.srch.ClusterDetailList.push(
            {"tableIndex": a,
             "ActionId": vm.lists[a].ActionId,
             "clusterNo" : []}
          );
          for (var i = 0; i < vm.lists[a].length; i++) {
            if (vm.lists[a][i].chkRow)
            {
              vm.srch.ClusterDetailList[a].clusterNo.push(vm.lists[a][i].ClusterNo);
            }
          }
        }

        var srch = encodeURIComponent(JSON.stringify(vm.srch));

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {srch: srch});
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_CUSTOMER_RANK_URL, {srch: srch});
        }
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {
        if (vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하세요.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap1, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap1, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      function getDataGroupAndActionList() {
        var data = {};
        data.selectType = 'List';
        data.mapCode = 'MaDatagroup.getDatagroupAndActionList';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              console.log(result.body.docs);
              vm.dagrouplists = result.body.docs;
            } else {
              // 데이터 조회 실패
              vm.dagrouplists = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getDataGroupAndActionList()");
          console.table(error);
        });
      }

      function getListCnt(data, mapCode, num, cntNo) {
        data.tableNm = null;
        data.mapCode = mapCode;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            console.log(result.body.docs[0]);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.data[num].cnt[cntNo] = result.body.docs[0];
            } else {
              // 데이터 조회 실패
              cnt = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getDataGroupAndActionList()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      vm.getCompareResult = getCompareResult;     // 두 함수 비교

    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:analysis-customerrank-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('AnalysisClusterCompareResultCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',
    function AnalysisCustomerrankListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'DataAnalysis.getAnalysisCustomerrankListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'DataAnalysis.getAnalysisCustomerrankList';    // 목록 조회 SQL
      var EXCEL_SQL = 'DataAnalysis.getExcelAnalysisCustomerrankList'; // 엑셀다운로드 SQL
      var COMPARE_SQL = 'DataAnalysis.getClusterCompare'; // 클러스터 비교 SQL
      var COMPARE_CNT_SQL = 'DataAnalysis.getClusterCompareCnt'; // 클러스터 비교 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-cluster-compare';         // 목록 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-cluster-compare-result';       // 조회 화면
      var LIST_CUSTOMER_RANK_URL = 'app.dataanalysis.analysis-cluster-compare.result'; // 고객등급 출력화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'masales.clustercompare'; // 작업 테이블명
      var KEY_COLUMN_NM = 'RelateDataId'; // Primary Key Column
      var EXCEL_TITLE = '고객등급_분석결과_목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: 25, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        if (vm.layout == 'N') {
          $state.go(VIEW_PAGE_URL, {srch: srch}, {reload:VIEW_PAGE_URL});
        } else {
          $state.go(LIST_CUSTOMER_RANK_URL, {srch: srch}, {reload:LIST_CUSTOMER_RANK_URL});
        }
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          $state.go(VIEW_PAGE_URL, {srch: ''}, {reload:VIEW_PAGE_URL});
        } else {
          $state.go(LIST_CUSTOMER_RANK_URL, {srch: ''}, {reload:LIST_CUSTOMER_RANK_URL});
        }
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = COMPARE_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
              vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
              console.log("totalCnt");
              console.log(vm.totalItems);
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });


      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
        vm.srch.ActionId = $rootScope.gVariable.dataActionId;
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = COMPARE_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              console.log("----");
              console.log(vm.lists);

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          /* postApi.select(data,function(result){
            if(result.header.status == CONSTANT.HttpStatus.OK){

              if(result.body.docs.length >0){
                vm.totalCompare=result.body.docCnt;

                vm.listsCompare=result.body.docs;
                console.log(vm.listsCompare);
              }else {
                vm.listsCompare={};
              }
            }
          }, function(err) {

            // 조회 중 오류 발생
            console.error("Error> getCompare()");
            console.table(error);
          });
 */

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
        console.log(vm.lists);
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        if (vm.layout == 'N') {
          $state.go(VIEW_PAGE_URL, {srch: srch}, {reload:VIEW_PAGE_URL});
        } else {
          $state.go(LIST_CUSTOMER_RANK_URL, {srch: srch}, {reload:LIST_CUSTOMER_RANK_URL});
        }
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {
        if (vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하세요.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      function goList() {
        $state.go(LIST_PAGE_URL, {});
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      vm.goList = goList;

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:cluster-three-plot
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('AnalysisClusterThreePlotCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate', '$filter',
    function AnalysisClusterThreePlotCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate, $filter) {

      var vm = this;          // View Model
      vm.totalItems = 0;
      vm.srch = {};
      vm.srch.viewSize = 100000;
      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;
      vm.getList = getList;
      vm.getSearch = getSearch;
      vm.reloadAll = reloadAll;
      vm.rfmlist = [{}, {}, {}];

      vm.srch.resultType = $stateParams.resultType? $stateParams.resultType : 'rfmCluster3d';

      vm.refreshList = refreshList;

      (function AnalysisClusterThreePlotCtrl() {
        // 목록 조회
        reloadAll();
      })();

      function createTextCanvas(text, color, font, size) {
        size = size || 16;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var fontStr = size + "px " + (font || "Arial");
        ctx.font = fontStr;
        var w = ctx.measureText(text).width;
        var h = Math.ceil(size);
        canvas.width = w;
        canvas.height = h;
        ctx.font = fontStr;
        ctx.fillStyle = color || "black";
        ctx.fillText(text, 0, Math.ceil(size * 0.8));
        return canvas;
      }

      function createText2D(text, color, font, size, segW, segH) {
        var canvas = createTextCanvas(text, color, font, size);
        var plane = new THREE.PlaneGeometry(canvas.width, canvas.height, segW, segH);
        var tex = new THREE.Texture(canvas);
        tex.needsUpdate = true;
        var planeMat = new THREE.MeshBasicMaterial({
            map: tex,
            color: 0xffffff,
            transparent: true
        });
        var mesh = new THREE.Mesh(plane, planeMat);
        mesh.scale.set(0.5, 0.5, 0.5);
        mesh.doubleSided = true;
        return mesh;
      }

      // from http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
      function hexToRgb(hex) { //TODO rewrite with vector output
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
      }

      var renderer = new THREE.WebGLRenderer({
        antialias: true
      });
      var w = 500;
      var h = 500;
      renderer.setSize(w, h);
      $('#container').append(renderer.domElement);

      renderer.setClearColor(15658734, 1.0);
      //renderer.setClearColorHex(0xEEEEEE, 1.0);

      var camera = new THREE.PerspectiveCamera(45, w / h, 1, 10000);
      camera.position.x = 150;
      camera.position.y = 100;
      camera.position.z = 200;

      function v(x, y, z) {
        return new THREE.Vector3(x, y, z);
      }

      var format = d3.format(",r");

      var colorCluster = [
                          [0.25,0.71,0.90],
                          [1.00,0.35,0.36],
                          [1.00,0.71,0.29],
                          [0.00,0.09,0.44],
                          [0.32,0.36,0.83],
                          [0.51,0.20,0.69],
                          [0.87,0.16,0.48],
                          [0.24,0.23,0.17]
                         ];

//    vm.colorMark = ['ED1B24', 'F68121', 'FEF200', '00A652', '0072BB', '2E3192', '812991', 'ED0678'];
      vm.colorMark = ['41b6e6', 'ff585d', 'ffb549', '001871', '515bd4', '8134af', 'dd2a7b', '3d3b2c'];
      vm.showCluster = ['Y', 'Y', 'Y', 'Y', 'Y', 'Y', 'Y', 'Y'];

      var xScale = null;
      var yScale = null;
      var zScale = null;
      var vpts = null;

      function refreshList(type) {
        if (type == 1) {
          xScale = null;
          yScale = null;
          zScale = null;
          vpts = null;
        }

        var lists = [];

        angular.forEach(vm.lists, function (item, index) {
          if (item.ClusterNo != null && vm.showCluster[item.ClusterNo] == 'Y' && item.Recency <= vm.srch.maxR && item.Frequency <= vm.srch.maxF && item.Monetary <= vm.srch.maxM) {
            lists.push(item);
          }
        });

        drawPlot(lists);
      }

      function getList() {
        vm.dataloader = true;
        vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
        vm.srch.ActionId = $rootScope.gVariable.dataActionId;

        getClusterList();

        xScale = null;
        yScale = null;
        zScale = null;
        vpts = null;

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        if (vm.srch.resultType == 'rfmCluster3d') {
          data.OutlierType = 'N';
          data.mapCode = 'DataAnalysis.getAnalysisCustomerrankList';
        } else if (vm.srch.resultType == 'rfmScore3d') {
          data.OutlierType = 'N';
          data.mapCode = 'DataAnalysis.getAnalysisScoreGroupList';
        } else if (vm.srch.resultType == 'rfmOutlier3d') {
          data.OutlierType = 'Y';
          data.mapCode = 'DataAnalysis.getAnalysisCustomerrankList';
        }

        postApi.select(data, function (result) {
          vm.dataloader = false;

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docCnt;
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              var lists = angular.copy(vm.lists);
              drawPlot(lists);
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function makeLine(v1, v2, propSca) {
        var lineSca = new THREE.Geometry();
        lineSca.vertices.push(
          v1, v2
        );
        var threeLineSca = new THREE.Line(lineSca, propSca);
        return threeLineSca;
      }

      function drawPlot(lists) {
        if (lists == null || lists.length == 0) {
          return;
        }

        var pointSize = 15/Math.log10(lists.length);

        var unfiltered = [];

        var scene = new THREE.Scene();

        var scatterPlot = new THREE.Object3D();
        scene.add(scatterPlot);
        scatterPlot.rotation.y = 0;

        var index = 0;
        angular.forEach(lists, function (item) {
          if (item.ClusterNo != null) {
            unfiltered[index] = {
              x: item.Recency,
              y: item.Monetary,
              z: item.Frequency,
              g: item.ClusterNo,
              s: item.Cnt
            };
            index++;
          }
        });

        var xExent = d3.extent(unfiltered, function (d) {return d.x; }),
            yExent = d3.extent(unfiltered, function (d) {return d.y; }),
            zExent = d3.extent(unfiltered, function (d) {return d.z; });

        if (vpts == null) {
          vpts = {
            xMax: xExent[1],
            xCen1: (xExent[1] + xExent[0]) * 1 / 5,
            xCen2: (xExent[1] + xExent[0]) * 2 / 5,
            xCen3: (xExent[1] + xExent[0]) * 3 / 5,
            xCen4: (xExent[1] + xExent[0]) * 4 / 5,
            xMin: xExent[0],
            yMax: yExent[1],
            yCen1: (yExent[1] + yExent[0]) * 1 / 5,
            yCen2: (yExent[1] + yExent[0]) * 2 / 5,
            yCen3: (yExent[1] + yExent[0]) * 3 / 5,
            yCen4: (yExent[1] + yExent[0]) * 4 / 5,
            yMin: yExent[0],
            zMax: zExent[1],
            zCen1: (zExent[1] + zExent[0]) * 1 / 5,
            zCen2: (zExent[1] + zExent[0]) * 2 / 5,
            zCen3: (zExent[1] + zExent[0]) * 3 / 5,
            zCen4: (zExent[1] + zExent[0]) * 4 / 5,
            zMin: zExent[0]
          };
        }

        vm.srch.maxR = xExent[1];
        vm.srch.maxM = yExent[1];
        vm.srch.maxF = zExent[1];

        var colour = d3.scale.category20c();

        if (xScale == null) {
          if (vm.srch.resultType == 'rfmScore3d') {
            xScale = d3.scale.linear().domain(xExent).range([-50,50]);
          } else {
            xScale = d3.scale.linear().domain(xExent).range([50,-50]);
          }
        }
        if (yScale == null) {
          yScale = d3.scale.linear().domain(yExent).range([-50,50]);
        }
        if (zScale == null) {
          zScale = d3.scale.linear().domain(zExent).range([50,-50]);
        }

        var propGeo = new THREE.LineBasicMaterial({
          color: 0x000000,
          lineWidth: 1
        });
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMin)), propGeo));
        scatterPlot.add(makeLine(v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMax)), propGeo));
        scatterPlot.add(makeLine(v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMax)), propGeo));

        var propSca = new THREE.LineBasicMaterial({
          color: 0xAAAAAA,
          lineWidth: 0.5
        });
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen1)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zCen1)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen2)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zCen2)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen3)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zCen3)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen4)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zCen4)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen1), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yCen1), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen2), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yCen2), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen3), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yCen3), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen4), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yCen4), zScale(vpts.zMax)), propSca));

        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen1)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zCen1)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen2)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zCen2)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen3)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zCen3)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zCen4)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zCen4)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xCen1), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xCen1), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xCen2), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xCen2), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xCen3), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xCen3), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xCen4), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xCen4), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));

        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen1), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yCen1), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen2), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yCen2), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen3), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yCen3), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yCen4), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yCen4), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xCen1), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xCen1), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xCen2), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xCen2), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xCen3), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xCen3), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xCen4), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xCen4), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));

        scatterPlot.add(makeLine(v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMin)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMin)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));

        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMin)), v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));

        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMin), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yMin), zScale(vpts.zMax)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMin)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMin)), propSca));
        scatterPlot.add(makeLine(v(xScale(vpts.xMin), yScale(vpts.yMax), zScale(vpts.zMax)), v(xScale(vpts.xMax), yScale(vpts.yMax), zScale(vpts.zMax)), propSca));

        var titleXmax = createText2D('R ' + format(xExent[1]));
        titleXmax.position.x = xScale(vpts.xMax);
        titleXmax.position.y = yScale(vpts.yMin);
        titleXmax.position.z = zScale(vpts.zMin) + 5;
        scatterPlot.add(titleXmax);

        var titleXmin = createText2D('R ' + format(xExent[0]));
        titleXmin.position.x = xScale(vpts.xMin);
        titleXmin.position.y = yScale(vpts.yMin);
        titleXmin.position.z = zScale(vpts.zMin) + 5;
        scatterPlot.add(titleXmin);

        var titleY = createText2D('M ' + format(yExent[1]));
        if (vm.srch.resultType == 'rfmScore3d') {
          titleY.position.x = xScale(vpts.xMax);
        } else {
          titleY.position.x = xScale(vpts.xMin);
        }
        titleY.position.y = yScale(vpts.yMax) + 5;
        titleY.position.z = zScale(vpts.zMax);
        scatterPlot.add(titleY);

        var titleZ = createText2D('F ' + format(zExent[1]));
        if (vm.srch.resultType == 'rfmScore3d') {
          titleZ.position.x = xScale(vpts.xMax) + 10;
        } else {
          titleZ.position.x = xScale(vpts.xMin) + 10;
        }
        titleZ.position.y = yScale(vpts.yMin);
        titleZ.position.z = zScale(vpts.zMax);
        scatterPlot.add(titleZ);

        var mat = new THREE.ParticleBasicMaterial({
            vertexColors: true,
            size: pointSize
        });

        var pointCount = unfiltered.length;
        var pointGeo = new THREE.Geometry();
        for (var i = 0; i < pointCount; i ++) {
          var x = xScale(unfiltered[i].x);
          var y = yScale(unfiltered[i].y);
          var z = zScale(unfiltered[i].z);

          pointGeo.vertices.push(new THREE.Vector3(x, y, z));
          //pointGeo.vertices[i].angle = Math.atan2(z, x);
          //pointGeo.vertices[i].radius = Math.sqrt(x * x + z * z);
          //pointGeo.vertices[i].speed = (z / 100) * (x / 100);
          var c = unfiltered[i].g % 8;
          pointGeo.colors.push(new THREE.Color().setRGB(
            colorCluster[c][0], colorCluster[c][1], colorCluster[c][2]
          ));
        }
        var points = new THREE.ParticleSystem(pointGeo, mat);
        scatterPlot.add(points);

        renderer.render(scene, camera);
        var paused = false;
        var last = new Date().getTime();
        var down = false;
        var sx = 0,
            sy = 0;

        $('#container').mousedown(function(ev) {
          down = true;
          sx = ev.clientX;
          sy = ev.clientY;
        });
        $('#container').mouseup(function() {
          down = false;
        });
        $('#container').mousemove(function(ev) {
          if (down) {
            var dx = ev.clientX - sx;
            var dy = ev.clientY - sy;
            scatterPlot.rotation.y += dx * 0.005;
            camera.position.y += dy;
            sx += dx;
            sy += dy;
          }
        });
        var animating = false;
        window.ondblclick = function() {
            animating = !animating;
        };

        function animate(t) {
          if (!paused) {
            last = t;
            if (animating) {
              var v = pointGeo.vertices;
              for (var i = 0; i < v.length; i++) {
                var u = v[i];
                u.angle += u.speed * 0.01;
                u.x = Math.cos(u.angle) * u.radius;
                u.z = Math.sin(u.angle) * u.radius;
              }
              pointGeo.__dirtyVertices = true;
            }
            renderer.clear();
            camera.lookAt(scene.position);
            renderer.render(scene, camera);
          }
          window.requestAnimationFrame(animate, renderer.domElement);
        }
        animate(new Date().getTime());
        onmessage = function(ev) {
          paused = (ev.data == 'pause');
        };
      }

      function getSearch(resultType) {
        vm.srch.resultType = resultType;
        getList();
      }

      function reloadAll(){
        vm.srch.resultType = 'rfmCluster3d';

        xScale = null;
        yScale = null;
        zScale = null;
        vpts = null;

        getList();

        getRfmList(0, 'rfmCluster3d');
        getRfmList(1, 'rfmScore3d');
        getRfmList(2, 'rfmOutlier3d');
        getRfmList(3, 'rfmSalesPie');
        getRfmList(4, 'rfmClusterByRecency');
        getRfmList(5, 'rfmClusterByFrequency');
        getRfmList(6, 'rfmClusterByMonetary');
        getRfmList(7, 'orderCountByState');
        getRfmList(8, 'orderPaymentByState');
        getRfmList(9, 'orderCountByStateMap');
        getRfmList(10, 'orderPaymentByStateMap');
        getRfmList(11, 'productTagWordCloud');
      }

      function getClusterList() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = 'DataAnalysis.getAnalysisRfmcentroidsList';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.clusterLists = result.body.docs;

            } else {
              // 데이터 조회 실패
              vm.clusterLists = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function getRfmList(divIdNum, resultType) {
        var data = angular.copy(vm.srch);

        data.selectType = 'List';
        data.ResultType = resultType;
        data.mapCode = 'DataAnalysis.getMaExeResult';

        postApi.select(data, function (result) {
        //postApi.sendPostApi('api/dataanalysis', 'getRfmList', data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.rfmlist[divIdNum] = binary2text(result.body.docs[0].ResultContents);
              $('#regTitle' + divIdNum).html(vm.rfmlist[divIdNum]);
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getDataGroupAndActionList()");
          console.table(error);
        });
      }
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:analysis-customerrank-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('AnalysisCustomerrankListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',
    function AnalysisCustomerrankListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'DataAnalysis.getAnalysisCustomerrankListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'DataAnalysis.getAnalysisCustomerrankList';    // 목록 조회 SQL
      var EXCEL_SQL = 'DataAnalysis.getExcelAnalysisCustomerrankList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-customerrank-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.analysis-customerrank-list.analysis-customerrank-detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.dataanalysis.analysis-customerrank-list.analysis-customerrank-edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-customerrank-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.dataanalysis.analysis-customerrank-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'macustomerrfm'; // 작업 테이블명
      var KEY_COLUMN_NM = 'RelateDataId'; // Primary Key Column
      var EXCEL_TITLE = '고객등급_분석결과_목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: 25, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
              vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
        vm.srch.ActionId = $rootScope.gVariable.dataActionId;
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {
        if (vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하세요.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";

  /**
   * @ngdoc function
   * @name app.dataanlaysis:analysis-customerrecommend-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the shop관리 등록/수정
   */

  webapp.controller('AnalysisCustomerrecommendDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate', '$timeout', '$filter',

    function AnalysisCustomerrecommendDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate, $timeout, $filter) {

      // #region 상수 정의
      // SQL Mapper Id 정의
      var UPDATE_SQL = 'DataAnalysis.updateAnalysisRfmcentroidsDetail';     // 수정 SQL
      var VIEW_SQL = 'DataAnalysis.getAnalysisRecommendDetail'; // 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-customerrecommend-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.dataanalysis.analysis-rfmcentroids-list.analysis-customerrecommend-detail'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-customerrecommend-detail';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'mlcustomerrecommend'; // 작업 테이블명
      var KEY_COLUMN_NM = 'RelateDataId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.lists = [];

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          RelateDataId: !isNullOrEmpty($stateParams.srch.RelateDataId) ? $stateParams.srch.RelateDataId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.RelateDataId = $stateParams.RelateDataId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.RelateDataId)) {
        vm.srch.RelateDataId = $stateParams.RelateDataId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      vm.srchDetail.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srchDetail.ActionId = $rootScope.gVariable.dataActionId;

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        RelateDataId: !isNullOrEmpty(vm.srch.RelateDataId) ? vm.srch.RelateDataId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.RelateDataId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = angular.copy(vm.srchDetail);
        data.CustomerCode = $stateParams.RelateDataId;

        postApi.sendPostApi('api/dataanalysis', 'getCustomerRecommend', data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data.similarities = result.body.docs[0].similarities;
              vm.data.recommended = result.body.docs[0].recommended;

              var data = [];
              angular.forEach(vm.data.recommended, function(item) {
                var word = {text:item.ProductName, size:(item.freq < 5 ? item.freq : 5) * 10};
                data.push(word);
              });

              drawWordCloud(data, 'wordcloud');

              vm.data.RelateDataId = result.body.docs[0].RelateDataId != null ? result.body.docs[0].RelateDataId : '';
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        var data = angular.copy(vm.data);
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          gAlert('', 'Menu.SAVED', {
            btn: '',
            fn: function () {
              // 화면 분할 모드에 따른 이동
              goNextPage(true);
            }
          });
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.RelateDataId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.RelateDataId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              RelateDataId: vm.data.RelateDataId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.RelateDataId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, RelateDataId: vm.data.RelateDataId});
        }
      }

      //함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.setData = setData;                     // 데이터 저장

      vm.goList = goList;                       // 목록 화면 이동
      // 데이터 조회
      getData();
    }]);

  })();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:analysis-customerrecommend-list-ctrl
   * @description Controller of the 고객 목록
   */
  webapp.controller('AnalysisCustomerrecommendListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',
    function AnalysisCustomerrecommendListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Masales.getCustomerListFromSalesListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Masales.getCustomerListFromSalesList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Masales.getSalesList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-customerrecommend-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.analysis-customerrecommend-list.analysis-customerrecommend-detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.dataanalysis.analysis-customerrecommend-list.analysis-customerrecommend-edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-customerrecommend-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.dataanalysis.analysis-customerrecommend-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'masales.customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'MASalesId'; // Primary Key Column
      var EXCEL_TITLE = '고객별 상품추천 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.RelatedDataId;

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
              vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = paramRelateDataId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

webapp.controller('AnalysisExecuteCtrl', [
    '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gConfirm', '$filter',
  function AnalysisExecuteCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalFactory, postApi, gConfirm, $filter) {
    var vm = this;
    vm.dataloader = false;

    var LIST_PAGE_URL = 'app.dataanalysis.analysis-execute';         // 목록 화면
    var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.analysis-execute.analysis-result';  // 목록 조회  화면
    var DETAIL_PAGE_URL = 'app.dataanalysis.analysis-result';       // 조회 화면

    if ($rootScope.gVariable.selectedShop != null) {
      vm.selectedShop = $rootScope.gVariable.selectedShop;
    } else {
      $rootScope.setDefaultSelectedShop();
    }

    $rootScope.$watchCollection('gVariable.selectedShop', function(newValue) {
      if (vm.selectedShop != null && vm.selectedShop.ActionId == newValue) return;
      vm.selectedShop = newValue;
    });

    console.log("$stateParams", $stateParams);
    if ($stateParams.page == undefined || $stateParams.page == "") {
      vm.currentPage = 1;
    } else {
      vm.currentPage = $stateParams.page;
    }

    vm.srch = {
      remark : '',
    };

    (function AnalysisExecuteCtrl() {
      vm.response = {};
    })();

    vm.listSize = [ 10, 25, 50, 100 ];

    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;
    vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
    vm.srch.ActionId = $rootScope.gVariable.dataActionId;

    vm.layout = $stateParams.layout ? $stateParams.layout : 'V'; // 화면 분할모드 :  H(수평), V(수직), N(기본)
    vm.anchor = "";
    setLayout(vm.layout); // 화면분할 모드 설정

    (function AnalysisExecuteCtrl() {
      // 목록 조회
      getList();
    })();

    vm.getList = getList;
    vm.runProcess = runProcess;
    vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
    vm.goDetail = goDetail;

    function runProcess() {
      if ($rootScope.gVariable.dataGroupId == null || $rootScope.gVariable.dataActionId == null) {
        gAlert('', '기본데이터 그룹과 작업이 지정되지 않았습니다.', {
          btn : '',
          fn : function() {
          }
        });
        return;
      }

      getList();
      vm.response.saved = [];
      vm.response.status = '';

      gConfirm('', '분석실행은 기존 결과를 삭제하고 다시 결과데이터를 생성합니다.<br>실행하시겠습니까?', {
        btn : '',
        fn : function() {
          vm.dataloader = true;

          var data = {};
          data.DatagroupId = $rootScope.gVariable.dataGroupId;
          data.ActionId = $rootScope.gVariable.dataActionId;
          data.selectType = '';

          /*
          postApi.sendPostApi('api/dataanalysis', 'getDataAnalysis', data, function (result) {
            vm.dataloader = false;

            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.lists = result.body.docs;
                console.log('vm.totalItems=', vm.totalItems, ",vm.currentPage=", vm.currentPage, ",vm.maxSize=", vm.maxSize, ",vm.numPages=", vm.numPages);
              } else {
                // 조회 실패
                vm.totalItems = 0;
              }
            }
          }, function (error) {
            // 조회 중 오류 발생
            vm.dataloader = false;
            console.error("Error> getDataAnalysis");
            console.table(error);
          });
          */

          postApi.sendPostApi('api/dataanalysis', 'callPythonService', data, function (result) {
            vm.dataloader = false;

            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.response = result.body.docs[0];
                //$('#regTitle').html(vm.lists);
              } else {
                // 조회 실패
              }
            }
          }, function (error) {
            // 조회 중 오류 발생
            vm.dataloader = false;
            console.error("Error> callPythonService");
            console.table(error);
          });
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    /**
     * 목록 조회
     *
     * @param
     * @return
     */
    function getList() {
      vm.dataloader = true; // Progressbar 표시
      var data = angular.copy(vm.srch);
      data.viewSize = 1000;
      data.mapCode = "DataAnalysis.getMaExeResultList";

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          // MetaColumn 사용
          if (result.body.docs.length > 0) {
            // 목록 데이터 표시
            vm.prevResult = result.body.docs;
          } else {
            // 데이터 조회 실패
            vm.prevResult = null;
          }
        }

        vm.dataloader = false; // Progressbar 숨김

      }, function (error) {
        vm.dataloader = false; // Progressbar 숨김

        // 조회 중 오류 발생
        console.error("Error> getList()");
        console.table(error);
      });
    }

    function goDetail(ResultType) {
      if (vm.layout == 'N') {
        // 등록/수정 화면 이동
        $state.go(DETAIL_PAGE_URL, {
          srch: ResultType
        });
      } else {
        // 목록 등록/수정 화면 이동
        $state.go(LIST_DETAIL_PAGE_URL, {
          srch: ResultType
        });
      }
    }

    /**
     * 화면 분할 모드 설정
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function setLayout(layout) {

      // 분할 모드 지정
      if (angular.isUndefined(layout)) {
        vm.layout = 'V';
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          // 수평
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          // 수직
          vm.anchor = "west";
          vm.paneMin = "500px";
          break;
        case "N":
          // 기본
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }
    /**
     * 화면 분할 모드 변경
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function setChangeLayout(layout) {
      // 분할 모드 설정값 저장
      $state.go(LIST_PAGE_URL, {layout:layout}, {reload: LIST_PAGE_URL});
    }
  } ]);

(function () {
  "use strict";

  /**
   * @ngdoc function
   * @name app.dataanlaysis:analysis-recommend-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the shop관리 등록/수정
   */

  webapp.controller('AnalysisRecommendDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate', '$timeout', '$filter',

    function AnalysisRecommendDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate, $timeout, $filter) {

      // #region 상수 정의
      // SQL Mapper Id 정의
      var UPDATE_SQL = 'DataAnalysis.updateAnalysisRfmcentroidsDetail';     // 수정 SQL
      var VIEW_SQL = 'DataAnalysis.getProductRecommend'; // 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-recommend-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.dataanalysis.analysis-recommend-list.analysis-rfmcentroids-edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-recommend-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'mlrecommend'; // 작업 테이블명
      var KEY_COLUMN_NM = 'RelateDataId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.lists = [];

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          RelateDataId: !isNullOrEmpty($stateParams.srch.RelateDataId) ? $stateParams.srch.RelateDataId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.RelateDataId = $stateParams.RelateDataId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.RelateDataId)) {
        vm.srch.RelateDataId = $stateParams.RelateDataId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      vm.srchDetail.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srchDetail.ActionId = $rootScope.gVariable.dataActionId;

      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        RelateDataId: !isNullOrEmpty(vm.srch.RelateDataId) ? vm.srch.RelateDataId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.RelateDataId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = angular.copy(vm.srchDetail);
        data.ProductCode = $stateParams.RelateDataId;

        postApi.sendPostApi('api/dataanalysis', 'getProductRecommend', data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data.similarities = result.body.docs[0].similarities;
              vm.data.recommended = result.body.docs[0].recommended;

              var data = [];
              angular.forEach(vm.data.recommended, function(item) {
                var size = (1 - item.distance) * 100;
                if (size > 50) size = 50;
                if (size < 10) size = 10;
                var word = {text:item.ProductName, size:size};
                data.push(word);
              });

              drawWordCloud(data, 'wordcloud');

              vm.data.RelateDataId = result.body.docs[0].RelateDataId != null ? result.body.docs[0].RelateDataId : '';
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        var data = angular.copy(vm.data);
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          gAlert('', 'Menu.SAVED', {
            btn: '',
            fn: function () {
              // 화면 분할 모드에 따른 이동
              goNextPage(true);
            }
          });
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.RelateDataId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.RelateDataId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              RelateDataId: vm.data.RelateDataId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.RelateDataId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, RelateDataId: vm.data.RelateDataId});
        }
      }

      //함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.setData = setData;                     // 데이터 저장

      vm.goList = goList;                       // 목록 화면 이동
      // 데이터 조회
      getData();
    }]);

  })();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:analysis-recommend-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('AnalysisRecommendListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',
    function AnalysisRecommendListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Masales.getGoodsListFromSalesListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Masales.getGoodsListFromSalesList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Masales.getSalesList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-recommend-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.analysis-recommend-list.analysis-recommend-detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.dataanalysis.analysis-recommend-list.analysis-recommend-edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-recommend-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.dataanalysis.analysis-recommend-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'masales.goods'; // 작업 테이블명
      var KEY_COLUMN_NM = 'MASalesId'; // Primary Key Column
      var EXCEL_TITLE = '판매목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.RelatedDataId;

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
              vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = paramRelateDataId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:cluster-three-plot
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('AnalysisResultCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate', '$filter',
    function AnalysisResultCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate, $filter) {

      var vm = this;
      vm.srch = {};
      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;
      vm.getRfmList = getRfmList;
      vm.rfmlist = [{}, {}, {}];

      (function AnalysisResultCtrl() {
        vm.resultType = $stateParams.srch? $stateParams.srch : 'rfmCluster3d';
        getRfmList('0', vm.resultType);
      })();

      function getRfmList(divIdNum, resultType) {
        var data = angular.copy(vm.srch);

        data.selectType = 'List';
        data.ResultType = resultType;
        data.mapCode = 'DataAnalysis.getMaExeResult';

        postApi.select(data, function (result) {
        //postApi.sendPostApi('api/dataanalysis', 'getRfmList', data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.rfmlist[divIdNum] = binary2text(result.body.docs[0].ResultContents);
              $('#regTitle' + divIdNum).html(vm.rfmlist[divIdNum]);
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getDataGroupAndActionList()");
          console.table(error);
        });
      }
    }]);
})();

(function () {
  "use strict";

  /**
   * @ngdoc function
   * @name app.dataanlaysis:analysis-rfmcentroids-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the shop관리 등록/수정
   */

  webapp.controller('AnalysisRfmcentroidsEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate', '$timeout', '$filter',

    function AnalysisRfmcentroidsEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate, $timeout, $filter) {

      // #region 상수 정의
      // SQL Mapper Id 정의
      var UPDATE_SQL = 'DataAnalysis.updateAnalysisRfmcentroidsDetail';     // 수정 SQL
      var VIEW_SQL = 'DataAnalysis.getAnalysisRfmcentroidsDetail'; // 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-rfmcentroids-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.dataanalysis.analysis-rfmcentroids-list.analysis-rfmcentroids-edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-rfmcentroids-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'marfmcentroids'; // 작업 테이블명
      var KEY_COLUMN_NM = 'RelateDataId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.lists = [];

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          RelateDataId: !isNullOrEmpty($stateParams.srch.RelateDataId) ? $stateParams.srch.RelateDataId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.RelateDataId = $stateParams.RelateDataId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.RelateDataId)) {
        vm.srch.RelateDataId = $stateParams.RelateDataId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        RelateDataId: !isNullOrEmpty(vm.srch.RelateDataId) ? vm.srch.RelateDataId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.RelateDataId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = result.body.docs[0].RelateDataId != null ? result.body.docs[0].RelateDataId : '';
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        var data = angular.copy(vm.data);
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          goNextPage(true);
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.RelateDataId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.RelateDataId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              RelateDataId: vm.data.RelateDataId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.RelateDataId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, RelateDataId: vm.data.RelateDataId});
        }
      }

      //함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.setData = setData;                     // 데이터 저장

      vm.goList = goList;                       // 목록 화면 이동
      // 데이터 조회
      getData();
    }]);

  })();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:analysis-rfmcentroids-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('AnalysisRfmcentroidsListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',
    function AnalysisRfmcentroidsListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'DataAnalysis.getAnalysisRfmcentroidsListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'DataAnalysis.getAnalysisRfmcentroidsList';    // 목록 조회 SQL
      var EXCEL_SQL = 'MaDatagroup.getExcelList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.analysis-rfmcentroids-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.analysis-rfmcentroids-list.analysis-rfmcentroids-detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.dataanalysis.analysis-rfmcentroids-list.analysis-rfmcentroids-edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.analysis-rfmcentroids-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.dataanalysis.analysis-rfmcentroids-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'marfmcentroids'; // 작업 테이블명
      var KEY_COLUMN_NM = 'RfmcentroidsId'; // Primary Key Column
      var EXCEL_TITLE = '고객클러스터 기준 목록'; // 고객클러스터 기준 목록
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.RelatedDateId;

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
              vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
        vm.srch.ActionId = $rootScope.gVariable.dataActionId;

        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = paramRelateDataId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
  "use strict";
 /**
 * @ngdoc function
 * @name app.dataanalysis:sales-detail-ctrl
 * @description # 회원사 조회 Controller of the 회원사관리
 */
webapp.controller('DaCustomerDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'CompanyAPISrv', 'postApi',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService',

    /**
     * 판매데이터관리 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function DaCustomerDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, postApi, customFieldApi, gAlert, gConfirm, fileUploadService) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          customerID : $stateParams.srch.customerID ? $stateParams.srch.customerID : 1,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'masales.customerdetail',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if ($stateParams.customerID) {
        vm.srch.customerID = $stateParams.customerID;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = 'MASalesId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "List"; // For CustomColumn and FileAttachment
      vm.srchDetail.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srchDetail.ActionId = $rootScope.gVariable.dataActionId;
      vm.srchDetail.tableNm = 'masales.customerdetail';

      // 업로드 파일 목록
      var fileUploadId = 0;

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('Masales.getSalesListByCustomerID', vm.srchDetail, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;

              var prevOrderNum = '';
              angular.forEach(vm.lists, function (item) {
                if (prevOrderNum != item.orderNum) {
                  item.newItemClass = 'bg-lightgray';
                }

                console.log(prevOrderNum + ',' + item.orderNum + ',' + item.newItemClass);

                prevOrderNum = item.orderNum;
              });

              return;
            }

          } else {
            gAlert('알림', data.responseVO.body.docs[0].errMessage);
          }
        },function(data) {
          vm.dataloader = false;
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;

      // 데이터 조회
      getData();
  } ]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:da-customer-list-ctrl
   * @description Controller of the 고객 목록
   */
  webapp.controller('DaCustomerListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function DaCustomerListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Masales.getCustomerListFromSalesListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Masales.getCustomerListFromSalesList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Masales.getSalesList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.da-customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.da-customer-list.da-customer-detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.dataanalysis.da-customer-list.da-customer-edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.da-customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.dataanalysis.da-customer-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'masales.customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'MASalesId'; // Primary Key Column
      var EXCEL_TITLE = '고객목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.RelateDataId;

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
              vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = paramRelateDataId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            customerID: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            customerID: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();



(function() {
  "use strict";
 /**
 * @ngdoc function
 * @name app.dataanalysis:sales-detail-ctrl
 * @description # 회원사 조회 Controller of the 회원사관리
 */
webapp.controller('DaGoodsDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'CompanyAPISrv', 'postApi', '$filter',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService',

    /**
     * 판매데이터관리 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function DaGoodsDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, postApi, $filter, customFieldApi, gAlert, gConfirm, fileUploadService) {
      // View Model
      var vm = this;

      var LIST_CNT_SQL = 'Masales.getSalesListByProductCodeCnt'; // 목록 건수 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.da-goods-list';         // 목록 화면

      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          productCode : $stateParams.productCode,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'masales.goodsdetail',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }


      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수


      vm.layout = $rootScope.gVariable.layoutBoard;

      if ($stateParams.customerID) {
        vm.srch.productCode = $stateParams.productCode;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'MASalesId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "List"; // For CustomColumn and FileAttachment
      vm.srchDetail.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srchDetail.ActionId = $rootScope.gVariable.dataActionId;

      // 조회 데이터
      vm.data = {
        tableNm : 'masales.goodsdetail',
        productCode : vm.srch.ProductCode,
      };

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;

        getListCnt();

        vm.srchDetail.customerID = vm.data.productCode;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment

        postApi.select('Masales.getSalesListByProductCode', vm.srchDetail, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;


              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            }

          } else {
            gAlert('알림', data.responseVO.body.docs[0].errMessage);
          }
        },function(data) {
          vm.dataloader = false;
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

            /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호
        getData();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srchDetail); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정

              vm.totalItems = result.body.docs[0].cnt;

            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go(LIST_PAGE_URL, {
          srch : srch
        });
      }



      // 함수 선언
      vm.getData = getData;
      vm.goList = goList;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.getSearch = getSearch;                   // 데이터 조회

      // 데이터 조회
      getData();
  } ]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:sales-list-ctrl
   * @description Controller of the 작업 목록
   */
  webapp.controller('DaGoodsListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function DaGoodsListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Masales.getGoodsListFromSalesListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Masales.getGoodsListFromSalesList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Masales.getSalesList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.da-goods-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.da-goods-list.da-goods-detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.dataanalysis.da-goods-list.da-goods-edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.da-goods-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.dataanalysis.da-goods-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'masales.goods'; // 작업 테이블명
      var KEY_COLUMN_NM = 'MASalesId'; // Primary Key Column
      var EXCEL_TITLE = '판매목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.productCode;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
              vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = paramRelateDataId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            productCode: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            productCode: paramRelateDataId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
  "use strict";
 /**
 * @ngdoc function
 * @name app.dataanalysis:sales-detail-ctrl
 * @description # 회원사 조회 Controller of the 회원사관리
 */
webapp.controller('SalesDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'CompanyAPISrv', 'postApi',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService',

    /**
     * 판매데이터관리 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function SalesDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, postApi, customFieldApi, gAlert, gConfirm, fileUploadService) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.da-sales-list';         // 목록 화면

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          RelateDataId : $stateParams.srch.RelateDataId ? $stateParams.srch.RelateDataId : 1,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'masales',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if ($stateParams.RelateDataId) {
        vm.srch.RelateDataId = $stateParams.RelateDataId;
      }

      vm.srchDetail = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'MASalesId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        tableNm : 'masales',
        RelateDataId : vm.srch.RelateDataId,
      };

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.RelateDataId = vm.data.RelateDataId;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('Masales.getSalesDetail', vm.srchDetail, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {

                // 화면 표시 컬럼 목록
                if (item.EditColumnShowYN === 'Y') {
                  vm.srchDetail.viewColumns[item.ColumnPhysicalNm] = true;
                }
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            }

          } else {
            gAlert('알림', data.responseVO.body.docs[0].errMessage);
          }
        },function(data) {
          vm.dataloader = false;
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go(LIST_PAGE_URL, {
          srch : srch
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.goList = goList;

      // 데이터 조회
      getData();
  } ]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:sales-list-ctrl
   * @description Controller of the 작업 목록
   */
  webapp.controller('DaSalesListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function DaSalesListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Masales.getSalesCount'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Masales.getSalesList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Masales.getSalesList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.da-sales-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.da-sales-list.da-sales-detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.dataanalysis.da-sales-list.da-sales-edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.da-sales-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.dataanalysis.da-sales-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'masales'; // 작업 테이블명
      var KEY_COLUMN_NM = 'MASalesId'; // Primary Key Column
      var EXCEL_TITLE = '판매목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.orderDateFrom = $rootScope.getDateFormat(vm.srch.orderDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.orderDateTo = $rootScope.getDateFormat(vm.srch.orderDateTo);
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.RelateDataId;

      vm.srch.DatagroupId = $rootScope.gVariable.dataGroupId;
      vm.srch.ActionId = $rootScope.gVariable.dataActionId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.orderDateFrom = $filter('localToUtc')(data.orderDateFrom, 'from');
        data.orderDateTo = $filter('localToUtc')(data.orderDateTo, 'to');
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;

              vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.orderDateFrom = $filter('localToUtc')(data.orderDateFrom, 'from');
        data.orderDateTo = $filter('localToUtc')(data.orderDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = paramRelateDataId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'orderDate')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.dataanalysis', {
      url: '/dataanalysis',
      template: '<div ui-view></div>',
    }).state('app.dataanalysis.datagroup-list', {
      url: '/datagroup-list/:srch',
      templateUrl: 'app/dataanalysis/datagroup-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.datagroup-list.datagroup-edit', {
      url: '/datagroup-edit/:RelateDataId',
      templateUrl: 'app/dataanalysis/datagroup-edit.html',
    }).state('app.dataanalysis.datagroup-edit', {
      url: '/datagroup-edit/:srch/:RelateDataId',
      templateUrl: 'app/dataanalysis/datagroup-edit.html',
    }).state('app.dataanalysis.da-sales-list', {
      url: '/da-sales-list/:srch',
      templateUrl: 'app/dataanalysis/da-sales-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.da-sales-list.da-sales-detail', {
      url: '/da-sales-detail/:RelateDataId',
      templateUrl: 'app/dataanalysis/da-sales-detail.html',
    }).state('app.dataanalysis.da-sales-detail', {
      url: '/da-sales-detail/:srch/:RelateDataId',
      templateUrl: 'app/dataanalysis/da-sales-detail.html',
    }).state('app.dataanalysis.da-customer-list', {
      url: '/da-customer-list/:srch',
      templateUrl: 'app/dataanalysis/da-customer-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.da-customer-list.da-customer-detail', {
      url: '/da-customer-detail/:customerID',
      templateUrl: 'app/dataanalysis/da-customer-detail.html',
    }).state('app.dataanalysis.da-customer-detail', {
      url: '/da-customer-detail/:srch/:customerID',
      templateUrl: 'app/dataanalysis/da-customer-detail.html',
    }).state('app.dataanalysis.da-goods-list', {
      url: '/da-goods-list/:srch',
      templateUrl: 'app/dataanalysis/da-goods-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.da-goods-list.da-goods-detail', {
      url: '/da-goods-detail/:productCode',
      templateUrl: 'app/dataanalysis/da-goods-detail.html',
    }).state('app.dataanalysis.da-goods-detail', {
      url: '/da-goods-detail/:srch/:productCode',
      templateUrl: 'app/dataanalysis/da-goods-detail.html',
    }).state('app.dataanalysis.analysis-execute', {
      url : '/analysis-execute/:layout',
      templateUrl : 'app/dataanalysis/analysis-execute.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.analysis-execute.analysis-result', {
      url: '/analysis-result/:srch',
      templateUrl: 'app/dataanalysis/analysis-result.html',
    }).state('app.dataanalysis.analysis-result', {
      url: '/analysis-result/:srch',
      templateUrl: 'app/dataanalysis/analysis-result.html',
    }).state('app.dataanalysis.analysis-rfmcentroids-list', {
      url: '/analysis-rfmcentroids-list/:srch',
      templateUrl: 'app/dataanalysis/analysis-rfmcentroids-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.analysis-rfmcentroids-list.analysis-rfmcentroids-edit', {
      url: '/analysis-rfmcentroids-edit/:RelateDataId',
      templateUrl: 'app/dataanalysis/analysis-rfmcentroids-edit.html',
    }).state('app.dataanalysis.analysis-rfmcentroids-edit', {
      url: '/analysis-rfmcentroids-edit/:srch/:RelateDataId',
      templateUrl: 'app/dataanalysis/analysis-rfmcentroids-edit.html',
    }).state('app.dataanalysis.analysis-recommend-list', {
      url: '/analysis-recommend-list/:srch',
      templateUrl: 'app/dataanalysis/analysis-recommend-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.analysis-recommend-list.analysis-recommend-detail', {
      url: '/analysis-recommend-detail/:RelateDataId',
      templateUrl: 'app/dataanalysis/analysis-recommend-detail.html',
    }).state('app.dataanalysis.analysis-recommend-detail', {
      url: '/analysis-recommend-detail/:srch/:RelateDataId',
      templateUrl: 'app/dataanalysis/analysis-recommend-detail.html',
    }).state('app.dataanalysis.analysis-customerrecommend-list', {
      url: '/analysis-customerrecommend-list/:srch',
      templateUrl: 'app/dataanalysis/analysis-customerrecommend-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.analysis-customerrecommend-list.analysis-customerrecommend-detail', {
      url: '/analysis-customerrecommend-detail/:RelateDataId',
      templateUrl: 'app/dataanalysis/analysis-customerrecommend-detail.html',
    }).state('app.dataanalysis.analysis-customerrecommend-detail', {
      url: '/analysis-customerrecommend-detail/:srch/:RelateDataId',
      templateUrl: 'app/dataanalysis/analysis-customerrecommend-detail.html',
    }).state('app.dataanalysis.analysis-customerrank-list', {
      url: '/analysis-customerrank-list/:srch',
      templateUrl: 'app/dataanalysis/analysis-customerrank-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.analysis-action-compare', {
      url: '/analysis-action-compare',
      templateUrl: 'app/dataanalysis/analysis-action-compare.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.analysis-cluster-compare', {
      url: '/analysis-cluster-compare',
      templateUrl: 'app/dataanalysis/analysis-cluster-compare.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.analysis-cluster-compare.result', {
      url: '/result/:srch',
      templateUrl: 'app/dataanalysis/analysis-cluster-compare-result.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.analysis-cluster-compare-result', {
      url: '/analysis-cluster-compare-result/:srch',
      templateUrl: 'app/dataanalysis/analysis-cluster-compare-result.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.dataanalysis.analysis-cluster-three-plot', {
      url: '/analysis-cluster-three-plot/:resultType',
      templateUrl: 'app/dataanalysis/analysis-cluster-three-plot.html',
    });
  }
})();

(function() {
  "use strict";
 /**
 * @ngdoc function
 * @name app.dataanalysis:datagroup-detail-ctrl
 * @description # 회원사 조회 Controller of the 회원사관리
 */
webapp.controller('DatagroupDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'CompanyAPISrv', 'postApi',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService',


    /**
     * 회원사관리 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function DatagroupDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, postApi, customFieldApi, gAlert, gConfirm, fileUploadService) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          TenantId : $stateParams.srch.TenantId ? $stateParams.srch.TenantId : 1,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'tenant',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if ($stateParams.TenantId) {
        vm.srch.TenantId = $stateParams.TenantId;
      }

      vm.srchDetail = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        tableNm : 'tenant',
        TenantId : vm.srch.TenantId,
      };

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('Tenant.getTenantDetail', vm.srchDetail, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {

                // 화면 표시 컬럼 목록
                if (item.EditColumnShowYN === 'Y') {
                  vm.srchDetail.viewColumns[item.ColumnPhysicalNm] = true;
                }
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            }

          } else {
            gAlert('알림', data.responseVO.body.docs[0].errMessage);
          }
        },function(data) {
          vm.dataloader = false;
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getFileList() {

        /* vm.srch.tableNm = 'Companys';
        if (vm.srch.CompanyId === null || vm.srch.CompanyId === "0") {
          return;
        } */

        var data = vm.srchDetail;
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var uploadFileList = [];

              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  typeId : 'file',
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                  delState : '',
                }

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              return;
            }
          }
        }, function(data) {
          console.error('Error-getFileList', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.data;
        data.mapCode = 'Tenant.deleteTenantDetail';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.system.company-list', {
                  srch:srch
                }, {reload:'app.system.company-list'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> company-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.system.company-list', {
          srch : srch
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.system.company-edit', {
            srch : srch, TenantId : vm.data.TenantId
          });
        } else {
          $state.go('app.system.company-list.edit', {
            srch : srch, TenantId : vm.data.TenantId
          });
        }
      }

      // 함수 선언
      vm.getData = getData;
      vm.getFileList = getFileList;
      vm.deleteDetail = deleteDetail;
      vm.goList = goList;
      vm.goEdit = goEdit;

      // 데이터 조회
      getData();
      getFileList();
  } ]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanlaysis:datagroup-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the shop관리 등록/수정
   */

  webapp.controller('DatagroupEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', '$translate', '$timeout', '$filter',

    function DatagroupEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, $translate, $timeout, $filter) {

      // #region 상수 정의
      // SQL Mapper Id 정의
      var INSERT_DATAGROUP_SQL = 'MaDatagroup.insertDatagroupDetail';     // DataGroup등록 SQL
      var INSERT_DATA_SQL = 'MaDatagroup.insertMasales';     // Data 등록 SQL
      var UPDATE_SQL = 'MaDatagroup.updateDatagroupDetail';     // 수정 SQL
      var VIEW_SQL = 'MaDatagroup.getDatagroupDetail'; // 조회 SQL
      var DEL_SQL = 'MaDatagroup.deleteDatagroupDetail';  // 삭제 SQL
      var DEL_ACTION_LIST_SQL = 'MaDatagroup.deleteDatagroupActionList';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.datagroup-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.dataanalysis.datagroup-list.datagroup-edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.datagroup-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'madatagroup'; // 작업 테이블명
      var KEY_COLUMN_NM = 'RelateDataId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트
      vm.lists = [];
      vm.modify = 'N';

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          RelateDataId: !isNullOrEmpty($stateParams.srch.RelateDataId) ? $stateParams.srch.RelateDataId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.RelateDataId = $stateParams.RelateDataId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.RelateDataId)) {
        vm.srch.RelateDataId = $stateParams.RelateDataId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      vm.columnMapActionList = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        RelateDataId: !isNullOrEmpty(vm.srch.RelateDataId) ? vm.srch.RelateDataId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.RelateDataId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];

              // 목록에서 추가 버튼 클릭 시, 초기값 설정
              if (!isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.data.UseYN = 'Y';
                vm.data.MaShopId = '';
                vm.data.ExtVarchar02 = 'cafe24';
              }

              vm.data.RelateDataId = result.body.docs[0].RelateDataId != null ? result.body.docs[0].RelateDataId : '';

              //Date형식 처리
              if (!isValidDate(vm.data.BeginDate) && vm.data.BeginDate != null && vm.data.BeginDate != "") vm.BeginDate = moment(vm.data.BeginDate).toDate();
              if (!isValidDate(vm.data.EndDate) && vm.data.EndDate != null && vm.data.EndDate != "") vm.EndDate = moment(vm.data.EndDate).toDate();
              vm.data.BeginDate = moment(vm.data.BeginDate).format('YYYY-MM-DD');
              vm.data.EndDate = moment(vm.data.EndDate).format('YYYY-MM-DD');
            } else {
              vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getActionList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.DatagroupId = vm.srch.RelateDataId;
        data.mapCode = "Maaction.getActionList";
        data.tableNm = "maaction";             // 작업 테이블명
        data.IdName = "ActionId";

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumnsAction = result.body.desc;
              angular.forEach(vm.listColumnsAction, function (item) {
                vm.columnMapActionList[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumnsAction)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                  if (!isValidDate(item.BeginDate) && item.BeginDate != null && item.BeginDate != "") item.ctrlBeginDate = moment(item.BeginDate).toDate();
                  if (!isValidDate(item.EndDate) && item.EndDate != null && item.EndDate != "") item.ctrlEndDate = moment(item.EndDate).toDate();
                  item.BeginDate = moment(item.BeginDate).format('YYYY-MM-DD');
                  item.EndDate = moment(item.EndDate).format('YYYY-MM-DD');
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }
            } else {
              // 데이터 조회 실패
              //vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.DatagroupNm)) {
          errMsg = errMsg + '- 데이터그룹명을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.tenantData.ExtVarchar03)) {
          errMsg = errMsg + '- 쇼핑몰아이디를 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.MaShopNm)) {
          errMsg = errMsg + '- 쇼핑몰명을 입력하세요.<br/>';
        }

        if (vm.BeginDate == undefined) {
          errMsg = errMsg + '- 시작일을 선택하세요.<br/>';
        }
        if (vm.EndDate == undefined) {
          errMsg = errMsg + '- 종료일을 선택하세요.<br/>';
        }

        if(vm.lists.length == 0) {
          errMsg = errMsg + '- 작업목록을 추가하세요.<br/>';
        }

        if(vm.lists.length > 0) {
          angular.forEach(vm.lists, function(item, index) {
            if (isNullOrEmpty(item.ActionNm)) {
              errMsg = errMsg + '- ' + (index+1) + '번째 작업목록 작업명을 입력하세요.<br/>';
            }
            if(item.ctrlBeginDate == undefined) {
              errMsg = errMsg + '- ' + (index+1) + '번째 작업목록 시작일을 선택하세요.<br/>';
            }
            if(item.ctrlEndDate == undefined) {
              errMsg = errMsg + '- ' + (index+1) + '번째 작업목록 종료일을 선택하세요.<br/>';
            }
          });
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return;
        } else {
          setData();
        }

        return true;
        // #endregion 필수항목 체크
      }

      function changeDefaultDataGroup(data) {
        if (data.UseYN == 'Y') {
          $rootScope.setGVariable('dataGroupId', data.RelateDataId);
          $rootScope.setGVariable('dataActionId', data.ActionId);
          $rootScope.setGVariable('dataGroupNm', data.DatagroupNm);
          if (data.ActionId) {
            $rootScope.setGVariable('dataActionNm', data.ActionNm + ' (' + data.ABeginDate + '~' + data.AEndDate + ')');
          }
        }
      }

      function setDataConfirm() {
        if (vm.data.UseYN == 'N') {
          gConfirm('', '기본그룹이 아닙니다. 기본그룹으로 지정하시겠습니까?', {
            btn: '',
            fn: function () {
              vm.data.UseYN = 'Y';
              getIsValidData();
            }
          }, {
            btn: '',
            fn: function () {
              getIsValidData();
            }
          });
        } else {
          getIsValidData();
        }
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        vm.data.MaShopId = vm.tenantData.ExtVarchar03;

        var data = angular.copy(vm.data);

        if (vm.data.BeginDate != null ) data.BeginDate = $filter('localToUtc')(vm.data.BeginDate, 'from');
        if (vm.data.EndDate != null ) data.EndDate = $filter('localToUtc')(vm.data.EndDate, 'to');

        var Lists = angular.copy(vm.lists);
        angular.forEach(Lists, function(item) {
          if (item.UseYN == 'Y') {
            data.ActionId = item.RelateDataId;
            data.ActionNm = item.ActionNm;
            data.ABeginDate = item.BeginDate;
            data.AEndDate = item.EndDate;
          }

          if(item.Type == 'A') {
            if (item.BeginDate != null ) {
              item.BeginDate = $filter('localToUtc')(item.BeginDate, 'from');
            }
            if (item.EndDate != null ) {
              item.EndDate = $filter('localToUtc')(item.EndDate, 'to');
            }
          } else {
            item.BeginDate = $filter('localToUtc')(moment(item.BeginDate).toDate(), 'from');
            item.EndDate = $filter('localToUtc')(moment(item.EndDate).toDate(), 'to');
          }
        });

        data.Lists = Lists;

        if (isNullOrEmpty(data.RelateDataId)) {
          // 신규 등록
          data.mapCode = INSERT_DATAGROUP_SQL;
          postApi.insert(data, function (result) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            changeDefaultDataGroup(data);
            vm.modify = 'N';
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            changeDefaultDataGroup(data);
            goNextPage(true);
            vm.modify = 'N';
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }

        if (data.DataType == 'cafe24') {
          data.mapCode = INSERT_DATA_SQL;
          /* postApi.insert(INSERT_DATA_SQL, data, function (result) {
            if (result.header.status != CONSTANT.HttpStatus.OK) {
              console.error("Error> setInsertUpdateDetail()");
            gAlert('', result.body.docs[0].errMessage);
            }
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          }); */
        }
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.RelateDataId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.RelateDataId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              RelateDataId: vm.data.RelateDataId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.RelateDataId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, RelateDataId: vm.data.RelateDataId});
        }
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }
      function addAction(type) {
        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
        var newLine = {
          RelateDataId : newnum.toString(36),
          ActionNm : '',
          RegDate : '',
          EndDate : null,
          BeginDate : null,
          UseYN : 'N',
          MallId : 1,
          DatagroupId : vm.data.RelateDataId != null ? vm.data.RelateDataId : null,
          RegUserNm : '',
          Type : type
        };
        vm.lists.push(newLine);
      }

      function checkUse(row) {
        angular.forEach(vm.lists, function (item) {
          if(item.RelateDataId == row.RelateDataId) {
            item.UseYN = 'Y';
          } else {
            item.UseYN = 'N';
          }
        })
      }

      function deleteActionList(row) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelActionList(row);
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });

      }

      function setDelActionList(row) {

        if(row.Type == 'A') {
          vm.lists.splice(vm.lists.indexOf(row), 1);

        } else {

          var data = angular.copy(row) ;

          data.mapCode = DEL_ACTION_LIST_SQL;

          postApi.update(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "삭제되었습니다.", {
              btn: "",
              fn: function () {
                vm.lists.splice(vm.lists.indexOf(row), 1);
              }
            });
            return;
          }
          console.error("Error> setInsertUpdateDetail()");
          gAlert('', result.body.docs[0].errMessage);
            }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      function goEdit () {
        vm.modify = 'Y';
      }

      function getTenantData() {
        vm.dataloader = true; // Progressbar 표시

        var data = {};
        data.mapCode = 'Tenant.getTenantCafe24Prop';

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.tenantData = result.body.docs[0];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getTenantData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getActionList = getActionList;
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인

      vm.setDataConfirm = setDataConfirm;       // 데이터 저장 확인
      vm.setData = setData;                     // 데이터 저장

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제
      vm.addAction = addAction;
      vm.checkUse = checkUse;             // 기본사용 변경
      vm.deleteActionList = deleteActionList; // 작업목록 삭제
      vm.goEdit = goEdit;
      // 데이터 조회
      getData();
      getActionList();
      getTenantData();
    }]);

  })();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dataanalysis:datagroup-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('DatagroupListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function DatagroupListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'MaDatagroup.getDatagroupCount'; // 목록 건수 조회 SQL
      var LIST_SQL = 'MaDatagroup.getDatagroupList';    // 목록 조회 SQL
      var EXCEL_SQL = 'MaDatagroup.getExcelList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.dataanalysis.datagroup-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.dataanalysis.datagroup-list.datagroup-detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.dataanalysis.datagroup-list.datagroup-edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.dataanalysis.datagroup-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.dataanalysis.datagroup-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'madatagroup'; // 작업 테이블명
      var KEY_COLUMN_NM = 'DatagroupId'; // Primary Key Column
      var EXCEL_TITLE = 'Datagroup 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        vm.currentPage = vm.srch.page;
      }

      $scope.selectedRow = $stateParams.RelateDataId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
              vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션

        $scope.selectedRow = paramRelateDataId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        $scope.selectedRow = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramRelateDataId) {
        var srch = $stateParams.srch; // 검색 옵션
        $scope.selectedRow = paramRelateDataId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            RelateDataId: paramRelateDataId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $rootScope.changeLayout(layout);

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'JoinDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
  "use strict";
  PanelsWellsController.$inject = [];
  /** @ngInject */
  function PanelsWellsController() {}
  var panelsWells = {
    transclude: true,
    bindings: {},
    templateUrl: "app/panels-wells/panels-wells.html",
    controller: PanelsWellsController,
    controllerAs: "panelsWells"
  };
  webapp.component("panelsWells", panelsWells);
})();

webapp.controller('GanttListCtrl', [
    '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gConfirm', '$filter',
  function GanttListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalFactory, postApi, gConfirm, $filter) {
    var vm = this;
    vm.dataloader = false;

    $scope.data = [
      {name: 'row1', tasks: [
          {name: 'task1', from: '2020-01-02', to: '2020-01-17'},
          {name: 'task2', from: '2020-01-20', to: '2020-01-24'}
          ]
      },
      {name: 'row2', tasks: [
          {name: 'task3', from: '2020-02-02', to: '2020-02-12'},
          {name: 'task4', from: '2020-02-12', to: '2020-02-22'}
        ]
      },
    ];

  } ]);

webapp.controller('GanttListGoogleCtrl', [
    '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gConfirm', '$filter',
  function GanttListGoogleCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalFactory, postApi, gConfirm, $filter) {
    var vm = this;
    vm.dataloader = false;

    $scope.data = [
      {name: 'row1', tasks: [
          {name: 'task1', from: '2020-01-02', to: '2020-01-17'},
          {name: 'task2', from: '2020-01-20', to: '2020-01-24'}
          ]
      },
      {name: 'row2', tasks: [
          {name: 'task3', from: '2020-02-02', to: '2020-02-12'},
          {name: 'task4', from: '2020-02-12', to: '2020-02-22'}
        ]
      },
    ];

  } ]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.project-google', {
      url : '/project-google',
      templateUrl: 'app/project/gantt-list-google.html',
      requiresAuthentication: true
    });
  }
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('PopupsEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function PopupsEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmApplication.insertPopup'; // 등록 SQL
      var UPDATE_SQL = 'WjmApplication.updatePopup'; // 수정 SQL
      var LIST_SQL = 'WjmApplication.getPopupList'; // 조회 SQL
      var DEL_SQL = 'WjmApplication.deletePopup';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.popup.popup-list';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.popup.popup-list.edit';         // 목록 조회 화면
      var EDIT_PAGE_URL = 'app.popup.popup-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'popups'; // 작업 테이블명
      var EXCEL_TITLE = '팝업 목록'; // 엑셀파일 이름

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.keyId = $stateParams.keyId ? $stateParams.keyId : 1;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};


      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        var data = vm.srchDetail;
        data.mapCode = LIST_SQL;
        data.PopupId = $stateParams.keyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];

            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       */
      function setData() {


        var data = angular.copy(vm.data); // 사용자 입력 데이터
        var html = oEditors.getById["strHtml"].getIR();
        data.Contents = html;
        console.log(vm.keyId);
        if (vm.keyId == 1) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.mapCode = UPDATE_SQL;
          data.PopupId = $stateParams.keyId;
          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs[0].RelateDataId !== null) {
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
      }else{
        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }
    }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if ($stateParams.keyId == 1){
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(EDIT_PAGE_URL, {
              srch: srch,
              keyId: $stateParams.keyId
            }, {reload:EDIT_PAGE_URL});
          }
        } else {
          if (reloadList) {
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
            $state.go(LIST_EDIT_PAGE_URL, {
              srch: srch,
              keyId: $stateParams.keyId
            });
          }
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, { srch: srch }, {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      function preview(){

        var imgurl = '';
        if($rootScope.gVariable.TenantId == '8LETQJJ81A'){
          imgurl = 'assets/images/center-main.JPG';
        }else{
          imgurl = 'assets/images/home-main.JPG';
        }

        var ctrl = 'previewCtrl as vc';
        var popHtml = oEditors.getById["strHtml"].getIR();

        var paramData = {data : vm.data, url : imgurl, popHtml : popHtml};
        var modalInstance = modalFactory.open('popup-preview', 'components/modal/preview/preview.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      }

      // 함수 정의
      vm.preview = preview;
      vm.getData = getData;                     // 데이터 조회

      vm.setData = setData;                     // 데이터 저장

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      getData();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('PopupsListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function PopupsListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmApplication.getPopupListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmApplication.getPopupList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmApplication.getPopupExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmApplication.deletePopupList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.popup.popup-list';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.popup.popup-list.edit';         // 목록 조회 화면
      var EDIT_PAGE_URL = 'app.popup.popup-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'popups'; // 작업 테이블명
      var EXCEL_TITLE = '팝업 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김


      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.currentPage = 1;
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo); // YYYY-MM-DD 를 date type 으로 변환
        vm.currentPage = vm.srch.page;
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();

      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 추가 및 수정 화면
      function goAdd(){
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: 1
          });
        }
      }

      // 조회 화면
      function goView(paramKeyId) {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].PopupId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        });
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      setInitData();
    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.popup', {
      url : '/popup',
      template : '<div ui-view></div>',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.popup.popup-list', {
      url : '/popup-list/:srch',
      templateUrl : 'app/popup/popup-list.html',
    }).state('app.popup.popup-edit', {
      url : '/popup-edit/:srch/:keyId',
      templateUrl : 'app/popup/popup-edit.html',
    }).state('app.popup.popup-list.edit', {
      url : '/edit/:srch/:keyId',
      templateUrl : 'app/popup/popup-edit.html',
    });
  }
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:ccreport01-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('CCReport01DetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CCReport01DetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'CvsReport.getCCReport01DetailCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'CvsReport.getCCReport01Detail';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getCCReport01Excel'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.user-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.user-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.user-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.user-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.user-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'ccreport01detail'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CustId'; // Primary Key Column
      var EXCEL_TITLE = '당월 지급 CC 현황'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          keyId : $stateParams.keyId,
        };
      } else {

        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.EntryDtFrom = $rootScope.getDateFormat(vm.srch.EntryDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.EntryDtTo = $rootScope.getDateFormat(vm.srch.EntryDtTo);
        vm.currentPage = vm.srch.page;
        vm.srch.keyId = $stateParams.keyId;

      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {

        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        vm.purchDateFrom = moment(vm.srch.CalcDateFrom).subtract(1, 'months').startOf('month').toDate();
        vm.purchDateTo = moment(vm.srch.CalcDateTo).subtract(1, 'months').endOf('month').toDate();
        vm.srch.PurchDateFrom = $filter('localToUtc')(vm.purchDateFrom, 'from');
        vm.srch.PurchDateTo = $filter('localToUtc')(vm.purchDateTo, 'to');
        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDate' ) {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  if(!isNullOrEmpty(item.ColumnPhysicalAsNm)){
                    obj.push(value[item.ColumnPhysicalAsNm]);
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {

      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.reports:ccreport01-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 매출현황 목록
   */
  webapp.controller('CCReport01ListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CCReport01ListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'CvsReport.getCCReport01List';    // 목록 조회 SQL
      var LIST_CNT_SQL = 'CvsReport.getCCReport01ListCnt';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getCCReport01List'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.reports.ccreport01-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.reports.ccreport01-list.detail';  // 목록 조회  화면
      var VIEW_PAGE_URL = 'app.reports.ccreport01-detail';       // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvspharmaptcalchist'; // 작업 테이블명
      var EXCEL_TITLE = '매출 현황'; //매출현황 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {

        vm.CalcDate = moment().toDate();

        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          CalcDate : moment(vm.calcDate).format('YYYY-MM'),
          CalcDateFrom: moment(vm.CalcDate).startOf('month').format('YYYY-MM-DD'),
          CalcDateTo: moment(vm.CalcDate).endOf('month').format('YYYY-MM-DD'),

        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.CalcDate = moment(vm.srch.CalcDateFrom).toDate();
        vm.currentPage = vm.srch.page;
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수


      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }



      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        getListCnt();
        vm.dataloader = true; // Progressbar 표시

        var data = vm.srch; // 검색 옵션 설정

        data.CalcDateFrom = $filter('localToUtc')(data.CalcDateFrom, 'from');
        data.CalcDateTo = $filter('localToUtc')(data.CalcDateTo, 'to');

        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.CalcDateFrom = $filter('localToUtc')(data.CalcDateFrom, 'from');
        data.CalcDateTo = $filter('localToUtc')(data.CalcDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'CalcDate') {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  if(!isNullOrEmpty(item.ColumnPhysicalAsNm)){
                    obj.push(value[item.ColumnPhysicalAsNm]);
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.ProductNm = res.ProductNm;
          vm.srch.ProductId = res.ProductId;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.ProductId = '';
        vm.srch.ProductNm = '';
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.CareTktNm = res.CareTktNm;
          vm.srch.CareTktId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.srch.CareTktId = '';
        vm.srch.CareTktNm = '';
      }

      /**
       * 판매자 검색
       *
       * @param
       * @return
       */
      vm.srchPayUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.PayUserNm = res.UserNm;
          vm.srch.PayUser = res.UserId;
        }, function(cancelData) {
        });
      }
      /**
       * 판매자 초기화
       *
       * @param
       * @return
       */
      vm.erasePayUser = function () {
        vm.srch.PayUserNm = '';
        vm.srch.PayUser = '';
      }

      function setCalcDate() {
        vm.srch.CalcDate = moment(vm.CalcDate).format('YYYY-MM');
        vm.srch.CalcDateFrom = moment(vm.CalcDate).startOf('month').format('YYYY-MM-DD');
        vm.srch.CalcDateTo = moment(vm.CalcDate).endOf('month').format('YYYY-MM-DD');
      }



      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        vm.options = {minMode : 'month', class : 'datepicker' };
        vm.datepickerMode = 'month';
        vm.dateFormat = 'yyyy-MM';
      }
      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드
      vm.setCalcDate = setCalcDate;                 //날짜선택시 start , end date 변경
      vm.goDetail = goDetail;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.reports:ccreport02-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 매출현황 목록
   */
  webapp.controller('CCReport02ListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CCReport02ListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translat, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'CvsReport.getCCReport02List';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getCCReport02List'; // 엑셀다운로드 SQL
      var UPDATE_SQL = 'CvsReport.updateCCREport02';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.reports.ccreport02-list';         // 목록 화면
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'ccreport02list'; // 작업 테이블명
      var EXCEL_TITLE = '지급내역'; //매출현황 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {

        vm.srch = {
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.PayDateFrom = moment(vm.srch.PayDateFrom).toDate(); // YYYY-MM-DD 를 date type 으로 변환
        vm.PayDateTo = moment(vm.srch.PayDateTo).toDate();
        vm.ApplyDateFrom = moment(vm.srch.ApplyDateFrom).toDate();
        vm.ApplyDateTo =  moment(vm.srch.ApplyDateTo).toDate();
      }

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }



      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {

        vm.dataloader = true; // Progressbar 표시

        var data = angular.copy(vm.srch);// 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        if(!isNullOrEmpty(data.PayDateFrom)&&data.PayDateFrom != undefined) {
          data.PayDateFrom = $filter('localToUtc')(data.PayDateFrom, 'from');
        }
        if(!isNullOrEmpty(data.PayDateTo)&&data.PayDateTo != undefined) {
          data.PayDateTo = $filter('localToUtc')(data.PayDateTo, 'to');
        }
        if(!isNullOrEmpty(data.ApplyDateFrom)&&data.ApplyDateFrom != undefined) {
          data.ApplyDateFrom = $filter('localToUtc')(data.ApplyDateFrom, 'from');
        }
        if(!isNullOrEmpty(data.ApplyDateTo)&&data.ApplyDateTo != undefined) {
          data.ApplyDateTo = $filter('localToUtc')(data.ApplyDateTo, 'to');
        }

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              vm.totalItems = vm.lists.length;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'PayDate') {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  if(!isNullOrEmpty(item.ColumnPhysicalAsNm)){
                    obj.push(value[item.ColumnPhysicalAsNm]);
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.ProductNm = res.ProductNm;
          vm.srch.ProductId = res.ProductId;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.ProductId = '';
        vm.srch.ProductNm = '';
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.CareTktNm = res.CareTktNm;
          vm.srch.CareTktId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.srch.CareTktId = '';
        vm.srch.CareTktNm = '';
      }

      /**
       * 판매자 검색
       *
       * @param
       * @return
       */
      vm.srchPayUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.PayUserNm = res.UserNm;
          vm.srch.PayUser = res.UserId;
        }, function(cancelData) {
        });
      }
      /**
       * 판매자 초기화
       *
       * @param
       * @return
       */
      vm.erasePayUser = function () {
        vm.srchPayUserNm = '';
        vm.srch.PayUser = '';
      }

      /**
       * 일별/월별/년별 에 따른 option setting
       * @param
       * @return
       */
      function setSrchType () {

        if (vm.srch.srchType == '100') {

          vm.options = {minMode : 'year', class : 'datepicker' };
          vm.datepickerMode = 'year';
          vm.dateFormat = 'yyyy';

        }else if(vm.srch.srchType == '200') {

          vm.options = {minMode : 'month', class : 'datepicker' };
          vm.datepickerMode = 'month';
          vm.dateFormat = 'yyyy-MM';

        }else if(vm.srch.srchType == '300') {

          vm.options = {minMode : 'day',class : 'datepicker'};
          vm.datepickerMode = 'day';
          vm.dateFormat = 'yyyy-MM-dd';
        }

      }



      vm.updatePayDate = function(row) {
        // 내용
        var data = vm.srch; // 사용자 입력 데이터

          // 수정
          data.KeyId = row.KeyId;
          data.UserType = row.UserType;
          data.Id = row.Id;
          data.ApplyPoint = row.ApplyPoint;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });

      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {

            // KeyId 조회
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                 $state.go(LIST_PAGE_URL, {
                   srch: ''
                 }, {reload: LIST_PAGE_URL});

              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        setSrchType();
      }
      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드
      vm.setSrchType = setSrchType;                 //날짜선택시 start , end date 변경
      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
      $stateProvider.state('app.reports', {
          url: '/reports',
          template: '<div ui-view></div>',
          controler: "reportsCtrl"
      }).state('app.reports.reports-list', {
          url: '/reports-list',
          templateUrl: 'app/reports/reports-list.html',
          resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                  '/assets/app/vendor/footable/js/footable.js',
                  '/assets/app/vendor/footable/css/footable.core.min.css',
              ]);
            }]
          },
      }).state('app.reports.salesreport01-list', {
        url: '/salesreport01-list/:srch',
        templateUrl: 'app/reports/salesreport01-list.html',
        resolve: {
          plugins: ['$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css',
            ]);
          }]
        },
      }).state('app.reports.salesreport02-list', {
        url: '/salesreport02-list/:srch',
        templateUrl: 'app/reports/salesreport02-list.html',
        resolve: {
          plugins: ['$ocLazyLoad', function($ocLazyLoad) {
            return $ocLazyLoad.load([
              '/assets/app/vendor/footable/js/footable.js',
              '/assets/app/vendor/footable/css/footable.core.min.css',
            ]);
          }]
        },
     }).state('app.reports.salesreport03-list', {
       url: '/salesreport03-list/:srch',
       templateUrl: 'app/reports/salesreport03-list.html',
       resolve: {
         plugins: ['$ocLazyLoad', function($ocLazyLoad) {
           return $ocLazyLoad.load([
             '/assets/app/vendor/footable/js/footable.js',
             '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
         }]
       },
     }).state('app.reports.salesreport04-list', {
      url: '/salesreport04-list/:srch',
      templateUrl: 'app/reports/salesreport04-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        }]
      },
    }).state('app.reports.salesreport05-list', {
      url: '/salesreport05-list/:srch',
      templateUrl: 'app/reports/salesreport05-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        }]
      },
    }).state('app.reports.salesreport06-list', {
      url: '/salesreport06-list/:srch',
      templateUrl: 'app/reports/salesreport06-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        }]
      },
    }).state('app.reports.salesreport06-list.detail', {
      url : '/detail/:srch',
      templateUrl : 'app/reports/salesreport06-detail.html',
    }).state('app.reports.salesreport06-detail', {
      url: '/salesreport06-detail/:srch',
      templateUrl: 'app/reports/salesreport06-detail.html',
      requiresAuthentication: true,
    })
    .state('app.reports.ccreport01-list', {
      url: '/ccreport01-list/:srch',
      templateUrl: 'app/reports/ccreport01-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        }]
      },
    }).state('app.reports.ccreport01-list.detail', {
      url : '/detail/:keyId',
      templateUrl : 'app/reports/ccreport01-detail.html',
    }).state('app.reports.ccreport01-detail', {
      url : '/detail/:srch/:keyId',
      templateUrl : 'app/reports/ccreport01-detail.html',
    })
    .state('app.reports.ccreport02-list', {
      url: '/ccreport02-list/:srch',
      templateUrl: 'app/reports/ccreport02-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        }]
      },
    });
  }
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:salesreport01-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 매출현황 목록
   */
  webapp.controller('SalesReport01ListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SalesReport01ListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'CvsReport.getSalesReport01List';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getSalesReport01List'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.reports.salesreport01-list';         // 목록 화면
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'purchhistcnt'; // 작업 테이블명
      var EXCEL_TITLE = '매출 현황'; //매출현황 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {

        vm.PurchDateFrom = moment().startOf('month').toDate()
        vm.PurchDateTo = moment().endOf('month').toDate();

        vm.srch = {
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          PurchDateFrom: moment().startOf('month').format('YYYY-MM-DD'),
          PurchDateTo: moment().endOf('month').format('YYYY-MM-DD'),
          srchType: '300',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.PurchDateFrom = $rootScope.getDateFormat(vm.srch.PurchDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PurchDateTo = $rootScope.getDateFormat(vm.srch.PurchDateTo);
      }

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }



      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시

        if(!isNullOrEmpty(vm.srch.srchType)) {
          if(vm.srch.srchType == '100') {

            vm.srch.PurchDateFrom = moment(vm.srch.PurchDateFrom).startOf('year').format('YYYY-MM-DD');
            vm.srch.PurchDateTo = moment(vm.srch.PurchDateTo).endOf('year').format('YYYY-MM-DD');

          } else if(vm.srch.srchType == '200') {

            vm.srch.PurchDateFrom = moment(vm.srch.PurchDateFrom).startOf('month').format('YYYY-MM-DD');
            vm.srch.PurchDateTo = moment(vm.srch.PurchDateTo).endOf('month').format('YYYY-MM-DD');
          }
        }

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.PurchDateFrom = $filter('localToUtc')(data.PurchDateFrom, 'from');
        data.PurchDateTo = $filter('localToUtc')(data.PurchDateTo, 'to');

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              vm.totalItems = vm.lists.length;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'PurchDate') {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.GoodsNm = res.GoodsNm;
          vm.srch.ProductId = res.GoodsNo;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.ProductId = '';
        vm.srch.GoodsNm = '';
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.CareTktNm = res.CareTktNm;
          vm.srch.CareTktId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.srch.CareTktId = '';
        vm.srch.CareTktNm = '';
      }

      /**
       * 판매자 검색
       *
       * @param
       * @return
       */
      vm.srchSellerModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.SellerNm = res.UserNm;
          vm.srch.SellerId = res.UserId;
        }, function(cancelData) {
        });
      }
      /**
       * 판매자 초기화
       *
       * @param
       * @return
       */
      vm.eraseSeller = function () {
        vm.srch.SellerNm = '';
        vm.srch.SellerId = '';
      }

      /**
       * 구매자(마스터) 검색
       *
       * @param
       * @return
       */
      vm.srchMasterModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.MasterNm = res.UserNm;
          vm.srch.MasterId = res.UserId;
        }, function(cancelData) {
        });
      }
      /**
       * 구매자(마스터) 초기화
       *
       * @param
       * @return
       */
      vm.eraseMaster = function () {
        vm.srch.MasterNm = '';
        vm.srch.MasterId = '';
      }
      /**
       * 구매자(파머) 검색
       *
       * @param
       * @return
       */
      vm.srchPharmaModal = function () {
        var ctrl = 'CustomerModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/customer/customer-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.PharmaNm = res.CustNm;
          vm.srch.PharmaId = res.CustId;
        }, function(cancelData) {
        });
      }
      /**
       * 구매자(파머) 초기화
       *
       * @param
       * @return
       */
      vm.erasePharma = function () {
        vm.srch.PharmaNm = '';
        vm.srch.PharmaId = '';
      }

      /**
       * 일별/월별/년별 에 따른 option setting
       * @param
       * @return
       */
      function setSrchType () {

        if (vm.srch.srchType == '100') {

          vm.options = {minMode : 'year', class : 'datepicker' };
          vm.datepickerMode = 'year';
          vm.dateFormat = 'yyyy';

        }else if(vm.srch.srchType == '200') {

          vm.options = {minMode : 'month', class : 'datepicker' };
          vm.datepickerMode = 'month';
          vm.dateFormat = 'yyyy-MM';

        }else if(vm.srch.srchType == '300') {

          vm.options = {minMode : 'day',class : 'datepicker'};
          vm.datepickerMode = 'day';
          vm.dateFormat = 'yyyy-MM-dd';
        }

      }
      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        setSrchType();
      }
      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드
      vm.setSrchType = setSrchType;               // 년별 월별 일별 검색 에 따른 datepicker option 설정

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:salesreport01-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 매출현황 목록
   */
  webapp.controller('SalesReport02ListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SalesReport02ListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'CvsReport.getSalesReport02List';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getSalesReport02List'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.reports.salesreport02-list';         // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'purchhistincome'; // 작업 테이블명
      var EXCEL_TITLE = '순이익 현황'; //매출현황 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      vm.PurchDateFrom = moment().startOf('month').toDate()
      vm.PurchDateTo = moment().endOf('month').toDate();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          PurchDateFrom: moment().startOf('month').format('YYYY-MM-DD'),
          PurchDateTo: moment().endOf('month').format('YYYY-MM-DD'),

        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;

        vm.PurchDateFrom = $rootScope.getDateFormat(vm.srch.PurchDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PurchDateTo = $rootScope.getDateFormat(vm.srch.PurchDateTo);

        vm.currentPage = vm.srch.page;
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }


      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.PurchDateFrom = $filter('localToUtc')(data.PurchDateFrom, 'from');
        data.PurchDateTo = $filter('localToUtc')(data.PurchDateTo, 'to');

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'PurchDate') {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.GoodsNm = res.GoodsNm;
          vm.srch.ProductId = res.GoodsNo;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.ProductId = '';
        vm.srch.GoodsNm = '';
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.CareTktNm = res.CareTktNm;
          vm.srch.CareTktId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.srch.CareTktId = '';
        vm.srch.CareTktNm = '';
      }

      /**
       * 판매자 검색
       *
       * @param
       * @return
       */
      vm.srchSellerModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.SellerNm = res.UserNm;
          vm.srch.SellerId = res.UserId;
        }, function(cancelData) {
        });
      }
      /**
       * 판매자 초기화
       *
       * @param
       * @return
       */
      vm.eraseSeller = function () {
        vm.srch.SellerNm = '';
        vm.srch.SellerId = '';
      }

      /**
       * shop 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchTenantModal = function () {
        var ctrl = 'TenantModalCtrl as vc';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.TenantNm = res.TenantNm;
          vm.srch.TenantId = res.TenantId;

        }, function(cancelData) {
        });
      }
      /**
       * shop 초기화
       *
       * @param
       * @return
       */
      vm.eraseTenant = function () {
        vm.srch.TenantId = '';
        vm.srch.TenantNm = '';
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        vm.PurchDateFrom = moment(vm.srch.PurchDateFrom).toDate();
        vm.PurchDateTo = moment(vm.srch.PurchDateTo).toDate();
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회


      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시


      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:salesreport01-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 매출현황 목록
   */
  webapp.controller('SalesReport03ListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function SalesReport03ListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CODE_SQL = 'CommonCode.getCommonCodeValue'; // CommonCode 조회 SQL
      var LIST_SQL = 'CvsReport.getSalesReport03List';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getSalesReport03List'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.reports.salesreport03-list';         // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'customervisitpath'; // 작업 테이블명
      var EXCEL_TITLE = '고객 유입 구분'; //매출현황 엑셀파일 이름

      var CODE_TYPE = 'VISITPATH';
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {

        vm.CustRegDtFrom = moment().startOf('month').toDate();
        vm.CustRegDtTo = moment().endOf('month').toDate();

        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          selectType: 'List',
          CustRegDtFrom: moment().startOf('month').format('YYYY-MM-DD'),
          CustRegDtTo: moment().endOf('month').format('YYYY-MM-DD'),
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.CustRegDtFrom = $rootScope.getDateFormat(vm.srch.CustRegDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.CustRegDtTo = $rootScope.getDateFormat(vm.srch.CustRegDtTo);
        vm.currentPage = vm.srch.page;
      }
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }


      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {

        vm.dataloader = true; // Progressbar 표시

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0) {

              // 컬럼 데이터 표시
              vm.lists = result.body.docs;
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });

            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'CustRegDt') {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });
            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {

      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();



(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:salesreport01-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 매출현황 목록
   */
  webapp.controller('SalesReport04ListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function SalesReport04ListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'CvsReport.getSalesReport04List';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getSalesReport04List'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.report.salesreport04-list';         // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'counselhistcnt'; // 작업 테이블명
      var EXCEL_TITLE = '신규 및 재방문 현황'; //매출현황 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {

        vm.CounselDtFrom = moment().toDate();
        vm.CounselDtTo = moment().toDate();

        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          CounselDtFrom: moment().format('YYYY-MM-DD'),
          CounselDtTo: moment().format('YYYY-MM-DD'),
          srchType: '300',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.CounselDtFrom = $rootScope.getDateFormat(vm.srch.CounselDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.CounselDtTo = $rootScope.getDateFormat(vm.srch.CounselDtTo);
        vm.currentPage = vm.srch.page;
      }


      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }


      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        if(!isNullOrEmpty(vm.srch.srchType)) {
          if(vm.srch.srchType == '100') {

            vm.srch.CounselDtFrom = moment(vm.srch.CounselDtFrom).startOf('year').format('YYYY-MM-DD');
            vm.srch.CounselDtTo = moment(vm.srch.CounselDtTo).endOf('year').format('YYYY-MM-DD');

          } else if(vm.srch.srchType == '200') {

            vm.srch.CounselDtFrom = moment(vm.srch.CounselDtFrom).startOf('month').format('YYYY-MM-DD');
            vm.srch.CounselDtTo = moment(vm.srch.CounselDtTo).endOf('month').format('YYYY-MM-DD');
          }
        }


        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 일별/월별/년별 에 따른 option setting
       * @param
       * @return
       */
      function setSrchType () {

        if (vm.srch.srchType == '100') {

          vm.options = {minMode : 'year', class : 'datepicker' };
          vm.datepickerMode = 'year';
          vm.dateFormat = 'yyyy';

        }else if(vm.srch.srchType == '200') {

          vm.options = {minMode : 'month', class : 'datepicker' };
          vm.datepickerMode = 'month';
          vm.dateFormat = 'yyyy-MM';

        }else if(vm.srch.srchType == '300') {

          vm.options = {minMode : 'day',class : 'datepicker'};
          vm.datepickerMode = 'day';
          vm.dateFormat = 'yyyy-MM-dd';
        }

      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        setSrchType();

        // 목록 조회
        getList();
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      vm.setSrchType = setSrchType;               // 년별 월별 일별 검색 에 따른 datepicker option 설정

      // 초기 데이터 설정
      setInitData();

    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:salesreport01-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 매출현황 목록
   */
  webapp.controller('SalesReport05ListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SalesReport05ListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'CvsReport.getSalesReport05List';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getSalesReport05List';  // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.report.salesreport05-list';         // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'purchhistreport'; // 작업 테이블명
      var KEY_COLUMN_NM = 'UserId'; // Primary Key Column
      var EXCEL_TITLE = '관리권_일반판매 매출 구분'; //매출현황 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {

      vm.PurchDateFrom = moment().toDate();
      vm.PurchDateTo = moment().toDate();

        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          PurchDateFrom: moment().format('YYYY-MM-DD'),
          PurchDateTo: moment().format('YYYY-MM-DD'),
          srchType: '300',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.PurchDateFrom = $rootScope.getDateFormat(vm.srch.PurchDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.PurchDateTo = $rootScope.getDateFormat(vm.srch.PurchDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }


      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {


        if(!isNullOrEmpty(vm.srch.srchType)) {
          if(vm.srch.srchType == '100') {

            vm.srch.PurchDateFrom = moment(vm.srch.PurchDateFrom).startOf('year').format('YYYY-MM-DD');
            vm.srch.PurchDateTo = moment(vm.srch.PurchDateTo).endOf('year').format('YYYY-MM-DD');

          } else if(vm.srch.srchType == '200') {

            vm.srch.PurchDateFrom = moment(vm.srch.PurchDateFrom).startOf('month').format('YYYY-MM-DD');
            vm.srch.PurchDateTo = moment(vm.srch.PurchDateTo).endOf('month').format('YYYY-MM-DD');
          }
        }

        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.PurchDateFrom = $filter('localToUtc')(data.PurchDateFrom, 'from');
        data.PurchDateTo = $filter('localToUtc')(data.PurchDateTo, 'to');

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });

            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(!isNullOrEmpty(item.ColumnPhysicalAsNm)){
                    obj.push(value[item.ColumnPhysicalAsNm]);
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchPrdModal = function () {
        var ctrl = 'ProductModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.ProductNm = res.GoodsNm;
          vm.srch.ProductId = res.GoodsNo;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.erasePrd = function () {
        vm.srch.ProductId = '';
        vm.srch.ProductNm = '';
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchCareTktModal = function () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.srch.CareTktNm = res.CareTktNm;
          vm.srch.CareTktId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.eraseCareTkt = function () {
        vm.srch.CareTktId = '';
        vm.srch.CareTktNm = '';
      }

      /**
       * 판매자 검색
       *
       * @param
       * @return
       */
      vm.srchSellerModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.SellerNm = res.UserNm;
          vm.srch.SellerId = res.UserId;
        }, function(cancelData) {
        });
      }
      /**
       * 판매자 초기화
       *
       * @param
       * @return
       */
      vm.eraseSeller = function () {
        vm.srch.SellerNm = '';
        vm.srch.SellerId = '';
      }

      /**
       * 일별/월별/년별 에 따른 option setting
       * @param
       * @return
       */
      function setSrchType () {

        if (vm.srch.srchType == '100') {

          vm.options = {minMode : 'year', class : 'datepicker' };
          vm.datepickerMode = 'year';
          vm.dateFormat = 'yyyy';

        }else if(vm.srch.srchType == '200') {

          vm.options = {minMode : 'month', class : 'datepicker' };
          vm.datepickerMode = 'month';
          vm.dateFormat = 'yyyy-MM';

        }else if(vm.srch.srchType == '300') {

          vm.options = {minMode : 'day',class : 'datepicker'};
          vm.datepickerMode = 'day';
          vm.dateFormat = 'yyyy-MM-dd';
        }

      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        setSrchType();
        // 목록 조회
        getList();

      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드
      vm.setSrchType = setSrchType;

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:salesreport06-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('SalesReport06DetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function SalesReport06DetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'CvsReport.getSalesReport06DetailCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'CvsReport.getSalesReport06Detail';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getSalesReport06Excel'; // 엑셀다운로드 SQL
      var GROUP_SQL ='CvsReport.getSalesReport06GroupNm'; // 그룹명 조회 SQL
      var GRPCUST_INSERT_SQL = 'CvsReport.insertSalesReport06GroupCust'; //그룹고객 투입 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.reports.salesreport06-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.user-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.user-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.user-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.user-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'customer'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CustId'; // Primary Key Column
      var EXCEL_TITLE = '리스크 고객 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.EntryDtFrom = $rootScope.getDateFormat(vm.srch.EntryDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.EntryDtTo = $rootScope.getDateFormat(vm.srch.EntryDtTo);
        vm.currentPage = vm.srch.page;

      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              var newnum ='';

              angular.forEach(vm.lists, function (item){

                if(isNullOrEmpty(item.GrpCustId)) {
                  newnum = Math.floor(100000000000000 + Math.random() * 899999999999999);
                  item.GrpCustId = newnum.toString(36);
                }

              })
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDate' ) {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  if(!isNullOrEmpty(item.ColumnPhysicalAsNm)){
                    obj.push(value[item.ColumnPhysicalAsNm]);
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };


        /**
       * 그룹List
       *
       * @param
       * @return
       */
      function getGroupList () {
        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = GROUP_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {


            if (result.body.docs.length > 0 ) {
              // 목록 데이터 표시
              vm.groupLists = result.body.docs;
            } else {
              // 데이터 조회 실패
              vm.groupLists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getGroupList()");
          console.table(error);

        });
      };

      /**
       * 그룹고객 저장
       *
       * @param
       * @return
       */
      function setGrpCust() {
        // 내용
        var data = {}; // 사용자 입력 데이터

        data.tableNm = 'groupcustomer';
        data.IdName = 'GrpCustId';
        data.userkey = vm.srch.userkey;
        data.GrpId = vm.srch.GrpId;
        data.lists = vm.lists;
        data.mapCode = GRPCUST_INSERT_SQL;

        postApi.insert(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].GrpCustId !== null) {

              gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {

              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        getGroupList();

      }
      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동
      vm.goList = goList;

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드
      vm.setGrpCust = setGrpCust;                 // 그룹고객 투입

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:salesreport01-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 매출현황 목록
   */
  webapp.controller('SalesReport06ListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function SalesReport06ListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_SQL = 'CvsReport.getSalesReport06List';    // 목록 조회 SQL
      var EXCEL_SQL = 'CvsReport.getSalesReport06List'; // 엑셀다운로드 SQL
      var LIST_CODE_SQL = 'CommonCode.getCommonCodeValue'; // CommonCode 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.reports.salesreport06-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.reports.salesreport06-list.detail';  // 목록 조회  화면
      var VIEW_PAGE_URL = 'app.reports.salesreport06-detail';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'purchhistreport'; // 작업 테이블명
      var EXCEL_TITLE = '리스크 고객 목록'; //매출현황 엑셀파일 이름
      var CODE_TYPE = 'ANALDAYTYPE';
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.CalDtFrom = moment().toDate(),
        vm.CalDtTo = moment().toDate(),

        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          CalDtFrom: moment().format('YYYY-MM-DD'),
          CalDtTo: moment().format('YYYY-MM-DD'),
          srchType: '300',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.CalDtFrom = $rootScope.getDateFormat(vm.srch.CalDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.CalDtTo = $rootScope.getDateFormat(vm.srch.CalDtTo);
        vm.currentPage = vm.srch.page;
      }


      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }


      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {

        if(!isNullOrEmpty(vm.srch.srchType)) {
          if(vm.srch.srchType == '100') {

            vm.srch.PurchDateFrom = moment(vm.srch.PurchDateFrom).startOf('year').format('YYYY-MM-DD');
            vm.srch.PurchDateTo = moment(vm.srch.PurchDateTo).endOf('year').format('YYYY-MM-DD');

          } else if(vm.srch.srchType == '200') {

            vm.srch.PurchDateFrom = moment(vm.srch.PurchDateFrom).startOf('month').format('YYYY-MM-DD');
            vm.srch.PurchDateTo = moment(vm.srch.PurchDateTo).endOf('month').format('YYYY-MM-DD');
          }
        }

        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = [];

              vm.columnMap['CalDt'] = {CodeValue: '최종방문일', Code: 'CalDt', idx: 0};
              vm.columnMap['Day14'] = {CodeValue: '2주 이상 미방문 고객수', Code: 'Day14', idx: 1};
              vm.columnMap['Day28'] = {CodeValue: '4주 이상 미방문 고객수', Code: 'Day28', idx: 2};

              vm.listColumns.push(vm.columnMap['CalDt']);
              vm.listColumns.push(vm.columnMap['Day14']);
              vm.listColumns.push(vm.columnMap['Day28']);

            if (result.body.docs.length > 0 ) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              vm.totalItems = vm.lists.length;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.totalItems = 0;
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 공통코드 조회
       *
       * @param
       * @return
       */
      function getCodeColumns() {

        vm.dataloader = true; // Progressbar 표시

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CODE_SQL;
        data.CodeType = CODE_TYPE;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {

              // 컬럼 데이터 표시
              vm.commonCode = result.body.docs;

            } else {
              // 데이터 조회 실패
              vm.commonCode = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getCodeColumns()");
          console.table(error);

        });

      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(field,CalDt) {

        vm.srch.calDt = CalDt;

        if(field =='Day14') {
          vm.srch.dayType = -14;
        }else if(field =='Day28') {
          vm.srch.dayType = -28;
        }
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));


        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch
          });
        } else {
        // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch
          });
        }


      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'CalDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 일별/월별/년별 에 따른 option setting
       * @param
       * @return
       */
      function setSrchType () {

        if (vm.srch.srchType == '100') {

          vm.options = {minMode : 'year', class : 'datepicker' };
          vm.datepickerMode = 'year';
          vm.dateFormat = 'yyyy';

        }else if(vm.srch.srchType == '200') {

          vm.options = {minMode : 'month', class : 'datepicker' };
          vm.datepickerMode = 'month';
          vm.dateFormat = 'yyyy-MM';

        }else if(vm.srch.srchType == '300') {

          vm.options = {minMode : 'day',class : 'datepicker'};
          vm.datepickerMode = 'day';
          vm.dateFormat = 'yyyy-MM-dd';
        }

      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        setSrchType();
        // 목록 조회
        getList();
        getCodeColumns();
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회


      vm.goDetail = goDetail;                     // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드
      vm.setSrchType = setSrchType;

      vm.getCodeColumns = getCodeColumns;

      // 초기 데이터 설정
      setInitData();
    }]);
})();

webapp.controller('ReserveDailyCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', '$filter', '$compile', '$interval', '$translate',
    function ReserveDailyCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalFactory, postApi, $filter, $compile, $interval, $translate) {
      var vm = this;

      vm.srch = {CalDt : ''};
      if ($stateParams.srch != null && $stateParams.srch != '') {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        if(vm.srch.CalDt != null || vm.srch.CalDt !="")
          vm.tmCalDt = $rootScope.getDateFormat(vm.srch.CalDt);
        else
          vm.tmCalDt = new Date();
      } else {
        vm.tmCalDt = new Date();
      }

      vm.data = {};

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        vm.srch.CalDt = $filter('date')(vm.tmCalDt,'yyyy-MM-dd');
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.listSize = [ 10, 25, 50, 100 ];

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
      vm.srch.viewSize = vm.viewSize;

      vm.getList = getList;
      vm.getSearch = getSearch;
      vm.getMeetingRole = getMeetingRole;

      vm.getClear = function() {
        vm.srch = {};
        $state.go('app.reserve.reserve-daily', {}, {reload: 'app.reserve.reserve-daily'});
      };

      vm.openMeetingRoom = function() {
        var srch = {CalDt:$filter('date')(vm.tmCalDt,'yyyy-MM-dd')};
        var encSrch = encodeURIComponent(JSON.stringify(srch));
        /* $window.open('/#/reserve/meeting-detail/meeting-daily/' + encSrch, "salemeet.meetingroom"); */
        $window.location.replace('/#/reserve/meeting-detail/meeting-daily/' + encSrch);
      };

      function getSearch() {
        vm.srch.CalDt = $filter('date')(vm.tmCalDt,'yyyy-MM-dd');

        $state.go('app.reserve.reserve-daily', {
          srch : encodeURIComponent(JSON.stringify(vm.srch))
        }, {reload: 'app.reserve.reserve-daily'});
      }

      $scope.col_defs = [
        /* { field: "T09", displayName: "09"},
        { field: "T10", displayName: "10"},
        { field: "T11", displayName: "11"},
        { field: "T12", displayName: "12"},
        { field: "T13", displayName: "13"},
        { field: "T14", displayName: "14"},
        { field: "T15", displayName: "15"},
        { field: "T16", displayName: "16"},
        { field: "T17", displayName: "17"},
        { field: "T18", displayName: "18"},
        { field: "T19", displayName: "19"},
        { field: "T20", displayName: "20"},
        { field: "T21", displayName: "21"},
        { field: "T22", displayName: "22"},
        { field: "T23", displayName: "23"} */
      ];

      $scope.expanding_property = {
        field: "label",
        displayName: "회의실",
        cellTemplate: "<i>{{row.branch[expandingProperty.field]}}</i>"
      };

      var tree;
      $scope.my_tree = tree = {};

      $scope.my_tree_handler = function (branch) {
        console.log('you clicked on', branch)
      };

      function getList() {
        $scope.tree_data = [];

        // 로케이션관리 select 검색실행함
        var data = vm.srch;
        data.CalDt = $filter('date')(vm.tmCalDt,'yyyy-MM-dd');
        data.selectType = 'List'; // For CustomColumn
        data.mapCode = 'Calendar.getReserveStatistics';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;

              var topItem = result.body.docs[0];

              var arrlist = [];

              var checkStr = '<i class="glyphicon glyphicon-check"></i>';

              // for문으로 다시 json 구조로 변환함.
              angular.forEach(vm.lists, function(item, key) {
                var data = {};
                data.label = item.CodeValue;
                data.guid = item.CommonCodeId;
                data.parent = topItem.CodeLevel == item.CodeLevel ? null : item.ParentCommonCodeId;
                data.T00 = item.T00 == '0'? '' : checkStr;
                data.T01 = item.T01 == '0'? '' : checkStr;
                data.T02 = item.T02 == '0'? '' : checkStr;
                data.T03 = item.T03 == '0'? '' : checkStr;
                data.T04 = item.T04 == '0'? '' : checkStr;
                data.T05 = item.T05 == '0'? '' : checkStr;
                data.T06 = item.T06 == '0'? '' : checkStr;
                data.T07 = item.T07 == '0'? '' : checkStr;
                data.T08 = item.T08 == '0'? '' : checkStr;
                data.T09 = item.T09 == '0'? '' : checkStr;
                data.T10 = item.T10 == '0'? '' : checkStr;
                data.T11 = item.T11 == '0'? '' : checkStr;
                data.T12 = item.T12 == '0'? '' : checkStr;
                data.T13 = item.T13 == '0'? '' : checkStr;
                data.T14 = item.T14 == '0'? '' : checkStr;
                data.T15 = item.T15 == '0'? '' : checkStr;
                data.T16 = item.T16 == '0'? '' : checkStr;
                data.T17 = item.T17 == '0'? '' : checkStr;
                data.T18 = item.T18 == '0'? '' : checkStr;
                data.T19 = item.T19 == '0'? '' : checkStr;
                data.T20 = item.T20 == '0'? '' : checkStr;
                data.T21 = item.T21 == '0'? '' : checkStr;
                data.T22 = item.T22 == '0'? '' : checkStr;
                data.T23 = item.T23 == '0'? '' : checkStr;
                arrlist.push(data);
              });

//              setTree(arrlist, "guid", "parent");

              // 계층형 json 구조로 변환함
              var recursiveArray = unflatten(arrlist);
              // guid, parent 제외 변환함
              traverse(recursiveArray);

              // 트리구조에 바인딩
              $scope.tree_data = recursiveArray;
            } else {
              vm.lists = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> getList', status, error);
          vm.dataloader = false;
        });
      }

      function findObject(obj, key, value) {
        for (var i = 0; i < obj.length; i++) {
          for (var objKey in obj[i]) {
            if (objKey == key) {
              if (obj[i][objKey] == value) {
                return obj[i];
              }
            }
          }
          if (obj[i]["children"].length > 0) {
            var result = findObject(obj[i]["children"], key, value);
            if (result != false) return result;
          }
        }
        return false;
      }

      function setTree(data) {
        if (!data || data.length == 0 ) {
          return [];
        }
        var test = $scope.tree_data;
        var temp;
        var i = 0;
        var len = data.length;
        var check = true;

        var interval = $interval(function(){
          if (check) {
            check = false;

            var item = data[i];

            if (!item.parent) {
              item.children = [];
              $scope.tree_data.push(item);
            } else {
              var obj = findObject($scope.tree_data, "guid", item.parent);

              //if(!obj.children) obj.children =[];
              if (obj.children) {
                item.children = [];
                obj.children.push(item);
              }
            }
            i++;

            if (len == i) {
              $interval.cancel(interval)
            }
            check = true;
          }
        }, 0);
      }

      function getTree(data, primaryIdName, parentIdName) {
        if (!data || data.length == 0 || !primaryIdName ||!parentIdName) {
          return [];
        }

        var tree = [];
        tree = $scope.tree_data;
        var rootIds = [];
        var treeObjs = [];
        var parentId = null;
        var parent = null;
        var len = data.length;
        var item = {};
        var i = 0;

        while (i < len) {
          item = data[i];

          primaryKey = item.guid;
          treeObjs[i] = item;
          parentId = item[parentIdName];

          if (parentId) {
            a = 0;
            while (a < len) {
              if (data[a].guid ==  treeObjs[i].parent) {
                parent =  data[a];
                break;
              }
              a++;
            }

            if (parent.children) {
              parent.children.push(item);
            } else {
              parent.children = [];
              parent.children.push(item);
            }
          } else {
            rootIds.push(primaryKey);
          }
          vm.tree_data.push(item);
          i++;
        }

        for (i = 0; i < rootIds.length; i++) {
          vm.tree_data.push(treeObjs[i]);
        }
        return tree;
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {
        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {};
          angular.copy(jsonObj[i], newItem);
          newItem.children = jsonObj[i].children;
          jsonObj[i] = newItem;
        }
      }

      function getMeetingRole() {
        var srch = {};
        srch.CodeType = 'SALEMEET';
        srch.mapCode = 'CommonProperties.getCommonPropertiesList';
        postApi.select(srch, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0] !== undefined) {
              angular.forEach(result.body.docs, function(item) {
                if (item.Code == 'reserve.starttime') {
                  vm.data.STARTTIME = parseInt(item.CodeValue);
                } else if (item.Code == 'reserve.endtime') {
                  vm.data.ENDTIME = parseInt(item.CodeValue);
                }
              });

              for (i = vm.data.STARTTIME; i <= vm.data.ENDTIME; i++) {
                var j = i;
                if (i < 10) j = "0" + j;
                $scope.col_defs.push({ field: "T" + j, displayName: j});
              }
            }
          }
        }, function(error) {
          console.error('Error> getMeetingRole()', error);
          vm.dataloader = false;
        });
      }

      getMeetingRole();
      getList();

    } ]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.system:user-detail-ctrl
 * @description # 사용자 조회 Controller of the 사용자정의 컬럼 사용자 목록
 */
webapp.controller('ReserveDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm',

  /**
   * @param {object}
   *          $window - window object
   * @param {object}
   *          $scope - scope object
   * @param {object}
   *          $location - location object
   * @param {object}
   *          $state - state object
   * @param {object}
   *          $stateParams - state Parameter object
   * @param {object}
   *          CONSTANT - 전역 상수
   * @param {object}
   *          StaticVariable - StaticVariable object
   * @param {object}
   *          userApi - userApi Module
   * @param {object}
   *          gAlert - Alert Module *
   */

  function ReserveDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, postApi, gAlert, gConfirm) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        ReserveId : $stateParams.srch.ReserveId ? $stateParams.srch.ReserveId : '',
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'users',
        uploadFileList : [],
        srchTenantId : $stateParams.srch.srchTenantId ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.ReserveId) {
      vm.srch.ReserveId = $stateParams.ReserveId;
    }
    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = [];
    vm.srchDetail.IdName = 'ReserveId';
    vm.srchDetail.selectType = "Detail";

    // 조회 데이터
    vm.data = {
      ReserveId : vm.srchDetail.ReserveId,
      TableNm : 'users',
    };

    // 업로드 파일 목록
    var fileUploadId = 0;
    vm.uploadFileList = [];

    /**
     * 첨부파일 목록 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getFileList() {

      var data = vm.srchDetail;
      data.viewColumns = {};
      data.mapCode = 'FileAttach.getFileList';
      postApi.select(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          var uploadFileList = [];

          angular.forEach(result.body.docs, function(item) {
            var obj = {
              id : item.fileId,
              isLoaded : true,
              link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
              fileName : item.LogicalFileNm,
              size : item.FileSize,
              fileKey : item.PhysicalFileNm,
              path : item.PhysicalPath,
              downloadCnt : item.DownloadCnt,
            };
            uploadFileList.push(obj);
          });

          angular.copy(uploadFileList, vm.uploadFileList);
          return;
        }
      }, function(error) {
        console.error('ErrorgetRoleList', status, error);
      });
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getData() {
      vm.dataloader = true;

      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
      var data = vm.srchDetail;

      data.mapCode = 'Calendar.getReserveDetail';

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function(item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }

          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
            vm.dataloader = false;
          } else {
            gAlert('', 'Menu.NODATA');
          }
        }

        vm.dataloader = false;
      }, function(error) {
        vm.dataloader = false;
        console.error('fail', status, error);
        gAlert('', error.body.docs[0].errMessage);
      });
    }

    function deleteData() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteDataAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteDataAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      var data = vm.data;
      data.mapCode = 'Calendar.updateDelete';
      postApi.update(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go("app.reserve.reserve-list", {
                srch:srch
              }, {reload:'app.reserve.reserve-list'});
            }
          });
          return;
        }
      }, function(error) {
        console.error('fail', status, error);
        gAlert('', error.body.docs[0].errMessage);
      });
    }

    function goList() {
      var srch = $stateParams.srch;
      $state.go('app.reserve.reserve-list', {
        srch : srch
      });
    }

    function goEdit() {
      var srch = $stateParams.srch;
      if (vm.layout == 'N') {
        $state.go('app.reserve.reserve-edit', {
          srch : srch, ReserveId : vm.data.ReserveId
        });
      } else {
        $state.go('app.reserve.reserve-list.edit', {
          srch : srch, ReserveId : vm.data.ReserveId
        });
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.getFileList = getFileList;
    vm.deleteData = deleteData;
    vm.goEdit = goEdit;
    vm.goList = goList;

    vm.getComboRole = getComboRole;
    function getComboRole() {
      var data = {
        TenantId : vm.TenantId,
        mapCode : 'Role.getRoleList'
      };

      postApi.select(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.roleOption = result.body.docs;
        }
      }, function(error) {
        console.error('ErrorgetRoleList', status, error);
      });
    }

    getComboRole();
    // 데이터 조회
    getData();
  }, ]);
})();

/**
 * @ngdoc function
 * @name app.system:user-edit-ctrl
 * @description
 * # 사용자관리 등록/수정
 * Controller of the 사용자정의 컬럼
 */

webapp.controller('ReserveEditCtrl', [ '$rootScope', '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$timeout',

  /**
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} userApi - userApi Module
   * @param {object} gAlert - Alert Module
   */

  function ReserveEditCtrl($rootScope, $window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, customFieldApi ,$timeout) {

    // View Model
    var vm = this;
    vm.vault = null;

    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        ReserveId : $stateParams.srch.ReserveId ? $stateParams.srch.ReserveId : '',
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'users',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.ReserveId) {
      vm.srch.ReserveId = $stateParams.ReserveId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = [];
    vm.srchDetail.IdName = 'ReserveId';
    vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
    vm.srchDetail.selectType = "Edit";

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 등록/수정 표시용 컬럼 목록
    vm.srchDetail.editColumns = {};

    // 조회 데이터
    vm.data = {
      ReserveId: vm.srch.ReserveId != null ? vm.srch.ReserveId : '',
      tableNm: vm.srch.tableNm
    };

    vm.UseYNData = {
      CallbackTarget : '0000',
      CodeType : '100',
      Code : vm.data.UseYN,
      ReloadSeq : 1
    };

    vm.onSelectCallback = function(data) {
      if (data.CallbackTarget == '0000') {
        vm.data.UseYN = data.Code;
      }
    };

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function(id, result) {
        $scope.$apply(function() {
          angular.forEach(result.body.docs, function(item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
            console.log("파일 업로드");
          });
        });

        $timeout(setData, 1);
      },
      onFileUploadComplete: function(id) {
        $timeout(setData, 1);
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = h0102Api.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(vault) {
        vm.vault = vault;
      }
    };

    // 부서 조회 start
    vm.srchDeptModal = function() {
      var ctrl = 'DeptModalCtrl as vc';
      var paramData = {};
      var modalInstance = modalFactory.open("modal", "components/modal/department/dept-modal.html", ctrl, paramData);
      modalInstance.result.then(
        function(okData) {
          console.log(vm.srch);
          vm.data.DeptNm = okData.label;
          vm.data.DeptId = okData.data;
        },
        function(cancelData) {}
      );
    };

    vm.eraseDept = function() {
      vm.data.DeptNm = "";
      vm.data.DeptId = "";
    };
    // 부서 조회 end

    // 회원사 조회 start
    vm.srchTenantModal = function() {
      var ctrl = 'TenantModalCtrl as vc';
      var paramData = {TenantId:vm.data.TenantId}
      var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);

      modalInstance.result.then(function(okData) {
        vm.data.TenantNm = okData.TenantNm;
        vm.data.TenantId = okData.TenantId;
      }, function(cancelData) {
      });
    };

    vm.eraseTenant = function() {
      if (vm.TenantId != '0') {
        return;
      }
      vm.data.TenantNm = "";
      vm.data.TenantId = "";
    };
    // 회원사 조회 end

    // 역할 조회 start
    vm.srchUserroleModal = function() {
      var ctrl = 'UserroleModalCtrl as vc';
      var paramData = {
        TenantId : vm.srch.TenantId,
        UserRoles : vm.data.UserRoles
      };

      console.log(vm.data.UserRoles);

      var modalInstance = modalFactory.open('modal', 'components/modal/userRole/userrole-modal.html', ctrl, paramData);
      modalInstance.result.then(function(okData) {
        vm.data.UserRoles = okData;
        var UserRoleNms = [];
        var UserRoleIds = [];
        angular.forEach(vm.data.UserRoles, function(role) {
          UserRoleNms.push(role.RoleNm);
          UserRoleIds.push(role.RoleId);
        });
        vm.data.UserRoleNms = UserRoleNms.join(',');
        vm.data.UserRoleIds = UserRoleIds.join(',');
      }, function(cancelData) {
      });
    };

    vm.eraseUserRole = function() {
      vm.data.UserRoleIds = "";
      vm.data.UserRoleNms = "";
    };
    // 역할 조회 end

    /**
     * 등록/수정 화면에 표시할 컬럼 목록
     *
     * @param
     * @return
     * @author 최원영
     */

    /**
     * 등록/수정 화면에 표시할 컬럼인지 여부 확인
     *
     * @return {boolean} true - 존재시, false - 미 존재시
     * @param {string}
     *          columnNm - 물리 컬럼명
     * @author 최원영
     */
    function getIsShowColumn(columnNm) {
      var result = false;

      // 등록/수정 화면 컬럼 조회
      // if (vm.srch.editColumns.length === 0) {
      // getSelectListColumnList();
      // }
      var itemIndex = vm.srch.editColumns.indexOf(columnNm);
      result = (itemIndex > -1);
      return result;
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      if (vm.srch.ReserveId == null || vm.srch.ReserveId == "") {
        vm.dataloader = false;
        return;
      }

      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
      var data = vm.srchDetail;
      data.mapCode = 'User.getUserMgrDetail';
      postApi.select(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (result.body.desc.length > 0) {
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function(item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }

          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
            vm.UseYNData.Code = vm.data.UseYN;
            vm.data.UserRoles = [];
            var UserRoleIds = [];
            var UserRoleNms = [];
            if (vm.data.UserRoleIds != null) {
              UserRoleIds = vm.data.UserRoleIds.split(",");
            }
            if (vm.data.UserRoleNms != null) {
              UserRoleNms = vm.data.UserRoleNms.split(",");
            }
            angular.forEach(UserRoleIds, function(item, key) {
              var UserRole = {RoleId:item,RoleNm:UserRoleNms[key]};
              vm.data.UserRoles.push(UserRole);
            });

            var uploadFileList = [];

            angular.forEach(vm.data.uploadFileList, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
              };
              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);

            return;
          }
        } else {
          vm.dataloader = false;
        }
        gAlert('', result.body.docs[0].errMessage);
      }, function(error) {
        console.error('fail', status, error);
        gAlert('', error.body.docs[0].errMessage);
      });
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 첨부파일 목록 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getFileList() {
      if (vm.srch.ReserveId === null || vm.srch.ReserveId === "") {
        return;
      }

      var data = vm.srch;
      data.mapCode = 'FileAttach.getFileList';

      postApi.select(data, function(result){
        vm.dataloader = false;
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if(!vm.showUploader){
            // AngularJS Version
            var uploadFileList = [];

            angular.forEach(result.body.docs, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                typeId : 'file',
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
                delState : '',
              };

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        }
      }, function(error) {
        console.error('ErrorgetRoleList', status, error);
      });
    }

    /**
     * 데이터 저장
     *
     * @param
     * @return
     * @author 최원영
     */
    function setData() {

      if (vm.data.UseYN == undefined || vm.data.UseYN == '') {
        gAlert('', 'Menu.CHECKENABLE');
        return false;
      }

      if (vm.data.Password != vm.data.Password2) {
        gAlert('', 'Menu.INVALIEDCONFIRMPASSWORD');
        return false;
      }

      // 내용
      vm.data.tableNm = vm.srch.tableNm;
      vm.data.IdName = "ReserveId";
      vm.data.uploadFileList = vm.uploadFileList;
      console.log('file : ',vm.data.uploadFileList);
      vm.data.userkey = vm.srch.userkey;

      var data = vm.data;

      if (vm.data.ReserveId == null || vm.srch.ReserveId == "") {
        // 등록
        data.mapCode = "User.insertUser";
        postApi.insert(data, function(result){
          InsertUpdateDetail(result);
        }, function(error) {
          console.error("Error> user-edit-ctrl> setData()", status, error);
          gAlert("", result.responseVO.body.docs[0].errMessage);
        });
      } else {
        // 수정
        data.RelateDataId = data.ReserveId;
        data.mapCode = "User.updateUser";
        postApi.update(data, function(result){
          InsertUpdateDetail(result);
        }, function(error) {
          console.error("Error> user-edit-ctrl> setData()", status, error);
          gAlert("", result.responseVO.body.docs[0].errMessage);
        });
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].ReserveId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.ReserveId = result.body.docs[0].ReserveId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              var srch = $stateParams.srch;

              if (vm.layout == 'N') {
                if (vm.srch.ReserveId == null || vm.srch.ReserveId == "") {
                  $state.go("app.reserve.reserve-list", { srch: srch });
                } else {
                  // 조회 화면 이동
                  $state.go("app.reserve.reserve-detail", {
                    srch: srch,
                    ReserveId: vm.data.ReserveId
                  });
                }
              } else {
                vm.srch.ReserveId = "";
                vm.srch.reload = (new Date()).getTime();
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.reserve.reserve-list.detail", { srch: srch, ReserveId:vm.data.ReserveId });
              }
            }
          });
          return;
        }
      }
      gAlert("", result.body.docs[0].errMessage);
    }

    function goList() {
      vm.srch.ReserveId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go("app.reserve.reserve-list", { srch: srch });
    }

    // 함수 선언
    vm.getIsShowColumn = getIsShowColumn;
    vm.getData = getData;
    vm.getFileList = getFileList;
    vm.setData = setData;
    vm.goList = goList;

    vm.getComboRole = getComboRole;

    function getComboRole() {
      var data = {
        TenantId : vm.TenantId,
        mapCode : 'Role.getRoleList'
      };

      postApi.select(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.roleOption = result.body.docs;
        }
      }, function(error) {
        console.error('ErrorgetRoleList', status, error);
      });
    }

    // 데이터 조회
    getData();

  }, ]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.reserve:reserve-list-ctrl
 * @description
 * # 회의실 목록
 * Controller of the 회의실 목록
 */
webapp.controller('ReserveListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gConfirm', 'gAlert',
/**
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param userApi - userApi Module
 */
  function ReserveListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, modalFactory, postApi, gConfirm, gAlert) {
    // View Model
    var vm = this;
    vm.dataloader = false;

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'reserve',
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'reserve';
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.ReserveId;
    vm.listSize = [ 10, 25, 50, 100 ];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);
    vm.reloadSeq = 0;

    $scope.$on('broadcastSetChangeTenantID', function(event, data) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'reserve',
        sortDirect : '',
        sortColumn : '',
      };
      vm.reloadSeq = (new Date()).getTime();
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    // 전역상수 선언
    vm.viewSize = vm.srch.viewSize;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;

    /* Sorting Methods */
    function tablesort(sortkey, sortable){
      if (sortable == 'N') return;

      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }


    // 부서 조회 start
    vm.srchDeptModal = function() {
      var ctrl = 'DeptModalCtrl as vc';
      var paramData = {};
      var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);
        modalInstance.result.then(function(okData) {
        vm.srch.DeptNm = okData.label;
        vm.srch.DeptId = okData.data;
        }, function(cancelData) {
      });
    };

    vm.eraseDept = function() {
      vm.srch.DeptNm = "";
      vm.srch.DeptId = "";
    };
    // 부서 조회 end

    function getListCnt() {

      var data = vm.srch;
      data.mapCode = 'Calendar.getReserveCount';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error> getListCnt', status, error);
      });
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      vm.dataloader = true;
      vm.viewSize = vm.srch.viewSize;

      getListCnt();

      var data = vm.srch;
      data.selectType = 'List'; // For CustomColumn
      data.mapCode = 'Calendar.getReserveList';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.listColumns = result.body.desc;
            angular.forEach(vm.listColumns, function(item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
            setResponsive();
          } else {
            vm.lists = {};
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error> getList', status, error);
        vm.dataloader = false;
      });
    }

    function setResponsive(dockMode) {
      var rows =  vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md","lg", "md","xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function(item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if(o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if(item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString="YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.reserve.reserve-list', {srch:srch}, {reload:'app.reserve.reserve-list'});
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function getSearch() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.reserve.reserve-list', {srch:srch}, {reload:'app.reserve.reserve-list'});
    }

    function goDetail(ReserveId) {
      var srch = $stateParams.srch;
      vm.keyId = ReserveId;

      if (vm.layout == 'N') {
        $state.go('app.reserve.reserve-detail', {
          srch : srch,
          ReserveId : ReserveId,
        });
      } else {
        $state.go('app.reserve.reserve-list.detail', {
          srch : srch,
          ReserveId : ReserveId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      vm.keyId = ReserveId;

      if (vm.layout == 'N') {
        $state.go('app.reserve.reserve-edit', {
          srch : srch, ReserveId : ''
        });
      } else {
        $state.go('app.reserve.reserve-list.edit', {
          srch : srch, ReserveId : ''
        });
      }
    }

    function resetSearch() {
      $state.go('app.reserve.reserve-list', {
        srch : ''
      }, {reload: 'app.reserve.reserve-list'});
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $rootScope.changeLayout(layout);

      var srch = $stateParams.srch;
      $state.go('app.reserve.reserve-list', {
        srch : srch
      }, {reload: 'app.reserve.reserve-list'});
    }

    function uploadExcel() {
      var ctrl = 'UploadExcelUserModalCtrl as vc';
      var paramData = {};
      var modalInstance = modalFactory.open('modal', 'components/modal/excel/upload-excel-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(okData) {
        vm.srch.DeptNm = okData.label;
        vm.srch.DeptId = okData.data;
        }, function(cancelData) {
      });
    }

    /** 목록에서 선택승인 **/
    vm.apprAll = function() {
      gConfirm('', '선택된 신청을 승인하시겠습니까?\r\n이미 승인된 회의실의 시간대는 승인되지 않습니다.', {
        btn : '',
        fn : function() {
          vm.dataloader = true;

          var data = { idArr:[] };
          angular.forEach(vm.lists, function(item) {
            if (item.ChkYN == 'Y') {
              data.idArr.push(item.ReserveId);
            }
          });

          data.mapCode = 'Calendar.updateReserveAppr';
          data.ApprYN = 'A';
          postApi.update(data, function(result){
            vm.dataloader = false;
            if (result.header.status === CONSTANT.HttpStatus.OK) {
//              vm.lists = result.body.docs;
              getList();
            } else {
              console.error('Error> getListCnt', result.body.docs);
              gAlert("", result.body.docs[0].errMessage);
            }
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> getListCnt', status, error);
          });
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    };

    /** 목록에서 선택승인취소 **/
    vm.apprCancelAll = function() {
      gConfirm('', '선택된 신청을 승인취소하시겠습니까?', {
        btn : '',
        fn : function() {
          vm.dataloader = true;

          var data = { idArr:[] };
          angular.forEach(vm.lists, function(item) {
            if (item.ChkYN == 'Y') {
              data.idArr.push(item.ReserveId);
            }
          });

          data.mapCode = 'Calendar.updateReserveAppr';
          data.ApprYN = 'W';
          postApi.update(data, function(result){
            vm.dataloader = false;
            if (result.header.status === CONSTANT.HttpStatus.OK) {
//              vm.lists = result.body.docs;
              getList();
            } else {
              console.error('Error> getListCnt', result.body.docs);
              gAlert("", result.body.docs[0].errMessage);
            }
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> getListCnt', status, error);
          });
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    };

    /** 전체선택 **/
    function checkAll() {
      var checkedAll = vm.checkedAll;

      angular.forEach(vm.lists, function(item) {
        item.ChkYN = checkedAll == 'Y' ? 'Y' : 'N';
      });
    }
    vm.checkedAll = 'N';

    vm.openMeetingRoom = function() {
      /* $window.open('/#/reserve/meeting-room/', "salemeet.meetingroom"); */
      $state.go('reserve.meeting-room', {
        srch : ''
      });
    };

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.changeLayout = changeLayout;
    vm.sortClass = sortClass;
    vm.tablesort = tablesort;
    vm.getSearch = getSearch;
    vm.uploadExcel = uploadExcel;
    vm.checkAll = checkAll;

    // 데이터 조회
    getList();
  }, ]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.reserve', {
      url : '/reserve',
      template : '<div ui-view></div>'
    }).state('app.reserve.reserve-list', {
      url: '/reserve-list/:srch',
      templateUrl: 'app/reserve/reserve-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.reserve.reserve-daily', {
      url: '/reserve-daily/:srch',
      templateUrl: 'app/reserve/reserve-daily.html',
      requiresAuthentication: true,
    }).state('app.reserve.reserve-detail', {
      url: '/reserve-detail/:srch/:ReserveId',
      templateUrl: 'app/reserve/reserve-detail.html',
      requiresAuthentication: true,
    }).state('app.reserve.reserve-edit', {
      url: '/reserve-edit/:srch/:ReserveId',
      templateUrl: 'app/reserve/reserve-edit.html',
      requiresAuthentication: true,
    }).state('app.reserve.reserve-list.detail', {
      url: '/reserve/:ReserveId',
      templateUrl: 'app/reserve/reserve-detail.html',
      requiresAuthentication: true,
    }).state('app.reserve.reserve-list.edit', {
      url: '/reserve/:ReserveId',
      templateUrl: 'app/system/reserve-edit.html',
      requiresAuthentication: true,
    }).state('app.reserve.reservecode-list', {
      url: '/reservecode-list',
      templateUrl: 'app/reserve/reservecode-list.html',
      requiresAuthentication: true,
    });
  }
})();

webapp.controller('ReservecodeListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'StaticVariable', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
    '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', function ReservecodeListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, StaticVariable, api, modalWindow, $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate) {
      var vm = this;
      vm.dataloader = false;
      vm.maxcommoncodeid = 0;
      vm.lists = [];
      vm.saveYn = true;

      vm.srch = {
        Code : 'MEETINGROOM',
        CodeType : 'MEETINGROOM'
      };

      vm.data = { CustomCode: 0 };
      $scope.codeDisabled = false;

      vm.vault = null;
      // 업로드 파일 목록
      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드 완료
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(saveData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param, function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );
        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      $scope.toggleLeft = buildToggler('left');
      $scope.toggleRight = buildToggler('right');
      /**
       * Build handler to open/close a SideNav; when animation finishes
       * report completion in console
       */
      function buildToggler(navID) {
        var debounceFn = $mdUtil.debounce(function() {
          $mdSidenav(navID).toggle().then(function() {
            console.debug("toggle " + navID + " is done");
          });
        }, 200);
        return debounceFn;
      }

      $scope.init = function() {
        // check if there is query in url
        // and fire search in case its value is not empty
      };

      // stops the interval
      $scope.$on("$destroy", function() {
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        resetList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      function resetSearch() {
        vm.srch.CodeValue = '';
        vm.data = { CustomCode: 0 };
        tree.select_branch(null);
      }

      function resetList() {
        resetSearch();
        getTreeList();
      }

      vm.nextSearch = function() {
        tree.next_search_text();
      };

      // 함수 선언
      vm.resetSearch = resetSearch;
      vm.resetList = resetList;
      vm.getTreeList = getTreeList;
      vm.delNode = delNode;
      vm.delNodeCancel = delNodeCancel;
      vm.saveData = saveData;
      vm.onChangeCodeValue = onChangeCodeValue;
      vm.onChangeCode = onChangeCode;
      vm.onChanged = onChanged;
      vm.ChangeCustomCode = ChangeCustomCode;
      vm.uploadFile = uploadFile;
      vm.getUploadFileList = getUploadFileList;
      vm.parentCodeValue01 = '';

      // my_tree 반드시 선언하기
      var tree;
      $scope.my_tree = tree = {};

      vm.topItem = null;

      vm.UseYNData = {
        CallbackTarget : '0000',
        CodeType : 'USEYN',
        Code : vm.data.UseYN,
        ReloadSeq : 1
      };

      vm.ReserveYNData = {
        CallbackTarget : '0001',
        CodeType : 'RESERVEYN',
        Code : vm.data.CodeValue02,
        ReloadSeq : 1
      };

      vm.onSelectCallback = function(data) {
        if (data.CallbackTarget == '0000') {
          vm.data.UseYN = data.Code;
        }
        else if (data.CallbackTarget == '0001') {
          vm.data.CodeValue02 = data.Code;
        }
      };

      getTreeList();

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        // 로케이션관리 select 검색실행함
        var data = vm.srch;
        data.mapCode = 'CommonCode.getCommonCodeTreeList';

        data.IdName = "CommonCodeId";   // Primary Key Column
        data.tableNm = "commoncode";    // 작업 테이블명

        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length == 0) {
              return;
            }

            // select한 datatable 바인딩
            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            refreshTree();

            // 트리 펼치기
            $timeout(function() {
              return tree.expand_init();
            }, 1);
          }
        }, function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {
        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {
            "label" : jsonObj[i].label,
            "data" : jsonObj[i].guid,
            "children" : jsonObj[i].children,
            "classes" : jsonObj[i].classes,
          };

          jsonObj[i] = newItem;
        }
      }

      // 트리 목록에서 조회값
      $scope.my_tree_handler = function(branch) {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            vm.data = item;

            vm.UseYNData = {
              CallbackTarget : '0000',
              CodeType : 'USEYN',
              Code : vm.data.UseYN,
              ReloadSeq : (new Date()).getTime()
            };

            vm.ReserveYNData = {
              CallbackTarget : '0001',
              CodeType : 'RESERVEYN',
              Code : vm.data.CodeValue02,
              ReloadSeq : (new Date()).getTime()
            };

            var pBranch = tree.get_parent_branch(branch);

            vm.parentCodeValue01 = '';

            if (pBranch) {
              angular.forEach(vm.lists, function(pItem) {
                if (pBranch.data == pItem.CommonCodeId.toString()) {
                  vm.parentCodeValue01 = pItem.CodeValue01;
                }
              });
            }

            if (item.Code.toString() == "MEETINGROOM") {
              $scope.codeDisabled = true;
            }
            else {
              $scope.codeDisabled = false;
            }

            getUploadFileList();

            return;
          }
        });
      };

      $scope.try_adding_a_branch = function() {
        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
        var commonCodeId = newnum.toString(36);
        var branch = tree.get_selected_branch();

        if (branch == null) {
          var commoncode = {
            'CodeValue' : '새로운 코드',
            'CommonCodeId' : commonCodeId,
            'ParentCommonCodeId' : 0,
            'CodeLevel' : 1,
            'UseYN' : 'Y',
            'New' : 'Y',
            'CodeType' : '',
            'TenantId' : $rootScope.gVariable.srchTenantId,
            'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1,
            'CodeValue02' : 'Y',
          };

          vm.lists.push(commoncode);
        } else {
          angular.forEach(vm.lists, function(item) {
            if (branch.data == item.CommonCodeId.toString()) {
              var commoncode = {
                'CodeValue' : '새로운 코드',
                'CommonCodeId' : commonCodeId,
                'ParentCommonCodeId' : branch.data,
                'CodeLevel' : item.CodeLevel + 1,
                'UseYN' : 'Y',
                'New' : 'Y',
                'CodeType' : item.CodeType == '000' ? item.Code : item.CodeType,
                'TenantId' : $rootScope.gVariable.srchTenantId,
                'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1,
                'CodeValue01' : item.CodeValue01,
                'CodeValue02' : 'Y',
              };

              vm.lists.push(commoncode);
              vm.parentCodeValue01 = item.CodeValue01;

              return;
            }
          });
        }

        var code = {};

        if ($rootScope.gVariable.srchTenantId == 0) {
          code = {label: '[*]새로운 코드', data: commonCodeId};
        } else {
          code = {label: '[*]새로운 코드', data: commonCodeId, classes: ['color-red']};
        }

        var new_branch = tree.add_branch(branch, code);
        tree.select_branch(new_branch);

        $scope.codeDisabled = false;
      };

      function delNode() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
          $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
          return;
        }

        gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
          btn : '',
          fn : function(){
            if (vm.data.New == 'Y') {
              deleteNodeTree();
            } else {
              vm.data.DelYN = 'Y';
              saveData();
            }
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteNodeTree() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            var index = vm.lists.indexOf(item);
            vm.lists.splice(index, 1);

            var parent = tree.select_parent_branch();

            if(parent) {
              parent.children.splice(parent.children.indexOf(branch),1);
            } else {
              refreshTree();
            }

            return;
          }
        });

        tree.select_branch(null);
        vm.data = { CustomCode: 0 };
      }

      function refreshTree() {
        // 리스트 생성
        var arrlist = [];

        // for문으로 다시 json 구조로 변환함.
        angular.forEach(vm.lists, function(item) {
          // 객체 생성
          var data = {};

          data.label = $translate.instant(item.CodeValue);
          data.guid = item.CommonCodeId;
          data.parent = item.ParentCommonCodeId == undefined || item.ParentCommonCodeId == 0  || item.CodeType == '000' ? null : item.ParentCommonCodeId;
          data.classes = [];
          data.classes.push(item.TenantId == '0' ? '' : 'color-red');

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (item.CommonCodeId > vm.maxcommoncodeid)
            vm.maxcommoncodeid = item.CommonCodeId;
        });

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
//        $timeout(function() {
//          return tree.expand_all();
//        }, 1);
      }

      function onChangeCodeValue() {
        onChanged();

        var branch = tree.get_selected_branch();
        if (branch == null) return;
        branch.label = '[*]' + vm.data.CodeValue;
      }

      function onChangeCode() {
        onChanged();

        if (vm.data.New == 'Y') {
        }

        if (vm.parentCodeValue01) {
          vm.data.CodeValue01 = vm.parentCodeValue01 + "." + vm.data.Code;
        } else {
          vm.data.CodeValue01 = vm.data.Code;
        }
      }

      function onChanged() {
        if (vm.data.New == null || vm.data.New != 'Y') {
          vm.data.Edit = 'Y';
        }
      }

      function removeNode(jsonObj, commonCodeId) {
        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].data == commonCodeId) {
            jsonObj[i].children = [];
            return true;
          }

          if (jsonObj[i].children == null) {
          } else {
            if (removeNode(jsonObj[i].children, commonCodeId) == true)
              break;
          }
        }
      }

      function delNodeCancel() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            item.DelYN = 'N';
            branch.label = branch.label.replace(/^\[X\]/,"");
            return;
          }
        });
      }

      function saveData() {
        vm.dataloader = true;
        var data = {lists : []};
        data.mapCode = 'CommonCode.insertCommoncodeDetailBatch';

        data.RelateDataId = vm.data.CommonCodeId;   // Primary Key Column
        data.tableNm = "commoncode";                // 작업 테이블명
        data.uploadFileList = [];
        data.CodeValue01 = vm.data.CodeValue01;  // 회의실의 첨부된 사진을 가져올때 필요
        angular.forEach(vm.uploadFileList, function(item) {
          data.uploadFileList.push(item);
        });

        data.lists.push(vm.data);

        postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            var branch = tree.get_selected_branch();
            branch.label = branch.label.replace(/^\[\*\]/,"");

            if (vm.data.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.New = '';
            } else if (vm.data.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.Edit = '';
            }

            getUploadFileList();
          }
        },
        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

      }

      function ChangeCustomCode() {
        if (vm.data.CustomCode == 0) {
          gConfirm('', $translate.instant('MSG.CUSTOMCODESTART'), {
            btn : '',
            fn : function(){
              var data = vm.data;
              var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
              data.NewCommonCodeId = newnum.toString(36).toUpperCase();
              data.mapCode = 'CommonCode.makeCustomCommonCode';
              postApi.insert(data, function(result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {
                  getTreeList();
                  vm.data.CustomCode = 1;
                }
              }, function(error) {
                console.error('fail', status, data);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        } else {
          gConfirm('', $translate.instant('MSG.CUSTOMCODESTOP'), {
            btn : '',
            fn : function(){
              var data = vm.data;
              data.mapCode = 'CommonCode.removeCustomCommonCode';
              postApi.update(data, function(result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {
                  getTreeList();
                  vm.data.CustomCode = 0;
                }
              }, function(error) {
                console.error('fail', status, data);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          saveData();
        }
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.data.CommonCodeId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getFileList';
        data.TableId = vm.data.CommonCodeId;
        data.tableNm = "commoncode";

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {

              var uploadFileList = [];
              // 첨부파일 목록 설정
              vm.uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            //}
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      // 첨부파일 컴포넌트 초기화
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback, false, 'jpg, gif, png, bmp, dib, tif, tiff');

    } ]);


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.cafe24:customer-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('Cafe24DeleteUserCtrl', ['$window', '$rootScope', '$scope', '$location', '$http', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function Cafe24DeleteUserCtrl($window, $rootScope, $scope, $location, $http, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {
      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.cafe24.customer-list';           // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.cafe24.customer-list.customer-detail'; // 목록 상세 화면
      var DETAIL_PAGE_URL = 'app.cafe24.customer-detail';       // 상세 화면

      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          tableNm: 'cafe24.customers'
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      vm.columnMap = {};

      // 조회 데이터
      vm.data = {

      };


      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
      }

      function getExcel() {
        var data = {};
        data.mapCode = 'generatechart';
        data.fileNm= 'test.xlsx';
        postApi.excelFile(data, function(result){
          vm.dataloader = false;
        }, function (error) {
          // 조회 중 오류 발생
          vm.dataloader = false;
          console.error("Error> generatechart");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goList = goList;                       // 목록 화면 이동
      vm.getExcel = getExcel;

      // 데이터 조회
      getData();

    }]);


})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:caretkt-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('CaretktEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function CaretktEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Caretkt.insertCareTkt';     // 등록 SQL
      var UPDATE_SQL = 'Caretkt.updateCareTkt';     // 수정 SQL
      var VIEW_SQL = 'Caretkt.getCareTktDetail';    // 조회 SQL
      var PRODUCT_SQL = 'Product.getPrdList';       // 쇼핑몰 제품 조회 SQL
      var CAREPRD_SQL = 'Caretkt.getCarePrdList';   // 관리권 제품 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.caretkt-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.caretkt-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.caretkt-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvscaretkt'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var TKTPRD_TABLE_NM = 'cvscaretktprd'; // 관리권제품 테이블명
      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      vm.prdColumnMap = {}; // 관리권 제품 컬럼(cvscaretktprd)
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      vm.deletePrdList = []; // 삭제할 제품
      vm.tktPrdLists = [];  // 관리권 제품 목록

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시


        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼
        vm.srchDetail.tableNm = KEY_TABLE_NM;
        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            gettktPrd();
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
            } else {
            vm.data.TenantId = $window.sessionStorage['loginTenantId'];
            vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      /**
       * 제품 조회
       * @param
       * @return
       */
      function getPrds() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        //쇼핑몰 제품 가져오기
        var data = vm.srchDetail;
        data.mapCode = PRODUCT_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.PrdLists = result.body.docs;

            } else {
              vm.PrdLists = {};
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getPrds()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getPrds()");
          console.table(error);
          gAlert('', error.body.docs[0].errMessage);
        });
      }


      function gettktPrd() {
        //관리권 제품 가져오기
        vm.srchDetail.tableNm = TKTPRD_TABLE_NM;
        var data = vm.srchDetail;
        data.mapCode = CAREPRD_SQL;
        data.selectType = 'List';

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.prdListColumns = result.body.desc;
              angular.forEach(vm.prdListColumns, function (item) {
                vm.prdColumnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.prdListColumns)) {
              // 조회 데이터 설정
              vm.tktPrdLists = result.body.docs;

            } else {
              vm.tktPrdLists = [];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getPrds()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getPrds()");
          gAlert('', error.body.docs[0].errMessage);
        });

      }
      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      vm.uploadFile = function () {
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      };

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {

        // #region 필수항목 체크
         var errMsg = '';
        if (isNullOrEmpty(vm.data.CareTktNm))
          errMsg = errMsg + '- 관리권명을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.MngCnt))
          errMsg = errMsg + '- 관리횟수를 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.Price))
        errMsg = errMsg + '- 가격을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.tktPrdLists))
          errMsg = errMsg + '- 품목을 선택하세요.<br/>';

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }


        // #endregion 필수항목 체크

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = vm.uploadFileList; // 첨부파일
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        vm.data.tktPrdLists = vm.tktPrdLists;
        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            InsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', error.body.docs[0].errMessage);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;
          data.deletePrdList = vm.deletePrdList;

          postApi.update(data, function (result) {
            InsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', result.responseVO.body.docs[0].errMessage);
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function InsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                var srch = $stateParams.srch; // 검색 옵션

                // 화면 분할 모드에 따른 이동
                if (vm.layout == 'N') {
                  if (isNullOrEmpty(vm.srch.keyId)) {
                    // 신규등록 -> 목록 화면 이동
                    $state.go(LIST_PAGE_URL, {srch: srch});
                  } else {
                    // 수정 -> 조회 화면 이동
                    $state.go(VIEW_PAGE_URL, {
                      srch: srch,
                      keyId: vm.data.KeyId
                    });
                  }
                } else {
                  vm.srch.keyId = "";
                  vm.srch.reload = (new Date()).getTime();
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  // 조회 화면 이동
                  $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
                }
              }
            });
            return;
          }
        }

        console.error("Error> InsertUpdateDetail()");
        gAlert("", result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function delData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            delDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function delDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        data.tableNm = KEY_TABLE_NM;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
          console.table(error.body.docs[0].errMessage);
        });
      }
      /**
       * 제품 추가
       *
       * @param
       * @return
       */
      function addPrd(row) {

        var res = false;
        angular.forEach(vm.tktPrdLists, function (item) {
          if(row.GoodsNo == item.GoodsNo){
            item.MngCnt++;
            item.MngAmt = row.GoodsPrice * item.MngCnt;
            res = true;
          }
        });
        var addRow = {};
        if(!res) {
          var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
          addRow = {
            MngSeq : 0,
            GoodsNm : row.GoodsNm,
            GoodsPrice : row.GoodsPrice,
            MngAmt : row.GoodsPrice,
            MngCnt : 1,
            GoodsNo : row.GoodsNo,
            CareTktPrdId : newnum.toString(36),
            isNew : true,
          };
          vm.tktPrdLists.push(addRow);
        }

        prdTotal();
      }
      /**
      * 제품 횟수 수정
      *
      * @param
      * @return
      */
     function changePrdCnt(row) {
      if(row.MngCnt == '' || row.MngCnt == undefined || row.MngCnt == null) row.MngAmt = 0;
      else row.MngAmt = row.GoodsPrice * row.MngCnt;

      prdTotal();
     }

     /**
      * 제품 삭제
      *
      * @param
      * @return
      */
     function prdDelete(row) {
      vm.tktPrdLists.splice(vm.tktPrdLists.indexOf(row), 1);
      if(row.isNew == undefined) vm.deletePrdList.push(row);
      prdTotal();
     }

      /**
      * 제품 가격 sum
      *
      * @param
      * @return
      */
     function prdTotal() {
       var sum = 0;
      angular.forEach(vm.tktPrdLists, function (item) {
        sum += item.GoodsPrice * item.MngCnt;
      });
      vm.data.Price = sum;
     }



      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      vm.setData = setData;                     // 데이터 저장
      vm.goList = goList;                       // 목록 화면 이동
      vm.delData = delData;                     // 데이터 삭제
      vm.addPrd = addPrd;                       // 쇼핑몰 제품 선택
      vm.changePrdCnt = changePrdCnt;             // 제품 횟수 수정
      vm.prdDelete = prdDelete;               // 제품 삭제

      // 데이터 조회
      getData();
      getPrds();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:CareTkt-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 관리권관리 목록
   */
  webapp.controller('CareTktListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CareTktListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Caretkt.getCareTktListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Caretkt.getCareTktList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Caretkt.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Caretkt.deleteCareTktList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.caretkt-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.caretkt-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.caretkt-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.caretkt-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.caretkt-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvscaretkt'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CareTktId'; // Primary Key Column
      var EXCEL_TITLE = '관리권관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.EntryDtFrom = $rootScope.getDateFormat(vm.srch.EntryDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.EntryDtTo = $rootScope.getDateFormat(vm.srch.EntryDtTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;

      vm.listSize = [10, 25, 50, 100]; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function changeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      function init(){

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 목록 삭제
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.CareTktIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.CareTktIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.CareTktIdList == null || vm.srch.CareTktIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = angular.copy(vm.srch);
        data.mapCode = DELETE_LIST_SQL;

        console.log(data);
        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          gAlert('', error.body.docs[0].errMessage);
          console.error("Error> deleteListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.changeLayout = changeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      init();
    }]);
})();

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.system:common-properties-ctrl
 * @description
 * # 공통설정
 * Controller of the 공통설정
 */

webapp.controller('CommonPropertiesCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm', '$translate',
/**
 * 시스템관리 - 공통설정 Control
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param postApi - postApi Module
 */
  function CommonPropertiesCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, gConfirm, $translate) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    vm.srch = {};

    vm.lists = [];

    /**
     * 데이터 조회
     *
     * @param
     * @return
    */
    function getList() {
      //getListCount();
      vm.dataloader = true;

      var data = vm.srch;
      postApi.sendPostApi('api/CommonProperties', 'getCommonPropertiesList', data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;

            angular.forEach(vm.lists, function(item) {
              item.makeCustomYN = 'Y';
            });
          } else {
            vm.totalItems = 0;
            vm.lists = [];
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    function getListCount() {
      var data = vm.srch;
      data.mapCode = 'CommonProperties.getCommonPropertiesList';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error-getList', status, data);
      });
    }

    function saveListComment() {
      if ($rootScope.gVariable.srchTenantId == 0 || $rootScope.gVariable.SysAdminYN != 'Y') {
        saveList();
        return;
      }

      gConfirm('', 'Menu.SAVECONFIRM', {
        btn : '',
        fn : function() {
          saveList();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function saveList() {
      //getListCount();
      if(!$scope.form1.$valid) {
        return false;
      }

      vm.dataloader = true;

      var data = {lists : []};
      angular.forEach(vm.lists, function(item) {
        if (item.makeCustomYN && item.makeCustomYN == 'Y') {
          data.lists.push(item);
        }
      });

      if (data.lists.length == 0) {
        return;
      }

      data.mapCode = 'CommonProperties.insertCommoncodeDetailBatch';

      postApi.insert(data, function(result) {
        vm.dataloader = false;
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          getList();
        }
      }, function(error) {
        console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    function addNew() {
      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
      var commonPropertiesId = newnum.toString(36);

      var item = {
        CommonPropertiesId:commonPropertiesId,
        isNew:'Y',
        TenantId:$rootScope.gVariable.srchTenantId,
        makeCustomYN:'Y'
      };
      vm.lists.push(item);
    }

    function checkChanged(li) {
      if (li.DelYN == 'Y') {
        if (li.isNew == 'Y') {
          angular.forEach(vm.lists, function(item, key) {
            if (item.CommonPropertiesId == li.CommonPropertiesId) {
              console.log(item, key);
              vm.lists.splice(key, 1);
            }
          });
        }
      }
    }

    // 함수 선언
    vm.getList = getList;
    vm.saveList = saveList;
    vm.saveListComment = saveListComment;
    vm.addNew = addNew;
    vm.checkChanged = checkChanged;

    // 데이터 조회
    getList();
  }, ]);
})();

webapp.service('CommoncodeAPISrv', [ '$resource', 'StaticVariable', function CommoncodeAPISrv($resource, StaticVariable) {
  console.log('CommoncodeAPISrv');
  var api = {
    doList : function() {
      return $resource(StaticVariable.getUrl('/select/CommonCode.getCommonCodeList/action.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doSaveList : function() {
      return $resource(StaticVariable.getUrl('/api/system/updateCommoncodeListBatch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doUpdateDeviceInfoStatusCd : function() {
      return $resource(StaticVariable.getUrl('/api/device/updateDeviceInfoStatusCd.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doTreeList : function() {
      return $resource(StaticVariable.getUrl('/select/CommonCode.getCommonCodeTreeList/action.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
  };
  return api;
} ]);

webapp.controller('CommoncodeListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
    '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', function CommoncodeListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, api, modalWindow, $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate) {
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.maxcommoncodeid = 0;
      vm.lists = [];
      vm.saveYn = true;
      vm.data = {CustomCode: 0};

      $scope.toggleLeft = buildToggler('left');
      $scope.toggleRight = buildToggler('right');
      /**
       * Build handler to open/close a SideNav; when animation finishes
       * report completion in console
       */
      function buildToggler(navID) {
        var debounceFn = $mdUtil.debounce(function() {
          $mdSidenav(navID).toggle().then(function() {
            console.debug("toggle " + navID + " is done");
          });
        }, 200);
        return debounceFn;
      }

      $scope.init = function() {
        // check if there is query in url
        // and fire search in case its value is not empty
      };

      // stops the interval
      $scope.$on("$destroy", function() {
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        resetList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      function resetSearch() {
        vm.srch.CodeValue = '';
        vm.data = {CustomCode: 0};
        tree.select_branch(null);
      }

      function resetList() {
        resetSearch();

        getTreeList();
      }

      vm.nextSearch = function() {
        tree.next_search_text();
      };

      // 함수 선언
      vm.resetSearch = resetSearch;
      vm.resetList = resetList;
      vm.getTreeList = getTreeList;
      vm.delNode = delNode;
      vm.delNodeCancel = delNodeCancel;
      vm.saveData = saveData;
      vm.onChangeCodeValue = onChangeCodeValue;
      vm.onChangeCode = onChangeCode;
      vm.onChanged = onChanged;
      vm.ChangeCustomCode = ChangeCustomCode;
      vm.parentCodeValue01 = '';

      // my_tree 반드시 선언하기
      var tree;
      $scope.my_tree = tree = {};

      vm.topItem = null;

      vm.UseYNData = {
        CallbackTarget : '0000',
        CodeType : 'USEYN',
        Code : vm.data.UseYN,
        ReloadSeq : 1
      };

      vm.onSelectCallback = function(data) {
        if (data.CallbackTarget == '0000') {
          vm.data.UseYN = data.Code;
        }
      };

      getTreeList();

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        // 로케이션관리 select 검색실행함
        var data = vm.srch;
        data.mapCode = 'CommonCode.getCommonCodeTreeList';
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length == 0) {
              return;
            }

            // select한 datatable 바인딩
            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            refreshTree();

            // 트리 펼치기
            $timeout(function() {
              return tree.expand_init();

            }, 1);
          }
        }, function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {

        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {
            "label" : jsonObj[i].label,
            "data" : jsonObj[i].guid,
            "children" : jsonObj[i].children,
            "classes" : jsonObj[i].classes,
          }
          jsonObj[i] = newItem;
        }
      }

      // 트리 목록에서 조회값
      $scope.my_tree_handler = function(branch) {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            vm.data = item;
            vm.UseYNData = {
              CallbackTarget : '0000',
              CodeType : 'USEYN',
              Code : vm.data.UseYN,
              ReloadSeq : (new Date()).getTime()
            };

            var pBranch = tree.get_parent_branch(branch);

            vm.parentCodeValue01 = '';

            if (pBranch) {
              angular.forEach(vm.lists, function(pItem) {
                if (pBranch.data == pItem.CommonCodeId.toString()) {
                  vm.parentCodeValue01 = pItem.CodeValue01;
                }
              });
            }

            return;
          }
        });
      };

      $scope.try_adding_a_branch = function() {

        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
        var commonCodeId = newnum.toString(36);

        var branch = tree.get_selected_branch();
        if (branch == null) {
          var commoncode = {
            'CodeValue' : '새로운 코드',
            'CommonCodeId' : commonCodeId,
            'ParentCommonCodeId' : 0,
            'CodeLevel' : 1,
            'UseYN' : 'Y',
            'New' : 'Y',
            'CodeType' : '',
            'TenantId' : $rootScope.gVariable.srchTenantId,
            'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1
          };
          vm.lists.push(commoncode);
        } else {
          angular.forEach(vm.lists, function(item) {
            if (branch.data == item.CommonCodeId.toString()) {
              var commoncode = {
                'CodeValue' : '새로운 코드',
                'CommonCodeId' : commonCodeId,
                'ParentCommonCodeId' : branch.data,
                'CodeLevel' : item.CodeLevel + 1,
                'UseYN' : 'Y',
                'New' : 'Y',
                'CodeType' : item.CodeType == '000' ? item.Code : item.CodeType,
                'TenantId' : $rootScope.gVariable.srchTenantId,
                'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1,
                'CodeValue01' : item.CodeValue01
              };
              vm.lists.push(commoncode);
              vm.parentCodeValue01 = item.CodeValue01;
              return;
            }
          });
        }

        var code = {};
        if ($rootScope.gVariable.srchTenantId == 0) {
          code = {label: '[*]새로운 코드', data: commonCodeId};
        } else {
          code = {label: '[*]새로운 코드', data: commonCodeId, classes: ['color-red']};
        }
        var new_branch = tree.add_branch(branch, code);
        tree.select_branch(new_branch);
      };

      function delNode() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
          $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
          return;
        }

        gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
          btn : '',
          fn : function(){
            if (vm.data.New == 'Y'){
              deleteNodeTree();
            }else {
              vm.data.DelYN = 'Y';
              saveData();
            }
          }
        }, {
          btn : '',
          fn : function(){
          }
        });
      }

      function deleteNodeTree() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            var index = vm.lists.indexOf(item);
            vm.lists.splice(index, 1);

            var parent = tree.select_parent_branch();
            if(parent){
              parent.children.splice(parent.children.indexOf(branch),1);
            } else {
              refreshTree();
            }

            return;
          }
        });

        tree.select_branch(null);
        vm.data = {CustomCode: 0};
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = [];

        // for문으로 다시 json 구조로 변환함.
        angular.forEach(vm.lists, function(item) {
          // 객체 생성
          var data = {};

          data.label = $translate.instant(item.CodeValue);
          data.guid = item.CommonCodeId;
          data.parent = item.ParentCommonCodeId == undefined || item.ParentCommonCodeId == 0 ? null : item.ParentCommonCodeId;
          data.classes = [];
          data.classes.push(item.TenantId == '0' ? '' : 'color-red');

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (item.CommonCodeId > vm.maxcommoncodeid)
            vm.maxcommoncodeid = item.CommonCodeId;
        });

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
//        $timeout(function() {
//          return tree.expand_all();
//        }, 1);

      }

      function onChangeCodeValue() {
        onChanged();
        var branch = tree.get_selected_branch();
        if (branch == null) return;
          branch.label = '[*]' + vm.data.CodeValue;
      }

      function onChangeCode() {
        onChanged();
        if (vm.data.New == 'Y') {
        }

        if (vm.parentCodeValue01) {
          vm.data.CodeValue01 = vm.parentCodeValue01 + "." + vm.data.Code;
        } else {
          vm.data.CodeValue01 = vm.data.Code;
        }
      }

      function onChanged() {
        if (vm.data.New == null || vm.data.New != 'Y') {
          vm.data.Edit = 'Y';
        }
      }

      function removeNode(jsonObj, commonCodeId) {
        for (var i = 0; i < jsonObj.length; i++) {
          console.log('jsonObj[i]=', jsonObj[i]);
          console.log('CommonCodeId=', commonCodeId);

          if (jsonObj[i].data == commonCodeId) {
            jsonObj[i].children = [];
            return true;
          }

          if (jsonObj[i].children == null) {
          } else {
            if (removeNode(jsonObj[i].children, commonCodeId) == true)
              break;
          }
        }
      }

      function delNodeCancel() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            item.DelYN = 'N';
            branch.label = branch.label.replace(/^\[X\]/,"");;
            return;
          }
        });
      }

      function saveData() {
        vm.dataloader = true;
        var data = {lists : []};
        data.mapCode = 'CommonCode.insertCommoncodeDetailBatch';
        data.lists.push(vm.data);
        postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            var branch = tree.get_selected_branch();
            branch.label = branch.label.replace(/^\[\*\]/,"");

            if (vm.data.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.New = '';
            } else if (vm.data.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.Edit = '';
            }
//            getTreeList();
          }
        },

        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

      }

      function ChangeCustomCode() {
        console.log($rootScope.gVariable);
        if (vm.data.CustomCode == 0) {
          gConfirm('', $translate.instant('MSG.CUSTOMCODESTART'), {
            btn : '',
            fn : function(){
              var data = vm.data;
              var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
              data.NewCommonCodeId = newnum.toString(36).toUpperCase();
              data.mapCode = 'CommonCode.makeCustomCommonCode';
              postApi.insert(data, function(result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {
                  getTreeList();
                  vm.data.CustomCode = 1;
                }
              }, function(error) {
                console.error('fail', status, data);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        } else {
          gConfirm('', $translate.instant('MSG.CUSTOMCODESTOP'), {
            btn : '',
            fn : function(){
              var data = vm.data;
              data.mapCode = 'CommonCode.removeCustomCommonCode';
              postApi.update(data, function(result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {
                  getTreeList();
                  vm.data.CustomCode = 0;
                }
              }, function(error) {
                console.error('fail', status, data);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        }
      }

    } ]);


webapp.service('CompanyAPISrv', ['$resource', '$rootScope', 'StaticVariable',
  function CompanyAPISrv($resource, $rootScope, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Tenant.getTenantList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/Tenant.getTenantCount/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Tenant.getTenantDetail/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doFileList: function() {
        return $resource(StaticVariable.getUrl('/select/FileAttach.getFileList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doComboRole: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/tenant/updateTenant.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/tenant/insertTenant.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Tenant.deleteTenantDetail/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveAttachFile: function() {
        return $resource(StaticVariable.getUrl('/attach/saveAttachFile.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      attachFileDelete: function() {
        return $resource(StaticVariable.getUrl('/attach/file/delete.do'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

(function() {
  "use strict";
 /**
 * @ngdoc function
 * @name app.bbspost:company-detail-ctrl
 * @description # 회원사 조회 Controller of the 회원사관리
 */
webapp.controller('CompanyDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'CompanyAPISrv', 'postApi',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService',


    /**
     * 회원사관리 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          api - CompanyApiSvr Module
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function CompanyDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, postApi, customFieldApi, gAlert, gConfirm, fileUploadService) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          TenantId : $stateParams.srch.TenantId ? $stateParams.srch.TenantId : 1,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'tenant',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if ($stateParams.TenantId) {
        vm.srch.TenantId = $stateParams.TenantId;
      }

      vm.srchDetail = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        tableNm : 'tenant',
        TenantId : vm.srch.TenantId,
      };

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('Tenant.getTenantDetail', vm.srchDetail, function(result){
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {

                // 화면 표시 컬럼 목록
                if (item.EditColumnShowYN === 'Y') {
                  vm.srchDetail.viewColumns[item.ColumnPhysicalNm] = true;
                }
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            }

          } else {
            gAlert('알림', data.responseVO.body.docs[0].errMessage);
          }
        },function(data) {
          vm.dataloader = false;
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getFileList() {

        /* vm.srch.tableNm = 'Companys';
        if (vm.srch.CompanyId === null || vm.srch.CompanyId === "0") {
          return;
        } */

        var data = vm.srchDetail;
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var uploadFileList = [];

              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  typeId : 'file',
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                  delState : '',
                }

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              return;
            }
          }
        }, function(data) {
          console.error('Error-getFileList', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.data;
        data.mapCode = 'Tenant.deleteTenantDetail';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.system.company-list', {
                  srch:srch
                }, {reload:'app.system.company-list'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> company-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.system.company-list', {
          srch : srch
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.system.company-edit', {
            srch : srch, TenantId : vm.data.TenantId
          });
        } else {
          $state.go('app.system.company-list.edit', {
            srch : srch, TenantId : vm.data.TenantId
          });
        }
      }

      // 함수 선언
      vm.getData = getData;
      vm.getFileList = getFileList;
      vm.deleteDetail = deleteDetail;
      vm.goList = goList;
      vm.goEdit = goEdit;

      // 데이터 조회
      getData();
      getFileList();
  } ]);
})();



  (function () {
    "use strict";
    /**
     * @ngdoc function
     * @name app.system:company-edit-ctrl
     * @param {object} $window - window object
     * @param {object} $rootScope - rootScope object
     * @param {object} $stateParams - state Parameter object
     * @description
      * # 회원사관리 등록/수정
      * Controller of the 회원사관리
     */

    webapp.controller('CompanyEditCtrl', ['$window', '$rootScope', '$stateParams', '$state',
      function CompanyEditCtrl($window, $rootScope, $stateParams, $state) {

        // #region 상수 정의

        // 관련 화면 정의
        var LIST_PAGE_URL = 'app.system.company-list';             // 목록 화면
        var LIST_VIEW_PAGE_URL = 'app.system.company-list.edit'; // 목록 수정 화면
        var VIEW_PAGE_URL = 'app.system.company-edit';           // 수정 화면

        // View Model
        var vm = this;          // View Model

        vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
        vm.url = $state.current.url;

        function setChangeTab(tabId) {
          var viewPageUrl = '';

          if (vm.layout == 'N') {
            viewPageUrl = VIEW_PAGE_URL + '.' + tabId;
            // 수정
            $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
          } else {
            viewPageUrl = LIST_VIEW_PAGE_URL + '.' + tabId;
            // 목록.수정 화면 이동
            $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
          }
        }

        // 함수 정의
        vm.setChangeTab = setChangeTab;
      }]);

  })();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:company-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the shop관리 등록/수정
   */

  webapp.controller('CompanyEditTab1Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CompanyEditTab1Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Tenant.insertTenantBatch';     // 등록 SQL
      var UPDATE_SQL = 'Tenant.updateTenantDetail';     // 수정 SQL
      var VIEW_SQL = 'Tenant.getTenantDetail'; // 조회 SQL
      var DEL_SQL = 'Tenant.deleteTenantDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.company-list.edit.tab1'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.company-edit.tab1';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'tenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        if (!vm.srch.tableNm) vm.srch.tableNm = KEY_TABLE_NM;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM,                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      // #region 부서 검색 팝업 호출

      /**
       * 부서 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};
        var modalInstance = modalFactory.open("modal", "components/modal/department/dept-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            // 부서 선택
            vm.data.DeptNm = okData.label;
            vm.data.DeptId = okData.data;
          },
          function (cancelData) {
            // 취소
          }
        );
      };

      /**
       * 부서 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseDept = function () {
        vm.data.DeptNm = "";
        vm.data.DeptId = "";
      };
      // #endregrion 부서 검색 팝업 호출

      // #region 회원사 검색 팝업 호출

      /**
       * 회원사 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchTenantModal = function () {
        var ctrl = 'TenantModalCtrl as vc';
        var paramData = {TenantId: vm.data.TenantId};
        var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          vm.data.TenantNm = okData.TenantNm;
          vm.data.TenantId = okData.TenantId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 회원사 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseTenant = function () {
        if (vm.TenantId != '0') {
          return;
        }
        vm.data.TenantNm = "";
        vm.data.TenantId = "";
      };
      // #endregion 회원사 검색 팝업 호출

      // #region 역할 검색 팝업 호출

      /**
       * 역할 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserroleModal = function () {
        var ctrl = 'UserroleModalCtrl as vc';
        var paramData = {
          TenantId: vm.srch.TenantId,
          UserRoles: vm.data.UserRoles
        };

        var modalInstance = modalFactory.open('modal', 'components/modal/userRole/userrole-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 역할 선택
          vm.data.UserRoles = okData;
          var UserRoleNms = [];
          var UserRoleIds = [];
          angular.forEach(vm.data.UserRoles, function (role) {
            UserRoleNms.push(role.RoleNm);
            UserRoleIds.push(role.RoleId);
          });

          vm.data.UserRoleNms = UserRoleNms.join(',');
          vm.data.UserRoleIds = UserRoleIds.join(',');

        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 역할 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUserRole = function () {
        vm.data.UserRoleIds = "";
        vm.data.UserRoleNms = "";
      };

      // #endregion 역할 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼
        vm.srchDetail.srchTenantId = vm.data.KeyId;

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              // 역할 설정
              vm.data.UserRoles = [];

              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });
              //Date형식 처리
              if (!isValidDate(vm.data.JoinDt) && vm.data.JoinDt != null && vm.data.JoinDt != "") vm.JoinDt = moment(vm.data.JoinDt).toDate();
              if (!isValidDate(vm.data.LeaveDt) && vm.data.LeaveDt != null && vm.data.LeaveDt != "") vm.LeaveDt = moment(vm.data.LeaveDt).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });

              initRadioMenuType();
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {

        vm.data.MenuTypeList = [];
        angular.forEach(vm.radioMenuType, function(item) {
          if (item.checked) {
            vm.data.MenuTypeList.push(item);
          }
        });

        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.TenantNm)) {
          errMsg = errMsg + '- Shop명을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Ceo)) {
          errMsg = errMsg + '- 대표자명을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.TenantStatus)) {
          errMsg = errMsg + '- 상태를 선택하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.TenantStatus)) {
          errMsg = errMsg + '- 가입일을 선택하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.MenuTypeList)){
          errMsg = errMsg + '- 메뉴그룹을 선택하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.srchTenantId = vm.data.KeyId;
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });

        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        if(vm.data.JoinDt != null ) vm.data.JoinDt = $filter('localToUtc')(vm.JoinDt);
        if(vm.data.LeaveDt != null ) vm.data.LeaveDt = $filter('localToUtc')(vm.LeaveDt);

        vm.data.Addr1 = $('#addr1').val();
        vm.data.ZipCode = $('#zipCode').val();
        var data = vm.data; // 사용자 입력 데이터

        vm.dataloader = true;

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            vm.dataloader = false;
            setInsertUpdateDetail(result);
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            vm.dataloader = false;
            setInsertUpdateDetail(result);
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if(result.body.docs[0].O_Result == 0) {
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  // 삭제 성공
                  var srch = $stateParams.srch;

                  // 목록 화면 이동
                  $state.go(LIST_PAGE_URL, {
                      srch: srch
                    },
                    {reload: LIST_PAGE_URL});
                }
              });
            } else {
              gAlert('', '삭제되지 않았습니다.', {
                btn: '',
                fn: function () {
                  var srch = $stateParams.srch;

                  // 목록 화면 이동
                  $state.go(LIST_PAGE_URL, {
                      srch: srch
                    },
                    {reload: LIST_PAGE_URL});
                }
              });
            }
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      function setChangeTab(tabId) {
        vm.tabId = tabId;
        goNextPage(false);
      }

      /* 다음 주소검색 */
      function getAddressInfo(){
        new daum.Postcode({
          oncomplete: function(data) {
            vm.zipCode = data.zonecode;
            vm.addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
            $('#zipCode').val(vm.zipCode);
            $('#addr1').val(vm.addr1);
          },
        }).open();

      }

      function initRadioMenuType() {
        var data = { mapCode: 'Menu.getMenuType', code: '' };
        postApi.select(data, function (response) {
          if (response.header.status == CONSTANT.HttpStatus.OK) {

            vm.radioMenuType = response.body.docs;

            if (vm.data.MenuTypes) {
              var menuTypeList = vm.data.MenuTypes.split(',');

              angular.forEach(vm.radioMenuType, function(menu) {
                angular.forEach(menuTypeList, function(item) {
                  if (menu.code == item) {
                    menu.checked = true;
                    return;
                  }
                });
              });
            }
          }
        }, function (e) { console.error('Error> initRadioMenuType', status, e); });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      vm.getRoleList = getRoleList;             // 역할 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      vm.setChangeTab = setChangeTab;
      vm.getAddressInfo = getAddressInfo;   // 주소검색

      // 데이터 조회
      getData();
      initRadioMenuType();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:company-edit-tab2-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('CompanyEditTab2Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function CompanyEditTab2Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'User.getUserTenantListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'User.getUserTenantList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-list.edit.tab2';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.system.company-list.edit.tab1';    // 목록 등록/수정 화면
      var EDIT_PAGE_URL = 'app.system.company-list.edit.tab2';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'userstenantlist'; // 작업 테이블명
      var EXCEL_TITLE = 'Shop관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.srch.keyId = $stateParams.keyId;
        vm.EntryDtFrom = $rootScope.getDateFormat(vm.srch.EntryDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.EntryDtTo = $rootScope.getDateFormat(vm.srch.EntryDtTo);
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;
      }

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수



      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              console.log(result.body.docs);
              vm.totalItems = result.body.docs[0].totalItems;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }


      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'EntryDt')
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                else
                  obj.push(value[item.ColumnPhysicalNm]);

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:company-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('CompanyListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CompanyListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Tenant.getTenantCount'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Tenant.getTenantList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Tenant.getExcelList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.company-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.company-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.company-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.company-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.company-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'tenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'TenantId'; // Primary Key Column
      var EXCEL_TITLE = 'Shop관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.JoinDtFrom = $rootScope.getDateFormat(vm.srch.JoinDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.JoinDtTo = $rootScope.getDateFormat(vm.srch.JoinDtTo);
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {

                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr = resList[0] + " " + resList[1];
                   }
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'JoinDt' || item.ColumnPhysicalNm == 'LeaveDt') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:contents-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('ContentsEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function ContentsEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Contents.insertContents';     // 등록 SQL
      var UPDATE_SQL = 'Contents.updateContents';     // 수정 SQL
      var VIEW_SQL = 'Contents.getContentsDetail'; // 조회 SQL
      var DEL_SQL = 'Contents.deleteContentsDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.contents-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.contents-list.detail'; // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.system.contents-detail';           // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvscontents'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트

      vm.isYoutubeContent = false;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드 완료
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 이후 저장을 호출해야 함
          $timeout(setData, 1);
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          /*  var prms = h0102Api.attachFileDelete().post(param).$promise;
            prms.then(function (data) {
              if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            });*/

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);

              gAlert("", error.responseVO.body.docs[0].errMessage);
            }
          );


        },
        onLoaded: function (vault) {
          // 첨부파일 control 설정
          vm.vault = vault;
        }
      };
      // #endregion 첨부파일 Callback

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent("vault");

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {

                // 코드값이 DBYTBURL 일 경우 노출이 되지 않도록 설정
                if(item.ColumnPhysicalNm == "CntntsType") {
                  for(var i = 0; i < item.CodeList.length; i++) {
                    if(item.CodeList[i].Code == "DBYTBURL") {
                      delete item.CodeList[i];
                      break;
                    }
                  }
                }

                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              (vm.data.CntntsType == "DBYTBURL") ? vm.isYoutubeContent = false : vm.isYoutubeContent = true;
              // 첨부파일 목록 설정
              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

              return;
            } else {
            vm.isYoutubeContent = true;
            vm.data.TenantId = $window.sessionStorage['loginTenantId'];
            vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김
          }

        }, function (error) {
          console.error("Error> getData()");
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      vm.uploadFile = function () {
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      };

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {

        // #region 필수항목 체크
         var errMsg = '';
        if (isNullOrEmpty(vm.data.Subject))
          errMsg = errMsg + '- 제목을 입력하십시오.<br/>';

/*         if (isNullOrEmpty(vm.data.Contents))
          errMsg = errMsg + '- 내용을 입력하십시오.<br/>'; */

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }


        // #endregion 필수항목 체크

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = vm.uploadFileList; // 첨부파일
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        //Editor
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.Contents = $("#strHtml").val();

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            InsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', error.body.docs[0].errMessage);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            InsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', result.responseVO.body.docs[0].errMessage);
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function InsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                var srch = $stateParams.srch; // 검색 옵션

                // 화면 분할 모드에 따른 이동
                if (vm.layout == 'N') {
                  if (isNullOrEmpty(vm.srch.keyId)) {
                    // 신규등록 -> 목록 화면 이동
                    $state.go(LIST_PAGE_URL, {srch: srch});
                  } else {
                    // 수정 -> 조회 화면 이동
                    $state.go(VIEW_PAGE_URL, {
                      srch: srch,
                      keyId: vm.data.KeyId
                    });
                  }
                } else {
                  vm.srch.keyId = "";
                  vm.srch.reload = (new Date()).getTime();
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  // 조회 화면 이동
                  $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
                }
              }
            });
            return;
          }
        }

        console.error("Error> InsertUpdateDetail()");
        gAlert("", result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

            /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function delData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            delDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function delDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
          console.table(error.body.docs[0].errMessage);
        });
      }

      /**
       * 미리보기 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.contentsModal = function () {
        var ctrl = 'ContentsModalCtrl as modalCtrl';
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        var Contents = $("#strHtml").val();
        var paramData = {Contents:Contents};

        var modalInstance = modalFactory.open("lg","components/modal/contents/contents-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
          },
          function (cancelData) {
            // 취소
          }
        );
      };

      /**
       * 컨텐츠타입 변경 이벤트
       *
       * @param {string}
       * @return {boolean}
       */
      vm.onChangeContentType = function (type) {
        console.log(e);
      };

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      vm.setData = setData;                     // 데이터 저장
      vm.goList = goList;                       // 목록 화면 이동
      vm.delData = delData;                     // 데이터 삭제

      // 데이터 조회
      getData();

    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:Contents-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('ContentsListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function ContentsListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Contents.getContentsListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Contents.getContentsList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Contents.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Contents.deleteContentsList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.contents-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.contents-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.contents-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.contents-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.contents-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvscontents'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CntntsId'; // Primary Key Column

      var EXCEL_TITLE = 'Contents관리 목록'; //Contents 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = [10, 25, 50, 100]; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        var column ={};

        angular.forEach(vm.listColumns, function (item) {
          column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function changeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);
        var strFormat = 'string';
        var strLformat = 'string2';
        var strWidth = '30';
        var numFormat = 'number2';
        var numFormat2 = 'number3';
        var numWidth = '15';

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                obj.push(value[item.ColumnPhysicalNm]);
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      function init(){

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      // 목록 삭제
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.ContentsIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.ContentsIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.ContentsIdList == null || vm.srch.ContentsIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          gAlert('', error.body.docs[0].errMessage);
          console.error("Error> deleteListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.changeLayout = changeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      init();
    }]);
})();

webapp.service('DepartmentAPISrv', ['$resource', 'StaticVariable',
    function DepartmentAPISrv($resource, StaticVariable) {
		console.log('DepartmentAPISrv');
    	var hDepartmentApi = {
    		doList : function() {
    			return $resource(StaticVariable.getUrl('/select/Department.getDepartmentList/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
        doTreeList : function() {
          return $resource(StaticVariable.getUrl('/select/Department.getDepartmentTreeList/action.json'), {},
              StaticVariable.getRequestActions.defaultAction());
        },
        doSaveList : function() {
          return $resource(StaticVariable.getUrl('/update/Department.updateDepartmentTreeListBatch/action.json'), {},
              StaticVariable.getRequestActions.defaultAction());
        },
    		doListCnt : function() {
    			return $resource(StaticVariable.getUrl('/select/Department.getDepartmentCount/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doDetail : function() {
    			return $resource(StaticVariable.getUrl('/select/Department.getDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doUpdateDetail : function() {
    			return $resource(StaticVariable.getUrl('/update/Department.updateDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doInsertDetail : function() {
    			return $resource(StaticVariable.getUrl('/insert/Department.insertDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doDelete : function() {
    			return $resource(StaticVariable.getUrl('/update/Department.deleteDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			}
    	};
    	return hDepartmentApi;
	}
]);

webapp.controller('DepartmentDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'DepartmentAPISrv', 'gAlert', 'gConfirm',
    'fileUploadService', function DepartmentDetailCtrl($window, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, departmentApi, gAlert, gConfirm, fileUploadService) {
      var vm = this;

      vm.page = $stateParams.page;
      vm.srch = {
        FreeBoardId : $stateParams.DeptId,
        TableId : $stateParams.DeptId,
        tableNm : 'department',
        DeptId : $stateParams.DeptId,
      };
      console.log("detail load vm.srch", vm.srch);
      vm.comment = {};

      var id = 0;

      vm.getDetail = getDetail;
      vm.deleteDetail = deleteDetail;
      vm.deleteDetailAction = deleteDetailAction;

      vm.userId = $window.sessionStorage['loginUserIdx'];

      function getDetail() {

        var prms = departmentApi.doDetail().post(vm.srch).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.data = data.responseVO.body.docs[0];
            return;
          }

          gAlert('', data.responseVO.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              $state.go("app.system.department-list", {
                page : vm.page
              })
            }
          });
        },

        function(data) {
          gAlert('', data.responseVO.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              $state.go("app.system.department-list", {
                page : vm.page
              })
            }
          });
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }
        console.log("vm.uploadFileList", vm.uploadFileList);
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        console.log("before delete", vm.data);

        var prms = departmentApi.doDelete().post(vm.data).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                $state.go("app.system.department-list")
              }
            });

          }
        },

          function (error) {
            console.table(error);
        });
      }

      Array.prototype.append = function(array) {
        this.push.apply(this, array)
      };

      getDetail();
    } ]);

webapp.controller('DepartmentEditCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'DepartmentAPISrv', 'gAlert', '$rootScope',
    function DepartmentEditCtrl($window, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, departmentApi, gAlert, $rootScope) {
      var vm = this;

      vm.page = $stateParams.page;

      vm.uploadFileList = [];
      vm.srch = {
        FreeBoardId : $stateParams.DeptId,
        TableId : $stateParams.DeptId,
        tableNm : 'department',
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        DeptId : $stateParams.DeptId,
      };

      vm.data = {
        DeptId : vm.srch.DeptId,
      };

      vm.getDetail = getDetail;
      vm.saveDetail = saveDetail;
      vm.listLink = listLink;

      $rootScope.$on('$locationChangeStart', function(event, current, previous) {
        // console.log("현재페이지",'current=', current, ",previous=", previous);
        vm.previous = previous;
      });

      // 부서 조회 start
      vm.srchDeptModal = function() {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        var modalInstance = modalWindow.open('modal', 'views/modal/dept-modal.html', ctrl, paramData);
        modalInstance.result.then(function(okData) {
          vm.data.ParentDeptNm = okData.label;
          vm.data.ParentDeptId = okData.data;
        }, function(cancelData) {
        });
      };

      vm.eraseDept = function() {
        vm.data.ParentDeptNm = "";
        vm.data.ParentDeptId = "";
      };
      // 부서 조회 end

      function listLink() {

        if (vm.previous.substring(vm.previous.length - 31) == 'app/system/department-list') {
          $state.go("app.system.department-list");
        } else {
          $state.go("app.system.department-list");
        }
      }

      function getDetail() {
        if (vm.srch.DeptId == null || vm.srch.DeptId == 0) {
          return;
        }

        var prms = departmentApi.doDetail().post(vm.srch).$promise;

        prms.then(function(data) {
          console.log("load", data);
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].DeptId != null) {
              vm.data = data.responseVO.body.docs[0];
              console.log("before getFileList", vm.data);

              return;
            }
          }
            console.table(data);
        },

        function(data) {
          console.table(data);
        });
      }

      function saveDetail() {

        vm.data.tableNm = "department";
        vm.data.TableId = vm.data.DeptId;

        var prms = null;

        if (vm.data.DeptId == null || vm.data.DeptId == 0)
          prms = departmentApi.doInsertDetail().post(vm.data).$promise;
        else
          prms = departmentApi.doUpdateDetail().post(vm.data).$promise;

        prms.then(

        function(data) {
          console.log(data);
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].DeptId != null || data.responseVO.body.docs[0].TableId != null) { // insert 시 TableId 만 넘어옴
              vm.data.keyId = data.responseVO.body.docs[0].DeptId;

              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  if ($stateParams.DeptId == 0) {
                    $state.go("app.system.department-list");
                  } else {
                    vm.data.DeptId = data.responseVO.body.docs[0].DeptId != null ? data.responseVO.body.docs[0].DeptId : data.responseVO.body.docs[0].TableId;
                    $state.go("app.system.department-detail", {
                      DeptId : vm.data.DeptId
                    });
                  }
                }
              });

              return;
            }
          }

          gAlert('', data.responseVO.body.docs[0].errMessage);
        },

        function(error) {
          console.table(data);
        });
      }

      getDetail();
    } ]);

webapp.controller('DepartmentListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', 'GLOBAL_CONSTANT', 'postApi', 'modalFactory', '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', '$timeout',
    function CommoncodeListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, postApi, modalFactory, $mdUtil, $mdSidenav, gAlert, gConfirm, $timeout) {
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.maxdeptid = 0;
      vm.lists = [];
      vm.saveYn = true;
      $scope.toggleLeft = buildToggler('left');
      $scope.toggleRight = buildToggler('right');
      /**
       * Build handler to open/close a SideNav; when animation finishes
       * report completion in console
       */
      function buildToggler(navID) {
        var debounceFn = $mdUtil.debounce(function() {
          $mdSidenav(navID).toggle().then(function() {
            console.debug("toggle " + navID + " is done");
          });
        }, 200);
        return debounceFn;
      }

      $scope.init = function() {
        // check if there is query in url
        // and fire search in case its value is not empty
      };

      // stops the interval
      $scope.$on("$destroy", function() {
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        resetList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'), '#toastContainer');
      });

      function resetSearch() {
        vm.srch.DeptNm = '';
        vm.data = {DeptNm: ''};
        tree.select_branch(null);
      }

      function resetList() {
        resetSearch();

        getTreeList();
      }

      vm.nextSearch = function() {
        tree.next_search_text();
      };

      // 함수 선언
      vm.resetSearch = resetSearch;
      vm.resetList = resetList;
      vm.getTreeList = getTreeList;
      vm.delNode = delNode;
      vm.delNodeCancel = delNodeCancel;
      vm.saveData = saveData;
      vm.onChanged = onChanged;
      vm.onChangeDeptNm = onChangeDeptNm;
      vm.getClear = getClear;

      var tree;
      $scope.my_tree = tree = {};

      vm.topItem = null;

      vm.onSelectCallback = function(data) {
        if (data.CallbackTarget == '0000') {
          vm.data.UseYN = data.Code;
        }
      };

      getTreeList();

      function onChangeDeptNm() {
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        if (vm.data.New == 'Y') {
          branch.label = '[*]' + vm.data.DeptNm;
        } else {
          branch.label = vm.data.DeptNm;
          vm.data.Edit = 'Y';
        }
      }

      vm.topItem = null;

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        var data = vm.srch;
        data.mapCode = "Department.getDepartmentTreeList";
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length == 0) return;

            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            refreshTree();
          }
        },
        function(error) {
          vm.dataloader = false;
          console.error("fail", status, data);
        });
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {

        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {
            "label" : jsonObj[i].label,
            "data" : jsonObj[i].guid,
            "children" : jsonObj[i].children,
          }
          jsonObj[i] = newItem;
        }
      }

      // 트리 목록에서 조회값
      $scope.my_tree_handler = function(branch) {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.DeptId.toString()) {
            vm.data = item;
            return;
          }
        });
      };

      $scope.try_adding_a_branch = function() {

        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
        var DeptId = newnum.toString(36);

        var branch = tree.get_selected_branch();
        if (branch == null) {
          var dept = {
            'DeptNm' : '새로운부서',
            'DeptId' : DeptId,
            'ParentDeptId' : 0,
            'Depth' : 1,
            'New' : 'Y'
          };
          vm.lists.push(dept);
        } else {
          angular.forEach(vm.lists, function(item) {
            if (branch.data == item.DeptId.toString()) {
              var dept = {
                'DeptNm' : '새로운부서',
                'DeptId' : DeptId,
                'ParentDeptId' : branch.data,
                'Depth' : item.Depth + 1,
                'New' : 'Y'
              };
              vm.lists.push(dept);
              return;
            }
          });
        }

        var new_branch = tree.add_branch(branch, {
          label: '[*]새로운부서',
          data: DeptId
        });
        tree.select_branch(new_branch);
      };

      function delNode() {
        var DeptId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
          $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'), '#toastContainer');
          return;
        }

        gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
          btn : '',
          fn : function(){
            if (vm.data.New == 'Y'){
              deleteNodeTree();
            }else {
              vm.data.DelYN = 'Y';
              saveData();
            }
          }
        }, {
          btn : '',
          fn : function(){
          }
        });
      }

      function deleteNodeTree() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.DeptId.toString()) {
            var index = vm.lists.indexOf(item);
            vm.lists.splice(index, 1);

            var parent = tree.select_parent_branch();
            if(parent){
              parent.children.splice(parent.children.indexOf(branch),1);
            } else {
              refreshTree();
            }

            return;
          }
        });

        tree.select_branch(null);
        vm.data = {CustomCode: 0};
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = new Array();

        // for문으로 다시 json 구조로 변환함.
        for (var i = 0; i < vm.lists.length; i++) {
          // 객체 생성
          var data = new Object();

          data.label = vm.lists[i]['DeptNm'];
          data.guid = vm.lists[i]['DeptId'].toString();
          data.parent = vm.lists[i]['ParentDeptId'] == undefined || vm.lists[i]['ParentDeptId'] == 0 ? null : vm.lists[i]['ParentDeptId'].toString();

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (vm.lists[i]['Deptid'] > vm.maxdeptid)
            vm.maxdeptid = vm.lists[i]['Deptid'];
        }

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
        $timeout(function() {
          return tree.expand_init();
        }, 1);

      }

      function removeNode(jsonObj, DeptId) {
        for (var i = 0; i < jsonObj.length; i++) {
          console.log('DeptId=', DeptId);

          if (jsonObj[i].data == DeptId) {
            jsonObj[i].children = [];
            return true;
          }

          if (jsonObj[i].children == null) {
          } else {
            if (removeNode(jsonObj[i].children, DeptId) == true)
              break;
          }
        }
      }

      function delNodeCancel() {
        var DeptId = '';
        var branch = tree.get_selected_branch();
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.DeptId.toString()) {
            item.DelYN = 'N';
            branch.label = branch.label.replace(/^\[X\]/,"");;
            return;
          }
        });
      }

      function saveData() {
        vm.dataloader = true;
        var data = {lists : []};
        data.mapCode = 'Department.updateDepartmentTreeListBatch';
        data.lists.push(vm.data);
        postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (vm.data.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'), '#toastContainer');
              vm.data.New = '';
              var branch = tree.get_selected_branch();
              branch.label = branch.label.replace(/^\[\*\]/,"");
            } else if (vm.data.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'), '#toastContainer');
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'), '#toastContainer');
              vm.data.Edit = '';
            }
//            getTreeList();
          }
        },
        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

      }

      function onChanged() {
        if (vm.data.New == null || vm.data.New != 'Y') {
          vm.data.Edit = 'Y';
        }
      }

      function getClear() {
        vm.srch.DeptNm = '';
      }
    } ]);

webapp.controller('MakeQueryListCtrl',
['$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', 'GLOBAL_CONSTANT', 'postApi', 'modalFactory', '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', '$timeout',
function MakeQueryList($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, postApi, modalFactory, $mdUtil, $mdSidenav, gAlert, gConfirm, $timeout) {


  var vm = this;
  vm.tableSchema = "civasan";
  vm.tables = []; // 테이블리스트
  vm.cols = []; // 컬럼리스트

  vm.namespace; // Mapper ID

  vm.checkMainTb = false;
  vm.tbMain = {}; // 메인 정보
  vm.tbJoins = []; // 조인테이블 정보
  // vm.innerjoinTb = []; // InnerJoin Table
  // vm.leftjoinTb = []; // LeftJoin Table

  vm.tempColsData = {}; // 호출된 테이블 컬럼을 임시로 저장한다.
  vm.checkDrawView = false;

  vm.copyFn = function() {
    console.log("copy")

    if(document.body.createTextRange) {
      var textRange = document.body.createTextRange();
      textRange.moveToElementText(document.getElementById("queryView"))
      textRange.execCommand("Copy");
      gAlert("","복사하였습니다.")
    } else {
      window.getSelection().selectAllChildren(document.getElementById("queryView"));
      document.execCommand("Copy");
      gAlert("","복사하였습니다.")
    }

  }

  vm.blurAlis = function(p) {
    var param = {};
    param = JSON.parse(JSON.stringify(p))
    param.mapCode = "makeQuery.setTbAlias";
    postApi.select(param, function(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        param.mapCode = "makeQuery.getAliasTable";
        postApi.select(param, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            p.rkey = result.body.docs[0].rkey;
          }
        });
      }
    });
  }

  vm.changeAlis = function(p) {

    p.aliasNm = p.aliasNm.toUpperCase();
    if(vm.checkMainTb) {
      if(p.tbNm.toLowerCase() == vm.tbMain.tableNm.toLowerCase()) {
        vm.tbMain.aliasNm = p.aliasNm.toUpperCase();
      }
    }

    var keys = Object.keys(vm.tempColsData);
    if(keys.length > 0) {
      if(vm.tempColsData[p.tbNm] != undefined) {
        vm.tempColsData[p.tbNm].aliasNm = p.aliasNm.toUpperCase();
      }
    }

    if(vm.cols.length > 0) {
      for(var i = 0; i < vm.cols.length; i++) {
        if(p.tbNm.toLowerCase() == vm.cols[i].tbNm.toLowerCase()) {
          vm.cols[i].aliasNm = p.aliasNm.toUpperCase();
        }
      }
    }
  };

  vm.setMainTable = function(p) {
    var checkCount = 0;
    angular.forEach(vm.tables, function(item) {
      if(p.tbNm != item.tbNm) {
        item.mChecked = false;
      } else checkCount++;
    });

    if(checkCount > 0) vm.checkMainTb = true;

    vm.tbMain.tableNm = p.tbNm.substring(0,1).toUpperCase() + p.tbNm.substring(1,p.tbNm.length).toLowerCase();
    vm.tbMain.aliasNm = p.aliasNm.toUpperCase();
    vm.setColData(p, "m");
  };

  vm.setJoinTable = function(p) {
    vm.tbJoins = [];
    vm.setColData(p, "ij");
  };

  vm.setColData = function(p, type){

    if( vm.tempColsData[p.tbNm] == undefined) {
      var param = {};
      param.mapCode = "makeQuery.getTableColumnList";
      param.tableSchema = vm.tableSchema;
      param.tbNm = p.tbNm;

      postApi.select(param, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.tempColsData[p.tbNm] = {};
          vm.tempColsData[p.tbNm]["aliasNm"] = p.aliasNm;
          vm.tempColsData[p.tbNm]["cols"] = result.body.docs;

          var pk = "";
          for(var i = 0; i < result.body.docs.length; i++) {
            var at = result.body.docs[i];
            if(at.column_key == "PRI") {
              pk = at.column_name;
              break;
            }
          }
          p.pk = pk;
          vm.initColData(p, type);
        }
      });
    } else {
      vm.initColData(p, type);
    }
    vm.writeQueryField();
  };

  vm.writeQueryField = function() {

  };

  vm.initColData = function(p, type){
    vm.cols = [];
    var mainCols = [], joinCols =[];
    angular.forEach(vm.tables, function(item) {
      if(p.tbNm != item.tbNm) {
        if(type == "m") {
          item.mChecked = false;
        }
      }
    })
    angular.forEach(vm.tables, function(item) {
      if(item.mChecked) {
        for(var i = 0; i < vm.tempColsData[item.tbNm].cols.length; i++) {
          vm.cols.push(
            {tbNm: item.tbNm, aliasNm : vm.tempColsData[item.tbNm].aliasNm, colNm : vm.tempColsData[item.tbNm].cols[i].column_name,
            dataType : vm.tempColsData[item.tbNm].cols[i].data_type, checkedYn: true, selectType: "m" }
          )
        }
      }

      if(item.ijChecked) {
        vm.tbJoins.push(item);
        for(var i = 0; i < vm.tempColsData[item.tbNm].cols.length; i++) {
          joinCols.push(
            {tbNm: item.tbNm, aliasNm : vm.tempColsData[item.tbNm].aliasNm, colNm : vm.tempColsData[item.tbNm].cols[i].column_name,
            dataType : vm.tempColsData[item.tbNm].cols[i].data_type, checkedYn: true, selectType: "i" }
          )
        }
      }

      if(item.ljChecked) {
        vm.tbJoins.push(item);
        for(var i = 0; i < vm.tempColsData[item.tbNm].cols.length; i++) {
          joinCols.push(
            {tbNm: item.tbNm, aliasNm : vm.tempColsData[item.tbNm].aliasNm, colNm : vm.tempColsData[item.tbNm].cols[i].column_name,
            dataType : vm.tempColsData[item.tbNm].cols[i].data_type, checkedYn: true, selectType: "l" }
          )
        }
      }
    });
    angular.forEach(joinCols, function(item) {
      vm.cols.push(item);
    })
    if(vm.cols.length > 0) vm.checkDrawView = true;
    else  vm.checkDrawView = false;
  };

  vm.changeMapperId = function() {
    vm.namespace = htpt('<mapper namespace="'+ vm.mapperId +'">');
  }


  function htpt(str) {
    var str = String(str).replaceAll("<", "&lt;").replaceAll(">", "&gt;");
    return  str.replaceAll("undefined", "");
  }
  vm.getTableList = function() {

    var param = {};
    param.mapCode = "makeQuery.getTableList";
    param.tableSchema = vm.tableSchema;
    postApi.select(param, function(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.tables = result.body.docs;

        for(var i = 0; i < vm.tables.length; i++) {
          var at = vm.tables[i];
          if(at.aliasNm == undefined) at.aliasNm = at.tbNm.toLowerCase();
        }
      }
    })
  }
  vm.init = function() {

    vm.getTableList();
    vm.namespace = htpt('<mapper namespace="'+ vm.mapperId +'">');
    vm.mapperend = htpt('</mapper>');

  }

  vm.init();
}]);



(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:mastergradefee-list-ctrl
   * @description
   * # 마스터 등급 및 수수료 지급기준표
   * Controller of the 마스터 등급 및 수수료 지급기준표
   */

  webapp.controller('MasterGradeFeeListCtrl', ['$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm', '$translate',
    /**
     * @param $window - window object
     * @param $scope - scope object
     * @param $location - location object
     * @param $state - state object
     * @param $stateParams - state Parameter object
     * @param CONSTANT - 전역 상수
     * @param $rootScope - rootscope object
     * @param postApi - postApi Module
     */
    function MasterGradeFeeListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, gConfirm, $translate) {

      // View Model
      var vm = this;
      vm.dataloader = false;
      vm.url = '/tab1';

      // TenantId
      vm.TenantId = $window.sessionStorage['loginTenantId'];

      // 회원사 변경 체크
      $scope.$on('broadcastSetChangeTenantID', function (event, args) {
        getList();
      });

      vm.srch = {};

      // 오너 리스트
      vm.listsOwner = [];

      // 파트너 리스트
      vm.listsPartner = [];


      /**
       * Tab변경
       *
       * @param {string} tabId - 조회할 TabId
       * @return {boolean}
       */
      function setChangeTab(tabId) {
        vm.url = tabId;
      }

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getList() {

        // Owner 조회
        getOwnerList();

        // Partner 조회
        getPartnerList();

      }

      /**
       * Owner 데이터 조회
       *
       * @param
       * @return
       */
      function getOwnerList() {
        vm.dataloader = true;

        var data = vm.srch;
        data.mapCode = 'CvsMasterGradeFee.getCvsMasterOwnerGradeFeeList';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.listsOwner = result.body.docs;

            } else {
              vm.totalItemsOwner = 0;
              vm.listsOwner = [];
            }
          }
          vm.dataloader = false;
        }, function (error) {
          console.error('Error-getList', status, data);
          vm.dataloader = false;
        });

      }

      /**
       * Partner 데이터 조회
       *
       * @param
       * @return
       */
      function getPartnerList() {
        vm.dataloader = true;

        var data = vm.srch;
        data.mapCode = 'CvsMasterGradeFee.getCvsMasterPrtnrGradeFeeList';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.listsPartner = result.body.docs;

            } else {
              vm.totalItemsPartner = 0;
              vm.listsPartner = [];
            }
          }
          vm.dataloader = false;
        }, function (error) {
          console.error('Error-getList', status, data);
          vm.dataloader = false;
        });

      }

      /**
       * 저장 확인
       *
       * @param
       * @return
       */
      function saveListConfirm() {
        gConfirm('', '저장 하시겠습니까?', {
          btn: '',
          fn: function () {
            saveOwnerList();
            savePartnerList();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      /**
       * Owner 저장
       *
       * @param
       * @return
       */
      function saveOwnerList() {

        vm.dataloader = true;

        var data = {lists: []};
        angular.forEach(vm.lists, function (item) {
          data.lists.push(item);
        });

        if (data.lists.length == 0) {
          return;
        }

        data.mapCode = 'CvsMasterGradeFee.insertCvsMasterOwnerGradeFeeBatch';

        postApi.insert(data, function (result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            getList();
          }
        }, function (error) {
          console.error('Error-getList', status, data);
          vm.dataloader = false;
        });
      }

      /**
       * Partner 저장
       *
       * @param
       * @return
       */
      function savePartnerList() {

        vm.dataloader = true;

        var data = {lists: []};
        angular.forEach(vm.listsPartner, function (item) {
          data.lists.push(item);
        });

        if (data.lists.length == 0) {
          return;
        }

        data.mapCode = 'CvsMasterGradeFee.insertCvsMasterPrtnrGradeFeeBatch';

        postApi.insert(data, function (result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            getList();
          }
        }, function (error) {
          console.error('Error-getList', status, data);
          vm.dataloader = false;
        });
      }


      // 함수 선언
      vm.setChangeTab = setChangeTab;
      vm.getList = getList;
      vm.saveListConfirm = saveListConfirm;

      // 데이터 조회
      getList();
    },]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:menumanage-list-ctrl
   * @description
   * # 메뉴 관리
   * 사용자 메뉴를 편집 및 관리 할 수 있는 페이지
   */

  webapp.controller('MenuManageCtrl', [
    '$window', '$scope', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', '$translate', '$compile', 'modalFactory',
    function MenuManageCtrl($window, $scope, $state, $stateParams, $rootScope, CONSTANT, postApi, gAlert, gConfirm, $translate, $compile, modalFactory) {
      var vm = this;
      vm.targetField = null; // Focus 엘리먼트를 구하기 위한 변수
      vm.selectMenu = null; // 선택된 메뉴가 있는지 체크하는 변수
      vm.checkShowDetailView = false; // 메뉴의 디테일 화면을 보여줄지에 여부
      vm.menuList = [];
      vm.menuInfo = [];
      vm.delMenuList = [];
      vm.fontList = [];

      vm.addInputFa = "fa-";

      vm.sendData = { menuList: vm.menuList, delMenuList: vm.delMenuList };

      vm.roleLevelList = [];
      for(var i = 0; i < 16; i++) {
        var o = {};
        o.commonCodeId = i.toString();
        o.codeNm = "Level " + i;
        vm.roleLevelList.push(o);
      }

      vm.SysAdmin = false;
      vm.viewMode = "A"; // A : 전체보기, T : 회원사보기, TV : 회원사일때
      if ($window.sessionStorage['loginSysAdminYN'] == "Y") {
        vm.SysAdmin = true;
        vm.viewMode = "A";
      } else {
        vm.viewMode = "TV";
      }

      vm.showTabView = [];
      for (var i = 0; i < 3; i++) vm.showTabView.push('');
      vm.showTabView[0] = "in active";

      vm.menuTitle = 'All Category';
      vm.selectTenantInfo = {};
      vm.tenantList = [];

      vm.sysAdminDisable = false;

      vm.selectedGroupOptions = "";
      vm.mobileOnlyYN = "N";
      if($state.$current.name.indexOf("menumanage-mobilelist") != -1) vm.mobileOnlyYN = "Y";

      vm.selectNewWindowYn = [
        {value : "Y", codeNm : "Y"},
        {value : "N", codeNm : "N"},
      ];

      vm.roles = [];
      vm.rolesInfo = [];
      vm.rolesInfo.sqlMapper = [];
      vm.checkEdtLabel = false;
      vm.checkEdtLabelText = "라벨편집";

      vm.choiceRolePage = "";

      vm.mSrchTenentID = $window.sessionStorage['srchTenantId'];

      vm.toggleMenuType = function(menuType) {
//        console.log(menuType);
      };

      vm.setDetailView = function (code) {
        if(code == undefined) {
          vm.menuInfo = [];
          vm.rolesInfo = {};
          vm.setChangeTab(0);
          return;
        }

        var data = { mapCode: 'Menu.getBaseMenuInfo', menuId: code.menuId, type: vm.viewMode };
        if (vm.SysAdmin && vm.viewMode == "TV") data.tenant = vm.selectTenantInfo.id;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.rolesInfo = [];
            vm.choiceRolePage ="";
            vm.setChangeTab(0);
            if(result.body.docs.length > 0) {
              vm.menuInfo = result.body.docs[0];
              vm.menuInfo.depth = code.depth;
              vm.menuInfo.useYn = code.useYn;
              vm.menuInfo.roleLevel = vm.menuInfo.roleLevel.toString();

              vm.menuInfo.menuTenantId = code.menuTenantId;
              ( vm.menuInfo.useYn == "Y" || ( vm.menuInfo.menuTenantId != null &&  vm.menuInfo.menuTenantId != ""))
              ?  vm.menuInfo.levelYn = true :  vm.menuInfo.levelYn = false;

              getFa();
              vm.getPages();
              vm.getMenuType();
            } else {
              var o = {};
              o.menuTenantId = code.menuTenantId;
              o.menuId = code.menuId;
              o.menuNm = code.menuNm;
              o.icon = code.icon;
              o.mobileOnlyYN = vm.mobileOnlyYN;
              o.useYn = code.useYn;
              o.menuTenantId = code.menuTenantId;
              o.roleLevel = "1";

              (o.useYn == "Y" || (o.menuTenantId != null && o.menuTenantId != "")) ? o.levelYn = true : o.levelYn = false;
              vm.menuInfo = o;

            }

            if (vm.mobileOnlyYN == "Y") getMenuSvyList(); //모바일 메뉴관리인 경우 연관페이지 정보도 같이 가져오도록 추가
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.getMenuType = function() {
        angular.forEach(vm.radioMenuType, function(item) {
          item.checked = false;
        });

        vm.menuInfo.pages = [];
        var data = { mapCode: 'MenuType.getBaseMenuType', menuId: vm.menuInfo.menuId };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.menuInfo.menuTypes = result.body.docs;

            angular.forEach(vm.radioMenuType, function(item) {
              angular.forEach(vm.menuInfo.menuTypes, function(menu) {
                if (item.code == menu.MenuType) {
                  item.checked = true;
                  return;
                }
              });
            });
          } else {
            console.error('Error> getMenuType', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> getMenuType', status, error);
        });
      };

      vm.getPages = function () {
        vm.menuInfo.pages = {};
        var data = { mapCode: 'Screen.getBaseMenuScreen', menuId: vm.menuInfo.menuId };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.menuInfo.pages = result.body.docs;
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.addChild = function (depth, code) {
        var $elem;
        (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
        $elem.css("display", "block");
        $elem.find("input").focus();

        $(".subTextmenu").addClass("importantHidden");
      };

      vm.delChild = function (depth, obj) {
        if (obj.child.length > 0) {
          gAlert('', '하위 메뉴가 있으면 삭제할 수 없습니다.', {
            btn: '확인', fn: function () { }
          });
          return;
        }
        var data = { mapCode: 'Menu.getUseTenantMenu', menuId: obj.menuId };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            var msg = "";
            if(result.body.docs.length == 0) {
              msg = "[" + obj.menuNm + "] 삭제하시겠습니까?";
            } else {
              var company = "";
              for(var j = 0; j < result.body.docs.length; j++) {
                if(j != 0) company += ", ";
                company += result.body.docs[j].TenantNm;
              }
              msg = "[" + company + "] 회원사가 사용중입니다.<br>그래도 [" + obj.menuNm + "] 삭제하시겠습니까?";
            }

            gConfirm('', msg , {
              btn: '확인', fn: function () {
                var data = { mapCode: 'Menu.delMenuList', menuId: obj.menuId };
                postApi.select(data, function (result) {
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    $rootScope.$broadcast('broadcastSetChangeMenuList', {});
                    $rootScope.showSimpleToast($translate.instant('삭제하였습니다.'));
                    initBaseMenuList();
                  }
                });
              }
            }, {btn: '취소', fn: function () {}
            });

        } else {
          console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
        }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.editChild = function (depth, obj) {
        //console.log("Edt :", depth, obj)
      };

      /**
      * 같은 Depth, 직속 관계가 아닐 경우 자리 이동을 하지 않기 위함
      */
      vm.sortableOptions = {
        allowDuplicates: true,
        accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
          var result = false;
          if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
          var target = sourceItemHandleScope.itemScope.item;
          if(target.menuTenantId == "") result = false;
          if(target.useYn == "N") result = false;
          if(destItemScope.modelValue.menuTenantId == "") result = false;
          if(destItemScope.modelValue.useYn == "N") result = false;
          return result;
        },
        dragEnd: function (eventObj) {
          var source = eventObj.source.sortableScope.modelValue;
          vm.setChangeSort(source);
        },
      };

      vm.setChangeSort = function (obj, ps) {
        for (var i = 0; i < obj.length; i++) {
          var minusLength = $("#atMenu_" + obj[i].menuId).closest("[ng-model]").
            parent().find("div").eq(0).find( ".fa-minus").length;
          if(minusLength != 0) $("#atMenu_" + obj[i].menuId).css("display","block");
          var tempSort = makeSortPath(obj[i].sort);
          if(ps == undefined) {
            if(tempSort.length == 1) {
              obj[i].sort = (100+i);
              obj[i].tempSortPath[0] = (100+i);
            } else if(tempSort.length == 2) {
              obj[i].sort = Number(tempSort[0] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = (100+i);
            } else {
              obj[i].sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = tempSort[1];
              obj[i].tempSortPath[2] = (100+i);
            }
          } else {
            var tempSort = makeSortPath(ps);
            if(tempSort.length == 1) {
              obj[i].sort = Number(tempSort[0] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = (100+i);
            } else {
              obj[i].sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = tempSort[1];
              obj[i].tempSortPath[2] = (100+i);
            }
          }
          if (obj[i].child.length > 0) vm.setChangeSort(obj[i].child, obj[i].sort);
        }
      };

      /**
       * 메뉴 확장
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
      vm.extendMenu = function (elementId) {
        var $o = $("#" + elementId);
        var code = elementId.split("_")[1];
        var menupath = $o.attr("menu-sort");
        var depth;
        if ($o.hasClass("depth-one")) depth = 1;
        else if ($o.hasClass("depth-two")) depth = 2;

        if (depth == 1) {
          $(".extend-btn").removeClass("fa-minus");
          $(".extend-btn").addClass("fa-plus");
          $(".depth-two").slideUp();
          $(".depth-three").slideUp();
          if ($("[menu-sort^='" + menupath + "'].depth-two").eq(0).css("display") == "block") {
            $("[menu-sort^='" + menupath + "'].depth-two").slideUp();
          } else {
            $o.find(".extend-btn").addClass("fa-minus");
            $("[menu-sort^='" + menupath + "'].depth-two").slideDown();
          }
        } else {
          if ($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display") == "block") {
            $o.find(".extend-btn").removeClass("fa-minus");
            $o.find(".extend-btn").addClass("fa-plus");
            $("[menu-sort^='" + menupath + "'] .depth-three").slideUp();
          } else {
            $(".depth-three").slideUp();
            $o.closest(".as-sortable-item").parent().find(".extend-btn").removeClass("fa-minus");
            $o.closest(".as-sortable-item").parent().find(".extend-btn").addClass("fa-plus");
            $o.find(".extend-btn").addClass("fa-minus");
            $("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
          }
        }
      }

      /**
       * 동일 선상의 서브 메뉴를 보여주기 위함
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
      vm.showSubMenu = function (elementId) { $("#" + elementId).css("display", "block"); }

      /**
       * 동일 선상의 서브 메뉴를 숨기기 위함
       * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
      */
      vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

      /**
       * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
      */
      vm.menuTitleChange = function () {
        var val = $(vm.targetField).val();
        var $obj = $(vm.targetField);
        var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
        (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
      };

      /**
       * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
       * @param {int} depth 메뉴 Depth
      */
      vm.cancelMenuItem = function (depth) {
        var $obj = $(vm.targetField);
        var $editLayout = $obj.closest(".edit-layout");
        var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
        $okBtn.addClass("disable");
        $editLayout.css("display", "none");
        $obj.val("");
        $(".subTextmenu").removeClass("importantHidden");
      };

      /**
       * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
       * @param {int} depth 메뉴 Depth
      */
      vm.addMenuItem = function (depth) {
        // 190503 만약 로그인 권한이 Sysadmin 이 아닐 경우
        // 해당 로직을 진행하면 안됨 (기능 추가 필요);
        var $obj = $(vm.targetField);
        if ($obj.val() == undefined || $obj.val().length == 0) return;
        var data = {};
        data.menuNm = $obj.val();
        data.menuId = makeDateUUID();
        data.depth = depth;
        data.child = [];
        data.delYn = "N"; // 생성모드
        data.mobileOnlyYN = vm.mobileOnlyYN;
        data.disableClass = "disable-master";
        data.tenantId = "";
        data.useYn = "N";
        data.roleLevel = 1;

        var checkDepth;
        if (depth == 1) {

          var checkUseY = 0, checkUseN = 0;
          for(var i = 0; i < vm.menuList.length; i++) {
            if(vm.menuList[i].useYn =="Y") checkUseY = vm.menuList[i].sort;
            if(vm.menuList[i].useYn =="N") checkUseN = vm.menuList[i].sort;
          }

          if(checkUseN == 0) {
            data.sort = checkUseY + 100;
          } else {
            data.sort = checkUseN + 1;
          }

          data.tempSortPath = [];
          data.tempSortPath[0] = data.sort;

          checkDepth = 1;
          vm.depth01title = "";
        } else {
          var sort = $obj.closest(".edit-layout").attr("menu-sort");
          var obj = findObject(vm.menuList, 'sort', sort);
          data.sort = sort + "" + (obj.child.length + 100);
          var sortArray = makeSortPath(data.sort);
          data.tempSortPath = sortArray;
          if (sortArray.length == 2) {
            checkDepth = 2;
            vm.depth02title = "";
          } else {
            checkDepth = 3;
            vm.depth03title = "";
          }
        }

        postApi.insert('Menu.setBaseMenuList', data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            var obj = findObject(vm.menuList, 'sort', sort);

            if (checkDepth == 1) vm.menuList.push(data);
            else obj.child.push(data);

            if (depth != 1) {
              $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
              $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
              setTimeout(function () {
                $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
              }, 500);
            }

            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            vm.setDetailView(data);
          }
        }, function (error) {
          console.error('Error> setBaseMenuList', status, error);
        });

        var $editLayout = $obj.closest(".edit-layout");
        var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
        $okBtn.addClass("disable");
        $editLayout.css("display", "none");
        $obj.val("");

        $(".subTextmenu").removeClass("importantHidden");
      };

      /**
       * 포커스가 된 엘리먼트를 구하기 위함
       * @param {object} $event AngularJS Object
      */
      $scope.focusCallback = function ($event) {
        if ($event.target === null) return;
        vm.targetField = $event.target;
      };

      vm.addPage = function () {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }

        if(vm.menuInfo.pages == null ) vm.menuInfo.pages = [];
        var o = {screenId:'', mainYn: 'N', screenNm: '', pageUrl: '', pageUrlParam: '', newWindowYn:'N', delYn: 'N' };
        vm.menuInfo.pages.push(o);
      };

      vm.delPage = function(item, idx) {
        if(item.screenId != null && item.screenId != "") {
          if(item.delYn == "Y") {
            item.delYn = "N";
          } else if(item.delYn == "N") {
            item.delYn = "Y";
          }
        } else if(item.screenId == null || item.screenId == "") {
          if(item.delYn == "N") {
            vm.menuInfo.pages.splice(idx, 1);
          }
        } else if(item.delYn == "Y") {
          item.delYn = "N";
        } else if(item.delYn == "N") {
          item.delYn = "Y";
        } else {
          vm.menuInfo.pages.splice(idx, 1);
        }
      };

      /**
       * Font 를 저장한다. DELETE 예정
      */
      vm.setFa = function () {
        if ($("#viewFontIcon").width() == 0) return;
        var data = { mapCode: "fontAwesome.setFontList", name: vm.addInputFa };
        postApi.insert(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.addInputFa = "fa-";
            getFa();
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.setChangeIcon = function (name) {
        if(vm.menuInfo.length == 0) {
          return;
        }
        for (var i = 0; i < vm.fontList.length; i++) {
          if (vm.fontList[i].name == name) {
            vm.fontList[i].active = "active";
          } else {
            vm.fontList[i].active = "";
          }
        }

        var menu = findObject(vm.menuList, 'menuId', vm.menuInfo.menuId);
        if (name == "_초기화") {
          menu.icon = '';
          vm.menuInfo.icon = '';
        } else {
          menu.icon = name;
          vm.menuInfo.icon = name;
        }

      };

      vm.invalidBaseInfo = function () {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }

        if (vm.menuInfo.name == '') {
          gAlert('', '메뉴명을 입력하세요.', {
            btn: '확인', fn: function () { }
          });
          return;
        }

        if(vm.viewMode != "T") {
          if (vm.menuInfo.pages != null && vm.menuInfo.pages.length == 0) {
            if (!vm.checkPages(function (boolean) {
              if (boolean) vm.checkMainPages();
            }));
          } else {
            vm.checkMainPages();
          }
        } else {
          vm.uptMenuBaseInfo();
        }

        // srchTenantId가 0일때만 insertBaseMenuTypeBatch 호출
        if ($rootScope.gVariable.srchTenantId == 0) {
          vm.updateMenuType();
        }
      };

      vm.updateMenuType = function() {
        var map = "MenuType.insertBaseMenuTypeBatch";
        var menuType = {MenuId: vm.menuInfo.menuId, lists:[]};
        angular.forEach(vm.radioMenuType, function(item) {
          if (item.checked) {
            menuType.lists.push(item);
          }
        });

        postApi.insert(map, menuType, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

          } else {
            console.error('Error> updateMenuType', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> updateMenuType', status, error);
        });
      };

      vm.uptMenuBaseInfo = function () {


        var map = "Menu.setBaseMenuInfoBatch";

        if( vm.menuInfo.roleLevel == null || vm.menuInfo.roleLevel == "") {
          vm.menuInfo.roleLevel = '1';
        }

        var setType = [];
        if(vm.menuInfo.depth == 1) {
          if(vm.menuInfo.menuType != null && vm.menuInfo.menuType != "") {

            var rootMenu = findObject(vm.menuList, 'menuId', vm.menuInfo.menuId);
            var menuType = vm.menuInfo.menuType;

            for(var i = 0; i < rootMenu.child.length; i++) {
              rootMenu.child[i].menuType = menuType;
              setType.push(rootMenu.child[i]);
              for(var j = 0; j < rootMenu.child[i].child.length; j++) {
                rootMenu.child[i].child[j].menuType = menuType;
                setType.push(rootMenu.child[i].child[j]);
              }
            }
          }
        }

        vm.menuInfo.setType = setType;
        if($rootScope.gVariable.srchTenantId != 0) {
          vm.menuInfo.pages = [];
        }
        postApi.update(map, vm.menuInfo, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var temp = findObject(vm.menuList, 'menuId', vm.menuInfo.menuId);
            temp.menuNm = vm.menuInfo.menuNm;
            vm.getPages();

            $rootScope.$broadcast('broadcastSetChangeMenuList', {});
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.checkMainPages = function () {
        if (vm.menuInfo.pages != null && vm.menuInfo.pages.length != 0) {
          var st = $(":input:radio[name=pageMain]:checked").val();
          if (vm.SysAdmin) {
            if (st == undefined) {
              gAlert('', '연관페이지의 [메인]을 선택하여주세요.', {
                btn: '확인', fn: function () { }
              });
              return;
            }

            var check = 0;
            for (var i = 0; i < vm.menuInfo.pages.length; i++) {
              if (vm.menuInfo.pages[i].pageNm == "") {
                gAlert('', '연관페이지의 [페이지명]을 확인하여주세요.', { btn: '확인', fn: function () { }});
                return;
              }
              if (vm.menuInfo.pages[i].pageUrl == "") {
                gAlert('', '연관페이지의 [페이지URL]을 확인하여주세요.', {btn: '확인', fn: function () { }});
                return;
              }
            }

            for (var i = 0; i < vm.menuInfo.pages.length; i++) {
              vm.menuInfo.pages[i].mainYn = "N";
            }

            vm.menuInfo.pages[st].mainYn = "Y";
          }

          var st = $(":input:radio[name=optionMenuType]:checked").val();
          vm.menuInfo.menuType = st;
          vm.uptMenuBaseInfo();
        } else {
          vm.uptMenuBaseInfo();
        }
      }

      vm.checkPages = function (callback) {
        gConfirm("연관 페이지가 없습니다. 계속 진행하시겠습니까?",
          { btn: '확인', fn: function () { callback(true); } },
          { btn: '취소', fn: function () { callback(false); } }
        );
      };

      vm.alertSelectMenu = function () {
        gAlert('w', '메뉴를 선택하여주세요.', {
          btn: '확인', fn: function () { }
        });
      };

      vm.onChangeGroupView = function (code) {
        if (code == null || code == undefined || code == "") {
          angular.forEach(vm.menuList, function (key, value) {
            key.extendGroupClass = "";
          });
        } else {
          angular.forEach(vm.menuList, function (key, value) {
            if (key.menuType == undefined) key.menuType = "";
            if (key.menuType.toString() == code.toString()) {
              if (key.mShowYn != "Y")
                key.extendGroupClass = "visible-group";
              else
                key.extendGroupClass = "visible-use-group";

            } else {
              key.extendGroupClass = "invisible-group";
            }
            //}
          });
        }
      };

      vm.onChangeNewWindowYn = function (code) {

      };

      /************************************************************* */
      vm.setChangeTenant = function (id, name) {
        vm.viewMode = "TV";
        vm.menuTitle = 'All Category';
        vm.sysAdminDisable = true
        vm.selectTenantInfo.id = id;
        vm.selectTenantInfo.name = name;

        for (var i = 0; i < vm.showTabView.length; i++) vm.showTabView[i] = "";
        vm.showTabView[0] = "in active";

        setTimeout(function () {
          $("ul.nav-tabs li").removeClass("active");
          $("ul.nav-tabs li").eq(1).addClass("active");
        }, 25);

        vm.menuList = [];
        vm.menuInfo = [];

        var data = { mapCode: 'Menu.getTenantMenuList', tenant: id }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            makeMenuList(result.body.docs, true);
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      // arrow  true : top, false : down, default up;
      var resultObj = {};
      vm.findUptTenantNode = function (obj, arrow) {
        resultObj.str = [];
        resultObj.codes = [];
        if (arrow) { // UP
          var path = makeSortPath(obj.sort);
          for (var i = 0; i < path.length-1; i++) {
            var temp = "";
            for(var j = 0; j < i+1; j++) {
              temp += path[j];
            }
            temp = findObject(vm.menuList, 'sort', temp);
            if (temp.useYn == "N") {
              resultObj.codes.push(temp);
              resultObj.str.push(temp.menuNm);
            }
          }
        } else {
          var temp = obj.child;
          var k = [];
          var count = 0;
          for (var c = 0; c < 1000; c++) {
            for (var i = 0; i < temp.length; i++) {
              var check = true;
              for (var j = 0; j < k.length; j++) {
                if (k[j].menuId == temp[i].menuId) {
                  check = false;
                  break;
                }
              }
              if (check) k.push(temp[i]);
              else count = -1;
            }

            if (count == -1) break;
            if (k.length == count) break;
            else {
              count = k.length;
              temp = [];
              for (var i = 0; i < k.length; i++) {
                if (k[i] == undefined) {
                  count = -1;
                  break;
                }
                for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
              }
            }
          }

          for (var i = 0; i < k.length; i++) {
            resultObj.str.push(k[i].menuNm);
          }
          resultObj.codes = k;
        }
        resultObj.str = resultObj.str.toString();
        return resultObj;
      };

      vm.setTenantEnable = function (depth, obj) {
        if (depth == 1) {
          if (obj.tenantId == "" || obj.useYn == "N") {
            gConfirm('', "해당 메뉴를 [활성] 하시겠습니까?", {
              btn: '확인', fn: function () {
                if (obj.child.length > 0) {
                  vm.checkDepth1OtherData(obj);
                } else {
                  var toData = [];
                  toData.push(obj);
                  vm.setChangeMenuState(toData, true);
                }
              }
            }, {btn: '취소', fn: function () {}});
          } else {
            var msg = "";
            if (obj.child.length > 0) msg = "해당 메뉴의 하위 메뉴포함하여 [비활성] 하시겠습니까?";
            else msg = "해당 메뉴를 [비활성] 하시겠습니까?";
            gConfirm('', msg, {
              btn: '확인', fn: function () {
                var toData = [];
                toData.push(obj);
                var result = vm.findUptTenantNode(obj, false);
                for (var i = 0; i < result.codes.length; i++) {
                  result.codes[i].useYn = "N";
                  result.codes[i].disableClass = "disable-master";
                  toData.push(result.codes[i]);
                }
                vm.setChangeMenuState(toData, false);
              }
            }, {
              btn: '취소', fn: function () {}
            });
          }
          // End Depth 1;
        } else {
          // 2Depth 이상
          var str, state = false, result = [], msg = '';
          (obj.tenantId == "" || obj.useYn == "N") ?  state = true : state = false;
          if(state) {
            result = vm.findUptTenantNode(obj, true);
            if(result.codes.length == 0) {
              msg = "해당 메뉴를 [활성] 하시겠습니까?";
            } else {
              msg = "해당 메뉴 포함하여 [" + result.str + "] 메뉴를 [활성] 하시겠습니까?";
            }
          } else {
            if(obj.child.length > 0) {
              result = vm.findUptTenantNode(obj, false);
              msg = "해당 메뉴의 하위 메뉴포함하여 [비활성] 하시겠습니까?";
            } else {
              msg = "해당 메뉴를 [비활성] 하시겠습니까?";
            }
          }

          gConfirm('', msg, {
            btn: '확인', fn: function () {
              var toData = [];
              setMenuState(state, obj);
              toData = setChangeDepthCode(state, obj);
              if(state) {
                if(obj.child.length > 0) {
                  gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
                    btn: '확인', fn: function () {
                      var $thisObj = findObject(toData, 'sort', obj.sort);
                      for(var i = 0; i < $thisObj.child.length; i++) {
                        $thisObj.child[i] = setMenuState(state, $thisObj.child[i]);
                        var temp = findObject(vm.menuList, 'sort', $thisObj.child[i].sort);
                        temp = setMenuState(state, temp);
                      }

                      (state) ? vm.setChangeMenuState(toData, true, true) : vm.setChangeMenuState(toData, false, true);
                    }
                  }, {
                    btn: '취소', fn: function () {
                      (state) ? vm.setChangeMenuState(toData, true, true) : vm.setChangeMenuState(toData, false, true);
                    }
                  });
                } else {
                  (state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
                }
              } else {
                (state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
              }
            }
          }, {
            btn: '취소', fn: function () {}
          });
        }
      };

      function setMenuState(state, data) {

        // 배열로 작업 예정
        if(state) {
          data.useYn = "Y";
          data.disableClass = "";
        } else {
          data.useYn = "N";
          data.disableClass = "disable-master";
        }

        return data;
      }

      // 2Depth 이상 수행 함수
      function setChangeDepthCode(state, obj) {

        var result = [];
        var sort = makeSortPath(obj.sort);
        var size = sort.length, oneDepth, twoDepth, sortKey = -1;
        oneDepth = findObject(vm.menuList, 'sort', sort[0]);
        if(size == 3){
           twoDepth = findObject(vm.menuList, 'sort', Number(sort[0]+''+sort[1]));
           if(state) setMenuState(state, twoDepth);
        }


        if(state) { // 활성
          var index = -1, checkSort = -1, sortidx = -1;
          if(oneDepth.useYn == "Y") {
            sortKey = oneDepth.sort;
          } else {
            for(var i = 0; i < vm.menuList.length; i++) {
              if(vm.menuList[i].menuId == oneDepth.menuId) {
                index = i;
              }
              if(vm.menuList[i].useYn == "Y") {
                checkSort = Number(vm.menuList[i].sort);
                sortidx = i;
              }
            }

            if(checkSort == -1) { sortKey = 100 } else { sortKey = checkSort+1; }
            oneDepth.useYn = "Y";
            oneDepth.disableClass = "";
            oneDepth.sort = sortKey;
            oneDepth.tempSortPath[0] = sortKey;

            result.push(oneDepth);
          }

          for(var i = 0; i < oneDepth.child.length; i++) {
            var o = oneDepth.child[i];
            var childSort = makeSortPath(o.sort);
            childSort[0] = sortKey;
            o.sort =  + "" + Number(childSort.toString().replaceAll(",",""));
            o.tempSortPath = childSort;
            var d3ParentCode = [];
            angular.copy(o.tempSortPath, d3ParentCode);
            d3ParentCode.push(0);

            result.push(o);
            for(var j = 0; j < o.child.length; j++) {
              var _o = o.child[j];
              d3ParentCode[2] = _o.tempSortPath[2];
              _o.sort =  Number(d3ParentCode.toString().replaceAll(",",""));
              _o.tempSortPath = d3ParentCode;
              result.push(_o);
            }
          }

          if(index != -1) {
            var temp = {};
            angular.copy(vm.menuList[index], temp);
            vm.menuList.splice(index, 1);
            if(state) {
              (sortidx != -1) ? vm.menuList.splice(sortidx+1, 0, temp) : vm.menuList.push(temp);
            } else {
              vm.menuList.push(temp);
            }
          }
        } else { // 비활성
          result.push(obj);
          if(obj.child.length > 0) {
            for(var i = 0; i < obj.child.length; i++) {
              obj.child[i] = setMenuState(state, obj.child[i]);
              result.push(obj.child[i]);
            }
          }
        }
        return result;
      }

      vm.checkDepth1OtherData = function (obj) {
        var result = vm.findUptTenantNode(obj, false);
        if (result.codes.length > 0) {
          gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
            btn: '확인', fn: function () {
              var toData = [];
              toData.push(obj);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].useYn = "Y";
                result.codes[i].disableClass = "";
                toData.push(result.codes[i]);
              }

              vm.setChangeMenuState(toData, true);
            }
          }, {
              btn: '취소', fn: function () {
                var toData = [];
                toData.push(obj);
                for (var i = 0; i < result.codes.length; i++) {
                  toData.push(result.codes[i]);
                }
                vm.setChangeMenuState(toData, true);
              }
            });
        } else {
          var toData = [];
          toData.push(obj);
          vm.setChangeMenuState(toData, true);
        }
      };

      vm.setChangeMenuState = function (data, state, checkSortEnable) {
        var sendData = {};
        sendData.menus = data;
        // 190717 배열 인덱스 조절
        var index = -1;
        var sortidx = -1;
        if(data[0].depth == 1) {
          var sortKey = -1;
          for(var i = 0; i < vm.menuList.length; i++) {
            if(vm.menuList[i].menuId == data[0].menuId) {
              index = i;
              break;
            }
          }

          if(!state) {
            var checkUseY = 0, checkUseN = 0;
            for(var i = 0; i < vm.menuList.length; i++) {
              if(vm.menuList[i].useYn =="Y") checkUseY = vm.menuList[i].sort;
              if(vm.menuList[i].useYn =="N") checkUseN = vm.menuList[i].sort;
            }
            (checkUseN == 0) ? sortKey = checkUseY + 100 : sortKey = checkUseN + 1;
            data[0].useYn = "N";
            data[0].disableClass = "disable-master";
          } else {
            var checkSort = -1;
            for(var i = 0; i < vm.menuList.length; i++) {
              if(vm.menuList[i].useYn == "Y") {
                checkSort = Number(vm.menuList[i].sort);
                sortidx = i;
              }
            }
            if(checkSort == -1) { sortKey = 100 } else { sortKey = checkSort+1; }
            data[0].useYn = "Y";
            data[0].disableClass = "";
          }

          for(var i = 0; i < data.length; i++) {
            var orgSort = makeSortPath(data[i].sort);
            orgSort[0] = sortKey;
            data[i].sort = Number(orgSort.toString().replaceAll(",",""));
            data[i].tempSortPath = orgSort;
          }
        } // END IF (data[0].depth == 1)

        for (var i = 0; i < data.length; i++) {
          if(data[i].tenantId == "") {
            (vm.SysAdmin) ? data[i].tenantId
              = $window.sessionStorage['srchTenantId'] : data[i].tenantId = $window.sessionStorage['loginTenantId'];
          }
        }


        if(index != -1) {

          // index 검증
          for(var i = 0; i < sortidx; i++) {
            if(vm.menuList[i].useYn == "N") {
              sortidx = i - 2 ;
            }
          }

          var temp = {};
          angular.copy(vm.menuList[index], temp);
          vm.menuList.splice(index, 1);
          if(state) {

            if(sortidx != -1) {
              if(checkSortEnable == undefined)  sortidx = sortidx+1;
              vm.menuList.splice(sortidx, 0, temp);
            } else {
              vm.menuList.push(temp);
            }
          } else {
            vm.menuList.push(temp);
          }
        }

        sendData.menus = data;
        postApi.update('Menu.setTenantMenuList', sendData, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.$broadcast('broadcastSetChangeMenuList', {});
            var msg;
            (state) ? msg = "해당 메뉴를 [활성]하였습니다." : msg = "해당 메뉴를 [비활성]하였습니다.";
            $rootScope.showSimpleToast(msg);
            vm.setChangeMenuList(false);
            for(var k = 0; k < data.length; k++) {
              if(data[k].menuTenantId == null || data[k].menuTenantId == "") {
                var request = {};
                request.menuId = data[k].menuId;
                postApi.callbackSelect('Menu.getTenantMenuId',request, data[k], function(result, data){
                  var sData = findObject(vm.menuList, 'menuId', data.menuId);
                  sData.menuTenantId =result.body.docs[0].menuTenantId;
                });
              }
            }
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      /* START 연관설문 ********************************************* */
      vm.srch = {};
      vm.deleteMenuSvyList = deleteMenuSvyList;

      // 문제 목록 체크박스 설정
      vm.menuSvyChkHead = false;
      $scope.menuSvyChkRowChg = function () {
        for (var i = 0; i < vm.menuSvyLists.length; i++) {
          if (!vm.menuSvyLists[i].isChecked) {
            vm.menuSvyChkHead = false;
            return;
          }
        }
        vm.menuSvyChkHead = true;
      };

      $scope.menuSvyChkHeadChg = function () {
        for (var i = 0; i < vm.menuSvyLists.length; i++) {
          vm.menuSvyLists[i].menuSvyChkRow = vm.menuSvyChkHead;
        }
      };

      getMenuSvyList();

      /**
       * 설문 추가 팝업 호출
       */
      vm.addMenuSvyModal = function () {
        if (isNullOrEmpty(vm.menuInfo.menuId)) {
          vm.alertSelectMenu();
          return;
        }

        var ctrl = 'MenusurveyModalCtrl as vc';
        var paramData = {keyId: vm.menuInfo.menuId};
        var modalInstance = modalFactory.open('modal', 'components/modal/survey/menusvy-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getMenuSvyList();
        }, function (cancelData) {
          getMenuSvyList();
        });
      };

      /**
       * 설문 목록 조회
       */
      function getMenuSvyList() {
        vm.dataloader = true; // Progressbar 표시

        var data = {};
        data.mapCode = "Survey.getMenusurveyList";
        data.MenuId = vm.menuInfo.menuId;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            //console.log("re", result);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.menuSvyLists = result.body.docs;
              vm.menuSvyTotalItems = vm.menuSvyLists.length;
            } else {
              // 데이터 조회 실패
              vm.menuSvyLists = {};
              vm.menuSvyTotalItems = 0;
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getMenuSvyList()");
          console.table(error);
        });
      }

      /**
       * 설문 목록 삭제
       */
      function deleteMenuSvyList() {
        if (isNullOrEmpty(vm.menuInfo.menuId)) {
          vm.alertSelectMenu();
          return;
        }

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteMenuSvyListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteMenuSvyListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.menuSvyLists.length; i++) {
          if (vm.menuSvyLists[i].menuSvyChkRow)
          {
            vm.srch.KeyIdList.push(vm.menuSvyLists[i].MenuSvyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = "Survey.deleteMenusurveyList";
        //data.MenuId = vm.menuInfo.menuId;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getMenuSvyList();
              }
            });
          }
        }, function (error) {
          console.error("Error> deleteMenuSvyListAction()");
          console.table(error);
        });
      }
      /* END 연관설문 ********************************************* */


      /* START 권한정보 ********************************************* */

      /**
       * 페이지를 선택하였을 시 기본 정보를 가져온다.
       * @param {int} depth 메뉴 Depth
      */
      vm.loadPageData = function(data) {
        vm.rolesInfo = data;
        vm.rolesInfo.loadPageData = [];
        vm.rolesInfo.sqlMapper = [];
        vm.rolesInfo.conditions = [];
        vm.rolesInfo.Btn01Text = '';
        vm.rolesInfo.Btn02Text = '';
        vm.rolesInfo.Btn03Text = '';
        vm.rolesInfo.Btn04Text = '';
        vm.rolesInfo.Btn05Text = '';
        vm.rolesInfo.Btn06Text = '';
        vm.choiceRolePage = data.screenId;

        var srch = { mapCode: 'Menu.getBaseRoleInfo', screenId : data.screenId};
        postApi.select(srch, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            initRoleData(result);
          } else {
            console.error('Error> getBaseRoleInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> getBaseRoleInfo', error);
        });
      };

      function initRoleData(result) {
        vm.rolesInfo.screen = result.body.docs;

        if (vm.rolesInfo.screen.length > 0) {
          vm.rolesInfo.Btn01Text = vm.rolesInfo.screen[0].Btn01Text;
          vm.rolesInfo.Btn02Text = vm.rolesInfo.screen[0].Btn02Text;
          vm.rolesInfo.Btn03Text = vm.rolesInfo.screen[0].Btn03Text;
          vm.rolesInfo.Btn04Text = vm.rolesInfo.screen[0].Btn04Text;
          vm.rolesInfo.Btn05Text = vm.rolesInfo.screen[0].Btn05Text;
          vm.rolesInfo.Btn06Text = vm.rolesInfo.screen[0].Btn06Text;
        }

        if(vm.rolesInfo.sqlId != null) {
          var sqlMap = vm.rolesInfo.sqlId.split(",");
          for(var i = 0; i < sqlMap.length; i++) {
            var o = {};
            o.sqlCode = sqlMap[i];
            o.useYn = true;
            o.delYn = "N";
            vm.rolesInfo.sqlMapper.push(o);
          }
        }

        if(vm.rolesInfo.paramPass != null) {
          var pass = vm.rolesInfo.paramPass.split(",");
          for(var i = 0; i < pass.length; i++) {
            var spliter = pass[i].split("=");
            var o = {};
            o.condition = spliter[0];
            o.value = spliter[1];
            o.useYn = true;
            o.delYn = "N";
            if(o.condition != null && o.condition != "")
            vm.rolesInfo.conditions.push(o);
          }
        }

        if(vm.rolesInfo.paramRefuse != null) {
          var paramRefuse = vm.rolesInfo.paramRefuse.split(",");
          for(var i = 0; i < paramRefuse.length; i++) {
            var spliter = paramRefuse[i].split("=");
            var o = {};
            o.condition = spliter[0];
            o.value = spliter[1];
            o.useYn = true;
            o.delYn = "N";
            if(o.condition != null && o.condition != "")
              vm.rolesInfo.conditions.push(o);
          }
        }

        vm.loadRolesData();
      }

      vm.loadRolesData = function() {
        if(vm.menuInfo.pages != null) {

        }
        //console.log(vm.menuInfo.pages);
      };

      vm.getLoadSqlMapper = function(){

        if (vm.choiceRolePage == null || vm.choiceRolePage == "") {
          gAlert('w', '연관페이지를 선택하여주세요.', {
            btn: '확인', fn: function () { }
          });
          return;
        }
        openTextFile();
      };

      function openTextFile() {
        var input = document.createElement("input");
        input.type = "file";
        input.accept = "js";

        input.onchange = function (event) {
            processFile(event.target.files[0]);
        };

        input.click();
      }

      function processFile(file) {
        var tx = "";
        var reader = new FileReader();
        reader.onload = function () {
          tx = reader.result.replaceAll(" ", "").replaceAll("\r\n","").replaceAll("\n","");
          if(tx.trim().length < 1) {
            gAlert('', '다시 시도하여주세요.', {
              btn: '확인', fn: function () { }
            });
            return;
          }
          for(var i = 0; i < 100; i++) {
            var check = false, index = -1, compareStr;
            if(tx.toLowerCase().indexOf('mapcode') != -1) {
              check = true;
              index = tx.toLowerCase().indexOf('mapcode');
              compareStr = 'mapcode';
            } else if(tx.toLowerCase().indexOf('postapi.') != -1) {
              check = true;
              index = tx.toLowerCase().indexOf('postapi.');
              compareStr = 'postapi';
            }
            if(!check) break;
            else {
              var index1 = -1, index2 = -1;
              tx = tx.substring(index, tx.length);
              if(compareStr == "mapcode") {
                index1 = tx.indexOf("\"");
                index2 = tx.indexOf("'");
                if(index1 == -1) index1 = 9999;
                if(index2 == -1) index2 = 9999;
                var temp;
                if(index1 < index2) {
                  tx = tx.substring(tx.indexOf('\"') + 1,tx.length);
                  temp = tx.substring(0, tx.indexOf('\"'));
                } else {
                  tx = tx.substring(tx.indexOf("'") + 1,tx.length);
                  temp = tx.substring(0, tx.indexOf("'"));
                }
                if(temp.indexOf("(") == -1 && temp.indexOf(")") == -1) {
                  var o = {};
                  o.sqlCode = temp.trim();
                  o.useYn = true;
                  o.delYn = "N";
                  var subCheck = true;
                  for(var z = 0; z < vm.rolesInfo.sqlMapper.length; z++) {
                    if(vm.rolesInfo.sqlMapper[z].sqlCode == o.sqlCode) {
                      subCheck = false;
                      break;
                    }
                  }
                  if(subCheck) {
                    if(temp.length > 1) vm.rolesInfo.sqlMapper.push(o);
                  }
                }

              } else {
                tx = tx.substring( tx.indexOf('(')+1, tx.length);
                var subTx = tx.substring(0, tx.indexOf(",")).trim();
                index1 = subTx.indexOf("\"");
                index2 = subTx.indexOf("'");
                if(index1 == -1) index1 = 9999;
                if(index2 == -1) index2 = 9999;
                if(index1 < index2) {
                  subTx = subTx.substring(subTx.indexOf('\"') + 1,subTx.length);
                  subTx = subTx.substring(0, subTx.indexOf('\"'));
                } else if(index1 > index2){
                  subTx = subTx.substring(subTx.indexOf("'") + 1,subTx.length);
                  subTx = subTx.substring(0, subTx.indexOf("'"));
                }
                if(subTx.indexOf(".") > -1) {
                  var o = {};
                  o.sqlCode = subTx.trim();
                  o.useYn = true;
                  o.delYn = "N";
                  var subCheck = true;
                  for(var z = 0; z < vm.rolesInfo.sqlMapper.length; z++) {
                    if(vm.rolesInfo.sqlMapper[z].sqlCode == o.sqlCode) {
                      subCheck = false;
                      break;
                    }
                  }
                  if(subCheck) {
                    if(subTx.length > 1) vm.rolesInfo.sqlMapper.push(o);
                  }
                }
              }
            }
          }

          setTimeout(function(){
            vm.rolesInfo.sqlMapper.push({sqlCode : ""});
            vm.rolesInfo.sqlMapper.splice(vm.rolesInfo.sqlMapper.length-1, 1);
            $rootScope.showSimpleToast('파일을 로드하였습니다.');
          }, 1000);

        };

        var errorEvent = function(event) {

          gAlert('', '다시 시도하여주세요.', {
            btn: '확인', fn: function () { }
          });
          if (event.type === 'loadstart') {
            reader.abort();
          }
        };
        reader.onerror = errorEvent;

        reader.readAsText(file, /* optional */ "utf-8");
      }

      vm.addSqlMapper = function() {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }
        var o = {};
        o.sqlCode = "";
        o.useYn = true;
        o.delYn = "N";
        vm.rolesInfo.sqlMapper.push(o);
      };

      vm.addCondition = function() {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }

        if(vm.rolesInfo.conditions == null) vm.rolesInfo.conditions = [];

        var o = {};
        o.condition = "";
        o.value = "";
        o.useYn = true;
        o.delYn = "N";
        vm.rolesInfo.conditions.push(o);
      };

      vm.setChangeEdtLabel = function() {
        if(vm.checkEdtLabel) {
          vm.checkEdtLabel = false;
          vm.checkEdtLabelText = "라벨편집";
        } else {
          vm.checkEdtLabel = true;
          vm.checkEdtLabelText = "수정완료";
        }
      };

      vm.setRoleData = function() {
        var request = angular.copy(vm.rolesInfo);

        var sql = request.sqlMapper;
        var cd = request.conditions;

        request.sqlId = "";
        for(var i = 0; i < sql.length; i++) {
          if(sql[i].useYn && sql[i].delYn == "N") {
            if(i != 0) request.sqlId += ",";
            request.sqlId += sql[i].sqlCode;
          }
        }
        request.paramPass = "";
        request.paramRefuse = "";
        for(var i = 0; i < cd.length; i++) {
          if(cd[i].delYn == "N") {
            if(cd[i].useYn) {
              request.paramPass += (cd[i].condition + "=" + cd[i].value + ",");
            } else {
              request.paramRefuse += (cd[i].condition + "=" + cd[i].value + ",");
            }
          }
        }
        if(request.paramPass != "") request.paramPass = request.paramPass.substring(0, request.paramPass.length-1);
        if(request.paramRefuse != "") request.paramRefuse =request.paramRefuse.substring(0, request.paramRefuse.length-1);

        // RoleScreen
        var screen = request.screen;
        request.roleScreen = [];
        for(var i = 0; i < screen.length; i++) {
          var o = {};
          o.roleScrId = screen[i].RoleScrId;
          o.screenId = screen[i].ScreenId;
          o.viewYn = screen[i].ViewYN;
          o.roleId = screen[i].RoleId;
          o.btn01Yn = screen[i].Btn01YN;
          o.btn02Yn = screen[i].Btn02YN;
          o.btn03Yn = screen[i].Btn03YN;
          o.btn04Yn = screen[i].Btn04YN;
          o.btn05Yn = screen[i].Btn05YN;
          o.btn06Yn = screen[i].Btn06YN;
          request.roleScreen.push(o);
        }

        postApi.update('Screen.updateScreenDetail2', request, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          } else {
            console.error('Error> setRoleData', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setRoleData', status, error);
        });

      };

      /************************************************************* */
      vm.viewChange = function (mode) {
        vm.viewMode = mode;
      };

      vm.setChangeMenuList = function (checkToast) {
        // 메뉴 리스트 1렬로 변경
        // A 모드와 TV 모드 변경
        var data = {}
        data.type = vm.viewMode;
        data.menus = [];
        var temp = vm.menuList;
        for (var i = 0; i < temp.length; i++) {
          data.menus.push(temp[i]);
          if (temp[i].child.length > 0) {
            for (var j = 0; j < temp[i].child.length; j++) {
              data.menus.push(temp[i].child[j]);
              if (temp[i].child[j].child.length > 0) {
                for (var k = 0; k < temp[i].child[j].child.length; k++) {
                  data.menus.push(temp[i].child[j].child[k]);
                }
              }
            }
          }
        }
        postApi.update('Menu.setAlignMenuList', data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if(checkToast != false) $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.setChangeTab = function (index) {
        if(index == 1) {
          if (vm.menuInfo.length == 0) {
            setTimeout(function(){
              $(".nav-tabs li").eq(0).addClass("active");
              $(".nav-tabs li").eq(1).removeClass("active");
            }, 500);

            vm.alertSelectMenu();
            return;
          }

          vm.loadRolesData();
        } else {
          $(".nav-tabs li").eq(0).addClass("active");
          $(".nav-tabs li").eq(1).removeClass("active");
        }

        for (var i = 0; i < vm.showTabView.length; i++) vm.showTabView[i] = "";
        vm.showTabView[index] = "in active";


      };

      //>> ICON
      /**
       * Font 를 저장한다.
      */
      function getFa() {
        var data = { mapCode: "fontAwesome.getFontList" };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.fontList = [];
            if (vm.menuInfo.icon != undefined) {
              for (var i = 0; i < result.body.docs.length; i++) {
                var o = {};
                o.name = result.body.docs[i].name;
                if (vm.menuInfo.icon == result.body.docs[i].name) {
                  o.active = "active";
                }
                vm.fontList.push(o);
              }
            } else {
              vm.fontList = result.body.docs;
            }
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      }

      //>> SELECT
      function initBaseMenuList() {
        vm.mSrchTenentID = $window.sessionStorage['srchTenantId'];
        vm.menuList = [];
        vm.setChangeTab(0);
        var srchTenentID = $window.sessionStorage['srchTenantId'];
        if (vm.SysAdmin && srchTenentID == "0") vm.viewMode = "A";
        else vm.viewMode = "T";
        var request = { mapCode: 'Menu.getBaseMenuList', mobileOnlyYN: vm.mobileOnlyYN};
        postApi.select(request, function (response) {
          if (checkResponse('initBaseMenuList', response)) {
            (vm.viewMode == "T") ? makeMenuList(response.body.docs, true) : makeMenuList(response.body.docs);
          }
        }, function (e) { console.error('Error> setBaseMenuInfo', status, e); });
      }

      function initRadioMenuType() {
        var data = { mapCode: 'Menu.getMenuType', code: '', mobileOnlyYN: vm.mobileOnlyYN }
        postApi.select(data, function (response) {
          if (checkResponse('initRadioMenuType', response)) {
            vm.radioMenuType = response.body.docs;
          }
        }, function (e) { console.error('Error> initRadioMenuType', status, e); });
      }

      //>> #Broadcast
      $scope.$on('broadcastSetChangeTenantID', function (event, args) {
        vm.setDetailView();
        initBaseMenuList();
      });

      //>> #Init
      vm.initialize = function () {
        initBaseMenuList();
        initRadioMenuType();
        getFa();
      };
      vm.initialize();

      //>> #Other

      function makeSortPath(sort) {
        if (!sort) return new Array();

        var sort = sort.toString();
        var result = new Array();
        if(sort.length >= 3) {
          result.push(Number(sort.substring(0, 3)));
        }
        if(sort.length >= 6) {
          result.push(Number(sort.substring(3, 6)));
        }
        if(sort.length == 9) {
          result.push(Number(sort.substring(6, 9)));
        }
        return result;
      }

      function makeMenuList(data, check) {
//        console.log(data, check)
//        console.log(check, JSON.parse(JSON.stringify(data)))
        // SORT를 다시 만들어주는 작업이 필요함
        // 현재 베이스 코드와 일반 코드가 정렬하면서 문제가 발생
        var checkDepth1Code = 0;
        var checkUpdateMenuList = false;
        var lastUseYSort = 99;
        for (var i = 0; i < data.length; i++) {
          var o = {};
          o.menuId = data[i].menuId;
          o.depth = data[i].depth;
          o.menuNm = data[i].menuNm;
          o.path = data[i].path;
          o.icon = data[i].icon;
          o.menuType = data[i].menuType;
          o.sort = data[i].sort;
          o.baseSortKey = data[i].baseSortKey;

          if(o.depth == 1 && (data[i].menuTenantId == "" || data[i].useYn == "N")) {

            var tempSort = o.sort;
            var checkN = false, checkPassSort = 0, checkUseNSort = 0;
            for(var j = 0; j < vm.menuList.length; j++) {
              if(vm.menuList[j].useYn == "Y") checkPassSort = vm.menuList[j].sort;
              if(vm.menuList[j].useYn == "N") checkUseNSort = vm.menuList[j].sort;
            }

            (checkUseNSort == 0) ? o.sort = checkPassSort + 100 : o.sort = checkUseNSort + 1;
            checkDepth1Code = o.sort;
            for(var j = i+1; j < data.length; j++) {
              var code1Depth = makeSortPath(data[j].sort);
              if(tempSort == code1Depth[0]) {
                data[j].sort = checkDepth1Code + "" + code1Depth[1];
                if(code1Depth.length == 3) data[j].sort += ""+code1Depth[2];
                data[j].sort = Number(data[j].sort);
              }
            }
          } else {
            if(o.depth == 1) {
              if(lastUseYSort + 1 == data[i].sort) {
                lastUseYSort = data[i].sort;
              } else {
                checkUpdateMenuList = true;
                lastUseYSort = lastUseYSort + 1;
                o.sort = lastUseYSort;
                for(var j = i+1; j < data.length; j++) {
                  var code1Depth = makeSortPath(data[j].sort);
                  if(data[i].sort == code1Depth[0]) {
                    code1Depth[0] = lastUseYSort;
                    data[j].sort = Number(code1Depth.toString().replaceAll(",",""));
                  }
                }
              }
            }
          }

          o.tempSortPath = makeSortPath(o.sort);
          o.tempBaseSortPath = makeSortPath(o.baseSortKey);
          o.tenantId = data[i].tenantId;
          o.menuTenantId = data[i].menuTenantId;
          o.useYn = data[i].useYn;

          if (data[i].tenantId == "" ) o.disableClass = "disable-master";
          else if(data[i].useYn == "N")  o.disableClass = "disable-master";
          else o.disableClass = "";
          o.extendGroupClass = "";
          o.child = [];

          if (Number(data[i].depth) == 1) {
            vm.menuList.push(o);
          } else {

            // 2019.11.06 기존 Sort가 겹치는 문제가 발생하여
            // 2Depth부터는 BaseSortKey를 기준으로 변경하도록 수정

            /* var temp;
            if(o.tempSortPath.length == 2) temp = o.tempSortPath[0];
            else temp = o.tempSortPath[0] + '' + o.tempSortPath[1];
            var sData;
            sData = findObject(vm.menuList, 'sort', temp); */

            var temp;
            if(o.tempBaseSortPath.length == 2) temp = o.tempBaseSortPath[0];
            else temp = o.tempBaseSortPath[0] + '' + o.tempBaseSortPath[1];
            var sData;
            //sData = findObject(vm.menuList, 'sort', temp);

            /* if(temp == '209' || temp == "209102" ) {
              console.log(sData, o)
            } */

            var parent = findObject(vm.menuList, 'baseSortKey', temp);

            if (parent) {
              var parentCode = parent.sort;
              var subpath = makeSortPath(parentCode);
              if(subpath.length == 1) {
                o.tempSortPath[0] = subpath[0];
                o.tempSortPath[1] = 100 + parent.child.length;
                temp = subpath[0]
              } else if (subpath.length > 1) {
                o.tempSortPath[0] = subpath[0];
                o.tempSortPath[1] = subpath[1];
                o.tempSortPath[2] = 100 + parent.child.length;
                temp = o.tempSortPath[0] + '' + o.tempSortPath[1];
              }

              o.sort = o.tempSortPath.toString().replaceAll(",","");

              sData = findObject(vm.menuList, 'sort', temp);
              checkUpdateMenuList = true;

              sData['child'].push(o);
            }
              //console.log(parentCode, o, temp, sData);
           //}
          }
        }

        if(checkUpdateMenuList) {
          vm.setChangeMenuList(false);
        }
        if (vm.selectedGroupOptions != "") vm.onChangeGroupView(vm.selectedGroupOptions);
      };

      function findObject(obj, key, value) {
        for (var i = 0; i < obj.length; i++) {
          for (var objKey in obj[i]) {
            if (objKey == key) {
              if (obj[i][objKey] == value) {
                return obj[i];
              }
            }
          }
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
        return false;
      }

      function checkResponse(fNm, reponse) {
        if (reponse.header.status === CONSTANT.HttpStatus.OK) return true;
        else {
          console.error('Error>' + fNm, reponse.header.status, reponse.body.docs[0]);
        }
      }
    },
  ])
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:pharmagradefee-list-ctrl
   * @description
   * # 파머 등급 및 수수료 지급기준표
   * Controller of the 파머 등급 및 수수료 지급기준표
   */

  webapp.controller('PharmaGradeFeeListCtrl', ['$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm', '$translate',
    /**
     * @param $window - window object
     * @param $scope - scope object
     * @param $location - location object
     * @param $state - state object
     * @param $stateParams - state Parameter object
     * @param CONSTANT - 전역 상수
     * @param $rootScope - rootscope object
     * @param postApi - postApi Module
     */
    function PharmaGradeFeeListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, gConfirm, $translate) {

      // View Model
      var vm = this;
      vm.dataloader = false;

      // TenantId
      vm.TenantId = $window.sessionStorage['loginTenantId'];

      // 회원사 변경 체크
      $scope.$on('broadcastSetChangeTenantID', function (event, args) {
        getList();
      });

      vm.srch = {};

      vm.lists = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getList() {
        //getListCount();
        vm.dataloader = true;

        var data = vm.srch;
        data.mapCode = 'CvsPharmaGradeFee.getCvsPharmaGradeFeeList';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;

            } else {
              vm.totalItems = 0;
              vm.lists = [];
            }
          }
          vm.dataloader = false;
        }, function (error) {
          console.error('Error-getList', status, data);
          vm.dataloader = false;
        });
      }


      /**
       * 저장 확인
       *
       * @param
       * @return
       */
      function saveListConfirm() {
        gConfirm('', '저장 하시겠습니까?', {
          btn: '',
          fn: function () {
            saveList();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      /**
       * 저장
       *
       * @param
       * @return
       */
      function saveList() {

        vm.dataloader = true;

        var data = {lists: []};
        angular.forEach(vm.lists, function (item) {
          data.lists.push(item);
        });

        if (data.lists.length == 0) {
          return;
        }

        data.mapCode = 'CvsPharmaGradeFee.insertCvsPharmaGradeFeeBatch';

        postApi.insert(data, function (result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            getList();
          }
        }, function (error) {
          console.error('Error-getList', status, data);
          vm.dataloader = false;
        });
      }

      // 함수 선언
      vm.getList = getList;
      vm.saveList = saveList;
      vm.saveListConfirm = saveListConfirm;

      // 데이터 조회
      getList();
    },]);
})();

webapp.service('RoleAPISrv', ['$resource', 'StaticVariable',
  function RoleAPISrv($resource, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCount: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleListCnt/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/Role.updateRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/Role.insertRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Role.deleteRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.system:role-detail-ctrl
 * @description # 사용자 역할 상세보기 Controller
 */

webapp.controller('RoleDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RoleAPISrv',
    'gAlert', 'gConfirm', 'postApi',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state - state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} RoleAPISrv - RoleAPISrv Module
 * @param {object} gAlert - Alert Module *
 */

  function RoleDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm, postApi) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        RoleId : $stateParams.srch.RoleId ? $stateParams.srch.RoleId  : '',
        TenantId : vm.TenantId,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'role',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.RoleId) {
      vm.srch.RoleId = $stateParams.RoleId;
    }

    vm.srchDetail = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      RoleId : $stateParams.RoleId,
      TenantId : vm.TenantId,
      tableNm : 'role',
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getData() {
      vm.dataloader = true;
      var data = vm.srchDetail;

      data.mapCode = 'Role.getRoleDetail';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
          }
        }
        vm.dataloader = false;
      },function(error) {
        console.error('Error> role-edit-ctrl> getData()', status, error);
        vm.dataloader = false;
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function deleteDetail() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteDetailAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteDetailAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      console.log("before delete", vm.data);

      var data = vm.data;
      data.mapCode = 'Role.deleteRoleDetail';
      postApi.update(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go('app.system.role-list', {
                srch:srch
              }, {reload:'app.system.role-list'});
            }
          });
          return;
        }
      }, function(error) {
        console.error('Error> role-detail-ctrl> deleteDataAction()', status, error);
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function goList() {
      var srch = $stateParams.srch;
      $state.go('app.system.role-list', {
        srch : srch
      });
    }

    function goEdit() {
      var srch = $stateParams.srch;
      if (vm.layout == 'N') {
        $state.go('app.system.role-edit', {
          srch : srch, RoleId : vm.data.RoleId
        });
      } else {
        $state.go('app.system.role-list.edit', {
          srch : srch, RoleId : vm.data.RoleId
        });
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.deleteDetail = deleteDetail;
    vm.goList = goList;
    vm.goEdit = goEdit;

    // 데이터 조회
    getData();
  }, ]);
})();

/**
 * @ngdoc function
 * @name app.system.role-edit-ctrl
 * @description
 * # 역활 등록/수정
 * Controller of the 역활관리
 */
webapp.controller('RoleEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RoleAPISrv',
    'gAlert', 'gConfirm', 'postApi',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} RoleAPISrv - RoleAPISrv Module
 * @param {object} gAlert - Alert Module
 */

  function RoleEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, api, gAlert, gConfirm, postApi) {
    // View Model
    var vm = this;
    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId : $stateParams.srch.BbsMasterId ? $stateParams.srch.RoleId : '',
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'Users',
        TenantId : vm.TenantId,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.RoleId) {
      vm.srch.RoleId = $stateParams.RoleId;
    }

    vm.srchDetail = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      RoleId : vm.srch.RoleId != null ? $stateParams.RoleId : '',
      TenantId : vm.TenantId,
      tableNm : vm.srch.tableNm,
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author rohbi
    */
    function getData() {
      vm.dataloader = true;
      if (vm.srch.RoleId == null || vm.srch.RoleId == '') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srchDetail;
      data.mapCode = 'Role.getRoleDetail';

      postApi.select(data, function(result){
        vm.dataloader = false;
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];

          }
        }
      }, function(error) {
        console.table(error);
        vm.dataloader = false;
      });
    }

  /**
   * 필수 입력 & Validation Check
   *
   * @param
   * @return
   */
  function getIsValidData() {

    // #region 필수항목 체크
    var errMsg = '';


    if (isNullOrEmpty(vm.data.RoleNm))
      errMsg = errMsg + '- 역할명을 입력하세요.<br/>';

    if (!isNullOrEmpty(errMsg)) {
      gAlert('', errMsg);
      return false;
    }

    // #endregion 필수항목 체크

    //#region Validation Check

    return true;
    //#endregion Validation Check
  }


    /**
     * 데이터 저장
     *
     * @param
     * @return
     * @author 최원영
    */
    function setData() {

      // #region 필수항목 & Validation Check 체크
      if (!getIsValidData()) {
        return;
      }
      // #endregion 필수항목 & Validation Check 체크


      // 내용
      vm.data.tableNm = vm.srch.tableNm;
      vm.data.TableId = vm.data.RoleId;

      var data = vm.data;

      if (vm.data.RoleId == null || vm.data.RoleId == '') {
        // 등록
        data.mapcode = "Role.insertRoleDetail";
        postApi.insert(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      } else {
        // 수정
        data.mapCode = "Role.updateRoleDetail";
        postApi.update(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (result.body.docs[0].RoleId !== null || result.body.docs[0].TableId !== null) {
          // KeyId 조회
          vm.data.RoleId = result.body.docs[0].RoleId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              var srch = $stateParams.srch;

              if (vm.layout == 'N') {
                if (vm.srch.RoleId == null || vm.srch.RoleId == '') {
                  $state.go("app.system.role-list", { srch: srch });
                } else {
                  // 조회 화면 이동
                  $state.go("app.system.role-detail", {
                    srch: srch,
                    RoleId: vm.data.RoleId
                  });
                }
              } else {
                vm.srch.RoleId = "";
                vm.srch.reload = (new Date()).getTime();
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.system.role-list.detail", { srch: srch, RoleId:vm.data.RoleId });
              }
            }
          });
          return;
        }
      }
      console.table(result);
    }

    function goList() {
      vm.srch.RoleId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go("app.system.role-list", { srch: srch });
    }

    function deleteDetail() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteDetailAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteDetailAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      var data = vm.data;
      data.mapCode = 'Role.deleteRoleDetail';
      postApi.update(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              if (vm.layout == 'N') {
                vm.srch.RoleId = "";
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.system.role-list", { srch: srch });
              } else {
                vm.srch.ScreenId = "";
                vm.srch.reload = (new Date()).getTime();
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.system.role-list.edit", { srch: srch, RoleId:''});
              }
            }
          });

        }
      }, function(error) {
        console.error('Error> role-detail-ctrl> deleteDataAction()', status, error);
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;
    vm.deleteDetail = deleteDetail;

    // 데이터 조회
    getData();

    }, ]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.system:role-list-ctrl
 * @description
 * # 고객그룹 목록
 * Controller of the 고객그룹 목록
 */

webapp.controller('RoleListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
/**
 * 고객그룹 - 목록화면 Control
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param RoleAPISrv - RoleAPISrv Module
 */
  function RoleListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'Role',
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        CustType : '',
        UseYN : '',
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'Role';
      vm.currentPage = vm.srch.page;
    }

    $scope.selectedRow = $stateParams.RoleId;

    // view 사이즈 목록
    vm.listSize = [ 10, 25, 50, 100 ];


    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.srch.layout);

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.system.role-list', {srch:srch}, {reload:'app.system.role-list'});
    }

    function resetSearch() {
      $state.go('app.system.role-list', {
        srch : ''
      }, {reload: 'app.system.role-list'});
    }

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getList();
    });

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getList() {
      vm.dataloader = true;
      vm.srch.page = vm.currentPage;
      $window.sessionStorage.setItem("role-list-ctrl", angular.toJson(vm.srch));

      getListCount();

      var data = vm.srch;
      data.mapCode = 'Role.getRoleList';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    function getListCount() {
      var data = vm.srch;
      data.mapCode = 'Role.getRoleListCnt';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error-getList', status, data);
      });
    }

    function goEdit(RoleId) {
      var srch = $stateParams.srch;
      $scope.selectedRow = RoleId;

      if (vm.layout == 'N') {
        $state.go('app.system.role-edit', {
          srch : srch,
          RoleId : RoleId,
        });
      } else {
        $state.go('app.system.role-list.edit', {
          srch : srch,
          RoleId : RoleId,
        });
      }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.system.role-list', {srch:srch}, {reload:'app.system.role-list'});
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      console.log('srch :: ch ::',vm.viewSize);
      getSearch();
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.system.role-list', {
        srch : srch
      }, {reload: 'app.system.role-list'});
    }

      // 함수 선언
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.changeViewSize = changeViewSize;
      vm.getSearch = getSearch;
      vm.resetSearch = resetSearch;
      vm.sortClass = sortClass;
      vm.tablesort = tablesort;
      vm.setLayout = setLayout;
      vm.changeLayout = changeLayout;
      vm.goEdit = goEdit;

      // 데이터 조회
      getList();
    }, ]);
})();

webapp.service('RolescreenAPISrv', ['$resource', 'StaticVariable',
  function RolescreenAPISrv($resource, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Rolescreen.getRolescreenList/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/Rolescreen.getRolescreenCount/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Rolescreen.getRolescreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doComboRole: function() {
          return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {},
            StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateList: function() {
        return $resource(StaticVariable.getUrl('/update/Rolescreen.updateRolescreen/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/tenant/insertRolescreen.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Rolescreen.deleteRolescreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

/**
 * @ngdoc function
 * @name
 * @description # 등록/수정 Controller
 * @param {object}
 *          $window - window object
 * @param {object}
 *          $scope - scope object
 * @param {object}
 *          $location - location object
 * @param {object}
 *          $state - state object
 * @param {object}
 *          $stateParams - state Parameter object
 * @param {object}
 *          CONSTANT - 전역 상수
 * @param {object}
 *          StaticVariable - StaticVariable object
 * @param {object}
 *          api - RolescreenApiSvr Module
 * @param {object}
 *          gAlert - Alert Module *
 */
webapp.controller('RolescreenDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RolescreenAPISrv',
    'gAlert', 'gConfirm', function RolescreenDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm) {

      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      vm.onSelectCallback = {
        onSelectComplete : function(data) {
          if (data.CodeType == '130') {
            vm.data.CompanyType = data.Value;
          }
        }
      }

      // 업로드 파일 목록
      vm.uploadFileList = [];

      vm.onFileCallback = {
        onFileUploadComplete : function() {
          console.log('file items::', vm.uploadFileList);
        },
        onFileDelete : function(item) {
          console.log('delete item::', item);
          var param = {
            'fileId' : item.id
          };
          var prms = h0101Api.attachFileDelete().post(param).$promise;
          prms.then(

          function(data) {
            console.log(data);
            if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED');
            }
          });
        }
      }

      vm.stateParams = {
        TenantId : $stateParams.TenantId,
      };

      // 검색 조건
      vm.srch = {
        TenantId : $stateParams.TenantId,
        IdName : 'TenantId',
        TableId : $stateParams.TenantId,
        tableNm : 'Tenant',
        uploadFileList : [],
      };

      // 조회 데이터
      vm.data = {
        TenantId : vm.TenantId,
        IdName : 'TenantId',
        TableId : $stateParams.TenantId,
        tableNm : 'Tenant',
      };

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        if (vm.srch.TenantId === null || vm.srch.TenantId === '') {
          console.log('$rootScope.gVariable', $rootScope.gVariable);
          vm.data.TenantId = $rootScope.gVariable.TenantId;
          vm.data.TenantNm = $rootScope.gVariable.TenantName;
          return;
        }

        var prms = api.doDetail().post(vm.srch).$promise;
        prms.then(function(data) {
          console.log("load", data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].CompanyId !== null) {
              vm.data = data.responseVO.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);

              return;
            }
          }
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        }, function(data) {
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getFileList() {
        vm.srch.tableNm = 'Companys';

        if (vm.srch.CompanyId === null || vm.srch.CompanyId === "0") {
          return;
        }

        var prms = api.doFileList().post(vm.srch).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];

            angular.forEach(data.responseVO.body.docs, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                typeId : 'file',
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
                delState : '',
              }

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        }, function(data) {
          console.error('Error-getFileList', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        // 내용
        vm.data.tableNm = "Tenant";
        vm.data.TableId = vm.data.TenantId;

        var prms = null;

        vm.data['uploadFileList'] = vm.uploadFileList;

        console.log(vm.data);
        if (vm.data.TenantId == 0) {
          // 등록
          prms = api.doInsertDetail().post(vm.data).$promise;
        } else {
          // 수정
          prms = api.doUpdateDetail().post(vm.data).$promise;
        }

        prms.then(function(data) {
          console.log(data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].TenantId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert
              // 시
              // TableId
              // 만
              // 넘어옴
              // KeyId 조회
              vm.data.TenantId = data.responseVO.body.docs[0].TenantId;

              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  if ($stateParams.TenantId === "0") {
                    $state.go("app.system.rolescreen-list");
                  } else {
                    vm.data.TenantId = data.responseVO.body.docs[0].TenantId !== null ? data.responseVO.body.docs[0].TenantId : "0";
                    vm.srch.TenantId = vm.data.TenantId;
                    getFileList();
                  }
                }
              });
              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error-setData', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }
        console.log("vm.uploadFileList", vm.uploadFileList);
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          }
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        console.log("before delete", vm.data);

        var prms = api.doDelete().post(vm.data).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                $state.go("app.system.rolescreen-list")
              }
            });
            return;
          }
        },

        function(data) {
          console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.getFileList = getFileList;
      vm.setData = setData;
      vm.deleteDetail = deleteDetail;

      // 데이터 조회
      getData();
    }, ]);

/**
 * @ngdoc function
 * @name app.bbspost:bbspost-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} api - RolescreenApiSrv Module
 * @param {object} gAlert - Alert Module
 */
webapp.controller('RolescreenEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RolescreenAPISrv',
    'gAlert', 'gConfirm', function RolescreenEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm) {

      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      vm.CompanyTypeData = {
        CodeType : '130',
        TenantId : vm.TenantId,
        Value : ''
      }

      vm.onSelectCallback = {
        onSelectComplete : function(data) {
          console.log('onSelectComplete', data);
          if (data.CodeType == '130') {
            vm.data.CompanyType = data.Value;
          }
        }
      }

      // 업로드 파일 목록
      vm.uploadFileList = [];

      vm.onFileCallback = {
        onFileUploadComplete : function() {
          console.log('file items::', vm.uploadFileList);
        },
        onFileDelete : function(item) {
          console.log('delete item::', item);
          var param = {
            'fileId' : item.id
          };
          var prms = h0101Api.attachFileDelete().post(param).$promise;
          prms.then(

          function(data) {
            console.log(data);
            if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED');
            }
          });
        }
      }

      vm.stateParams = {
        TenantId : $stateParams.TenantId,
      };

      // 검색 조건
      vm.srch = {
        TenantId : $stateParams.TenantId,
        IdName : 'TenantId',
        TableId : $stateParams.TenantId,
        tableNm : 'Tenant',
        uploadFileList : [],
      };

      // 조회 데이터
      vm.data = {
        TenantId : $stateParams.TenantId,
        tableNm : 'Tenant',
        IdName : 'TenantId',
      };

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        if (vm.srch.TenantId === null || vm.srch.TenantId === '') {
          console.log('$rootScope.gVariable', $rootScope.gVariable);
          vm.data.TenantId = $rootScope.gVariable.TenantId;
          vm.data.TenantNm = $rootScope.gVariable.TenantId == '0' ? '' : $rootScope.gVariable.TenantName;
          return;
        }

        var prms = api.doDetail().post(vm.srch).$promise;
        prms.then(function(data) {
          console.log("load", data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docCnt !== 0 && data.responseVO.body.docs[0].TenantId !== null) {
              vm.data = data.responseVO.body.docs[0];

              // 첨부파일 목록 조회
              getFileList();

              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(data) {
          console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getFileList() {
        vm.srch.tableNm = 'Tenant';

        if (vm.srch.TenantId === null || vm.srch.TenantId === "0") {
          return;
        }

        var prms = api.doFileList().post(vm.srch).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];

            angular.forEach(data.responseVO.body.docs, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                typeId : 'file',
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
                delState : '',
              }

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        }, function(data) {
          console.error('Error-getFileList', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.TableId = vm.data.TenantId;
        vm.data.tableNm = 'Tenant';
        vm.data.IdName = 'TenantId';

        var prms = null;

        vm.data['uploadFileList'] = vm.uploadFileList;

        console.log(vm.data);
        if (vm.data.TenantId == 0) {
          // 등록
          prms = api.doInsertDetail().post(vm.data).$promise;
        } else {
          // 수정
          prms = api.doUpdateDetail().post(vm.data).$promise;
        }

        prms.then(function(data) {
          console.log(data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].CompanyId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert시 TableId 만 넘어옴
              // KeyId 조회
              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  vm.data.TenantId = data.responseVO.body.docs[0].TenantId != null ? data.responseVO.body.docs[0].TenantId : data.responseVO.body.docs[0].TableId;
                  $state.go("app.system.rolescreen-detail", {
                    TenantId : vm.data.TenantId
                  });
                }
              });
              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error-setData', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.getFileList = getFileList;
      vm.setData = setData;

      // 데이터 조회
      getData();
    }, ]);

/**
 * @ngdoc function
 * @name app.bbspost:bbspost-list-ctrl
 * @description # 목록 Controller of the 사용자정의 필드 게시판
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param api -  RolescreenAPISrv Module
 */
webapp.controller('RolescreenListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi','gAlert','LoginAPISrv','Auth',
  function RolescreenListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, loginApi, Auth) {
    // View Model
    var vm = this;

    vm.TenantId = $window.sessionStorage['loginTenantId'];

    // 검색 조건
    if ($stateParams.srch == '' || $stateParams.srch == undefined) {
      vm.srch = {
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        mobile : 'N'
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'rolescrean';
      vm.currentPage = vm.srch.page;
    }

    if ($stateParams.mobile) {
      vm.srch.mobile = $stateParams.mobile;
    }

    vm.data = {
      ActionId: vm.srch.ActionId,
    };

    vm.checkAllBtn = {ViewYN:'N', Btn01YN:'N', Btn02YN:'N', Btn03YN:'N', Btn04YN:'N', Btn05YN:'N', Btn06YN:'N'};

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      vm.srch.ScreenNm = '';
      vm.srch.PageUrl = '';
      vm.srch.role = '';
      getList();
      getRoleList();
    });

    /**
     * 데이터 조회
     *
     * @param
     * @return
     */
    function getList() {
      vm.srch.page = vm.currentPage;

      getListCnt();

      var data = vm.srch;
      console.log(vm.srch);
      data.mapCode = 'Rolescreen.getRolescreenList';
      // 내용
      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.lists = result.body.docs;
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
        fnCloseLayer();
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getListCnt() {
      var data = vm.srch;
      data.mapCode = 'Rolescreen.getRolescreenCount';
      // 내용
      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs[0];
          }
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getRoleList() {
      var data = vm.srch;
      data.mapCode = 'Role.getRoleList';
      // 내용
      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.roleList = result.body.docs;
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function saveList() {
      vm.dataloader = true;
      vm.data.upList = vm.lists;
      vm.data.mapCode = 'Rolescreen.updateRolescreen';
      // 내용
      postApi.update(vm.data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn: '확인',
            fn: function () {
              $state.go("app.system.rolescreen-list");
            }
          });
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function checkBtn(BtnYN) {
      angular.forEach(vm.lists, function(item) {
        item[BtnYN] = vm.checkAllBtn[BtnYN];
      });
    }

    function doCheckSession() {
      var prms = loginApi.doCheckSession().post().$promise;

      prms.then(function (json) {
        if (json.responseVO.header.status == CONSTANT.HttpStatus.OK && json.responseVO.body.docs != null && json.responseVO.body.docs != '') {

          $rootScope.setUserSession(json.responseVO.body.docs[0]);

          Auth.init(json.responseVO.body.docs[0].permissions);

          vm.userNm = $window.sessionStorage['loginUserName'];
          vm.userGbn = $window.sessionStorage['loginUserGbn'];
          vm.userTerm = $window.sessionStorage['loginUserTerm'];

        } else {
          StaticVariable.sessionExpire();
        }
      }, function (error) {
        console.table(error);
      });
    }

    /**
      * 데이터 조회
      * @param
      * @return
    */
    function getSearch() {
      vm.srch.mobile = null;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.system.rolescreen-list', {mobile:$stateParams.mobile, srch:srch}, {reload:'app.system.rolescreen-list'});
    }

    function resetSearch() {
      $state.go('app.system.rolescreen-list', {
        srch : ''
      }, {reload: 'app.system.rolescreen-list'});
    }

    // 함수 선언
    vm.getList = getList;
    vm.getRoleList = getRoleList;
    vm.saveList = saveList;
    vm.checkBtn = checkBtn;
    vm.getSearch = getSearch;
    vm.resetSearch = resetSearch;

    // 데이터 조회
    getList();
    getRoleList();
  }, ]);

webapp.service('ScreenAPISrv', ['$resource', 'StaticVariable',
  function ScreenAPISrv($resource, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Screen.getScreenList/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/Screen.getScreenCount/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Screen.getScreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doComboRole: function() {
          return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {},
            StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/Screen.updateScreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/Screen.insertScreen/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Screen.deleteScreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doCallProcRolescreen: function() {
    	  return $resource(StaticVariable.getUrl('/select/Rolescreen.callProcRolescreen/action.json'), {},
    			  StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

/**
 * @ngdoc function
 * @name
 * @description # 등록/수정 Controller
 * @param {object}
 *          $window - window object
 * @param {object}
 *          $scope - scope object
 * @param {object}
 *          $location - location object
 * @param {object}
 *          $state - state object
 * @param {object}
 *          $stateParams - state Parameter object
 * @param {object}
 *          CONSTANT - 전역 상수
 * @param {object}
 *          StaticVariable - StaticVariable object
 * @param {object}
 *          api - ScreenApiSvr Module
 * @param {object}
 *          gAlert - Alert Module *
 */
webapp.controller('ScreenDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'ScreenAPISrv',
    'gAlert', 'gConfirm', function ScreenDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm) {

      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      // 검색 조건
      vm.srch = {
        ScreenId : $stateParams.ScreenId,
        IdName : 'ScreenId',
        TableId : $stateParams.ScreenId,
        tableNm : 'Screen',
      };

      // 조회 데이터
      vm.data = {
        ScreenId : $stateParams.ScreenId,
        IdName : 'ScreenId',
        TableId : $stateParams.ScreenId,
        tableNm : 'Screen',
      };

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        var prms = api.doDetail().post(vm.srch).$promise;
        prms.then(function(data) {
          console.log("load", data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].ScreenId !== null) {
              vm.data = data.responseVO.body.docs[0];
              return;
            }
          }
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        }, function(data) {
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        // 내용
        vm.data.tableNm = "Screen";
        vm.data.TableId = vm.data.ScreenId;

        var prms = null;

        console.log(vm.data);
        if (vm.data.ScreenId == 0) {
          // 등록
          prms = api.doInsertDetail().post(vm.data).$promise;
        } else {
          // 수정
          prms = api.doUpdateDetail().post(vm.data).$promise;
        }

        prms.then(function(data) {
          console.log(data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].TenantId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert
              // 시
              // TableId
              // 만
              // 넘어옴
              // KeyId 조회
              vm.data.ScreenId = data.responseVO.body.docs[0].ScreenId;

              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  if ($stateParams.ScreenId === "0") {
                    $state.go("app.system.screen-list");
                  } else {
                    vm.data.ScreenId = data.responseVO.body.docs[0].ScreenId !== null ? data.responseVO.body.docs[0].ScreenId : "0";
                    vm.srch.ScreenId = vm.data.ScreenId;
                  }
                }
              });
              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error-setData', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }
        console.log("before delete", vm.data);

        var prms = api.doDelete().post(vm.data).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                $state.go("app.system.screen-list")
              }
            });
            return;
          }
        },

        function(data) {
          console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.setData = setData;
      vm.deleteDetail = deleteDetail;

      // 데이터 조회
      getData();
    }, ]);

/**
 * @ngdoc function
 * @name app.system:screen-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - Alert Module
 */
webapp.controller('ScreenEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', function ScreenEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, postApi, gAlert, gConfirm) {
      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      // 검색 조건
      vm.srch = {
        ScreenId : $stateParams.ScreenId,
        IdName : 'ScreenId',
        TableId : $stateParams.ScreenId,
        tableNm : 'screen',
        uploadFileList : [],
      };

      // 조회 데이터
      vm.data = {
        ScreenId : $stateParams.ScreenId,
        tableNm : 'screen',
        IdName : 'ScreenId',
      };

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        var data = vm.srch;
        data.mapCode = 'Screen.getScreenDetail';
        vm.dataloader = true;
        // 내용
        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
            }
          } else {
            console.log(result.body);
            gAlert('', result.body.docs[0].errMessage);
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error-getList', error);
          vm.dataloader = false;
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        var data = vm.data;
        data.tableNm = vm.srch.tableNm;
        data.TableId = vm.data.ScreenId;
        vm.dataloader = true;
        if (data.ScreenId == null || data.ScreenId == '') {
          // 등록
          data.mapcode = "Screen.insertScreen";
          postApi.insert(data, function(result) {
            vm.dataloader = false;
            InsertUpdateDetail(result);
          },function(error) {
            vm.dataloader = false;
            console.table(error);
          });
        } else {
          // 수정
          data.mapCode = "Screen.updateScreenDetail";
          postApi.update(data, function(result){
            vm.dataloader = false;
            InsertUpdateDetail(result);
          },function(error) {
            vm.dataloader = false;
            console.table(error);
          });
        }
      }

      function InsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs[0].ScreenId !== null || result.body.docs[0].TableId !== null) {
            // KeyId 조회
            vm.data.ScreenId = result.body.docs[0].ScreenId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function() {
                var srch = $stateParams.srch;

                if (vm.layout == 'N') {
                  if (vm.srch.ScreenId == null || vm.srch.ScreenId == '') {
                    $state.go("app.system.screen-list", { srch: srch });
                  } else {
                    // 조회 화면 이동
                    $state.go("app.system.screen-edit", {
                      srch: srch,
                      ScreenId: vm.data.ScreenId
                    });
                  }
                } else {
                  var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
                  srch2.ScreenId = "";
                  srch2.reload = (new Date()).getTime();
                  srch = encodeURIComponent(JSON.stringify(srch2, replacer));

                  $state.go("app.system.screen-list.edit", { srch: srch, ScreenId:vm.data.ScreenId });
                }
              }
            });
            return;
          }
        }
        console.table(result);
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        vm.dataloader = true;
        vm.data.mapcode = "Screen.deleteScreenDetail";
        postApi.update(vm.data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                if (vm.layout == 'N') {
                  vm.srch.ScreenId = "";
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  $state.go("app.system.screen-list", { srch: srch });
                } else {
                  vm.srch.ScreenId = "";
                  vm.srch.reload = (new Date()).getTime();
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  $state.go("app.system.screen-list.edit", { srch: srch, ScreenId:''});
                }
              }
            });
          }
        },function(error) {
          vm.dataloader = false;
          console.table(error);
        });
      }

      function goList() {
        vm.srch.ScreenId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go("app.system.screen-list", { srch: srch });
      }

      // 함수 선언
      vm.getData = getData;
      vm.setData = setData;
      vm.goList = goList;
      vm.deleteDetail = deleteDetail;

      // 데이터 조회
      getData();
    }, ]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost:bbspost-list-ctrl
 * @description # 목록 Controller of the 사용자정의 필드 게시판
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param api -  ScreenAPISrv Module
 */
webapp.controller('ScreenListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm',
  function ScreenListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, gConfirm) {
    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    if ($stateParams.srch == '') {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'screen',
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        sortDirect : '',
        sortColumn : ''
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'screen';
      vm.currentPage = vm.srch.page;
    }

    $scope.selectedRow = $stateParams.ScreenId;

    vm.listSize = [ 10, 25, 50, 100 ];

    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.srch.layout);

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.system.screen-list', {srch:srch}, {reload:'app.system.screen-list'});
    }

    function resetSearch() {
      $state.go('app.system.screen-list', {
        srch : ''
      }, {reload: 'app.system.screen-list'});
    }

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getList();
    });

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      vm.viewSize = vm.srch.viewSize;

      vm.dataloader = true;
      getListCnt();

      var data = vm.srch;
      data.mapCode = 'Screen.getScreenList';

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getListCnt() {
      var data = vm.srch;
      data.mapCode = 'Screen.getScreenListCnt';

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs[0].totalItems;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function goDetail(ScreenId) {
      var srch = $stateParams.srch;

      if (vm.layout == 'N') {
        $state.go('app.system.screen-detail', {
          srch : srch,
          ScreenId : ScreenId,
        });
      } else {
        $state.go('app.system.screen-list.detail', {
          srch : srch,
          ScreenId : ScreenId,
        });
      }
    }

    function goEdit(ScreenId) {
      var srch = $stateParams.srch;
      $scope.selectedRow = ScreenId;

      if (vm.layout == 'N') {
        $state.go('app.system.screen-edit', {
          srch : srch,
          ScreenId : ScreenId
        });
      } else {
        $state.go('app.system.screen-list.edit', {
          srch : srch,
          ScreenId : ScreenId
        });
      }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getSearch();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.system.screen-list', {
        srch : srch
      }, {reload: 'app.system.screen-list'});
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.resetSearch = resetSearch;
    vm.sortClass = sortClass;
    vm.tablesort = tablesort;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;

    // 데이터 조회
    getList();
  }, ]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $stateParams - state Parameter object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('SeminarEditCtrl', ['$window', '$rootScope', '$stateParams', '$state',
    function SeminarEditCtrl($window, $rootScope, $stateParams, $state) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.seminar-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.seminar-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.seminar-edit';           // 수정 화면

      // View Model
      var vm = this;          // View Model

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.url = $state.current.url;

      function setChangeTab(tabId) {
        var viewPageUrl = '';

        if (vm.layout == 'N') {
          viewPageUrl = VIEW_PAGE_URL + '.' + tabId;
          // 수정
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
        } else {
          viewPageUrl = LIST_VIEW_PAGE_URL + '.' + tabId;
          // 목록.수정 화면 이동
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
        }
      }

      // 함수 정의
      vm.setChangeTab = setChangeTab;
    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:seminar-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('SeminarEditTab1Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function SeminarEditTab1Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout,  $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Seminar.insertSeminar';     // 등록 SQL
      var UPDATE_SQL = 'Seminar.updateSeminar';     // 수정 SQL
      var VIEW_SQL = 'Seminar.getSeminarDetail'; // 조회 SQL
      var DEL_SQL = 'Seminar.deleteSeminarDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.seminar-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.seminar-list.edit.tab1'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.seminar-edit.tab1';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'seminaradminlist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      // #region 부서 검색 팝업 호출

      /**
       * 부서 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};
        var modalInstance = modalFactory.open("modal", "components/modal/department/dept-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            // 부서 선택
            vm.data.DeptNm = okData.label;
            vm.data.DeptId = okData.data;
          },
          function (cancelData) {
            // 취소
          }
        );
      };

      /**
       * 부서 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseDept = function () {
        vm.data.DeptNm = "";
        vm.data.DeptId = "";
      };
      // #endregrion 부서 검색 팝업 호출

      // #region 회원사 검색 팝업 호출

      /**
       * 회원사 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchTenantModal = function () {
        var ctrl = 'TenantModalCtrl as vc';
        var paramData = {TenantId: vm.data.TenantId};
        var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          vm.data.TenantNm = okData.TenantNm;
          vm.data.TenantId = okData.TenantId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 회원사 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseTenant = function () {
        if (vm.TenantId != '0') {
          return;
        }
        vm.data.TenantNm = "";
        vm.data.TenantId = "";
      };
      // #endregion 회원사 검색 팝업 호출

      // #region 역할 검색 팝업 호출

      /**
       * 역할 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserroleModal = function () {
        var ctrl = 'UserroleModalCtrl as vc';
        var paramData = {
          TenantId: vm.srch.TenantId,
          UserRoles: vm.data.UserRoles
        };

        var modalInstance = modalFactory.open('modal', 'components/modal/userRole/userrole-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 역할 선택
          vm.data.UserRoles = okData;
          var UserRoleNms = [];
          var UserRoleIds = [];
          angular.forEach(vm.data.UserRoles, function (role) {
            UserRoleNms.push(role.RoleNm);
            UserRoleIds.push(role.RoleId);
          });

          vm.data.UserRoleNms = UserRoleNms.join(',');
          vm.data.UserRoleIds = UserRoleIds.join(',');

        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 역할 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUserRole = function () {
        vm.data.UserRoleIds = "";
        vm.data.UserRoleNms = "";
      };

      // #endregion 역할 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';


              // 역할 설정
              vm.data.UserRoles = [];
              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });
              //Date형식 처리

              if (!isNullOrEmpty(vm.data.SeminarStartDt)) vm.SeminarStartDt = moment(vm.data.SeminarStartDt).toDate();
              if (!isNullOrEmpty(vm.data.SeminarEndDt)) vm.SeminarEndDt = moment(vm.data.SeminarEndDt).toDate();
              if (!isNullOrEmpty(vm.data.ApplStartDt)) vm.ApplStartDt = moment(vm.data.ApplStartDt).toDate();
              if (!isNullOrEmpty(vm.data.ApplEndDt)) vm.ApplEndDt = moment(vm.data.ApplEndDt).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {
              vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.SeminarNm)) {
          errMsg = errMsg + '- 제목을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.SeminarType)) {
          errMsg = errMsg + '- 구분을 선택하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.SeminarStartDt) || isNullOrEmpty(vm.data.SeminarEndDt)) {
          errMsg = errMsg + '- 세미나 기간을 선택하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ApplStartDt) || isNullOrEmpty(vm.data.ApplEndDt)) {
          errMsg = errMsg + '- 신청 기간을 선택하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 비밀번호 체크
       *
       * @param
       * @return
       */
      function getIsValidPassword() {
        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
        var birthDay = moment(vm.data.BirthDay).format('MMDD');
        var birthDay2 = moment(vm.data.BirthDay).format('YYMMDD');

        if(!reg.test(vm.data.Password)) return false;
        if(vm.data.Password.indexOf(birthDay) > -1) return false;
        if(vm.data.Password.indexOf(birthDay2) > -1) return false;
        if(vm.data.Password.length < 8) return false;

        return true;

      }
      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        //Editor
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.Contents = $("#strHtml").val();

        vm.data.SeminarStartDt = moment(vm.SeminarStartDt).format('YYYY-MM-DD');
        vm.data.SeminarEndDt = moment(vm.SeminarEndDt).format('YYYY-MM-DD');
        vm.data.ApplStartDt = moment(vm.ApplStartDt).format('YYYY-MM-DD');
        vm.data.ApplEndDt = moment(vm.ApplEndDt).format('YYYY-MM-DD');

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }


      /**
       * 사용자 중복 체크
       *
       * @param
       * @return
       */
      function getIsDupLoginId() {
        var data = vm.data;

        if (isNullOrEmpty(vm.data.LoginId)) {
          return;
        }

        vm.data.checkedLoginId = "";

        if (!getIsValidId()) {
          gAlert('', '사용할 수 없는 아이디 입니다.');
          return;
        }

        data.mapCode = GETID_SQL;

        postApi.login(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.checkedLoginId = vm.data.LoginId;
            gAlert('', '사용가능한 아이디 입니다.');
          } else {
            gAlert('', result.body.docs[0].errMessage);
            vm.data.checkedLoginId = "";
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      }

      /**
       * 아이디 유효성 검사
       * (영문 소문자, 숫자, 특수문자 -_)
       *
       * @param
       * @return
       */
      function getIsValidId() {
        var regExp = /^[a-z0-9\-_]{5,25}$/;
        if (!regExp.test(vm.data.LoginId)) return false;
        //if (vm.data.LoginId.search(/\s/) != -1) return false;

        return true;
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      function setChangeTab(tabId) {
        vm.tabId = tabId;
        goNextPage(false);
      }

      /**
       * 제품 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchSurveyModal = function () {
        var ctrl = 'SurveyModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/survey/survey-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.SvyNm = res.SvyNm;
          vm.data.SvyId = res.KeyId;

        }, function(cancelData) {
        });
      }
      /**
       * 제품 초기화
       *
       * @param
       * @return
       */
      vm.eraseSurvey = function () {
        vm.data.SvyId = '';
        vm.data.SvyNm = '';
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      vm.getRoleList = getRoleList;             // 역할 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.getIsDupLoginId = getIsDupLoginId;         // 사용자 중복 체크
      vm.setDelData = setDelData;                     // 데이터 삭제

      vm.setChangeTab = setChangeTab;

      // 데이터 조회
      getData();

    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:seminar-edit-tab2-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 세미나이력 목록
   */
  webapp.controller('SeminarEditTab2Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function SeminarEditTab2Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Seminar.getSeminarHistListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Seminar.getSeminarHistList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Seminar.getSeminarHistExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Seminar.deleteSeminarHistList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.seminar-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.seminar-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.seminar-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.seminar-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.seminar-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'seminarattend'; // 작업 테이블명
      var KEY_COLUMN_NM = 'keyId'; // Primary Key Column
      var EXCEL_TITLE = '세미나 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.EntryDtFrom = $rootScope.getDateFormat(vm.srch.EntryDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.EntryDtTo = $rootScope.getDateFormat(vm.srch.EntryDtTo);
        vm.currentPage = vm.srch.page;
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.keyId = $stateParams.keyId;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'PurchDate') {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  if(!isNullOrEmpty(item.ColumnPhysicalAsNm)){
                    obj.push(value[item.ColumnPhysicalAsNm]);
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:seminar-edit-tab3-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 세미나이력 목록
   */
  webapp.controller('SeminarEditTab3Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function SeminarEditTab3Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var RSPCNTCHT_SQL = 'Survey.getSurveyresphistCntCht';    // 차트용 문제항목 총 응답수
      var QSTLISTCHT_SQL = 'Survey.getSurveyqstListCht';    // 차트용 문제 목록
      var RSPLISTCHT_SQL = 'Survey.getSurveyresphistListCht';    // 차트용 문제항목 답변수 목록
      var VIEW_SQL = 'Seminar.getSeminarDetail'; // 조회 SQL
      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.seminar-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.seminar-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.seminar-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.seminar-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.seminar-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'seminarattend'; // 작업 테이블명
      var KEY_COLUMN_NM = 'keyId'; // Primary Key Column
      var EXCEL_TITLE = '세미나 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.EntryDtFrom = $rootScope.getDateFormat(vm.srch.EntryDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.EntryDtTo = $rootScope.getDateFormat(vm.srch.EntryDtTo);
        vm.currentPage = vm.srch.page;
      }

      vm.srch.keyId = $stateParams.keyId;

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 차트용 총 응답수
       */
      function getRstCntCht() {
        var data = vm.srch;
        data.mapCode = RSPCNTCHT_SQL;

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.RstCnt = result.body.docs[0].RstCnt;
          }
        }, function (error) {
          console.error("Error> getRstCntCht()");
          console.table(error);
        });
      }

      /**
       * 차트용 문제 목록 조회
       */
      function getQstListCht() {
        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = QSTLISTCHT_SQL;

        vm.RstCnt = 0;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.qstChtLists = result.body.docs;
              vm.qstChtTotalItems = vm.qstChtLists.length;

              if (!isNullOrEmpty(vm.qstChtLists)) {8
                vm.chtInfo = {};
                vm.rstChtLists = {};
                getRstCntCht();
                getRstListCht(0);
              }
            } else {
              // 데이터 조회 실패
              vm.qstChtLists = {};
              vm.qstChtTotalItems = 0;
            }
          }
        }, function (error) {
          console.error("Error> getQstListCht()");
          console.table(error);
        });
      }

      /**
       * 차트용 문제항목 결과 목록
       */
      function getRstListCht(idx) {
        var data = vm.srch;
        data.mapCode = RSPLISTCHT_SQL;
        data.keyId2 = vm.qstChtLists[idx].KeyId2;

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.rstChtLists[idx] = result.body.docs;
            setChtInfo(idx);

            idx++;
            if (vm.qstChtLists.length > idx) {
              getRstListCht(idx);
            }
            else {
            }
          }
        }, function (error) {
          console.error("Error> getRstListCht()");
          console.table(error);
        });
      }

      /**
       * 차트 설정
       */
      function setChtInfo(idx) {
        vm.chtInfo[idx] = {};

        vm.chtInfo[idx].colors = ['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'];
        vm.chtInfo[idx].datasetOverride = [
          {
            label: "",
            backgroundColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
            borderColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
            borderWidth: 2,
            type: 'bar',
            yAxisID: 'y-axis-1',
          }
        ];

        vm.chtInfo[idx].options = {
          scales: {
            yAxes: [{
              id: 'y-axis-1',
              type: 'linear',
              display: true,
              position: 'left',
              ticks: {
                beginAtZero: true,
                ShowGridLines : true
              }
            }]
          },
          legend: {
            display : false,
            position : 'bottom'
          },
          tooltips: {
            callbacks : {
              label : function(tooltipItem, data) {
                return tooltipItem.yLabel;
              }
            }
          }
        };

        vm.chtInfo[idx].options.scales.yAxes[0].ticks.max = 0;

        vm.chtInfo[idx].data = new Array(new Array(1));
        vm.chtInfo[idx].labels = [];

        angular.forEach(vm.rstChtLists[idx], function(item, index) {
          vm.chtInfo[idx].labels[index] = item.QstItemContents;
          vm.chtInfo[idx].data[0][index] = item.RespCnt;
        });

        angular.forEach(vm.chtInfo[idx].data[0], function(item,index){
          if (vm.chtInfo[idx].options.scales.yAxes[0].ticks.max < vm.chtInfo[idx].data[0][index] + 5) {
            vm.chtInfo[idx].options.scales.yAxes[0].ticks.max = vm.chtInfo[idx].data[0][index] + 5;
          }
        });

      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {

        var data = vm.srch;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.srch.keyId = result.body.docs[0].SvyId;
              getQstListCht();

            }
          } else {

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }


      // 함수 정의

      // 함수 호출
      getData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('SeminarListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function SeminarListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Seminar.getSeminarAdminListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Seminar.getSeminarAdminList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Seminar.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Seminar.deleteSeminarList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.seminar-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.seminar-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.seminar-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.seminar-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.seminar-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'seminaradminlist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'keyId'; // Primary Key Column
      var EXCEL_TITLE = '세미나 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.EntryDtFrom = $rootScope.getDateFormat(vm.srch.EntryDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.EntryDtTo = $rootScope.getDateFormat(vm.srch.EntryDtTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'PurchDate') {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  if(!isNullOrEmpty(item.ColumnPhysicalAsNm)){
                    obj.push(value[item.ColumnPhysicalAsNm]);
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('SurveyEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function SurveyEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Survey.insertSurvey';     // 등록 SQL
      var UPDATE_SQL = 'Survey.updateSurvey';     // 수정 SQL
      var VIEW_SQL = 'Survey.getSurveyDetail'; // 조회 SQL
      var DEL_SQL = 'Survey.deleteSurveyDetail';  // 삭제 SQL

      var QSTLIST_SQL = 'Survey.getSurveyqstList';    // 문제 목록 조회 SQL
      var DELETE_QSTLIST_SQL = 'Survey.deleteSurveyqstList'; // 문제 목록에서 삭제

      var TGTLIST_SQL = 'Survey.getSurveytargetList';    // 테스트대상자 목록 조회 SQL
      var DELETE_TGTLIST_SQL = 'Survey.deleteSurveytargetList'; // 테스트대상자 목록에서 삭제

      var RSPCNTCHT_SQL = 'Survey.getSurveyresphistCntCht';    // 차트용 문제항목 총 응답수
      var QSTLISTCHT_SQL = 'Survey.getSurveyqstListCht';    // 차트용 문제 목록
      var RSPLISTCHT_SQL = 'Survey.getSurveyresphistListCht';    // 차트용 문제항목 답변수 목록

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.survey-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.survey-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.survey-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'survey'; // 작업 테이블명
      var KEY_COLUMN_NM = 'SvyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      //vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        keyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        keyId2: 0,
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      /**
       * 본사 여부
       * @param
       * @return
       */
      vm.isMaster = function () {
        if ($rootScope.gVariable.srchTenantId == 0) return true;
        else return false;
      };

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback

      /**
       * 문제 추가 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.addQstModal = function (qstType, keyId2) {
        var ctrl = 'QstModalCtrl as vc';
        var paramData = {keyId: vm.data.keyId, keyId2: keyId2, qstType: qstType};
        var modalInstance = modalFactory.open('modal', 'components/modal/survey/qst-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          //vm.data.TenantNm = okData.TenantNm;
          //vm.data.TenantId = okData.TenantId;
        }, function (cancelData) {
          // 취소
          getQstList();
        });
      };

      /**
       * 테스트대상자 추가 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.addTgtModal = function (tgtType) {
        var ctrl = 'TgtModalCtrl as vc';
        var paramData = {keyId: vm.data.keyId, tgtType: tgtType};
        var modalInstance = modalFactory.open('modal', 'components/modal/survey/tgt-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getTgtList();
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 미리보기 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.preModal = function () {
        var ctrl = 'PreModalCtrl as vc';
        var paramData = {keyId: vm.data.keyId};
        var modalInstance = modalFactory.open('modal', 'components/modal/survey/pre-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          //vm.data.TenantNm = okData.TenantNm;
          //vm.data.TenantId = okData.TenantId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 초기 세팅
       * @param
       * @return
       */
      function init(){

        // 문제 목록 체크박스 설정
        vm.qstChkHead = false;
        $scope.qstChkRowChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            if (!vm.qstLists[i].isChecked) {
              vm.qstChkHead = false;
              return;
            }
          }
          vm.qstChkHead = true;
        };

        $scope.qstChkHeadChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            vm.qstLists[i].qstChkRow = vm.qstChkHead;
          }
        };

        // 테스트대상자 목록 체크박스 설정
        vm.tgtChkHead = false;
        $scope.tgtChkRowChg = function () {
          for (var i = 0; i < vm.tgtLists.length; i++) {
            if (!vm.tgtLists[i].isChecked) {
              vm.tgtChkHead = false;
              return;
            }
          }
          vm.tgtChkHead = true;
        };

        $scope.tgtChkHeadChg = function () {
          for (var i = 0; i < vm.tgtLists.length; i++) {
            vm.tgtLists[i].tgtChkRow = vm.tgtChkHead;
          }
        };
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        /*
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);
        */

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              // 역할 설정
              /*
              vm.data.UserRoles = [];

              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });
              */

              //Date형식 처리
              /*
              if (vm.data.BirthDay != null && vm.data.BirthDay != "") vm.BirthDay = moment(vm.data.BirthDay).toDate();
              if (vm.data.EntryDt != null && vm.data.EntryDt != "") vm.EntryDt = moment(vm.data.EntryDt).toDate();
              if (vm.data.RetireDt != null && vm.data.RetireDt != "") vm.RetireDt = moment(vm.data.RetireDt).toDate();
              */

              // 첨부파일 목록 설정
              /*
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
              */
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';
        if (isNullOrEmpty(vm.data.SvyNm)) {
          errMsg = errMsg + '- 제목을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.SvyType)) {
          errMsg = errMsg + '- 구분을 선택하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Remark)) {
          errMsg = errMsg + '- 비고를 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      /*
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }
      */

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (getIsValidData() == false) {
          return;
        }

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        /*
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        */

        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        /*
        vm.data.BirthDay = moment(vm.data.BirthDay).format('YYYY-MM-DD');
        vm.data.EntryDt = moment(vm.data.EntryDt).format('YYYY-MM-DD');
        vm.data.RetireDt = moment(vm.data.RetireDt).format('YYYY-MM-DD');
        */

        var data = vm.data; // 사용자 입력 데이터
        if (vm.data.JoinShowYN != "Y") vm.data.JoinShowYN = "N";

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            /*
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
            */
            !isNullOrEmpty(result.body.docs[0].RelateDataId)
          ) {
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            vm.data.KeyId = result.body.docs[0].RelateDataId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId,
              tabId: vm.tabId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        /*
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;
        */

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }

      /**
       * 테스트대상자 목록 조회
       *
       * @param
       * @return
       */
      function getQstList() {
        vm.dataloader = true; // Progressbar 표시

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = QSTLIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            //console.log("re", result);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.qstLists = result.body.docs;
              vm.qstTotalItems = vm.qstLists.length;
            } else {
              // 데이터 조회 실패
              vm.qstLists = {};
              vm.qstTotalItems = 0;
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getQstList()");
          console.table(error);
        });
      }

      // 문제 목록 삭제
      function deleteQstList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteQstListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteQstListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.qstLists.length; i++) {
          if (vm.qstLists[i].qstChkRow)
          {
            vm.srch.KeyIdList.push(vm.qstLists[i].KeyId2);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_QSTLIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getQstList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteQstListAction()");
          console.table(error);
        });
      }

      /**
       * 테스트대상자 목록 조회
       *
       * @param
       * @return
       */
      function getTgtList() {
        vm.dataloader = true; // Progressbar 표시

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = TGTLIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            //console.log("re", result);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.tgtLists = result.body.docs;
              vm.tgtTotalItems = vm.tgtLists.length;
            } else {
              // 데이터 조회 실패
              vm.tgtLists = {};
              vm.tgtTotalItems = 0;
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getTgtList()");
          console.table(error);
        });
      }

      /**
       * 테스트대상자 목록 삭제
       * @param
       * @return
       */
      function deleteTgtList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteTgtListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteTgtListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.tgtLists.length; i++) {
          if (vm.tgtLists[i].tgtChkRow)
          {
            vm.srch.KeyIdList.push(vm.tgtLists[i].KeyId4);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_TGTLIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getTgtList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteTgtListAction()");
          console.table(error);
        });
      }

      /**
       * 차트용 총 응답수
       */
      function getRstCntCht() {
        var data = vm.srch;
        data.mapCode = RSPCNTCHT_SQL;

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.RstCnt = result.body.docs[0].RstCnt;
          }
        }, function (error) {
          console.error("Error> getRstCntCht()");
          console.table(error);
        });
      }

      /**
       * 차트용 문제 목록 조회
       */
      function getQstListCht() {
        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = QSTLISTCHT_SQL;

        vm.RstCnt = 0;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            //console.log("re", result);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.qstChtLists = result.body.docs;
              vm.qstChtTotalItems = vm.qstChtLists.length;

              if (!isNullOrEmpty(vm.qstChtLists)) {8
                vm.chtInfo = {};
                vm.rstChtLists = {};
                getRstCntCht();
                getRstListCht(0);
              }
            } else {
              // 데이터 조회 실패
              vm.qstChtLists = {};
              vm.qstChtTotalItems = 0;
            }
          }
        }, function (error) {
          console.error("Error> getQstListCht()");
          console.table(error);
        });
      }

      /**
       * 차트용 문제항목 결과 목록
       */
      function getRstListCht(idx) {
        var data = vm.srch;
        data.mapCode = RSPLISTCHT_SQL;
        data.keyId2 = vm.qstChtLists[idx].KeyId2;

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.rstChtLists[idx] = result.body.docs;
            setChtInfo(idx);

            idx++;
            if (vm.qstChtLists.length > idx) {
              getRstListCht(idx);
            }
            else {
            }
          }
        }, function (error) {
          console.error("Error> getRstListCht()");
          console.table(error);
        });
      }

      /**
       * 차트 설정
       */
      function setChtInfo(idx) {
        vm.chtInfo[idx] = {};

        vm.chtInfo[idx].colors = ['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'];
        vm.chtInfo[idx].datasetOverride = [
          {
            label: "",
            backgroundColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
            borderColor:['#47a4f1','#47a4f1','#47a4f1','#47a4f1','#47a4f1'],
            borderWidth: 2,
            type: 'bar',
            yAxisID: 'y-axis-1',
          }
        ];

        vm.chtInfo[idx].options = {
          scales: {
            yAxes: [{
              id: 'y-axis-1',
              type: 'linear',
              display: true,
              position: 'left',
              ticks: {
                beginAtZero: true,
                ShowGridLines : true
              }
            }]
          },
          legend: {
            display : false,
            position : 'bottom'
          },
          tooltips: {
            callbacks : {
              label : function(tooltipItem, data) {
                return tooltipItem.yLabel;
              }
            }
          }
        };

        vm.chtInfo[idx].options.scales.yAxes[0].ticks.max = 0;

        vm.chtInfo[idx].data = new Array(new Array(1));
        vm.chtInfo[idx].labels = [];

        angular.forEach(vm.rstChtLists[idx], function(item, index) {
          vm.chtInfo[idx].labels[index] = item.QstItemContents;
          vm.chtInfo[idx].data[0][index] = item.RespCnt;
        });

        angular.forEach(vm.chtInfo[idx].data[0], function(item,index){
          if (vm.chtInfo[idx].options.scales.yAxes[0].ticks.max < vm.chtInfo[idx].data[0][index] + 5) {
            vm.chtInfo[idx].options.scales.yAxes[0].ticks.max = vm.chtInfo[idx].data[0][index] + 5;
          }
        });

        //console.log("chtInfo" + idx, vm.chtInfo[idx]);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      vm.setChangeTab = setChangeTab;
      vm.deleteQstList = deleteQstList;
      vm.deleteTgtList = deleteTgtList;

      // 데이터 조회
      getData();
      getQstList();
      getQstListCht();
      getTgtList();
      init();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('SurveyListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function SurveyListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Survey.getSurveyListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Survey.getSurveyList';    // 목록 조회 SQL
      var EXCEL_SQL = 'Survey.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Survey.deleteSurveyList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.survey-list';         // 목록 화면
      //var LIST_DETAIL_PAGE_URL = 'app.system.survey-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.survey-list.edit';    // 목록 등록/수정 화면
      //var VIEW_PAGE_URL = 'app.system.survey-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.survey-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'survey'; // 작업 테이블명
      var KEY_COLUMN_NM = 'SvyId'; // Primary Key Column
      var EXCEL_TITLE = '설문 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 추가 변수
      vm.keyId = 0;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = [10, 25, 50, 100]; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 본사 여부
       * @param
       * @return
       */
      vm.isMaster = function () {
        if ($rootScope.gVariable.srchTenantId == 0) return true;
        else return false;
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            //console.log("re", result);
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      /*
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }
      */

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: '',
            tabId: 1
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            tabId: 1
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if (item.ColumnPhysicalNm != 'SvyType') {
                  if (item.ColumnPhysicalNm == 'EntryDt')
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  else
                    obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      /**
       * 초기 세팅
       * @param
       * @return
       */
      function init(){

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      //vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      init();
    }]);
})();

webapp.service('SystemCodeAPISrv', ['$resource', 'StaticVariable', '$rootScope',
	  function SystemCodeAPISrv($resource, staticVariable, $rootScope) {
	    return {
	    	getSystemCodeList: function(){
	    		return $resource(staticVariable.getUrl('/api/system/codegroup/:parentCommonCodeId/codelist.json'), {
	    			parentCommonCodeId : '@parentCommonCodeId', userkey:$rootScope.gVariable.userKey
	    		}, staticVariable.getRequestActions.getStandardAction());
	    	},
	    	getCommonCodeList: function(){
	    		return $resource(staticVariable.getUrl('/api/common/codegroup/:parentCommonCodeId/codelist.json'), {
	    			parentCommonCodeId : '@parentCommonCodeId', userkey:$rootScope.gVariable.userKey
	    		}, staticVariable.getRequestActions.getStandardAction());
	    	},
	    };
  },
]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.system', {
      url : '/system',
      template : '<div ui-view></div>',
    }).state('app.system.menumanage-list', {
      url : '/menumanage-list',
      templateUrl : 'app/system/menu-manage-list.html',
      requiresAuthentication: true,
    }).state('app.system.menumanage-mobilelist', {
      url : '/menumanage-mobilelist',
      templateUrl : 'app/system/menu-manage-list.html',
      requiresAuthentication: true,
    }).state('app.system.user-list', {
      url: '/user-list/:srch',
      templateUrl: 'app/system/user-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.system.user-detail', {
      url: '/user-detail/:srch/:keyId',
      templateUrl: 'app/system/user-detail.html',
      requiresAuthentication: true,
    }).state('app.system.user-edit', {
      url: '/user-edit/:srch/:keyId',
      templateUrl: 'app/system/user-edit.html',
    }).state('app.system.user-edit.tab1', {
      url: '/user-edit/:srch/:keyId/tab1',
      templateUrl: 'app/system/user-edit-tab1.html',
    }).state('app.system.user-edit.tab2', {
      url: '/user-edit/:srch/:keyId/tab2',
      templateUrl: 'app/system/user-edit-tab2.html',
    }).state('app.system.user-edit.tab3', {
      url: '/user-edit/:srch/:keyId/tab3',
      templateUrl: 'app/system/user-edit-tab3.html',
    }).state('app.system.user-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/system/user-detail.html',
      requiresAuthentication: true,
    }).state('app.system.user-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/system/user-edit.html',
    }).state('app.system.user-list.edit.tab1', {
      url: '/tab1',
      templateUrl: 'app/system/user-edit-tab1.html',
    }).state('app.system.user-list.edit.tab2', {
      url: '/tab2',
      templateUrl: 'app/system/user-edit-tab2.html',
    }).state('app.system.user-list.edit.tab3', {
      url: '/tab3',
      templateUrl: 'app/system/user-edit-tab3.html',
    }).state('app.system.department-list', {
      url: '/department-list',
      templateUrl: 'app/system/department-list.html',
      requiresAuthentication: true,
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    }).state('app.system.department-detail', {
        url: '/department-detail/:DeptId',
        templateUrl: 'app/system/department-detail.html',
    }).state('app.system.department-edit', {
      url: '/department-edit/:DeptId',
      templateUrl: 'app/system/department-edit.html',
    }).state('app.system.role-list', {
      url: '/role-list/:srch',
      templateUrl: 'app/system/role-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    }).state('app.system.role-detail', {
        url: '/role-detail/:srch/:RoleId',
        templateUrl: 'app/system/role-detail.html',
    }).state('app.system.role-edit', {
      url: '/role-edit/:srch/:RoleId',
      templateUrl: 'app/system/role-edit.html',
    }).state('app.system.role-list.detail', {
      url: '/detail/:RoleId',
      templateUrl: 'app/system/role-detail.html',
    }).state('app.system.role-list.edit', {
      url: '/edit/:RoleId',
      templateUrl: 'app/system/role-edit.html',
    }).state('app.system.company-list', {
      url: '/company-list/:srch',
      templateUrl: 'app/system/company-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    }).state('app.system.company-detail', {
        url: '/company-detail/:srch/:keyId',
        templateUrl: 'app/system/company-detail.html',
    }).state('app.system.company-edit', {
      url: '/company-edit/:srch/:keyId',
      templateUrl: 'app/system/company-edit.html',
    }).state('app.system.company-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/system/company-detail.html',
    }).state('app.system.company-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/system/company-edit.html',
    }).state('app.system.company-edit.tab1', {
      url: '/tab1',
      templateUrl: 'app/system/company-edit-tab1.html',
    }).state('app.system.company-edit.tab2', {
      url: '/tab2',
      templateUrl: 'app/system/company-edit-tab2.html',
    }).state('app.system.company-list.edit.tab1', {
      url: '/tab1',
      templateUrl: 'app/system/company-edit-tab1.html',
    }).state('app.system.company-list.edit.tab2', {
      url: '/tab2',
      templateUrl: 'app/system/company-edit-tab2.html',
    }).state('app.system.screen-list', {
      url: '/screen-list/:srch',
      templateUrl: 'app/system/screen-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.system.screen-detail', {
        url: '/screen-detail/:ScreenId',
        templateUrl: 'app/system/screen-detail.html',
    }).state('app.system.screen-edit', {
      url: '/screen-edit/:ScreenId',
      templateUrl: 'app/system/screen-edit.html',
    }).state('app.system.screen-list.detail', {
      url: '/detail/:ScreenId',
      templateUrl: 'app/system/screen-detail.html',
    }).state('app.system.screen-list.edit', {
      url: '/edit/:ScreenId',
      templateUrl: 'app/system/screen-edit.html',
    }).state('app.system.rolescreen-list', {
      url: '/rolescreen-list/:mobile/:srch',
      templateUrl: 'app/system/rolescreen-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    }).state('app.system.rolescreen-detail', {
        url: '/rolescreen-detail/:RolescreenId',
        templateUrl: 'app/system/rolescreen-detail.html',
    }).state('app.system.rolescreen-edit', {
      url: '/rolescreen-edit/:RolescreenId',
      templateUrl: 'app/system/rolescreen-edit.html',
    }).state('app.system.commoncode-list', {
    url : '/commoncode-list',
    templateUrl : 'app/system/commoncode-list.html',
    requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
           ]);
        } ],
      }
    }).state('app.system.contents-list', {
      url: '/contents-list/:srch',
      templateUrl: 'app/system/contents-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.system.contents-edit', {
      url: '/contents-edit/:srch/:keyId',
      templateUrl: 'app/system/contents-edit.html',
    }).state('app.system.contents-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/system/contents-edit.html',
    }).state('app.system.caretkt-list', {
      url: '/caretkt-list/:srch',
      templateUrl: 'app/system/caretkt-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.system.survey-list', {
      url: '/survey-list/:srch',
      templateUrl: 'app/system/survey-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
      /*
    }).state('app.system.survey-detail', {
      url: '/survey-detail/:srch/:keyId/:tabId',
      templateUrl: 'app/system/survey-detail.html',
      requiresAuthentication: true,
      */
    }).state('app.system.survey-edit', {
      url: '/survey-edit/:srch/:keyId/:tabId',
      templateUrl: 'app/system/survey-edit.html',
      /*
    }).state('app.system.survey-list.detail', {
      url: '/detail/:keyId/:tabId',
      templateUrl: 'app/system/survey-detail.html',
      requiresAuthentication: true,
      */
    }).state('app.system.survey-list.edit', {
      url: '/edit/:keyId/:tabId',
      templateUrl: 'app/system/survey-edit.html',
    }).state('app.system.caretkt-edit', {
      url: '/caretkt-edit/:srch/:keyId',
      templateUrl: 'app/system/caretkt-edit.html',
    }).state('app.system.caretkt-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/system/caretkt-edit.html',
    }).state('app.system.common-properties', {
      url: '/common-properties',
      templateUrl: 'app/system/common-properties.html',
    }).state('app.system.mastergradefee-list', {
      url: '/mastergradefee-list',
      templateUrl: 'app/system/mastergradefee-list.html'
    }).state('app.system.seminar-list', {
      url: '/seminar-list/:srch',
      templateUrl: 'app/system/seminar-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.system.seminar-edit', {
      url: '/seminar-edit/:srch/:keyId',
      templateUrl: 'app/system/seminar-edit.html',
    }).state('app.system.seminar-edit.tab1', {
      url: '/seminar-edit/:keyId/tab1',
      templateUrl: 'app/system/seminar-edit-tab1.html',
    }).state('app.system.seminar-edit.tab2', {
      url: '/seminar-edit/:keyId/tab2',
      templateUrl: 'app/system/seminar-edit-tab2.html',
    }).state('app.system.seminar-edit.tab3', {
      url: '/seminar-edit/:keyId/tab3',
      templateUrl: 'app/system/seminar-edit-tab3.html',
    }).state('app.system.seminar-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/system/seminar-edit.html',
    }).state('app.system.seminar-list.edit.tab1', {
      url: '/tab1',
      templateUrl: 'app/system/seminar-edit-tab1.html',
    }).state('app.system.seminar-list.edit.tab2', {
      url: '/tab2',
      templateUrl: 'app/system/seminar-edit-tab2.html',
    }).state('app.system.seminar-list.edit.tab3', {
      url: '/tab2',
      templateUrl: 'app/system/seminar-edit-tab3.html',
    }).state('app.system.pharmagradefee-list', {
      url: '/pharmagradefee-list',
      templateUrl: 'app/system/pharmagradefee-list.html'
    }).state('app.system.makequery-list', {
      url: '/makequery-list',
      templateUrl: 'app/system/makequery-list.html',
      requiresAuthentication: true,
    }).state('app.system.cafe24-deleteuser', {
      url: '/cafe24-deleteuser',
      templateUrl: 'app/system/cafe24-deleteuser.html'
    })
    ;
  }
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 조회
   */
  webapp.controller('UserDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate',

    function UserDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var VIEW_SQL = 'User.getUserMgrDetail'; // 조회 SQL
      var DEL_SQL = 'User.deleteUserDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.user-list';           // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.system.user-list.edit'; // 목록 등록/수정 화면
      var EDIT_PAGE_URL = 'app.system.user-edit';           // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Users'; // 작업 테이블명
      var KEY_COLUMN_NM = 'UserId'; // Primary Key Column

      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          uploadFileList: [], // 첨부파일 목록
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = [];    // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        KeyId: vm.srchDetail.hKeyId,  // Primary Key Data
        tableNm: KEY_TABLE_NM         // 작업 테이블명
      };

      // 첨부파일 목록
      vm.uploadFileList = [];

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        vm.srchDetail.viewColumns = {}; // 사용자정의 컬럼 정보 설정

        var data = vm.srchDetail; // 검색 옵션 설정
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 조회 정보 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              // 조회 데이터 표시
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;

              // 첨부파일 목록 표시
              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

              vm.dataloader = false; // Progressbar 숨김
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {

        var data = vm.srchDetail; // 검색 옵션 설정
        data.viewColumns = {};
        data.mapCode = 'FileAttach.getFileList';

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // 첨부파일 목록 표시
            var uploadFileList = [];
            angular.forEach(result.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt
              };
              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);


          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> setDelDataAction()");
          console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        var srch = $stateParams.srch; // 검색 옵션
        $state.go(LIST_PAGE_URL, {
          srch: srch
        });
      }

      /**
       * 등록/수정 화면 이동
       *
       * @param
       * @return
       */
      function goEdit() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch, keyId: vm.data.KeyId, tabId: 1
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch, keyId: vm.data.KeyId, tabId: 1
          });
        }
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setDelData = setDelData;                     // 데이터 삭제 확인

      vm.getRoleList = getRoleList;             // 역할 목록 조회

      vm.goList = goList;                       // 목록 화면 이동
      vm.goEdit = goEdit;                       // 등록/수정 화면 이동

      // 역할 목록 조회
      getRoleList();

      // 데이터 조회
      getData();

    }]);


})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $stateParams - state Parameter object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('UserEditCtrl', ['$window', '$rootScope', '$stateParams', '$state',
    function UserEditCtrl($window, $rootScope, $stateParams, $state) {

      // #region 상수 정의

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.user-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.user-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.user-edit';           // 수정 화면

      // View Model
      var vm = this;          // View Model

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.url = $state.current.url;
      vm.keyId = $stateParams.keyId;


      function setChangeTab(tabId) {
        var viewPageUrl = '';

        if (vm.layout == 'N') {
          viewPageUrl = VIEW_PAGE_URL + '.' + tabId;
          // 수정
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
        } else {
          viewPageUrl = LIST_VIEW_PAGE_URL + '.' + tabId;
          // 목록.수정 화면 이동
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
        }
      }

      // 함수 정의
      vm.setChangeTab = setChangeTab;
    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('UserEditTab1Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function UserEditTab1Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'User.insertUser';     // 등록 SQL
      var UPDATE_SQL = 'User.updateUser';     // 수정 SQL
      var VIEW_SQL = 'User.getUserMgrDetail'; // 조회 SQL
      var GETID_SQL = 'checkLoginId';         //아이디중복 SQL
      var DEL_SQL = 'User.deleteUserDetail';  // 삭제 SQL
      var MY_CODE_SQL = 'User.getMyRecomendrCd'; // 추천인 코드 중복 확인
      var CODE_UPDATE_SQL = 'User.updateMyRecomendrCd'; //추천인 코드 저장
      var DUPEMAIL_SQL = 'User.getEmail'; // 이메일 중복 확인 SQL
      var CODE_SQL = 'User.getRecomendrCd'; // 추천인코드 존재여부
      var DEL_SHOP_SQL = 'User.deleteOwnerDetail';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.user-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.user-list.edit.tab1'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.user-edit.tab1';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Users'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        if (!vm.srch.tableNm) vm.srch.tableNm = KEY_TABLE_NM;
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback

      // #region 부서 검색 팝업 호출

      /**
       * 부서 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};
        var modalInstance = modalFactory.open("modal", "components/modal/department/dept-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            // 부서 선택
            vm.data.DeptNm = okData.label;
            vm.data.DeptId = okData.data;
          },
          function (cancelData) {
            // 취소
          }
        );
      };

      /**
       * 부서 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseDept = function () {
        vm.data.DeptNm = "";
        vm.data.DeptId = "";
      };
      // #endregrion 부서 검색 팝업 호출

      // #region 회원사 검색 팝업 호출

      /**
       * 회원사 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchTenantModal = function () {
        var ctrl = 'TenantModalCtrl as vc';
        var paramData = {TenantId: vm.data.TenantId};
        var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          if (okData != null) {
            vm.data.TenantNm = okData.TenantNm;
            vm.data.TenantId = okData.TenantId;
          }
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 회원사 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseTenant = function () {
        if (vm.TenantId && vm.TenantId != '0') {
          return;
        }
        vm.data.TenantNm = "";
        vm.data.TenantId = "";
      };
      // #endregion 회원사 검색 팝업 호출

      // #region 역할 검색 팝업 호출

      /**
       * 역할 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserroleModal = function () {
        var ctrl = 'UserroleModalCtrl as vc';
        var paramData = {
          TenantId: vm.data.TenantId,
          UserRoles: vm.data.UserRoles
        };

        var modalInstance = modalFactory.open('modal', 'components/modal/userRole/userrole-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 역할 선택
          vm.data.UserRoles = okData;
          var UserRoleNms = [];
          var UserRoleIds = [];
          angular.forEach(vm.data.UserRoles, function (role) {
            UserRoleNms.push(role.RoleNm);
            UserRoleIds.push(role.RoleId);
          });

          vm.data.UserRoleNms = UserRoleNms.join(',');
          vm.data.UserRoleIds = UserRoleIds.join(',');

        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 역할 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUserRole = function () {
        vm.data.UserRoleIds = "";
        vm.data.UserRoleNms = "";
      };

      // #endregion 역할 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              vm.tmpEmail = vm.data.Email;
              vm.tmpPassword = vm.data.Password;
              vm.RecomendrCd = vm.data.RecomendrCd;

              // 역할 설정
              vm.data.UserRoles = [];
              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });
              //Date형식 처리
              if (vm.data.BirthDay != null && vm.data.BirthDay != "") vm.BirthDay = moment(vm.data.BirthDay).toDate();
              if (vm.data.EntryDt != null && vm.data.EntryDt != "") vm.EntryDt = moment(vm.data.EntryDt).toDate();
              if (vm.data.RetireDt != null && vm.data.RetireDt != "") vm.RetireDt = moment(vm.data.RetireDt).toDate();

              // 첨부파일 목록 설정
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
            } else {
              console.log('nodata');
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      function getIsDupEmail () {

        var data = vm.data;
        data.mapCode = DUPEMAIL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            vm.dupEmail = result.body.docs.length;
          } else {
            gAlert('', result.body.docs[0].errMessage);
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });

      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.LoginId)) {
          errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.keyId)) {
          if (isNullOrEmpty(vm.data.checkedLoginId)) {
            errMsg = errMsg + '- 아이디 중복체크를 해 주세요.<br/>';
          }
        }

        if (isNullOrEmpty(vm.data.UserNm)) {
          errMsg = errMsg + '- 사용자명을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(vm.data.KeyId) && vm.tmpPassword != vm.data.Password) {
          if( isNullOrEmpty(vm.data.Password)) {
            errMsg = errMsg + '- 비밀번호를 입력하세요.<br/>';
          }
        }
        if (vm.data.Password != vm.data.Password2) {
          errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
        }

        if (!isNullOrEmpty(vm.data.Password)) {
          if (!getIsValidPassword()) {
            errMsg = errMsg + '- 비밀번호 형식을 확인해 주세요.<br/>';
          }
        }
        if (!isNullOrEmpty(vm.RecomendrCd)) {
          if (vm.RecomendrCd != vm.tmpRecomendrCd) {
            errMsg = errMsg + '- 추천인코드를 확인해주세요<br/>';
          }
        }
        if (isNullOrEmpty(vm.data.UseYN)) {
          errMsg = errMsg + '- 사용여부를 선택하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.Email)) {
          errMsg = errMsg + '- 이메일을 입력하세요.<br/>';
        }
        if (!isNullOrEmpty(vm.data.Email) && vm.data.Email != vm.tmpEmail) {
          if (vm.dupEmail > 0) {
            errMsg = errMsg + '- 이메일이 중복되었습니다.<br/>';
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }


      function checkedRecomendrCd() {
        var data = angular.copy(vm.srchDetail);

        data.mapCode = CODE_SQL;
        data.RecomendrCd = vm.RecomendrCd;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            if (result.body.docs.length > 0) {
              vm.data.RecomendrCd = vm.RecomendrCd;
              vm.tmpRecomendrCd = vm.RecomendrCd;
            } else {
              gAlert('','- 추천인코드를 확인해주세요.');
            }
          } else {
            console.error("Error> getMyRecomendrCd()");
          }
        }, function (error) {
          console.error("Error> getMyRecomendrCd()");
          console.table(error);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 비밀번호 체크
       *
       * @param
       * @return
       */
      function getIsValidPassword() {
        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
        var birthDay = moment(vm.data.BirthDay).format('MMDD');
        var birthDay2 = moment(vm.data.BirthDay).format('YYMMDD');

        if(!reg.test(vm.data.Password)) return false;
        if(vm.data.Password.indexOf(birthDay) > -1) return false;
        if(vm.data.Password.indexOf(birthDay2) > -1) return false;
        if(vm.data.Password.length < 8) return false;

        return true;

      }
      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        if(vm.data.JoinDt != null ) {
          vm.data.JoinDt = moment(vm.data.JoinDt).format('YYYY-MM-DD');
        } else {
          vm.data.JoinDt = '';
        }
        if(vm.data.LeaveDt != null ) {
          vm.data.LeaveDt = moment(vm.data.LeaveDt).format('YYYY-MM-DD');
        } else {
          vm.data.LeaveDt = '';
        }

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }


      /**
       * 사용자 중복 체크
       *
       * @param
       * @return
       */
      function getIsDupLoginId() {
        var data = vm.data;

        if (isNullOrEmpty(vm.data.LoginId)) {
          return;
        }

        vm.data.checkedLoginId = "";

        if (!getIsValidId()) {
          gAlert('', '사용할 수 없는 아이디 입니다.');
          return;
        }

        data.mapCode = GETID_SQL;

        postApi.login(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.checkedLoginId = vm.data.LoginId;
            gAlert('', '사용가능한 아이디 입니다.');
          } else {
            gAlert('', result.body.docs[0].errMessage);
            vm.data.checkedLoginId = "";
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      }

      /**
       * 아이디 유효성 검사
       * (영문 소문자, 숫자, 특수문자 -_)
       *
       * @param
       * @return
       */
      function getIsValidId() {
        var regExp = /^[a-z0-9\-_]{5,25}$/;
        if (!regExp.test(vm.data.LoginId)) return false;
        //if (vm.data.LoginId.search(/\s/) != -1) return false;

        return true;
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {

        var param = {};
        param.mapCode = "remoteJfc";
        param.remoteAction = "getUserType";
        param.rTenantID = $rootScope.gVariable.srchTenantId;
        param.rUserID = vm.data.KeyId;
        param.rLoginID = vm.data.LoginId;
        param.rShopTentID = vm.data.TenantId;

        postApi.openApi(param, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            param.rUserType = result.body.docs[0].data.UserType;

            if(param.rUserType == "Owner") {
              gConfirm('', '[원장]권한으로 탈퇴시 Shop에 대한 모든 정보가 삭제되며 관여되어있는 사용자들 역시 탈퇴처리가 됩니다. 그래도 진행하시겠습니까?', {
                btn: '',
                fn: function () {
                  // 데이터 삭제
                  setDelOwnerDataAction(param);
                }
              }, {
                btn: '',
                fn: function () {
                  // 취소
                }
              });
            } else {
              gConfirm('', 'Menu.DELETECONFIRM', {
                btn: '',
                fn: function () {
                  // 데이터 삭제
                  setDelDataAction();
                }
              }, {
                btn: '',
                fn: function () {
                  // 취소
                }
              });
            }
          } else {

          }
        });



      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      function setChangeTab(tabId) {
        vm.tabId = tabId;
        goNextPage(false);
      }
      /**
       * 추천인 코드 생성
       *
       * @param
       * @return
       */
      function setCode() {
        var s = '';
        var start = true;
        var intSum = '';
        var stringSum = '';
        var randomchar = function() {
        var n = Math.floor(Math.random() * 35);

        if(s.length == 0) {

          n = Math.floor(Math.random() * 26);
          stringSum += String.fromCharCode(n + 55);

          return String.fromCharCode(n + 65);
        }

          if (n < 10 && intSum.length < 3) {

            intSum += n;
            return n;
          }
            //1-10
          if (n < 36 &&  stringSum.length < 3) {

            stringSum += String.fromCharCode(n + 55);
            return String.fromCharCode(n + 55); //A-Z
          }
          if( n < 10 && n > 36) {
            return;
          }

        };
        var t ='';
        while (s.length < 6) {

          t = randomchar();
          if(t != undefined) {
            s += t;
          }
        }
        getIsDupMyCd(s);

      }

      /**
       * 추천인 코드 중복확인
       *
       * @param
       * @return
       */
      function getIsDupMyCd(newCode) {

        var data = vm.srchDetail;
        data.mapCode = MY_CODE_SQL;
        data.MyRecomendrCd = newCode;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공

            if (result.body.docs.length > 0) {
              getIsDupMyCd();
            } else {
              vm.data.MyRecomendrCd = newCode;
              setMyRecomendrCd();
            }
          } else {
            console.error("Error> getMyRecomendrCd()");

          }
        }, function (error) {
          console.error("Error> getMyRecomendrCd()");
          console.table(error);
        });
      }


      /**
       * 추천인 코드 저장
       *
       * @param
       * @return
       */
      function setMyRecomendrCd (){

        var data = vm.srchDetail;
        data.mapCode = CODE_UPDATE_SQL;

        postApi.update(data, function (result) {

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            if (result.body.docs.length > 0) {
              gAlert('추천인 코드가 저장되었습니다.');
            } else {
              gAlert('추천인 코드 저장 실패');
            }
          } else {
            console.error("Error> getMyRecomendrCd()");

          }
        }, function (error) {
          console.error("Error> getMyRecomendrCd()");
          console.table(error);
        });

      }

      function setDelOwnerDataAction(param) {

        param.mapCode = "remoteJfc";
        param.remoteAction = "getUserType";

        postApi.openApi(param, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
          } else {
          }
        });
        var data = vm.data;
        data.mapCode = DEL_SHOP_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            console.log('ddd',result);
            if(result.body.docs[0].O_Result == 0) {
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  // 삭제 성공
                  var srch = $stateParams.srch;

                  // 목록 화면 이동
                  $state.go(LIST_PAGE_URL, {
                      srch: srch
                    },
                    {reload: LIST_PAGE_URL});
                }
              });
            } else {
              gAlert('', '삭제되지 않았습니다.', {
                btn: '',
                fn: function () {
                  var srch = $stateParams.srch;

                  // 목록 화면 이동
                  $state.go(LIST_PAGE_URL, {
                      srch: srch
                    },
                    {reload: LIST_PAGE_URL});
                }
              });
            }
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회
      vm.getRoleList = getRoleList;             // 역할 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.getIsDupLoginId = getIsDupLoginId;         // 사용자 중복 체크
      vm.setDelData = setDelData;                     // 데이터 삭제
      vm.getIsDupEmail = getIsDupEmail;

      vm.setChangeTab = setChangeTab;
      vm.setCode = setCode;
      vm.checkedRecomendrCd = checkedRecomendrCd;
      vm.setDelOwnerDataAction = setDelOwnerDataAction;

      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('UserEditTab2Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function UserEditTab2Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'User.getSeminarUserHistListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'User.getSeminarUserHistList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getSeminarHistExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Seminar.deleteSeminarHistList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.user-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.user-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.user-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.user-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.user-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'seminaruser'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var EXCEL_TITLE = '세미나 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          KeyId: $stateParams.keyId,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.srch.KeyId = $stateParams.keyId;
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.srch.sortColumn = '';
        vm.srch.sortDirect = '';
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'PurchDate') {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  if(!isNullOrEmpty(item.ColumnPhysicalAsNm)){
                    obj.push(value[item.ColumnPhysicalAsNm]);
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-edit-tab3-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 탭3
   */

  webapp.controller('UserEditTab3Ctrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function UserEditTab2Ctrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {
      // #region 상수 정의

      // SQL Mapper Id 정의

      var LIST_VIEW_PAGE_URL = 'app.system.user-list.edit.tab3'; // 목록 수정 화면
      var LIST_CNT_SQL = 'User.getUserfeeListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'User.getUserfeeList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getSeminarHistExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'User.deleteUserFeeHistList'; // 목록에서 삭제
      var UPDATE_SQL = 'User.updateUserfeeList';  //저장/수정
      var CALC_SQL = 'User.getUserfeeCalc';  // 수수료 계산


      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.user-list.edit.tab3';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.user-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.user-list.edit.tab3';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.user-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.user-edit.tab3';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvsusersfeehist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'keyId'; // Primary Key Column
      var EXCEL_TITLE = '수수료이력 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          UserId: $stateParams.keyId,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.srch.UserId = $stateParams.keyId;
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.srch.sortColumn = '';
        vm.srch.sortDirect = '';
      }

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        postApi.select(data, function (result) {

          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {

                if(item.ColumnPhysicalNm == 'StdYm' || item.ColumnPhysicalNm == 'EtcSalesAmt' || item.ColumnPhysicalNm == 'PayFixFee') {
                  item.InputType = 'Y';
                } else {
                  item.InputType = 'N';
                }

                vm.columnMap[item.ColumnPhysicalNm] = item;

              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();

              angular.forEach(vm.lists, function (item) {

                  item.StdYm = moment(item.StdYm,'YYYY-MM-DD').toDate();

              });

            } else {
              // 데이터 조회 실패
              vm.lists = [];
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {

        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);

        var newLine = {
          KeyId : newnum.toString(36),
          StdYm : '',
          MonTotSalesAmt : 0,
          CareTktSalesAmt : 0,
          GenSalesAmt : 0,
          EtcSalesAmt : 0,
          CustAcqFee : 0,
          CareTktSalesFee : 0,
          GenSalesFee : 0,
          EtcSalesFee : 0,
          FeeSum : 0,
          PayFixFee : 0
        };
        vm.lists.push(newLine);

        vm.totalItems += 1;
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {

                if(item.ColumnPhysicalNm == 'PurchDate') {
                  obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                } else {
                  if(!isNullOrEmpty(item.ColumnPhysicalAsNm)){
                    obj.push(value[item.ColumnPhysicalAsNm]);
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }

              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {

        setSrchType();

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      /**
       * 일별/월별/년별 에 따른 option setting
       * @param
       * @return
       */
      function setSrchType () {

        vm.options = {minMode : 'month', class : 'datepicker' };
        vm.datepickerMode = 'month';
        vm.dateFormat = 'yyyy-MM';

      }

      /**
       * 매출총액 수수료합계 계산
       * @param
       * @return
       */
      function getUserFeeCalc(row) {

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = CALC_SQL;
        data.StdYm = moment(row.StdYm).format('YYYY-MM');

        postApi.select(data, function (result) {

          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0 ) {
              // 목록 데이터 표시
              var newRow =  result.body.docs[0];

              if(isNullOrEmpty(row.EtcSalesAmt)){
                row.EtcSalesAmt = 0;
              }

              //row.StdYm = moment(newRow.StdYm,'YYYY-MM').toDate();
              //  row.KeyId = newRow.KeyId;
              row.MonTotSalesAmt = Number(newRow.CareTktSalesAmt) + Number(newRow.GenSalesAmt) + Number(row.EtcSalesAmt);
              row.CareTktSalesAmt = newRow.CareTktSalesAmt;
              row.GenSalesAmt = newRow.GenSalesAmt;

              row.CustAcqFee = newRow.CustAcqFee;
              row.CareTktSalesFee = newRow.CareTktSalesFee;
              row.GenSalesFee = newRow.GenSalesFee;
              row.EtcSalesFee = Number(row.EtcSalesAmt) * 0.1;
              row.FeeSum = Number(newRow.CustAcqFee) + Number(newRow.CareTktSalesFee) + Number(newRow.GenSalesFee)  + Number(row.EtcSalesFee);
              row.PayFixFee = row.PayFixFee;

            } else {
              // 데이터 조회 실패
              gAlert('','수수료 계산 중 오류가 발생했습니다.');
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getUserFeeCalc()");
          console.table(error);

        });

      }


      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        angular.forEach(vm.lists, function (item) {
          item.StdYm = moment(item.StdYm).format('YYYYMM');
        })

        vm.data = {
          lists : vm.lists,
          mapCode : UPDATE_SQL,
          UserId : $stateParams.keyId
        };

        var data = vm.data;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });

      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      function getMonthData(row) {

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.StdYm = moment(row.StdYm).format('YYYYMM');

        postApi.select(data, function (result) {

          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0 ) {
              // 목록 데이터 표시
              var newRow =  result.body.docs[0];

              row.StdYm = moment(newRow.StdYm,'YYYY-MM').toDate();
            //  row.KeyId = newRow.KeyId;
              row.MonTotSalesAmt = newRow.MonTotSalesAmt;
              row.CareTktSalesAmt = newRow.CareTktSalesAmt;
              row.GenSalesAmt = newRow.GenSalesAmt;
              row.EtcSalesAmt = newRow.EtcSalesAmt;
              row.CustAcqFee = newRow.CustAcqFee;
              row.CareTktSalesFee = newRow.CareTktSalesFee;
              row.GenSalesFee = newRow.GenSalesFee;
              row.EtcSalesFee = newRow.EtcSalesFee;
              row.FeeSum = newRow.FeeSum;
              row.PayFixFee = newRow.PayFixFee;

              } else {
              // 데이터 조회 실패
              gAlert('','해당 월의 데이터가 없습니다.');
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {srch:srch, keyId: vm.srch.UserId});
        }
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      vm.setSrchType = setSrchType;               // 날짜 년월로 표시
      vm.getUserFeeCalc = getUserFeeCalc;                     //매출총액 / 수수료 합계 계산
      vm.setData = setData;
      vm.getMonthData = getMonthData;             // 달력 변경에 따른 새로운 데이터
      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('UserListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function UserListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'User.getUserMgrListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'User.getUserMgrList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'User.deleteUserList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.user-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.user-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.user-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.user-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.user-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'users'; // 작업 테이블명
      var KEY_COLUMN_NM = 'UserId'; // Primary Key Column
      var EXCEL_TITLE = '사용자관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.EntryDtFrom = $rootScope.getDateFormat(vm.srch.EntryDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.EntryDtTo = $rootScope.getDateFormat(vm.srch.EntryDtTo);
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.EntryDtFrom = $filter('localToUtc')(data.EntryDtFrom, 'from');
        data.EntryDtTo = $filter('localToUtc')(data.EntryDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.EntryDtFrom = $filter('localToUtc')(data.EntryDtFrom, 'from');
        data.EntryDtTo = $filter('localToUtc')(data.EntryDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'EntryDt') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";

  webapp.controller('AnalysisCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function AnalysisCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      var ANAL_TGT_SQL = 'WjmReport.getAnalTgtList'; // 대상자 분석 조회 SQL
      var ANAL_RESP_SQL = 'WjmReport.getAnalRespList'; // 응답정보 분석 조회 SQL
      var ANAL_ASSO_SQL = 'WjmReport.getAssociAnalTgtList'; // 연관분석 조회 SQL

      var SCORE_LIST_SQL = 'WjmReport.getAnalQstSecScoreList'; // 분석 조회 SQL > 영역별 점수

      var CF_LIST_SQL = 'WjmSurvey.getClassfyDropList'; // 분류정보 조회 SQL
      var SEC_LIST_SQL = 'WjmSurvey.getQstSecList'; // 문항영역 조회 SQL
      var LV_LIST_SQL = 'WjmSurvey.getScoreLvDropList'; // 문항영역별 등급구분 SQL
      var CD_LIST_SQL = 'CommonCode.getCommonCodeList'; // 공통코드 조회 SQL
      var QSTINFO_LIST_SQL = 'WjmReport.getQstInfoList'; // 문항영역, 문항, 보기 조회 SQL

      var LIST_PAGE_URL = 'app.survey.result-list';           // 설문 결과 목록 화면
      var RESP_PAGE_URL = 'app.survey.target-result-list';   // 분석 결과 대상자 목록 화면
      var RPT_PAGE_URL = "app.survey.report-mng-detail"; // 보고서 생성 관리 상세 화면

      var vm = this;
      vm.dataloader = false;

      if (!$stateParams.srch) {
        vm.srch = {
          FormId : '',
          SvyIds : [],
          TgtCnt : 0
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));

        // 서식이 없는 경우, 서식이 있으나 선택된 설문이 하나인 경우
        if((isNullOrEmpty(vm.srch.FormId) && vm.srch.SvyIds.length > 0)
          || vm.srch.SvyIds.length == 1) {
          vm.srch.FormId = '';
          vm.srch.SvyId = vm.srch.SvyIds[0];
        }

        // 보고서 생성에서 이동한 경우
        if( ! isNullOrEmpty(vm.srch.fileNm)) vm.isReport = true;
      }

      vm.dataTypeListOrg = [
        {chtType: "C", cfCd: "", typeNm: "전체 참여율", typeChtCd: "pie", dataChk: true, useChk: true},
        {chtType: "C", cfCd: "GD", typeNm: "성별 참여율", typeChtCd: "pie", dataChk: true, useChk: false},
        {chtType: "C", cfCd: "AG", typeNm: "연령대별 참여율", typeChtCd: "pie", dataChk: true, useChk: false},
        {chtType: "C", cfCd: "PS", typeNm: "직급별 참여율", typeChtCd: "pie", dataChk: true, useChk: false},
        {chtType: "C", cfCd: "GR1", typeNm: "그룹1별 참여율", typeChtCd: "pie", dataChk: true, useChk: false},
        {chtType: "C", cfCd: "GR2", typeNm: "그룹2별 참여율", typeChtCd: "pie", dataChk: true, useChk: false},
        {chtType: "C", cfCd: "GR3", typeNm: "그룹3별 참여율", typeChtCd: "pie", dataChk: true, useChk: false},
        {chtType: "C", cfCd: "GR4", typeNm: "그룹4별 참여율", typeChtCd: "pie", dataChk: true, useChk: false},
        {chtType: "L", cfCd: "", typeNm: "전체 결과", typeChtCd: "pie", dataChk: false, useChk: false},
        {chtType: "L", cfCd: "GD", typeNm: "성별 결과", typeChtCd: "pie", dataChk: false, useChk: false},
        {chtType: "L", cfCd: "AG", typeNm: "연령대별 결과", typeChtCd: "pie", dataChk: false, useChk: false},
        {chtType: "L", cfCd: "PS", typeNm: "직급별 결과", typeChtCd: "pie", dataChk: false, useChk: false},
        {chtType: "L", cfCd: "GR1", typeNm: "그룹1별 결과", typeChtCd: "pie", dataChk: false, useChk: false},
        {chtType: "L", cfCd: "GR2", typeNm: "그룹2별 결과", typeChtCd: "pie", dataChk: false, useChk: false},
        {chtType: "L", cfCd: "GR3", typeNm: "그룹3별 결과", typeChtCd: "pie", dataChk: false, useChk: false},
        {chtType: "L", cfCd: "GR4", typeNm: "그룹4별 결과", typeChtCd: "pie", dataChk: false, useChk: false},
        {chtType: "S1", cfCd: "", typeNm: "상위영역 점수", useChk: false},
        {chtType: "S1", cfCd: "GD", typeNm: "상위영역 성별 점수", useChk: false},
        {chtType: "S1", cfCd: "AG", typeNm: "상위영역 연령대별 점수", useChk: false},
        {chtType: "S1", cfCd: "PS", typeNm: "상위영역 직급별 점수", useChk: false},
        {chtType: "S1", cfCd: "GR1", typeNm: "상위영역 그룹1별 점수", useChk: false},
        {chtType: "S1", cfCd: "GR2", typeNm: "상위영역 그룹2별 점수", useChk: false},
        {chtType: "S1", cfCd: "GR3", typeNm: "상위영역 그룹3별 점수", useChk: false},
        {chtType: "S1", cfCd: "GR4", typeNm: "상위영역 그룹4별 점수", useChk: false},
        {chtType: "S1", cfCd: "TGT", typeNm: "상위영역 대상자별 점수", useChk: false},
        {chtType: "S2", cfCd: "", typeNm: "하위영역 점수", useChk: false},
        {chtType: "S2", cfCd: "GD", typeNm: "하위영역 성별 점수", useChk: false},
        {chtType: "S2", cfCd: "AG", typeNm: "하위영역 연령대별 점수", useChk: false},
        {chtType: "S2", cfCd: "PS", typeNm: "하위영역 직급별 점수", useChk: false},
        {chtType: "S2", cfCd: "GR1", typeNm: "하위영역 그룹1별 점수", useChk: false},
        {chtType: "S2", cfCd: "GR2", typeNm: "하위영역 그룹2별 점수", useChk: false},
        {chtType: "S2", cfCd: "GR3", typeNm: "하위영역 그룹3별 점수", useChk: false},
        {chtType: "S2", cfCd: "GR4", typeNm: "하위영역 그룹4별 점수", useChk: false},
      ];

      vm.dataTypeList = angular.copy(vm.dataTypeListOrg);

      // 분석 데이터 조회용
      vm.srchAnal = angular.copy(vm.srch);
      vm.srchAnal.LvCd01 = '';
      vm.srchAnal.LvCd02 = '';
      vm.srchAnal.LvCd03 = '';
      vm.srchAnal.LvCd04 = '';
      vm.srchAnal.LvCd05 = '';
      vm.srchAnal.QstItemSelYN11 = 'Y';
      vm.srchAnal.QstItemSelYN12 = 'Y';
      vm.srchAnal.QstItemSelYN13 = 'Y';
      vm.srchAnal.QstItemId11 = '';
      vm.srchAnal.QstItemId12 = '';
      vm.srchAnal.QstItemId13 = '';

      vm.gdList = [];
      vm.agList = [];
      vm.psList = [];
      vm.gr1List = [];
      vm.gr2List = [];
      vm.gr3List = [];
      vm.gr4List = [];

      setCodeList();

      // 대상자 분석 데이터 조회
      function getTgtData() {

        if(isNullOrEmpty(vm.srchAnal.SvyIds)){
          gAlert('', '설문을 선택하세요.');
          return;
        }

        if( (!isNullOrEmpty(vm.srchAnal.QstId11) && isNullOrEmpty(vm.srchAnal.QstItemId11))
          || (!isNullOrEmpty(vm.srchAnal.QstId12) && isNullOrEmpty(vm.srchAnal.QstItemId12))
          || (!isNullOrEmpty(vm.srchAnal.QstId13) && isNullOrEmpty(vm.srchAnal.QstItemId13))
        ){
          gAlert('', '교차문항 보기를 선택하세요.');
          return;
        }

        vm.dataloader = true;
        var data = vm.srchAnal;
        data.mapCode = ANAL_TGT_SQL;

        vm.tgtList = []; // 대상자

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tgtList = result.body.docs;

              // 보고서의 경우 대상자와 응답정보를 함께 조회
              if(vm.isReport) getRespData();
              else vm.dataloader = false;

            }
            else
            {
              gAlert('', '조건에 맞는 대상이 없습니다.');
              vm.dataloader = false;
            }
          }
          else
          {
            gAlert('', '오류가 발생했습니다.');
            vm.dataloader = false;
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getTgtData()");
          console.table(error);
        });
      }

      // 응답정보 분석 데이터 조회
      function getRespData() {

        if(isNullOrEmpty(vm.tgtList)){
          gAlert('', '대상자 분석을 실행하세요.');
          return;
        }

        vm.dataloader = true;
        var data = vm.srchAnal;

        data.SvyTgtIds = [];
        angular.forEach(vm.tgtList, function(tgt) {
          data.SvyTgtIds.push(tgt.SvyTgtId);
        });
        data.mapCode = ANAL_RESP_SQL;

        vm.respList = []; // 응답정보
        vm.scoreList = []; // 점수
        vm.respCntList = []; // 응답수

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.respList = result.body.docs;

              // 채점이 있을 경우에만 점수 데이터 조회
              if(vm.srch.ScoringType != "N") getScoreData();
              else setChtData();

              // 문항별 응답수
              angular.forEach(vm.qstItemList, function(i) {
                var data = i;
                if(i.QstType == "5")
                {
                  var sNum = String(i.ScaleNum);
                  data.CntT = $filter('filter')(vm.respList, {SvyQstId: i.QstId, SvyQstItemId: i.QstItemId, SbjctResp: sNum}, true).length;
                  data.CntM = $filter('filter')(vm.respList, {SvyQstId: i.QstId, SvyQstItemId: i.QstItemId, SbjctResp: sNum, GD: "M"}, true).length;
                  data.CntF = $filter('filter')(vm.respList, {SvyQstId: i.QstId, SvyQstItemId: i.QstItemId, SbjctResp: sNum, GD: "F"}, true).length;
                } else {
                  data.CntT = $filter('filter')(vm.respList, {SvyQstId: i.QstId, SvyQstItemId: i.QstItemId}, true).length;
                  data.CntM = $filter('filter')(vm.respList, {SvyQstId: i.QstId, SvyQstItemId: i.QstItemId, GD: "M"}, true).length;
                  data.CntF = $filter('filter')(vm.respList, {SvyQstId: i.QstId, SvyQstItemId: i.QstItemId, GD: "F"}, true).length;
                }
                vm.respCntList.push(data);
              });

              //console.error("vm.respList",vm.respList);
              //console.error("vm.qstItemList",vm.qstItemList);
            }
            else
            {
              gAlert('', '조건에 맞는 결과가 없습니다.');
              vm.dataloader = false;
            }
          }
          else
          {
            gAlert('', '오류가 발생했습니다.');
            vm.dataloader = false;
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getRespData()");
          console.table(error);
        });
      }

      // 점수 데이터 조회
      function getScoreData() {

        vm.dataloader = true;
        var data = {};
        data.SvyTgtIds = [];
        data.mapCode = SCORE_LIST_SQL;

        angular.forEach(vm.tgtList, function(tgt) {
          data.SvyTgtIds.push(tgt.SvyTgtId);
        });

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              vm.scoreList = result.body.docs;

              // 대상자 정보에 영역별 점수 매핑
              angular.forEach(vm.tgtList, function(t) {
                t.scoreList = $filter('filter')(vm.scoreList, {SvyTgtId: t.SvyTgtId}, true);
              });
            }

            setChtData();
          }
          else
          {
            gAlert('', '오류가 발생했습니다.');
            vm.dataloader = false;
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getScoreData()");
          console.table(error);
        });
      }

      // 연관분석 데이터 조회
      function getAssociData() {

        if(isNullOrEmpty(vm.srchAnal.SvyIds)){
          gAlert('', '설문을 선택하세요.');
          return;
        }

        if(isNullOrEmpty(vm.srchAnal.QstId21) && isNullOrEmpty(vm.srchAnal.QstId22)){
          gAlert('', '연관문항을 하나 이상 선택하세요.');
          return;
        }

        vm.dataloader = true;
        var data = vm.srchAnal;
        data.mapCode = ANAL_ASSO_SQL;

        vm.assoRespList = [];

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.assoRespList = result.body.docs;
              vm.dataloader = false;
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }
          vm.dataloader = false;
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getAssociData()");
          console.table(error);
        });
      }

      // 연관분석 엑셀 다운로드
      function getAssociExcel() {

        if(isNullOrEmpty(vm.assoRespList)){
          gAlert('', '연관문항을 선택하고 문항 보기별 분석을 실행하세요.');
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        $scope.jsonToExport = vm.assoRespList;
        $scope.fileName = "데이터분석";
        $scope.exportData = [];

        var obj = [];
        var cnt = 0;

        obj = [];
        obj.push("설문제목 : " + vm.srchAnal.SvyNms);
        $scope.exportData.push(obj);

        obj = [];
        obj.push("문항수 : " + vm.qstList.length + " 문항");
        $scope.exportData.push(obj);

        obj = [];
        obj.push("참여자수 : " + vm.tgtList.length + " 명");
        $scope.exportData.push(obj);

        obj = [];
        obj.push("연관문항1 : " + vm.srchAnal.QstSubject21);
        $scope.exportData.push(obj);

        obj = [];
        obj.push("연관문항2 : " + vm.srchAnal.QstSubject22);
        $scope.exportData.push(obj);

        obj = [];
        obj.push("");
        $scope.exportData.push(obj);


        // 연관문항1 질문
        obj = [];
        obj.push(vm.srchAnal.QstSubject21);
        $scope.exportData.push(obj);

        // 연관문항1 보기
        angular.forEach(vm.itemList21, function (it1) {
          obj = [];
          cnt = $filter('filter')(vm.assoRespList, {QstItemId1: it1.QstItemId}, true).length;
          obj.push("(" + it1.QstItemNo + ")." + it1.QstItemContents + " : " + cnt + "명");
          $scope.exportData.push(obj);

          // 연관문항2 질문
          obj = [];
          obj.push("");
          obj.push(vm.srchAnal.QstSubject22);
          $scope.exportData.push(obj);

          // 연관문항1 보기
          angular.forEach(vm.itemList22, function (it2) {
            obj = [];
            obj.push("");
            obj.push(it2.QstItemNo + "." + it2.QstItemContents);
            obj.push($filter('filter')(vm.assoRespList, {QstItemId1: it1.QstItemId, QstItemId2: it2.QstItemId}, true).length + "명");
            $scope.exportData.push(obj);
          });
        });

        $rootScope.excelDown($scope.exportData, $scope.fileName);
      }

      // 페이지 이동
      function goPage() {

        // 보고서 생성 관리 상세
        if(vm.isReport){
          $state.go(RPT_PAGE_URL, {
            srch: $stateParams.srch2,
            keyId: vm.srch.SvyId
          });
        }
        // 설문 결과 관리 목록
        else{
          $state.go(LIST_PAGE_URL, {
            srch: $stateParams.srch
          });
        }
      }

      // 분석조건 코드 조회
      function getCodeList(type) {

        var data = {
          SvyId : vm.srchAnal.SvyId,
          FormId : vm.srchAnal.FormId,
          SvyTypeId : vm.srchAnal.SvyTypeId,
          ClassfyInfoId : vm.srchAnal.ClassfyInfoId,
        };

        if(type == "GD") data = {CodeType : 'GENDER', mapCode : CD_LIST_SQL}; // 성별
        else if(type == "SEC") data.mapCode = SEC_LIST_SQL; // 문항영역
        else if(type == "SECLV") data.mapCode = LV_LIST_SQL; // 문항영역별 등급구분
        else if(type == "QST") data.mapCode = QSTINFO_LIST_SQL; // 문항
        else if(type == "CF") data.mapCode = CF_LIST_SQL; // 분류정보

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            switch(type) {

              case "GD" : vm.gdList = result.body.docs; break; // 성별

              case "CF" : // 분류정보
                vm.agList = $filter('filter')(angular.copy(result.body.docs), {ClassfyCd: "AG"}, true); // 연령대
                vm.psList = $filter('filter')(angular.copy(result.body.docs), {ClassfyCd: "PS"}, true); // 직급
                vm.gr1List = $filter('filter')(angular.copy(result.body.docs), {ClassfyCd: "GR1"}, true); // 그룹1
                vm.gr2List = $filter('filter')(angular.copy(result.body.docs), {ClassfyCd: "GR2"}, true); // 그룹2
                vm.gr3List = $filter('filter')(angular.copy(result.body.docs), {ClassfyCd: "GR3"}, true); // 그룹3
                vm.gr4List = $filter('filter')(angular.copy(result.body.docs), {ClassfyCd: "GR4"}, true); // 그룹4
                break;

              case "QST" : // 문항정보
                vm.qstList = [];
                vm.qstItemList = [];
                angular.forEach(result.body.docs, function (info) {
                  // 문항 전체
                  if(isNullOrEmpty(vm.qstList[info.QstId])){
                    var qInfo = {
                      QstId: info.QstId,
                      Qst: info.Qst,
                      QstSubject: info.QstSubject,
                      QstType: info.QstType,
                      ClassfyCd: info.ClassfyCd
                    };
                    vm.qstList[info.QstId] = qInfo;
                    vm.qstList.push(qInfo);
                  }
                  // 보기 전체
                  if(info.QstType == "5"){ // 척도형
                    for(var p = 1; p <= info.ScaleMax; p++){
                      if(isNullOrEmpty(vm.qstItemList[info.QstItemId +"_"+ p])){
                        var d = angular.copy(info);
                        d.ScaleNum = p;
                        d.QstItem = d.QstItem +"_"+ p;
                        d.QstItemContents = d.QstItemContents +"_"+ p;
                        vm.qstItemList[info.QstItemId +"_"+ p] = d;
                        vm.qstItemList.push(d);
                      }
                    }
                  }
                  else{
                    if(isNullOrEmpty(vm.qstItemList[info.QstItemId])){
                      vm.qstItemList[info.QstItemId] = info;
                      vm.qstItemList.push(info);
                    }
                  }
                });

                // 다른 페이지에서 뒤로 버튼으로 이동했을 경우를 위해
                if(!isNullOrEmpty(vm.srchAnal.QstId11)) setQstItem(11);
                if(!isNullOrEmpty(vm.srchAnal.QstId12)) setQstItem(12);
                if(!isNullOrEmpty(vm.srchAnal.QstId13)) setQstItem(13);
                if(!isNullOrEmpty(vm.srchAnal.QstId21)) setQstItem(21);
                if(!isNullOrEmpty(vm.srchAnal.QstId22)) setQstItem(22);
                break;

              // 상위 문항영역
              case "SEC" :
                vm.qstSecList = result.body.docs;
                vm.qstSec1List = $filter('filter')(angular.copy(result.body.docs), {QstSecLevel: 1}, true); // 상위영역
                getCodeList('SECLV');
                break;


              // 각 영역별 진단결과 첫 행에 영역명 추가
              case "SECLV" :
                var list = result.body.docs;
                vm.secLvList = [];
                angular.forEach(vm.qstSec1List, function(sec, idx) {
                  vm.secLvList[idx] = $filter('filter')(list, {QstSecId: sec.QstSecId}, true);
                  vm.secLvList[idx].unshift({LvCd: "", LvTxt: sec.QstSecNm});
                });
                vm.lvList = $filter('filter')(list, {QstSecId: "0"}, true);
                break;
            }
          }
          if(type == "CF") {
            vm.dataTypeSort = [];
            var num = 1;
            var dChk = false;
            angular.forEach(vm.dataTypeList, function (d) {

              if(d.cfCd == "GD") dChk = vm.gdList.length > 0;
              if(d.cfCd == "AG") dChk = vm.agList.length > 0;
              if(d.cfCd == "PS") dChk = vm.psList.length > 0;
              if(d.cfCd == "GR1") dChk = vm.gr1List.length > 0;
              if(d.cfCd == "GR2") dChk = vm.gr2List.length > 0;
              if(d.cfCd == "GR3") dChk = vm.gr3List.length > 0;
              if(d.cfCd == "GR4") dChk = vm.gr4List.length > 0;

              // 채점없이 아닐 경우
              if(vm.srch.ScoringType != "N") {

                // 진단결과 활성화
                if(d.chtType == "L") d.dataChk = true;

                // 보고서는 전체 활성화
                if(vm.isReport){
                  if(d.cfCd == "" || d.cfCd == "TGT") d.dataChk = true;
                  else d.dataChk = dChk;
                  d.useChk = d.dataChk;
                }
              }
              else {
                if(d.usechk) d.dataChk = dChk;
              }

              if(d.dataChk) {
                d.typeSort = num++;
                vm.dataTypeSort.push(d.typeSort);
              }
            });
          }
        }, function (error) {
          console.error("Error> getCodeList()", type);
          console.table(error);
        });
      }

      // 분석조건 코드 설정 (분류정보, 문항영역)
      function setCodeList(){
        if( !isNullOrEmpty(vm.srchAnal.FormId) || !isNullOrEmpty(vm.srchAnal.SvyId)){
          getCodeList('GD');
          getCodeList('SEC');
          getCodeList('CF');
          getCodeList('QST');
        }
      }

      // 선택된 문항의 보기 목록 설정
      function setQstItem(num){
        var qstId = '';
        switch(num){

          case 11 :
            vm.itemList11 = [];
            vm.itemList12 = [];
            vm.itemList13 = [];
            vm.srchAnal.QstItemId11 = '';
            qstId = vm.srchAnal.QstId11;
            vm.srchAnal.QstSubject11 = (!isNullOrEmpty(qstId) ? vm.qstList[qstId].QstSubject : "");
            break;
          case 12 :
            vm.itemList12 = [];
            vm.itemList13 = [];
            vm.srchAnal.QstItemId12 = '';
            qstId = vm.srchAnal.QstId12;
            vm.srchAnal.QstSubject12 = (!isNullOrEmpty(qstId) ? vm.qstList[qstId].QstSubject : "");
            break;
          case 13 :
            vm.itemList13 = [];
            vm.srchAnal.QstItemId13 = '';
            qstId = vm.srchAnal.QstId13;
            vm.srchAnal.QstSubject13 = (!isNullOrEmpty(qstId) ? vm.qstList[qstId].QstSubject : "");
            break;

          case 21 :
            vm.assoRespList = [];
            vm.itemList21 = [];
            vm.itemList22 = [];
            qstId = vm.srchAnal.QstId21;
            if(!isNullOrEmpty(qstId)){
              vm.srchAnal.QstSubject21 = vm.qstList[qstId].QstSubject;
              vm.srchAnal.QstType1 = vm.qstList[qstId].QstType;
            }
            break;
          case 22 :
            vm.assoRespList = [];
            vm.itemList22 = [];
            qstId = vm.srchAnal.QstId22;
            if(!isNullOrEmpty(qstId)){
              vm.srchAnal.QstSubject22 = vm.qstList[qstId].QstSubject;
              vm.srchAnal.QstType2 = vm.qstList[qstId].QstType;
            }
            break;
        }

        if(!isNullOrEmpty(qstId)) {
          var list = [];
          angular.forEach($filter('filter')(vm.qstItemList, {QstId: qstId}, true), function(item) {
            var data = {
              QstId: item.QstId,
              QstItemId: item.QstItemId,
              QstItem: item.QstItem,
              QstItemNo: item.QstItemNo,
              QstItemContents: item.QstItemContents
            };
            list.push(data);
          });
          switch(num){
            case 11 : vm.itemList11 = list; break;
            case 12 : vm.itemList12 = list; break;
            case 13 : vm.itemList13 = list; break;
            case 21 : vm.itemList21 = list; break;
            case 22 : vm.itemList22 = list; break;
          }
        }
      }


      // 분석 결과보기
      function goTargetList(type, itId1, itId2){

        var srch = vm.srchAnal;
        var SvyTgtIds = [];
        var tgtRespList = [];

        if(type == "Anal"){
          angular.forEach(vm.tgtList, function(tgt) {
            SvyTgtIds.push(tgt.SvyTgtId);
          });

        } else if (type == "AssociAnal") {
          if (isNullOrEmpty(itId2)) tgtRespList = $filter('filter')(vm.assoRespList, {QstItemId1: itId1}, true);
          else tgtRespList = $filter('filter')(vm.assoRespList, {QstItemId1: itId1, QstItemId2: itId2}, true);
          angular.forEach(tgtRespList, function(tgt) {
            SvyTgtIds.push(tgt.SvyTgtId);
          });
        }


        srch.goBack = type;
        srch.SvyTgtIds = SvyTgtIds;

        $state.go(RESP_PAGE_URL, {
          srch: encodeURIComponent(JSON.stringify(srch, replacer)),
        });
      }

      // 미리보기
      function goPreview(dataType){

        if(isNullOrEmpty(vm.srchAnal.SvyIds)){
          gAlert('', '설문을 선택하고 대상자 분석 후 응답정보 분석을 실행하세요.');
          return;
        }

        if(isNullOrEmpty(vm.respList)){
          gAlert('', '대상자 분석 후 응답정보 분석을 실행하세요.');
          return;
        }

        var ctrl = 'WjmAnalPreviewModalCtrl as vc';
        var paramData = {
          tgtList : vm.tgtList,
          dataType : dataType,
          gdChk : vm.gdList.length > 0,
          agChk : vm.agList.length > 0,
          psChk : vm.psList.length > 0,
          gr1Chk : vm.gr1List.length > 0,
          gr2Chk : vm.gr2List.length > 0,
          gr3Chk : vm.gr3List.length > 0,
          gr4Chk : vm.gr4List.length > 0,
          lvChk : vm.lvList.length > 0
        };

        var modalInstance = modalFactory.open('md', 'components/modal/survey/wjm-anal-preview-modal.html', ctrl, paramData);
        modalInstance.result.then(function() {
        },
        function(cancelData) {
        });
      }

      // 설문 검색 팝업
      vm.srchSurveyModal = function () {
        var ctrl = 'WjmSurveyMultiselModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId, isResult : 'Y'};
        var modalInstance = modalFactory.open('md', 'components/modal/survey/wjm-survey-multisel-modal.html', ctrl, paramData);

        modalInstance.result.then(function(srchChk) {

          vm.tgtList = [];

          vm.srchAnal.SvyIds = srchChk.KeyIdList;
          vm.srchAnal.SvyNms = srchChk.SvyNms;
          vm.srchAnal.FormId = srchChk.FormId;
          vm.srchAnal.SvyTypeId = srchChk.SvyTypeId;
          vm.srchAnal.ClassfyInfoId = srchChk.ClassfyInfoId;
          vm.srchAnal.TgtCnt = srchChk.TgtCnt;

          vm.srch.ScoringType = srchChk.ScoringType;
          vm.srch.SecLevelCnt = srchChk.SecLevelCnt;

          vm.dataTypeList = angular.copy(vm.dataTypeListOrg);

          angular.forEach(vm.dataTypeList, function (d) {
            // 채점없음이 아닐 경우 결과 차트 표시
            if(srchChk.ScoringType != "N" && d.chtType == "L") d.dataChk = true;
          });


          // 서식이 없는 경우, 서식이 있으나 선택된 설문이 하나인 경우
          if((isNullOrEmpty(vm.srchAnal.FormId) && vm.srchAnal.SvyIds.length > 0)
            || vm.srchAnal.SvyIds.length == 1) {
              vm.srchAnal.FormId = '';
              vm.srchAnal.SvyId = vm.srchAnal.SvyIds[0];
          }

          setCodeList();
        },
        function(cancelData) {
        });
      };
      vm.eraseSurvey = function () {
        vm.srchAnal.SvyIds = '';
        vm.srchAnal.SvyNms = '';
      };

      // 데이터 유형별 차트 데이터 설정
      function setChtData()
      {
        //console.error("vm.tgtList",vm.tgtList);
        var totalCnt = vm.srchAnal.TgtCnt; // 전체 대상인원
        var respCnt = vm.tgtList.length; // 전체 응답인원

        angular.forEach(vm.dataTypeList, function(dt)
        {
          var cfList = [];
          var cfTgtList = [];
          var chtList = [];
          var dataList = [];
          var cntTot = 0;
          var qList = [];

          var cfTgtListR = [];
          var dataListR = [];
          var qListR = [];

          switch(dt.cfCd)
          {
            case "GD":
              cfList = angular.copy(vm.gdList);
              //console.error("cfList",cfList);
              break;
            case "AG":
              cfList = angular.copy(vm.agList);
              //if(vm.agList.length > 0) cfList.push({ClassfyCd: "AG", ClassfyId: "none", ClassfyNm: "미응답"});
              break;
            case "PS":
              cfList = angular.copy(vm.psList);
              //if(vm.psList.length > 0) cfList.push({ClassfyCd: "PS", ClassfyId: "none", ClassfyNm: "미응답"});
              break;
            case "GR1":
              cfList = angular.copy(vm.gr1List);
              //if(vm.gr1List.length > 0) cfList.push({ClassfyCd: "GR1", ClassfyId: "none", ClassfyNm: "미응답"});
              break;
            case "GR2":
              cfList = angular.copy(vm.gr2List);
              //if(vm.gr2List.length > 0) cfList.push({ClassfyCd: "GR2", ClassfyId: "none", ClassfyNm: "미응답"});
              break;
            case "GR3":
              cfList = angular.copy(vm.gr3List);
              //if(vm.gr3List.length > 0) cfList.push({ClassfyCd: "GR3", ClassfyId: "none", ClassfyNm: "미응답"});
              break;
            case "GR4":
              cfList = angular.copy(vm.gr4List);
              //if(vm.gr4List.length > 0) cfList.push({ClassfyCd: "GR4", ClassfyId: "none", ClassfyNm: "미응답"});
              break;
          }

          // 1. 참여율 ==================================================================================================
          if(dt.chtType == "C")
          {
            // 전체 참여율
            if(dt.cfCd == "")
            {
              var cnt1 = respCnt;
              var cnt2 = totalCnt - cnt1;
              var rate1 = cnt1 + "("+ (cnt1 / totalCnt * 100).toFixed(1) +"%)";
              var rate2 = cnt2 + "("+ (cnt2 / totalCnt * 100).toFixed(1) +"%)";
              dataList.push({Type: "참여", Cnt: cnt1, Rate: rate1});
              dataList.push({Type: "미참여", Cnt: cnt2, Rate: rate2});
              cntTot = cnt1 + cnt2;
            }
            // 분류정보별 참여율
            else
            {
              var cnt = 0;

              angular.forEach(cfList, function(c)
              {
                if(dt.cfCd == "GD") cnt = $filter('filter')(vm.tgtList, {GD: c.Code}, true).length;
                else if(dt.cfCd == "AG") cnt = $filter('filter')(vm.tgtList, {AG: c.ClassfyId}, true).length;
                else if(dt.cfCd == "PS") cnt = $filter('filter')(vm.tgtList, {PS: c.ClassfyId}, true).length;
                else if(dt.cfCd == "GR1") cnt = $filter('filter')(vm.tgtList, {GR1: c.ClassfyId}, true).length;
                else if(dt.cfCd == "GR2") cnt = $filter('filter')(vm.tgtList, {GR2: c.ClassfyId}, true).length;
                else if(dt.cfCd == "GR3") cnt = $filter('filter')(vm.tgtList, {GR3: c.ClassfyId}, true).length;
                else if(dt.cfCd == "GR4") cnt = $filter('filter')(vm.tgtList, {GR4: c.ClassfyId}, true).length;

                var rate = cnt + "("+ (cnt / respCnt * 100).toFixed(1) +"%)";

                dataList.push({
                  Type: (dt.cfCd == "GD" ? c.CodeValue : c.ClassfyNm),
                  Cnt: cnt,
                  Rate: rate
                });

                cntTot = cntTot + cnt;
              });
            }
            chtList.push({dataList: dataList, cntTot: cntTot});
          }
          // 2. 진단결과 ==================================================================================================
          else if(dt.chtType == "L")
          {
            // 전체 진단결과
            if(dt.cfCd == "")
            {
              angular.forEach(angular.copy(vm.lvList), function(lv)
              {
                var cnt = $filter('filter')(vm.tgtList, {LvCd: lv.LvCd}, true).length;
                var rate = cnt + "("+ (cnt / respCnt * 100).toFixed(1) +"%)";
                dataList.push({LvCd: lv.LvCd, Type: lv.LvTxt, Cnt: cnt, Rate: rate});
                cntTot = cntTot + cnt;
              });

              // Red
              var cntR = $filter('filter')(vm.tgtList, {LvCd: "Red"}, true).length;
              dataListR.push({LvCd: "Red", Cnt: cntR});

              chtList.push({dataList: dataList, dataListR: dataListR, cntTot: cntTot, title : "전체"});
            }
            // 분류정보별 진단결과
            else
            {
              angular.forEach(cfList, function(c)
              {
                dataList = [];
                dataListR = [];
                cntTot = 0;
                var title = "";

                if(dt.cfCd == "GD") {
                  cfTgtList = $filter('filter')(vm.tgtList, {GD: c.Code}, true);
                  cfTgtListR = $filter('filter')(vm.tgtList, {LvCd: "Red", GD: c.Code}, true);
                } else if(dt.cfCd == "AG") {
                  cfTgtList = $filter('filter')(vm.tgtList, {AG: c.ClassfyId}, true);
                  cfTgtListR = $filter('filter')(vm.tgtList, {LvCd: "Red", AG: c.ClassfyId}, true);
                } else if(dt.cfCd == "PS") {
                  cfTgtList = $filter('filter')(vm.tgtList, {PS: c.ClassfyId}, true);
                  cfTgtListR = $filter('filter')(vm.tgtList, {LvCd: "Red", PS: c.ClassfyId}, true);
                } else if(dt.cfCd == "GR1") {
                  cfTgtList = $filter('filter')(vm.tgtList, {GR1: c.ClassfyId}, true);
                  cfTgtListR = $filter('filter')(vm.tgtList, {LvCd: "Red", GR1: c.ClassfyId}, true);
                } else if(dt.cfCd == "GR2") {
                  cfTgtList = $filter('filter')(vm.tgtList, {GR2: c.ClassfyId}, true);
                  cfTgtListR = $filter('filter')(vm.tgtList, {LvCd: "Red", GR2: c.ClassfyId}, true);
                } else if(dt.cfCd == "GR3") {
                  cfTgtList = $filter('filter')(vm.tgtList, {GR3: c.ClassfyId}, true);
                  cfTgtListR = $filter('filter')(vm.tgtList, {LvCd: "Red", GR3: c.ClassfyId}, true);
                } else if(dt.cfCd == "GR4") {
                  cfTgtList = $filter('filter')(vm.tgtList, {GR4: c.ClassfyId}, true);
                  cfTgtListR = $filter('filter')(vm.tgtList, {LvCd: "Red", GR4: c.ClassfyId}, true);
                }

                angular.forEach(angular.copy(vm.lvList), function(lv)
                {
                  var cnt = $filter('filter')(cfTgtList, {LvCd: lv.LvCd}, true).length;
                  var rate = cnt + "("+ (cnt / respCnt * 100).toFixed(1) +"%)";
                  dataList.push({LvCd: lv.LvCd, Type: lv.LvTxt, Cnt: cnt, Rate: rate});
                  cntTot = cntTot + cnt;
                });
                if(dt.cfCd == "GD") title = c.CodeValue;
                else title = c.ClassfyNm;

                // Red
                var cntR = cfTgtListR.length;
                dataListR.push({LvCd: "Red", Cnt: cntR});

                chtList.push({dataList: dataList, dataListR: dataListR, cntTot: cntTot, title: title}); // 진단결과별로 차트가 생성됨
              });
            }
          }
          // 3. 상위영역  ===========================================================================================
          else if(dt.chtType == "S1" && vm.isReport)
          {
            // 문항별 상위영역 평균점수
            if(dt.cfCd == "")
            {
              dataList = [];
              cntTot = 0;
              qList = [];

              angular.forEach(vm.qstSec1List, function(q, i)
              {
                var score = 0;
                var cnt = 0;
                var secTgt = [];
                qList[i] = {};

                var sList = $filter('filter')(vm.scoreList, {ParentQstSecId: q.QstSecId}, true);
                angular.forEach(sList, function(s)
                {
                  if(isNullOrEmpty(secTgt[s.SvyTgtId])) {
                    secTgt[s.SvyTgtId] = s.SvyTgtId;
                    secTgt.push(s.SvyTgtId);
                  }
                  score = score + (isNullOrEmpty(s.QstSecScore) ? 0 : s.QstSecScore);
                  cnt = cnt + 1;
                });

                var secScore = 0;
                // 상위영역의 평가유형에 따른 점수
                if(q.ScoringType == "C") secScore = (score > 0 ? (score / cnt) : 0);
                else if(q.ScoringType == "S") secScore = (score > 0 ? (score / secTgt.length) : 0);

                qList[i] = {
                  QstSecId: q.QstSecId,
                  QstSecNm: q.QstSecNm,
                  SecScore: secScore.toFixed(1)
                };
                cntTot = cntTot + cnt;
              });

              dataList.push({
                Type: "",
                ScoreList: qList,
              });
            }
            // 응답자별 문항별 상위영역 평균점수
            else if(dt.cfCd == "TGT")
            {
              dataList = [];
              cntTot = 0;

              angular.forEach(vm.tgtList, function(t)
              {
                qList = [];

                var sList = $filter('filter')(vm.scoreList, {SvyTgtId: t.SvyTgtId}, true);

                angular.forEach(vm.qstSec1List, function(q, i) {
                  var score = 0;
                  var secTgt = [];
                  var cnt = 0;
                  qList[i] = {};

                  var sList2 = $filter('filter')(sList, {ParentQstSecId: q.QstSecId}, true);
                  angular.forEach(sList2, function(s)
                  {
                    if(isNullOrEmpty(secTgt[s.SvyTgtId])) {
                      secTgt[s.SvyTgtId] = s.SvyTgtId;
                      secTgt.push(s.SvyTgtId);
                    }
                    score = score + (isNullOrEmpty(s.QstSecScore) ? 0 : s.QstSecScore);
                    cnt = cnt + 1;
                  });

                  var secScore = 0;
                  // 상위영역의 평가유형에 따른 점수
                  if(q.ScoringType == "C") secScore = (score > 0 ? (score / cnt) : 0);
                  else if(q.ScoringType == "S") secScore = (score > 0 ? (score / secTgt.length) : 0);

                  qList[i] = {
                    QstSecId: q.QstSecId,
                    QstSecNm: q.QstSecNm,
                    SecScore: secScore.toFixed(1)
                  };
                  cntTot = cntTot + cnt;
                });

                dataList.push({
                  Name: t.Name,
                  Score: t.Score.toFixed(1),
                  LvCd: t.LvCd,
                  LvTxt: t.LvTxt,
                  ScoreList: qList,
                });
              });
            }
            // 분류정보별 문항별 상위영역 평균점수
            else
            {
              angular.forEach(cfList, function(c)
              {
                var sList = [];
                qList = [];

                if(dt.cfCd == "GD") sList = $filter('filter')(angular.copy(vm.scoreList), {GD: c.Code}, true);
                else if(dt.cfCd == "AG") sList = $filter('filter')(angular.copy(vm.scoreList), {AG: c.ClassfyId}, true);
                else if(dt.cfCd == "PS") sList = $filter('filter')(angular.copy(vm.scoreList), {PS: c.ClassfyId}, true);
                else if(dt.cfCd == "GR1") sList = $filter('filter')(angular.copy(vm.scoreList), {GR1: c.ClassfyId}, true);
                else if(dt.cfCd == "GR2") sList = $filter('filter')(angular.copy(vm.scoreList), {GR2: c.ClassfyId}, true);
                else if(dt.cfCd == "GR3") sList = $filter('filter')(angular.copy(vm.scoreList), {GR3: c.ClassfyId}, true);
                else if(dt.cfCd == "GR4") sList = $filter('filter')(angular.copy(vm.scoreList), {GR4: c.ClassfyId}, true);

                angular.forEach(vm.qstSec1List, function(q, i)
                {
                  var score = 0;
                  var cnt = 0;
                  var secTgt = [];
                  qList[i] = {};

                  var sList2 = $filter('filter')(angular.copy(sList), {ParentQstSecId: q.QstSecId}, true);
                  angular.forEach(sList2, function(s)
                  {
                    if(isNullOrEmpty(secTgt[s.SvyTgtId])) {
                      secTgt[s.SvyTgtId] = s.SvyTgtId;
                      secTgt.push(s.SvyTgtId);
                    }
                    score = score + (isNullOrEmpty(s.QstSecScore) ? 0 : s.QstSecScore);
                    cnt = cnt + 1;
                  });

                  var secScore = 0;
                  // 상위영역의 평가유형에 따른 점수
                  if(q.ScoringType == "C") secScore = (score > 0 ? (score / cnt) : 0);
                  else if(q.ScoringType == "S") secScore = (score > 0 ? (score / secTgt.length) : 0);

                  qList[i] = {
                    QstSecId: q.QstSecId,
                    QstSecNm: q.QstSecNm,
                    SecScore: secScore.toFixed(1)
                  };
                  cntTot = cntTot + cnt;
                });

                dataList.push({
                  Type: (dt.cfCd == "GD" ? c.CodeValue : c.ClassfyNm),
                  GD: (dt.cfCd == "GD" ? c.Code : ""),
                  ScoreList: qList,
                });
              });
            }
            chtList.push({dataList: dataList, cntTot: cntTot});
          }
          // 4. 하위영역 평균점수 ===========================================================================================
          else if(dt.chtType == "S2" && vm.isReport)
          {
            // 상위영역별 데이터 생성
            for(var n = 1; n <= 5; n++)
            {
              var qstSec2List = $filter('filter')(angular.copy(vm.qstSecList), {QstSecNum: n, QstSecLevel: 2}, true);
              if(qstSec2List.length > 0)
              {
                dataList = [];
                cntTot = 0;
                qList = [];
                dataListR = [];
                qListR = [];

                // 문항별 하위영역 평균점수
                if(dt.cfCd == "")
                {
                  angular.forEach(qstSec2List, function(q, i)
                  {
                    var score = 0;
                    var cnt = 0;
                    qList[i] = {};
                    var sList = $filter('filter')(angular.copy(vm.scoreList), {QstSecId: q.QstSecId, QstSecNum: n}, true);
                    angular.forEach(sList, function(s) {
                      score = score + (isNullOrEmpty(s.QstSecScore) ? 0 : s.QstSecScore);
                      cnt = cnt + 1;
                    });
                    var secScore = (score > 0 ? (score / cnt) : 0);
                    qList[i] = {
                      QstSecId: q.QstSecId,
                      QstSecNm: q.QstSecNm,
                      ParentQstSecNm: q.ParentQstSecNm,
                      SecScore: secScore.toFixed(1)
                    };

                    // Red
                    var scoreR = 0;
                    var cntR = 0;
                    qListR[i] = {};
                    var sListR = $filter('filter')(angular.copy(vm.scoreList), {LvCd: "Red", QstSecId: q.QstSecId, QstSecNum: n}, true);
                    angular.forEach(sListR, function(s) {
                      scoreR = scoreR + (isNullOrEmpty(s.QstSecScore) ? 0 : s.QstSecScore);
                      cntR = cntR + 1;
                    });
                    var secScoreR = (scoreR > 0 ? (scoreR / cntR) : 0);
                    qListR[i] = {
                      QstSecId: q.QstSecId,
                      QstSecNm: q.QstSecNm,
                      ParentQstSecNm: q.ParentQstSecNm,
                      SecScore: secScoreR.toFixed(1)
                    };

                    cntTot = cntTot + cnt;
                  });

                  // Top3 체크를 위한 정렬
                  var qListSort = angular.copy(qList);
                  qListSort.sort(function(a,b){
                    var aSc = parseFloat(a.SecScore);
                    var bSc = parseFloat(b.SecScore);
                    return aSc > bSc ? -1 : aSc < bSc ? 1 : 0;
                  });

                  dataList.push({
                    Type: "",
                    QstSecNum: n,
                    ScoreList: qList,
                    ScoreListR: qListR,
                    Top1: (qListSort.length >= 3 ? qListSort[0].QstSecNm : ""),
                    Top2: (qListSort.length >= 3 ? qListSort[1].QstSecNm : ""),
                    Top3: (qListSort.length >= 3 ? qListSort[2].QstSecNm : ""),
                  });
                }
                // 분류정보별 문항별 하위영역 평균점수
                else
                {
                  angular.forEach(cfList, function(c)
                  {
                    var sList = [];
                    qList = [];
                    var sListR = [];
                    qListR = [];

                    if(dt.cfCd == "GD") {
                      sList = $filter('filter')(angular.copy(vm.scoreList), {GD: c.Code, QstSecNum: n}, true);
                      sListR = $filter('filter')(angular.copy(vm.scoreList), {LvCd: "Red", GD: c.Code, QstSecNum: n}, true);
                    } else if(dt.cfCd == "AG") {
                      sList = $filter('filter')(angular.copy(vm.scoreList), {AG: c.ClassfyId, QstSecNum: n}, true);
                      sListR = $filter('filter')(angular.copy(vm.scoreList), {LvCd: "Red", AG: c.ClassfyId, QstSecNum: n}, true);
                    } else if(dt.cfCd == "PS") {
                      sList = $filter('filter')(angular.copy(vm.scoreList), {PS: c.ClassfyId, QstSecNum: n}, true);
                      sListR = $filter('filter')(angular.copy(vm.scoreList), {LvCd: "Red", PS: c.ClassfyId, QstSecNum: n}, true);
                    } else if(dt.cfCd == "GR1") {
                      sList = $filter('filter')(angular.copy(vm.scoreList), {GR1: c.ClassfyId, QstSecNum: n}, true);
                      sListR = $filter('filter')(angular.copy(vm.scoreList), {LvCd: "Red", GR1: c.ClassfyId, QstSecNum: n}, true);
                    } else if(dt.cfCd == "GR2") {
                      sList = $filter('filter')(angular.copy(vm.scoreList), {GR2: c.ClassfyId, QstSecNum: n}, true);
                      sListR = $filter('filter')(angular.copy(vm.scoreList), {LvCd: "Red", GR2: c.ClassfyId, QstSecNum: n}, true);
                    } else if(dt.cfCd == "GR3") {
                      sList = $filter('filter')(angular.copy(vm.scoreList), {GR3: c.ClassfyId, QstSecNum: n}, true);
                      sListR = $filter('filter')(angular.copy(vm.scoreList), {LvCd: "Red", GR3: c.ClassfyId, QstSecNum: n}, true);
                    } else if(dt.cfCd == "GR4") {
                      sList = $filter('filter')(angular.copy(vm.scoreList), {GR4: c.ClassfyId, QstSecNum: n}, true);
                      sListR = $filter('filter')(angular.copy(vm.scoreList), {LvCd: "Red", GR4: c.ClassfyId, QstSecNum: n}, true);
                    }

                    angular.forEach(qstSec2List, function(q, i)
                    {
                      var score = 0;
                      var cnt = 0;
                      qList[i] = {};
                      var sList2 = $filter('filter')(angular.copy(sList), {QstSecId: q.QstSecId}, true);
                      angular.forEach(sList2, function(s) {
                        score = score + (isNullOrEmpty(s.QstSecScore) ? 0 : s.QstSecScore);
                        cnt = cnt + 1;
                      });
                      var secScore = (score > 0 ? (score / cnt) : 0);
                      qList[i] = {
                        QstSecId: q.QstSecId,
                        QstSecNm: q.QstSecNm,
                        ParentQstSecNm: q.ParentQstSecNm,
                        SecScore: secScore.toFixed(1)
                      };

                      // Red
                      var scoreR = 0;
                      var cntR = 0;
                      qListR[i] = {};
                      var sList2R = $filter('filter')(angular.copy(sListR), {QstSecId: q.QstSecId}, true);
                      angular.forEach(sList2R, function(s) {
                        scoreR = scoreR + (isNullOrEmpty(s.QstSecScore) ? 0 : s.QstSecScore);
                        cntR = cntR + 1;
                      });
                      var secScoreR = (scoreR > 0 ? (scoreR / cntR) : 0);
                      qListR[i] = {
                        QstSecId: q.QstSecId,
                        QstSecNm: q.QstSecNm,
                        ParentQstSecNm: q.ParentQstSecNm,
                        SecScore: secScoreR.toFixed(1)
                      };

                      cntTot = cntTot + cnt;
                    });

                    // Top3 체크를 위한 정렬
                    var qListSort = angular.copy(qList);
                    qListSort.sort(function(a,b){
                      var aSc = parseFloat(a.SecScore);
                      var bSc = parseFloat(b.SecScore);
                      return aSc > bSc ? -1 : aSc < bSc ? 1 : 0;
                    });

                    dataList.push({
                      Type: (dt.cfCd == "GD" ? c.CodeValue : c.ClassfyNm),
                      GD: (dt.cfCd == "GD" ? c.Code : ""),
                      QstSecNum: n,
                      ScoreList: qList,
                      ScoreListR: qListR,
                      Top1: (qListSort.length >= 3 ? qListSort[0].QstSecNm : ""),
                      Top2: (qListSort.length >= 3 ? qListSort[1].QstSecNm : ""),
                      Top3: (qListSort.length >= 3 ? qListSort[2].QstSecNm : ""),
                    });
                  });
                }
                chtList.push({dataList: dataList, cntTot: cntTot, QstSecNum: n});
              }
            }
          }
          dt.chtList = chtList;
        });

        vm.dataloader = false;
      }

      // 분석 파일 다운로드, 보고서 생성
      function getFile(fType) {

        if(fType == "F"){
          if(isNullOrEmpty(vm.tgtList)){
            gAlert('', '대상자 분석을 실행하세요.');
            return;
          }
        }
        else {
          if(isNullOrEmpty(vm.srchAnal.SvyIds)){
            gAlert('', '설문을 선택하고 대상자 분석 후 응답정보 분석을 실행하세요.');
            return;
          }

          if(isNullOrEmpty(vm.respList)){
            gAlert('', '대상자 분석 후 응답정보 분석을 실행하세요.');
            return;
          }
        }

        vm.dataloader = true;

        var sList = [];
        var data = {};
        data.mapCode = "analysis";
        data.fileType = fType;

        switch(data.fileType)
        {
          case "O" :
            // 보고서
            data.tmpFileNm = vm.srch.tmpFileNm;
            data.fileNm = vm.srch.fileNm;
            data.fileDir = vm.srch.fileDir;
            data.RptNum = vm.srch.rptNum;
            data.RptNm = vm.srch.rptNm;
            data.RptType = vm.srch.rptType;
            data.srchUsrId =  $rootScope.gVariable.UserId;
            data.srchTenantId = $rootScope.gVariable.TenantId;
            data.ClientNm = vm.srch.ClientNm;
            data.SvyId = vm.srch.SvyId;
            data.SvyTypeId = vm.srch.SvyTypeId;
            data.SvyTypeCd = vm.srch.SvyTypeCd;
            data.SvyNm = vm.srch.SvyNms;
            data.SvyDate = vm.srch.SvyDate;
            data.SvyStatus = vm.srch.SvyStatus;
            data.QstCnt = vm.srch.QstCnt;
            break;

          case "A" :
            // 차트 엑셀
            data.tmpFileNm = "Analysis_org.xlsx"; // 템플릿 파일명
            data.fileNm = "Analysis_Chart.xlsx"; // 저장될 파일명
            data.fileDir = "wjm-report";
            break;

          case "F" :
            // 분류별 빈도표
            data.fileNm = "Analysis_Frequency.xlsx"; // 저장될 파일명
            data.fileDir = "wjm-report";

            data.SvyTgtIds = [];
            angular.forEach(vm.tgtList, function(tgt) {
              data.SvyTgtIds.push(tgt.SvyTgtId);
            });

            data.SvyIds = vm.srchAnal.SvyIds;
            data.ClassfyInfoId = vm.srchAnal.ClassfyInfoId;
            data.qstList = vm.qstList;
            //console.error("SvyIds",data.SvyIds);

            break;
        }

        // "사용" 체크된 데이터유형을 순서대로 정렬하여 대상으로 담기
        var dList = [];
        for(var s = 0; s < vm.dataTypeList.length; s++){
          sList = $filter('filter')(vm.dataTypeList, {typeSort: s, useChk: true}, true);
          for(var d = 0; d < sList.length; d++){
            dList.push(sList[d]);
          }
        }
        data.dataTypeList = dList;
        data.TgtCnt = vm.srchAnal.TgtCnt;
        data.tgtList = vm.tgtList;
        data.tgtScoreList = vm.scoreList;
        data.respList = vm.respList;
        data.respCntList = vm.respCntList;
        data.gdList = vm.gdList;
        data.psList = vm.psList;

        //console.error("respCntList",vm.respCntList);

        postApi.wjmReport(data, function(result){
            vm.dataloader = false;

        }, function (error) {
          // 조회 중 오류 발생
          vm.dataloader = false;
          console.error("Error> getFile");
          console.table(error);
        });
      }

      // 함수 정의
      vm.goPage = goPage;             // 페이지 이동
      vm.getTgtData = getTgtData;   // 대상자 분석 조회
      vm.getRespData = getRespData;   // 응답정보 분석 조회
      vm.getAssociData = getAssociData;   // 연관분석 조회
      vm.getAssociExcel = getAssociExcel; // 연관분석 엑셀 다운로드
      vm.setQstItem = setQstItem; // 보기정보 조회
      vm.goTargetList = goTargetList; // 분석 결과보기
      vm.goPreview = goPreview; // 미리보기
      vm.getFile = getFile; // 분석 파일
    }]);
})();

/**
 * [chartjs-plugin-labels]{@link https://github.com/emn178/chartjs-plugin-labels}
 *
 * @version 1.1.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2017-2018
 * @license MIT
 */
(function () {
  'use strict';

  if (typeof Chart === 'undefined') {
    console.error('Can not find Chart object.');
    return;
  }

  if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) {
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      var to = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
          for (var nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    };
  }

  var SUPPORTED_TYPES = {};
  ['pie', 'doughnut', 'polarArea'].forEach(function (t) {
    SUPPORTED_TYPES[t] = true;
  });

  function Label() {
    this.renderToDataset = this.renderToDataset.bind(this);
  }

  Label.prototype.setup = function (chart, options) {
    this.chart = chart;
    this.ctx = chart.ctx;
    this.args = {};
    this.barTotal = {};
    var chartOptions = chart.config.options;
    this.options = Object.assign({
      position: 'default',
      precision: 0,
      fontSize: chartOptions.defaultFontSize,
      fontColor: chartOptions.defaultFontColor,
      fontStyle: chartOptions.defaultFontStyle,
      fontFamily: chartOptions.defaultFontFamily,
      shadowOffsetX: 3,
      shadowOffsetY: 3,
      shadowColor: 'rgba(0,0,0,0.3)',
      shadowBlur: 6,
      images: [],
      outsidePadding: 2,
      textMargin: 2,
      overlap: true
    }, options);
    if (chart.config.type === 'bar') {
      this.options.position = 'default';
      this.options.arc = false;
      this.options.overlap = true;
    }
  };

  Label.prototype.render = function () {
    this.labelBounds = [];
    this.chart.data.datasets.forEach(this.renderToDataset);
  };

  Label.prototype.renderToDataset = function (dataset, index) {
    this.totalPercentage = 0;
    this.total = null;
    var arg = this.args[index];
    arg.meta.data.forEach(function (element, index) {
      this.renderToElement(dataset, arg, element, index);
    }.bind(this));
  };

  Label.prototype.renderToElement = function (dataset, arg, element, index) {
    if (!this.shouldRenderToElement(arg.meta, element)) {
      return;
    }
    this.percentage = null;
    var label = this.getLabel(dataset, element, index);
    if (!label) {
      return;
    }
    var ctx = this.ctx;
    ctx.save();
    ctx.font = Chart.helpers.fontString(this.options.fontSize, this.options.fontStyle, this.options.fontFamily);
    var renderInfo = this.getRenderInfo(element, label);
    if (!this.drawable(element, label, renderInfo)) {
      ctx.restore();
      return;
    }
    ctx.beginPath();
    ctx.fillStyle = this.getFontColor(dataset, element, index);
    this.renderLabel(label, renderInfo);
    ctx.restore();
  };

  Label.prototype.renderLabel = function (label, renderInfo) {
    return this.options.arc ? this.renderArcLabel(label, renderInfo) : this.renderBaseLabel(label, renderInfo);
  };

  Label.prototype.renderBaseLabel = function (label, position) {
    var ctx = this.ctx;
    if (typeof label === 'object') {
      ctx.drawImage(label, position.x - label.width / 2, position.y - label.height / 2, label.width, label.height);
    } else {
      ctx.save();
      ctx.textBaseline = 'top';
      ctx.textAlign = 'center';

      if (this.options.textShadow) {
        ctx.shadowOffsetX = this.options.shadowOffsetX;
        ctx.shadowOffsetY = this.options.shadowOffsetY;
        ctx.shadowColor = this.options.shadowColor;
        ctx.shadowBlur = this.options.shadowBlur;
      }

      var lines = label.split('\n');
      for (var i = 0; i < lines.length; i++) {
        var y = position.y - this.options.fontSize / 2 * lines.length + this.options.fontSize * i;
        ctx.fillText(lines[i], position.x, y);
      }
      ctx.restore();
    }
  };

  Label.prototype.renderArcLabel = function (label, renderInfo) {
    var ctx = this.ctx, radius = renderInfo.radius, view = renderInfo.view;
    ctx.save();
    ctx.translate(view.x, view.y);
    if (typeof label === 'string') {
      ctx.rotate(renderInfo.startAngle);
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'left';
      var lines = label.split('\n'), max = 0, widths = [], offset = 0;
      if (this.options.position === 'border') {
        offset = (lines.length - 1) * this.options.fontSize / 2;
      }
      for (var j = 0; j < lines.length; ++j) {
        var mertrics = ctx.measureText(lines[j]);
        if (mertrics.width > max) {
          max = mertrics.width;
        }
        widths.push(mertrics.width);
      }
      for (var j = 0; j < lines.length; ++j) {
        var line = lines[j];
        var y = (lines.length - 1 - j) * -this.options.fontSize + offset;
        ctx.save();
        var padding = (max - widths[j]) / 2;
        ctx.rotate(padding / radius);
        for (var i = 0; i < line.length; i++) {
          var char = line.charAt(i);
          mertrics = ctx.measureText(char);
          ctx.save();
          ctx.translate(0, -1 * radius);
          ctx.fillText(char, 0, y);
          ctx.restore();
          ctx.rotate(mertrics.width / radius);
        }
        ctx.restore();
      }
    } else {
      ctx.rotate((view.startAngle + Math.PI / 2 + renderInfo.endAngle) / 2);
      ctx.translate(0, -1 * radius);
      this.renderLabel(label, { x: 0, y: 0 });
    }
    ctx.restore();
  };

  Label.prototype.shouldRenderToElement = function (meta, element) {
    return !meta.hidden && !element.hidden && (
      this.options.showZero ||
      this.chart.config.type === 'polarArea' ? element._view.outerRadius !== 0 : element._view.circumference !== 0
    );
  };

  Label.prototype.getLabel = function (dataset, element, index) {
    var label;
    if (typeof this.options.render === 'function') {
      label = this.options.render({
        label: this.chart.config.data.labels[index],
        value: dataset.data[index],
        percentage: this.getPercentage(dataset, element, index),
        dataset: dataset,
        index: index
      });
    } else {
      switch (this.options.render) {
        case 'value':
          label = dataset.data[index];
          break;
        case 'label':
          label = this.chart.config.data.labels[index];
          break;
        case 'image':
          label = this.options.images[index] ? this.loadImage(this.options.images[index]) : '';
          break;
        case 'percentage':
        default:
          label = this.getPercentage(dataset, element, index) + '%';
          break;
      }
    }
    if (typeof label === 'object') {
      label = this.loadImage(label);
    } else if (label !== null && label !== undefined) {
      label = label.toString();
    }
    return label;
  };

  Label.prototype.getFontColor = function (dataset, element, index) {
    var fontColor = this.options.fontColor;
    if (typeof fontColor === 'function') {
      fontColor = fontColor({
        label: this.chart.config.data.labels[index],
        value: dataset.data[index],
        percentage: this.getPercentage(dataset, element, index),
        backgroundColor: dataset.backgroundColor[index],
        dataset: dataset,
        index: index
      });
    } else if (typeof fontColor !== 'string') {
      fontColor = fontColor[index] || this.chart.config.options.defaultFontColor;
    }
    return fontColor;
  };

  Label.prototype.getPercentage = function (dataset, element, index) {
    if (this.percentage !== null) {
      return this.percentage;
    }
    var percentage;
    if (this.chart.config.type === 'polarArea') {
      if (this.total === null) {
        this.total = 0;
        for (var i = 0;i < dataset.data.length; ++i) {
          this.total += dataset.data[i];
        }
      }
      percentage = dataset.data[index] / this.total * 100;
    } else if (this.chart.config.type === 'bar') {
      if (this.barTotal[index] === undefined) {
        this.barTotal[index] = 0;
        for (var i = 0;i < this.chart.data.datasets.length; ++i) {
          this.barTotal[index] += this.chart.data.datasets[i].data[index];
        }
      }
      percentage = dataset.data[index] / this.barTotal[index] * 100;
    } else {
      percentage = element._view.circumference / this.chart.config.options.circumference * 100;
    }
    percentage = parseFloat(percentage.toFixed(this.options.precision));
    if (!this.options.showActualPercentages) {
      if (this.chart.config.type === 'bar') {
        this.totalPercentage = this.barTotalPercentage[index] || 0;
      }
      this.totalPercentage += percentage;
      if (this.totalPercentage > 100) {
        percentage -= this.totalPercentage - 100;
        percentage = parseFloat(percentage.toFixed(this.options.precision));
      }
      if (this.chart.config.type === 'bar') {
        this.barTotalPercentage[index] = this.totalPercentage
      }
    }
    this.percentage = percentage;
    return percentage;
  };

  Label.prototype.getRenderInfo = function (element, label) {
    if (this.chart.config.type === 'bar') {
      return this.getBarRenderInfo(element, label);
    } else {
      return this.options.arc ? this.getArcRenderInfo(element, label) : this.getBaseRenderInfo(element, label);
    }
  };

  Label.prototype.getBaseRenderInfo = function (element, label) {
    if (this.options.position === 'outside' || this.options.position === 'border') {
      var renderInfo, rangeFromCentre,
        view = element._view,
        centreAngle = view.startAngle + (view.endAngle - view.startAngle) / 2,
        innerRadius = view.outerRadius / 2;
      if (this.options.position === 'border') {
        rangeFromCentre = (view.outerRadius - innerRadius) / 2 + innerRadius;
      } else if (this.options.position === 'outside') {
        rangeFromCentre = (view.outerRadius - innerRadius) + innerRadius + this.options.textMargin;
      }
      renderInfo = {
        x: view.x + (Math.cos(centreAngle) * rangeFromCentre),
        y: view.y + (Math.sin(centreAngle) * rangeFromCentre)
      };
      if (this.options.position === 'outside') {
        var offset = this.options.textMargin + this.measureLabel(label).width / 2;
        renderInfo.x += renderInfo.x < view.x ? -offset : offset;
      }
      return renderInfo;
    } else {
      return element.tooltipPosition();
    }
  };

  Label.prototype.getArcRenderInfo = function (element, label) {
    var radius, view = element._view;
    if (this.options.position === 'outside') {
      radius = view.outerRadius + this.options.fontSize + this.options.textMargin;
    } else if (this.options.position === 'border') {
      radius = (view.outerRadius / 2 + view.outerRadius) / 2;
    } else {
      radius = (view.innerRadius + view.outerRadius) / 2;
    }
    var startAngle = view.startAngle, endAngle = view.endAngle;
    var totalAngle = endAngle - startAngle;
    startAngle += Math.PI / 2;
    endAngle += Math.PI / 2;
    var mertrics = this.measureLabel(label);
    startAngle += (endAngle - (mertrics.width / radius + startAngle)) / 2;
    return {
      radius: radius,
      startAngle: startAngle,
      endAngle: endAngle,
      totalAngle: totalAngle,
      view: view
    }
  };

  Label.prototype.getBarRenderInfo = function (element, label) {
    var renderInfo = element.tooltipPosition();
    renderInfo.y -= this.measureLabel(label).height / 2 + this.options.textMargin;
    return renderInfo;
  };

  Label.prototype.drawable = function (element, label, renderInfo) {
    if (this.options.overlap) {
      return true;
    } else if (this.options.arc) {
      return renderInfo.endAngle - renderInfo.startAngle <= renderInfo.totalAngle;
    } else {
      var mertrics = this.measureLabel(label),
        left = renderInfo.x - mertrics.width / 2,
        right = renderInfo.x + mertrics.width / 2,
        top = renderInfo.y - mertrics.height / 2,
        bottom = renderInfo.y + mertrics.height / 2;
      if (this.options.renderInfo === 'outside') {
        return this.outsideInRange(left, right, top, bottom);
      } else {
        return element.inRange(left, top) && element.inRange(left, bottom) &&
          element.inRange(right, top) && element.inRange(right, bottom);
      }
    }
  };

  Label.prototype.outsideInRange = function (left, right, top, bottom) {
    var labelBounds = this.labelBounds;
    for (var i = 0;i < labelBounds.length;++i) {
      var bound = labelBounds[i];
      var potins = [
        [left, top],
        [left, bottom],
        [right, top],
        [right, bottom]
      ];
      for (var j = 0;j < potins.length;++j) {
        var x = potins[j][0];
        var y = potins[j][1];
        if (x >= bound.left && x <= bound.right && y >= bound.top && y <= bound.bottom) {
          return false;
        }
      }
      potins = [
        [bound.left, bound.top],
        [bound.left, bound.bottom],
        [bound.right, bound.top],
        [bound.right, bound.bottom]
      ];
      for (var j = 0;j < potins.length;++j) {
        var x = potins[j][0];
        var y = potins[j][1];
        if (x >= left && x <= right && y >= top && y <= bottom) {
          return false;
        }
      }
    }
    labelBounds.push({
      left: left,
      right: right,
      top: top,
      bottom: bottom
    });
    return true;
  };

  Label.prototype.measureLabel = function (label) {
    if (typeof label === 'object') {
      return { width: label.width, height: label.height };
    } else {
      var width = 0;
      var lines = label.split('\n');
      for (var i = 0; i < lines.length; ++i) {
        var result = this.ctx.measureText(lines[i]);
        if (result.width > width) {
          width = result.width;
        }
      }
      return { width: width, height: this.options.fontSize * lines.length };
    }
  };

  Label.prototype.loadImage = function (obj) {
    var image = new Image();
    image.src = obj.src;
    image.width = obj.width;
    image.height = obj.height;
    return image;
  };

  Chart.plugins.register({
    id: 'labels',
    beforeDatasetsUpdate: function (chart, options) {
      if (!SUPPORTED_TYPES[chart.config.type]) {
        return;
      }
      if (!Array.isArray(options)) {
        options = [options];
      }
      var count = options.length;
      if (!chart._labels || count !== chart._labels.length) {
        chart._labels = options.map(function () {
          return new Label();
        });
      }
      var someOutside = false, maxPadding = 0;
      for (var i = 0; i < count; ++i) {
        var label = chart._labels[i];
        label.setup(chart, options[i]);
        if (label.options.position === 'outside') {
          someOutside = true;
          var padding = label.options.fontSize * 1.5 + label.options.outsidePadding;
          if (padding > maxPadding) {
            maxPadding = padding;
          }
        }
      }
      if (someOutside) {
        chart.chartArea.top += maxPadding;
        chart.chartArea.bottom -= maxPadding;
      }
    },
    afterDatasetUpdate: function (chart, args, options) {
      if (!SUPPORTED_TYPES[chart.config.type]) {
        return;
      }
      chart._labels.forEach(function (label) {
        label.args[args.index] = args;
      });
    },
    beforeDraw: function (chart) {
      if (!SUPPORTED_TYPES[chart.config.type]) {
        return;
      }
      chart._labels.forEach(function (label) {
        label.barTotalPercentage = {};
      });
    },
    afterDatasetsDraw: function (chart) {
      if (!SUPPORTED_TYPES[chart.config.type]) {
        return;
      }
      chart._labels.forEach(function (label) {
        label.render();
      });
    }
  });
})();

webapp.controller('ClassfyInfoEditCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
  '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', '$http',
  function ClassfyInfoEditCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, api, modalFactory,
    $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate, $http) {


    // SQL Mapper Id 정의
    var INSERT_SQL = 'WjmSurvey.insertClassfyInfo';     // 등록 SQL
    var UPDATE_SQL = 'WjmSurvey.updateClassfyInfo';     // 수정 SQL
    var VIEW_SQL = 'WjmSurvey.getClassfyInfoDetail'; // 조회 SQL
    var DEL_SQL = 'WjmSurvey.deleteClassfyInfoDetailBatch';  // 삭제 SQL

    var TREE_VIEW_SQL = 'WjmSurvey.getClassfyList'; // 트리조회 SQL
    var TREE_SAVE_SQL = 'WjmSurvey.saveClassfyBatch';  // 트리 등록/수정/삭제 SQL

    // 관련 화면 정의
    var LIST_PAGE_URL = 'app.survey.classfy-info-list';             // 목록 화면
    var LIST_EDIT_PAGE_URL = 'app.survey.classfy-info-list.edit'; // 목록 수정 화면
    var EDIT_PAGE_URL = 'app.survey.classfy-info-edit';           // 수정 화면

    // 관련 테이블 정의
    var VIEW_TABLE_NM = 'wjm.classfyinfo'; // 조회용 테이블명
    var EDIT_TABLE_NM = 'wjmclassfyinfo'; // 저장용 테이블명
    var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};
    vm.treelist = [];
    vm.treedata = {};
    vm.data = {};

    // my_tree 반드시 선언하기
    var tree;
    $scope.my_tree = tree = {};


    vm.excelFile = {};

    vm.selItem = null;

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
        keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
        tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : VIEW_TABLE_NM, // 작업 테이블명
        srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.keyId = $stateParams.keyId;
    }

    vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

    // Key Data 설정
    if (!isNullOrEmpty($stateParams.keyId)) {
      vm.srch.keyId = $stateParams.keyId;
    }

    // 조회 데이터 설정
    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
    vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

    // 등록/수정 표시용 컬럼 목록
    vm.srchDetail.editColumns = {};

    // 조회 데이터
    vm.data = {
      KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
      tableNm: VIEW_TABLE_NM
    };


    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true; // Progressbar 표시

      if (isNullOrEmpty(vm.srch.keyId)) {
        vm.dataloader = false;  // Progressbar 숨김
      }
      vm.srchDetail.viewColumns = {}; // 조회 컬럼

      var data = vm.srchDetail;
      data.mapCode = VIEW_SQL;

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          vm.dataloader = false; // Progressbar 숨김

          if (result.body.desc.length > 0) {
            // 사용자정의 컬럼 설정
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            vm.data = result.body.docs[0];
            vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
            vm.tmpClassfyInfoCd = vm.data.ClassfyInfoCd;

          } else {
            console.log('nodata');
            vm.data.TenantId = $rootScope.gVariable.srchTenantId;
            vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
          }
        } else {
          vm.dataloader = false; // Progressbar 숨김

          console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }

      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    }



    /**
     * 등록/수정 화면에 표시할 컬럼인지 여부 확인
     *
     * @param {string} columnNm - 물리 컬럼명
     * @return {boolean} true - 존재시, false - 미 존재시
     */
    function getIsShowColumn(columnNm) {
      var result = false;
      var itemIndex = vm.srch.editColumns.indexOf(columnNm);

      result = (itemIndex > -1);
      return result;
    }


    // 설문유형코드 중복 체크
    function getIsDupClassfyInfoCd() {
      var data = vm.data;
        data.mapCode = DUPCHK_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            vm.dupClassfyInfoCd = result.body.docs.length;
          } else {
            gAlert('', result.body.docs[0].errMessage);
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
    }

    /**
     * 필수항목 체크
     * @param
     * @return
     */
    function getIsValidData() {
      // #region 필수항목 체크
      var errMsg = '';
      if (isNullOrEmpty(vm.data.ClassfyInfoNm)) {
        errMsg = errMsg + '- 분류정보명을 입력하세요.<br/>';
      }
      if (isNullOrEmpty(vm.data.Manager)) {
        errMsg = errMsg + '- 업체를 선택하세요.<br/>';
      }
      if (isNullOrEmpty(vm.data.UseYN)) {
        errMsg = errMsg + '- 사용여부를 선택하세요.<br/>';
      }
      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      return true;
      // #endregion 필수항목 체크
    }



    /**
     * 데이터 저장
     *
     * @param
     * @return
     */
    function setData() {

      if (getIsValidData() == false) {
        return;
      }

      // 내용
      vm.data.tableNm = EDIT_TABLE_NM;             // 작업 테이블명
      vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
      vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

      var data = vm.data; // 사용자 입력 데이터

      if (isNullOrEmpty(vm.data.keyId)) {
        // 신규 등록
        data.mapCode = INSERT_SQL;

        postApi.insert(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      } else {
        // 수정
        data.RelateDataId = data.keyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }
    }

    /**
     * 데이터 저장 후 처리
     *
     * @param result - 저장 결과
     * @return
     */
    function setInsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].KeyId !== null ||
          result.body.docs[0].NewKeyId !== null ||
          result.body.docs[0].RelateDataId !== null
        ) {
          // KeyId 조회
          if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
            vm.data.KeyId = result.body.docs[0].NewKeyId;
          } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
            vm.data.KeyId = result.body.docs[0].KeyId;
          } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
            vm.data.KeyId = result.body.docs[0].RelateDataId;
          }

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function () {
              // 화면 분할 모드에 따른 이동
              goNextPage(true);
            }
          });
          return;
        }
      }

      console.error("Error> setInsertUpdateDetail()");
      gAlert('', result.body.docs[0].errMessage);
    }

    /**
     * 목록 화면 이동
     *
     * @param
     * @return
     */
    function goList() {
      vm.srch.keyId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, {srch: srch});
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch;

      if (vm.layout == 'N') {
        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: vm.data.KeyId
        }, {reload:EDIT_PAGE_URL});
      } else {
        if (reloadList) {
          var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
          srch2.keyId = '';
          srch2.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(srch2, replacer));
        }

        // 조회 화면 이동
        $state.go(LIST_EDIT_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
      }
    }




    /**
     * 데이터 삭제 확인
     *
     * @param
     * @return
     */
    function setDelData() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn: '',
        fn: function () {
          // 데이터 삭제
          setDelDataAction();
        }
      }, {
        btn: '',
        fn: function () {
          // 취소
        }
      });
    }

    /**
     * 데이터 삭제
     *
     * @param
     * @return
     */
    function setDelDataAction() {
      if (vm.data == null) {
        // 삭제할 데이터 미 존재
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      vm.data.tableNm = EDIT_TABLE_NM;

      var data = vm.data;
      data.mapCode = DEL_SQL;
      postApi.update(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn: '',
            fn: function () {
              // 삭제 성공
              var srch = $stateParams.srch;

              // 목록 화면 이동
              $state.go(LIST_PAGE_URL, {
                  srch: srch
                },
                {reload: LIST_PAGE_URL});
            }
          });

        }
      }, function (error) {
        // 삭제 중 오류 발생
        console.error("Error> delDataAction()");
        console.table(error);
      });
    }



    // 트리 초기화
    function resetList() {
      vm.treedata = {};
      getTreeList();
    }

    // 계층형 json 구조로 변환
    function unflatten(items) {
      // 다시 설정(배치)하는 부분
      return items.reduce(insert, {
        res : [],
        map : {}
      }).res;
    }

    // guid, parent 제외한 계층형 json 구조 변환하기
    function traverse(jsonObj) {

      for (var i = 0; i < jsonObj.length; i++) {
        if (jsonObj[i].children == null) {
        } else {
          traverse(jsonObj[i].children);
        }

        // label, children 만 추가함
        var newItem = {
          "label" : jsonObj[i].label,
          "data" : jsonObj[i].guid,
          "children" : jsonObj[i].children,
          "classes" : jsonObj[i].classes,
        };
        jsonObj[i] = newItem;
      }
    }

    // 트리 새로고침
    function refreshTree() {

      // 리스트 생성
      var arrlist = [];

      // for문으로 다시 json 구조로 변환함.
      angular.forEach(vm.treelist, function(item) {
        // 객체 생성
        var data = {};

        data.label = $translate.instant(item.ClassfyNm);
        data.guid = item.ClassfyId;
        data.parent = item.ClassfyCd == undefined || item.ClassfyCd == '0' ? null : item.ClassfyCd;
        data.classes = [];

        // 리스트에 생성된 객체 삽입
        arrlist.push(data);
      });

      // 계층형 json 구조로 변환함
      var recursiveArray = unflatten(arrlist);

      // guid, parent 제외 변환함
      traverse(recursiveArray);

      // 트리구조에 바인딩
      $scope.my_data = recursiveArray;
    }

    // 트리 조회
    function getTreeList() {
      // 사전에 트리 선언함.(중요포인트)
      vm.dataloader = true;
      $scope.my_data = [];

      // 로케이션관리 select 검색실행함
      var data = vm.srch;
      data.mapCode = TREE_VIEW_SQL;
      postApi.select(data, function(result) {
        vm.dataloader = false;

        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length == 0) {
            return;
          }

          // select한 datatable 바인딩
          vm.treelist = result.body.docs;

          refreshTree();
        }
      }, function(error) {
        vm.dataloader = false;
        console.error('fail', status, data);
      });
    }

    // 트리 목록에서 선택
    $scope.my_tree_handler = function(branch) {
      angular.forEach(vm.treelist, function(item) {
        if (branch.data == item.ClassfyId.toString()) {
          vm.treedata = item;
          return;
        }
      });
    };

    // 추가
    $scope.try_adding_a_branch = function() {

      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
      var qstSecId = newnum.toString(36);
      var branch = tree.get_selected_branch();

      // 상위 분류는 자동 생성, 하우 분류만 생성 가능
      if (branch != null) {
        angular.forEach(vm.treelist, function(item) {
          if (branch.data == item.ClassfyId.toString()) {
            var qstSecInfo = {
              'ClassfyNm' : '',
              'ClassfyId' : qstSecId,
              'ClassfyCd' : branch.data,
              'ClassfyInfoId' : vm.srch.keyId,
              'ClassfyLevel' : item.ClassfyLevel + 1,
              'New' : 'Y',
              'TenantId' : $rootScope.gVariable.srchTenantId
            };
            vm.treelist.push(qstSecInfo);
            return;
          }
        });
      }

      var code = {};
      code = {label: '분류 정보를 입력하세요.', data: qstSecId};

      var new_branch = tree.add_branch(branch, code);
      tree.select_branch(new_branch);
    };

    // 삭제
    function delNode() {
      var qstSecId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
        $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
        return;
      }

      gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
        btn : '',
        fn : function(){
          if (vm.treedata.New == 'Y'){
            deleteNodeTree();
          }else {
            vm.treedata.DelYN = 'Y';
            saveData();
          }
        }
      }, {
        btn : '',
        fn : function(){
        }
      });
    }

    // 삭제 실행
    function deleteNodeTree() {
      var qstSecId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      angular.forEach(vm.treelist, function(item) {
        if (branch.data == item.ClassfyId.toString()) {
          var index = vm.treelist.indexOf(item);
          vm.treelist.splice(index, 1);

          var parent = tree.select_parent_branch();
          if(parent){
            parent.children.splice(parent.children.indexOf(branch),1);
          } else {
            refreshTree();
          }

          return;
        }
      });

      tree.select_branch(null);
      vm.treedata = {};
    }

    function onChangeClassfyNm() {
      onChanged();
      var branch = tree.get_selected_branch();
      if (branch == null) return;
      branch.label = vm.treedata.ClassfyNm;
    }

    function onChanged() {
      if (vm.treedata.New == null || vm.treedata.New != 'Y') {
        vm.treedata.Edit = 'Y';
      }
    }

    // 저장
    function saveData() {
      vm.dataloader = true;
      var data = {lists : []};
      data.mapCode = TREE_SAVE_SQL;

      if (isNullOrEmpty(vm.treedata.SortSeq)) vm.treedata.SortSeq = 0;

      data.lists.push(vm.treedata);
      postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            var branch = tree.get_selected_branch();
            branch.label = branch.label.replace(/^\[\*\]/,"");

            if (vm.treedata.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.treedata.New = '';
            } else if (vm.treedata.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.treedata.Edit = '';
            }
          }
        },

        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

    }

    // 저장 실행
    function insert(obj, item) {
      var parent = item.parent; // 부모값
      var map = obj.map;
      map[item.guid] = item; // 아이템 구성함

      if (parent === null)
        obj.res.push(item); // 부모값 생성
      else {
        var parentItem = map[parent];
        // 자식값 생성
        if (parentItem != null) {
          if (parentItem.hasOwnProperty("children"))
            parentItem.children.push(item);
          else
            parentItem.children = [ item ];
        }
      }
      return obj;
    }

    // 업체 검색
    vm.srchUserModal = function () {
      var ctrl = 'WjmUserModalCtrl as modalCtrl';
      var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
      var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        vm.data.ManagerNm = okData.UserNm;
        vm.data.Manager = okData.UserId;
      }, function (cancelData) {
      });
    };
    vm.eraseUser = function () {
      vm.data.ManagerNm = "";
      vm.data.Manager = "";
    };

    // 양식 다운로드
    function doDownload()  {
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileName = "분류 일괄업로드 양식";
      var exportData = [];

      exportData.push(["분류(고정)", "값(예시)"]);

      //var arrGD = ["남", "여"];
      //angular.forEach(arrGD, function(d) { exportData.push(["성별", d]); });
      var arrAG = ["10대", "20대", "30대", "40대", "50대", "60대", "70대"];
      angular.forEach(arrAG, function(d) { exportData.push(["연령대", d]); });
      var arrPS = ["대표", "부장", "과장", "대리", "사원"];
      angular.forEach(arrPS, function(d) { exportData.push(["직급", d]); });
      var arrCC = ["사과", "딸기"];
      angular.forEach(arrCC, function(d) { exportData.push(["상담사코드", d]); });
      var arrCC = ["test@test.com"];
      angular.forEach(arrCC, function(d) { exportData.push(["이메일", d]); });
      for(var i = 1; i <= 4; i++){ exportData.push(["그룹"+ i, ""]); }

      $rootScope.excelDown(exportData, fileName);
    }


    // 일괄 업로드 체크
    function chkUpload()  {
      gConfirm('', '기존 데이터는 삭제됩니다. 진행하시겠습니까?', {
        btn: '',
        fn: function () {
          doUpload();
        }
      }, {
        btn: '',
        fn: function () {
        }
      });
    }

    // 일괄 업로드
    function doUpload()  {
      vm.dataloader = true;

      var file = $("input[name=excelFile]")[0].files[0];
      var formData = new FormData();
      var uploadUrl = "excelUpload/WjmSurvey.updateClassfyExcelBatch/action.json";
      var ext = file.name.split('.').pop().toLowerCase();

      if(file == undefined || $.inArray(ext, ['xlsx']) == -1){
        vm.dataloader = false;
        gAlert('', 'xlsx 형식의 파일을 선택하세요.');
        return;
      }

      formData.append("mFile",file);
      formData.append("ext",ext);
      formData.append("ClassfyInfoId", vm.data.KeyId);
      formData.append("SESSION_USERID", $rootScope.gVariable.UserId);
      formData.append("SESSION_TENANTID", $rootScope.gVariable.TenantId);

      $http({
        url: uploadUrl,
        method: "POST",
        data: formData,
        transformRequest: angular.identity,
        headers: {'Content-type': undefined}
      }).success(function (data, status, headers, config) {
        vm.dataloader = false;
        gAlert('', data.responseVO.body.docs[0].message.replace(/<br>/gi, "\r\n"));
        getTreeList();
      }).error(function (data, status, headers, config) {
        vm.dataloader = false;
        gAlert('', '오류가 발생했습니다.');
      });
      vm.dataloader = false;
    }


    // 함수 선언
    //--------------------------------- 트리
    vm.resetList = resetList;
    vm.getTreeList = getTreeList;
    vm.delNode = delNode;
    vm.saveData = saveData;
    vm.onChangeClassfyNm = onChangeClassfyNm;
    vm.onChanged = onChanged;
    //--------------------------------- 트리

    vm.getData = getData;                     // 데이터 조회
    vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
    vm.setData = setData;                     // 데이터 저장
    vm.goList = goList;                       // 목록 화면 이동
    vm.setDelData = setDelData;                     // 데이터 삭제
    vm.getIsDupClassfyInfoCd = getIsDupClassfyInfoCd;         // 설문유형코드 중복 체크

    vm.doDownload = doDownload; // 양식 다운로드
    vm.doUpload = doUpload; // 일괄 업로드
    vm.chkUpload = chkUpload; // 일괄 업로드 체크

    // 데이터 조회
    getData();

    // 트리 조회
    getTreeList();

  }]);



(function () {
  "use strict";

  webapp.controller('ClassfyInfoListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function ClassfyInfoListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSurvey.getClassfyInfoListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSurvey.getClassfyInfoList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.classfy-info-list';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.survey.classfy-info-list.edit';    // 목록 등록/수정 화면
      var EDIT_PAGE_URL = 'app.survey.classfy-info-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.classfyinfo'; // 작업 테이블명
      var KEY_COLUMN_NM = 'ClassfyInfoId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 업체 검색
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      // 목록 조회
      getList();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.survey:client-editctrl
   * @description Controller of the 업체정보 등록/수정
   */

  webapp.controller('ClientEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function ClientEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmSystem.insertUser';     // 등록 SQL
      var UPDATE_SQL = 'WjmSystem.updateUser';     // 수정 SQL
      var VIEW_SQL = 'WjmSystem.getUserMgrDetail'; // 조회 SQL
      var DEL_SQL = 'WjmSystem.deleteUserDetail';  // 삭제 SQL
      var GETID_SQL = 'checkLoginId';         // 아이디중복체크 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.client-list';             // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.survey.client-list.edit'; // 목록 수정 화면
      var EDIT_PAGE_URL = 'app.survey.client-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.client'; // 조회용 테이블명
      var EDIT_TABLE_NM = 'users'; // 저장용 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }
      vm.srch.srchUserGubun = "DEFAULT";

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );
        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      // #endregion 첨부파일 Callback

      /**
       * 역할 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserroleModal = function () {
        var ctrl = 'UserroleModalCtrl as vc';
        var paramData = {
          TenantId: vm.data.TenantId,
          UserRoles: vm.data.UserRoles
        };

        var modalInstance = modalFactory.open('modal', 'components/modal/userRole/userrole-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 역할 선택
          vm.data.UserRoles = okData;
          var UserRoleNms = [];
          var UserRoleIds = [];
          angular.forEach(vm.data.UserRoles, function (role) {
            UserRoleNms.push(role.RoleNm);
            UserRoleIds.push(role.RoleId);
          });

          vm.data.UserRoleNms = UserRoleNms.join(',');
          vm.data.UserRoleIds = UserRoleIds.join(',');

        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 역할 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUserRole = function () {
        vm.data.UserRoleIds = "";
        vm.data.UserRoleNms = "";
      };

      // #endregion 역할 검색 팝업 호출


      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.tableNm = KEY_TABLE_NM;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              vm.tmpEmail = vm.data.Email;

              // 역할 설정
              vm.data.UserRoles = [];
              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });

              getUploadFileList("1");
            } else {
              console.log('nodata');
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.LoginId)) {
          errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.keyId)) {
          if (isNullOrEmpty(vm.data.checkedLoginId)) {
            errMsg = errMsg + '- 중복된 아이디인지 체크하세요.<br/>';
          }
        }
        if (isNullOrEmpty(vm.data.UserNm)) {
          errMsg = errMsg + '- 업체명을 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.UseYN)) {
          errMsg = errMsg + '- 사용여부를 선택하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.Mobile)) {
          errMsg = errMsg + '- 휴대폰을 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.Email)) {
          errMsg = errMsg + '- 이메일을 입력하세요.<br/>';
        }
        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        }
        else if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList(grpId) {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.tableNm = EDIT_TABLE_NM;
        data.TableId = vm.srch.keyId;
        data.grpId = grpId;
        data.mapCode = 'FileAttach.getFileListOri';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {

            var uploadFileList = [];

            angular.forEach(result.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalFolderNm + "&fileName=" + item.LogicalFileNm),
                src: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                typeId: 'file',
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
                delState: ''
              };

              uploadFileList.push(obj);
            });

            if (grpId == 1) {
              vm.uploadFileList = angular.copy(uploadFileList);
              getUploadFileList("2");
            }
            else {
              vm.uploadFileList2 = angular.copy(uploadFileList);
            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });

        // 내용
        vm.data.tableNm = EDIT_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        vm.data.UserGubun = vm.srch.srchUserGubun;

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          // 최초 비밀번호는 아이디
          data.Password = data.LoginId;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(EDIT_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:EDIT_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }


      /**
       * 아이디 중복 체크
       *
       * @param
       * @return
       */
      function getIsDupLoginId() {
        var data = vm.data;

        if (isNullOrEmpty(vm.data.LoginId)) {
          return;
        }

        vm.data.checkedLoginId = "";

        if (!getIsValidId()) {
          gAlert('', '사용할 수 없는 아이디입니다.');
          return;
        }

        data.mapCode = GETID_SQL;

        postApi.login(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.checkedLoginId = vm.data.LoginId;
            gAlert('', '사용 가능한 아이디입니다.');
          } else {
            gAlert('', result.body.docs[0].errMessage);
            vm.data.checkedLoginId = "";
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      }

      /**
       * 아이디 유효성 검사
       * (영문 소문자, 숫자, 특수문자 -_)
       *
       * @param
       * @return
       */
      function getIsValidId() {
        var regExp = /^[a-z0-9\-_]{5,25}$/;
        if (!regExp.test(vm.data.LoginId)) return false;
        //if (vm.data.LoginId.search(/\s/) != -1) return false;

        return true;
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        //gConfirm('', 'Menu.DELETECONFIRM', {
        gConfirm('', '해당업체를 삭제하시겠습니까?', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);
        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = EDIT_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getRoleList = getRoleList;             // 역할 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;

      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.getIsDupLoginId = getIsDupLoginId;         // 아이디 중복 체크
      vm.setDelData = setDelData;                     // 데이터 삭제

      // 데이터 조회
      getData();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('ClientListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function ClientListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSystem.getUserMgrListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSystem.getUserMgrList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.client-list';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.survey.client-list.edit';    // 목록 등록/수정 화면
      var EDIT_PAGE_URL = 'app.survey.client-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.client'; // 작업 테이블명
      var KEY_COLUMN_NM = 'UserId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;
      }
      vm.srch.srchUserGubun = "DEFAULT";

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      /**
       * 접속 정보 발송
       * @param
       * @return
       */
      function sendEmail() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push({
              UserId : vm.lists[i].KeyId,
              UserNm : vm.lists[i].UserNm,
              LoginId : vm.lists[i].LoginId,
              Email : vm.lists[i].Email});
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', '대상을 선택해 주세요.');
          return false;
        }

        gConfirm('', '비밀번호가 아이디로 초기화 된 후 발송됩니다. 진행하시겠습니까?', {
          btn: '',
          fn: function () {

            var cnt = 0;
            angular.forEach(vm.srch.KeyIdList, function (c) {
              sendMail(c);
            });

            gAlert('', '발송했습니다.');
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      function sendMail(c) {
        var data = {};
        data.UserId = c.UserId;
        data.toEmail = c.Email;
        data.title = "더휴먼데이터센터에서 접속정보를 발송해드립니다.";
        data.content = "<div style=\"width:100%;max-width:600px;min-height:320px; background:url('http://thehumandc.co.kr/assets/images/tem_bg6.png') no-repeat;\">"
                        +"<div style='padding-left:30px; padding-top:50px; font-size:11px;'>"
                        +"더휴먼데이터센터에서 접속정보를 발송해드립니다. <br><br>"
                        +"<ul><li>업체명 : "+ c.UserNm +"</li><li>ID : "+ c.LoginId +"</li><li>PW : "+ c.LoginId +"</li></ul><br>"
                        +"비밀번호는 아이디와 동일합니다.<br>"
                        +"로그인 후 우측 상단의 내 정보에서 비밀번호 변경 후 사용하시기 바랍니다.<br><br><br>"
                        +"<a href='http://thehumandc.co.kr/'><img src='http://thehumandc.co.kr/assets/images/tem_bg6_1.png'></a>"
                        +"</div>"
                        +"<div style='padding-left:230px;padding-top:40px;font-size:11px;'>"
                        +"전화: (02)6956-9501 / 팩스 : (02)703-9182 / <a href='http://www.thehumandc.co.kr'>www.thehumandc.co.kr</a>"
                        +"</div></div>";

        data.mapCode="sendClientLoginInfo";

        postApi.openApi(data, function(result) {
          if(result.header.status === CONSTANT.HttpStatus.OK) {

          }
        });
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동
      vm.sendEmail = sendEmail;                 // 접속정보 발송

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('WjmClientResultListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function WjmClientResultListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSurvey.getSurveyListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSurvey.getSurveyList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.client-result-list';         // 목록 화면

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 차트관련
      vm.chart = {};
      vm.chart.opt = {legend: { display: true, position : 'left'}};

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.anchor = "";

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      vm.listsStyle = function(keyId) {
        alert(keyId);
        if (keyId == vm.srch.keyId) {
          return "background-color:#999;";
        }
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        data.roleType = vm.roleType;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.roleType = vm.roleType;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              console.log("d", vm.lists);
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 사용자 역할 조회
       * @param
       * @return
       */
      function getRoleType() {
        var data = {};
        vm.dataloader = true;
        data.mapCode = "WjmSystem.getRoleType";

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.roleType = result.body.docs[0].RoleType;

              if (vm.roleType != "ADM") {
                getList();
              }
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getRoleType()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getRoleType()");
          console.table(error);
        });
      }

      // 분석
      function getAnalysis(keyId) {
        vm.srch.keyId = keyId;

        // 전체 진단결과
        vm.chart.dtL = [];
        vm.chart.lbL = [];
        getDataL();

        // 상담사별 상담건수
        vm.chart.dtCC = [];
        vm.chart.lbCC = [];
        getDataCC();

        // 전체 참여율
        vm.chart.dtC = [];
        vm.chart.lbC = [];
        getDataC();

        // 분류별 참여율
        vm.listGD = {};
        vm.listAG = {};
        vm.listPS = {};
        vm.listGR1 = {};
        vm.listGR2 = {};
        vm.listGR3 = {};
        vm.listGR4 = {};
        vm.chart.dtGD = [];
        vm.chart.lbGD = [];
        vm.chart.dtAG = [];
        vm.chart.lbAG = [];
        vm.chart.dtPS = [];
        vm.chart.lbPS = [];
        vm.chart.dtGR1 = [];
        vm.chart.lbGR1 = [];
        vm.chart.dtGR2 = [];
        vm.chart.lbGR2 = [];
        vm.chart.dtGR3 = [];
        vm.chart.lbGR3 = [];
        vm.chart.dtGR4 = [];
        vm.chart.lbGR4 = [];
        getDataCF();

        // 대상고객 목록
        getDataTgtList();
      }


      /**
       * 대상고객 목록
       */
      function getDataTgtList() {
        vm.dataloader = true;

        var data = {};
        data.mapCode = "WjmSurvey.getClientResultTgtList";
        data.SvyId = vm.srch.keyId;
        vm.tgtList = {};

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              vm.tgtList = result.body.docs;
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataTgtList()");
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getDataTgtList()");
          console.table(error);
        });
      }

      /**
       * 전체 진단결과
       */
      function getDataL() {
        vm.dataloader = true;

        var data = {};
        data.mapCode = "WjmSurvey.getClientResultChtL";
        data.SvyId = vm.srch.keyId;
        vm.listL = {};

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;
            if (result.body.docs.length > 0) {
              vm.listL = result.body.docs;

              var colorCode = "";

              // 차트 설정
              vm.chart.color = []; // Green, Blue, Yellow, Red
              angular.forEach(vm.listL, function(item) {
                vm.chart.dtL.push(item.RespCnt);
                vm.chart.lbL.push(item.Resp);
                switch (item.LvCd) {
                  case "Green": colorCode = "#70ad47"; break;
                  case "Blue": colorCode = "#4472c4"; break;
                  case "Yellow": colorCode = "#ed7d31"; break;
                  case "Red": colorCode = "#c00000"; break;
                }
                vm.chart.color.push(colorCode);
              });
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataL()");
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getDataL()");
          console.table(error);
        });
      }


      /**
       * 상담사별 상담건수
       */
      function getDataCC() {
        vm.dataloader = true;

        var data = angular.copy(vm.srch);
        data.mapCode = "WjmDashboard.getCounselorList";
        data.roleType = vm.roleType;
        vm.listCC = {};

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;
            if (result.body.docs.length > 0) {
              vm.listCC = result.body.docs;

              // 차트 설정
              angular.forEach(vm.listCC, function(item) {
                vm.chart.dtCC.push(item.CounselCnt);
                vm.chart.lbCC.push(item.CounselorCode);
              });
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataCC()");
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getDataCC()");
          console.table(error);
        });
      }

      /**
       * 전체 참여율
       */
      function getDataC() {
        vm.dataloader = true;

        var data = {};
        data.mapCode = "WjmSurvey.getClientResultChtC";
        data.SvyId = vm.srch.keyId;
        vm.listC = {};

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;
            if (result.body.docs.length > 0) {
              vm.listC = result.body.docs[0];

              // 차트 설정
              vm.chart.dtC.push(vm.listC.RespCnt);
              vm.chart.dtC.push(vm.listC.NoRespCnt);
              vm.chart.lbC.push("참여");
              vm.chart.lbC.push("미참여");
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataC()");
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getDataC()");
          console.table(error);
        });
      }

      /**
       * 분류별 참여율
       */
       function getDataCF() {
        vm.dataloader = true;

        var data = {};
        data.mapCode = "WjmSurvey.getClientResultChtCf";
        data.SvyId = vm.srch.keyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;
            if (result.body.docs.length > 0) {

              setChartByCf(result.body.docs);
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataCF()");
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getDataCF()");
          console.table(error);
        });
      }

      // 분류별 차트 설정
      function setChartByCf(list){

        vm.listGD = $filter('filter')(list, {ClassfyCd: "GD"}, true);
        vm.listAG = $filter('filter')(list, {ClassfyCd: "AG"}, true);
        vm.listPS = $filter('filter')(list, {ClassfyCd: "PS"}, true);
        vm.listGR1 = $filter('filter')(list, {ClassfyCd: "GR1"}, true);
        vm.listGR2 = $filter('filter')(list, {ClassfyCd: "GR2"}, true);
        vm.listGR3 = $filter('filter')(list, {ClassfyCd: "GR3"}, true);
        vm.listGR4 = $filter('filter')(list, {ClassfyCd: "GR4"}, true);

        angular.forEach(list, function(item) {
          switch(item.ClassfyCd){
            case "GD" :
              vm.chart.dtGD.push(item.RespCnt);
              vm.chart.lbGD.push(item.Resp);
              break;
            case "AG" :
              vm.chart.dtAG.push(item.RespCnt);
              vm.chart.lbAG.push(item.Resp);
              break;
            case "PS" :
              vm.chart.dtPS.push(item.RespCnt);
              vm.chart.lbPS.push(item.Resp);
              break;
            case "GR1" :
              vm.chart.dtGR1.push(item.RespCnt);
              vm.chart.lbGR1.push(item.Resp);
              break;
            case "GR2" :
              vm.chart.dtGR2.push(item.RespCnt);
              vm.chart.lbGR2.push(item.Resp);
              break;
            case "GR3" :
              vm.chart.dtGR3.push(item.RespCnt);
              vm.chart.lbGR3.push(item.Resp);
              break;
            case "GR4" :
              vm.chart.dtGR4.push(item.RespCnt);
              vm.chart.lbGR4.push(item.Resp);
              break;
          }
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.getAnalysis = getAnalysis;

      // 목록 조회
      getRoleType();
    }]);
})();

(function () {
  "use strict";
  webapp.controller('WjmContactEditCtrl', ['GLOBAL_CONSTANT', 'postApi', 'gAlert',
    function WjmContactEditCtrl(CONSTANT, postApi, gAlert) {

      var vm = this;

      var VIEW_SQL = 'WjmSurvey.getContactTxt'; // 조회 SQL
      var UPDATE_SQL = 'WjmSurvey.updateContactTxt';     // 수정 SQL

      vm.data = {
        ContactTxt : ''
      };
        // 조회
      function getData() {
        var data = vm.data;
        data.mapCode = VIEW_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data.ContactTxt = result.body.docs[0].ContactTxt;
            }
          }
        }, function (error) {
        });
      }

      // 저장
      function setData() {
        var data = vm.data;
        data.mapCode = UPDATE_SQL;
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        data.ContactTxt = $("#strHtml").val();

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
              }
            });
          }
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }

      // 함수 선언
      vm.setData = setData;

      getData();

    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('WjmCounselEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function WjmCounselEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmCounsel.insertCounsel'; // 등록 SQL
      var UPDATE_SQL = 'WjmCounsel.updateCounsel'; // 수정 SQL
      var VIEW_SQL = 'WjmCounsel.getCounselDetail'; // 조회 SQL
      var DEL_SQL = 'WjmCounsel.deleteCounselDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.counsel-list'; // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.counsel-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.survey.counsel-edit'; // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.counsel'; // 조회용 테이블명
      var KEY_COLUMN_NM = 'ImgId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      //vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = KEY_COLUMN_NM; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
              vm.uploadFileList.push(obj);
              }
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          /*
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
          $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback



      /**
       * 초기 세팅
       * @param
       * @return
       */
      function init(){
        // 문항 목록 체크박스 설정
        /*
        vm.qstChkHead = false;
        $scope.qstChkRowChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            if (!vm.qstLists[i].isChecked) {
              vm.qstChkHead = fal se;
              return;
            }
          }
          vm.qstChkHead = true;
        };

        $scope.qstChkHeadChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            vm.qstLists[i].qstChkRow = vm.qstChkHead;
          }
        };
        */
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData(type) {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        //vm.showUploader = enableUploadComponent();
        //initVaultComponent('vault', vm.onFileCallback);
        //initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (!isNullOrEmpty(vm.data.RegDate)) vm.RegDate = moment(vm.data.RegDate).format('YYYY-MM-DD HH:mm:ss');

              // 기본값 (no data 때문에 이쪽으로 들어오는 듯)
              if (isNullOrEmpty(vm.data.keyId)) {
                vm.data.CounselNum = "자동생성";
              }

              //getUploadFileList();
            } else {
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.data.CounselDate)) {
          errMsg = errMsg + '- 신청일을 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.CounselStatus)) {
          errMsg = errMsg + '- 상태를 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Name)) {
          errMsg = errMsg + '- 고객명을 입력해주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      /*
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.tableNm = KEY_TABLE_NM;
        data.TableId = vm.srch.keyId;
        data.mapCode = 'FileAttach.getFileListOri';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {

            var uploadFileList = [];

            angular.forEach(result.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalFolderNm + "&fileName=" + item.LogicalFileNm),
                src: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                typeId: 'file',
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
                delState: ''
              };

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);

          }
          //}
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }
      */

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (!getIsValidData()) return;

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        /*
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        */

        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // 에디터 내용 삽입
        //oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        //vm.data.TopCont = $("#strHtml").val();

        // 체크박스 처리
        if (isNullOrEmpty(vm.data.TopicYN0)) vm.data.TopicYN0 = "N";
        if (isNullOrEmpty(vm.data.TopicYN1)) vm.data.TopicYN1 = "N";
        if (isNullOrEmpty(vm.data.TopicYN2)) vm.data.TopicYN2 = "N";
        if (isNullOrEmpty(vm.data.TopicYN3)) vm.data.TopicYN3 = "N";
        if (isNullOrEmpty(vm.data.TopicYN4)) vm.data.TopicYN4 = "N";
        if (isNullOrEmpty(vm.data.TopicYN5)) vm.data.TopicYN5 = "N";
        if (isNullOrEmpty(vm.data.TopicYN6)) vm.data.TopicYN6 = "N";
        if (isNullOrEmpty(vm.data.TopicYN7)) vm.data.TopicYN7 = "N";
        if (isNullOrEmpty(vm.data.TopicYN8)) vm.data.TopicYN8 = "N";
        if (isNullOrEmpty(vm.data.TopicYN9)) vm.data.TopicYN9 = "N";
        if (isNullOrEmpty(vm.data.TopicYN10)) vm.data.TopicYN10 = "N";
        if (isNullOrEmpty(vm.data.TopicYN11)) vm.data.TopicYN11 = "N";
        if (isNullOrEmpty(vm.data.TopicYN12)) vm.data.TopicYN12 = "N";
        if (isNullOrEmpty(vm.data.InfoAgreeYN)) vm.data.InfoAgreeYN = "N";

        // 라디오박스 처리
        //if (isNullOrEmpty(vm.data.QstPassYN)) vm.data.QstPassYN = "Y";

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            //result.body.docs[0].KeyId !== null || result.body.docs[0].NewKeyId !== null
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            vm.data.keyId = result.body.docs[0].RelateDataId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              //keyId: vm.data.KeyId
              keyId: vm.data.keyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.keyId});
          //$state.go(LIST_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        /*
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;
        */

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, { srch: srch }, {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }
      */

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;

      getData();
      init();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('WjmCounselListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function WjmCounselListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmCounsel.getCounselListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmCounsel.getCounselList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmCounsel.getCounselExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmCounsel.deleteCounselList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.counsel-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.counsel-list.edit';         // 목록 조회 화면
      //var VIEW_PAGE_URL = 'app.survey.counsel-detail';         // 조회 화면
      var EDIT_PAGE_URL = 'app.survey.counsel-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.counsel'; // 작업 테이블명
      var EXCEL_TITLE = '상담신청목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.CounselDateFrom = $rootScope.getDateFormat(vm.srch.CounselDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.CounselDateTo = $rootScope.getDateFormat(vm.srch.CounselDateTo); // YYYY-MM-DD 를 date type 으로 변환
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        //console.log("vm.srch", vm.srch);
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 설문작성 화면
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: '',
          cKeyId: ''
        });
      }

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          //$state.go(VIEW_PAGE_URL, {
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          //if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getList();
            }
          });
          //}
          /*
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
          */
        });
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.survey:counselor-editctrl
   * @description Controller of the 상담사정보 등록/수정
   */

  webapp.controller('CounselorEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function CounselorEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmSystem.insertUser';     // 등록 SQL
      var UPDATE_SQL = 'WjmSystem.updateUser';     // 수정 SQL
      var VIEW_SQL = 'WjmSystem.getUserMgrDetail'; // 조회 SQL
      var DEL_SQL = 'WjmSystem.deleteUserDetail';  // 삭제 SQL
      var GETID_SQL = 'checkLoginId';         // 아이디중복체크 SQL
      var GETCROLEID_SQL = 'WjmSystem.getCounselorRoleId'; // 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.counselor-list';             // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.survey.counselor-list.edit'; // 목록 수정 화면
      var EDIT_PAGE_URL = 'app.survey.counselor-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.counselor'; // 조회용 테이블명
      var EDIT_TABLE_NM = 'users'; // 저장용 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      vm.CounselorCodeList = [];

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }
      vm.srch.srchUserGubun = "COUNSELOR";

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.uploadFileList2 = [];  // 첨부파일 목록

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );
        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      // #endregion 첨부파일 Callback

      /**
       * 업체 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchComUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.data.ComUserNm = okData.UserNm;
          vm.data.ComUserId = okData.UserId;


          vm.data.ClassfyInfoNm = "";
          vm.data.ClassfyInfoId = "";
          vm.data.CounselorCode = "";
          vm.CounselorCodeList = [];
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 업체 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseComUser = function () {
        vm.data.ComUserNm = "";
        vm.data.ComUserId = "";
        vm.data.ClassfyInfoNm = "";
        vm.data.ClassfyInfoId = "";

        vm.data.CounselorCode = "";
        vm.CounselorCodeList = [];
      };

      /**
       * 분류 정보 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchClassfyInfoModal = function () {
        var ctrl = 'ClassfyInfoModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId, srchManager: vm.data.ComUserId};
        var modalInstance = modalFactory.open('xs', 'components/modal/survey/classfyinfo-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.data.ClassfyInfoNm = okData.ClassfyInfoNm;
          vm.data.ClassfyInfoId = okData.ClassfyInfoId;

          vm.data.CounselorCode = "";
          vm.CounselorCodeList = [];

          getCounselorCodeList();
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 분류 정보 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseClassfyInfo = function () {
        vm.data.ClassfyInfoNm = "";
        vm.data.ClassfyInfoId = "";

        vm.data.CounselorCode = "";
        vm.CounselorCodeList = [];
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.tableNm = KEY_TABLE_NM;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              console.log("test", vm.data);
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              vm.tmpEmail = vm.data.Email;

              // 역할 설정
              vm.data.UserRoles = [];
              var UserRoleIds = [];
              var UserRoleNms = [];
              if (vm.data.UserRoleIds != null) {
                UserRoleIds = vm.data.UserRoleIds.split(",");
              }
              if (vm.data.UserRoleNms != null) {
                UserRoleNms = vm.data.UserRoleNms.split(",");
              }
              angular.forEach(UserRoleIds, function (item, key) {
                var UserRole = {RoleId: item, RoleNm: UserRoleNms[key]};
                vm.data.UserRoles.push(UserRole);
              });

              getUploadFileList("1");
            } else {
              console.log('nodata');
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }

            getCounselorCodeList();
            if (isNullOrEmpty(vm.srch.keyId)) getCounselorRoleId();
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 상담사역할 아이디 조회
       * @param
       * @return
       */
      function getCounselorRoleId() {
        vm.dataloader = true;
        var data = vm.srchDetail;
        data.mapCode = GETCROLEID_SQL;
        var rtn = [];

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                rtn = result.body.docs[0];

                var UserRole = {RoleId: rtn.RoleId, RoleNm: rtn.RoleNm};
                vm.data.UserRoles.push(UserRole);
              }
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataApp()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataApp()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';

        if (isNullOrEmpty(vm.data.UserNm)) {
          errMsg = errMsg + '- 상담사명을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.ComUserNm)) {
          errMsg = errMsg + '- 업체를 선택하세요.<br/>';
        }

        /*
        if (isNullOrEmpty(vm.data.CounselorCode)) {
          errMsg = errMsg + '- 상담사코드를 선택하세요.<br/>';
        }
        */

        if (isNullOrEmpty(vm.data.LoginId)) {
          errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.keyId)) {
          if (isNullOrEmpty(vm.data.checkedLoginId)) {
            errMsg = errMsg + '- 중복된 아이디인지 체크하세요.<br/>';
          }
        }

        if (isNullOrEmpty(vm.data.Mobile)) {
          errMsg = errMsg + '- 휴대폰을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Email)) {
          errMsg = errMsg + '- 이메일을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.UseYN)) {
          errMsg = errMsg + '- 사용여부를 선택하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        }
        else if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList(grpId) {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.tableNm = EDIT_TABLE_NM;
        data.TableId = vm.srch.keyId;
        data.grpId = grpId;
        data.mapCode = 'FileAttach.getFileListOri';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {

            var uploadFileList = [];

            angular.forEach(result.body.docs, function (item) {
              var obj = {
                id: item.fileId,
                isLoaded: true,
                link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalFolderNm + "&fileName=" + item.LogicalFileNm),
                src: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                fileName: item.LogicalFileNm,
                size: item.FileSize,
                fileKey: item.PhysicalFileNm,
                typeId: 'file',
                path: item.PhysicalPath,
                downloadCnt: item.DownloadCnt,
                delState: ''
              };

              uploadFileList.push(obj);
            });

            if (grpId == 1) {
              vm.uploadFileList = angular.copy(uploadFileList);
              getUploadFileList("2");
            }
            else {
              vm.uploadFileList2 = angular.copy(uploadFileList);
            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 분류 목록
       * @param
       * @return
       */
      function getCounselorCodeList() {
        if (isNullOrEmpty(vm.data.ComUserId) || isNullOrEmpty(vm.data.ClassfyInfoId)) return;

        vm.CounselorCodeList = [];

        var data = {
          mapCode: 'WjmSurvey.getClassfyDropListForCode',
          Manager : vm.data.ComUserId,
          ClassfyInfoId : vm.data.ClassfyInfoId,
          DupExceptYN : 'Y',
          UserId : vm.srch.keyId
        };

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.CounselorCodeList = result.body.docs;
            }
          }
        }, function(error) {
          console.error('Error> getCounselorCodeList()', status, error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });

        // 내용
        vm.data.tableNm = EDIT_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
        vm.data.UserGubun = vm.srch.srchUserGubun;

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          // 최초 비밀번호는 아이디
          data.Password = data.LoginId;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        //if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        //}

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(EDIT_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:EDIT_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }


      /**
       * 아이디 중복 체크
       *
       * @param
       * @return
       */
      function getIsDupLoginId() {
        var data = vm.data;

        if (isNullOrEmpty(vm.data.LoginId)) {
          return;
        }

        vm.data.checkedLoginId = "";

        if (!getIsValidId()) {
          gAlert('', '사용할 수 없는 아이디입니다.');
          return;
        }

        data.mapCode = GETID_SQL;

        postApi.login(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.checkedLoginId = vm.data.LoginId;
            gAlert('', '사용 가능한 아이디입니다.');
          } else {
            gAlert('', result.body.docs[0].errMessage);
            vm.data.checkedLoginId = "";
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      }

      /**
       * 아이디 유효성 검사
       * (영문 소문자, 숫자, 특수문자 -_)
       *
       * @param
       * @return
       */
      function getIsValidId() {
        var regExp = /^[a-z0-9\-_]{5,25}$/;
        if (!regExp.test(vm.data.LoginId)) return false;
        //if (vm.data.LoginId.search(/\s/) != -1) return false;

        return true;
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        //gConfirm('', 'Menu.DELETECONFIRM', {
        gConfirm('', '해당상담사를 삭제하시겠습니까?', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);
        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = EDIT_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;
        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getRoleList = getRoleList;             // 역할 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;

      vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.getIsDupLoginId = getIsDupLoginId;         // 아이디 중복 체크
      vm.setDelData = setDelData;                     // 데이터 삭제

      // 데이터 조회
      getData();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('CounselorListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter', '$http',

    function CounselorListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, $http) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSystem.getUserMgrListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSystem.getUserMgrList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.counselor-list';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.survey.counselor-list.edit';    // 목록 등록/수정 화면
      var EDIT_PAGE_URL = 'app.survey.counselor-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.counselor'; // 작업 테이블명
      var KEY_COLUMN_NM = 'UserId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;
      }
      vm.srch.srchUserGubun = "COUNSELOR";

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      /**
       * 접속 정보 발송
       * @param
       * @return
       */
      function sendEmail() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push({
              UserId : vm.lists[i].KeyId,
              UserNm : vm.lists[i].UserNm,
              LoginId : vm.lists[i].LoginId,
              Email : vm.lists[i].Email});
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', '대상을 선택해 주세요.');
          return false;
        }

        gConfirm('', '비밀번호가 아이디로 초기화 된 후 발송됩니다. 진행하시겠습니까?', {
          btn: '',
          fn: function () {

            var cnt = 0;
            angular.forEach(vm.srch.KeyIdList, function (c) {
              sendMail(c);
            });

            gAlert('', '발송했습니다.');
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      function sendMail(c) {
        var data = {};
        data.UserId = c.UserId;
        data.toEmail = c.Email;
        data.title = "더휴먼데이터센터에서 접속정보를 발송해드립니다.";
        data.content = "<div style=\"width:100%;max-width:600px;min-height:320px; background:url('http://thehumandc.co.kr/assets/images/tem_bg6.png') no-repeat;\">"
                        +"<div style='padding-left:30px; padding-top:50px; font-size:11px;'>"
                        +"더휴먼데이터센터에서 접속정보를 발송해드립니다. <br><br>"
                        +"<ul><li>상담사명 : "+ c.UserNm +"</li><li>ID : "+ c.LoginId +"</li><li>PW : "+ c.LoginId +"</li></ul><br>"
                        +"비밀번호는 아이디와 동일합니다.<br>"
                        +"로그인 후 우측 상단의 내 정보에서 비밀번호 변경 후 사용하시기 바랍니다.<br><br><br>"
                        +"<a href='http://thehumandc.co.kr/'><img src='http://thehumandc.co.kr/assets/images/tem_bg6_1.png'></a>"
                        +"</div>"
                        +"<div style='padding-left:230px;padding-top:40px;font-size:11px;'>"
                        +"전화: (02)6956-9501 / 팩스 : (02)703-9182 / <a href='http://www.thehumandc.co.kr'>www.thehumandc.co.kr</a>"
                        +"</div></div>";

        data.mapCode="sendCounselorLoginInfo";

        postApi.openApi(data, function(result) {
          if(result.header.status === CONSTANT.HttpStatus.OK) {

          }
        });
      }

      // 양식 다운로드
      function doDownload()  {
        var a = document.createElement("a");
        document.body.appendChild(a);

        var fileName = "상담사 일괄업로드 양식";
        var exportData = [];

        exportData.push(["상담사명(필수)", "업체명(필수)", "분류정보명(필수)", "상담사코드(필수)", "아이디(필수)", "휴대폰(필수)", "이메일(필수)", "사용여부(필수 | Y/N)"]);
        exportData.push(["홍길동", "위너스제이엠", "위너스제이엠 분류", "사과", "cs_hong", "010-1234-5678", "email@winnersjm.co.kr", "Y"]);

        $rootScope.excelDown(exportData, fileName);
      }


      // 일괄 업로드 체크
      function chkUpload()  {
        gConfirm('', '아래의 경우에 해당하는 데이터는 저장되지 않습니다. 진행하시겠습니까?<div class=\"text-left\"><br />- 중복된 아이디인 경우<br />- 필수값이 입력되지 않는 경우<br />- 업체 데이터가 존재하지 않는 경우<br />- 상담사코드 데이터가 존재하지 않는 경우</div>', {
          btn: '',
          fn: function () {
            doUpload();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 일괄 업로드
      function doUpload()  {
        vm.dataloader = true;

        var file = $("input[name=excelFile]")[0].files[0];
        var formData = new FormData();
        var uploadUrl = "excelUpload/WjmSystem.insertCounselorExcel/action.json";
        var ext = file.name.split('.').pop().toLowerCase();

        if(file == undefined || $.inArray(ext, ['xlsx']) == -1){
          vm.dataloader = false;
          gAlert('', 'xlsx 형식의 파일을 선택하세요.');
          return;
        }

        formData.append("mFile",file);
        formData.append("ext",ext);
        formData.append("SESSION_USERID", $rootScope.gVariable.UserId);
        formData.append("SESSION_TENANTID", $rootScope.gVariable.TenantId);

        $http({
          url: uploadUrl,
          method: "POST",
          data: formData,
          transformRequest: angular.identity,
          headers: {'Content-type': undefined}
        }).success(function (data, status, headers, config) {
          vm.dataloader = false;
          gAlert('', data.responseVO.body.docs[0].message.replace(/<br>/gi, "\r\n"));
          getList();
        }).error(function (data, status, headers, config) {
          vm.dataloader = false;
          gAlert('', '오류가 발생했습니다.');
        });
        vm.dataloader = false;
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동
      vm.sendEmail = sendEmail;                 // 접속정보 발송

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.doDownload = doDownload;
      vm.chkUpload = chkUpload;

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('WjmFormEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter', 'wjmSurvey',

    function WjmFormEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter, wjmSurvey) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmForm.insertForm'; // 등록 SQL
      var UPDATE_SQL = 'WjmForm.updateForm'; // 수정 SQL
      var VIEW_SQL = 'WjmForm.getFormDetail'; // 조회 SQL
      var DEL_SQL = 'WjmForm.deleteFormDetail';  // 삭제 SQL

      var VIEWQST_SQL = 'WjmForm.getFormQstDetail'; // 조회 SQL (문항)
      var VIEWQSTITEM_SQL = 'WjmForm.getFormQstItemDetail'; // 조회 SQL (보기)
      var INSERTUPDATEQST_SQL = 'WjmForm.insertUpdateFormQst'; // 등록/수정 SQL (문항)
      var INSERTUPDATEQSTITEM_SQL = 'WjmForm.insertUpdateFormQstItem'; // 등록/수정 SQL (보기)
      var UPDATEFORMCLEANUP_SQL = 'WjmForm.updateFormCleanup'; // 문항,보기 정리

      var SVY_VIEW_SQL = 'WjmSurvey.getSurveyDetail'; // 설문 조회 SQL
      var SVY_VIEWQST_SQL = 'WjmSurvey.getSurveyQstDetail'; // 설문 조회 SQL (문항)
      var SVY_VIEWQSTITEM_SQL = 'WjmSurvey.getSurveyQstItemDetail'; // 설문 조회 SQL (보기)

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.form-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.form-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.survey.form-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.form'; // 조회용 테이블명
      var KEY_COLUMN_NM = 'FormId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트

      // 설문관련 변수
      vm.svyPages = [];
      vm.svyQsts = [];
      vm.svyQstItems = [];

      vm.isChrome = true;
      if (navigator.userAgent.toLowerCase().indexOf("chrome") == -1) vm.isChrome = false;

      vm.isLoaded = false;

      $scope.wjmSurvey = wjmSurvey;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      // 설문 조회에서 복사등록으로 넘어온 경우
      vm.srch.cKeyId = !isNullOrEmpty($stateParams.cKeyId) ? $stateParams.cKeyId : '';

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      /**
       * 저장/삭제 사용불가처리 여부
       *
       * @param
       * @return
       */
      vm.isDisable = function() {
        var rtn = false;

        if (!isNullOrEmpty(vm.data.keyId) && vm.data.UseCnt != '0') {
          rtn = true;
        }
        else if (!vm.isLoaded) {
          rtn = true;
        }

        return rtn;
      };

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback

      /**
       * 미리보기 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.goPreview = function () {
        // 에디터 내용 삽입
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.TopCont = $("#strHtml").val();
        oEditors.getById["strHtml2"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.BtmCont = $("#strHtml2").val();

        var ctrl = 'WjmPreModalCtrl as vc';
        var paramData = {
          svyInfo: vm.data,
          svyPages: vm.svyPages,
          svyQsts: vm.svyQsts,
          svyQstItems: vm.svyQstItems
        };

        var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-pre-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 성공
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 문항 편집 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstEdit = function (qtId) {
        var ctrl = 'WjmQstModalCtrl as vc';
        //var paramData = { qt: qt, it: $filter('filter')(vm.svyQstItems, {qtId: qt.qtId}) };
        var paramData = {
          qtId: qtId,
          svyQsts: vm.svyQsts,
          svyQstItems: vm.svyQstItems,

          // vm.data 의 데이터들은 이름 그대로 전달
          //Manager: vm.data.Manager,
          SvyTypeId: vm.data.SvyTypeId,
          ClassfyInfoId: vm.data.ClassfyInfoId,
          pageType: "FORM"
        };
        var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-qst-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 성공
          wjmSurvey.sortSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);

        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      /**
       * 설문유형선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchSvyTypeModal = function () {
        var ctrl = 'SvyTypeModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/survey/svytype-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          gConfirm('', '설문유형이 변경되면 문항에 매핑된 문항영역이 초기화됩니다. 진행하시겠습니까?', {
            btn: '',
            fn: function () {
              vm.data.SvyTypeNm = okData.SvyTypeNm;
              vm.data.SvyTypeId = okData.SvyTypeId;
              vm.data.SvyTypeCd = okData.SvyTypeCd;

              vm.svyQsts.forEach(function(i) {
                i.QstSecId = "";
              });
            }
          }, {
            btn: '',
            fn: function () {
              // 취소
            }
          });
        }, function (cancelData) {
          // 취소
        });
      };
      vm.eraseSvyType = function () {
        gConfirm('', '설문유형이 변경되면 문항에 매핑된 문항영역이 초기화됩니다. 진행하시겠습니까?', {
          btn: '',
          fn: function () {
            vm.data.SvyTypeNm = "";
            vm.data.SvyTypeId = "";
            vm.data.SvyTypeCd = "";

            vm.svyQsts.forEach(function(i) {
              i.QstSecId = "";
            });
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      };

      /**
       * 분류정보선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchClassfyInfoModal = function () {
        if (isNullOrEmpty(vm.data.Manager)) {
          gAlert('', "업체를 선택해주세요.");
          return false;
        }

        var ctrl = 'ClassfyInfoModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId, srchManager: vm.data.Manager};
        var modalInstance = modalFactory.open('xs', 'components/modal/survey/classfyinfo-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ClassfyInfoNm = okData.ClassfyInfoNm;
          vm.data.ClassfyInfoId = okData.ClassfyInfoId;
        }, function (cancelData) {
        });
      };
      vm.eraseClassfyInfo = function () {
        vm.data.ClassfyInfoNm = "";
        vm.data.ClassfyInfoId = "";
      };

      /**
       * 문항 일괄생성
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setBatchQst = function () {
        var i = 0;
        var j = 0;
        var errMsg = '';

        if (vm.svyPages.length == 0) {
          errMsg = errMsg + '- 페이지를 추가해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.batchQstType)) {
          errMsg = errMsg + '- 문항유형을 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.batchCnt)) {
          errMsg = errMsg + '- 페이지당반복수를 입력해주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        gConfirm('', '일괄생성시 기존 문항데이터는 삭제됩니다. 계속진행하시겠습니까?', {
          btn: '',
          fn: function () {
            //vm.svyQsts = [];
            //vm.svyQstItems = [];
            vm.setDelQstAll();

            for (i = 0; i < vm.svyPages.length; i++) {
              for (j = 0; j < vm.batchCnt; j++) {
                if (!vm.setSvyQstAdd(vm.svyPages[i].PageNo, vm.batchQstType)) break;
              }
            }

            if (isNullOrEmpty(vm.svyPagesCur)) vm.svyPagesCur = 1;
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      };

      /**
       * 모든 문항, 보기 삭제
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setDelQstAll = function() {
        /*
        vm.svyQsts.forEach(function(i) {
          if (isNullOrEmpty(i.FormQstId)) vm.svyQsts.splice(vm.svyQsts.indexOf(i), 1);
          else i.stat = "D"
        });
        vm.svyQstItems.forEach(function(i) {
          if (isNullOrEmpty(i.FormQstItemId)) vm.svyQstItems.splice(vm.svyQstItems.indexOf(i), 1);
          else i.stat = "D"
        });
        */

        var i = 0;

        for (i = vm.svyQsts.length - 1; i >= 0; i--) {
          if (isNullOrEmpty(vm.svyQsts[i].FormQstId)) {
            vm.svyQsts.splice(i, 1);
          }
          else {
            vm.svyQsts[i].stat = "D";
          }
        }

        for (i = vm.svyQstItems.length - 1; i >= 0; i--) {
          if (isNullOrEmpty(vm.svyQstItems[i].FormQstItemId)) {
            vm.svyQstItems.splice(i, 1);
          }
          else {
            vm.svyQstItems[i].stat = "D";
          }
        }
      };

      /**
       * 분기정보 조회
       *
       * @param {string}
       * @return {boolean}
       */
      vm.getGotoInfoFrom = function (goToQstId) {
        // 추후 정보를 보여줘야한다면 확장
        var qt = [];

        if (!isNullOrEmpty(goToQstId)) {
          qt = $filter('filter')(vm.svyQsts, {qtId: goToQstId}, true);
        }

        return qt.length > 0;
      };

      vm.getGotoInfoTo = function (qtId) {
        // 추후 정보를 보여줘야한다면 확장
        var qt = [];
        var it = [];

        qt = $filter('filter')(vm.svyQsts, {GoToQstId: qtId}, true);
        it = $filter('filter')(vm.svyQstItems, {GoToQstId: qtId}, true);

        return qt.length > 0 || it.length > 0;
      };

      /**
       * 분기정보 삭제
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setGotoDel = function (qtId) {
        var qt = $filter('filter')(vm.svyQsts, {GoToQstId: qtId}, true);
        var it = $filter('filter')(vm.svyQstItems, {GoToQstId: qtId}, true);

        qt.forEach(function(i) {
          i.GoToQstId = "";
          i.stat = "U";
        });
        it.forEach(function(i) {
          i.GoToQstId = "";
          i.stat = "U";
        });
      };

      /**
       * 페이지 마지막에 추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyPageAdd = function () {
        var nextPgNo = vm.svyPages.length + 1;

        if (vm.svyPages.length > wjmSurvey.maxSvyPagesCnt) {
          gAlert('', "더이상 페이지를 만들 수 없습니다.");
          return false;
        }

        vm.svyPages.push({PageNo: nextPgNo});
        vm.svyPagesCur = nextPgNo;

        return true;
      };

      /**
       * 페이지 이전에 추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyPagePrevAdd = function () {
        var nextPgNo = vm.svyPages.length + 1;

        if (vm.svyPages.length > wjmSurvey.maxSvyPagesCnt) {
          gAlert('', "더이상 페이지를 만들 수 없습니다.");
          return false;
        }

        /*
        if ($filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur, QstLock: 'Y'}, true).length > 0) {
          gAlert('', "현재 페이지에 잠금문항(서식)이 존재하므로 이전페이지를 삽입할 수 없습니다.");
          return false;
        }
        */

        vm.svyPages.push({PageNo: nextPgNo});

        vm.svyQsts.forEach(function(i) {
          if (i.PageNo > vm.svyPagesCur - 1) {
            i.PageNo = i.PageNo + 1;
            i.stat = "U";
          }
        });

        return true;
      };

      /**
       * 페이지 삭제
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyPageDel = function () {
        var pg = [];
        var qt = [];
        var it = [];

        if (isNullOrEmpty(vm.svyPagesCur)) {
          gAlert('', "삭제할 페이지를 선택해주세요.");
          return false;
        }

        gConfirm('', '선택한 페이지와 해당 페이지에 등록된 문항을 삭제하고 페이지번호를 순차적으로 재정의 하시겠습니까?', {
          btn: '',
          fn: function () {
            pg = $filter('filter')(vm.svyPages, {PageNo: vm.svyPagesCur}, true)[0];
            vm.svyPages.splice(vm.svyPages.indexOf(pg), 1);

            qt = $filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur}, true);
            qt.forEach(function(i) {
              it = $filter('filter')(vm.svyQstItems, {qtId: i.qtId}, true);
              it.forEach(function(j) {
                if (isNullOrEmpty(j.FormQstItemId)) vm.svyQstItems.splice(vm.svyQstItems.indexOf(j), 1);
                else j.stat = "D";
              });

              vm.setGotoDel(i.qtId);

              if (isNullOrEmpty(i.FormQstId)) vm.svyQsts.splice(vm.svyQsts.indexOf(i), 1);
              else i.stat = "D";
            });

            wjmSurvey.initSvyNo("PG", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
            wjmSurvey.initSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
            //wjmSurvey.initSvyNo("IT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);

            if (vm.svyPages.length > 0) vm.svyPagesCur--;
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      };

      /**
       * 문항 추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstAdd = function (paramSvyPagesCur, paramQstType) {
        var i = 0;
        var nextQtId = wjmSurvey.getSvyCode("QT", vm.svyQsts, vm.svyQstItems);
        var svyPagesCur = "";
        var qstType = "";
        var errMsg = "";
        var qstSort = vm.svyQsts.length + 1;
        var qstNo = $filter('filter')(vm.svyQsts, {QstType: '!R'}, true).length + 1;

        svyPagesCur = !isNullOrEmpty(paramSvyPagesCur) ? paramSvyPagesCur : vm.svyPagesCur;
        qstType = !isNullOrEmpty(paramSvyPagesCur) ? paramQstType : vm.addQstType;

        if (isNullOrEmpty(svyPagesCur)) {
          errMsg = errMsg + '- 문항을 추가할 페이지를 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(qstType)) {
          errMsg = errMsg + '- 문항유형을 선택해주세요.<br/>';
        }

        if (vm.svyQsts.length > wjmSurvey.maxSvyQstsCnt) {
          errMsg = errMsg + '- 더이상 문항을 만들 수 없습니다.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        switch (qstType) {
          // 선택형
          case "1":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              FormQstId: "",
              QstLock: "Y",
              GoToQstId: "",
              QstImgId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "S",
              SelMin: 1,
              SelMax: 1,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "I",
              InputHint: "",
              QstPassYN: "Y",
            });

            for (i = 0; i < 4; i++) {
              vm.svyQstItems.push({
                itId: wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems),
                qtId: nextQtId,
                stat: "I",

                // DB명과 같은 항목
                QstItemNo: i + 1,
                QstItemContents: wjmSurvey.txtQstItemContents,
                QstItemContents2: "",
                QstItemScore: "0",
                FormQstItemId: "",
                GoToQstId: "",
                ClassfyId: "",
                QstItemImgId: ""
              });
            }
            break;

          // 입력형
          case "2":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              FormQstId: "",
              QstLock: "Y",
              GoToQstId: "",
              QstImgId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "I",
              InputHint: "",
              QstPassYN: "Y",
            });
            break;

          // 우선순위형
          case "3":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 4,
              QstSecId: "",
              ClassfyCd: "",
              FormQstId: "",
              QstLock: "Y",
              GoToQstId: "",
              QstImgId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "",
              InputHint: "",
              QstPassYN: "Y",
            });

            for (i = 0; i < 4; i++) {
              vm.svyQstItems.push({
                itId: wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems),
                qtId: nextQtId,
                stat: "I",

                // DB명과 같은 항목
                QstItemNo: i + 1,
                QstItemContents: wjmSurvey.txtQstItemContents,
                QstItemContents2: "",
                QstItemScore: "0",
                FormQstItemId: "",
                GoToQstId: "",
                ClassfyId: "",
                QstItemImgId: ""
              });
            }
            break;

          // 이미지형
          case "4":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              FormQstId: "",
              QstLock: "Y",
              GoToQstId: "",
              QstImgId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "I",
              InputHint: "",
              QstPassYN: "Y",
            });

            for (i = 0; i < 4; i++) {
              vm.svyQstItems.push({
                itId: wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems),
                qtId: nextQtId,
                stat: "I",

                // DB명과 같은 항목
                QstItemNo: i + 1,
                QstItemContents: wjmSurvey.txtQstItemContents,
                QstItemContents2: "",
                QstItemScore: "0",
                FormQstItemId: "",
                GoToQstId: "",
                ClassfyId: "",
                QstItemImgId: ""
              });
            }
            break;

          // 척도형
          case "5":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              FormQstId: "",
              QstLock: "Y",
              GoToQstId: "",
              QstImgId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: wjmSurvey.qstScaleMaxDef,
              ScaleOrder: "A",
              InputType: "",
              InputHint: "",
              QstPassYN: "Y",
            });

            for (i = 0; i < 4; i++) {
              vm.svyQstItems.push({
                itId: wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems),
                qtId: nextQtId,
                stat: "I",

                // DB명과 같은 항목
                QstItemNo: i + 1,
                QstItemContents: wjmSurvey.txtQstItemContents,
                //QstItemContents2: wjmSurvey.txtQstItemContents,
                QstItemContents2: "",
                QstItemScore: "0",
                FormQstItemId: "",
                GoToQstId: "",
                ClassfyId: "",
                QstItemImgId: ""
              });
            }
            break;

          // 분류정보
          case "C":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              FormQstId: "",
              QstLock: "Y",
              GoToQstId: "",
              QstImgId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "I",
              InputHint: "",
              QstPassYN: "Y",
            });
            break;

          // 설명글
          case "R":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: 0,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubjectR,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              FormQstId: "",
              QstLock: "Y",
              GoToQstId: "",
              QstImgId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "",
              InputHint: "",
              QstPassYN: "Y",
            });
            break;

          default :
            break;
        }

        wjmSurvey.initSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);

        //console.log("vm.svyQsts", vm.svyQsts);console.log("vm.svyQstItems", vm.svyQstItems);
        return true;
      };

      /**
       * 문항 삭제
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstDel = function (qtId) {
        var qt = [];
        var it = [];

        gConfirm('', '선택한 문항을 삭제하고 문항번호를 순차적으로 재정의 하시겠습니까?', {
          btn: '',
          fn: function () {
            qt = $filter('filter')(vm.svyQsts, {qtId: qtId}, true)[0];
            if (isNullOrEmpty(qt.FormQstId)) vm.svyQsts.splice(vm.svyQsts.indexOf(qt), 1);
            else qt.stat = "D";

            it = $filter('filter')(vm.svyQstItems, {qtId: qtId}, true);
            it.forEach(function(i) {
              if (isNullOrEmpty(i.FormQstItemId)) vm.svyQstItems.splice(vm.svyQstItems.indexOf(i), 1);
              else i.stat = "D";
            });

            vm.setGotoDel(qtId);
            wjmSurvey.initSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
            //wjmSurvey.initSvyNo("IT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      };

      /**
       * 복사후편집
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setCopyData = function () {
        var i = 0;
        var j = 0;
        var nQtId = "";
        var gQt = [];
        var gIt = [];

        gConfirm('', '현재의 서식을 복사 후 편집하시겠습니까? 이전에 작업한 내용은 초기화됩니다.', {
          btn: '',
          fn: function () {
            // 키 데이터 및 문항코드 초기화
            vm.data.keyId = "";
            vm.data.KeyId = "";
            vm.srch.keyId = "";
            vm.data.FormNm += "-복사본";
            vm.data.UseCnt = 0;

            for (i = vm.svyQsts.length - 1; i >= 0; i--) {
              nQtId = wjmSurvey.getSvyCode("QT", vm.svyQsts, vm.svyQstItems);

              // 보기 치환
              for (j = vm.svyQstItems.length - 1; j >= 0; j--) {
                if (vm.svyQstItems[j].qtId == vm.svyQsts[i].qtId) {
                  vm.svyQstItems[j].qtId = nQtId;
                }

                vm.svyQstItems[j].stat = "I";
                vm.svyQstItems[j].itId = wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems);
                vm.svyQstItems[j].FormQstItemId = "";
              }

              // 분기 치환 (문항)
              gQt = $filter('filter')(vm.svyQsts, {GoToQstId: vm.svyQsts[i].qtId}, true);
              gQt.forEach(function(item) {
                //item.stat = "I";
                item.GoToQstId = nQtId;
              });

              // 분기 치환 (보기)
              gIt = $filter('filter')(vm.svyQstItems, {GoToQstId: vm.svyQsts[i].qtId}, true);
              gIt.forEach(function(item) {
                //item.stat = "I";
                item.GoToQstId = nQtId;
              });

              // 문항 치환
              vm.svyQsts[i].stat = "I";
              vm.svyQsts[i].qtId = nQtId;
              vm.svyQsts[i].FormQstId = "";
            }
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      };

      /**
       * 분기 설정
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstGoto = function (qtId) {
        var ctrl = 'WjmQstGotoModalCtrl as vc';
        var paramData = {
          qtId: qtId,
          //svyInfo: vm.data,
          svyPages: vm.svyPages,
          svyQsts: vm.svyQsts,
          svyQstItems: vm.svyQstItems
        };

        var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-qstgoto-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          //vm.data.TenantNm = okData.TenantNm;
          //vm.data.TenantId = okData.TenantId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 이동 설정
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstMove = function (qtId) {
        var ctrl = 'WjmQstMoveModalCtrl as vc';
        var paramData = {
          qtId: qtId,
          //svyInfo: vm.data,
          svyPages: vm.svyPages,
          svyQsts: vm.svyQsts,
          //svyQstItems: vm.svyQstItems
          pageType: "FORM"
        };

        var modalInstance = modalFactory.open('xs', 'components/modal/survey/wjm-qstmove-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          //vm.data.TenantNm = okData.TenantNm;
          //vm.data.TenantId = okData.TenantId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 초기 세팅
       * @param
       * @return
       */
      function init(){

        // 문항 목록 체크박스 설정
        /*
        vm.qstChkHead = false;
        $scope.qstChkRowChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            if (!vm.qstLists[i].isChecked) {
              vm.qstChkHead = fal se;
              return;
            }
          }
          vm.qstChkHead = true;
        };

        $scope.qstChkHeadChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            vm.qstLists[i].qstChkRow = vm.qstChkHead;
          }
        };
        */

        vm.isLoaded = true;
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData(type) {
        var i = 0;
        var data = vm.srchDetail;

        vm.dataloader = true;
        vm.srchDetail.viewColumns = {}; // 조회 컬럼
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;

            // 데이터 조회 성공
            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (type == "COPY") {
              getDataCopy();
              return;
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              if (!isNullOrEmpty(vm.data.PageCnt)) {
                for (i = 0; i < parseInt(vm.data.PageCnt); i++) {
                  if (!vm.setSvyPageAdd()) break;
                }
                vm.svyPagesCur = 1;
              }

              //Date형식 처리
              if (!isNullOrEmpty(vm.data.SvyBeginDate)) vm.SvyBeginDate = moment(vm.data.SvyBeginDate).toDate();
              if (!isNullOrEmpty(vm.data.SvyEndDate)) vm.SvyEndDate = moment(vm.data.SvyEndDate).toDate();

              // 에디터 내용삽입 (익스플로러 고려)
              try {
                if (!vm.isChrome && oEditors.length > 0) {
                  oEditors.getById["strHtml"].exec("SET_IR", [""]); //내용초기화
                  oEditors.getById["strHtml2"].exec("SET_IR", [""]); //내용초기화
                  oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.TopCont]);
                  oEditors.getById["strHtml2"].exec("PASTE_HTML", [vm.data.BtmCont]);
                }
                else {
                  $("#strHtml").val(vm.data.TopCont);
                  $("#strHtml2").val(vm.data.BtmCont);
                }
              }
              catch (e) {
              }

              // 기본값 (no data 때문에 이쪽으로 들어오는 듯)
              if (isNullOrEmpty(vm.data.keyId)) {
                vm.data.FormType = "100";

                vm.data.SvyNum = "자동생성";
                vm.data.SvyEndMsg = "기간이 만료된 설문입니다.";
                vm.data.RespLimitEndMsg = "응답건수가 마감된 설문입니다.";
                vm.data.BoxColor = "999999";
                vm.data.LineColor = "555555";
                vm.data.BoxColorData = "#" + vm.data.BoxColor + "!Important";
                vm.data.LineColorData = "#" + vm.data.LineColor + "!Important";
                vm.data.SvyTypeNm = "일반설문(미선택)";
                vm.data.RespLimitYN = 'N';
                vm.data.SvyLang = "";

                vm.setSvyPageAdd();
              }

              getDataQsts();
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (문항)
       * @param
       * @return
       */
      function getDataQsts() {
        vm.dataloader = true;

        var data = vm.srchDetail;
        data.mapCode = VIEWQST_SQL;
        data.FormId = vm.data.keyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.svyQsts = result.body.docs;
                //wjmSurvey.sortSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);

                getDataQstItems();
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataQst()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataQst()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (문항)
       * @param
       * @return
       */
      function getDataQstItems() {
        var data = vm.srchDetail;

        vm.dataloader = true;
        data.mapCode = VIEWQSTITEM_SQL;
        data.FormId = vm.data.keyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.svyQstItems = result.body.docs;
                //wjmSurvey.sortSvyNo("IT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }

            setEndProc();
          } else {
            vm.dataloader = false;
            console.error("Error> getDataQstItems()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataQstItems()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (카피)
       * @param
       * @return
       */
      function getDataCopy() {
        var i = 0;

        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.cKeyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        //vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = SVY_VIEW_SQL;
        data.keyId = vm.srch.cKeyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            /*
            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            */

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.FormNm = vm.data.SvyNm + "-복사본";
              vm.data.UseCnt = 0;
              vm.data.FormType = "100";

              delete vm.data.SvyNm;

              if (!isNullOrEmpty(vm.data.PageCnt)) {
                for (i = 0; i < parseInt(vm.data.PageCnt); i++) {
                  if (!vm.setSvyPageAdd()) break;
                }
                vm.svyPagesCur = 1;
              }

              // Date형식 처리
              if (!isNullOrEmpty(vm.data.SvyBeginDate)) vm.SvyBeginDate = moment(vm.data.SvyBeginDate).toDate();
              if (!isNullOrEmpty(vm.data.SvyEndDate)) vm.SvyEndDate = moment(vm.data.SvyEndDate).toDate();

              // 에디터 내용삽입 (익스플로러 고려)
              try {
                if (!vm.isChrome && oEditors.length > 0) {
                  oEditors.getById["strHtml"].exec("SET_IR", [""]); //내용초기화
                  oEditors.getById["strHtml2"].exec("SET_IR", [""]); //내용초기화
                  oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.TopCont]);
                  oEditors.getById["strHtml2"].exec("PASTE_HTML", [vm.data.BtmCont]);
                }
                else {
                  $("#strHtml").val(vm.data.TopCont);
                  $("#strHtml2").val(vm.data.BtmCont);
                }
              }
              catch (e) {
              }

              getDataCopyQsts();
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataCopy()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataCopy()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (카피 문항)
       * @param
       * @return
       */
      function getDataCopyQsts() {
        var data = vm.srchDetail;
        var rtn = [];

        vm.dataloader = true;
        data.mapCode = SVY_VIEWQST_SQL;
        data.SvyId = vm.srch.cKeyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                //vm.svyQsts = result.body.docs;
                rtn = result.body.docs;
                rtn.forEach(function(i) {
                  i.stat = "C";
                  vm.svyQsts.push(i);
                });

                //wjmSurvey.sortSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
                getDataCopyQstItems();
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataCopyQsts()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataCopyQsts()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (카피 보기)
       * @param
       * @return
       */
      function getDataCopyQstItems() {
        var data = vm.srchDetail;
        var rtn = [];

        vm.dataloader = true;
        data.mapCode = SVY_VIEWQSTITEM_SQL;
        data.SvyId = vm.srch.cKeyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                //vm.svyQstItems = result.body.docs;
                rtn = result.body.docs;
                rtn.forEach(function(i) {
                  i.stat = "C";
                  vm.svyQstItems.push(i);
                });

                //wjmSurvey.sortSvyNo("IT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }

            // 문항코드 초기화 및 설문필드 생성
            initQstCode("C");
            setEndProc();
          } else {
            vm.dataloader = false;
            console.error("Error> getDataCopyQstItems()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataCopyQstItems()");
          console.table(error);
        });
      };

      /**
       * 문항코드 초기화 및 설문필드 생성 (카피)
       * @param
       * @return
       */
      /**
       * 문항코드 초기화 및 설문필드 생성
       * @param
       * @return
       */
      function initQstCode(type) {
        var qt = [];
        var it = [];
        var fQt = [];
        var fIt = [];
        var nQtId = "";

        wjmSurvey.codeNo = 0;

        fQt = $filter('filter')(vm.svyQsts, {stat: type}, true);
        fIt = $filter('filter')(vm.svyQstItems, {stat: type}, true);

        fQt.forEach(function (i) {
          nQtId = wjmSurvey.getSvyCode("QT", null, null, false);

          it = $filter('filter')(fIt, {qtId: i.qtId}, true);
          it.forEach(function(j) {
            j.stat = "I";
            j.qtId = nQtId;
            j.itId = wjmSurvey.getSvyCode("IT", null, null, false);
            j.FormQstItemId = "";

            delete j.SvyQstItemId;
          });

          it = $filter('filter')(fIt, {GoToQstId: i.qtId}, true);
          it.forEach(function(j) { j.GoToQstId = nQtId });

          qt = $filter('filter')(fQt, {GoToQstId: i.qtId}, true);
          qt.forEach(function(j) { j.GoToQstId = nQtId });

          i.stat = "I";
          i.qtId = nQtId;
          i.FormQstId = "";

          delete i.SvyQstId;
        });

        wjmSurvey.codeNo = 0;
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';
        if (isNullOrEmpty(vm.data.FormNm)) {
          errMsg = errMsg + '- 서식명을 입력해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.FormType)) {
          errMsg = errMsg + '- 서식유형을 선택해주세요.<br/>';
        }
        /*
        if (isNullOrEmpty(vm.data.TargetCnt) || vm.data.TargetCnt == "0") {
          errMsg = errMsg + '- 대상인원을 입력해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.Gubun)) {
          errMsg = errMsg + '- 구분을 선택해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.SvyBeginDate)) {
          errMsg = errMsg + '- 설문시작일을 선택해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.SvyEndDate)) {
          errMsg = errMsg + '- 설문종료일을 선택해주세요.<br/>';
        }
        */
        /*
        if (vm.data.RespLimitYN == "Y") {
          if (isNullOrEmpty(vm.data.RespLimitCnt) || vm.data.RespLimitCnt == "0") {
            errMsg = errMsg + '- 응답인원을 제한한 경우 제한수를 입력해주세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.RespLimitEndMsg)) {
            errMsg = errMsg + '- 응답인원을 제한한 경우 건수마감메시지를 입력해주세요.<br/>';
          }
        }
        */
        /*
        if (isNullOrEmpty(vm.data.SvyEndMsg)) {
          errMsg = errMsg + '- 기간만료메세지를 입력해주세요.<br/>';
        }
        */
        /*
        if (isNullOrEmpty(vm.data.BoxColor)) {
          errMsg = errMsg + '- 테두리색상을 입력해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.LineColor)) {
          errMsg = errMsg + '- 구분선색상을 선택해주세요.<br/>';
        }
        */

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (!getIsValidData()) return;

        vm.dataloader = true;

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        //vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');
        vm.data.SvyBeginDate = moment(vm.data.SvyBeginDate).format('YYYY-MM-DD');
        vm.data.SvyEndDate = moment(vm.data.SvyEndDate).format('YYYY-MM-DD');

        // 에디터 내용 삽입
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.TopCont = $("#strHtml").val();
        oEditors.getById["strHtml2"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.BtmCont = $("#strHtml2").val();

        // 체크박스 처리
        if (isNullOrEmpty(vm.data.InfoAgreeYN1)) vm.data.InfoAgreeYN1 = "N";
        if (isNullOrEmpty(vm.data.InfoAgreeYN2)) vm.data.InfoAgreeYN2 = "N";
        if (isNullOrEmpty(vm.data.InfoAgreeYN3)) vm.data.InfoAgreeYN3 = "N";
        if (isNullOrEmpty(vm.data.InfoAgreeYN4)) vm.data.InfoAgreeYN4 = "N";

        // 라디오박스 처리
        if (isNullOrEmpty(vm.data.QstPassYN)) vm.data.QstPassYN = "Y";
        if (isNullOrEmpty(vm.data.RespLimitYN)) vm.data.RespLimitYN = "N";
        if (isNullOrEmpty(vm.data.QstNumYN)) vm.data.QstNumYN = "Y";
        if (isNullOrEmpty(vm.data.QstIconType)) vm.data.QstIconType = "N";
        if (isNullOrEmpty(vm.data.LinkCRMYN)) vm.data.LinkCRMYN = "N";
        if (isNullOrEmpty(vm.data.BtmType)) vm.data.BtmType = "100";
        if (isNullOrEmpty(vm.data.SvyLang)) vm.data.SvyLang = "";

        // 기타
        vm.data.PageCnt = vm.svyPages.length;
        //if (!isNullOrEmpty(vm.data.RespLimitCnt)) vm.data.RespLimitYN = "Y";

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            vm.dataloader = false;

            //setInsertUpdateDetail(result);
            if (result.body.docs[0].KeyId !== null || result.body.docs[0].NewKeyId !== null || !isNullOrEmpty(result.body.docs[0].RelateDataId))
            {
              //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
              vm.data.keyId = result.body.docs[0].RelateDataId;
            }

            setDataQsts();
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            vm.dataloader = false;
            //setInsertUpdateDetail(result);
            setDataQsts();
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 (문항)
       *
       * @param
       * @return
       */
      function setDataQsts() {
        //if (!getIsValidData()) return;
        vm.dataloader = true; // Progressbar 표시

        // 내용
        //vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        //vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        //vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        //vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');

        var data = vm.data;
        var insertData = $filter('filter')(vm.svyQsts, {FormQstId: '!!'}, true);
        var updateData = $filter('filter')(vm.svyQsts, {FormQstId: '!', stat: 'U'}, true);

        data.userkey = vm.srch.userkey;
        data.mapCode = INSERTUPDATEQST_SQL;

        data.insertData = insertData;
        data.updateData = updateData;
        data.FormId = vm.data.keyId;

        if (insertData.length > 0 || updateData.length > 0) {
          postApi.insert(data, function (result) {
            vm.dataloader = false;
            setDataQstItems();
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setDataQsts()");
            console.table(error);
          });
        }
        else {
          vm.dataloader = false;
          setInsertUpdateDetail();
        }
      }

      /**
       * 데이터 저장 (보기)
       *
       * @param
       * @return
       */
      function setDataQstItems() {
        //if (!getIsValidData()) return;

        vm.dataloader = true;

        // 내용
        //vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        //vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        //vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        //vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');

        var data = vm.data;
        var insertData = $filter('filter')(vm.svyQstItems, {FormQstItemId: '!!'}, true);
        var updateData = $filter('filter')(vm.svyQstItems, {FormQstItemId: '!', stat: 'U'}, true);

        data.userkey = vm.srch.userkey;
        data.mapCode = INSERTUPDATEQSTITEM_SQL;

        data.insertData = insertData;
        data.updateData = updateData;
        data.FormId = vm.data.keyId;

        if (insertData.length > 0 || updateData.length > 0) {
          postApi.insert(data, function (result) {
            vm.dataloader = false;
            setDataCleanup();
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setDataQstItems()");
            console.table(error);
          });
        }
        else {
          vm.dataloader = false;
          setDataCleanup();
        }
      }

      /**
       * 문항 정리
       *
       * @param
       * @return
       */
      function setDataCleanup() {
        var data = vm.data;
        var deleteQstData = $filter('filter')(vm.svyQsts, {FormQstId: '!', stat: 'D'}, true);
        var deleteQstItemData = $filter('filter')(vm.svyQstItems, {FormQstItemId: '!', stat: 'D'}, true);

        vm.dataloader = true;

        data.deleteQstData = deleteQstData;
        data.deleteQstItemData = deleteQstItemData;
        data.userkey = vm.srch.userkey;
        data.mapCode = UPDATEFORMCLEANUP_SQL;
        data.FormId = vm.data.keyId;

        postApi.insert(data, function (result) {
          vm.dataloader = false;
          setInsertUpdateDetail();
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> setDataCleanup()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        gAlert("", "Menu.SAVED", {
          btn: "",
          fn: function () {
            // 화면 분할 모드에 따른 이동
            goNextPage(true);
          }
        });

        /*
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          //console.log("result.body.docs[0]", result.body.docs[0]);
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
            !isNullOrEmpty(result.body.docs[0].RelateDataId)
          ) {
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            //vm.data.KeyId = result.body.docs[0].RelateDataId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
        */
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId,
              cKeyId: ''
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, cKeyId: ''});
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.keyId, cKeyId: ''});
          //$state.go(LIST_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        /*
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;
        */

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          //if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });
          //}
          /*
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
          */
        });
      }

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }
      */

      /**
       * 마지막 실행 프로세스
       *
       * @param
       * @return
       */
      function setEndProc() {
        wjmSurvey.getImageList(vm.imageList, vm.svyQsts, vm.svyQstItems);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;
      vm.init = init;

      // 데이터 조회
      if (isNullOrEmpty(vm.srch.keyId) && !isNullOrEmpty(vm.srch.cKeyId)) {
        getData("COPY");
      }
      else {
        getData();
      }

      //init();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('WjmFormListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function WjmFormListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmForm.getFormListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmForm.getFormList';    // 목록 조회 SQL
      //var EXCEL_SQL = 'WjmReport.getResultExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmForm.deleteFormList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.form-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.form-list.edit';         // 목록 조회 화면
      //var VIEW_PAGE_URL = 'app.survey.result-detail';         // 조회 화면
      var EDIT_PAGE_URL = 'app.survey.form-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.form'; // 작업 테이블명
      //var EXCEL_TITLE = '설문 결과 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 설문작성 화면
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: '',
          cKeyId: ''
        });
      }

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          //$state.go(VIEW_PAGE_URL, {
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          //if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          //}
          /*
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
          */
        });
      }

      // 목록 엑셀 다운로드
      /*
      function getExcelFile() {

        // 체크 대상이 있을 경우 해당 목록만 다운로드 하게 해달라는 요청
        // 체크 대상이 없을 경우 전체 목록 다운로드
        var chk = getChkList("XLS");
        if ( ! chk) return false;

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if (item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'SvyBeginDate' || item.ColumnPhysicalNm == 'SvyEndDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }
      */

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      //vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      setInitData();
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('WjmImageEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function WjmImageEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmSurvey.insertImage'; // 등록 SQL
      var UPDATE_SQL = 'WjmSurvey.updateImage'; // 수정 SQL
      var VIEW_SQL = 'WjmSurvey.getImageDetail'; // 조회 SQL
      var DEL_SQL = 'WjmSurvey.deleteImageDetail';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.image-list'; // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.image-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.survey.image-edit'; // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.image'; // 조회용 테이블명
      var KEY_COLUMN_NM = 'ImgId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = KEY_COLUMN_NM; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              /*
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
              */
                vm.uploadFileList.push(obj);
              /*}*/
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          /*
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
          */
            $timeout(setData, 1);
          /*}*/
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      // #endregion 첨부파일 Callback

      /**
       * 초기 세팅
       * @param
       * @return
       */
      function init(){
        // 문항 목록 체크박스 설정
        /*
        vm.qstChkHead = false;
        $scope.qstChkRowChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            if (!vm.qstLists[i].isChecked) {
              vm.qstChkHead = fal se;
              return;
            }
          }
          vm.qstChkHead = true;
        };

        $scope.qstChkHeadChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            vm.qstLists[i].qstChkRow = vm.qstChkHead;
          }
        };
        */
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData(type) {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback);
        //initVaultComponent('vault2', vm.onFileCallback);

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              //if (!isNullOrEmpty(vm.data.SvyBeginDate)) vm.SvyBeginDate = moment(vm.data.SvyBeginDate).toDate();

              getUploadFileList();
              return false;

              // 첨부파일 목록 설정
              /*
              vm.uploadFileList = [];
              //vm.uploadFileList2 = [];

              console.log("vm.data.uploadFileList", vm.data.uploadFileList);

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
              */
            } else {
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      /*
      function uploadFile2() {
        if (vm.vault2 != null && vm.vault2.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault2);
        } else {
          // 데이터 저장
          setData();
        }
      }
      */

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';
        if (isNullOrEmpty(vm.data.ImgNm)) {
          errMsg = errMsg + '- 이미지그룹명을 입력해주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.tableNm = KEY_TABLE_NM;
        data.TableId = vm.srch.keyId;
        data.mapCode = 'FileAttach.getFileListOri';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            //if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalFolderNm + "&fileName=" + item.LogicalFileNm),
                  src: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          //}
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (!getIsValidData()) return;

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        /*
        angular.forEach(vm.uploadFileList2, function(item) {
          vm.data.uploadFileList.push(item);
        });
        */

        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        //vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');

        // 에디터 내용 삽입
        //oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        //vm.data.TopCont = $("#strHtml").val();

        // 체크박스 처리
        //if (isNullOrEmpty(vm.data.InfoAgreeYN1)) vm.data.InfoAgreeYN1 = "N";

        // 라디오박스 처리
        //if (isNullOrEmpty(vm.data.QstPassYN)) vm.data.QstPassYN = "Y";

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            //result.body.docs[0].KeyId !== null || result.body.docs[0].NewKeyId !== null
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            vm.data.keyId = result.body.docs[0].RelateDataId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              //keyId: vm.data.KeyId
              keyId: vm.data.keyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
          $state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.keyId});
          //$state.go(LIST_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, { srch: srch }, {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }
      */

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      vm.setDelData = setDelData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;

      getData();
      init();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('WjmImageListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function WjmImageListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSurvey.getImageListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSurvey.getImageList';    // 목록 조회 SQL
      //var EXCEL_SQL = 'WjmSurvey.getImageExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmSurvey.deleteImageList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.image-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.image-list.edit';         // 목록 조회 화면
      //var VIEW_PAGE_URL = 'app.survey.image-detail';         // 조회 화면
      var EDIT_PAGE_URL = 'app.survey.image-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.image'; // 작업 테이블명
      //var EXCEL_TITLE = '설문 결과 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 설문작성 화면
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: '',
          cKeyId: ''
        });
      }

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          //$state.go(VIEW_PAGE_URL, {
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            cKeyId: ''
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function deleteList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          //if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getList();
            }
          });
          //}
          /*
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> deleteListAction()");
          console.table(error);
          */
        });
      }

      // 목록 엑셀 다운로드
      /*
      function getExcelFile() {

        // 체크 대상이 있을 경우 해당 목록만 다운로드 하게 해달라는 요청
        // 체크 대상이 없을 경우 전체 목록 다운로드
        var chk = getChkList("XLS");
        if ( ! chk) return false;

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if (item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'SvyBeginDate' || item.ColumnPhysicalNm == 'SvyEndDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }
      */

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.deleteList = deleteList;                 // 목록 삭제
      //vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      setInitData();
    }]);
})();

(function () {
  "use strict";

  webapp.controller('WjmReportDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter' , 'wjmSurvey', '$http',

    function WjmReportDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, wjmSurvey, $http) {

      // SQL Mapper Id 정의
      var VIEW_SQL = 'WjmReport.getReportDetail'; // 조회 SQL
      var UPDATE_SQL = 'WjmReport.updateReport'; // 수정 SQL
      var LIST_SQL = 'WjmReport.getReportTargetList';    // 개인보고서 목록 조회 SQL
      var LIST_CNT_SQL = 'WjmReport.getReportTargetListCnt'; // 개인보고서 목록 건수 조회 SQL
      var DELETE_LIST_SQL = 'WjmReport.deleteReportTargetListBatch'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.report-list';           // 목록 화면
      var VIEW_PAGE_URL = 'app.survey.report-detail';           // 조회 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.report-list.detail'; // 목록 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.report'; // 보고서
      var KEY_TABLE_NM2 = 'wjm.reporttarget'; // 개인보고서 목록
      var KEY_COLUMN_NM = 'RptId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId, // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      // 개인보고서 검색 옵션 설정
      if (!$stateParams.srch2) {
        vm.srch2 = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM2,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate',          // 정렬컬럼명
        };
      } else {
        vm.srch2 = JSON.parse(decodeURIComponent($stateParams.srch2));
        vm.srch2.tableNm = !isNullOrEmpty($stateParams.srch2.tableNm) ? $stateParams.srch2.tableNm : KEY_TABLE_NM2;
        vm.SendBeginDate = $rootScope.getDateFormat(vm.srch2.SendBeginDate);
        vm.SendEndDate = $rootScope.getDateFormat(vm.srch2.SendEndDate);
        vm.RegBeginDate = $rootScope.getDateFormat(vm.srch2.RegBeginDate);
        vm.RegEndDate = $rootScope.getDateFormat(vm.srch2.RegEndDate);
        vm.currentPage = vm.srch2.page;
      }

      $scope.wjmSurvey = wjmSurvey;
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
        vm.srch2.keyId = $stateParams.keyId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch2, vm.srchList);
      vm.anchor = "";

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      // 개인보고서 목록 검색
      function getSearch() {
        goNextPage(false);
      }

      // 개인보고서 목록 검색 초기화
      function setResetSearch() {
        goNextPage(false, '');
      }

      // 개인보고서 목록 건수
      function getListCnt() {
        var data = angular.copy(vm.srch2);
        data.mapCode = LIST_CNT_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      // 보고서정보 조회
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        vm.srchDetail.viewColumns = {}; // 사용자정의 컬럼 정보 설정
        var data = vm.srchDetail; // 검색 옵션 설정
        data.mapCode = VIEW_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }
            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;


              getList();
            } else {
              gAlert('', 'MSG.NO_DATA');
              vm.dataloader = false;
            }
          }
          vm.dataloader = false;
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getData()");
          console.table(error);
        });
      }

      // 개인보고서 목록 조회
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch2.viewSize; // 목록당 조회건수 설정


        var data = angular.copy(vm.srch2); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        getListCnt(); // 목록 건수 조회

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch2);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD HH:mm:ss";
          }
          index++;
          columns.push(column);
        });

        setInitData();
      }

      // 개인보고서 목록 페이지 이동
      function setPageChanged() {
        vm.srch2.page = vm.currentPage;
        goNextPage(false);
      }

      // 개인보고서 목록 조회건수 변경
      function setChangeViewSize() {
        vm.currentPage = 1;
        vm.viewSize = vm.srch2.viewSize;
        getSearch();
      }

      // 개인보고서 목록 정렬
      function setSortColumn(sortColumn, isSortable) {
        if (isSortable == 'N') return;
        if (vm.srch2.sortColumn != sortColumn) {
          vm.srch2.sortDirect = "ASC";
        } else {
          vm.srch2.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }
        vm.srch2.sortColumn = sortColumn;
        getSearch();
      }

      // 개인보고서 목록 정렬 아이콘 설정
      function setSortDirect(sortColumn) {
        if (sortColumn != vm.srch2.sortColumn) {
          return 'fa fa-sort';
        }
        var rtnval = '';
        if (vm.srch2.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 페이지 이동
      function goPage(type) {
        var srch = $stateParams.srch;
        var page = '';
        switch(type){
          case "L" : page = LIST_PAGE_URL; break; // 목록
        }
        $state.go(page, {srch: srch, keyId: vm.data.KeyId});
      }

      // 다운로드
      function getFile() {
        vm.dataloader = true;

        var fileList = [];
        switch(vm.data.RptType)
        {
          // 개인보고서
          case "P" :
            for (var i = 0; i < vm.lists.length; i++) {
              if (vm.lists[i].chkRow) {
                fileList.push({
                  fileDir: vm.lists[i].PhysicalFolderNm,
                  fileNm: vm.lists[i].LogicalFileNm,
                  pFileNm: vm.lists[i].PhysicalFileNm
                });
              }
            }
            break;

          // 조직보고서
          case "O" :
            fileList.push({
              fileDir: vm.data.PhysicalFolderNm,
              fileNm: vm.data.LogicalFileNm,
              pFileNm: vm.data.PhysicalFileNm
            });
            break;
        }
        if (fileList.length == 0) {
          gAlert('', '대상을 선택해 주세요.');
          vm.dataloader = false;
          return false;
        }

        angular.forEach(fileList, function (item) {

          var data = {};
          data.mapCode = "analysis";
          data.fileType = "D";
          data.fileDir = item.fileDir;
          data.fileNm = item.fileNm;
          data.pFileNm = item.pFileNm;

          postApi.wjmReport(data, function(result){
          }, function (error) {
            // 조회 중 오류 발생
            vm.dataloader = false;
            console.error("Error> getFile");
            console.table(error);
          });
        });

        vm.dataloader = false;
      }

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      vm.sendRpt = function (sendType) {
        var tgtList = [];
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            tgtList.push({RptTgtId: vm.lists[i].KeyId, Email: vm.lists[i].SendEmail, Mobile: vm.lists[i].SendMobile});
          }
        }
        if (tgtList.length == 0) {
          gAlert('', '대상을 선택해 주세요.');
          vm.dataloader = false;
          return false;
        }
        var url = "app.survey."+ sendType +"-send";
        var srch = {
          svyId: vm.data.SvyId,
          svyNm: (isNullOrEmpty(vm.data.SvyNm) ? vm.data.RptNm : vm.data.SvyNm),
          svyDate: vm.data.SvyDate,
          clientId: vm.data.Manager,
          clientNm: vm.data.ManagerNm,
          rptId: vm.data.KeyId,
          rptTgtList: tgtList
        };
        $rootScope.gVariable.layoutBoard = "N";
        $state.go(url, {srch: encodeURIComponent(JSON.stringify(srch, replacer))});
      };

      // 목록 삭제 확인
      function setDelList() {
        gConfirm('', '선택한 정보를 삭제하시겠습니까?', {
          btn: '',
          fn: function () {
            setDelListAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 목록 삭제
      function setDelListAction() {

        vm.srch2.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch2.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch2.KeyIdList == null || vm.srch2.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = angular.copy(vm.srch2);
        data.MapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 파일 삭제 확인
      function setDelFile() {
        gConfirm('', '삭제 후 복구가 불가능합니다. 진행하시겠습니까?', {
          btn: '',
          fn: function () {
            setDelFileAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 파일 삭제
      function setDelFileAction() {

        vm.srch2.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch2.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch2.KeyIdList == null || vm.srch2.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = angular.copy(vm.srch2);
        data.delMapCode = DELETE_LIST_SQL;
        data.uploadFileList = [];


        data.mapCode = 'WjmReport.delRptList';
        postApi.wjmReportDel(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 양식 다운로드
      vm.doDownload = function ()  {
        var a = document.createElement("a");
        document.body.appendChild(a);

        var fileName = "외부보고서 대상자정보 양식";
        var exportData = [];

        exportData.push(["이메일", "이름", "휴대폰"]);
        exportData.push(["email@email.com", "김고객", "01012345678"]);

        $rootScope.excelDown(exportData, fileName);
      };

      // 일괄 업로드
      function doUpload()  {
        vm.dataloader = true;

        var file = $("input[name=excelFile]")[0].files[0];
        if(file == undefined) {
          vm.dataloader = false;
          gAlert('', '파일을 선택하세요.');
          return;
        }
        var formData = new FormData();
        var uploadUrl = "excelUpload/WjmReport.updateExtRptTargetBatch/action.json";
        var ext = file.name.split('.').pop().toLowerCase();
        if($.inArray(ext, ['xlsx']) == -1){
          vm.dataloader = false;
          gAlert('', 'xlsx 형식의 파일을 선택하세요.');
          return;
        }

        formData.append("mFile",file);
        formData.append("ext",ext);
        formData.append("RptId", vm.data.KeyId);
        formData.append("SESSION_USERID", $rootScope.gVariable.UserId);

        $http({
          url: uploadUrl,
          method: "POST",
          data: formData,
          transformRequest: angular.identity,
          headers: {'Content-type': undefined}
        }).success(function (data, status, headers, config) {
          vm.dataloader = false;
          gAlert('', '저장 되었습니다.');
          getList();
        }).error(function (data, status, headers, config) {
          vm.dataloader = false;
          gAlert('', '오류가 발생했습니다.');
        });
        vm.dataloader = false;
      }

      function getIsValidData() {
        var errMsg = '';
        if (isNullOrEmpty(vm.data.RptNm)) {
          errMsg = errMsg + '- 보고서명을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      // 보고서명 저장
      function setData() {
        if (!getIsValidData()) return;

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

        var data = vm.data; // 사용자 입력 데이터

        data.RelateDataId = data.keyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
        });
      }

      // 데이터 저장 후 처리
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function () {
              goNextPage(true);
            }
          });
          return;
        }
        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }


      function goNextPage(reloadList, srch2Init) {
        var srch = $stateParams.srch; // 검색 옵션
        var srch2 = (srch2Init ? '' : encodeURIComponent(JSON.stringify(vm.srch2, replacer)));

        if (vm.layout == 'N') {
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            srch2: srch2,
            keyId: vm.data.KeyId
          }, {reload:VIEW_PAGE_URL});
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
            srch2 = srch2;
          }
          $state.go(LIST_VIEW_PAGE_URL, {srch2: srch2, srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
        }
      }

      // 업체 검색
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.setData = setData;
      vm.goPage = goPage;                       // 화면 이동
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.setDelFile = setDelFile;                 // 파일 삭제
      vm.getFile = getFile; // 파일 다운로드
      vm.doUpload = doUpload; // 일괄 업로드

      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시


      // 데이터 조회
      getData();

    }]);
})();


(function () {
  "use strict";

  webapp.controller('WjmReportListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function WjmReportListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmReport.getReportListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmReport.getReportList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.report-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.report-list.detail';         // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.survey.report-detail';         // 조회 화면
      var EXCEL_SQL = 'WjmReport.getReportExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmReport.deleteReportListBatch'; // 목록에서 삭제

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.report'; // 작업 테이블명
      var EXCEL_TITLE = '보고서 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom);
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              console.log(vm.lists);
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }


      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 업체 검색
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            srch2: ''
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId,
            srch2: ''
          });
        }
      }

      // 목록 엑셀 다운로드
      function getExcelFile() {

        if (vm.lists.length == undefined || vm.lists.length == 0) {
          gAlert("", "데이터가 없습니다.");
          return;
        }

        // 체크한 대상만 엑셀로 다운로드
        vm.srch.KeyIdList = [];
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if (item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                obj.push(value[item.ColumnPhysicalNm]);
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 목록 삭제 확인
      function setDelList() {
        gConfirm('', '선택한 정보를 삭제하시겠습니까?', {
          btn: '',
          fn: function () {
            setDelListAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 목록 삭제
      function setDelListAction() {

        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = angular.copy(vm.srch);
        data.MapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 파일 삭제 확인
      function setDelFile() {
        gConfirm('', '삭제 후 복구가 불가능합니다. 진행하시겠습니까?', {
          btn: '',
          fn: function () {
            setDelFileAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 파일 삭제
      function setDelFileAction() {

        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = angular.copy(vm.srch);
        data.delMapCode = DELETE_LIST_SQL;
        data.uploadFileList = [];


        data.mapCode = 'WjmReport.delRptList';
        postApi.wjmReportDel(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 설문 검색 팝업
      vm.srchSurveyModal = function () {
        var ctrl = 'WjmSurveyModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };
        var modalInstance = modalFactory.open('md', 'components/modal/survey/wjm-survey-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.SvyNm = res.SvyNm;
          vm.srch.SvyId = res.KeyId;
        }, function(cancelData) {
        });
      };
      vm.eraseSurvey = function () {
        vm.srch.SvyId = '';
        vm.srch.SvyNm = '';
      };


      // 업체 검색
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.setDelFile = setDelFile;                 // 파일 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
      setInitData();

    }]);
})();

(function () {
  "use strict";

  webapp.controller('WjmReportMngDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter' , 'wjmSurvey', '$http',

    function WjmReportMngDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter,wjmSurvey, $http) {

      // SQL Mapper Id 정의
      var VIEW_SQL = 'WjmReport.getReportMngDetail'; // 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.report-mng-list';           // 목록 화면
      var ANAL_PAGE_URL = 'app.survey.analysis';         // 데이터분석 화면 (조직보고서 생성)

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.reportmng'; // 작업 테이블명
      var KEY_COLUMN_NM = 'SvyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      $scope.wjmSurvey = wjmSurvey;
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      // 설문정보 조회
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        vm.srchDetail.viewColumns = {}; // 사용자정의 컬럼 정보 설정
        var data = vm.srchDetail; // 검색 옵션 설정
        data.mapCode = VIEW_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }
            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;

              vm.dataloader = false;
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }
          vm.dataloader = false;
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getData()");
          console.table(error);
        });
      }

      // 페이지 이동
      function goPage(type) {
        var srch = $stateParams.srch;
        var page = '';
        switch(type){
          case "L" : page = LIST_PAGE_URL; break; // 목록
        }
        $state.go(page, {srch:srch, keyId: vm.data.KeyId});
      }

      // 보고서 생성 화면 > 데이터 분석 화면
      function genOgnRpt() {

        var KeyIdList = [vm.data.KeyId];

        var srch = {
          "SvyIds": KeyIdList,
          "SvyNms": vm.data.SvyNm,
          "SvyDate": vm.data.SvyDate,
          "SvyStatus": vm.data.SvyStatus,
          "SvyTypeId": vm.data.SvyTypeId,
          "ClassfyInfoId": vm.data.ClassfyInfoId,
          "SecLevelCnt": vm.data.SecLevelCnt,
          "TgtCnt": vm.data.TgtCnt,
          "QstCnt": vm.data.QstCnt,
          "ClientNm": vm.data.ManagerNm,
          "rptNum": vm.data.SvyNum +"_O",
          "rptType": "O",
          "ScoringType": vm.data.ScoringType,
          "SvyTypeCd": vm.data.SvyTypeCd,

          "tmpFileNm": "",
          "fileNm": "",
          "fileDir": "",
          "rptNm": ""
        };

        srch.tmpFileNm = "Report_"+ vm.data.SvyTypeCd +"_org.xlsx";
        srch.fileNm = "Report_"+ vm.data.KeyId + ".xlsx";
        srch.fileDir =  "wjm-report";
        srch.rptNm = "조직보고서";

        $state.go(ANAL_PAGE_URL, {
          srch: encodeURIComponent(JSON.stringify(srch, replacer)),
          srch2: $stateParams.srch
        });
      }

      // 개인보고서 수동생성
      function genPsnRpt() {
        var msg = "- 시스템 속도에 영향을 줄 수 있습니다.<br/>";
        msg += "- 페이지를 벗어나도 작업은 계속됩니다.<br/>";
        msg += "- 새로고침으로 상태를 확인하세요.<br/><br/>";
        msg += "수동 생성을 시작하시겠습니까?";

        gConfirm('', msg, {
          btn: '',
          fn: function () {
            var data = angular.copy(vm.srch);
            data.tgtSvyId = vm.data.KeyId;
            data.mapcode = 'wjm/createPsnReport';

            postApi.api(data, function (result) {
              if (result.body.docs.length > 0) {
                gAlert("",result.body.docs[0].errMessage);
              }
            }, function (error) {
              console.error("Error> genPsnRpt()");
              console.table(error);
            });
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goPage = goPage;                       // 화면 이동
      vm.genOgnRpt = genOgnRpt;   // 조직보고서 생성 화면 이동
      vm.genPsnRpt = genPsnRpt;   // 개인보고서 수동생성

      // 데이터 조회
      getData();

    }]);
})();


(function () {
  "use strict";

  webapp.controller('WjmReportMngListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function WjmReportMngListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmReport.getReportMngListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmReport.getReportMngList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.report-mng-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.report-mng-list.detail';         // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.survey.report-mng-detail';         // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.reportmng'; // 작업 테이블명
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.SvyBeginDate = $rootScope.getDateFormat(vm.srch.SvyBeginDate);
        vm.SvyEndDate = $rootScope.getDateFormat(vm.srch.SvyEndDate);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }


      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 업체 검색
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }



      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      // 목록 조회
      getList();

    }]);
})();

(function () {
  "use strict";

  webapp.controller('WjmReportSearchCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter' , 'wjmSurvey', '$http',

    function WjmReportSearchCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, wjmSurvey, $http) {

      // SQL Mapper Id 정의
      var LIST_SQL = 'WjmReport.getReportTargetList';    // 개인보고서 목록 조회 SQL
      var LIST_CNT_SQL = 'WjmReport.getReportTargetListCnt'; // 개인보고서 목록 건수 조회 SQL

      // 관련 화면 정의
      var VIEW_PAGE_URL = 'app.survey.report-search';           // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.reportsearch'; // 개인보고서 목록

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.totalItems = 0;

      // 개인보고서 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate',          // 정렬컬럼명
          Manager: $rootScope.gVariable.UserId,
          chkSrch: "N",
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.SendBeginDate = $rootScope.getDateFormat(vm.srch.SendBeginDate);
        vm.SendEndDate = $rootScope.getDateFormat(vm.srch.SendEndDate);
        vm.currentPage = vm.srch.page;
        vm.srch.chkSrch = "Y";
      }

      vm.srch.loginComUserId = $window.sessionStorage['loginComUserId'];
      vm.srch.loginCounselorCode = $window.sessionStorage['loginCounselorCode'];

      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.anchor = "";

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      // 개인보고서 목록 검색
      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(VIEW_PAGE_URL, {srch: srch}, {reload: ''});
      }

      // 개인보고서 목록 검색 초기화
      function setResetSearch() {
        $state.go(VIEW_PAGE_URL, {srch: ''}, {reload: ''});
      }

      // 개인보고서 목록 건수
      function getListCnt() {
        var data = angular.copy(vm.srch);
        data.mapCode = LIST_CNT_SQL;
        data.roleType = vm.roleType;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      // 개인보고서 목록 조회
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        if(vm.srch.chkSrch == "Y") getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.roleType = vm.roleType;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 사용자 역할 조회
       * @param
       * @return
       */
      function getRoleType() {
        var data = {};
        vm.dataloader = true;
        data.mapCode = "WjmSystem.getRoleType";

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.roleType = result.body.docs[0].RoleType;

              getList();
            } else {
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getRoleType()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getRoleType()");
          console.table(error);
        });
      }

      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD HH:mm:ss";
          }
          index++;
          columns.push(column);
        });
      }

      // 개인보고서 목록 페이지 이동
      function setPageChanged() {
        vm.srch.page = vm.currentPage;
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(VIEW_PAGE_URL, {srch: srch}, {reload: ''});
      }

      // 개인보고서 목록 조회건수 변경
      function setChangeViewSize() {
        vm.currentPage = 1;
        vm.viewSize = vm.srch.viewSize;
        getSearch();
      }

      // 개인보고서 목록 정렬
      function setSortColumn(sortColumn, isSortable) {
        if (isSortable == 'N') return;
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }
        vm.srch.sortColumn = sortColumn;
        getSearch();
      }

      // 개인보고서 목록 정렬 아이콘 설정
      function setSortDirect(sortColumn) {
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }
        var rtnval = '';
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 다운로드
      function getFile(li) {
        vm.dataloader = true;

        var fileList = [];
        if(isNullOrEmpty(li)) {
          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].chkRow) {
              fileList.push({
                fileDir: vm.lists[i].PhysicalFolderNm,
                fileNm: vm.lists[i].LogicalFileNm,
                pFileNm: vm.lists[i].PhysicalFileNm
              });
            }
          }
        }
        else{
          fileList.push({
            fileDir: li.PhysicalFolderNm,
            fileNm: li.LogicalFileNm,
            pFileNm: li.PhysicalFileNm
          });
        }

        if (fileList.length == 0) {
          gAlert('', '대상을 선택해 주세요.');
          vm.dataloader = false;
          return false;
        }

        angular.forEach(fileList, function (item) {

          var data = {};
          data.mapCode = "analysis";
          data.fileType = "D";
          data.fileDir = item.fileDir;
          data.fileNm = item.fileNm;
          data.pFileNm = item.pFileNm;

          postApi.wjmReport(data, function(result){
          }, function (error) {
            // 조회 중 오류 발생
            vm.dataloader = false;
            console.error("Error> getFile");
            console.table(error);
          });
        });

        vm.dataloader = false;
      }

      // 업체 검색
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 함수 정의
      vm.getFile = getFile; // 파일 다운로드
      vm.getList = getList;
      vm.setInitData = setInitData;

      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      getRoleType();
      setInitData();

    }]);
})();

(function () {
  "use strict";
  webapp.controller('WjmReportUploadCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function WjmReportUploadCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      var INSERT_SQL = 'WjmReport.saveWjmReport'; // 보고서 등록,수정 SQL
      var INSERT_TGT_SQL = 'WjmReport.insertWjmReportTarget'; // 보고서 대상 등록 SQL

      var VIEW_PAGE_URL = 'app.survey.report-detail'; // 보고서 관리 상세 화면

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.uploadFileList = [];  // 첨부파일 목록
      vm.data = {};
      vm.chkRpt = false;
      vm.chkFile = false;

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.RelateDataId = getKeyVal("tgt"); // RptTgtId 키 생성
              obj.ExtTgtEmail = item.fileName.replace(".pdf","");
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          $timeout(setData, 1);
        },
        onLoaded: function (id, vault) {
          vm[id] = vault;
        }
      };
      // #endregion 첨부파일 Callback

      // 초기화
      function init() {
        vm.data.RptId = getKeyVal("rpt"); // RptId 키 생성

        vm.showUploader = enableUploadComponent();
        wjmInitVaultComponent('vault', vm.onFileCallback);
      }

      // 업로드
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }
        vm.dataloader = true;
        uploadVaultFile(vm.vault);
      }

      // 값 체크
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.data.RptNm)) {
          errMsg = errMsg + '보고서명을 입력해주세요.<br/>';
        }
        if( ! vm.chkFile){
          errMsg = errMsg + '보고서 파일을 선택해주세요.';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }
        return true;
      }

      // 보고서 정보 저장
      function setData() {

        if (!getIsValidData()) return;

        vm.dataloader = true;

        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });

        vm.data.tableNm = "wjmreport";
        vm.data.IdName = "RptId";
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });

        var data = vm.data;
        data.mapCode = INSERT_SQL;

        postApi.insert(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].RelateDataId !== null) {
              setTgtData();
            }
            vm.dataloader = false;
          }
          vm.dataloader = false;
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> setRptData()");
          console.table(error);
        });
      }

      // 보고서 대상 정보 저장
      function setTgtData() {

        vm.data.FolderId = vm.data.RptId;
        vm.data.tableNm = "wjmreporttarget";
        vm.data.IdName = "RptTgtId";

        var data = vm.data;
        data.mapCode = INSERT_TGT_SQL;

        postApi.insert(data, function (result) {
          vm.dataloader = false;
          setInsertUpdateDetail(result);
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> setTgtData()");
          console.table(error);
        });
      }

      // 저장 후 이동
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert("", result.body.docs[0].iCnt +"건이 업로드 되었습니다.", {
            btn: "",
            fn: function () {
              goNextPage(true);
            }
          });
          return;
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      // 이동
      function goNextPage(reloadList) {
        var srch = $stateParams.srch;
        $state.go(VIEW_PAGE_URL, {
          srch: '',
          keyId: vm.data.RptId,
          srch2: ''
        }, {reload:VIEW_PAGE_URL});
      }

      function wjmInitVaultComponent (id, callback, bOpenApi, exts) {
        var korean = {
          add: "파일추가",
          browse: "파일찾기",
          cancel: "취소",
          clear: "초기화",
          clearAll: "전체 초기화",
          download: "다운로드",
          dragAndDrop: "",
          filesOrFoldersHere: "여러 개의 첨부 파일을 마우스로 끌어놓으세요.",
          or: "",
          upload: ""
        };
        var iCheck = 0;
        var checkVaultInterval = setInterval(function() {
          if (iCheck > 10) {
            clearInterval(checkVaultInterval);
            return;
          }
          iCheck++;
          if($('#' + id).length > 0) {
            clearInterval(checkVaultInterval);
            var vault = new dhx.Vault(id, {
                mode: "list",
                uploader: {
                    target: API_HTTP_PROTOCOL + "//" + API_SERVER_DOMAIN + ":" + API_SERVER_PORT + (bOpenApi? "/openapi": "") + "/wjmpsnreport/upload.do?RptId=" + vm.data.RptId,
                    autosend: false
                }
            });
            var activeCheck = "pdf";//확장자 제한
            if (exts) {
              activeCheck = exts;
            }
            var sizeLimit = 3145728; // 3mb 제한
            var maxUploadFileCnt = 300;
            var isErrMaxUploadFileCnt = false;
            vault.events.on("beforeAdd", function (item) {
              if (vault.data.getLength() >= maxUploadFileCnt) {
                  if(!isErrMaxUploadFileCnt) {
                    alert("파일 첨부는 최대 300개 까지만 가능합니다.");
                    isErrMaxUploadFileCnt = true;
                  }
                  return false;
              }
              var extension = item.file.name.split(".").pop();
              var size = item.file.size;
              var predicate = activeCheck.indexOf(extension.toLowerCase()) > -1 && size < sizeLimit;
              if (!predicate) {
                alert(activeCheck + " 파일만 가능합니다.");
                var $obj = $(".dhx-dropable-area.drop-files-here");
                $obj.closest(".layout_y").removeClass('dhx-dragin');
              }
              return predicate;
            });
            vault.events.on("AfterAdd", function(item) {
              vault.toolbar.hide("upload");
              vm.chkFile = true;
            });
            vault.events.on("UploadFile", function (file) {
            });
            vault.events.on("uploadComplete", function (data) {
              if (data != null && data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                  if (data[i].responseVO != null) {
                    var result = {};
                    result.header = data[i].responseVO.header;
                    result.body = data[i].responseVO.body;
                    callback.onFileUploaded(id, result);
                  }
                }
              }
              callback.onFileUploadComplete(id);
              vault.data.removeAll(); // 초기화
            });
            dhx.i18n.setLocale('vault', korean);
            if (callback)
              callback.onLoaded(id, vault);
          }
        }, 100);
      }

      function getKeyVal(type){
        var key = "";
        if(type == "tgt" || isNullOrEmpty(vm.data.RptId)) {
          var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
          key = newnum.toString(36).toUpperCase();
        } else {
          key = vm.data.RptId;
        }
        return key;
      }

      // 보고서 검색
      vm.srchRptModal = function () {
        var ctrl = 'WjmRptModalCtrl as modalCtrl';
        var paramData = {};
        var modalInstance = modalFactory.open('xs', 'components/modal/survey/wjm-report-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.RptNm = okData.RptNm;
          vm.data.RptId = okData.RptId;
          vm.data.Manager = okData.Manager;
          vm.data.ManagerNm = okData.ManagerNm;
          vm.chkRpt = true;

          // RptId를 새로 설정하기 위해 컴포넌트 재생성
          vm.vault = null;
          $("#vault").html("");
          wjmInitVaultComponent('vault', vm.onFileCallback);

        }, function (cancelData) {
        });
      };
      vm.eraseRpt = function () {
        vm.data.RptNm = "";
        vm.data.RptId = "";
        vm.data.Manager = "";
        vm.data.ManagerNm = "";
        vm.chkRpt = false;
      };

      // 업체 검색
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      // 함수 정의
      vm.init = init;
      vm.setTgtData = setTgtData;
      vm.setData = setData;
      vm.uploadFile = uploadFile;
      vm.getKeyVal = getKeyVal;

      init();
    }]);
})();

(function () {
  "use strict";

  webapp.controller('WjmResultDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter' , 'wjmSurvey',

    function WjmResultDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter,wjmSurvey) {

      // SQL Mapper Id 정의
      var VIEW_SQL = 'WjmReport.getResultDetail'; // 조회 SQL
      var VIEW_RESP_SQL = 'WjmReport.getResultRespHistList'; // 응답결과 조회 SQL
      var VIEW_RESP_CNT_SQL = "WjmReport.getResultRespHistCntList"; // 응답건수 조회 SQL
      var VIEWQST_SQL = 'WjmSurvey.getSurveyQstDetail'; // 조회 SQL (문항)
      var VIEWQSTITEM_SQL = 'WjmSurvey.getSurveyQstItemDetail'; // 조회 SQL (보기)

      // 관련 화면 정의
      var RESP_PAGE_URL = 'app.survey.target-result-list';           // 참여자별 결과 목록 화면
      var TREND_PAGE_URL = 'app.survey.trend-analysis';           // 참여추이 화면
      var LIST_TREND_PAGE_URL = 'app.survey.result-list.trend'; // 목록 참여추이 화면
      var LIST_PAGE_URL = 'app.survey.result-list';           // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.surveyresult'; // 작업 테이블명
      var KEY_COLUMN_NM = 'SvyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      $scope.wjmSurvey = wjmSurvey;
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      vm.chtCd = "pie";
      vm.isOk = false;

      // 입력형 답변 목록 보기
      vm.showSbjQstId = '';

      // 설문정보 조회
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        vm.srchDetail.viewColumns = {}; // 사용자정의 컬럼 정보 설정
        var data = vm.srchDetail; // 검색 옵션 설정
        data.mapCode = VIEW_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }
            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;

              vm.svyPages = [];
              for(var i = 1; i <= vm.data.PageCnt; i++){
                vm.svyPages.push({PageNo: i, Label: i});
              }
              vm.svyPages.unshift({PageNo: 'ALL', Label: '전체'});
              vm.svyPagesCur = 1;

              vm.srchDetail.SvyId = vm.data.KeyId;
              getDataQsts();

            } else {
              vm.dataloader = false;
              gAlert('', 'MSG.NO_DATA');
            }
          } else {
            vm.dataloader = false;
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getData()");
          console.table(error);
        });
      }

      // 문항정보 조회
      function getDataQsts() {
        var data = vm.srchDetail;
        data.mapCode = VIEWQST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.svyQsts = result.body.docs;
                angular.forEach(vm.svyQsts , function (qt) {
                  vm.svyQsts[qt.qtId] = qt;

                  // 우선순위형 순위, 척도형 순서
                  if(qt.QstType == 3 || qt.QstType == 5) {
                    var num = (qt.QstType == 3 ? qt.QstTopCnt : qt.ScaleMax);
                    num = (isNullOrEmpty(num) ? 0 : num);
                    var nums = [];
                    for(var i = 1; i <= num; i++) {
                      nums.push(i);
                    }
                    vm.svyQsts[qt.qtId].Nums = nums;
                  }
                });

                getDataQstItems();

              } else {
                vm.dataloader = false;
              }
            } else {
              vm.dataloader = false;
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataQst()");
            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getDataQst()");
          console.table(error);
        });
      }

      // 보기정보 조회
      function getDataQstItems() {
        var data = vm.srchDetail;
        data.mapCode = VIEWQSTITEM_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.svyQstItems = result.body.docs;

                setEndProc();
              }
            }

            getRespList();

          } else {
            vm.dataloader = false;
            console.error("Error> getDataQstItems()");
            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getDataQstItems()");
          console.table(error);
        });
      }

      // 응답결과 조회
      function getRespList() {
        var data = vm.srchDetail;
        data.mapCode = VIEW_RESP_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {

              vm.respList = result.body.docs;

              getRespCntList();

            } else {
              vm.dataloader = false;
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getRespList()");
            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getRespList()");
          console.table(error);
        });
      }

      // 응답건수 조회 (보기가 있는 문항)
      function getRespCntList() {
        var data = vm.srchDetail;
        data.mapCode = VIEW_RESP_CNT_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            vm.respListCnt = [];
            vm.respListSbj = [];
            var respCnt = 0;

            if (result.body.docs.length > 0) {

              vm.respListItm = [];
              vm.respListTop = [];
              var num = "";

              // 선택형, 분류정보형(일반), 우선순위형
              angular.forEach(result.body.docs , function (it) {

                // 우선순위형, 척도형
                if(it.QstType == "3" || it.QstType == "5"){
                  switch(it.QstType){
                    case "3": num = it.PrioNo.toString(); break;
                    case "5": num = it.SbjctResp; break;
                  }
                  var keyVal = it.SvyQstItemId + "_" + num;
                  vm.respListTop[keyVal] = {};
                  vm.respListTop[keyVal].RespRltCnt = it.RespRltCnt;
                  vm.respListTop[keyVal].RespRltRate = it.RespRltRate;

                  vm.respListCnt.push({
                    qtId : it.SvyQstId,
                    itId : it.SvyQstItemId,
                    pNo : num,
                    rCnt : vm.respListTop[keyVal].RespRltCnt
                  });
                }
                // 선택형, 분류정보형
                else {
                  vm.respListItm[it.SvyQstItemId] = {};
                  vm.respListItm[it.SvyQstItemId].RespRltCnt = it.RespRltCnt;
                  vm.respListItm[it.SvyQstItemId].RespRltRate = it.RespRltRate;

                  vm.respListCnt.push({
                    qtId : it.SvyQstId,
                    itId : it.SvyQstItemId,
                    pNo : "0",
                    rCnt : vm.respListItm[it.SvyQstItemId].RespRltCnt
                  });
                }
              });
            }

            var sbjQsts = [];

            // 성별
            sbjQsts = $filter('filter')(vm.svyQsts, {QstType: "C", ClassfyCd: "GD"}, true);
            angular.forEach(sbjQsts , function (qt) {
              respCnt = 0;
              var gender = ["M","F"];
              var keyVal = "";
              angular.forEach(gender , function (gd) {
                respCnt = $filter('filter')(vm.respList, {SvyQstId: qt.qtId, ObjctResp: gd}, true).length;
                keyVal = qt.qtId + "_" + gd;
                vm.respListSbj[keyVal] = {};
                vm.respListSbj[keyVal].RespRltCnt = respCnt;
                vm.respListSbj[keyVal].RespRltRate = Math.round(respCnt / vm.data.RespRCnt * 100);

                vm.respListCnt.push({
                  qtId : qt.qtId,
                  itId : gd,
                  pNo : "0",
                  rCnt : vm.respListSbj[keyVal].RespRltCnt
                });
              });
            });

            // 입력형
            sbjQsts = $filter('filter')(vm.svyQsts, {QstType: "2"}, true);
            var tmpQsts = $filter('filter')(vm.svyQsts, {QstType: "C", ClassfyCd: "NM"}, true);
            if( ! isNullOrEmpty(tmpQsts) && tmpQsts.length > 0) sbjQsts.push(tmpQsts[0]);
            tmpQsts = $filter('filter')(vm.svyQsts, {QstType: "C", ClassfyCd: "MB"}, true);
            if( ! isNullOrEmpty(tmpQsts) && tmpQsts.length > 0) sbjQsts.push(tmpQsts[0]);
            tmpQsts = $filter('filter')(vm.svyQsts, {QstType: "C", ClassfyCd: "EM"}, true);
            if( ! isNullOrEmpty(tmpQsts) && tmpQsts.length > 0) sbjQsts.push(tmpQsts[0]);
            angular.forEach(sbjQsts , function (qt) {
              respCnt = $filter('filter')(vm.respList, {SvyQstId: qt.qtId}, true).length;
                vm.respListSbj[qt.qtId] = {};
                vm.respListSbj[qt.qtId].RespRltCnt = respCnt;
                vm.respListSbj[qt.qtId].RespRltRate = Math.round(respCnt / vm.data.RespRCnt * 100);

                vm.respListCnt.push({
                  qtId : qt.qtId,
                  itId : "",
                  pNo : "0",
                  rCnt : vm.respListSbj[qt.qtId].RespRltCnt
                });
            });

            vm.dataloader = false;
            vm.isOk = true;

          } else {
            vm.dataloader = false;
            console.error("Error> getRespCntList()");
            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getRespCntList()");
          console.table(error);
        });
      }

      // 페이지 이동
      function goPage(type) {
        var srch = $stateParams.srch;
        var page = '';
        switch(type){
          case "T" : page = (vm.layout == 'N' ? TREND_PAGE_URL : LIST_TREND_PAGE_URL); break; // 참여추이
          case "L" : page = LIST_PAGE_URL; break; // 목록
        }
        $state.go(page, {srch:srch, keyId: vm.data.KeyId});
      }

      // 참여자별 결과보기
      vm.goTargetList = function(qType, id, opt){

        var srch = vm.srch;
        srch.goSvyId = vm.data.KeyId; // 되돌아 왔을 때 목록 검색에 영향을 미쳐서 다른 변수명으로 사용
        srch.analTxt = vm.data.SvyNm;
        srch.goBack = "SvyResult";

        // 문항별 결과 대상
        if(!isNullOrEmpty(qType)){
          var SvyTgtIds = [];
          var tgtList = [];

          // 선택형, 분류정보(일반)
          if(qType == "1" || qType =="4" || (qType == "C")) tgtList = $filter('filter')(vm.respList, {SvyQstItemId: id}, true);
          // 입력형, 분류정보(이름, 휴대폰,이메일)
          else if(qType == "2" || qType == "NM" || qType == "MB" || qType == "EM") tgtList = $filter('filter')(vm.respList, {SvyQstId: id}, true);
          // 분류정보(성별)
          else if(qType == "GD") tgtList = $filter('filter')(vm.respList, {SvyQstId: id, ObjctResp: opt}, true);
          // 우선순위형
          else if(qType == "3" || qType == "5") tgtList = $filter('filter')(vm.respList, {SvyQstItemId: id, PrioNo: opt}, true);

          angular.forEach(tgtList, function(tgt) {
            SvyTgtIds.push(tgt.SvyTgtId);
          });

          srch.SvyTgtIds = SvyTgtIds;
        }

        $state.go(RESP_PAGE_URL, {
          srch: encodeURIComponent(JSON.stringify(srch, replacer))
        });
      };


      // 입력형 답변 목록 보기
      vm.showSbjList = function(id){
        vm.showSbjQstId = (vm.showSbjQstId == id ? '' : id);
      };

      // 이미지 조회
      function setEndProc() {
        wjmSurvey.getImageList(vm.imageList, vm.svyQsts, vm.svyQstItems);
      }

      // 엑셀 다운로드
      function getExcel() {
        vm.dataloader = true;

        var sList = [];
        var data = {};
        data.mapCode = "analysis";

        data.fileType = "S";
        data.tmpFileNm = "Result_org.xlsx"; // 템플릿 파일명
        data.fileDir = "wjm-report";
        data.fileNm = "설문결과_" + vm.data.SvyNm // 저장될 파일명
          .replaceAll("*","").replaceAll("?","").replaceAll("\\","")
          .replaceAll("/","-").replaceAll(":","-").replaceAll("|","-")
          .replaceAll("\"","'")
          .replaceAll("<","(").replaceAll(">",")")
          .replaceAll("[","(").replaceAll("]",")") + ".xlsx";

        data.qtList = vm.svyQsts;
        data.itList = vm.svyQstItems;
        data.rpList = vm.respListCnt;
        data.sbjList = $filter('filter')(vm.respList, {QstType: "2"}, true);


        console.error("vm.respList",vm.respList);
        console.error("sbjList",data.sbjList);

        data.respCnt = vm.data.RespRCnt;
        data.chtCd = vm.chtCd;
        data.svyId = vm.data.KeyId;
        data.svyNm = vm.data.SvyNm;
        data.svyDt = vm.data.SvyDate;
        data.svySt = vm.data.SvyStatus;
        data.svyRpR = vm.data.RespRltCnt + "(" + vm.data.RespRltRate + ")";
        data.svyRpP = vm.data.RespRltPCnt;

        postApi.wjmReport(data, function(result){
            vm.dataloader = false;

        }, function (error) {
          // 조회 중 오류 발생
          vm.dataloader = false;
          console.error("Error> getExcel");
          console.table(error);
        });
      }

      // 엑셀 다운로드
      function getExcel_bak() {

        var a = document.createElement("a");
        document.body.appendChild(a);

        $scope.jsonToExport = vm.assoRespList;
        $scope.fileName = "설문결과";
        $scope.exportData = [];

        var obj = [];

        obj = [];
        obj.push("설문제목 : " + vm.data.SvyNm);
        $scope.exportData.push(obj);

        obj = [];
        obj.push("설문기간 : " + vm.data.SvyDate );
        $scope.exportData.push(obj);

        obj = [];
        obj.push("상태 : " + vm.data.SvyStatus);
        $scope.exportData.push(obj);

        obj = [];
        obj.push("응답/전체(응답률) : " + vm.data.RespRltCnt + "(" + vm.data.RespRltRate + ")");
        $scope.exportData.push(obj);

        obj = [];
        obj.push("부분응답 : " + vm.data.RespRltPCnt);
        $scope.exportData.push(obj);

        obj = [];
        obj.push("");
        $scope.exportData.push(obj);


        // 문항
        angular.forEach(vm.svyQsts, function (qt) {
          obj = [];
          obj.push(qt.QstNo + "." + qt.QstSubject);
          $scope.exportData.push(obj);

          var itList = $filter('filter')(vm.svyQstItems, {qtId: qt.qtId}, true);

          // 보기
          switch(qt.QstType){

            // 선택형
            case "1" :
              angular.forEach(itList, function (it) {
                obj = [];
                obj.push("(" + it.QstItemNo + ")" + it.QstItemContents);
                obj.push(isNullOrEmpty(vm.respListItm[it.itId]) ? "0명" : vm.respListItm[it.itId].RespRltCnt + "명");
                obj.push(isNullOrEmpty(vm.respListItm[it.itId]) ? "0%" : vm.respListItm[it.itId].RespRltRate + "%");
                $scope.exportData.push(obj);
              });
              break;

            // 입력형
            case "2" :
              obj = [];
              obj.push("주관식 문항");
              obj.push(vm.respListSbj[qt.qtId].RespRltCnt + "명");
              obj.push(vm.respListSbj[qt.qtId].RespRltRate + "%");
              $scope.exportData.push(obj);
              break;

            // 우선순위형
            case "3" :
              angular.forEach(itList, function (it) {
                obj = [];
                obj.push("(" + it.QstItemNo + ")" + it.QstItemContents);
                $scope.exportData.push(obj);

                angular.forEach(qt.Nums, function (num) {
                  obj = [];
                  obj.push(num);
                  obj.push(isNullOrEmpty(vm.respListTop[it.itId + "_" + num]) ? "0명" : vm.respListTop[it.itId + "_" + num].RespRltCnt + "명");
                  obj.push(isNullOrEmpty(vm.respListTop[it.itId + "_" + num]) ? "0%" : vm.respListTop[it.itId + "_" + num].RespRltRate + "%");
                  $scope.exportData.push(obj);
                });
              });
              break;

            // 이미지형
            case "4" :
              angular.forEach(itList, function (it) {
                obj = [];
                obj.push("(" + it.QstItemNo + ")" + it.QstItemContents);
                obj.push(isNullOrEmpty(vm.respListItm[it.itId]) ? "0명" : vm.respListItm[it.itId].RespRltCnt + "명");
                obj.push(isNullOrEmpty(vm.respListItm[it.itId]) ? "0%" : vm.respListItm[it.itId].RespRltRate + "%");
                $scope.exportData.push(obj);
              });
              break;


            // 척도형
            case "5" :
              angular.forEach(itList, function (it) {
                obj = [];
                obj.push("(" + it.QstItemNo + ")" + it.QstItemContents +"~"+ it.QstItemContents2);
                $scope.exportData.push(obj);

                angular.forEach(qt.Nums, function (num) {
                  obj = [];
                  obj.push(num);
                  obj.push(isNullOrEmpty(vm.respListTop[it.itId + "_" + num]) ? "0명" : vm.respListTop[it.itId + "_" + num].RespRltCnt + "명");
                  obj.push(isNullOrEmpty(vm.respListTop[it.itId + "_" + num]) ? "0%" : vm.respListTop[it.itId + "_" + num].RespRltRate + "%");
                  $scope.exportData.push(obj);
                });
              });
              break;

            // 분류정보
            case "C" :
              if(qt.ClassfyCd == "NM" || qt.ClassfyCd == "MB" || qt.ClassfyCd == "EM"){
                obj = [];
                obj.push("주관식 문항");
                obj.push(vm.respListSbj[qt.qtId].RespRltCnt + "명");
                obj.push(vm.respListSbj[qt.qtId].RespRltRate + "%");
                $scope.exportData.push(obj);
              }
              else if(qt.ClassfyCd == "GD"){
                obj = [];
                obj.push("남");
                obj.push(vm.respListSbj[qt.qtId + "_M"].RespRltCnt + "명");
                obj.push(vm.respListSbj[qt.qtId + "_M"].RespRltRate + "%");
                $scope.exportData.push(obj);
                obj = [];
                obj.push("여");
                obj.push(vm.respListSbj[qt.qtId + "_F"].RespRltCnt + "명");
                obj.push(vm.respListSbj[qt.qtId + "_F"].RespRltRate + "%");
                $scope.exportData.push(obj);
              }
              else {
                angular.forEach(itList, function (it) {
                  obj = [];
                  obj.push("(" + it.QstItemNo + ")" + it.QstItemContents);
                  obj.push(isNullOrEmpty(vm.respListItm[it.itId]) ? "0명" : vm.respListItm[it.itId].RespRltCnt + "명");
                  obj.push(isNullOrEmpty(vm.respListItm[it.itId]) ? "0%" : vm.respListItm[it.itId].RespRltRate + "%");
                  $scope.exportData.push(obj);
                });
              }
              break;

            // 설명글
            case "R" :
              obj = [];
              obj.push(qt.QstSubject);
              break;
          }
        });

        $rootScope.excelDown($scope.exportData, $scope.fileName);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goPage = goPage;                       // 화면 이동
      vm.getExcel = getExcel; // 엑셀 다운로드

      // 데이터 조회
      getData();

    }]);
})();


(function () {
  "use strict";

  webapp.controller('WjmResultListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter', 'wjmReport',

    function WjmResultListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, wjmReport) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmReport.getResultListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmReport.getResultList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmReport.getResultExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmSurvey.deleteSurveyList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.result-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.result-list.detail';         // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.survey.result-detail';         // 조회 화면
      var EDIT_PAGE_URL = 'app.survey.result-edit.tab1';         // 등록/수정 화면
      var ANAL_PAGE_URL = 'app.survey.analysis';         // 데이터분석 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.surveyresult'; // 작업 테이블명
      var EXCEL_TITLE = '설문 결과 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      (function WjmResultListCtrl() {
        $scope.wjmReport = wjmReport;
      })();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.SvyBeginDate = $rootScope.getDateFormat(vm.srch.SvyBeginDate);
        vm.SvyEndDate = $rootScope.getDateFormat(vm.srch.SvyEndDate);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 설문작성 화면
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: ''
        });
      }

      // 데이터분석 화면
      function goAnalysis() {

        var chk = getChkList("ANAL");
        if ( ! chk) return false;

        var srch = {
          "SvyIds": vm.srchChk.KeyIdList,
          "SvyNms": vm.srchChk.SvyNms,
          "FormId": vm.srchChk.FormId,
          "SvyTypeId": vm.srchChk.SvyTypeId,
          "SecLevelCnt": vm.srchChk.SecLevelCnt,
          "ClassfyInfoId": vm.srchChk.ClassfyInfoId,
          "TgtCnt": vm.srchChk.TgtCnt,
          "ScoringType": vm.srchChk.ScoringType,
          "sortDirect": vm.srch.sortDirect,    // 되돌아 왔을 때 사용
          "sortColumn": vm.srch.sortColumn
        };

        $state.go(ANAL_PAGE_URL, {
          srch: encodeURIComponent(JSON.stringify(srch, replacer)),
          srch2: ""
        });
      }

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 체크한 대상 (삭제, 엑셀, RawData)
      function getChkList(type){
        if (vm.lists.length == undefined || vm.lists.length == 0) {
          gAlert("", "데이터가 없습니다.");
          return false;
        }

        vm.srchChk = {};
        vm.srchChk.FormId = '';
        vm.srchChk.SvyId = '';
        vm.srchChk.SvyTypeId = '';
        vm.srchChk.ClassfyInfoId = '';
        vm.srchChk.KeyIdList = [];
        vm.srchChk.SvyNms = '';
        vm.srchChk.TgtCnt = 0;
        vm.srchChk.SecLevelCnt = 0;
        vm.srchChk.ScoringType = '';

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {

            if (type == "RAW" || type == 'ANAL'){
              if(vm.srchChk.SvyId == '') {
                vm.srchChk.FormId = vm.lists[i].FormId;
                vm.srchChk.SvyId = vm.lists[i].KeyId;
                vm.srchChk.SvyTypeId = vm.lists[i].SvyTypeId;
                vm.srchChk.ClassfyInfoId = vm.lists[i].ClassfyInfoId;
                vm.srchChk.SecLevelCnt = vm.lists[i].SecLevelCnt;
                vm.srchChk.ScoringType = vm.lists[i].ScoringType;
              }
              if(vm.srchChk.KeyIdList.length >= 1 && isNullOrEmpty(vm.srchChk.FormId)){
                gAlert("", "서식을 사용하지 않은 설문의 경우 다른 설문과 함께 선택할 수 없습니다.");
                return false;
              }
              if(vm.srchChk.FormId != vm.lists[i].FormId || vm.srchChk.ClassfyInfoId != vm.lists[i].ClassfyInfoId){
                gAlert("", "동일한 서식 및 분류정보를 사용하는 설문 내에서 체크해 주세요.");
                return false;
              }
              if(vm.lists[i].RespCnt == 0){
                gAlert("", "응답이 존재하는 설문만 체크해 주세요.");
                return false;
              }
              //console.error("cnt",vm.lists[i].RespCnt);
            }

            vm.srchChk.KeyIdList.push(vm.lists[i].KeyId);
            vm.srchChk.SvyNms = vm.srchChk.SvyNms +(vm.srchChk.SvyNms == ''? '' : ', ')+ vm.lists[i].SvyNm;

            if(type == 'ANAL') {
              vm.srchChk.TgtCnt = vm.srchChk.TgtCnt + vm.lists[i].TgtCnt;
            }
          }
        }
        if (type != "XLS" && (vm.srchChk.KeyIdList == null || vm.srchChk.KeyIdList.length == 0)) {
          gAlert('', '항목을 선택해 주세요.');
          return false;
        }
        return true;
      }

      // 목록 엑셀 다운로드
      function getExcelFile() {

        // 체크 대상이 있을 경우 해당 목록만 다운로드 하게 해달라는 요청
        // 체크 대상이 없을 경우 전체 목록 다운로드
        var chk = getChkList("XLS");
        if ( ! chk) return false;

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        vm.srch.KeyIdList = vm.srchChk.KeyIdList;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if (item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'SvyBeginDate' || item.ColumnPhysicalNm == 'SvyEndDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }



      // 목록 RawData 다운로드
      function getRawData() {

        var chk = getChkList("RAW");
        if ( ! chk) return false;

        vm.srchChk.keyCol = "SvyId";

        vm.dataloader = true;
        wjmReport.getRawData(vm.srchChk, $scope, $rootScope)
          .then(function() { vm.dataloader = false; })
          .catch(function(error) { vm.dataloader = false; });
      }


      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 목록 삭제 확인
      function setDelList() {
        gConfirm('', '해당 설문을 삭제할 경우, 진단 데이터도 모두 삭제됩니다. 삭제하시겠습니까?', {
          btn: '',
          fn: function () {
            setDelListAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 목록 삭제
      function setDelListAction() {

        var chk = getChkList("DEL");
        if ( ! chk) return false;

        var data = vm.srch;
        vm.srch.KeyIdList = vm.srchChk.KeyIdList;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 업체 검색
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.Manager = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.Manager = "";
      };





      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goView = goView;                         // 조회 화면 이동
      vm.goAnalysis = goAnalysis;

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드
      vm.getRawData = getRawData;             // RawData Excel 파일 다운로드

      // 목록 조회
      getList();


      setInitData();

    }]);
})();


(function () {
  "use strict";

  webapp.controller('ResvSendListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function ResvSendListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSend.getResvSendListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSend.getResvSendList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.resv-send-list';         // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.resvsend'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
        vm.ResvDateFrom = $rootScope.getDateFormat(vm.srch.ResvDateFrom);
        vm.ResvDateTo = $rootScope.getDateFormat(vm.srch.ResvDateTo);
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = "N"; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD HH:mm:ss";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
       function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      /**
       * 예약발송 취소
       * @param
       * @return
       */
      vm.cancel = function () {
        gConfirm('', '취소하시겠습니까?', {
          btn: '',
          fn: function () {
            cancelResvSend();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      function cancelResvSend(){
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', '취소할 항목을 선택해 주세요.');
          return false;
        }

        var data = vm.srch;
        data.mapCode = "WjmSend.cancelResvSendList";

        postApi.update(data, function (result) {
          gAlert('', '취소되었습니다.', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          //}
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> cancel()");
          console.table(error);
        });
      };


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

/**
 * @description SMS 금액통계 controller
 * */
webapp.controller('SMSStatisticCtrl', ['postApi', 'GLOBAL_CONSTANT', '$stateParams', '$state', '$filter',
  function SMSStatisticCtrl(postApi, CONSTANT, $stateParams, $state, $filter){

    // SQL Mapper Id 정의
    var LIST_SQL = 'WjmSend.getSMSResultList'; // 조회 SQL
    var TOTAL_SQL = 'WjmSend.getSMSResultTotal'; // 조회 SQL
    var LIST_CNT_SQL = 'WjmSend.getSMSResultListCnt'; // 조회CNT SQL

    // 관련 화면 정의
    var LIST_PAGE_URL = 'app.survey.sms-statistic';             // 목록 화면

    // 관련 테이블 정의
    var KEY_TABLE_NM = 'smsstatistic'; // 조회용 테이블명
    var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

    var vm = this;
    vm.dataloader = false;

    vm.data = {};

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      var today = new Date();
      vm.RegDateTo = today;
      vm.RegDateFrom = angular.copy(today).setDate(1);
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: 'RegDate',          // 정렬컬럼명
        selectType : 'List',
        RegDateTo : $filter('date')(vm.RegDateTo, 'yyyy-MM-dd'),
        RegDateFrom : $filter('date')(vm.RegDateFrom, 'yyyy-MM-dd')
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
      if(vm.srch.RegDateFrom){
        vm.RegDateFrom = new Date(vm.srch.RegDateFrom);
      }
      if(vm.srch.RegDateTo){
        vm.RegDateTo = new Date(vm.srch.RegDateTo);
      }
      vm.currentPage = vm.srch.page;
    }

    vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

    vm.sendFee = {SMS : 10, MMS : 28, MMS_IMG : 80};

    function getSearch() {
      // 검색 옵션
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

      // 데이터 조회
      $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
    }

    /**
     * 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
    }

    /**
     * 목록 당 조회 건수 변경
     * @param
     * @return
     */
    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      getSearch();
    }

    function getList(){

      getListCnt();
      vm.total = {
        sms : {cnt:0, pri:0},
        mms : {cnt:0, pri:0},
        img : {cnt:0, pri:0},

        // send : 0,
        // succ : 0,
        // fail : 0,
        // amt : 0
      };
      var data = vm.srch;

      data.mapCode = LIST_SQL;
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK){
          // MetaColumn 사용
          if (result.body.desc.length > 0) {
            vm.columnMap = {};
            // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
            vm.listColumns = result.body.desc;
            angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          } else {
            console.error('Error> getList()> MetaColumn 정보 조회 오류');
            console.table(data);
          }

          if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
            // 목록 데이터 표시
            vm.lists = result.body.docs;
            // angular.forEach(vm.lists, function(item){
            //   vm.total.send += item.SendCnt;
            //   vm.total.succ += item.SendSucc;
            //   vm.total.amt += item.SendSucc * vm.sendFee[item.CmpgnChannel];
            // });
            // vm.total.fail = vm.total.send - vm.total.succ;
            // 목록 화면 구성
          } else {
            // 데이터 조회 실패
            vm.lists = [];
          }
        }
      });

      data.mapCode = TOTAL_SQL;
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK){
          if (result.body.docs.length > 0) {
            // 목록 데이터 표시
            vm.totals = result.body.docs;
            angular.forEach(vm.totals, function(item){
              var pri = item.totalSucc * vm.sendFee[item.CmpgnChannel];
              switch(item.CmpgnChannel){
                case 'SMS' : vm.total.sms.cnt += item.totalSucc; vm.total.sms.pri += pri; break;
                case 'MMS' : vm.total.mms.cnt += item.totalSucc; vm.total.mms.pri += pri; break;
                case 'MMS_IMG' : vm.total.img.cnt += item.totalSucc; vm.total.img.pri += pri; break;
              }
            });
            vm.total.pri = vm.total.sms.pri + vm.total.mms.pri + vm.total.img.pri;
          }else{
            vm.totals = [];
          }
        }
      });
    }

    /**
     * 목록 건수 조회
     *
     * @param
     * @return
     */
    function getListCnt() {

      var data = angular.copy(vm.srch); // 검색 옵션 설정

      data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          if (result.body.docs.length > 0) {
            // 총 목록 건수 설정
            vm.totalItems = result.body.docs;
          } else {
            // 조회 실패
            vm.totalItems = 0;
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getListCnt()");
        console.table(error);
      });
    }

    vm.setPageChanged = setPageChanged;
    vm.setChangeViewSize = setChangeViewSize;
    vm.getSearch = getSearch;

    getList();
  }
]);

webapp.controller('WjmSurveyViewCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
  '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', '$filter', 'wjmSurvey', 'StaticVariable',
  function WjmSurveyViewCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, api, modalFactory, $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate, $filter, wjmSurvey, StaticVariable) {


    // SQL Mapper Id 정의
    var VIEW_SQL = 'WjmSurvey.getSurveyDetail'; // 조회 SQL
    var UPDATE_SQL = 'WjmSurvey.updateSurvey'; // 수정 SQL
    var DEL_SQL = 'WjmSurvey.deleteSurveyDetail';  // 삭제 SQL

    var VIEWQST_SQL = 'WjmSurvey.getSurveyQstDetail'; // 조회 SQL (문항)
    var VIEWQSTITEM_SQL = 'WjmSurvey.getSurveyQstItemDetail'; // 조회 SQL (보기)
    var UPDATE_STATUS_SQL = 'WjmSurvey.updateSurveyStatus'; // 설문시작/완료하기 SQL

    // 관련 화면 정의
    var LIST_PAGE_URL = 'app.survey.survey-list';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.survey.survey-list.detail'; // 목록 조회 화면
    var VIEW_PAGE_URL = 'app.survey.survey-detail';           // 조회 화면
    var EDIT_PAGE_URL = 'app.survey.survey-edit';           // 수정 화면
    var FORM_EDIT_PAGE_URL = 'app.survey.form-edit';           // 수정 화면 (서식)

    // 관련 테이블 정의
    var KEY_TABLE_NM = 'wjm.survey'; // 조회용 테이블명
    var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};
    vm.data = {};

    // 설문관련 변수
    vm.svyQsts = [];
    vm.svyQstItems = [];

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
        keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
        tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
        srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.keyId = $stateParams.keyId;
    }

    vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

    // Key Data 설정
    if (!isNullOrEmpty($stateParams.keyId)) {
      vm.srch.keyId = $stateParams.keyId;
    }

    // 조회 데이터 설정
    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
    vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

    // 등록/수정 표시용 컬럼 목록
    vm.srchDetail.editColumns = {};

    // 조회 데이터
    vm.data = {
      KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
      tableNm: KEY_TABLE_NM
    };

    /**
     * URL게시 팝업 호출
     *
     * @param {string}
     * @return {boolean}
     */
    vm.goUrlPost = function () {
      var ctrl = 'WjmUrlPostModalCtrl as vc';
      var paramData = {
        keyId: vm.data.KeyId
      };

      var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-urlpost-modal.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        // 성공
      }, function (cancelData) {
        // 취소
      });
    };

    /**
     * SMS, EMAIL 발송페이지로 이동
     *
     * @param {string}
     * @return {boolean}
     */
    vm.goSend = function (type) {
      var url = "app.survey.email-send";
      var srch = {
        //page: 1,
        //viewSize: 25,
        //keyId: '',
        //tableNm: '',
        svyId: vm.data.keyId,
        svyNm: vm.data.SvyNm,
        svyDate: vm.data.SvyDate,
        clientId: vm.data.Manager,
        clientNm: vm.data.ManagerNm
      };

      $rootScope.gVariable.layoutBoard = "N"; // 타메뉴 조회로 바로 접근하기때문에 분할상태인경우 UI가 정상적이지 않아 기본으로 강제변경

      if (type == "SMS") {
        srch.formType = "SMS";
        url = "app.survey.sms-send";
      }
      $state.go(url, {srch: encodeURIComponent(JSON.stringify(srch, replacer))});
    };

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true; // Progressbar 표시

      if (isNullOrEmpty(vm.srch.keyId)) {
        vm.dataloader = false;  // Progressbar 숨김
      }
      vm.srchDetail.viewColumns = {}; // 조회 컬럼

      var data = vm.srchDetail;
      data.mapCode = VIEW_SQL;

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          vm.dataloader = false; // Progressbar 숨김

          if (result.body.desc.length > 0) {
            // 사용자정의 컬럼 설정
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            vm.data = result.body.docs[0];
            vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

            vm.svyPages = [];
            for(var i = 1; i <= vm.data.PageCnt; i++){
              vm.svyPages.push({PageNo: i, Label: i});
            }
            vm.svyPages.unshift({PageNo: 'ALL', Label: '전체'});
            vm.svyPagesCur = 1;//'ALL';

            //Date형식 처리
            if (!isNullOrEmpty(vm.data.SvyBeginDate)) vm.SvyBeginDate = moment(vm.data.SvyBeginDate).toDate();
            if (!isNullOrEmpty(vm.data.SvyEndDate)) vm.SvyEndDate = moment(vm.data.SvyEndDate).toDate();

            getDataQsts();
          } else {
            //console.log('nodata');
            //vm.data.TenantId = $rootScope.gVariable.srchTenantId;
            //vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
          }
        } else {
          vm.dataloader = false; // Progressbar 숨김

          console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }

      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    }

    /**
     * 데이터 조회 (문항)
     * @param
     * @return
     */
    function getDataQsts() {
      //vm.dataloader = true; // Progressbar 표시

      // 첨부파일 컴포넌트 초기화
      /*
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);
      initVaultComponent('vault2', vm.onFileCallback);
      */

      /*
      if (isNullOrEmpty(vm.srch.keyId)) {
        vm.dataloader = false;  // Progressbar 숨김
      }
      */

      var data = vm.srchDetail;
      data.mapCode = VIEWQST_SQL;
      data.SvyId = vm.data.keyId;

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          //vm.dataloader = false; // Progressbar 숨김

          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            if (isNullOrEmpty(result.body.docs[0]["no data"])) {
              vm.svyQsts = result.body.docs;
              // 첨부파일 목록 설정
              /*
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
              */

              //wjmSurvey.sortSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);

              getDataQstItems();
            }
          } else {
            //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
            //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
          }
        } else {
          //vm.dataloader = false; // Progressbar 숨김
          console.error("Error> getDataQst()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }

      }, function (error) {
        console.error("Error> getDataQst()");
        console.table(error);
      });
    }

    /**
     * 데이터 조회 (보기)
     * @param
     * @return
     */
    function getDataQstItems() {
      //vm.dataloader = true; // Progressbar 표시

      // 첨부파일 컴포넌트 초기화
      /*
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);
      initVaultComponent('vault2', vm.onFileCallback);
      */

      /*
      if (isNullOrEmpty(vm.srch.keyId)) {
        vm.dataloader = false;  // Progressbar 숨김
      }
      */

      var data = vm.srchDetail;
      data.mapCode = VIEWQSTITEM_SQL;
      data.SvyId = vm.data.keyId;

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          //vm.dataloader = false; // Progressbar 숨김

          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            if (isNullOrEmpty(result.body.docs[0]["no data"])) {
              vm.svyQstItems = result.body.docs;
              //console.log("vm.svyQstItems", result.body.docs);

              // 첨부파일 목록 설정
              /*
              vm.uploadFileList = [];
              vm.uploadFileList2 = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId : item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                };
                if (item.GrpId == 2) {
                  vm.uploadFileList2.push(obj);
                } else {
                  vm.uploadFileList.push(obj);
                }
              });
              */

              //wjmSurvey.sortSvyNo("IT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
            }
          } else {
            //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
            //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
          }

          setEndProc();
        } else {
          //vm.dataloader = false; // Progressbar 숨김
          console.error("Error> getDataQstItems()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }

      }, function (error) {
        console.error("Error> getDataQstItems()");
        console.table(error);
      });
    }

    /**
     * 데이터 저장
     *
     * @param
     * @return
     */
    function setData() {
      if (!getIsValidData()) return;

      // 내용
      vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
      vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

      /*
      vm.data.uploadFileList = [];
      angular.forEach(vm.uploadFileList, function(item) {
        vm.data.uploadFileList.push(item);
      });
      angular.forEach(vm.uploadFileList2, function(item) {
        vm.data.uploadFileList.push(item);
      });
      */

      vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

      // Date형식 처리
      //vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');
      vm.data.SvyBeginDate = moment(vm.data.SvyBeginDate).format('YYYY-MM-DD');
      vm.data.SvyEndDate = moment(vm.data.SvyEndDate).format('YYYY-MM-DD');

      // 에디터 내용 삽입
      /*
      oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
      vm.data.TopCont = $("#strHtml").val();
      oEditors.getById["strHtml2"].exec("UPDATE_CONTENTS_FIELD", []);
      vm.data.BtmCont = $("#strHtml2").val();
      */

      // 기타
      /*
      vm.data.PageCnt = vm.svyPages.length;
      if (!isNullOrEmpty(vm.data.RespLimitCnt)) vm.data.RespLimitYN = "Y";
      */

      var data = vm.data; // 사용자 입력 데이터

      if (isNullOrEmpty(vm.data.keyId)) {
        /*
        // 신규 등록
        data.mapCode = INSERT_SQL;

        postApi.insert(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
        */
      } else {
        // 수정
        data.RelateDataId = data.keyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }
    }

    /**
     * 데이터 저장 후 처리
     *
     * @param result - 저장 결과
     * @return
     */
    function setInsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        //console.log("result.body.docs[0]", result.body.docs[0]);
        if (
          /*
          result.body.docs[0].KeyId !== null ||
          result.body.docs[0].NewKeyId !== null
          */
          !isNullOrEmpty(result.body.docs[0].RelateDataId)
        ) {
          // KeyId 조회
          //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
          //vm.data.KeyId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function () {
              // 화면 분할 모드에 따른 이동
              goNextPage(true);
            }
          });
          return;
        }
      }

      console.error("Error> setInsertUpdateDetail()");
      gAlert('', result.body.docs[0].errMessage);
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch; // 검색 옵션

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.keyId)) {
          // 신규등록 -> 목록 화면 이동
          //$state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: vm.data.KeyId
            //tabId: vm.tabId
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.keyId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, tabId: vm.tabId});
        $state.go(LIST_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
      }
    }

    /**
     * 데이터 삭제 확인
     *
     * @param
     * @return
     */
    function setDelData() {
      //gConfirm('', 'Menu.DELETECONFIRM', {
      gConfirm('', '해당 설문을 삭제할 경우, 진단 데이터도 모두 삭제됩니다. 삭제하시겠습니까?', {
        btn: '',
        fn: function () {
          // 데이터 삭제
          setDelDataAction();
        }
      }, {
        btn: '',
        fn: function () {
          // 취소
        }
      });
    }

    /**
     * 데이터 삭제
     *
     * @param
     * @return
     */
    function setDelDataAction() {
      if (vm.data == null) {
        // 삭제할 데이터 미 존재
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      // 첨부파일 삭제
      /*
      var uploadFileList = [];
      angular.forEach(vm.uploadFileList, function (item) {
        var obj = {
          id: item.id,
          fileName: item.fileName,
          size: item.size,
          fileKey: item.fileKey,
          typeId: 'file',
          path: item.path,
          delState: 'delete'
        };
        uploadFileList.push(obj);

      });
      vm.data['uploadFileList'] = uploadFileList;
      */

      vm.data.tableNm = KEY_TABLE_NM;

      var data = vm.data;
      data.mapCode = DEL_SQL;

      postApi.update(data, function (result) {
        //if (result.header.status == CONSTANT.HttpStatus.OK) {
        gAlert('', 'Menu.DELETED', {
          btn: '',
          fn: function () {
            // 삭제 성공
            var srch = $stateParams.srch;

            // 목록 화면 이동
            $state.go(LIST_PAGE_URL, {
                srch: srch
              },
              {reload: LIST_PAGE_URL});
          }
        });
        //}
        /*
      }, function (error) {
        // 삭제 중 오류 발생
        console.error("Error> delDataAction()");
        console.table(error);
        */
      });
    }

    /**
     * 필수항목 체크
     * @param
     * @return
     */
    function getIsValidData() {
      var errMsg = '';
      if (isNullOrEmpty(vm.data.SvyNm)) {
        errMsg = errMsg + '- 설문명을 입력해주세요.<br/>';
      }
      /*
      if (isNullOrEmpty(vm.data.TargetCnt) || vm.data.TargetCnt == "0") {
        errMsg = errMsg + '- 대상인원을 입력해주세요.<br/>';
      }
      if (isNullOrEmpty(vm.data.Gubun)) {
        errMsg = errMsg + '- 구분을 선택해주세요.<br/>';
      }
      */
      if (isNullOrEmpty(vm.data.SvyBeginDate)) {
        errMsg = errMsg + '- 설문시작일을 선택해주세요.<br/>';
      }
      if (isNullOrEmpty(vm.data.SvyEndDate)) {
        errMsg = errMsg + '- 설문종료일을 선택해주세요.<br/>';
      }
      /*
      if (vm.data.RespLimitYN == "Y") {
        if (isNullOrEmpty(vm.data.RespLimitCnt) || vm.data.RespLimitCnt == "0") {
          errMsg = errMsg + '- 응답인원을 제한한 경우 제한수를 입력해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.RespLimitEndMsg)) {
          errMsg = errMsg + '- 응답인원을 제한한 경우 건수마감메시지를 입력해주세요.<br/>';
        }
      }
      */
      /*
      if (isNullOrEmpty(vm.data.SvyEndMsg)) {
        errMsg = errMsg + '- 기간만료메세지를 입력해주세요.<br/>';
      }
      */
      /*
      if (isNullOrEmpty(vm.data.BoxColor)) {
        errMsg = errMsg + '- 테두리색상을 입력해주세요.<br/>';
      }
      if (isNullOrEmpty(vm.data.LineColor)) {
        errMsg = errMsg + '- 구분선색상을 선택해주세요.<br/>';
      }
      */

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      return true;
    }

    /**
     * 설문시작하기
     *
     * @param
     * @return
     */
    function setBegin(stat) {
      gConfirm('', '입력한 시작일, 종료일이 반영됩니다. 설문 상태를 변경하시겠습니까?', {
        btn: '',
        fn: function () {
          // 내용
          vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
          vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
          vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키
          vm.data.SvyStatus = stat;

          vm.data.SvyBeginDate = moment(vm.data.SvyBeginDate).format('YYYY-MM-DD');
          vm.data.SvyEndDate = moment(vm.data.SvyEndDate).format('YYYY-MM-DD');


          // Date형식 처리
          //vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');

          // 에디터 내용 삽입
          /*
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
          vm.data.TopCont = $("#strHtml").val();
          */

          var data = vm.data; // 사용자 입력 데이터
          data.mapCode = UPDATE_STATUS_SQL;

          postApi.update(data, function (result) {
            gAlert("", "설문 상태가 변경되었습니다", {
              btn: "",
              fn: function () {
                getData();
              }
            });
          }, function (error) {
            console.error("Error> setBegin()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }, {
        btn: '',
        fn: function () {
          // 취소
        }
      });
    }

    /**
     * 목록 화면 이동
     *
     * @param
     * @return
     */
    function goList() {
      vm.srch.keyId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, {srch: srch});
    }

    // 수정 화면
    function goEdit() {
      var srch = $stateParams.srch;

      $state.go(EDIT_PAGE_URL, {
        srch: srch,
        keyId: vm.data.KeyId,
        cKeyId: ''
      }, {reload:EDIT_PAGE_URL});
    }

    // 복사 후 편집 화면으로 이동
    function goCopyEdit() {
      var srch = $stateParams.srch;

      $state.go(EDIT_PAGE_URL, {
        srch: srch,
        keyId: '',
        cKeyId: vm.data.KeyId
      }, {reload:EDIT_PAGE_URL});
    }

    // 서식으로등록 화면으로 이동
    function goCopyFormEdit() {
      var srch = $stateParams.srch;

      $state.go(FORM_EDIT_PAGE_URL, {
        srch: srch,
        keyId: '',
        cKeyId: vm.data.KeyId
      }, {reload:FORM_EDIT_PAGE_URL});
    }

    /**
     * 마지막 실행 프로세스
     *
     * @param
     * @return
     */
    function setEndProc() {
      wjmSurvey.getImageList(vm.imageList, vm.svyQsts, vm.svyQstItems);
    }

    /**
     * 설문지 엑셀 다운로드
     *
     * @param
     * @return
     */
    function getExcelFile() {
      var i = 0;
      var a = document.createElement("a");
      var sheetNames = [];
      var qt = [];
      var it = [];
      var exportData = [];
      var fileName = "설문지_" + vm.data.SvyNm // 파일명, 시트명에 사용할 수 없는 특수문자 치환.
                                  .replaceAll("*","").replaceAll("?","").replaceAll("\\","")
                                  .replaceAll("/","-").replaceAll(":","-").replaceAll("|","-")
                                  .replaceAll("\"","'")
                                  .replaceAll("<","(").replaceAll(">",")")
                                  .replaceAll("[","(").replaceAll("]",")");

      document.body.appendChild(a);

      /*
      if (!isNullOrEmpty(vm.data.PageCnt)) {
        for (i = 0; i < parseInt(vm.data.PageCnt); i++) {
          sheetNames.push((i + 1) + "페이지");
          exportData[i] = [];

          qt = $filter('filter')(vm.svyQsts, {PageNo: i + 1}, true);
          qt.forEach(function(qst) {
            addExcelRow(exportData[i],
              wjmSurvey.getQstTypeNm(qst.QstType)
              + " " + (qst.QstType == "R" ? "" : qst.QstNo + ". ")
              + qst.QstSubject
              + (qst.QstType == "3" ? " (" + qst.QstTopCnt + "순위 선택)" : "")
              + (qst.QstType == "4" && !isNullOrEmpty(qst.QstImgId) ? " (" + qst.qtImgSrc + ")" : "")
            );

            if (qst.QstType == "1"
              || qst.QstType == "3"
              || qst.QstType == "4"
              || (qst.QstType == "C" && qst.ClassfyCd != "MB" && qst.ClassfyCd != "EM")
            ) {
              if (qst.QstType == "C" && qst.ClassfyCd == "GD") {
                addExcelRow(exportData[i], "1. 남");
                addExcelRow(exportData[i], "2. 여");
              }
              else {
                it = $filter('filter')(vm.svyQstItems, {qtId: qst.qtId}, true);
                it.forEach(function (item) {
                  addExcelRow(exportData[i],
                    item.QstItemNo + ". "
                    + item.QstItemContents
                    + (qst.QstType == "4" && !isNullOrEmpty(item.QstItemImgId) ? " (" + item.itImgSrc + ")" : "")
                  );
                });
              }
            }

            addExcelRow(exportData[i], " ");
            addExcelRow(exportData[i], " ");
          });
        }
      }
      else {
        sheetNames.push("1페이지");
      }
      */

      sheetNames.push("설문지");
      exportData = [];

      vm.svyQsts.forEach(function(qst) {
        addExcelRow(exportData,
          wjmSurvey.getQstTypeNm(qst.QstType)
          + " " + (qst.QstType == "R" ? "" : qst.QstNo + ". ")
          + qst.QstSubject
          + (qst.QstType == "3" ? " (" + qst.QstTopCnt + "순위 선택)" : "")
          + (qst.QstType == "4" && !isNullOrEmpty(qst.QstImgId) ? " (" + qst.qtImgSrc + ")" : "")
        );

        if (qst.QstType == "1"
          || qst.QstType == "3"
          || qst.QstType == "4"
          || (qst.QstType == "C" && qst.ClassfyCd != "MB" && qst.ClassfyCd != "EM")
        ) {
          if (qst.QstType == "C" && qst.ClassfyCd == "GD") {
            addExcelRow(exportData, "1. 남");
            addExcelRow(exportData, "2. 여");
          }
          else {
            it = $filter('filter')(vm.svyQstItems, {qtId: qst.qtId}, true);
            it.forEach(function (item) {
              addExcelRow(exportData,
                item.QstItemNo + ". "
                + item.QstItemContents
                + (qst.QstType == "4" && !isNullOrEmpty(item.QstItemImgId) ? " (" + item.itImgSrc + ")" : "")
              );
            });
          }

          addExcelRow(exportData, " ");
          addExcelRow(exportData, " ");
        }
      });

      $rootScope.excelDown(exportData, fileName, sheetNames);
    }

    /**
     * 설문지 엑셀 다운로드용 Row 추가
     *
     * @param
     * @return
     */
    function addExcelRow(exportData, txt) {
      var row = [];

      row.push(txt);
      exportData.push(row);
    }

    // 함수 선언
    vm.getData = getData;                     // 데이터 조회
    vm.goList = goList;                       // 목록 화면 이동
    vm.goEdit = goEdit;                       // 수정 화면 이동
    vm.setData = setData;
    vm.setDelData = setDelData;
    vm.goCopyEdit = goCopyEdit;
    vm.goCopyFormEdit = goCopyFormEdit;
    vm.setBegin = setBegin;
    vm.getExcelFile = getExcelFile;

    // 데이터 조회
    getData();

  }]);


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:survey-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 설문 등록/수정
   */
  webapp.controller('WjmSurveyEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter', 'wjmSurvey',

    function WjmSurveyEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter, wjmSurvey) {
      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmSurvey.insertSurvey'; // 등록 SQL
      var UPDATE_SQL = 'WjmSurvey.updateSurvey'; // 수정 SQL
      var VIEW_SQL = 'WjmSurvey.getSurveyDetail'; // 조회 SQL
      //var DEL_SQL = 'WjmSurvey.deleteSurveyDetail';  // 삭제 SQL

      var VIEWQST_SQL = 'WjmSurvey.getSurveyQstDetail'; // 조회 SQL (문항)
      var VIEWQSTITEM_SQL = 'WjmSurvey.getSurveyQstItemDetail'; // 조회 SQL (보기)
      var INSERTUPDATEQST_SQL = 'WjmSurvey.insertUpdateSurveyQst'; // 등록/수정 SQL (문항)
      var INSERTUPDATEQSTITEM_SQL = 'WjmSurvey.insertUpdateSurveyQstItem'; // 등록/수정 SQL (보기)
      var UPDATESURVEYCLEANUP_SQL = 'WjmSurvey.updateSurveyCleanup'; // 문항,보기 정리

      var FORM_VIEW_SQL = 'WjmForm.getFormDetail'; // 서식 조회 SQL
      var FORM_VIEWQST_SQL = 'WjmForm.getFormQstDetail'; // 서식 조회 SQL (문항)
      var FORM_VIEWQSTITEM_SQL = 'WjmForm.getFormQstItemDetail'; // 서식 조회 SQL (보기)

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.survey-list';             // 목록 화면
      //var LIST_VIEW_PAGE_URL = 'app.survey.survey-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.survey.survey-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.survey'; // 조회용 테이블명
      var KEY_COLUMN_NM = 'SvyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      //vm.vault = null;        // 첨부파일 컴포넌트
      //vm.vault2 = null;        // 첨부파일 컴포넌트

      // 설문관련 변수
      vm.svyPages = [];
      vm.svyQsts = [];
      vm.svyQstItems = [];

      vm.isChrome = true;
      if (navigator.userAgent.toLowerCase().indexOf("chrome") == -1) vm.isChrome = false;

      vm.isLoaded = false;

      $scope.wjmSurvey = wjmSurvey;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      // 설문 조회에서 복사등록으로 넘어온 경우
      vm.srch.cKeyId = !isNullOrEmpty($stateParams.cKeyId) ? $stateParams.cKeyId : '';

      /*
      if (!$stateParams.tabId) {
        vm.tabId = 1;
      } else {
        vm.tabId = $stateParams.tabId;
      }
      */

      //vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      //vm.uploadFileList = [];  // 첨부파일 목록
      //vm.uploadFileList2 = [];  // 첨부파일 목록
      //vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      /**
       * 저장/삭제 사용불가처리 여부
       *
       * @param
       * @return
       */
      vm.isDisable = function() {
        var rtn = false;

        if (vm.data.SvyStatus != '1' && vm.data.SvyStatus != '2' && vm.data.SvyStatus != null) {
          rtn = true;
        }
        else if (!vm.isLoaded) {
          rtn = true;
        }

        return rtn;
      };

      // #region 첨부파일 Callback
      /*
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              if (id == 'vault2') {
                obj.grpId = 2;
                vm.uploadFileList2.push(obj);
              } else {
                vm.uploadFileList.push(obj);
              }

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };
      */
      // #endregion 첨부파일 Callback

      /**
       * 미리보기 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.goPreview = function () {
        // 에디터 내용 삽입
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.TopCont = $("#strHtml").val();
        oEditors.getById["strHtml2"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.BtmCont = $("#strHtml2").val();

        var ctrl = 'WjmPreModalCtrl as vc';
        var paramData = {
          svyInfo: vm.data,
          svyPages: vm.svyPages,
          svyQsts: vm.svyQsts,
          svyQstItems: vm.svyQstItems
        };

        var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-pre-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 성공
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 문항 편집 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstEdit = function (qtId) {
        var ctrl = 'WjmQstModalCtrl as vc';
        //var paramData = { qt: qt, it: $filter('filter')(vm.svyQstItems, {qtId: qt.qtId}) };
        var paramData = {
          qtId: qtId,
          svyQsts: vm.svyQsts,
          svyQstItems: vm.svyQstItems,

          // vm.data 의 데이터들은 이름 그대로 전달
          //Manager: vm.data.Manager,
          SvyTypeId: vm.data.SvyTypeId,
          ClassfyInfoId: vm.data.ClassfyInfoId,
        };
        var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-qst-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 성공
          wjmSurvey.sortSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);

        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 업체선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
        }, function (cancelData) {
        });
      };
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
      };

      /**
       * 서식선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchFormModal = function () {
        var ctrl = 'WjmFormModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/survey/wjm-form-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          gConfirm('', '설문옵션, 소개글, 문항편집, 끝맺음말의 내용을 해당서식으로 대체하겠습니까?', {
            btn: '',
            fn: function () {
              vm.data.FormNm = okData.FormNm;
              vm.data.FormId = okData.KeyId;

              vm.setDelQstAll();
              getDataForm();
            }
          }, {
            btn: '',
            fn: function () {
              // 취소
            }
          });
        }, function (cancelData) {
          // 취소
        });

        //console.log("test", vm.svyQstItems);
      };
      vm.eraseForm = function () {
        if (!isNullOrEmpty(vm.data.FormId)) {
          gConfirm('', '적용된 서식 초기화시 등록된 페이지 및 문항데이터가 초기화됩니다. 계속진행하시겠습니까?', {
            btn: '',
            fn: function () {
              vm.data.FormNm = "";
              vm.data.FormId = "";
              vm.svyPages = [];
              //vm.svyQsts = [];
              //vm.svyQstItems = [];
              vm.setDelQstAll();
            }
          }, {
            btn: '',
            fn: function () {
              // 취소
            }
          });
        }

        /*
        vm.data.FormNm = "";
        vm.data.FormId = "";
        */
      };

      /**
       * 설문유형선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchSvyTypeModal = function () {
        var ctrl = 'SvyTypeModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/survey/svytype-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          gConfirm('', '설문유형이 변경되면 문항에 매핑된 문항영역이 초기화됩니다. 진행하시겠습니까?', {
            btn: '',
            fn: function () {
              vm.data.SvyTypeNm = okData.SvyTypeNm;
              vm.data.SvyTypeId = okData.SvyTypeId;
              vm.data.SvyTypeCd = okData.SvyTypeCd;

              vm.svyQsts.forEach(function(i) {
                i.QstSecId = "";
              });
            }
          }, {
            btn: '',
            fn: function () {
              // 취소
            }
          });
        }, function (cancelData) {
          // 취소
        });
      };
      vm.eraseSvyType = function () {
        gConfirm('', '설문유형이 변경되면 문항에 매핑된 문항영역이 초기화됩니다. 진행하시겠습니까?', {
          btn: '',
          fn: function () {
            vm.data.SvyTypeNm = "";
            vm.data.SvyTypeId = "";
            vm.data.SvyTypeCd = "";

            vm.svyQsts.forEach(function(i) {
              i.QstSecId = "";
            });
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      };

      /**
       * 분류정보선택 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchClassfyInfoModal = function () {
        if (isNullOrEmpty(vm.data.Manager)) {
          gAlert('', "업체를 선택해주세요.");
          return false;
        }

        var ctrl = 'ClassfyInfoModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId, srchManager: vm.data.Manager};
        var modalInstance = modalFactory.open('xs', 'components/modal/survey/classfyinfo-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.data.ClassfyInfoNm = okData.ClassfyInfoNm;
          vm.data.ClassfyInfoId = okData.ClassfyInfoId;
        }, function (cancelData) {
        });
      };
      vm.eraseClassfyInfo = function () {
        vm.data.ClassfyInfoNm = "";
        vm.data.ClassfyInfoId = "";
      };

      /**
       * 문항 일괄생성
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setBatchQst = function () {
        var i = 0;
        var j = 0;
        var errMsg = '';

        if (vm.svyPages.length == 0) {
          errMsg = errMsg + '- 페이지를 추가해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.batchQstType)) {
          errMsg = errMsg + '- 문항유형을 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.batchCnt)) {
          errMsg = errMsg + '- 페이지당반복수를 입력해주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        gConfirm('', '일괄생성시 기존 서식 및 문항데이터는 삭제됩니다. 계속진행하시겠습니까?', {
          btn: '',
          fn: function () {
            vm.data.FormId = "";
            vm.data.FormNm = "";
            //vm.svyQsts = [];
            //vm.svyQstItems = [];
            vm.setDelQstAll();

            for (i = 0; i < vm.svyPages.length; i++) {
              for (j = 0; j < vm.batchCnt; j++) {
                if (!vm.setSvyQstAdd(vm.svyPages[i].PageNo, vm.batchQstType)) break;
              }
            }

            if (isNullOrEmpty(vm.svyPagesCur)) vm.svyPagesCur = 1;
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      };

      /**
       * 모든 문항, 보기 삭제
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setDelQstAll = function() {
        /*
        vm.svyQsts.forEach(function(i) {
          if (isNullOrEmpty(i.SvyQstId)) {
            vm.svyQsts.splice(vm.svyQsts.indexOf(i), 1);
            console.log("1");
          }
          else {
            console.log("2");
            i.stat = "D"
          }
        });
        vm.svyQstItems.forEach(function(i) {
          if (isNullOrEmpty(i.SvyQstItemId)) vm.svyQstItems.splice(vm.svyQstItems.indexOf(i), 1);
          else i.stat = "D"
        });
        */

        var i = 0;

        for (i = vm.svyQsts.length - 1; i >= 0; i--) {
          if (isNullOrEmpty(vm.svyQsts[i].SvyQstId)) {
            vm.svyQsts.splice(i, 1);
          }
          else {
            vm.svyQsts[i].stat = "D";
          }
        }

        for (i = vm.svyQstItems.length - 1; i >= 0; i--) {
          if (isNullOrEmpty(vm.svyQstItems[i].SvyQstItemId)) {
            vm.svyQstItems.splice(i, 1);
          }
          else {
            vm.svyQstItems[i].stat = "D";
          }
        }

        //console.log("del", vm.svyQsts);
      };

      /**
       * 분기정보 조회
       *
       * @param {string}
       * @return {boolean}
       */
      vm.getGotoInfoFrom = function (goToQstId) {
        // 추후 정보를 보여줘야한다면 확장
        var qt = [];

        if (!isNullOrEmpty(goToQstId)) {
          qt = $filter('filter')(vm.svyQsts, {qtId: goToQstId}, true);
        }

        return qt.length > 0;
      };

      vm.getGotoInfoTo = function (qtId) {
        // 추후 정보를 보여줘야한다면 확장
        var qt = [];
        var it = [];

        qt = $filter('filter')(vm.svyQsts, {GoToQstId: qtId}, true);
        it = $filter('filter')(vm.svyQstItems, {GoToQstId: qtId}, true);

        return qt.length > 0 || it.length > 0;
      };

      /**
       * 분기정보 삭제
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setGotoDel = function (qtId) {
        var qt = $filter('filter')(vm.svyQsts, {GoToQstId: qtId}, true);
        var it = $filter('filter')(vm.svyQstItems, {GoToQstId: qtId}, true);

        qt.forEach(function(i) {
          i.GoToQstId = "";
          i.stat = "U";
        });
        it.forEach(function(i) {
          i.GoToQstId = "";
          i.stat = "U";
        });
      };

      /**
       * 페이지 마지막에 추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyPageAdd = function () {
        var nextPgNo = vm.svyPages.length + 1;

        if (vm.svyPages.length > wjmSurvey.maxSvyPagesCnt) {
          gAlert('', "더이상 페이지를 만들 수 없습니다.");
          return false;
        }

        vm.svyPages.push({PageNo: nextPgNo});
        vm.svyPagesCur = nextPgNo;

        return true;
      };

      /**
       * 페이지 이전에 추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyPagePrevAdd = function () {
        var nextPgNo = vm.svyPages.length + 1;

        if (vm.svyPages.length > wjmSurvey.maxSvyPagesCnt) {
          gAlert('', "더이상 페이지를 만들 수 없습니다.");
          return false;
        }

        if ($filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur, QstLock: 'Y'}, true).length > 0) {
          gAlert('', "현재 페이지에 잠금문항(서식)이 존재하므로 이전페이지를 삽입할 수 없습니다.");
          return false;
        }

        vm.svyPages.push({PageNo: nextPgNo});

        vm.svyQsts.forEach(function(i) {
          if (i.PageNo > vm.svyPagesCur - 1) {
            i.PageNo = i.PageNo + 1;
            i.stat = "U";
          }
        });

        return true;
      };

      /**
       * 페이지 삭제
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyPageDel = function () {
        var pg = [];
        var qt = [];
        var it = [];
        var isLock = true;

        if (isNullOrEmpty(vm.svyPagesCur)) {
          gAlert('', "삭제할 페이지를 선택해주세요.");
          return false;
        }

        gConfirm('', '선택한 페이지와 해당 페이지에 등록된 문항을 삭제하고 페이지번호를 순차적으로 재정의 하시겠습니까?', {
          btn: '',
          fn: function () {
            pg = $filter('filter')(vm.svyPages, {PageNo: vm.svyPagesCur}, true)[0];

            if ($filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur, QstLock: 'Y'}, true).length == 0) {
              vm.svyPages.splice(vm.svyPages.indexOf(pg), 1);
              isLock = false;
            }

            qt = $filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur}, true);
            qt.forEach(function(i) {
              if (i.QstLock == "N") {
                it = $filter('filter')(vm.svyQstItems, {qtId: i.qtId}, true);
                it.forEach(function(j) {
                  if (isNullOrEmpty(j.SvyQstItemId)) vm.svyQstItems.splice(vm.svyQstItems.indexOf(j), 1);
                  else j.stat = "D";
                });

                vm.setGotoDel(i.qtId);

                if (isNullOrEmpty(i.SvyQstId)) vm.svyQsts.splice(vm.svyQsts.indexOf(i), 1);
                else i.stat = "D";
              }
            });

            wjmSurvey.initSvyNo("PG", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
            wjmSurvey.initSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
            //wjmSurvey.initSvyNo("IT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);

            if (vm.svyPages.length > 0 && !isLock) vm.svyPagesCur--;
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      };

      /**
       * 문항 추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstAdd = function (paramSvyPagesCur, paramQstType) {
        var i = 0;
        var nextQtId = wjmSurvey.getSvyCode("QT", vm.svyQsts, vm.svyQstItems);
        var svyPagesCur = "";
        var qstType = "";
        var errMsg = "";
        var qstSort = vm.svyQsts.length + 1;
        var qstNo = $filter('filter')(vm.svyQsts, {QstType: '!R'}, true).length + 1;

        svyPagesCur = !isNullOrEmpty(paramSvyPagesCur) ? paramSvyPagesCur : vm.svyPagesCur;
        qstType = !isNullOrEmpty(paramSvyPagesCur) ? paramQstType : vm.addQstType;

        if (isNullOrEmpty(svyPagesCur)) {
          errMsg = errMsg + '- 문항을 추가할 페이지를 선택해주세요.<br/>';
        }

        if (isNullOrEmpty(qstType)) {
          errMsg = errMsg + '- 문항유형을 선택해주세요.<br/>';
        }

        if (vm.svyQsts.length > wjmSurvey.maxSvyQstsCnt) {
          errMsg = errMsg + '- 더이상 문항을 만들 수 없습니다.<br/>';
        }

        if (!isNullOrEmpty(vm.data.FormId) && vm.svyPages.length != vm.svyPagesCur) {
          errMsg = errMsg + '- 서식을 불러온 경우 마지막 페이지와 새로 추가한 페이지에만 문항을 추가할 수 있습니다.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        switch (qstType) { // form-edit-ctrl.js의 항목 내용과 다릅니다. 복사할때 확인
          // 선택형
          case "1":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              SvyQstId: "",
              QstLock: "N",
              GoToQstId: "",
              QstImgId: "",
              FormQstId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "S",
              SelMin: 1,
              SelMax: 1,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "I",
              InputHint: "",
              QstPassYN: "Y",
            });

            for (i = 0; i < 4; i++) {
              vm.svyQstItems.push({
                itId: wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems),
                qtId: nextQtId,
                stat: "I",

                // DB명과 같은 항목
                QstItemNo: i + 1,
                QstItemContents: wjmSurvey.txtQstItemContents,
                QstItemContents2: "",
                QstItemScore: "0",
                SvyQstItemId: "",
                GoToQstId: "",
                ClassfyId: "",
                QstItemImgId: "",
                FormQstItemId: ""
              });
            }
            break;

          // 입력형
          case "2":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              SvyQstId: "",
              QstLock: "N",
              GoToQstId: "",
              QstImgId: "",
              FormQstId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "I",
              InputHint: "",
              QstPassYN: "Y",
            });
            break;

          // 우선순위형
          case "3":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 4,
              QstSecId: "",
              ClassfyCd: "",
              SvyQstId: "",
              QstLock: "N",
              GoToQstId: "",
              QstImgId: "",
              FormQstId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "",
              InputHint: "",
              QstPassYN: "Y",
            });

            for (i = 0; i < 4; i++) {
              vm.svyQstItems.push({
                itId: wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems),
                qtId: nextQtId,
                stat: "I",

                // DB명과 같은 항목
                QstItemNo: i + 1,
                QstItemContents: wjmSurvey.txtQstItemContents,
                QstItemContents2: "",
                QstItemScore: "0",
                SvyQstItemId: "",
                GoToQstId: "",
                ClassfyId: "",
                QstItemImgId: "",
                FormQstItemId: ""
              });
            }
            break;

          // 이미지형
          case "4":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              SvyQstId: "",
              QstLock: "N",
              GoToQstId: "",
              QstImgId: "",
              FormQstId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "I",
              InputHint: "",
              QstPassYN: "Y",
            });

            for (i = 0; i < 4; i++) {
              vm.svyQstItems.push({
                itId: wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems),
                qtId: nextQtId,
                stat: "I",

                // DB명과 같은 항목
                QstItemNo: i + 1,
                QstItemContents: wjmSurvey.txtQstItemContents,
                QstItemContents2: "",
                QstItemScore: "0",
                SvyQstItemId: "",
                GoToQstId: "",
                ClassfyId: "",
                QstItemImgId: "",
                FormQstItemId: ""
              });
            }
            break;

          // 척도형
          case "5":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              SvyQstId: "",
              QstLock: "N",
              GoToQstId: "",
              QstImgId: "",
              FormQstId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: wjmSurvey.qstScaleMaxDef,
              ScaleOrder: "A",
              InputType: "",
              InputHint: "",
              QstPassYN: "Y",
            });

            for (i = 0; i < 4; i++) {
              vm.svyQstItems.push({
                itId: wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems),
                qtId: nextQtId,
                stat: "I",

                // DB명과 같은 항목
                QstItemNo: i + 1,
                QstItemContents: wjmSurvey.txtQstItemContents,
                //QstItemContents2: wjmSurvey.txtQstItemContents,
                QstItemContents2: "",
                QstItemScore: "0",
                SvyQstItemId: "",
                GoToQstId: "",
                ClassfyId: "",
                QstItemImgId: "",
                FormQstItemId: ""
              });
            }
            break;

          // 분류정보
          case "C":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: qstNo,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubject,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              SvyQstId: "",
              QstLock: "N",
              GoToQstId: "",
              QstImgId: "",
              FormQstId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "I",
              InputHint: "",
              QstPassYN: "Y",
            });
            break;

          // 설명글
          case "R":
            vm.svyQsts.push({
              qtId: nextQtId,
              stat: "I",

              // DB명과 같은 항목
              PageNo: svyPagesCur,
              QstNo: 0,
              QstSort: qstSort,
              QstSubject: wjmSurvey.txtQstSubjectR,
              QstType: qstType,
              QstTopCnt: 0,
              QstSecId: "",
              ClassfyCd: "",
              SvyQstId: "",
              QstLock: "N",
              GoToQstId: "",
              QstImgId: "",
              FormQstId: "",
              QstFontSize: wjmSurvey.qstFontSizeDef,
              QstEndType: "",
              SelType: "",
              SelMin: 0,
              SelMax: 0,
              ScaleMax: 0,
              ScaleOrder: "",
              InputType: "",
              InputHint: "",
              QstPassYN: "Y",
            });
            break;

          default :
            break;
        }

        wjmSurvey.initSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);

        return true;
      };

      /**
       * 문항 삭제
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstDel = function (qtId) {
        var qt = [];
        var it = [];

        gConfirm('', '선택한 문항을 삭제하고 문항번호를 순차적으로 재정의 하시겠습니까?', {
          btn: '',
          fn: function () {
            qt = $filter('filter')(vm.svyQsts, {qtId: qtId}, true)[0];
            if (isNullOrEmpty(qt.SvyQstId)) vm.svyQsts.splice(vm.svyQsts.indexOf(qt), 1);
            else qt.stat = "D";

            it = $filter('filter')(vm.svyQstItems, {qtId: qtId}, true);
            it.forEach(function(i) {
              if (isNullOrEmpty(i.SvyQstItemId)) vm.svyQstItems.splice(vm.svyQstItems.indexOf(i), 1);
              else i.stat = "D";
            });

            vm.setGotoDel(qtId);

            wjmSurvey.initSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
            //wjmSurvey.initSvyNo("IT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      };

      /**
       * 설문기간추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyDate = function () {
        if (isNullOrEmpty(vm.data.SvyBeginDate) || isNullOrEmpty(vm.data.SvyEndDate)) {
          gAlert('', "설문시작일과 종료일을 입력해주세요.");
          return;
        }

        oEditors.getById["strHtml"].exec("PASTE_HTML", ["설문조사기간: " + moment(vm.data.SvyBeginDate).format('YYYY-MM-DD') + " ~ " + moment(vm.data.SvyEndDate).format('YYYY-MM-DD')]);
      };

      /**
       * 분기 설정
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstGoto = function (qtId) {
        var ctrl = 'WjmQstGotoModalCtrl as vc';
        var paramData = {
          qtId: qtId,
          //svyInfo: vm.data,
          svyPages: vm.svyPages,
          svyQsts: vm.svyQsts,
          svyQstItems: vm.svyQstItems
        };

        var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-qstgoto-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          //vm.data.TenantNm = okData.TenantNm;
          //vm.data.TenantId = okData.TenantId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 이동 설정
       *
       * @param {string}
       * @return {boolean}
       */
      vm.setSvyQstMove = function (qtId) {
        var ctrl = 'WjmQstMoveModalCtrl as vc';
        var paramData = {
          qtId: qtId,
          //svyInfo: vm.data,
          svyPages: vm.svyPages,
          svyQsts: vm.svyQsts
          //svyQstItems: vm.svyQstItems
        };

        var modalInstance = modalFactory.open('xs', 'components/modal/survey/wjm-qstmove-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          //vm.data.TenantNm = okData.TenantNm;
          //vm.data.TenantId = okData.TenantId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 초기 세팅
       * @param
       * @return
       */
      function init(){

        // 문항 목록 체크박스 설정
        /*
        vm.qstChkHead = false;
        $scope.qstChkRowChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            if (!vm.qstLists[i].isChecked) {
              vm.qstChkHead = false;
              return;
            }
          }
          vm.qstChkHead = true;
        };

        $scope.qstChkHeadChg = function () {
          for (var i = 0; i < vm.qstLists.length; i++) {
            vm.qstLists[i].qstChkRow = vm.qstChkHead;
          }
        };
        */

        vm.isLoaded = true;
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        var i = 0;

        vm.dataloader = true;
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공NPBNPM INSTALLNPMNNsssssddsafdsafafdsgasdafasd
            vm.dataloader = false;

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              if (!isNullOrEmpty(vm.data.PageCnt)) {
                for (i = 0; i < parseInt(vm.data.PageCnt); i++) {
                  if (!vm.setSvyPageAdd()) break;
                }
                vm.svyPagesCur = 1;
              }

              //Date형식 처리
              if (!isNullOrEmpty(vm.data.SvyBeginDate)) vm.SvyBeginDate = moment(vm.data.SvyBeginDate).toDate();
              if (!isNullOrEmpty(vm.data.SvyEndDate)) vm.SvyEndDate = moment(vm.data.SvyEndDate).toDate();

              // 에디터 내용삽입 (익스플로러 고려)
              try {
                if (!vm.isChrome && oEditors.length > 0) {
                  oEditors.getById["strHtml"].exec("SET_IR", [""]); //내용초기화
                  oEditors.getById["strHtml2"].exec("SET_IR", [""]); //내용초기화
                  oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.TopCont]);
                  oEditors.getById["strHtml2"].exec("PASTE_HTML", [vm.data.BtmCont]);
                }
                else {
                  $("#strHtml").val(vm.data.TopCont);
                  $("#strHtml2").val(vm.data.BtmCont);
                }
              }
              catch (e) {
              }

              // 기본값 (no data 때문에 이쪽으로 들어오는 듯)
              if (isNullOrEmpty(vm.data.keyId)) {
                vm.data.SvyNum = "자동생성";
                vm.data.SvyEndMsg = "기간이 만료된 설문입니다.";
                vm.data.RespLimitEndMsg = "응답건수가 마감된 설문입니다.";
                vm.data.BoxColor = "999999";
                vm.data.LineColor = "555555";
                vm.data.BoxColorData = "#" + vm.data.BoxColor + "!Important";
                vm.data.LineColorData = "#" + vm.data.LineColor + "!Important";
                vm.data.SvyTypeNm = "일반설문(미선택)";
                vm.data.RespLimitYN = 'N';
                vm.data.QstPassYN = "Y";
                vm.data.SvyLang = "";

                vm.setSvyPageAdd();
              }

              getDataQsts();
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (문항)
       * @param
       * @return
       */
      function getDataQsts() {
        var data = vm.srchDetail;

        vm.dataloader = true;
        data.mapCode = VIEWQST_SQL;
        data.SvyId = vm.data.keyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.svyQsts = result.body.docs;
                //wjmSurvey.sortSvyNo("QT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);

                getDataQstItems();
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataQst()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataQst()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (보기)
       * @param
       * @return
       */
      function getDataQstItems() {
        var data = vm.srchDetail;

        vm.dataloader = true;
        data.mapCode = VIEWQSTITEM_SQL;
        data.SvyId = vm.data.keyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.svyQstItems = result.body.docs;
                //wjmSurvey.sortSvyNo("IT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }

            setEndProc();
          } else {
            vm.dataloader = false;
            console.error("Error> getDataQstItems()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataQstItems()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (서식)
       * @param
       * @return
       */
      function getDataForm() {
        var i = 0;

        vm.dataloader = true;

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;
        }

        var data = vm.srchDetail;
        data.mapCode = FORM_VIEW_SQL;
        data.keyId = vm.data.FormId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 치환 데이터
              vm.svyPages = [];
              //vm.svyQsts = [];
              //vm.svyQstItems = [];

              //vm.data.Manager = result.body.docs[0].Manager;
              //vm.data.ManagerNm = result.body.docs[0].ManagerNm;
              vm.data.SvyTypeId = result.body.docs[0].SvyTypeId;
              vm.data.SvyTypeNm = result.body.docs[0].SvyTypeNm;
              vm.data.SvyTypeCd = result.body.docs[0].SvyTypeCd;
              //vm.data.ClassfyInfoId = result.body.docs[0].ClassfyInfoId;
              //vm.data.ClassfyInfoNm = result.body.docs[0].ClassfyInfoNm;
              vm.data.RespLimitYN = result.body.docs[0].RespLimitYN;
              //vm.data.RespLimitCnt = result.body.docs[0].RespLimitCnt;
              vm.data.QstPassYN = result.body.docs[0].QstPassYN;
              vm.data.QstNumYN = result.body.docs[0].QstNumYN;
              vm.data.QstIconType = result.body.docs[0].QstIconType;
              vm.data.BoxColor = result.body.docs[0].BoxColor;
              vm.data.LineColor = result.body.docs[0].LineColor;
              vm.data.ClosingType = result.body.docs[0].ClosingType;
              vm.data.RespLimitEndMsg = result.body.docs[0].RespLimitEndMsg;
              vm.data.LinkCRMYN = result.body.docs[0].LinkCRMYN;
              vm.data.InfoAgreeYN1 = result.body.docs[0].InfoAgreeYN1;
              vm.data.InfoAgreeYN2 = result.body.docs[0].InfoAgreeYN2;
              vm.data.InfoAgreeYN3 = result.body.docs[0].InfoAgreeYN3;
              vm.data.InfoAgreeYN4 = result.body.docs[0].InfoAgreeYN4;
              vm.data.TopCont = result.body.docs[0].TopCont;
              vm.data.BtmCont = result.body.docs[0].BtmCont;
              vm.data.BtmType = result.body.docs[0].BtmType;
              vm.data.PageCnt = result.body.docs[0].PageCnt;
              vm.data.SvyLang = result.body.docs[0].SvyLang;

              // 에디터 내용삽입
              oEditors.getById["strHtml"].exec("SET_IR", [""]); //내용초기화
              oEditors.getById["strHtml2"].exec("SET_IR", [""]); //내용초기화
              oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.TopCont]);
              oEditors.getById["strHtml2"].exec("PASTE_HTML", [vm.data.BtmCont]);

              if (!isNullOrEmpty(vm.data.PageCnt)) {
                for (i = 0; i < parseInt(vm.data.PageCnt); i++) {
                  if (!vm.setSvyPageAdd()) break;
                }
                vm.svyPagesCur = 1;
              }

              //Date형식 처리
              //if (!isNullOrEmpty(vm.data.SvyBeginDate)) vm.SvyBeginDate = moment(vm.data.SvyBeginDate).toDate();
              //if (!isNullOrEmpty(vm.data.SvyEndDate)) vm.SvyEndDate = moment(vm.data.SvyEndDate).toDate();

              getDataFormQsts();
            } else {
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataForm()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataForm()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (서식 문항)
       * @param
       * @return
       */
      function getDataFormQsts() {
        var data = vm.srchDetail;
        var rtn = [];

        vm.dataloader = true;
        data.mapCode = FORM_VIEWQST_SQL;
        data.FormId = vm.data.FormId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                //vm.svyQsts = result.body.docs;
                rtn = result.body.docs;
                rtn.forEach(function(i) {
                  i.stat = "F";

                  // 분류정보 문항일 경우 저장전까지 수정이 가능하도록 임시잠금처리
                  if (i.QstType == "C") i.QstLock = "Y_";

                  vm.svyQsts.push(i);
                });

                getDataFormQstItems();
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataFormQsts()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataFormQsts()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (서식 보기)
       * @param
       * @return
       */
      function getDataFormQstItems() {
        var data = vm.srchDetail;
        var rtn = [];

        vm.dataloader = true;
        data.mapCode = FORM_VIEWQSTITEM_SQL;
        data.FormId = vm.data.FormId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                //vm.svyQstItems = result.body.docs;
                rtn = result.body.docs;
                rtn.forEach(function(i) {
                  i.stat = "F";
                  vm.svyQstItems.push(i);
                });

                //wjmSurvey.sortSvyNo("IT", "", vm.svyPages, vm.svyQsts, vm.svyQstItems);
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }

            // 문항코드 초기화 및 설문필드 생성
            initQstCode("F");
            setEndProc();
          } else {
            vm.dataloader = false;
            console.error("Error> getDataFormQstItems()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataFormQstItems()");
          console.table(error);
        });
      }

      /**
       * 문항코드 초기화 및 설문필드 생성
       * @param
       * @return
       */
      function initQstCode(type) {
        var qt = [];
        var it = [];
        var fQt = [];
        var fIt = [];
        var nQtId = "";

        wjmSurvey.codeNo = 0;

        fQt = $filter('filter')(vm.svyQsts, {stat: type}, true);
        fIt = $filter('filter')(vm.svyQstItems, {stat: type}, true);

        fQt.forEach(function (i) {
          nQtId = wjmSurvey.getSvyCode("QT", null, null, false);

          it = $filter('filter')(fIt, {qtId: i.qtId}, true);
          it.forEach(function(j) {
            j.stat = "I";
            j.qtId = nQtId;
            j.itId = wjmSurvey.getSvyCode("IT", null, null, false);
            j.SvyQstItemId = "";
            //delete j.FormQstItemId;
          });

          it = $filter('filter')(fIt, {GoToQstId: i.qtId}, true);
          it.forEach(function(j) { j.GoToQstId = nQtId });

          qt = $filter('filter')(fQt, {GoToQstId: i.qtId}, true);
          qt.forEach(function(j) { j.GoToQstId = nQtId });

          i.stat = "I";
          i.qtId = nQtId;
          i.SvyQstId = "";
          //delete i.FormQstId;
        });

        wjmSurvey.codeNo = 0;
      }

      /**
       * 데이터 조회 (카피)
       * @param
       * @return
       */
      function getDataCopy() {
        var i = 0;

        vm.dataloader = true;

        if (isNullOrEmpty(vm.srch.cKeyId)) {
          vm.dataloader = false;
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        data.keyId = vm.srch.cKeyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              //result.body.docs[0];

              vm.data = result.body.docs[0];
              //vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              vm.data.SvyStatus = 1; // 작성중으로 변경

              if (!isNullOrEmpty(vm.data.PageCnt)) {
                for (i = 0; i < parseInt(vm.data.PageCnt); i++) {
                  if (!vm.setSvyPageAdd()) break;
                }
                vm.svyPagesCur = 1;
              }

              // Date형식 처리
              if (!isNullOrEmpty(vm.data.SvyBeginDate)) vm.SvyBeginDate = moment(vm.data.SvyBeginDate).toDate();
              if (!isNullOrEmpty(vm.data.SvyEndDate)) vm.SvyEndDate = moment(vm.data.SvyEndDate).toDate();

              // 에디터 내용삽입 (익스플로러 고려)
              try {
                if (!vm.isChrome && oEditors.length > 0) {
                  oEditors.getById["strHtml"].exec("SET_IR", [""]); //내용초기화
                  oEditors.getById["strHtml2"].exec("SET_IR", [""]); //내용초기화
                  oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.TopCont]);
                  oEditors.getById["strHtml2"].exec("PASTE_HTML", [vm.data.BtmCont]);
                }
                else {
                  $("#strHtml").val(vm.data.TopCont);
                  $("#strHtml2").val(vm.data.BtmCont);
                }
              }
              catch (e) {
              }

              // 기타
              vm.data.SvyNum = "";
              vm.data.SvyNm += "-복사본";

              getDataCopyQsts();
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataCopy()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataCopy()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (카피 문항)
       * @param
       * @return
       */
      function getDataCopyQsts() {
        var data = vm.srchDetail;
        var rtn = [];

        vm.dataloader = true;
        data.mapCode = VIEWQST_SQL;
        data.SvyId = vm.srch.cKeyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                //vm.svyQsts = result.body.docs;
                rtn = result.body.docs;
                rtn.forEach(function(i) {
                  i.stat = "C";
                  vm.svyQsts.push(i);
                });

                getDataCopyQstItems();
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }
          } else {
            vm.dataloader = false;
            console.error("Error> getDataCopyQsts()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataCopyQsts()");
          console.table(error);
        });
      }

      /**
       * 데이터 조회 (카피 보기)
       * @param
       * @return
       */
      function getDataCopyQstItems() {
        var data = vm.srchDetail;
        var rtn = [];

        vm.dataloader = true;
        data.mapCode = VIEWQSTITEM_SQL;
        data.SvyId = vm.srch.cKeyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false;

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                //vm.svyQstItems = result.body.docs;
                rtn = result.body.docs;
                rtn.forEach(function(i) {
                  i.stat = "C";
                  vm.svyQstItems.push(i);
                });
              }
            } else {
              //vm.data.TenantId = $window.sessionStorage['loginTenantId'];
              //vm.data.TenantNm = $window.sessionStorage['loginTenantName'];
            }

            // 문항코드 초기화 및 설문필드 생성
            initQstCode("C");
            setEndProc();
          } else {
            vm.dataloader = false;
            console.error("Error> getDataCopyQstItems()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getDataCopyQstItems()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';
        if (isNullOrEmpty(vm.data.SvyNm)) {
          errMsg = errMsg + '- 설문명을 입력해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.TargetCnt) || vm.data.TargetCnt == "0") {
          errMsg = errMsg + '- 대상인원을 입력해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.Gubun)) {
          errMsg = errMsg + '- 구분을 선택해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.SvyBeginDate)) {
          errMsg = errMsg + '- 설문시작일을 선택해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.SvyEndDate)) {
          errMsg = errMsg + '- 설문종료일을 선택해주세요.<br/>';
        }
        /*
        if (vm.data.RespLimitYN == "Y") {
          if (isNullOrEmpty(vm.data.RespLimitCnt) || vm.data.RespLimitCnt == "0") {
            errMsg = errMsg + '- 응답인원을 제한한 경우 제한수를 입력해주세요.<br/>';
          }
          if (isNullOrEmpty(vm.data.RespLimitEndMsg)) {
            errMsg = errMsg + '- 응답인원을 제한한 경우 건수마감메시지를 입력해주세요.<br/>';
          }
        }
        */
        /*
        if (isNullOrEmpty(vm.data.SvyEndMsg)) {
          errMsg = errMsg + '- 기간만료메세지를 입력해주세요.<br/>';
        }
        */
        /*
        if (isNullOrEmpty(vm.data.BoxColor)) {
          errMsg = errMsg + '- 테두리색상을 입력해주세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.LineColor)) {
          errMsg = errMsg + '- 구분선색상을 선택해주세요.<br/>';
        }
        */

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (!getIsValidData()) return;

        vm.dataloader = true;

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        vm.data.SvyBeginDate = moment(vm.data.SvyBeginDate).format('YYYY-MM-DD');
        vm.data.SvyEndDate = moment(vm.data.SvyEndDate).format('YYYY-MM-DD');

        // 에디터 내용 삽입
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.TopCont = $("#strHtml").val();
        oEditors.getById["strHtml2"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.BtmCont = $("#strHtml2").val();

        // 체크박스 처리
        if (isNullOrEmpty(vm.data.InfoAgreeYN1)) vm.data.InfoAgreeYN1 = "N";
        if (isNullOrEmpty(vm.data.InfoAgreeYN2)) vm.data.InfoAgreeYN2 = "N";
        if (isNullOrEmpty(vm.data.InfoAgreeYN3)) vm.data.InfoAgreeYN3 = "N";
        if (isNullOrEmpty(vm.data.InfoAgreeYN4)) vm.data.InfoAgreeYN4 = "N";

        // 라디오박스 처리
        if (isNullOrEmpty(vm.data.QstPassYN)) vm.data.QstPassYN = "Y";
        if (isNullOrEmpty(vm.data.RespLimitYN)) vm.data.RespLimitYN = "N";
        if (isNullOrEmpty(vm.data.QstNumYN)) vm.data.QstNumYN = "Y";
        if (isNullOrEmpty(vm.data.QstIconType)) vm.data.QstIconType = "N";
        if (isNullOrEmpty(vm.data.LinkCRMYN)) vm.data.LinkCRMYN = "N";
        if (isNullOrEmpty(vm.data.BtmType)) vm.data.BtmType = "100";
        if (isNullOrEmpty(vm.data.SvyLang)) vm.data.SvyLang = "";

        // 기타
        vm.data.PageCnt = vm.svyPages.length;
        //if (!isNullOrEmpty(vm.data.RespLimitCnt)) vm.data.RespLimitYN = "Y";

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            vm.dataloader = false;
            //setInsertUpdateDetail(result);
            if (result.body.docs[0].KeyId !== null || result.body.docs[0].NewKeyId !== null || !isNullOrEmpty(result.body.docs[0].RelateDataId))
            {
              //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
              vm.data.keyId = result.body.docs[0].RelateDataId;
            }

            setDataQsts();
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.RelateDataId = data.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            vm.dataloader = false;
            //setInsertUpdateDetail(result);
            setDataQsts();
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 (문항)
       *
       * @param
       * @return
       */
      function setDataQsts() {
        //if (!getIsValidData()) return;

        vm.dataloader = true;

        // 내용
        //vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        //vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        //vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        //vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');

        // 임시잠금처리 상태의 문항이 있는경우 다시 잠금 처리
        $filter('filter')(vm.svyQsts, {QstLock: 'Y_'}, true).forEach(function(i) { i.QstLock = "Y"; });

        var data = vm.data;
        var insertData = $filter('filter')(vm.svyQsts, {SvyQstId: '!!'}, true);
        var updateData = $filter('filter')(vm.svyQsts, {SvyQstId: '!', stat: 'U'}, true);

        data.userkey = vm.srch.userkey;
        data.mapCode = INSERTUPDATEQST_SQL;

        data.insertData = insertData;
        data.updateData = updateData;
        data.SvyId = vm.data.keyId;

        if (insertData.length > 0 || updateData.length > 0) {
          postApi.insert(data, function (result) {
            vm.dataloader = false;
            setDataQstItems();
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setDataQsts()");
            console.table(error);
          });
        }
        else {
          vm.dataloader = false;
          //setInsertUpdateDetail();
          setDataCleanup();
        }
      }

      /**
       * 데이터 저장 (보기)
       *
       * @param
       * @return
       */
      function setDataQstItems() {
        //if (!getIsValidData()) return;

        vm.dataloader = false;

        // 내용
        //vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        //vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        //vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        // Date형식 처리
        //vm.data.PurchDate = moment(vm.data.PurchDate).format('YYYY-MM-DD HH:mm:ss');

        var data = vm.data;
        var insertData = $filter('filter')(vm.svyQstItems, {SvyQstItemId: '!!'}, true);
        var updateData = $filter('filter')(vm.svyQstItems, {SvyQstItemId: '!', stat: 'U'}, true);

        data.userkey = vm.srch.userkey;
        data.mapCode = INSERTUPDATEQSTITEM_SQL;

        data.insertData = insertData;
        data.updateData = updateData;
        data.SvyId = vm.data.keyId;

        if (insertData.length > 0 || updateData.length > 0) {
          postApi.insert(data, function (result) {
            vm.dataloader = false;
            setDataCleanup();
          }, function (error) {
            vm.dataloader = false;
            console.error("Error> setDataQstItems()");
            console.table(error);
          });
        }
        else {
          vm.dataloader = false;
          setDataCleanup();
        }
      }

      /**
       * 문항 정리
       *
       * @param
       * @return
       */
      function setDataCleanup() {
        var data = vm.data;
        var deleteQstData = $filter('filter')(vm.svyQsts, {SvyQstId: '!', stat: 'D'}, true);
        var deleteQstItemData = $filter('filter')(vm.svyQstItems, {SvyQstItemId: '!', stat: 'D'}, true);

        vm.dataloader = true;

        data.deleteQstData = deleteQstData;
        data.deleteQstItemData = deleteQstItemData;
        data.userkey = vm.srch.userkey;
        data.mapCode = UPDATESURVEYCLEANUP_SQL;
        data.SvyId = vm.data.keyId;

        //console.log("data.deleteQstData", data.deleteQstData);console.log("data.deleteQstItemData", data.deleteQstItemData);return false;

        postApi.insert(data, function (result) {
          vm.dataloader = false;
          setInsertUpdateDetail();
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> setDataCleanup()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        gAlert("", "Menu.SAVED", {
          btn: "",
          fn: function () {
            // 화면 분할 모드에 따른 이동
            goNextPage(true);
          }
        });

        /*
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          //console.log("result.body.docs[0]", result.body.docs[0]);
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
            !isNullOrEmpty(result.body.docs[0].RelateDataId)
          ) {
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            //vm.data.KeyId = result.body.docs[0].RelateDataId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
        */
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch; // 검색 옵션

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId,
              cKeyId: ''
              //tabId: vm.tabId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            vm.srch.keyId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          }
          // 조회 화면 이동
          //$state.go(LIST_VIEW_PAGE_URL, {srch: srch, keyId: vm.data.KeyId, cKeyId: ''});
          //$state.go(LIST_PAGE_URL, {srch: srch, keyId: vm.data.KeyId});
          $state.go(LIST_PAGE_URL, {srch: []});
        }
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      /*
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }
      */

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      /*
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                var srch = $stateParams.srch;

                // 목록 화면 이동
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
              }
            });
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }
      */

      /*
      function setChangeTab(tabId) {
        vm.tabId = tabId;
        //goNextPage(false);
      }
      */

      /**
       * 마지막 실행 프로세스
       *
       * @param
       * @return
       */
      function setEndProc() {
        wjmSurvey.getImageList(vm.imageList, vm.svyQsts, vm.svyQstItems);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      //vm.getUploadFileList = getUploadFileList; // 첨부파일 목록 조회

      vm.setData = setData;                     // 데이터 저장
      //vm.uploadFile = uploadFile;
      //vm.uploadFile2 = uploadFile2;

      vm.goList = goList;                       // 목록 화면 이동
      //vm.setDelData = setDelData;                     // 데이터 삭제

      //vm.setChangeTab = setChangeTab;
      vm.init = init;

      // 데이터 조회
      if (isNullOrEmpty(vm.srch.keyId) && !isNullOrEmpty(vm.srch.cKeyId)) {
        getDataCopy();
      }
      else {
        getData();
      }

      //init();
    }]);
})();


(function () {
  "use strict";
  webapp.controller('SurveyEmailSendCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout','$filter',

    function SurveyEmailSendCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmSend.insertSurvyCampaign';     // 등록 SQL (설문, 개별)
      var LIST_SVYTGT_SQL = 'WjmSend.getSurveyTargetList';
      var LIST_GRPTGT_SQL = 'WjmSend.getGrpCustList';
      var LIST_FAVEMAIL_SQL = 'WjmSend.getFavoriteDropList';

      // 관련 화면 정의
      var VIEW_PAGE_URL = 'app.survey.email-send';

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.emaillog'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column


      // View Model
      var vm = this;          // View Model

      vm.formType = 'EMAIL';
      vm.dataloader = false;  // Progressbar 숨김
      vm.Contents = "0";
      vm.SurveyUrl = "";

      vm.isRpt = false;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: 'EMAIL'
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.formType = 'EMAIL';
        vm.srch.tableNm = KEY_TABLE_NM;
      }


      // #endregion 상수 정의
      var WEB_URL = CONSTANT.URL.SITE_URL_FRM_MIN;
      var API_URL = CONSTANT.URL.SITE_URL + '/openapi/';
      var SVY_URL = WEB_URL + '/survey/';
      //var DENY_URL = WEB_URL + '/emaildeny/{TgtId}/' + (!isNullOrEmpty(vm.srch.rptId) ? "RPT" : "SVY");
      var DENY_URL = CONSTANT.URL.SITE_URL_FRM + '/emaildeny/{TgtId}/' + (!isNullOrEmpty(vm.srch.rptId) ? "RPT" : "SVY");
      var OPEN_URL = API_URL + (!isNullOrEmpty(vm.srch.rptId) ? "RPT" : "SVY") + "/{TgtId}/setResultStatus.json";
      var DOWN_URL = API_URL + '{RptTgtId}/getFile.json';

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.favEmailList = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM,                               // 작업 테이블명
        SendType :'EMAIL',
        chkTgtList : [], // 체크한 발송 대상자
        SvyTgtList : [], // 설문 재발송 대상자 (응답완료, 거부 제외)
        GrpTotalList : [], // 최종 발송 대상자
        GrpTotal : 0,
        Amt : 0
      };

      vm.SvyTgtListAll = []; //설문에 매핑된 전체 대상자 (중복 체크용)
      vm.SvyTgtListRD = []; //설문에 매핑된 재발송 제외 대상자 (중복 체크용)


      // 초기값
      function init() {

        setTimeList();
        setHourList();

        getFavEmail();

        vm.data.Amt = 0;
        vm.data.SendDtType = '100';
        vm.data.FormType = vm.formType;
        vm.data.TenantId = $rootScope.gVariable.srchTenantId;
        vm.data.TenantNm = $rootScope.gVariable.srchTenantName;

        // 개인보고서 이메일 발송
        if (!isNullOrEmpty(vm.srch.rptId)) {

          vm.isRpt = true;

          // 개인보고서 상세에서 체크한 대상만 발송함.
          // 외부 업로드의 경우 설문ID가 없음
          vm.data.SurveyId = vm.srch.svyId;
          vm.data.SurveyNm = vm.srch.svyNm;
          vm.data.SurveyDate = vm.srch.svyDate;
          vm.data.ClientNm = vm.srch.clientNm;
          vm.data.RptId = vm.srch.rptId;
          vm.data.GrpTotal = vm.srch.rptTgtList.length;
          vm.data.GrpTotalList = vm.srch.rptTgtList;
          vm.data.SvyUrl = DOWN_URL;

          // 업체로고 조회
          getLogoImg(vm.srch.clientId);

        }
        // 설문조회 메뉴에서 넘어온 설문으로 변경
        else if (!isNullOrEmpty(vm.srch.svyId)) {
          vm.data.SurveyId = vm.srch.svyId;
          vm.data.SurveyNm = vm.srch.svyNm;
          vm.data.SurveyDate = vm.srch.svyDate;
          vm.data.ClientNm = vm.srch.clientNm;
          vm.data.SvyUrl = SVY_URL + vm.data.SurveyId + "/{SvyTgtId}";
          vm.getTargetList(vm.srch.svyId);
          //oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.SvyUrl]); // html페이지 에디터 로드 콜백부분에서 불러오도록 함
        }
      }

      // 유효성 체크
      function getIsValidData() {
        // #region 필수항목 체크
        var sendDate = '';
        var errMsg = '';

        if (isNullOrEmpty(vm.data.Contents)) {
          errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        }
        // 발송유형(즉시-DIRECT/예약-RESERVE/반복-REPEAT)
        vm.data.CampaignSendType = vm.data.SendDtType == '100' ? 'DIRECT' : 'RESERVE';
        vm.data.CmpgnChannel = 'EMAIL';

        if(isNullOrEmpty(vm.data.GrpTotal) || vm.data.GrpTotal <= 0) {
          errMsg = errMsg + '- 대상자를 선택하세요.<br/>';
        }
        if(isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 회신메일을 입력하세요.<br/>';
        }
        if(isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 제목을 입력하세요.<br/>';
        }

        if(vm.data.SendDtType == '200'){
          if(isNullOrEmpty(vm.data.SendDt) || isNullOrEmpty(vm.data.SendHour) || isNullOrEmpty(vm.data.SendMin)) {
            // 미입력 및 잘못된 날짜 유형
            errMsg = errMsg + '- 발송일시를 바르게 입력하세요.<br/>';
          } else {
            sendDate =  vm.data.SendDt+" "+vm.data.SendHour+":"+vm.data.SendMin+":00";
            var tday = moment(new Date()).format('YYYY-MM-DD HH:mm');
            var sday = moment(new Date(sendDate)).format('YYYY-MM-DD HH:mm');
            if(sday <= tday) {
              errMsg = errMsg + '- 발송일시를 현재 이후로 입력하세요.<br/>';
            } else {
              vm.data.SendDate = new Date(sendDate).toISOString().substr( 0, 19 ).replace("T"," ");
            }
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /** 발송
       * @param
       * @return
       */
      function setData() {

        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.Contents = $("#strHtml").val();

        if (getIsValidData() == false) {
          return;
        }

        var dt = moment.utc(vm.data.SendDate, 'YYYY-MM-DD HH:mm').local().format('YYYY년 MM월 DD일 HH시 mm분에');
        var msg = (vm.data.SendDtType == "200" ? dt + "<br/>예약" : "");
        gConfirm('', msg +' 발송하시겠습니까?', {
          btn: '',
          fn: function () {

            // 내용
            vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
            vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
            vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

            var data = vm.data; // 사용자 입력 데이터
            if(!data.SurveyNm){
              data.SurveyNm = '이메일 발송 ';
            }
            data.FromNm = "더휴먼데이터센터";

            // 메일 수신확인 코드 삽입
            data.Contents = data.Contents + "<img width='0' height='0' src='"+ OPEN_URL +"'>";

            // 신규 등록 (WJMRPT 개인보고서발송 / WJRMCHK 체크대상발송 / WJM 그외발송)
            data.SiteId = (vm.isRpt ? "WJMRPT" : (! isNullOrEmpty(vm.data.chkTgtList) ? "WJMCHK" : "WJM"));
            data.mapCode = INSERT_SQL;
            data.SendMessage = data.Contents;

            postApi.insert(data, function (result) {
              setInsertUpdateDetail(result);
            }, function (error) {
              console.error("Error> setData()");
              console.table(error);
            });
          }

        }, {
          btn: '',
          fn: function () {
            return;
          }
        });
      }

      // 데이터 저장 후 처리
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert("", "발송했습니다.", {
            btn: "",
            fn: function () {
              var srch = $stateParams.srch;
              $state.go(VIEW_PAGE_URL, {
                srch: srch,
                formType: vm.formType,
                keyId: ''
              }, {reload:VIEW_PAGE_URL});
            }
          });
          return;
        }
        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      // 서식 검색
      vm.srchFormModal = function () {
        var ctrl = 'FormModalCtrl as modalCtrl';
        var paramData = {formType: vm.formType};
        var modalInstance = modalFactory.open("modal", "components/modal/campaign/form-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {

            // 치환처리
            okData.Contents = replaceMsg(okData.Contents);

            vm.data.FormId = okData.KeyId;
            vm.data.FormNm = okData.FormNm;
            vm.data.FormType = vm.formType;
            if(vm.formType =='EMAIL') {
              vm.data.SendMessage = okData.Contents;
              oEditors.getById["strHtml"].exec("SET_IR", ['']);
              oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.SendMessage]);
            }
          },
          function (cancelData) {
            // 취소
          }
        );
      };
      vm.eraseFrom = function () {
        vm.data.FormId = '';
        vm.data.FormNm = '';
        vm.data.SendMessage = '';
        oEditors.getById["strHtml"].exec("SET_IR", ['']);
      };

      // 자주쓰는메일 관리
      vm.srchFavoriyModal = function () {
        var ctrl = 'FavoriyModalCtrl as modalCtrl';
        var paramData = { SaveType : 'E' };

        var modalInstance = modalFactory.open('md', 'components/modal/campaign/favori-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          getFavEmail();
        }, function(cancelData) {
          getFavEmail();
        });
      }

       // 자주쓰는메일 등록
       function setFavEmail() {
         // 내용
         var data = vm.data; // 사용자 입력 데이터

         vm.favEmailList.unshift({CodeValue:vm.data.FromInfo, Code:vm.data.FromInfo});
         /*
          * TODO : 메일형식 인증해야
          */
         data.mapCode = 'aws/verifyEmailAddress';
         data.SaveType = 'E';
         data.SESSION_USERID = $rootScope.gVariable.UserId;
         postApi.api(data, function (result) {
           if (result.header.status === CONSTANT.HttpStatus.OK) {
             gAlert("", "저장되었습니다.<br/>Amazon Web Services로부터 인증메일을 받아서 이후 절차를 진행해야.<br/>해당 메일로 발송이 가능합니다.", {
               btn: "",
               fn: function () {
               }
             });
           }else{
             gAlert('', result.body.docs[0].errMessage);
           }

         }, function (error) {
           console.error("Error> setFavEmail()");
           console.table(error);
         });
       }

       // 자주쓰는메일 조회
       function getFavEmail() {

         var data = vm.srchDetail;
         data.mapCode = LIST_FAVEMAIL_SQL;
         data.SaveType = 'E';

         postApi.select(data, function (result) {
           if (result.header.status == CONSTANT.HttpStatus.OK) {
             if (result.body.docs.length > 0) {
               result.body.docs.push({CodeValue: '직접입력', Code: 'setValue'});
               vm.favEmailList = result.body.docs;
             } else {
               vm.favEmailList = [{CodeValue:'직접입력', Code: 'setValue'}];
             }
           } else {

             console.error("Error> getFavEmail()");

             if (!isNullOrEmpty(result.body.docs)) {
               gAlert('', result.body.docs[0].errMessage);
             }
           }

         }, function (error) {
           console.error("Error> getFavEmail()");
           console.table(error);
         });
       }

       // 자주쓰는메일 등록을 위해 선택된 회신메일 설정
       function changeEmail() {
         if(vm.data.Favorite != "setValue") {
           vm.data.FromInfo = vm.data.Favorite;
         } else {
           vm.data.FromInfo = "";
         }
       }

      // 설문 검색
      vm.srchSurveyModal = function () {
        var ctrl = 'WjmSurveyModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/survey/wjm-survey-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.SurveyNm = res.SvyNm;
          vm.data.SurveyId = res.SvyId;
          vm.data.SurveyDate = res.SvyDate;
          vm.data.ClientNm = res.ManagerNm;
          vm.data.SvyUrl = SVY_URL + vm.data.SurveyId + "/{SvyTgtId}";

          // 업체로고 조회
          getLogoImg(res.Manager);

          // 치환처리
          if( ! isNullOrEmpty(vm.data.SendMessage)) vm.data.SendMessage = replaceMsg(vm.data.SendMessage);

          oEditors.getById["strHtml"].exec("SET_IR", ['']);
          oEditors.getById["strHtml"].exec("PASTE_HTML", [ !isNullOrEmpty(vm.data.SendMessage) ? vm.data.SendMessage : vm.data.SvyUrl ]);

          //선택설문에 대한 대상자 목록 조회해야함.
          vm.getTargetList(res.SvyId);
        }, function(cancelData) {
          //ignore
        });
      };
      vm.eraseSurvey = function () {
        vm.data.SurveyId = '';
        vm.data.SurveyNm = '';
        vm.datt.SurveyDate = '';
        vm.data.SvyUrl = '';
        vm.data.SendMessage = '';
        oEditors.getById["strHtml"].exec("SET_IR", ['']);

        vm.deleteTargetType('SURVEY');
        vm.resetGrpTotalList("");
      };

      function replaceMsg(msg)
      {
        // 서식의 설문링크 치환 처리
        if(msg.indexOf("{SvyLink}") != -1 && ! isNullOrEmpty(vm.data.SvyUrl))  {
          msg = msg.replace("{SvyLink}",vm.data.SvyUrl);
        }
        // 서식의 설문제목 치환 처리
        if(msg.indexOf("{SvyNm}") != -1 && ! isNullOrEmpty(vm.data.SurveyNm))  {
          msg = msg.replace("{SvyNm}",vm.data.SurveyNm);
        }
        // 서식의 설문기간 치환 처리
        if(msg.indexOf("{SvyDate}") != -1 && ! isNullOrEmpty(vm.data.SurveyDate))  {
          msg = msg.replace("{SvyDate}",vm.data.SurveyDate);
        }
        // 서식의 업체명 치환 처리
        if(msg.indexOf("{ClientNm}") != -1 && ! isNullOrEmpty(vm.data.ClientNm))  {
          msg = msg.replace("{ClientNm}",vm.data.ClientNm);
        }
        // 서식의 수신거부 치환 처리
        if(msg.indexOf("{DenyLink}") != -1 && ! isNullOrEmpty(DENY_URL))  {
          msg = msg.replace("{DenyLink}",DENY_URL);
        }
        // 서식의 로고 치환 처리
        if(msg.indexOf("{LogoSrc}") != -1 && ! isNullOrEmpty(vm.data.LogoSrc))  {
          msg = msg.replace("{LogoSrc}",vm.data.LogoSrc);
        }
        return msg;
      }

      // 설문 대상자 조회
      vm.getTargetList = function (SvyId) {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = vm.srch; // 검색 옵션 설정
        data.SvyId = SvyId;
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SVYTGT_SQL;

        vm.deleteTargetType('SURVEY');

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            vm.SvyTgtListAll = [];
            vm.SvyTgtListRD = [];

            angular.forEach(result.body.docs, function (item) {
              item.tagetType = 'SURVEY';

              // 중복 체크 (전체목록)
              if(isNullOrEmpty(vm.SvyTgtListAll[item.Email])) {
                vm.SvyTgtListAll[item.Email] = item;
              }

              // 발송완료, 거부가 아니면 재발송 대상
              if(item.RespStatus != "R" && item.ResultStatus != "D"){
                if(isNullOrEmpty(vm.data.SvyTgtList[item.Email])) {
                  vm.data.SvyTgtList.push(item);
                  vm.data.SvyTgtList[item.Email] = item; // 중복 체크 (발송목록)
                }
              } else {
                vm.SvyTgtListRD[item.Email] = item;
              }
            });

            vm.resetGrpTotalList("[재발송대상]");
          }

          vm.dataloader = false;
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getTargetList()");
          console.table(error);
        });
      };


      // 설문대상자, 수신인 변경에 따른 발송대상자 초기화
      vm.deleteTargetType = function(_tagetType){
        var delData = [];
        angular.forEach(vm.data.SvyTgtList, function (item) {
          if(item.tagetType == _tagetType){
            delData.push(item);
          }
        });

        angular.forEach(delData, function(item){
          vm.data.SvyTgtList.splice(vm.data.SvyTgtList.indexOf(item), 1);
          delete vm.data.SvyTgtList[item.Email];
        });
      };


      // 수신인 검색
      vm.srchGrpTreeModal = function () {
        var ctrl = 'TreeModalCtrl as modalCtrl';
        var paramData = {};

        var modalInstance = modalFactory.open('md', 'components/modal/campaign/tree-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.data.GrpNm = okData.GrpNm;
          vm.data.GrpId = okData.GrpId;
          getGrpTgtList(okData.GrpId);

        }, function (cancelData) {
          // 취소
        });
      };
      vm.eraseGroup = function () {
        vm.data.GrpNm = '';
        vm.data.GrpId = '';

        vm.deleteTargetType('GROUP');
        vm.resetGrpTotalList("");
      }


      // 발송 대상자에 수신인 추가
      function getGrpTgtList(GrpId) {
        var data = vm.srch;
        data.GrpId = GrpId;
        data.viewSize = 0;
        data.mapCode = LIST_GRPTGT_SQL;

        vm.deleteTargetType('GROUP');
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            var dupCnt = 0;
            var addCnt = 0;
            angular.forEach(result.body.docs, function (item) {
              item.tagetType = 'GROUP';

              // 중복 체크 후 추가
              if(isNullOrEmpty(vm.SvyTgtListAll[item.Email]) && isNullOrEmpty(vm.data.SvyTgtList[item.Email])) {
                item.ResultStatus = "N";
                item.ResultStatusConv = "발송대기";
                vm.data.SvyTgtList.push(item);
                vm.data.SvyTgtList[item.Email] = item; // 발송목록
                addCnt = addCnt + 1;
              } else {
                dupCnt = dupCnt + 1;
              }
            });

            if(dupCnt > 0 || addCnt > 0) gAlert("", "[수신인추가] 중복 : "+ dupCnt +"건 / 추가 : "+ addCnt +"건");
            vm.resetGrpTotalList("");
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getGrpTgtList()");
          console.table(error);
        });
      }


      // 대상자 편집
      function editTargetList() {
        var ctrl = 'surveyTargetEdit2Ctrl as modalCtrl';
        var paramData = {SendType : 'EMAIL', GrpId : vm.data.GrpId, SvyTgtList : angular.copy(vm.data.SvyTgtList)};

        var modalInstance = modalFactory.open('lg', 'components/modal/campaign/survey-target-edit-modal2.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 체크한 대상만 발송 처리
          vm.data.chkTgtList = okData.chkList;
          vm.data.SvyTgtList = angular.copy(okData.list);
          vm.resetGrpTotalList("[발송대상자]");
        }, function (cancelData) {
          // 취소
        });
      }

      // 발송 대상자 변경에 따른 적용
      vm.resetGrpTotalList = function(addType){
        var dupCnt = 0;
        var chkCnt = 0;
        var chkDupCnt = 0;
        var temp = [];
        vm.data.GrpTotalList = [];
        angular.forEach(vm.data.SvyTgtList, function(item){

          item.IsChk = vm.data.chkTgtList[item.SvyTgtId];

          // 중복 체크 (최종 발송목록)
          if(isNullOrEmpty(vm.SvyTgtListRD[item.Email]) && temp.indexOf(item.Email) == -1) {
            vm.data.GrpTotalList.push(item);
            temp.push(item.Email);
            //if(isNullOrEmpty(vm.data.GrpTotalList[item.Email])) {
            //  vm.data.GrpTotalList[item.Email] = item;
            //}
            if(item.IsChk == "Y") chkCnt = chkCnt + 1;
          } else {
            item.ResultStatusConv = "중복";
            dupCnt = dupCnt + 1;
            if(item.IsChk == "Y") chkDupCnt = chkDupCnt + 1;
            vm.data.chkTgtList.splice(vm.data.chkTgtList.indexOf(item), 1);
          }
        });

        // 체크한 대상이 있을 경우 해당 대상자만 발송.
        if(!isNullOrEmpty(vm.data.chkTgtList) && vm.data.chkTgtList.length > 0) {
          vm.data.GrpTotal = vm.data.chkTgtList.length;
          dupCnt = chkDupCnt;
        } else {
          vm.data.GrpTotal = vm.data.GrpTotalList.length;
        }
        if(addType != "" && dupCnt > 0) {
          gAlert("", addType +" 중복 "+ dupCnt +"건 / 최종 "+ vm.data.GrpTotal +"건");
        }
      };


      // 발송시간
      function setHourList() {
        vm.sendHourList = [
          {time:"08"}
          , {time:"09"}
          , {time:"10"}
          , {time:"11"}
          , {time:"12"}
          , {time:"13"}
          , {time:"14"}
          , {time:"15"}
          , {time:"16"}
          , {time:"17"}
          , {time:"18"}
          , {time:"19"}
          , {time:"20"}
        ];
      }

      // 발송 분
      function setTimeList() {
        vm.sendMinList = [];
        for(i = 0; i < 60; i++){
          vm.sendMinList.push({time: (i < 10 ? "0" : "") + i });
        }
      }

      // 업체로고
      function getLogoImg(manager) {
        if (isNullOrEmpty(manager)) {
          return;
        }

        var data = {
          mapCode : "FileAttach.getFileListOri",
          tableNm : "users",
          TableId : manager,
          grpId : "1"
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK && result.body.docs.length > 0) {
            vm.data.LogoSrc = StaticVariable.getUrl('/attach/file/' + result.body.docs[0].PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey);
            //console.error("logo", vm.data.LogoSrc);
          }
        }, function (error) {
          console.error("Error> getLogoImg()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.init = init;
      vm.setFavEmail = setFavEmail;
      vm.changeEmail = changeEmail;
      vm.setData = setData;
      vm.editTargetList = editTargetList;

      init();
    }]);
})();

webapp.controller('SurveyTargetListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
  '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', '$http',
  function SurveyTargetListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, api, modalFactory, $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate, $http) {

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};
    vm.maxGrpId = 0;
    vm.lists = [];
    vm.saveYn = true;
    vm.data = {CustomCode: 0};

    $scope.toggleLeft = buildToggler('left');
    $scope.toggleRight = buildToggler('right');


    // 함수 선언
    //vm.resetSearch = resetSearch;
    vm.resetList = resetList;
    vm.getTreeList = getTreeList;
    vm.delNode = delNode;
    vm.delNodeCancel = delNodeCancel;
    vm.saveData = saveData;
    vm.onChangeGrpNm = onChangeGrpNm;
    //vm.onChangeCode = onChangeCode;
    vm.onChanged = onChanged;
    //vm.ChangeCustomCode = ChangeCustomCode;
    vm.deleteGrpcust = deleteGrpcust;
    vm.addGrpcustAll = addGrpcustAll;

    vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
    vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
    vm.setSortColumn = setSortColumn;           // 정렬 설정
    vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
    vm.doUpload = doUpload;
    vm.excelform = excelform; //엑셀업로드양식 다운
    vm.getExcelFile = getExcelFile; //엑셀 다운



    // --------------------------------------------------------- 그룹고객 관련 소스 ---------------------------------------------------------
    // SQL Mapper Id 정의
    var LIST_CNT_SQL = 'WjmCampaign.getGroupcustomerListCnt'; // 그룹고객 목록 건수 조회 SQL
    var LIST_SQL = 'WjmCampaign.getGroupcustomerList';    // 그룹고객 목록 조회 SQL
    var EXCEL_SQL = 'WjmCampaign.getGroupcustomerExcelList'; // 그룹고객 엑셀다운로드 SQL
    var DELETE_LIST_SQL = 'WjmCampaign.deleteGroupcustomerList'; // 그룹고객 목록에서 삭제
    var DELETEALL_LIST_SQL = 'WjmCampaign.deleteAllGroupcustomerList'; // 그룹고객 목록에서 전체삭제
    var ADDGRPCUSTALL_SQL = 'WjmCampaign.insertAllGroupcustomer'; // 그룹고객 목록에서 고객전체추가
    var COPY_CUST_SQL = 'WjmCampaign.insertGroupcustomerCopy';
    var DUPCHK_SQL = 'WjmCampaign.getDupList';

    // 관련 테이블 정의
    var KEY_TABLE_NM = 'wjm.surveytargetlist'; // 그룹고객 작업 테이블명
    var KEY_COLUMN_NM = 'CustId'; // 그룹고객 Primary Key Column
    var EXCEL_TITLE = '그룹고객목록'; // 그룹고객 엑셀파일 이름
    var EXCEL_FORM_TITLE = '일괄업로드 양식';
    // #endregion 상수 정의

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: 'T.RegDate' // 정렬컬럼명
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
      vm.currentPage = vm.srch.page;
    }

    vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    //vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
    vm.anchor = "";
    //setLayout(vm.layout); // 화면분할 모드 설정

    /**
     * 전체고객 추가
     *
     * @param
     * @return
     */
    function addGrpcustAll() {
      var data;

      data = vm.srch;
      data.GrpId = vm.data.GrpId;

      data.mapCode = ADDGRPCUSTALL_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn : '',
            fn : function() {
              getGrpcustList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> addGrpcustAll()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 삭제
     *
     * @param
     * @return
     */
    function deleteGrpcust(type) {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteGrpcustAction(type);
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteGrpcustAction(type) {
      vm.srch.KeyIdList = [];
      var data;

      if (type == "") {
        for (var i = 0; i < vm.grpcustLists.length; i++) {
          if (vm.grpcustLists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.grpcustLists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }
      }

      data = vm.srch;
      data.GrpId = vm.data.GrpId;

      if (type == "ALL") data.mapCode = DELETEALL_LIST_SQL;
      else data.mapCode = DELETE_LIST_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              getGrpcustList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteGrpcustAction()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 건수 조회
     *
     * @param
     * @return
     */
    function getGrpcustListCnt() {

      var data = vm.srch; // 검색 옵션 설정
      data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

      data.GrpId = vm.data.GrpId;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          if (result.body.docs.length > 0) {
            // 총 목록 건수 설정
            vm.grpcustTotalItems = result.body.docs;
          } else {
            // 조회 실패
            vm.grpcustTotalItems = 0;
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getGrpcustListCnt()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 조회
     *
     * @param
     * @return
     */
    function getGrpcustList() {
      vm.dataloader = true; // Progressbar 표시
      vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

      getGrpcustListCnt(); // 목록 건수 조회

      var data = vm.srch; // 검색 옵션 설정
      data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
      data.mapCode = LIST_SQL;

      data.GrpId = vm.data.GrpId;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          // MetaColumn 사용
          if (result.body.desc.length > 0) {
            // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
            vm.grpcustListColumns = result.body.desc;
            angular.forEach(vm.grpcustListColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          } else {
            console.error('Error> getGrpcustList()> MetaColumn 정보 조회 오류');
            console.table(data);
          }

          if (result.body.docs.length > 0 && !isNullOrEmpty(vm.grpcustListColumns)) {
            // 목록 데이터 표시
            vm.grpcustLists = result.body.docs;
            // 목록 화면 구성
            setResponsive();
          } else {
            // 데이터 조회 실패
            vm.grpcustLists = {};
          }
        }

        vm.dataloader = false; // Progressbar 숨김

      }, function (error) {
        vm.dataloader = false; // Progressbar 숨김

        // 조회 중 오류 발생
        console.error("Error> getGrpcustList()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 목록 비우기
     *
     * @param
     * @return
     */
    function getGrpcustListClear() {
      vm.grpcustLists = null;
      vm.grpcustTotalItems = 0;
    }

    /**
     * 그룹고객 목록 화면 구성
     *
     * @param
     * @return
     */
    function setResponsive() {
      var columns = [];
      var o = {};

      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.grpcustListColumns, function (item) {
        var column = {};

        column.name = item.ColumnPhysicalNm; // 물리 컬럼명
        column.title = item.ColumnLogicalNm; // 논리 컬럼명

        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }

        if (item.ColumnPhysicalDataType == "40") {
          // 날짜형 데이터 처리
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }

        index++;
        columns.push(column);
      });
    }

    /**
     * 그룹고객 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      //var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});

      getGrpcustList();
    }

    /**
     * 그룹고객 목록 당 조회 건수 변경
     * @param
     * @return
     */
    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      //getSearch();
      getGrpcustList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {

      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      //getSearch();
      getGrpcustList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    function setSortDirect(sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    /**
     * 그룹고객 Excel 파일 다운로드
     * @param
     * @return
     */
    function getExcelFile() {

      if (vm.grpcustLists.length == undefined) {
        gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
        return;
      }

      if (vm.grpcustLists.length == 0) {
        gAlert("", "Menu.데이터가 없습니다.");
        return;
      }

      var a = document.createElement("a");
      document.body.appendChild(a);

      var data = vm.srch;
      data.mapCode = EXCEL_SQL;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          $scope.jsonToExport = result.body.docs;
          $scope.fileName = EXCEL_TITLE;
          $scope.exportData = [];

          var obj = [];

          angular.forEach(vm.columnMap, function (item) {
            obj.push(item.ColumnLogicalNm);
          });
          $scope.exportData.push(obj);

          // Data:
          angular.forEach($scope.jsonToExport, function (value) {
            obj = [];
            angular.forEach(vm.columnMap, function (item) {
              obj.push(value[item.ColumnPhysicalNm]);
            });
            $scope.exportData.push(obj);
          });

          $rootScope.excelDown($scope.exportData, $scope.fileName);
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getExcelFile()");
        console.table(error);
      });
    }

    /**
     * 그룹고객추가 팝업 호출
     *
     * @param {string}
     * @return {boolean}
     */
    vm.srchGrpcustModal = function () {
      var ctrl = 'GrpcustModalCtrl as vc';

      var paramData = {keyId: vm.data.GrpId};
      var modalInstance = modalFactory.open('modal', 'components/modal/campaign/grpcust-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        getGrpcustList();
      }, function (cancelData) {
      });
    };

    // --------------------------------------------------------- /그룹고객 관련 소스 ---------------------------------------------------------

    /**
     * SMS발송 팝업 호출
     *
     * @param {string}
     * @return {boolean}
     */
    vm.addSmsModal = function () {
      var ctrl = 'SmsModalCtrl as vc';

      var paramData = {keyId: vm.data.GrpId};
      var modalInstance = modalFactory.open('modal', 'components/modal/campaign/sms-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
      }, function (cancelData) {
      });
    };

    // 회원사 변경 설정
    $scope.$on('broadcastSetChangeTenantID', function (event, data) {
      getTreeList();
      getGrpcustList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수


    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildToggler(navID) {
      var debounceFn = $mdUtil.debounce(function() {
        $mdSidenav(navID).toggle().then(function() {
          console.debug("toggle " + navID + " is done");
        });
      }, 200);
      return debounceFn;
    }

    $scope.init = function() {
      // check if there is query in url
      // and fire search in case its value is not empty
    };

    // stops the interval
    $scope.$on("$destroy", function() {
    });

    $scope.$on('broadcastSetChangeTenantID', function(event, data) {
      resetList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.grpcustLists.length; i++) {
        if (!vm.grpcustLists[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }
      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.grpcustLists.length; i++) {
        vm.grpcustLists[i].chkRow = vm.chkHead;
      }
    };

    /*
    function resetSearch() {
      vm.srch.GrpNm = '';
      vm.data = {CustomCode: 0};
      tree.select_branch(null);
    }
    */

    function resetList() {
      //resetSearch();

      getTreeList();
      getGrpcustListClear();
    }


    vm.nextSearch = function() {
      tree.next_search_text();
    };



    // 일괄 업로드
    function doUpload()  {
      vm.dataloader = true;

      var file = $("input[name=excelFile]")[0].files[0];
      if(file == undefined){
        vm.dataloader = false;
        gAlert('', 'xlsx 형식의 파일을 선택하세요.');
        return;
      }
      var ext = file.name.split('.').pop().toLowerCase();
      if($.inArray(ext, ['xlsx']) == -1){
        vm.dataloader = false;
        gAlert('', 'xlsx 형식의 파일을 선택하세요.');
        return;
      }

      var uploadUrl = "excelUpload/WjmCampaign.updateGroupCustomerExcel/action.json";
      var formData = new FormData();

      formData.append("mFile",file);
      formData.append("ext",ext);
      formData.append("GrpId", vm.data.GrpId);
      formData.append("Manager",vm.data.Manager);
      formData.append("SESSION_USERID", $rootScope.gVariable.UserId);
      formData.append("SESSION_TENANTID", $rootScope.gVariable.TenantId);

      $http({
        url: uploadUrl,
        method: "POST",
        data: formData,
        transformRequest: angular.identity,
        headers: {'Content-type': undefined}
      }).success(function (data, status, headers, config) {
        vm.dataloader = false;
        gAlert('', data.responseVO.body.docs[0].message.replace(/<br>/gi, "\r\n"));
        getGrpcustList();
      }).error(function (data, status, headers, config) {
        vm.dataloader = false;
        gAlert('', '오류가 발생했습니다.');
      });
      vm.dataloader = false;
    }
  /**
     * Excel 업로드 양식 다운로드
     * @param
     * @return
  */
  function excelform () {
    var a = document.createElement("a");
    document.body.appendChild(a);

    $scope.jsonToExport = [];
    $scope.fileName = EXCEL_FORM_TITLE;
    $scope.exportData = [];

    $scope.exportData.push(['이름','휴대폰','이메일'],
      ['나고객','010-1234-5678','test@naver.com']);
    $rootScope.excelDown($scope.exportData,$scope.fileName);

  };

    // my_tree 반드시 선언하기
    var tree;
    $scope.my_tree = tree = {};

    vm.topItem = null;

    /*
    vm.UseYNData = {
      CallbackTarget : '0000',
      CodeType : 'USEYN',
      Code : vm.data.UseYN,
      ReloadSeq : 1
    };
    */

    /*
    vm.onSelectCallback = function(data) {
      if (data.CallbackTarget == '0000') {
        vm.data.UseYN = data.Code;
      }
    };
    */

    getTreeList();

    function getTreeList() {
      // 사전에 트리 선언함.(중요포인트)
      vm.dataloader = true;
      $scope.my_data = [];

      // 로케이션관리 select 검색실행함
      var data = vm.srch;
      data.mapCode = 'WjmCampaign.getGroupList';
      postApi.select(data, function(result) {
        vm.dataloader = false;

        if (result.header.status == CONSTANT.HttpStatus.OK) {

          if (result.body.docs.length == 0) {
            return;
          }

          // select한 datatable 바인딩
          vm.lists = result.body.docs;

          vm.topItem = result.body.docs[0];

          refreshTree();

          // 트리 펼치기
          $timeout(function() {
            return tree.expand_init();
          }, 1);

          console.log('vm.topItem', vm.topItem);
        }
      }, function(error) {
        vm.dataloader = false;
        console.error('fail', status, data);
      });
    }

    // 계층형 json 구조로 변환
    function unflatten(items) {
      // 다시 설정(배치)하는 부분
      return items.reduce(insert, {
        res : [],
        map : {}
      }).res;
    }

    // 계층형 json 부모/자식 구분하여 구조 변환
    function insert(obj, item) {
      var parent = item.parent; // 부모값
      var map = obj.map;
      map[item.guid] = item; // 아이템 구성함

      if (parent === null)
        obj.res.push(item); // 부모값 생성
      else {
        var parentItem = map[parent];
        // 자식값 생성
        if (parentItem != null) {
          if (parentItem.hasOwnProperty("children"))
            parentItem.children.push(item);
          else
            parentItem.children = [ item ];
        }
      }

      return obj;
    }

    // guid, parent 제외한 계층형 json 구조 변환하기
    function traverse(jsonObj) {

      for (var i = 0; i < jsonObj.length; i++) {
        if (jsonObj[i].children == null) {
        } else {
          traverse(jsonObj[i].children);
        }

        // label, children 만 추가함
        var newItem = {
          "label" : jsonObj[i].label,
          "data" : jsonObj[i].guid,
          "children" : jsonObj[i].children,
          "classes" : jsonObj[i].classes,
        }
        jsonObj[i] = newItem;
      }
    }

    // 트리 목록에서 조회값
    $scope.my_tree_handler = function(branch) {
      angular.forEach(vm.lists, function(item) {
        if (branch.data == item.GrpId.toString()) {
          vm.data = item;

          if (vm.data.New != 'Y' && vm.data.GrpId != null) {
            getGrpcustList();
          }
          /*
          vm.UseYNData = {
            CallbackTarget : '0000',
            CodeType : 'USEYN',
            Code : vm.data.UseYN,
            ReloadSeq : (new Date()).getTime()
          };
          */
          return;
        }
      });
    };

    $scope.try_adding_a_branch = function() {

      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
      var grpId = newnum.toString(36);

      var branch = tree.get_selected_branch();
      if (branch == null) {
        var grpInfo = {
          'GrpNm' : '새로운 코드',
          'GrpId' : grpId,
          'ParentGrpId' : 0,
          'GrpLevel' : 1,
          //'UseYN' : 'Y',
          'New' : 'Y',
          //'CodeType' : '',
          'TenantId' : $rootScope.gVariable.srchTenantId,
          //'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1
        };
        vm.lists.push(grpInfo);
      } else {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.GrpId.toString()) {
            var grpInfo = {
              'GrpNm' : '새로운 코드',
              'GrpId' : grpId,
              'ParentGrpId' : branch.data,
              'GrpLevel' : item.GrpLevel + 1,
              //'UseYN' : 'Y',
              'New' : 'Y',
              //'CodeType' : item.CodeType,
              'TenantId' : $rootScope.gVariable.srchTenantId,
              'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1
            };
            vm.lists.push(grpInfo);
            return;
          }
        });

        getGrpcustListClear();
      }

      var code = {};
      if ($rootScope.gVariable.srchTenantId == 0) {
        code = {label: '[*]새로운 코드', data: grpId};
      } else {
        //code = {label: '[*]새로운 코드', data: grpId, classes: ['color-red']};
        code = {label: '[*]새로운 코드', data: grpId};
      }
      var new_branch = tree.add_branch(branch, code);
      tree.select_branch(new_branch);
    };

    function delNode() {
      var grpId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
        $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
        return;
      }

      gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
        btn : '',
        fn : function(){
          if (vm.data.New == 'Y'){
            deleteNodeTree();
          }else {
            vm.data.DelYN = 'Y';
            saveData();
          }
        }
      }, {
        btn : '',
        fn : function(){
        }
      });
    }

    function deleteNodeTree() {
      var grpId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      angular.forEach(vm.lists, function(item) {
        if (branch.data == item.GrpId.toString()) {
          var index = vm.lists.indexOf(item);
          vm.lists.splice(index, 1);

          var parent = tree.select_parent_branch();
          if(parent){
            parent.children.splice(parent.children.indexOf(branch),1);
          } else {
            refreshTree();
          }

          return;
        }
      });

      tree.select_branch(null);
      vm.data = {CustomCode: 0};
    }

    function refreshTree() {

      // 리스트 생성
      var arrlist = [];

      // for문으로 다시 json 구조로 변환함.
      angular.forEach(vm.lists, function(item) {
        // 객체 생성
        var data = {};

        data.label = $translate.instant(item.GrpNm);
        data.guid = item.GrpId;
        data.parent = item.ParentGrpId == undefined || item.ParentGrpId == 0 ? null : item.ParentGrpId;
        data.classes = [];
        //data.classes.push(item.TenantId == '0' ? '' : 'color-red');

        // 리스트에 생성된 객체 삽입
        arrlist.push(data);

        if (item.GrpId > vm.maxGrpId)
          vm.maxGrpId = item.GrpId;
      });

      // 계층형 json 구조로 변환함
      var recursiveArray = unflatten(arrlist);

      // guid, parent 제외 변환함
      traverse(recursiveArray);

      // 트리구조에 바인딩
      $scope.my_data = recursiveArray;

      // 트리 펼치기
//        $timeout(function() {
//          return tree.expand_all();
//        }, 1);

    }

    function onChangeGrpNm() {
      onChanged();
      var branch = tree.get_selected_branch();
      if (branch == null) return;
      branch.label = '[*]' + vm.data.GrpNm;
    }

    /*
    function onChangeCode() {
      onChanged();
      if (vm.data.New == 'Y') {
      }
    }
    */

    function onChanged() {
      if (vm.data.New == null || vm.data.New != 'Y') {
        vm.data.Edit = 'Y';
      }
    }

    function removeNode(jsonObj, grpId) {
      for (var i = 0; i < jsonObj.length; i++) {
        console.log('jsonObj[i]=', jsonObj[i]);
        console.log('GrpId=', grpId);

        if (jsonObj[i].data == grpId) {
          jsonObj[i].children = [];
          return true;
        }

        if (jsonObj[i].children == null) {
        } else {
          if (removeNode(jsonObj[i].children, grpId) == true)
            break;
        }
      }
    }

    function delNodeCancel() {
      var grpId = '';
      var branch = tree.get_selected_branch();
      angular.forEach(vm.lists, function(item) {
        if (branch.data == item.GrpId.toString()) {
          item.DelYN = 'N';
          branch.label = branch.label.replace(/^\[X\]/,"");;
          return;
        }
      });
    }

    function saveData() {
      vm.dataloader = true;
      var data = {lists : []};
      data.mapCode = 'WjmCampaign.insertGroup';

      if (isNullOrEmpty(vm.data.SortSeq)) vm.data.SortSeq = 0;

      data.lists.push(vm.data);
      postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            var branch = tree.get_selected_branch();
            branch.label = branch.label.replace(/^\[\*\]/,"");

            if (vm.data.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.New = '';
            } else if (vm.data.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.Edit = '';
            }
//            getTreeList();
          }
        },

        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

    }

    /**
     * 트리 호출
     *
     * @param
     * @return
     */
    vm.srchTreeModal = function () {
      var ctrl = 'TreeModalCtrl as modalCtrl';
      var paramData = {};

      // 부서 검색 팝업 호출
      var modalInstance = modalFactory.open('md', 'components/modal/campaign/tree-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        // 부서 선택

        if(!isNullOrEmpty(okData.GrpId)) {
          gConfirm('', '선택된 수신인에 추가 하겠습니까?', {
            btn: '',
            fn: function () {
              getIsDup(okData.GrpId);
            }
          }, {
            btn: '',
            fn: function () {
            }
          });

        }
      }, function (cancelData) {
        // 취소
      });
    };

    function getIsDup(GrpId) {
      var data;

      vm.srch.KeyIdList = [];
      for (var i = 0; i < vm.grpcustLists.length; i++) {

        if (vm.grpcustLists[i].chkRow) {
          vm.srch.KeyIdList.push(vm.grpcustLists[i]);
        }
      }
      if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
        gAlert('', '고객을 선택해주세요.');
        return false;
      }

      data = vm.srch;
      data.GrpId = GrpId;
      data.mapCode = DUPCHK_SQL;

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if(result.body.docs.length == 0) {
            updateCustTree(GrpId);
          } else {
            angular.forEach(result.body.docs, function(item) {
              angular.forEach(vm.srch.KeyIdList,function(item2){
                if(item.CustId == item2.KeyId) {
                  vm.srch.KeyIdList.splice(vm.srch.KeyIdList.indexOf(item2),1);
                }
              });
            });
            updateCustTree(GrpId);
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteGrpcustAction()");
        console.table(error);
      });


    }
    function updateCustTree(GrpId) {

      var data;
      data = vm.srch;
      data.GrpId = GrpId;
      data.mapCode = COPY_CUST_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '추가 되었습니다.', {
            btn : '',
            fn : function() {
              getGrpcustList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteGrpcustAction()");
        console.table(error);
      });
    }

      // #region 담당자 검색 팝업 호출

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'WjmUserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/users/wjm-user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.data.ManagerNm = okData.UserNm;
          vm.data.Manager = okData.UserId;
          onChanged();
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.data.ManagerNm = "";
        vm.data.Manager = "";
        onChanged();
      };
      /**
       * 고객추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.GroupCustEditModal = function () {
        var ctrl = 'GroupEditModalCtrl as vc';
        var paramData = {keyId : '', GrpId: vm.data.GrpId, GrpNm : vm.data.GrpNm, Manager: vm.data.Manager};
        var modalInstance = modalFactory.open("md", "components/modal/survey/wjm-group-edit-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            getGrpcustList();

          },
          function (cancelData) {
          }
        );
      }

    vm.alertMsg = function () {
      gAlert('준비중입니다.');
    }
    // 목록 조회
    getGrpcustList();
  } ]);











(function () {
  "use strict";

  webapp.controller('WjmSurveyListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function WjmSurveyListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSurvey.getSurveyListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSurvey.getSurveyList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmSurvey.getSvyExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmSurvey.deleteSurveyList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.survey-list';         // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.survey-list.detail';         // 목록 조회 화면
      var VIEW_PAGE_URL = 'app.survey.survey-detail';         // 조회 화면
      var EDIT_PAGE_URL = 'app.survey.survey-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.survey'; // 작업 테이블명
      var EXCEL_TITLE = '설문 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'SvyStatus, SvyBeginDate DESC'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.SvyBeginDate = $rootScope.getDateFormat(vm.srch.SvyBeginDate);
        vm.SvyEndDate = $rootScope.getDateFormat(vm.srch.SvyEndDate);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        // 등록/수정 화면 이동
        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: '',
          cKeyId: ''
        });
      }

      // 조회 화면
      function goView(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 목록 엑셀 다운로드
      function getExcelFile() {

        if (vm.lists.length == undefined || vm.lists.length == 0) {
          gAlert("", "데이터가 없습니다.");
          return;
        }

        // 체크한 대상만 엑셀로 다운로드
        vm.srch.KeyIdList = [];
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if (item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {

                if (item.ColumnPhysicalNm == 'SvyBeginDate' || item.ColumnPhysicalNm == 'SvyEndDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (vm.lists[i].SvyStatusCd == "1") vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 목록 삭제 확인
      function setDelList() {
        gConfirm('', '해당 설문을 삭제할 경우, 진단 데이터도 모두 삭제됩니다. 삭제하시겠습니까?', {
          btn: '',
          fn: function () {
            setDelListAction();
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 목록 삭제
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          //if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          //}
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }




      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goView = goView;                         // 조회 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();


      setInitData();

    }]);
})();


(function () {
  "use strict";

  webapp.controller('SurveySendResultListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SurveySendResultListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSend.getSendTargetListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSend.getSendTargetList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmSend.getSendTargetList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.survey-send-result-list';         // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.surveytarget'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var EXCEL_TITLE = '개별 발송 결과 목록';
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = "N"; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD HH:mm:ss";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 목록 엑셀 다운로드
      function getExcelFile() {

        if (vm.lists.length == undefined || vm.lists.length == 0) {
          gAlert("", "데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        data.viewSize = 0;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if (item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                  obj.push(value[item.ColumnPhysicalNm]);
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }




      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('SurveySendTotResultListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SurveySendTotResultListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSend.getSendTotResultListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSend.getSendTotResultList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmSend.getSendTotResultList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.survey-send-totresult-list';         // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.sendtotresult'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      var EXCEL_TITLE = '개별 발송 결과 목록';
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom);
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = "N"; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
      * 데이터 조회
      * @param
      * @return
      */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
      * 검색값 초기화
      * @param
      * @return
      */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
      * 목록 건수 조회
      *
      * @param
      * @return
      */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
      * 목록 조회
      *
      * @param
      * @return
      */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

      /**
      * 목록 화면 구성
      *
      * @param
      * @return
      */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD HH:mm:ss";
          }

          index++;
          columns.push(column);
        });
      }

      /**
      * 페이지 변경시 데이터 조회
      * @param
      * @return
      */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
      * 목록 당 조회 건수 변경
      * @param
      * @return
      */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
      * 정렬 컬럼 설정
      *
      * @param {string} sortColumn  - 정렬 컬럼명
      * @param {string} isSortable - 정렬가능 여부
      * @return
      */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
      * 정렬 컬럼 설정에 따른 Grid header Icon 표시
      *
      * @param {string} sortColumn  - 정렬 컬럼명
      * @return
      */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 목록 엑셀 다운로드
      function getExcelFile() {

        if (vm.lists.length == undefined || vm.lists.length == 0) {
          gAlert("", "데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        data.viewSize = 0;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if (item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                obj.push(value[item.ColumnPhysicalNm]);
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      // 설문 검색 팝업
      vm.srchSurveyModal = function () {
        var ctrl = 'WjmSurveyModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };
        var modalInstance = modalFactory.open('md', 'components/modal/survey/wjm-survey-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.SvyNm = res.SvyNm;
          vm.srch.SvyId = res.SvyId;
        }, function(cancelData) {
        });
      };
      vm.eraseSurvey = function () {
        vm.srch.SvyId = '';
        vm.srch.SvyNm = '';
      };

      // 조회 화면
      function goView(row) {
        var ctrl = 'WjmSendTotResultModalCtrl as vc';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId, sendInfo : row };
        var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-send-totresult-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
        }, function(cancelData) {
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.goView = goView;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();
  }]);
})();


(function () {
  "use strict";
  webapp.controller('SurveySmsSendCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout','$filter', 'CommoncodeAPISrv',

    function SurveySmsSendCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'WjmSend.insertSurvyCampaign';     // 등록 SQL
      var LIST_SVYTGT_SQL = 'WjmSend.getSurveyTargetList';
      var LIST_GRPTGT_SQL = 'WjmSend.getGrpCustList';
      //var LIST_FAVTELNO_SQL = 'WjmSend.getFavoriteDropList';
      var LIST_FAVTELNO_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';
      var INSERT_FAVTELNO_SQL = 'WjmSend.insertFavorite';
      var CD_LIST_SQL = 'CommonCode.getCommonCodeList'; // 공통코드 조회 SQL

      // 관련 화면 정의
      var VIEW_PAGE_URL = 'app.survey.sms-send';

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의
      var SVY_URL = CONSTANT.URL.SITE_URL_FRM_MIN + '/survey/';
      var DOWN_URL = CONSTANT.URL.SITE_URL + '/openapi/{RptTgtId}/getFile.json';

      // View Model
      var vm = this;          // View Model

      vm.formType = 'SMS';
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.Contents = "0";
      vm.SurveyUrl = "";
      vm.sendFee = {SMS : 10, MMS : 28, MMS_IMG : 80};

      vm.isRpt = false;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: "SMS"
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        vm.srch.formType = "SMS";
        vm.srch.tableNm = KEY_TABLE_NM;
      }

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.favTelNoList = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM,                               // 작업 테이블명
        SendType :'SMS',
        chkTgtList : [], // 체크한 발송 대상자
        SvyTgtList : [], // 설문 재발송 대상자 (응답완료, 거부 제외)
        GrpTotalList : [], // 최종 발송 대상자
        GrpTotal : 0,
        Amt : 0
      };

      vm.SvyTgtListAll = []; //설문에 매핑된 전체 대상자 (중복 체크용)
      vm.SvyTgtListRD = []; //설문에 매핑된 재발송 제외 대상자 (중복 체크용)

      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          $timeout(setData, 1);
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback


      // 초기값
      function init() {

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vault', vm.onFileCallback, false, 'jpg', 1);

        setTimeList();
        setHourList();

        getFavTelno();
        getCodeList();

        vm.data.Amt = 0;
        vm.data.SendDtType = '100';
        vm.data.FormType = vm.formType;
        vm.data.TenantId = $rootScope.gVariable.srchTenantId;
        vm.data.TenantNm = $rootScope.gVariable.srchTenantName;

        // 개인보고서 문자 발송
        if (!isNullOrEmpty(vm.srch.rptId)) {

          vm.isRpt = true;

          // 개인보고서 상세에서 체크한 대상만 발송함.
          // 외부 업로드의 경우 설문ID가 없음
          vm.data.SurveyId = vm.srch.svyId;
          vm.data.SurveyNm = vm.srch.svyNm;
          vm.data.RptId = vm.srch.rptId;
          vm.data.GrpTotal = vm.srch.rptTgtList.length;
          vm.data.GrpTotalList = vm.srch.rptTgtList;
          vm.data.SendMessage = DOWN_URL;
        }
        // 설문조회 메뉴에서 넘어온 설문으로 변경
        else if (!isNullOrEmpty(vm.srch.svyId)) {
          vm.data.SurveyId = vm.srch.svyId;
          vm.data.SurveyNm = vm.srch.svyNm;
          vm.SurveyUrl = SVY_URL + vm.data.SurveyId + "/{SvyTgtId}";
          vm.data.SendMessage = vm.SurveyUrl;
          vm.getTargetList(vm.srch.svyId);
        }
      }

      // 파일 업로드
      function uploadFile() {
        if (getIsValidData() == false) {
          return;
        }

        var dt = moment.utc(vm.data.SendDate, 'YYYY-MM-DD HH:mm').local().format('YYYY년 MM월 DD일 HH시 mm분에');
        var msg = (vm.data.SendDtType == "200" ? dt + "<br/>예약" : "");
        gConfirm('', msg +' 발송하시겠습니까?', {
          btn: '',
          fn: function () {
            if (vm.vault != null && vm.vault.data.getLength() > 0) {
              // 첨부파일 존재시 파일 업로드 후 저장
              uploadVaultFile(vm.vault);
            } else {
              // 데이터 저장
              setData();
            }
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 유효성 체크
      function getIsValidData() {
        // #region 필수항목 체크
        var sendDate = '';
        var errMsg = '';

        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        }

        // 발송유형(즉시-DIRECT/예약-RESERVE/반복-REPEAT)
        vm.data.CampaignSendType = vm.data.SendDtType == '100' ? 'DIRECT' : 'RESERVE';
        vm.data.CmpgnChannel = vm.data.SendType; //'SMS';

        if(isNullOrEmpty(vm.data.GrpTotal) || vm.data.GrpTotal <= 0) {
          errMsg = errMsg + '- 대상자를 선택하세요.<br/>';
        }
        if(isNullOrEmpty(vm.data.SendType)) {
          errMsg = errMsg + '- 발송 유형을 선택하세요.<br/>';
        }
        if(isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 회신번호를 입력하세요.<br/>';
        }

        if(vm.data.SendDtType == '200'){
          if(isNullOrEmpty(vm.data.SendDt) || isNullOrEmpty(vm.data.SendHour) || isNullOrEmpty(vm.data.SendMin)) {
            // 미입력 및 잘못된 날짜 유형
            errMsg = errMsg + '- 발송일시를 바르게 입력하세요.<br/>';
          } else {
            sendDate =  vm.data.SendDt+" "+vm.data.SendHour+":"+vm.data.SendMin+":00";
            var tday = moment(new Date()).format('YYYY-MM-DD HH:mm');
            var sday = moment(new Date(sendDate)).format('YYYY-MM-DD HH:mm');
            if(sday <= tday) {
              errMsg = errMsg + '- 발송일시를 현재 이후로 입력하세요.<br/>';
            } else {
              vm.data.SendDate = new Date(sendDate).toISOString().substr( 0, 19 ).replace("T"," ");
            }
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }


      // 첨부파일 목록 조회
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      // 발송
      function setData() {
        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

        var data = vm.data; // 사용자 입력 데이터
        if(!data.SurveyNm){
          data.SurveyNm = 'SMS 발송 ';
        }

        //console.log(vm.data);
        // 신규 등록 (WJMRPT 개인보고서발송 / WJRMCHK 체크대상발송 / WJM 그외발송)
        data.SiteId = (vm.isRpt ? "WJMRPT" : (! isNullOrEmpty(vm.data.chkTgtList) ? "WJMCHK" : "WJM"));
        data.mapCode = INSERT_SQL;
        console.log(data);

        postApi.insert(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      }

      // 데이터 저장 후 처리
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert("", "발송했습니다.", {
            btn: "",
            fn: function () {
              var srch = $stateParams.srch;
              $state.go(VIEW_PAGE_URL, {
                srch: srch,
                formType: vm.formType,
                keyId: ''
              }, {reload:VIEW_PAGE_URL});
            }
          });
          return;
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      // 발송내용 바이트 체크
      function chkSendMessage () {
        if(isNullOrEmpty(vm.bytesCheck) || vm.bytesCheck == 'Null') {
          gAlert('발송유형을 선택하세요.');
          return false;
        }

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          var msg = "";
          var bytes = 0;

          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > vm.bytesCheck) {
            if(vm.data.SendType == 'SMS'){
              gAlert('', 'SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
              vm.data.SendType = 'MMS';
            }else{
              vm.data.SendMessage = fnCutMsg(msg, vm.bytesCheck);
              bytes = vm.bytesCheck;
            }
          }

          vm.Contents = bytes;
        }
      }

      // 발송내용 자르기
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }


      // 자주쓰는번호 관리
      vm.srchFavoriyModal = function () {
        var ctrl = 'FavoriyModalCtrl as modalCtrl';
        var paramData = { SaveType : 'N' };

        var modalInstance = modalFactory.open('md', 'components/modal/campaign/favori-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          getFavTelno();
        }, function(cancelData) {
          getFavTelno();
        });
      }

      // 자주쓰는번호 등록
      function setFavTelNo() {
        // 내용
        var data = vm.data; // 사용자 입력 데이터

        vm.favTelnoList.unshift({CodeValue:vm.data.FromInfo, Code:vm.data.FromInfo});
        // 신규 등록
        data.mapCode = INSERT_FAVTELNO_SQL;
        data.SaveType = 'N';

        postApi.insert(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setFavTelNo()");
          console.table(error);
        });
      }

      // 자주쓰는번호 조회
      function getFavTelno() {

        var data = vm.srchDetail;
        data.mapCode = LIST_FAVTELNO_SQL;
        data.SaveType = 'N';
        data.SiteId = 'WJM';

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공

            if (result.body.docs.length > 0) {
//              result.body.docs.push({CodeValue: '직접입력', Code: 'setValue'});
              vm.favTelnoList = result.body.docs;
            } else {
//              vm.favTelnoList = [{CodeValue: '직접입력', Code: 'setValue'}];
            }
          } else {

            console.error("Error> getFavTelno()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getFavTelno()");
          console.table(error);
        });
      }

      // 자주쓰는번호 등록을 위해 선택된 회신번호 설정
      function changeTelno() {
        if(vm.data.Favorite != "setValue") {
          vm.data.FromInfo = vm.data.Favorite;
        } else {
          vm.data.FromInfo = "";
        }
      }


      // 설문 검색
      vm.srchSurveyModal = function () {
        var ctrl = 'WjmSurveyModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/survey/wjm-survey-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.data.SurveyNm = res.SvyNm;
          vm.data.SurveyId = res.SvyId;
          vm.data.SurveyDate = res.SvyDate;
          vm.data.ClientNm = res.ManagerNm;
          vm.data.SendMessage = '';
          vm.SurveyUrl = SVY_URL + vm.data.SurveyId + "/{SvyTgtId}";

          if(isNullOrEmpty(vm.data.SendMessage)) {
            vm.data.SendMessage = vm.SurveyUrl;
          } else {
            // 설문링크 치환 처리
            if(vm.data.SendMessage.indexOf("{SvyLink}") != -1 )  {
              vm.data.SendMessage = vm.data.SendMessage.replace("{SvyLink}",vm.SurveyUrl);
            }
            // 설문제목 치환 처리
            if(vm.data.SendMessage.indexOf("{SvyNm}") != -1 && ! isNullOrEmpty(vm.data.SurveyNm))  {
              vm.data.SendMessage = vm.data.SendMessage.replace("{SvyNm}",vm.data.SurveyNm);
            }
            // 설문기간 치환 처리
            if(vm.data.SendMessage.indexOf("{SvyDate}") != -1 && ! isNullOrEmpty(vm.data.SurveyDate))  {
              vm.data.SendMessage = vm.data.SendMessage.replace("{SvyDate}",vm.data.SurveyDate);
            }
            // 업체명 치환 처리
            if(vm.data.SendMessage.indexOf("{ClientNm}") != -1 && ! isNullOrEmpty(vm.data.ClientNm))  {
              vm.data.SendMessage = vm.data.SendMessage.replace("{ClientNm}",vm.data.ClientNm);
            }
          }

          chkSendMessage();

          //선택설문에 대한 대상자 목록 조회해야함.
          vm.getTargetList(res.SvyId);
        }, function(cancelData) {
          //ignore
        });
      };
      vm.eraseSurvey = function () {
        vm.data.SurveyId = '';
        vm.data.SurveyNm = '';
        vm.data.SvyUrl = '';
        vm.data.SendMessage = '';

        vm.deleteTargetType('SURVEY');
        vm.resetGrpTotalList("");
      };


      // 설문 대상자 조회
      vm.getTargetList = function (SvyId) {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = vm.srch; // 검색 옵션 설정
        data.SvyId = SvyId;
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SVYTGT_SQL;

        vm.deleteTargetType('SURVEY');

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            vm.SvyTgtListAll = [];
            vm.SvyTgtListRD = [];

            angular.forEach(result.body.docs, function (item) {
              if( ! isNullOrEmpty(item.Mobile))
              {
                // 엑셀에서 0이 탈락하는 경우에 대한 처리 (그대로 진행할 경우 중복체크시 휴대폰 번호를 배열의 인덱스로 인식하는 오류가 있음)
                item.Mobile = item.Mobile.trim();
                if(item.Mobile.substr(0,1) != "0") item.Mobile = "0" + item.Mobile;

                item.tagetType = 'SURVEY';

                // 중복 체크 (전체목록)
                if(isNullOrEmpty(vm.SvyTgtListAll[item.Mobile])) {
                  vm.SvyTgtListAll[item.Mobile] = item;
                }

                // 발송완료, 거부가 아니면 재발송 대상
                if(item.RespStatus != "R" && item.ResultStatus != "D"){
                  if(isNullOrEmpty(vm.data.SvyTgtList[item.Mobile])) {
                    vm.data.SvyTgtList.push(item);
                    vm.data.SvyTgtList[item.Mobile] = item; // 중복 체크 (발송목록)
                  }
                } else {
                  vm.SvyTgtListRD[item.Mobile] = item;
                }
              }
            });

            vm.resetGrpTotalList("[재발송대상]");
          }

          vm.dataloader = false;
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getTargetList()");
          console.table(error);
        });
      }

      // 설문대상자, 수신인 변경에 따른 발송대상자 초기화
      vm.deleteTargetType = function(_tagetType){
        var delData = [];
        angular.forEach(vm.data.SvyTgtList, function (item) {
          if(item.tagetType == _tagetType){
            delData.push(item);
          }
        });

        angular.forEach(delData, function(item){
          vm.data.SvyTgtList.splice(vm.data.SvyTgtList.indexOf(item), 1);
          delete vm.data.SvyTgtList[item.Mobile];
        });
      }


    // 수신인 검색
    vm.srchGrpTreeModal = function () {
      var ctrl = 'TreeModalCtrl as modalCtrl';
      var paramData = {};

      var modalInstance = modalFactory.open('md', 'components/modal/campaign/tree-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        vm.data.GrpNm = okData.GrpNm;
        vm.data.GrpId = okData.GrpId;
        getGrpTgtList(okData.GrpId);

      }, function (cancelData) {
        // 취소
      });
    };
    vm.eraseGroup = function () {
      vm.data.GrpNm = '';
      vm.data.GrpId = '';

      vm.deleteTargetType('GROUP');
      vm.resetGrpTotalList("");
    };

    // 발송 대상자에 수신인 추가
    function getGrpTgtList(GrpId) {
      var data = vm.srch;
      data.GrpId = GrpId;
      data.viewSize = 0;
      data.mapCode = LIST_GRPTGT_SQL;

      vm.deleteTargetType('GROUP');
      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          var dupCnt = 0;
          var addCnt = 0;
          angular.forEach(result.body.docs, function (item) {
            if( ! isNullOrEmpty(item.Mobile))
            {
              // 엑셀에서 0이 탈락하는 경우에 대한 처리 (그대로 진행할 경우 중복체크시 휴대폰 번호를 배열의 인덱스로 인식하는 오류가 있음)
              item.Mobile = item.Mobile.trim();
              if(item.Mobile.substr(0,1) != "0") item.Mobile = "0" + item.Mobile;

              item.tagetType = 'GROUP';

              // 중복 체크 후 추가
              if(isNullOrEmpty(vm.SvyTgtListAll[item.Mobile]) && isNullOrEmpty(vm.data.SvyTgtList[item.Mobile])) {
                item.ResultStatus = "N";
                item.ResultStatusConv = "발송대기";
                vm.data.SvyTgtList.push(item);
                vm.data.SvyTgtList[item.Mobile] = item; // 발송목록
                addCnt = addCnt + 1;
              } else {
                dupCnt = dupCnt + 1;
              }
            }
          });

          if(dupCnt > 0 || addCnt > 0) gAlert("", "[수신인추가] 중복 : "+ dupCnt +"건 / 추가 : "+ addCnt +"건");
          vm.resetGrpTotalList("");
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getGrpTgtList()");
        console.table(error);
      });
    }


    // 대상자 편집
    function editTargetList() {
      var ctrl = 'surveyTargetEdit2Ctrl as modalCtrl';
      var paramData = {SendType : 'SMS', GrpId : vm.data.GrpId, SvyTgtList : angular.copy(vm.data.SvyTgtList)};

      var modalInstance = modalFactory.open('lg', 'components/modal/campaign/survey-target-edit-modal2.html', ctrl, paramData);
      modalInstance.result.then(function (okData) {
        // 체크한 대상만 발송 처리
        vm.data.chkTgtList = okData.chkList;
        vm.data.SvyTgtList = angular.copy(okData.list);
        vm.resetGrpTotalList("[발송대상자]");
      }, function (cancelData) {
        // 취소
      });
    }

    // 발송 대상자 변경에 따른 적용
    vm.resetGrpTotalList = function(addType){
      var dupCnt = 0;
      var chkCnt = 0;
      var chkDupCnt = 0;
      var temp = [];
      vm.data.GrpTotalList = [];
      angular.forEach(vm.data.SvyTgtList, function(item){

        item.IsChk = vm.data.chkTgtList[item.SvyTgtId];

        // 중복 체크 (최종 발송목록)
        if(isNullOrEmpty(vm.SvyTgtListRD[item.Mobile]) && temp.indexOf(item.Mobile) == -1) {
          vm.data.GrpTotalList.push(item);
          temp.push(item.Mobile);
          // if(isNullOrEmpty(vm.data.GrpTotalList[item.Mobile])) {
          //   vm.data.GrpTotalList[item.Mobile] = item;
          // }
          if(item.IsChk == "Y") chkCnt = chkCnt + 1;
        } else {
          item.ResultStatusConv = "중복";
          dupCnt = dupCnt + 1;
          if(item.IsChk == "Y") chkDupCnt = chkDupCnt + 1;
          vm.data.chkTgtList.splice(vm.data.chkTgtList.indexOf(item), 1);
        }
      });

      // 체크한 대상이 있을 경우 해당 대상자만 발송.
      if(!isNullOrEmpty(vm.data.chkTgtList) && vm.data.chkTgtList.length > 0) {
        vm.data.GrpTotal = vm.data.chkTgtList.length;
        dupCnt = chkDupCnt;
      } else {
        vm.data.GrpTotal = vm.data.GrpTotalList.length;
      }
      if(addType != "" && dupCnt > 0) {
        gAlert("", addType +" 중복 "+ dupCnt +"건 / 최종 "+ vm.data.GrpTotal +"건");
      }
      vm.data.Amt = vm.data.GrpTotal * vm.sendFee[vm.data.SendType];
    };


    // 발송시간 코드
    function setHourList() {
      vm.sendHourList = [
        {time:"08"}
        , {time:"09"}
        , {time:"10"}
        , {time:"11"}
        , {time:"12"}
        , {time:"13"}
        , {time:"14"}
        , {time:"15"}
        , {time:"16"}
        , {time:"17"}
        , {time:"18"}
        , {time:"19"}
        , {time:"20"}
      ];
    }

    // 발송분 코드 목록
    function setTimeList() {
      vm.sendMinList = [];
      for(i = 0; i < 60; i++){
        vm.sendMinList.push({time: (i < 10 ? "0" : "") + i });
      }
    }

    // 발송유형 변경
    function changeSendType (type) {

      if(!isNullOrEmpty(vm.data.GrpTotal) && type != 'Null') {
        vm.data.Amt = vm.data.GrpTotal * vm.sendFee[type];
      }

      if(type == 'Null') {
        vm.bytesCheck = 'Null';
        return 0;
      }

      if(type == 'SMS') {
        vm.bytesCheck ='90';
        chkSendMessage();
        return vm.bytesCheck;
      }

      if(type =='MMS' || type == 'MMS_IMG') {
        vm.bytesCheck = '2000';
        chkSendMessage();
        return vm.bytesCheck;
      }
    }

    // 발송유형 코드 조회
    function getCodeList() {
      var data = {CodeType : 'SMSSENDTYPE', mapCode : CD_LIST_SQL};
      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.sendTypeList = result.body.docs;
        }
      });
    }

    // 함수 정의
    vm.init = init;
    vm.getUploadFileList = getUploadFileList;
    vm.setFavTelNo = setFavTelNo;
    vm.changeTelno = changeTelno;
    vm.changeSendType = changeSendType;
    vm.setData = setData;
    vm.uploadFile = uploadFile;
    vm.chkSendMessage = chkSendMessage;
    vm.editTargetList = editTargetList;

    init();

  }]);

})();

webapp.controller('SurveyTypeEditCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
  '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', '$filter',
  function SurveyTypeEditCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, api, modalFactory, $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate, $filter) {


    // SQL Mapper Id 정의
    var INSERT_SQL = 'WjmSurvey.insertSurveyType';     // 등록 SQL
    var UPDATE_SQL = 'WjmSurvey.updateSurveyType';     // 수정 SQL
    var VIEW_SQL = 'WjmSurvey.getSurveyTypeDetail'; // 조회 SQL
    var DEL_SQL = 'WjmSurvey.deleteSurveyTypeDetailBatch';  // 삭제 SQL
    var DUPCHK_SQL = 'WjmSurvey.checkSurveyTypeCd';         // 설문유형코드중복 SQL

    var TREE_VIEW_SQL = 'WjmSurvey.getQstSecList'; // 트리조회 SQL
    var TREE_SAVE_SQL = 'WjmSurvey.saveQstSecBatch';  // 트리 등록/수정/삭제 SQL

    // 관련 화면 정의
    var LIST_PAGE_URL = 'app.survey.survey-type-list';             // 목록 화면
    var LIST_EDIT_PAGE_URL = 'app.survey.survey-type-list.edit'; // 목록 수정 화면
    var EDIT_PAGE_URL = 'app.survey.survey-type-edit';           // 수정 화면

    // 관련 테이블 정의
    var VIEW_TABLE_NM = 'wjm.surveytype'; // 조회용 테이블명
    var EDIT_TABLE_NM = 'wjmsurveytype'; // 저장용 테이블명
    var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};
    vm.treelist = [];
    vm.treedata = {};
    vm.addBtnShow = true;
    vm.data = {};

    // my_tree 반드시 선언하기
    var tree;
    $scope.my_tree = tree = {};

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
        keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
        tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : VIEW_TABLE_NM, // 작업 테이블명
        srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.keyId = $stateParams.keyId;
    }

    vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

    // Key Data 설정
    if (!isNullOrEmpty($stateParams.keyId)) {
      vm.srch.keyId = $stateParams.keyId;
    }

    // 조회 데이터 설정
    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
    vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

    // 등록/수정 표시용 컬럼 목록
    vm.srchDetail.editColumns = {};

    // 조회 데이터
    vm.data = {
      KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
      tableNm: VIEW_TABLE_NM
    };

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true; // Progressbar 표시

      if (isNullOrEmpty(vm.srch.keyId)) {
        vm.dataloader = false;  // Progressbar 숨김
      }
      vm.srchDetail.viewColumns = {}; // 조회 컬럼

      var data = vm.srchDetail;
      data.mapCode = VIEW_SQL;

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          vm.dataloader = false; // Progressbar 숨김

          if (result.body.desc.length > 0) {
            // 사용자정의 컬럼 설정
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            vm.data = result.body.docs[0];
            vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
            vm.tmpSvyTypeCd = vm.data.SvyTypeCd;

          } else {
            console.log('nodata');
            vm.data.TenantId = $rootScope.gVariable.srchTenantId;
            vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
          }
        } else {
          vm.dataloader = false; // Progressbar 숨김

          console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }

      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    }



    /**
     * 등록/수정 화면에 표시할 컬럼인지 여부 확인
     *
     * @param {string} columnNm - 물리 컬럼명
     * @return {boolean} true - 존재시, false - 미 존재시
     */
    function getIsShowColumn(columnNm) {
      var result = false;
      var itemIndex = vm.srch.editColumns.indexOf(columnNm);

      result = (itemIndex > -1);
      return result;
    }


    // 설문유형코드 중복 체크
    function getIsDupSvyTypeCd() {
      var data = vm.data;
        data.mapCode = DUPCHK_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            vm.dupSvyTypeCd = result.body.docs.length;
          } else {
            gAlert('', result.body.docs[0].errMessage);
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
    }

    /**
     * 필수항목 체크
     * @param
     * @return
     */
    function getIsValidData() {
      // #region 필수항목 체크
      var errMsg = '';
      if (isNullOrEmpty(vm.data.SvyTypeNm)) {
        errMsg = errMsg + '- 설문유형명을 입력하세요.<br/>';
      }
      if (isNullOrEmpty(vm.data.SvyTypeCd) || vm.data.SvyTypeCd.length != 4) {
        errMsg = errMsg + '- 4자리 설문유형코드를 입력하세요.<br/>';
      }
      if (!isNullOrEmpty(vm.data.SvyTypeCd) && vm.data.SvyTypeCd != vm.tmpSvyTypeCd) {
        if (vm.dupSvyTypeCd > 0) {
          errMsg = errMsg + '- 중복된 설문유형코드가 존재합니다.<br/>';
        }
      }
      if (isNullOrEmpty(vm.data.ScoringType)) {
        errMsg = errMsg + '- 평가유형을 선택하세요.<br/>';
      }
      if (vm.data.ScoringType != 'N' && isNullOrEmpty(vm.data.TotType)) {
        errMsg = errMsg + '- 기준총점유형을 선택하세요.<br/>';
      }
      if (isNullOrEmpty(vm.data.UseYN)) {
        errMsg = errMsg + '- 사용여부를 선택하세요.<br/>';
      }
      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      return true;
      // #endregion 필수항목 체크
    }



    /**
     * 데이터 저장
     *
     * @param
     * @return
     */
    function setData() {

      if (getIsValidData() == false) {
        return;
      }

      // 내용
      vm.data.tableNm = EDIT_TABLE_NM;             // 작업 테이블명
      vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
      vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

      var data = vm.data; // 사용자 입력 데이터

      if (isNullOrEmpty(vm.data.keyId)) {
        // 신규 등록
        data.mapCode = INSERT_SQL;

        postApi.insert(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      } else {
        // 수정
        data.RelateDataId = data.keyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }
    }

    /**
     * 데이터 저장 후 처리
     *
     * @param result - 저장 결과
     * @return
     */
    function setInsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].KeyId !== null ||
          result.body.docs[0].NewKeyId !== null ||
          result.body.docs[0].RelateDataId !== null
        ) {
          // KeyId 조회
          if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
            vm.data.KeyId = result.body.docs[0].NewKeyId;
          } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
            vm.data.KeyId = result.body.docs[0].KeyId;
          } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
            vm.data.KeyId = result.body.docs[0].RelateDataId;
          }

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function () {
              // 화면 분할 모드에 따른 이동
              goNextPage(true);
            }
          });
          return;
        }
      }

      console.error("Error> setInsertUpdateDetail()");
      gAlert('', result.body.docs[0].errMessage);
    }

    /**
     * 목록 화면 이동
     *
     * @param
     * @return
     */
    function goList() {
      vm.srch.keyId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, {srch: srch});
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch;

      if (vm.layout == 'N') {
        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: vm.data.KeyId
        }, {reload:EDIT_PAGE_URL});
      } else {
        if (reloadList) {
          var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
          srch2.keyId = '';
          srch2.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(srch2, replacer));
        }

        // 조회 화면 이동
        $state.go(LIST_EDIT_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
      }
    }




    /**
     * 데이터 삭제 확인
     *
     * @param
     * @return
     */
    function setDelData() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn: '',
        fn: function () {
          // 데이터 삭제
          setDelDataAction();
        }
      }, {
        btn: '',
        fn: function () {
          // 취소
        }
      });
    }

    /**
     * 데이터 삭제
     *
     * @param
     * @return
     */
    function setDelDataAction() {
      if (vm.data == null) {
        // 삭제할 데이터 미 존재
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      vm.data.tableNm = EDIT_TABLE_NM;

      var data = vm.data;
      data.mapCode = DEL_SQL;
      postApi.update(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn: '',
            fn: function () {
              // 삭제 성공
              var srch = $stateParams.srch;

              // 목록 화면 이동
              $state.go(LIST_PAGE_URL, {
                  srch: srch
                },
                {reload: LIST_PAGE_URL});
            }
          });

        }
      }, function (error) {
        // 삭제 중 오류 발생
        console.error("Error> delDataAction()");
        console.table(error);
      });
    }



    // 트리 초기화
    function resetList() {
      vm.treedata = {};
      getTreeList();
    }

    // 계층형 json 구조로 변환
    function unflatten(items) {
      // 다시 설정(배치)하는 부분
      return items.reduce(insert, {
        res : [],
        map : {}
      }).res;
    }

    // guid, parent 제외한 계층형 json 구조 변환하기
    function traverse(jsonObj) {

      for (var i = 0; i < jsonObj.length; i++) {
        if (jsonObj[i].children == null) {
        } else {
          traverse(jsonObj[i].children);
        }

        // label, children 만 추가함
        var newItem = {
          "label" : jsonObj[i].label,
          "data" : jsonObj[i].guid,
          "children" : jsonObj[i].children,
          "classes" : jsonObj[i].classes,
        };
        jsonObj[i] = newItem;
      }
    }

    // 트리 새로고침
    function refreshTree() {

      // 리스트 생성
      var arrlist = [];

      // for문으로 다시 json 구조로 변환함.
      angular.forEach(vm.treelist, function(item) {
        // 객체 생성
        var data = {};

        data.label = $translate.instant(item.QstSecNm);
        data.guid = item.QstSecId;
        data.parent = item.ParentQstSecId == undefined || item.ParentQstSecId == 0 ? null : item.ParentQstSecId;
        data.classes = [];

        // 리스트에 생성된 객체 삽입
        arrlist.push(data);
      });

      // 계층형 json 구조로 변환함
      var recursiveArray = unflatten(arrlist);

      // guid, parent 제외 변환함
      traverse(recursiveArray);

      // 트리구조에 바인딩
      $scope.my_data = recursiveArray;
    }

    // 트리 조회
    function getTreeList() {
      // 사전에 트리 선언함.(중요포인트)
      vm.dataloader = true;
      $scope.my_data = [];

      // 로케이션관리 select 검색실행함
      var data = vm.srch;
      data.SvyTypeId = vm.srch.keyId;
      data.mapCode = TREE_VIEW_SQL;
      postApi.select(data, function(result) {
        vm.dataloader = false;

        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length == 0) {
            return;
          }

          // select한 datatable 바인딩
          vm.treelist = result.body.docs;

          // 상위 문항영역 5개 이하만 생성 가능 (테이블 연계되어 있음)
          vm.addBtnShow = $filter('filter')(vm.treelist, {QstSecLevel: 1}, true).length < 5;


          refreshTree();
        }
      }, function(error) {
        vm.dataloader = false;
        console.error('fail', status, data);
      });
    }

    // 트리 목록에서 선택
    $scope.my_tree_handler = function(branch) {
      angular.forEach(vm.treelist, function(item) {
        if (branch.data == item.QstSecId.toString()) {
          vm.treedata = item;
          return;
        }
      });
    };

    // 추가
    $scope.try_adding_a_branch = function() {

      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
      var qstSecId = newnum.toString(36);
      var branch = tree.get_selected_branch();

      // 추가> 초기화> 추가시 값 비우기
      if(branch != null && branch.isNew) branch = null;

      if (branch == null) {
        var qstSecInfo = {
          'QstSecNm' : '',
          'QstSecId' : qstSecId,
          'ParentQstSecId' : 0,
          'SvyTypeId' : vm.srch.keyId,
          'QstSecLevel' : 1,
          'ScoringType' : vm.data.ScoringType,
          'New' : 'Y',
          'TenantId' : $rootScope.gVariable.srchTenantId,
          'QstSecNum' : $filter('filter')(vm.treelist, {QstSecLevel: 1}, true).length + 1
        };
        vm.treelist.push(qstSecInfo);
      } else {
        angular.forEach(vm.treelist, function(item) {
          if (branch.data == item.QstSecId.toString()) {
            var qstSecInfo = {
              'QstSecNm' : '',
              'QstSecId' : qstSecId,
              'ParentQstSecId' : branch.data,
              'SvyTypeId' : vm.srch.keyId,
              'QstSecLevel' : item.QstSecLevel + 1,
              'ScoringType' : '',
              'New' : 'Y',
              'TenantId' : $rootScope.gVariable.srchTenantId
            };
            vm.treelist.push(qstSecInfo);
            return;
          }
        });
      }

      var code = {};
      code = {label: '문항영역 정보를 입력하세요.', data: qstSecId, isNew : true};

      var new_branch = tree.add_branch(branch, code);
      tree.select_branch(new_branch);
    };

    // 삭제
    function delNode() {
      var qstSecId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
        $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
        return;
      }

      gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
        btn : '',
        fn : function(){
          if (vm.treedata.New == 'Y'){
            deleteNodeTree();
          }else {
            vm.treedata.DelYN = 'Y';
            saveData();
          }
        }
      }, {
        btn : '',
        fn : function(){
        }
      });
    }

    // 삭제 실행
    function deleteNodeTree() {
      var qstSecId = '';
      var branch = tree.get_selected_branch();
      if (branch == null) return;

      angular.forEach(vm.treelist, function(item) {
        if (branch.data == item.QstSecId.toString()) {
          var index = vm.treelist.indexOf(item);
          vm.treelist.splice(index, 1);

          var parent = tree.select_parent_branch();
          if(parent){
            parent.children.splice(parent.children.indexOf(branch),1);
          } else {
            refreshTree();
          }

          return;
        }
      });

      tree.select_branch(null);
      vm.treedata = {};
    }

    function onChangeQstSecNm() {
      onChanged();
      var branch = tree.get_selected_branch();
      if (branch == null) return;
      branch.label = vm.treedata.QstSecNm;
    }

    function onChanged() {
      if (vm.treedata.New == null || vm.treedata.New != 'Y') {
        vm.treedata.Edit = 'Y';
      }
      if(vm.treedata.ScoringType != "C") vm.treedata.TotalType = "N";
    }

    function onChangeHandler() {
      console.error('chk');

      onchange();
    }

    // 저장
    function saveData() {
      vm.dataloader = true;
      var data = {SvyTypeId : vm.srch.keyId, lists : []};
      data.mapCode = TREE_SAVE_SQL;

      if (isNullOrEmpty(vm.treedata.SortSeq)) vm.treedata.SortSeq = 0;

      data.lists.push(vm.treedata);
      postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            var branch = tree.get_selected_branch();
            branch.label = branch.label.replace(/^\[\*\]/,"");

            if (vm.treedata.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.treedata.New = '';
            } else if (vm.treedata.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.treedata.Edit = '';
            }
          }
        },

        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

    }

    // 저장 실행
    function insert(obj, item) {
      var parent = item.parent; // 부모값
      var map = obj.map;
      map[item.guid] = item; // 아이템 구성함

      if (parent === null)
        obj.res.push(item); // 부모값 생성
      else {
        var parentItem = map[parent];
        // 자식값 생성
        if (parentItem != null) {
          if (parentItem.hasOwnProperty("children"))
            parentItem.children.push(item);
          else
            parentItem.children = [ item ];
        }
      }
      return obj;
    }

    // 기준총점/기준총점 설정 팝업
    vm.goScoreLvModal = function (type) {
      var ctrl = null;

      var paramData = {
        svyTypeId : vm.srch.keyId,
        svyTypeNm : vm.data.SvyTypeNm,
      };

      if(type == 'sec') {
        // 영역별 기준점 설정
        ctrl = 'ScoreLvSecModalCtrl as vc';
        paramData.isTot = "N";
      }
      else if (type == 'tot' && vm.data.TotType == "S") {
        // 총점으로 기준총점 설정
        type = 'sec';
        ctrl = 'ScoreLvSecModalCtrl as vc';
        paramData.isTot = "Y";
      }
      else if(type == 'tot' && vm.data.TotType == "L") {
        // 영역결과로 기준총점 설정
        ctrl = 'ScoreLvTotModalCtrl as vc';
      }
      var modalInstance = modalFactory.open("lg", "components/modal/survey/wjm-scorelv-"+ type +"-modal.html", ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
        },
        function (cancelData) {
        }
      );
    };


    // 함수 선언
    //--------------------------------- 트리
    vm.resetList = resetList;
    vm.getTreeList = getTreeList;
    vm.delNode = delNode;
    vm.saveData = saveData;
    vm.onChangeQstSecNm = onChangeQstSecNm;
    vm.onChanged = onChanged;
    //--------------------------------- 트리

    vm.getData = getData;                     // 데이터 조회
    vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
    vm.setData = setData;                     // 데이터 저장
    vm.goList = goList;                       // 목록 화면 이동
    vm.setDelData = setDelData;                     // 데이터 삭제
    vm.getIsDupSvyTypeCd = getIsDupSvyTypeCd;         // 설문유형코드 중복 체크

    vm.onChangeHandler = onChangeHandler;

    // 데이터 조회
    getData();

    // 트리 조회
    getTreeList();

  }]);



(function () {
  "use strict";

  webapp.controller('SurveyTypeListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SurveyTypeListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmSurvey.getSurveyTypeListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmSurvey.getSurveyTypeList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.survey-type-list';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.survey.survey-type-list.edit';    // 목록 등록/수정 화면
      var EDIT_PAGE_URL = 'app.survey.survey-type-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.surveytype'; // 작업 테이블명
      var KEY_COLUMN_NM = 'SvyTypeId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }




      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      // 목록 조회
      getList();
    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.survey', {
      url : '/survey',
      template : '<div ui-view></div>'


    //-------------------------------------------------------------- 1-1. 설문 작성 시작
    }).state('app.survey.survey-edit', {
      url: '/survey-edit/:srch/:keyId/:cKeyId',
      templateUrl: 'app/survey/survey-edit.html',
    //-------------------------------------------------------------- 1-1. 설문 작성 끝
    //-------------------------------------------------------------- 1-2. 서식 관리 시작
    }).state('app.survey.form-list', {
      url: '/form-list/:srch',
      templateUrl: 'app/survey/form-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.survey.form-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/survey/form-edit.html',
    }).state('app.survey.form-edit', {
      url: '/form-edit/:srch/:keyId/:cKeyId',
      templateUrl: 'app/survey/form-edit.html',
    //-------------------------------------------------------------- 1-2. 서식 관리 끝
    //-------------------------------------------------------------- 1-3. 설문유형 관리 시작
    }).state('app.survey.survey-type-list', {
      url: '/survey-type-list/:srch',
      templateUrl: 'app/survey/survey-type-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.survey.survey-type-edit', {
      url: '/survey-type-edit/:srch/:keyId',
      templateUrl: 'app/survey/survey-type-edit.html',
    }).state('app.survey.survey-type-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/survey/survey-type-edit.html',
    //-------------------------------------------------------------- 1-3. 설문유형 관리 끝
    //-------------------------------------------------------------- 1-4. 분류정보 관리 시작
    }).state('app.survey.classfy-info-list', {
      url: '/classfy-info-list/:srch',
      templateUrl: 'app/survey/classfy-info-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.survey.classfy-info-edit', {
      url: '/classfy-info-edit/:srch/:keyId',
      templateUrl: 'app/survey/classfy-info-edit.html',
    }).state('app.survey.classfy-info-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/survey/classfy-info-edit.html',
    //-------------------------------------------------------------- 1-4. 분류정보 관리 끝
    //-------------------------------------------------------------- 1-5. 문항이미지 관리 시작
    }).state('app.survey.image-list', {
      url: '/image-list/:srch',
      templateUrl: 'app/survey/image-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.survey.image-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/survey/image-edit.html',
    }).state('app.survey.image-edit', {
      url: '/image-edit/:srch/:keyId/:cKeyId',
      templateUrl: 'app/survey/image-edit.html',
    //-------------------------------------------------------------- 1-5. 문항이미지 관리 끝
    //-------------------------------------------------------------- 1-6. 상담문의문구 관리 시작
    }).state('app.survey.contact-edit', {
      url: '/contact-edit',
      templateUrl: 'app/survey/contact-edit.html',
    //-------------------------------------------------------------- 1-6. 상담문의문구 관리 끝
    //-------------------------------------------------------------- 2-1. 설문 관리 시작
    }).state('app.survey.survey-list', {
      url: '/survey-list/:srch',
      templateUrl: 'app/survey/survey-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.survey.survey-detail', {
      url: '/survey-detail/:srch/:keyId',
      templateUrl: 'app/survey/survey-detail.html',
    }).state('app.survey.survey-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/survey/survey-detail.html',
    //-------------------------------------------------------------- 2-1. 설문 관리 끝
    //-------------------------------------------------------------- 2-2. 결과 관리 시작
    }).state('app.survey.result-list', {
      url: '/result-list/:srch',
      templateUrl: 'app/survey/result-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.survey.result-detail', {
      url: '/result-detail/:srch/:keyId',
      templateUrl: 'app/survey/result-detail.html',
    }).state('app.survey.result-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/survey/result-detail.html',
    }).state('app.survey.trend-analysis', { //------------- 참여추이
      url: '/trend-analysis/:srch/:keyId',
      templateUrl: 'app/survey/trend-analysis.html',
    }).state('app.survey.result-list.trend', {
      url: '/trend/:keyId',
      templateUrl: 'app/survey/trend-analysis.html',
    }).state('app.survey.cross-analysis', { //------------- 교차분석
      url: '/cross-analysis/:srch/:keyId',
      templateUrl: 'app/survey/cross-analysis.html',
    }).state('app.survey.result-list.cross', {
      url: '/cross/:keyId',
      templateUrl: 'app/survey/cross-analysis.html',
    }).state('app.survey.associ-analysis', { //------------- 연관분석
      url: '/associ-analysis/:srch/:keyId',
      templateUrl: 'app/survey/associ-analysis.html',
    }).state('app.survey.result-list.associ', {
      url: '/associ/:keyId',
      templateUrl: 'app/survey/associ-analysis.html',
    //-------------------------------------------------------------- 2-2. 결과 관리 끝
    //-------------------------------------------------------------- 2-3. 참여자별 결과 관리 시작
    }).state('app.survey.target-result-list', {
      url: '/target-result-list/:srch',
      templateUrl: 'app/survey/target-result-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.survey.target-result-edit', {
      url: '/target-result-edit/:srch/:keyId',
      templateUrl: 'app/survey/target-result-edit.html',
    }).state('app.survey.target-result-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/survey/target-result-edit.html',
    //-------------------------------------------------------------- 2-3. 참여자별 결과 관리 끝
    //-------------------------------------------------------------- 2-4. 데이터 분석 시작
    }).state('app.survey.analysis', {
      url: '/analysis/:srch/:srch2',
      templateUrl: 'app/survey/analysis.html',
    //-------------------------------------------------------------- 2-4. 데이터 분석 끝
    //-------------------------------------------------------------- 2-5. 수신인 관리 시작
    }).state('app.survey.group-list', {
      url: '/survey-group-list/:srch',
      templateUrl: 'app/survey/survey-group-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.survey.survey-group-edit', {
      url: '/survey-group-edit/:srch/:keyId',
      templateUrl: 'app/survey/survey-group-edit.html',
    }).state('app.survey.survey-group-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/survey/survey-group-edit.html',
    //-------------------------------------------------------------- 2-5. 수신인 관리 끝
    //-------------------------------------------------------------- 2-0. 업체로그인 결과 관리 시작
    }).state('app.survey.client-result-list', {
      url: '/client-result-list/:srch',
      templateUrl: 'app/survey/client-result-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    //-------------------------------------------------------------- 2-0. 업체로그인 결과 관리 끝
    //-------------------------------------------------------------- 3-1. 보고서 생성 관리 시작
    }).state('app.survey.report-mng-list', {
      url: '/report-mng-list/:srch',
      templateUrl: 'app/survey/report-mng-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.survey.report-mng-detail', {
      url: '/report-mng-detail/:srch/:keyId',
      templateUrl: 'app/survey/report-mng-detail.html',
    }).state('app.survey.report-mng-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/survey/report-mng-detail.html',
    //-------------------------------------------------------------- 3-1. 보고서 생성 관리 끝
    //-------------------------------------------------------------- 3-2. 보고서 관리 시작
    }).state('app.survey.report-list', {
      url: '/report-list/:srch',
      templateUrl: 'app/survey/report-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.survey.report-detail', {
      url: '/report-detail/:srch/:keyId/:srch2',
      templateUrl: 'app/survey/report-detail.html',
    }).state('app.survey.report-list.detail', {
      url: '/detail/:srch/:keyId/:srch2',
      templateUrl: 'app/survey/report-detail.html',
    //-------------------------------------------------------------- 3-2. 보고서 관리 끝
    //-------------------------------------------------------------- 3-3. 외부 보고서 업로드 시작
    }).state('app.survey.report-upload', {
      url: '/eport-upload/',
      templateUrl: 'app/survey/report-upload.html',
    //-------------------------------------------------------------- 3-0. 업체로그인 보고서 검색
    }).state('app.survey.report-search', {
      url: '/report-search/:srch/',
      templateUrl: 'app/survey/report-search.html',
    //-------------------------------------------------------------- 3-0. 업체로그인 보고서 검색 끝
    //-------------------------------------------------------------- 4-1. 전체 발송 이력 관리 시작
    }).state('app.survey.survey-send-totresult-list', {
      url: '/survey-send-totresult-list/:srch',
      templateUrl: 'app/survey/survey-send-totresult-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    //-------------------------------------------------------------- 4-1. 전체 발송 이력 관리 끝
    //-------------------------------------------------------------- 4-2. 개별 발송 결과 관리 시작
    }).state('app.survey.survey-send-result-list', {
      url: '/survey-send-result-list/:srch',
      templateUrl: 'app/survey/survey-send-result-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    //-------------------------------------------------------------- 4-2. 개별 발송 결과 관리 끝
    //-------------------------------------------------------------- 4-3. SMS 발송 시작
    }).state('app.survey.sms-send', {
      url: '/survey-sms-send/:srch',
      templateUrl: 'app/survey/survey-sms-send.html',
    //-------------------------------------------------------------- 4-3. SMS 발송 끝
    //-------------------------------------------------------------- 4-4. 이메일 발송 시작
    }).state('app.survey.email-send', {
      url: '/survey-email-send/:srch',
      templateUrl: 'app/survey/survey-email-send.html',
    //-------------------------------------------------------------- 4-4. 이메일 발송 끝
    //-------------------------------------------------------------- 4-5. SMS 금액통계 시작
    }).state('app.survey.sms-statistic', {
      url: '/sms-statistic/:srch',
      templateUrl: 'app/survey/sms-statistic.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    //-------------------------------------------------------------- 4-5. SMS 금액통계 끝
    //-------------------------------------------------------------- 4-7. 예약발송 취소 시작
    }).state('app.survey.resv-send-list', {
      url: '/resv-send-list/:srch',
      templateUrl: 'app/survey/resv-send-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    //-------------------------------------------------------------- 4-7. 예약발송 취소 끝
    //-------------------------------------------------------------- 5-1. 상담신청 시작
    }).state('app.survey.counsel-list', {
      url: '/counsel-list/:srch',
      templateUrl: 'app/survey/counsel-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.survey.counsel-edit', {
      url: '/counsel-edit/:srch/:keyId',
      templateUrl: 'app/survey/counsel-edit.html',
    }).state('app.survey.counsel-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/survey/counsel-edit.html',
    //-------------------------------------------------------------- 5-2. 상담신청 끝
    //-------------------------------------------------------------- 6-1. 업체정보 관리 시작
    }).state('app.survey.client-list', {
      url: '/client-list/:srch',
      templateUrl: 'app/survey/client-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.survey.client-edit', {
      url: '/client-edit/:srch/:keyId',
      templateUrl: 'app/survey/client-edit.html',
    }).state('app.survey.client-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/survey/client-edit.html',
    //-------------------------------------------------------------- 6-1. 업체정보 관리 끝
    //-------------------------------------------------------------- 6-2. 상담사정보 관리 시작
    }).state('app.survey.counselor-list', {
      url: '/counselor-list/:srch',
      templateUrl: 'app/survey/counselor-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.survey.counselor-edit', {
      url: '/counselor-edit/:srch/:keyId',
      templateUrl: 'app/survey/counselor-edit.html',
    }).state('app.survey.counselor-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/survey/counselor-edit.html',
    //-------------------------------------------------------------- 6-2. 상담사정보 관리 끝





    });
  }
})();

(function () {
  "use strict";

  webapp.controller('TargetResultEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter', 'wjmSurvey',

    function TargetResultEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, wjmSurvey) {

      // SQL Mapper Id 정의
      var VIEW_SQL = 'WjmReport.getTargetResultDetail'; // 조회 SQL
      var VIEW_RESP_SQL = 'WjmReport.getTargetRespHistList'; // 응답결과 조회 SQL
      var RESP_SAVE_SQL = 'WjmReport.saveTargetRespHistListBatch';  // 응답결과 등록/수정 SQL
      var SCORELV_SAVE_SQL = 'WjmReport.saveSvyRespScoreAndLvBatch';  // 응답결과 점수 등록 SQL
      var VIEWQST_SQL = 'WjmSurvey.getSurveyQstDetail'; // 조회 SQL (문항)
      var VIEWQSTITEM_SQL = 'WjmSurvey.getSurveyQstItemDetail'; // 조회 SQL (보기)
      var CF_LIST_SQL = 'WjmSurvey.getClassfyDropList'; // 분류정보 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.target-result-list';           // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.targetresult'; // 작업 테이블명
      var KEY_COLUMN_NM = 'SvyTgtId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      vm.chkScore = true;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
      }

      $scope.wjmSurvey = wjmSurvey;
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      vm.srchDetail = {
        keyId : vm.srch.keyId,
        tableNm : vm.srch.tableNm,
        IdName : KEY_COLUMN_NM, // Primary Key Column
        selectType : "Edit",  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      };
      vm.columnMap = {};

      vm.respList = [];

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM
      };

      // 대상자정보 조회
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.viewColumns = {};
        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }
            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;
              if (!isNullOrEmpty(vm.data.SendDate)) vm.data.SendDate = moment(vm.data.SendDate).format('YYYY-MM-DD HH:mm:ss');
              if (!isNullOrEmpty(vm.data.OpenDate)) vm.data.OpenDate = moment(vm.data.OpenDate).format('YYYY-MM-DD HH:mm:ss');
              if (!isNullOrEmpty(vm.data.RespDate)) vm.data.RespDate = moment(vm.data.RespDate).format('YYYY-MM-DD HH:mm:ss');

              vm.svyPages = [];
              for(var i = 1; i <= vm.data.PageCnt; i++){
                vm.svyPages.push({PageNo: i, Label: i});
              }
              vm.svyPages.unshift({PageNo: 'ALL', Label: '전체'});
              vm.svyPagesCur = 'ALL';

              getDataQsts(); // 문항

              vm.dataloader = false;
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }
          vm.dataloader = false;
        }, function (error) {
          vm.dataloader = false;
          console.error("Error> getData()");
          console.table(error);
        });
      }

      // 페이지 이동
      function goPage(type) {
        var srch = $stateParams.srch;
        var page = '';
        switch(type){
          case "L" : page = LIST_PAGE_URL; break; // 목록
        }
        $state.go(page, {srch:srch, keyId: vm.data.KeyId});
      }


      // 영역별 점수보기
      vm.goScoreLvModal = function (type) {
        var ctrl = 'TargetScoreLvModalCtrl as vc';
        var paramData = {
          keyId : vm.srch.keyId,
          SvyTypeId : vm.data.SvyTypeId,
          SecLevelCnt : vm.data.SecLevelCnt,
          ScoringType : vm.data.ScoringType
        };
        var modalInstance = modalFactory.open("md", "components/modal/survey/wjm-target-scorelv-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
          },
          function (cancelData) {
          }
        );
      };

      // 문항정보 조회
      function getDataQsts() {
        var data = {SvyId : vm.data.SvyId};
        data.mapCode = VIEWQST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.svyQsts = result.body.docs;
                getDataQstItems(); // 보기
              }
            }
          } else {
            console.error("Error> getDataQst()");
            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getDataQst()");
          console.table(error);
        });
      }

      // 보기정보 조회
      function getDataQstItems() {
        var data = {SvyId : vm.data.SvyId};
        data.mapCode = VIEWQSTITEM_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (isNullOrEmpty(result.body.docs[0]["no data"])) {
                vm.svyQstItems = result.body.docs;
              }
            }
            getRespList();
          } else {
            console.error("Error> getDataQstItems()");
            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getDataQstItems()");
          console.table(error);
        });
      }


      function chkSave(){
        if(vm.data.RespStatus == "P") {
          gConfirm('', '부분응답 상태가 응답완료로 변경됩니다. 진행하시겠습니까?', {
            btn: '',
            fn: function () {
              setData();
            }
          }, {
            btn: '',
            fn: function () {
            }
          });
        } else {
          setData();
        }
      }

      // 저장
      function setData(){
        vm.dataloader = true;
        var data = {
          lists : [],
          SvyId : vm.data.SvyId,
          SvyTgtId : vm.srch.keyId,
          ScoringType : vm.data.ScoringType,
          RespStatus : vm.data.RespStatus,
          mapCode : RESP_SAVE_SQL
        };

        vm.chkScore = false;

        angular.forEach( $filter('filter')(vm.respList, {isChg: "Y"}, true), function (resp) {
          data.lists.push(resp);
        });
        angular.forEach( $filter('filter')(vm.respListTop, {isChg: "Y"}, true), function (resp) {
          data.lists.push(resp);
        });

        if(isNullOrEmpty(data.lists)){
          vm.dataloader = false;
          gAlert("", "변경된 정보가 없습니다.");
          return;
        }

        postApi.insert(data, function(result) {
          //if (result.header.status == CONSTANT.HttpStatus.OK) {
            setScoreData();
            if(vm.data.RespStatus == "P") getData();
            else getRespList();
          //}
          //else {
          //  vm.dataloader = false;
          //}
        },
        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      // 점수 변경
      function setScoreData(){
        vm.dataloader = true;
        var data = {
          SvyId : vm.data.SvyId,
          SvyTgtId : vm.srch.keyId,
          SvyTypeId : vm.data.SvyTypeId,
          SvyTypeCd : vm.data.SvyTypeCd,
          ScoringType : vm.data.ScoringType,
          TotType : vm.data.TotType,
          mapCode : SCORELV_SAVE_SQL
        };

        postApi.insert(data, function(result) {
          //if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                vm.chkScore = true;
              }
            });
            vm.dataloader = false;
          //}
        },
        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      // 응답결과 조회
      function getRespList() {
        var data = {keyId : vm.srch.keyId, mapCode : VIEW_RESP_SQL};

        vm.respList = [];
        vm.respListTop = [];
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            var imgChk = false;

            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs , function (resp) {

                resp.isChg = "N";

                // 우선순위형, 다중선택형, 척도형
                if(!isNullOrEmpty(resp.PrioNo)){
                  vm.respListTop.push(resp);
                  vm.respListTop[resp.SvyQstId + "_" + resp.PrioNo] = resp;
                } else {
                  vm.respList.push(resp);
                  vm.respList[resp.SvyQstId] = resp;
                }
              });
            }


            // 기존 응답이 존재하지 않는 문항에 대한 초기값
            angular.forEach(vm.svyQsts, function (qt) {

              if(qt.QstType == "4") imgChk = true;

              if(qt.QstType != "R") {
                  var newnum = 0;
                  var resp = {};
                  var cnt = 0;

                // 우선순위형, 다중선택형, 척도형
                if(qt.QstType == "3" || (qt.QstType == "1" && qt.SelType == "M") || qt.QstType == "5"){
                  switch(qt.QstType){
                    case "3" : cnt = qt.QstTopCnt; break;
                    case "1" : cnt = $filter('filter')(vm.svyQstItems, {qtId: qt.qtId}, true).length; break;
                    case "5" : cnt = qt.ScaleMax; break;
                  }
                  for(var i = 1; i <= cnt; i++){
                    if(isNullOrEmpty(vm.respListTop[qt.qtId + "_" + i])) {
                      newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                      resp = {
                        SvyRespHistId : newnum.toString(36),
                        SvyId : vm.data.SvyId,
                        SvyQstId : qt.qtId,
                        SvyQstItemId : null,
                        ObjctResp : null,
                        SbjctResp : null,
                        PrioNo : i,
                        isChg : "N"
                      };
                      vm.respListTop.push(resp);
                      vm.respListTop[qt.qtId + "_" + i] = resp;
                    }
                  }

                } else if(isNullOrEmpty(vm.respList[qt.qtId])) {
                  newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                  resp = {
                    SvyRespHistId : newnum.toString(36),
                    SvyId : vm.data.SvyId,
                    SvyQstId : qt.qtId,
                    SvyQstItemId : null,
                    ObjctResp : null,
                    SbjctResp : null,
                    PrioNo : null,
                    isChg : "N"
                  };
                  vm.respList.push(resp);
                  vm.respList[qt.qtId] = resp;
                }
              }
            });

            // 이미지형 설정
            if(imgChk) setEndProc();

          } else {
            console.error("Error> getRespList()");
            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }
        }, function (error) {
          console.error("Error> getRespList()");
          console.table(error);
        });
      }

      // 변경 대상 체크
      function chkChange(list, id){
        list[id].isChg = "Y";
      }

      // 이미지 조회
      function setEndProc() {
        wjmSurvey.getImageList(vm.imageList, vm.svyQsts, vm.svyQstItems);
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goPage = goPage;                       // 화면 이동
      vm.setData = setData; // 저장
      vm.chkSave = chkSave;
      vm.chkChange = chkChange; // 변경 대상 체크

      // 데이터 조회
      getData();
    }]);
})();


(function () {
  "use strict";

  webapp.controller('TargetResultListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter', 'wjmReport',

    function TargetResultListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter, wjmReport) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'WjmReport.getTargetResultListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'WjmReport.getTargetResultList';    // 목록 조회 SQL
      var EXCEL_SQL = 'WjmReport.getTargetResultExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'WjmReport.deleteTargetListBatch'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.survey.target-result-list';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.survey.target-result-list.edit';         // 목록 수정 화면
      var EDIT_PAGE_URL = 'app.survey.target-result-edit';         // 수정 화면

      var RSLT_PAGE_URL = 'app.survey.result-detail';           // 조회 화면
      var LIST_RSLT_PAGE_URL = 'app.survey.result-list.detail'; // 목록 조회 화면
      var ANAL_PAGE_URL = 'app.survey.analysis';           // 교차분석, 연관분석 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.targetresult'; // 작업 테이블명
      var XLS_TABLE_NM = 'wjm.targetresult.xls'; // 작업 테이블명
      var EXCEL_TITLE = '참여자별 결과 목록'; // 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      var srchTmp = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: 'DESC',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: 'SendDate',          // 정렬컬럼명
      };

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = srchTmp;
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch2 = encodeURIComponent(JSON.stringify(srchTmp, replacer));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;

        vm.RespBeginDate = $rootScope.getDateFormat(vm.srch.RespBeginDate);
        vm.RespEndDate = $rootScope.getDateFormat(vm.srch.RespEndDate);

      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.tableNm = KEY_TABLE_NM;
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;

              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

          // 다른 페이지에서 이동
          var analTxt = "";
          if(!isNullOrEmpty(vm.srch.goBack)){
            switch(vm.srch.goBack){
              case "SvyResult": analTxt = " > " + vm.srch.analTxt + " 참여자 목록"; break;
              case "Anal": analTxt = " > 데이터분석 대상 목록"; break;
              case "AssociAnal": analTxt = " > 연관분석 대상 목록"; break;
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch) + analTxt;
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD HH:mm:ss";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      // 설문작성 화면
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        $state.go(EDIT_PAGE_URL, {
          srch: srch,
          keyId: ''
        });
      }

      // 페이지 이동
      function goPage(selStat, selKeyId) {
        var srch = $stateParams.srch;
        vm.keyId = selKeyId;
        var page = "";

        // 뒤로
        if(selStat == "back"){
          if(!isNullOrEmpty(vm.srch.goBack)){
            if(vm.srch.goBack == "SvyResult") { // 결과상세
              page = (vm.layout == 'N' ? RSLT_PAGE_URL : LIST_RSLT_PAGE_URL);
              $state.go(page, {srch: srch, keyId: vm.srch.goSvyId});
            } else if(vm.srch.goBack == "Anal" || vm.srch.goBack == "AssociAnal") { // 교차분석, 연관분석
              page = ANAL_PAGE_URL;
              $state.go(page, {srch: srch, srch2: vm.srch2, keyId: vm.srch.goSvyId});
            }
          }

        // 발송완료일 경우 참여자별 결과 수정 화면
        } else if(selStat == 'R' || selStat == 'P'){
          page = (vm.layout == 'N' ? EDIT_PAGE_URL : LIST_EDIT_PAGE_URL);
          if( ! isNullOrEmpty(vm.srch.goSvyId)) {
            var tmp = JSON.parse(decodeURIComponent($stateParams.srch));
            tmp.SvyId = vm.srch.goSvyId;
            srch = encodeURIComponent(JSON.stringify(tmp, replacer));
          }
          $state.go(page, {srch: ( ! isNullOrEmpty(vm.srch) ? srch : vm.srch2), keyId: selKeyId});

        // 그 외는 대상자 정보 수정 팝업
        } else {
          var ctrl = 'TargetEditModalCtrl as vc';
          var paramData = {keyId : selKeyId};
          var modalInstance = modalFactory.open("md", "components/modal/survey/wjm-target-edit-modal.html", ctrl, paramData);
          modalInstance.result.then(
            function (okData) {
              getSearch();
            },
            function (cancelData) {
            }
          );
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 체크한 대상 (삭제, 엑셀, RawData)
      function getChkList(type){
        if (vm.lists.length == undefined || vm.lists.length == 0) {
          gAlert("", "데이터가 없습니다.");
          return false;
        }

        vm.srchChk = {};
        vm.srchChk.FormId = '';
        vm.srchChk.SvyId = '';
        vm.srchChk.SvyNms = '';
        vm.srchChk.SvyTypeId = '';
        vm.srchChk.ClassfyInfoId = '';
        vm.srchChk.KeyIdList = [];
        vm.srchChk.SecLevelCnt = 0;
        vm.srchChk.ScoringType = '';

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {

            if (type == "RAW"){
              if(vm.srchChk.SvyId == '') {
                vm.srchChk.FormId = vm.lists[i].FormId;
                vm.srchChk.SvyId = vm.lists[i].SvyId;
                vm.srchChk.SvyTypeId = vm.lists[i].SvyTypeId;
                vm.srchChk.ClassfyInfoId = vm.lists[i].ClassfyInfoId;
                vm.srchChk.SecLevelCnt = vm.lists[i].SecLevelCnt;
                vm.srchChk.ScoringType = vm.lists[i].ScoringType;
              }
              if( ! isNullOrEmpty(vm.srchChk.FormId) && vm.srchChk.FormId != vm.lists[i].FormId){
                gAlert("", "동일한 서식을 사용하는 설문의 대상자 내에서 체크해 주세요.");
                return false;
              }
              if(vm.srchChk.KeyIdList.length >= 1 && isNullOrEmpty(vm.srchChk.FormId) && vm.srchChk.SvyId != vm.lists[i].SvyId){
                gAlert("", "서식을 사용하지 않는 설문의 경우 동일한 설문의 대상자 내에서 체크해 주세요.");
                return false;
              }
              if(vm.lists[i].RespStatus != "R" && vm.lists[i].RespStatus != "P"){
                gAlert("", "응답이 존재하는 대상자만 체크해 주세요.");
                return false;
              }
            }

            vm.srchChk.KeyIdList.push(vm.lists[i].KeyId);

            if(vm.srchChk.SvyNms != vm.lists[i].SvyNm) {
              vm.srchChk.SvyNms = vm.srchChk.SvyNms + (vm.srchChk.SvyNms == ''? '' : ', ') + vm.lists[i].SvyNm;
            }
          }
        }
        if (type != "XLS" && (vm.srchChk.KeyIdList == null || vm.srchChk.KeyIdList.length == 0)) {
          gAlert('', '항목을 선택해 주세요.');
          return false;
        }
        return true;
      }

      // 목록 엑셀 다운로드
      function getExcelFile() {

        // 체크 대상이 있을 경우 해당 목록만 다운로드 하게 해달라는 요청
        // 체크 대상이 없을 경우 전체 목록 다운로드
        var chk = getChkList("XLS");
        if ( ! chk) return false;

        var a = document.createElement("a");
        document.body.appendChild(a);

        vm.srch.KeyIdList = vm.srchChk.KeyIdList;

        var data = vm.srch;
        data.selectType = 'List';
        data.tableNm = XLS_TABLE_NM;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            // 조회 목록과 엑셀 헤더가 달라서 컬럼맵을 별도로 생성
            var xlsListColumns;
            var xlsColumnMap = {};
            if (result.body.desc.length > 0) {
              xlsListColumns = result.body.desc;
              angular.forEach(xlsListColumns, function (item) {
                xlsColumnMap[item.ColumnPhysicalNm] = item;
              });
            }
            angular.forEach(xlsColumnMap, function (item) {
              if (item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(xlsColumnMap, function (item) {

                if (item.ColumnPhysicalNm == 'SendDate' || item.ColumnPhysicalNm == 'RespDate' || item.ColumnPhysicalNm == 'OpenDate') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).format('YYYY-MM-DD HH:mm:ss'));
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                } else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

      // 초기 데이터 설정
      function setInitData() {

        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 목록 삭제 확인
      function setDelList(tgtType) {
        gConfirm('', '선택한 정보를 삭제하시겠습니까?', {
          btn: '',
          fn: function () {
            setDelListAction(tgtType);
          }
        }, {
          btn: '',
          fn: function () {
          }
        });
      }

      // 목록 삭제
      function setDelListAction(tgtType) {

        var chk = getChkList("DEL");
        if ( ! chk) return false;

        vm.srch.KeyIdList = vm.srchChk.KeyIdList;

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;
        data.tgtType = tgtType;

        postApi.update(data, function (result) {
          //if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                getList();
              }
            });
          //}
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 설문 검색 팝업
      vm.srchSurveyModal = function () {
        var ctrl = 'WjmSurveyModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };
        var modalInstance = modalFactory.open('md', 'components/modal/survey/wjm-survey-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.srch.SvyNm = res.SvyNm;
          vm.srch.SvyId = res.SvyId;
        }, function(cancelData) {
        });
      };
      vm.eraseSurvey = function () {
        vm.srch.SvyId = '';
        vm.srch.SvyNm = '';
      };

      // 목록 RawData 다운로드
      function getRawData() {

        var chk = getChkList("RAW");
        if ( ! chk) return false;

        vm.srchChk.keyCol = "SvyTgtId";

        vm.dataloader = true;
        wjmReport.getRawData(vm.srchChk, $scope, $rootScope)
          .then(function() { vm.dataloader = false; })
          .catch(function(error) { vm.dataloader = false; });
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goPage = goPage;                         // 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드
      vm.getRawData = getRawData;             // RawData Excel 파일 다운로드

      // 목록 조회
      getList();
      setInitData();

    }]);
})();

(function () {
  "use strict";

  webapp.controller('TrendAnalysisCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function TrendAnalysisCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // SQL Mapper Id 정의
      var VIEW_SQL = 'WjmReport.getResultDetail'; // 설문정보 조회 SQL
      var ANAL_SQL = 'WjmReport.getTrendAnalysis'; // 분석정보 조회 SQL

      // 관련 화면 정의
      var VIEW_PAGE_URL = 'app.survey.result-detail';           // 조회 화면
      var LIST_VIEW_PAGE_URL = 'app.survey.result-list.detail'; // 목록 조회 화면
      var LIST_PAGE_URL = 'app.survey.result-list';           // 목록 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'wjm.surveyresult'; // 설문정보 테이블명
      var ANAL_TABLE_NM = 'wjm.trendanalysis'; // 분석정보 테이블명
      var KEY_COLUMN_NM = 'SvyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Detail";  // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
      };

      // 설문 조회
      function getData() {
        vm.dataloader = true; // Progressbar 표시
        vm.srchDetail.viewColumns = {}; // 사용자정의 컬럼 정보 설정

        var data = vm.srchDetail; // 검색 옵션 설정

        data.tableNm = KEY_TABLE_NM;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 조회 정보 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getData()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.allColumns)) {
              // 조회 데이터 표시
              vm.data = result.body.docs[0];
              vm.data.RelateDataId = vm.data.KeyId;

              getAnalData();

              vm.dataloader = false; // Progressbar 숨김
            } else {
              gAlert('', 'MSG.NO_DATA');
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getData()");
          console.table(error);
        });
      }

      // 분석 데이터 조회
      function getAnalData() {
        vm.dataloader = true; // Progressbar 표시

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.tableNm = ANAL_TABLE_NM;
        data.mapCode = ANAL_SQL;
        data.SvyBeginDate = $filter('utcToLocal')(vm.data.SvyBeginDate,'yyyy-MM-dd');

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      // 목록 구성
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      // 페이지 이동
      function goPage(type) {
        var srch = $stateParams.srch;
        var page = '';
        switch(type){
          case "V" : page = (vm.layout == 'N' ? VIEW_PAGE_URL : LIST_VIEW_PAGE_URL); break; // 조회
          case "L" : page = LIST_PAGE_URL; break; // 목록
        }
        $state.go(page, {srch:srch, keyId: vm.data.KeyId});
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.goPage = goPage;                       // 화면 이동
      vm.getAnalData = getAnalData;   // 분석 데이터 조회

      // 데이터 조회
      getData();
    }]);
})();

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.main:main-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('MainCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'StaticVariable', 'GLOBAL_CONSTANT', 'postApi', '$compile', 'modalFactory', '$translate', '$filter', 'LoginAPISrv', 'gAlert',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   */
  function MainCtrl($window, $scope, $location, $state, $stateParams, $rootScope, StaticVariable, CONSTANT, postApi, $compile, modalFactory, $translate, $filter, loginApi, gAlert) {

    var vm = this;
    vm.dataloader = false;

    vm.test = '1234';
    vm.userNm = $window.sessionStorage.loginUserName;
    vm.userId = $window.sessionStorage.loginUserId;

    function isLoggedIn(){
      if(!angular.isUndefined($window.sessionStorage['isLoggedIn']) && $window.sessionStorage['isLoggedIn'] === 'Y'){
        return true;
      }else{
        return false;
      }
    }

    function doLogout() {
      StaticVariable.sessionExpire();
      var prms = loginApi.doLogout().post().$promise;
      prms.then(function(json) {
        var temp = {};
        temp.layoutBoard = "N";
        $window.sessionStorage.clear();
        $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
        gAlert('', 'Menu.SIGNEDOUT', {
          btn : '',
          fn : function() {
            //$window.location.replace('/' + CONSTANT.URL.CONTEXT);
            //$state.reload('main.login');
            $window.location.replace('/#/home/main');
          }
        });
      }, function(error) {
        console.error('fail', status);
      });
    }

    function goDataCenter(){
      var mainpage = $window.sessionStorage.mainPage;

      if(mainpage == null || mainpage == "") mainpage = "app.dashboard";

      console.log(mainpage);
      $state.go(mainpage, {srch : ''});
    }

    vm.isLoggedIn = isLoggedIn;
    vm.goDataCenter = goDataCenter;
    vm.doLogout = doLogout;

    vm.message = '<p>o 서비스 중단 일시 : &rsquo;19. 11. 22. 00시 ~ 08시 (8시간)</p>' +
    '<p>&nbsp;</p>' +
    '<p>o 중단 서비스 : 인터넷주소 등록관리 서비스</p>' +
    '<p>&nbsp;- 국가도메인(.kr, .한국) 신규 등록, 기 등록 국가도메인 정보 변경 및 사용기간 연장 등</p>' +
    '<p>&nbsp;- IP주소/AS번호 신규 할당 신청, IP주소/AS번호 할당기관 정보 변경 등</p>' +
    '<p>&nbsp;- 인터넷주소 할당등록정보 검색서비스(WHOIS) 내 국가도메인 부가서비스*</p>' +
    '<p>&nbsp; * 도메인 정보보호서비스, 도메인 인증코드 발급, WHOIS OpenAPI key 발급 서비스</p>' +
    '<p>&nbsp; ※ 국가도메인, IP주소/AS번호 할당등록 정보 검색 서비스는 정상 이용 가능 </p>' +
    '<p>&nbsp;</p>' +
    '<p>o 문의처</p>' +
    '<p>&nbsp;- 국가도메인(.kr, .한국) 등록관리 서비스 : <a href="mailto:domop@nic.or.kr">domop@nic.or.kr</a></p>' +
    '<p>&nbsp;- IP주소/AS번호 할당관리 서비스 : <a href="mailto:hostmaster@nic.or.kr">hostmaster@nic.or.kr</a></p>' +
    '<p>&nbsp;- 인터넷주소 할당등록정보 검색서비스(WHOIS) : <a href="mailto:whoisquery@nic.or.kr">whoisquery@nic.or.kr</a></p>' +
    '<p>----------------------------------------------------------------------------------------------------</p>';


    function getPopups(){
      var data = {};
      data.mapCode = 'getPopupList';
      data.UseYN = 'Y';
      data.TenantId = '8LETQJJ81A';
      postApi.openApi(data, function (result) {
        if (result.header.status === 200) {
          if(result.body.docs.length > 0){
            vm.lists = result.body.docs;
            console.log($rootScope.gVariable.TenantId);
            angular.forEach(vm.lists, function(item){
              if(getCookie(item.Title) != 'done'){
                makePopup(item);
              }
            });
          }
        }
      });
    }

    function getCookie(name){
        var nameOfCookie = name + "=";
        var x = 0;
        while (x <= document.cookie.length){
            var y = (x + nameOfCookie.length);
            if (document.cookie.substring(x, y) == nameOfCookie){
              var endOfCookie = document.cookie.indexOf(";", y);
              if (endOfCookie == -1){
              endOfCookie = document.cookie.length;
              }
              return document.cookie.substring(y, endOfCookie);
            }
            x = document.cookie.indexOf (" ", x) + 1;
            if (x == 0) break;
        }
        return "";
    }

    function makePopup(li){
      var html = '<div class="popup-each" style="position:absolute; overflow:hidden; width:'+ li.WidthSize + 'px; height:' + (li.VrticleSize + 35) + 'px; top:' + li.UpendLC + 'px; left:' + li.LeftLC + 'px;">' + li.Contents + '<div class="popup-btn-wrap"><div style="float:right; line-height:20px; position:relative; top: 5px;"><button class="popup-btn" ng-click="vc.setCookie(\'' + li.Title + '\', $event)">24시간동안 열지않음</button><button class="popup-btn" ng-click="vc.winClose($event)">닫기</button></div></div></div>';
      var comp = $compile(html);
      angular.element('home').append(comp($scope));
    }

    function winClose(e){
      angular.element(e.target).parents('.popup-each').hide();
    }

    function setCookie(name, e){
      var today = new Date();
      today.setDate(today.getDate() + 1);
      document.cookie = name + "=" + escape('done') + "; path=/; expires=" + today.toGMTString() + ";";
      winClose(e);
    }

    vm.setCookie = setCookie;
    vm.winClose = winClose;
    getPopups();

  }
]);

webapp.component('homeMain',{
  templateUrl : 'home/main/main.html'
});

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name home.support:support-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('SupportCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'StaticVariable', 'GLOBAL_CONSTANT', 'postApi', '$compile', 'modalFactory', '$translate', '$filter', 'LoginAPISrv', 'gAlert',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   */
  function SupportCtrl($window, $scope, $location, $state, $stateParams, $rootScope, StaticVariable, CONSTANT, postApi, $compile, modalFactory, $translate, $filter, loginApi, gAlert) {

    vm.srch = {};
    vm.srch.title = "서비스 복구 안내 수신";
    vm.srch.srchTenantId = '8LETQJJ81A';
    vm.srch.serviceId=3;
    vm.srch.mapCode="insertApp";

    function submit() {
      if(vm.validation()){
        var data = angular.copy(vm.srch);
        postApi.openApi(data,
          function(result) {
            if(result.header.status === CONSTANT.HttpStatus.OK) {
              gAlert("","등록되었습니다.");
              $state.go('home.contacts', {}, {reload : true});
            }
          },
          function(error) {
            console.error('fail', status, data);
          });
      }
    }

    function validation(){

      if($scope.theForm.email.$invalid){
        gAlert("","E-mail주소를 입력해주세요.");
        return false;
      }else {
        var date = new Date();

        vm.srch.content = "<p>등록일시 : " + date.getFullYear() + "년 " + (date.getMonth()+1) + "월 " + date.getDate() + "일 " + date.getHours() + "시 " + date.getMinutes() + "분</p>"
                        + "<p>E-main주소 : " + vm.srch.email + "</p>";
        vm.srch.To = 'dataCenter';
        return true;
      }
    }


    vm.submit = submit;
    vm.validation = validation;

  }
]);


/*
 ng-sortable v1.3.8
 The MIT License (MIT)

 Copyright (c) 2014 Muhammed Ashik

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */

/*jshint indent: 2 */
/*global angular: false */

(function () {
  'use strict';
  angular.module('as.sortable', [])
    .constant('sortableConfig', {
      itemClass: 'as-sortable-item',
      handleClass: 'as-sortable-item-handle',
      placeHolderClass: 'as-sortable-placeholder',
      dragClass: 'as-sortable-drag',
      hiddenClass: 'as-sortable-hidden',
      dragging: 'as-sortable-dragging'
    });
}());

/*jshint indent: 2 */
/*global angular: false */

(function () {
  'use strict';

  var mainModule = angular.module('as.sortable');

  /**
   * Helper factory for sortable.
   */
  mainModule.factory('$helper', ['$document', '$window',
    function ($document, $window) {
      return {

        /**
         * Get the height of an element.
         *
         * @param {Object} element Angular element.
         * @returns {String} Height
         */
        height: function (element) {
          return element[0].getBoundingClientRect().height;
        },

        /**
         * Get the width of an element.
         *
         * @param {Object} element Angular element.
         * @returns {String} Width
         */
        width: function (element) {
          return element[0].getBoundingClientRect().width;
        },

        /**
         * Get the offset values of an element.
         *
         * @param {Object} element Angular element.
         * @param {Object} [scrollableContainer] Scrollable container object for calculating relative top & left (optional, defaults to Document)
         * @returns {Object} Object with properties width, height, top and left
         */
        offset: function (element, scrollableContainer) {
          var boundingClientRect = element[0].getBoundingClientRect();
          if (!scrollableContainer) {
            scrollableContainer = $document[0].documentElement;
          }

          return {
            width: boundingClientRect.width || element.prop('offsetWidth'),
            height: boundingClientRect.height || element.prop('offsetHeight'),
            top: boundingClientRect.top + ($window.pageYOffset || scrollableContainer.scrollTop - scrollableContainer.offsetTop),
            left: boundingClientRect.left + ($window.pageXOffset || scrollableContainer.scrollLeft - scrollableContainer.offsetLeft)
          };
        },

        /**
         * get the event object for touch.
         *
         * @param  {Object} event the touch event
         * @return {Object} the touch event object.
         */
        eventObj: function (event) {
          var obj = event;
          if (event.targetTouches !== undefined) {
            obj = event.targetTouches.item(0);
          } else if (event.originalEvent !== undefined && event.originalEvent.targetTouches !== undefined) {
            obj = event.originalEvent.targetTouches.item(0);
          }
          return obj;
        },

        /**
         * Checks whether the touch is valid and multiple.
         *
         * @param event the event object.
         * @returns {boolean} true if touch is multiple.
         */
        isTouchInvalid: function (event) {

          var touchInvalid = false;
          if (event.touches !== undefined && event.touches.length > 1) {
            touchInvalid = true;
          } else if (event.originalEvent !== undefined &&
            event.originalEvent.touches !== undefined && event.originalEvent.touches.length > 1) {
            touchInvalid = true;
          }
          return touchInvalid;
        },

        /**
         * Get the start position of the target element according to the provided event properties.
         *
         * @param {Object} event Event
         * @param {Object} target Target element
         * @param {Object} [scrollableContainer] (optional) Scrollable container object
         * @returns {Object} Object with properties offsetX, offsetY.
         */
        positionStarted: function (event, target, scrollableContainer) {
          var pos = {};
          pos.offsetX = event.pageX - this.offset(target, scrollableContainer).left;
          pos.offsetY = event.pageY - this.offset(target, scrollableContainer).top;
          pos.startX = pos.lastX = event.pageX;
          pos.startY = pos.lastY = event.pageY;
          pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
          pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
          return pos;
        },

        /**
         * Calculates the event position and sets the direction
         * properties.
         *
         * @param pos the current position of the element.
         * @param event the move event.
         */
        calculatePosition: function (pos, event) {
          // mouse position last events
          pos.lastX = pos.nowX;
          pos.lastY = pos.nowY;

          // mouse position this events
          pos.nowX = event.pageX;
          pos.nowY = event.pageY;

          // distance mouse moved between events
          pos.distX = pos.nowX - pos.lastX;
          pos.distY = pos.nowY - pos.lastY;

          // direction mouse was moving
          pos.lastDirX = pos.dirX;
          pos.lastDirY = pos.dirY;

          // direction mouse is now moving (on both axis)
          pos.dirX = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
          pos.dirY = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;

          // axis mouse is now moving on
          var newAx = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;

          // calc distance moved on this axis (and direction)
          if (pos.dirAx !== newAx) {
            pos.distAxX = 0;
            pos.distAxY = 0;
          } else {
            pos.distAxX += Math.abs(pos.distX);
            if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
              pos.distAxX = 0;
            }

            pos.distAxY += Math.abs(pos.distY);
            if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
              pos.distAxY = 0;
            }
          }
          pos.dirAx = newAx;
        },

        /**
         * Move the position by applying style.
         *
         * @param event the event object
         * @param element - the dom element
         * @param pos - current position
         * @param container - the bounding container.
         * @param containerPositioning - absolute or relative positioning.
         * @param {Object} [scrollableContainer] (optional) Scrollable container object
         */
        movePosition: function (event, element, pos, container, containerPositioning, scrollableContainer) {
          var bounds;
          var useRelative = (containerPositioning === 'relative');

          element.x = event.pageX - pos.offsetX;
          element.y = event.pageY - pos.offsetY;

          if (container) {
            bounds = this.offset(container, scrollableContainer);

            if (useRelative) {
              // reduce positioning by bounds
              element.x -= bounds.left;
              element.y -= bounds.top;

              // reset bounds
              bounds.left = 0;
              bounds.top = 0;
            }

            if (element.x < bounds.left) {
              element.x = bounds.left;
            } else if (element.x >= bounds.width + bounds.left - this.offset(element).width) {
              element.x = bounds.width + bounds.left - this.offset(element).width;
            }
            if (element.y < bounds.top) {
              element.y = bounds.top;
            } else if (element.y >= bounds.height + bounds.top - this.offset(element).height) {
              element.y = bounds.height + bounds.top - this.offset(element).height;
            }
          }

          element.css({
            'left': element.x + 'px',
            'top': element.y + 'px'
          });

          this.calculatePosition(pos, event);
        },

        /**
         * The drag item info and functions.
         * retains the item info before and after move.
         * holds source item and target scope.
         *
         * @param item - the drag item
         * @returns {{index: *, parent: *, source: *,
                 *          sourceInfo: {index: *, itemScope: (*|.dragItem.sourceInfo.itemScope|$scope.itemScope|itemScope), sortableScope: *},
                 *         moveTo: moveTo, isSameParent: isSameParent, isOrderChanged: isOrderChanged, eventArgs: eventArgs, apply: apply}}
         */
        dragItem: function (item) {

          return {
            index: item.index(),
            parent: item.sortableScope,
            source: item,
            targetElement: null,
            targetElementOffset: null,
            sourceInfo: {
              index: item.index(),
              itemScope: item.itemScope,
              sortableScope: item.sortableScope
            },
            canMove: function(itemPosition, targetElement, targetElementOffset) {
              // return true if targetElement has been changed since last call
              if (this.targetElement !== targetElement) {
                this.targetElement = targetElement;
                this.targetElementOffset = targetElementOffset;
                return true;
              }
              // return true if mouse is moving in the last moving direction of targetElement
              if (itemPosition.dirX * (targetElementOffset.left - this.targetElementOffset.left) > 0 ||
                  itemPosition.dirY * (targetElementOffset.top - this.targetElementOffset.top) > 0) {
                this.targetElementOffset = targetElementOffset;
                return true;
              }
              // return false otherwise
              return false;
            },
            moveTo: function (parent, index) {
              // move the item to a new position
              this.parent = parent;
              // if the source item is in the same parent, the target index is after the source index and we're not cloning
              if (this.isSameParent() && this.source.index() < index && !this.sourceInfo.sortableScope.cloning) {
                index = index - 1;
              }
              this.index = index;
            },
            isSameParent: function () {
              return this.parent.element === this.sourceInfo.sortableScope.element;
            },
            isOrderChanged: function () {
              return this.index !== this.sourceInfo.index;
            },
            eventArgs: function () {
              return {
                source: this.sourceInfo,
                dest: {
                  index: this.index,
                  sortableScope: this.parent
                }
              };
            },
            apply: function () {
              if (!this.sourceInfo.sortableScope.cloning) {
                // if not cloning, remove the item from the source model.
                this.sourceInfo.sortableScope.removeItem(this.sourceInfo.index);

                // if the dragged item is not already there, insert the item. This avoids ng-repeat dupes error
                if (this.parent.options.allowDuplicates || this.parent.modelValue.indexOf(this.source.modelValue) < 0) {
                  this.parent.insertItem(this.index, this.source.modelValue);
                }
              } else if (!this.parent.options.clone) { // prevent drop inside sortables that specify options.clone = true
                // clone the model value as well
                this.parent.insertItem(this.index, angular.copy(this.source.modelValue));
              }
            }
          };
        },

        /**
         * Check the drag is not allowed for the element.
         *
         * @param element - the element to check
         * @returns {boolean} - true if drag is not allowed.
         */
        noDrag: function (element) {
          return element.attr('no-drag') !== undefined || element.attr('data-no-drag') !== undefined;
        },

        /**
         * Helper function to find the first ancestor with a given selector
         * @param el - angular element to start looking at
         * @param selector - selector to find the parent
         * @returns {Object} - Angular element of the ancestor or body if not found
         * @private
         */
        findAncestor: function (el, selector) {
          el = el[0];
          var matches = Element.matches || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector;
          while ((el = el.parentElement) && !matches.call(el, selector)) {
          }
          return el ? angular.element(el) : angular.element(document.body);
        }
      };
    }
  ]);

}());

/*jshint undef: false, unused: false, indent: 2*/
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('as.sortable');

  /**
   * Controller for Sortable.
   * @param $scope - the sortable scope.
   */
  mainModule.controller('as.sortable.sortableController', ['$scope', function ($scope) {

    this.scope = $scope;

    $scope.modelValue = null; // sortable list.
    $scope.callbacks = null;
    $scope.type = 'sortable';
    $scope.options = {
      longTouch: false
    };
    $scope.isDisabled = false;

    /**
     * Inserts the item in to the sortable list.
     *
     * @param index - the item index.
     * @param itemData - the item model data.
     */
    $scope.insertItem = function (index, itemData) {
      if ($scope.options.allowDuplicates) {
        $scope.modelValue.splice(index, 0, angular.copy(itemData));
      } else {
        $scope.modelValue.splice(index, 0, itemData);
      }
    };

    /**
     * Removes the item from the sortable list.
     *
     * @param index - index to be removed.
     * @returns {*} - removed item.
     */
    $scope.removeItem = function (index) {
      var removedItem = null;
      if (index > -1) {
        removedItem = $scope.modelValue.splice(index, 1)[0];
      }
      return removedItem;
    };

    /**
     * Checks whether the sortable list is empty.
     *
     * @returns {null|*|$scope.modelValue|boolean}
     */
    $scope.isEmpty = function () {
      return ($scope.modelValue && $scope.modelValue.length === 0);
    };

    /**
     * Wrapper for the accept callback delegates to callback.
     *
     * @param sourceItemHandleScope - drag item handle scope.
     * @param destScope - sortable target scope.
     * @param destItemScope - sortable destination item scope.
     * @returns {*|boolean} - true if drop is allowed for the drag item in drop target.
     */
    $scope.accept = function (sourceItemHandleScope, destScope, destItemScope) {
      return $scope.callbacks.accept(sourceItemHandleScope, destScope, destItemScope);
    };

  }]);

  /**
   * Sortable directive - defines callbacks.
   * Parent directive for draggable and sortable items.
   * Sets modelValue, callbacks, element in scope.
   * sortOptions also includes a longTouch option which activates longTouch when set to true (default is false).
   */
  mainModule.directive('asSortable',
    function () {
      return {
        require: 'ngModel', // get a hold of NgModelController
        restrict: 'A',
        scope: true,
        controller: 'as.sortable.sortableController',
        link: function (scope, element, attrs, ngModelController) {

          var ngModel, callbacks;

          ngModel = ngModelController;

          if (!ngModel) {
            return; // do nothing if no ng-model
          }

          // Set the model value in to scope.
          ngModel.$render = function () {
            scope.modelValue = ngModel.$modelValue;
          };
          //set the element in scope to be accessed by its sub scope.
          scope.element = element;
          element.data('_scope',scope); // #144, work with angular debugInfoEnabled(false)

          callbacks = {accept: null, orderChanged: null, itemMoved: null, dragStart: null, dragMove:null, dragCancel: null, dragEnd: null};

          /**
           * Invoked to decide whether to allow drop.
           *
           * @param sourceItemHandleScope - the drag item handle scope.
           * @param destSortableScope - the drop target sortable scope.
           * @param destItemScope - the drop target item scope.
           * @returns {boolean} - true if allowed for drop.
           */
          callbacks.accept = function (sourceItemHandleScope, destSortableScope, destItemScope) {
            return true;
          };

          /**
           * Invoked when order of a drag item is changed.
           *
           * @param event - the event object.
           */
          callbacks.orderChanged = function (event) {
          };

          /**
           * Invoked when the item is moved to other sortable.
           *
           * @param event - the event object.
           */
          callbacks.itemMoved = function (event) {
          };

          /**
           * Invoked when the drag started successfully.
           *
           * @param event - the event object.
           */
          callbacks.dragStart = function (event) {
          };

          /**
           * Invoked when the drag move.
           *
           * @param itemPosition - the item position.
           * @param containment - the containment element.
           * @param eventObj - the event object.
          */
          callbacks.dragMove = angular.noop;

          /**
           * Invoked when the drag cancelled.
           *
           * @param event - the event object.
           */
          callbacks.dragCancel = function (event) {
          };

          /**
           * Invoked when the drag stopped.
           *
           * @param event - the event object.
           */
          callbacks.dragEnd = function (event) {
          };

          //Set the sortOptions callbacks else set it to default.
          scope.$watch(attrs.asSortable, function (newVal, oldVal) {
            angular.forEach(newVal, function (value, key) {
              if (callbacks[key]) {
                if (typeof value === 'function') {
                  callbacks[key] = value;
                }
              } else {
                scope.options[key] = value;
              }
            });
            scope.callbacks = callbacks;
          }, true);

          // Set isDisabled if attr is set, if undefined isDisabled = false
          if (angular.isDefined(attrs.isDisabled)) {
            scope.$watch(attrs.isDisabled, function (newVal, oldVal) {
              if (!angular.isUndefined(newVal)) {
                scope.isDisabled = newVal;
              }
            }, true);
          }
        }
      };
    });

}());

/*jshint indent: 2 */
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('as.sortable');

  /**
   * Controller for sortableItemHandle
   *
   * @param $scope - item handle scope.
   */
  mainModule.controller('as.sortable.sortableItemHandleController', ['$scope', function ($scope) {

    this.scope = $scope;

    $scope.itemScope = null;
    $scope.type = 'handle';
  }]);

  //Check if a node is parent to another node
  function isParent(possibleParent, elem) {
    if(!elem || elem.nodeName === 'HTML') {
      return false;
    }

    if(elem.parentNode === possibleParent) {
      return true;
    }

    return isParent(possibleParent, elem.parentNode);
  }

  /**
   * Directive for sortable item handle.
   */
  mainModule.directive('asSortableItemHandle', ['sortableConfig', '$helper', '$window', '$document', '$timeout',
    function (sortableConfig, $helper, $window, $document, $timeout) {
      return {
        require: '^asSortableItem',
        scope: true,
        restrict: 'A',
        controller: 'as.sortable.sortableItemHandleController',
        link: function (scope, element, attrs, itemController) {

          var dragElement, //drag item element.
            placeHolder, //place holder class element.
            placeElement,//hidden place element.
            itemPosition, //drag item element position.
            dragItemInfo, //drag item data.
            containment,//the drag container.
            containerPositioning, // absolute or relative positioning.
            dragListen,// drag listen event.
            scrollableContainer, //the scrollable container
            dragStart,// drag start event.
            dragMove,//drag move event.
            dragEnd,//drag end event.
            dragCancel,//drag cancel event.
            isDraggable,//is element draggable.
            placeHolderIndex,//placeholder index in items elements.
            bindDrag,//bind drag events.
            unbindDrag,//unbind drag events.
            bindEvents,//bind the drag events.
            unBindEvents,//unbind the drag events.
            hasTouch,// has touch support.
            isIOS,// is iOS device.
            longTouchStart, // long touch start event
            longTouchCancel, // cancel long touch
            longTouchTimer, // timer promise for the long touch on iOS devices
            dragHandled, //drag handled.
            createPlaceholder,//create place holder.
            isPlaceHolderPresent,//is placeholder present.
            isDisabled = false, // drag enabled
            escapeListen, // escape listen event
            isLongTouch = false; //long touch disabled.

          hasTouch = 'ontouchstart' in $window;
          isIOS = /iPad|iPhone|iPod/.test($window.navigator.userAgent) && !$window.MSStream;

          if (sortableConfig.handleClass) {
            element.addClass(sortableConfig.handleClass);
          }

          scope.itemScope = itemController.scope;
          element.data('_scope', scope); // #144, work with angular debugInfoEnabled(false)

          scope.$watchGroup(['sortableScope.isDisabled', 'sortableScope.options.longTouch'],
              function (newValues) {
            if (isDisabled !== newValues[0]) {
              isDisabled = newValues[0];
              if (isDisabled) {
                unbindDrag();
              } else {
                bindDrag();
              }
            } else if (isLongTouch !== newValues[1]) {
              isLongTouch = newValues[1];
              unbindDrag();
              bindDrag();
            } else {
              bindDrag();
            }
          });

          scope.$on('$destroy', function () {
            angular.element($document[0].body).unbind('keydown', escapeListen);
          });

          createPlaceholder = function (itemScope) {
            if (typeof scope.sortableScope.options.placeholder === 'function') {
              return angular.element(scope.sortableScope.options.placeholder(itemScope));
            } else if (typeof scope.sortableScope.options.placeholder === 'string') {
              return angular.element(scope.sortableScope.options.placeholder);
            } else {
              return angular.element($document[0].createElement(itemScope.element.prop('tagName')));
            }
          };

          /**
           * Listens for a 10px movement before
           * dragStart is called to allow for
           * a click event on the element.
           *
           * @param event - the event object.
           */
          dragListen = function (event) {

            var unbindMoveListen = function () {
              angular.element($document).unbind('mousemove', moveListen);
              angular.element($document).unbind('touchmove', moveListen);
              element.unbind('mouseup', unbindMoveListen);
              element.unbind('touchend', unbindMoveListen);
              element.unbind('touchcancel', unbindMoveListen);
            };

            var startPosition;
            var moveListen = function (e) {
              e.preventDefault();
              var eventObj = $helper.eventObj(e);
              if (!startPosition) {
                startPosition = { clientX: eventObj.clientX, clientY: eventObj.clientY };
              }
              if (Math.abs(eventObj.clientX - startPosition.clientX) + Math.abs(eventObj.clientY - startPosition.clientY) > 10) {
                unbindMoveListen();
                dragStart(event);
              }
            };

            angular.element($document).bind('mousemove', moveListen);
            angular.element($document).bind('touchmove', moveListen);
            element.bind('mouseup', unbindMoveListen);
            element.bind('touchend', unbindMoveListen);
            element.bind('touchcancel', unbindMoveListen);
            event.stopPropagation();
          };

          /**
           * Triggered when drag event starts.
           *
           * @param event the event object.
           */
          dragStart = function (event) {

            var eventObj, tagName;

            if (!hasTouch && (event.button === 2 || event.which === 3)) {
              // disable right click
              return;
            }
            if (hasTouch && $helper.isTouchInvalid(event)) {
              return;
            }
            if (dragHandled || !isDraggable(event)) {
              // event has already fired in other scope.
              return;
            }
            // Set the flag to prevent other items from inheriting the drag event
            dragHandled = true;
            event.preventDefault();
            eventObj = $helper.eventObj(event);
            scope.sortableScope = scope.sortableScope || scope.itemScope.sortableScope; //isolate directive scope issue.
            scope.callbacks = scope.callbacks || scope.itemScope.callbacks; //isolate directive scope issue.

            if (scope.itemScope.sortableScope.options.clone || (scope.itemScope.sortableScope.options.ctrlClone && event.ctrlKey)) {
                // Clone option is true
                // or Ctrl clone option is true & the ctrl key was pressed when the user innitiated drag
              scope.itemScope.sortableScope.cloning = true;
            } else {
              scope.itemScope.sortableScope.cloning = false;
            }

            // (optional) Scrollable container as reference for top & left offset calculations, defaults to Document
            scrollableContainer = angular.element($document[0].querySelector(scope.sortableScope.options.scrollableContainer)).length > 0 ?
              $document[0].querySelector(scope.sortableScope.options.scrollableContainer) : $document[0].documentElement;

            containment = (scope.sortableScope.options.containment)? $helper.findAncestor(element, scope.sortableScope.options.containment):angular.element($document[0].body);
            //capture mouse move on containment.
            containment.css('cursor', 'move');
            containment.css('cursor', '-webkit-grabbing');
            containment.css('cursor', '-moz-grabbing');
            containment.addClass('as-sortable-un-selectable');

            // container positioning
            containerPositioning = scope.sortableScope.options.containerPositioning || 'absolute';

            dragItemInfo = $helper.dragItem(scope);
            tagName = scope.itemScope.element.prop('tagName');

            dragElement = angular.element($document[0].createElement(scope.sortableScope.element.prop('tagName')))
              .addClass(scope.sortableScope.element.attr('class')).addClass(sortableConfig.dragClass);
            dragElement.css('width', $helper.width(scope.itemScope.element) + 'px');
            dragElement.css('height', $helper.height(scope.itemScope.element) + 'px');

            placeHolder = createPlaceholder(scope.itemScope)
              .addClass(sortableConfig.placeHolderClass).addClass(scope.sortableScope.options.additionalPlaceholderClass);
            placeHolder.css('width', $helper.width(scope.itemScope.element) + 'px');
            placeHolder.css('height', $helper.height(scope.itemScope.element) + 'px');

            placeElement = angular.element($document[0].createElement(tagName));
            if (sortableConfig.hiddenClass) {
              placeElement.addClass(sortableConfig.hiddenClass);
            }

            itemPosition = $helper.positionStarted(eventObj, scope.itemScope.element, scrollableContainer);

            // fill the immediate vacuum.
            if (!scope.itemScope.sortableScope.options.clone) {
              scope.itemScope.element.after(placeHolder);
            }

            if (scope.itemScope.sortableScope.cloning) {
              // clone option is enabled or triggered, so clone the element.
              dragElement.append(scope.itemScope.element.clone());
            }
            else {
              // add hidden placeholder element in original position.
              scope.itemScope.element.after(placeElement);
              // not cloning, so use the original element.
              dragElement.append(scope.itemScope.element);
            }

            containment.append(dragElement);
            $helper.movePosition(eventObj, dragElement, itemPosition, containment, containerPositioning, scrollableContainer);

            scope.sortableScope.$apply(function () {
              scope.callbacks.dragStart(dragItemInfo.eventArgs());
            });
            bindEvents();
          };

          /**
           * Allow Drag if it is a proper item-handle element.
           *
           * @param event - the event object.
           * @return boolean - true if element is draggable.
           */
          isDraggable = function (event) {

            var elementClicked, sourceScope, isDraggable;

            elementClicked = angular.element(event.target);

            // look for the handle on the current scope or parent scopes
            sourceScope = fetchScope(elementClicked);

            isDraggable = (sourceScope && sourceScope.type === 'handle');

            //If a 'no-drag' element inside item-handle if any.
            while (isDraggable && elementClicked[0] !== element[0]) {
              if ($helper.noDrag(elementClicked)) {
                isDraggable = false;
              }
              elementClicked = elementClicked.parent();
            }
            return isDraggable;
          };

          /**
           * Inserts the placeHolder in to the targetScope.
           *
           * @param targetElement the target element
           * @param targetScope the target scope
           */
          function insertBefore(targetElement, targetScope) {
            // Ensure the placeholder is visible in the target (unless it's a table row)
            if (placeHolder.css('display') !== 'table-row') {
              placeHolder.css('display', 'block');
            }
            if (!targetScope.sortableScope.options.clone) {
              targetElement[0].parentNode.insertBefore(placeHolder[0], targetElement[0]);
              dragItemInfo.moveTo(targetScope.sortableScope, targetScope.index());
            }
          }

          /**
           * Inserts the placeHolder next to the targetScope.
           *
           * @param targetElement the target element
           * @param targetScope the target scope
           */
          function insertAfter(targetElement, targetScope) {
            // Ensure the placeholder is visible in the target (unless it's a table row)
            if (placeHolder.css('display') !== 'table-row') {
              placeHolder.css('display', 'block');
            }
            if (!targetScope.sortableScope.options.clone) {
              targetElement.after(placeHolder);
              dragItemInfo.moveTo(targetScope.sortableScope, targetScope.index() + 1);
            }
          }

          /**
           * Triggered when drag is moving.
           *
           * @param event - the event object.
           */
          dragMove = function (event) {

            var eventObj, targetX, targetY, targetScope, targetElement;

            if (hasTouch && $helper.isTouchInvalid(event)) {
              return;
            }
            // Ignore event if not handled
            if (!dragHandled) {
              return;
            }
            if (dragElement) {

              event.preventDefault();

              eventObj = $helper.eventObj(event);

              // checking if dragMove callback exists, to prevent application
              // rerenderings on each mouse move event
              if (scope.callbacks.dragMove !== angular.noop) {
                scope.sortableScope.$apply(function () {
                  scope.callbacks.dragMove(itemPosition, containment, eventObj);
                });
              }

              targetX = eventObj.pageX - $document[0].documentElement.scrollLeft;
              targetY = eventObj.pageY - ($window.pageYOffset || $document[0].documentElement.scrollTop);

              //IE fixes: hide show element, call element from point twice to return pick correct element.
              dragElement.addClass(sortableConfig.hiddenClass);
              targetElement = angular.element($document[0].elementFromPoint(targetX, targetY));
              dragElement.removeClass(sortableConfig.hiddenClass);

              $helper.movePosition(eventObj, dragElement, itemPosition, containment, containerPositioning, scrollableContainer);

              //Set Class as dragging starts
              dragElement.addClass(sortableConfig.dragging);

              targetScope = fetchScope(targetElement);

              if (!targetScope || !targetScope.type) {
                return;
              }
              if (targetScope.type === 'handle') {
                targetScope = targetScope.itemScope;
              }
              if (targetScope.type !== 'item' && targetScope.type !== 'sortable') {
                return;
              }

              if (targetScope.type === 'item' && targetScope.accept(scope, targetScope.sortableScope, targetScope)) {
                // decide where to insert placeholder based on target element and current placeholder if is present
                targetElement = targetScope.element;

                // Fix #241 Drag and drop have trembling with blocks of different size
                var targetElementOffset = $helper.offset(targetElement, scrollableContainer);
                if (!dragItemInfo.canMove(itemPosition, targetElement, targetElementOffset)) {
                  return;
                }

                var placeholderIndex = placeHolderIndex(targetScope.sortableScope.element);
                if (placeholderIndex < 0) {
                  insertBefore(targetElement, targetScope);
                } else {
                  if (placeholderIndex <= targetScope.index()) {
                    insertAfter(targetElement, targetScope);
                  } else {
                    insertBefore(targetElement, targetScope);
                  }
                }
              }

              if (targetScope.type === 'sortable') {//sortable scope.
                if (targetScope.accept(scope, targetScope) &&
                  !isParent(targetScope.element[0], targetElement[0])) {
                  //moving over sortable bucket. not over item.
                  if (!isPlaceHolderPresent(targetElement) && !targetScope.options.clone) {
                    targetElement[0].appendChild(placeHolder[0]);
                    dragItemInfo.moveTo(targetScope, targetScope.modelValue.length);
                  }
                }
              }
            }
          };


          /**
           * Fetch scope from element or parents
           * @param  {object} element Source element
           * @return {object}         Scope, or null if not found
           */
          function fetchScope(element) {
            var scope;
            while (!scope && element.length) {
              scope = element.data('_scope');
              if (!scope) {
                element = element.parent();
              }
            }
            return scope;
          }


          /**
           * Get position of place holder among item elements in itemScope.
           * @param targetElement the target element to check with.
           * @returns {*} -1 if placeholder is not present, index if yes.
           */
          placeHolderIndex = function (targetElement) {
            var itemElements, i;
            // targetElement is placeHolder itself, return index 0
            if (targetElement.hasClass(sortableConfig.placeHolderClass)){
              return 0;
            }
            // find index in target children
            itemElements = targetElement.children();
            for (i = 0; i < itemElements.length; i += 1) {
              //TODO may not be accurate when elements contain other siblings than item elements
              //solve by adding 1 to model index of previous item element
              if (angular.element(itemElements[i]).hasClass(sortableConfig.placeHolderClass)) {
                return i;
              }
            }
            return -1;
          };


          /**
           * Check there is no place holder placed by itemScope.
           * @param targetElement the target element to check with.
           * @returns {*} true if place holder present.
           */
          isPlaceHolderPresent = function (targetElement) {
            return placeHolderIndex(targetElement) >= 0;
          };

          /**
           * Rollback the drag data changes.
           */

          function rollbackDragChanges() {
            if (!scope.itemScope.sortableScope.cloning) {
              placeElement.replaceWith(scope.itemScope.element);
            }
            placeHolder.remove();
            dragElement.remove();
            dragElement = null;
            dragHandled = false;
            containment.css('cursor', '');
            containment.removeClass('as-sortable-un-selectable');
          }

          /**
           * triggered while drag ends.
           *
           * @param event - the event object.
           */
          dragEnd = function (event) {
            // Ignore event if not handled
            if (!dragHandled) {
              return;
            }
            event.preventDefault();
            if (dragElement) {
              //rollback all the changes.
              rollbackDragChanges();
              // update model data
              dragItemInfo.apply();
              scope.sortableScope.$apply(function () {
                if (dragItemInfo.isSameParent()) {
                  if (dragItemInfo.isOrderChanged()) {
                    scope.callbacks.orderChanged(dragItemInfo.eventArgs());
                  }
                } else {
                  scope.callbacks.itemMoved(dragItemInfo.eventArgs());
                }
              });
              scope.sortableScope.$apply(function () {
                scope.callbacks.dragEnd(dragItemInfo.eventArgs());
              });
              dragItemInfo = null;
            }
            unBindEvents();
          };

          /**
           * triggered while drag is cancelled.
           *
           * @param event - the event object.
           */
          dragCancel = function (event) {
            // Ignore event if not handled
            if (!dragHandled) {
              return;
            }
            event.preventDefault();

            if (dragElement) {
              //rollback all the changes.
              rollbackDragChanges();
              scope.sortableScope.$apply(function () {
                scope.callbacks.dragCancel(dragItemInfo.eventArgs());
              });
              dragItemInfo = null;
            }
            unBindEvents();
          };

          /**
           * Binds the drag start events.
           */
          bindDrag = function () {
            if (hasTouch) {
              if (isLongTouch) {
                if (isIOS) {
                  element.bind('touchstart', longTouchStart);
                  element.bind('touchend', longTouchCancel);
                  element.bind('touchmove', longTouchCancel);
                } else {
                  element.bind('contextmenu', dragListen);
                }
              } else {
                element.bind('touchstart', dragListen);
              }
            }
            element.bind('mousedown', dragListen);
          };

          /**
           * Unbinds the drag start events.
           */
          unbindDrag = function () {
            element.unbind('touchstart', longTouchStart);
            element.unbind('touchend', longTouchCancel);
            element.unbind('touchmove', longTouchCancel);
            element.unbind('contextmenu', dragListen);
            element.unbind('touchstart', dragListen);
            element.unbind('mousedown', dragListen);
          };

          /**
           * starts a timer to detect long touch on iOS devices. If touch held for more than 500ms,
           * it would be considered as long touch.
           *
           * @param event - the event object.
           */
          longTouchStart = function(event) {
            longTouchTimer = $timeout(function() {
              dragListen(event);
            }, 500);
          };

          /**
           * cancel the long touch and its timer.
           */
          longTouchCancel = function() {
            $timeout.cancel(longTouchTimer);
          };

          //bind drag start events.
          //put in a watcher since this method is now depending on the longtouch option from sortable.sortOptions
          //bindDrag();

          //Cancel drag on escape press.
          escapeListen = function (event) {
            if (event.keyCode === 27) {
              dragCancel(event);
            }
          };
          angular.element($document[0].body).bind('keydown', escapeListen);

          /**
           * Binds the events based on the actions.
           */
          bindEvents = function () {
            angular.element($document).bind('touchmove', dragMove);
            angular.element($document).bind('touchend', dragEnd);
            angular.element($document).bind('touchcancel', dragCancel);
            angular.element($document).bind('mousemove', dragMove);
            angular.element($document).bind('mouseup', dragEnd);
          };

          /**
           * Un binds the events for drag support.
           */
          unBindEvents = function () {
            angular.element($document).unbind('touchend', dragEnd);
            angular.element($document).unbind('touchcancel', dragCancel);
            angular.element($document).unbind('touchmove', dragMove);
            angular.element($document).unbind('mouseup', dragEnd);
            angular.element($document).unbind('mousemove', dragMove);
          };
        }
      };
    }]);
}());

/*jshint indent: 2 */
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('as.sortable');

  /**
   * Controller for sortable item.
   *
   * @param $scope - drag item scope
   */
  mainModule.controller('as.sortable.sortableItemController', ['$scope', function ($scope) {

    this.scope = $scope;

    $scope.sortableScope = null;
    $scope.modelValue = null; // sortable item.
    $scope.type = 'item';

    /**
     * returns the index of the drag item from the sortable list.
     *
     * @returns {*} - index value.
     */
    $scope.index = function () {
      return $scope.$index;
    };

    /**
     * Returns the item model data.
     *
     * @returns {*} - item model value.
     */
    $scope.itemData = function () {
      return $scope.sortableScope.modelValue[$scope.$index];
    };

  }]);

  /**
   * sortableItem directive.
   */
  mainModule.directive('asSortableItem', ['sortableConfig',
    function (sortableConfig) {
      return {
        require: ['^asSortable', '?ngModel'],
        restrict: 'A',
        controller: 'as.sortable.sortableItemController',
        link: function (scope, element, attrs, ctrl) {
          var sortableController = ctrl[0];
          var ngModelController = ctrl[1];
          if (sortableConfig.itemClass) {
            element.addClass(sortableConfig.itemClass);
          }
          scope.sortableScope = sortableController.scope;
          if (ngModelController) {
            ngModelController.$render = function () {
              scope.modelValue = ngModelController.$modelValue;
            };
          } else {
            scope.modelValue = sortableController.scope.modelValue[scope.$index];
          }
          scope.element = element;
          element.data('_scope',scope); // #144, work with angular debugInfoEnabled(false)
        }
      };
    }]);

}());

(function () {
  "use strict";
  webapp.directive('fileDropzone', function() {
  return {
    restrict: 'A',
    scope: {
      file: '=',
      fileName: '='
    },
    link: function(scope, element, attrs) {
      var checkSize,
          isTypeValid,
          processDragOverOrEnter,
          validMimeTypes;

      processDragOverOrEnter = function (event) {
        if (event != null) {
          event.preventDefault();
        }
        if(enableUploadComponent()) {
          var $obj = $(".dhx-dropable-area.drop-files-here");
          if($obj.length == 0) $obj = $(".dhx-files-block.dhx-webkit-scroll");
          if( $obj.length > 0) {
            $obj.closest(".layout_y").addClass('dhx-dragin');
          }
        }
        return false;
      };

      validMimeTypes = attrs.fileDropzone;
      element.bind('dragover', processDragOverOrEnter);
      element.bind('dragenter', processDragOverOrEnter);
      element.hover(function(){

      }, function(){
        var $obj = $(".dhx-dropable-area.drop-files-here");
        $obj.closest(".layout_y").removeClass('dhx-dragin');
      });


      return element.bind('drop', function(event) {
        console.log("drop");

        return false;
      });
    }
  };
});
}());

(function () {
  "use strict";
  webapp.directive('inputEnter', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.inputEnter);
          });
          event.preventDefault();
        }
      });
    }
  });
}());

(function () {
  "use strict";
  webapp.directive('krInput', ['$parse', function($parse) {
    return {
        priority : 2,
        restrict : 'A',
        compile : function(element) {
            element.on('compositionstart', function(e) { e.stopImmediatePropagation(); });
        },
    };
  }]);
}());

(function () {
  "use strict";
  webapp.directive('krTextarea', ['$parse', function($parse) {
    return {
      restrict: 'E',
      compile : function(element) {
        element.on('compositionstart', function(e) { e.stopImmediatePropagation(); });
        //element.on('compositionupdate', function(e) { e.triggerHandler('compositionend'); }); // 위에꺼 안되면 이걸로 시도
      },
    };
  }]);
}());

webapp.directive('modalDrag', function(){
  return {
    restrict: 'A',
    link : function(scope, element, attr){
      element.parent().addClass('dragging');
      angular.element('.dragging').draggable({
        handle : '.modal-header',
        scroll:false
      });
    }
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:activateButton
 * @description
 * # activateButton
 */
webapp.directive('permission', [ 'Auth', function(Auth) {
  return {
    restrict : 'A',
    scope : {
      permission : '=',
    },

    link : function(scope, elem, attrs) {
      scope.$watch(attrs.ngShow, function() {
        /* console.log('scope.permission=', scope.permission); */
        if (Auth.userHasPermission(scope.permission)) {
          elem.show();
        } else {
          elem.hide();
        }
      });
    }
  }
} ]);

/* 'use strict'; */

/**
 * @ngdoc directive
 * @name minovateApp.directive:tileControlToggle
 * @description
 * # tileControlToggle
 */
webapp.directive('tileControlToggle', function () {
    return {
      restrict: 'A',
      link: function postLink(scope, element) {
        var tile = element.parents('.tile').eq(0);

        element.on('click', function(){
          tile.toggleClass('collapsed');
          tile.children().not('.tile-header').slideToggle(150);
        });
      }
    };
  });


function setTmpFileKey(fileKeys) {
	angular.element($(".fileAttachArea")).scope().modalCtrl.fileKeys = fileKeys;
};

webapp.filter('byteCheck', function () {
	return function(text,b,i,c){
		if(angular.isUndefined(text)) return 0;
		for(b=i=0;c=text.charCodeAt(i++);b+=c>>11?3:c>>7?2:1);
		return b;
	}
});

/**
 * Usage
 * {{text|byteCheck}} / 2000byte
 * Output
 * "12 / 2000byte"
 *
 */

// add the filter to your application module
webapp.filter('filesize', function ($sce) {
		return function (bytes) {
	        if(bytes < 1024) return bytes + " Bytes";
	        else if(bytes < 1048576) return(bytes / 1024).toFixed(2) + " KB";
	        else if(bytes < 1073741824) return(bytes / 1048576).toFixed(2) + " MB";
	        else return(bytes / 1073741824).toFixed(2) + " GB";
		};
	});
/**
 * Usage
 * var myFile = 5678;
 *
 * {{myText|filesize}}
 *
 * Output
 * "5.54 Kb"
 *
 */


webapp.filter('htmlString', function($sce){
	return function(val){
		if(val) {
			return $sce.trustAsHtml(val);
		}else{
		    return val;
		}
	};
});


(function() {
  "use strict";

  webapp.filter("localToUtc", Filter);

  function Filter($filter) {
    return function(localeDateString, type, timezoneOffset) {
      var localeDate;
      var utcDate;
      var toUtcDate = "";

      if (!localeDateString) {
        return;
      }

      if (typeof localeDateString === "string" && localeDateString != "") {
        var dateArr = localeDateString.split("-");
        if (dateArr.length == 3) {
          localeDate = new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2], 0, 0, 0);
        }
      } else if (typeof localeDateString === "object" && localeDateString instanceof Date) {
        localeDate = localeDateString;
      } else {
        return "";
      }

      if (timezoneOffset == undefined) {
        if (!type) {
          utcDate = new Date(localeDate.getTime() + (localeDate.getTimezoneOffset() * 60000));
        } else if (type == 'from') {
          utcDate = new Date(localeDate.getTime() + (localeDate.getTimezoneOffset() * 60000));
        } else if (type == 'to') {
          utcDate = new Date(localeDate.getTime() + (localeDate.getTimezoneOffset() * 60000) + 86399000);
        }
      } else {
        if (!type) {
          utcDate = new Date(localeDate.getTime() + (-1 * timezoneOffset * 60 * 60000));
        } else if (type == 'from') {
          utcDate = new Date(localeDate.getTime() + (-1 * timezoneOffset * 60 * 60000));
        } else if (type == 'to') {
          utcDate = new Date(localeDate.getTime() + (-1 * timezoneOffset * 60 * 60000) + 86399000);
        }
      }

      toUtcDate = $filter("date")(utcDate, 'yyyy-MM-dd HH:mm:ss');

      return toUtcDate;
    };
  }
})();

/*!
 * nl2br필터는 carriage return 값을 html의 <br/>로 바꿔준다.
 * */
webapp.filter('nl2brString', function($sce){
    return function(val){
        if(angular.isString(val)) {
            return $sce.trustAsHtml(val.replace(/\n/g, '<br/>'));
        }else{
            return val;
        }
    };
});


/*!
 * url-encode필터는 url에서 사용하면 안되는 특수 문자를 인코딩해 주는 필터이다..
 * */
webapp.filter('toLocaleDate', ['$filter', '$window', 'StaticVariable', function($filter, $window, variables) {
    return function(dateNumber) {
        var localeDate;
        var toLocalDate = '';
//        $window.localStorage.loginUserLang 변경 필요.
        var format = variables.getDateFormat('ko', false);

        if(typeof dateNumber == 'string' && dateNumber != ''){
            localeDate = new Date(parseInt(dateNumber));
        }else if(typeof dateNumber == 'number'){
            localeDate = new Date(dateNumber);
        }else{
            return '';
        }

        if(format != ''){
            toLocalDate = $filter('date')(localeDate, format);
        }else{
            toLocalDate = localeDate.toLocaleDateString();
        }
        return toLocalDate;
    };
}]);

/*!
 * url-encode필터는 url에서 사용하면 안되는 특수 문자를 인코딩해 주는 필터이다..
 * */
webapp.filter('toLocaleDatetime', ['$filter', '$window', 'StaticVariable', function($filter, $window, variables) {
    return function(dateNumber) {

        var localeDate;
        var toLocalDate = '';
        var format = variables.getDateFormat($window.localStorage.loginUserLang, true);

        if(typeof dateNumber == 'string' && dateNumber != ''){
            localeDate = new Date(parseInt(dateNumber));
        }else if(typeof dateNumber == 'number'){
            localeDate = new Date(dateNumber);
        }else{
            return '';
        }

        if(format != ''){
            toLocalDate = $filter('date')(localeDate, format);
        }else{
            toLocalDate = localeDate.toLocaleDateString();
        }

        return toLocalDate;
    };
}]);

(function() {
  "use strict";

  webapp.filter("utcToLocal", Filter);

  function Filter($filter) {
    return function(utcDateString, format) {
      var localeDate;
      var toLocalDate = "";

      if (!utcDateString) {
        return;
      }

      if (typeof utcDateString == "string" && utcDateString != "") {
        localeDate = new Date(parseInt(utcDateString));
      } else if (typeof utcDateString == "number") {
        localeDate = new Date(utcDateString);
      } else {
        return "";
      }

      //localeDate += 'Z';

      if (format != "") {
        toLocalDate = $filter("date")(localeDate, format);
      } else {
        toLocalDate = localeDate.toLocaleDateString();
      }

      return toLocalDate;
    };
  }
})();



webapp.controller('mtSidenavCtrl', function($scope, $timeout, $mdSidenav, $mdUtil, $log) {

    $scope.page = {
      title: 'Sidenav',
      subtitle: 'Place subtitle here...'
    };

    $scope.toggleLeft = buildToggler('left');
    $scope.toggleRight = buildToggler('right');
    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildToggler(navID) {
      var debounceFn =  $mdUtil.debounce(function(){
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      },200);
      return debounceFn;
    }

  })

  .controller('mtSidenavLeftCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('left').close()
        .then(function () {
          $log.debug("close LEFT is done");
        });
    };
  })
  .controller('mtSidenavRightCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('right').close()
        .then(function () {
          $log.debug("close RIGHT is done");
        });
    };
  });





(function() {
  var module,
    __slice = [].slice;

  module = angular.module("fa.directive.borderLayout", []);

  module.factory("paneManager", function() {
    return {
      panes: {},
      get: function(paneId) {
        return this.panes[paneId];
      },
      set: function(paneId, pane) {
        return this.panes[paneId] = pane;
      },
      remove: function(paneId) {
        return delete this.panes[paneId];
      }
    };
  });

  module.directive("faPane", [
    "$window", "$rootScope", "paneManager", function($window, $rootScope, paneManager) {
      var Region, generateSerialId, getHandleStyle, getOrientation, getScrollerStyle;
      Region = (function() {
        function Region(_at_width, _at_height, _at_top, _at_right, _at_bottom, _at_left) {
          this.width = _at_width != null ? _at_width : 0;
          this.height = _at_height != null ? _at_height : 0;
          this.top = _at_top != null ? _at_top : 0;
          this.right = _at_right != null ? _at_right : 0;
          this.bottom = _at_bottom != null ? _at_bottom : 0;
          this.left = _at_left != null ? _at_left : 0;
        }

        Region.prototype.clone = function() {
          return new Region(this.width, this.height, this.top, this.right, this.bottom, this.left);
        };

        Region.prototype.calculateSize = function(orientation, target) {
          var available, matches, terms, total;
          if (target == null) {
            target = 0;
          }
          total = this.getSize(orientation);
          available = this.getAvailableSize(orientation);
          if (angular.isNumber(target)) {
            if (target >= 1) {
              return Math.round(target);
            }
            if (target >= 0) {
              return Math.round(target * total);
            }
            return 0;
          }
          target = target.replace(/\s+/mg, "");
          if ((terms = target.split("-")).length > 1) {
            return this.calculateSize(orientation, terms.shift()) - this.calculateSize(orientation, terms.join("+"));
          }
          if ((terms = target.split("+")).length > 1) {
            return this.calculateSize(orientation, terms.shift()) + this.calculateSize(orientation, terms.join("+"));
          }
          if (matches = target.match(/^(\d+)px$/)) {
            return parseInt(matches[1], 10);
          }
          if (matches = target.match(/^(\d+)$/)) {
            return parseInt(matches[1], 10);
          }
          if (matches = target.match(/^(\d+(?:\.\d+)?)&$/)) {
            return Math.round(available * parseFloat(matches[1]) / 100);
          }
          if (matches = target.match(/^(\d+(?:\.\d+)?)%$/)) {
            return Math.round(total * parseFloat(matches[1]) / 100);
          }
          throw new Error("Unsupported size: " + target);
        };

        Region.prototype.consume = function(anchor, size) {
          var style;
          if (size == null) {
            size = 0;
          }

          switch (anchor) {
            case "north":
              style = {
                top: this.top + "px",
                right: this.right + "px",
                bottom: "auto",
                left: this.left + "px",
                height: size + "px",
                width: "auto"
              };
              this.top += size;
              break;
            case "east":
              style = {
                top: this.top + "px",
                right: this.right + "px",
                bottom: this.bottom + "px",
                left: "auto",
                width: size + "px",
                height: "auto"
              };
              this.right += size;
              break;
            case "south":
              style = {
                top: "auto",
                right: this.right + "px",
                bottom: this.bottom + "px",
                left: this.left + "px",
                height: size + "px",
                width: "auto"
              };
              this.bottom += size;
              break;
            case "west":
              style = {
                top: this.top + "px",
                right: "auto",
                bottom: this.bottom + "px",
                left: this.left + "px",
                width: size + "px",
                height: "auto"
              };
              this.left += size;
          }
          if (size === 0) {
            style.display = "none";
          }
          return style;
        };

        Region.prototype.getInnerRegion = function() {
          return new Region(this.width - this.right - this.left, this.height - this.top - this.bottom);
        };

        Region.prototype.getSize = function(orientation) {
          switch (orientation) {
            case "vertical":
              return this.height;
            case "horizontal":
              return this.width;
          }
        };

        Region.prototype.getAvailableSize = function(orientation) {
          switch (orientation) {
            case "vertical":
              return this.height - this.top - this.bottom;
            case "horizontal":
              return this.width - this.right - this.left;
          }
        };

        Region.prototype.toString = function() {
          return "{" + this.top + ", " + this.right + ", " + this.bottom + ", " + this.left + "}, {" + this.width + ", " + this.height + "}";
        };

        return Region;

      })();
      getOrientation = function(anchor) {
        switch (anchor) {
          case "north":
          case "south":
            return "vertical";
          case "east":
          case "west":
            return "horizontal";
        }
      };
      getScrollerStyle = function(anchor, size) {
        var style;
        style = {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        };
        if (size) {
          switch (anchor) {
            case "north":
              style.bottom = "auto";
              style.height = size + "px";
              break;
            case "east":
              style.left = "auto";
              style.width = size + "px";
              break;
            case "south":
              style.top = "auto";
              style.height = size + "px";
              break;
            case "west":
              style.right = "auto";
              style.width = size + "px";
          }
        }
        return style;
      };
      getHandleStyle = function(anchor, region, handleSize) {
        switch (anchor) {
          case "north":
            return {
              height: (region.calculateSize('vertical', handleSize)) + "px",
              right: 0,
              left: 0,
              bottom: 0
            };
          case "south":
            return {
              height: (region.calculateSize('vertical', handleSize)) + "px",
              right: 0,
              left: 0,
              top: 0
            };
          case "east":
            return {
              width: (region.calculateSize('horizontal', handleSize)) + "px",
              top: 0,
              bottom: 0,
              left: 0
            };
          case "west":
            return {
              width: (region.calculateSize('horizontal', handleSize)) + "px",
              top: 0,
              bottom: 0,
              right: 0
            };
        }
      };
      generateSerialId = (function() {
        var counter, fun;
        counter = 0;
        fun = function() {
          return counter++;
        };
        fun.peek = function() {
          return counter;
        };
        return fun;
      })();
      return {
        restrict: "A",
        replace: true,
        require: "faPane",
        priority: 1,
        transclude: "element",
        scope: {
          anchor: "@paneAnchor",
          paneId: "@faPane",
          size: "@paneSize",
          min: "@paneMin",
          max: "@paneMax",
          handle: "@paneHandle",
          closed: "=paneClosed",
          closable: "@paneNoToggle"
        },
        template: "<div class=\"fa-pane pane-{{$pane.id}}\">\n  <div class=\"fa-pane-overlay\"></div>\n  <div class=\"fa-pane-handle\" fa-pane-resizer>\n    <div ng-if=\"!paneNotoggle\" class=\"fa-pane-toggle\" ng-click=\"$pane.toggle()\"></div>\n  </div>\n</div>",
        controllerAs: "$pane",
        controller: function() {
          var $pane, Pane;
          return $pane = new (Pane = (function() {
            function Pane() {
              this.children = [];
              this.closed = false;
              this.max = Number.MAX_VALUE;
              this.min = 0;
            }

            Pane.prototype.$scheduleReflow = function() {
              if ($pane.parent) {
                return $pane.parent.$scheduleReflow();
              } else if (!$pane.$reflowScheduled) {
                $pane.$reflowScheduled = true;
                return $rootScope.$evalAsync(function() {
                  if ($pane.$reflowScheduled) {
                    $pane.reflow();
                  }
                  return $pane.$reflowScheduled = false;
                });
              }
            };

            Pane.prototype.getOptions = function() {
              return {
                anchor: this.anchor,
                targetSize: this.targetSize,
                size: this.size,
                min: this.min,
                max: this.max,
                handle: {
                  open: this.handleSizeOpen || 0,
                  closed: this.handleSizeClosed || 0
                },
                closed: this.closed
              };
            };

            Pane.prototype.setOptions = function(options) {
              if (options == null) {
                options = {};
              }
              if (options.anchor != null) {
                this.setAnchor(options.anchor);
              }
              if (options.size != null) {
                this.setTargetSize(options.size);
              }
              if (options.min != null) {
                this.setMinSize(options.min);
              }
              if (options.max != null) {
                this.setMaxSize(options.max);
              }
              if (options.handle != null) {
                this.setHandleSize(options.handle);
              }
              if (options.closed != null) {
                return this.toggle(!options.closed);
              }
            };

            Pane.prototype.setAnchor = function(_at_anchor) {
              this.anchor = _at_anchor;
              return this.$scheduleReflow();
            };

            Pane.prototype.setTargetSize = function(_at_targetSize) {
              this.targetSize = _at_targetSize;
              return this.$scheduleReflow();
            };

            Pane.prototype.setMinSize = function(_at_min) {
              this.min = _at_min;
              return this.$scheduleReflow();
            };

            Pane.prototype.setMaxSize = function(_at_max) {
              this.max = _at_max;
              return this.$scheduleReflow();
            };

            Pane.prototype.setHandleSize = function(handleSize) {
              if ((handleSize != null ? handleSize.open : void 0) || (handleSize != null ? handleSize.closed : void 0)) {
                this.handleSizeOpen = handleSize.open || 0;
                this.handleSizeClosed = handleSize.closed || 0;
              } else {
                this.handleSizeOpen = this.handleSizeClosed = parseInt(handleSize, 10);
              }
              return this.$scheduleReflow();
            };

            Pane.prototype.addChild = function(child) {
              child.parent = $pane;
              this.children.push(child);
              if (this.children.length) {
                $pane.$containerEl.addClass("fa-pane-parent");
              }
              return $pane.$scheduleReflow();
            };

            Pane.prototype.getOrientation = function() {
              return getOrientation($pane.anchor);
            };

            Pane.prototype.onHandleDown = function() {
              return $pane.$containerEl.addClass("active");
            };

            Pane.prototype.onHandleUp = function() {
              $pane.$containerEl.removeClass("active");
              return $pane.$scheduleReflow();
            };

            Pane.prototype.removeChild = function(child) {
              var idx;
              if (!(0 > (idx = this.children.indexOf(child)))) {
                this.children.splice(idx, 1);
              }
              if (!this.children.length) {
                $pane.$containerEl.removeClass("fa-pane-parent");
              }
              return $pane.$scheduleReflow();
            };

            Pane.prototype.reflow = function(region) {
              var handleSize, height, orientation, size, styleContainer, styleHandle, styleScroller, width, _ref;
              width = $pane.$containerEl[0].offsetWidth;
              height = $pane.$containerEl[0].offsetHeight;
              region || (region = new Region(width, height));
              if ((_ref = $pane.anchor) === "north" || _ref === "east" || _ref === "south" || _ref === "west") {
                $pane.$containerEl.removeClass("fa-pane-orientation-vertical");
                $pane.$containerEl.removeClass("fa-pane-orientation-horizontal");
                orientation = getOrientation($pane.anchor);
                $pane.$containerEl.addClass("fa-pane-orientation-" + orientation);
                handleSize = region.calculateSize(orientation, !$pane.closed && $pane.handleSizeOpen || $pane.handleSizeClosed);
                if ($pane.closed) {
                  size = handleSize;
                } else {
                  size = region.calculateSize(orientation, !$pane.closed && $pane.targetSize || handleSize);
                  size = Math.min(size, region.calculateSize(orientation, $pane.max));
                  size = Math.max(size, region.calculateSize(orientation, $pane.min));
                  size = Math.min(size, region.getAvailableSize(orientation));
                  size = Math.max(size, handleSize);
                }
                this.size = size;
                styleContainer = region.consume($pane.anchor, size);
                styleScroller = getScrollerStyle($pane.anchor, size - handleSize);
                styleHandle = getHandleStyle($pane.anchor, region, handleSize);
                $pane.$containerEl.attr("style", "").css(styleContainer);
                $pane.$overlayEl.attr("style", "").css(styleScroller);
                $pane.$handleEl.attr("style", "").css(styleHandle);
                $pane.$scrollerEl.attr("style", "").css(styleScroller);
                if ($rootScope.gVariable && $rootScope.gVariable.layoutBoardSize) {
                  $rootScope.gVariable.layoutBoardSize = size + "px";
                }
              } else {

                // SZ Custom HJH GJ
                // 방향에 따라 사이즈 조절
                var offset = $pane.$containerEl.offset();
                var tempHeight = ($(window).height() - offset.top) + "px";
                var $parentObj = $pane.$containerEl.closest("[pane-wrap-anchor]")
                var anchor = $parentObj.attr("pane-wrap-anchor");
                var sheight = "auto";
                var swidth = "auto";
                if(!$pane.$containerEl.hasClass("pane-root")) sheight = "auto";
                else {
                  if(anchor != "west" && anchor != "north") {
                    swidth = "100%";
                    sheight = tempHeight;
                    $parentObj.find("[fa-pane]").css("height","auto");
                    $parentObj.find("[fa-pane]").css("width","auto");
                  } else {
                    sheight = tempHeight;
                  }
                }

                $pane.$containerEl.css({
                  top: region.top + "px",
                  right: region.right + "px",
                  bottom: region.bottom + "px",
                  left: region.left + "px",
                  width: swidth,
                  height: sheight
                });
              }

              $pane.$region = region.clone();


              // HJH HJ 19.07.02
              // anchor == west 일경우
              // 자식 엘리먼트의 사이즈 조절을 하기 위해 fapane-size Attribute 속성을 추가
              // 나머지는 CSS에서 작업
              if($pane.anchor == "west") {
                var $rootPane = $pane.parent;
                var $first = $rootPane.children[0];
                var $second = $rootPane.children[1];
                var fw = $rootPane.children[0].size, sw = $rootPane.$region.width - fw;
                if (fw > 992) $first.$containerEl.attr('fapane-size', "lg");
                else if (fw > 768) $first.$containerEl.attr('fapane-size', "md");
                else if (fw > 650) $first.$containerEl.attr('fapane-size', "sm");
                else $first.$containerEl.attr('fapane-size', "xs");
                if (sw > 992) $second.$containerEl.attr('fapane-size', "lg");
                else if (sw > 768) $second.$containerEl.attr('fapane-size', "md");
                else if (sw > 650) $second.$containerEl.attr('fapane-size', "sm");
                else $second.$containerEl.attr('fapane-size', "xs");
              } else {
                if($pane.anchor != undefined) $('[fapane-size]').removeAttr('fapane-size');
              }

              return $pane.reflowChildren(region.getInnerRegion());
            };

            Pane.prototype.reflowChildren = function(region) {
              var child, _i, _len, _ref, _results;
              region || (region = $pane.$region);
              $pane.children.sort(function(a, b) {
                return a.order - b.order;
              });
              _ref = $pane.children;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                child = _ref[_i];
                _results.push(child.reflow(region));
              }
              return _results;
            };

            Pane.prototype.resize = function(size) {
              if (size == null) {
                size = $pane.targetSize;
              }
              $pane.targetSize = size;
              $pane.parent.reflowChildren($pane.parent.$region.getInnerRegion());
              if (size !== $pane.size) {
                return $pane.$containerEl.addClass("fa-pane-constrained");
              } else {
                return $pane.$containerEl.removeClass("fa-pane-constrained");
              }
            };

            Pane.prototype.toggle = function(open) {
              var reflow;
              if (open == null) {
                open = !!$pane.closed;
              }
              $pane.closed = !open;
              reflow = function() {
                if ($pane.parent) {
                  return $pane.parent.$scheduleReflow();
                } else {
                  return $pane.$scheduleReflow();
                }
              };
              if ($pane.closed) {
                $pane.$containerEl.addClass("fa-pane-closed");
              } else {
                $pane.$containerEl.removeClass("fa-pane-closed");
              }
              return reflow();
            };

            return Pane;

          })());
        },
        compile: function($el, $attrs, $transclude) {
          var link, serialId;
          serialId = generateSerialId();
          return link = function($scope, $el, $attrs, $pane) {
            var $directiveScope, $transcludeScope;
            $directiveScope = $scope.$parent.$new();
            $directiveScope.$pane = $scope.$pane = $pane;
            $transcludeScope = $directiveScope.$new();
            if ($pane.order == null) {
              $pane.order = serialId;
            }
            $pane.$isolateScope = $scope;
            $pane.$directiveScope = $directiveScope;
            $pane.$transcludeScope = $transcludeScope;
            return $transclude($transcludeScope, function(clone) {
              clone.addClass("fa-pane-scroller");
              $el.append(clone);
              $pane.$containerEl = $el;
              $pane.$overlayEl = $el.children().eq(0);
              $pane.$handleEl = $el.children().eq(1);
              $pane.$scrollerEl = $el.children().eq(2);
              $scope.$watch("anchor", function(anchor) {
                return $pane.setAnchor(anchor);
              });
              $scope.$watch("size", function(targetSize) {
                return $pane.setTargetSize(targetSize);
              });
              $scope.$watch("closed", function(closed) {
                return $pane.toggle(!closed);
              });
              $scope.$watch("min", function(min) {
                return $pane.setMinSize(min != null ? min : 0);
              });
              $scope.$watch("max", function(max) {
                return $pane.setMaxSize(max != null ? max : Number.MAX_VALUE);
              });
              $scope.$watch("paneId", function(paneId, prevPaneId) {
                if (prevPaneId) {
                  paneManager.remove(prevPaneId);
                }
                paneManager.set(paneId, $pane);
                return $pane.id = paneId;
              });
              $scope.$watch("handle", function(handle) {
                return $pane.setHandleSize(handle);
              });
              $pane.$directiveScope.$on("fa-pane-attach", function(e, child) {
                if (child !== $pane) {
                  e.stopPropagation();
                  return $pane.addChild(child);
                }
              });
              $pane.$directiveScope.$on("fa-pane-detach", function(e, child) {
                if (child !== $pane) {
                  e.stopPropagation();
                  return $pane.removeChild(child);
                }
              });
              $window.addEventListener("resize", function(e) {
                e.stopPropagation();
                return $pane.$scheduleReflow();
              });
              $pane.$directiveScope.$on("$stateChangeSuccess", function() {

                return $pane.$scheduleReflow();
              });
              $pane.$directiveScope.$emit("fa-pane-attach", $pane);
              return $pane.$directiveScope.$on("$destroy", function() {
                return $pane.$directiveScope.$emit("fa-pane-detach", $pane);
              });
            });
          };
        }
      };
    }
  ]);

  module.directive("faPaneToggle", [
    "paneManager", function(paneManager) {
      return {
        link: function($scope, $el, $attrs) {
          return $attrs.$observe("faPaneToggle", function(paneId) {});
        }
      };
    }
  ]);

  module.directive("faPaneResizer", [
    "$window", function($window) {
      var throttle;
      throttle = function(delay, fn) {
        var throttled;
        throttled = false;
        return function() {
          if (throttled) {
            return;
          }
          throttled = true;
          setTimeout(function() {
            return throttled = false;
          }, delay);
          return fn.call.apply(fn, [this].concat(__slice.call(arguments)));
        };
      };
      return {
        restrict: "A",
        link: function($scope, $element, $attrs, $pane) {
          var clickRadius, clickTime, el;
          $pane || ($pane = $scope.$pane);
          el = $element[0];
          clickRadius = 5;
          clickTime = 300;
          $scope.$watch((function() {
            return $pane.getOrientation();
          }), function(orientation) {
            $element.removeClass("vertical");
            $element.removeClass("horizontal");
            switch (orientation) {
              case "vertical":
                return $element.addClass("vertical");
              case "horizontal":
                return $element.addClass("horizontal");
            }
          });
          return el.addEventListener("mousedown", function(e) {
            var anchor, coord, handleMouseMove, handleMouseMoveThrottled, handleMouseUp, scale, startCoord, startPos, startSize, startTime;
            if (e.button !== 0) {
              return;
            }
            anchor = $pane.anchor;
            if (anchor === "north" || anchor === "south") {
              coord = "screenY";
            } else if (anchor === "west" || anchor === "east") {
              coord = "screenX";
            }
            if (anchor === "north" || anchor === "west") {
              scale = 1;
            } else if (anchor === "south" || anchor === "east") {
              scale = -1;
            }
            startPos = {
              x: e.screenX,
              y: e.screenY
            };
            startCoord = e[coord];
            startSize = $pane.size;
            startTime = Date.now();
            el.unselectable = "on";
            el.onselectstart = function() {
              return false;
            };
            el.style.userSelect = el.style.MozUserSelect = "none";
            e.preventDefault();
            e.defaultPrevented = true;
            e = null;
            handleMouseMove = function(e) {
              $pane.$containerEl.addClass("fa-pane-resizing");

              $scope.$apply(function() {
                var targetSize;
                // by rohbi on 2019.06.17
                targetSize = startSize + scale * (e[coord] - startCoord);
                //targetSize = startSize + scale * (startCoord - e[coord]);
                return $pane.resize(targetSize);
              });
              e.preventDefault();
              e.defaultPrevented = true;
              return e = null;
            };
            handleMouseUp = function(e) {
              var cleanup, displacementSq, timeElapsed;
              displacementSq = Math.pow(e.screenX - startPos.x, 2) + Math.pow(e.screenY - startPos.y, 2);
              timeElapsed = Date.now() - startTime;
              $window.removeEventListener("mousemove", handleMouseMoveThrottled, true);
              $window.removeEventListener("mouseup", handleMouseUp, true);
              cleanup = function() {
                $pane.$containerEl.removeClass("fa-pane-resizing");
                e.preventDefault();
                e.defaultPrevented = true;
                return e = null;
              };
              if (displacementSq <= Math.pow(clickRadius, 2) && timeElapsed <= clickTime) {
                cleanup();
                return;
              }
              handleMouseMove(e);
              return cleanup();
            };
            handleMouseMoveThrottled = throttle(10, handleMouseMove);
            $window.addEventListener("mouseup", handleMouseUp, true);
            return $window.addEventListener("mousemove", handleMouseMoveThrottled, true);
          });
        }
      };
    }
  ]);

}).call(this);


angular.module('ngDock', []).factory('dock', function () {
  var valids = ['left', 'right', 'top', 'bottom', 'fill'];
  return {
    dockRefs: {},
    valids: valids,
    handlesByDock: {
      "top": "s",
      "left": "e",
      "right": "w",
      "bottom": "n"
    },
    Area: (function () {
      function setPosition(r, s, pos) {
        r.position = 'absolute';
        if (pos != "bottom") r.top = s.top; else { r.top = 'auto'; }
        if (pos != "left") r.right = s.right; else { r.right = 'auto'; }
        if (pos != "right") r.left = s.left; else { r.left = 'auto'; }
        if (pos != "top") r.bottom = s.bottom; else { r.bottom = 'auto'; }
      }
      function decreaseSize($element, pos, s) {
        if ("top|bottom".indexOf(pos) != -1) size = $element.outerHeight(true);
        if ("left|right".indexOf(pos) != -1) size = $element.outerWidth(true);
        if (pos == "bottom") s.bottom += size;
        if (pos == "left") s.left += size;
        if (pos == "right") s.right += size;
        if (pos == "top") s.top += size;
      }
      function removeClasses($element) {
        var x = valids.length;
        while (x--)
          $element.removeClass("dock-" + valids[x]);
      }
      function update($element, pos, s) {
        var r = {};
        removeClasses($element);
        setPosition(r, s, pos);
        $element.addClass("dock-" + pos);
        $element.css(r);
        decreaseSize($element, pos, s);
      }
      var Area = function ($div, $scope) {
        var s = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        };
        var childList = [];
        this.addChild = function ($element, $pos) {
          var pos = $scope.$eval($pos);

          if (valids.indexOf(pos) == -1)
            throw {
              message: " : dock position must be one of this: " + valids.join(', ')
            };
          childList.push({
            element: $element,
            pos: $pos,
            order: childList.length
          });

          console.log($(".ui-resizable-handle"))
          if($(".ui-resizable-handle").length > 0) {
            if($(".ui-resizable-handle > div").length == 0)
              $(".ui-resizable-handle").append("<div></div>");
          }
          update($element, pos, s);
        };
        this.refresh = function () {
          s.top = 0;
          s.bottom = 0;
          s.left = 0;
          s.right = 0;
          for (var x = 0; x < childList.length; x++) {
            var pos = $scope.$eval(childList[x].pos);
            update(childList[x].element, pos, s);
          }
        };


        var _this = this;
        $(window).resize(function () {
          $(".ui-resizable-handle").addClass("ui-resizable-bar-area");
          _this.refresh();
          clearTimeout($.data(this, 'resizeTimer'));
          $.data(this, 'resizeTimer', setTimeout(function() {
              $(".ui-resizable-handle").removeClass("ui-resizable-bar-area");
          }, 250));
        });
        $scope.$watch(function () {
          _this.refresh();
        });
      };
      return Area;
    })()
  };
})
.directive('dockRef', function (dock) {
  return {
    restrict: "A",
    controller: function ($scope, $element) {
      $scope.__dock_ref_id = String(Math.random()).replace(/\./g, "");
      dock.dockRefs[$scope.__dock_ref_id] = new dock.Area($element, $scope);
    },
    scope: true
  };
})
.directive('dock', function (dock) {
  return {
    restrict: "A",
    controller: function ($scope, $element) {
      var dp = $element.attr('dock');
      $scope.__dock_id = String(Math.random()).replace(/\./g, "");
      var area = dock.dockRefs[$scope.$parent.__dock_ref_id];
      area.addChild($element, dp);
    },
    scope: true
  };
})
.directive("dockResizable", function (dock) {
  function enableResize($element, dp) {
    $element.resizable({
      handles: dock.handlesByDock[dp]
    });
  }
  return {
    require: 'dock',
    restrict: "A",
    controller: function ($scope, $element) {

      var dp = $scope.$eval($element.attr('dock'));
      if (dock.valids.indexOf(dp) >= 0 && dp != "fill") enableResize($element, dp);
      $scope.$watch(function () {
        var newdp = $scope.$eval($element.attr('dock'));
        if (newdp != dp) {
          if (dock.valids.indexOf(newdp) == -1)
            throw {
              message: "> dock position must be one of this: " + valids.join(', ')
            };
          dp = newdp;
          $element.resizable('destroy');
          if (newdp != 'fill') enableResize($element, dp);
        }
      });
    }
  };
});


webapp.controller('HeaderCtrl', [ '$window', '$rootScope', '$scope', '$state', '$cookieStore', 'gAlert', 'GLOBAL_CONSTANT', 'LoginAPISrv', 'StaticVariable', 'modalFactory','$location', '$stateParams',
    function HeaderCtrl($window, $rootScope, $scope, $state, $cookieStore, gAlert, CONSTANT, loginApi, StaticVariable, modalFactory,$location,$stateParams) {

      var vm = this;
      vm.user = {}
      vm.privateModal = privateModal;
      var saveId = $cookieStore.get('mySavedId');

      if (saveId != undefined && saveId != '') {
        vm.user = {
          DeviceId : saveId,
          saveId : '1',
        };
      }

      $scope.init = function() {
        $rootScope.changeLanguage($window.sessionStorage['currentLanguage']);
      };

      vm.user.userGbn = 'C';
      vm.user.Tenant = 'logo_salevis';

      vm.doLogout = doLogout;

      vm.urlcheck = urlcheck;

      function urlcheck(url){
        console.log(url);
        location.href="/#/"+$stateParams.lang+"/home/"+url;
      }

      function doLogout() {
        /*
         * if(vm.user.DeviceId == undefined || vm.user.DeviceId == "" ){
         * gAlert('', '아이디를 입력하세요.'); return; } if(vm.user.loginPw == undefined ||
         * vm.user.loginPw == "" ){ gAlert('', '비밀번호를 입력하세요.'); return; }
         */
        StaticVariable.sessionExpire();

        var prms = loginApi.doLogout().post().$promise;

        prms.then(
          function(json) {
            gAlert('', 'Menu.SIGNEDOUT', {
              btn : '',
              fn : function() {
                $window.location.replace('/d/');
                //$state.reload('main.login');
                //$state.go('main.login');
              }
            });
          }, function(error) {
            console.error('fail', status);
          });
      }

      function privateModal() {
        var ctrl = 'Private2ModalCtrl as modalCtrl';
        var paramData = {view: 'Y'};
        var modalInstance = modalFactory.open('lg', 'views/modal/private2-modal.html', ctrl, paramData);

        modalInstance.result.then(function(res) {
          //없음
        }, function(cancelData) {
          //없음
        });

      }
      //다국어 언어변환
      vm.changefn = changefn;
      function changefn(key) {
        console.log("changefn:" + key);
        if(key =='en') {
          $('.mainOn').text('ENG');
          var oldpath = $location.path();
          console.log(oldpath);
          $window.location.href = '/#/'+key+oldpath.substr(3,oldpath.langth);
        }else if(key =='ko') {
          $('.mainOn').text('KOR');
          var oldpath = $location.path();
          $window.location.href = '/#/'+key+oldpath.substr(3,oldpath.langth);
        }else if(key =='de') {
          $('.mainOn').text('DEU');
          var oldpath = $location.path();
          $window.location.href = '/#/'+key+oldpath.substr(3,oldpath.langth);
        }else if(key =='ru') {
          $('.mainOn').text('RUS');
          var oldpath = $location.path();
          $window.location.href = '/#/'+key+oldpath.substr(3,oldpath.langth);
        }

      }

      vm.getCurrentLanguage = function() {
        if ($rootScope.currentLanguage == 'ko') {
          return 'KOR';
        } else if($rootScope.currentLanguage == 'en') {
          return 'ENG';
        } else if($rootScope.currentLanguage == 'de') {
          return 'DEU';
        } else if($rootScope.currentLanguage == 'ru') {
          return 'RUS';
        } else {
          return 'ENG';
        }
      }

    } ]);

/*
== malihu jquery custom scrollbar plugin ==
Version: 3.1.5
Plugin URI: http://manos.malihu.gr/jquery-custom-content-scroller
Author: malihu
Author URI: http://manos.malihu.gr
License: MIT License (MIT)
*/

/*
Copyright Manos Malihutsakis (email: manos@malihu.gr)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

/*
The code below is fairly long, fully commented and should be normally used in development.
For production, use either the minified jquery.mCustomScrollbar.min.js script or
the production-ready jquery.mCustomScrollbar.concat.min.js which contains the plugin
and dependencies (minified).
*/

(function(factory){
	if(typeof define==="function" && define.amd){
		define(["jquery"],factory);
	}else if(typeof module!=="undefined" && module.exports){
		module.exports=factory;
	}else{
		factory(jQuery,window,document);
	}
}(function($){
(function(init){
	var _rjs=typeof define==="function" && define.amd, /* RequireJS */
		_njs=typeof module !== "undefined" && module.exports, /* NodeJS */
		_dlp=("https:"==document.location.protocol) ? "https:" : "http:", /* location protocol */
		_url="cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js";
	if(!_rjs){
		if(_njs){
			require("jquery-mousewheel")($);
		}else{
			/* load jquery-mousewheel plugin (via CDN) if it's not present or not loaded via RequireJS
			(works when mCustomScrollbar fn is called on window load) */
			$.event.special.mousewheel || $("head").append(decodeURI("%3Cscript src="+_dlp+"//"+_url+"%3E%3C/script%3E"));
		}
	}
	init();
}(function(){

	/*
	----------------------------------------
	PLUGIN NAMESPACE, PREFIX, DEFAULT SELECTOR(S)
	----------------------------------------
	*/

	var pluginNS="mCustomScrollbar",
		pluginPfx="mCS",
		defaultSelector=".mCustomScrollbar",





	/*
	----------------------------------------
	DEFAULT OPTIONS
	----------------------------------------
	*/

		defaults={
			/*
			set element/content width/height programmatically
			values: boolean, pixels, percentage
				option						default
				-------------------------------------
				setWidth					false
				setHeight					false
			*/
			/*
			set the initial css top property of content
			values: string (e.g. "-100px", "10%" etc.)
			*/
			setTop:0,
			/*
			set the initial css left property of content
			values: string (e.g. "-100px", "10%" etc.)
			*/
			setLeft:0,
			/*
			scrollbar axis (vertical and/or horizontal scrollbars)
			values (string): "y", "x", "yx"
			*/
			axis:"y",
			/*
			position of scrollbar relative to content
			values (string): "inside", "outside" ("outside" requires elements with position:relative)
			*/
			scrollbarPosition:"inside",
			/*
			scrolling inertia
			values: integer (milliseconds)
			*/
			scrollInertia:950,
			/*
			auto-adjust scrollbar dragger length
			values: boolean
			*/
			autoDraggerLength:true,
			/*
			auto-hide scrollbar when idle
			values: boolean
				option						default
				-------------------------------------
				autoHideScrollbar			false
			*/
			/*
			auto-expands scrollbar on mouse-over and dragging
			values: boolean
				option						default
				-------------------------------------
				autoExpandScrollbar			false
			*/
			/*
			always show scrollbar, even when there's nothing to scroll
			values: integer (0=disable, 1=always show dragger rail and buttons, 2=always show dragger rail, dragger and buttons), boolean
			*/
			alwaysShowScrollbar:0,
			/*
			scrolling always snaps to a multiple of this number in pixels
			values: integer, array ([y,x])
				option						default
				-------------------------------------
				snapAmount					null
			*/
			/*
			when snapping, snap with this number in pixels as an offset
			values: integer
			*/
			snapOffset:0,
			/*
			mouse-wheel scrolling
			*/
			mouseWheel:{
				/*
				enable mouse-wheel scrolling
				values: boolean
				*/
				enable:true,
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto",
				/*
				mouse-wheel scrolling axis
				the default scrolling direction when both vertical and horizontal scrollbars are present
				values (string): "y", "x"
				*/
				axis:"y",
				/*
				prevent the default behaviour which automatically scrolls the parent element(s) when end of scrolling is reached
				values: boolean
					option						default
					-------------------------------------
					preventDefault				null
				*/
				/*
				the reported mouse-wheel delta value. The number of lines (translated to pixels) one wheel notch scrolls.
				values: "auto", integer
				"auto" uses the default OS/browser value
				*/
				deltaFactor:"auto",
				/*
				normalize mouse-wheel delta to -1 or 1 (disables mouse-wheel acceleration)
				values: boolean
					option						default
					-------------------------------------
					normalizeDelta				null
				*/
				/*
				invert mouse-wheel scrolling direction
				values: boolean
					option						default
					-------------------------------------
					invert						null
				*/
				/*
				the tags that disable mouse-wheel when cursor is over them
				*/
				disableOver:["select","option","keygen","datalist","textarea"]
			},
			/*
			scrollbar buttons
			*/
			scrollButtons:{
				/*
				enable scrollbar buttons
				values: boolean
					option						default
					-------------------------------------
					enable						null
				*/
				/*
				scrollbar buttons scrolling type
				values (string): "stepless", "stepped"
				*/
				scrollType:"stepless",
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto"
				/*
				tabindex of the scrollbar buttons
				values: false, integer
					option						default
					-------------------------------------
					tabindex					null
				*/
			},
			/*
			keyboard scrolling
			*/
			keyboard:{
				/*
				enable scrolling via keyboard
				values: boolean
				*/
				enable:true,
				/*
				keyboard scrolling type
				values (string): "stepless", "stepped"
				*/
				scrollType:"stepless",
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto"
			},
			/*
			enable content touch-swipe scrolling
			values: boolean, integer, string (number)
			integer values define the axis-specific minimum amount required for scrolling momentum
			*/
			contentTouchScroll:25,
			/*
			enable/disable document (default) touch-swipe scrolling
			*/
			documentTouchScroll:true,
			/*
			advanced option parameters
			*/
			advanced:{
				/*
				auto-expand content horizontally (for "x" or "yx" axis)
				values: boolean, integer (the value 2 forces the non scrollHeight/scrollWidth method, the value 3 forces the scrollHeight/scrollWidth method)
					option						default
					-------------------------------------
					autoExpandHorizontalScroll	null
				*/
				/*
				auto-scroll to elements with focus
				*/
				autoScrollOnFocus:"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",
				/*
				auto-update scrollbars on content, element or viewport resize
				should be true for fluid layouts/elements, adding/removing content dynamically, hiding/showing elements, content with images etc.
				values: boolean
				*/
				updateOnContentResize:true,
				/*
				auto-update scrollbars each time each image inside the element is fully loaded
				values: "auto", boolean
				*/
				updateOnImageLoad:"auto",
				/*
				auto-update scrollbars based on the amount and size changes of specific selectors
				useful when you need to update the scrollbar(s) automatically, each time a type of element is added, removed or changes its size
				values: boolean, string (e.g. "ul li" will auto-update scrollbars each time list-items inside the element are changed)
				a value of true (boolean) will auto-update scrollbars each time any element is changed
					option						default
					-------------------------------------
					updateOnSelectorChange		null
				*/
				/*
				extra selectors that'll allow scrollbar dragging upon mousemove/up, pointermove/up, touchend etc. (e.g. "selector-1, selector-2")
					option						default
					-------------------------------------
					extraDraggableSelectors		null
				*/
				/*
				extra selectors that'll release scrollbar dragging upon mouseup, pointerup, touchend etc. (e.g. "selector-1, selector-2")
					option						default
					-------------------------------------
					releaseDraggableSelectors	null
				*/
				/*
				auto-update timeout
				values: integer (milliseconds)
				*/
				autoUpdateTimeout:60
			},
			/*
			scrollbar theme
			values: string (see CSS/plugin URI for a list of ready-to-use themes)
			*/
			theme:"light",
			/*
			user defined callback functions
			*/
			callbacks:{
				/*
				Available callbacks:
					callback					default
					-------------------------------------
					onCreate					null
					onInit						null
					onScrollStart				null
					onScroll					null
					onTotalScroll				null
					onTotalScrollBack			null
					whileScrolling				null
					onOverflowY					null
					onOverflowX					null
					onOverflowYNone				null
					onOverflowXNone				null
					onImageLoad					null
					onSelectorChange			null
					onBeforeUpdate				null
					onUpdate					null
				*/
				onTotalScrollOffset:0,
				onTotalScrollBackOffset:0,
				alwaysTriggerOffsets:true
			}
			/*
			add scrollbar(s) on all elements matching the current selector, now and in the future
			values: boolean, string
			string values: "on" (enable), "once" (disable after first invocation), "off" (disable)
			liveSelector values: string (selector)
				option						default
				-------------------------------------
				live						false
				liveSelector				null
			*/
		},





	/*
	----------------------------------------
	VARS, CONSTANTS
	----------------------------------------
	*/

		totalInstances=0, /* plugin instances amount */
		liveTimers={}, /* live option timers */
		oldIE=(window.attachEvent && !window.addEventListener) ? 1 : 0, /* detect IE < 9 */
		touchActive=false,touchable, /* global touch vars (for touch and pointer events) */
		/* general plugin classes */
		classes=[
			"mCSB_dragger_onDrag","mCSB_scrollTools_onDrag","mCS_img_loaded","mCS_disabled","mCS_destroyed","mCS_no_scrollbar",
			"mCS-autoHide","mCS-dir-rtl","mCS_no_scrollbar_y","mCS_no_scrollbar_x","mCS_y_hidden","mCS_x_hidden","mCSB_draggerContainer",
			"mCSB_buttonUp","mCSB_buttonDown","mCSB_buttonLeft","mCSB_buttonRight"
		],





	/*
	----------------------------------------
	METHODS
	----------------------------------------
	*/

		methods={

			/*
			plugin initialization method
			creates the scrollbar(s), plugin data object and options
			----------------------------------------
			*/

			init:function(options){

				var options=$.extend(true,{},defaults,options),
					selector=_selector.call(this); /* validate selector */

				/*
				if live option is enabled, monitor for elements matching the current selector and
				apply scrollbar(s) when found (now and in the future)
				*/
				if(options.live){
					var liveSelector=options.liveSelector || this.selector || defaultSelector, /* live selector(s) */
						$liveSelector=$(liveSelector); /* live selector(s) as jquery object */
					if(options.live==="off"){
						/*
						disable live if requested
						usage: $(selector).mCustomScrollbar({live:"off"});
						*/
						removeLiveTimers(liveSelector);
						return;
					}
					liveTimers[liveSelector]=setTimeout(function(){
						/* call mCustomScrollbar fn on live selector(s) every half-second */
						$liveSelector.mCustomScrollbar(options);
						if(options.live==="once" && $liveSelector.length){
							/* disable live after first invocation */
							removeLiveTimers(liveSelector);
						}
					},500);
				}else{
					removeLiveTimers(liveSelector);
				}

				/* options backward compatibility (for versions < 3.0.0) and normalization */
				options.setWidth=(options.set_width) ? options.set_width : options.setWidth;
				options.setHeight=(options.set_height) ? options.set_height : options.setHeight;
				options.axis=(options.horizontalScroll) ? "x" : _findAxis(options.axis);
				options.scrollInertia=options.scrollInertia>0 && options.scrollInertia<17 ? 17 : options.scrollInertia;
				if(typeof options.mouseWheel!=="object" &&  options.mouseWheel==true){ /* old school mouseWheel option (non-object) */
					options.mouseWheel={enable:true,scrollAmount:"auto",axis:"y",preventDefault:false,deltaFactor:"auto",normalizeDelta:false,invert:false}
				}
				options.mouseWheel.scrollAmount=!options.mouseWheelPixels ? options.mouseWheel.scrollAmount : options.mouseWheelPixels;
				options.mouseWheel.normalizeDelta=!options.advanced.normalizeMouseWheelDelta ? options.mouseWheel.normalizeDelta : options.advanced.normalizeMouseWheelDelta;
				options.scrollButtons.scrollType=_findScrollButtonsType(options.scrollButtons.scrollType);

				_theme(options); /* theme-specific options */

				/* plugin constructor */
				return $(selector).each(function(){

					var $this=$(this);

					if(!$this.data(pluginPfx)){ /* prevent multiple instantiations */

						/* store options and create objects in jquery data */
						$this.data(pluginPfx,{
							idx:++totalInstances, /* instance index */
							opt:options, /* options */
							scrollRatio:{y:null,x:null}, /* scrollbar to content ratio */
							overflowed:null, /* overflowed axis */
							contentReset:{y:null,x:null}, /* object to check when content resets */
							bindEvents:false, /* object to check if events are bound */
							tweenRunning:false, /* object to check if tween is running */
							sequential:{}, /* sequential scrolling object */
							langDir:$this.css("direction"), /* detect/store direction (ltr or rtl) */
							cbOffsets:null, /* object to check whether callback offsets always trigger */
							/*
							object to check how scrolling events where last triggered
							"internal" (default - triggered by this script), "external" (triggered by other scripts, e.g. via scrollTo method)
							usage: object.data("mCS").trigger
							*/
							trigger:null,
							/*
							object to check for changes in elements in order to call the update method automatically
							*/
							poll:{size:{o:0,n:0},img:{o:0,n:0},change:{o:0,n:0}}
						});

						var d=$this.data(pluginPfx),o=d.opt,
							/* HTML data attributes */
							htmlDataAxis=$this.data("mcs-axis"),htmlDataSbPos=$this.data("mcs-scrollbar-position"),htmlDataTheme=$this.data("mcs-theme");

						if(htmlDataAxis){o.axis=htmlDataAxis;} /* usage example: data-mcs-axis="y" */
						if(htmlDataSbPos){o.scrollbarPosition=htmlDataSbPos;} /* usage example: data-mcs-scrollbar-position="outside" */
						if(htmlDataTheme){ /* usage example: data-mcs-theme="minimal" */
							o.theme=htmlDataTheme;
							_theme(o); /* theme-specific options */
						}

						_pluginMarkup.call(this); /* add plugin markup */

						if(d && o.callbacks.onCreate && typeof o.callbacks.onCreate==="function"){o.callbacks.onCreate.call(this);} /* callbacks: onCreate */

						$("#mCSB_"+d.idx+"_container img:not(."+classes[2]+")").addClass(classes[2]); /* flag loaded images */

						methods.update.call(null,$this); /* call the update method */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin update method
			updates content and scrollbar(s) values, events and status
			----------------------------------------
			usage: $(selector).mCustomScrollbar("update");
			*/

			update:function(el,cb){

				var selector=el || _selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							mCSB_container=$("#mCSB_"+d.idx+"_container"),
							mCustomScrollBox=$("#mCSB_"+d.idx),
							mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];

						if(!mCSB_container.length){return;}

						if(d.tweenRunning){_stop($this);} /* stop any running tweens while updating */

						if(cb && d && o.callbacks.onBeforeUpdate && typeof o.callbacks.onBeforeUpdate==="function"){o.callbacks.onBeforeUpdate.call(this);} /* callbacks: onBeforeUpdate */

						/* if element was disabled or destroyed, remove class(es) */
						if($this.hasClass(classes[3])){$this.removeClass(classes[3]);}
						if($this.hasClass(classes[4])){$this.removeClass(classes[4]);}

						/* css flexbox fix, detect/set max-height */
						mCustomScrollBox.css("max-height","none");
						if(mCustomScrollBox.height()!==$this.height()){mCustomScrollBox.css("max-height",$this.height());}

						_expandContentHorizontally.call(this); /* expand content horizontally */

						if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
							mCSB_container.css("width",_contentWidth(mCSB_container));
						}

						d.overflowed=_overflowed.call(this); /* determine if scrolling is required */

						_scrollbarVisibility.call(this); /* show/hide scrollbar(s) */

						/* auto-adjust scrollbar dragger length analogous to content */
						if(o.autoDraggerLength){_setDraggerLength.call(this);}

						_scrollRatio.call(this); /* calculate and store scrollbar to content ratio */

						_bindEvents.call(this); /* bind scrollbar events */

						/* reset scrolling position and/or events */
						var to=[Math.abs(mCSB_container[0].offsetTop),Math.abs(mCSB_container[0].offsetLeft)];
						if(o.axis!=="x"){ /* y/yx axis */
							if(!d.overflowed[0]){ /* y scrolling is not required */
								_resetContentPosition.call(this); /* reset content position */
								if(o.axis==="y"){
									_unbindEvents.call(this);
								}else if(o.axis==="yx" && d.overflowed[1]){
									_scrollTo($this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
								}
							}else if(mCSB_dragger[0].height()>mCSB_dragger[0].parent().height()){
								_resetContentPosition.call(this); /* reset content position */
							}else{ /* y scrolling is required */
								_scrollTo($this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
								d.contentReset.y=null;
							}
						}
						if(o.axis!=="y"){ /* x/yx axis */
							if(!d.overflowed[1]){ /* x scrolling is not required */
								_resetContentPosition.call(this); /* reset content position */
								if(o.axis==="x"){
									_unbindEvents.call(this);
								}else if(o.axis==="yx" && d.overflowed[0]){
									_scrollTo($this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
								}
							}else if(mCSB_dragger[1].width()>mCSB_dragger[1].parent().width()){
								_resetContentPosition.call(this); /* reset content position */
							}else{ /* x scrolling is required */
								_scrollTo($this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
								d.contentReset.x=null;
							}
						}

						/* callbacks: onImageLoad, onSelectorChange, onUpdate */
						if(cb && d){
							if(cb===2 && o.callbacks.onImageLoad && typeof o.callbacks.onImageLoad==="function"){
								o.callbacks.onImageLoad.call(this);
							}else if(cb===3 && o.callbacks.onSelectorChange && typeof o.callbacks.onSelectorChange==="function"){
								o.callbacks.onSelectorChange.call(this);
							}else if(o.callbacks.onUpdate && typeof o.callbacks.onUpdate==="function"){
								o.callbacks.onUpdate.call(this);
							}
						}

						_autoUpdate.call(this); /* initialize automatic updating (for dynamic content, fluid layouts etc.) */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin scrollTo method
			triggers a scrolling event to a specific value
			----------------------------------------
			usage: $(selector).mCustomScrollbar("scrollTo",value,options);
			*/

			scrollTo:function(val,options){

				/* prevent silly things like $(selector).mCustomScrollbar("scrollTo",undefined); */
				if(typeof val=="undefined" || val==null){return;}

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							/* method default options */
							methodDefaults={
								trigger:"external", /* method is by default triggered externally (e.g. from other scripts) */
								scrollInertia:o.scrollInertia, /* scrolling inertia (animation duration) */
								scrollEasing:"mcsEaseInOut", /* animation easing */
								moveDragger:false, /* move dragger instead of content */
								timeout:60, /* scroll-to delay */
								callbacks:true, /* enable/disable callbacks */
								onStart:true,
								onUpdate:true,
								onComplete:true
							},
							methodOptions=$.extend(true,{},methodDefaults,options),
							to=_arr.call(this,val),dur=methodOptions.scrollInertia>0 && methodOptions.scrollInertia<17 ? 17 : methodOptions.scrollInertia;

						/* translate yx values to actual scroll-to positions */
						to[0]=_to.call(this,to[0],"y");
						to[1]=_to.call(this,to[1],"x");

						/*
						check if scroll-to value moves the dragger instead of content.
						Only pixel values apply on dragger (e.g. 100, "100px", "-=100" etc.)
						*/
						if(methodOptions.moveDragger){
							to[0]*=d.scrollRatio.y;
							to[1]*=d.scrollRatio.x;
						}

						methodOptions.dur=_isTabHidden() ? 0 : dur; //skip animations if browser tab is hidden

						setTimeout(function(){
							/* do the scrolling */
							if(to[0]!==null && typeof to[0]!=="undefined" && o.axis!=="x" && d.overflowed[0]){ /* scroll y */
								methodOptions.dir="y";
								methodOptions.overwrite="all";
								_scrollTo($this,to[0].toString(),methodOptions);
							}
							if(to[1]!==null && typeof to[1]!=="undefined" && o.axis!=="y" && d.overflowed[1]){ /* scroll x */
								methodOptions.dir="x";
								methodOptions.overwrite="none";
								_scrollTo($this,to[1].toString(),methodOptions);
							}
						},methodOptions.timeout);

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin stop method
			stops scrolling animation
			----------------------------------------
			usage: $(selector).mCustomScrollbar("stop");
			*/
			stop:function(){

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						_stop($this);

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin disable method
			temporarily disables the scrollbar(s)
			----------------------------------------
			usage: $(selector).mCustomScrollbar("disable",reset);
			reset (boolean): resets content position to 0
			*/
			disable:function(r){

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx);

						_autoUpdate.call(this,"remove"); /* remove automatic updating */

						_unbindEvents.call(this); /* unbind events */

						if(r){_resetContentPosition.call(this);} /* reset content position */

						_scrollbarVisibility.call(this,true); /* show/hide scrollbar(s) */

						$this.addClass(classes[3]); /* add disable class */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin destroy method
			completely removes the scrollbar(s) and returns the element to its original state
			----------------------------------------
			usage: $(selector).mCustomScrollbar("destroy");
			*/
			destroy:function(){

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							mCustomScrollBox=$("#mCSB_"+d.idx),
							mCSB_container=$("#mCSB_"+d.idx+"_container"),
							scrollbar=$(".mCSB_"+d.idx+"_scrollbar");

						if(o.live){removeLiveTimers(o.liveSelector || $(selector).selector);} /* remove live timers */

						_autoUpdate.call(this,"remove"); /* remove automatic updating */

						_unbindEvents.call(this); /* unbind events */

						_resetContentPosition.call(this); /* reset content position */

						$this.removeData(pluginPfx); /* remove plugin data object */

						_delete(this,"mcs"); /* delete callbacks object */

						/* remove plugin markup */
						scrollbar.remove(); /* remove scrollbar(s) first (those can be either inside or outside plugin's inner wrapper) */
						mCSB_container.find("img."+classes[2]).removeClass(classes[2]); /* remove loaded images flag */
						mCustomScrollBox.replaceWith(mCSB_container.contents()); /* replace plugin's inner wrapper with the original content */
						/* remove plugin classes from the element and add destroy class */
						$this.removeClass(pluginNS+" _"+pluginPfx+"_"+d.idx+" "+classes[6]+" "+classes[7]+" "+classes[5]+" "+classes[3]).addClass(classes[4]);

					}

				});

			}
			/* ---------------------------------------- */

		},





	/*
	----------------------------------------
	FUNCTIONS
	----------------------------------------
	*/

		/* validates selector (if selector is invalid or undefined uses the default one) */
		_selector=function(){
			return (typeof $(this)!=="object" || $(this).length<1) ? defaultSelector : this;
		},
		/* -------------------- */


		/* changes options according to theme */
		_theme=function(obj){
			var fixedSizeScrollbarThemes=["rounded","rounded-dark","rounded-dots","rounded-dots-dark"],
				nonExpandedScrollbarThemes=["rounded-dots","rounded-dots-dark","3d","3d-dark","3d-thick","3d-thick-dark","inset","inset-dark","inset-2","inset-2-dark","inset-3","inset-3-dark"],
				disabledScrollButtonsThemes=["minimal","minimal-dark"],
				enabledAutoHideScrollbarThemes=["minimal","minimal-dark"],
				scrollbarPositionOutsideThemes=["minimal","minimal-dark"];
			obj.autoDraggerLength=$.inArray(obj.theme,fixedSizeScrollbarThemes) > -1 ? false : obj.autoDraggerLength;
			obj.autoExpandScrollbar=$.inArray(obj.theme,nonExpandedScrollbarThemes) > -1 ? false : obj.autoExpandScrollbar;
			obj.scrollButtons.enable=$.inArray(obj.theme,disabledScrollButtonsThemes) > -1 ? false : obj.scrollButtons.enable;
			obj.autoHideScrollbar=$.inArray(obj.theme,enabledAutoHideScrollbarThemes) > -1 ? true : obj.autoHideScrollbar;
			obj.scrollbarPosition=$.inArray(obj.theme,scrollbarPositionOutsideThemes) > -1 ? "outside" : obj.scrollbarPosition;
		},
		/* -------------------- */


		/* live option timers removal */
		removeLiveTimers=function(selector){
			if(liveTimers[selector]){
				clearTimeout(liveTimers[selector]);
				_delete(liveTimers,selector);
			}
		},
		/* -------------------- */


		/* normalizes axis option to valid values: "y", "x", "yx" */
		_findAxis=function(val){
			return (val==="yx" || val==="xy" || val==="auto") ? "yx" : (val==="x" || val==="horizontal") ? "x" : "y";
		},
		/* -------------------- */


		/* normalizes scrollButtons.scrollType option to valid values: "stepless", "stepped" */
		_findScrollButtonsType=function(val){
			return (val==="stepped" || val==="pixels" || val==="step" || val==="click") ? "stepped" : "stepless";
		},
		/* -------------------- */


		/* generates plugin markup */
		_pluginMarkup=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				expandClass=o.autoExpandScrollbar ? " "+classes[1]+"_expand" : "",
				scrollbar=["<div id='mCSB_"+d.idx+"_scrollbar_vertical' class='mCSB_scrollTools mCSB_"+d.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_vertical"+expandClass+"'><div class='"+classes[12]+"'><div id='mCSB_"+d.idx+"_dragger_vertical' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>","<div id='mCSB_"+d.idx+"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_"+d.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_horizontal"+expandClass+"'><div class='"+classes[12]+"'><div id='mCSB_"+d.idx+"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>"],
				wrapperClass=o.axis==="yx" ? "mCSB_vertical_horizontal" : o.axis==="x" ? "mCSB_horizontal" : "mCSB_vertical",
				scrollbars=o.axis==="yx" ? scrollbar[0]+scrollbar[1] : o.axis==="x" ? scrollbar[1] : scrollbar[0],
				contentWrapper=o.axis==="yx" ? "<div id='mCSB_"+d.idx+"_container_wrapper' class='mCSB_container_wrapper' />" : "",
				autoHideClass=o.autoHideScrollbar ? " "+classes[6] : "",
				scrollbarDirClass=(o.axis!=="x" && d.langDir==="rtl") ? " "+classes[7] : "";
			if(o.setWidth){$this.css("width",o.setWidth);} /* set element width */
			if(o.setHeight){$this.css("height",o.setHeight);} /* set element height */
			o.setLeft=(o.axis!=="y" && d.langDir==="rtl") ? "989999px" : o.setLeft; /* adjust left position for rtl direction */
			$this.addClass(pluginNS+" _"+pluginPfx+"_"+d.idx+autoHideClass+scrollbarDirClass).wrapInner("<div id='mCSB_"+d.idx+"' class='mCustomScrollBox mCS-"+o.theme+" "+wrapperClass+"'><div id='mCSB_"+d.idx+"_container' class='mCSB_container' style='position:relative; top:"+o.setTop+"; left:"+o.setLeft+";' dir='"+d.langDir+"' /></div>");
			var mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
				mCSB_container.css("width",_contentWidth(mCSB_container));
			}
			if(o.scrollbarPosition==="outside"){
				if($this.css("position")==="static"){ /* requires elements with non-static position */
					$this.css("position","relative");
				}
				$this.css("overflow","visible");
				mCustomScrollBox.addClass("mCSB_outside").after(scrollbars);
			}else{
				mCustomScrollBox.addClass("mCSB_inside").append(scrollbars);
				mCSB_container.wrap(contentWrapper);
			}
			_scrollButtons.call(this); /* add scrollbar buttons */
			/* minimum dragger length */
			var mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];
			mCSB_dragger[0].css("min-height",mCSB_dragger[0].height());
			mCSB_dragger[1].css("min-width",mCSB_dragger[1].width());
		},
		/* -------------------- */


		/* calculates content width */
		_contentWidth=function(el){
			var val=[el[0].scrollWidth,Math.max.apply(Math,el.children().map(function(){return $(this).outerWidth(true);}).get())],w=el.parent().width();
			return val[0]>w ? val[0] : val[1]>w ? val[1] : "100%";
		},
		/* -------------------- */


		/* expands content horizontally */
		_expandContentHorizontally=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(o.advanced.autoExpandHorizontalScroll && o.axis!=="y"){
				/* calculate scrollWidth */
				mCSB_container.css({"width":"auto","min-width":0,"overflow-x":"scroll"});
				var w=Math.ceil(mCSB_container[0].scrollWidth);
				if(o.advanced.autoExpandHorizontalScroll===3 || (o.advanced.autoExpandHorizontalScroll!==2 && w>mCSB_container.parent().width())){
					mCSB_container.css({"width":w,"min-width":"100%","overflow-x":"inherit"});
				}else{
					/*
					wrap content with an infinite width div and set its position to absolute and width to auto.
					Setting width to auto before calculating the actual width is important!
					We must let the browser set the width as browser zoom values are impossible to calculate.
					*/
					mCSB_container.css({"overflow-x":"inherit","position":"absolute"})
						.wrap("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />")
						.css({ /* set actual width, original position and un-wrap */
							/*
							get the exact width (with decimals) and then round-up.
							Using jquery outerWidth() will round the width value which will mess up with inner elements that have non-integer width
							*/
							"width":(Math.ceil(mCSB_container[0].getBoundingClientRect().right+0.4)-Math.floor(mCSB_container[0].getBoundingClientRect().left)),
							"min-width":"100%",
							"position":"relative"
						}).unwrap();
				}
			}
		},
		/* -------------------- */


		/* adds scrollbar buttons */
		_scrollButtons=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_scrollTools=$(".mCSB_"+d.idx+"_scrollbar:first"),
				tabindex=!_isNumeric(o.scrollButtons.tabindex) ? "" : "tabindex='"+o.scrollButtons.tabindex+"'",
				btnHTML=[
					"<a href='#' class='"+classes[13]+"' "+tabindex+" />",
					"<a href='#' class='"+classes[14]+"' "+tabindex+" />",
					"<a href='#' class='"+classes[15]+"' "+tabindex+" />",
					"<a href='#' class='"+classes[16]+"' "+tabindex+" />"
				],
				btn=[(o.axis==="x" ? btnHTML[2] : btnHTML[0]),(o.axis==="x" ? btnHTML[3] : btnHTML[1]),btnHTML[2],btnHTML[3]];
			if(o.scrollButtons.enable){
				mCSB_scrollTools.prepend(btn[0]).append(btn[1]).next(".mCSB_scrollTools").prepend(btn[2]).append(btn[3]);
			}
		},
		/* -------------------- */


		/* auto-adjusts scrollbar dragger length */
		_setDraggerLength=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				ratio=[mCustomScrollBox.height()/mCSB_container.outerHeight(false),mCustomScrollBox.width()/mCSB_container.outerWidth(false)],
				l=[
					parseInt(mCSB_dragger[0].css("min-height")),Math.round(ratio[0]*mCSB_dragger[0].parent().height()),
					parseInt(mCSB_dragger[1].css("min-width")),Math.round(ratio[1]*mCSB_dragger[1].parent().width())
				],
				h=oldIE && (l[1]<l[0]) ? l[0] : l[1],w=oldIE && (l[3]<l[2]) ? l[2] : l[3];
			mCSB_dragger[0].css({
				"height":h,"max-height":(mCSB_dragger[0].parent().height()-10)
			}).find(".mCSB_dragger_bar").css({"line-height":l[0]+"px"});
			mCSB_dragger[1].css({
				"width":w,"max-width":(mCSB_dragger[1].parent().width()-10)
			});
		},
		/* -------------------- */


		/* calculates scrollbar to content ratio */
		_scrollRatio=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				scrollAmount=[mCSB_container.outerHeight(false)-mCustomScrollBox.height(),mCSB_container.outerWidth(false)-mCustomScrollBox.width()],
				ratio=[
					scrollAmount[0]/(mCSB_dragger[0].parent().height()-mCSB_dragger[0].height()),
					scrollAmount[1]/(mCSB_dragger[1].parent().width()-mCSB_dragger[1].width())
				];
			d.scrollRatio={y:ratio[0],x:ratio[1]};
		},
		/* -------------------- */


		/* toggles scrolling classes */
		_onDragClasses=function(el,action,xpnd){
			var expandClass=xpnd ? classes[0]+"_expanded" : "",
				scrollbar=el.closest(".mCSB_scrollTools");
			if(action==="active"){
				el.toggleClass(classes[0]+" "+expandClass); scrollbar.toggleClass(classes[1]);
				el[0]._draggable=el[0]._draggable ? 0 : 1;
			}else{
				if(!el[0]._draggable){
					if(action==="hide"){
						el.removeClass(classes[0]); scrollbar.removeClass(classes[1]);
					}else{
						el.addClass(classes[0]); scrollbar.addClass(classes[1]);
					}
				}
			}
		},
		/* -------------------- */


		/* checks if content overflows its container to determine if scrolling is required */
		_overflowed=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				contentHeight=d.overflowed==null ? mCSB_container.height() : mCSB_container.outerHeight(false),
				contentWidth=d.overflowed==null ? mCSB_container.width() : mCSB_container.outerWidth(false),
				h=mCSB_container[0].scrollHeight,w=mCSB_container[0].scrollWidth;
			if(h>contentHeight){contentHeight=h;}
			if(w>contentWidth){contentWidth=w;}
			return [contentHeight>mCustomScrollBox.height(),contentWidth>mCustomScrollBox.width()];
		},
		/* -------------------- */


		/* resets content position to 0 */
		_resetContentPosition=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];
			_stop($this); /* stop any current scrolling before resetting */
			if((o.axis!=="x" && !d.overflowed[0]) || (o.axis==="y" && d.overflowed[0])){ /* reset y */
				mCSB_dragger[0].add(mCSB_container).css("top",0);
				_scrollTo($this,"_resetY");
			}
			if((o.axis!=="y" && !d.overflowed[1]) || (o.axis==="x" && d.overflowed[1])){ /* reset x */
				var cx=dx=0;
				if(d.langDir==="rtl"){ /* adjust left position for rtl direction */
					cx=mCustomScrollBox.width()-mCSB_container.outerWidth(false);
					dx=Math.abs(cx/d.scrollRatio.x);
				}
				mCSB_container.css("left",cx);
				mCSB_dragger[1].css("left",dx);
				_scrollTo($this,"_resetX");
			}
		},
		/* -------------------- */


		/* binds scrollbar events */
		_bindEvents=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt;
			if(!d.bindEvents){ /* check if events are already bound */
				_draggable.call(this);
				if(o.contentTouchScroll){_contentDraggable.call(this);}
				_selectable.call(this);
				if(o.mouseWheel.enable){ /* bind mousewheel fn when plugin is available */
					function _mwt(){
						mousewheelTimeout=setTimeout(function(){
							if(!$.event.special.mousewheel){
								_mwt();
							}else{
								clearTimeout(mousewheelTimeout);
								_mousewheel.call($this[0]);
							}
						},100);
					}
					var mousewheelTimeout;
					_mwt();
				}
				_draggerRail.call(this);
				_wrapperScroll.call(this);
				if(o.advanced.autoScrollOnFocus){_focus.call(this);}
				if(o.scrollButtons.enable){_buttons.call(this);}
				if(o.keyboard.enable){_keyboard.call(this);}
				d.bindEvents=true;
			}
		},
		/* -------------------- */


		/* unbinds scrollbar events */
		_unbindEvents=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				sb=".mCSB_"+d.idx+"_scrollbar",
				sel=$("#mCSB_"+d.idx+",#mCSB_"+d.idx+"_container,#mCSB_"+d.idx+"_container_wrapper,"+sb+" ."+classes[12]+",#mCSB_"+d.idx+"_dragger_vertical,#mCSB_"+d.idx+"_dragger_horizontal,"+sb+">a"),
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(o.advanced.releaseDraggableSelectors){sel.add($(o.advanced.releaseDraggableSelectors));}
			if(o.advanced.extraDraggableSelectors){sel.add($(o.advanced.extraDraggableSelectors));}
			if(d.bindEvents){ /* check if events are bound */
				/* unbind namespaced events from document/selectors */
				$(document).add($(!_canAccessIFrame() || top.document)).unbind("."+namespace);
				sel.each(function(){
					$(this).unbind("."+namespace);
				});
				/* clear and delete timeouts/objects */
				clearTimeout($this[0]._focusTimeout); _delete($this[0],"_focusTimeout");
				clearTimeout(d.sequential.step); _delete(d.sequential,"step");
				clearTimeout(mCSB_container[0].onCompleteTimeout); _delete(mCSB_container[0],"onCompleteTimeout");
				d.bindEvents=false;
			}
		},
		/* -------------------- */


		/* toggles scrollbar visibility */
		_scrollbarVisibility=function(disabled){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				contentWrapper=$("#mCSB_"+d.idx+"_container_wrapper"),
				content=contentWrapper.length ? contentWrapper : $("#mCSB_"+d.idx+"_container"),
				scrollbar=[$("#mCSB_"+d.idx+"_scrollbar_vertical"),$("#mCSB_"+d.idx+"_scrollbar_horizontal")],
				mCSB_dragger=[scrollbar[0].find(".mCSB_dragger"),scrollbar[1].find(".mCSB_dragger")];
			if(o.axis!=="x"){
				if(d.overflowed[0] && !disabled){
					scrollbar[0].add(mCSB_dragger[0]).add(scrollbar[0].children("a")).css("display","block");
					content.removeClass(classes[8]+" "+classes[10]);
				}else{
					if(o.alwaysShowScrollbar){
						if(o.alwaysShowScrollbar!==2){mCSB_dragger[0].css("display","none");}
						content.removeClass(classes[10]);
					}else{
						scrollbar[0].css("display","none");
						content.addClass(classes[10]);
					}
					content.addClass(classes[8]);
				}
			}
			if(o.axis!=="y"){
				if(d.overflowed[1] && !disabled){
					scrollbar[1].add(mCSB_dragger[1]).add(scrollbar[1].children("a")).css("display","block");
					content.removeClass(classes[9]+" "+classes[11]);
				}else{
					if(o.alwaysShowScrollbar){
						if(o.alwaysShowScrollbar!==2){mCSB_dragger[1].css("display","none");}
						content.removeClass(classes[11]);
					}else{
						scrollbar[1].css("display","none");
						content.addClass(classes[11]);
					}
					content.addClass(classes[9]);
				}
			}
			if(!d.overflowed[0] && !d.overflowed[1]){
				$this.addClass(classes[5]);
			}else{
				$this.removeClass(classes[5]);
			}
		},
		/* -------------------- */


		/* returns input coordinates of pointer, touch and mouse events (relative to document) */
		_coordinates=function(e){
			var t=e.type,o=e.target.ownerDocument!==document && frameElement!==null ? [$(frameElement).offset().top,$(frameElement).offset().left] : null,
				io=_canAccessIFrame() && e.target.ownerDocument!==top.document && frameElement!==null ? [$(e.view.frameElement).offset().top,$(e.view.frameElement).offset().left] : [0,0];
			switch(t){
				case "pointerdown": case "MSPointerDown": case "pointermove": case "MSPointerMove": case "pointerup": case "MSPointerUp":
					return o ? [e.originalEvent.pageY-o[0]+io[0],e.originalEvent.pageX-o[1]+io[1],false] : [e.originalEvent.pageY,e.originalEvent.pageX,false];
					break;
				case "touchstart": case "touchmove": case "touchend":
					var touch=e.originalEvent.touches[0] || e.originalEvent.changedTouches[0],
						touches=e.originalEvent.touches.length || e.originalEvent.changedTouches.length;
					return e.target.ownerDocument!==document ? [touch.screenY,touch.screenX,touches>1] : [touch.pageY,touch.pageX,touches>1];
					break;
				default:
					return o ? [e.pageY-o[0]+io[0],e.pageX-o[1]+io[1],false] : [e.pageY,e.pageX,false];
			}
		},
		/* -------------------- */


		/*
		SCROLLBAR DRAG EVENTS
		scrolls content via scrollbar dragging
		*/
		_draggable=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				draggerId=["mCSB_"+d.idx+"_dragger_vertical","mCSB_"+d.idx+"_dragger_horizontal"],
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=$("#"+draggerId[0]+",#"+draggerId[1]),
				draggable,dragY,dragX,
				rds=o.advanced.releaseDraggableSelectors ? mCSB_dragger.add($(o.advanced.releaseDraggableSelectors)) : mCSB_dragger,
				eds=o.advanced.extraDraggableSelectors ? $(!_canAccessIFrame() || top.document).add($(o.advanced.extraDraggableSelectors)) : $(!_canAccessIFrame() || top.document);
			mCSB_dragger.bind("contextmenu."+namespace,function(e){
				e.preventDefault(); //prevent right click
			}).bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
				e.stopImmediatePropagation();
				e.preventDefault();
				if(!_mouseBtnLeft(e)){return;} /* left mouse button only */
				touchActive=true;
				if(oldIE){document.onselectstart=function(){return false;}} /* disable text selection for IE < 9 */
				_iframe.call(mCSB_container,false); /* enable scrollbar dragging over iframes by disabling their events */
				_stop($this);
				draggable=$(this);
				var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left,
					h=draggable.height()+offset.top,w=draggable.width()+offset.left;
				if(y<h && y>0 && x<w && x>0){
					dragY=y;
					dragX=x;
				}
				_onDragClasses(draggable,"active",o.autoExpandScrollbar);
			}).bind("touchmove."+namespace,function(e){
				e.stopImmediatePropagation();
				e.preventDefault();
				var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
				_drag(dragY,dragX,y,x);
			});
			$(document).add(eds).bind("mousemove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace,function(e){
				if(draggable){
					var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
					if(dragY===y && dragX===x){return;} /* has it really moved? */
					_drag(dragY,dragX,y,x);
				}
			}).add(rds).bind("mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
				if(draggable){
					_onDragClasses(draggable,"active",o.autoExpandScrollbar);
					draggable=null;
				}
				touchActive=false;
				if(oldIE){document.onselectstart=null;} /* enable text selection for IE < 9 */
				_iframe.call(mCSB_container,true); /* enable iframes events */
			});
			function _drag(dragY,dragX,y,x){
				mCSB_container[0].idleTimer=o.scrollInertia<233 ? 250 : 0;
				if(draggable.attr("id")===draggerId[1]){
					var dir="x",to=((draggable[0].offsetLeft-dragX)+x)*d.scrollRatio.x;
				}else{
					var dir="y",to=((draggable[0].offsetTop-dragY)+y)*d.scrollRatio.y;
				}
				_scrollTo($this,to.toString(),{dir:dir,drag:true});
			}
		},
		/* -------------------- */


		/*
		TOUCH SWIPE EVENTS
		scrolls content via touch swipe
		Emulates the native touch-swipe scrolling with momentum found in iOS, Android and WP devices
		*/
		_contentDraggable=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				draggable,dragY,dragX,touchStartY,touchStartX,touchMoveY=[],touchMoveX=[],startTime,runningTime,endTime,distance,speed,amount,
				durA=0,durB,overwrite=o.axis==="yx" ? "none" : "all",touchIntent=[],touchDrag,docDrag,
				iframe=mCSB_container.find("iframe"),
				events=[
					"touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace, //start
					"touchmove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace, //move
					"touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace //end
				],
				touchAction=document.body.style.touchAction!==undefined && document.body.style.touchAction!=="";
			mCSB_container.bind(events[0],function(e){
				_onTouchstart(e);
			}).bind(events[1],function(e){
				_onTouchmove(e);
			});
			mCustomScrollBox.bind(events[0],function(e){
				_onTouchstart2(e);
			}).bind(events[2],function(e){
				_onTouchend(e);
			});
			if(iframe.length){
				iframe.each(function(){
					$(this).bind("load",function(){
						/* bind events on accessible iframes */
						if(_canAccessIFrame(this)){
							$(this.contentDocument || this.contentWindow.document).bind(events[0],function(e){
								_onTouchstart(e);
								_onTouchstart2(e);
							}).bind(events[1],function(e){
								_onTouchmove(e);
							}).bind(events[2],function(e){
								_onTouchend(e);
							});
						}
					});
				});
			}
			function _onTouchstart(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){touchable=0; return;}
				touchable=1; touchDrag=0; docDrag=0; draggable=1;
				$this.removeClass("mCS_touch_action");
				var offset=mCSB_container.offset();
				dragY=_coordinates(e)[0]-offset.top;
				dragX=_coordinates(e)[1]-offset.left;
				touchIntent=[_coordinates(e)[0],_coordinates(e)[1]];
			}
			function _onTouchmove(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){return;}
				if(!o.documentTouchScroll){e.preventDefault();}
				e.stopImmediatePropagation();
				if(docDrag && !touchDrag){return;}
				if(draggable){
					runningTime=_getTime();
					var offset=mCustomScrollBox.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left,
						easing="mcsLinearOut";
					touchMoveY.push(y);
					touchMoveX.push(x);
					touchIntent[2]=Math.abs(_coordinates(e)[0]-touchIntent[0]); touchIntent[3]=Math.abs(_coordinates(e)[1]-touchIntent[1]);
					if(d.overflowed[0]){
						var limit=mCSB_dragger[0].parent().height()-mCSB_dragger[0].height(),
							prevent=((dragY-y)>0 && (y-dragY)>-(limit*d.scrollRatio.y) && (touchIntent[3]*2<touchIntent[2] || o.axis==="yx"));
					}
					if(d.overflowed[1]){
						var limitX=mCSB_dragger[1].parent().width()-mCSB_dragger[1].width(),
							preventX=((dragX-x)>0 && (x-dragX)>-(limitX*d.scrollRatio.x) && (touchIntent[2]*2<touchIntent[3] || o.axis==="yx"));
					}
					if(prevent || preventX){ /* prevent native document scrolling */
						if(!touchAction){e.preventDefault();}
						touchDrag=1;
					}else{
						docDrag=1;
						$this.addClass("mCS_touch_action");
					}
					if(touchAction){e.preventDefault();}
					amount=o.axis==="yx" ? [(dragY-y),(dragX-x)] : o.axis==="x" ? [null,(dragX-x)] : [(dragY-y),null];
					mCSB_container[0].idleTimer=250;
					if(d.overflowed[0]){_drag(amount[0],durA,easing,"y","all",true);}
					if(d.overflowed[1]){_drag(amount[1],durA,easing,"x",overwrite,true);}
				}
			}
			function _onTouchstart2(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){touchable=0; return;}
				touchable=1;
				e.stopImmediatePropagation();
				_stop($this);
				startTime=_getTime();
				var offset=mCustomScrollBox.offset();
				touchStartY=_coordinates(e)[0]-offset.top;
				touchStartX=_coordinates(e)[1]-offset.left;
				touchMoveY=[]; touchMoveX=[];
			}
			function _onTouchend(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){return;}
				draggable=0;
				e.stopImmediatePropagation();
				touchDrag=0; docDrag=0;
				endTime=_getTime();
				var offset=mCustomScrollBox.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
				if((endTime-runningTime)>30){return;}
				speed=1000/(endTime-startTime);
				var easing="mcsEaseOut",slow=speed<2.5,
					diff=slow ? [touchMoveY[touchMoveY.length-2],touchMoveX[touchMoveX.length-2]] : [0,0];
				distance=slow ? [(y-diff[0]),(x-diff[1])] : [y-touchStartY,x-touchStartX];
				var absDistance=[Math.abs(distance[0]),Math.abs(distance[1])];
				speed=slow ? [Math.abs(distance[0]/4),Math.abs(distance[1]/4)] : [speed,speed];
				var a=[
					Math.abs(mCSB_container[0].offsetTop)-(distance[0]*_m((absDistance[0]/speed[0]),speed[0])),
					Math.abs(mCSB_container[0].offsetLeft)-(distance[1]*_m((absDistance[1]/speed[1]),speed[1]))
				];
				amount=o.axis==="yx" ? [a[0],a[1]] : o.axis==="x" ? [null,a[1]] : [a[0],null];
				durB=[(absDistance[0]*4)+o.scrollInertia,(absDistance[1]*4)+o.scrollInertia];
				var md=parseInt(o.contentTouchScroll) || 0; /* absolute minimum distance required */
				amount[0]=absDistance[0]>md ? amount[0] : 0;
				amount[1]=absDistance[1]>md ? amount[1] : 0;
				if(d.overflowed[0]){_drag(amount[0],durB[0],easing,"y",overwrite,false);}
				if(d.overflowed[1]){_drag(amount[1],durB[1],easing,"x",overwrite,false);}
			}
			function _m(ds,s){
				var r=[s*1.5,s*2,s/1.5,s/2];
				if(ds>90){
					return s>4 ? r[0] : r[3];
				}else if(ds>60){
					return s>3 ? r[3] : r[2];
				}else if(ds>30){
					return s>8 ? r[1] : s>6 ? r[0] : s>4 ? s : r[2];
				}else{
					return s>8 ? s : r[3];
				}
			}
			function _drag(amount,dur,easing,dir,overwrite,drag){
				if(!amount){return;}
				_scrollTo($this,amount.toString(),{dur:dur,scrollEasing:easing,dir:dir,overwrite:overwrite,drag:drag});
			}
		},
		/* -------------------- */


		/*
		SELECT TEXT EVENTS
		scrolls content when text is selected
		*/
		_selectable=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
				namespace=pluginPfx+"_"+d.idx,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				action;
			mCSB_container.bind("mousedown."+namespace,function(e){
				if(touchable){return;}
				if(!action){action=1; touchActive=true;}
			}).add(document).bind("mousemove."+namespace,function(e){
				if(!touchable && action && _sel()){
					var offset=mCSB_container.offset(),
						y=_coordinates(e)[0]-offset.top+mCSB_container[0].offsetTop,x=_coordinates(e)[1]-offset.left+mCSB_container[0].offsetLeft;
					if(y>0 && y<wrapper.height() && x>0 && x<wrapper.width()){
						if(seq.step){_seq("off",null,"stepped");}
					}else{
						if(o.axis!=="x" && d.overflowed[0]){
							if(y<0){
								_seq("on",38);
							}else if(y>wrapper.height()){
								_seq("on",40);
							}
						}
						if(o.axis!=="y" && d.overflowed[1]){
							if(x<0){
								_seq("on",37);
							}else if(x>wrapper.width()){
								_seq("on",39);
							}
						}
					}
				}
			}).bind("mouseup."+namespace+" dragend."+namespace,function(e){
				if(touchable){return;}
				if(action){action=0; _seq("off",null);}
				touchActive=false;
			});
			function _sel(){
				return 	window.getSelection ? window.getSelection().toString() :
						document.selection && document.selection.type!="Control" ? document.selection.createRange().text : 0;
			}
			function _seq(a,c,s){
				seq.type=s && action ? "stepped" : "stepless";
				seq.scrollAmount=10;
				_sequentialScroll($this,a,c,"mcsLinearOut",s ? 60 : null);
			}
		},
		/* -------------------- */


		/*
		MOUSE WHEEL EVENT
		scrolls content via mouse-wheel
		via mouse-wheel plugin (https://github.com/brandonaaron/jquery-mousewheel)
		*/
		_mousewheel=function(){
			if(!$(this).data(pluginPfx)){return;} /* Check if the scrollbar is ready to use mousewheel events (issue: #185) */
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				iframe=$("#mCSB_"+d.idx+"_container").find("iframe");
			if(iframe.length){
				iframe.each(function(){
					$(this).bind("load",function(){
						/* bind events on accessible iframes */
						if(_canAccessIFrame(this)){
							$(this.contentDocument || this.contentWindow.document).bind("mousewheel."+namespace,function(e,delta){
								_onMousewheel(e,delta);
							});
						}
					});
				});
			}
			mCustomScrollBox.bind("mousewheel."+namespace,function(e,delta){
				_onMousewheel(e,delta);
			});
			function _onMousewheel(e,delta){
				_stop($this);
				if(_disableMousewheel($this,e.target)){return;} /* disables mouse-wheel when hovering specific elements */
				var deltaFactor=o.mouseWheel.deltaFactor!=="auto" ? parseInt(o.mouseWheel.deltaFactor) : (oldIE && e.deltaFactor<100) ? 100 : e.deltaFactor || 100,
					dur=o.scrollInertia;
				if(o.axis==="x" || o.mouseWheel.axis==="x"){
					var dir="x",
						px=[Math.round(deltaFactor*d.scrollRatio.x),parseInt(o.mouseWheel.scrollAmount)],
						amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mCustomScrollBox.width() ? mCustomScrollBox.width()*0.9 : px[0],
						contentPos=Math.abs($("#mCSB_"+d.idx+"_container")[0].offsetLeft),
						draggerPos=mCSB_dragger[1][0].offsetLeft,
						limit=mCSB_dragger[1].parent().width()-mCSB_dragger[1].width(),
						dlt=o.mouseWheel.axis==="y" ? (e.deltaY || delta) : e.deltaX;
				}else{
					var dir="y",
						px=[Math.round(deltaFactor*d.scrollRatio.y),parseInt(o.mouseWheel.scrollAmount)],
						amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mCustomScrollBox.height() ? mCustomScrollBox.height()*0.9 : px[0],
						contentPos=Math.abs($("#mCSB_"+d.idx+"_container")[0].offsetTop),
						draggerPos=mCSB_dragger[0][0].offsetTop,
						limit=mCSB_dragger[0].parent().height()-mCSB_dragger[0].height(),
						dlt=e.deltaY || delta;
				}
				if((dir==="y" && !d.overflowed[0]) || (dir==="x" && !d.overflowed[1])){return;}
				if(o.mouseWheel.invert || e.webkitDirectionInvertedFromDevice){dlt=-dlt;}
				if(o.mouseWheel.normalizeDelta){dlt=dlt<0 ? -1 : 1;}
				if((dlt>0 && draggerPos!==0) || (dlt<0 && draggerPos!==limit) || o.mouseWheel.preventDefault){
					e.stopImmediatePropagation();
					e.preventDefault();
				}
				if(e.deltaFactor<5 && !o.mouseWheel.normalizeDelta){
					//very low deltaFactor values mean some kind of delta acceleration (e.g. osx trackpad), so adjusting scrolling accordingly
					amount=e.deltaFactor; dur=17;
				}
				_scrollTo($this,(contentPos-(dlt*amount)).toString(),{dir:dir,dur:dur});
			}
		},
		/* -------------------- */


		/* checks if iframe can be accessed */
		_canAccessIFrameCache=new Object(),
		_canAccessIFrame=function(iframe){
		    var result=false,cacheKey=false,html=null;
		    if(iframe===undefined){
				cacheKey="#empty";
		    }else if($(iframe).attr("id")!==undefined){
				cacheKey=$(iframe).attr("id");
		    }
			if(cacheKey!==false && _canAccessIFrameCache[cacheKey]!==undefined){
				return _canAccessIFrameCache[cacheKey];
			}
			if(!iframe){
				try{
					var doc=top.document;
					html=doc.body.innerHTML;
				}catch(err){/* do nothing */}
				result=(html!==null);
			}else{
				try{
					var doc=iframe.contentDocument || iframe.contentWindow.document;
					html=doc.body.innerHTML;
				}catch(err){/* do nothing */}
				result=(html!==null);
			}
			if(cacheKey!==false){_canAccessIFrameCache[cacheKey]=result;}
			return result;
		},
		/* -------------------- */


		/* switches iframe's pointer-events property (drag, mousewheel etc. over cross-domain iframes) */
		_iframe=function(evt){
			var el=this.find("iframe");
			if(!el.length){return;} /* check if content contains iframes */
			var val=!evt ? "none" : "auto";
			el.css("pointer-events",val); /* for IE11, iframe's display property should not be "block" */
		},
		/* -------------------- */


		/* disables mouse-wheel when hovering specific elements like select, datalist etc. */
		_disableMousewheel=function(el,target){
			var tag=target.nodeName.toLowerCase(),
				tags=el.data(pluginPfx).opt.mouseWheel.disableOver,
				/* elements that require focus */
				focusTags=["select","textarea"];
			return $.inArray(tag,tags) > -1 && !($.inArray(tag,focusTags) > -1 && !$(target).is(":focus"));
		},
		/* -------------------- */


		/*
		DRAGGER RAIL CLICK EVENT
		scrolls content via dragger rail
		*/
		_draggerRail=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				namespace=pluginPfx+"_"+d.idx,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				mCSB_draggerContainer=$(".mCSB_"+d.idx+"_scrollbar ."+classes[12]),
				clickable;
			mCSB_draggerContainer.bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
				touchActive=true;
				if(!$(e.target).hasClass("mCSB_dragger")){clickable=1;}
			}).bind("touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
				touchActive=false;
			}).bind("click."+namespace,function(e){
				if(!clickable){return;}
				clickable=0;
				if($(e.target).hasClass(classes[12]) || $(e.target).hasClass("mCSB_draggerRail")){
					_stop($this);
					var el=$(this),mCSB_dragger=el.find(".mCSB_dragger");
					if(el.parent(".mCSB_scrollTools_horizontal").length>0){
						if(!d.overflowed[1]){return;}
						var dir="x",
							clickDir=e.pageX>mCSB_dragger.offset().left ? -1 : 1,
							to=Math.abs(mCSB_container[0].offsetLeft)-(clickDir*(wrapper.width()*0.9));
					}else{
						if(!d.overflowed[0]){return;}
						var dir="y",
							clickDir=e.pageY>mCSB_dragger.offset().top ? -1 : 1,
							to=Math.abs(mCSB_container[0].offsetTop)-(clickDir*(wrapper.height()*0.9));
					}
					_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
				}
			});
		},
		/* -------------------- */


		/*
		FOCUS EVENT
		scrolls content via element focus (e.g. clicking an input, pressing TAB key etc.)
		*/
		_focus=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent();
			mCSB_container.bind("focusin."+namespace,function(e){
				var el=$(document.activeElement),
					nested=mCSB_container.find(".mCustomScrollBox").length,
					dur=0;
				if(!el.is(o.advanced.autoScrollOnFocus)){return;}
				_stop($this);
				clearTimeout($this[0]._focusTimeout);
				$this[0]._focusTimer=nested ? (dur+17)*nested : 0;
				$this[0]._focusTimeout=setTimeout(function(){
					var	to=[_childPos(el)[0],_childPos(el)[1]],
						contentPos=[mCSB_container[0].offsetTop,mCSB_container[0].offsetLeft],
						isVisible=[
							(contentPos[0]+to[0]>=0 && contentPos[0]+to[0]<wrapper.height()-el.outerHeight(false)),
							(contentPos[1]+to[1]>=0 && contentPos[0]+to[1]<wrapper.width()-el.outerWidth(false))
						],
						overwrite=(o.axis==="yx" && !isVisible[0] && !isVisible[1]) ? "none" : "all";
					if(o.axis!=="x" && !isVisible[0]){
						_scrollTo($this,to[0].toString(),{dir:"y",scrollEasing:"mcsEaseInOut",overwrite:overwrite,dur:dur});
					}
					if(o.axis!=="y" && !isVisible[1]){
						_scrollTo($this,to[1].toString(),{dir:"x",scrollEasing:"mcsEaseInOut",overwrite:overwrite,dur:dur});
					}
				},$this[0]._focusTimer);
			});
		},
		/* -------------------- */


		/* sets content wrapper scrollTop/scrollLeft always to 0 */
		_wrapperScroll=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				namespace=pluginPfx+"_"+d.idx,
				wrapper=$("#mCSB_"+d.idx+"_container").parent();
			wrapper.bind("scroll."+namespace,function(e){
				if(wrapper.scrollTop()!==0 || wrapper.scrollLeft()!==0){
					$(".mCSB_"+d.idx+"_scrollbar").css("visibility","hidden"); /* hide scrollbar(s) */
				}
			});
		},
		/* -------------------- */


		/*
		BUTTONS EVENTS
		scrolls content via up, down, left and right buttons
		*/
		_buttons=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
				namespace=pluginPfx+"_"+d.idx,
				sel=".mCSB_"+d.idx+"_scrollbar",
				btn=$(sel+">a");
			btn.bind("contextmenu."+namespace,function(e){
				e.preventDefault(); //prevent right click
			}).bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace+" mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace+" mouseout."+namespace+" pointerout."+namespace+" MSPointerOut."+namespace+" click."+namespace,function(e){
				e.preventDefault();
				if(!_mouseBtnLeft(e)){return;} /* left mouse button only */
				var btnClass=$(this).attr("class");
				seq.type=o.scrollButtons.scrollType;
				switch(e.type){
					case "mousedown": case "touchstart": case "pointerdown": case "MSPointerDown":
						if(seq.type==="stepped"){return;}
						touchActive=true;
						d.tweenRunning=false;
						_seq("on",btnClass);
						break;
					case "mouseup": case "touchend": case "pointerup": case "MSPointerUp":
					case "mouseout": case "pointerout": case "MSPointerOut":
						if(seq.type==="stepped"){return;}
						touchActive=false;
						if(seq.dir){_seq("off",btnClass);}
						break;
					case "click":
						if(seq.type!=="stepped" || d.tweenRunning){return;}
						_seq("on",btnClass);
						break;
				}
				function _seq(a,c){
					seq.scrollAmount=o.scrollButtons.scrollAmount;
					_sequentialScroll($this,a,c);
				}
			});
		},
		/* -------------------- */


		/*
		KEYBOARD EVENTS
		scrolls content via keyboard
		Keys: up arrow, down arrow, left arrow, right arrow, PgUp, PgDn, Home, End
		*/
		_keyboard=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
				namespace=pluginPfx+"_"+d.idx,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				editables="input,textarea,select,datalist,keygen,[contenteditable='true']",
				iframe=mCSB_container.find("iframe"),
				events=["blur."+namespace+" keydown."+namespace+" keyup."+namespace];
			if(iframe.length){
				iframe.each(function(){
					$(this).bind("load",function(){
						/* bind events on accessible iframes */
						if(_canAccessIFrame(this)){
							$(this.contentDocument || this.contentWindow.document).bind(events[0],function(e){
								_onKeyboard(e);
							});
						}
					});
				});
			}
			mCustomScrollBox.attr("tabindex","0").bind(events[0],function(e){
				_onKeyboard(e);
			});
			function _onKeyboard(e){
				switch(e.type){
					case "blur":
						if(d.tweenRunning && seq.dir){_seq("off",null);}
						break;
					case "keydown": case "keyup":
						var code=e.keyCode ? e.keyCode : e.which,action="on";
						if((o.axis!=="x" && (code===38 || code===40)) || (o.axis!=="y" && (code===37 || code===39))){
							/* up (38), down (40), left (37), right (39) arrows */
							if(((code===38 || code===40) && !d.overflowed[0]) || ((code===37 || code===39) && !d.overflowed[1])){return;}
							if(e.type==="keyup"){action="off";}
							if(!$(document.activeElement).is(editables)){
								e.preventDefault();
								e.stopImmediatePropagation();
								_seq(action,code);
							}
						}else if(code===33 || code===34){
							/* PgUp (33), PgDn (34) */
							if(d.overflowed[0] || d.overflowed[1]){
								e.preventDefault();
								e.stopImmediatePropagation();
							}
							if(e.type==="keyup"){
								_stop($this);
								var keyboardDir=code===34 ? -1 : 1;
								if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
									var dir="x",to=Math.abs(mCSB_container[0].offsetLeft)-(keyboardDir*(wrapper.width()*0.9));
								}else{
									var dir="y",to=Math.abs(mCSB_container[0].offsetTop)-(keyboardDir*(wrapper.height()*0.9));
								}
								_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
							}
						}else if(code===35 || code===36){
							/* End (35), Home (36) */
							if(!$(document.activeElement).is(editables)){
								if(d.overflowed[0] || d.overflowed[1]){
									e.preventDefault();
									e.stopImmediatePropagation();
								}
								if(e.type==="keyup"){
									if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
										var dir="x",to=code===35 ? Math.abs(wrapper.width()-mCSB_container.outerWidth(false)) : 0;
									}else{
										var dir="y",to=code===35 ? Math.abs(wrapper.height()-mCSB_container.outerHeight(false)) : 0;
									}
									_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
								}
							}
						}
						break;
				}
				function _seq(a,c){
					seq.type=o.keyboard.scrollType;
					seq.scrollAmount=o.keyboard.scrollAmount;
					if(seq.type==="stepped" && d.tweenRunning){return;}
					_sequentialScroll($this,a,c);
				}
			}
		},
		/* -------------------- */


		/* scrolls content sequentially (used when scrolling via buttons, keyboard arrows etc.) */
		_sequentialScroll=function(el,action,trigger,e,s){
			var d=el.data(pluginPfx),o=d.opt,seq=d.sequential,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				once=seq.type==="stepped" ? true : false,
				steplessSpeed=o.scrollInertia < 26 ? 26 : o.scrollInertia, /* 26/1.5=17 */
				steppedSpeed=o.scrollInertia < 1 ? 17 : o.scrollInertia;
			switch(action){
				case "on":
					seq.dir=[
						(trigger===classes[16] || trigger===classes[15] || trigger===39 || trigger===37 ? "x" : "y"),
						(trigger===classes[13] || trigger===classes[15] || trigger===38 || trigger===37 ? -1 : 1)
					];
					_stop(el);
					if(_isNumeric(trigger) && seq.type==="stepped"){return;}
					_on(once);
					break;
				case "off":
					_off();
					if(once || (d.tweenRunning && seq.dir)){
						_on(true);
					}
					break;
			}

			/* starts sequence */
			function _on(once){
				if(o.snapAmount){seq.scrollAmount=!(o.snapAmount instanceof Array) ? o.snapAmount : seq.dir[0]==="x" ? o.snapAmount[1] : o.snapAmount[0];} /* scrolling snapping */
				var c=seq.type!=="stepped", /* continuous scrolling */
					t=s ? s : !once ? 1000/60 : c ? steplessSpeed/1.5 : steppedSpeed, /* timer */
					m=!once ? 2.5 : c ? 7.5 : 40, /* multiplier */
					contentPos=[Math.abs(mCSB_container[0].offsetTop),Math.abs(mCSB_container[0].offsetLeft)],
					ratio=[d.scrollRatio.y>10 ? 10 : d.scrollRatio.y,d.scrollRatio.x>10 ? 10 : d.scrollRatio.x],
					amount=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*(ratio[1]*m)) : contentPos[0]+(seq.dir[1]*(ratio[0]*m)),
					px=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*parseInt(seq.scrollAmount)) : contentPos[0]+(seq.dir[1]*parseInt(seq.scrollAmount)),
					to=seq.scrollAmount!=="auto" ? px : amount,
					easing=e ? e : !once ? "mcsLinear" : c ? "mcsLinearOut" : "mcsEaseInOut",
					onComplete=!once ? false : true;
				if(once && t<17){
					to=seq.dir[0]==="x" ? contentPos[1] : contentPos[0];
				}
				_scrollTo(el,to.toString(),{dir:seq.dir[0],scrollEasing:easing,dur:t,onComplete:onComplete});
				if(once){
					seq.dir=false;
					return;
				}
				clearTimeout(seq.step);
				seq.step=setTimeout(function(){
					_on();
				},t);
			}
			/* stops sequence */
			function _off(){
				clearTimeout(seq.step);
				_delete(seq,"step");
				_stop(el);
			}
		},
		/* -------------------- */


		/* returns a yx array from value */
		_arr=function(val){
			var o=$(this).data(pluginPfx).opt,vals=[];
			if(typeof val==="function"){val=val();} /* check if the value is a single anonymous function */
			/* check if value is object or array, its length and create an array with yx values */
			if(!(val instanceof Array)){ /* object value (e.g. {y:"100",x:"100"}, 100 etc.) */
				vals[0]=val.y ? val.y : val.x || o.axis==="x" ? null : val;
				vals[1]=val.x ? val.x : val.y || o.axis==="y" ? null : val;
			}else{ /* array value (e.g. [100,100]) */
				vals=val.length>1 ? [val[0],val[1]] : o.axis==="x" ? [null,val[0]] : [val[0],null];
			}
			/* check if array values are anonymous functions */
			if(typeof vals[0]==="function"){vals[0]=vals[0]();}
			if(typeof vals[1]==="function"){vals[1]=vals[1]();}
			return vals;
		},
		/* -------------------- */


		/* translates values (e.g. "top", 100, "100px", "#id") to actual scroll-to positions */
		_to=function(val,dir){
			if(val==null || typeof val=="undefined"){return;}
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				t=typeof val;
			if(!dir){dir=o.axis==="x" ? "x" : "y";}
			var contentLength=dir==="x" ? mCSB_container.outerWidth(false)-wrapper.width() : mCSB_container.outerHeight(false)-wrapper.height(),
				contentPos=dir==="x" ? mCSB_container[0].offsetLeft : mCSB_container[0].offsetTop,
				cssProp=dir==="x" ? "left" : "top";
			switch(t){
				case "function": /* this currently is not used. Consider removing it */
					return val();
					break;
				case "object": /* js/jquery object */
					var obj=val.jquery ? val : $(val);
					if(!obj.length){return;}
					return dir==="x" ? _childPos(obj)[1] : _childPos(obj)[0];
					break;
				case "string": case "number":
					if(_isNumeric(val)){ /* numeric value */
						return Math.abs(val);
					}else if(val.indexOf("%")!==-1){ /* percentage value */
						return Math.abs(contentLength*parseInt(val)/100);
					}else if(val.indexOf("-=")!==-1){ /* decrease value */
						return Math.abs(contentPos-parseInt(val.split("-=")[1]));
					}else if(val.indexOf("+=")!==-1){ /* inrease value */
						var p=(contentPos+parseInt(val.split("+=")[1]));
						return p>=0 ? 0 : Math.abs(p);
					}else if(val.indexOf("px")!==-1 && _isNumeric(val.split("px")[0])){ /* pixels string value (e.g. "100px") */
						return Math.abs(val.split("px")[0]);
					}else{
						if(val==="top" || val==="left"){ /* special strings */
							return 0;
						}else if(val==="bottom"){
							return Math.abs(wrapper.height()-mCSB_container.outerHeight(false));
						}else if(val==="right"){
							return Math.abs(wrapper.width()-mCSB_container.outerWidth(false));
						}else if(val==="first" || val==="last"){
							var obj=mCSB_container.find(":"+val);
							return dir==="x" ? _childPos(obj)[1] : _childPos(obj)[0];
						}else{
							if($(val).length){ /* jquery selector */
								return dir==="x" ? _childPos($(val))[1] : _childPos($(val))[0];
							}else{ /* other values (e.g. "100em") */
								mCSB_container.css(cssProp,val);
								methods.update.call(null,$this[0]);
								return;
							}
						}
					}
					break;
			}
		},
		/* -------------------- */


		/* calls the update method automatically */
		_autoUpdate=function(rem){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(rem){
				/*
				removes autoUpdate timer
				usage: _autoUpdate.call(this,"remove");
				*/
				clearTimeout(mCSB_container[0].autoUpdate);
				_delete(mCSB_container[0],"autoUpdate");
				return;
			}
			upd();
			function upd(){
				clearTimeout(mCSB_container[0].autoUpdate);
				if($this.parents("html").length===0){
					/* check element in dom tree */
					$this=null;
					return;
				}
				mCSB_container[0].autoUpdate=setTimeout(function(){
					/* update on specific selector(s) length and size change */
					if(o.advanced.updateOnSelectorChange){
						d.poll.change.n=sizesSum();
						if(d.poll.change.n!==d.poll.change.o){
							d.poll.change.o=d.poll.change.n;
							doUpd(3);
							return;
						}
					}
					/* update on main element and scrollbar size changes */
					if(o.advanced.updateOnContentResize){
						d.poll.size.n=$this[0].scrollHeight+$this[0].scrollWidth+mCSB_container[0].offsetHeight+$this[0].offsetHeight+$this[0].offsetWidth;
						if(d.poll.size.n!==d.poll.size.o){
							d.poll.size.o=d.poll.size.n;
							doUpd(1);
							return;
						}
					}
					/* update on image load */
					if(o.advanced.updateOnImageLoad){
						if(!(o.advanced.updateOnImageLoad==="auto" && o.axis==="y")){ //by default, it doesn't run on vertical content
							d.poll.img.n=mCSB_container.find("img").length;
							if(d.poll.img.n!==d.poll.img.o){
								d.poll.img.o=d.poll.img.n;
								mCSB_container.find("img").each(function(){
									imgLoader(this);
								});
								return;
							}
						}
					}
					if(o.advanced.updateOnSelectorChange || o.advanced.updateOnContentResize || o.advanced.updateOnImageLoad){upd();}
				},o.advanced.autoUpdateTimeout);
			}
			/* a tiny image loader */
			function imgLoader(el){
				if($(el).hasClass(classes[2])){doUpd(); return;}
				var img=new Image();
				function createDelegate(contextObject,delegateMethod){
					return function(){return delegateMethod.apply(contextObject,arguments);}
				}
				function imgOnLoad(){
					this.onload=null;
					$(el).addClass(classes[2]);
					doUpd(2);
				}
				img.onload=createDelegate(img,imgOnLoad);
				img.src=el.src;
			}
			/* returns the total height and width sum of all elements matching the selector */
			function sizesSum(){
				if(o.advanced.updateOnSelectorChange===true){o.advanced.updateOnSelectorChange="*";}
				var total=0,sel=mCSB_container.find(o.advanced.updateOnSelectorChange);
				if(o.advanced.updateOnSelectorChange && sel.length>0){sel.each(function(){total+=this.offsetHeight+this.offsetWidth;});}
				return total;
			}
			/* calls the update method */
			function doUpd(cb){
				clearTimeout(mCSB_container[0].autoUpdate);
				methods.update.call(null,$this[0],cb);
			}
		},
		/* -------------------- */


		/* snaps scrolling to a multiple of a pixels number */
		_snapAmount=function(to,amount,offset){
			return (Math.round(to/amount)*amount-offset);
		},
		/* -------------------- */


		/* stops content and scrollbar animations */
		_stop=function(el){
			var d=el.data(pluginPfx),
				sel=$("#mCSB_"+d.idx+"_container,#mCSB_"+d.idx+"_container_wrapper,#mCSB_"+d.idx+"_dragger_vertical,#mCSB_"+d.idx+"_dragger_horizontal");
			sel.each(function(){
				_stopTween.call(this);
			});
		},
		/* -------------------- */


		/*
		ANIMATES CONTENT
		This is where the actual scrolling happens
		*/
		_scrollTo=function(el,to,options){
			var d=el.data(pluginPfx),o=d.opt,
				defaults={
					trigger:"internal",
					dir:"y",
					scrollEasing:"mcsEaseOut",
					drag:false,
					dur:o.scrollInertia,
					overwrite:"all",
					callbacks:true,
					onStart:true,
					onUpdate:true,
					onComplete:true
				},
				options=$.extend(defaults,options),
				dur=[options.dur,(options.drag ? 0 : options.dur)],
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				totalScrollOffsets=o.callbacks.onTotalScrollOffset ? _arr.call(el,o.callbacks.onTotalScrollOffset) : [0,0],
				totalScrollBackOffsets=o.callbacks.onTotalScrollBackOffset ? _arr.call(el,o.callbacks.onTotalScrollBackOffset) : [0,0];
			d.trigger=options.trigger;
			if(wrapper.scrollTop()!==0 || wrapper.scrollLeft()!==0){ /* always reset scrollTop/Left */
				$(".mCSB_"+d.idx+"_scrollbar").css("visibility","visible");
				wrapper.scrollTop(0).scrollLeft(0);
			}
			if(to==="_resetY" && !d.contentReset.y){
				/* callbacks: onOverflowYNone */
				if(_cb("onOverflowYNone")){o.callbacks.onOverflowYNone.call(el[0]);}
				d.contentReset.y=1;
			}
			if(to==="_resetX" && !d.contentReset.x){
				/* callbacks: onOverflowXNone */
				if(_cb("onOverflowXNone")){o.callbacks.onOverflowXNone.call(el[0]);}
				d.contentReset.x=1;
			}
			if(to==="_resetY" || to==="_resetX"){return;}
			if((d.contentReset.y || !el[0].mcs) && d.overflowed[0]){
				/* callbacks: onOverflowY */
				if(_cb("onOverflowY")){o.callbacks.onOverflowY.call(el[0]);}
				d.contentReset.x=null;
			}
			if((d.contentReset.x || !el[0].mcs) && d.overflowed[1]){
				/* callbacks: onOverflowX */
				if(_cb("onOverflowX")){o.callbacks.onOverflowX.call(el[0]);}
				d.contentReset.x=null;
			}
			if(o.snapAmount){ /* scrolling snapping */
				var snapAmount=!(o.snapAmount instanceof Array) ? o.snapAmount : options.dir==="x" ? o.snapAmount[1] : o.snapAmount[0];
				to=_snapAmount(to,snapAmount,o.snapOffset);
			}
			switch(options.dir){
				case "x":
					var mCSB_dragger=$("#mCSB_"+d.idx+"_dragger_horizontal"),
						property="left",
						contentPos=mCSB_container[0].offsetLeft,
						limit=[
							mCustomScrollBox.width()-mCSB_container.outerWidth(false),
							mCSB_dragger.parent().width()-mCSB_dragger.width()
						],
						scrollTo=[to,to===0 ? 0 : (to/d.scrollRatio.x)],
						tso=totalScrollOffsets[1],
						tsbo=totalScrollBackOffsets[1],
						totalScrollOffset=tso>0 ? tso/d.scrollRatio.x : 0,
						totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.x : 0;
					break;
				case "y":
					var mCSB_dragger=$("#mCSB_"+d.idx+"_dragger_vertical"),
						property="top",
						contentPos=mCSB_container[0].offsetTop,
						limit=[
							mCustomScrollBox.height()-mCSB_container.outerHeight(false),
							mCSB_dragger.parent().height()-mCSB_dragger.height()
						],
						scrollTo=[to,to===0 ? 0 : (to/d.scrollRatio.y)],
						tso=totalScrollOffsets[0],
						tsbo=totalScrollBackOffsets[0],
						totalScrollOffset=tso>0 ? tso/d.scrollRatio.y : 0,
						totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.y : 0;
					break;
			}
			if(scrollTo[1]<0 || (scrollTo[0]===0 && scrollTo[1]===0)){
				scrollTo=[0,0];
			}else if(scrollTo[1]>=limit[1]){
				scrollTo=[limit[0],limit[1]];
			}else{
				scrollTo[0]=-scrollTo[0];
			}
			if(!el[0].mcs){
				_mcs();  /* init mcs object (once) to make it available before callbacks */
				if(_cb("onInit")){o.callbacks.onInit.call(el[0]);} /* callbacks: onInit */
			}
			clearTimeout(mCSB_container[0].onCompleteTimeout);
			_tweenTo(mCSB_dragger[0],property,Math.round(scrollTo[1]),dur[1],options.scrollEasing);
			if(!d.tweenRunning && ((contentPos===0 && scrollTo[0]>=0) || (contentPos===limit[0] && scrollTo[0]<=limit[0]))){return;}
			_tweenTo(mCSB_container[0],property,Math.round(scrollTo[0]),dur[0],options.scrollEasing,options.overwrite,{
				onStart:function(){
					if(options.callbacks && options.onStart && !d.tweenRunning){
						/* callbacks: onScrollStart */
						if(_cb("onScrollStart")){_mcs(); o.callbacks.onScrollStart.call(el[0]);}
						d.tweenRunning=true;
						_onDragClasses(mCSB_dragger);
						d.cbOffsets=_cbOffsets();
					}
				},onUpdate:function(){
					if(options.callbacks && options.onUpdate){
						/* callbacks: whileScrolling */
						if(_cb("whileScrolling")){_mcs(); o.callbacks.whileScrolling.call(el[0]);}
					}
				},onComplete:function(){
					if(options.callbacks && options.onComplete){
						if(o.axis==="yx"){clearTimeout(mCSB_container[0].onCompleteTimeout);}
						var t=mCSB_container[0].idleTimer || 0;
						mCSB_container[0].onCompleteTimeout=setTimeout(function(){
							/* callbacks: onScroll, onTotalScroll, onTotalScrollBack */
							if(_cb("onScroll")){_mcs(); o.callbacks.onScroll.call(el[0]);}
							if(_cb("onTotalScroll") && scrollTo[1]>=limit[1]-totalScrollOffset && d.cbOffsets[0]){_mcs(); o.callbacks.onTotalScroll.call(el[0]);}
							if(_cb("onTotalScrollBack") && scrollTo[1]<=totalScrollBackOffset && d.cbOffsets[1]){_mcs(); o.callbacks.onTotalScrollBack.call(el[0]);}
							d.tweenRunning=false;
							mCSB_container[0].idleTimer=0;
							_onDragClasses(mCSB_dragger,"hide");
						},t);
					}
				}
			});
			/* checks if callback function exists */
			function _cb(cb){
				return d && o.callbacks[cb] && typeof o.callbacks[cb]==="function";
			}
			/* checks whether callback offsets always trigger */
			function _cbOffsets(){
				return [o.callbacks.alwaysTriggerOffsets || contentPos>=limit[0]+tso,o.callbacks.alwaysTriggerOffsets || contentPos<=-tsbo];
			}
			/*
			populates object with useful values for the user
			values:
				content: this.mcs.content
				content top position: this.mcs.top
				content left position: this.mcs.left
				dragger top position: this.mcs.draggerTop
				dragger left position: this.mcs.draggerLeft
				scrolling y percentage: this.mcs.topPct
				scrolling x percentage: this.mcs.leftPct
				scrolling direction: this.mcs.direction
			*/
			function _mcs(){
				var cp=[mCSB_container[0].offsetTop,mCSB_container[0].offsetLeft], /* content position */
					dp=[mCSB_dragger[0].offsetTop,mCSB_dragger[0].offsetLeft], /* dragger position */
					cl=[mCSB_container.outerHeight(false),mCSB_container.outerWidth(false)], /* content length */
					pl=[mCustomScrollBox.height(),mCustomScrollBox.width()]; /* content parent length */
				el[0].mcs={
					content:mCSB_container, /* original content wrapper as jquery object */
					top:cp[0],left:cp[1],draggerTop:dp[0],draggerLeft:dp[1],
					topPct:Math.round((100*Math.abs(cp[0]))/(Math.abs(cl[0])-pl[0])),leftPct:Math.round((100*Math.abs(cp[1]))/(Math.abs(cl[1])-pl[1])),
					direction:options.dir
				};
				/*
				this refers to the original element containing the scrollbar(s)
				usage: this.mcs.top, this.mcs.leftPct etc.
				*/
			}
		},
		/* -------------------- */


		/*
		CUSTOM JAVASCRIPT ANIMATION TWEEN
		Lighter and faster than jquery animate() and css transitions
		Animates top/left properties and includes easings
		*/
		_tweenTo=function(el,prop,to,duration,easing,overwrite,callbacks){
			if(!el._mTween){el._mTween={top:{},left:{}};}
			var callbacks=callbacks || {},
				onStart=callbacks.onStart || function(){},onUpdate=callbacks.onUpdate || function(){},onComplete=callbacks.onComplete || function(){},
				startTime=_getTime(),_delay,progress=0,from=el.offsetTop,elStyle=el.style,_request,tobj=el._mTween[prop];
			if(prop==="left"){from=el.offsetLeft;}
			var diff=to-from;
			tobj.stop=0;
			if(overwrite!=="none"){_cancelTween();}
			_startTween();
			function _step(){
				if(tobj.stop){return;}
				if(!progress){onStart.call();}
				progress=_getTime()-startTime;
				_tween();
				if(progress>=tobj.time){
					tobj.time=(progress>tobj.time) ? progress+_delay-(progress-tobj.time) : progress+_delay-1;
					if(tobj.time<progress+1){tobj.time=progress+1;}
				}
				if(tobj.time<duration){tobj.id=_request(_step);}else{onComplete.call();}
			}
			function _tween(){
				if(duration>0){
					tobj.currVal=_ease(tobj.time,from,diff,duration,easing);
					elStyle[prop]=Math.round(tobj.currVal)+"px";
				}else{
					elStyle[prop]=to+"px";
				}
				onUpdate.call();
			}
			function _startTween(){
				_delay=1000/60;
				tobj.time=progress+_delay;
				_request=(!window.requestAnimationFrame) ? function(f){_tween(); return setTimeout(f,0.01);} : window.requestAnimationFrame;
				tobj.id=_request(_step);
			}
			function _cancelTween(){
				if(tobj.id==null){return;}
				if(!window.requestAnimationFrame){clearTimeout(tobj.id);
				}else{window.cancelAnimationFrame(tobj.id);}
				tobj.id=null;
			}
			function _ease(t,b,c,d,type){
				switch(type){
					case "linear": case "mcsLinear":
						return c*t/d + b;
						break;
					case "mcsLinearOut":
						t/=d; t--; return c * Math.sqrt(1 - t*t) + b;
						break;
					case "easeInOutSmooth":
						t/=d/2;
						if(t<1) return c/2*t*t + b;
						t--;
						return -c/2 * (t*(t-2) - 1) + b;
						break;
					case "easeInOutStrong":
						t/=d/2;
						if(t<1) return c/2 * Math.pow( 2, 10 * (t - 1) ) + b;
						t--;
						return c/2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
						break;
					case "easeInOut": case "mcsEaseInOut":
						t/=d/2;
						if(t<1) return c/2*t*t*t + b;
						t-=2;
						return c/2*(t*t*t + 2) + b;
						break;
					case "easeOutSmooth":
						t/=d; t--;
						return -c * (t*t*t*t - 1) + b;
						break;
					case "easeOutStrong":
						return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
						break;
					case "easeOut": case "mcsEaseOut": default:
						var ts=(t/=d)*t,tc=ts*t;
						return b+c*(0.499999999999997*tc*ts + -2.5*ts*ts + 5.5*tc + -6.5*ts + 4*t);
				}
			}
		},
		/* -------------------- */


		/* returns current time */
		_getTime=function(){
			if(window.performance && window.performance.now){
				return window.performance.now();
			}else{
				if(window.performance && window.performance.webkitNow){
					return window.performance.webkitNow();
				}else{
					if(Date.now){return Date.now();}else{return new Date().getTime();}
				}
			}
		},
		/* -------------------- */


		/* stops a tween */
		_stopTween=function(){
			var el=this;
			if(!el._mTween){el._mTween={top:{},left:{}};}
			var props=["top","left"];
			for(var i=0; i<props.length; i++){
				var prop=props[i];
				if(el._mTween[prop].id){
					if(!window.requestAnimationFrame){clearTimeout(el._mTween[prop].id);
					}else{window.cancelAnimationFrame(el._mTween[prop].id);}
					el._mTween[prop].id=null;
					el._mTween[prop].stop=1;
				}
			}
		},
		/* -------------------- */


		/* deletes a property (avoiding the exception thrown by IE) */
		_delete=function(c,m){
			try{delete c[m];}catch(e){c[m]=null;}
		},
		/* -------------------- */


		/* detects left mouse button */
		_mouseBtnLeft=function(e){
			return !(e.which && e.which!==1);
		},
		/* -------------------- */


		/* detects if pointer type event is touch */
		_pointerTouch=function(e){
			var t=e.originalEvent.pointerType;
			return !(t && t!=="touch" && t!==2);
		},
		/* -------------------- */


		/* checks if value is numeric */
		_isNumeric=function(val){
			return !isNaN(parseFloat(val)) && isFinite(val);
		},
		/* -------------------- */


		/* returns element position according to content */
		_childPos=function(el){
			var p=el.parents(".mCSB_container");
			return [el.offset().top-p.offset().top,el.offset().left-p.offset().left];
		},
		/* -------------------- */


		/* checks if browser tab is hidden/inactive via Page Visibility API */
		_isTabHidden=function(){
			var prop=_getHiddenProp();
			if(!prop) return false;
			return document[prop];
			function _getHiddenProp(){
				var pfx=["webkit","moz","ms","o"];
				if("hidden" in document) return "hidden"; //natively supported
				for(var i=0; i<pfx.length; i++){ //prefixed
				    if((pfx[i]+"Hidden") in document)
				        return pfx[i]+"Hidden";
				}
				return null; //not supported
			}
		};
		/* -------------------- */





	/*
	----------------------------------------
	PLUGIN SETUP
	----------------------------------------
	*/

	/* plugin constructor functions */
	$.fn[pluginNS]=function(method){ /* usage: $(selector).mCustomScrollbar(); */
		if(methods[method]){
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		}else if(typeof method==="object" || !method){
			return methods.init.apply(this,arguments);
		}else{
			$.error("Method "+method+" does not exist");
		}
	};
	$[pluginNS]=function(method){ /* usage: $.mCustomScrollbar(); */
		if(methods[method]){
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		}else if(typeof method==="object" || !method){
			return methods.init.apply(this,arguments);
		}else{
			$.error("Method "+method+" does not exist");
		}
	};

	/*
	allow setting plugin default options.
	usage: $.mCustomScrollbar.defaults.scrollInertia=500;
	to apply any changed default options on default selectors (below), use inside document ready fn
	e.g.: $(document).ready(function(){ $.mCustomScrollbar.defaults.scrollInertia=500; });
	*/
	$[pluginNS].defaults=defaults;

	/*
	add window object (window.mCustomScrollbar)
	usage: if(window.mCustomScrollbar){console.log("custom scrollbar plugin loaded");}
	*/
	window[pluginNS]=true;

	$(window).bind("load",function(){

		$(defaultSelector)[pluginNS](); /* add scrollbars automatically on default selector */

		/* extend jQuery expressions */
		$.extend($.expr[":"],{
			/* checks if element is within scrollable viewport */
			mcsInView:$.expr[":"].mcsInView || function(el){
				var $el=$(el),content=$el.parents(".mCSB_container"),wrapper,cPos;
				if(!content.length){return;}
				wrapper=content.parent();
				cPos=[content[0].offsetTop,content[0].offsetLeft];
				return 	cPos[0]+_childPos($el)[0]>=0 && cPos[0]+_childPos($el)[0]<wrapper.height()-$el.outerHeight(false) &&
						cPos[1]+_childPos($el)[1]>=0 && cPos[1]+_childPos($el)[1]<wrapper.width()-$el.outerWidth(false);
			},
			/* checks if element or part of element is in view of scrollable viewport */
			mcsInSight:$.expr[":"].mcsInSight || function(el,i,m){
				var $el=$(el),elD,content=$el.parents(".mCSB_container"),wrapperView,pos,wrapperViewPct,
					pctVals=m[3]==="exact" ? [[1,0],[1,0]] : [[0.9,0.1],[0.6,0.4]];
				if(!content.length){return;}
				elD=[$el.outerHeight(false),$el.outerWidth(false)];
				pos=[content[0].offsetTop+_childPos($el)[0],content[0].offsetLeft+_childPos($el)[1]];
				wrapperView=[content.parent()[0].offsetHeight,content.parent()[0].offsetWidth];
				wrapperViewPct=[elD[0]<wrapperView[0] ? pctVals[0] : pctVals[1],elD[1]<wrapperView[1] ? pctVals[0] : pctVals[1]];
				return 	pos[0]-(wrapperView[0]*wrapperViewPct[0][0])<0 && pos[0]+elD[0]-(wrapperView[0]*wrapperViewPct[0][1])>=0 &&
						pos[1]-(wrapperView[1]*wrapperViewPct[1][0])<0 && pos[1]+elD[1]-(wrapperView[1]*wrapperViewPct[1][1])>=0;
			},
			/* checks if element is overflowed having visible scrollbar(s) */
			mcsOverflow:$.expr[":"].mcsOverflow || function(el){
				var d=$(el).data(pluginPfx);
				if(!d){return;}
				return d.overflowed[0] || d.overflowed[1];
			}
		});

	});

}))}));

angular.module('AuthServices', [ 'ngResource' ]).factory('Auth', function($resource, $rootScope, $window) {

  var auth = {};
  //auth.permissions = {'app.system.user-list':true,'app.system.department-list':false};
  auth.permissions = null;

  auth.init = function(perm) {
    auth.permissions = {};

    angular.forEach(perm, function(item) {
      auth.permissions[item.PageUrl] = item;
    });

    $window.sessionStorage.setItem("authPer", angular.toJson(auth.permissions))
  };

  auth.checkPermissionForView = function(view) {
    if (auth.permissions == null) {
      auth.permissions = angular.fromJson($window.sessionStorage.getItem("authPer"));
    }

    if (!view.requiresAuthentication) {
      return true;
    }

    return userHasPermissionForView(view);
  };

  var userHasPermissionForView = function(view) {
    if (!auth.isLoggedIn()) {
      return false;
    }

    return auth.userHasPermission(view.name);
  };

  auth.userHasPermission = function(viewName) {
    if (!auth.isLoggedIn()) {
      return false;
    }

    //console.log('2 permissions=', auth.permissions);
    //console.log('auth.permissions[viewName]=', auth.permissions[viewName]);

    if (auth.permissions == null) {
      auth.permissions = angular.fromJson($window.sessionStorage.getItem("authPer"));
    }

    if (auth.permissions == null) {
      return false;
    }

    /* console.log(viewName); */

    if (viewName.indexOf(':') == -1) {
      if (auth.permissions[viewName] == null) {
        //console.log('auth.permissions viewName null');
        //return false;
        return true;
      }

      if (auth.permissions[viewName]['read'] == 'Y') {
        return true;
      }
    } else {
      var view = viewName.split(':')[0];
      var button = viewName.split(':')[1];

      if (auth.permissions[view] == null || auth.permissions[view][button] == null) {
        return false;
      }

      if (auth.permissions[view][button] == 'Y') {
        return true;
      }
    }

    return false;
  };

  auth.currentUser = function() {
    return $window.sessionStorage.user;
  };

  auth.isLoggedIn = function() {
    return $window.sessionStorage.loginUserIdx != null;
  };

  return auth;
});

/* "use strict"; */
webapp.service('customFieldApi', ['$resource', 'StaticVariable', '$rootScope', '$filter',
  function customFieldApi($resource, StaticVariable, $rootScope, $filter) {
    /**
     * * Noti
     *   - 호출 타입
     *     * customFieldApi 내 type 참고
    **/
    var translate = $filter('translate');

    var customFieldApi = {
      setReadOnlyUdcColumns : function(allColumns) {
        var udcColumns = [];
        // var udcCols = vm.allColumns.filter(x => x.CustomColumnYN == 'Y');
        var udcCols = allColumns.filter(function(x) {
          return x.CustomColumnYN == 'Y';
        });
        // for (var i = 0; i < udcCols.length; i += 4){
        var row = {};
        row.className = 'row';
        row.fieldGroup = [];

        for (var j = 0; j < udcCols.length; j++) {
          var item = {};

          if (udcCols[j] !== undefined) {
            item.key = udcCols[j].ColumnPhysicalNm;
            item.className = udcCols[j].EditColumnWidth;

            item.type = 'readOnly';

            item.templateOptions = {};
            item.templateOptions.label = udcCols[j].ColumnLogicalNm;

            row.fieldGroup.push(item);
          }
        }

        // 등록/수정 대상 사용자정의 컬럼 정보
        udcColumns.push(row);

        return udcColumns;
      },
      setEditableUdcColumns : function(allColumns) {
        var udcColumns = [];
        //      var udcCols = vm.allColumns.filter(x => x.CustomColumnYN === 'Y');
        var udcCols = allColumns.filter(function(x) {
          return x.CustomColumnYN === 'Y';
        });

        // row당 4개의 컬럼 표시
        var row = {};
        row.className = 'row';
        row.fieldGroup = [];

        for (var j = 0; j < udcCols.length; j++) {

          var item = {};
          if (udcCols[j] !== undefined) {
            item.key = udcCols[j].ColumnPhysicalNm;
            item.className = udcCols[j].EditColumnWidth+' form-right';
            console.log('udcCols : ',udcCols[j].EditColumnWidth);
            item.type = 'input';

            item.templateOptions = {};
            item.templateOptions.label = udcCols[j].ColumnLogicalNm;

            //TODO: 데이터 유형에 따라서 type을 다르게 처리 필요
            // 10-text, 20-number, 30-number(float), 40-date, 50-select
            console.log(udcCols[j]);
            switch (udcCols[j].ColumnPhysicalDataType) {
            case '20':
              item.templateOptions.type = 'number';
              item.templateOptions.placeholder = '{숫자만 입력하세요.}';
              break;
            case '30':
              item.templateOptions.type = 'number';
              item.templateOptions.placeholder = '{숫자만 입력하세요.}';
              break;
            case '40':
              item.templateOptions.type = 'text';
              item.templateOptions.placeholder = '{년-월-일}';
              break;
            case '50':
              item.type = 'select';
              item.templateOptions.valueProp = 'abbr';
              item.templateOptions.labelProp = 'name';
              item.templateOptions.options = [];

              var items = [{name:'--'+translate('Menu.CHOOSE')+'--',abbr:''}];

              if (udcCols[j].CodeKey != null && udcCols[j].CodeValue != null) {
                var codeValues = udcCols[j].CodeValue.split(',');
                var codeKeys = udcCols[j].CodeKey.split(',');

                codeValues.forEach(function(codeRow, key) {
                  var code = {};
                  code.name = codeRow;
                  code.abbr = codeKeys[key];
                  items.push(code);
                });
              } else  if (udcCols[j].ColumnCodeValue.length > 0) {
                var codeValues = udcCols[j].ColumnCodeValue.split(',');

                codeValues.forEach(function(codeRow) {
                  var code = {};
                  code.name = codeRow;
                  code.abbr = codeRow;
                  items.push(code);
                });
              }

              item.templateOptions.options = items;

              break;
            default:
              item.templateOptions.type = 'text';
              break;
            }

            row.fieldGroup.push(item);
          }
        }
        // 등록/수정 대상 사용자정의 컬럼 정보
        udcColumns.push(row);

        return udcColumns;
      },
    };
    return customFieldApi;
  },
]);

/* "use strict"; */
webapp.service("Helper", ["$state","$location",
  function($state, $location) {
    var services = {};

    function objectKeys(object) {
      var result = [];

      angular.forEach(object, function(val, key) {
        result.push(val);
      });
      return result;
    }

    services.stateIs = function(state_name) {
      var names = state_name.split('.');
      var state = '';
      var url = '';

      angular.forEach(names, function(name) {
        state = state == '' ? name : state + '.' + name;
        if ($state.get(state)) {
          url = url + $state.get(state).url;
        }
      });

      return url;
    };

    return services;
  }
]);

/* "use strict"; */
webapp.service('ifProxy',
  ['GLOBAL_CONSTANT', '$compile', 'postApi', '$window', 'gAlert', '$rootScope', '$state', 'StaticVariable', 'LoginAPISrv', '$timeout',
  function ifProxy(CONSTANT, $compile, postApi, $window, gAlert, $rootScope, $state, StaticVariable, loginApi, $timeout) {

    var vm = this;
    vm.userType = $window.sessionStorage['USE_APPTYPE'];

     /**
     * @description 멤버스 로그인
     * @param Object data : Iframe으로 받은 정보값
     * @return void
     */
    vm.membersLogin = function (data) {
      var field = data;
      field.loginId = field.memId;
      field.loginPw = field.memPwd;
      postApi.login('custLogin',field, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          //$window.localStorage['M_USER_PWD'] = field.memPwd;
          $window.localStorage['M_USER_ID'] = field.memId;
          $window.localStorage['M_USER_PW'] = field.loginPw;
          $window.localStorage['M_USER_SAVEID'] = field.saveId;
          $window.localStorage['M_USER_TYPE'] = "MEMBER";
          $window.localStorage['M_USER_SAVEAUTOLOGIN'] = field.saveAutoLogin;
          $rootScope.setUserSession(result.body.docs[0]);
          $rootScope.$broadcast('broadcastMobileChangeUserState', {});
          ifProxy.send('startLogin', { passYn: true} );
        } else {
          gAlert('', '로그인에 실패하였습니다. 다시 시도하여주세요.', {
            btn: '확인', fn: function () { }
          });
        }
      });
    };
    /**
     * @description 리더스 로그인
     * @param Object data : Iframe으로 받은 정보값
     * @return void
     */
    vm.Login = function (data) {
      var field = data;
      field.loginId = field.memId;
      field.loginPw = field.memPwd;

      postApi.login('login',field, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          //$window.localStorage['M_USER_PWD'] = field.memPwd;
          $window.localStorage['M_USER_ID'] = field.memId;
          $window.localStorage['M_USER_PW'] = field.loginPw;
          $window.localStorage['M_USER_SAVEID'] = field.saveId;
          $window.localStorage['M_USER_TYPE'] = "MASTER";
          $window.localStorage['M_USER_SAVEAUTOLOGIN'] = field.saveAutoLogin;
          $rootScope.setUserSession(result.body.docs[0]);
          $rootScope.$broadcast('broadcastMobileChangeUserState', {});
          ifProxy.send('startLogin', { passYn: true} );
        } else {

          if(result.body.docs.length > 0 && result.body.docs[0].checkApproval == "N") {
            gAlert('', result.body.docs[0].MSG, {
              btn: '확인', fn: function () { }
            });
          } else {
            gAlert('', '로그인에 실패하였습니다. 다시 시도하여주세요.', {
              btn: '확인', fn: function () { }
            });
          }
        }
      });
    };


    var ifProxy = null;
    var regEvent = true;
    ifProxy = {
      instance : this,
      responselistner : null,
      porthole : null,
      $frame : null,
      $fromRequestKey : null,
      orgTargetRequestKey : null,
      getIfProxyReqKey : null,
      reset : function () {

      },
      init : function(option){
        //$window.sessionStorage["M_LAST_PAGE"] = $state.current.name;
        this.porthole = new Porthole.WindowProxy(SHOP_DOMAIN_ADDRESSS, option.targetId);

        $frame = $("#" + option.targetId);
        $frame.attr("ng-src", option.url);
        var offset = $("#page-wrapper [ui-view]").offset();
        $frame.css("height", $(window).height() - offset.top );
        $frame.css("display", "block");
        $compile($frame)(option.scope);

        var callback = option.callback;

        if(regEvent) {
          this.porthole.addEventListener(this.reqeuest);
          regEvent = false;
        }

        if(callback.completInit != null)
          callback.completInit(this.porthole);

        if(callback.contentChangeSuccess != null)
          ifProxy.porthole.Callback_contentChangeSuccess = callback.contentChangeSuccess;

        if(callback.onMessage != null)
          ifProxy.porthole.Callback_onMessage = callback.onMessage;
      },

      reqeuest :  function(msg) {
        if (SHOP_DOMAIN_ADDRESSS.replace("https","").replace("http","") == msg.origin.replace("https","").replace("http","")) {
          ifProxy.orgTargetRequestKey = msg.data.data.requestKey;
          var action = msg.data.action;
          var sData = msg.data.data;
          if(action == "redirctLoginPage") {
            StaticVariable.sessionExpire();
            var prms = loginApi.doLogout().post().$promise;
            prms.then(function(json) {
              var temp = {};
              temp.layoutBoard = "N";
              temp.USE_APPTYPE = $window.sessionStorage["USE_APPTYPE"];
              $window.sessionStorage.clear();
              $window.localStorage.clear();
              gAlert('', '접속 정보가 변경되어 재로그인이 필요합니다.', {
                btn : '',
                fn : function() {
                  $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
                  $window.sessionStorage["USE_APPTYPE"] = temp.USE_APPTYPE;
                  vm.showTopBtn = true;
                  $rootScope.$broadcast('broadcastMobileChangeUserState', {});

                  $state.go("m.member.login");
                }
              });
            }, function(error) {
              console.error('fail', status);
            });
          }

          if(action == "setNavi" && sData.title == "회원로그인" && $window.loginUserIdx != undefined) {
            StaticVariable.sessionExpire();
            var prms = loginApi.doLogout().post().$promise;
            prms.then(function(json) {
              var temp = {};
              temp.layoutBoard = "N";
              temp.USE_APPTYPE = $window.sessionStorage["USE_APPTYPE"];
              $window.sessionStorage.clear();
              $window.localStorage.clear();
              gAlert('', '접속 정보가 변경되어 재로그인이 필요합니다.', {
                btn : '',
                fn : function() {
                  $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
                  $window.sessionStorage["USE_APPTYPE"] = temp.USE_APPTYPE;
                  vm.showTopBtn = true;
                  $rootScope.$broadcast('broadcastMobileChangeUserState', {});
                }
              });
            }, function(error) {
              console.error('fail', status);
            });
          }

          if(action == "startLogin") {
            M.fcm.getFcmToken({
              onSucess:function(token){
                msg.data.data.osType = getOs();
                msg.data.data.fcmToken = token;
                if(vm.userType == "members") {
                  vm.membersLogin(msg.data.data);
                } else {
                  vm.Login(msg.data.data);
                }
              }
            });
            return;
          }

          if(action == "findUserId" || action == "findUserPw") {
            var request = sData;
            request.mapCode = 'checkFindUserInfo';
            request.action = action;
            request.userType = vm.userType;
            postApi.openApi(request, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                console.log(result);
                var req = {};
                if(result.body.docs.length == 0) {
                  req.passYn = false;
                  gAlert('', '해당 정보를 찾을 수 없습니다.', {
                    btn: '확인', fn: function () { }
                  });
                } else {
                  req.passYn = true;
                }
                ifProxy.send(action, req);
              }
            });
            return;
          }

          if(action == "goDashboard") {
            $state.go("m.dashboard");
          }

          if(ifProxy.porthole.Callback_contentChangeSuccess != null && action == 'frameContentChangeSuccess') {
            if($window.sessionStorage["M_LAST_PAGE"] != $state.current.name) {
              ifProxy.porthole.Callback_contentChangeSuccess(sData);
              $window.sessionStorage["M_LAST_PAGE"] = $state.current.name;
            } else {

            }
            return;
          }

          var data = msg.data;
          if(data.useAuth) {

          } else {
            var response = {
              action : action,
              requestKey : data.requestKey,
              data : data.data
            };
            delete response.data.action;
            delete response.data.useAuth;
            ifProxy.porthole.Callback_onMessage(response);
          }
        } else {

        }
      },

      send : function (action, data) {
        if(data == null) data = {};
        if(data != null) {
          data.requestKey = '';
			    data.useAuth = false;
          this.porthole.post({action: action, data : data, useAuth : false});
        } else {
          var data = {};
          data.requestKey = '';
			    data.useAuth = false;
          this.porthole.post({action: action});
        }
      },

      page : function(data) {
        var thisTemp = this;
        var param = {};
        param.requestKey = ifProxy.orgTargetRequestKey;
        var porthole = this.porthole;
        postApi.openApi('getRequestKey',param, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var action = "goPages";
            data.useAuth = true;
            data.fromKey = param.requestKey;
            data.requestKey = result.body.docs[0].requestKey;
            data.userKey = result.body.docs[0].userKey;
            //porthole.post({action: action, data : data, useAuth : true});
            //alert(JSON.stringify(data))
            thisTemp.overrideSender(action, data);
          } else {
            console.error(result);
          }
        });
      },

      overrideSender : function(action, data) {
        //$timeout(
          try {

          this.porthole.post({action: action, data : data, useAuth : true})
        } catch (e) {
          console.log(e)
          $window.sessionStorage["M_LAST_PAGE"] = "";
          $state.reload($state.current.name);
        }
          //, 500);
          //this.porthole.post({action: action, data : data, useAuth : true});
        //}, 1000)

      },

      authApi : function(actionKey, data) {
        var param = {};
        param.requestKey = ifProxy.orgTargetRequestKey;
        var porthole = this.porthole;
        postApi.openApi('getRequestKey',param, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var action = "authApi";
            data.useAuth = true;
            data.actionKey = actionKey;
            data.fromKey = ifProxy.orgTargetRequestKey;
            data.requestKey = result.body.docs[0].requestKey;
            data.userKey = result.body.docs[0].userKey;

            porthole.post({action: action, data : data, useAuth : true});

          } else {
            console.error(result);
          }
        });
      }
    };
    return ifProxy;
  },
]);

/* "use strict"; */
webapp.service('postApi', ['$resource', 'StaticVariable', '$rootScope', '$window', '$http',
  function postApi($resource, StaticVariable, $rootScope, $window, $http) {
    /**
     * * Noti
     *   - 사용방법 예시
     *     * postApi.get('namespace.method', data, function(){});
     *     * postApi.get(data, function(){});
     *     * postApi.get(data, callbackFnc);
     *       > function callbackFnc() {}
     *
     *      var data = {mapCode : 'Role.getRoleList'};
     *      postApi.get(data, function(result){
     *        console.log("type B", result);
     *      });
     *      var data = {};
     *      postApi.get('Role.getRoleList', data, function(result){
     *        console.log("type C", result);
     *      });
     *      var data = {};
     *      postApi.get('Role.getRoleList', data, callback);
     *      function callback(result) {
     *        console.log("type D", result);
     *      }
     *
     *   - 호출 타입
     *     * postApi 내 type 참고
    **/

    var postApi = {
      type : {
        select : "select", insert : "insert", update : "update", delete : "delete",
        action : "action", attach : "attach", excel : "excel", api : "api",
        openApi : "openapi", login : "login",
      },
      makeData : function(D) {
        if($window.sessionStorage["loginTenantId"] != "" && $window.sessionStorage["loginTenantId"] != null && $window.sessionStorage["loginTenantId"] != undefined){
          D.userkey = $rootScope.gVariable.userKey;
        }
        if ($window.sessionStorage['loginSysAdminYN'] == "Y") {
          D.srchTenantId = $rootScope.gVariable.srchTenantId;
        }
        return D;
      },
      makeErrorMsg : function(errorType) {
        var result = {};
        if(errorType == "undefinedSqlMap") result.header = {status:405, msg: "This service requires a 'mapCode' key for data."};
        result.body = {};
        console.error(result.header);
        return result;
      },
      makeResultData : function(D){
        var result = {};
        if (D == null || D.responseVO == null) return result;
        result.header = D.responseVO.header;
        result.body = D.responseVO.body;
        return result;
      },
      getMapCode : function(D) {
        var obj = {result : false, mapcode : ""};
        for( var key in D )
          if(key.toLowerCase() == "mapcode") {
            obj.result = true;
            obj.mapcode =  D[key];
            obj.data = D;
            delete obj.data.mapCode;
          }
        return obj;
      },
      sendPost : function(p1, p2, p3, callback, callback2) {
        $resource(StaticVariable.getUrl('/'+ p1 +'/' + p2  + '/action.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(p3)).$promise.then(function (data) {
          callback(postApi.makeResultData(data), p2);
        }, function(error) {
          callback2(error, p2);
        });
      },
      sendPostOpen : function(p1, p2, p3, callback, callback2) {
        $resource(StaticVariable.getUrl('/'+ p1 +'/' + p2  + '.json'), {},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(p3)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      sendPostCustom : function(p1, p2, p3, callback, callback2) {
        $resource(StaticVariable.getUrl('/'+ p1 +'/' + p2  + '/actionCustom.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(p3)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      sendPostApi : function(p1, p2, p3, callback, callback2) {
        $resource(StaticVariable.getUrl('/'+ p1 +'/' + p2  + '.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(p3)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      login : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPostOpen(this.type.login, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPostOpen(this.type.login, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      select : function(p1, p2, callback, callback2) {
        if(Array.isArray(p1)) {
          // HJH GJ - 20200103 멀티 Select를 할 수 있는 환경 추가
          // postApi.select(data, function(result) {});
          // data 가 배열일 경우 해당 루트를 타게됨
          // data 구조 = [{mapCode: "map1", param: data},{mapCode: "map1", param: data}];
          // 기존과 다르게 mapCode 명시 - 같은 파라메터를 넘길 수 있음으로 mapCode가 key 값을 가지게 됨
          for(var i = 0; i < p1.length; i++) {
            this.sendPost(this.type.select, p1[i].mapCode, p1[i].param, function(data, mapCode){ data.mapCode = mapCode; p2(data); });
          }

        } else {
          if(typeof p1 == "string") {
              this.sendPost(this.type.select, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
          } else {
            var code = this.getMapCode(p1);
            if(code.result) {
              this.sendPost(this.type.select, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
            } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        }
      },
      callbackSelect : function(p1, p2, tempData, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.select, p1, p2, function(data){ callback(data, tempData); }, function(data){ callback2(data, tempData); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.select, code.mapcode, code.data, function(data){ p2(data, tempData); },function(data){ callback(data, tempData); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      selectCustom : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPostCustom(this.type.select, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPostCustom(this.type.select, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      insert : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.insert, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.insert, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else callback2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      update : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.update, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.update, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      delete : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.delete, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.delete, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      action : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.action, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.action, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      attach : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.attach, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.attach, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      excel : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.excel, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.excel, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      excelFile : function(p1, p2, p3, callback, callback2) {
        var url = null;
        var data = {};
        var fileNm;
        var cal1, cal2;
        if (typeof p1 == "string") {
          url = StaticVariable.getUrl('/'+ this.type.excel +'/' + p1  + '.json');

          if (typeof p2 == "string") {
            if(p2.indexOf("xls") != -1 || p2.indexOf("xlsx") != -1) {
              fileNm = p2;
            } else {
              fileNm = p2 + ".xlsx"
            }
            data = p3;
            cal1 = callback;
            cal2 = callback2;
          } else {
            fileNm = "";
            data = p2;
            cal1 = p3;
            cal2 = callback;
          }
        } else {
          var code = this.getMapCode(p1);
          if (code.result) {
            url = StaticVariable.getUrl('/'+ this.type.excel +'/' + code.mapcode  + '.json');
            data = p1;
          } else {
            p2(postApi.makeErrorMsg("undefinedSqlMap"));
            return;
          }

          if (p1.fileNm != undefined) {
            if (p1.fileNm.indexOf("xls") != -1 || p1.fileNm.indexOf("xlsx") != -1) {
              fileNm = p1.fileNm;
            }
            else if (p1.fileNm.indexOf(".pdf") != -1) {
              fileNm = p1.fileNm;
            }
            else {
              fileNm = p1.fileNm + ".xlsx";
            }
          } else {
            fileNm = "";
          }

          // 파일을 바로 반환하지 않는 경우에 대한 처리
          if(p1.returnYN != undefined && p1.returnYN == "N") fileNm = "";

          cal1 = p2;
          cal2 = p3;
        }
        var temp = {};
        temp = this.makeData(temp)
        url += "?userkey=" + temp.userkey;
        $http({
          method: 'POST',
          url: url,
          data: data,
          responseType: 'arraybuffer',
        }).success(function(data, status, headers, config) {

          if(fileNm != null && fileNm != ""){
            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([data], { type: "application/octet-stream" });

              if (window.navigator.msSaveOrOpenBlob) { // IE 10+
                  window.navigator.msSaveOrOpenBlob(blob, fileNm);
              } else { // not IE
                var url = window.URL.createObjectURL(blob);

                if (fileNm == "") {
                  var urls = url.split("/");
                  fileNm = urls[urls.length-1] + ".xlsx";
                }
                linkElement.setAttribute('href', url);
                linkElement.setAttribute("download", fileNm);
                var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                });
                linkElement.dispatchEvent(clickEvent);
                if(cal1 != undefined) {
                    cal1(data)
                }
              }
            } catch (ex) {
              if(cal2 != undefined) {
                cal2(ex)
              }
            }
          }
        }).error(function (data) {
          if(cal2 != undefined) {
            cal2(data)
          }
        });
      },
      // 위너스제이엠 보고서 관련
      wjmReport : function(data, cal1, cal2) {
        var url = null;
        var fileNm;

        var code = this.getMapCode(data);
        if (code.result) {
          url = StaticVariable.getUrl('/wjm/analysis.json');
        } else {
          p2(postApi.makeErrorMsg("undefinedSqlMap"));
          return;
        }

        if (data.fileNm != undefined) {
          fileNm = data.fileNm;
        } else {
          fileNm = "";
        }

        // 파일을 바로 반환하지 않는 경우에 대한 처리 > 개인보고서
        if(data.returnYN != undefined && data.returnYN == "N") fileNm = "";

        var temp = {};
        temp = this.makeData(temp);
        url += "?userkey=" + temp.userkey;
        $http({
          method: 'POST',
          url: url,
          data: data,
          responseType: 'arraybuffer',
        }).success(function(data, status, headers, config) {

          // 파일 다운로드
          if(fileNm != ""){
            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([data], { type: "application/octet-stream" });

              if (window.navigator.msSaveOrOpenBlob) { // IE 10+
                  window.navigator.msSaveOrOpenBlob(blob, fileNm);

              } else { // not IE
                var url = window.URL.createObjectURL(blob);
                linkElement.setAttribute('href', url);
                linkElement.setAttribute("download", fileNm);
                var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                });
                linkElement.dispatchEvent(clickEvent);
                if(cal1 != undefined) {
                    cal1(data);
                }
              }
            } catch (ex) {
              if(cal2 != undefined) {
                cal2(ex);
              }
            }
          }
        }).error(function (data) {
          if(cal2 != undefined) {
            cal2(data);
          }
        });
      },
      // 위너스제이엠 보고서 삭제
      wjmReportDel : function(data, cal1, cal2) {
        var url = null;
        var code = this.getMapCode(data);
        if (code.result) {
          url = StaticVariable.getUrl('/wjm/' + code.mapcode + '/reportDelete.json');
        } else {
          p2(postApi.makeErrorMsg("undefinedSqlMap"));
          return;
        }

        var temp = {};
        temp = this.makeData(temp);
        $resource(url, {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(data)).$promise.then(function (data) {
          cal1(postApi.makeResultData(data), code.mapcode);
        }, function(error) {
          cal2(error, code.mapcode);
        });
        // $http({
        //   method: 'POST',
        //   url: url,
        //   data: data,
        // }).success(function(data, status, headers, config) {


        // }).error(function (data) {
        //   if(cal2 != undefined) {
        //     cal2(data);
        //   }
        // });
      },
      api : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPostApi(this.type.api, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPostApi(this.type.api, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      openApi : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
          this.sendPostOpen(this.type.openApi, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPostOpen(this.type.openApi, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      ajax : {
        get : function(p1, p2, callback) {
          if(typeof p1 == "string") postApi.ajax.sendAjax(postApi.type.select, p1, p2, function(data){ callback(data); });
          else {
            var code = postApi.getMapCode(p1);
            (code.result) ? postApi.ajax.sendAjax(postApi.type.select, code.mapcode, code.data, function(data){ p2(data); })
            : p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        },
        set : function(p1, p2, callback) {
          if(typeof p1 == "string") postApi.ajax.sendAjax(postApi.type.insert, p1, p2, function(data){ callback(data); });
          else {
            var code = postApi.getMapCode(p1);
            (code.result) ? postApi.ajax.sendAjax(postApi.type.insert, code.mapcode, code.data, function(data){ p2(data); })
            : p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        },
        upt : function(p1, p2, callback) {
          if(typeof p1 == "string") postApi.ajax.sendAjax(postApi.type.update, p1, p2, function(data){ callback(data); });
          else {
            var code = postApi.getMapCode(p1);
            (code.result) ? postApi.ajax.sendAjax(postApi.type.update, code.mapcode, code.data, function(data){ p2(data); })
            : p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        },
        del : function(p1, p2, callback) {
          if(typeof p1 == "string") postApi.ajax.sendAjax(postApi.type.delete, p1, p2, function(data){ callback(data); });
          else {
            var code = postApi.getMapCode(p1);
            (code.result) ? postApi.ajax.sendAjax(postApi.type.delete, code.mapcode, code.data, function(data){ p2(data); })
            : p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        },
        sendAjax : function(type, sqlmap, data, callback) {
          if(data == undefined) data = {};
          var url = "/"  + type + "/" + sqlmap + "/action.json"
          if(sqlmap.indexOf(".json") > -1) url = "/"  + type + "/" + sqlmap;
          data.userkey = $rootScope.gVariable.userKey;
          if ($window.sessionStorage['loginSysAdminYN'] == "Y" && !data.srchTenantId) {
            data.srchTenantId = $window.sessionStorage['srchTenantId'];
          }
          url = StaticVariable.getUrl(url);
          url = url + "?" +$rootScope.gVariable.userKey;
          var reciveJsonData = null;
          $.ajax({
            type: "POST",
            url: url,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(data),
            async: false,
            crossDomain: true,
            beforeSend : function(xhr){},
            success: function(result){callback(reciveJsonData)},
            error: function(jqXHR, textStatus, errorThrown) {}
          });
        }
      }
    };
    return postApi;
  },
]);

/* "use strict"; */
webapp.service('wjmReport',
  ['GLOBAL_CONSTANT', 'postApi', 'gAlert', '$filter', 'StaticVariable',
    function wjmReport(CONSTANT, postApi, gAlert, $filter, StaticVariable) {
      var vm = this;

      // rawdata 생성
      vm.getRawData = function(data, scope, rootScope) {
        return new Promise(function(res, rej) {

          var a = document.createElement("a");
          document.body.appendChild(a);

          var resultColumns = [];
          var obj = [];
          var respList = [];
          var scoreList = [];
          var sheetNames = ["설문응답","진단결과"];

          var nm = "RawData_" + data.SvyNms // 파일명, 시트명에 사용할 수 없는 특수문자 치환.
                              .replaceAll("*","").replaceAll("?","").replaceAll("\\","")
                              .replaceAll("/","-").replaceAll(":","-").replaceAll("|","-")
                              .replaceAll("\"","'")
                              .replaceAll("<","(").replaceAll(">",")")
                              .replaceAll("[","(").replaceAll("]",")");

          scope.fileName = (nm.length > 20 ? nm.substring(0,20) : nm);
          scope.exportData = [];

          // 설문응답 헤더 조회
          data.keyId = data.SvyId;
          data.mapCode = "WjmReport.getRawResultHeader";
          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                angular.forEach(result.body.docs, function (item, idx) {

                  // 다중선택형, 우선순위형, 척도형
                  if(item.RespCnt > 0){
                    for(var i = 1; i <= item.RespCnt; i++){
                      var it = angular.copy(item);
                      it.ColNm = item.ColNm +"_"+ i;
                      it.ColDesc = item.ColDesc + "-"+ i;
                      resultColumns.push(it);
                      resultColumns[it.ColNm] = it;
                    }
                  }
                  else {
                    resultColumns.push(item);
                    resultColumns[item.ColNm] = item;
                  }
                });

                // 설문응답 데이터 조회
                data.mapCode = "WjmReport.getRawResultList";
                postApi.select(data, function (result) {
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    scope.jsonToExport = result.body.docs;

                    // 엑셀에 헤더행 추가
                    angular.forEach(resultColumns, function (item) {
                      obj.push(item.ColDesc);
                    });
                    respList.push(obj);

                    var curSvyTgtId = '';
                    var curData = [];
                    var dataList = [];
                    var chkNew = true;

                    // 문항별 답변 피벗처리
                    angular.forEach(scope.jsonToExport, function (value) {
                      if(curSvyTgtId != value.SvyTgtId) {
                        curSvyTgtId = value.SvyTgtId;
                        curData = value;
                        chkNew = true;
                      } else {
                        chkNew = false;
                      }
                      curData['QstNo_'+ value.QstNo] = value.RespVal;

                      // 다중응답 체크용
                      if(String(value.QstNo).split("_").length == 2 && isNullOrEmpty(curData['Multi_'+ value.QstNo.split("_")[0]])){
                        curData['Multi_'+ value.QstNo.split("_")[0]] = "Y";
                      }

                      if(chkNew){
                        delete curData.QstNo;
                        delete curData.RespVal;
                        dataList.push(curData);
                      }
                    });

                    // 엑셀에 데이터행 추가
                    angular.forEach(dataList, function (value) {
                      obj = [];
                      angular.forEach(resultColumns, function (item) {
                        var v = "";

                        var chk = String(item.ColNm).split("_");
                        var mQstNo = (chk.length == 3 ? "Multi_" + chk[1] : "");

                        if( ! isNullOrEmpty(value[mQstNo]) && isNullOrEmpty(value[item.ColNm])) v = "N";
                        else v = value[item.ColNm];
                        obj.push(v);
                      });
                      respList.push(obj);
                    });

                    // 채점이 없을 경우에는 진단결과 시트 없이 엑셀 다운로드
                    if(data.ScoringType == "N")
                    {
                      rootScope.excelDown(respList, scope.fileName);
                      res();
                    }
                    else {

                      // 진단결과 헤더 조회
                      resultColumns = [];
                      data.mapCode = "WjmReport.getRawScoreHeader";
                      postApi.select(data, function (result) {
                        if (result.header.status === CONSTANT.HttpStatus.OK) {
                          if (result.body.docs.length > 0) {
                            resultColumns = result.body.docs;
                            angular.forEach(resultColumns, function (item) {
                              resultColumns[item.ColNm] = item;
                            });

                            // 진단결과 데이터 조회
                            data.mapCode = "WjmReport.getRawScoreList";
                            postApi.select(data, function (result) {
                              if (result.header.status === CONSTANT.HttpStatus.OK) {
                                scope.jsonToExport = result.body.docs;

                                // 엑셀에 두번째 헤더행 먼저 추가
                                obj = [];
                                angular.forEach(resultColumns, function (item) {
                                  if(item.ColType != 2) obj.push(item.ColDesc);
                                });
                                scoreList.push(obj);

                                // 문항영역 개수가 2개일 경우 엑셀에 첫번째 헤더행 추가
                                if(data.SecLevelCnt == 2)  {
                                  obj = [];
                                  var curParentQstSec = '';
                                  angular.forEach(resultColumns, function (item) {
                                    switch (item.ColType) {
                                      case 0 : obj.push('rspan_dw'); break;
                                      case 1 :
                                        if(item.Parent == 0) obj.push('rspan_dw');
                                        else {
                                          // 각 2단계 문항영역 위치에 1단계 문항영역 컬럼 추가
                                          if(curParentQstSec != item.Parent) {
                                            curParentQstSec = item.Parent;
                                            if(curParentQstSec != 0 && resultColumns[item.Parent] != null)
                                              obj.push(resultColumns[item.Parent].ColDesc);
                                            break;
                                          }
                                          else {
                                            obj.push('cspan_lf'); break;
                                          }
                                        }
                                    }
                                  });
                                  scoreList.unshift(obj);
                                }

                                curSvyTgtId = '';
                                curData = [];
                                dataList = [];
                                chkNew = true;

                                // 하위영역별 점수 피벗처리
                                angular.forEach(scope.jsonToExport, function (value) {
                                  if(curSvyTgtId != value.SvyTgtId) {
                                    curSvyTgtId = value.SvyTgtId;
                                    curData = value;
                                    chkNew = true;
                                  } else {
                                    chkNew = false;
                                  }
                                  curData[value.QstSecId] = value.Score;

                                  if(chkNew){
                                    delete curData.Score;
                                    dataList.push(curData);
                                  }
                                });

                                // 엑셀에 데이터행 추가
                                angular.forEach(dataList, function (value) {
                                  obj = [];
                                  angular.forEach(resultColumns, function (item) {
                                    obj.push(value[item.ColNm]);

                                  });
                                  scoreList.push(obj);
                                });

                                // 엑셀 데이터셋에 추가
                                scope.exportData = [respList, scoreList];

                                // RawData 엑셀 다운로드
                                rootScope.excelDown(scope.exportData, scope.fileName, sheetNames);
                                res();
                              }
                              else rej();
                            }, function (error) {
                              // 조회 중 오류 발생
                              console.error("Error> getRawScoreList");
                              console.table(error);
                              rej();
                            });
                          }
                          else rej();
                        }
                        else rej();
                      }, function (error) {
                        // 조회 중 오류 발생
                        console.error("Error> getRawScoreHeader");
                        console.table(error);
                      });
                    }
                  }
                  else rej();
                }, function (error) {
                  // 조회 중 오류 발생
                  console.error("Error> getRawResultList");
                  console.table(error);
                  rej();
                });
              }
              else rej();
            }
            else rej();
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> getRawResultHeader");
            console.table(error);
            rej();
          });
        });
      };
    }
  ]);

/* "use strict"; */
webapp.service('wjmSurvey',
  ['GLOBAL_CONSTANT', 'postApi', 'gAlert', '$filter', 'StaticVariable',
    function wjmSurvey(CONSTANT, postApi, gAlert, $filter, StaticVariable) {
      var vm = this;

      // 문항, 보기 갯수 제한
      vm.maxSvyPagesCnt = 100;
      vm.maxSvyQstsCnt = 500;
      vm.maxSvyQstItemsCntAll = 2000;
      vm.maxSvyQstItemsCnt = 50;

      // 문항,보기 기본 텍스트
      vm.txtQstSubject = "질문내용을 입력해주세요.";
      vm.txtQstSubjectR = "설명내용을 입력해주세요.";
      vm.txtQstItemContents = "답변내용을 입력해주세요.";

      // 문항 폰트 사이즈 목록 (for문이나 함수로 넣으면 오류발생)
      vm.qstFontSizeList = [];
      vm.qstFontSizeList.push({txt: "8pt", val: 8});
      vm.qstFontSizeList.push({txt: "9pt", val: 9});
      vm.qstFontSizeList.push({txt: "10pt", val: 10});
      vm.qstFontSizeList.push({txt: "11pt", val: 11});
      vm.qstFontSizeList.push({txt: "12pt", val: 12});
      vm.qstFontSizeList.push({txt: "13pt", val: 13});
      vm.qstFontSizeList.push({txt: "14pt", val: 14});
      vm.qstFontSizeList.push({txt: "15pt", val: 15});
      vm.qstFontSizeList.push({txt: "16pt", val: 16});
      vm.qstFontSizeList.push({txt: "17pt", val: 17});
      vm.qstFontSizeList.push({txt: "18pt", val: 18});
      vm.qstFontSizeDef = 13; // 문항 기폰 폰트크기 (pt)

      // 척도수 목록 (for문이나 함수로 넣으면 오류발생)
      vm.qstScaleMaxList = [];
      vm.qstScaleMaxList.push({txt: "2", val: 2});
      vm.qstScaleMaxList.push({txt: "3", val: 3});
      vm.qstScaleMaxList.push({txt: "4", val: 4});
      vm.qstScaleMaxList.push({txt: "5", val: 5});
      vm.qstScaleMaxList.push({txt: "6", val: 6});
      vm.qstScaleMaxList.push({txt: "7", val: 7});
      vm.qstScaleMaxList.push({txt: "8", val: 8});
      vm.qstScaleMaxList.push({txt: "9", val: 9});
      vm.qstScaleMaxList.push({txt: "10", val: 10});
      vm.qstScaleMaxDef = 4; // 척도수 기폰

      // 이메일 도메인 목록
      vm.qstEmailDomainList = [];
      vm.qstEmailDomainList.push({txt: "korea.kr", val: "korea.kr"});
      vm.qstEmailDomainList.push({txt: "naver.com", val: "naver.com"});
      vm.qstEmailDomainList.push({txt: "gmail.com", val: "gmail.com"});
      vm.qstEmailDomainList.push({txt: "hanmail.net", val: "hanmail.net"});
      vm.qstEmailDomainList.push({txt: "daum.net", val: "daum.net"});
      vm.qstEmailDomainList.push({txt: "nate.com", val: "nate.com"});
      vm.qstEmailDomainList.push({txt: "hotmail.com", val: "hotmail.com"});

      // 문항 아이콘 설정
      vm.qstIcon1 = '<i class="glyphicon glyphicon-circle-arrow-right"></i>';
      vm.qstIcon2 = '<i class="glyphicon glyphicon-arrow-right"></i>';
      vm.qstIcon3 = '<i class="glyphicon glyphicon-chevron-right"></i>';
      vm.qstIcon4 = '<i class="glyphicon glyphicon-ok-circle"></i>';

      // 응답페이지 언어 데이터
      vm.langData = [];
      vm.langData.push({code: "L00001", kor: "설문제목을 입력해주세요.", eng: "Please enter the survey title."});
      vm.langData.push({code: "L00002", kor: "순위 선택", eng: "Rank Select"});
      vm.langData.push({code: "L00003", kor: "이전", eng: "Prev"});
      vm.langData.push({code: "L00004", kor: "다음", eng: "Next"});
      vm.langData.push({code: "L00005", kor: "완료", eng: "Completed"});
      vm.langData.push({code: "L00006", kor: "소개글", eng: "Introduce"});
      vm.langData.push({code: "L00007", kor: "문항", eng: "Question"});
      vm.langData.push({code: "L00008", kor: "끝맺음말", eng: "Concluding Remarks"});
      vm.langData.push({code: "L00009", kor: "설문시작", eng: "Start(Survey)"});
      vm.langData.push({code: "L00010", kor: "설문완료", eng: "Completed"});
      vm.langData.push({code: "L00011", kor: "오류가 발생하였습니다.", eng: "An error has occurred."});
      vm.langData.push({code: "L00012", kor: "현재 페이지에 설정된 문항이 없습니다. (페이지당 하나 이상의 문항 필요)", eng: "There are no items set on the current page. (At least one or more questions per page required.)"});
      vm.langData.push({code: "L00013", kor: "응답하지 않거나 응답수가 맞지 않은 문항이 존재합니다.", eng: "There are questions without responses or the numbers of responses were incorrect."});
      vm.langData.push({code: "L00014", kor: "페이지 변경중 오류가 발생하였습니다.", eng: "An error occurred while changing the page."});
      vm.langData.push({code: "L00015", kor: "응답한 문항이 없습니다. 최소 한개이상의 문항에 응답해주세요.", eng: "No question has been answered. Please answer at least one of the following question."});
      vm.langData.push({code: "L00016", kor: "더이상 페이지를 만들 수 없습니다.", eng: "You can no longer create pages."});
      vm.langData.push({code: "L00017", kor: "진행중인 설문이 아닙니다.", eng: "This survey was not available."});
      vm.langData.push({code: "L00018", kor: "이미 응답한 설문입니다.", eng: "You have already answered this survey."});
      vm.langData.push({code: "L00019", kor: "응답건수가 마감된 설문입니다.", eng: "The survey was not available."});
      vm.langData.push({code: "L00020", kor: "기간이 만료되었거나 시작전인 설문입니다.", eng: "This survey has expired or have not yet started"});
      vm.langData.push({code: "L00021", kor: "기존에 작성중인 응답데이터가 존재하여 해당화면으로 이동합니다.", eng: "Since response data exists, it will lead you to the corresponding screen."});
      vm.langData.push({code: "L00022", kor: "닫기", eng: "Close"});
      vm.langData.push({code: "L00023", kor: "관련된 미니결과표가 없습니다.", eng: "There are no related mini-result tables."});
      vm.langData.push({code: "L00024", kor: "관련된 총점데이터 또는 미니결과표가 없습니다.", eng: "There is no relevant total score data or mini-result table."});
      vm.langData.push({code: "L00025", kor: "직접입력", eng: "Manual"});
      vm.langData.push({code: "L00026", kor: "남", eng: "Male"});
      vm.langData.push({code: "L00027", kor: "여", eng: "Female"});
      vm.langData.push({code: "L00028", kor: "선택", eng: "Select"});
      vm.langData.push({code: "L00029", kor: "확인", eng: "Close"});
      vm.langData.push({code: "L00030", kor: "순위 선택에 중복이 있습니다.", eng: ""});

      /**
       * 문항타입 텍스트 반환
       *
       * @param
       * @return
       */
      vm.getQstTypeNm = function(qstType) {
        var rtn = "";
        switch (qstType) {
          case "1": rtn = "[선택형]"; break;
          case "2": rtn = "[입력형]"; break;
          case "3": rtn = "[우선순위형]"; break;
          case "4": rtn = "[이미지형]"; break;
          case "5": rtn = "[척도형]"; break;
          case "C": rtn = "[분류정보]"; break;
          case "R": rtn = "[설명글]"; break;
          default: break;
        }

        return rtn;
      };

      /**
       * 관련코드생성
       *
       * @param
       * @return
       */
      vm.codeNo = 0;
      vm.getSvyCode = function(type, svyQsts, svyQstItems, isChkDup) {
        var code = "";
        var date = new Date();
        //var year = date.getFullYear();
        var month = new String(date.getMonth()+1);
        var day = new String(date.getDate());
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        var uniNo = "";

        code = type;

        if (isNullOrEmpty(isChkDup)) isChkDup = true;
        uniNo = vm.getUniNo(isChkDup, ++vm.codeNo);

        if (month.length == 1) month = "0" + month;
        if(day.length == 1) day = "0" + day;
        if(hour.length == 1) hour = "0" + hour;
        if(minute.length == 1) minute = "0" + minute;
        if(second.length == 1) second = "0" + second;

        if (vm.codeS > 999999) vm.codeS = 0;

        // 중복체크 후 재생성
        if (isChkDup) {
          code += month + "" + day + "" + hour + "" + minute + "" + second + "" + uniNo;

          switch (type) {
            case "QT":
              if ($filter('filter')(svyQsts, {qtId: code}, true).length > 0) vm.getSvyCode(type, svyQsts, svyQstItems);
              break;

            case "IT":
              if ($filter('filter')(svyQstItems, {itId: code}, true).length > 0) vm.getSvyCode(type, svyQsts, svyQstItems);
              break;

            default :
              break;
          }
        }
        else {
          code += month + "" + day + "" + hour + "" + minute + "" + uniNo;
        }

        return code;
      };

      vm.getUniNo = function(isChkDup, codeNo) {
        var rtn = "";
        var no = "";

        if (isChkDup) {
          rtn += "" + Math.floor(Math.random() * (9));
          rtn += "" + Math.floor(Math.random() * (9));
          rtn += "" + Math.floor(Math.random() * (9));

          no = "000" + codeNo;
          rtn += no.slice(-3);
        }
        else {
          no = "000000" + codeNo;
          rtn = no.slice(-6);
        }

        return rtn;
      };

      /**
       * 관련번호초기화
       *
       * @param
       * @return
       */
      vm.initSvyNo = function(type, qtId, svyPages, svyQsts, svyQstItems) {
        var prevQtId = "";
        var qt = [];
        var it = [];
        var nPgNo = 0;
        var no = 0;
        var sort = 0;

        switch (type) {
          case "PG":
            svyPages.forEach(function(i, idx) {
              nPgNo = idx + 1;

              qt = $filter('filter')(svyQsts, {PageNo: i.PageNo}, true);
              qt.forEach(function(j) {
                if (j.PageNo != nPgNo) {
                  j.stat = "U";
                  j.PageNo = nPgNo;
                }
              });

              i.PageNo = nPgNo;
            });
            break;

          case "QT":
            svyQsts.sort( function( a, b ) { return (a.PageNo > b.PageNo) ? 1 : ((b.PageNo > a.PageNo) ? -1 : 0)} );

            qt = $filter('filter')(svyQsts, {stat: '!D'}, true);
            qt.forEach(function(i, idx) {
              sort = idx + 1;
              if (i.QstSort != sort) {
                i.stat = "U";
                i.QstSort = sort;
              }

              if (i.QstType != "R") {
                no++;
                if (i.QstNo != no) {
                  i.stat = "U";
                  i.QstNo = no;
                }
              }
            });
            break;

          case "IT":
            if (!isNullOrEmpty(qtId)) {
              it = $filter('filter')(svyQstItems, {qtId: qtId, stat: '!D'}, true);
              it.forEach(function(i, idx) {
                no = idx + 1;
                if (i.QstItemNo != no) {
                  i.stat = "U";
                  i.QstItemNo = no;
                }
              });
            }
            else {
              it = $filter('filter')(svyQstItems, {stat: '!D'}, true);
              it.forEach(function(i) {
                if (i.qtId != prevQtId) {
                  prevQtId = i.qtId;
                  no = 0;
                }

                no++;
                if (i.QstItemNo != no) {
                  i.stat = "U";
                  i.QstItemNo = no;
                }
              });
            }
            break;

          default : break;
        }
      };

      /**
       * 관련번호순정렬
       *
       * @param
       * @return
       */
      vm.sortSvyNo = function(type, qtId, svyPages, svyQsts, svyQstItems) {
        var it = [];

        switch (type) {
          case "PG":
            svyPages.sort( function( a, b ) { return (a.PageNo > b.PageNo) ? 1 : ((b.PageNo > a.PageNo) ? -1 : 0)} );
            break;

          case "QT":
            svyQsts.sort( function( a, b ) { return (a.QstSort > b.QstSort) ? 1 : ((b.QstSort> a.QstSort) ? -1 : 0)} );
            break;

          case "IT":
            if (isNullOrEmpty(qtId)) {
              it = $filter('filter')(svyQstItems, {qtId: qtId}, true);
              it.sort( function( a, b ) { return (a.QstItemNo > b.QstItemNo) ? 1 : ((b.QstItemNo > a.QstItemNo) ? -1 : 0)} );
            }
            break;

          default : break;
        }
      };

      /**
       * 문항이미지 목록
       * @param
       * @return
       * 주의: 해당함수를 커스덤하여 따로 쓰고있는 페이지가 존재함 (수정시 참고: survey.component.js > setImage())
       */
      vm.getImageList = function(imageList, svyQsts, svyQstItems) {
        var data = {
          mapCode: 'WjmSurvey.getImageDropListConcat'
        };

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              imageList = result.body.docs;
              vm.setImage(imageList, svyQsts, svyQstItems);
            }
          }
        }, function(error) {
          console.error('Error> getImageList()', status, error);
        });
      };

      /**
       * 문항, 보기이미지 경로 삽입
       * @param
       * @return
       * 주의: 해당함수를 커스덤하여 따로 쓰고있는 페이지가 존재함 (수정시 참고: survey.component.js > setImage())
       */
      vm.setImage = function(imageList, svyQsts, svyQstItems) {
        var qt = [];
        var it = [];
        var img = [];

        qt = $filter('filter')(svyQsts, {QstType: "4"}, true);
        qt.forEach(function (i) {
          i.qtImgSrc = "";

          if (!isNullOrEmpty(i.QstImgId)) {
            img = $filter('filter')(imageList, {AttachmentId: i.QstImgId}, true);
            if (img.length > 0) i.qtImgSrc = StaticVariable.getUrl('/attach/file/' + img[0].PhysicalFileNm + '/download.do?userkey=');
          }

          it = $filter('filter')(svyQstItems, {qtId: i.qtId}, true);
          it.forEach(function (j) {
            j.itImgSrc = "";

            if (!isNullOrEmpty(j.QstItemImgId)) {
              img = $filter('filter')(imageList, {AttachmentId: j.QstItemImgId}, true);
              if (img.length > 0) j.itImgSrc = StaticVariable.getUrl('/attach/file/' + img[0].PhysicalFileNm + '/download.do?userkey=');
            }
          });
        });
      };

      /**
       * 문항 아이콘 설정
       *
       * @param {string}
       * @return {boolean}
       */
      vm.getQstStyle = function (qstNo, QstIconType, QstNumYN) {
        var rtn = "";

        switch (QstIconType) {
          case "10": rtn += vm.qstIcon1 + " "; break;
          case "20": rtn += vm.qstIcon2 + " "; break;
          case "30": rtn += vm.qstIcon3 + " "; break;
          case "40": rtn += vm.qstIcon4 + " "; break;
          default : break;
        }

        if (QstNumYN == "Y") rtn += qstNo + ". ";

        return rtn;
      };

      /**
       * 문항 css 생성
       *
       * @param {string}
       * @return {boolean}
       */
      vm.getQstPreStyle = function (size) {
        var rtn = "";

        if (isNullOrEmpty(size)) size = vm.qstFontSizeDef;
        rtn = "font-size:" + size + "pt !Important";

        return rtn;
      };

      /**
       * 보기 라디오 선택 css-class 생성
       *
       * @param {string}
       * @return {boolean}
       */
      vm.getItemSelClass = function (sel, itId, type, sel2) {
        var rtn = "";
        var val = "";

        if (typeof type == "undefined" || type == null) type = "";
        if (typeof sel == "undefined" || sel == null || itId == "") sel = "";
        if (type == "M") val = sel2;
        else val = sel;

        //console.error("chkResp",val);

        if (val == itId && ! isNullOrEmpty(val)) {
          rtn = "rdosvy-label-active";
        }
        else {
          rtn = "rdosvy-label";
        }

        return rtn;
      };

      /**
       * 휴대폰번호 보정
       *
       * @param {string}
       * @return {boolean}
       */
      vm.blurMobile = function (svyResps, qtId) {
        if( ! isNullOrEmpty(svyResps[qtId][0])){
          var val = angular.copy(svyResps[qtId][0]);
          if (!isNullOrEmpty(val)) {
            val = val.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3").replace("--", "-");
          }
          svyResps[qtId][0] = val;
        }
      };

      /**
       * 언어 설정에 따른 문구 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.getLangData = function (code, svyLang) {
        var lang = [];
        var rtn = "";

        lang = $filter('filter')(vm.langData, {code: code}, true);

        if (lang.length > 0) {
          if (svyLang == "ENG") {
            rtn = lang[0].eng;
          }
          else {
            rtn = lang[0].kor;
          }
        }

        return rtn;
      };
    }
  ]);

(function() {
  "use strict";
  branchAppsController.$inject = ['$state', '$cookies', '$rootScope', '$window', '$stateParams'];

  /** @ngInject */
  function branchAppsController($state, $cookies, $rootScope, $window, $stateParams) {
    var vm = this;

    if($stateParams.targetApp == "leaders" || $stateParams.targetApp == "members") {
      $window.sessionStorage['USE_APPTYPE'] = $stateParams.targetApp;
      $rootScope.USE_APPTYPE = $stateParams.targetApp;
      $state.go('m.dashboard');
    }
  }

  webapp.component("branchApps", {
    transclude: true,
    bindings: {},
    controller: branchAppsController
  });
})();

webapp.service('LoginAPISrv', [ '$resource', '$rootScope', 'StaticVariable', function LoginAPISrv($resource, $rootScope, StaticVariable) {
  var loginApi = {
    doLogin : function(obj) {
      return $resource(StaticVariable.getUrl('/login/login.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doLogout : function(obj) {
      return $resource(StaticVariable.getUrl('/login/logout.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doCustomerLogin : function(obj) {
      return $resource(StaticVariable.getUrl('/login/loginCustomer.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCheckSession : function(obj) {
      return $resource(StaticVariable.getUrl('/login/checkSession.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doPersonal_IdSrch : function(obj) {
      return $resource(StaticVariable.getUrl('/login/personal_IdSrch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCompany_IdSrch : function(obj) {
      return $resource(StaticVariable.getUrl('/login/company_IdSrch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doPersonal_PwSrch : function(obj) {
      return $resource(StaticVariable.getUrl('/login/personal_PwSrch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCompany_PwSrch : function(obj) {
      return $resource(StaticVariable.getUrl('/login/company_PwSrch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doResetPassword : function() {
      return $resource(StaticVariable.getUrl('/login/resetPassword.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doSaveResetPwAutoMail : function() {
      return $resource(StaticVariable.getUrl('/login/insertAutoMail.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCreateUser : function(obj) {
      return $resource(StaticVariable.getUrl('/login/signupUser.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCheckLoginId : function(obj) {
      return $resource(StaticVariable.getUrl('/login/checkLoginId.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doMetaColumns : function(obj) {
      return $resource(StaticVariable.getUrl('/login/getMetaColumns.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doGetTenant : function(obj) {
      return $resource(StaticVariable.getUrl('/login/getTenant.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
  };
  return loginApi;
} ]);

(function() {
  "use strict";
  LoginController.$inject = ['$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];

  /** @ngInject */
  function LoginController($log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    if($cookies.get('mySavedId') != undefined) {
      vm.loginInfo.loginId = $cookies.get('mySavedId');
      vm.loginInfo.saveId = '1';
    }


    var translate = $filter("translate");
    vm.language = $rootScope.currentLanguage;
    console.log('$rootScope.currentLanguage=', $rootScope.currentLanguage);
    vm.placeholder = {
      id: translate("LOGIN.LABEL.ID"),
      pw: translate("LOGIN.LABEL.PW")
    };
    $log.info("console log info translate::", translate("LOGIN.BTN.LOGIN"));

    vm.findIdPwd = findIdPwd;
    vm.doLogin = doLogin;
    vm.onChangeHandler = onChangeHandler;

    function doLogin() {
      vm.appName = MAIN.APP_NAME;

      var prms = loginApi.doLogin().post(vm.loginInfo).$promise;

      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          if (data.responseVO.body.docCnt > 0) {
            setUserSession(vm, data);

            var srch = '';
            if (data.responseVO.body.docs[0].mainpagesrch) {
              srch = encodeURIComponent(data.responseVO.body.docs[0].mainpagesrch);
            }
            $state.go('home.main', {srch: srch, lang:''}, {reload: true});
//            $window.location.replace('/#' + data.responseVO.body.docs[0].mainpage);

            // Auth.init(data.permissions);

            // 이메일, 전화번호 추가
            // $window.sessionStorage['loginUserEmail'] =
            // json.responseVO.body.docs[0].email;

            // $window.location.replace('/app/dashboard');
            // $state.reload("home");
            //$window.location.replace('/');
            // $state.go("app.dashboard");

          } else {
            gAlert('', 'Menu.INVALIEDIDPASSWORD');
          }
        } else {

          if(data.responseVO.body.docs.length > 0 && data.responseVO.body.docs[0].checkApproval == "N") {
            gAlert('', data.responseVO.body.docs[0].MSG, {
              btn: '확인', fn: function () { }
            });
          } else {
            gAlert('', '로그인에 실패하였습니다. 다시 시도하여주세요.', {
              btn: '확인', fn: function () { }
            });
          }
        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });

      $log.info("account::", vm.loginInfo.account);
      $log.info("secureCode::", vm.loginInfo.secureCode);
      // $state.go("app.dashboard");
    }

    function onChangeHandler() {
      console.log('language=', vm.language);
      $rootScope.changeLanguage(vm.language);
    }

    function setUserSession(vm, json) {
      if (vm.loginInfo.saveId == '1') {
        var now = new Date();
        var cookieExp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());

        $cookies.put('mySavedId', vm.loginInfo.loginId);

      } else {
        $cookies.remove('mySavedId');
      }

      $rootScope.setUserSession(json.responseVO.body.docs[0]);

      Auth.init(json.responseVO.body.docs[0].permissions);

//      Auth.init(json.responseVO.body.docs[0].permissions);

      // 이메일, 전화번호 추가
      // $window.sessionStorage['loginUserEmail'] =
      // json.responseVO.body.docs[0].email;

      // $window.location.replace('/app/dashboard');
      // $state.reload("home");

      // $state.go("app.dashboard");
    }

    function findIdPwd(find){
      var ctrl = 'FindIdPwdModalCtrl as modalCtrl';
      var paramData = { find : find };
      var modalInstance = modalFactory.open('modal', 'components/modal/findIdPwd/findIdPwd-modal.html', ctrl, paramData);
    }

/*     function getCookieId(){
      var userInputId = getCookie("userInputId");
      if(userInputId != null) {
        vm.loginInfo.loginId = userInputId;
        vm.ckId = true;
      } else {
        vm.loginInfo.loginId = '';
        vm.ckId = false;
      }

    } */
  }

  webapp.component("login", {
    transclude: true,
    bindings: {},
    controller: LoginController,
    controllerAs: "login",
    templateUrl: "components/login/login.html"
  });

  webapp.component("salemeet", {
    transclude: true,
    bindings: {},
    controller: LoginController,
    controllerAs: "login",
    templateUrl: "components/login/salemeet.html"
  });

  webapp.component("winnersjm", {
    transclude: true,
    bindings: {},
    controller: LoginController,
    controllerAs: "login",
    templateUrl: "components/login/winnersjm.html"
  });

  webapp.component("main", {
    transclude: true,
    bindings: {},
    controller: LoginController,
    controllerAs: "login",
    templateUrl: "home/main/main.html"
  });
})();

(function() {
  "use strict";
  LogoutController.$inject = ['$window', '$state', 'StaticVariable', 'LoginAPISrv', 'gAlert'];

  /** @ngInject */
  function LogoutController($window, $state, StaticVariable, loginApi, gAlert) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    vm.doLogout = doLogout;

    function doLogout() {
      StaticVariable.sessionExpire();
      var prms = loginApi.doLogout().post().$promise;
      prms.then(function(json) {
        var temp = {};
        temp.layoutBoard = "N";
        $window.sessionStorage.clear();
        $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
        gAlert('', 'Menu.SIGNEDOUT', {
          btn : '',
          fn : function() {
            //$window.location.replace('/' + CONSTANT.URL.CONTEXT);
            //$state.reload('main.login');
            $window.location.replace('/#/home/main');
          }
        });
      }, function(error) {
        console.error('fail', status);
      });
    }

    doLogout();

  }

  webapp.component("logout", {
    transclude: true,
    bindings: {},
    controller: LogoutController,
  });
})();

(function() {
  "use strict";
  SignupStepOneController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate', '$stateParams','modalFactory'];

  /** @ngInject */
  function SignupStepOneController($scope, $log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, $translate, $stateParams,modalFactory) {
    var vm = this;

    vm.signupStepTwo = signupStepTwo;
    vm.salemeetSignupStepTwo = salemeetSignupStepTwo;

    vm.tenantId = '';
    vm.tenantNm = '';
    vm.goCancel = goCancel;
    vm.salemeetGoCancel = salemeetGoCancel;

    vm.srchTenantModal = function() {
      var ctrl = 'TenantModalCtrl as vc';
      var paramData = {tenantId:''};
      var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);
      modalInstance.result.then(function(okData) {
        vm.tenantId = okData.TenantId;
        vm.tenantNm = okData.TenantNm;
      }, function(cancelData) {});
    };

    vm.eraseTenant = function() {
      vm.tenantId = '';
      vm.tenantNm = '';
    };

    function signupStepTwo(){
      if (vm.tenantId == '' || vm.tenantId == null || vm.tenantId == undefined ||
       vm.tenantNm == '' || vm.tenantNm == null || vm.tenantNm == undefined ) {
        gAlert('','회원사를 선택해주세요');
      } else {
        $state.go('signup2', {
          tenantId: vm.tenantId
        });
      }
    }

    function salemeetSignupStepTwo(){
      if (vm.tenantId == '' || vm.tenantId == null || vm.tenantId == undefined) {
        gAlert('','회원사코드를 입력해주세요');
      } else {
        $state.go('salemeetsignup2', {
          tenantId: vm.tenantId
        });
      }
    }

    function goCancel() {
      $state.go("login");
    }

    function salemeetGoCancel() {
      $state.go("salemeet");
    }
  }

  webapp.component("signupStepOne", {
    transclude: true,
    bindings: {},
    controller: SignupStepOneController,
    controllerAs: "vc",
    templateUrl: "components/login/signup-step-one.html"
  });

  webapp.component("salemeetSignupStepOne", {
    transclude: true,
    bindings: {},
    controller: SignupStepOneController,
    controllerAs: "vc",
    templateUrl: "components/login/salemeet-signup-step-one.html"
  });
})();

(function() {
  "use strict";
  SignupStepTwoController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate', '$stateParams', 'customFieldApi','postApi'];

  /** @ngInject */
  function SignupStepTwoController($scope, $log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, $translate, $stateParams, customFieldApi, postApi) {
    var vm = this;
      // 페이징
    vm.tenantId = $stateParams.tenantId;
    // 사용자정의 컬럼 폼
    vm.udcForm = {};

    // 사용자정의 컬럼 모델
    vm.udcModel = {};
    vm.udcDataType = {};

    // 사용자정의 컬럼정보
    vm.udcColumns = [];
    vm.columnMap = {};
    vm.srchDetail = {};
    vm.srchDetail.viewColumns = {};

    vm.metaList = [];
    vm.metaModel = [];
    vm.initalized = false;

    vm.udcOptions = {
      formState: {
        horizontalLabelClass: "",
        horizontalFieldClass: "",
        readOnly: false
      }
    };
    vm.result = false;
    var srchTenantName = ($window.sessionStorage['loginTenantNm'] !== null) ? $window.sessionStorage['loginTenantNm'] : '';
    vm.goCancel = goCancel;
    vm.salemeetGoCancel = salemeetGoCancel;
    vm.stateParams = {
      UserId : $stateParams.UserId,
    };

    // 검색 조건
    vm.srch = {
      UserId : $stateParams.UserId,
      TableId : $stateParams.UserId,
      tableNm : 'users',
    };

    // 등록/수정 표시용 컬럼 목록
    vm.srch.editColumns = [];

    // 조회 데이터
    vm.data = {
      UserId : $stateParams.UserId,
      TenantNm : srchTenantName,
      tableNm : 'users',
      checkedLoginId : '',
      Mobile1 : '010'
    };

    vm.joinVisible = false;

    vm.onDateChanged = function(ColumnPhysicalNm, index) {
//    vm.metaModel[ColumnPhysicalNm] = $filter('date')(vm.RegDate[index], 'yyyy-MM-dd', 'UTC');
      vm.data[ColumnPhysicalNm] = (new Date(vm.RegDate[index])).getTime();
    };

    /**
     * 데이터 저장
     *
     * @param
     * @return
     * @author 최원영
     */
    function setData() {
      if(!$scope.form1.$valid) {
          return false;
      }

      if (typeof(vm.data.LoginId) == "undefined" || vm.data.LoginId == "") {
        gAlert('', '아이디를 입력후 중복확인을 해주세요.');
        return false;
      }

      if (vm.data.checkedLoginId != vm.data.LoginId) {
        gAlert('', '아이디를 입력후 중복확인을 해주세요.');
        return false;
      }

      if (vm.data.Password.length < 8) {
        gAlert('', '비밀번호는 8자리 이상입니다.');
        return false;
      }

      if (vm.data.Password != vm.data.Password2) {
        gAlert('', '비밀번호확인을 확인해주세요.');
        return false;
      }

      var spe = vm.data.Password.search(/[`.~!@@#$%^&*()|\\\'\";:\/?-_=+]/gi);

      if (vm.data.Password.search(/\s/) != -1) {
        gAlert('', '비밀번호는 공백없이 입력해주세요.');
        return false;
      }
      if (spe < 0) {
        gAlert('', '비밀번호에 특수문자를 혼합하여 입력해주세요.');
        return false;
      }

      if(document.getElementById("termsY").checked != true) {
        gAlert('', '이용약관, 개인정보보호정책에 동의해주세요.');
        return false;
      }

      vm.data.UseYN = 'Y'; // 사용여부
      vm.data.UserType = '30'; // 사용자구분
      vm.data.LoginId = vm.UserId;
      vm.data.Email = vm.data.Email1 + '@' + vm.data.Email2;
      vm.data.Mobile = vm.data.Mobile1 + '-' + vm.data.Mobile2 + '-' + vm.data.Mobile3;

      // 내용
      vm.data.tableNm = "users";
      vm.data.TableId = vm.data.UserId;
      vm.data.tenantId = vm.tenantId;
      var prms = null;
      if (typeof(vm.data.UserId) == "undefined" || vm.data.UserId == 0) {
        // 등록
        prms = loginApi.doCreateUser().post(vm.data).$promise;
      } else {
        // 수정
        //prms = loginApi.doUpdateUserDetail().post(vm.data).$promise;
      }

      prms.then(function(data) {
        if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
          if (data.responseVO.body.docs[0].UserId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert시 TableId 만 넘어옴
            // KeyId 조회
            vm.data.UserId = data.responseVO.body.docs[0].UserId;
            $('#tab2').removeClass("current");
            $('#tab3').addClass("current");
            vm.result = true;
            return;
          }
        }
        gAlert('', data.responseVO.body.docs[0].errMessage);
      }, function(error) {
        console.error('Error-setData', status, data);
        gAlert('', data.responseVO.body.docs[0].errMessage);
      });
    }

    // 사용자 중복체크
    function chkDupLoginId() {
      vm.data.LoginId = vm.UserId;

      if(!chkId()) {
        gAlert('', '사용할 수 없는 아이디 입니다.');
        return;
      }

      var prms = null;

      prms = loginApi.doCheckLoginId().post(vm.data).$promise;
      prms.then(function(data) {
        if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
          if (data.responseVO.body.docs[0].message == '사용가능한 아이디입니다.') {
            vm.data.checkedLoginId = vm.data.LoginId;
            gAlert('', '사용가능한 아이디 입니다.');
          }
          else {
            vm.data.checkedLoginId = "";
            gAlert('', '이미 사용중인  아이디 입니다.');
          }

          return;
        }
        gAlert('', data.responseVO.body.docs[0].errMessage);
      }, function(error) {
        console.error('Error-setData', status, data);
        gAlert('', data.responseVO.body.docs[0].errMessage);
      });
    }

    // ID 체크
    function chkId() {
      var regExp = /^[a-z0-9\-_]{5,25}$/;

      if (!regExp.test(vm.UserId)) return false;
      if (vm.UserId.search(/\s/) != -1) return false;

      return true;
    }

    // 사용자 중복체크
    function setEmail() {
      vm.data.Email2 = vm.data.Email3;
    }

    function getColunmList() {
      var data = {
        tableNm : 'users',
        tenantId : vm.tenantId,
        mapCode : 'getMetaColumns',
        selectType : "Edit",
      };

      postApi.login(data,function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          if (result.body.desc.length > 0) {
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function(item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }

          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
            vm.UseYNData.Code = vm.data.UseYN;
            vm.data.UserRoles = [];
            var UserRoleIds = [];
            var UserRoleNms = [];
            if (vm.data.UserRoleIds != null) {
              UserRoleIds = vm.data.UserRoleIds.split(",");
            }
            if (vm.data.UserRoleNms != null) {
              UserRoleNms = vm.data.UserRoleNms.split(",");
            }
            angular.forEach(UserRoleIds, function(item, key) {
              var UserRole = {RoleId:item,RoleNm:UserRoleNms[key]};
              vm.data.UserRoles.push(UserRole);
            });

            var uploadFileList = [];

            angular.forEach(vm.data.uploadFileList, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
              };
              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);

            return;
          }
        }
      },
      function(error) {
        console.error("Error> h0102-edit-ctrl> getData()", status, error);
        vm.dataloader = false;
        gAlert("", error.responseVO.body.docs[0].errMessage);
      });
    }

    // 회원사 체크 (회원사가 존재하지 않을시 history.back)
    function getTenantNm() {
      var data = {
        TenantId : vm.tenantId,
        mapCode : 'getTenantNm',
      };

      postApi.login(data,function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.tenantNm = result.body.docs[0].TenantNm;
            vm.joinVisible = true;
          }
          else {
            gAlert('', '회원사코드와 일치하는 회원사가 존재하지 않습니다.', {
              btn : '',
              fn : function() {
                history.back();
              }
            });
          }

          return;
        }
      },
      function(error) {
        console.error("Error> signup-step-two.component.js > getTenantNm()", status, error);
        vm.dataloader = false;
        gAlert("", error.responseVO.body.docs[0].errMessage);
      });
    }

    function goCancel() {
      $state.go("login");
    }

    function salemeetGoCancel() {
      $state.go("salemeet");
    }

    // 함수 선언
    vm.setData = setData;
    vm.chkDupLoginId = chkDupLoginId;
    vm.setEmail = setEmail;
    vm.getColunmList = getColunmList;
    vm.getTenantNm = getTenantNm;

    getTenantNm();
    getColunmList();
  }

  webapp.component("signupStepTwo", {
    transclude: true,
    bindings: {},
    controller: SignupStepTwoController,
    controllerAs: "vc",
    templateUrl: "components/login/signup-step-two.html"
  });

  webapp.component("salemeetSignupStepTwo", {
    transclude: true,
    bindings: {},
    controller: SignupStepTwoController,
    controllerAs: "vc",
    templateUrl: "components/login/salemeet-signup-step-two.html"
  });
})();

webapp.service('ModalAPISrv', ['$rootScope', '$resource', 'StaticVariable',
  function ModalAPISrv($rootScope, $resource, staticVariable) {
    var modalApi = {
      getClientApi: function(){
        return $resource(staticVariable.getUrl('/api/org/clients.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.getStandardAction());
      },
      getOrgDeptUserApi: function(){
        return $resource(staticVariable.getUrl('/api/org/department/:deptId/users.json?userkey=' + $rootScope.gVariable.userKey), {
          deptId: '@deptId'
        }, staticVariable.getRequestActions.getStandardAction());
      },
      getOrgDepartmentApi: function(){
        return $resource(staticVariable.getUrl('/api/org/departement/tree.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.getStandardAction());
      },
      doDeptList: function() {
        return $resource(staticVariable.getUrl('/select/Department.getDepartmentTree/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      doTenantList: function() {
        alert('doTenantList');
        return $resource(staticVariable.getUrl('/select/Tenant.getTenantSrch/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      doLocationList: function() {
        return $resource(staticVariable.getUrl('/select/Location.getLocationTreeList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getUserApi: function(){
        return $resource(staticVariable.getUrl('/select/User.getUserMgrList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getUserCntApi: function(){
        return $resource(staticVariable.getUrl('/select/User.getUserMgrListCnt/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getShopApi: function(){
        return $resource(staticVariable.getUrl('/select/DataAnalysis.getShopList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.defaultAction());
      },
      getShopCntApi: function(){
        return $resource(staticVariable.getUrl('/select/DataAnalysis.getShopCount/action.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.defaultAction());
      },
      getUserRoleApi: function(){
        return $resource(staticVariable.getUrl('/select/Role.getRoleList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getUserRoleCntApi: function(){
        return $resource(staticVariable.getUrl('/select/Role.getRoleListCnt/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      doUpdateDefaultActionDetail : function() {
        return $resource(staticVariable.getUrl('/update/DataAnalysis.updateDefaultActionDetail/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
    };
    return modalApi;
  },
]);

webapp.controller('WjmAgreeModalCtrl', [ '$uibModalInstance', 'toModalData','$filter',
    function WjmAgreeModalCtrl($uibModalInstance, toModalData, $filter) {

      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;

      vm.type = toModalData.type;
      vm.title = (vm.type == "I" ? "개인정보수집 동의(필수)" : "마케팅정보 수신 동의(선택)");

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(valYN) {
        $uibModalInstance.close(valYN);
      }

    } ]);


webapp.service('CounselAPISrv', [ '$resource', '$rootScope', 'StaticVariable', function CounselAPISrv($resource, $rootScope, StaticVariable) {
  var counselApi = {
    insertCounsel: function() {
      return $resource(StaticVariable.getUrl('/openapi/insertCounsel.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    getCounselTargetDetail: function() {
      return $resource(StaticVariable.getUrl('/openapi/getCounselTargetDetail.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
  };
  return counselApi;
} ]);

(function() {
  "use strict";
  CounselController.$inject = ['$state', '$filter', '$rootScope', 'CounselAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', '$stateParams', 'StaticVariable'];

  /** @ngInject */
  function CounselController($state, $filter, $rootScope, api, CONSTANT, gAlert, $window, $translate, modalFactory, $stateParams, StaticVariable) {
    var vm = this;

    //테스트 URL
    //http://localhost:3000/min.html#/counsel/5CE1FZGZCK

    //vm.data = {};
    vm.srch = {};
    vm.srch.SvyTgtId = $stateParams.tgtId;
    vm.data = [];
    vm.msg = "";

    if (!isNullOrEmpty(vm.srch.SvyTgtId)) {
      getData();
    }
    else {
      //setMsg();
      // 대상키 없이 상담신청 가능하도록
      vm.data = {
        SvyTgtId : ''
      };
    }

    /**
     * 화면 메세지 변경
     * @param
     * @return
     */
    function setMsg(msg) {
      vm.msg = isNullOrEmpty(msg) ? "오류가 발생하였습니다." : msg;
    }

    /**
     * 상담 대상자정보 조회
     * @param
     * @return
     */
    function getData() {
      var prms;
      var param = angular.copy(vm.srch);

      param.keyId = vm.srch.SvyTgtId;

      prms = api.getCounselTargetDetail().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          if (data.responseVO.body.docCnt > 0) {
            vm.data = data.responseVO.body.docs[0];
          }
        } else {
          console.error("Error> getData()");
          setMsg();
        }
      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
        setMsg();
      });
    }

    /**
     * 상담신청 저장
     * @param
     * @return
     */
    vm.setData = function () {
      var prms;
      var param = vm.data; // 사용자 입력 데이터

      if (!getIsValidData()) return false;

      param.SvyTgtId = vm.srch.SvyTgtId;

      // 체크박스 처리
      if (isNullOrEmpty(vm.data.TopicYN0)) vm.data.TopicYN0 = "N";
      if (isNullOrEmpty(vm.data.TopicYN1)) vm.data.TopicYN1 = "N";
      if (isNullOrEmpty(vm.data.TopicYN2)) vm.data.TopicYN2 = "N";
      if (isNullOrEmpty(vm.data.TopicYN3)) vm.data.TopicYN3 = "N";
      if (isNullOrEmpty(vm.data.TopicYN4)) vm.data.TopicYN4 = "N";
      if (isNullOrEmpty(vm.data.TopicYN5)) vm.data.TopicYN5 = "N";
      if (isNullOrEmpty(vm.data.TopicYN6)) vm.data.TopicYN6 = "N";
      if (isNullOrEmpty(vm.data.TopicYN7)) vm.data.TopicYN7 = "N";
      if (isNullOrEmpty(vm.data.TopicYN8)) vm.data.TopicYN8 = "N";
      if (isNullOrEmpty(vm.data.TopicYN9)) vm.data.TopicYN9 = "N";
      if (isNullOrEmpty(vm.data.TopicYN10)) vm.data.TopicYN10 = "N";
      if (isNullOrEmpty(vm.data.TopicYN11)) vm.data.TopicYN11 = "N";
      if (isNullOrEmpty(vm.data.TopicYN12)) vm.data.TopicYN12 = "N";
      if (isNullOrEmpty(vm.data.InfoAgreeYN)) vm.data.InfoAgreeYN = "N";
      if (isNullOrEmpty(vm.data.MktAgreeYN)) vm.data.MktAgreeYN = "N";


      var topic = "";
      if(vm.data.TopicYN1 == "Y") topic = topic + "부부관계";
      if(vm.data.TopicYN2 == "Y") topic = topic + ", 자녀문제";
      if(vm.data.TopicYN3 == "Y") topic = topic + ", 부모문제";
      if(vm.data.TopicYN4 == "Y") topic = topic + ", 우울";
      if(vm.data.TopicYN5 == "Y") topic = topic + ", 불안";
      if(vm.data.TopicYN6 == "Y") topic = topic + ", 분노";
      if(vm.data.TopicYN7 == "Y") topic = topic + ", 중독";
      if(vm.data.TopicYN8 == "Y") topic = topic + ", 대인관계";
      if(vm.data.TopicYN9 == "Y") topic = topic + ", 직장";
      if(vm.data.TopicYN10 == "Y") topic = topic + ", 스트레스";
      if(vm.data.TopicYN11 == "Y") topic = topic + ", 성격고민";
      if(vm.data.TopicYN12 == "Y") topic = topic + ", 기타";
      if(topic.substr(0,1) == ",") topic = topic.substr(2);

      var tit = (isNullOrEmpty(vm.data.ClientNm) ? "" : vm.data.ClientNm + "-") + vm.data.Name;

      // 담당자 메일 발송 값
      param.fromEmail = "humandc@winnersjm.co.kr";
      param.fromName = "더휴먼데이터센터";
      param.toEmail = "happylife@winnersjm.co.kr";
      param.title = "더휴먼데이터센터에서 '"+ tit +"'님의 상담신청이 접수되었습니다.";
      param.content = "<table width='100%' style='font-family: &quot;Noto Sans KR&quot;, Roboto, sans-serif; font-size: 13px; color: rgb(102, 102, 102); ' cellspacing='10px'>"
                      +"<tr>"
                      +"<td width='10%' style='color: rgb(255, 106, 0);text-align:right'>상담번호</td><td width='20%'>{CounselNum}</td>"
                      +"<td width='10%' style='color: rgb(255, 106, 0);text-align:right'>등록일시</td><td width='60%' colspan='3'>{RegDate}</td>"
                      +"</tr><tr>"
                      +"<td style='color: rgb(255, 106, 0);text-align:right'>고객명</td><td>"+ vm.data.Name +"</td>"
                      +"<td style='text-align:right'>휴대폰</td><td width='20%'>"+ vm.data.Mobile +"</td>"
                      +"<td width='10%' style='text-align:right'>이메일</td><td width='30%'>"+ vm.data.Email +"</td>"
                      +"</tr><tr>"
                      +"<td style='text-align:right'>업체</td><td>"+ (isNullOrEmpty(vm.data.ClientNm) ? "" : vm.data.ClientNm) +"</td>"
                      +"<td style='text-align:right'>부서</td><td>"+ (isNullOrEmpty(vm.data.Department) ? "" : vm.data.Department) +"</td>"
                      +"<td style='text-align:right'>직급</td><td>"+ (isNullOrEmpty(vm.data.Position) ? "" : vm.data.Position) +"</td>"
                      +"</tr><tr>"
                      +"<td style='text-align:right'>나이</td><td>"+ (isNullOrEmpty(vm.data.Age) ? "" : vm.data.Age) +"</td>"
                      +"<td style='text-align:right'>상담희망방법</td><td>"+ (isNullOrEmpty(vm.data.Area) ? "" : vm.data.Area) +"</td>"
                      +"<td style='text-align:right'>상담희망일정</td><td>"+ (isNullOrEmpty(vm.data.Schedule) ? "" : vm.data.Schedule) +"</td>"
                      +"</tr>"
                      +"<tr><td style='text-align:right'>상담주제</td><td colspan='5'>"+ topic +"</td></tr>"
                      +"<tr><td style='padding-top:10px;text-align:right'>내용</td><td colspan='5' style='padding-top:10px;padding-right:100px;'>"+ (isNullOrEmpty(vm.data.Memo) ? "" : vm.data.Memo.replace(/\n/g, '<br/>')) +"</td></tr>"
                      +"</table>"
                      +"<table width='100%' style='font-family: &quot;Noto Sans KR&quot;, Roboto, sans-serif; font-size: 13px; color: rgb(102, 102, 102);padding-top:10px; '>"
                      +"<tr><td width='150ox' style='text-align:right'>개인정보수집동의</td><td style='padding-left:20px'>"+ (vm.data.InfoAgreeYN == "Y" ? "동의" : "미동의") +"</td></tr>"
                      +"<tr><td style='text-align:right'>마케팅정보수집동의</td><td style='padding-left:20px'>"+ (vm.data.MktAgreeYN == "Y" ? "동의" : "미동의") +"</td></tr>"
                      +"</table>";

      prms = api.insertCounsel().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          if (data.responseVO.body.docCnt > 0) {
            if (data.responseVO.body.docs[0].RegCnt == "0") setMsg("상담신청이 완료되었습니다.");
            else setMsg("이미 상담신청 처리되었습니다.");
          }
          else {
            setMsg();
          }
        } else {
          setMsg("상담신청이 완료되었습니다.");
          console.error("Error> setData(1)");
        }
      }, function (error) {
        setMsg();
        console.error("Error> setData(2)");
        console.table(error);
      });
    }

    /**
     * 입력항목 체크
     * @param
     * @return
     */
    function getIsValidData() {
      var msg = "";

      if (isNullOrEmpty(vm.data.Name)) {
        msg += "- 고객명을 입력해주세요.<br/>";
      }

      if (isNullOrEmpty(vm.data.Mobile)) {
        msg += "- 휴대폰을 입력해주세요.<br/>";
      }

      if (isNullOrEmpty(vm.data.Email)) {
        msg += "- 이메일을 입력해주세요.<br/>";
      }

      if (isNullOrEmpty(vm.data.ClientNm)) {
        msg += "- 업체를 입력해주세요.<br/>";
      }

      if (isNullOrEmpty(vm.data.Age)) {
        msg += "- 나이를 입력해주세요.<br/>";
      }

      if (isNullOrEmpty(vm.data.Area)) {
        msg += "- 상담희망방법을 입력해주세요.<br/>";
      }

      if (isNullOrEmpty(vm.data.Schedule)) {
        msg += "- 상담희망일정을 입력해주세요.<br/>";
      }

      if ( ! (vm.data.TopicYN1 == "Y" || vm.data.TopicYN2 == "Y" || vm.data.TopicYN3 == "Y" || vm.data.TopicYN4 == "Y"
              && vm.data.TopicYN5 == "Y" || vm.data.TopicYN6 == "Y" || vm.data.TopicYN7 == "Y" || vm.data.TopicYN8 == "Y"
              && vm.data.TopicYN9 == "Y" || vm.data.TopicYN10 == "Y"|| vm.data.TopicYN11 == "Y" || vm.data.TopicYN12 == "Y")) {
        msg += "- 상담주제를 선택해주세요.<br/>";
      }

      if (isNullOrEmpty(vm.data.Memo)) {
        msg += "- 내용을 입력해주세요.<br/>";
      }

      if (isNullOrEmpty(vm.data.InfoAgreeYN) || vm.data.InfoAgreeYN != "Y") {
        msg += "- 개인정보수집에 동의해주세요.<br/>";
      }

      if (msg) {
        gAlert('', msg);
        return false;
      }

      return true;
    }

    // 동의 내용보기
    vm.openAgreePop = function (type) {
      var ctrl = 'WjmAgreeModalCtrl as vc';
      var paramData = {type : type};
      var modalInstance = modalFactory.open('md', 'components/survey/counsel-agree.html', ctrl, paramData);
      modalInstance.result.then(function(agreeYN) {
        if(type == "I") vm.data.InfoAgreeYN = agreeYN;
        else vm.data.MktAgreeYN = agreeYN;
      },
      function(cancelData) {
      });
    };
  }

  webapp.component("counsel", {
    transclude: true,
    bindings: {},
    controller: CounselController,
    controllerAs: "counsel",
    templateUrl: "components/survey/counsel.html"
  });
})();

(function() {
  "use strict";
  EmailDenyController.$inject = ['SurveyAPISrv', 'GLOBAL_CONSTANT', '$stateParams'];

  /** @ngInject */
  function EmailDenyController(api, CONSTANT, $stateParams) {
    var vm = this;

    //테스트 URL
    //http://localhost:3000/i.html#/emaildeny/9MFWOF4JVW/SVY
    //http://localhost:3000/i.html#/emaildeny/9MFWOF4JVW/RPT

    vm.srch = {};
    vm.srch.tgtId = $stateParams.tgtId;
    vm.srch.workType = $stateParams.workType;

    if (!isNullOrEmpty(vm.srch.tgtId) && !isNullOrEmpty(vm.srch.workType)) {
      setData();
    }
    else {
      setMsg();
    }

    function setMsg(msg) {
      vm.msg = isNullOrEmpty(msg) ? "오류가 발생하였습니다." : msg;
    }

    function setData() {
      var prms;
      var param = angular.copy(vm.srch);

      prms = api.updateDenyStatus().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO) {
          setMsg(data.responseVO.body.docs[0].message);
        } else {
          setMsg();
        }
      }, function (error) {
        setMsg();
      });
    }
  }

  webapp.component("emaildeny", {
    transclude: true,
    bindings: {},
    controller: EmailDenyController,
    controllerAs: "emaildeny",
    templateUrl: "components/survey/emaildeny.html"
  });
})();

webapp.service('SurveyAPISrv', [ '$resource', '$rootScope', 'StaticVariable', function SurveyAPISrv($resource, $rootScope, StaticVariable) {
  var surveyApi = {
    getClientEmailList : function(obj) {
      return $resource(StaticVariable.getUrl('/openapi/getClientEmailList.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    getSurveyDetail : function(obj) {
      return $resource(StaticVariable.getUrl('/openapi/getWjmSurveyDetail.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    getSurveyQstDetail: function() {
      return $resource(StaticVariable.getUrl('/openapi/getWjmSurveyQstDetail.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    getSurveyQstItemDetail: function() {
      return $resource(StaticVariable.getUrl('/openapi/getWjmSurveyQstItemDetail.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
      getImageDropListConcat: function() {
      return $resource(StaticVariable.getUrl('/openapi/getImageDropListConcat.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    getSurveyRespHistCheck: function() {
      return $resource(StaticVariable.getUrl('/openapi/getSurveyRespHistCheck.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    getSurveyTarget: function() {
      return $resource(StaticVariable.getUrl('/openapi/getSurveyTarget.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    insertSurveyTarget: function() {
      return $resource(StaticVariable.getUrl('/openapi/insertSurveyTarget.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    updateSurveyRespHist: function() {
      return $resource(StaticVariable.getUrl('/openapi/updateSurveyRespHist.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    updateSurveyRespHistLog: function() {
      return $resource(StaticVariable.getUrl('/openapi/updateSurveyRespHistLog.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    getMiniResultDetail: function() {
      return $resource(StaticVariable.getUrl('/openapi/getMiniResultDetail.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    getSurveyRespHistTmpList: function() {
      return $resource(StaticVariable.getUrl('/openapi/getSurveyRespHistTmpList.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    updateSurveyRespHistTmp: function() {
      return $resource(StaticVariable.getUrl('/openapi/updateSurveyRespHistTmp.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    getFileListOri: function() {
      return $resource(StaticVariable.getUrl('/openapi/getFileListOri.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    updateDenyStatus: function() {
      return $resource(StaticVariable.getUrl('/openapi/updateEmailDenyResultStatus.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    /*
    getSurveyRespSaveCheck: function() {
      return $resource(StaticVariable.getUrl('/openapi/getSurveyRespSaveCheck.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    */
  };
  return surveyApi;
} ]);

(function() {
  "use strict";
  SurveyController.$inject = ['$scope', '$state', '$filter', '$rootScope', 'SurveyAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', '$stateParams', 'StaticVariable', 'wjmSurvey'];

  /** @ngInject */
  function SurveyController($scope, $state, $filter, $rootScope, api, CONSTANT, gAlert, $window, $translate, modalFactory, $stateParams, StaticVariable, wjmSurvey) {
    var vm = this;

    //테스트 URL
    //http://localhost:3000/#/survey/6KWE5GM8YO/ZG3D62R5S

    //vm.data = {};
    vm.srch = {};
    vm.srch.SvyId = $stateParams.keyId;
    vm.srch.SvyTgtId = $stateParams.tgtId;
    vm.srch.respMode = isNullOrEmpty(vm.srch.SvyTgtId) ? "U" : "T";
    vm.srch.chkTgtNM = null;
    vm.srch.chkTgtMB = null;
    vm.srch.chkTgtEM = null;
    vm.isErr = false;
    vm.errMsg = "오류가 발생하였습니다.";

    // 설문관련 변수
    vm.svyInfo = [];
    vm.svyPages = [];
    vm.svyQsts = [];
    vm.svyQstItems = [];
    vm.svyPagesType = 1;
    vm.svyPagesTypeTxt = "소개글";
    vm.svyPagesCur = 1;
    vm.svyPagesTxt = "설문시작";
    vm.prevPages = [];
    vm.respPages = new Map();

    // 기타
    vm.svyResps = [];
    vm.svyRespsSbj = [];
    vm.svyQstsCur = [];
    vm.beginQtId = "";
    vm.beginQtIdByPrev = ""; // 이전 이동시 유지하기 위한 값
    vm.LvCont = "";
    vm.ContactTxt = "";
    vm.isFailEnd = false;
    vm.timeLine = [];
    vm.timeNo = 0; // 타임라인 증가 번호
    vm.CutMsg = []; // Textarea bytes 계산

    $scope.wjmSurvey = wjmSurvey;

    if (!isNullOrEmpty(vm.srch.SvyId)) {
      getData();
    }
    else setErrMsg(true);

     /**
     * 현재 페이지 문항 설정
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setQstsCur = function () {
      var k = 0;
      var qstsCur = [];
      var qt = [];

      if (!isNullOrEmpty(vm.beginQtId)) {
        qt = $filter('filter')(vm.svyQsts, {qtId: vm.beginQtId}, true)[0];
        if (!isNullOrEmpty(qt)) {
          vm.svyPagesCur = qt.PageNo;
          vm.svyPagesType = 2;
        }

        qstsCur = angular.copy($filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur}, true));
        for (k = qstsCur.length - 1; k >= 0; k--) {
          if (parseInt(qstsCur[k].QstSort) < parseInt(qt.QstSort)) {
            qstsCur.splice(k, 1);
          }
        }
      }
      else {
        qstsCur = angular.copy($filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur}, true));
      }

      vm.svyQstsCur = qstsCur;

      vm.checkNewPage();

      // 타임라인 저장
      vm.setTimeLine();

      vm.beginQtId = "";
    };

    /**
     * 다음페이지 시작 문항 설정
     * 설명: 페이지에 문항중 다음 버튼을 눌렀을때 가야되는 분기는 최종적으로 하나이며,
     * 해당페이지에 복수의 분기가 설정된 경우 마지막으로 클릭한 문항, 마지막으로 클릭한 문항의 보기순으로 우선권을 가짐
     * @param {string}
     * @return {boolean}
     */
    vm.setBeginQtId = function (qt, it, idx) {
      var itTmp = [];

      if (isNullOrEmpty(vm.svyResps[qt.qtId])) return false;
      if (typeof idx == "undefined" || idx == null) idx = 0;
      if (typeof it == "undefined" || it == null) {
        switch(qt.QstType){
          case "3" :
          case "C" :

            if(idx > 0) return false;
            if (isNullOrEmpty(vm.svyResps[qt.qtId][0])) return false;
            it = $filter('filter')(vm.svyQstItems, {itId: vm.svyResps[qt.qtId][0]}, true)[0];
        }
      }
      if (!isNullOrEmpty(it) && vm.svyResps[qt.qtId][idx] != it.itId) return false;

      if (!isNullOrEmpty(qt.GoToQstId)) {
        vm.beginQtId = qt.GoToQstId;
        return false;
      }

      if (!isNullOrEmpty(it.GoToQstId)) {
        vm.beginQtId = it.GoToQstId;
      }
      else {
        itTmp = $filter('filter')(vm.svyQstItems, {qtId: qt.qtId}, true);
        itTmp.forEach(function(i) {
          if (!isNullOrEmpty(i.GoToQstId)) {
            vm.beginQtId = "";
            return false;
          }
        });
      }

      return true;
    };

    /**
     * 미응답 문항 스타일변경
     * @param
     * @return
     */
    function setAddClssQst(qtId) {
      $("#divQstSubject_" + qtId).removeClass("svy-qst-chk").addClass("svy-qst-chk");
    }

    function setDelClssQst() {
      $("div[id^='divQstSubject_']").removeClass("svy-qst-chk");
    }

    /**
     * 입력항목 체크
     * @param
     * @return
     */
    function getIsValidData() {
      var j = 0;
      var isPass = true;
      var qstRespCnt = 0;
      var qstItemCnt = 0;

      setDelClssQst();

      if (vm.svyQstsCur.length == 0) {
        gAlert('', wjmSurvey.getLangData("L00012", vm.svyInfo.SvyLang), '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
        return false;
      }

      vm.svyQstsCur.forEach(function(i) {
        if (i.QstType == "R") return true;

        //그외유형
        if (isNullOrEmpty(vm.svyResps[i.qtId])
          || vm.svyResps[i.qtId].length == 0
          || (i.QstType != "1" && i.SelType != "M" && isNullOrEmpty(vm.svyResps[i.qtId][0]))
        ) {
          if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

          setAddClssQst(i.qtId);
          isPass = false;
          return false;
        }

        //다중선택형
        if (i.QstType == "1" && i.SelType == "M") {
          qstRespCnt = fnChkQstRespCnt(i.qtId, false);

          if (qstRespCnt < i.SelMin || qstRespCnt > i.SelMax) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }
        }
        //우선순위형
        else if (i.QstType == "3") {

          qstRespCnt = fnChkQstRespCnt(i.qtId, true);

          // 순위 중복 오류
          if(qstRespCnt == -1){
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }

          if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

          if (i.QstTopCnt != qstRespCnt) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }

          for (j = 0; j < i.QstTopCnt; j++) {
            if (isNullOrEmpty(vm.svyResps[i.qtId][j])) {
              setAddClssQst(i.qtId);
              isPass = false;
              return false;
            }
          }
        }
        //척도형
        else if (i.QstType == "5") {
          if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

          qstRespCnt = fnChkQstRespCnt(i.qtId, false);
          qstItemCnt = $filter('filter')(vm.svyQstItems, {qtId: i.qtId}, true).length;
          //console.log("qstRespCnt", qstRespCnt + "|" + qstItemCnt);
          if (qstRespCnt != qstItemCnt) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }
        }
        //분류형(이름,휴대폰)
        else if (i.QstType == "C" && (i.ClassfyCd == "NM" || i.ClassfyCd == "MB")) {
          if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

          if (isNullOrEmpty(vm.svyResps[i.qtId][0])
            || isNullOrEmpty(vm.svyResps[i.qtId][0].replaceAll(" ", ""))
          ) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }
        }
        //분류형(이메일)
       else if (i.QstType == "C" && i.ClassfyCd == "EM") {
        if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

        if (Object.keys(vm.svyResps[i.qtId]).length < 2
          || isNullOrEmpty(vm.svyResps[i.qtId][0])
          || isNullOrEmpty(vm.svyResps[i.qtId][1])
        ) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }
        }
      });

      if (!isPass) {
        if(qstRespCnt == -1) {
          // 우선순위 중복
          gAlert('', wjmSurvey.getLangData("L00030", vm.svyInfo.SvyLang), '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
        }
        else {
          gAlert('', wjmSurvey.getLangData("L00013", vm.svyInfo.SvyLang), '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
        }
      }

      return isPass;
    }

    /**
     * 페이지타입 변경
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setSvyPagesType = function (type) {
      switch (type) {
        case "PREV":
          var prevPage = vm.prevPages.pop();

          if (prevPage != null) {
            //console.log('prevPage::', prevPage.type, prevPage.page);
            vm.svyPagesType = prevPage.type;
            vm.svyPagesCur = prevPage.page;
            vm.beginQtId = "";
            vm.beginQtIdByPrev = prevPage.beginQtId;
          }
          else {
            gAlert('', wjmSurvey.getLangData("L00014", vm.svyInfo.SvyLang) + '[P]', '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
            return false;
          }

          break;
        case "NEXT":
          if (vm.svyPagesType == 1) {
            vm.setPrevInfo();
            vm.svyPagesType++;
          }
          else if (vm.svyPagesType == 2) {
            if (!getIsValidData()) return false;

            vm.setPrevInfo();

            if (vm.srch.respMode == "U" && isNullOrEmpty(vm.srch.SvyTgtId)) {
              setTgtData(type);
            }
            else {
              setTmpData();
            }
            return false;
          }
          else {
            gAlert('', wjmSurvey.getLangData("L00014", vm.svyInfo.SvyLang) + '[N]', '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
            return false;
          }

          break;
        case "END":
          if (vm.svyPagesType == 2) {
            if (!getIsValidData()) return false;
            if (Object.keys(vm.svyResps).length == 0) {
              gAlert('', wjmSurvey.getLangData("L00015", vm.svyInfo.SvyLang), '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
              return false;
            }
          }
          else {
            gAlert('', wjmSurvey.getLangData("L00014", vm.svyInfo.SvyLang) + '[E]', '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
            return false;
          }

          vm.setPrevInfo();
          vm.svyPagesType++;
          break;
        default : break;
      }

      vm.setSvyPagesTypeNext();
    };

    /**
     * 페이지타입 변경 후처리
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setSvyPagesTypeNext = function() {
      if (vm.prevPages.length > 0) {
        vm.setQstsCur();
        vm.chkEndType();
      }

      if (vm.svyPagesType == 3) {
        if (vm.srch.respMode == "U" && isNullOrEmpty(vm.srch.SvyTgtId)) {
          setTgtData("END");
        }
        else {
          setLogData();
        }
      }

      // 상단 설문타입 텍스트 설정
      switch (vm.svyPagesType) {
        case 1: vm.svyPagesTypeTxt = wjmSurvey.getLangData("L00006", vm.svyInfo.SvyLang); break;
        case 2: vm.svyPagesTypeTxt = wjmSurvey.getLangData("L00007", vm.svyInfo.SvyLang); break;
        case 3: vm.svyPagesTypeTxt = wjmSurvey.getLangData("L00008", vm.svyInfo.SvyLang); break;
        default: break;
      }

      // 상단 페이지 텍스트 설정
      if (vm.svyPagesType == 1) {
        vm.svyPagesTxt = wjmSurvey.getLangData("L00009", vm.svyInfo.SvyLang);
      }
      else if (vm.svyPagesType == 2) {
        vm.svyPagesTxt = vm.svyPagesCur + " / " + vm.svyPages.length;
      }
      else if (vm.svyPagesType == 3) {
        vm.svyPagesTxt = wjmSurvey.getLangData("L00010", vm.svyInfo.SvyLang);
      }

      // 이전 문항 로딩 완료 후에 해당 값 세팅
      vm.beginQtId = vm.beginQtIdByPrev;
      vm.beginQtIdByPrev = "";

      vm.backToTop();

      //console.log("vm.svyQsts", vm.svyQsts);
      //console.log("vm.svyQstItems", vm.svyQstItems);
      //console.log("vm.svyResps", vm.svyResps);
    };

    /**
     * 타임라인 설정
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setTimeLine = function () {
      vm.timeLine.push({
        timeNo: ++vm.timeNo
        , pagesType: vm.svyPagesType
        , pagesCur: vm.svyPagesCur
        , beginQtId: vm.beginQtId
        , datetime: $filter('date')(Date.now(), "yyyy-MM-dd H:mm:ss")
      });

      //console.log("time", vm.timeLine);
    };

    /**
     * 이전페이지 정보 설정
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setPrevInfo = function () {
      vm.setPrevPage(vm.svyPagesType, vm.svyPagesCur, vm.beginQtId);
    };

    /**
     * 종료 처리
     *
     * @param {string}
     * @return {boolean}
     */
    vm.chkEndType = function () {
      var qt = $filter('filter')(vm.svyQstsCur, {QstEndType: 'F'}, true);

      if (qt.length > 0) {
        vm.isFailEnd = true;
      }
      else {
        vm.isFailEnd = false;
      }
    };

    /**
     * 설문버튼 상태변경
     *
     * @param {string}
     * @return {boolean}
     */
    vm.showSvyBtn = function (type) {
      var rtn = false;

      switch (type) {
        case "PREV":
          if (vm.prevPages.length > 0 && vm.svyPagesType == 2) rtn = true;
          break;
        case "NEXT":
          if (vm.isFailEnd) {
            rtn = false;
          }
          else if (
            vm.svyPagesType == 1
            || (vm.svyPagesType == 2 && vm.svyPagesCur != vm.svyPages.length && vm.svyPages.length != 0)
          ) {
            rtn = true;
          }
          break;
        case "END":
          if (vm.isFailEnd) {
            rtn = false;
          }
          else if (vm.svyPagesType == 2 && (vm.svyPagesCur == vm.svyPages.length || vm.svyPages.length == 0)) {
            rtn = true;
          }
          break;
        default : break;
      }

      return rtn;
    };

    /**
     * 페이지 추가
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setSvyPageAdd = function () {
      var nextPgNo = vm.svyPages.length + 1;

      if (vm.svyPages.length > wjmSurvey.maxSvyPagesCnt) {
        gAlert('', wjmSurvey.getLangData("L00016", vm.svyInfo.SvyLang), '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
        return false;
      }

      vm.svyPages.push({PageNo: nextPgNo});
      //vm.svyPagesCur = nextPgNo;
    };

    /**
     * 이메일 도메인 선택 변경
     *
     * @param {string}
     * @return {boolean}
     */
    vm.chgQstEmailDomain = function (svyResps, qtId) {
      if (isNullOrEmpty(svyResps[qtId][2])) {
        svyResps[qtId][1] = "";
      }
      else {
        svyResps[qtId][1] = svyResps[qtId][2];
      }
    };

    /**
     * 이전페이지 기록
     * @param
     * @return
     */
    vm.setPrevPage = function (type, page, beginQtId) {
      //console.log('setPrevPage::', type, page);
      if (type == 3 || (vm.prevPages.length > 0 && vm.prevPages[vm.prevPages.length - 1].page == page && vm.prevPages[vm.prevPages.length - 1].type == type)) {
        return;
      }
      // console.log('page filter::', $filter('filter')(vm.prevPages, {type: type, page: page}, true).length);
      // if (type == 3 || $filter('filter')(vm.prevPages, {type: type, page: page}, true).length > 0) {
      //   return;
      // }

      vm.prevPages.push({type:type, page:page, beginQtId:beginQtId});

      //console.log('page vm.prevPages.push::', type, page);
    };

    /**
     * 화면에러 상태 변경
     * @param
     * @return
     */
    function setErrMsg(isErr, errMsg) {
      vm.isErr = isErr;
      vm.errMsg = isNullOrEmpty(errMsg) ? wjmSurvey.getLangData("L00011", vm.svyInfo.SvyLang) : errMsg;
    }

    /**
     * 설문가능 여부 조회
     * @param
     * @return
     */
    function getChkSurvey() {
      var prms;
      var rtn = [];
      var today = moment(new Date()).format('YYYYMMDD');
      var fromDt = moment(vm.svyInfo.SvyBeginDate).format('YYYYMMDD');
      var toDt = moment(vm.svyInfo.SvyEndDate).format('YYYYMMDD');
      var param = angular.copy(vm.srch);

      vm.dataloader = true;
      param.TargetCnt = vm.svyInfo.TargetCnt;
      param.RespLimitYN = vm.svyInfo.RespLimitYN;

      prms = api.getSurveyRespHistCheck().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docCnt > 0) {
            rtn = data.responseVO.body.docs[0];

            if (vm.svyInfo.SvyStatus != "2") {
              setErrMsg(true, wjmSurvey.getLangData("L00017", vm.svyInfo.SvyLang));
              return false;
            }

            if (vm.srch.respMode == "T" && rtn.DupYN == "Y") {
              setErrMsg(true, wjmSurvey.getLangData("L00018", vm.svyInfo.SvyLang));
              return false;
            }

            if (rtn.LimitYN == "Y") {
              setErrMsg(true, wjmSurvey.getLangData("L00019", vm.svyInfo.SvyLang));
              return false;
            }

            if (today < fromDt || today > toDt) {
              setErrMsg(true, wjmSurvey.getLangData("L00020", vm.svyInfo.SvyLang));
              return false;
            }

            getDataQsts();
          }
        } else {
          console.error("Error> getChkSurvey()");
        }
      }, function (error) {
        console.error("Error> getChkSurvey()");
        console.table(error);
      });
    }

    /**
     * 임시(부분) 응답데이터 조회
     * @param
     * @return
     */
    function getRespHistTmpList() {
      var prms;
      var param = angular.copy(vm.srch);
      var rtn = [];
      var it = [];
      var nextPg = 1;
      var arr;

      vm.dataloader = true;

      prms = api.getSurveyRespHistTmpList().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docCnt > 0) {
            gAlert("", wjmSurvey.getLangData("L00021", vm.svyInfo.SvyLang), {
              btn: "",
              fn: function () {
                vm.svyResps = [];
                vm.svyRespsSbj = [];
                rtn = data.responseVO.body.docs;
                var page = 1;

                // 소개페이지 추가
                vm.setPrevPage(1, 1);

                vm.svyQsts.forEach(function (i) {
                  it = $filter('filter')(rtn, {SvyQstId: i.SvyQstId}, true);

                  if (it.length > 0) {
                    if (nextPg < i.PageNo) nextPg = i.PageNo;

                    it.forEach(function (j, idx) {
                      if (isNullOrEmpty(vm.svyResps[i.SvyQstId])) vm.svyResps[i.SvyQstId] = [];

                      if (!isNullOrEmpty(j.PrioNo)) {
                        if (i.QstType == "5") {
                          vm.svyResps[i.SvyQstId][parseInt(j.PrioNo) - 1] = j.SvyQstItemId + "|" + j.SbjctResp;
                        }
                        else {
                          vm.svyResps[i.SvyQstId][parseInt(j.PrioNo) - 1] = j.SvyQstItemId;

                          if (i.QstType == "1" && !isNullOrEmpty(j.SbjctResp)) { // 선택형중 기타입력박스가 있는 경우
                            if (isNullOrEmpty(vm.svyRespsSbj[i.SvyQstId])) vm.svyRespsSbj[i.SvyQstId] = [];
                            vm.svyRespsSbj[i.SvyQstId][parseInt(j.PrioNo) - 1] = j.SbjctResp;
                          }
                        }
                      }
                      else {
                        if (!isNullOrEmpty(j.SvyQstItemId)) {
                          vm.svyResps[i.SvyQstId][idx] = j.SvyQstItemId;
                        }
                        else if (!isNullOrEmpty(j.SbjctResp)) {
                          if (i.ClassfyCd == "EM") {
                            arr = j.SbjctResp.split("@");
                            if (arr.length == 2) {
                              vm.svyResps[i.SvyQstId][0] = arr[0];
                              vm.svyResps[i.SvyQstId][1] = arr[1];
                            }
                          }
                          else {
                            vm.svyResps[i.SvyQstId][idx] = j.SbjctResp;
                          }
                        }
                        else if (!isNullOrEmpty(j.ObjctResp)) {
                          vm.svyResps[i.SvyQstId][idx] = j.ObjctResp;
                        }
                      }
                    });
                  }
                });

                vm.setPrevPage(2, 1);
                vm.respPages.set(1, 1);

                vm.svyQsts.forEach(function (i) {
                  if (!isNullOrEmpty(vm.svyResps[i.qtId])) {
                    vm.setPrevPage(2, i.PageNo);
                    vm.respPages.set(i.PageNo, i.PageNo);
                    var it = $filter('filter')(vm.svyQstItems, {qtId: i.qtId}, true);

                    for (var qst in it) {
                      if (vm.svyResps[i.qtId][0] == it[qst].itId) {

                        if (it[qst].GoToQstId) {
                          var qt = $filter('filter')(vm.svyQsts, {qtId: it[qst].GoToQstId}, true)[0];
                          if (!isNullOrEmpty(qt)) {
                            vm.setPrevPage(2, qt.PageNo);
                            vm.respPages.set(qt.PageNo, qt.PageNo);
                          }
                        }
                        break;
                      }
                    }
                  }
                });

                vm.svyPagesType = 2;
                vm.svyPagesCur = nextPg;

                // 맨 마지막 prevPage 가 현재 페이지일 때는 제거
                if (vm.prevPages.length > 0 && vm.prevPages[vm.prevPages.length - 1].page == nextPg) {
                  vm.prevPages.pop();
                }

                vm.setSvyPagesTypeNext();
              }
            }, wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
          }
        } else {
          console.error("Error> getRespHistTmpList()");
        }
      }, function (error) {
        console.error("Error> getRespHistTmpList()");
        console.table(error);
      });
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      var i = 0;
      var prms;
      var param = angular.copy(vm.srch);

      vm.dataloader = true;
      param.keyId = vm.srch.SvyId;

      vm.clientEmailList = angular.copy(wjmSurvey.qstEmailDomainList);
      prms = api.getClientEmailList().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          if (data.responseVO.body.docCnt > 0) {
            var tmp = data.responseVO.body.docs[0].list;
            tmp.forEach(function(em) {
              vm.clientEmailList.unshift({txt: em.ClassfyNm, val: em.ClassfyNm});
            });
          }
        } else {
          console.error("Error> getClientEmailList()");
        }
      }, function (error) {
        console.error("Error> getClientEmailList()");
        console.table(error);
      });

      prms = api.getSurveyDetail().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docCnt > 0) {
            vm.svyInfo = data.responseVO.body.docs[0];

            // 언어 변경
            vm.errMsg = wjmSurvey.getLangData("L00011", vm.svyInfo.SvyLang);
            vm.svyPagesTypeTxt = wjmSurvey.getLangData("L00006", vm.svyInfo.SvyLang);
            vm.svyPagesTxt = wjmSurvey.getLangData("L00009", vm.svyInfo.SvyLang);

            if (!isNullOrEmpty(vm.svyInfo["no data"])) {
              setErrMsg(true);
            }
            else {
              if (!isNullOrEmpty(vm.svyInfo.PageCnt)) {
                for (i = 0; i < parseInt(vm.svyInfo.PageCnt); i++) vm.setSvyPageAdd();
                //vm.svyPagesCur = 1;
              }

              getChkSurvey();
            }
          }
          else {
            setErrMsg(true, wjmSurvey.getLangData("L00017", vm.svyInfo.SvyLang));
          }
        } else {
          console.error("Error> getData()");
          /*
          if (!isNullOrEmpty(data.responseVO.body.docs)) {
            gAlert('', data.responseVO.body.docs[0].errMessage);
          }
          */
        }
      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    }

    /**
     * 데이터 조회 (문항)
     * @param
     * @return
     */
    function getDataQsts() {
      var prms = api.getSurveyQstDetail().post(vm.srch).$promise;

      vm.dataloader = true;

      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docCnt > 0) {
            vm.svyQsts = data.responseVO.body.docs[0].list;

            getDataQstItems();
          }
        } else {
          console.error("Error> getDataQst()");

          /*
         if (!isNullOrEmpty(data.responseVO.body.docs)) {
           gAlert('', data.responseVO.body.docs[0].errMessage);
         }
         */
        }
      }, function (error) {
        console.error("Error> getDataQst()");
        console.table(error);
      });
    }

    /**
     * 데이터 조회 (보기)
     * @param
     * @return
     */
    function getDataQstItems() {
      var prms = api.getSurveyQstItemDetail().post(vm.srch).$promise;

      vm.dataloader = true;

      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docCnt > 0) {
            vm.svyQstItems = data.responseVO.body.docs[0].list;
          }

          vm.svyQstsCur = angular.copy($filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur}, true)); // 현재 페이지의 문제 데이터 (분기처리를 위함)

          getImageList();
          if (vm.srch.respMode == "T") getRespHistTmpList();
          getLogoImg();
        } else {
          console.error("Error> getDataQstItems()");
        }

      }, function (error) {
        console.error("Error> getDataQstItems()");
        console.table(error);
      });
    }

    /**
     * 문항이미지 목록
     * @param
     * @return
     */
    function getImageList() {
      var prms = api.getImageDropListConcat().post(vm.srch).$promise;

      vm.dataloader = true;

      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docCnt > 0) {
            vm.imageList = data.responseVO.body.docs[0].list;
            setImage();
          }
        } else {
          console.error("Error> getImageList()");

          /*
         if (!isNullOrEmpty(data.responseVO.body.docs)) {
           gAlert('', data.responseVO.body.docs[0].errMessage);
         }
         */
        }

      }, function (error) {
        console.error("Error> getImageList()");
        console.table(error);
      });
    }

    /**
     * 문항, 보기이미지 경로 삽입
     * @param
     * @return
     */
    function setImage() {
      var qt = [];
      var it = [];
      var img = [];

      qt = $filter('filter')(vm.svyQsts, {QstType: "4"}, true);
      qt.forEach(function (i) {
        i.qtImgSrc = "";

        if (!isNullOrEmpty(i.QstImgId)) {
          img = $filter('filter')(vm.imageList, {AttachmentId: i.QstImgId}, true);
          if (img.length > 0) i.qtImgSrc = StaticVariable.getUrl('/attach/file/' + img[0].PhysicalFileNm + '/download.do?userkey=');
        }

        it = $filter('filter')(vm.svyQstItems, {qtId: i.qtId}, true);
        it.forEach(function (j) {
          j.itImgSrc = "";

          if (!isNullOrEmpty(j.QstItemImgId)) {
            img = $filter('filter')(vm.imageList, {AttachmentId: j.QstItemImgId}, true);
            if (img.length > 0) j.itImgSrc = StaticVariable.getUrl('/attach/file/' + img[0].PhysicalFileNm + '/download.do?userkey=');
          }
        });
      });
    }

    /**
     * 미니결과 조회
     * @param
     * @return
     */
    function getMiniResult() {
      var prms;
      var param = angular.copy(vm.srch);

      vm.dataloader = true;
      param.SvyTypeId = vm.svyInfo.SvyTypeId;
      param.ScoringType = vm.svyInfo.ScoringType;
      param.TotType = vm.svyInfo.TotType;

      prms = api.getMiniResultDetail().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docCnt > 0) {
            if (!isNullOrEmpty(data.responseVO.body.docs[0]["no data"])) {
              vm.LvCont = wjmSurvey.getLangData("L00023", vm.svyInfo.SvyLang);
            }
            else {
              var cont = data.responseVO.body.docs[0].LvCont;
              var sc = data.responseVO.body.docs[0].Score;
              var lv = data.responseVO.body.docs[0].LvTxt;
              var sc1 = data.responseVO.body.docs[0].Score01;
              var sc2 = data.responseVO.body.docs[0].Score02;
              var sc3 = data.responseVO.body.docs[0].Score03;
              var sc4 = data.responseVO.body.docs[0].Score04;
              var sc5 = data.responseVO.body.docs[0].Score05;
              var lv1 = data.responseVO.body.docs[0].LvTxt01;
              var lv2 = data.responseVO.body.docs[0].LvTxt02;
              var lv3 = data.responseVO.body.docs[0].LvTxt03;
              var lv4 = data.responseVO.body.docs[0].LvTxt04;
              var lv5 = data.responseVO.body.docs[0].LvTxt05;
              var nm = data.responseVO.body.docs[0].Name;

              // 응답자명
              if(cont.indexOf("{TgtNm}") != -1 && ! isNullOrEmpty(nm))  {
                cont = cont.replace("{TgtNm}",nm);
              }
              // 총점
              if(cont.indexOf("{TotScore}") != -1 && ! isNullOrEmpty(sc))  {
                cont = cont.replace("{TotScore}",sc);
              }
              // 진단결과
              if(cont.indexOf("{TotLv}") != -1 && ! isNullOrEmpty(lv))  {
                cont = cont.replace("{TotLv}",lv);
              }
              // 영역점수 1~5
              if(cont.indexOf("{SecScore1}") != -1 && ! isNullOrEmpty(sc1))  {
                cont = cont.replace("{SecScore1}",sc1);
              }
              if(cont.indexOf("{SecScore2}") != -1 && ! isNullOrEmpty(sc2))  {
                cont = cont.replace("{SecScore2}",sc2);
              }
              if(cont.indexOf("{SecScore3}") != -1 && ! isNullOrEmpty(sc3))  {
                cont = cont.replace("{SecScore3}",sc3);
              }
              if(cont.indexOf("{SecScore4}") != -1 && ! isNullOrEmpty(sc4))  {
                cont = cont.replace("{SecScore4}",sc4);
              }
              if(cont.indexOf("{SecScore5}") != -1 && ! isNullOrEmpty(sc5))  {
                cont = cont.replace("{SecScore5}",sc5);
              }
              // 영역결과 1~5
              if(cont.indexOf("{SecLv1}") != -1 && ! isNullOrEmpty(lv1))  {
                cont = cont.replace("{SecLv1}",lv1);
              }
              if(cont.indexOf("{SecLv2}") != -1 && ! isNullOrEmpty(lv2))  {
                cont = cont.replace("{SecLv2}",lv2);
              }
              if(cont.indexOf("{SecLv3}") != -1 && ! isNullOrEmpty(lv3))  {
                cont = cont.replace("{SecLv3}",lv3);
              }
              if(cont.indexOf("{SecLv4}") != -1 && ! isNullOrEmpty(lv4))  {
                cont = cont.replace("{SecLv4}",lv4);
              }
              if(cont.indexOf("{SecLv5}") != -1 && ! isNullOrEmpty(lv5))  {
                cont = cont.replace("{SecLv5}",lv5);
              }
              // 상담링크
              if(cont.indexOf("{CounselLink}") != -1 && ! isNullOrEmpty(vm.srch.SvyTgtId))  {
                cont = cont.replace("{CounselLink}", CONSTANT.URL.SITE_URL_FRM_MIN + '/counsel/' + vm.srch.SvyTgtId);
              }

              vm.LvCont = cont;
            }
          }
          else {
            vm.LvCont = wjmSurvey.getLangData("L00024", vm.svyInfo.SvyLang);
          }
        } else {
          console.error("Error> getMiniResult()");
        }
      }, function (error) {
        console.error("Error> getMiniResult()");
        console.table(error);
      });
    }

    /**
     * 설문대상자 생성
     * @param
     * @return
     */
    function setTgtData(type) {
      //console.log('setTgtData()', type);
      var prms;
      var param = angular.copy(vm.srch);

      vm.dataloader = true;

      prms = api.insertSurveyTarget().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docCnt > 0) {
            vm.srch.SvyTgtId = data.responseVO.body.docs[0].RelateDataId;

            if (type == "END") setLogData();
            else setTmpData();
          }
        } else {
          console.error("Error> setTgtData()");
        }
      }, function (error) {
        console.error("Error> setTgtData()");
        console.table(error);
      });
    }

    /**
     * 임시(부분) 응답데이터 이전 저장시간 비교
     * @param
     * @return
     */
    /*
    function setTmpData() {
      var prms;
      var rtn = [];
      var param = angular.copy(vm.srch);

      vm.dataloader = true;

      prms = api.getSurveyRespSaveCheck().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docCnt > 0) {
            rtn = data.responseVO.body.docs[0];

            if (rtn.DupYN == "Y") {
              //setErrMsg(true, "시스템오류가 발생하였습니다.");
              return false;
            }
            else {
              vm.setPrevInfo();
              setTmpDataNext();
            }
          }
        } else {
          console.error("Error> getChkSurvey()");
        }
      }, function (error) {
        console.error("Error> getChkSurvey()");
        console.table(error);
      });
    }
    */

    /**
     * 임시(부분) 응답데이터 저장
     * @param
     * @return
     */
    //function setTmpDataNext() {
    function setTmpData() {
      //console.log('setTmpData()');
      var prms;
      var param = angular.copy(vm.srch);

      vm.dataloader = true;
      param.SvyTypeId = vm.svyInfo.SvyTypeId;
      param.insertData = getRespDataArr();

      // 순서 문제로 여기에서 재설정
      param.chkTgtNM = vm.srch.chkTgtNM;
      param.chkTgtMB = vm.srch.chkTgtMB;
      param.chkTgtEM = vm.srch.chkTgtEM;

      // 입력데이터가 있는 경우 임시(부분)저장 후에 다음페이지로 이동
      if (param.insertData.length > 0) {
        prms = api.updateSurveyRespHistTmp().post(param).$promise;
        prms.then(function (data) {
          if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.dataloader = false;

            if (data.responseVO.body.docCnt > 0) {
              vm.svyPagesCur++;
              vm.setSvyPagesTypeNext();
            }
          } else {
            console.error("Error> setTmpDataNext()");
          }
        }, function (error) {
          console.error("Error> setTmpDataNext()");
          console.table(error);
        });
      }
      else {
        vm.dataloader = false;

        vm.svyPagesCur++;
        vm.setSvyPagesTypeNext();
      }
    }

    /**
     * 응답 저장
     * @param
     * @return
     */
    function setData() {
      var prms;
      var param = angular.copy(vm.srch);

      vm.dataloader = true;
      param.SvyTypeId = vm.svyInfo.SvyTypeId;
      param.SvyTypeCd = vm.svyInfo.SvyTypeCd;
      param.ScoringType = vm.svyInfo.ScoringType;
      param.TotType = vm.svyInfo.TotType;
      param.insertData = getRespDataArr();

      // 순서 문제로 여기에서 재설정
      param.chkTgtNM = vm.srch.chkTgtNM;
      param.chkTgtMB = vm.srch.chkTgtMB;
      param.chkTgtEM = vm.srch.chkTgtEM;


      prms = api.updateSurveyRespHist().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          // 상담문의
          if (vm.svyInfo.ContactTxtYN == "Y"){
            var cont = vm.svyInfo.ContactTxt;
            if(cont.indexOf("{CounselLink}") != -1 && ! isNullOrEmpty(vm.srch.SvyTgtId))  {
              cont = cont.replace("{CounselLink}", CONSTANT.URL.SITE_URL_FRM_MIN + '/counsel/' + vm.srch.SvyTgtId);
            }
            vm.svyInfo.ContactTxt = cont;
          }

          // 미니결과
          if (data.responseVO.body.docCnt > 0) {
            getMiniResult();
          }
        } else {
          console.error("Error> setData()");
        }
      }, function (error) {
        console.error("Error> setData()");
        console.table(error);
      });
    }

    /**
     * 응답 로그 저장
     * @param
     * @return
     */
    function setLogData() {
      var prms;
      var param = angular.copy(vm.srch);

      vm.dataloader = true;
      param.svyInfo = angular.toJson(vm.svyInfo);
      param.svyPages = angular.toJson(vm.svyPages);
      param.svyQsts = angular.toJson(vm.svyQsts);
      param.svyQstItems = angular.toJson(vm.svyQstItems);
      param.svyResps = angular.toJson(getRespDataArr());
      param.userAgent = navigator.userAgent;
      param.timeLine = angular.toJson(vm.timeLine);

      var svyRespsStr = "";

      try {
        for(var data in vm.svyResps) {
          svyRespsStr += "|" + ("I:" + data + ", V:" + angular.toJson(vm.svyResps[data]));
        }
      }
      catch (e) {}

      param.svyResps2 = svyRespsStr;

      // 로그 기록 임시 중단 2022-10-28
      //prms = api.updateSurveyRespHistLog().post(param).$promise;
      //prms.then(function(data) {
      //  if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
      //    vm.dataloader = false;

      //    if (data.responseVO.body.docCnt > 0) {
            setData();
      //    }
      //  } else {
      //    console.error("Error> setLogData()");
      //  }
      //}, function (error) {
      //  console.error("Error> setLogData()");
      //  console.table(error);
      //});
    }

    /**
     * 응답 데이터 변환
     * @param
     * @return
     */
    function getRespDataArr() {
      //console.log('getRespDataArr()');

      var k = 0;
      var data = [];
      var arr;

      vm.svyQsts.forEach(function(i) {
        if (!isNullOrEmpty(vm.svyResps[i.qtId])) {
          if (i.QstType == "1" && i.SelType == "M") {
            angular.forEach(vm.svyResps[i.qtId], function(j, idx) {
              if (!isNullOrEmpty(j)) {
                data.push({
                  SvyQstId: i.qtId,
                  SvyQstItemId: vm.svyResps[i.qtId][idx],
                  ObjctResp: "",
                  SbjctResp: (isNullOrEmpty(vm.svyRespsSbj[i.qtId]) || isNullOrEmpty(vm.svyRespsSbj[i.qtId][idx]) ? "" : vm.svyRespsSbj[i.qtId][idx]), // 기타입력
                  PrioNo: parseInt(idx) + 1
                });
              }
            });
          }
          else if (i.QstType == "2") {
            data.push({
              SvyQstId: i.qtId,
              SvyQstItemId: "",
              ObjctResp: "",
              SbjctResp: vm.svyResps[i.qtId][0],
              PrioNo: ""
            });
          }
          else if (i.QstType == "3") {
            angular.forEach(vm.svyResps[i.qtId], function(j, idx) {
              if (!isNullOrEmpty(j)) {
                data.push({
                  SvyQstId: i.qtId,
                  SvyQstItemId: vm.svyResps[i.qtId][idx],
                  ObjctResp: "",
                  SbjctResp: "",
                  PrioNo: parseInt(idx) + 1
                });
              }
            });
          }
          else if (i.QstType == "5") {
            angular.forEach(vm.svyResps[i.qtId], function(j, idx) {
              if (!isNullOrEmpty(j)) {
                arr = vm.svyResps[i.qtId][idx].split("|");
                if (arr.length == 2) {
                  data.push({
                    SvyQstId: i.qtId,
                    SvyQstItemId: arr[0],
                    ObjctResp: "",
                    SbjctResp: arr[1],
                    PrioNo: parseInt(idx) + 1
                  });
                }
              }
            });
          }
          else if (i.QstType == "C" && i.ClassfyCd == "NM") {
            vm.srch.chkTgtNM = vm.svyResps[i.qtId][0];
            data.push({
              SvyQstId: i.qtId,
              SvyQstItemId: "",
              ObjctResp: "",
              SbjctResp: vm.srch.chkTgtNM,
              PrioNo: ""
            });

            // 편집 끝맺음말 치환 처리
            if(vm.svyInfo.BtmCont.indexOf("{TgtNm}") != -1 && ! isNullOrEmpty(vm.srch.chkTgtNM))  {
              vm.svyInfo.BtmCont = vm.svyInfo.BtmCont.replace("{TgtNm}",vm.srch.chkTgtNM);
            }
          }
          else if (i.QstType == "C" && i.ClassfyCd == "MB") {
            vm.srch.chkTgtMB = vm.svyResps[i.qtId][0];
            data.push({
              SvyQstId: i.qtId,
              SvyQstItemId: "",
              ObjctResp: "",
              SbjctResp: vm.srch.chkTgtMB,
              PrioNo: ""
            });
          }
          else if (i.QstType == "C" && i.ClassfyCd == "EM") {
            vm.srch.chkTgtEM = vm.svyResps[i.qtId][0] + "@" + vm.svyResps[i.qtId][1];
            data.push({
              SvyQstId: i.qtId,
              SvyQstItemId: "",
              ObjctResp: "",
              SbjctResp: vm.srch.chkTgtEM,
              PrioNo: ""
            });
          }
          else if (i.QstType == "C" && i.ClassfyCd == "GD") {
            data.push({
              SvyQstId: i.qtId,
              SvyQstItemId: "",
              ObjctResp: vm.svyResps[i.qtId][0],
              SbjctResp: "",
              PrioNo: ""
            });
          }
          else {
            data.push({
              SvyQstId: i.qtId,
              SvyQstItemId: vm.svyResps[i.qtId][0],
              ObjctResp: "",
              SbjctResp: (isNullOrEmpty(vm.svyRespsSbj[i.qtId]) || isNullOrEmpty(vm.svyRespsSbj[i.qtId][0]) ? "" : vm.svyRespsSbj[i.qtId][0]), // 기타입력
              PrioNo: ""
            });
          }
        }
      });

      return data;
    }

    vm.checkNewPage = function () {
      var curPage = vm.svyPagesCur;

      if (vm.respPages.get(curPage) == null) {
        var delPages = [];
        var prevPage = vm.prevPages[vm.prevPages.length - 1].page;

        angular.forEach(vm.respPages, function(item, page) {
          //console.log('item:', item, ',page:', page);
          if (page > curPage || (curPage > page && page > prevPage)) {
            angular.forEach(vm.svyQsts, function(i) {
              if (i.PageNo == page && !isNullOrEmpty(vm.svyResps[i.qtId])) {
                vm.svyResps[i.qtId] = null;
              }
            });

            delPages.push(page);
          }
        });

        angular.forEach(delPages, function(page) {
          vm.respPages.delete(page);
        });

        vm.respPages.set(curPage, curPage);
        //console.log('vm.respPages::', vm.respPages);
      }
    };

    /**
     * 업체 로고이미지 조회
     *
     * @param
     * @return
     */
    function getLogoImg() {
      if (isNullOrEmpty(vm.svyInfo.Manager)) {
        return;
      }

      var prms;
      var param = {};

      vm.dataloader = true;
      param.tableNm = "users";
      param.TableId = vm.svyInfo.Manager;
      param.grpId = "1";

      prms = api.getFileListOri().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (data.responseVO.body.docs.length > 0) {
            vm.svyInfo.logoSrc = StaticVariable.getUrl('/openapi/attach/file/' + data.responseVO.body.docs[0].PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey);
          }
        }
      }, function (error) {
        console.error("Error> getLogoImg()");
        console.table(error);
      });
    }

    /**
     * 문항 응답 갯수 조회
     *
     * @param
     * @return
     */
    function fnChkQstRespCnt(qtId, dupChk) {
      var rtn = 0;
      var tmpArr = []; // 중복제거

      if (!isNullOrEmpty(vm.svyResps[qtId])) {
        angular.forEach(vm.svyResps[qtId], function(i) {
          if (!isNullOrEmpty(i)) {
            rtn++;
            if(dupChk && !tmpArr.includes(i)) {
              tmpArr.push(i);
            }
          }
        });
      }

      if(dupChk) {
        if(rtn == tmpArr.length) {
          return rtn;
        }
        else {
          return -1;
        }
      }
      else {
        return rtn;
      }
    }

    // 발송내용 바이트 체크
    vm.chkSbjBytes = function(id, len) {
      var sbj = vm.svyResps[id][0];
      if(!isNullOrEmpty(sbj)) {
        var bytes = sbj.length + (escape(sbj) + "%u").match(/%u/g).length - 1;
        if (bytes > len) {
          sbj = fnCutMsg(sbj, len);
          bytes = len;
        }
        vm.CutMsg[id] = bytes;
      }
    };

    // 발송내용 자르기
    function fnCutMsg(str, len) {
      var ret = '';
      var i;
      var msglen = 0;
      for (i = 0; i < str.length; i++) {
        var ch = str.charAt(i);
        if (escape(ch).length > 4) {
          msglen += 2;
        } else {
          msglen++;
        }
        if (msglen > len) break;
        ret += ch;
      }
      return ret;
    }

    /**
     * 스크롤 위로 옮기기
     *
     * @param
     * @return
     */
    vm.backToTop = function() {
      $("html, body").animate({ scrollTop: 0 }, 0);
    };
  }

  webapp.component("survey", {
    transclude: true,
    bindings: {},
    controller: SurveyController,
    controllerAs: "survey",
    templateUrl: "components/survey/survey.html"
  });
})();

(function() {
  "use strict";

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  StatesController.$inject = [];
  /** @ngInject */
  function StatesController() {}

  webapp.component("stats", {
    templateUrl: "app/dashboard/stats/stats.html",
    controller: StatesController,
    controllerAs: "states",
    bindings: {
      model: "=",
      comments: "@",
      number: "@",
      name: "@",
      colour: "@",
      details: "@",
      type: "@",
      goto: "@"
    }
  });
})();

webapp.controller('CommonCodeCustomCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate',
  function CommonCodeCustomCtrl($scope, $element, $compile, CONSTANT, $translate) {
    var vm = this;
    vm.isDisabled = false;

    vm.codeList = {
      Code : '',
      CodeValue : ''
    };

    vm.codeModel = {};
    vm.SelectedCode = 'Y';

    vm.list = [];
    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onChangeHandler = function() {
      if (vm.callback) {
        vm.initChangeData(vm.codeModel);
        vm.callback(vm.codeModel);
        return;
      }

      if (!vm.codeModel) {
        vm.codeModel = '';
      }

      try {
        vm.initChangeData(vm.codeModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList(codeList, codeExclude) {
      angular.forEach(codeList, function (item) {
        var bEx = true;
        if(codeExclude && codeExclude.length > 0 ){
          for(var i = 0; i < codeExclude.length; i++){
            if(codeExclude[i] == item.Code){
              bEx = false;
              break;
            }
          }
        }
        
        if(bEx){
          vm.list.push(item);
        }
        
      });
    }
  }
]);

webapp.directive('commonCodeCustom', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      name : "=",
      codeList : "=",
      codeModel : "=",
      callback : "=",
      isDisabled : "=",
      codeExclude : "=",  //표시하고 싶지 않는 코드를 Array형태로 넘겨준다. Ref) code-exclude="['RESERVE','REPEAT']">
    },
    templateUrl : 'scripts/directives/common-code-custom/common-code-custom.html',
    controller : 'CommonCodeCustomCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.callback = scope.callback;
      ctrl.isDisabled = scope.isDisabled;

      scope.$watchCollection('codeList', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.list = [];
        ctrl.codeModel = scope.codeModel;
        ctrl.getSelectList(scope.codeList, scope.codeExclude);
      });

      scope.$watchCollection('codeModel', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.codeModel = value;
        ctrl.onChangeHandler();
      });

      /** CommonCode Controller **/
      ctrl.initChangeData = function(val) {
        try {
          if(attrs.codeModel != undefined) {
            scope.codeModel = val;
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.service('CommonAPISrv', ['$resource', 'StaticVariable',
    function CommonAPISrv($resource, StaticVariable) {
    	var commonApi = {
       		doComboCode : function() {
       			return $resource(StaticVariable.getUrl('/api/system/getCommonCodeList.json'), {},
       					StaticVariable.getRequestActions.defaultAction());
   			},
    	};
    	return commonApi;
	}
]);


webapp.controller('CommonCodeCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'CommonAPISrv', 'postApi',
  function CommonCodeCtrl($scope, $element, $compile, CONSTANT, commonApi, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.paramData = {
      CodeType : '',
      ParentCommonCodeId : '',
      CommonCodeId : '',
      Code : '',
      CodeValue : '',
      CallbackTarget : '',
      ReloadSeq : 0
    };

    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onChangeHandler = function() {
      if (vm.callback) {
        if (vm.data != null) {
          vm.data.CallbackTarget = vm.paramData.CallbackTarget;
          vm.callback(vm.data);
        } else {
          var data = vm.paramData;
          data.Code = '';
          vm.callback(data);
        }
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList() {
      if (vm.paramData == null || vm.paramData.CodeType == null || vm.paramData.CodeType == '') {
        vm.list = {};
        return;
      }

      angular.copy(vm.paramData, vm.data);

      vm.data.mapCode = "CommonCode.getCommonCodeList";

      var prms = postApi.select(vm.data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.list = result.body.docs;
        }
      }, function(error) {
        console.table(error);
      });
    }

  }
]);

webapp.directive('commonCode', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      paramData : "=",
      callback : "=",
      isDisabled : "=",
      chooseMessage : "="
    },
    templateUrl : 'scripts/directives/common-code/common-code.html',
    controller : 'CommonCodeCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.callback = scope.callback;

      scope.$watchCollection('paramData', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.paramData = scope.paramData;
        ctrl.getSelectList();
      });

      scope.$watchCollection('isDisabled', function(value) {
        //console.log('isDisabled=', scope.isDisabled);
        if (ctrl.isDisabled != undefined)
          ctrl.isDisabled = scope.isDisabled;
      });

      scope.$watchCollection('chooseMessage', function(value) {
        if (scope.chooseMessage != undefined)
          ctrl.chooseMessage = scope.chooseMessage;
      });
    }
  };
} ]);

webapp.service('CommonCodeTreeAPISrv', ['$resource', 'StaticVariable',
    function CommonCodeTreeAPISrv($resource, StaticVariable) {
    	var commonApi = {
       		doComboCode : function() {
       			return $resource(StaticVariable.getUrl('/api/system/getCommonCodeList.json'), {},
       					StaticVariable.getRequestActions.defaultAction());
   			},
    	};
    	return commonApi;
	}
]);


webapp.controller('CommonCodeTreeCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'CommonAPISrv', 'postApi',
  function CommonCodeTreeCtrl($scope, $element, $compile, CONSTANT, commonApi, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.codeModel = {};
    vm.codeChanged = null;
    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';
    vm.allList = {};
    vm.list = [[], [], [], []];
    vm.CommonCode = [];
    vm.Code = [];

    vm.onChangeHandler = function(index) {
      angular.forEach(vm.Code, function(item, key) {
        if (key > index) {
          vm.Code[key] = '';
        }
      });

      vm.list[index + 1] = [];

      if (vm.CommonCode[index]) {
        vm.Code[index] = vm.CommonCode[index].Code;
        angular.forEach(vm.allList, function(item) {
          if (vm.CommonCode[index] && vm.CommonCode[index].CommonCodeId == item.ParentCommonCodeId) {
            vm.list[index + 1].push(item);
          }
        });
      } else {
        vm.Code[index] = '';
      }

      try {
        var bLast = vm.list[index + 1].length == 0 && vm.Code[index] ? true : false;
        vm.initChangeData(vm.Code.filter(function(el){return el != '';}).join('.'), bLast);
      } catch (err) {
        vm.initChangeData("", true);
      }
    };

    vm.setSelectList = setSelectList;
    function setSelectList(codeList) {
      if (codeList == null || codeList == '') {
        vm.list = {};
        return;
      }

      vm.list = [[], [], [], []];

      if (vm.codeModel) {
        vm.Code = vm.codeModel.split('.');

        angular.forEach(vm.Code, function(code, key) {
          vm.CommonCode[key] = {Code:code};
        });
      }

      vm.allList = codeList;

      vm.CodeLevel = vm.allList.reduce(function(a, b) {
        if (a.indexOf(b.CodeLevel) < 0) a.push(b.CodeLevel);
        return a;
      }, []);

      var index = 0;

      angular.forEach(vm.allList, function(item) {
        if (vm.CodeLevel[0]) {
          if (vm.CodeLevel[0] == item.CodeLevel) {
            vm.list[0].push(item);

            if (vm.CommonCode[0] && vm.CommonCode[0].Code == item.Code) {
              vm.CommonCode[0].CommonCodeId = item.CommonCodeId;
            }
          }
        }
      });

      angular.forEach(vm.CodeLevel, function(codeLevel, key) {
        if (key == 0) return;

        angular.forEach(vm.allList, function(item) {
          if (codeLevel == item.CodeLevel) {
            if (vm.CommonCode[key - 1] && vm.CommonCode[key - 1].CommonCodeId == item.ParentCommonCodeId) {
              vm.list[key].push(item);

              if (vm.CommonCode[key] && vm.CommonCode[key].Code == item.Code) {
                vm.CommonCode[key].CommonCodeId = item.CommonCodeId;
              }
            }
          }
        });
      });
    }

    vm.getSelectList = getSelectList;
    function getSelectList(codeType) {
      if (codeType == null || codeType == '') {
        vm.list = {};
        return;
      }

      vm.list = [[], [], [], []];

      if (vm.codeModel) {
        vm.Code = vm.codeModel.split('.');

        angular.forEach(vm.Code, function(code, key) {
          vm.CommonCode[key] = {Code:code};
        });
      }

      vm.data.CodeType = codeType;
      vm.data.mapCode = "CommonCode.getCommonCodeTreeValue";

      var prms = postApi.select(vm.data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.allList = result.body.docs;

          vm.CodeLevel = vm.allList.reduce(function(a, b) {
            if (a.indexOf(b.CodeLevel) < 0) a.push(b.CodeLevel);
            return a;
          }, []);

          var index = 0;

          angular.forEach(vm.allList, function(item) {
            if (vm.CodeLevel[0]) {
              if (vm.CodeLevel[0] == item.CodeLevel) {
                vm.list[0].push(item);

                if (vm.CommonCode[0] && vm.CommonCode[0].Code == item.Code) {
                  vm.CommonCode[0].CommonCodeId = item.CommonCodeId;
                }
              }
            }
          });

          angular.forEach(vm.CodeLevel, function(codeLevel, key) {
            if (key == 0) return;

            angular.forEach(vm.allList, function(item) {
              if (codeLevel == item.CodeLevel) {
                if (vm.CommonCode[key - 1] && vm.CommonCode[key - 1].CommonCodeId == item.ParentCommonCodeId) {
                  vm.list[key].push(item);

                  if (vm.CommonCode[key] && vm.CommonCode[key].Code == item.Code) {
                    vm.CommonCode[key].CommonCodeId = item.CommonCodeId;
                  }
                }
              }
            });
          });
        }
      }, function(error) {
        console.error('Error> getSelectList', error);
      });
    }

  }
]);

webapp.directive('commonCodeTree', [ '$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      codeType : "=",
      codeList : "=",
      codeModel : "=",
      reloadSeq : "=",
      codeChanged : "=",
      chooseMessage : "=",
      preventChanging : "="
    },
    templateUrl : 'scripts/directives/common-code-tree/common-code-tree.html',
    controller : 'CommonCodeTreeCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      // scope.$watchCollection('codeType', function(value) {
      //   ctrl.codeModel = scope.codeModel;
      //   ctrl.getSelectList(scope.codeType);
      // });
      ctrl.codeModel = scope.codeModel;
      ctrl.codeChanged = scope.codeChanged;

      scope.$watchCollection('codeList', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.codeModel = scope.codeModel;
        ctrl.setSelectList(scope.codeList);
      });

      scope.$watchCollection('reloadSeq', function(value) {
        if (attrs.reloadSeq != undefined) {
          ctrl.getSelectList(scope.codeType);
        }
      });

      /** CommonCode Controller **/
      ctrl.initChangeData = function(code, bLast) {
        try {
          scope.codeModel = code;

          if (attrs.codeChanged != undefined) {
            if (!scope.preventChanging || bLast) {
              // timeout을 사용하지 않으면 codeModel 이 바뀌기 전에 codeChanged callback 이 호출되기 때문에
              // timeout을 사용하여 callback 호출시기를 늦춤
              $timeout(function() {
                return ctrl.codeChanged(code);
              }, 1);
            }
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.controller('SearchConditionCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT',
  function SearchConditionCtrl($scope, $element, $compile, CONSTANT) {
    var vm = this;

    vm.searchCoditionStr = "";
    vm.columnMap = null;
    vm.srch = "";
    vm.count = 0;
    vm.countStr = "0";

    vm.updateSearchCoditionStr = function() {
      console.log(vm.count);
      console.log(vm.columnMap);
      console.log(vm.srch);

      vm.countStr = vm.count? vm.count : 0;
      vm.searchConditionStr = "";

      if (vm.columnMap == null)
        return;

      for (var key2 in vm.columnMap) {
        console.log(key2);
      }

      var str = [];
      for (var key in vm.srch) {
        if (key == 'page' || key == 'viewSize' || key == 'tableNm' || key == 'sortDirect' || key == 'sortColumn' || key == 'userkey' || key == 'selectType' || key == 'srchTenantId')
          continue;

        var name = key;
        var value = vm.srch[key];

        console.log(key);

        if (vm.columnMap[key]) {
          name = vm.columnMap[key].ColumnLogicalNm;

          console.log(name, value);

          if (vm.columnMap[key].ColumnLogicalDataType == "50") {
            if (vm.columnMap[key].CodeList) {
              vm.columnMap[key].CodeList.forEach(function (v) {
                if (v.Code == value) {
                  value = v.CodeValue;
                  return;
                }
              });
            }
          }
        }

        str.push(name + ':' + value);
      }

      vm.searchConditionStr += str.join(',');
    };
  }
]);

webapp.directive('searchCondition', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      count : "=",
      columnMap : "=",
      srch : "="
    },
    templateUrl : 'scripts/directives/search-condition/search-condition.html',
    controller : 'SearchConditionCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('count', function(value) {
        ctrl.count = scope.count;
      });

      scope.$watchCollection('columnMap', function(value) {
        ctrl.columnMap = scope.columnMap;
      });

      scope.$watchCollection('srch', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.srch = scope.srch;
        ctrl.updateSearchCoditionStr();
      });
    }
  };
} ]);

webapp.controller('SelectDataGroupCtrl', [ '$scope', '$rootScope', '$element', '$compile', '$filter', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
  function SelectDataGroupCtrl($scope, $rootScope, $element, $compile, $filter, CONSTANT, modalFactory, postApi) {
    var vm = this;

    vm.DatagroupNm = $rootScope.gVariable.dataGroupNm;
    vm.ActionNm = $rootScope.gVariable.dataActionNm;

    vm.changeDatagroup = changeDatagroup;

    function changeDatagroup() {
      var ctrl = 'DataGroupActionModalCtrl as vc';
      var paramData = {};

      // 부서 검색 팝업 호출
      var modalInstance = modalFactory.open('modal', 'components/modal/dataanalysis/data-group-action-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        $rootScope.setGVariable('dataGroupId', okData.DatagroupId);
        $rootScope.setGVariable('dataActionId', okData.ActionId);
        $rootScope.setGVariable('dataGroupNm', okData.DatagroupNm);
        $rootScope.setGVariable('dataActionNm', okData.ActionNm);
        vm.DatagroupNm = okData.DatagroupNm;
        vm.ActionNm = okData.ActionNm;

        if (vm.codeChanged) {
          vm.codeChanged();
        }
      }, function (cancelData) {
        // 취소
      });
    }
  }
]);

webapp.directive('selectDataGroup', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      codeChanged : "=",
    },
    templateUrl : 'scripts/directives/select-data-group/select-data-group.html',
    controller : 'SelectDataGroupCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.codeChanged = scope.codeChanged;
    }
  };
} ]);

webapp.controller('UdcDetailCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$filter',
  function UdcDetailCtrl($scope, $element, $compile, CONSTANT, $translate, $filter) {
    var vm = this;
    vm.disabled = false;
    vm.metaList = [];
    vm.metaModel = [];
    vm.initalized = false;
  }
]);

webapp.directive('udcDetail', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      metaList : "=",
      metaModel : "=",
    },
    templateUrl : 'scripts/directives/udc/udc-detail.html',
    controller : 'UdcDetailCtrl as vc',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('metaList', function(value) {
        ctrl.metaList = scope.metaList;
        ctrl.metaModel = scope.metaModel;
        ctrl.initalized = true;
      });

      ctrl.initChangeData = function(val) {
        try {
          if(attrs.metaModel != undefined) {
//            scope.metaModel = val;
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.controller('UdcEditCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$filter',
  function UdcEditCtrl($scope, $element, $compile, CONSTANT, $translate, $filter) {
    var vm = this;
    vm.disabled = false;
    vm.metaList = [];
    vm.metaModel = [];

    vm.initalized = false;
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onModelChanged = function() {
      if (!vm.initalized) return;

      try {
        vm.initChangeData(vm.metaModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.onDateChanged = function(ColumnPhysicalNm, index) {
//    vm.metaModel[ColumnPhysicalNm] = $filter('date')(vm.RegDate[index], 'yyyy-MM-dd', 'UTC');
      vm.metaModel[ColumnPhysicalNm] = (new Date(vm.RegDate[index])).getTime();
      vm.onModelChanged();
    };
  }
]);

webapp.directive('udcEdit', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      metaList : "=",
      metaModel : "=",
    },
    templateUrl : 'scripts/directives/udc/udc-edit.html',
    controller : 'UdcEditCtrl as vc',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('metaList', function(value) {
        ctrl.metaList = scope.metaList;
        ctrl.metaModel = scope.metaModel;
        ctrl.initalized = true;
      });

      ctrl.initChangeData = function(val) {
        try {
          if(attrs.metaModel != undefined) {
//            scope.metaModel = val;
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.controller('UdcSearchCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$filter',
  function UdcSearchCtrl($scope, $element, $compile, CONSTANT, $translate, $filter) {
    var vm = this;
    vm.disabled = false;
    vm.metaList = [];
    vm.metaModel = [];

    vm.initalized = false;
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onModelChanged = function() {
      if (!vm.initalized) return;

      try {
        vm.initChangeData(vm.metaModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.onDateChanged = function(ColumnPhysicalNm, index) {
//    vm.metaModel[ColumnPhysicalNm] = $filter('date')(vm.RegDate[index], 'yyyy-MM-dd', 'UTC');
      vm.metaModel[ColumnPhysicalNm] = (new Date(vm.RegDate[index])).getTime();
      vm.onModelChanged();
    };
  }
]);

webapp.directive('udcSearch', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      metaList : "=",
      metaModel : "=",
    },
    templateUrl : 'scripts/directives/udc/udc-search.html',
    controller : 'UdcSearchCtrl as vc',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('metaList', function(value) {
        ctrl.metaList = scope.metaList;
        ctrl.metaModel = scope.metaModel;
        ctrl.initalized = true;
      });

      ctrl.initChangeData = function(val) {
        try {
          if(attrs.metaModel != undefined) {
//            scope.metaModel = val;
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.controller('FileAttachController', [ '$scope', '$element', '$compile', '$timeout', 'StaticVariable', 'fileUploadService', 'uuidFactory', '$rootScope',
    function FileAttachController($scope, $element, $compile, $timeout, StaticVariable, fileUploadService, uuid, $rootScope) {
      var vm = this;
      var addLine = '';
      var request;

      vm.showLoading = false;
      vm.onDelete = onDelete;
      vm.onDeleteCancel = onDeleteCancel;
      vm.loadingPosition = "";
      vm.fileData = new Array();
      var id = 0;

      vm.onChangeHandler = function(files) {
        console.log('onChangeHandler');
        vm.uploadFiles(files);
      };

      $scope.$on('cancelFileSend', function(event, args) {
        if (request) {
          request.about();
        }
      });

      vm.uploadFiles = uploadFiles;

      function uploadFiles(files) {
        console.log('uploadFiles', vm.fileData);
        var tempIds = [];
        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;
          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : id,
                delState : ''
              };
              tempIds.push(obj);
              if (vm.fileData == null)
                vm.fileData = new Array();
              vm.fileData.push(angular.copy(obj));
              id++;
            }
          });
          console.log("fu", vm.fileData);
          if (hasZeroByteFile) {
            alert('빈 파일이 있습니다.');
            return;
          }

          request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              console.log('progress percent::', percent);
              $('#filectl_' + obj.id + ' .progress .progress-bar').css('width', percent + '%');
            });
            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.fileData, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.tmpFileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?fileName=" + item.encFileName);
                    obj.delState = '';
                    console.log(obj.link);
                  }
                });
              });
              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element(vm.fileElement).val(null);
              if (vm.callback) {
                vm.callback.onFileUploadComplete();
              }
              vm.showLoading = false;
            }, function(reason) {
              console.log(reason);
            });
          } catch (err) {
            console.log(err);
          }
        });
      }
      ;

      function onDelete(obj) {
        if (obj.typeId != "temp") {
          if (obj.delState != 'delete')
            obj.delState = 'delete';
          else
            obj.delState = '';
          return;
        }

        var idx = -1;
        angular.forEach(vm.fileData, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.fileData[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete().get({
              attachId : vm.fileData[idx].fileKey
            }).$promise;

            prms.then(function(data) {
              console.log('success', data);
            }, function(error) {
              console.error('fail', error);
            })
            vm.fileData.splice(idx, 1);
          } else {
            vm.fileData[idx].delState = 'delete';
            // if (vm.callback)
            // vm.callback.onFileDelete(vm.fileData[idx]);
          }
        }
      }
      ;

      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.fileData, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.fileData[idx].delState = '';
          /*			if (vm.fileData[idx].typeId == "temp") {
          			var prms = fileUploadService.attachFileDelete().get({attachId:vm.fileData[idx].fileKey}).$promise;

          			prms.then(
          	                function (data) {
          	                	console.log('success', data);
          	                },
          	                function (error) {
          	                    console.error('fail', error);
          	                }
          	            )
          			} else if (vm.callback){
          				vm.callback.onFileDelete(vm.fileData[idx]);
          			}
          			vm.fileData.splice(idx, 1);\
           */
        }
      }
      ;

      vm.openDilalog = openDilalog;
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

    } ]);

webapp.directive('fileAttach', ['$compile','$parse', function ($compile,$parse) {
    return {
    	transclude: true,
        restrict: 'E',
        scope:{
        	fileData:"=",
        	preFilesUpload:"=",
        	callback:"="
        },
        templateUrl: 'scripts/file-attach/directive/file-attach.html',
        controller: 'FileAttachController as faCtrl',
        link: function(scope, element, attrs, ctrl) {
        	var fileElement = angular.element(element[0].querySelector('input'));
        	fileElement.bind('change', function(){
        		ctrl.onChangeHandler(fileElement[0].files);
        	});

        	scope.$watchCollection('fileData', function(value) {
          	ctrl.fileData = scope.fileData;
          });

          if(scope.preFilesUpload && scope.preFilesUpload.length > 0){
            ctrl.uploadFiles(scope.preFilesUpload);
          }
          ctrl.callback = scope.callback;
          ctrl.fileElement = fileElement;

	        var checkSize, isTypeValid, processDragOverOrEnter, validMimeTypes;
	        processDragOverOrEnter = function(event) {
	          if (event != null) {
	            event.preventDefault();
	          }
	          event.dataTransfer.effectAllowed = 'copy';
	          return false;
	        };
	        validMimeTypes = attrs.fileDropzone;
	        checkSize = function(size) {
	          var _ref;
	          if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) / 1024 < attrs.maxFileSize) {
	            return true;
	          } else {
	            alert("File must be smaller than " + attrs.maxFileSize + " MB");
	            return false;
	          }
	        };
	        isTypeValid = function(type) {
	          if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
	            return true;
	          } else {
	            alert("Invalid file type.  File must be one of following types " + validMimeTypes);
	            return false;
	          }
	        };
	        element.bind('dragover', processDragOverOrEnter);
	        element.bind('dragenter', processDragOverOrEnter);
	        return element.bind('drop', function(event) {
	          var file, name, reader, size, type;
	          if (event != null) {
	            event.preventDefault();
	          }
	          reader = new FileReader();
	          reader.onload = function(evt) {
	            if (checkSize(size) && isTypeValid(type)) {
	              return scope.$apply(function() {
	                scope.file = evt.target.result;
	                if (angular.isString(scope.fileName)) {
	                  return scope.fileName = name;
	                }
	              });
	            }
	          };
	          file = event.dataTransfer.files[0];
	          name = file.name;
	          type = file.type;
	          size = file.size;
	          reader.readAsDataURL(file);
	          return false;
	        });
        }
    };
}]);

(function() {
  'use strict';
  angular.module('reusableThings', []).directive('fileDropzone', function() {
    return {
      restrict: 'A',
      scope: {
        file: '=',
        fileName: '='
      },
      link: function(scope, element, attrs) {
        var checkSize, isTypeValid, processDragOverOrEnter, validMimeTypes;
        processDragOverOrEnter = function(event) {
          if (event != null) {
            event.preventDefault();
          }
          event.dataTransfer.effectAllowed = 'copy';
          return false;
        };
        validMimeTypes = attrs.fileDropzone;
        checkSize = function(size) {
          var _ref;
          if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) / 1024 < attrs.maxFileSize) {
            return true;
          } else {
            alert("File must be smaller than " + attrs.maxFileSize + " MB");
            return false;
          }
        };
        isTypeValid = function(type) {
          if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
            return true;
          } else {
            alert("Invalid file type.  File must be one of following types " + validMimeTypes);
            return false;
          }
        };
        element.bind('dragover', processDragOverOrEnter);
        element.bind('dragenter', processDragOverOrEnter);
        return element.bind('drop', function(event) {
          var file, name, reader, size, type;
          if (event != null) {
            event.preventDefault();
          }
          reader = new FileReader();
          reader.onload = function(evt) {
            if (checkSize(size) && isTypeValid(type)) {
              return scope.$apply(function() {
                scope.file = evt.target.result;
                if (angular.isString(scope.fileName)) {
                  return scope.fileName = name;
                }
              });
            }
          };
          file = event.dataTransfer.files[0];
          name = file.name;
          type = file.type;
          size = file.size;
          reader.readAsDataURL(file);
          return false;
        });
      }
    };
  });

}).call(this);

(function() {
  'use strict';
    angular.module('reusableThings').controller('TestCtrl', function($scope) {
        $scope.image = null
        $scope.imageFileName = ''
    });

}).call(this);

webapp.factory('fileAttachDataUtil', function() {
	return {
		isLoading : function(arr) {
			if (arr) {
				var ret = false;
				angular.forEach(arr, function(value) {
					if (!value.isLoaded) {
						ret = true;
						return;
					}
				});
				return ret;
			} else {
				return ret;
			}
		},
		getTempFileKeys : function(arr) {
			var ret = [];
			if(arr){
				angular.forEach(arr, function(value) {
					if(value.tmpFileKey){
						ret.push(value.tmpFileKey);
					}
				});
			}
			return ret;
		},
		getAttachIds: function(arr){
			var ret = [];
			if(arr){
				angular.forEach(arr, function(value) {
					if(value.attachId){
						ret.push(value.attachId);
					}
				});
			}
			return ret;
		},
		cancel: function(scope){
			scope.$broadcast('cancelFileSend', {});
		}
	}
});

webapp.factory('fileUploadListener', fileUploadListener);
function fileUploadListener() {
	this.listener = {
			setListener: function(listener){
				this.listener = listener;
			},
			getListener: function()
			{
				return this.listener;
			}
		};
	return this.listener;
};

webapp.service('fileUploadService', [ '$rootScope', '$q', '$resource', 'StaticVariable', FileUploadService ]);

function FileUploadService($rootScope, $q, $resource, StaticVariable) {
	var requests = [];
	var svc = {
		post : function(files, data, progressCb) {
			var xhr = new XMLHttpRequest();
			requests.push(xhr);
			return {
				to : function(uploadUrl) {
					var deferred = $q.defer()
					if (!files || !files.length) {
						deferred.reject("No files to upload");
						return;
          }

          // CORS 문제 발생
          // xhr.withCredentials = true;
          xhr.upload.onprogress = onProgress;
          xhr.onload = onLoad;
          xhr.upload.onerror = onError;

          var formData = new FormData();

          if (data) {
            Object.keys(data).forEach(function(key) {
              formData.append(key, data[key]);
            });
          }

          for (var idx = 0; idx < files.length; idx++) {
            formData.append(files[idx].name, files[idx]);
          }

          xhr.open("POST", uploadUrl);
          xhr.send(formData);

          function onProgress(e) {
            $rootScope.safeApply(function() {
              var percentCompleted;
              if (e.lengthComputable) {
                percentCompleted = Math.round((e.loaded / e.total) * 100);
                if (progressCb) {
                  progressCb(percentCompleted);
                } else if (deferred.notify) {
                  deferred.notify(percentCompleted);
                }
              }
            });
          }

          function onLoad(e) {
            var idx = -1;
            angular.forEach(requests, function(val, key) {
              if (val == xhr) {
                idx = key;
              }
            });
            if (idx != -1) {
              requests.splice(idx, 1);
            }
            $rootScope.safeApply(function() {
              var ret = {
                files: files,
                data: angular.fromJson(xhr.responseText)
              };
              deferred.resolve(ret);
            });
          }

          function onError(e) {
            var msg = xhr.responseText? xhr.responseText : "An unknown error occurred posting to '" + uploadUrl + "'";
            $rootScope.safeApply(function() {
              deferred.reject(msg);
            });
          }

					return deferred.promise;
				},
				about: function(){
					if(requests){
						angular.forEach(requests, function(req){
							req.abort();
						});
					}
				}
			};
		},
		attachFileDelete : function(){
			return $resource(StaticVariable.getUrl('/attach/delete/:typeId/:attachId?userkey='+$rootScope.gVariable.userKey),
				{
					typeId : '@typeId',
					attachId : '@attachId'
				},
				StaticVariable.getRequestActions.defaultAction());
		},
		attachFileDelete : function(){
			return $resource(StaticVariable.getUrl('/attach/temp/:attachId/delete.do?userkey='+$rootScope.gVariable.userKey),
				{
					attachId : '@attachId',
				},
				StaticVariable.getRequestActions.defaultAction());
		},
	};

	return svc;
};

(function() {
  ButtonsController.$inject = [];

  function ButtonsController() {}
  var buttons = {
    bindings: {},
    controller: ButtonsController,
    controllerAs: "buttons",
    templateUrl: "components/biz-component/buttons/buttons.html"
  };
  webapp.component("buttons", buttons);
})();

webapp.controller('FavoriyModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'gAlert', 'gConfirm', 'postApi', '$rootScope', 'modalFactory',
    function FavoriyModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, gAlert, gConfirm, postApi, $rootScope, modalFactory) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.columnMap = {};
      vm.currentPage = 1;
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'WjmFavorites'; // 그룹고객 작업 테이블명

      var LIST_SQL = 'WjmSend.getFavoriteList';
      var LIST_CNT_SQL = 'WjmSend.getFavoriteCnt';
      var DELETE_SQL = 'WjmSend.deleteFavorite';

      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        userkey : '',
        tableNm : KEY_TABLE_NM,
      };

      (function FavoriyModalCtrl() {
        vm.SaveType = toModalData.SaveType == undefined ? 'E' : toModalData.SaveType;
        vm.SaveTypeNm = vm.SaveType == 'E' ? '이메일' : '회신번호';
        getList();
        setInitData();
      })();


      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.SaveType = vm.SaveType;
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.SaveType = vm.SaveType;
        data.mapCode = LIST_CNT_SQL;

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = result.body.docs[0];
          }
        });
      }

    /**
     * 그룹고객 목록 화면 구성
     *
     * @param
     * @return
     */
    function setResponsive() {
      var columns = [];
      var o = {};

      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};

        column.name = item.ColumnPhysicalNm; // 물리 컬럼명
        column.title = item.ColumnLogicalNm; // 논리 컬럼명

        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }

        if (item.ColumnPhysicalDataType == "40") {
          // 날짜형 데이터 처리
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }

        index++;
        columns.push(column);
      });
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(item) {
      $uibModalInstance.close(item);
    }

    /**
     * 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();
    }


    /* 사용자검색- 지우기 */
    function eraseUser() {
      vm.srch.ManagerNm = '';
      vm.srch.ManagerId = '';
    }

    /**
     * 초기 데이터 설정
     * @param
     * @return
     */
    function setInitData() {
      // 목록 체크박스 로직 설정
      vm.chkHead = false;
      $scope.chkRowChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          if (!vm.lists[i].isChecked) {
            vm.chkHead = false;
            return;
          }
        }
        vm.chkHead = true;
      };

      $scope.chkHeadChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          vm.lists[i].chkRow = vm.chkHead;
        }
      };

    }

      /**
     * 그룹고객 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {

      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      //getSearch();
      getList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    function setSortDirect(sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    /**
     * 그룹고객 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      //var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});

      getList();
    }

    /**
     * 그룹고객 목록 당 조회 건수 변경
     * @param
     * @return
     */
    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수
      getList();
    }


    function delInfo() {
      var data = angular.copy(vm.srch);
      data.SaveType = vm.SaveType;
      data.mapCode = DELETE_SQL;

      data.lists = [];
      for (var i = 0; i < vm.lists.length; i++) {
        if (vm.lists[i].chkRow) {
          data.lists.push(vm.lists[i].KeyId);
        }
      }

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETE', {
            btn : '',
            fn : function() {
              getList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> delInfo()");
        console.table(error);
      });
    }


    vm.pageChanged = pageChanged;
    vm.eraseUser = eraseUser;
    vm.setSortColumn = setSortColumn;           // 정렬 설정
    vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
    vm.setPageChanged = setPageChanged;
    vm.setChangeViewSize = setChangeViewSize;
    vm.delInfo = delInfo;

  } ]);

webapp.controller('FormModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function FormModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getFormList = getFormList;
      vm.columnMap = {};

      (function FormModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.FormType = '200';
        vm.FormList = [];
        getFormList();
      })();

      function changeViewSize() {
        getFormList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          FormType: '200',
        }
        vm.filter = req;
        return req;
      }

      function getFormList() {
        getFormListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'form.modal';
        data.mapCode = 'Campaign2.getFormList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.FormList = result.body.docs;
            } else {
              vm.FormList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getFormList()', status, error);
          vm.dataloader = false;
        });
      }

      function getFormListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'Campaign2.getFormListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getFormList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(Form) {
        gConfirm('', '작성된 내용이 있을경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
          btn: '',
          fn: function () {
            $uibModalInstance.close(Form);
          }
        }, {
          btn: '',
          fn: function () {
            cancel();
          }
        });

      }

    } ]);

webapp.controller('FormModal2Ctrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function FormModal2Ctrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getFormList = getFormList;
      vm.columnMap = {};

      (function FormModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.FormType = toModalData.formType;
        vm.FormList = [];
        getFormList();
      })();

      function changeViewSize() {
        getFormList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          formType: toModalData.formType,
        }
        vm.filter = req;
        return req;
      }

      function getFormList() {
        getFormListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'form.modal';
        data.mapCode = 'Campaign2.getFormList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.FormList = result.body.docs;
            } else {
              vm.FormList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getFormList()', status, error);
          vm.dataloader = false;
        });
      }

      function getFormListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'Campaign2.getFormListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getFormList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(Form) {
        $uibModalInstance.close(Form);
//        gConfirm('', '작성된 내용이 있을경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
//          btn: '',
//          fn: function () {
//            $uibModalInstance.close(Form);
//          }
//        }, {
//          btn: '',
//          fn: function () {
//            cancel();
//          }
//        });
      }

    } ]);

webapp.controller('FreModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm',
    function FreModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm) {
      var vm = this;

      // html 에서 사용하는 함수 연결
      vm.ok = ok;
      vm.cancel = cancel;
      vm.setData = setData;
      vm.setDelData = setDelData;

      (function FreModalCtrl() {
        vm.srch = {
          keyId: toModalData.keyId,
          message: toModalData.message
        };

        vm.data = {};
        vm.MessageBytes = "0";

        if (!isNullOrEmpty(vm.srch.keyId)) {
          getDetail();
        }
        else {
          vm.data.Message = vm.srch.message;
        }
      })();

      /**
       * 내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.chkMessage = function () {
        var msg = "";
        var bytes = 0;

        msg = vm.data.Message;
        bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

        if (bytes > 90) {
          vm.data.Message = fnCutMsg(msg, 90);
          bytes = 90;
        }

        vm.MessageBytes = bytes;
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      /**
       * 자주 사용하는 메세지 조회
       *
       * @param
       * @return
       */
      function getDetail() {
        var data = vm.srch;
        data.mapCode = 'Campaign.getFrequsedmsgDetail';

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.data = result.body.docs[0];
          }
        });
      }

      /**
       * 자주 사용하는 메세지 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (getIsValidData() == false) {
          return;
        }

        var data = vm.data; // 사용자 입력 데이터
        data.keyId = vm.srch.keyId;

        if (isNullOrEmpty(data.keyId)) {
          // 신규 등록
          data.mapCode = 'Campaign.insertFrequsedmsg';

          postApi.insert(data, function (result) {
            vm.srch.keyId = result.body.docs[0].RelateDataId;
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
          });
        } else {
          // 수정
          data.mapCode = 'Campaign.updateFrequsedmsg';

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 자주 사용하는 메세지 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        //console.log("res", result);
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          /*
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
          */
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                //goNextPage(true);
                ok();
              }
            });
            return;
          //}
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';
        if (isNullOrEmpty(vm.data.Subject)) {
          errMsg = errMsg + '- 제목을 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Message)) {
          errMsg = errMsg + '- 내용을 선택하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        /*
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;
        */

        //vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = "Campaign.deleteFrequsedmsgDetail";

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                //var srch = $stateParams.srch;

                // 목록 화면 이동
                /*
                $state.go(LIST_PAGE_URL, {
                    srch: srch
                  },
                  {reload: LIST_PAGE_URL});
                  */
                ok();
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> setDelDataAction()");
          console.table(error);
        });
      }

      /**
       * 취소 버튼 이벤트
       *
       * @param
       * @return
       */
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      /**
       * 성공 이벤트
       *
       * @param
       * @return
       */
      function ok() {
        $uibModalInstance.close(null);
      }
    } ]);

webapp.controller('GrpcustModalCtrl', [ '$window', '$rootScope', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', 'modalFactory',
  function GrpcustModalCtrl($window, $rootScope, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm, modalFactory) {
    var vm = this;

    // html 에서 사용하는 함수 연결
    vm.ok = ok;
    vm.cancel = cancel;
    vm.getData = getData;
    vm.setData = setData;

    (function GrpcustModalCtrl() {
      vm.srch = {
        keyId: toModalData.keyId
      };

      vm.data = {};
      vm.data.CustCnt = 0;

      if (isNullOrEmpty(vm.srch.keyId)) cancel();

      getCommonCodeList("CUSTGRADE");
    })();

    /**
     * 담당자 검색 팝업 호출
     *
     * @param {string}
     * @return {boolean}
     */
    vm.srchUserModal = function () {
      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
      var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        // 사용자 선택
        vm.srch.ManagerNm = okData.UserNm;
        vm.srch.Manager = okData.UserId;
      }, function (cancelData) {
        // 취소
      });
    };

    /**
     * 담당자 초기화
     *
     * @param {string}
     * @return {boolean}
     */
    vm.eraseUser = function () {
      vm.srch.ManagerNm = "";
      vm.srch.Manager = "";
    };

    /**
     * 문제유형코드 목록
     *
     * @param
     * @return
     */
    function getCommonCodeList(codeType) {
      var data = vm.srch;

      vm.srch.CodeType = codeType;
      data.mapCode = 'CommonCode.getCommonCodeList';

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {

          switch (codeType) {
            case "CUSTGRADE" :
              vm.CustGradeCodeList = result.body.docs;
              getCommonCodeList("VISITPATH");
              break;
            case "VISITPATH" :
              vm.VisitPathCodeList = result.body.docs;
              break;
            default : break;
          }
        }
      });
    }

    /**
     * 그룹고객 추출
     *
     * @param
     * @return
     */
    function getData() {
      if (getIsValidData() == false) return;

      var data = vm.srch;
      data.mapCode = 'Campaign.getGroupcustomerExtract';

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {

          if (result.body.docs.length > 0) {
            vm.data.CustCnt = result.body.docs;
          } else {
            vm.data.CustCnt = 0;
          }
        }
      });
    }

    /**
     * 그룹고객 추가
     *
     * @param
     * @return
     */
    function setData() {
      if (getIsValidData() == false) return;

      if (isNullOrEmpty(vm.data.CustCnt) || vm.data.CustCnt == "0") {
        gAlert("", "추출고객수가 0명입니다.");
        return;
      }

      var data = vm.srch;

      data.mapCode = 'Campaign.updateGroupcustomerExtract';

      postApi.insert(data, function (result) {
        setInsertUpdateDetail(result);
      }, function (error) {
        console.error("Error> setData()");
        console.table(error);
      });
    }

    /**
     * 그룹고객 추가 후 처리
     *
     * @param result - 저장 결과
     * @return
     */
    function setInsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        gAlert("", "Menu.SAVED", {
          btn: "",
          fn: function () {
            ok();
          }
        });
        return;
      }

      console.error("Error> setInsertUpdateDetail()");
      gAlert('', result.body.docs[0].errMessage);
    }

    /**
     * 필수항목 체크
     * @param
     * @return
     */
    function getIsValidData() {
      var errMsg = '';

      if (
        isNullOrEmpty(vm.srch.CustNm)
        && isNullOrEmpty(vm.srch.Mobile)
        && isNullOrEmpty(vm.srch.CustGrade)
        && isNullOrEmpty(vm.srch.VisitPath)
        && isNullOrEmpty(vm.srch.ManagerNm)
      ) {
        errMsg = errMsg + '- 검색조건을 하나 이상 입력하세요.<br/>';
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      return true;
    }

    /**
     * 취소 버튼 이벤트
     *
     * @param
     * @return
     */
    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    /**
     * 성공 이벤트
     *
     * @param
     * @return
     */
    function ok() {
      $uibModalInstance.close(null);
    }
  } ]);

webapp.controller('SmsModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', 'modalFactory',
    function SmsModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm, modalFactory) {
      var vm = this;

      // html 에서 사용하는 함수 연결
      vm.cancel = cancel;
      vm.setData = setData;
      vm.setFreMessage = setFreMessage;

      (function SmsModalCtrl() {
        vm.srch = {
          keyId: toModalData.keyId
        };

        vm.data = {};
        vm.MessageBytes = "0";

        if (isNullOrEmpty(vm.srch.keyId)) cancel();

        getFreList();
        getSendHourList();
        getSendTimeList();
      })();

      /**
       * 자주 사용하는 메세지 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchFreModal = function (keyId) {
        var ctrl = 'FreModalCtrl as vc';
        var message = "";

        if (isNullOrEmpty(keyId)) {
          message = vm.data.SendMessage;
        }

        var paramData = {keyId: keyId, message: message};
        var modalInstance = modalFactory.open('modal', 'components/modal/campaign/fre-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getFreList();
        }, function (cancelData) {
        });
      };

      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        msg = vm.data.SendMessage;
        bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

        if (bytes > 90) {
          vm.data.SendMessage = fnCutMsg(msg, 90);
          bytes = 90;
        }

        vm.SendMessageBytes = bytes;
      };

      /**
       * 자주 사용하는 메세지 목록 조회
       *
       * @param
       * @return
       */
      function getFreList() {
        //vm.dataloader = true; // Progressbar 표시

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = "Campaign.getFrequsedmsgList";

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            //console.log("re", result);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.freLists = result.body.docs;
              vm.freTotalItems = vm.freLists.length;
            } else {
              // 데이터 조회 실패
              vm.freLists = {};
              vm.freTotalItems = 0;
            }
          }

          //vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          //vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getFreList()");
          console.table(error);
        });
      }

      /**
       * 발송시간 코드
       *
       * @param
       * @return
       */
      function setFreMessage(message) {
        vm.data.SendMessage = message;

      }

      /**
       * 발송시간 코드
       *
       * @param
       * @return
       */
      function getSendHourList() {
        vm.sendHourList = [
          {time:"09"}
          , {time:"10"}
          , {time:"11"}
          , {time:"12"}
          , {time:"13"}
          , {time:"14"}
          , {time:"15"}
          , {time:"16"}
          , {time:"17"}
          , {time:"18"}
          , {time:"19"}
          , {time:"20"}
        ];
      }

      /**
       * 발송분 코드 목록
       *
       * @param
       * @return
       */
      function getSendTimeList() {
        vm.sendMinList = [
          {time:"00"}
          , {time:"10"}
          , {time:"20"}
          , {time:"30"}
          , {time:"40"}
          , {time:"50"}
        ];
      }

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.srch.keyId)) {
          errMsg = errMsg + '- 대상그룹이 없습니다.<br/>';
        }

        if (isNullOrEmpty(vm.data.SendTelno)) {
          errMsg = errMsg + '- 발신번호를 입력하세요.<br/>';
        }

        if (vm.data.SendDateType == "200") {
          if (isNullOrEmpty(vm.data.SendDt)) {
            errMsg = errMsg + '- 발송일을 선택하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.SendHour)) {
            errMsg = errMsg + '- 발송시간(시)을 선택하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.SendMin)) {
            errMsg = errMsg + '- 발송시간(분)을 선택하세요.<br/>';
          }
        }

        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 발송내용을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 문제 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (getIsValidData() == false) {
          return;
        }

        var data = vm.data; // 사용자 입력 데이터
        data.GrpId = vm.srch.keyId;
        data.SendType = "20";
        data.SendDtType = "";

        if (data.SendDateType == "200") data.SendDate = data.SendDt + " " + data.SendHour + ":" + data.SendMin + ":00";

        // 신규 등록
        data.mapCode = 'Campaign.updateSMSHistGroup';

        postApi.insert(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setQstData()");
          console.table(error);
        });
      }

      /**
       * 문제 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        //console.log("res", result);
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          /*
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
          */
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                cancel();
              }
            });
            return;
          //}
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 취소 버튼 이벤트
       *
       * @param
       * @return
       */
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
    } ]);

webapp.controller('SrchCustModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'gAlert', 'gConfirm', 'postApi', '$rootScope', 'modalFactory',
    function SrchCustModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, gAlert, gConfirm, postApi, $rootScope, modalFactory) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.columnMap = {};

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.srchcustomer'; // 그룹고객 작업 테이블명
      var LIST_SQL = 'Campaign2.getSrchCustomerList';
      var LIST_CNT_SQL = 'Campaign2.getSrchCustomerListCnt';
      var ADD_GRPCUST_SQL = 'Campaign2.insertGroupcustomer';
      var ADD_ALL_GRPCUST_SQL = 'Campaign2.insertGroupcustomerSrchAll';
  
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        userkey : '',
        tableNm : KEY_TABLE_NM,
      };
  
      vm.currentPage = vm.srch.page;

      (function SrchCustModalCtrl() {
        vm.GrpId = toModalData.GrpId;
        getList();
        setInitData();
      })();


      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL;

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = result.body.docs[0];
          }
        });
      }

    /**
     * 그룹고객 목록 화면 구성
     *
     * @param
     * @return
     */
    function setResponsive() {
      var columns = [];
      var o = {};

      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};

        column.name = item.ColumnPhysicalNm; // 물리 컬럼명
        column.title = item.ColumnLogicalNm; // 논리 컬럼명

        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }

        if (item.ColumnPhysicalDataType == "40") {
          // 날짜형 데이터 처리
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }

        index++;
        columns.push(column);
      });
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(item) {
      $uibModalInstance.close(item);
    }
    
    /**
     * 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();
    }

    /* 사용자검색 */
    function srchUserModal() {

      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.ManagerNm = res.UserNm;
        vm.srch.ManagerId = res.UserId;
      }, function(cancelData) {
        //
      });
    }
    
    /* 사용자검색- 지우기 */
    function eraseUser() {
      vm.srch.ManagerNm = '';
      vm.srch.ManagerId = '';
    }

    /**
     * 초기 데이터 설정
     * @param
     * @return
     */
    function setInitData() {
      // 목록 체크박스 로직 설정
      vm.chkHead = false;
      $scope.chkRowChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          if (!vm.lists[i].isChecked) {
            vm.chkHead = false;
            return;
          }
        }
        vm.chkHead = true;
      };

      $scope.chkHeadChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          vm.lists[i].chkRow = vm.chkHead;
        }
      };

    }

      /**
     * 그룹고객 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {

      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      //getSearch();
      getList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    function setSortDirect(sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    /**
     * 그룹고객 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      //var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});

      getList();
    }

    /**
     * 그룹고객 목록 당 조회 건수 변경
     * @param
     * @return
     */
    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      //getSearch();
      getList();
    }
    
    
    function addGrpcust(_type) {
      var data = angular.copy(vm.srch);

      data.GrpId = vm.GrpId;
      data.srchTenantId = $rootScope.gVariable.srchTenantId 
      
      if(_type){
        data.mapCode = ADD_ALL_GRPCUST_SQL;
      }else{
        data.mapCode = ADD_GRPCUST_SQL;
        data.lists = [];
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            data.lists.push(vm.lists[i].KeyId);
          }
        }
      }

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn : '',
            fn : function() {
              ok();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> addGrpcust()");
        console.table(error);
      });
    }


    vm.pageChanged = pageChanged;
    vm.srchUserModal = srchUserModal;
    vm.eraseUser = eraseUser;
    vm.setSortColumn = setSortColumn;           // 정렬 설정
    vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
    vm.setPageChanged = setPageChanged;
    vm.setChangeViewSize = setChangeViewSize;
    vm.addGrpcust = addGrpcust;

  } ]);

webapp.controller('surveyTargetEdit2Ctrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$rootScope', 'modalFactory', '$mdUtil', '$stateParams','$http', 'gAlert', 'gConfirm','$filter' ,
  function surveyTargetEdit2Ctrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $rootScope, modalFactory, $mdUtil,$stateParams,$http, gAlert, gConfirm, $filter) {

    var vm = this;
    vm.dataloader = false;
    vm.srch = {};
    vm.maxGrpId = 0;
    vm.lists = [];
    vm.saveYn = true;
    vm.data = {
        'SendType' : (toModalData.SendType == undefined ? 'SMS' : toModalData.SendType)
      ,'GrpId': (toModalData.GrpId == undefined ? '' : toModalData.GrpId)
      ,'SvyTgtList' : (toModalData.SvyTgtList == undefined ? [] : toModalData.SvyTgtList)
    };

    vm.grpcustLists = vm.data.SvyTgtList;
    vm.totalItems = vm.grpcustLists.length;


    var o = {
        breakpoints : ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]
        ,type : []
        ,style : []
      }

      var columns = [{name: "CustNm", title: "이름"},{name: "Mobile", title: "휴대폰"},{name: "Email", title: "이메일"},{name: "ResultStatusConv", title: "발송상태"},{name: "RespStatusConv", title: "응답상태"}];
      vm.grpcustListColumns = [{ColumnPhysicalNm: "CustNm", ColumnLogicalNm: "이름"},{ColumnPhysicalNm: "Mobile", ColumnLogicalNm: "휴대폰"},{ColumnPhysicalNm: "Email", ColumnLogicalNm: "이메일"},{ColumnPhysicalNm: "ResultStatusConv", ColumnLogicalNm: "발송상태"},{ColumnPhysicalNm: "RespStatusConv", ColumnLogicalNm: "응답상태"}];

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

    $scope.toggleLeft = buildToggler('left');
    $scope.toggleRight = buildToggler('right');

    // 함수 선언
    vm.resetList = resetList;
    vm.deleteGrpcust = deleteGrpcust;

    vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
    vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
    vm.doUpload = doUpload;
    vm.excelform = excelform;                   //엑셀업로드양식 다운
    vm.cancel = cancel;
    vm.ok = ok;
    vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드
    vm.inputDirect = inputDirect;
    vm.setSortDirect = setSortDirect;
    vm.setSortColumn = setSortColumn;

    // --------------------------------------------------------- 그룹고객 관련 소스 ---------------------------------------------------------
    // 관련 테이블 정의
    var EXCEL_TITLE = '그룹고객목록'; // 그룹고객 엑셀파일 이름
    var EXCEL_FORM_TITLE = '일괄업로드 양식';

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: 10, // 페이지당 조회건수
        sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: 'T.RegDate' // 정렬컬럼명
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.currentPage = 1;
    vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    vm.anchor = "";
    angular.copy(vm.srch, vm.srchList);

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    /**
     * TODO : 전제 목록을 넘겨줘야. 삭제된것을 처리할수 있다.
     */
    function ok() {
      var chkList = [];
      angular.forEach(vm.viewList, function(item){
        if (item.chkRow) {
          chkList.push(item);
          chkList[item.SvyTgtId] = "Y";
        }
      });

      $uibModalInstance.close({
        'list' : vm.grpcustLists,
        'chkList' : chkList
      });
    }


    /**
     * 고객 삭제
     *
     * @param
     * @return
     */
    function deleteGrpcust(type) {
      gConfirm('', '발송 대상에서 제외하시겠습니까?', {
        btn : '',
        fn : function() {
          deleteGrpcustAction(type);
        }
      }, {
        btn : '',
        fn : function() {
          //ignore
        }
      });
    }

    /**
     * 고객 삭제 처리
     */
    function deleteGrpcustAction(type) {
      //삭제데이터
      vm.delData = [];

      if (type == "") {
        angular.forEach(vm.viewList, function(item){
          if (item.chkRow) {
            vm.delData.push(item);
          }
        });

        angular.forEach(vm.delData, function(item){
          vm.grpcustLists.splice(vm.grpcustLists.indexOf(item),1);
        });

      } else if (type == "ALL") {
        vm.grpcustLists = [];
      }

      setChangeViewSize();
    }

    /**
     * 그룹고객 목록 화면 구성
     * @param
     * @return
     */
    function getGrpcustList() {

      vm.totalItems = vm.grpcustLists.length;

      var startNum = ((vm.currentPage - 1) * vm.viewSize);
      var endNum = (vm.currentPage * vm.viewSize);

      vm.viewList = [];
      for(var i = 0; i < vm.grpcustLists.length; i++){
        if(i >= startNum && i < endNum){
          vm.viewList.push(vm.grpcustLists[i]);
        }
      }

      setSortColumn("", true);
    }

    /**
     * 그룹고객 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      getGrpcustList();
    }

    /**
     * 그룹고객 목록 당 조회 건수 변경
     * @param
     * @return
     */
    function setChangeViewSize() {

      vm.chkHead = false;
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize =  vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      getGrpcustList();
    }

    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildToggler(navID) {
      var debounceFn = $mdUtil.debounce(function() {
        $mdSidenav(navID).toggle().then(function() {
          console.debug("toggle " + navID + " is done");
        });
      }, 200);
      return debounceFn;
    }

    $scope.init = function() {
      // check if there is query in url
      // and fire search in case its value is not empty
    };

    // stops the interval
    $scope.$on("$destroy", function() {
    });

    $scope.$on('broadcastSetChangeTenantID', function(event, data) {
      resetList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    // 목록 체크박스 로직 설정
    vm.chkHead = false;
    $scope.chkRowChg = function () {
      for (var i = 0; i < vm.viewList.length; i++) {
        if (!vm.viewList[i].isChecked) {
          vm.chkHead = false;
          return;
        }
      }
      vm.chkHead = true;
    };

    $scope.chkHeadChg = function () {
      for (var i = 0; i < vm.viewList.length; i++) {
        vm.viewList[i].chkRow = vm.chkHead;
      }
    };

    function resetList() {
      getTreeList();
    }


    /*
      * 일괄 업로드
      * - DB입력하지 않고 목록만 가져옴.
      */
    function doUpload()  {
      vm.dataloader = true;

      var file = $("input[name=excelFile]")[0].files[0];
      var formData = new FormData();
      var uploadUrl = "excelUpload/WjmCampaign.updateSurveyTargetExcel/action.json";

      var ext = "";

      if (file != undefined) {
        ext = file.name.split('.').pop().toLowerCase();
      }

      if (file == undefined || $.inArray(ext, ['xlsx']) == -1){
        vm.dataloader = false;
        gAlert('', 'xlsx 형식의 파일을 선택하세요.');
        return;
      }

      formData.append("mFile",file);
      formData.append("ext",ext);
      formData.append("GrpId", vm.data.GrpId);
      formData.append("Manager",vm.data.Manager);
      formData.append("SESSION_USERID", $rootScope.gVariable.UserId);
      formData.append("SESSION_TENANTID", $rootScope.gVariable.TenantId);

      $http({
        url: uploadUrl,
        method: "POST",
        data: formData,
        transformRequest: angular.identity,
        headers: {'Content-type': undefined}
      }).success(function (data, status, headers, config) {
        vm.dataloader = false;

        angular.forEach(data.responseVO.body.docs[0].dataList, function (item) {
          var lists = {};
          lists.CustNm =  ( ! isNullOrEmpty(item.column_0) && item.column_0 != "false") ? item.column_0.trim() : null;
          lists.Mobile = ( ! isNullOrEmpty(item.column_1) && item.column_1 != "false") ? item.column_1.trim() : null;
          lists.Email = ( ! isNullOrEmpty(item.column_2) && item.column_2 != "false") ? item.column_2.trim() : null;

          if( ! isNullOrEmpty(lists.Mobile) && lists.Mobile.substr(0,1) != "0") lists.Mobile = "0" + lists.Mobile;

          // 발송 매체에 따라 휴대폰, 이메일 정보 체크하여 목록 생성
          if((vm.data.SendType == "SMS" &&  ! isNullOrEmpty(lists.Mobile))
            || (vm.data.SendType == "EMAIL" && ! isNullOrEmpty(lists.Email)) ){
            lists.ResultStatus = "N";
            lists.ResultStatusConv = "발송대기";
            vm.grpcustLists.unshift(lists);
          }
        });

        setChangeViewSize();

      }).error(function (data, status, headers, config) {
        vm.dataloader = false;
        gAlert('', '오류가 발생했습니다.');
      });
      vm.dataloader = false;
    }


    /**
       * Excel 업로드 양식 다운로드
       * @param
       * @return
    */
    function excelform () {
      var a = document.createElement("a");
      document.body.appendChild(a);

      $scope.jsonToExport = [];
      $scope.fileName = EXCEL_FORM_TITLE;
      $scope.exportData = [];

      $scope.exportData.push(['이름','휴대폰','이메일'],
        ['나고객','010-1234-5678','test@naver.com']);
      $rootScope.excelDown($scope.exportData,$scope.fileName);

    };

    vm.topItem = null;

    /**
     * 고객추가
     *
     * @param {string}
     * @return {boolean}
     */
    vm.GroupCustEditModal = function (_idx, SvyTgtId) {
      vm.editIdx = null;
      var ctrl;
      var paramData = {};
      var modalInstance;

      if (_idx != undefined){
        vm.editIdx = _idx;
        paramData = angular.copy(vm.viewList[vm.editIdx]);
      }
      paramData.SendType = vm.data.SendType;

      //console.error("idx",_idx);
      //console.error("id",SvyTgtId);

      if (SvyTgtId != undefined) {
        paramData.keyId = SvyTgtId;
        ctrl = 'TargetEditModalCtrl as vc';
        modalInstance = modalFactory.open("md", "components/modal/survey/wjm-target-edit-modal.html", ctrl, paramData);
      } else {
        ctrl = 'GroupEditModal2Ctrl as vc';
        modalInstance = modalFactory.open("md", "components/modal/survey/wjm-group-edit-modal2.html", ctrl, paramData);
      }
      modalInstance.result.then(
        function (okData) {
          if (okData) {
            if (vm.editIdx != undefined) {
              vm.viewList[vm.editIdx] = okData;
              vm.grpcustLists[((vm.currentPage - 1) * vm.viewSize) + vm.editIdx] = okData;
            } else {
              vm.grpcustLists.unshift(okData);
              getGrpcustList();
            }
          }
        },
        function (cancelData) {
          //ignore
        }
      );
    };

    /**
     * 거부/ 오류 삭제
     */
    vm.deleteErrorCust = function () {
      angular.forEach(vm.grpcustLists, function (item) {
        if((item.ResultStatus == 'D' || item.ResultStatus == 'E') && !isNullOrEmpty(item.SvyTgtId)){
          vm.grpcustLists.splice(vm.grpcustLists.indexOf(item),1);
        }
      });
      setChangeViewSize();
    }

    // 목록 엑셀 다운로드
    function getExcelFile() {
      if (vm.grpcustLists.length == undefined || vm.grpcustLists.length == 0) {
        gAlert("", "데이터가 없습니다.");
        return;
      }

      vm.columnMap = ['CustNm', 'Email', 'Mobile', 'ResultStatusConv'];
      $scope.jsonToExport = [];
      $scope.fileName = "발송대상자목록";
      $scope.exportData = [];
      $scope.exportData.push(vm.columnMap);

      angular.forEach(vm.grpcustLists, function (value) {
        var obj = [];
        angular.forEach(vm.columnMap, function (item) {
          obj.push(value[item]);
        });
        $scope.exportData.push(obj);
      });

      $rootScope.excelDown($scope.exportData,$scope.fileName);
    }

    function inputDirect() {
      var ctrl = 'GroupEditModal3Ctrl as vc';
      var paramData = {SendType : vm.data.SendType};

      var modalInstance = modalFactory.open("md", "components/modal/survey/wjm-group-edit-modal3.html", ctrl, paramData);
      modalInstance.result.then(
        function (okData) {
          if (okData) {
            angular.forEach(okData, function(item) {
              var json = {SendType:vm.data.SendType, CustNm:item.name, Mobile:item.mobile, Email:item.email, ResultStatus:'N', ResultStatusConv:'발송대기'};
              vm.grpcustLists.unshift(json);
              getGrpcustList();
            });
          }
        },
        function (cancelData) {
          //ignore
        }
      );
    }

    /**
     * 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    function setSortDirect(sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isChgPage) {
      // 정렬순서(오름차순, 내림차순) 설정
      if (!isChgPage) {
        if (vm.srch.sortColumn != sortColumn) vm.srch.sortDirect = "ASC";
        else vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.srch.sortColumn = sortColumn;
      }

      switch (vm.srch.sortColumn) {
        case "CustNm":
          if (vm.srch.sortDirect == "ASC") vm.viewList.sort(function (a, b) { return (a.CustNm > b.CustNm) ? 1 : ((b.CustNm > a.CustNm) ? -1 : 0) });
          else vm.viewList.sort(function (a, b) { return (a.CustNm < b.CustNm) ? 1 : ((b.CustNm < a.CustNm) ? -1 : 0) });
          break;
        case "Mobile":
          if (vm.srch.sortDirect == "ASC") vm.viewList.sort(function (a, b) { return (a.Mobile > b.Mobile) ? 1 : ((b.Mobile > a.Mobile) ? -1 : 0) });
          else vm.viewList.sort(function (a, b) { return (a.Mobile < b.Mobile) ? 1 : ((b.Mobile < a.Mobile) ? -1 : 0) });
          break;
        case "Email":
          if (vm.srch.sortDirect == "ASC") vm.viewList.sort(function (a, b) { return (a.Email > b.Email) ? 1 : ((b.Email > a.Email) ? -1 : 0) });
          else vm.viewList.sort(function (a, b) { return (a.Email < b.Email) ? 1 : ((b.Email < a.Email) ? -1 : 0) });
          break;
        case "ResultStatusConv":
          if (vm.srch.sortDirect == "ASC") vm.viewList.sort(function (a, b) { return (a.ResultStatusConv > b.ResultStatusConv) ? 1 : ((b.ResultStatusConv > a.ResultStatusConv) ? -1 : 0) });
          else vm.viewList.sort(function (a, b) { return (a.ResultStatusConv < b.ResultStatusConv) ? 1 : ((b.ResultStatusConv < a.ResultStatusConv) ? -1 : 0) });
          break;
        case "RespStatusConv":
          if (vm.srch.sortDirect == "ASC") vm.viewList.sort(function (a, b) { return (a.RespStatusConv > b.RespStatusConv) ? 1 : ((b.RespStatusConv > a.RespStatusConv) ? -1 : 0) });
          else vm.viewList.sort(function (a, b) { return (a.RespStatusConv < b.RespStatusConv) ? 1 : ((b.RespStatusConv < a.RespStatusConv) ? -1 : 0) });
          break;
        default: break;
      }
    }

    vm.chkSendDate = function(){
      if(isNullOrEmpty(vm.SendDate1) || isNullOrEmpty(vm.SendDate2)){
        alert("발송기간을 입력하세요.");
        return;
      }

      var list = $filter('filter')(vm.grpcustLists, function(item) {
        return item.SendDate >= vm.SendDate1 && item.SendDate <= vm.SendDate2;
      });
      console.error(list);
      vm.grpcustLists = list;
      setChangeViewSize();
    };

    vm.initList = function(){
      if(confirm("목록을 초기 상태로 되돌리시겠습니까?")){
        vm.BeginDate = "";
        vm.EndDate = "";
        vm.grpcustLists = (toModalData.SvyTgtList == undefined ? [] : toModalData.SvyTgtList);
        getGrpcustList();
      }
    }

    getGrpcustList();
  }
]);

webapp.controller('TreeModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm', '$translate', '$timeout',
    function TreeModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm, $translate, $timeout ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.columnMap = {};
      var tree;
      $scope.my_tree = tree = {};
      vm.srch = {};
      (function TreeModalCtrl() {
        vm.getRequestParams = getRequestParams;
        getTreeList();
      })();

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          formType: toModalData.formType,
        }
        vm.filter = req;
        return req;
      }

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        // 로케이션관리 select 검색실행함
        var data = vm.srch;

        data.mapCode = 'Campaign.getGroupList';
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length == 0) {
              return;
            }

            // select한 datatable 바인딩
            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            refreshTree();

            // 트리 펼치기
            $timeout(function() {
              return tree.expand_init();
            }, 1);

          }
        }, function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = [];

        // for문으로 다시 json 구조로 변환함.
        angular.forEach(vm.lists, function(item) {
          // 객체 생성
          var data = {};

          data.label = $translate.instant(item.GrpNm);
          data.guid = item.GrpId;
          data.parent = item.ParentGrpId == undefined || item.ParentGrpId == 0 ? null : item.ParentGrpId;
          data.classes = [];
          //data.classes.push(item.TenantId == '0' ? '' : 'color-red');

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (item.GrpId > vm.maxGrpId)
            vm.maxGrpId = item.GrpId;
        });

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
  //        $timeout(function() {
  //          return tree.expand_all();
  //        }, 1);

      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

    // 계층형 json 부모/자식 구분하여 구조 변환
    function insert(obj, item) {
      var parent = item.parent; // 부모값
      var map = obj.map;
      map[item.guid] = item; // 아이템 구성함

      if (parent === null)
        obj.res.push(item); // 부모값 생성
      else {
        var parentItem = map[parent];
        // 자식값 생성
        if (parentItem != null) {
          if (parentItem.hasOwnProperty("children"))
            parentItem.children.push(item);
          else
            parentItem.children = [ item ];
        }
      }

      return obj;
    }

    // guid, parent 제외한 계층형 json 구조 변환하기
    function traverse(jsonObj) {

      for (var i = 0; i < jsonObj.length; i++) {
        if (jsonObj[i].children == null) {
        } else {
          traverse(jsonObj[i].children);
        }

        // label, children 만 추가함
        var newItem = {
          "label" : jsonObj[i].label,
          "data" : jsonObj[i].guid,
          "children" : jsonObj[i].children,
          "classes" : jsonObj[i].classes,
        }
        jsonObj[i] = newItem;
      }
    }



      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        var branch = tree.get_selected_branch();

        var data = {GrpNm : branch.label, GrpId : branch.data};
        $uibModalInstance.close(data);
      }

    } ]);

webapp.controller('ContentsModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert',
    function ContentsModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;

      vm.Contents = toModalData.Contents;

      (function ContentsModalCtrl() {

      })();

      function ok() {
        $uibModalInstance.close();
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

    } ]);

webapp.controller('CareTktModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function CareTktModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    ProductNm : '',
        ProductId : '',
        viewSize : 10,
      };

      vm.selectedTenantId = toModalData.TenantId;

      (function CareTktModalCtrl() {
        getList();
      })();

      function getList() {
        getCnt()
        var data = {
          mapCode: 'Caretkt.getCareTktListModal',
          CareTktNm : vm.srch.CareTktNm,
          Remark : vm.srch.Remark,
          page : vm.srch.page,
          userkey : '',
        };

        data.mapCode= 'Caretkt.getCareTktListModal';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.careTktlists = result.body.docs;
          }
        });
      }

      function getCnt() {
        var data = {
          mapCode: 'Caretkt.getCareTktListModalCnt',
          CareTktNm : vm.srch.CareTktNm,
          Remark : vm.srch.Remark,
          userkey : '',
        };

        data.mapCode= 'Caretkt.getCareTktListModalCnt';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = result.body.docs[0].totalItems;
          }
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }
      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();

      }

      vm.pageChanged = pageChanged;
    } ]);

webapp.controller('CvsReservInfoModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter',
    function CvsReservInfoModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.CustId = toModalData.custId;
      vm.keyId = toModalData.keyId;
      vm.type = toModalData.type;
      vm.MobileYn = toModalData.MobileYn;
      if(toModalData.MobileYn == undefined) vm.MobileYn = false;

      //function
      vm.setData = setData;
      vm.getData = getData;

      var VIEW_SQL = 'CvsReserv.getReservDetail'; // 조회 SQL
      var UPDATE_SQL = 'CvsReserv.updateReserv';     // 수정 SQL
      var INSERT_SQL = 'CvsReserv.insertReserv';     // 수정 SQL
      var DEL_SQL = 'CvsReserv.deleteReserv';     // 수정 SQL
      var CUSTMER_SQL = 'CvsReserv.getReservCustomer'; // 고객정보 SQL
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'cvsreservhist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column


      var RES_TYPE_DEL = 'D';
      var RES_TYPE_EDIT = 'E';
      var RES_TYPE_ADD = 'A';

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      vm.srchDetail.keyId = vm.keyId;
      vm.srchDetail.tableNm = KEY_TABLE_NM;

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: vm.keyId, // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      // 예약시간 - 분
      vm.ReservMinCodeList = ['00','10','20','30','40','50'];

      (function CvsReservInfoModalCtrl() {

      })();

      function ok() {
        var title = vm.data.ReservHour +':'+vm.data.ReservMin+'/'+vm.data.CustNm+'/';

        if (!isNullOrEmpty(vm.data.CareTktNm)) {
          title = title + vm.data.CareTktNm+'/';
        }
        if (!isNullOrEmpty(vm.data.MngCnt)) {
          title = title + vm.data.MngCnt+'회차/';
        }
        title = title + vm.data.ManagerNm;

        var okData = {
          res : vm.res,
          reservDate : vm.data.ReservDate,
          keyId : vm.data.keyId,
          title : title
        }
        $uibModalInstance.close(okData);
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {

        vm.srchDetail.viewColumns = {};

        if(vm.type ==='add') { // 추가인 경우

          var data = vm.srchDetail;
          data.CustId = vm.CustId;
          data.mapCode = CUSTMER_SQL;

          postApi.select(data, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              // 데이터 조회 성공
              if (result.body.desc.length > 0) {
                // 사용자정의 컬럼 설정
                vm.allColumns = result.body.desc;
                angular.forEach(vm.allColumns, function (item) {
                  vm.columnMap[item.ColumnPhysicalNm] = item;
                });
              }

              if (result.body.docs.length > 0) {
                // 조회 데이터 설정
                vm.data = result.body.docs[0];


              } else {
                vm.data = {
                  CustId : '',
                  CustNm : '',
                  Manager : '',
                  ManagerNm : ''
                }
              }
              // 추가시 고객정보 유무를 제외한 초기 셋팅값
              vm.data.keyId = '';
              vm.chkDate = moment(toModalData.chkDate).toDate();

              vm.data.ReservDate = moment(vm.chkDate).format('YYYY-MM-DD');
              vm.data.ReservReason = '';
              vm.data.CareTktId = '';
              vm.data.CareTktNm = '';

          } else {
              console.error("Error> getData()");

              if (!isNullOrEmpty(result.body.docs)) {
                gAlert('', result.body.docs[0].errMessage);
              }
            }

          }, function (error) {
            console.error("Error> getData()");
            console.table(error);
          });

        } else if(vm.type === 'edit') { // edit인 경우 데이터 조회
          var data = vm.srchDetail;
          data.mapCode = VIEW_SQL;

          postApi.select(data, function (result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              // 데이터 조회 성공
              if (result.body.desc.length > 0) {
                // 사용자정의 컬럼 설정
                vm.allColumns = result.body.desc;
                angular.forEach(vm.allColumns, function (item) {
                  vm.columnMap[item.ColumnPhysicalNm] = item;
                });
              }

              if (result.body.docs.length > 0) {
                // 조회 데이터 설정

                vm.data = result.body.docs[0];
                vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

                //Date형식 처리
                vm.chkDate = moment(vm.data.ReservDate).toDate();
                vm.data.ReservHour = moment(vm.data.ReservDate).format('HH');
                vm.data.ReservMin = moment(vm.data.ReservDate).format('mm');
                vm.data.ReservDate = moment(vm.chkDate).format('YYYY-MM-DD');
              }
            } else {
              console.error("Error> getData()");

              if (!isNullOrEmpty(result.body.docs)) {
                gAlert('', result.body.docs[0].errMessage);
              }
            }

          }, function (error) {
            console.error("Error> getData()");
            console.table(error);
          });
        }
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {

        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.CustNm)) {
          errMsg = errMsg + '- 고객명을 선택하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ManagerNm)) {
          errMsg = errMsg + '- 관리사를 선택하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ReservDate)) {
          errMsg = errMsg + '- 예약일자를 선택하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ReservHour) || isNullOrEmpty(vm.data.ReservMin)) {
          errMsg = errMsg + '- 예약시간을 선택하세요.<br/>';
        }
        if (isNullOrEmpty(vm.data.ReservReason)) {
          errMsg = errMsg + '- 예약사유를 선택하세요.<br/>';
        }


        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }


        // #endregion 필수항목 체크

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.userkey = $rootScope.gVariable.userkey;       // 사용자 식별 키
        var data = angular.copy(vm.data); // 사용자 입력 데이터
        var tmpDate = moment(vm.data.ReservDate+' '+vm.data.ReservHour+':'+vm.data.ReservMin+':00').toDate();
        data.ReservDate = $filter('localToUtc')(tmpDate);
        // 수정

        console.log(data.ReservDate);

        if(vm.type ==='add') {
          data.mapCode = INSERT_SQL;
          vm.res = RES_TYPE_ADD;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          } ,function (error) {
            console.error("Error> setData()");
            console.table(error);
          });

        } else if(vm.type ==='edit') {

          data.mapCode = UPDATE_SQL;
          data.RelateDataId = data.keyId;
          vm.res = RES_TYPE_EDIT;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          } ,function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });

        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
            // KeyId 조회
            vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;

            if(isNullOrEmpty(vm.data.keyId)) {
              vm.data.keyId = result.body.docs[0].RelateDataId != null ? result.body.docs[0].RelateDataId : '';
            }
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                sendSMS();
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      function sendSMS() {

        var data = angular.copy(vm.data);

        data.UserId = data.Manager;
        data.SendMessage = vm.data.ReservDate+" "+vm.data.ReservHour +':'+vm.data.ReservMin+" "+vm.data.CustNm+"님 예약되었습니다.";
        data.mapCode = "Campaign.insertReservSMSHist";

        postApi.insert(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            ok();
          }
        } ,function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      }

      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function setDelData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn: '',
          fn: function () {
            // 데이터 삭제
            setDelDataAction();
          }
        }, {
          btn: '',
          fn: function () {
            // 취소
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function setDelDataAction() {
        if (vm.data == null) {
          // 삭제할 데이터 미 존재
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 첨부파일 삭제
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function (item) {
          var obj = {
            id: item.id,
            fileName: item.fileName,
            size: item.size,
            fileKey: item.fileKey,
            typeId: 'file',
            path: item.path,
            delState: 'delete'
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        vm.data.tableNm = KEY_TABLE_NM;

        var data = vm.data;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn: '',
              fn: function () {
                // 삭제 성공
                vm.res = RES_TYPE_DEL;
                ok();
              }
            });

          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      // #region 사용자 팝업 호출

      /**
       * 사용자 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */

      function srchUserModal () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId, MobileYn : vm.MobileYn };
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.ManagerNm = res.UserNm;
          vm.data.Manager = res.UserId;
        }, function(cancelData) {
        });
      };

      /* 사용자검색- 지우기 */
      function eraseUser() {
        vm.data.ManagerNm = '';
        vm.data.Manager = '';
      }

      // #region 고객 팝업 호출

      /**
       * 고객 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */

      function srchCustomerModal () {
        var ctrl = 'CustomerModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('lg', 'components/modal/customer/customer-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {
          vm.data.CustNm = res.CustNm;
          vm.data.CustId = res.CustId;
        }, function(cancelData) {
        });
      };

      /* 고객검색- 지우기 */
      function eraseCustomer() {
        vm.data.CustNm = '';
        vm.data.CustId = '';
      }

      // #region 고객 팝업 호출

      /**
       * 관리권 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */

      function srchCareTktModal () {
        var ctrl = 'CareTktModalCtrl as modalCtrl';
        var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

        var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
        modalInstance.result.then(function(res) {

          vm.data.CareTktNm = res.CareTktNm;
          vm.data.CareTktId = res.KeyId;
          vm.data.TotMngCnt = res.MngCnt;

        }, function(cancelData) {
        });
      };

      /* 관리권검색- 지우기 */
      function eraseCareTkt() {
        vm.data.CareTktNm = '';
        vm.data.CareTktId = '';
        vm.data.TotMngCnt = '';
      }

      getData();

      //함수 호출
      vm.srchUserModal = srchUserModal;
      vm.eraseUser = eraseUser;
      vm.srchCustomerModal = srchCustomerModal;
      vm.eraseCustomer = eraseCustomer;
      vm.srchCareTktModal = srchCareTktModal;
      vm.eraseCareTkt = eraseCareTkt;
      vm.setDelData = setDelData;
    } ]);

webapp.controller('DataGroupActionModalCtrl', [ '$window', '$scope', '$rootScope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$filter',
    function DataGroupActionModalCtrl($window, $scope, $rootScope, $uibModalInstance, toModalData, CONSTANT, postApi, $filter) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.select = select;
      vm.getDatagroupList = getDatagroupList;
      vm.selectedLi = {};
      console.log('toModalData=', toModalData);

      (function DataGroupActionModalCtrl() {
        // search
        // pagination
        vm.GroupAndAction = $rootScope.gVariable.dataGroupId + "." + $rootScope.gVariable.dataActionId;
        getDatagroupList();
      })();

      function getDatagroupList() {
        var data = {};
        data.mapCode = 'MaDatagroup.getDatagroupAndActionList';

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.dagrouplists = result.body.docs;
          }
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        if (toModalData.UpdateDefault != null && toModalData.UpdateDefault == false) {
          $uibModalInstance.close(vm.selectedLi);
          return;
        }
        var daId = vm.GroupAndAction.split('.');
        var data = {};
        data.DatagroupId = daId[0];
        data.ActionId = daId[1];
        data.mapCode = 'MaDatagroup.updateDefaultDatagroupActionDetail';

        postApi.update(data, function (result) {
          vm.dataloader = false;
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            angular.forEach(vm.dagrouplists, function(item) {
              if (data.DatagroupId == item.Code) {
                data.DatagroupNm = item.DataNm;
              }

              if (data.ActionId == item.Code) {
                data.ActionNm = item.DataNm + ' (' + $filter('utcToLocal')(item.BeginDate,'yyyy-MM-dd') + '~' + $filter('utcToLocal')(item.EndDate,'yyyy-MM-dd') + ')';
              }
            });
            $uibModalInstance.close(data);
          }
        });
      }

      function select(li) {
        vm.selectedLi = li;
        console.log('vm.selectedLi=', vm.selectedLi);
      }

    } ]);

webapp.controller('DataGroupModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function DataGroupModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.select = select;
      vm.getShopList = getShopList;
      vm.selectedLi = {};
      console.log('toModalData=', toModalData);

      (function DataGroupModalCtrl() {
        // search
        vm.searchValue = '';
        vm.selectPeriod = 'all';
        vm.startDate = '';
        vm.endDate = '';
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        // 검색 선택 옵션
        vm.searchFieldTypeList = [ {
          optionId : 'ActionNm',
          optionName : '이름'
        } ];
        vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.ShopList = [];
        getShopList();
      })();
      function changeViewSize() {
        getShopList();
      }
      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          searchFieldType : vm.searchFieldType,
          MLShopNm : vm.searchValue,
          selectPeriod : vm.selectPeriod
        }
        vm.filter = req;
        return req;
      }

      function getShopList() {
        getShopListCnt();

        var data = vm.getRequestParams();
        data.mapCode = 'MaDatagroup.getDatagroupList';

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.ShopList = result.body.docs;
          }
        });
      }

      function getShopListCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MaDatagroup.getDatagroupCount';

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalCount = result.body.docs[0];
          }
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        if (toModalData.UpdateDefault != null && toModalData.UpdateDefault == false) {
          $uibModalInstance.close(vm.selectedLi);
          return;
        }
        var data = angular.copy(vm.selectedLi);
        data.mapCode = 'MaDatagroup.updateDefaultDatagroupDetail';

        postApi.update(data, function (result) {
          vm.dataloader = false;
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            $uibModalInstance.close(vm.selectedLi);
          }
        });
      }

      function select(li) {
        vm.selectedLi = li;
        console.log('vm.selectedLi=', vm.selectedLi);
      }

    } ]);

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.customer:counselhist-modal-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $uibModalInstance - uibModalInstance object
   * @param {object} toModalData - toModalData object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} modalFactory - Modal Popup object
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   * @description Controller of the 고객정보
   */
  webapp.controller('CounselHistModalCtrl', ['$window', '$rootScope', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'StaticVariable', 'postApi', 'gAlert', 'modalFactory', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',
    function CounselHistModalCtrl($window, $rootScope, $scope, $uibModalInstance, toModalData, CONSTANT, StaticVariable, postApi, gAlert, modalFactory, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Customer.insertCounselHist';  // 등록 SQL
      var UPDATE_SQL = 'Customer.updateCounselHist';  // 수정 SQL
      var VIEW_SQL = 'Customer.getCounselHistDetail'; // 조회 SQL
      var DELETE_SQL = 'Customer.deleteCounselHist';  // 삭제 SQL
      var UPDATE_ATTACHMENT_SQL = 'Customer.updateCounselHistAttachmet';  // 첨부파일 연결 SQL

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'counselhist'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // #endregion 상수 정의

      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.vaultCounsel = null; // 고객관리 첨부파일 컴포넌트

      // 부모 창에서 전달받은 Key값 정의
      vm.custId = toModalData.custId;
      vm.keyId = toModalData.keyId;

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};

      vm.srchDetail.uploadFileList = []; // 첨부파일 목록
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      vm.srchDetail.keyId = vm.keyId;
      vm.srchDetail.tableNm = KEY_TABLE_NM;

      vm.uploadFileListCounsel = [];  // 상담이력 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: vm.keyId, // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      /**
       * 생성자
       * @param
       * @return
       */
      (function CounselHistModalCtrl() {

      })();


      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;

              vm.uploadFileListCounsel.push(obj);

            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 이후 저장을 호출해야 함
          $timeout(setData, 1);
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      // #endregion 첨부파일 Callback


      /**
       * 저장
       * @param
       * @return
       */
      function ok() {

        var okData = {
          keyId: vm.data.keyId
        };

        $uibModalInstance.close(okData);
      }

      /**
       * 취소
       * @param
       * @return
       */
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        // 첨부파일 컴포넌트 초기화
        vm.showUploader = enableUploadComponent();
        initVaultComponent('vaultCounsel', vm.onFileCallback);

        // 초기 데이터 설정
        setInitData();

        if (isNullOrEmpty(vm.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }

        vm.srchDetail.viewColumns = {}; // 조회 컬럼
        var data = vm.srchDetail;

        data.custId = vm.custId;
        data.mapCode = UPDATE_ATTACHMENT_SQL;

        // 첨부파일 연결
        // 신규등록에서 상담>첨부파일 등록시 고객>관련사진으로 연결되므로 상담>첨부파일로 재 연결 처리
        postApi.update(data, function (result) {
          // Do Nothing
        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
          gAlert('', result.responseVO.body.docs[0].errMessage);
        });

        data.mapCode = VIEW_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              // 날짜 데이터 설정
              if (!isNullOrEmpty(vm.data.CounselDt))
                vm.CounselDt = moment(vm.data.CounselDt).toDate();

              // 첨부파일 목록 설정
              var uploadFileListCounsel = [];

              angular.forEach(vm.data.uploadFileList, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  grpId: item.GrpId,
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt
                };

                vm.uploadFileListCounsel.push(obj);
              });

              //angular.copy(uploadFileList, vm.uploadFileList);
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");


          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });

      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {

        // 날짜 컬럼 초기값
        vm.CounselDt = new moment().toDate();

        // 신규 등록
        if (isNullOrEmpty(vm.data.keyId)) {
          // 초기 데이터 설정
        }

      }

      /**
       * 첨부파일 업로드
       * @param
       * @return
       */
      vm.uploadFile = function () {
        if (vm.vault != null && vm.vault.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vault);
        } else {
          // 데이터 저장
          setData();
        }
      };

      /**
       * 상담 첨부파일 업로드
       * @param
       * @return
       */
      function uploadFileCounsel() {

        // #region 입력값 설정
        // 날짜 데이터 설정
        if (isValidDate(vm.CounselDt))
          vm.data.CounselDt = moment(vm.CounselDt).format('YYYY-MM-DD');
        // #endregion 입력값 설정

        // #region 필수항목 & Validation Check 체크
        if (!getIsValidData()) {
          return;
        }
        // #endregion 필수항목 & Validation Check 체크

        if (vm.vaultCounsel != null && vm.vaultCounsel.data.getLength() > 0) {
          // 첨부파일 존재시 파일 업로드 후 저장
          uploadVaultFile(vm.vaultCounsel);
        } else {
          // 데이터 저장
          setData();
        }
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getUploadFileList() {
        if (isNullOrEmpty(vm.srch.keyId)) {
          return;
        }

        var data = vm.srch;
        data.mapCode = 'FileAttach.getUploadFileList';

        postApi.select(data, function (result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {

              var uploadFileList = [];

              angular.forEach(result.body.docs, function (item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: 'file',
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ''
                };

                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        }, function (error) {
          console.error("Error> getUploadFileList()");
          console.table(error);
        });
      }

      /**
       * 필수 입력 & Validation Check
       *
       * @param
       * @return
       */
      function getIsValidData() {

        // #region 필수항목 체크
        var errMsg = '';

        if (!vm.CounselDt)
          errMsg = errMsg + '- 상담일을 입력하세요.<br/>';

        if (isNullOrEmpty(vm.data.CounselContents))
          errMsg = errMsg + '- 상담내용을 입력하세요.<br/>';

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        // #endregion 필수항목 체크

        //#region Validation Check

        return true;
        //#endregion Validation Check
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {

        // #region 필수항목 & Validation Check 체크
        /*  if (!getIsValidData())
            return false;*/
        //#endregion 필수항목 & Validation Check 체크


        // #region 입력값 설정

        // KeyId
        vm.data.keyId = vm.keyId;

        // 고객ID
        vm.data.CustId = vm.custId;

        // #endregion 입력값 설정

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.uploadFileList = [];                // 첨부파일

        angular.forEach(vm.uploadFileListCounsel, function (item) {
          vm.data.uploadFileList.push(item);
        });
        vm.data.userkey = $rootScope.gVariable.userkey;          // 사용자 식별 키

        var data = vm.data; // 사용자 입력 데이터
        if (isNullOrEmpty(vm.keyId)) {
          // 신규 등록
          data.mapCode = INSERT_SQL;

          postApi.insert(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', error.body.docs[0].errMessage);
          });
        } else {
          // 수정
          data.RelateDataId = vm.keyId;
          data.mapCode = UPDATE_SQL;

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            console.table(error);
            gAlert('', result.responseVO.body.docs[0].errMessage);
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                ok();
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      // 함수 정의
      vm.setData = setData; // 저장
      vm.uploadFileCounsel = uploadFileCounsel; // 저장

      vm.ok = ok; // 저장
      vm.cancel = cancel; // 취소

      // 데이터 조회
      getData();

    }]);

})();

webapp.controller('CustomerModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function CustomerModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    CustNm : '',
        Mobile : '',
        viewSize : 10,
      };

      vm.selectedTenantId = toModalData.TenantId;

      (function CustomerModalCtrl() {
        getList();
      })();

      function getList() {
        getCnt();
        var data = {
          mapCode: 'Customer.getCustomerModalList',
          CustNm : vm.srch.CustNm,
          Mobile : vm.srch.Mobile,
          userkey : '',
          page : vm.srch.page
        };

        data.mapCode= 'Customer.getCustomerModalList';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.customerlists = result.body.docs;
          }
        });
      }

      function getCnt() {
        var data = {
          mapCode: 'Customer.getCustomerModalListCnt',
          CustNm : vm.srch.CustNm,
          Mobile : vm.srch.Mobile,
          userkey : '',
        };

        data.mapCode= 'Customer.getCustomerModalListCnt';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = result.body.docs[0].totalItems;
          }
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();

      }

      vm.pageChanged = pageChanged;
    } ]);

webapp.controller('UploadExcelUserModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function UploadExcelUserModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    TenantNm : '',
        TenantId : '',
        viewSize : 10
      };

      vm.selectedTenantId = toModalData.TenantId;

      (function TenantModalCtrl() {
        getList();
      })();

      function getList() {

        var data = {
          mapCode: 'Tenant.getTenantSrch',
          TenantNm : vm.srch.TenantNm,
          userkey : '',
        };

        if($window.sessionStorage['loginTenantId']!= null && $window.sessionStorage['loginTenantId'] != "" && $window.sessionStorage['loginTenantId'] != undefined){
          data.mapCode= 'Tenant.getTenantSrch';
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;
              vm.totalItems = result.body.docCnt;
            }
          });
        } else if($window.sessionStorage['loginTenantId'] == null || $window.sessionStorage['loginTenantId'] == "" &&  $window.sessionStorage['loginTenantId'] == undefined) {
          data.mapCode= 'getTenantId';
          postApi.login(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;
              vm.totalItems = result.body.docCnt;
            }
          });
        }

      }


      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }
    } ]);

webapp.controller('DeptModalCtrl', ['$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', '$timeout', 'postApi',
	function DeptModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, $timeout, postApi) {
		var vm = this;
    vm.dataloader = false;

		vm.getList = getList;
		vm.selectItem = {}

    //my_tree 반드시 선언하기
    var tree;
    $scope.my_tree = tree = {};

		function getList() {
      vm.dataloader = true;
      // 사전에 트리 선언함.(중요포인트)
			$scope.my_data = [];

      var srch = {}

      //로케이션관리 select 검색실행함
      var data = srch;
      data.mapCode = 'Department.getDepartmentTree';
      postApi.select(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length == 0){
            vm.dataloader = false;
            return;
          }

          // select한 datatable 바인딩
          vm.lists = result.body.docs;

          refreshTree();
          vm.dataloader = false;
        }
      },function(error) {
        console.error('fail', status, data);
        vm.dataloader = false;
			});
    }

    function refreshTree(){

      //리스트 생성
      var arrlist = new Array();

      // for문으로 다시 json 구조로 변환함.
      for (var i = 0; i < vm.lists.length; i++) {
        //객체 생성
        var data = new Object();

        data.label = vm.lists[i]['DeptNm'] ;
        data.guid = vm.lists[i]['DeptId'].toString() ;
        data.parent = vm.lists[i]['ParentDeptId'] == 0 ? null : vm.lists[i]['ParentDeptId'].toString()  ;

        // 리스트에 생성된 객체 삽입
        arrlist.push(data) ;
      }

      //계층형 json 구조로 변환함
      var recursiveArray = unflatten(arrlist);

      //guid, parent 제외 변환함
      traverse(recursiveArray);

      //트리구조에 바인딩
      $scope.my_data = recursiveArray;

      // 트리 펼치기
      $timeout(function() {
        return tree.expand_init();
      }, 1);
    }

		// 계층형 json 구조로 변환
		function unflatten(items) {

		    // 다시 설정(배치)하는 부분
			return items.reduce(insert, {
		        res: [],
		        map: {}
		    }).res;
		}

		// 계층형 json 부모/자식 구분하여 구조 변환
		function insert(obj, item) {

		  var parent     = item.parent;	//부모값
		  var map        = obj.map;
		  map[item.guid] = item;			//아이템 구성함

		  if (parent === null) obj.res.push(item);	//부모값 생성
		  else {
		    var parentItem = map[parent];
		    //자식값 생성
		    if (parentItem != null) {
  		    if (parentItem.hasOwnProperty("children"))
  		      parentItem.children.push(item);
  		    else parentItem.children = [item];
		    }
		  }

		  return obj;
		}

		// guid, parent 제외한 계층형 json 구조 변환하기
		function traverse(jsonObj) {

			for (var i = 0; i < jsonObj.length; i++) {
				if (jsonObj[i].children == null) {
				} else {
					traverse(jsonObj[i].children);
				}

				// label, children 만 추가함
		    	var newItem = {
					    "label": jsonObj[i].label,
					    "data": jsonObj[i].guid,
					    "children": jsonObj[i].children,
					}
		    	jsonObj[i] = newItem;
			}
		}


		// 트리 목록에서 조회값
		$scope.dept_tree_handler = function(dept) {
      console.log(dept);
	    	vm.selectItem = dept;
		};


	  vm.cancel = cancel;
	  function cancel() {
			$uibModalInstance.dismiss('cancel data');
		}

    vm.ok = ok;
    function ok(){
      $uibModalInstance.close(vm.selectItem);
    }

		getList();

	}
]);

webapp.controller('FindIdPwdModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert',
    function FindIdPwdModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.sendMail = sendMail;
      vm.setPass = false;
      vm.find = toModalData.find;
      vm.crtfcNo = "";
      vm.success = false;
      //vm.find = 'pwd';
      //vm.success = true;
      vm.pass = false;

      (function FindIdPwdModalCtrl() {

      })();

      function ok() {
        $uibModalInstance.close();
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function sendMail() {

        var data = {
          Email : vm.Email,
          UserNm : vm.UserNm,
          LoginId : vm.LoginId,
          mapCode : 'findIdPwd',
          find : vm.find
        };

        postApi.login(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              vm.success = true;
            }
          } else {

            gAlert('',result.body.docs[0].errMessage);
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> findIdPwd-modal-ctrl> sendMail()', status, error);
        });
      }


      function getCrtfcNo() {
        var data = {
          Email : vm.data.Email,
          UserNm : vm.data.UserNm,
          LoginId : vm.data.LoginId,
          mapCode : 'getCrtfcNo',
          find : vm.find,
          CrtfcNo : vm.crtfcNo
        };

        postApi.login(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              //메일발송 관련된부분
              vm.pass = true;
            } else {
              gAlert('','인증번호를 다시 확인해주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> findIdPwd-modal-ctrl> sendMail()', status, error);
        });
      }


      function setData() {

        if (getIsValidData() == false) {
          return;
        }
        var data = angular.copy(vm.data);
        data.mapCode = 'updateUserPass';
        postApi.login(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              //메일발송 관련된부분
              vm.setPass = true;
            } else {
              gAlert('','인증번호를 다시 확인해주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> findIdPwd-modal-ctrl> sendMail()', status, error);
        });

      }



      /**
       * 비밀번호 체크
       *
       * @param
       * @return
       */
      function getIsValidPassword() {
        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
        var birthDay = moment(vm.data.BirthDay).format('MMDD');
        var birthDay2 = moment(vm.data.BirthDay).format('YYMMDD');

        if(!reg.test(vm.data.Password)) return false;
        if(vm.data.Password.indexOf(birthDay) > -1) return false;
        if(vm.data.Password.indexOf(birthDay2) > -1) return false;
        if(vm.data.Password.length < 8) return false;

        return true;

      }

      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';

        if (!isNullOrEmpty(vm.data.KeyId) && isNullOrEmpty(vm.data.Password)) {
          errMsg = errMsg + '- 비밀번호를 입력하세요.<br/>';
        }

        if (vm.data.Password != vm.data.Password2) {
          errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
        }

        if (!isNullOrEmpty(vm.data.Password)) {
          if (!getIsValidPassword()) {
            errMsg = errMsg + '- 비밀번호 형식을 확인해 주세요.<br/>';
          }
        }
        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }
        return true;
      }

      vm.getCrtfcNo = getCrtfcNo;
      vm.setData = setData;
    } ]);

webapp.controller('MyPageModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope',
    function FindIdPwdModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.keyId = toModalData.UserId;
      vm.TenantId = toModalData.TenantId;

      //function
      vm.setData = setData;
      vm.getData = getData;

      var VIEW_SQL = 'User.getUserMgrDetail'; // 조회 SQL
      var UPDATE_SQL = 'User.updateMyPage';     // 수정 SQL

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Users'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      vm.srchDetail.keyId = vm.keyId;
      vm.srchDetail.tableNm = KEY_TABLE_NM;

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: vm.keyId, // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      (function MyPageModalCtrl() {

      })();

      function ok() {
        $uibModalInstance.close();
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {

        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

              //Date형식 처리
              if (vm.data.BirthDay != null && vm.data.BirthDay != "") vm.BirthDay = moment(vm.data.BirthDay).toDate();


            }
          } else {
            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {

        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.UserNm))
          errMsg = errMsg + '- 사용자명을 입력하십시오.<br/>';

        if (vm.data.Password != vm.data.Password2)
          errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';

        if (!isNullOrEmpty(vm.data.Password)){
          if (!chkPass())
          errMsg = errMsg + '- 비밀번호 형식을 확인해주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }


        // #endregion 필수항목 체크

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.userkey = $rootScope.gVariable.userkey;       // 사용자 식별 키
        vm.data.BirthDay = moment(vm.data.BirthDay).format('YYYY-MM-DD');
        var data = vm.data; // 사용자 입력 데이터

        // 수정
        data.RelateDataId = data.keyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (
              result.body.docs[0].KeyId !== null ||
              result.body.docs[0].NewKeyId !== null
            ) {
              // KeyId 조회
              vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;

              gAlert("", "Menu.SAVED", {
                btn: "",
                fn: function () {
                  ok();
                }
              });
              return;
            }
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });

      }

      /**
       * 비밀번호 체크
       *
       * @param
       * @return
       */
      function chkPass() {
        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
        var birthDay = moment(vm.data.BirthDay).format('MMDD');
        var birthDay2 = moment(vm.data.BirthDay).format('YYMMDD');

        if(!reg.test(vm.data.Password)) return false;
        if(vm.data.Password.indexOf(birthDay) > -1) return false;
        if(vm.data.Password.indexOf(birthDay2) > -1) return false;
        if(vm.data.Password.length < 8) return false;
        if(!isNullOrEmpty(vm.data.keyId)) setMallFW();


        return true;

      }

      function setMallFW(param) {
        var param = {};
        param.rTenantID = $rootScope.gVariable.srchTenantId;
        param.rUserID = vm.data.KeyId;
        param.rLoginID = vm.data.LoginId;
        param.rShopTentID = vm.data.TenantId;
        param.mapCode = "remoteJfc";
        param.remoteAction = "setChangePw";
        param.rUserPw = vm.data.Password;

        postApi.openApi(param, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
          } else {
          }
        });
      }


      getData();
    } ]);

webapp.controller('previewCtrl', ['$uibModalInstance', 'toModalData', '$compile', '$scope',
  function previewCtrl($uibModalInstance, toModalData, $compile, $scope){

    var vm = this;
    vm.data = toModalData;
    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function makePopup(){
      var data = angular.copy(vm.data.data);
      var popHtml = angular.copy(vm.data.popHtml);
      var html = '<div class="popup-each" style="position:absolute; overflow:hidden; width: '+ data.WidthSize + 'px; height:' + (data.VrticleSize + 35) + 'px; top:' + data.UpendLC + 'px; left:' + data.LeftLC + 'px;">' + popHtml + '<div class="popup-btn-wrap"><div style="float:right; line-height:20px; position: relative; top: 5px;"><button class="popup-btn" ng-click="vc.setCookie(\'' + data.Title + '\', $event)">24시간동안 열지않음</button><button class="popup-btn" ng-click="vc.winClose($event)">닫기</button></div></div></div>';
      var comp = $compile(html);
      setTimeout(function(){
        angular.element('.modal-body').append(comp($scope));
      }, 300);
    }

    makePopup();

    vm.cancel = cancel;
  }
]);

webapp.controller('ProductModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function ProductModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    GoodsNm : '',
        GoodsNo : '',
        viewSize : 10,
      };

      vm.selectedTenantId = toModalData.TenantId;

      (function TenantModalCtrl() {
        getList();
      })();

      function getList() {
        getCnt();
        var data = {
          mapCode: 'Product.getProductList',
          GoodsNm : vm.srch.GoodsNm,
          userkey : '',
          page : vm.srch.page,
        };

        data.mapCode= 'Product.getProductList';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.productlists = result.body.docs;
          }
        });
      }

      function getCnt() {
        var data = {
          mapCode: 'Product.getProductCnt',
          GoodsNm : vm.srch.GoodsNm,
          userkey : '',
        };

        data.mapCode= 'Customer.getProductCnt';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = result.body.docs[0].totalItems;
          }
        });
      }


      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }

      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();

      }

      vm.pageChanged = pageChanged;
    } ]);

webapp.controller('ProductallModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
  function ProductallModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.getList = getList;
    vm.currentPage = 1;
    vm.maxSize = 10;

    vm.srch = {
      GoodsNm : '',
      GoodsNo : '',
      viewSize : 10,
    };

    vm.selectedTenantId = toModalData.TenantId;

    (function TenantModalCtrl() {
      getList();
    })();

    function getList() {
      getCnt();
      var data = {
        mapCode: 'Product.getProductallList',
        GoodsNm : vm.srch.GoodsNm,
        userkey : '',
        page : vm.srch.page,
      };

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          vm.productlists = result.body.docs;
        }
      });
    }

    function getCnt() {
      var data = {
        mapCode: 'Product.getProductallListCnt',
        GoodsNm : vm.srch.GoodsNm,
        userkey : '',
      };

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          vm.totalItems = result.body.docs[0].totalItems;
        }
      });
    }


    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(item) {
      $uibModalInstance.close(item);
    }

    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();

    }

    vm.pageChanged = pageChanged;
  } ]);

webapp.controller('UserroleModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function UserroleModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi) {
      var vm = this;

      vm.UserRoles = [];
      if (!isNullOrEmpty(toModalData.UserRoles))
        vm.UserRoles = toModalData.UserRoles;

      vm.data = {list:[]};

      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.IsRole = IsRole;
      vm.addRole = addRole;
      vm.querySearch = querySearch;
      vm.onRemoveChip = onRemoveChip;
      vm.filterSelected = true;

      (function UserroleModalCtrl() {
        // search
        vm.searchValue = '';
        vm.selectPeriod = 'all';
        vm.startDate = '';
        vm.endDate = '';
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        // 검색 선택 옵션
        vm.searchFieldTypeList = [ {
          optionId : 'UserNm',
          optionName : '이름'
        } ];
        vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.list = [];
        getList();
      })();
      function changeViewSize() {
        getList();
      }
      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          searchFieldType : vm.searchFieldType,
          RoleNm : vm.searchValue,
          selectPeriod : vm.selectPeriod,
          TenantId : toModalData.TenantId
        };
        vm.filter = req;
        return req;
      }

      function getList() {
        getListCnt();

        var data = vm.getRequestParams();
        data.mapCode = 'Role.getRoleList';

        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docCnt > 0) {
              vm.data.list = result.body.docs;
            } else {
              vm.totalCount = 0;
            }
          }
        }, function(error) {
          console.error('Error-getList', status, data);
        });
      }

      function getListCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'Role.getRoleListCnt';

        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docCnt > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
        }, function(error) {
          console.error('Error-getList', status, data);
        });
      }

      function IsRole(role) {

        if(vm.UserRoles != null && vm.UserRoles != undefined && vm.UserRoles != ""){

          for (i = 0; i < vm.UserRoles.length; i++) {
            if (role.RoleId == vm.UserRoles[i].RoleId)
              return true;
          }
        }
        return false;
      }

      function addRole(RoleId) {
        for (var i = 0; i < vm.data.list.length; i++) {
          if (vm.data.list[i].RoleId == RoleId) {
            vm.UserRoles.push(vm.data.list[i]);
            break;
          }
        }
      }

      /**
       * Search for contacts.
       */
      function querySearch(query) {
        var results = query ? vm.data.list.filter(createFilterFor(query)) : [];
        return results;
      }
      /**
       * Create filter function for a query string
       */
      function createFilterFor(query) {
        return function filterFn(role) {
          return (role.RoleNm.indexOf(query) != -1);
        };
      }

      function onRemoveChip(item) {
        console.log('item=', item);
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        $uibModalInstance.close(vm.UserRoles);
      }

    } ]);

webapp.controller('ClassfyInfoModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function ClassfyInfoModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getClassfyInfoList = getClassfyInfoList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      vm.MobileYn = toModalData.MobileYn;
      if(toModalData.MobileYn == undefined) vm.MobileYn = false;

      vm.Manager = !isNullOrEmpty(toModalData.srchManager) ? toModalData.srchManager : "";

      (function ClassfyInfoModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.ClassfyInfoList = [];
        getClassfyInfoList();
      })();

      function changeViewSize() {
        getClassfyInfoList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          ClassfyInfoNm : vm.ClassfyInfoNm != undefined ? vm.ClassfyInfoNm : '',
          Manager : vm.Manager
        };
        vm.filter = req;
        return req;
      }

      function getClassfyInfoList() {
        getClassfyInfoListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'wjm.clasfyinfo';
        data.mapCode = 'WjmSurvey.getClassfyInfoModalList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.ClassfyInfoList = result.body.docs;
            } else {
              vm.ClassfyInfoList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getClassfyInfoList()', status, error);
          vm.dataloader = false;
        });
      }

      function getClassfyInfoListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'WjmSurvey.getClassfyInfoModalListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getClassfyInfoList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(ClassfyInfo) {
        $uibModalInstance.close(ClassfyInfo);
      }

    } ]);

webapp.controller('MenusurveyModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'gAlert', 'postApi',
  function MenusurveyModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, gAlert, postApi) {
    var vm = this;
    vm.close = close;
    vm.ok = ok;
    vm.getList = getList;
    vm.setData = setData;
    vm.currentPage = 1;
    vm.maxSize = 10;

    vm.srch = {
      SvyNm : '',
      SvyType : '',
      viewSize : 10,
      keyId: toModalData.keyId,
    };

    vm.selectedTenantId = toModalData.TenantId;

    (function MenusurveyModalCtrl() {
      getList();
      getSvyTypeCodeList();

      if (isNullOrEmpty(vm.srch.keyId)) close();
    })();

    function getList() {
      getCnt();
      var data = {
        mapCode: 'Survey.getSurveyList',
        SvyNm : vm.srch.SvyNm,
        SvyType : vm.srch.SvyType,
        userkey : '',
        page : vm.srch.page
      };

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          vm.svyLists = result.body.docs;
        }
      });
    }

    function getCnt() {
      var data = {
        mapCode: 'Survey.getSurveyListCnt',
        CustNm : vm.srch.CustNm,
        Mobile : vm.srch.Mobile,
        userkey : '',
      };

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          vm.totalItems = result.body.docs[0].totalItems;
        }
      });
    }

    /**
     * 공통코드 목록 (구분)
     *
     * @param
     * @return
     */
    function getSvyTypeCodeList() {
      var data = vm.srch;

      if (!isNullOrEmpty(vm.SvyTypeCodeList)) return;

      vm.srch.CodeType = "SVYTYPE";
      data.mapCode = 'CommonCode.getCommonCodeList';

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          vm.SvyTypeCodeList = result.body.docs;
        }
      });
    }

    /**
     * 선택설문 추가
     *
     * @param
     * @return
     */
    function setData() {
      vm.srch.KeyIdList = [];

      for (var i = 0; i < vm.svyLists.length; i++) {
        if (vm.svyLists[i].svyChkRow)
        {
          vm.srch.KeyIdList.push(vm.svyLists[i].KeyId);
        }
      }

      if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
      {
        gAlert('', '추가할 설문을 선택해주세요.');
        return false;
      }

      var data = {};
      data = vm.srch;
      data.mapCode = "Survey.updateMenusurveyList";

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn : '',
            fn : function() {
              ok();
            }
          });
        }
      }, function (error) {
        console.error("Error> setData()");
        console.table(error);
      });
    }

    function close() {
      $uibModalInstance.dismiss('close data');
    }

    function ok(item) {
      $uibModalInstance.close(item);
    }

    /**
     * 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();

    }

    /**
     * 목록 체크박스 로직 설정
     * @param
     * @return
     */
    vm.svyChkHead = false;
    $scope.svyChkRowChg = function () {
      for (var i = 0; i < vm.svyLists.length; i++) {
        if (!vm.svyLists[i].isChecked) {
          vm.svyChkHead = false;
          return;
        }
      }
      vm.svyChkHead = true;
    };

    $scope.svyChkHeadChg = function () {
      for (var i = 0; i < vm.svyLists.length; i++) {
        vm.svyLists[i].svyChkRow = vm.svyChkHead;
      }
    };

    vm.pageChanged = pageChanged;
  } ]);

webapp.controller('PreModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm',
  function PreModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm) {
    var vm = this;

    // html 에서 사용하는 함수 연결
    vm.close = close;

    (function PreModalCtrl() {
      vm.srch = {
        keyId: toModalData.keyId,
      };

      vm.qstItemLists = {};
      //console.log("test", vm.srch);
      //vm.data = {};

      if (!isNullOrEmpty(vm.srch.keyId)) {
        getQstList();
      }
    })();

    /**
     * 문제 목록
     *
     * @param
     * @return
     */
    function getQstList() {
      var data = vm.srch;
      data.mapCode = 'Survey.getSurveyqstList';

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          vm.qstLists = result.body.docs;

          if (!isNullOrEmpty(vm.qstLists)) {
            getQstItemList(0);
          }
        }
      });
    }

    /**
     * 문제항목 목록
     *
     * @param
     * @return
     */
    function getQstItemList(idx) {
      var data = vm.srch;
      data.mapCode = 'Survey.getSurveyqstitemList';
      data.keyId2 = vm.qstLists[idx].KeyId2;

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          vm.qstItemLists[idx] = result.body.docs;

          idx++;
          if (vm.qstLists.length > idx) {
            getQstItemList(idx)
          }
          else {
            //console.log("tttt", vm.qstItemLists);
          }
        }
      });
    }

    /**
     * 닫기 버튼 이벤트
     *
     * @param
     * @return
     */
    function close() {
      $uibModalInstance.dismiss('close data');
    }
  } ]);

webapp.controller('QstModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm',
    function QstModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm) {
      var vm = this;

      // html 에서 사용하는 함수 연결
      vm.close = close;
      vm.setQstData = setQstData;
      vm.setDelQstItemData = setDelQstItemData;

      (function QstModalCtrl() {
        vm.srch = {
          keyId: toModalData.keyId,
          keyId2: toModalData.keyId2,
          qstType: toModalData.qstType
        };

        //console.log("test", vm.srch);
        vm.data = {};

        if (!isNullOrEmpty(vm.srch.keyId2)) {
          getQstDetail();
        }
        else {
          vm.data.QstType = vm.srch.qstType;
          getQstTypeCodeList();
        }
      })();

      /**
       * 문제 조회
       *
       * @param
       * @return
       */
      function getQstDetail() {
        var data = vm.srch;
        data.mapCode = 'Survey.getSurveyqstDetail';

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            vm.data = result.body.docs[0];

            getQstItemList();
          }
        });
      }

      /**
       * 문제항목 목록
       *
       * @param
       * @return
       */
      function getQstItemList() {
        var data = vm.srch;
        data.mapCode = 'Survey.getSurveyqstitemList';

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.qstItemLists = result.body.docs;

            // 주관식일 경우
            if (vm.data.QstType == "300" && !isNullOrEmpty(vm.qstItemLists) && vm.qstItemLists.length > 0) {
              vm.data.QstItemScore = vm.qstItemLists[0].QstItemScore;
            }

            getQstTypeCodeList();
            /*
            var resList = [];
            var res = '';

            if (vm.tenantlists != null) {
              angular.forEach(vm.tenantlists, function (item) {
                 resList = [];
                 if (item.Addr1 != undefined) {
                  res = item.Addr1;
                  resList = res.split(" ");
                  item.Addr1 = resList[0] + " " + resList[1];
                 }
              });
            }
            */
          }
        });
      }

      /**
       * 공통코드 목록
       *
       * @param
       * @return
       */
      function getQstTypeCodeList() {
        var data = vm.srch;

        if (!isNullOrEmpty(vm.QstTypeCodeList)) return;

        vm.srch.CodeType = "QSTTYPE";
        data.mapCode = 'CommonCode.getCommonCodeList';

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.QstTypeCodeList = result.body.docs;
            /*
            var resList = [];
            var res = '';

            if (vm.tenantlists != null) {
              angular.forEach(vm.tenantlists, function (item) {
                 resList = [];
                 if (item.Addr1 != undefined) {
                  res = item.Addr1;
                  resList = res.split(" ");
                  item.Addr1 = resList[0] + " " + resList[1];
                 }
              });
            }
            */
          }
        });
      }

      /**
       * 문제 저장
       *
       * @param
       * @return
       */
      function setQstData() {
        if (getIsValidData() == false) {
          return;
        }

        vm.data.keyId = vm.srch.keyId;
        vm.data.keyId2 = vm.srch.keyId2;

        var data = vm.data; // 사용자 입력 데이터

        if (isNullOrEmpty(vm.data.keyId2)) {
          // 신규 등록
          data.mapCode = 'Survey.insertSurveyqst';

          postApi.insert(data, function (result) {
            vm.srch.keyId2 = result.body.docs[0].RelateDataId;

            setQstItemData("ADD", 0, result);
          }, function (error) {
            console.error("Error> setQstData()");
            console.table(error);
          });
        } else {
          // 수정
          //data.RelateDataId = data.keyId2;
          data.mapCode = 'Survey.updateSurveyqst';

          postApi.update(data, function (result) {
            setQstItemData("ADD", 0, result);
          }, function (error) {
            console.error("Error> setQstData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 문제 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        //console.log("res", result);
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          /*
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null
          ) {
          */
            // KeyId 조회
            //vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                //goNextPage(true);
                getQstDetail();
              }
            });
            return;
          //}
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var errMsg = '';
        if (isNullOrEmpty(vm.data.QstNo)) {
          errMsg = errMsg + '- No를 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.QstType)) {
          errMsg = errMsg + '- 구분을 선택하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.QstSubject)) {
          errMsg = errMsg + '- 제목을 입력하세요.<br/>';
        }

        if (vm.data.QstType == "300") {
          if (isNullOrEmpty(vm.data.QstItemScore)) {
            errMsg = errMsg + '- 배점을 입력하세요.<br/>';
          }
        }
        else {
          if (isNullOrEmpty(vm.qstItemLists)) {
            if (isNullOrEmpty(vm.data.NewQstItemNo)) {
              errMsg = errMsg + '- 항목 No를 입력하세요.<br/>';
            }

            if (isNullOrEmpty(vm.data.NewQstItemContents)) {
              errMsg = errMsg + '- 항목 내용을 입력하세요.<br/>';
            }

            if (isNullOrEmpty(vm.data.NewQstItemScore)) {
              errMsg = errMsg + '- 항목 배점을 입력하세요.<br/>';
            }
          }
          else {
            angular.forEach(vm.qstItemLists, function (item) {
              if (isNullOrEmpty(item.QstItemNo) || isNullOrEmpty(item.QstItemContents) || isNullOrEmpty(item.QstItemScore)) {
                errMsg = errMsg + '- 기존 문제항목 데이터중 빈항목이 존재합니다.<br/>';
              }
            });
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
      }

      /**
       * 문제항목 저장
       *
       * @param
       * @return
       */
      function setQstItemData(type, rowIdx, qstResult) {
        var data = vm.srch; // 사용자 입력 데이터

        // 주관식일 경우
        if (vm.data.QstType == "300") {
          if (isNullOrEmpty(vm.data.keyId2)) {
            // 신규 등록
            data.QstItemNo = "1";
            data.QstItemContents = "주관식문제항목";
            data.QstItemScore = vm.data.QstItemScore;
            data.mapCode = 'Survey.insertSurveyqstitem';

            postApi.insert(data, function (result) {
              setInsertUpdateDetail(qstResult);
            }, function (error) {
              console.error("Error> setQstItemData()");
              console.table(error);
            });
          }
          else {
            // 수정
            data = vm.qstItemLists[0];
            data.keyId3 = data.KeyId3;
            data.QstItemScore = vm.data.QstItemScore;
            data.mapCode = 'Survey.updateSurveyqstitem';

            postApi.update(data, function (result) {
              setInsertUpdateDetail(qstResult);
            }, function (error) {
              console.error("Error> setQstItemData()");
              gAlert('', 'Menu.EXCEPTIONOCCURED');
            });
          }
        }
        else {
          if (type == "ADD") {
            // 신규 등록
            data.QstItemNo = vm.data.NewQstItemNo;
            data.QstItemContents = vm.data.NewQstItemContents;
            data.QstItemScore = vm.data.NewQstItemScore;
            data.mapCode = 'Survey.insertSurveyqstitem';

            if (isNullOrEmpty(data.QstItemNo) || isNullOrEmpty(data.QstItemContents) || isNullOrEmpty(data.QstItemScore)) {
              if (!isNullOrEmpty(vm.qstItemLists)) {
                setQstItemData("MODIFY", 0, qstResult);
              }
              else {
                setInsertUpdateDetail(qstResult);
              }

              return;
            }

            postApi.insert(data, function (result) {
              vm.data.NewQstItemNo = "";
              vm.data.NewQstItemContents = "";
              vm.data.NewQstItemScore = "";

              if (!isNullOrEmpty(vm.qstItemLists)) {
                setQstItemData("MODIFY", 0, qstResult);
              }
              else {
                setInsertUpdateDetail(qstResult);
              }
            }, function (error) {
              console.error("Error> setQstItemData()");
              console.table(error);
            });
          } else {
            // 수정
            data = vm.qstItemLists[rowIdx];
            data.keyId3 = data.KeyId3;
            data.mapCode = 'Survey.updateSurveyqstitem';

            postApi.update(data, function (result) {
              rowIdx++;
              if (vm.qstItemLists.length > rowIdx) {
                setQstItemData("MODIFY", rowIdx, qstResult);
              }
              else {
                setInsertUpdateDetail(qstResult);
              }
            }, function (error) {
              console.error("Error> setQstItemData()");
              gAlert('', 'Menu.EXCEPTIONOCCURED');
            });
          }
        }
      }

      /**
       * 문제항목 삭제
       *
       * @param
       * @return
       */
      function setDelQstItemData(keyId3) {
        var data = {};
        data.keyId3 = keyId3;
        data.mapCode = "Survey.deleteSurveyqstitemList";

        postApi.update(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            getQstItemList();
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> setDelQstItemData()");
          console.table(error);
        });
      }

      /**
       * 닫기 버튼 이벤트
       *
       * @param
       * @return
       */
      function close() {
        $uibModalInstance.dismiss('close data');
      }
    } ]);

webapp.controller('SurveyModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function SurveyModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.columnMap = {};

      var KEY_TABLE_NM = 'surveymodal'; // 작업 테이블명

      vm.srch = {
		    SvyNm : '',
        SvyId : '',
        viewSize : 10,
        tableNm : KEY_TABLE_NM,
      };


      vm.selectedTenantId = toModalData.TenantId;

      (function TenantModalCtrl() {
        getList();
      })();

      function getList() {
        getCnt();
        var data = {
          mapCode: 'Survey.getSurveyList',
          SvyNm : vm.srch.SvyNm,
          userkey : '',
          page : vm.srch.page,
          selectType : 'List',
          tableNm : KEY_TABLE_NM,
        };

        data.mapCode= 'Survey.getSurveyList';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시

            vm.svyLists = result.body.docs;
              // 목록 화면 구성
            } else {
              // 데이터 조회 실패
              vm.svyLists = {};
            }

          }
        });
      }

      function getCnt() {
        var data = {
          mapCode: 'Survey.getSurveyListCnt',
          SvyNm : vm.srch.SvyNm,
          userkey : '',
        };

        data.mapCode= 'Survey.getSurveyListCnt';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = result.body.docs;
          }
        });
      }


      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }

      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();

      }

      vm.pageChanged = pageChanged;
    } ]);

webapp.controller('SvyTypeModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function SvyTypeModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getSvyTypeList = getSvyTypeList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      vm.MobileYn = toModalData.MobileYn;
      if(toModalData.MobileYn == undefined) vm.MobileYn = false;

      (function SvyTypeModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.SvyTypeList = [];
        getSvyTypeList();
      })();

      function changeViewSize() {
        getSvyTypeList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          SvyTypeNm : vm.SvyTypeNm != undefined ? vm.SvyTypeNm : ''
        };
        vm.filter = req;
        return req;
      }

      function getSvyTypeList() {
        getSvyTypeListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'wjm.surveytype';
        data.mapCode = 'WjmSurvey.getSvyTypeModalList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.SvyTypeList = result.body.docs;
            } else {
              vm.SvyTypeList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getSvyTypeList()', status, error);
          vm.dataloader = false;
        });
      }

      function getSvyTypeListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'WjmSurvey.getSvyTypeModalListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getSvyTypeList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(SvyType) {
        $uibModalInstance.close(SvyType);
      }

    } ]);

webapp.controller('TgtModalCtrl', [ '$window', '$rootScope', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', 'modalFactory',
  function TgtModalCtrl($window, $rootScope, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm, modalFactory) {
    var vm = this;

    // html 에서 사용하는 함수 연결
    vm.ok = ok;
    vm.cancel = cancel;
    vm.getData = getData;
    vm.setData = setData;

    (function TgtModalCtrl() {
      vm.srch = {
        keyId: toModalData.keyId,
        tgtType: toModalData.tgtType
      };

      vm.data = {};
      vm.data.TgtCnt = 0;

      if (isNullOrEmpty(vm.srch.keyId)) cancel();

      if (vm.srch.tgtType == "100") {
        vm.pageTitle = "테스트대상자(마스터)";
        getCommonCodeList("USERGRADE");
      }
      else {
        vm.pageTitle = "테스트대상자(멤버)";
        getCommonCodeList("CUSTGRADE");
      }
    })();

    /**
     * 회원사 검색 팝업 호출
     *
     * @param {string}
     * @return {boolean}
     */
    vm.srchTenantModal = function () {
      var ctrl = 'TenantModalCtrl as vc';
      var paramData = {TenantId: vm.srch.TenantId};
      var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        // 회원사 선택
        vm.srch.TenantNm = okData.TenantNm;
        vm.srch.TenantId = okData.TenantId;
      }, function (cancelData) {
        // 취소
      });
    };

    /**
     * 회원사 초기화
     *
     * @param {string}
     * @return {boolean}
     */
    vm.eraseTenant = function () {
      /*
      if (vm.TenantId != '0') {
        return;
      }
      */
      vm.srch.TenantNm = "";
      vm.srch.TenantId = "";
    };

    /**
     * 공통코드 목록
     *
     * @param
     * @return
     */
    function getCommonCodeList(codeType) {
      var data = vm.srch;

      vm.srch.CodeType = codeType;
      data.mapCode = 'CommonCode.getCommonCodeList';

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {

          switch (codeType) {
            case "CUSTGRADE" :
              vm.CustGradeCodeList = result.body.docs;
              getCommonCodeList("GENDER");
              break;
            case "GENDER" :
              vm.GenderCodeList = result.body.docs;
              break;
            case "USERGRADE" :
              vm.UserGradeCodeList = result.body.docs;
              break;
            default : break;
          }
        }
      });
    }

    /**
     * 추출
     *
     * @param
     * @return
     */
    function getData() {
      if (getIsValidData() == false) return;

      var data = vm.srch;
      data.mapCode = 'Survey.getSurveyTargetExtract';

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {

          if (result.body.docs.length > 0) {
            vm.data.TgtCnt = result.body.docs[0].TgtCnt;
          } else {
            vm.data.TgtCnt = 0;
          }
        }
      });
    }

    /**
     * 추가
     *
     * @param
     * @return
     */
    function setData() {
      if (getIsValidData() == false) return;

      if (isNullOrEmpty(vm.data.TgtCnt) || vm.data.TgtCnt == "0") {
        gAlert("", "추출대상이 0명입니다.");
        return;
      }

      var data = vm.srch;

      data.mapCode = 'Survey.updateSurveyTargetExtract';

      postApi.insert(data, function (result) {
        setInsertUpdateDetail(result);
      }, function (error) {
        console.error("Error> setData()");
        console.table(error);
      });
    }

    /**
     * 추가 후 처리
     *
     * @param result - 저장 결과
     * @return
     */
    function setInsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        gAlert("", "Menu.SAVED", {
          btn: "",
          fn: function () {
            ok();
          }
        });
        return;
      }

      console.error("Error> setInsertUpdateDetail()");
      gAlert('', result.body.docs[0].errMessage);
    }

    /**
     * 필수항목 체크
     * @param
     * @return
     */
    function getIsValidData() {
      var errMsg = '- 검색조건을 하나 이상 입력하세요.<br/>';
      var isErr = false;

      if (vm.srch.tgtType == "100") {
        if (
          isNullOrEmpty(vm.srch.UserNm)
          && isNullOrEmpty(vm.srch.Mobile)
          && isNullOrEmpty(vm.srch.UserGrade)
          && isNullOrEmpty(vm.srch.Addr1)
          && isNullOrEmpty(vm.srch.AgeFrom)
          && isNullOrEmpty(vm.srch.AgeTo)
          && isNullOrEmpty(vm.srch.TenantId)
        ) {
          isErr = true;
        }
      }
      else {
        if (
          isNullOrEmpty(vm.srch.CustNm)
          && isNullOrEmpty(vm.srch.Mobile)
          && isNullOrEmpty(vm.srch.Gender)
          && isNullOrEmpty(vm.srch.CustGrade)
          && isNullOrEmpty(vm.srch.AgeFrom)
          && isNullOrEmpty(vm.srch.AgeTo)
          && isNullOrEmpty(vm.srch.Addr1)
          && isNullOrEmpty(vm.srch.TenantId)
        ) {
          isErr = true;
        }
      }

      if (isErr) {
        gAlert('', errMsg);
        return false;
      }

      return true;
    }

    /**
     * 취소 버튼 이벤트
     *
     * @param
     * @return
     */
    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    /**
     * 성공 이벤트
     *
     * @param
     * @return
     */
    function ok() {
      $uibModalInstance.close(null);
    }
  } ]);

webapp.controller('WjmAnalPreviewModalCtrl', [ '$uibModalInstance', 'toModalData','$filter',
    function WjmAnalPreviewModalCtrl($uibModalInstance, toModalData, $filter) {
      var vm = this;
      vm.cancel = cancel;
      vm.getData = getData;

      vm.TgtCnt = toModalData.TgtCnt;
      vm.tgtList = toModalData.tgtList;
      vm.dataType = toModalData.dataType;
      vm.gdChk = toModalData.gdChk;
      vm.agChk = toModalData.agChk;
      vm.psChk = toModalData.psChk;
      vm.gr1Chk = toModalData.gr1Chk;
      vm.gr2Chk = toModalData.gr2Chk;
      vm.gr3Chk = toModalData.gr3Chk;
      vm.gr4Chk = toModalData.gr4Chk;
      vm.lvChk = toModalData.lvChk;

      vm.chtList = [];

      var useScale = (vm.dataType.typeChtCd != "pie" && vm.dataType.typeChtCd != "doughnut");
      var useStack = (vm.dataType.typeChtCd == "stackedBar");
      var useLegend = (vm.dataType.typeChtCd == "pie" || vm.dataType.typeChtCd == "doughnut" || vm.dataType.typeChtCd == "stackedBar");

      // 차트 초기화
      vm.chart = {
        dataList : [],
        class : "chart-" + vm.dataType.typeChtCd,
        type : (vm.dataType.typeChtCd == "stackedBar" ? "bar" : vm.dataType.typeChtCd),
        data : [],
        series : [],
        labels : [],
        colors : [],
        options : {
          legend : {
            display : useLegend,
            position : 'left'
          },
          scales: {
            yAxes: [{
              display : useScale,
              ticks: {min: 0},
              stacked: useStack,
            }],
            xAxes: [{
              display : useScale,
              ticks: {min: 0},
              stacked: useStack,
            }]
          },
          elements : {
            line: { fill: false }
          },
        }
      };


      function getData(){

        var first = -1;

        // 차트 데이터 조회
        angular.forEach(vm.dataType.chtList, function(c, idx) {
          var cht = angular.copy(vm.chart);
          cht.dataList = c.dataList;
          cht.cntTot = c.cntTot;
          cht.title = c.title;

          if(first == -1 && c.cntTot > 0) first = idx; // 분류정보별 진단결과 차트의 경우 맨 처음 차트에만 범례 표시

          if( ! isNullOrEmpty(c.title)) cht.options.title = { display: true, text: c.title };
          if(useLegend && vm.dataType.chtType == "L" && vm.dataType.cfCd != "") {
            cht.options.legend.display = (first == idx);
          }

          vm.chtList.push(cht);
        });

        var hx = "";

        // 차트에 매핑
        angular.forEach(vm.chtList, function(c) {

          var dt = [];
          var sr = [];
          var lb = [];
          var cr = [];
          var hx = "";

          angular.forEach(c.dataList, function(d) {


            if(! isNullOrEmpty(d.LvCd)) {
              hx = "";
              switch(d.LvCd){
                case "Green" : hx = "#6DDB59"; break;
                case "Blue" : hx = "#2E64FE"; break;
                case "Yellow" : hx = "#F5E523"; break;
                case "Red" : hx = "#E4355A "; break;
              }
            }

            if(vm.dataType.typeChtCd == "stackedBar") {
              dt.push([d.Cnt]);
              sr.push([d.Type]);
              if(hx != "") cr.push([hx]);
              lb = ["전체"];
            }
            else {
              dt.push(d.Cnt);
              lb.push(d.Type);
              if(hx != "") cr.push(hx);
            }
          });

          c.data = dt;
          c.series = sr;
          c.labels = lb;
          c.colors = cr;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      getData();

    } ]);


webapp.controller('WjmFormModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
  function WjmFormModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.getList = getList;
    vm.columnMap = {};

    (function WjmFormModalCtrl() {
      // pagination
      vm.totalCount = 0;
      vm.currentPageNum = 1;
      vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
      vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
      vm.changeViewSize = changeViewSize;
      vm.getRequestParams = getRequestParams;

      vm.lists = [];
      getList();
    })();

    function changeViewSize() {
      getList();
    }

    function getRequestParams() {
      var req = {
        page : vm.currentPageNum,
        viewSize : vm.viewSizePerPage,
        FormNm : vm.FormNm != undefined ? vm.FormNm : '',
        FormType : '100' // 설문유형이 설문인 것만
      };
      vm.filter = req;
      return req;
    }

    function getList() {
      getListCnt();
      var data = vm.getRequestParams();
      data.selectType = 'List';
      data.tableNm = 'wjm.form';
      data.mapCode = 'WjmForm.getFormList';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          /*
          if (result.body.desc.length > 0) {
            vm.listColumns = result.body.desc;
            angular.forEach(vm.listColumns, function(item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          */

          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.Lists = {};
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error> wjm-form-modal-ctrl> getList()', status, error);
        vm.dataloader = false;
      });
    }

    function getListCnt() {

      var data = vm.getRequestParams();
      data.mapCode = 'WjmForm.getFormListCnt';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalCount = result.body.docs[0];
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error> wjm-form-modal-ctrl> getListCnt()', status, error);
        vm.dataloader = false;
      });
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(item) {
      $uibModalInstance.close(item);
    }

  } ]);

webapp.controller('GroupEditModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function GroupEditModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {

    var vm = this;
    vm.dataloader = false;

    // SQL Mapper Id 정의
    var INSERT_SQL = 'WjmCampaign.updateGroupCustomer';     // 등록 SQL
    var UPDATE_SQL = 'WjmSurvey.updateSvyTarget';     // 수정 SQL
    var VIEW_SQL = 'WjmSurvey.getSvyTargetDetail'; // 조회 SQL
    var DUPCHK_SQL = 'WjmCampaign.checkGroupCustomer';         // 중복체크 SQL

    // 관련 테이블 정의
    var VIEW_TABLE_NM = 'wjm.surveytarget'; // 조회용 테이블명
    var EDIT_TABLE_NM = 'wjmsurveytarget'; // 저장용 테이블명
    var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

    vm.srch = {
      keyId : toModalData.keyId,
      GrpNm : toModalData.GrpNm,
      GrpId : toModalData.GrpId,
      Manager : toModalData.Manager
    };

    // 조회 데이터 설정
    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
    vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

    // 등록/수정 표시용 컬럼 목록
    vm.srchDetail.editColumns = {};

    // 조회 데이터

    vm.data = {
      keyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '',  // Primary Key Data
      tableNm: VIEW_TABLE_NM,
      Manager: vm.srch.Manager,
      GrpId : toModalData.GrpId
    };

    // 조회
    function getData() {
      vm.dataloader = true; // Progressbar 표시

      if (isNullOrEmpty(vm.srch.keyId)) {
        vm.dataloader = false;  // Progressbar 숨김
      }
      vm.srchDetail.viewColumns = {}; // 조회 컬럼

      var data = vm.srchDetail;
      data.mapCode = VIEW_SQL;

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          vm.dataloader = false; // Progressbar 숨김

          if (result.body.desc.length > 0) {
            // 사용자정의 컬럼 설정
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            vm.data = result.body.docs[0];
            vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

            vm.tmpMobile = vm.data.Mobile;
            vm.tmpEmail = vm.data.Email;

          } else {
            vm.data.TenantId = $rootScope.gVariable.srchTenantId;
            vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
          }
        } else {
          vm.dataloader = false; // Progressbar 숨김

          console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }

      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    }

    // 등록수정 화면 표시여부
    function getIsShowColumn(columnNm) {
      var result = false;
      var itemIndex = vm.srch.editColumns.indexOf(columnNm);

      result = (itemIndex > -1);
      return result;
    }

    // 필수항목 체크
    function getIsValidData() {
      var errMsg = '';
      if (isNullOrEmpty(vm.data.Mobile) && isNullOrEmpty(vm.data.Email)) {
        errMsg = errMsg + '- 휴대폰, 이메일 중 하나는 입력해 주세요.<br/>';
      }
      if (!isNullOrEmpty(vm.data.Mobile) && vm.data.Mobile != vm.tmpMobile) {
        if (vm.dupMobile > 0) {
          errMsg = errMsg + '- 중복된 휴대폰 정보가 존재합니다.<br/>';
        }
      }
      if (!isNullOrEmpty(vm.data.Email) && vm.data.Email != vm.tmpEmail) {
        if (vm.dupEmail > 0) {
          errMsg = errMsg + '- 중복된 이메일 정보가 존재합니다.<br/>';
        }
      }
      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }
      return true;
    }

    // 저장
    function setData() {

      if (getIsValidData() == false) {
        return;
      }

      // 내용
      vm.data.tableNm = EDIT_TABLE_NM;             // 작업 테이블명
      vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
      vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

      var data = vm.data; // 사용자 입력 데이터

      // 발송대기가 아니면서 휴대폰이나 이메일이 변경된 경우 발송대기로 변경하여 재발송 대상이 되게 한다.
      if(vm.data.ResultStatus != "N" &&
        ((vm.data.SendType == "S" && vm.data.Mobile != vm.tmpMobile) || (vm.data.SendType == "E" && vm.data.Email != vm.tmpEmail))) {
          vm.data.ResultStatus = "N";
        }

      if (isNullOrEmpty(vm.data.keyId)) {
        // 신규 등록
        data.mapCode = INSERT_SQL;

        postApi.insert(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      } else {
        // 수정
        data.RelateDataId = data.keyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }
    }

    // 저장 후 처리
    function setInsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].KeyId !== null ||
          result.body.docs[0].NewKeyId !== null ||
          result.body.docs[0].RelateDataId !== null
        ) {
          // KeyId 조회
          if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
            vm.data.KeyId = result.body.docs[0].NewKeyId;
          } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
            vm.data.KeyId = result.body.docs[0].KeyId;
          } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
            vm.data.KeyId = result.body.docs[0].RelateDataId;
          }

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function () {
              $uibModalInstance.close(null);
            }
          });
          return;
        }
      }

      console.error("Error> setInsertUpdateDetail()");
      gAlert('', result.body.docs[0].errMessage);
    }

    // 휴대폰, 이메일 중복 체크
    function getIsDup(type) {
      var data = {};
      switch(type){
        case "M": data = {keyId: vm.data.keyId, Mobile: vm.data.Mobile}; break;
        case "E": data = {keyId: vm.data.keyId, Email: vm.data.Email}; break;
      }
      data.mapCode = DUPCHK_SQL;
      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          switch(type){
            case "M": vm.dupMobile = result.body.docs.length; break;
            case "E": vm.dupEmail = result.body.docs.length; break;
          }
        } else {
          gAlert('', result.body.docs[0].errMessage);
        }
      }, function (error) {
        console.error("Error> getIsDup()");
        console.table(error);
      });
    }


    // 닫기
    function closeWin() {
      $uibModalInstance.close();
    }

    // 함수 정의
    vm.getData = getData;                     // 데이터 조회
    vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
    vm.setData = setData;                     // 데이터 저장
    vm.getIsDup = getIsDup;    // 중복 체크
    vm.closeWin = closeWin;  // 닫기

    // 데이터 조회
    //getData();


  }, ]);

/**
 * 캠페인 발송용 대상자 추가/변경.
 * - 고객 추가시에 DB에 바로 추가하지 않고. List에 가지고 있다가 저장할때 일괄 적용할것.
 */
webapp.controller('GroupEditModal2Ctrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function GroupEditModal2Ctrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {

    var vm = this;
    vm.data = toModalData;
    vm.originData = angular.copy(vm.data);

    // 필수항목 체크
    function getIsValidData() {
      var errMsg = '';
      if(isNullOrEmpty(vm.data.CustNm)) {
        //errMsg = errMsg + '- 이름을 입력해 주세요.<br/>';
        vm.data.CustNm = '';
      }

      if(isNullOrEmpty(vm.data.Mobile) && isNullOrEmpty(vm.data.Email)) {
        errMsg = errMsg + '- 휴대폰 또는 이메일 정보를 입력해 주세요.<br/>';
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }
      return true;
    }

    // 저장
    function setData() {
      if (getIsValidData() == false) {
        return;
      }

      // 신규 추가의 경우 발송대기 상태
      if (isNullOrEmpty(vm.data.ResultStatus)) {
        vm.data.ResultStatus = "N";
        vm.data.ResultStatusConv = "발송대기";
      } else {
        // 발송대기가 아니면서 휴대폰이나 이메일이 변경된 경우 발송대기로 변경하여 재발송 대상이 되게 한다.
        if (vm.data.ResultStatus != "N" &&
            ((vm.data.SendType == "SMS" && vm.data.Mobile != vm.originData.Mobile)
                || (vm.data.SendType == "EMAIL" && vm.data.Email != vm.originData.Email))
        ) {
            vm.data.ResultStatus = "N";
            vm.data.ResultStatusConv = "발송대기";
        }
      }

      setInsertUpdateDetail();
    }

    // 저장 후 처리
    function setInsertUpdateDetail() {
      $uibModalInstance.close(vm.data);
    }

    // 닫기
    function closeWin() {
      $uibModalInstance.close();
    }

    // 함수 정의
    vm.setData = setData;    // 데이터 저장
    vm.closeWin = closeWin;  // 닫기
  }, ]);

/**
 * 캠페인 발송용 대상자 추가/변경.
 * - 고객 추가시에 DB에 바로 추가하지 않고. List에 가지고 있다가 저장할때 일괄 적용할것.
 */
webapp.controller('GroupEditModal3Ctrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function GroupEditModal3Ctrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {
    var vm = this;
    vm.data = toModalData;
    vm.originData = angular.copy(vm.data);

    vm.sendTypeNm = (vm.data.SendType == "SMS" ? "휴대폰" : "이메일");

    // 저장
    function setData() {
      var data = "";
      var chkNum = 0;
      var check = true;
      var dataArr;

      // var $objDirectData = $(opener.document).find("#ContentPage_hdnInsertDirectData");
      // var $objTotNum = $(opener.document).find("#ContentPage_targetCnt");
      // var $objCustNum = $(opener.document).find("#ContentPage_custNms");
      // var $objDirectNum = $(opener.document).find("#ContentPage_directNms");

      // focusOut이 되어야만 해당 정보를 읽기 때문에 "확인" 버튼을 누렀을 경우 강제로 마지막 Cell로 옮김
      grid.gotoCell(grid.getDataLength(), 0, true);

      if (grid.getDataLength() <= 0) {
          gAlert('', '추가된 정보가 없습니다.');
          return false;
      }

      var gridData = grid.getData();
      if (gridData != null) {
          $.each(gridData, function (i, jsonData) {
            if( ! isNullOrEmpty(jsonData.mobile)) {
              var mb = jsonData.mobile.trim();
              if (mb != "") {
                  if (!fnTelMobileNoCheck(mb)) {
                      gAlert('', mb + ' 휴대폰번호 형식이 아닙니다.');
                      check = false;
                      return false;
                  }
                  if (data == "") data = mb;
                  else data += ";" + mb;
                  //chkNum++;
              }
            }
            if( ! isNullOrEmpty(jsonData.email)) {
              var em = jsonData.email.trim();
              if (em != "") {
                  if (!isValidEmail(em)) {
                      gAlert('', em + ' 이메일 형식이 아닙니다.');
                      check = false;
                      return false;
                  }
                  if (data == "") data = em;
                  else data += ";" + em;
                  //chkNum++;
              }
            }
        });
      }

      if (check) {
          dataArr = fnGetUnique(gridData);
          $uibModalInstance.close(dataArr);
      }
      return false;
    }

    // 중복제거
    function fnGetUnique(list) {
      var uniqueList = [];
      var newList = [];

      if (vm.data.SendType == "SMS"){
        $.each(list, function (i, el) {
          if ($.inArray(el.mobile, uniqueList) === -1) {
            uniqueList.push(el.mobile);
            newList.push(el);
          }
        });
      } else if (vm.data.SendType == "EMAIL"){
        $.each(list, function (i, el) {
          if ($.inArray(el.email, uniqueList) === -1) {
            uniqueList.push(el.email);
            newList.push(el);
          }
        });
      }
      return newList;
    }

    // 저장 후 처리
    function setInsertUpdateDetail() {
      $uibModalInstance.close(vm.data);
    }

    // 닫기
    function closeWin() {
      $uibModalInstance.dismiss('cancel data');
    }

    // 함수 정의
    vm.setData = setData;    // 데이터 저장
    vm.closeWin = closeWin;  // 닫기
  }, ]);

webapp.controller('WjmPreModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', '$filter', 'wjmSurvey', 'StaticVariable', '$rootScope',
  function WjmPreModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm, $filter, wjmSurvey, StaticVariable, $rootScope) {
    var vm = this;

    // html 에서 사용하는 함수 연결
    vm.close = close;
    //vm.apply = apply;

    (function WjmPreModalCtrl() {
      vm.data = {};

      // 설문관련 변수
      vm.svyInfo = [];
      vm.svyPages = [];
      vm.svyQsts = [];
      vm.svyQstItems = [];
      vm.svyPagesType = 1;
      vm.svyPagesTypeTxt = "";
      vm.svyPagesCur = 1;
      vm.svyPagesTxt = "";
      vm.prevPagesType = 0;
      vm.prevPagesCur = 0;

      // 부모페이지의 전달값 삽입
      vm.svyInfo = angular.copy(toModalData.svyInfo);
      vm.svyPages = angular.copy(toModalData.svyPages);
      vm.svyQsts = angular.copy(toModalData.svyQsts);
      vm.svyQstItems = angular.copy(toModalData.svyQstItems);

      // 언어 변경
      vm.svyPagesTypeTxt = wjmSurvey.getLangData("L00006", vm.svyInfo.SvyLang);
      vm.svyPagesTxt = wjmSurvey.getLangData("L00009", vm.svyInfo.SvyLang);

      // 기타
      vm.svyResps = []; // 응답데이터
      vm.svyRespsSbj = [];
      vm.svyQstsCur = $filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur}, true); // 현재 페이지의 문제 데이터 (분기처리를 위함)
      vm.beginQtId = "";
      vm.isFailEnd = false;
      vm.timeLine = []; // 분기문항 사용인경우에는 뒤로가기 버튼 기능 구현을위해 타임라인 데이터 설정
      vm.timeNo = 0; // 타임라인 증가 번호
      vm.CutMsg = []; // Textarea bytes 계산

      $scope.wjmSurvey = wjmSurvey;

      setIsUseGotoPage();
      getLogoImg();

      /*
      vm.srch = {
        keyId: toModalData.keyId
      };
      */
    })();

    /**
     * 현재 페이지 문항 설정
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setQstsCur = function () {
      var k = 0;
      var qstsCur = [];
      var qt = [];

      if (!isNullOrEmpty(vm.beginQtId)) {
        qt = $filter('filter')(vm.svyQsts, {qtId: vm.beginQtId}, true)[0];
        if (!isNullOrEmpty(qt)) {
          vm.svyPagesCur = qt.PageNo;
          vm.svyPagesType = 2;
        }

        qstsCur = angular.copy($filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur}, true));
        /*
        qstsCur.forEach(function (i) {
          if (parseInt(i.QstSort) < parseInt(qt.QstSort)) {
            qstsCur.splice(qstsCur.indexOf(i), 1);
          }
        });
        */
        for (k = qstsCur.length - 1; k >= 0; k--) {
          if (parseInt(qstsCur[k].QstSort) < parseInt(qt.QstSort)) {
            qstsCur.splice(k, 1);
          }
        }
      }
      else {
        qstsCur = angular.copy($filter('filter')(vm.svyQsts, {PageNo: vm.svyPagesCur}, true));
      }

      vm.svyQstsCur = qstsCur;

      // 타임라인 저장
      vm.setTimeLine();

      vm.beginQtId = "";
    };

    /**
     * 다음페이지 시작 문항 설정
     * 설명: 페이지에 문항중 다음 버튼을 눌렀을때 가야되는 분기는 최종적으로 하나이며,
     * 해당페이지에 복수의 분기가 설정된 경우 마지막으로 클릭한 문항, 마지막으로 클릭한 문항의 보기순으로 우선권을 가짐
     * @param {string}
     * @return {boolean}
     */
    vm.setBeginQtId = function (qt, it, idx) {
      var itTmp = [];

      if (isNullOrEmpty(vm.svyResps[qt.qtId])) return false;
      if (typeof idx == "undefined" || idx == null) idx = 0;
      if (typeof it == "undefined" || it == null) {
        switch(qt.QstType){
          case "3" :
          case "C" :

            if(idx > 0) return false;
            if (isNullOrEmpty(vm.svyResps[qt.qtId][0])) return false;
            it = $filter('filter')(vm.svyQstItems, {itId: vm.svyResps[qt.qtId][0]}, true)[0];
        }
      }
      if (vm.svyResps[qt.qtId][idx] != it.itId) return false;

      if (!isNullOrEmpty(qt.GoToQstId)) {
        vm.beginQtId = qt.GoToQstId;
        return false;
      }

      if (!isNullOrEmpty(it.GoToQstId)) {
        vm.beginQtId = it.GoToQstId;
      }
      else {
        itTmp = $filter('filter')(vm.svyQstItems, {qtId: qt.qtId}, true);
        itTmp.forEach(function(i) {
          if (!isNullOrEmpty(i.GoToQstId)) {
            vm.beginQtId = "";
            return false;
          }
        });
      }

      return true;
    };

    /**
     * 미응답 문항 스타일변경
     * @param
     * @return
     */
    function setAddClssQst(qtId) {
      $("#divQstSubject_" + qtId).removeClass("svy-qst-chk").addClass("svy-qst-chk");
    }

    function setDelClssQst() {
      $("div[id^='divQstSubject_']").removeClass("svy-qst-chk");
    }

    /**
     * 입력항목 체크
     * @param
     * @return
     */
    function getIsValidData() {
      var j = 0;
      var isPass = true;
      var qstRespCnt = 0;
      var qstItemCnt = 0;

      setDelClssQst();

      if (vm.svyQstsCur.length == 0) {
        gAlert('', wjmSurvey.getLangData("L00012", vm.svyInfo.SvyLang), '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
        return false;
      }

      vm.svyQstsCur.forEach(function(i) {
        if (i.QstType == "R") return true;

        //그외유형
        if (isNullOrEmpty(vm.svyResps[i.qtId])
          || vm.svyResps[i.qtId].length == 0
          || (i.QstType != "1" && i.SelType != "M" && isNullOrEmpty(vm.svyResps[i.qtId][0]))
        ) {
          if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

          setAddClssQst(i.qtId);
          isPass = false;
          return false;
        }

        //다중선택형
        if (i.QstType == "1" && i.SelType == "M") {
          qstRespCnt = fnChkQstRespCnt(i.qtId, false);

          if (qstRespCnt < i.SelMin || qstRespCnt > i.SelMax) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }
        }
        //우선순위형
        else if (i.QstType == "3") {
          if (vm.svyInfo.QstPassYN == "Y") return true;

          qstRespCnt = fnChkQstRespCnt(i.qtId, true);

          // 순위 중복 오류
          if(qstRespCnt == -1){
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }

          if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

          if (i.QstTopCnt != qstRespCnt) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }

          for (j = 0; j < i.QstTopCnt; j++) {
            if (isNullOrEmpty(vm.svyResps[i.qtId][j])) {
              setAddClssQst(i.qtId);
              isPass = false;
              return false;
            }
          }
        }
        //척도형
        else if (i.QstType == "5") {
          if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

          qstRespCnt = fnChkQstRespCnt(i.qtId, false);
          qstItemCnt = $filter('filter')(vm.svyQstItems, {qtId: i.qtId}, true).length;

          if (qstRespCnt != qstItemCnt) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }
        }
        //분류형(이름,휴대폰)
        else if (i.QstType == "C" && (i.ClassfyCd == "NM" || i.ClassfyCd == "MB")) {
          if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

          if (isNullOrEmpty(vm.svyResps[i.qtId][0])
            || isNullOrEmpty(vm.svyResps[i.qtId][0].replaceAll(" ", ""))
          ) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }
        }
        //분류형(이메일)
        else if (i.QstType == "C" && i.ClassfyCd == "EM") {
          if (vm.svyInfo.QstPassYN == "Y" && i.QstPassYN == "Y") return true;

          if (Object.keys(vm.svyResps[i.qtId]).length < 2
            || isNullOrEmpty(vm.svyResps[i.qtId][0])
            || isNullOrEmpty(vm.svyResps[i.qtId][1])
          ) {
            setAddClssQst(i.qtId);
            isPass = false;
            return false;
          }
        }
      });

      if (!isPass) {
        if(qstRespCnt == -1) {
          // 우선순위 중복
          gAlert('', wjmSurvey.getLangData("L00030", vm.svyInfo.SvyLang), '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
        }
        else {
          gAlert('', wjmSurvey.getLangData("L00013", vm.svyInfo.SvyLang), '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
        }
      }

      return isPass;
    }

    /**
     * 페이지타입 변경
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setSvyPagesType = function (type) {
      switch (type) {
        case "PREV":
          if (vm.prevPagesCur > 0) {
            vm.svyPagesType = vm.prevPagesType;
            vm.svyPagesCur = vm.prevPagesCur;
            vm.beginQtId = "";
          }
          else {
            gAlert('', wjmSurvey.getLangData("L00014", vm.svyInfo.SvyLang) + '[P]', '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
            return false;
          }

          //vm.prevPagesType = 0;
          vm.prevPagesCur = 0;
          break;
        case "NEXT":
          if (vm.svyPagesType == 1) {
            vm.setPrevInfo();
            vm.svyPagesType++;
          }
          else if (vm.svyPagesType == 2) {
            if (!getIsValidData()) return false;
            vm.setPrevInfo();
            vm.svyPagesCur++;
          }
          else {
            gAlert('', wjmSurvey.getLangData("L00014", vm.svyInfo.SvyLang) + '[N]', '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
            return false;
          }

          break;
        case "END":
          if (vm.svyPagesType == 2) {
            if (!getIsValidData()) return false;
            if (Object.keys(vm.svyResps).length == 0) {
              gAlert('', wjmSurvey.getLangData("L00015", vm.svyInfo.SvyLang), '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
              return false;
            }

            vm.chkEndType();
          }
          else {
            gAlert('', wjmSurvey.getLangData("L00014", vm.svyInfo.SvyLang) + '[E]', '', wjmSurvey.getLangData("L00029", vm.svyInfo.SvyLang));
            return false;
          }

          vm.setPrevInfo();
          vm.svyPagesType++;
          break;
        default : break;
      }

      vm.setSvyPagesTypeNext();
    };

    /**
     * 페이지타입 변경 후처리
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setSvyPagesTypeNext = function() {

      // 현재페이지 내용 삽입
      if (vm.prevPagesType == 2) {
        vm.setQstsCur();
        vm.chkEndType();
      }

      // 상단 설문타입 텍스트 설정
      switch (vm.svyPagesType) {
        case 1: vm.svyPagesTypeTxt = wjmSurvey.getLangData("L00006", vm.svyInfo.SvyLang); break;
        case 2: vm.svyPagesTypeTxt = wjmSurvey.getLangData("L00007", vm.svyInfo.SvyLang); break;
        case 3: vm.svyPagesTypeTxt = wjmSurvey.getLangData("L00008", vm.svyInfo.SvyLang); break;
        default: break;
      }

      // 상단 페이지 텍스트 설정
      if (vm.svyPagesType == 1) {
        vm.svyPagesTxt = wjmSurvey.getLangData("L00009", vm.svyInfo.SvyLang);
      }
      else if (vm.svyPagesType == 2) {
        //vm.svyPagesTxt = vm.svyPagesCur + " / " + vm.svyPages.length + " 페이지 진행중";
        vm.svyPagesTxt = vm.svyPagesCur + " / " + vm.svyPages.length;
      }
      else if (vm.svyPagesType == 3) {
        vm.svyPagesTxt = wjmSurvey.getLangData("L00010", vm.svyInfo.SvyLang);
      }

      vm.backToTop();

      //console.log("vm.svyQsts", vm.svyQsts);
      //console.log("vm.svyQstItems", vm.svyQstItems);
      //console.log("vm.svyResps", vm.svyResps);
    };

    /**
     * 타임라인 설정
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setTimeLine = function () {
      vm.timeLine.push({
        timeNo: ++vm.timeNo
        , pagesType: vm.svyPagesType
        , pagesCur: vm.svyPagesCur
        , beginQtId: vm.beginQtId
        , datetime: $filter('date')(Date.now(), "yyyy-MM-dd H:mm:ss")
      });
    };

    /**
     * 이전페이지 정보 설정
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setPrevInfo = function () {
      vm.prevPagesType = vm.svyPagesType;
      vm.prevPagesCur = vm.svyPagesCur;

      //console.log("1", vm.prevPagesType);
      //console.log("2", vm.prevPagesCur);
    };

    /**
     * 종료 처리
     *
     * @param {string}
     * @return {boolean}
     */
    vm.chkEndType = function () {
      var qt = $filter('filter')(vm.svyQstsCur, {QstEndType: 'F'}, true);

      if (qt.length > 0) {
        vm.isFailEnd = true;
      }
      else {
        vm.isFailEnd = false;
      }
    };

    /**
     * 설문버튼 상태변경
     *
     * @param {string}
     * @return {boolean}
     */
    vm.showSvyBtn = function (type) {
      var rtn = false;

      switch (type) {
        case "PREV":
          if (vm.prevPagesCur > 0 && vm.svyPagesType == 2) rtn = true;
          break;
        case "NEXT":
          if (vm.isFailEnd) {
            rtn = false;
          }
          else if (
            vm.svyPagesType == 1
            || (vm.svyPagesType == 2 && vm.svyPagesCur != vm.svyPages.length && vm.svyPages.length != 0)
          ) {
            rtn = true;
          }
          break;
        case "END":
          if (vm.isFailEnd) {
            rtn = false;
          }
          else if (vm.svyPagesType == 2 && (vm.svyPagesCur == vm.svyPages.length || vm.svyPages.length == 0)) {
            rtn = true;
          }
          break;
        default : break;
      }

      return rtn;
    };

    /**
     * 이메일 도메인 선택 변경
     *
     * @param {string}
     * @return {boolean}
     */
    vm.chgQstEmailDomain = function (svyResps, qtId) {
      if (isNullOrEmpty(svyResps[qtId][2])) {
        svyResps[qtId][1] = "";
      }
      else {
        svyResps[qtId][1] = svyResps[qtId][2];
      }
    };

    /**
     * 해당 설문에서 분기 사용여부 체크
     *
     * @param {string}
     * @return {boolean}
     */
    function setIsUseGotoPage() {
      var rtn = false;
      // 필터로 체크되지 않아서 반복문으로 체크
      /*
      if ($filter('filter')(vm.svyQsts, {GoToQstId: '!'}, true).length > 0
        || $filter('filter')(vm.svyQstItems, {GoToQstId: '!'}, true).length > 0
      ) vm.isUseGotoPage = true;
      */

      vm.svyQsts.forEach(function (i) {
        if (!isNullOrEmpty(i.GoToQstId)) {
          rtn = true;
          return false;
        }
      });

      if (!rtn) {
        vm.svyQstItems.forEach(function (i) {
          if (!isNullOrEmpty(i.GoToQstId)) {
            rtn = true;
            return false;
          }
        });
      }

      vm.isUseGotoPage = rtn;
    }

    /**
     * 업체 로고이미지 조회
     *
     * @param
     * @return
     */
    function getLogoImg() {
      if (isNullOrEmpty(vm.svyInfo.Manager)) {
        return;
      }

      var data = {};
      data.tableNm = "users";
      data.TableId = vm.svyInfo.Manager;
      data.grpId = "1";
      data.mapCode = 'FileAttach.getFileListOri';

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          /*
          var item = result.body.docs[0];
          var obj = {
            id: item.fileId,
            isLoaded: true,
            link: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalFolderNm + "&fileName=" + item.LogicalFileNm),
            src: StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
            fileName: item.LogicalFileNm,
            size: item.FileSize,
            fileKey: item.PhysicalFileNm,
            typeId: 'file',
            path: item.PhysicalPath,
            downloadCnt: item.DownloadCnt,
            delState: ''
          };
          */

          if (result.body.docs.length > 0) {
            vm.svyInfo.logoSrc = StaticVariable.getUrl('/attach/file/' + result.body.docs[0].PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey);
          }
        }
      }, function (error) {
        console.error("Error> getLogoImg()");
        console.table(error);
      });
    }

    /**
     * 문항 응답 갯수 조회
     *
     * @param
     * @return
     */
    function fnChkQstRespCnt(qtId, dupChk) {
      var rtn = 0;
      var tmpArr = []; // 중복제거

      if (!isNullOrEmpty(vm.svyResps[qtId])) {
        angular.forEach(vm.svyResps[qtId], function(i) {
          if (!isNullOrEmpty(i)) {
            rtn++;
            if(dupChk && !tmpArr.includes(i)) {
              tmpArr.push(i);
            }
          }
        });
      }

      if(dupChk) {
        if(rtn == tmpArr.length) {
          return rtn;
        }
        else {
          return -1;
        }
      }
      else {
        return rtn;
      }
    }

    // 발송내용 바이트 체크
    vm.chkSbjBytes = function(id, len) {
      var sbj = vm.svyResps[id][0];
      if(!isNullOrEmpty(sbj)) {
        var bytes = sbj.length + (escape(sbj) + "%u").match(/%u/g).length - 1;
        if (bytes > len) {
          sbj = fnCutMsg(sbj, len);
          bytes = len;
        }
        vm.CutMsg[id] = bytes;
      }
    };

    // 발송내용 자르기
    function fnCutMsg(str, len) {
      var ret = '';
      var i;
      var msglen = 0;
      for (i = 0; i < str.length; i++) {
        var ch = str.charAt(i);
        if (escape(ch).length > 4) {
          msglen += 2;
        } else {
          msglen++;
        }
        if (msglen > len) break;
        ret += ch;
      }
      return ret;
    }

    /**
     * 스크롤 위로 옮기기
     *
     * @param
     * @return
     */
    vm.backToTop = function() {
      //$(".modal-content").animate({ scrollTop: 0 }, 1000);
    };

    /**
     * 닫기 버튼 이벤트
     *
     * @param
     * @return
     */
    function close() {
      $uibModalInstance.dismiss('cancel data');
    }
  } ]);

webapp.controller('WjmQstModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', '$filter', 'StaticVariable', '$rootScope', 'wjmSurvey',
  function WjmQstModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm, $filter, StaticVariable, $rootScope, wjmSurvey) {
    var vm = this;

    // html 에서 사용하는 함수 연결
    vm.close = close;
    vm.apply = apply;
    vm.chgQstSec = chgQstSec;

    (function WjmQstModalCtrl() {
      vm.data = {};

      // 설문관련 변수
      vm.svyQsts = [];
      vm.svyQstItems = [];
      vm.qt = [];
      vm.it = [];
      vm.classfyList = [];
      vm.classfyListLev1 = [];
      vm.classfyListLev2 = [];
      vm.clientEmailList = [];
      vm.imageList = [];
      vm.oClassfyCd = "";

      vm.qstSecList2 = [];

      $scope.wjmSurvey = wjmSurvey;

      // 부모페이지의 전달값 삽입
      vm.svyQsts = angular.copy(toModalData.svyQsts);
      vm.svyQstItems = angular.copy(toModalData.svyQstItems);
      vm.qt = $filter('filter')(vm.svyQsts, {qtId: toModalData.qtId}, true)[0];
      vm.it = $filter('filter')(vm.svyQstItems, {qtId: toModalData.qtId}, true);

      //vm.manager = toModalData.manager;
      vm.SvyTypeId = toModalData.SvyTypeId;
      vm.ClassfyInfoId = toModalData.ClassfyInfoId;
      vm.pageType = isNullOrEmpty(toModalData.pageType) ? "" : toModalData.pageType;

      /*
      vm.srch = {
        keyId: toModalData.keyId
      };
      */

      if (!isNullOrEmpty(vm.SvyTypeId)) {
        getQstSecList();
      }

      switch (vm.qt.QstType) {
        case "4":
          // 이미지형
          getImageList();
          break;

        case "C":
          // 분류정보
          vm.oClassfyCd = vm.qt.ClassfyCd;
          setClassfyCommon();

          if (!isNullOrEmpty(vm.ClassfyInfoId)) {
            getClassfyList();
          }
          else {
            vm.classfyListLev1 = $filter('filter')(vm.classfyList, {ClassfyLevel: "1"}, true);
            vm.classfyListLev2 = $filter('filter')(vm.classfyList, {ClassfyLevel: "2"}, true);

            vm.clientEmailList = angular.copy(wjmSurvey.qstEmailDomainList);
            var tmp = $filter('filter')(vm.classfyListLev2, {ClassfyCd: "EM"}, true);
            tmp.forEach(function(em) {
              vm.clientEmailList.unshift({txt: em.ClassfyNm, val: em.ClassfyNm});
            });
          }
          break;

        default: break;
      }
    })();

    /**
     * 보기 추가
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setSvyQstItemAdd = function () {
      var nextItId = wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems);

      if (vm.it.length >= wjmSurvey.maxSvyQstItemsCnt || vm.svyQstItems.length >= wjmSurvey.maxSvyQstItemsCntAll) {
        gAlert('', "더이상 보기를 만들 수 없습니다.");
        return false;
      }

      switch (vm.qt.QstType) {
        // 선택형
        case "1":
          vm.it.push({
            itId: nextItId,
            qtId: vm.qt.qtId,
            stat: "I",
            QstItemNo: vm.it.length + 1,
            QstItemContents: wjmSurvey.txtQstItemContents,
            QstItemContents2: "",
            QstItemScore: "0",
            GoToQstId: "",
            ClassfyId: "",
            QstItemImgId: ""
          });
          break;

        // 우선순위형
        case "3":
          vm.it.push({
            itId: nextItId,
            qtId: vm.qt.qtId,
            stat: "I",
            QstItemNo: vm.it.length + 1,
            QstItemContents: wjmSurvey.txtQstItemContents,
            QstItemContents2: "",
            QstItemScore: "0",
            GoToQstId: "",
            ClassfyId: "",
            QstItemImgId: ""
          });
          break;

        // 이미지형
        case "4":
          vm.it.push({
            itId: nextItId,
            qtId: vm.qt.qtId,
            stat: "I",
            QstItemNo: vm.it.length + 1,
            QstItemContents: wjmSurvey.txtQstItemContents,
            QstItemContents2: "",
            QstItemScore: "0",
            GoToQstId: "",
            ClassfyId: "",
            QstItemImgId: ""
          });
          break;

        // 척도형
        case "5":
          vm.it.push({
            itId: nextItId,
            qtId: vm.qt.qtId,
            stat: "I",
            QstItemNo: vm.it.length + 1,
            QstItemContents: wjmSurvey.txtQstItemContents,
            //QstItemContents2: wjmSurvey.txtQstItemContents,
            QstItemContents2: "",
            QstItemScore: "0",
            GoToQstId: "",
            ClassfyId: "",
            QstItemImgId: ""
          });
          break;

        default : break;
      }

      if (vm.pageType == "FORM") vm.it[vm.it.length - 1].FormQstItemId = "";
      else vm.it[vm.it.length - 1].SvyQstItemId = "";
    };

    /**
     * 보기 삭제
     *
     * @param {string}
     * @return {boolean}
     */
    vm.setSvyQstItemDel = function (itId) {
      var it = [];
      var no = 0;

      gConfirm('', '선택한 보기를 삭제하고 보기번호를 순차적으로 재정의 하시겠습니까?', {
        btn: '',
        fn: function () {
          it = $filter('filter')(vm.it, {itId: itId}, true)[0];

          if (
            (vm.pageType == "FORM" && isNullOrEmpty(it.FormQstItemId))
            || (vm.pageType != "FORM" && isNullOrEmpty(it.SvyQstItemId))
          ) {
            vm.it.splice(vm.it.indexOf(it), 1);
          }
          else {
            it.stat = "D";
          }

          vm.it.forEach(function(i, idx) {
            no = idx + 1;
            if (i.QstItemNo != no) {
              i.stat = "U";
              i.QstItemNo = no;
            }
          });

          // 우선순위형인 경우
          if (vm.qt.QstType == "3" && vm.qt.QstTopCnt > vm.it.length) {
            vm.qt.stat = "U";
            vm.qt.QstTopCnt = vm.it.length;
          }

          // 선택형-다중선택인 경우
          if (vm.qt.QstType == "1" && vm.qt.SelType == "M") {
            if (vm.qt.SelMin > vm.it.length) {
              vm.qt.stat = "U";
              vm.qt.SelMin = vm.it.length;
            }
            if (vm.qt.SelMax > vm.it.length) {
              vm.qt.stat = "U";
              vm.qt.SelMax = vm.it.length;
            }
          }
        }
      }, {
        btn: '',
        fn: function () {
          // 취소
        }
      });
    };

    /**
     * 문항,보기 클릭 이벤트
     *
     * @param {string}
     * @return {boolean}
     */
    vm.clickQstSubject = function () {
      if (vm.qt.QstSubject == wjmSurvey.txtQstSubject || vm.qt.QstSubject == wjmSurvey.txtQstSubjectR) vm.qt.QstSubject = "";
    };
    vm.clickQstItemContents = function (it) {
      if (it.QstItemContents == wjmSurvey.txtQstItemContents) it.QstItemContents = "";
    };
    /*
    vm.clickQstItemContents2 = function (it) {
      if (it.QstItemContents2 == wjmSurvey.txtQstItemContents) it.QstItemContents2 = "";
    };
    */
    vm.clickQstItemScore = function (it) {
      if (it.QstItemScore == "0") it.QstItemScore = "";
    };

    /**
     * 문항,보기 포커스아웃 이벤트
     *
     * @param {string}
     * @return {boolean}
     */
    vm.blurQstSubject = function () {
      if (vm.qt.QstType == "R" && vm.qt.QstSubject == "") vm.qt.QstSubject = wjmSurvey.txtQstSubjectR;
      else if (vm.qt.QstSubject == "") vm.qt.QstSubject = wjmSurvey.txtQstSubject;
    };
    vm.blurQstItemContents = function (it) {
      if (it.QstItemContents == "") it.QstItemContents = wjmSurvey.txtQstItemContents;
    };
    /*
    vm.blurQstItemContents2 = function (it) {
      if (it.QstItemContents2 == "") it.QstItemContents2 = wjmSurvey.txtQstItemContents;
    };
    */
    vm.blurQstItemScore = function (it) {
      if (it.QstItemScore == "") it.QstItemScore = "0";
    };

    /**
     * 이메일 도메인 선택 변경
     *
     * @param {string}
     * @return {boolean}
     */
    vm.chgQstEmailDomain = function () {
      if (isNullOrEmpty(vm.qstEmailDomainList)) {
        vm.qstEmailDomain = "";
      }
      else {
        vm.qstEmailDomain = vm.qstEmailDomainList;
      }
    };

    /**
     * 이미지 파일 변경
     *
     * @param {string}
     * @return {boolean}
     */
    vm.chgQstImgId = function (qt) {
      var img = [];

      qt.qtImgSrc = "";
      if (isNullOrEmpty(qt.QstImgId)) return false;

      img = $filter('filter')(vm.imageList, {AttachmentId: qt.QstImgId}, true);
      if (img.length > 0) qt.qtImgSrc = StaticVariable.getUrl('/attach/file/' + img[0].PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey);
    };

    vm.chgQstItemImgId = function (it) {
      var img = [];

      it.itImgSrc = "";
      if (isNullOrEmpty(it.QstItemImgId)) return false;

      img = $filter('filter')(vm.imageList, {AttachmentId: it.QstItemImgId}, true);
      if (img.length > 0) it.itImgSrc = StaticVariable.getUrl('/attach/file/' + img[0].PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey);
    };

    // 보기별결과 또는 보기별가산 영역일 경우에 사용할 하위영역 목록
    function chgQstSec () {
      vm.qstSecList2 = [];
      if( ! isNullOrEmpty(vm.qt.QstSecId)) {
        var tmp = $filter('filter')(vm.qstSecList, {SecId2: vm.qt.QstSecId}, true);
        if(tmp.length > 0 && tmp[0].QstSecLevel == 1 && (tmp[0].ScoringType == "R" || tmp[0].ScoringType == "P")) {
          vm.qt.ScoringType = tmp[0].ScoringType;
          vm.qstSecList2 = $filter('filter')(vm.qstSecList, {SecId1: tmp[0].SecId1, QstSecLevel: 2}, true);
        }
      }
    }

    /**
     * 필수항목 체크
     * @param
     * @return
     */
    /*
    function getIsValidData() {
      var errMsg = '';
      if (isNullOrEmpty(vm.data.QstNo)) {
        errMsg = errMsg + '- No를 입력하세요.<br/>';
      }

      if (isNullOrEmpty(vm.data.QstType)) {
        errMsg = errMsg + '- 구분을 선택하세요.<br/>';
      }

      if (isNullOrEmpty(vm.data.QstSubject)) {
        errMsg = errMsg + '- 제목을 입력하세요.<br/>';
      }

      if (vm.data.QstType == "300") {
        if (isNullOrEmpty(vm.data.QstItemScore)) {
          errMsg = errMsg + '- 배점을 입력하세요.<br/>';
        }
      }
      else {
        if (isNullOrEmpty(vm.qstItemLists)) {
          if (isNullOrEmpty(vm.data.NewQstItemNo)) {
            errMsg = errMsg + '- 항목 No를 입력하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.NewQstItemContents)) {
            errMsg = errMsg + '- 항목 내용을 입력하세요.<br/>';
          }

          if (isNullOrEmpty(vm.data.NewQstItemScore)) {
            errMsg = errMsg + '- 항목 배점을 입력하세요.<br/>';
          }
        }
        else {
          angular.forEach(vm.qstItemLists, function (item) {
            if (isNullOrEmpty(item.QstItemNo) || isNullOrEmpty(item.QstItemContents) || isNullOrEmpty(item.QstItemScore)) {
              errMsg = errMsg + '- 기존 문항항목 데이터중 빈항목이 존재합니다.<br/>';
            }
          });
        }
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      return true;
    }
    */

    /**
     * 문항영역 목록
     * @param
     * @return
     */
    function getQstSecList() {
      var data = {
        mapCode: 'WjmSurvey.getQstSecDropListConcat',
        keyId : vm.SvyTypeId
      };

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.qstSecList = result.body.docs;
            chgQstSec();
          } else {
            vm.qstSecList = {};
          }
        }
      }, function(error) {
        console.error('Error> getQstSecList()', status, error);
      });
    }

    /**
     * 문항이미지 목록
     * @param
     * @return
     */
    function getImageList() {
      var data = {
        mapCode: 'WjmSurvey.getImageDropListConcat'
      };

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {

            vm.imageList = result.body.docs;

            vm.chgQstImgId(vm.qt);
            vm.it.forEach(function(i){
              vm.chgQstItemImgId(i);
            });
          }
        }
      }, function(error) {
        console.error('Error> getImageList()', status, error);
      });
    }

    /**
     * 분류정보 목록
     * @param
     * @return
     */
    function getClassfyList() {
      var data = {
        mapCode: 'WjmSurvey.getClassfyList',
        keyId : vm.ClassfyInfoId,
        pageType : 'wjmQstModal'
      };

      postApi.select(data, function (result) {
        if(result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {

            //vm.classfyList = result.body.docs;
            result.body.docs.forEach(function(i) {
              vm.classfyList.push({
                ClassfyId: i.ClassfyId,
                ClassfyInfoId: i.ClassfyInfoId,
                ClassfyCd: i.ClassfyCd,
                ClassfyNm: i.ClassfyNm,
                ClassfyLevel: i.ClassfyLevel,
                SortSeq: i.SortSeq
              });
            });

            vm.classfyListLev1 = $filter('filter')(vm.classfyList, {ClassfyLevel: "1"}, true);
            vm.classfyListLev2 = $filter('filter')(vm.classfyList, {ClassfyLevel: "2"}, true);

            vm.clientEmailList = angular.copy(wjmSurvey.qstEmailDomainList);
            var tmp = $filter('filter')(vm.classfyListLev2, {ClassfyCd: "EM"}, true);
            tmp.forEach(function(em) {
              vm.clientEmailList.unshift({txt: em.ClassfyNm, val: em.ClassfyNm});
            });
          }
        }
      }, function(error) {
        console.error('Error> getClassfyList()', status, error);
      });
    }

    /**
     * 공통 분류정보 삽입
     * @param
     * @return
     */
    function setClassfyCommon() {
      // 공통 분류 삽입
      vm.classfyList.push({
        ClassfyId: "NM",
        ClassfyInfoId: "",
        ClassfyCd: "",
        ClassfyNm: "이름",
        ClassfyLevel: "1",
        SortSeq: vm.classfyList.length + 1
      });

      vm.classfyList.push({
        ClassfyId: "GD",
        ClassfyInfoId: "",
        ClassfyCd: "",
        ClassfyNm: "성별",
        ClassfyLevel: "1",
        SortSeq: vm.classfyList.length + 1
      });

      vm.classfyList.push({
        ClassfyId: "MB",
        ClassfyInfoId: "",
        ClassfyCd: "",
        ClassfyNm: "휴대폰",
        ClassfyLevel: "1",
        SortSeq: vm.classfyList.length + 1
      });

      /*
      vm.classfyList.push({
        ClassfyId: "EM",
        ClassfyInfoId: "",
        ClassfyCd: "",
        ClassfyNm: "이메일",
        ClassfyLevel: "1",
        SortSeq: vm.classfyList.length + 1
      });
      */
    }

    /**
     * 적용 버튼 이벤트
     *
     * @param
     * @return
     */
    function apply() {
      var i = 0;
      var classfyLev2 = [];
      var pQt = [];
      var pIt = [];
      var it = [];

      // 기존 데이터 배열 삭제
      /*
      for (i = toModalData.svyQsts.length - 1; i >= 0; i--) {
        if (toModalData.svyQsts[i].qtId == vm.qt.qtId) toModalData.svyQsts.splice(i, 1);
      }
      */
      for (i = toModalData.svyQstItems.length - 1; i >= 0; i--) {
        if (toModalData.svyQstItems[i].qtId == vm.qt.qtId) {
          if (vm.qt.QstType == "C") {
            if (vm.qt.ClassfyCd != vm.oClassfyCd) {
              if ((vm.pageType == "FORM" && isNullOrEmpty(toModalData.svyQstItems[i].FormQstItemId))
                || (vm.pageType != "FORM" && isNullOrEmpty(toModalData.svyQstItems[i].SvyQstItemId))
              ) {
                toModalData.svyQstItems.splice(i, 1);
              }
              else {
                toModalData.svyQstItems[i].stat = "D";
              }
            }
          }
          else {
            toModalData.svyQstItems.splice(i, 1);
          }
        }
      }

      pQt = $filter('filter')(toModalData.svyQsts, {qtId: vm.qt.qtId}, true)[0];

      // 입력 데이터 추가
      switch (vm.qt.QstType) {

        // 선택형
        case "1":
          pQt.stat = "U";
          pQt.QstSubject = vm.qt.QstSubject;
          pQt.QstFontSize = vm.qt.QstFontSize;
          pQt.QstSecId = vm.qt.QstSecId;
          pQt.SelType = vm.qt.SelType;
          pQt.SelMin = vm.qt.SelMin;
          pQt.SelMax = vm.qt.SelMax;
          pQt.QstPassYN = vm.qt.QstPassYN;

          vm.it.forEach(function(j) {
            if (isNullOrEmpty(j.stat)) j.stat = "U";
            toModalData.svyQstItems.push(j);
          });

          break;

        // 입력형
        case "2":
          pQt.stat = "U";
          pQt.QstSubject = vm.qt.QstSubject;
          pQt.QstFontSize = vm.qt.QstFontSize;
          pQt.InputType = vm.qt.InputType;
          pQt.InputHint = vm.qt.InputHint;
          pQt.QstPassYN = vm.qt.QstPassYN;

          break;

        // 우선순위형
        case "3":
          pQt.stat = "U";
          pQt.QstSubject = vm.qt.QstSubject;
          pQt.QstFontSize = vm.qt.QstFontSize;
          pQt.QstTopCnt = vm.qt.QstTopCnt;
          pQt.QstPassYN = vm.qt.QstPassYN;

          vm.it.forEach(function(j) {
            if (isNullOrEmpty(j.stat)) j.stat = "U";
            toModalData.svyQstItems.push(j);
          });

          break;

        // 이미지형
        case "4":
          pQt.stat = "U";
          pQt.QstSubject = vm.qt.QstSubject;
          pQt.QstFontSize = vm.qt.QstFontSize;
          pQt.QstSecId = vm.qt.QstSecId;
          pQt.QstImgId = vm.qt.QstImgId;
          pQt.qtImgSrc = vm.qt.qtImgSrc;
          pQt.QstPassYN = vm.qt.QstPassYN;

          vm.it.forEach(function(j) {
            if (isNullOrEmpty(j.stat)) j.stat = "U";
            toModalData.svyQstItems.push(j);
          });

          break;

        // 척도형
        case "5":
          pQt.stat = "U";
          pQt.QstSubject = vm.qt.QstSubject;
          pQt.QstFontSize = vm.qt.QstFontSize;
          pQt.ScaleMax = vm.qt.ScaleMax;
          pQt.ScaleOrder = vm.qt.ScaleOrder;
          pQt.QstPassYN = vm.qt.QstPassYN;

          vm.it.forEach(function(j) {
            if (isNullOrEmpty(j.stat)) j.stat = "U";
            toModalData.svyQstItems.push(j);
          });

          break;

        // 분류정보
        case "C":
          pQt.stat = "U";
          pQt.QstSubject = vm.qt.QstSubject;
          pQt.QstFontSize = vm.qt.QstFontSize;
          pQt.ClassfyCd = vm.qt.ClassfyCd;
          pQt.QstPassYN = vm.qt.QstPassYN;

          if (vm.qt.ClassfyCd != vm.oClassfyCd) {
            classfyLev2 = $filter('filter')(vm.classfyListLev2, {ClassfyCd: vm.qt.ClassfyCd}, true);

            vm.it = [];
            for (i = 0; i < classfyLev2.length; i++) {
              vm.it.push({
                itId: wjmSurvey.getSvyCode("IT", vm.svyQsts, vm.svyQstItems),
                qtId: vm.qt.qtId,
                stat: "I",
                QstItemNo: vm.it.length + 1,
                QstItemContents: classfyLev2[i].ClassfyNm,
                QstItemScore: "0",
                GoToQstId: "",
                ClassfyId: classfyLev2[i].ClassfyId
              });

              if (vm.pageType == "FORM") vm.it[i].FormQstItemId = "";
              else vm.it[i].SvyQstItemId = "";

              toModalData.svyQstItems.push(vm.it[i]);
            }
          }

          break;

        // 설명글
        case "R":
          pQt.stat = "U";
          pQt.QstSubject = vm.qt.QstSubject;
          pQt.QstFontSize = vm.qt.QstFontSize;
          pQt.QstEndType = vm.qt.QstEndType;

          break;

        default : break;
      }

      $uibModalInstance.close();
    }

    /**
     * 닫기 버튼 이벤트
     *
     * @param
     * @return
     */
    function close() {
      $uibModalInstance.dismiss('cancel data');
    }
  } ]);

webapp.controller('WjmQstGotoModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', '$filter', 'wjmSurvey',
  function WjmQstGotoModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm, $filter, wjmSurvey) {
    var vm = this;

    // html 에서 사용하는 함수 연결
    vm.close = close;
    vm.apply = apply;

    (function WjmQstGotoModalCtrl() {
      vm.data = {};

      // 설문관련 변수
      vm.svyPages = [];
      vm.svyQsts = [];
      vm.svyQstItems = [];
      vm.qt = [];
      vm.it = [];
      vm.gotoList = [];

      $scope.wjmSurvey = wjmSurvey;

      // 부모페이지의 전달값 삽입
      vm.svyPages = angular.copy(toModalData.svyPages);
      vm.svyQsts = angular.copy(toModalData.svyQsts);
      vm.svyQstItems = angular.copy(toModalData.svyQstItems);
      vm.qt = $filter('filter')(vm.svyQsts, {qtId: toModalData.qtId}, true)[0];
      vm.it = $filter('filter')(vm.svyQstItems, {qtId: toModalData.qtId}, true);

      //vm.pageType = isNullOrEmpty(toModalData.pageType) ? "" : toModalData.pageType;

      /*
      vm.srch = {
        keyId: toModalData.keyId
      };
      */

      getGotoList();
    })();

    /**
     * 문항,보기 변경 이벤트
     *
     * @param {string}
     * @return {boolean}
     */
    vm.chgQstGotoList = function () {
      var i = 0;
      if (!isNullOrEmpty(vm.qt.GoToQstId)) {
        vm.it.forEach(function(i) {
          i.GoToQstId = "";
          //i.stat = "U";
        });
      }
    };
    vm.chgQstItemGotoList = function (i) {
      if (!isNullOrEmpty(vm.it[i].GoToQstId)) {
        vm.qt.GoToQstId = "";
        //vm.qt.stat = "U";
      }
    };

    /**
     * 분기목록
     * @param
     * @return
     */
    function getGotoList() {
      var i = 0;
      var j = 0;
      var qt = [];

      for (i = 0; i < vm.svyPages.length; i++) {
        qt = $filter('filter')(vm.svyQsts, {PageNo: vm.svyPages[i].PageNo}, true);

        for (j = 0; j < qt.length; j++) {
          if (qt[j].qtId != toModalData.qtId) {
            if (qt[j].stat != "D") {
              vm.gotoList.push({
                qtId: qt[j].qtId,
                gotoTxt: "[" + qt[j].PageNo + "페이지] " + wjmSurvey.getQstTypeNm(qt[j].QstType) + " " + (qt[j].QstNo == "0" ? "" : qt[j].QstNo + ".") + qt[j].QstSubject
              });
            }
          }
        }
      }
    }

    /**
     * 적용 버튼 이벤트
     *
     * @param
     * @return
     */
    function apply() {
      var i = 0;
      var qt = [];
      var it = [];

      qt = $filter('filter')(toModalData.svyQsts, {qtId: toModalData.qtId}, true)[0];

      if (qt.GoToQstId != vm.qt.GoToQstId) {
        qt.stat = "U";
        qt.GoToQstId = vm.qt.GoToQstId;
      }

      // 입력 데이터 추가
      switch (vm.qt.QstType) {
        // 선택형, 이미지형, 분류정보
        case "1":
        case "3":
        case "4":
        case "C":

          for (i = 0; i < vm.it.length; i++) {
            it = $filter('filter')(toModalData.svyQstItems, {itId: vm.it[i].itId}, true)[0];

            if (it.GoToQstId != vm.it[i].GoToQstId) {
              qt.stat = "U";
              it.stat = "U";
              it.GoToQstId = vm.it[i].GoToQstId;
            }
          }
          break;

        default : break;
      }

      $uibModalInstance.close();
    }

    /**
     * 닫기 버튼 이벤트
     *
     * @param
     * @return
     */
    function close() {
      $uibModalInstance.dismiss('cancel data');
    }
  } ]);

webapp.controller('WjmQstMoveModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', '$filter', 'wjmSurvey',
  function WjmQstMoveModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm, $filter, wjmSurvey) {
    var vm = this;

    // html 에서 사용하는 함수 연결
    vm.close = close;
    vm.apply = apply;

    (function WjmQstMoveModalCtrl() {
      vm.data = {};

      // 설문관련 변수
      vm.svyPages = [];
      vm.svyQsts = [];
      vm.qt = [];
      vm.moveList = [];

      // 부모페이지의 전달값 삽입
      vm.svyPages = angular.copy(toModalData.svyPages);
      vm.svyQsts = angular.copy(toModalData.svyQsts);
      //vm.qt = $filter('filter')(vm.svyQsts, {qtId: toModalData.qtId}, true)[0];
      vm.qt = $filter('filter')(toModalData.svyQsts, {qtId: toModalData.qtId}, true)[0];
      vm.pageType = isNullOrEmpty(toModalData.pageType) ? "" : toModalData.pageType;

      // 기본값
      vm.data.moveOrder = "BEFORE";

      /*
      vm.srch = {
        keyId: toModalData.keyId
      };
      */

      getMoveList();
    })();

    /**
     * 문항목록
     * @param
     * @return
     */
    function getMoveList() {
      var i = 0;
      var j = 0;
      var qt = [];
      var qtId = "";

      for (i = 0; i < vm.svyPages.length; i++) {
        qt = $filter('filter')(vm.svyQsts, {PageNo: vm.svyPages[i].PageNo}, true);

        for (j = 0; j < qt.length; j++) {
          if (qt[j].qtId != toModalData.qtId) {
            if (qt[j].stat != "D" && (vm.pageType == "FORM" || qt[j].QstLock == 'N')) {
              qtId = qt[j].qtId;

              vm.moveList.push({
                qtId: qtId,
                moveTxt: "[" + qt[j].PageNo + "페이지] " + wjmSurvey.getQstTypeNm(qt[j].QstType) + " " + (qt[j].QstNo == "0" ? "" : qt[j].QstNo + ".") + qt[j].QstSubject
              });
            }
          }
        }

        if (qt.length == 0) {
          vm.moveList.push({
            qtId: vm.svyPages[i].PageNo + "|" + qtId,
            moveTxt: "[" + vm.svyPages[i].PageNo + "페이지]"
          });
        }
      }
    }

    /**
     * 적용 버튼 이벤트
     *
     * @param
     * @return
     */
    function apply() {
      var tgtQt = [];
      var qstNo = 0;
      var sort = 0;
      var moveQtId;
      var moveQtIdArr;

      if (isNullOrEmpty(vm.data.moveQtId)) {
        gAlert('', "이동기준 문항을 선택해주세요.");
        return false;
      }

      moveQtId = vm.data.moveQtId;
      moveQtIdArr = moveQtId.split("|");

      // 선택항목이 페이지인 경우
      if (moveQtIdArr.length == 2) {
        vm.qt.PageNo = parseInt(moveQtIdArr[0]);
        moveQtId = moveQtIdArr[1];

        if (isNullOrEmpty(moveQtId)) {
          vm.qt.QstSort = 0.1;
        }
        else {
          tgtQt = $filter('filter')(toModalData.svyQsts, {qtId: moveQtId}, true)[0];
          vm.qt.QstSort = parseInt(tgtQt.QstSort) + 0.1;
        }

        //console.log(toModalData.svyQsts);return;
      }

      // 선택항목이 문항인 경우
      else {
        tgtQt = $filter('filter')(toModalData.svyQsts, {qtId: moveQtId}, true)[0];
        vm.qt.PageNo = tgtQt.PageNo;

        if (vm.data.moveOrder == "BEFORE") {
          vm.qt.QstSort = parseInt(tgtQt.QstSort) - 0.1;
        }
        else {
          vm.qt.QstSort = parseInt(tgtQt.QstSort) + 0.1;
        }
      }

      toModalData.svyQsts.sort( function( a, b ) { return (a.QstSort > b.QstSort) ? 1 : ((b.QstSort > a.QstSort) ? -1 : 0)} );
      toModalData.svyQsts.forEach(function(i, idx) {
        sort = idx + 1;

        if (i.QstSort != sort) {
          i.stat = "U";
          i.QstSort = sort;
        }

        if (i.QstType != "R") {
          qstNo++;

          if (i.QstNo != qstNo) {
            i.stat = "U";
            i.QstNo = qstNo;
          }
        }
      });

      $uibModalInstance.close();
    }

    /**
     * 닫기 버튼 이벤트
     *
     * @param
     * @return
     */
    function close() {
      $uibModalInstance.dismiss('cancel data');
    }
  } ]);

webapp.controller('WjmRptModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function WjmRptModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.columnMap = {};

      (function WjmRptModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.List = [];
        getList();
      })();

      function changeViewSize() {
        getList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          RptNm : vm.RptNm != undefined ? vm.RptNm : ''
        };
        vm.filter = req;
        return req;
      }

      function getList() {
        getListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'wjm.report';
        data.mapCode = 'WjmReport.getRptModalList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.List = result.body.docs;
            } else {
              vm.List = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getList()', status, error);
          vm.dataloader = false;
        });
      }

      function getListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'WjmReport.getRptModalListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getListCnt()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(Rpt) {
        $uibModalInstance.close(Rpt);
      }

    } ]);

webapp.controller('ScoLvContModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function ScoLvContModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {

    var vm = this;
    vm.dataloader = false;

    var VIEW_SQL = 'WjmSurvey.getScoLvCont'; // 조회 SQL
    var UPDATE_SQL = 'WjmSurvey.updateScoLvCont';     // 수정 SQL

    vm.data = {
      ScoreLvSecId : toModalData.ScoreLvSecId, // 단순합계인 경우 기준점에서의 미니결과
      ScoreLvTotId : toModalData.ScoreLvTotId, // 환산합계인 경우 기준총점에서의 미니결과
      LvCont : ''
    };

    // 조회
    function getData() {
      vm.dataloader = true;

      var data = vm.data;
      data.mapCode = VIEW_SQL;

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.dataloader = false;

          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
            if(isNullOrEmpty(vm.data.LvCont)){
              vm.data.LvCont = "이 내용은 임시로 삽입된 값이며 저장된 상태는 아닙니다."
                                  + "<br><br>응답자 : {TgtNm}님"
                                  + "<br><br>총점 : {TotScore}"
                                  + "<br>결과 : {TotLv}"
                                  + "<br><br>영역1 점수 : {SecScore1} // 영역1 결과 : {SecLv1}"
                                  + "<br>영역2 점수 : {SecScore2} // 영역2 결과 : {SecLv2}"
                                  + "<br>영역3 점수 : {SecScore3} // 영역3 결과 : {SecLv3}"
                                  + "<br><br><a href='{CounselLink}'>상담신청</a>"
                                  + "<br><a href='tel:02-6956-9501'>상담전화걸기</a>";
            }

          } else {
            console.log('nodata');
          }
        }
      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    }

    // 저장
    function setData() {
      vm.dataloader = true;

      var data = vm.data;
      data.mapCode = UPDATE_SQL;
      oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
      data.LvCont = $("#strHtml").val();

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function () {
            }
          });
        }
      }, function (error) {
        console.error("Error> setData()");
        gAlert('', 'Menu.EXCEPTIONOCCURED');
      });
    }

    // 닫기
    function closeWin() {
      $uibModalInstance.close();
    }

    // 함수 선언
    vm.setData = setData;
    vm.closeWin = closeWin;

    getData();

}, ]);

webapp.controller('ScoreLvSecModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function ScoreLvSecModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {

    var vm = this;

    vm.dataloader = false;

    var LIST_SQL = 'WjmSurvey.getScoreLvSecList';
    var MODIFY_SQL = 'WjmSurvey.insertScoreLvSecDetailBatch';
    var SEC_LIST_SQL = 'WjmSurvey.getQstSecDropList';

    vm.srch = {
      QstSecId : '',
      SvyTypeId : toModalData.svyTypeId,
      SvyTypeNm : toModalData.svyTypeNm,
      isTot : toModalData.isTot
    };
    vm.lists = [];

    // 조회
    function getList() {
      vm.dataloader = true;

      var data = vm.srch;
      data.mapCode = LIST_SQL;
      postApi.select(data, function (result) {

        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.lists = [];
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    // 저장
    function saveList() {

      if(!$scope.form1.$valid) {
        return false;
      }

      var data = {lists : []};
      angular.forEach(vm.lists, function(item) {
        data.lists.push(item);
      });

      if (data.lists.length == 0) {
        return;
      }

      vm.dataloader = true;

      data.mapCode = MODIFY_SQL;

      postApi.insert(data, function(result) {
        vm.dataloader = false;
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          getList();
        }
      }, function(error) {
        console.error('Error-saveList', status, data);
        vm.dataloader = false;
      });
    }

    // 행 추가
    function addNew() {
      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);

      var item = {
        KeyId : newnum.toString(36),
        SvyTypeId : vm.srch.SvyTypeId,
        QstSecId : vm.srch.QstSecId,
        LvNum : '',
        LvCd : '',
        LvTxt : '',
        LvColor : '',
        Gender : '',
        MinScore : '',
        MaxScore : '',
        isNew:'Y',
      };
      vm.lists.push(item);
    }

    // 행 삭제
    function checkChanged(li) {
      if (li.DelYN == 'Y') {
        if (li.isNew == 'Y') {
          angular.forEach(vm.lists, function(item, key) {
            if (item.KeyId == li.KeyId) {
              console.log(item, key);
              vm.lists.splice(key, 1);
            }
          });
        }
      }
    }

    // 문항영역 선택 목록 조회
    function getQstSecList () {
      var data = vm.srch;
      data.mapCode = SEC_LIST_SQL;
      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.qstSecList = result.body.docs;
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getQstSecList()");
        console.table(error);
      });
  }

  // 성별 공통코드 목록 조회
  function getCodeList(type) {
    var data = {CodeType : type, mapCode : 'CommonCode.getCommonCodeList'};
    postApi.select(data, function (result) {
      if(result.header.status == CONSTANT.HttpStatus.OK) {
        switch(type) {
          case "ScoreLv" : vm.scoreLvList = result.body.docs; break;
          case "GENDER" : vm.genderList = result.body.docs; break;
        }
      }
    });
  }

  // 닫기
  function closeWin() {
    $uibModalInstance.close();
  }

  // 미니결과 편집
  function goEditLvCont(id) {
    var ctrl = 'ScoLvContModalCtrl as vc';
    var paramData = {
      ScoreLvSecId: id
    };
    var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-scorelv-lvcont-modal.html', ctrl, paramData);
    modalInstance.result.then(function (okData) {
      // 성공
    }, function (cancelData) {
      // 취소
    });
  }


    // 함수 선언
    vm.getList = getList;
    vm.saveList = saveList;
    vm.addNew = addNew;
    vm.checkChanged = checkChanged;
    vm.closeWin = closeWin;
    vm.goEditLvCont = goEditLvCont;

    getQstSecList();
    getCodeList('ScoreLv');
    getCodeList('GENDER');
    getList();

  }, ]);

webapp.controller('ScoreLvTotModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function ScoreLvTotModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {

    var vm = this;

    vm.dataloader = false;

    var LIST_SQL = 'WjmSurvey.getScoreLvTotList';
    var MODIFY_SQL = 'WjmSurvey.insertScoreLvTotDetailBatch';
    var SEC_LIST_SQL = 'WjmSurvey.getQstSecDropList';
    var LV_LIST_SQL = 'WjmSurvey.getScoreLvDropList';
    var CD_LIST_SQL = 'CommonCode.getCommonCodeList';

    vm.srch = {
      SvyTypeId : toModalData.svyTypeId,
      SvyTypeNm : toModalData.svyTypeNm,
      forTot : "Y"
    };
    vm.lists = [];
    vm.secHeader = [];
    vm.lvList = [];
    vm.secLen = 0;

    // 조회
    function getList() {

      // 성별,영역별 기준점 조회
      getCodeList('SEC');
      getCodeList('LV');

      vm.dataloader = true;

      var data = vm.srch;
      data.mapCode = LIST_SQL;
      postApi.select(data, function (result) {

        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.lists = [];
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    // 저장
    function saveList() {

      if(!$scope.form1.$valid) {
        return false;
      }

      var data = {lists : []};
      angular.forEach(vm.lists, function(item) {

        // 보기별결과형, 환산고득점형의 경우 기준점 아닌 영역ID가 매핑됨
        if ( ! isNullOrEmpty(vm.secHeader[0]) && vm.secHeader[0].indexOf("^") != -1) {
          item.SecId01 = item.LvCd01;
          item.LvCd01 = null;
        }
        if ( ! isNullOrEmpty(vm.secHeader[1]) && vm.secHeader[1].indexOf("^") != -1) {
          item.SecId02 = item.LvCd02;
          item.LvCd02 = null;
        }
        if ( ! isNullOrEmpty(vm.secHeader[2]) && vm.secHeader[2].indexOf("^") != -1) {
          item.SecId03 = item.LvCd03;
          item.LvCd03 = null;
        }
        if ( ! isNullOrEmpty(vm.secHeader[3]) && vm.secHeader[3].indexOf("^") != -1) {
          item.SecId04 = item.LvCd04;
          item.LvCd04 = null;
        }
        if ( ! isNullOrEmpty(vm.secHeader[4]) && vm.secHeader[4].indexOf("^") != -1) {
          item.SecId05 = item.LvCd05;
          item.LvCd05 = null;
        }

        data.lists.push(item);
      });

      if (data.lists.length == 0) {
        return;
      }

      vm.dataloader = true;

      data.mapCode = MODIFY_SQL;

      postApi.insert(data, function(result) {
        vm.dataloader = false;
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          getList();
        }
      }, function(error) {
        console.error('Error-saveList', status, data);
        vm.dataloader = false;
      });
    }

    // 행 추가
    function addNew() {
      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);

      var item = {
        KeyId : newnum.toString(36),
        SvyTypeId : vm.srch.SvyTypeId,
        LvCd01 : '',
        LvCd02 : '',
        LvCd03 : '',
        LvCd04 : '',
        LvCd05 : '',
        LvCd : '',
        LvTxt : '',
        SecId01 : '',
        SecId02 : '',
        SecId03 : '',
        SecId04 : '',
        SecId05 : '',
        isNew:'Y',
      };
      vm.lists.push(item);
    }

    // 행 삭제
    function checkChanged(li) {
      if (li.DelYN == 'Y') {
        if (li.isNew == 'Y') {
          angular.forEach(vm.lists, function(item, key) {
            if (item.KeyId == li.KeyId) {
              console.log(item, key);
              vm.lists.splice(key, 1);
            }
          });
        }
      }
    }

    // 선택 목록 조회
    function getCodeList(type) {
      var data = vm.srch;

      switch(type) {
        case "SEC" : data.mapCode = SEC_LIST_SQL; break;
        case "SECLV" : data.mapCode = LV_LIST_SQL; break;
        case "LV" : data = {CodeType : 'ScoreLv', mapCode : CD_LIST_SQL}; break;
      }

      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          switch(type) {

            // 문항영역
            case "SEC" :
              vm.qstSecList = result.body.docs;
              vm.secLen = vm.qstSecList.length;

              getCodeList('SECLV');
              break;

            // 영역별 기준점
            case "SECLV" :
              var lvListAll = result.body.docs;
              var i = 0;
              angular.forEach(vm.qstSecList, function(sec) {
                vm.secHeader[i] = sec.QstSecId;
                vm.lvList[i] = $filter('filter')(lvListAll, {QstSecId: sec.QstSecId}, true);
                i++;
              });
              break;

            // 최종등급
            case "LV" :
              vm.scoreLvList = result.body.docs;
              break;
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getQstSecList()");
        console.table(error);
      });
  }

  // 닫기
  function closeWin() {
    $uibModalInstance.close();
  }

  // 미니결과 편집
  function goEditLvCont(id) {
    var ctrl = 'ScoLvContModalCtrl as vc';
    var paramData = {
      ScoreLvTotId: id
    };
    var modalInstance = modalFactory.open('lg', 'components/modal/survey/wjm-scorelv-lvcont-modal.html', ctrl, paramData);
    modalInstance.result.then(function (okData) {
      // 성공
    }, function (cancelData) {
      // 취소
    });
  }


  // 함수 선언
  vm.getList = getList;
  vm.saveList = saveList;
  vm.addNew = addNew;
  vm.checkChanged = checkChanged;
  vm.closeWin = closeWin;
  vm.goEditLvCont = goEditLvCont;

  getList();

}, ]);

webapp.controller('WjmSendTotResultModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT'
, 'postApi', 'gAlert', 'gConfirm', '$filter', '$sce',
  function WjmSendTotResultModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm, $filter, $sce) {
    var vm = this;

    vm.close = close;

    vm.tit = "";
    vm.cont = "";

    // 부모페이지의 전달값 삽입
    vm.sendInfo = angular.copy(toModalData.sendInfo);

    vm.tit = toModalData.sendInfo.SendTitle;
    vm.cont = $sce.trustAsHtml(toModalData.sendInfo.SendMessage); // trustAsHtml을 사용하지 않고 매핑하면 내부 스타일 일부가 적용되지 않음.

    function close() {
      $uibModalInstance.dismiss('cancel data');
    }
  } ]);

webapp.controller('WjmSurveyModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function WjmSurveyModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.columnMap = {};


      (function WjmSurveyModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.SvyList = [];
        getList();
      })();

      function changeViewSize() {
        getList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          SvyNm : vm.SvyNm != undefined ? vm.SvyNm : ''
        };
        vm.filter = req;
        return req;
      }

      function getList() {
        getListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'wjm.surveymodal';
        data.mapCode = 'WjmSurvey.getSurveyModalList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.SvyList = result.body.docs;
            } else {
              vm.SvyList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getList()', status, error);
          vm.dataloader = false;
        });
      }

      function getListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'WjmSurvey.getSurveyModalListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getListCnt()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }

    } ]);

webapp.controller('WjmSurveyMultiselModalCtrl', [ '$window', '$rootScope', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'modalFactory',
    function WjmSurveyMultiselModalCtrl($window, $rootScope, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, modalFactory ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.columnMap = {};


      (function WjmSurveyMultiselModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.lists = [];
        getList();
      })();

      function changeViewSize() {
        getList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          SvyNm : vm.SvyNm != undefined ? vm.SvyNm : '',
          FormId : vm.FormId,
          isResult : toModalData.isResult // 진행중, 완료 상태만 조회하기 위한 조건 Y/N
        };
        vm.filter = req;
        return req;
      }

      function getList() {
        getListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'wjm.surveymodal';
        data.mapCode = 'WjmSurvey.getSurveyModalList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
            } else {
              vm.lists = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getList()', status, error);
          vm.dataloader = false;
        });
      }

      function getListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'WjmSurvey.getSurveyModalListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> classfyinfo-modal-ctrl> getListCnt()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {

        if (vm.lists.length == undefined || vm.lists.length == 0) {
          gAlert("", "데이터가 없습니다.");
          return false;
        }

        var srchChk = {};
        srchChk.FormId = '';
        srchChk.SvyId = '';
        srchChk.SvyTypeId = '';
        srchChk.ClassfyInfoId = '';
        srchChk.KeyIdList = [];
        srchChk.SvyNms = '';
        srchChk.SecLevelCnt = 0;
        srchChk.ScoringType = '';
        srchChk.TgtCnt = 0;

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {

            if(srchChk.SvyId == '') {
              srchChk.FormId = vm.lists[i].FormId;
              srchChk.SvyId = vm.lists[i].SvyId;
              srchChk.SvyTypeId = vm.lists[i].SvyTypeId;
              srchChk.ClassfyInfoId = vm.lists[i].ClassfyInfoId;
              srchChk.SecLevelCnt = vm.lists[i].SecLevelCnt;
              srchChk.ScoringType = vm.lists[i].ScoringType;
            }
            if(srchChk.KeyIdList.length >= 1 && isNullOrEmpty(srchChk.FormId)){
              gAlert("", "서식을 사용하지 않은 설문의 경우 다른 설문과 함께 선택할 수 없습니다.");
              return false;
            }
            if(srchChk.FormId != vm.lists[i].FormId || srchChk.ClassfyInfoId != vm.lists[i].ClassfyInfoId){
              gAlert("", "동일한 서식 및 분류정보를 사용하는 설문 내에서 체크해 주세요.");
              return false;
            }

            srchChk.KeyIdList.push(vm.lists[i].SvyId);
            srchChk.SvyNms = srchChk.SvyNms +(srchChk.SvyNms == ''? '' : ', ')+ vm.lists[i].SvyNm;
            srchChk.TgtCnt = srchChk.TgtCnt + vm.lists[i].TgtCnt;
          }
        }
        if (srchChk.KeyIdList == null || srchChk.KeyIdList.length == 0) {
          gAlert('', '항목을 선택해 주세요.');
          return false;
        }

        $uibModalInstance.close(srchChk);
      }

      // 목록 체크박스 로직 설정
      function setInitData() {
        vm.chkHead = false;
        $scope.chkRowChg = function (row) {

          // 행 클릭하여 체크
          if(!isNullOrEmpty(row)) row.chkRow = true;

          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };
        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };
      }

      // 서식
      vm.srchFormModal = function () {
        var ctrl = 'WjmFormModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('xs', 'components/modal/survey/wjm-form-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          vm.FormNm = okData.FormNm;
          vm.FormId = okData.KeyId;
        }, function (cancelData) {
        });
      };
      vm.eraseForm = function () {
        vm.FormNm = "";
        vm.FormId = "";
      };

      setInitData();

    } ]);

webapp.controller('TargetEditModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function TargetEditModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {

    var vm = this;
    vm.dataloader = false;

    // SQL Mapper Id 정의
    var INSERT_SQL = 'WjmSurvey.insertSvyTarget';     // 등록 SQL
    var UPDATE_SQL = 'WjmSurvey.updateSvyTarget';     // 수정 SQL
    var VIEW_SQL = 'WjmSurvey.getSvyTargetDetail'; // 조회 SQL
    var DUPCHK_SQL = 'WjmSurvey.checkSvyTarget';         // 중복체크 SQL

    // 관련 테이블 정의
    var VIEW_TABLE_NM = 'wjm.surveytarget'; // 조회용 테이블명
    var EDIT_TABLE_NM = 'wjmsurveytarget'; // 저장용 테이블명
    var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

    vm.srch = {
      keyId : toModalData.keyId
    };

    // 조회 데이터 설정
    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
    vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

    // 등록/수정 표시용 컬럼 목록
    vm.srchDetail.editColumns = {};

    // 조회 데이터
    vm.data = {
      KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
      tableNm: VIEW_TABLE_NM
    };

    // 조회
    function getData() {
      vm.dataloader = true; // Progressbar 표시

      if (isNullOrEmpty(vm.srch.keyId)) {
        vm.dataloader = false;  // Progressbar 숨김
      }
      vm.srchDetail.viewColumns = {}; // 조회 컬럼

      var data = vm.srchDetail;
      data.mapCode = VIEW_SQL;

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          vm.dataloader = false; // Progressbar 숨김

          if (result.body.desc.length > 0) {
            // 사용자정의 컬럼 설정
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            vm.data = result.body.docs[0];
            vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';

            vm.tmpMobile = vm.data.Mobile;
            vm.tmpEmail = vm.data.Email;

          } else {
            console.log('nodata');
            vm.data.TenantId = $rootScope.gVariable.srchTenantId;
            vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
          }
        } else {
          vm.dataloader = false; // Progressbar 숨김

          console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }

      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    }

    // 등록수정 화면 표시여부
    function getIsShowColumn(columnNm) {
      var result = false;
      var itemIndex = vm.srch.editColumns.indexOf(columnNm);

      result = (itemIndex > -1);
      return result;
    }

    // 필수항목 체크
    function getIsValidData() {
      var errMsg = '';
      if (isNullOrEmpty(vm.data.Mobile) && isNullOrEmpty(vm.data.Email)) {
        errMsg = errMsg + '- 휴대폰, 이메일 중 하나는 입력해 주세요.<br/>';
      }
      if (!isNullOrEmpty(vm.data.Mobile) && vm.data.Mobile != vm.tmpMobile) {
        if (vm.dupMobile > 0) {
          errMsg = errMsg + '- 중복된 휴대폰 정보가 존재합니다.<br/>';
        }
      }
      if (!isNullOrEmpty(vm.data.Email) && vm.data.Email != vm.tmpEmail) {
        if (vm.dupEmail > 0) {
          errMsg = errMsg + '- 중복된 이메일 정보가 존재합니다.<br/>';
        }
      }
      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }
      return true;
    }

    // 저장
    function setData() {

      if (getIsValidData() == false) {
        return;
      }

      // 내용
      vm.data.tableNm = EDIT_TABLE_NM;             // 작업 테이블명
      vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
      vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

      var data = vm.data; // 사용자 입력 데이터

      // 발송대기가 아니면서 휴대폰이나 이메일이 변경된 경우 발송대기로 변경하여 재발송 대상이 되게 한다.
      if(vm.data.ResultStatus != "N" &&
        ((vm.data.SendType == "SMS" && vm.data.Mobile != vm.tmpMobile) || (vm.data.SendType == "EMAIL" && vm.data.Email != vm.tmpEmail))) {
          vm.data.ResultStatus = "N";
        }

      if (isNullOrEmpty(vm.data.keyId)) {
        // 신규 등록
        data.mapCode = INSERT_SQL;

        postApi.insert(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      } else {
        // 수정
        data.RelateDataId = data.keyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          setInsertUpdateDetail(result);
        }, function (error) {
          console.error("Error> setData()");
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }
    }

    // 저장 후 처리
    function setInsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].KeyId !== null ||
          result.body.docs[0].NewKeyId !== null ||
          result.body.docs[0].RelateDataId !== null
        ) {
          // KeyId 조회
          if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
            vm.data.KeyId = result.body.docs[0].NewKeyId;
          } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
            vm.data.KeyId = result.body.docs[0].KeyId;
          } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
            vm.data.KeyId = result.body.docs[0].RelateDataId;
          }

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function () {

              // 발송 대상자 편집에서 사용하는 값
              vm.data.SvyTgtId = vm.data.keyId;
              vm.data.CustNm = vm.data.Name;

              $uibModalInstance.close(vm.data);
            }
          });
          return;
        }
      }

      console.error("Error> setInsertUpdateDetail()");
      gAlert('', result.body.docs[0].errMessage);
    }

    // 휴대폰, 이메일 중복 체크
    function getIsDup(type) {
      var data = {};
      switch(type){
        case "M": data = {SvyId: vm.data.SvyId, Mobile: vm.data.Mobile}; break;
        case "E": data = {SvyId: vm.data.SvyId, Email: vm.data.Email}; break;
      }
      data.mapCode = DUPCHK_SQL;
      postApi.select(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          switch(type){
            case "M": vm.dupMobile = result.body.docs.length; break;
            case "E": vm.dupEmail = result.body.docs.length; break;
          }
        } else {
          gAlert('', result.body.docs[0].errMessage);
        }
      }, function (error) {
        console.error("Error> getIsDup()");
        console.table(error);
      });
    }


    // 닫기
    function closeWin() {
      $uibModalInstance.close();
    }

    // 함수 정의
    vm.getData = getData;                     // 데이터 조회
    vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
    vm.setData = setData;                     // 데이터 저장
    vm.getIsDup = getIsDup;    // 중복 체크
    vm.closeWin = closeWin;  // 닫기

    // 데이터 조회
    getData();


  }, ]);

webapp.controller('TargetScoreLvModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function TargetScoreLvModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {

    var vm = this;
    vm.dataloader = false;

    var LIST_SQL = 'WjmReport.getTargetScoreLvList';

    vm.srch = {
      keyId : toModalData.keyId,
      SvyTypeId : toModalData.SvyTypeId,
      SecLevelCnt : toModalData.SecLevelCnt,
      ScoringType : toModalData.ScoringType
    };
    vm.lists = [];

    // 조회
    function getList() {

      vm.dataloader = true;

      var data = vm.srch;
      data.mapCode = LIST_SQL;
      postApi.select(data, function (result) {

        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.lists = [];
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }



    // 닫기
    function closeWin() {
      $uibModalInstance.close();
    }


    // 함수 선언
    vm.getList = getList;
    vm.closeWin = closeWin;

    getList();

  }, ]);

webapp.controller('WjmUrlPostModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', '$filter',
  function WjmUrlPostModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, gAlert, gConfirm, $filter) {
    var vm = this;

    // html 에서 사용하는 함수 연결
    vm.close = close;

    (function WjmUrlPostModalCtrl() {
      vm.data = {};
      vm.srch = {
        keyId: toModalData.keyId
      };

      // 데이터 삽입
      var SVY_URL = CONSTANT.URL.SITE_URL_FRM_MIN + '/survey/';

      vm.data.SvyUrl = SVY_URL + vm.srch.keyId + "/";
      vm.data.SvyUrlLink = "<a href=\"" + vm.data.SvyUrl + "\" target=\"_blank\">설문참여하기</a>";
      vm.data.SvyUrlCode = "<iframe width=\"1000\" height=\"600\" src=\"" + vm.data.SvyUrl + "\" frameborder=0></iframe>";
    })();

    /**
     * 닫기 버튼 이벤트
     *
     * @param
     * @return
     */
    function close() {
      $uibModalInstance.dismiss('cancel data');
    }
  } ]);

webapp.controller('UserModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function UserModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getUserList = getUserList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      vm.MobileYn = toModalData.MobileYn;
      if(toModalData.MobileYn == undefined) vm.MobileYn = false;

      (function UserModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.UserList = [];
        getUserList();
      })();

      function changeViewSize() {
        getUserList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          LoginId : vm.LoginId != undefined ? vm.LoginId : '',
          UserNm : vm.UserNm != undefined ? vm.UserNm : '',
          WorkStyle : vm.WorkStyle != undefined ? vm.WorkStyle : '',
          UserGrade : vm.UserGrade != undefined ? vm.UserGrade : ''
        }
        vm.filter = req;
        return req;
      }

      function getUserList() {
        getUserListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'users';
        data.mapCode = 'User.getUserModalList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.UserList = result.body.docs;
            } else {
              vm.UserList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function getUserListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'User.getUserModalListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(User) {
        $uibModalInstance.close(User);
      }

    } ]);

webapp.controller('WjmCounselorModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
  function WjmCounselorModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.getUserList = getUserList;
    vm.columnMap = {};
    vm.SrchEntryDtTo = '';
    vm.SrchEntryDtFrom = '';

    vm.MobileYn = toModalData.MobileYn;
    if(toModalData.MobileYn == undefined) vm.MobileYn = false;

    (function WjmUserModalCtrl() {
      // pagination
      vm.totalCount = 0;
      vm.currentPageNum = 1;
      vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
      vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
      vm.changeViewSize = changeViewSize;
      vm.getRequestParams = getRequestParams;

      vm.UserList = [];
      getUserList();
    })();

    function changeViewSize() {
      getUserList();
    }

    function getRequestParams() {
      var req = {
        page : vm.currentPageNum,
        viewSize : vm.viewSizePerPage,
        UserNm : vm.UserNm != undefined ? vm.UserNm : '',
        srchUserGubun : 'COUNSELOR'
      };
      vm.filter = req;
      return req;
    }

    function getUserList() {
      getUserListCnt();
      var data = vm.getRequestParams();
      data.selectType = 'List';
      data.tableNm = 'wjm.client';
      data.mapCode = 'WjmSystem.getUserModalList';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          if (result.body.desc.length > 0) {
            vm.listColumns = result.body.desc;
            angular.forEach(vm.listColumns, function(item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          if (result.body.docs.length > 0) {
            vm.UserList = result.body.docs;
          } else {
            vm.UserList = {};
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error> wjm-user-modal-ctrl> getUserList()', status, error);
        vm.dataloader = false;
      });
    }

    function getUserListCnt() {

      var data = vm.getRequestParams();
      data.mapCode = 'User.getUserModalListCnt';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalCount = result.body.docs[0];
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error> wjm-user-modal-ctrl> getUserList()', status, error);
        vm.dataloader = false;
      });
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(User) {
      $uibModalInstance.close(User);
    }

  } ]);

webapp.controller('WjmUserModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function WjmUserModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getUserList = getUserList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      vm.MobileYn = toModalData.MobileYn;
      if(toModalData.MobileYn == undefined) vm.MobileYn = false;

      (function WjmUserModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.UserList = [];
        getUserList();
      })();

      function changeViewSize() {
        getUserList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          UserNm : vm.UserNm != undefined ? vm.UserNm : '',
          srchUserGubun : 'DEFAULT'
        };
        vm.filter = req;
        return req;
      }

      function getUserList() {
        getUserListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'wjm.client';
        data.mapCode = 'WjmSystem.getUserModalList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.UserList = result.body.docs;
            } else {
              vm.UserList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> wjm-user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function getUserListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'User.getUserModalListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> wjm-user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(User) {
        $uibModalInstance.close(User);
      }

    } ]);

webapp.controller('TenantModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function TenantModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    TenantNm : '',
        TenantId : '',
        viewSize : 10,
        Ceo :'',
      };

      vm.selectedTenantId = toModalData.TenantId;
      if (toModalData.showBaseTenant == undefined || toModalData.showBaseTenant == null) {
        vm.showBaseTenant = 'Y';
      } else if(toModalData.showBaseTenant != undefined && toModalData.showBaseTenant != '') {
        if(!toModalData.showBaseTenant) vm.showBaseTenant = 'N';
        else vm.showBaseTenant = 'Y';
      } else if (!toModalData.showBaseTenant) {
        vm.showBaseTenant = 'N';
      } else {
        vm.showBaseTenant = 'Y';
      }

      (function TenantModalCtrl() {
        getList();
      })();
      function getList() {

        var data = {
          mapCode: 'Tenant.getTenantSrch',
          TenantNm : vm.srch.TenantNm,
          Ceo : vm.srch.Ceo,
          userkey : '',
          showBaseTenant : vm.showBaseTenant,
          page : vm.srch.page,
        };

        if($window.sessionStorage['loginTenantId']!= null && $window.sessionStorage['loginTenantId'] != "" && $window.sessionStorage['loginTenantId'] != undefined){

          getCnt(true);

          data.mapCode= 'Tenant.getTenantSrch';
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.tenantlists != null) {
                angular.forEach(vm.tenantlists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr1 = resList[0] + " " + resList[1];
                   }
                });
              }
            }
          });
        } else if($window.sessionStorage['loginTenantId'] == null || $window.sessionStorage['loginTenantId'] == "" &&  $window.sessionStorage['loginTenantId'] == undefined) {

          getCnt(false);

          data.showBaseTenant = vm.showBaseTenant;
          data.mapCode= 'getTenantId';
          postApi.login(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;

              console.log('d',vm.tenantlists);

              var resList = [];
              var res = '';

              if (vm.tenantlists != null) {
                angular.forEach(vm.tenantlists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr1 = resList[0] + " " + resList[1];
                   }
                });
              }
            }
          });
        }


      }

      function getCnt(checkSession) {
        var data = {
          mapCode: 'Tenant.getTenantSrchCnt',
          TenantNm : vm.srch.TenantNm,
          Ceo : vm.srch.Ceo,
          userkey : '',
          showBaseTenant : vm.showBaseTenant
        };

        if(checkSession) {
          data.mapCode= 'Tenant.getTenantSrchCnt';
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.totalItems = result.body.docs[0].totalItems;
            }
          });
        } else {
          data.mapCode= 'getTenantSrchCnt';
          postApi.login(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.totalItems = result.body.docs[0].totalItems;
            }
          });
        }
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();

      }

      vm.pageChanged = pageChanged;
    } ]);

webapp.controller('Tenant2ModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function Tenant2ModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;


      vm.srch = {
		    TenantNm : '',
        TenantId : toModalData.TenantId,
        viewSize : 10
		  };

      (function TenantModalCtrl() {
        getList();
      })();


      function getList() {
        var data = {
          mapCode: 'Tenant.getTenantSrch', TenantNm : vm.srch.TenantNm, TenantId : toModalData.TenantId
        };
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.tenantlists = result.body.docs;
            vm.totalItems = result.body.docCnt;

          }
        });
      }


      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }
    } ]);

/* 'use strict'; */

/**
 * @ngdoc function
 * @name minovateApp.controller:UiGeneralCtrl
 * @description
 * # UiGeneralCtrl
 * Controller of the minovateApp
 */
webapp
  .controller('GeneralCtrl', function ($scope) {
    $scope.page = {
      title: 'General Elements',
      subtitle: 'Place subtitle here...'
    };
  })

  .controller('ProgressDemoCtrl', function ($scope) {
    $scope.max = 200;

    $scope.random = function() {
      var value = Math.floor((Math.random() * 100) + 1);
      var type;

      if (value < 25) {
        type = 'success';
      } else if (value < 50) {
        type = 'info';
      } else if (value < 75) {
        type = 'warning';
      } else {
        type = 'danger';
      }

      $scope.showWarning = (type === 'danger' || type === 'warning');

      $scope.dynamic = value;
      $scope.type = type;
    };

    $scope.random();

    $scope.randomStacked = function() {
      $scope.stacked = [];
      var types = ['success', 'info', 'warning', 'danger'];

      for (var i = 0, n = Math.floor((Math.random() * 4) + 1); i < n; i++) {
          var index = Math.floor((Math.random() * 4));
          $scope.stacked.push({
            value: Math.floor((Math.random() * 30) + 1),
            type: types[index]
          });
      }
    };

    $scope.randomStacked();
  })

  .controller('RatingDemoCtrl', function ($scope) {
    $scope.rate = 7;
    $scope.max = 10;
    $scope.isReadonly = false;

    $scope.hoveringOver = function(value) {
      $scope.overStar = value;
      $scope.percent = 100 * (value / $scope.max);
    };
  })

  .controller('ButtonsCtrl', function ($scope) {
    $scope.singleModel = 1;

    $scope.radioModel = 'Middle';

    $scope.checkModel = {
      left: false,
      middle: true,
      right: false
    };
  })

  .controller('CarouselDemoCtrl', function ($scope) {
    $scope.myInterval = 5000;
    $scope.noWrapSlides = false;
    var slides = $scope.slides = [];
    $scope.addSlide = function() {
      var newWidth = 801 + slides.length + 1;
      slides.push({
        image: '//placekitten.com/' + newWidth + '/300',
        text: ['More','Extra','Lots of','Surplus'][slides.length % 4] + ' ' +
        ['Cats', 'Kittys', 'Felines', 'Cutes'][slides.length % 4]
      });
    };
    for (var i=0; i<4; i++) {
      $scope.addSlide();
    }
  })

  .controller('TooltipDemoCtrl', function ($scope, $sce) {
    $scope.dynamicTooltip = 'Hello, World!';
    $scope.dynamicTooltipText = 'dynamic';
    $scope.htmlTooltip = $sce.trustAsHtml('I\'ve been made <b>bold</b>!');
  })

  /* jshint ignore:start */
  .controller('TypeaheadCtrl', function($scope, $http) {

    $scope.selected = undefined;
    $scope.states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Dakota', 'North Carolina', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

    // Any function returning a promise object can be used to load values asynchronously
    $scope.getLocation = function(val) {
      return $http.get('http://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          address: val,
          sensor: false
        }
      }).then(function(response){
        return response.data.results.map(function(item){
          return item.formatted_address;
        });
      });

    };

    $scope.statesWithFlags = [{'name':'Alabama','flag':'5/5c/Flag_of_Alabama.svg/45px-Flag_of_Alabama.svg.png'},{'name':'Alaska','flag':'e/e6/Flag_of_Alaska.svg/43px-Flag_of_Alaska.svg.png'},{'name':'Arizona','flag':'9/9d/Flag_of_Arizona.svg/45px-Flag_of_Arizona.svg.png'},{'name':'Arkansas','flag':'9/9d/Flag_of_Arkansas.svg/45px-Flag_of_Arkansas.svg.png'},{'name':'California','flag':'0/01/Flag_of_California.svg/45px-Flag_of_California.svg.png'},{'name':'Colorado','flag':'4/46/Flag_of_Colorado.svg/45px-Flag_of_Colorado.svg.png'},{'name':'Connecticut','flag':'9/96/Flag_of_Connecticut.svg/39px-Flag_of_Connecticut.svg.png'},{'name':'Delaware','flag':'c/c6/Flag_of_Delaware.svg/45px-Flag_of_Delaware.svg.png'},{'name':'Florida','flag':'f/f7/Flag_of_Florida.svg/45px-Flag_of_Florida.svg.png'},{'name':'Georgia','flag':'5/54/Flag_of_Georgia_%28U.S._state%29.svg/46px-Flag_of_Georgia_%28U.S._state%29.svg.png'},{'name':'Hawaii','flag':'e/ef/Flag_of_Hawaii.svg/46px-Flag_of_Hawaii.svg.png'},{'name':'Idaho','flag':'a/a4/Flag_of_Idaho.svg/38px-Flag_of_Idaho.svg.png'},{'name':'Illinois','flag':'0/01/Flag_of_Illinois.svg/46px-Flag_of_Illinois.svg.png'},{'name':'Indiana','flag':'a/ac/Flag_of_Indiana.svg/45px-Flag_of_Indiana.svg.png'},{'name':'Iowa','flag':'a/aa/Flag_of_Iowa.svg/44px-Flag_of_Iowa.svg.png'},{'name':'Kansas','flag':'d/da/Flag_of_Kansas.svg/46px-Flag_of_Kansas.svg.png'},{'name':'Kentucky','flag':'8/8d/Flag_of_Kentucky.svg/46px-Flag_of_Kentucky.svg.png'},{'name':'Louisiana','flag':'e/e0/Flag_of_Louisiana.svg/46px-Flag_of_Louisiana.svg.png'},{'name':'Maine','flag':'3/35/Flag_of_Maine.svg/45px-Flag_of_Maine.svg.png'},{'name':'Maryland','flag':'a/a0/Flag_of_Maryland.svg/45px-Flag_of_Maryland.svg.png'},{'name':'Massachusetts','flag':'f/f2/Flag_of_Massachusetts.svg/46px-Flag_of_Massachusetts.svg.png'},{'name':'Michigan','flag':'b/b5/Flag_of_Michigan.svg/45px-Flag_of_Michigan.svg.png'},{'name':'Minnesota','flag':'b/b9/Flag_of_Minnesota.svg/46px-Flag_of_Minnesota.svg.png'},{'name':'Mississippi','flag':'4/42/Flag_of_Mississippi.svg/45px-Flag_of_Mississippi.svg.png'},{'name':'Missouri','flag':'5/5a/Flag_of_Missouri.svg/46px-Flag_of_Missouri.svg.png'},{'name':'Montana','flag':'c/cb/Flag_of_Montana.svg/45px-Flag_of_Montana.svg.png'},{'name':'Nebraska','flag':'4/4d/Flag_of_Nebraska.svg/46px-Flag_of_Nebraska.svg.png'},{'name':'Nevada','flag':'f/f1/Flag_of_Nevada.svg/45px-Flag_of_Nevada.svg.png'},{'name':'New Hampshire','flag':'2/28/Flag_of_New_Hampshire.svg/45px-Flag_of_New_Hampshire.svg.png'},{'name':'New Jersey','flag':'9/92/Flag_of_New_Jersey.svg/45px-Flag_of_New_Jersey.svg.png'},{'name':'New Mexico','flag':'c/c3/Flag_of_New_Mexico.svg/45px-Flag_of_New_Mexico.svg.png'},{'name':'New York','flag':'1/1a/Flag_of_New_York.svg/46px-Flag_of_New_York.svg.png'},{'name':'North Carolina','flag':'b/bb/Flag_of_North_Carolina.svg/45px-Flag_of_North_Carolina.svg.png'},{'name':'North Dakota','flag':'e/ee/Flag_of_North_Dakota.svg/38px-Flag_of_North_Dakota.svg.png'},{'name':'Ohio','flag':'4/4c/Flag_of_Ohio.svg/46px-Flag_of_Ohio.svg.png'},{'name':'Oklahoma','flag':'6/6e/Flag_of_Oklahoma.svg/45px-Flag_of_Oklahoma.svg.png'},{'name':'Oregon','flag':'b/b9/Flag_of_Oregon.svg/46px-Flag_of_Oregon.svg.png'},{'name':'Pennsylvania','flag':'f/f7/Flag_of_Pennsylvania.svg/45px-Flag_of_Pennsylvania.svg.png'},{'name':'Rhode Island','flag':'f/f3/Flag_of_Rhode_Island.svg/32px-Flag_of_Rhode_Island.svg.png'},{'name':'South Carolina','flag':'6/69/Flag_of_South_Carolina.svg/45px-Flag_of_South_Carolina.svg.png'},{'name':'South Dakota','flag':'1/1a/Flag_of_South_Dakota.svg/46px-Flag_of_South_Dakota.svg.png'},{'name':'Tennessee','flag':'9/9e/Flag_of_Tennessee.svg/46px-Flag_of_Tennessee.svg.png'},{'name':'Texas','flag':'f/f7/Flag_of_Texas.svg/45px-Flag_of_Texas.svg.png'},{'name':'Utah','flag':'f/f6/Flag_of_Utah.svg/45px-Flag_of_Utah.svg.png'},{'name':'Vermont','flag':'4/49/Flag_of_Vermont.svg/46px-Flag_of_Vermont.svg.png'},{'name':'Virginia','flag':'4/47/Flag_of_Virginia.svg/44px-Flag_of_Virginia.svg.png'},{'name':'Washington','flag':'5/54/Flag_of_Washington.svg/46px-Flag_of_Washington.svg.png'},{'name':'West Virginia','flag':'2/22/Flag_of_West_Virginia.svg/46px-Flag_of_West_Virginia.svg.png'},{'name':'Wisconsin','flag':'2/22/Flag_of_Wisconsin.svg/45px-Flag_of_Wisconsin.svg.png'},{'name':'Wyoming','flag':'b/bc/Flag_of_Wyoming.svg/43px-Flag_of_Wyoming.svg.png'}];
  })
  /* jshint ignore:end */

  .controller('DropdownCtrl', function ($scope) {

     $scope.items = [
      'The first choice!',
      'And another choice for you.',
      'but wait! A third!'
    ];

    $scope.status = {
      isopen: false
    };

    $scope.toggled = function(open) {
      console.log('Dropdown is now: ', open);
    };

    $scope.toggleDropdown = function($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.status.isopen = !$scope.status.isopen;
    };
  })

  .controller('DatepickerDemoCtrl', function ($scope) {

    $scope.today = function() {
      $scope.dt = new Date();
    };

    $scope.today();

    $scope.clear = function () {
      $scope.dt = null;
    };

    // Disable weekend selection
    $scope.disabled = function(date, mode) {
      return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };

    $scope.toggleMin = function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    };
    $scope.toggleMin();

    $scope.open = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened = true;
    };

    $scope.dateOptions = {
      formatYear: 'yy',
      startingDay: 0,
      showWeeks: false,
      'class': 'datepicker'
    };

    $scope.formats = ['yyyy-MM-dd', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[0];

    $scope.processDate = function (dt) {
      return $filter('date')(dt, 'yyyy-MM-dd');
    }
  })

  .controller('TimepickerDemoCtrl', function ($scope) {
    $scope.mytime = new Date();

    $scope.hstep = 1;
    $scope.mstep = 15;

    $scope.options = {
      hstep: [1, 2, 3],
      mstep: [1, 5, 10, 15, 25, 30]
    };

    $scope.ismeridian = true;
    $scope.toggleMode = function() {
      $scope.ismeridian = ! $scope.ismeridian;
    };

    $scope.update = function() {
      var d = new Date();
      d.setHours( 14 );
      d.setMinutes( 0 );
      $scope.mytime = d;
    };

    $scope.changed = function () {
      console.log('Time changed to: ' + $scope.mytime);
    };

    $scope.clear = function() {
      $scope.mytime = null;
    };
  })

  .controller('PaginationDemoCtrl', function ($scope) {
    $scope.totalItems = 64;
    $scope.currentPage = 4;

    $scope.setPage = function (pageNo) {
      $scope.currentPage = pageNo;
    };

    $scope.pageChanged = function() {
      console.log('Page changed to: ' + $scope.currentPage);
    };

    $scope.maxSize = 5;
    $scope.bigTotalItems = 175;
    $scope.bigCurrentPage = 1;
  })

  .controller('PopoverDemoCtrl', function ($scope) {
    $scope.dynamicPopover = 'Hello, World!';
    $scope.dynamicPopoverTitle = 'Title';
  });

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */

    TimeLine.$inject = ['$log'];

    /** @ngInject */
    function TimeLine($log) {
        $log.info('TimeLine Controller');
    }

    angular.module('salevis4-web')
        .component('timeline', {
            templateUrl: 'components/ui-component/timeline/timeline.html',
            controller: TimeLine
        });

})();

(function() {
  webapp
  .factory('dock', function() {
    var valids = [ 'left', 'right', 'top', 'bottom', 'fill' ];
    return {
      dockRefs: {},
      valids: valids,
      handlesByDock: {
        "top": "s",
        "left": "e",
        "right": "w",
        "bottom": "n"
      },
      Area: (function() {
        function setPosition(r, s, pos) {
            r.position = 'absolute';
            if (pos != "bottom") r.top = s.top; else { r.top = 'auto'; }
            if (pos != "left") r.right = s.right; else { r.right = 'auto'; }
            if (pos != "right") r.left = s.left; else { r.left = 'auto'; }
            if (pos != "top") r.bottom = s.bottom; else { r.bottom = 'auto'; }
        }
        function decreaseSize($element, pos, s) {
            var size = 0;
            if ("top|bottom".indexOf(pos) != -1) size = $element.outerHeight(true);
            if ("left|right".indexOf(pos) != -1) size = $element.outerWidth(true);
            if (pos == "bottom") s.bottom += size;
            if (pos == "left")   s.left   += size;
            if (pos == "right")  s.right  += size;
            if (pos == "top")    s.top    += size;
        }
        function removeClasses($element){
          var x = valids.length;
          while(x--)
            $element.removeClass("dock-" + valids[x]);
        }
        function update($element, pos, s) {
            var r = {};
            removeClasses($element);
            setPosition(r, s, pos);
            $element.addClass("dock-" + pos);
            $element.css(r);
            decreaseSize($element, pos, s);
        }
        var Area = function($div, $scope) {
          var s = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          };
          var childList = [];
          this.addChild = function($element, $pos) {
            var pos = $scope.$eval($pos);
            console.log('pos=', pos);

            if (valids.indexOf(pos) == -1)
              throw {
                message: "dock position must be one of this: " + valids.join(', ')
              };
            childList.push({
              element: $element,
              pos: $pos,
              order: childList.length
            });
            update($element, pos, s);
          };
          this.refresh = function() {
            s.top = 0;
            s.bottom = 0;
            s.left = 0;
            s.right= 0;
            for (var x = 0; x < childList.length; x++) {
              var pos = $scope.$eval(childList[x].pos);
              update(childList[x].element, pos, s);
            }
          };

          var _this = this;
          $(window).resize(function() {
            _this.refresh();
          });
          $scope.$watch(function() {
            _this.refresh();
          });
        };
        return Area;
      })()
    };
  })
  .directive('dockRef', function(dock) {
    return {
      restrict: "A",
      controller: function($scope, $element) {
        $scope.__dock_ref_id = String(Math.random()).replace(/\./g, "");
        dock.dockRefs[$scope.__dock_ref_id] = new dock.Area($element, $scope);
      },
      scope: true
    };
  })
  .directive('dock', function(dock) {
    return {
      restrict: "A",
      controller: function($scope, $element) {
        var dp = $element.attr('dock');
        $scope.__dock_id = String(Math.random()).replace(/\./g, "");
        var area = dock.dockRefs[$scope.$parent.__dock_ref_id];
        area.addChild($element, dp);
      },
      scope: true
    };
  })
  .directive("dockResizable", function(dock) {
    function enableResize($element, dp) {
      $element.resizable({
        handles: dock.handlesByDock[dp]
      });
    }
    return {
      require: 'dock',
      restrict: "A",
      controller: function($scope, $element) {
        var dp = $scope.$eval($element.attr('dock'));
        if (dock.valids.indexOf(dp) >= 0 && dp != "fill") enableResize($element, dp);
        $scope.$watch(function() {
          var newdp = $scope.$eval($element.attr('dock'));
          if (newdp != dp) {
            if (dock.valids.indexOf(newdp) == -1)
              throw {
                message: "dock position must be one of this: " + valids.join(', ')
              };
            dp = newdp;
            $element.resizable('destroy');
            if (newdp != 'fill') enableResize($element, dp);
          }
        });
      }
    }
  });
})();

(function() {
  "use strict";
  webapp.factory('gAlert',
    [ '$filter', '$rootScope', 'modalFactory',
    function($filter, $rootScope, modalFactory) {

      var templateUrl = 'components/ui-component/factory/galert-factory.html';

      return function(p1, p2, p3, p4) {

        /*
          if p2 ? string : p1 = "type", p2 = msg, p3 = function
          else p1 = msg, p2 = function

          Alert Type : info, error
          p1 type of String : alert type
          p1 type of Function : ok function / default Info
        */

        var ico = "", color = "", mode = true;
        if(typeof(p2) == "string") {
          if(p1.toLowerCase() == "i") {
            ico = "alert-icon-exclamation";
            color = "0066cc";
          } else if(p1.toLowerCase() == "c") {
           ico = "alert-icon-check";
           color = "0066cc";
          } else if(p1.toLowerCase() == "w") {
            ico = "alert-icon-caution";
            color = "be1a16";
          } else {
            ico = "alert-icon-exclamation";
            color = "0066cc";
          }
        } else {
          mode = false;
          ico = "alert-icon-exclamation";
          color = "0066cc";
        }

        var translate = $filter('translate');
        var defaultCloseBtn = translate('Menu.CONFIRM');

        if (p4 != null && p4 != "") {
          defaultCloseBtn = p4;
        }

        if(mode) {
          if ($rootScope.gVariable.alertMessage == p2 || p2 == null)
            return;
        } else {
          if ($rootScope.gVariable.alertMessage == p1 || p1 == null)
            return;
        }


        var modalInstance = modalFactory.open('sm', templateUrl, function($uibModalInstance, $scope, $document) {
          //$scope.title = (title == '') ? translate('Menu.ALERT') : translate(title);

          var msg = (mode) ? p2 : p1;
          $rootScope.gVariable.alertMessage = msg;
          $scope.alertColor = color;
          $scope.alertMessage = translate(msg);
          $scope.alertIco = ico;

          var okAct;
          if(mode) {
            $scope.closeBtn = p3 && p3.btn ? translate(p3.btn) : defaultCloseBtn;
            okAct = p3;
          } else {
            $scope.closeBtn = p2 && p2.btn ? translate(p2.btn) : defaultCloseBtn;
            okAct = p2;
          }

          var okFn = okAct && okAct.fn ? okAct.fn : null;
          $scope.onClose = function() {
            if (okFn)
              okFn();
            $uibModalInstance.dismiss('cancel');
            $rootScope.gVariable.alertMessage = '';
          };

          var EVENT_TYPES = 'keydown keypress';
          function eventHandler(event) {
            var _key = event.which; // enter, space
            if ((_key === 13 || _key === 32) && event.target.className.indexOf('modal') > -1) {
              event.preventDefault();
              $scope.onClose();
            }
          }
          $document.on(EVENT_TYPES, eventHandler);
          $scope.$on('$destroy', function() {
            $document.off(EVENT_TYPES, eventHandler);
          });
        }, {}, {
          keyboard : true
        });
      };
    }]);
})();

webapp.factory('gConfirm', [ '$filter', 'modalFactory', function($filter, modalFactory) {
  var defaultIconClazz = 'noty';
  var templateUrl = 'components/ui-component/factory/gconfirm-factory.html';

  var basicConfirm = function(p1, p2, p3, p4, p5) {

    //title, msg, okAct, closeAct, options
    /*
      if p2 ? string : p1 = "type", p2 = msg, p3 = ok, p4 = cancel;
      else p1 = msg, p2 = ok, p3 = cancel

      Alert Type : info, error
      p1 type of String : alert type
      p1 type of Function : ok function / default Info
    */

   var ico = "", color = "", mode = true;
   if(typeof(p2) == "string") {
     if(p1.toLowerCase() == "i") {
       ico = "alert-icon-exclamation";
       color = "0066cc";
     } else if(p1.toLowerCase() == "c") {
      ico = "alert-icon-check";
      color = "0066cc";
     } else if(p1.toLowerCase() == "w") {
       ico = "alert-icon-caution";
       color = "be1a16";
     } else {
       ico = "alert-icon-exclamation";
       color = "0066cc";
     }
   } else {
     mode = false;
     ico = "alert-icon-exclamation";
     color = "0066cc";
   }

    var translate = $filter('translate');
    var defaultCloseBtn = translate('Menu.CANCEL');
    var defaultOkBtn = translate('Menu.OK');

    var modalInstance = modalFactory.open('sm', templateUrl, function($uibModalInstance, $scope, $document) {

      var msg = (mode) ? p2 : p1;

      $scope.alertColor = color;
      $scope.alertIco = ico;
      $scope.alertMessage = translate(msg);

      var okAct, closeAct;
      if(mode) {
        okAct = p3; closeAct = p4;
        $scope.okBtn = okAct && okAct.btn ? translate(okAct.btn) : defaultOkBtn;
        $scope.closeBtn = closeAct && closeAct.btn ? translate(closeAct.btn) : defaultCloseBtn;
        $scope.iconClazz = p5 && p5.type ? p5.type : defaultIconClazz;
      } else {
        okAct = p2; closeAct = p3;
        $scope.okBtn = okAct && okAct.btn ? translate(okAct.btn) : defaultOkBtn;
        $scope.closeBtn = closeAct && closeAct.btn ? translate(closeAct.btn) : defaultCloseBtn;
        $scope.iconClazz = p4 && p4.type ? p4.type : defaultIconClazz;
      }

      var okFn = okAct && okAct.fn ? okAct.fn : null;
      var closeFn = closeAct && closeAct.fn ? closeAct.fn : null;

      $scope.onClose = function() {
        if (closeFn)
          closeFn();
        $uibModalInstance.dismiss('cancel');
      };
      $scope.onOk = function() {
        if (okFn)
          okFn();
        $uibModalInstance.dismiss('cancel');
      };

      var EVENT_TYPES = 'keydown keypress';
      function eventHandler(event) {
        var _key = event.which; // enter, space
        if ((_key === 13 || _key === 32) && event.target.className.indexOf('modal') > -1) {
          event.preventDefault();
          $scope.onOk();
        }

      }
      $document.on(EVENT_TYPES, eventHandler);
      $scope.$on('$destroy', function() {
        $document.off(EVENT_TYPES, eventHandler);
      });
    }, {}, {
      keyboard : true
    });
  }

  return basicConfirm;
} ]);

/**
 * 자세한 옵션은 https://angular-ui.github.io/bootstrap/ 의 Modal 항목 참고
 *
 * 사용 예제
 *
 * <pre>
 * 모달을 사용하는 측 모달 열기
 * var modalInstance = modalFactory.open('lg', 'html/changemng/req-change.html',
 * 		'ReqChangeController', data: modal측에 전달할 객체);
 * 모달 외부에서 내부로 값 전달 하는 방법
 * data에 데이터를 넣고, 모달의 내부에서 사용하는 controller에서
 * gmsController.controller('ReqChangeController', [ '$scope','$uibModalInstance','toModalData',
 * 	function($scope, $uibModalInstance, toModalData) {
 * console.log(JSON.stringify(toModalData));
 * 이런식으로 하면 toModalData안에 데이터가 들어있게 된다.
 *
 * 모달에서 처리된 값 받기
 * modalInstance.result.then(function(data) {
 * 	console.log(JSON.stringify(data))
 * }, function() {
 * 	$log.info('Modal dismissed at: ' + new Date());
 * });
 *
 * 모달 내부에서 외부로 값 전달 하는 방법
 * 확인 버튼
 * $uibModalInstance.close($scope.reqChangeModel);
 * - modalInstance.result.then(function(data) 모달을 사용하는 측에서 data에 값이 들어오게 된다.
 *
 * 취소 버튼
 * $uibModalInstance.dismiss('cancel');
 * - modalInstance.result.then 이부분이 호출되지 않게 된다.
 *
 *
 * </pre>
 */

webapp.factory('modalFactory', [ '$uibModal', '$rootScope', ModalFactory ]);

function ModalFactory($uibModal, $rootScope) {
  var modalInstance = {};
  // $uibModalInstance

  modalInstance.open = function(size, templateUrl, controller, data, options) {
    var modal = $uibModal.open({
      animation : false,
      templateUrl : templateUrl,
      controller : controller,
      // size - (Type: string, Example: lg)
      // Optional suffix of modal window class. The value used is appended
      // to the modal- class, i.e. a value of sm gives modal-sm.
      size : size,
      backdrop : 'static',
      // 키보드 esc로 모달을 닫을지 여부
      keyboard : options && options.keyboard ? options.keyboard : false,
      windowTemplate : 'ui/template/modal/window.html',
      // 모달 외부로 부터 내부로 전달 받을 값
      resolve : {
        toModalData : function() {
          return data;
        }
      }
    });
    return modal;
  };
  return modalInstance;
}

/**
 * sort-array-object.js는 object Type들로 이루어진 Array에 대한 정렬을 제공하는 기능이다. 숫자 타입의 속성 값만 비교 가능하다.
 * Params - input: 정렬할 데이터
 * Params - attr : 정렬 기준 항목
 */
webapp.factory('sortArrayFactory', ['$resource', 'GLOBAL_CONSTANT', function sortArrayFactory($resource, CONSTANT) {
    return {
        sortArrayObject: function(input, attr){
            if(!angular.isArray(input)){
                return input;
            }
            input.sort(function(pre, post){
                try{
                    a = parseInt(pre[attr]);
                    b = parseInt(post[attr]);
                    return a - b;
                }catch(ex){
                    throw new Error('NumberFormat Error.');
                    return input;
                }
            })
            return input;
        }
    }
}]);

/**
 * static-variable-factory.js는 ng-app 전역적인 변수값을 정의하여 사용할 수 있는 정적 메소드이다.
 */

webapp.factory('StaticVariable', [
    '$state',
    '$window',
    '$cookies',
    '$filter',
    '$rootScope',
    'gAlert',
    'GLOBAL_CONSTANT',
    function($state, $window, $cookies, $filter, $rootScope, gAlert, CONSTANT) {
      // -- ACCESS_DENIED("ACN1N00-403") 홈으로 이동
      // -- ALREADY_LOGGED_IN("ACN0N04-409") 로그인에서만 사용
      // -- ACCESS_TOKEN_IS_NULL("ACN0N01-401") 로그인으로 이동
      // -- INVALID_TOKEN("ACN1N01-401") 로그인으로 이동
      // -- TOKEN_IS_EXPIRED("ACN1N02-401") 로그인으로 이동
      // -- DOES_NOT_MATCH_TOKEN_VERSION("ACN1N03-401") 로그인으로 이동
      // -- LOGEDIN_ANOTHER_CLIENT("ACN1N04-401") 로그인으로 이동
      function getContextPath() {
        var offset=location.href.indexOf(location.host)+location.host.length;
        if (offset + 1 >= location.href.length)
          return "";

        var offset2 = location.href.indexOf('/',offset+1);
        if (offset2 == -1) offset2 = location.href.length;

        var ctxPath=location.href.substring(offset+1, offset2);

        if (ctxPath == '#' || ctxPath == 'i.html#' || ctxPath == 'm.html#' || ctxPath == 'min.html#' || ctxPath == 'i.html' || ctxPath == 'm.html' || ctxPath == 'min.html')
          ctxPath = '';

        return ctxPath;
      }

      CONSTANT.URL.CONTEXT = getContextPath();
      var translate = $filter('translate');

      var alreadyOccurError = false;
      var serverDead = false;

      var intercept = {
        response : function(JSON) {
          //console.info('intercept JSON=====', JSON);
          return JSON.data;
        },
        responseError : function(error) {
          console.log('intercept error=====', error);

          if (error.data == null) {
            gAlert(translate('Menu.SERVERERROR4'), "Unknown error.");
            return null;
          }

          if ((error.status == -1 || error.status == 400) && !serverDead) {
            serverDead = true;
            gAlert(translate('Menu.SERVERERROR1'), {
              fn : function() {
                sessionExpire();
                $state.go('home.main');
              }
            });

          } else if (error.data && angular.isUndefined(error.data.response)) {
            gAlert(translate('Menu.SERVERERROR2'), error.statusText, {
              fn : function() {
                console.error('server Error', '[' + error.status + ']' + error.statusText);
                if (error.status == 401 || error.status == 400) {
                  sessionExpire();
                  $state.go('home.main');
                }
              }
            });
            return null;
          } else if (error.data.response.body.docs.errCode == 'ACN0N01-401' || error.data.response.body.docs.errCode == 'ACN1N01-401'
              || error.data.response.body.docs.errCode == 'ACN1N02-401' || error.data.response.body.docs.errCode == 'ACN1N03-401'
              || error.data.response.body.docs.errCode == 'ACN1N04-401') {

            if ($window.sessionStorage.isLoggedIn) {
              alreadyOccurError = true;
              sessionExpire();
              $state.go('home.main');
              return null;
            }
          } else if (error.data.response.body.docs.errCode === 'ACN1N00-403') {
            console.log(error.data);
            gAlert(translate('Menu.SERVERERROR3'), error.data.response.body.docs.errMessage, {
              fn : function() {
                console.error(error.data.response.body.docs.errMessage);
                $state.go('home.main');
              }
            });
            return null;
          } else {
            return error.data;
          }

          gAlert(translate('Menu.SERVERERROR4'), error.data.response.body.docs.errMessage);
          console.error(error.data.response.body.docs.errCode, error.data.response.body.docs.errMessage);
        }
      };
      function sessionExpire() {
        $window.sessionStorage.removeItem('isLoggedIn');
        $window.sessionStorage.removeItem('loginUserId');
        $window.sessionStorage.removeItem('loginUserIdx');
        $window.sessionStorage.removeItem('loginSysAdminYN');
        $window.sessionStorage.removeItem('loginUserName');
        $window.sessionStorage.removeItem('loginUserGbn');
        $window.sessionStorage.removeItem('loginUserDept');
        $window.sessionStorage.removeItem('loginUserDeptCode');
        $window.sessionStorage.removeItem('loginComGbn');
        $window.sessionStorage.removeItem('loginUserType');
        $window.sessionStorage.removeItem('loginUserEmail');
        $window.sessionStorage.removeItem('loginTenantId');
        $window.sessionStorage.removeItem('loginTenantName');
        $window.sessionStorage.removeItem('loginTenantDir');
        $window.sessionStorage.removeItem('loginEmail');
        $window.sessionStorage.removeItem('loginTelNo');
        $window.sessionStorage.removeItem('srchTenantId');
        $window.sessionStorage.removeItem('srchTenantName');
      }
      return {
        getUrl : function(uri) {
          var domainPort = CONSTANT.URL.PORT == null || CONSTANT.URL.PORT == "" ? "" : ":" + CONSTANT.URL.PORT;
          var domainContext = CONSTANT.URL.CONTEXT == null || CONSTANT.URL.CONTEXT == "" ? "" : '/' + CONSTANT.URL.CONTEXT;
          var domainVersion = CONSTANT.URL.VERSION == null || CONSTANT.URL.VERSION == "" ? "" : '/' + CONSTANT.URL.VERSION;

          var url = CONSTANT.URL.HTTP_PROTOCOL + '//' +
          CONSTANT.URL.API_SERVER_DOMAIN + domainPort + domainContext +
          domainVersion + uri;
          //var url = domainContext + domainVersion + uri;
          return url;
        },
        getFileDownloadUrl : function(FileKey) {
          return this.getUrl('/attach/file/' + FileKey + '/download.do?userkey=' + $rootScope.gVariable.userKey);
        },
        getDateFormat : function(langCode, useDateTime) {
          var foramt;
          switch (langCode) {
          case 'ko':
            format = 'yyyy.MM.dd';
            break;
          case 'zh':
            // break;
          case 'ja':
            format = 'yyyy.MM.dd';
            break;
          case 'en':
            format = 'MM/dd/yy';
            break;
          default:
            format = 'MM/dd/yy';
            break;
          }
          return useDateTime ? format + ' HH:mm:ss' : format;
        },
        sessionExpire : function() {
          sessionExpire();
        },
        getRequestActions : {
          defaultAction : function() {
            return {
              one : {
                method : 'GET',
                interceptor : intercept,
                transformResponse : function(data, headersGetter) {
                  var contentType = headersGetter('Content-Type');
                  if (contentType && contentType.indexOf('text/html') > -1) {
                    return {
                      'body' : data
                    };
                  }
                  return angular.fromJson(data);
                }
              },
              post : {
                method : "POST",
                interceptor : intercept
              },
              get : {
                method : "GET",
                interceptor : intercept
              },
            };
          },
          getStandardAction : function() {
            return {
              getOne : {
                method : 'GET',
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
              getList : {
                method : "GET",
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
              create : {
                method : "POST",
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
              modify : {
                method : "PUT",
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
              remove : {
                method : "DELETE",
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
            };
          },
        }
      };
    } ]);

webapp.factory("uuidFactory", function() {
	function r(r) {
		return Math.random() * r
	}
	return {
		v4 : function() {
			var n, a = "";
			for (n = 0; 36 > n; n++)
				a += 14 === n ? "4" : 19 === n ? "89ab".charAt(r(4)) : 8 === n
						|| 13 === n || 18 === n || 23 === n ? "-"
						: "0123456789abcdef".charAt(r(16));
			return a
		}
	};
});

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  SidebarController.$inject = ['GLOBAL_CONSTANT', 'postApi', '$scope', '$rootScope', '$state', '$filter', 'Helper'];
  function SidebarController(CONSTANT, postApi, $scope, $rootScope, $state, $filter, Helper) {

    var vm = this;
    vm.selectedMenu = 'dashboard';
    vm.collapseVar = 0;
    vm.secondCollapseVar = -1;
    vm.threeCollapseVar = -1;
    vm.menuList = [];

    vm.check = function (x) {
      if (x == vm.collapseVar)
        vm.collapseVar = 0;
      else
        vm.collapseVar = x;
    };

    vm.secondCheck = function (y) {
      if (y == vm.secondCollapseVar)
        vm.secondCollapseVar = 0;
      else
        vm.secondCollapseVar = y;
    };

    vm.threeCheck = function (y) {
      if (y == vm.threeCollapseVar)
        vm.threeCollapseVar = 0;
      else
        vm.threeCollapseVar = y;
    };

    $scope.$on('broadcastSetChangeMenuList', function(event, args) {
      vm.loadMenuData();
    });

    vm.loadMenuData = function () {
      vm.menuList = [];
      var mobileOnlyYN = "N";
      //if(checkMobile()) mobileOnlyYN = 'Y';
      var data = { mapCode: 'Menu.getMenuList', mobileOnlyYN : mobileOnlyYN};
      postApi.select(data, function (result) {
        if (result != null && result.header != null && result.header.status === CONSTANT.HttpStatus.OK) {
          vm.makeMenuList(result.body.docs, true);
          //var count = result.body.docs.length;
          var interval = setInterval(function() {
            if( vm.menuList.length > 0) {
              $(".sz-custom-navbar-toggle").css("display","block");
              initNavView();
              clearInterval(interval);
            }
          }, 600);
        } else {
          if (result != null && result.header != null && result.body != null)
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          else
          console.error('Error> setBaseMenuInfo');
        }
      }, function (error) {
        console.error('Error> setBaseMenuInfo', error);
      });
    };
    vm.loadMenuData();

    function makeSortPath(sort) {

      var sort = sort.toString();
      var result = Array();
      if(sort.length >= 3) {
        result.push(sort.substring(0, 3));
      }
      if(sort.length >= 6) {
        result.push(sort.substring(3, 6))
      }
      if(sort.length == 9) {
        result.push(sort.substring(6, 9))
      }
      return result;
    }
    vm.makeMenuList = function (data) {

      /* temp :
        Menu에 바로 데이터를 바인딩할 경우
        바인딩한 데이터를 바로 화면에 그리기 때문에 속도에 문제가 있어
        temp 에서 선 작업 한 후 메뉴리스트에 값을 대입
      */
      var temp = [];
      var bFoundMainPage = false;
      var mainPage = '';

      for (var i = 0; i < data.length; i++) {
        var o = {};
        o.menuId = data[i].menuId;
        o.depth = data[i].depth;
        o.name = data[i].menuNm;
        o.icon = data[i].icon;
        o.sort = data[i].sort;
        o.tempSortPath = makeSortPath(data[i].sort);
        o.idx = i;

        if(data[i].menuCode != null && data[i].menuCode != undefined) {
          o.menuCode = data[i].menuCode;
        }
        o.child = [];

        o.pageUrl = data[i].pageUrl;
        o.pageUrlParam = data[i].pageUrlParam;

        if (Number(data[i].depth) == 1) {
          temp.push(o);
        } else {
          var temp2;
          if(o.tempSortPath.length == 2) temp2 = o.tempSortPath[0];
          else temp2 = o.tempSortPath[0] + '' + o.tempSortPath[1];
          var sData = vm.findObject(temp, 'sort', temp2);
          if (sData['child'])
            sData['child'].push(o);
        }

        // var page = Helper.stateIs(data[i].pageUrl);
        // if (page == $rootScope.gVariable.mainPage) {
        //   bFoundMainPage = true;
        // }
      }

      // if (!bFoundMainPage && data.length > 0) {
      //   $rootScope.setGVariable('mainPage', Helper.stateIs(data[0].pageUrl));
      //   $state.go(data[0].pageUrl);
      // }

      vm.menuList = temp;
    };

    vm.findObject = function (obj, key, value) {
      for (var i = 0; i < obj.length; i++) {
        for (var objKey in obj[i]) {
          if (objKey == key) {
            if (obj[i][objKey] == value) {
              return obj[i];
            }
          }
        }
        if (obj[i]["child"].length > 0) {
          var result = vm.findObject(obj[i]["child"], key, value);
          if (result != false) return result;
        }
      }
      return false;
    };

    function getData() {
      var srch = {};
      srch.mapCode = "MaDatagroup.getDatagroupAndAction";

      var prms = postApi.select(srch, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length == 0) {
            $rootScope.setGVariable('dataGroupId', '');
            $rootScope.setGVariable('dataActionId', '');
            $rootScope.setGVariable('dataGroupNm', '');
            $rootScope.setGVariable('dataActionNm', '');
          } else {
            var data = result.body.docs[0];
            $rootScope.setGVariable('dataGroupId', data.DatagroupId);
            $rootScope.setGVariable('dataActionId', data.ActionId);
            $rootScope.setGVariable('dataGroupNm', data.DatagroupNm);
            if (data.ActionId) {
              $rootScope.setGVariable('dataActionNm', data.ActionNm + ' (' + $filter('utcToLocal')(data.ABeginDate,'yyyy-MM-dd') + '~' + $filter('utcToLocal')(data.AEndDate,'yyyy-MM-dd') + ')');
            }
          }
        }
      }, function(error) {
        console.table(error);
      });
    }

    getData();
  }

  // Header 쪽에 선언 하는 것이 맞으나
  // 소스 찾기가 어려울 것 같아 한 곳에 선언
  // Window Resize Event에 따른 HTML 에 사이즈 선언 함
  /**
* @description
*  메뉴 초기 설정
*/
  function initNavView() {

    setOsAgent();
    setToggleBtnEvent();
    setMenuEvent();
    setResizeEvent();
    setTimeout(function(){
        $(".side_wrapper").mCustomScrollbar();
    },1000);
  }

  function setMenuEvent() {

    $(".sidebar-nav > ul > li > a").click(function(e) {
      var currentState = $("body").attr("nav-state").split("-");
      if(currentState[0] == "md") {
        if(currentState[1].indexOf('rm') > -1 || currentState[1].indexOf('lm') > -1 || currentState[1].indexOf('s') > -1) {
          e.stopImmediatePropagation();
        }
      }
    });

    $(".sidebar-nav  ul  li  a").click(function(e) {
      if( $(this).attr("ui-sref") != undefined && $(this).attr("ui-sref") != "" ) {
        e.stopImmediatePropagation();
        var aThis = $(this);
        setTimeout(function(){
          $(".sidebar-nav  ul  li").removeClass("active");
          $(aThis).closest("li").addClass("active");
          $(aThis).closest("li").parent().closest("li").addClass("active");
          $(aThis).closest("li").parent().closest("li").parent().closest("li").addClass("active");
        },0);
      } else {

      }
    });

    $(".sidebar-nav > ul > li").hover(function(e) {
      var currentState = $("body").attr("nav-state").split("-");
      if(currentState[0] == "md") {
        if(currentState[1].indexOf('rm') > -1 || currentState[1].indexOf('lm') > -1 || currentState[1].indexOf('s') > -1) {

          $(this).addClass('active');
          $(this).find("> ul").css("overflow","auto");
          $(this).find("> ul").addClass("in");
          $(this).find("> ul").css("height", "auto");
          $(this).find("> ul").attr("aria-expanded", "true");
          $(this).find("> ul").attr("aria-hidden", "false");

          var offset = $(this).offset();
          $(this).find("> ul").css("top", offset.top);
          var $ulObj = $(this).find("> ul");
          var $thisObj = $(this);
          var ulHeight = ($ulObj.find('li').height() * $ulObj.find('li').length)
          if(offset.top + ulHeight > $(window).height()) {
            $ulObj.css("top","");
            $ulObj.css("bottom", $(window).height() - offset.top - $thisObj.height());
          }
        } else {
          $(this).find("> ul").css("top", "");
          $(this).find("> ul").css("bottom", "");
        }
      } else {
        $(this).find("> ul").css("top", "");
        $(this).find("> ul").css("bottom", "");
      }
    }, function(e){
      var currentState = $("body").attr("nav-state").split("-");
      if(currentState[0] == "md") {
        if(currentState[1].indexOf('rm') > -1 || currentState[1].indexOf('lm') > -1 || currentState[1].indexOf('s') > -1) {

          $(this).removeClass('active');
          $(this).find("> ul").removeClass("in");
          $(this).find("> ul").css("overflow","");
          $(this).find("> ul").css("height", "0px");
          $(this).find("> ul").attr("aria-expanded", "false");
          $(this).find("> ul").attr("aria-hidden", "true");

        } else {
          $(this).find("> ul").css("top", "");
          $(this).find("> ul").css("bottom", "");
        }
      } else {
        $(this).find("> ul").css("top", "");
        $(this).find("> ul").css("bottom", "");
      }
    });
  }

  /**
  * @description
  *  OS Agent 설정
  */
  function setOsAgent() {
    var isMobile = false;

    // Mobile 여부 확인
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
      isMobile = true;

    if (isMobile) {
      $("body").attr("is-device", "Y");
    } else {
      $("body").attr("is-device", "N");
    }

  }

  function changeNavState() {
    var currentState = $("body").attr("nav-state").split("-");
    var winWidth = $(window).width();

    if (winWidth < 768 ) {
      (currentState[1] == "on") ? currentState[1] = "off" : currentState[1] = "on";
      $("body").attr("nav-state", currentState[0] + "-" + currentState[1])
      if(currentState[1] == "on") setBlockLayer();
      else $("#nav-block-screen").detach();
    } else {
      var localStorage = window.localStorage;
      var navState = localStorage.getItem("navMenuMdSizeState");
      $("body").attr("nav-state", currentState[0] + "-" + navState);
    }
    setToggleImage();
  }

  /**
  * @description
  *  초기 페이지 진입시 Layer 설정
  */
  function setBlockLayer() {
    var $div = $("<div />", {
      id: "nav-block-screen",
      onclick: "changeNavState();"
    });
    $("html body").append($div.clone());
    $("#nav-block-screen").bind("click", function(){
      changeNavState();
    });
  }



  /**
  * @description
  *  토글 버튼 클릭시 nav state 값 변경
  */
  function setToggleBtnEvent() {
    $(".sz-custom-navbar-toggle").bind("click", function () {
      $(this).addClass("focus");
      var winWidth = $(window).width();

      if (winWidth < 768 ) {
        changeNavState();
      } else {
        var localStorage = window.localStorage;
        var navState;
        if( $("body").attr("nav-state") != undefined) navState = $("body").attr("nav-state").split("-")[1];
        else navState = localStorage.getItem("navMenuMdSizeState");

        if(navState == "l") {
          navState = "lm";
          hiddenSecondMenus()
        } else if(navState == "lm") {
          navState = "s";
          hiddenSecondMenus()
        } else if(navState == "s") {
          navState = "rm";
          hiddenSecondMenus()
        } else if(navState == "rm") {
          navState = "l";
        }
        localStorage.setItem('navMenuMdSizeState', navState);
        changeNavState();
      }

      setTimeout(function () { $(".sz-custom-navbar-toggle").removeClass("focus"); }, 150);
    });
  }

  function hiddenSecondMenus() {
    //$(".sidebar-nav > ul > li > ul").removeClass('active');
    $(".sidebar-nav > ul > li > ul").removeClass("in");
    $(".sidebar-nav > ul > li > ul").css("overflow","");
    $(".sidebar-nav > ul > li > ul").css("height", "0px");
    $(".sidebar-nav > ul > li > ul").attr("aria-expanded", "false");
    $(".sidebar-nav > ul > li > ul").attr("aria-hidden", "true");

  }

  function setToggleImage() {

    if ($(window).width() < 768 ) {
      $(".sz-custom-navbar-toggle i").removeClass('fa-outdent');
      $(".sz-custom-navbar-toggle i").removeClass('fa-indent');
      $(".sz-custom-navbar-toggle i").addClass('fa-bars');
    } else {
      var localStorage = window.localStorage;
      var navState = localStorage.getItem("navMenuMdSizeState");
      $(".sz-custom-navbar-toggle i").removeClass('fa-bars');
      if(navState == "l") {
        $(".sz-custom-navbar-toggle i").addClass('fa-outdent');
        $(".sz-custom-navbar-toggle i").removeClass('fa-indent');
      } else if(navState == "lm") {
        $(".sz-custom-navbar-toggle i").addClass('fa-outdent');
        $(".sz-custom-navbar-toggle i").removeClass('fa-indent');
      } else if(navState == "s") {
        $(".sz-custom-navbar-toggle i").removeClass('fa-outdent');
        $(".sz-custom-navbar-toggle i").addClass('fa-indent');
      } else if(navState == "rm") {
        $(".sz-custom-navbar-toggle i").removeClass('fa-outdent');
        $(".sz-custom-navbar-toggle i").addClass('fa-indent');
      }
    }
  }

  /**
  * @description
  *  화면 사이즈 변경 시 html element에 nav state 값을 변경해주는 함수
  */
  function setResizeEvent() {
    $(window).resize(function () {
      initNavState();
    });
  }

  /**
  * @description
  *  window 넓이에 따른 값 셋팅
  */
  function initNavState() {
    var winWidth = $(window).width();
    if (winWidth < 560) $("body").attr("nav-state", "xs-off");
    else if (winWidth < 768) $("body").attr("nav-state", "sm-off");
    else if (winWidth > 767 ) {

      if($("#nav-block-screen").length > 0) $("#nav-block-screen").detach();
      var localStorage = window.localStorage;
      var navState = localStorage.getItem("navMenuMdSizeState");
      if(navState == null || navState == undefined || navState == "on" || navState == "off") {
        navState = "l";
        localStorage.setItem('navMenuMdSizeState', navState);
      }
      $("body").attr("nav-state", "md-" + navState);
    }
    setToggleImage();
  }

  angular.module('salevis4-web')
    .component('sidebar', {
      templateUrl: 'components/ui-component/layout/sidebar/sidebar.html',
      controller: SidebarController,
      controllerAs: 'sidebar'
    });

})();

(function () {
  'use strict';
  HeaderController.$inject = ['$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', 'StaticVariable', 'Auth', 'modalFactory'];

  /** @ngInject */
  function HeaderController($log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, StaticVariable, Auth, modalFactory) {
    var vm = this;

    vm.srch = {};
    var translate = $filter("translate");

    //$log.info("console log info translate::", translate("LOGIN.BTN.LOGIN"));

    vm.loginInfo = {};
    vm.doLogin = doLogin;
    vm.isLogin = isLogin;
    vm.doLogout = doLogout;
    vm.doCheckSession = doCheckSession;
    vm.checkUse = false;
    vm.paddingTop = 40;

    vm.TENANTID = "";
    vm.TENANTNAME = "";
    if ($window.sessionStorage['loginSysAdminYN'] == "Y") {
      if($window.sessionStorage['srchTenantId'] == undefined) {
        vm.TENANTID = $window.sessionStorage['loginTenantId'];
        vm.TENANTNAME = $window.sessionStorage['loginTenantName'];
        $window.sessionStorage.setItem('srchTenantId', $window.sessionStorage['loginTenantId']);
        $window.sessionStorage.setItem('srchTenantName', $window.sessionStorage['loginTenantName']);
        $rootScope.gVariable.srchTenantId = $window.sessionStorage['loginTenantId'];
        $rootScope.gVariable.srchTenantName = $window.sessionStorage['loginTenantName'];
      } else {
        vm.TENANTID = $window.sessionStorage['srchTenantId'];
        vm.TENANTNAME = $window.sessionStorage['srchTenantName'];
        $rootScope.gVariable.srchTenantId = $window.sessionStorage['srchTenantId'];
        $rootScope.gVariable.srchTenantName = $window.sessionStorage['srchTenantName'];
      }
      vm.checkUse = true;
    }

    vm.srchTenantModal = function() {
      var ctrl = 'TenantModalCtrl as vc';
      var paramData = {TenantId:$rootScope.gVariable.srchTenantId}
      var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);
      modalInstance.result.then(function(okData) {
        vm.TENANTID = okData.TenantId;
        vm.TENANTNAME = okData.TenantNm;
        $window.sessionStorage.setItem('srchTenantId', okData.TenantId);
        $window.sessionStorage.setItem('srchTenantName', okData.TenantNm);
        $rootScope.gVariable.srchTenantId = okData.TenantId;
        $rootScope.gVariable.srchTenantName = okData.TenantNm;
        $rootScope.$broadcast('broadcastSetChangeTenantID', okData);
      }, function(cancelData) {});
    };

    vm.eraseTenant = function() {
      vm.TENANTID = $window.sessionStorage['loginTenantId'];
      vm.TENANTNAME = $window.sessionStorage['loginTenantName'];
      $window.sessionStorage.setItem('srchTenantId', $window.sessionStorage['loginTenantId']);
      $window.sessionStorage.setItem('srchTenantName', $window.sessionStorage['loginTenantName']);
      $rootScope.gVariable.srchTenantId = $window.sessionStorage['loginTenantId'];
      $rootScope.gVariable.srchTenantName = $window.sessionStorage['loginTenantName'];
      $rootScope.$broadcast('broadcastSetChangeTenantID', {});
    };
    doCheckSession();

    function doLogin() {
      vm.appName = MAIN.APP_NAME;
      $log.info("account::", vm.loginInfo.account);
      $log.info("secureCode::", vm.loginInfo.secureCode);
      $state.go("main.dashboard");
    }

    function isLogin() {}

    function doLogout() {}

    function doCheckSession() {
      var prms = loginApi.doCheckSession().post({}).$promise;

      prms.then(function(json) {
        if (json != null && json.responseVO != null && json.responseVO.header.status == CONSTANT.HttpStatus.OK && json.responseVO.body.docs != null && json.responseVO.body.docs != '') {
          //console.log('Login user')
          $rootScope.setUserSession(json.responseVO.body.docs[0]);

          Auth.init(json.responseVO.body.docs[0].permissions);

          vm.userNm = $window.sessionStorage['loginUserName'];
          vm.userGbn = $window.sessionStorage['loginUserGbn'];
          vm.userTerm = $window.sessionStorage['loginUserTerm'];

        } else {
          StaticVariable.sessionExpire();
          $state.go('home.main');
        }
        // gAlert("로그아웃 되었습니다.");
      }, function(error) {
        console.error('fail', status);
      });
    }
  }
  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  var header = {
    transclude: true,
    controller: HeaderController,
    bindings: {},
    controllerAs: "header",
    templateUrl: 'components/ui-component/layout/header/header.html'
  };

  webapp.component("header", header);
})();


(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */

    angular.module('salevis4-web')
        .component('sidebarSearch', {
            templateUrl: 'components/ui-component/layout/sidebar/sidebar-search/sidebar-search.html',
            controller: function ($scope) {
                $scope.selectedMenu = 'home';
            }
        });
})();

(function () {
    'use strict';

    HeaderNotificationController.$inject = ['$log','$window','LoginAPISrv','StaticVariable','GLOBAL_CONSTANT', 'gAlert', '$state', 'modalFactory', '$rootScope'];
    /** @ngInject */
    function HeaderNotificationController($log,$window,loginApi,StaticVariable,CONSTANT,gAlert, $state, modalFactory, $rootScope) {
      var vm = this;
      vm.user = {UserName:$rootScope.gVariable.UserName};
      vm.doLogout = doLogout;
      vm.myPage = myPage;
      vm.checkUse = false;
      vm.tenantId = $window.sessionStorage.loginTenantId;

      function doLogout() {
        StaticVariable.sessionExpire();
        var prms = loginApi.doLogout().post().$promise;
        prms.then(function(json) {
          var temp = {};
          temp.layoutBoard = "N";
          $window.sessionStorage.clear();
          $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
          gAlert('', 'Menu.SIGNEDOUT', {
            btn : '',
            fn : function() {
              //$window.location.replace('/' + CONSTANT.URL.CONTEXT);
              //$state.reload('main.login');
              // $window.location.replace('/#/home/main');
              $window.location.href="/";
            }
          });
        }, function(error) {
          console.error('fail', status);
        });
      }

      /**
       * 내정보 수정 팝업 호출
       *
       */
      function myPage() {
        var ctrl = 'MyPageModalCtrl as modalCtrl';
        var paramData = {UserId : $rootScope.gVariable.UserId, TenantId: $window.sessionStorage["loginTenantId"]};
        var page = "";

        if($window.sessionStorage["loginTenantId"] == "8LETQJJ81A") page = "wjm-mypage-modal.html";
        else page = "mypage-modal.html";

        var modalInstance = modalFactory.open("lg", "components/modal/mypage/"+ page, ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            //성공
          },
          function (cancelData) {
            // 취소
          }
        );
      }
    } // End Controller

    var header = {
      transclude: true,
      controller: HeaderNotificationController,
      bindings: {},
      controllerAs: "vc",
      templateUrl: 'components/ui-component/layout/header/header-notification/header-notification.html'
    };

    webapp.component("headerNotification", header);

})();

angular.module("salevis4-web").run(["$templateCache", function($templateCache) {$templateCache.put("i.html","<!doctype html><html ng-app=salevis4-web><head><title ng-bind=$root.title>더휴먼데이터센터</title><meta charset=utf-8><meta name=description content=\"\"><meta name=viewport content=\"width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no\"><meta http-equiv=Expires content=-1><meta http-equiv=Pragma content=no-cache><meta http-equiv=Cache-Control content=No-Cache><link rel=stylesheet href=assets/css/app.css><!-- Place favicon.ico and apple-touch-icon.png in the root directory --><!-- build:css({.tmp/serve,src}) styles/vendor.css --><!-- bower:css --><!-- run `gulp inject` to automatically populate bower styles dependencies --><!-- endbower --><!-- endbuild --><!-- build:css({.tmp/serve,src}) styles/app.css --><!-- inject:css --><!-- css files will be automatically insert here --><!-- endinject --><!-- endbuild --></head><body><!--[if lt IE 10]>\r\n    <p class=\"browsehappy\">최신 웹 브라우저로 업그레이드 하시기 바랍니다. (권장: Internet Explorer 11 이상, Google Chrome 76 이상). <a\r\n      href=\"http://browsehappy.com/\">최신 웹 브라우저 다운로드</a></p>\r\n    <![endif]--><div ui-view><div class=loading-container><div class=loading></div><div id=loading-text>loading...</div></div></div><!-- build:js(src) scripts/vendor.js --><!-- bower:js --><!-- run `gulp inject` to automatically populate bower script dependencies --><!-- endbower --><!-- endbuild --><!-- build:js({.tmp/serve,.tmp/partials,src}) scripts/app.js --><!-- inject:js --><!-- js files will be automatically insert here --><!-- endinject --><!-- inject:partials --><!-- angular templates will be automatically converted in js and inserted here --><!-- endinject --><!-- endbuild --><link rel=stylesheet href=assets/css/common.css><link rel=stylesheet href=assets/css/custom-media-width-size.css><link rel=stylesheet href=assets/css/fullcalendar.min.css><link rel=stylesheet href=assets/css/main.css><link rel=stylesheet href=assets/css/style.css><link rel=stylesheet href=assets/css/animate.css><script src=assets/global-constant.js></script><script src=assets/app/common/common.js></script><!--<script src=\"http://dmaps.daum.net/map_js_init/postcode.v2.js\"></script>--><!-- SSL 적용시 호출 --><script src=https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js></script><script src=assets/app/common/FileSaver.min.js></script><script src=assets/app/common/xlsx.full.min.js></script><script src=assets/app/common/fullcalendar.min.js></script><script src=assets/app/common/locale-all.js></script><script src=assets/app/common/signature_pad.min.js></script><script crossorigin=anonymous integrity=sha384-/x1aHz0nKRd6zVUazsV6CbQvjJvr6zQL2CHbQZf3yoLkezyEtZUpqUNnOLW9Nt3v src=https://browser.sentry-cdn.com/5.9.1/bundle.min.js></script><script crossorigin=anonymous src=https://browser.sentry-cdn.com/5.9.1/angular.min.js></script><script src=assets/app/vendor/d3.v3.min.js charset=utf-8></script><script src=assets/app/vendor/d3.layout.cloud.js charset=utf-8></script><script src=../bower_components/css-element-queries/src/ResizeSensor.js></script><script src=../bower_components/css-element-queries/src/ElementQueries.js></script><script type=text/javascript src=https://www.gstatic.com/charts/loader.js></script><script src=assets/app/vendor/html2canvas.js></script><script src=assets/app/vendor/html2canvas.min.js></script><script src=assets/app/common/wow.min.js></script><!--폰트아이콘--><script src=https://kit.fontawesome.com/48797d4313.js crossorigin=anonymous></script><script>Sentry.init({\r\n        dsn: \'https://16048dd690ce403199d465f9e650c996@o484328.ingest.sentry.io/5537304\',\r\n        integrations: [\r\n          new Sentry.Integrations.Angular(),\r\n        ],\r\n      });</script><!-- <script src=\"http://cdnjs.cloudflare.com/ajax/libs/waypoints/2.0.3/waypoints.min.js\"></script> bower.json에 추가--><script src=assets/app/common/jquery.counterup.min.js></script><script>new WOW().init();</script><!--\r\n    # PG결제\r\n      - API : https://www.iamport.kr/getstarted\r\n      - DOC : https://docs.iamport.kr/\r\n  --><script src=https://cdn.iamport.kr/js/iamport.payment-1.1.5.js></script><script>Sentry.init({\r\n      dsn: \'https://16048dd690ce403199d465f9e650c996@o484328.ingest.sentry.io/5537304\',\r\n      integrations: [\r\n        new Sentry.Integrations.Angular(),\r\n      ],\r\n    });\r\n\r\n    //결제초기화 : 상점ID\r\n    IMP.init(\"imp31731325\");</script></body></html>");
$templateCache.put("index.html","<!doctype html><head><title>더휴먼데이터센터</title><frameset rows=*,8 rows1=*,30 rows2_disabled=*,60 frameborder=0 framespacing=0 name=fst><frame src=i.html name=main frameborder=0 noresize><noframes><p></p></noframes></frameset></head>");
$templateCache.put("m.html","<!doctype html><html ng-app=salevis4-web><head><title ng-bind=$root.title>더휴먼데이터센터</title><meta charset=utf-8><meta name=description content=\"\"><meta name=viewport content=\"width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no\"><meta http-equiv=Expires content=-1><meta http-equiv=Pragma content=no-cache><meta http-equiv=Cache-Control content=No-Cache><link rel=stylesheet href=assets/css/app.css><!-- Place favicon.ico and apple-touch-icon.png in the root directory --><!-- build:css({.tmp/serve,src}) styles/vendor.css --><!-- bower:css --><!-- run `gulp inject` to automatically populate bower styles dependencies --><!-- endbower --><!-- endbuild --><!-- build:css({.tmp/serve,src}) styles/app.css --><!-- inject:css --><!-- css files will be automatically insert here --><!-- endinject --><!-- endbuild --></head><body><!--[if lt IE 10]>\r\n    <p class=\"browsehappy\">최신 웹 브라우저로 업그레이드 하시기 바랍니다. (권장: Internet Explorer 11 이상, Google Chrome 76 이상). <a\r\n      href=\"http://browsehappy.com/\">최신 웹 브라우저 다운로드</a></p>\r\n    <![endif]--><div ui-view><div class=loading-container><div class=loading></div><div id=loading-text>loading...</div></div></div><!-- build:js(src) scripts/vendor.js --><!-- bower:js --><!-- run `gulp inject` to automatically populate bower script dependencies --><!-- endbower --><!-- endbuild --><!-- build:js({.tmp/serve,.tmp/partials,src}) scripts/app.js --><!-- inject:js --><!-- js files will be automatically insert here --><!-- endinject --><!-- inject:partials --><!-- angular templates will be automatically converted in js and inserted here --><!-- endinject --><!-- endbuild --><link rel=stylesheet href=assets/css/common.css><link rel=stylesheet href=assets/css/custom-media-width-size.css><link rel=stylesheet href=assets/css/fullcalendar.min.css><link rel=stylesheet href=assets/css/main.css><link rel=stylesheet href=assets/css/style.css><link rel=stylesheet href=assets/css/animate.css><script src=assets/global-constant.js></script><script src=assets/app/common/common.js></script><!--<script src=\"http://dmaps.daum.net/map_js_init/postcode.v2.js\"></script>--><!-- SSL 적용시 호출 --><script src=https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js></script><script src=assets/app/common/FileSaver.min.js></script><script src=assets/app/common/xlsx.full.min.js></script><script src=assets/app/common/fullcalendar.min.js></script><script src=assets/app/common/locale-all.js></script><script src=assets/app/common/signature_pad.min.js></script><script crossorigin=anonymous integrity=sha384-/x1aHz0nKRd6zVUazsV6CbQvjJvr6zQL2CHbQZf3yoLkezyEtZUpqUNnOLW9Nt3v src=https://browser.sentry-cdn.com/5.9.1/bundle.min.js></script><script crossorigin=anonymous src=https://browser.sentry-cdn.com/5.9.1/angular.min.js></script><script src=assets/app/vendor/d3.v3.min.js charset=utf-8></script><script src=assets/app/vendor/d3.layout.cloud.js charset=utf-8></script><script src=../bower_components/css-element-queries/src/ResizeSensor.js></script><script src=../bower_components/css-element-queries/src/ElementQueries.js></script><script type=text/javascript src=https://www.gstatic.com/charts/loader.js></script><script src=assets/app/vendor/html2canvas.js></script><script src=assets/app/vendor/html2canvas.min.js></script><script src=assets/app/common/wow.min.js></script><!--폰트아이콘--><script src=https://kit.fontawesome.com/48797d4313.js crossorigin=anonymous></script><script>Sentry.init({\r\n      dsn: \'https://16048dd690ce403199d465f9e650c996@o484328.ingest.sentry.io/5537304\',\r\n      integrations: [\r\n        new Sentry.Integrations.Angular(),\r\n      ],\r\n\r\n      tracesSampleRate: 1.0,\r\n    });</script><!-- <script src=\"http://cdnjs.cloudflare.com/ajax/libs/waypoints/2.0.3/waypoints.min.js\"></script> bower.json에 추가--><script src=assets/app/common/jquery.counterup.min.js></script><script>new WOW().init();</script></body></html>");
$templateCache.put("app/app.html","<div id=wrapper><!-- Navigation --><!-- <div ui-view=\"header\"></div> --><header ng-if=\"$root.gVariable.noHeader == \'false\'\"></header><sidebar></sidebar><!-- /.navbar-top-links --><!-- /.navbar-static-side --><div id=page-wrapper style=\"min-height: 561px\"><div ui-view></div></div><!-- /#page-wrapper --></div>");
$templateCache.put("home/about.html","<!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=\"sub_content wow fadeInUp\"><!--타이틀--><h2>About <span>HDC</span></h2><h3>더휴먼 데이터센터는 인간의 생각과 마음, 조직, 일에 대해<br>연구하는 데이터 컨설팅 전문가 그룹입니다.</h3><!--//타이틀--></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!--전체컨텐츠--><div class=\"section human\"><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"c_white wow fadeInUp\"><span>Human</span></h2><h3 class=\"c_white wow fadeInUp\">데이터 분석에 대한 믿음과 신뢰로 휴먼 데이터센터는 미래를 향해 더욱더 성장하고 있습니다.</h3><!--//타이틀--><ul class=\"num_box wow fadeInUp\"><li><div class=human_tit>년 평균 프로젝트</div><div class=count><span class=counter>67</span></div></li><li><div class=human_tit>년간 평균 진단 및 분석</div><div class=count><span class=counter>28,500</span><em>건</em></div></li><li><div class=human_tit>누적 고객사</div><div class=count><span class=counter>145</span></div></li></ul></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"wow fadeInUp\">인사말</h2><h3 class=\"wow fadeInUp\">Let’s make Human better</h3><!--//타이틀--><div class=\"msg wow fadeInUp\"><p>더휴먼 데이터센터는 사람의 생각과 마음 조직과 일의 상호작용 속에서 발생하는 현상들을 연구하고 있습니다.<br><br>이를 통해 더 많은 사람들이 좀 더 행복하고, 좀 더 건강하며, 좀 더 생산성 높게 일할 수 있도록 사람과 일, 조직간의 상호작용을 연구합니다.<br><br>더 바람직한 방향으로 개선되도록 ‘데이터 기반의 HR(data-driven HR’)을 실현하여 조직의 변화와 혁신을 지원하고 있습니다.</p><p class=\"last_name wow fadeInUp\">더휴먼 데이터센터</p></div></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"wow fadeInUp\">연혁</h2><h3 class=underline>Let’s make Human better</h3><!--//타이틀--><div class=history><dl><dt class=\"wow fadeInUp\">2020</dt><dd><p class=\"wow fadeInUp\">위너스제이엠 [더휴먼 데이터센터] 분석 시스템 개발</p><p class=\"wow fadeInUp\">구직자 대상 취업욕구검사 도구 런칭</p><p class=\"wow fadeInUp\">위너스제이엠 직무스트레스 진단 Ver 1.1 리뉴얼</p><p class=\"wow fadeInUp\">꿀잠테라피 수면장애 모바일 오픈</p><p class=\"wow fadeInUp\">에듀센터 오픈</p></dd><dt class=\"wow fadeInUp\">2019</dt><dd><p class=\"wow fadeInUp\">조직 직장내 괴롭힘 실태조사 서비스 런칭</p><p class=\"wow fadeInUp\">진로성숙 및 학교적응 스트레스 검사 보급</p></dd><dt class=\"wow fadeInUp\">2018</dt><dd><p class=\"wow fadeInUp\">EAP 서비스 생산성(ROI) 측정방법 개발</p><p class=\"wow fadeInUp\">전직지원협회 조선업 퇴직자 대상 심리안정 프로그램 공로상 수상</p><p class=\"wow fadeInUp\">버크만코리아와 조직심리 진단도구 EAP분야 독점공급 체결</p></dd><dt class=\"wow fadeInUp\">2017</dt><dd><p class=\"wow fadeInUp\">HRD KOREA 인적자원개발 솔루션 부문(EAP) 대상 수상</p><p class=\"wow fadeInUp\">본사 및 서울숲 임직원 전용 상담센터 개소</p></dd><dt class=\"wow fadeInUp\">2016</dt><dd><p class=\"wow fadeInUp\">공공기관 대상 직무 스트레스 진단 실시</p><p class=\"wow fadeInUp\">직무스트레스 고위험군 및 자살예방 스크리닝 모델 개발</p><p class=\"wow fadeInUp\">위너스제이엠 모바일 웹사이트 오픈</p><p class=\"wow fadeInUp\">독자적인 온라인 스트레스 진단 체계 런칭</p></dd><dt class=\"wow fadeInUp\">2015</dt><dd><p class=\"wow fadeInUp\">EAP전문기관 독립법인 설립</p><p class=\"wow fadeInUp\">전직지원프로그램과 EAP프로그램 통합 서비스 실시</p></dd><dt class=\"wow fadeInUp\">2013</dt><dd><p class=\"wow fadeInUp\">EAP사업부 신설</p></dd><dt class=\"wow fadeInUp\">2001</dt><dd><p class=\"wow fadeInUp\">국내기업 최초 전직지원 전문기업 “제이엠커리어” 설립</p></dd></dl></div></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!--human data 수치--><script>$(\'.counter\').counterUp({\r\n        delay: 10,\r\n        time: 1000\r\n    });</script>");
$templateCache.put("home/business.html","<!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"wow fadeInUp\"><span>Business</span></h2><h3 class=\"wow fadeInUp\">IT플랫폼 기반의 데이터 서비스를 통해<br>사람, 조직, 일 , 모두가 성장하는 데이터 컨설팅을 제공합니다.</h3><!--//타이틀--></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!-------조직스트레스-------><!--전체컨텐츠--><div class=\"section business\"><div class=business1><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"wow fadeInUp\"><span>조직 스트레스 진단</span></h2><h3 class=\"wow fadeInUp\">Good Condition, Good Performance<br><span>매년 10,000명 이상이 참여하는 직장인 스트레스 Assessment</span></h3><!--//타이틀--></div></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=\"sub_content busi\"><ul class=busi_box01><li><dl><dt class=\"wow fadeInUp\">조직 건강도 진단<br><span>Org Mental Health Assessment</span></dt><dd class=\"wow fadeInUp\">업종별, 조직 유형별, 스트레스 분석<br>위험군 부서별 특성 분석</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">팀 스트레스 진단<br><span>Team Stress Inventory</span></dt><dd class=\"wow fadeInUp\">직무 스트레스 원인에 따른<br>부서별, 스트레스 패턴, 위험군 분포 등 제공</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">개인 스트레스 진단<br><span>Individual Stress Inventory</span></dt><dd class=\"wow fadeInUp\">개인별 직무스트레스 진단 보고서<br>스트레스 원인, 증상 등 맞춤 보고서 제공</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">스트레스 고위험군 선별시스템<br><span>Stress Screening System</span></dt><dd class=\"wow fadeInUp\">스트레스 위험군에 대한<br>초기 선별대응 시스템 구축</dd></dl></li></ul></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!-------//조직스트레스-------><!-------직장내괴롭힘-------><!--전체컨텐츠--><div class=\"section business\"><div class=business2><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"wow fadeInUp\"><span>직장 내 괴롭힘</span></h2><h3 class=\"wow fadeInUp\">Good worker, Good Company<br><span>문제확산 사전차단, 건강한 조직을 만드는 예방중심의 Assessment Process</span></h3><!--//타이틀--></div></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=\"sub_content busi\"><ul class=busi_box02><li><dl><dt class=\"wow fadeInUp\">직장 내 괴롭힘 진단<br><span>Workplace harassment Assessment</span></dt><dd class=\"wow fadeInUp\">직장 내 괴롭힘, 따돌림, 성희롱 등 피해규모<br>주로 발생하는 괴롭힘 현황 평가조사</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">개인 직장 내 괴롭힘 평가<br><span>Personality harassment Assessment</span></dt><dd class=\"wow fadeInUp\">직장 내 괴롭힘 사건 관련, 개인의 피해수준을<br>분석/평가하여 객관적인 정보 제공</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">외부 고충처리 시스템<br><span>External grievance processing system</span></dt><dd class=\"wow fadeInUp\">직장 내 괴롭힘 등 고충처리 문제 발생에<br>따른 외부전문가의 심리평가 및 행동변화 상담 제공</dd></dl></li></ul></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!-------//직장내괴롭힘-------><!-------커리어개발진단-------><!--전체컨텐츠--><div class=\"section business\"><div class=business3><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"wow fadeInUp\"><span>커리어 개발진단</span></h2><h3 class=\"wow fadeInUp\">Good Career, Good Life<br><span>신입부터 퇴직 이후까지 전 생애 커리어 라이프 진단(Lifespan Development Career)</span></h3><!--//타이틀--></div></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=\"sub_content busi\"><ul class=busi_box02><li><dl><dt class=\"wow fadeInUp\">경력개발 진단<br><span>Career Professional Inventory</span></dt><dd class=\"wow fadeInUp\">조직 문화에 있어 6가지 유형의 사내 경력개발<br>방향에 따른 개인의 경력개발 방향을 진단</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">퇴직예정자 은퇴 준비도 진단<br><span>Pre-Retirement Life Plan Inventory</span></dt><dd class=\"wow fadeInUp\">퇴직예정 임직원들의 은퇴이후<br>6대 인생설계 영역 진단</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">정년퇴직자 인생설계 진단<br><span>Retirement Active Senior Inventory</span></dt><dd class=\"wow fadeInUp\">조직에서의 정년퇴직 이후 본인이<br>희망하는 커리어 라이프스타일을 진단하는 검사</dd></dl></li></ul></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!-------//커리어개발진단-------><!-------버크만리더십진단-------><!--전체컨텐츠--><div class=\"section business\"><div class=business4><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"wow fadeInUp\"><span>버크만 리더십 진단</span></h2><h3 class=\"wow fadeInUp\">Good People, Good Performance<br><span>전세계적으로 신뢰도와 타당도가 확보된 Global Leading Assessment</span></h3><!--//타이틀--></div></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=\"sub_content busi\"><ul class=busi_box02><li><dl><dt class=\"wow fadeInUp\">버크만 리더십<br><span>The Birkman Method Leadership Program</span></dt><dd class=\"wow fadeInUp\">계층별 전사교육, 리더 및 신입사원 교육<br>소통, 커뮤니케이션, 리더십 역량강화, 팔로워십 등<br>변화와 혁신의 인사이트를 얻는 과정</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">버크만 조직활성화<br><span>The Birkman Method Team Program</span></dt><dd class=\"wow fadeInUp\">팀빌딩, 부서간 소통, 조직활성화, 팀 역량강화<br>강점개발 및 커뮤니케이션, 360진단 등<br>그룹 차원에서 논의하고 인사이트를 얻는 팔로업 과정</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">버크만 개인 디브리핑/코칭<br><span>The Birkman Method Individual Debriefing</span></dt><dd class=\"wow fadeInUp\">개인별 디브리핑 코칭 과정 속에서<br>리더십 인사이트를 제공하는 과정</dd></dl></li></ul></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!-------//버크만리더십진단-------><!-------조직맞춤형-------><!--전체컨텐츠--><div class=\"section business\"><div class=business5><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"wow fadeInUp\"><span>조직 맞춤형 프로젝트</span></h2><h3 class=\"wow fadeInUp\">Good Balance, Good Performance<br><span>프로젝트 목표에 맞는 Customizing, Assessment R&D. ROI</span></h3><!--//타이틀--></div></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--><!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=\"sub_content busi\"><ul class=busi_box02><li><dl><dt class=\"wow fadeInUp\">목표에 맞는 맞춤형 진단개발<br><span>Customizing R&D</span></dt><dd class=\"wow fadeInUp\">계층별 특성에 맞는 평가 툴 개발<br>측정과 분석까지 전 과정 진행</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">사전/사후 효과성 진단<br><span>Pre-Post Diagnosis</span></dt><dd class=\"wow fadeInUp\">효과성을 측정하기 위한 사전/사후 변화<br>Follow up 서비스 진행</dd></dl></li><li><dl><dt class=\"wow fadeInUp\">조직 워크라이프 밸런스 조사<br><span>Work and Life Balance Survey</span></dt><dd class=\"wow fadeInUp\">개인별 디브리핑 코칭 과정 속에서<br>리더십 인사이트를 제공하는 과정</dd></dl></li></ul></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠--> <!-------//조직맞춤형------->");
$templateCache.put("home/contacts.html","<!--전체컨텐츠--><div class=section><!--서브센터컨텐츠--><div class=sub_content ng-controller=\"ContactsCtrl as vc\"><!--타이틀--><h2 class=\"wow fadeInUp\"><span>Contact</span></h2><h3 class=\"wow fadeInUp\">귀사의 고민, 더휴먼 데이터센터가 함께 해결하겠습니다.</h3><!--//타이틀--><!--오시는길--><div class=location><h4 class=\"wow fadeInUp\">오시는길</h4><div class=\"map wow fadeInUp\"><div class=map_info>서울특별시 영등포구 경인로 775 (문래동3가 55-20, 에이스하이테크시티 1동 9층)<br><br><br>humandc@winnersjm.co.kr<br>02 6956 9501<br></div><div class=map_img><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.711058635723!2d126.8953627160834!3d37.5147324348494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9ef6551bb4f5%3A0xc21fab53024fab3f!2z7JyE64SI7IqkIOygnOydtOyXoA!5e0!3m2!1sko!2skr!4v1586756874479!5m2!1sko!2skr\" width=100% height=350 frameborder=0 style=border:0 allowfullscreen aria-hidden=false tabindex=0></iframe></div></div></div><!--//오시는길--><!--사업문의--><div class=contact><h4 class=\"wow fadeInUp\">사업문의</h4><form class=\"form wow fadeInUp\" role=form name=theForm><ul class=form><li><div>이름<span class=point_red ng-show=theForm.name.$invalid>*</span></div><div><input type=text class=input_txt2 name=name ng-model=vc.srch.name minlength=2 maxlength=6 required></div></li><li><div>회사명<span class=point_red ng-show=theForm.company.$invalid>*</span></div><div><input type=text class=input_txt2 name=company ng-model=vc.srch.company maxlength=15 required></div></li><li><div>부서명</div><div><input type=text class=input_txt2 ng-model=vc.srch.department maxlength=15></div></li><li><div>이메일</div><div><input type=email class=input_txt2 ng-model=vc.srch.email></div></li><li><div>연락처<span class=point_red ng-show=theForm.mobile.$invalid>*</span></div><div><input type=text class=input_txt2 name=mobile ng-model=vc.srch.mobile numbers-hyphen required maxlength=13 minlength=11></div></li><li><div>내용</div><div><textarea ng-model=vc.srch.memo></textarea></div></li></ul></form><div class=\"bt_wrap wow fadeInUp\"><input type=button value=목록 class=bt_gray> <input type=submit value=확인 class=bt_sky ng-click=vc.submit()></div></div><!--//사업문의--></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠-->");
$templateCache.put("home/home.html","<!-- 헤더 --><!-- for pc .section--module_header__on --><div id=section--module_header ng-controller=\"HeaderCtrl as vc\"><div class=section--module_inner><div class=section--header_top><!-- for mobile .on --><div class=section--header_content><button type=button class=button--toggle_gnb><i class=\"fa fa-bars\"></i></button> <a href=/ target=_parent class=link--header_logo><img src=assets/images/logo.png alt=\"the human data center\" class=image--header_logo> </a><!-- 모바일 gnb --><div class=section--mobile_gnb><div class=section--mobile_gnb_header><p class=text--mobile_gnb_header_title><img src=assets/images/logo.png alt=\"the human data center\" style=\"background-size: contain; width: 138px; position: relative;bottom: 2px\"></p><button type=button class=button--close_mobile_gnb><i class=\"fa fa-bars\"></i></button></div><ul class=list--gnb><li class=\"item--gnb item--gnb_consulting\"><a ui-sref=\"home.about({new :true})\" ui-sref-opts=\"{reload : true}\" class=link--gnb><span>About us</span></a></li><li class=\"item--gnb item--gnb_online\"><a ui-sref=\"home.business({new :true})\" ui-sref-opts=\"{reload : true}\" class=link--gnb><span>Business</span></a></li><li class=\"item--gnb item--gnb_solutions\"><a ui-sref=\"home.prcenter({new :true})\" ui-sref-opts=\"{reload : true}\" class=link--gnb><span>PR Center</span></a></li><li class=\"item--gnb item--gnb_abouts_us\"><a ui-sref=\"home.contacts({new :true})\" ui-sref-opts=\"{reload : true}\" class=link--gnb><span>Contacts</span></a></li></ul></div><!---\r\n        <div class=\"section--search\" ng-controller=\"ProductSearchCtrl as vc\">\r\n          <form ng-submit=\"vc.doSearch(form)\">\r\n            <input type=\"text\" class=\"input--search_keyword\" name=\"SearchKey\" ng-model=\"vc.srch.SearchKey\" />\r\n            <button type=\"button\" class=\"button--search_keyword\"></button>\r\n          </form>\r\n        </div>\r\n\r\n\r\n        <ul class=\"lang_list lang_list_on\">\r\n          <li class=\"on lang_on\"><a href=\"javascript:void(0);\"><span class=\"mainOn\">{{vc.getCurrentLanguage()}}</span></a></li>\r\n          <li class=\"lang_list_sub\"><a href=\"javascript:void(0);\" ng-click=\"vc.changefn(\'ko\')\">KOR</a></li>\r\n          <li class=\"lang_list_sub\"><a href=\"javascript:void(0);\" ng-click=\"vc.changefn(\'en\')\">ENG</a></li>\r\n        </ul>\r\n        ---><div class=dimmed></div></div></div><!--서브메뉴 배경 --\r\n    <div class=\"section--header_bottom\"></div>\r\n    --서브메뉴 배경 --></div></div><!-- /헤더 --><div id=wrapper><!-- Navigation --><div id=home-wrapper style=\"min-height: 561px\"><div ui-view></div></div><!-- /#page-wrapper --></div><!-- 푸터 --><div id=section--module_footer><div class=section--module_inner><div class=section--footer_information ng-controller=\"HeaderCtrl as vc\"><div class=text--footer_information style=\"margin-bottom: 0\"><p>더휴먼데이터센터 02-6956-9501 humandc@winnersjm.co.kr | Copyrightⓒ2015 WINNERSJM Co., Ltd. All rights reserved</p><p>서울특별시 영등포구 경인로 775 (문래동3가 55-20, 에이스하이테크시티 1동 9층) | 사업자번호 : 135-88-00279 | 대표 : 윤종만 TEL. (02)2676-9501 | FAX. (02)703-9182</p><!---\r\n        <span>{{ \'Menu.ADDR_KO\' | translate }}</span>\r\n        <span><a href=\"javascript:void(0);\" ng-click=\"vc.privateModal()\"\r\n            ng-show=\"currentLanguage == \'ko\'\">개인정보처리방침</a></span>\r\n        <span>Copyright(c) by Point Mobile, All Rights Reserved.</span>\r\n        ---></div><!--\r\n      <ul class=\"list--sns\">\r\n        <li class=\"item--sns item--sns_linkedin\"><a href=\"https://www.linkedin.com/company/pointmobilekr\"\r\n            target=\"_blank\" class=\"link--sns\"> <span class=\"image--sns_icon\"></span>\r\n          </a></li>\r\n        <li class=\"item--sns item--sns_youtube\"><a\r\n            href=\"https://www.youtube.com/channel/UCmDuGO_lsI0yKI30zFOo_Tw?view_as=subscriber\" target=\"_blank\"\r\n            class=\"link--sns\"> <span class=\"image--sns_icon\"></span>\r\n          </a></li>\r\n        <li class=\"item--sns item--sns_twiter rel_top\" style=\"margin-left: -1px; padding-left: -1px;\"><a\r\n            href=\"https://twitter.com/PointMobileKR\" target=\"_blank\" class=\"link--sns\"> <img\r\n              src=\"assets/images/icon_social_twiter.png\" alt=\"\" />\r\n          </a></li>\r\n      </ul>\r\n      --></div><!--\r\n    <a href=\"#\" class=\"link--goto_top\"> <span class=\"image--top_arrow\"></span>\r\n    </a>\r\n    ---></div></div><script>$(\".lang_list_sub\").on({\r\n    touchend: function () {\r\n      $(\".lang_list_on\").removeClass(\"lang_list\");\r\n    },\r\n  });\r\n\r\n  $(\".lang_list_on\").on({\r\n    touchstart: function () {\r\n      if ($(\"#lang_list_on\").hasClass(\"lang_list\") === false)\r\n        $(\".lang_list_on\").addClass(\"lang_list\");\r\n    },\r\n  });\r\n\r\n  $(\"a.link--gnb\").on({\r\n    click: function (event) {\r\n      //PC용이거나. 하위메뉴가 없으면.\r\n      if (\r\n        $(\".button--toggle_gnb\").css(\"display\") == \"none\" ||\r\n        $(this).hasClass(\"non-child\")\r\n      ) {\r\n        //event.stopImmediatepropagation();\r\n        event.preventDefault();\r\n        location.href = $(this).attr(\"href\");\r\n        $(\"#section--module_header\").removeClass(\"section--module_header__on\");\r\n      }\r\n    },\r\n  });\r\n\r\n  $(\".section--header_content\").hover(\r\n    function () {\r\n      $(\"#section--module_header\").addClass(\"section--module_header__on\");\r\n    },\r\n    function () {\r\n      $(\"#section--module_header\").removeClass(\"section--module_header__on\");\r\n    }\r\n  );\r\n  $(\".button--toggle_gnb\").click(function () {\r\n    $(\".section--header_content\").addClass(\"on\");\r\n  });\r\n\r\n  $(\".button--close_mobile_gnb\").click(function () {\r\n    $(\".section--header_content\").removeClass(\"on\");\r\n  });\r\n\r\n  $(\"a.link--goto_top\").click(function (e) {\r\n    event.preventDefault();\r\n    $(\"html, body\").animate(\r\n      { scrollTop: $(\"#section--module_header\").offset().top },\r\n      500\r\n    );\r\n  });\r\n\r\n  $(\".button--search_keyword\").on(\"click\", function (b) {\r\n    var c = $(\".section--search\"),\r\n      d = $(\".input--search_keyword\"),\r\n      e = c.hasClass(\"on\"),\r\n      f = d.val();\r\n\r\n    if (e) {\r\n      c.removeClass(\"on\");\r\n      d.blur();\r\n    } else {\r\n      c.addClass(\"on\");\r\n      d.focus();\r\n    }\r\n\r\n    if (($(\".button--toggle_gnb\").css(\"display\") == \"none\" || e) && f != \"\") {\r\n      if ($(\".mainOn\").text() == \"KOR\") {\r\n        location.href = \"/#/ko/home/search-result/\" + f;\r\n      } else if ($(\".mainOn\").text() == \"ENG\") {\r\n        location.href = \"/#/en/home/search-result/\" + f;\r\n      }\r\n    } else {\r\n      event.preventDefault();\r\n      return false;\r\n    }\r\n  });</script>");
$templateCache.put("home/prcenter-view.html","<!---게시판 view 영역 [모든 서브컨텐츠는 타이틀 하단의 생성된 div 안에 들어갑니다. 각 컨텐츠마다 주석달려있으며 주석이 끝나는영역까지 입니다. 게시판의 경우 리스트부분과 뷰, 쓰기부분은 교체해주면 됩니다. ]--><div class=board_view ng-controller=\"PrCenterViewCtrl as vc\"><ul><li class=write_tit ng-bind=vc.noticeData[0].Title></li><li class=write_date>{{vc.noticeData[0].RegDate | utcToLocal : \'yyyy-MM-dd\'}} / {{vc.noticeData[0].RegUserNm}}</li><li class=write_content><div class=view_con><!-- <img src=\"{{$root.getImageUrl(vc.noticeData[0].uploadFileList[0].PhysicalFileNm, vc.srch.srchTenantId, vc.noticeData[0].uploadFileList[0].PhysicalPath)}}\" alt=\"게시판이미지\"> --><p ng-bind-html=vc.noticeData[0].Contents></p></div></li></ul><div class=bt_wrap><input tpye=button value=목록 class=bt_gray ng-click=vc.goList()> <input tpye=button value=확인 class=bt_sky ng-click=\"\"></div></div><!--//게시판 view 영역-->");
$templateCache.put("home/prcenter.html","<!--전체컨텐츠--><div class=section ng-controller=\"PrCentreCtrl as vc\"><!--서브센터컨텐츠--><div class=sub_content><!--타이틀--><h2 class=\"wow fadeInUp\"><span>HDC</span> News</h2><h3 class=\"wow fadeInUp\">더휴먼 데이터센터의 다양한 소식과 최신 리포트를 알려드립니다.</h3><!--//타이틀--><!--게시판리스트--><div class=\"board wow fadeInUp\"><ul><li ng-repeat=\"item in vc.lists\" ng-click=vc.goDetail(item.BbsPostId)><a><div class=brd_date><p class=date_day ng-bind=item.date></p><p class=date_ym>{{item.year}}-{{item.month}}</p></div><div class=brd_tit><p class=brd_cate ng-bind=item.BoardTypeNm></p>{{item.Title}}</div></a></li></ul><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad wow fadeInUp\"><div class=\"paging dataTables_paginate pull-right\"><ul direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div><!--//게시판리스트--><!---게시판 쓰기--><div class=\"board_write wow fadeInUp\" style=display:none><ul><li class=write_tit><input type=text style=\"width:90%; height:35px\" placeholder=제목></li><li class=write_content><textarea></textarea></li></ul><div class=bt_wrap><input tpye=button value=목록 class=bt_gray> <input tpye=button value=확인 class=bt_sky></div></div><!--//게시판 view 영역--></div><!--//서브센터컨텐츠--></div><!--//전체컨텐츠-->");
$templateCache.put("reserve/meeting-daily-modal.html","<div class=modal-content style=\"min-height: 500px\"><div class=\"modal-header ng-scope\"><div class=page-header>일별 예약정보</div></div><div class=\"modal-body ng-scope\" style=\"min-height: 400px\"><div class=row><div class=col-lg-12><div class=table-responsive><tree-grid tree-data=tree_data tree-control=my_tree col-defs=col_defs expand-on=expanding_property on-select=my_tree_handler(branch) expand-level=4 icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-minus\" icon-collapse=\"fa fa-minus\"></tree-grid></div></div></div><!-- /row --></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.OK\' | translate }}</button></div></div>");
$templateCache.put("reserve/meeting-daily.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 reserve_body_blue\" ng-init=vc.getList()><div class=row><!-- 년/월/일 선택 --><div class=\"col-lg-3 col-md-3 col-xs-12\"><div class=dataloader ng-show=vc.dataloader></div><div class=form-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty ng-valid-date\" uib-datepicker-popup=yyyy-MM-dd ng-model=vc.tmCalDt ng-change=vc.getSearch() is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=에약일 aria-invalid=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!--// 년/월/일 선택 --><!-- 회의실선택 및 달력보기 --><div class=\"col-lg-9 col-md-9 col-xs-12\"><div class=pull-right><div class=\"fl-l mr-5\"><common-code-tree code-type=\"\'MEETINGROOM\'\" reload-seq=vc.reloadSeq code-model=vc.srch.MeetingRoom code-changed=vc.getSearch prevent-changing=false></common-code-tree></div><div class=\"fl-l form-group\"><button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button><!--<button class=\"btn btn-default\" ng-click=\"vc.resetSearch()\">\r\n            <i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}\r\n            입력값 초기화 후 자동 리스트 재조회\r\n          </button> --> <button type=button class=\"btn btn-primary mr-10\" ng-click=vc.goCalendar()><span class=\"fa fa-calendar-o\" aria-hidden=true></span> 월별 예약현황</button></div></div></div><!--// 회의실선택 및 달력보기 --></div><!-- //row --><!-- 코멘트 부분 --><div class=row><div class=\"col-lg-12 col-md-12\"><div class=\"col-lg-6 col-md-6 pl-0 col-xs-12 mt-10\"><span class=\"pull-left reserve_commnet\">※ 예약시간을 먼저 선택해주세요.</span></div><div class=\"col-lg-6 col-md-6 pl-0 col-xs-12 mt-10\"><span class=\"my-right-float reserve_commnet\">※ 예약 삭제는 해당라인의 <span><button type=button class=\"btn btn-default\"><i class=\"fa fa-close\"></i></button></span>을 클릭하세요.</span></div></div></div><!-- //코멘트 부분 --><!-- 시간대별 예약 현황 테이블 --><div class=\"row mt-10\"><div class=\"col-lg-12 col-md-12 reserve_table_wrap pr-10\"><table class=\"table reserve_table\"><colgroup><col width=25%><col width=50%><col width=25%></colgroup><tr ng-repeat=\"li in vc.timeList\" ng-class=li.RowCSS><th><label style=\"cursor: pointer\" ng-if=\"li.Reserved == null || li.Reserved == \'N\'\"><input type=checkbox name=ch id={{$index}} ng-model=li.Reserv ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" ng-change=vc.checkTime({{$index}})>{{li.str}}</label><label ng-if=\"li.Reserved != null && li.Reserved == \'Y\'\"><i class=\"glyphicon glyphicon-check\" ng-click=\"vc.DataDelete(li.ReserveId, li.RegUser)\"></i> <span ng-click=vc.viewDetail(li)>{{li.str}}</span></label></th><td class=modal-header ng-show=\"li.Company != null\"><button type=button class=\"close pt-5 mt-5\" data-dismiss=modal ng-click=\"vc.DataDelete(li.ReserveId, li.RegUser)\" ng-show=\"li.RegUser == $root.gVariable.UserId\"><i class=\"fa fa-close\"></i></button><div class=reserve_meet_detail ng-click=vc.viewDetail(li)><strong class=reserve_meet_detail_strong><span ng-if=li.DeptNm>[{{li.DeptNm}}] </span>{{li.UserNm}}</strong><span class=mr-5 ng-if=\"li.Mobile && li.Mobile != \'null\'\"> / {{li.Mobile}}</span><span class=mr-5 ng-if=\"li.TelNo && li.TelNo != \'null\'\"> / {{li.TelNo}}</span> <span class=mr-5>{{li.Comment}}</span></div></td><td><strong ng-click=vc.viewDetail(li)>{{li.Status}}</strong></td></tr></table></div></div><!--// 시간대별 예약 현황 테이블 --></div>");
$templateCache.put("reserve/meeting-detail-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>예약정보</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>시간</label><div class=\"form-control txt_view\" ng-bind=vc.data.ReserveTime></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>등록자</label><div class=\"form-control txt_view\"><span ng-if=vc.data.DeptNm>[{{vc.data.DeptNm}}] </span>{{vc.data.UserNm}}</div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>전화번호</label><div class=\"form-control txt_view\"><span ng-show=\"vc.data.TelNo && vc.data.TelNo != \'null\'\">{{vc.data.TelNo}}</span></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>핸드폰</label><div class=\"form-control txt_view\"><span ng-show=\"vc.data.Mobile && vc.data.Mobile != \'null\'\">{{vc.data.Mobile}}</span></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>이용목적</label><div class=\"form-control txt_view\"><span ng-show=\"vc.data.Comment && vc.data.Comment != \'null\'\">{{vc.data.Comment}}</span></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>상태</label><div class=\"form-control txt_view\" ng-bind=vc.data.ApprYN></div></div></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.OK\' | translate }}</button></div></div>");
$templateCache.put("reserve/meeting-detail.html","<script src=scripts/slick.min.js></script><link rel=stylesheet href=styles/slick.css><link rel=stylesheet href=styles/slick-theme.css><div class=reserve_inner ng-controller=\"MeetingDetailCtrl as vc\" data-ng-init=init()><div class=reserve-container id=toastContainer><div class=row><div class=\"col-lg-12 col-md-12 pl-0\"><!-- 예약현황 (좌측) --><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12 mt-20 m_pd_0 m_mt_10\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 reserve_title reserve_title_gray\" ng-click=vc.goCalendar()><h4 class=monthR>{{vc.monthlyReserve}}</h4></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 reserve_title reserve_title_blue\"><h4>예약하기</h4></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 reserve_title reserve_title_gray\" ng-click=vc.myReserveList()><h4>내 예약</h4></div><ui-view></ui-view></div><!-- //예약현황 (좌측) --><!-- 회의실 예약등록 정보 (우측) --><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12 mt-20 m_pd_0 pr-0\"><div class=\"col-lg-12 col-md-12 reserve_title reserve_title_cyan\"><h4>회의실 예약등록 정보</h4></div><div class=\"col-lg-12 col-md-12 reserve_body_cyan\"><!-- 코멘트 부분 --><div class=row><div class=\"col-lg-12 col-md-12 col-md-12\"><div class=\"col-lg-7 col-md-7 pl-0\"><span class=\"pull-left reserve_commnet\">※ 예약시간을 먼저 선택해주세요.</span></div><div class=\"col-lg-5 col-md-5 pr-0\"><span class=\"my-right-float reserve_commnet m_pl10\">※ (*)표시 필수입력</span></div></div></div><!-- //코멘트 부분 --><form id=form1 name=form1><!-- 예약내용 입력 --><div class=\"row reserve_meet_regist mt-10\"><div class=\"col-lg-12 col-md-12\"><div class=\"form-group form-inline xs-mb0\"><label title=소속지점>소속지점</label><input type=text class=form-control ng-model=vc.data.DeptNm disabled></div></div><div class=\"col-lg-12 col-md-12\"><div class=\"form-group form-inline xs-mb0\"><label title=예약자명>예약자명</label><input type=text class=form-control ng-model=vc.data.userName required></div></div><div class=\"col-lg-12 col-md-12\"><div class=\"form-group form-inline xs-mb0\"><label title=전화번호>전화번호</label><input type=text class=form-control ng-model=vc.data.TelNo></div></div><div class=\"col-lg-12 col-md-12\"><div class=\"form-group form-inline xs-mb0\"><label title=핸드폰>핸드폰</label><input type=text class=form-control ng-model=vc.data.Mobile></div></div><div class=\"col-lg-12 col-md-12\"><div class=\"form-group form-inline xs-mb0\"><label title=이용목적><span class=text-red>*</span> 이용목적</label><input type=text class=form-control required ng-model=vc.data.Comment></div></div><div class=\"col-lg-12 col-md-12 mt-10\"><div class=\"col-lg-12 col-md-12 meet_input\"><button class=\"btn btn-default my-right-float reserve_meet_btn_ok\" ng-click=vc.saveDetail()><span class=\"glyphicon glyphicon-saved\" aria-hidden=true></span> 회의실 예약</button></div></div></div></form><div class=\"row mt-20\"><div class=\"col-lg-6 col-md-6\"><h4><strong>※ 회의실 안내</strong></h4></div><div class=\"col-lg-6 col-md-6\"><span class=pull-right><button type=button class=\"btn btn-primary\" ng-click=vc.openDaily()><span class=\"fa fa-external-link\" aria-hidden=true></span> 일별 예약현황</button></span></div></div><div class=\"col-lg-12 col-md-12\"><div id=topDiv style=\"padding:1px !important; overflow-y: scroll; height: 367px; margin-left:-10px !important; margin-right:-10px !important\"><md-content><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) select-id=vc.selectId expand-level=4 icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></div><div id=bottomDiv style=\"height: 0px; margin-left: 15px !important; margin-right: 15px !important\"><div class=\"roomImgList mt-10\"></div></div></div></div></div><!-- // 회의실 예약등록 정보 (우측) --></div></div></div></div>");
$templateCache.put("reserve/meeting-detail2.html","<form id=form1 name=form1><div class=\"container-fluid reserve_inner\" ng-controller=\"MeetingDetail2Ctrl as vc\" data-ng-init=init()><div class=container id=toastContainer><div class=row><div class=\"col-md-12 pl-0\"><!-- 회의실 예약등록 정보 (우측) --><div class=\"col-md-4 mt-30 m_pd_0 pr-0\"><div class=\"col-md-12 reserve_title reserve_title_cyan\"><h4>우리건설 회의실 예약현황</h4></div><div class=\"col-md-12 reserve_body_cyan\" style=height:450px><!-- 코멘트 부분 --><!--\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"col-md-7 pl-0\">\r\n                    <span class=\"pull-left reserve_commnet\">※ 예약시간을 먼저 선택해주세요.</span>\r\n                  </div>\r\n                  <div class=\"col-md-5 pr-0\">\r\n                    <span class=\"my-right-float reserve_commnet m_pl10\">※ (*)표시 필수입력</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n               --><!-- //코멘트 부분 --><!-- 예약내용 입력 --><div class=\"row reserve_meet_regist\"><!--\r\n                <div class=\"col-md-12 meet_minigroup\">\r\n                  <div class=\"col-md-3 meet_title\">\r\n                    <label class=\"ng-binding text-right\"><span class=\"text-red\">*</span> 소속지점</label>\r\n                  </div>\r\n                  <div class=\"col-md-9 meet_input\">\r\n                    <input type=\"text\" class=\"form-control\" required ng-model=\"vc.data.Company\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-12 meet_minigroup\">\r\n                  <div class=\"col-md-3 meet_title\">\r\n                    <label class=\"ng-binding\"><span class=\"text-red\">*</span> 예약자명</label>\r\n                  </div>\r\n                  <div class=\"col-md-9 meet_input\">\r\n                    <input type=\"text\" class=\"form-control\" value=\"{{vc.loginUserName}}\" required disabled>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-12 meet_minigroup\">\r\n                  <div class=\"col-md-3 meet_title\">\r\n                    <label class=\"ng-binding\">전화</label>\r\n                  </div>\r\n                  <div class=\"col-md-9 meet_input\">\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.TelNo\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-12 meet_minigroup\">\r\n                  <div class=\"col-md-3 meet_title\">\r\n                    <label class=\"ng-binding\"> <span class=\"text-red\">*</span> 휴대폰\r\n                    </label>\r\n                  </div>\r\n                  <div class=\"col-md-9 meet_input\">\r\n                    <input type=\"text\" class=\"form-control\" required ng-model=\"vc.data.Mobile\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-12 meet_minigroup\">\r\n                  <div class=\"col-md-3 meet_title\">\r\n                    <label class=\"ng-binding\"><span class=\"text-red\">*</span> 이용목적</label>\r\n                  </div>\r\n                  <div class=\"col-md-9 meet_input\">\r\n                    <input type=\"text\" class=\"form-control\" required ng-model=\"vc.data.Comment\">\r\n                  </div>\r\n                </div>\r\n                 --><div class=\"col-md-12 meet_minigroup\" style=height:350px><br><br><br><br><br><h1>14:00 ~ 16:00 회의중</h1><h1>영업회의</h1><h1>다음회의14:00 시작</h1></div><div class=\"col-md-12 meet_minigroup\"><div class=\"col-md-12 meet_input\"><button class=\"btn btn-default my-right-float reserve_meet_btn_ok\" ng-click=vc.getDetail(vc.strToday)><span class=\"glyphicon glyphicon-saved\" aria-hidden=true></span> 퇴실하기</button></div></div></div><!--\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12 reserve_room_info\">\r\n                  <h4 class=\"reserve_room_title\">\r\n                    <strong>※ 회의실 안내</strong>\r\n                  </h4>\r\n                </div>\r\n                <div class=\"col-md-12 reserve_room_wrap\">\r\n                  <div class=\"reserve_room_img\">\r\n                    <img src=\"/images/reserve_room_small.png\" alt=\"\" />\r\n                  </div>\r\n                  <div class=\"reserve_room_text\">\r\n                    <h5>\r\n                      <strong>소회의실</strong> <br />유선LAN, 냉/난방기\r\n                    </h5>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-12 reserve_room_wrap\">\r\n                  <div class=\"reserve_room_img\">\r\n                    <img src=\"/images/reserve_room_medium1.png\" alt=\"\" />\r\n                  </div>\r\n                  <div class=\"reserve_room_text multi\">\r\n                    <h5>\r\n                      <strong>중회의실 1</strong> <br />유/무선LAN, 냉/난방기, 스크린\r\n                    </h5>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-12 reserve_room_wrap\">\r\n                  <div class=\"reserve_room_img\">\r\n                    <img src=\"/images/reserve_room_medium2.png\" alt=\"\" />\r\n                  </div>\r\n                  <div class=\"reserve_room_text multi\">\r\n                    <h5>\r\n                      <strong>중회의실 2</strong> <br />유/무선LAN, 냉/난방기, 스크린, 빔프로젝트\r\n                    </h5>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n               --></div><!-- // 회의실 예약등록 정보 (우측) --></div><!-- 예약현황 (좌측) --><div class=\"col-md-8 mt-30 m_pd_0 m_mt_10\"><div class=\"col-md-12 reserve_title reserve_title_blue\"><h4><div id=divClock class=clock></div></h4></div><div class=\"col-md-12 reserve_body_blue\"><div class=row><!-- 년/월/일 선택 --> <!--\r\n                <div class=\"col-md-6 col-xs-12\">\r\n                  <div class=\"dataloader\" ng-show=\"vc.dataloader\"></div>\r\n                  <div class=\"form-inline pull-left \">\r\n                    <div class=\"form-group\">\r\n                      <div class=\"input-group wd100\">\r\n                        <div class=\"input-group ng-scope\" ng-controller=\"DatepickerDemoCtrl\">\r\n                          <input type=\"text\" class=\"form-control ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty ng-valid-date\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"vc.tmCalDt\"\r\n                            ng-change=\"vc.getList()\" is-open=\"opened\" datepicker-options=\"dateOptions\" current-text=\"오늘\" clear-text=\"취소\" close-text=\"닫기\" placeholder=\"에약일\" aria-invalid=\"false\">\r\n                          <div uib-datepicker-popup-wrap=\"\" ng-model=\"date\" ng-model-options=\"ngModelOptions\" ng-change=\"dateSelection(date)\" template-url=\"uib/template/datepicker/popup.html\"\r\n                            class=\"ng-empty ng-valid\" aria-invalid=\"false\">\r\n                            <!-- ngIf: isOpen --><!--\r\n                          </div>\r\n                          <span class=\"input-group-btn\">\r\n                            <button type=\"button\" class=\"btn btn-default reserve_button_calender\" ng-click=\"open($event)\">\r\n                              <i class=\"fa fa-calendar\"></i>\r\n                            </button>\r\n                          </span>\r\n                        </div>\r\n                        <!-- <button type=\"button\" ng-click=\"vc.setToday()\" class=\"btn btn-primary ml-10\">오늘</button> --><!--\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                 --><!--// 년/월/일 선택 --><!-- 회의실선택 및 달력보기 --><!--\r\n                <div class=\"col-md-6 col-xs-12\">\r\n                  <div class=\"form-inline  my-right-float\">\r\n                    <div class=\"form-group\">\r\n                      <select class=\"form-control\" ng-model=\"vc.MeetingRoom\" ng-change=\"vc.getList()\">\r\n                        <option value=\"10\" selected=\"selected\">소회의실</option>\r\n                        <option value=\"20\">중회의실1</option>\r\n                        <option value=\"30\">중회의실2</option>\r\n                      </select>\r\n                    </div>\r\n                      <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vc.goCalendar()\">\r\n                        <span class=\"fa fa-calendar-o\" aria-hidden=\"true\"></span> 월별 예약현황\r\n                      </button>\r\n                  </div>\r\n                </div>\r\n                 --><!--// 회의실선택 및 달력보기 --></div><!-- //row --><!-- 코멘트 부분 --><!--\r\n              <div class=\"row mt-10 \">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"col-md-6 pl-0 col-xs-12 mt-10\">\r\n                    <span class=\"pull-left reserve_commnet\">※ 예약시간을 먼저 선택해주세요.</span>\r\n                  </div>\r\n                  <div class=\"col-md-6 pl-0 col-xs-12 mt-10\">\r\n                    <span class=\"my-right-float reserve_commnet\">※ 예약 삭제는 해당라인의 예약취소를 클릭하세요.</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n               --><!-- //코멘트 부분 --><!-- 시간대별 예약 현황 테이블 --><div class=\"row mt-20\"><div class=\"col-md-12 reserve_table_wrap pr-10\" style=height:350px><table class=\"table reserve_table\"><colgroup><col width=25%><col width=*></colgroup><tr ng-repeat=\"li in vc.timeList\" ng-class=\"li.Company != null ? \'sz_timebox\' : \'\'\"><th><label class=checkbox-inline ng-if=\"li.Reserved == null || li.Reserved == \'N\'\"><!-- <input type=\"checkbox\" name=\"ch\" id=\"{{$index}}\" ng-model=\"li.Reserv\"\r\n                          ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" ng-change=\"vc.checkTime({{$index}})\"> -->{{li.str}}</label><label ng-if=\"li.Reserved != null && li.Reserved == \'Y\'\"><i class=\"glyphicon glyphicon-check\"></i> {{li.str}}</label></th><td class=modal-header ng-show=\"li.Company != null\"><div ng-show=\"li.Company != null\" class=reserve_meet_detail><!-- <button type=\"button\" class=\"close pt-5\" data-dismiss=\"modal\" ng-click=\"vc.DataDelete(li.ReserveId)\" ng-show=\"li.RegUser == gVariable.UserId\">× 예약취소</button> --> <strong class=reserve_meet_detail_strong>{{li.Company}} {{li.UserNm}}</strong> / <span class=mr-5>{{li.TelNo}}{{li.TelNo != null ? \' / \' : \'\'}}{{li.Mobile}}</span>/ <span class=mr-5>{{li.Comment}}</span></div></td></tr></table></div></div><!--// 시간대별 예약 현황 테이블 --><div class=\"col-md-12 meet_minigroup\"><div class=\"col-md-12 meet_input\"><button class=\"btn btn-default my-right-float reserve_meet_btn_ok\" ng-click=vc.getDetail(vc.strToday)><span class=\"glyphicon glyphicon-saved\" aria-hidden=true></span> 예약하기</button></div></div></div></div><!-- //예약현황 (좌측) --></div><script language=javascript>$(document).ready(function() {\r\n        showClock();\r\n    });\r\n\r\n    function showClock(){\r\n        var currentDate = new Date();\r\n        var divClock = document.getElementById(\"divClock\");\r\n\r\n        var msg = \"현재 시간 : \"+currentDate.getFullYear()+\"년 \"\r\n        msg += currentDate.getMonth() + 1+\"월 \";\r\n        msg += currentDate.getDate()+\"일 \";\r\n        msg += currentDate.getHours()+\"시 \";\r\n        msg += currentDate.getMinutes()+\"분 \";\r\n        msg += currentDate.getSeconds()+\"초 \";\r\n\r\n        divClock.innerText = msg;\r\n        setTimeout(showClock,1000);\r\n    }</script></div></div></div></form>");
$templateCache.put("reserve/meeting-room.html","<div class=\"registe reserve_scheduler\" ng-controller=\"MeetingRoomCtrl as vc\" data-ng-init=init()><div class=\"reserve-container text-center\" id=toastContainer><!-- table  --><div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 reserve_title reserve_title_blue\"><h4 class=monthR ng-bind=vc.monthlyReserve></h4></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 reserve_title reserve_title_gray\" ng-click=vc.getDetail(vc.CalDt)><h4>예약하기</h4></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 reserve_title reserve_title_gray\" ng-click=vc.myReserveList()><h4>내 예약</h4></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-5 reserve_body2\"><!-- 날짜선택 및 회의실선택 --><div class=container-fluid><div class=row><div class=\"col-lg-12 col-md-12 m_pl_0 m_pr_0\"><!-- 년,월,오늘버튼 --><div class=reserve_table_container><div class=fl-l><div class=fl-l><select ng-model=vc.srch.TargetYear ng-options=\"data.TargetYear as data.TargetYear for data in vc.yearsList\" class=form-control ng-change=vc.getSearch prevent-changing=false></select></div><div class=table_label><label for=\"\" class=control-label><h5>년</h5></label></div></div><div class=fl-l><div class=fl-l><select class=form-control ng-model=vc.srch.TargetMonth ng-change=vc.getSearch()><option value=01>01</option><option value=02>02</option><option value=03>03</option><option value=04>04</option><option value=05>05</option><option value=06>06</option><option value=07>07</option><option value=08>08</option><option value=09>09</option><option value=10>10</option><option value=11>11</option><option value=12>12</option></select></div><div class=table_label><label for=\"\" class=control-label><h5>월</h5></label></div></div><div class=fl-l><button type=button ng-click=vc.setToday() class=\"btn btn-primary\">오늘</button></div><div class=pull-right><!--\r\n                <div class=\"reserve_table_room_select select_button\">\r\n                  <button type=\"button\" class=\"btn btn-primary mr-10\" ng-click=\"vc.getDetail2(vc.strToday)\">\r\n                    <span class=\"fa fa-calendar\" aria-hidden=\"true\"></span> 예약현황\r\n                  </button>\r\n                </div>\r\n                 --><div class=\"fl-l mr-5\"><common-code-tree code-type=\"\'MEETINGROOM\'\" reload-seq=vc.reloadSeq code-model=vc.srch.MeetingRoom code-changed=vc.getSearch prevent-changing=true></common-code-tree></div><div class=\"fl-l form-group\"><button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button><!--<button class=\"btn btn-default\" ng-click=\"vc.resetSearch()\">\r\n                    <i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}\r\n                    입력값 초기화 후 자동 리스트 재조회\r\n                  </button> --> <button type=button class=\"btn btn-primary\" ng-click=vc.getDetail(vc.CalDt)><span class=\"fa fa-calendar\" aria-hidden=true></span> 예약하기</button></div></div></div></div></div></div><!-- // 날짜선택 및 회의실선택 --><div class=dataloader ng-show=vc.dataloader></div><div class=\"col-lg-8 m_schedule\"><table class=\"table table_blue reserve\" cellspacing=0 rules=all border=1><colgroup><col style=\"width: 10%\"><col style=\"width: 16%\"><col style=\"width: 16%\"><col style=\"width: 16%\"><col style=\"width: 16%\"><col style=\"width: 16%\"><col style=\"width: 10%\"></colgroup><thead><tr><th class=\"active text-center th-new\"><span style=\"color: #d9534f\">일</span></th><th class=\"active text-center th-new\">월</th><th class=\"active text-center th-new\">화</th><th class=\"active text-center th-new\">수</th><th class=\"active text-center th-new\">목</th><th class=\"active text-center th-new\">금</th><th class=\"active text-center th-new\">토</th></tr></thead><tbody><tr></tr><tr ng-repeat=\"li in vc.lists2\"><td ng-click=vc.getReservData(vc.data.lists[li.SunIndex].CalDt) ng-class=vc.getDateCellClass(vc.data.lists[li.SunIndex].CalDt)><span ng-class=vc.getDateClass(li.SunIndex) ng-bind=li.Sun></span> <span ng-show=\"li.SunIndex != null\" ng-bind=vc.data.lists[li.SunIndex].Description></span><div class=reserve_date_info><div class=ellipsis ng-repeat=\"timeLi in vc.data.lists[li.SunIndex].timeList\"><!--<span class=\"data_info_time\"><strong>{{timeLi.ReserveTime}}</strong> {{timeLi.CompanyNm}}&nbsp;</span>--> <span class=data_info_time title={{timeLi.Comment}}><strong>{{timeLi.ReserveTime}}</strong>&nbsp;</span></div></div></td><td ng-click=vc.getReservData(vc.data.lists[li.MonIndex].CalDt) ng-class=vc.getDateCellClass(vc.data.lists[li.MonIndex].CalDt)><span ng-class=vc.getDateClass(li.MonIndex) ng-bind=li.Mon></span> <span ng-show=\"li.MonIndex != null\" ng-bind=vc.data.lists[li.MonIndex].Description></span><div class=reserve_date_info><div class=ellipsis ng-repeat=\"timeLi in vc.data.lists[li.MonIndex].timeList\"><span class=data_info_time title={{timeLi.Comment}}><strong>{{timeLi.ReserveTime}}</strong>&nbsp;</span></div></div></td><td ng-click=vc.getReservData(vc.data.lists[li.TueIndex].CalDt) ng-class=vc.getDateCellClass(vc.data.lists[li.TueIndex].CalDt)><span ng-class=vc.getDateClass(li.TueIndex) ng-bind=li.Tue></span><span ng-show=\"li.TueIndex != null\" ng-bind=vc.data.lists[li.TueIndex].Description></span><div class=reserve_date_info><div class=ellipsis ng-repeat=\"timeLi in vc.data.lists[li.TueIndex].timeList\"><span class=data_info_time title={{timeLi.Comment}}><strong>{{timeLi.ReserveTime}}</strong>&nbsp;</span></div></div></td><td ng-click=vc.getReservData(vc.data.lists[li.WedIndex].CalDt) ng-class=vc.getDateCellClass(vc.data.lists[li.WedIndex].CalDt)><span ng-class=vc.getDateClass(li.WedIndex) ng-bind=li.Wed></span> <span ng-show=\"li.WedIndex != null\" ng-bind=vc.data.lists[li.WedIndex].Description></span><div class=reserve_date_info><div class=ellipsis ng-repeat=\"timeLi in vc.data.lists[li.WedIndex].timeList\"><span class=data_info_time title={{timeLi.Comment}}><strong>{{timeLi.ReserveTime}}</strong>&nbsp;</span></div></div></td><td ng-click=vc.getReservData(vc.data.lists[li.ThuIndex].CalDt) ng-class=vc.getDateCellClass(vc.data.lists[li.ThuIndex].CalDt)><span ng-class=vc.getDateClass(li.ThuIndex) ng-bind=li.Thu></span> <span ng-show=\"li.ThuIndex != null\" ng-bind=vc.data.lists[li.ThuIndex].Description></span><div class=reserve_date_info><div class=ellipsis ng-repeat=\"timeLi in vc.data.lists[li.ThuIndex].timeList\"><span class=data_info_time title={{timeLi.Comment}}><strong>{{timeLi.ReserveTime}}</strong>&nbsp;</span></div></div></td><td ng-click=vc.getReservData(vc.data.lists[li.FriIndex].CalDt) ng-class=vc.getDateCellClass(vc.data.lists[li.FriIndex].CalDt)><span ng-class=vc.getDateClass(li.FriIndex) ng-bind=li.Fri></span> <span ng-show=\"li.FriIndex != null\" ng-bind=vc.data.lists[li.FriIndex].Description></span><div class=reserve_date_info><div class=ellipsis ng-repeat=\"timeLi in vc.data.lists[li.FriIndex].timeList\"><span class=data_info_time title={{timeLi.Comment}}><strong>{{timeLi.ReserveTime}}</strong>&nbsp;</span></div></div></td><td ng-click=vc.getReservData(vc.data.lists[li.SatIndex].CalDt) ng-class=vc.getDateCellClass(vc.data.lists[li.SatIndex].CalDt)><span ng-class=vc.getDateClass(li.SatIndex) ng-bind=li.Sat></span> <span ng-show=\"li.SatIndex != null\" ng-bind=vc.data.lists[li.SatIndex].Description></span><div class=reserve_date_info><div class=ellipsis ng-repeat=\"timeLi in vc.data.lists[li.SatIndex].timeList\"><span class=data_info_time title={{timeLi.Comment}}><strong>{{timeLi.ReserveTime}}</strong>&nbsp;</span></div></div></td></tr></tbody></table></div><div class=\"col-lg-4 mt-10\"><table id=topDiv class=\"table reserve_table\" width=100%><colgroup><col width=80px><col width=*><col width=80px></colgroup><tr ng-repeat=\"li in vc.calDtList\" ng-class=li.RowCSS><th width=80px><span>{{li.str}}</span></th><td width=* ng-show=\"li.Company != null\"><div class=reserve_meet_detail><strong class=reserve_meet_detail_strong><span ng-if=li.DeptNm>[{{li.DeptNm}}] </span>{{li.UserNm}}</strong><span class=mr-5 ng-if=\"li.Mobile && li.Mobile != \'null\'\"> / {{li.Mobile}}</span><span class=mr-5 ng-if=\"li.TelNo && li.TelNo != \'null\'\"> / {{li.TelNo}}</span> <span class=mr-5>{{li.Comment}}</span></div></td><td width=80px><div class=\"close pt-5 mt-5 status\" ng-show=\"li.Status == 1\"><span class=status1><i class=\"fa fa-check-circle-o\"></i> 사용</span></div><div class=\"close pt-5 mt-5 status\" ng-show=\"li.Status == 2\"><span class=status2><i class=\"fa fa-close\"></i> 미사용</span></div><div class=\"close pt-5 mt-5 status\" ng-show=\"li.Status == 3\"><span class=status3><i class=\"fa fa-clock-o\"></i> 대기</span></div><button type=button class=\"close pt-5 mt-5 status\" ng-click=vc.checkUsed(li.ReserveId) ng-show=\"li.Status == 4\"><span class=status4><i class=\"fa fa-check\"></i> 사용하기</span></button></td></tr></table><div id=bottomDiv style=\"height: 0px; margin-left: 15px !important; margin-right: 15px !important\"><div class=\"roomImgList mt-10\"></div></div></div></div></div><!-- // table  --></div>");
$templateCache.put("reserve/meeting-roomimage-modal.html","<div class=modal-content style=\"min-height: 500px\"><div class=\"modal-header ng-scope\"><div class=page-header>회의실 사진</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12></div><div class=roomImg><img ng-src={{vc.data}} style=\"width: 100%; height: 400px\">;</div></div><!-- /row --></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.OK\' | translate }}</button></div></div>");
$templateCache.put("reserve/my-reserve-list.html","<div class=\"registe reserve_scheduler\" ng-controller=\"MyReserveListCtrl as vc\"><div class=\"reserve-container text-center\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 reserve_title reserve_title_gray noImage_gray\" ng-click=vc.goCalendar()><h4 class=monthR ng-bind=vc.monthlyReserve></h4></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 reserve_title reserve_title_gray noImage_gray\" ng-click=vc.getDetail()><h4>예약하기</h4></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 reserve_title reserve_title_blue noImage_blue\"><h4>내 예약</h4></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-5 reserve_body2\"><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-8 col-sm-8 col-md-8 col-xg-8 col-xl-8 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Comment placeholder=\"이용목적 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer(\'500\')\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading style=\"text-align: left\">상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-tree code-type=\"\'MEETINGROOM\'\" reload-seq=vc.reloadSeq code-model=vc.srch.MeetingRoom></common-code-tree></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'LoginId\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.LoginId></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UserType\'].CodeList\" code-model=vc.srch.UserType></common-code-custom><label>{{vc.columnMap[\'UserType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'DeptNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.DeptNm readonly><label>{{vc.columnMap[\'DeptNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" type=button ng-click=vc.srchDeptModal(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseDept(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ApprYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ApprYN\'].CodeList\" code-model=vc.srch.ApprYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserNm\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.UserNm><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.Mobile><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TelNo\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.TelNo><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.Email><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button=\"\" class=\"btn btn-info pull-left mr-5\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default pull-left\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-4 col-sm-4 col-md-4 col-xg-4 col-xl-4\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getDetail()><i class=\"fa fa-institution\"></i> 회의실예약</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- form --><div class=row><div class=col-lg-12><div class=myreserve-status><div id=menu1 class=\"col-sm-6 col-lg-3 info\" ng-click=\"vc.getList(\'all\', \'init\')\"><img src=assets/images/myreserve-icon-total.png alt=\"\"> <span>전체 <span class=txt-blue>{{vc.reserveAllCnt}}</span>건</span></div><div id=menu2 class=\"col-sm-6 col-lg-3 info\" ng-click=\"vc.getList(\'ing\', \'init\')\"><img src=assets/images/myreserve-icon-standby.png alt=\"\"> <span>이용예정 <span class=txt-blue>{{vc.reserveIngCnt}}</span>건</span></div><div id=menu3 class=\"col-sm-6 col-lg-3 info\" ng-click=\"vc.getList(\'end\', \'init\')\"><img src=assets/images/myreserve-icon-done.png alt=\"\"> <span>이용만료 <span class=txt-blue>{{vc.reserveEndCnt}}</span>건</span></div><div id=menu4 class=\"col-sm-6 col-lg-3 info\" ng-click=\"vc.getList(\'cancel\', \'init\')\"><img src=assets/images/myreserve-icon-cancel.png alt=\"\"> <span>취소 <span class=txt-blue>{{vc.reserveCancelCnt}}</span>건</span></div></div><div class=dataloader ng-show=vc.dataloader></div><!-- /tile header --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-repeat=\"liCol in vc.listColumns\" ng-click=\"vc.tablesort(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" style=\"width: {{liCol.ListColumnWidth}}\" class=\"text-center none\">{{ :: liCol.ColumnLogicalNm | translate }} <span ng-show=\"liCol.KeyColumnYN == \'Y\'\" class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" my-directive><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-click=vc.viewDetail(li) style=\"cursor: pointer\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd h:mm a\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list fl-l\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div>");
$templateCache.put("reserve/reserve.html","<section id=top2><div id=Top2Ctrl class=menu style=\"padding-right: 25px\"><div class=row><ul class=\"nav navbar-top-links2 navbar-right\"><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown><i class=\"fa fa-user fa-fw\"></i> {{$root.gVariable.UserName}} <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-user\"><li><a href=\"\" ng-click=hc.myPage()><i class=\"fa fa-user fa-fw\"></i> 내 정보</a></li><li class=divider></li><li><a href=\"\" ng-click=hc.bbspost()><i class=\"fa fa-calendar fa-fw\"></i> 개선의견 게시판</a></li><li class=divider></li><li permission=\"\'app.reserve.reserve-daily:button01\'\"><a href=\"\" ng-click=hc.goManager()><i class=\"fa fa-cog fa-fw\"></i> 관리자페이지</a></li><li class=divider permission=\"\'app.reserve.reserve-daily:button01\'\"></li><li><a href=\"\" ng-click=hc.doLogout2()><i class=\"fa fa-sign-out fa-fw\"></i> Logout</a></li></ul><!-- /.dropdown-user --></li><!-- /.dropdown --></ul></div></div><script>//Create a clone of the menu, right next to original.\r\n    $(\'.menu\').addClass(\'original\').clone().insertAfter(\'.menu\').addClass(\r\n      \'cloned\').css(\'position\', \'fixed\').css(\'top\', \'0\').css(\'margin-top\',\r\n      \'0\').css(\'z-index\', \'500\').removeClass(\'original\').hide();\r\n\r\n    scrollIntervalID = setInterval(stickIt, 10);\r\n\r\n    function stickIt() {\r\n\r\n      /* var orgElementPos = $(\'.original\').offset();\r\n      orgElementTop = orgElementPos.top;\r\n\r\n      if ($(window).scrollTop() >= (orgElementTop)) {\r\n        // scrolled past the original position; now only show the cloned, sticky element.\r\n\r\n        // Cloned element should always have same left position and width as original element.\r\n        orgElement = $(\'.original\');\r\n        coordsOrgElement = orgElement.offset();\r\n        leftOrgElement = coordsOrgElement.left;\r\n        widthOrgElement = orgElement.css(\'width\');\r\n        $(\'.cloned\').css(\'left\', leftOrgElement + \'px\').css(\'top\', 0).css(\r\n            \'width\', widthOrgElement).show();\r\n        $(\'.original\').css(\'visibility\', \'hidden\');\r\n      } else {\r\n        // not scrolled past the menu; only show the original menu.\r\n        $(\'.cloned\').hide();\r\n        $(\'.original\').css(\'visibility\', \'visible\');\r\n      } */\r\n    }\r\n\r\n    var isMobile = checkMobile();\r\n    if (isMobile) {\r\n      $(\"#top2\").css(\'display\', \'none\');\r\n    }</script></section><div class=view-container ui-view-container><section ui-view id=content autoscroll=false style=\"position: static\"></section></div><!--<section ng-include=\"\'views/bottom.html\'\" id=\"bottom\"></section> -->");
$templateCache.put("components/login/login.html","<div id=login-container><div class=login-boxwrap><div class=box-half><div class=wellcome-text-box><p class=wellcome-text>Welcome<br>to iM Solution</p><p class=salevis-ai-logo><img src=/assets/images/login/logo-yesiam.png alt=\"\"></p></div></div><div class=box-half><div class=deco-circle><img src=/assets/images/login-deco-arrow.png alt=\"\"></div><div class=login-input-box><form class=login_box id=login_box ng-submit=login.doLogin()><div class=\"title mb-30\">Log in</div><div class=idpw-box-input><div class=id><input name=txtLoginID title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" type=text maxlength=20 id=txtLoginID class=form-control placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" style=\"ime-mode: inactive; margin-bottom: 10px\" ng-model=login.loginInfo.loginId ng-required=true></div><div class=pw><input name=txtPassword title=\"{{\'LOGIN.TITLE.I.n-login-bodyNST_PW\'|translate}}\" type=password maxlength=20 id=txtPassword class=form-control placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" ng-model=login.loginInfo.loginPw ng-required=true></div></div><div class=idpw-text-box><div class=checkbox><input id=ckID type=checkbox name=ckID ng-checked=\"login.loginInfo.saveId === \'1\'\" ng-model=login.loginInfo.saveId ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" tabindex=3><label for=ckID>아이디 저장</label></div></div><div class=n-login-btn><button class=\"bts btn btn-lg btn-primary btn-block\" type=submit>Login</button></div><div class=mt-20><ul class=n-login-ui-find><li><a ui-sref=signup>{{ \'Menu.SIGNUP\' | translate }}</a></li><li><span ng-click=\"login.findIdPwd(\'id\')\">아이디 찾기</span></li><li><span ng-click=\"login.findIdPwd(\'pwd\')\">비밀번호 찾기</span></li></ul></div></form></div></div></div></div><!-- <div class=\"n-login-wrap\">\r\n  <div class=\"n-login-box\">\r\n    <a class=\"btn-example btn btn-outline btn-danger\" href=\"#Notice\" id=\"notice\" style=\"display: none;\"></a>\r\n    <div class=\"box-top-deco\">\r\n      <p class=\"deco-text\">JEANFICIALJEANFICIALJEANFICIALJEANFICIAL</p>\r\n    </div>\r\n    <div class=\"n-login-body\">\r\n      <form class=\"login_box\" id=\"login_box\" ng-submit=\"login.doLogin()\">\r\n        <div class=\"title mb-30\"><img src=\"/assets/images/login/login-civasan-logo.png\" alt=\"\"></div>\r\n        <div class=\"idpw-box-input\">\r\n          <div class=\"id\">\r\n            <input name=\"txtLoginID\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" type=\"text\" maxlength=\"20\"\r\n              id=\"txtLoginID\" class=\"form-control\" placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\"\r\n              style=\"ime-mode: inactive; margin-bottom: 10px;\" ng-model=\"login.loginInfo.loginId\" ng-required=\"true\" />\r\n          </div>\r\n          <div class=\"pw\">\r\n            <input name=\"txtPassword\" title=\"{{\'LOGIN.TITLE.I.n-login-bodyNST_PW\'|translate}}\" type=\"password\" maxlength=\"20\"\r\n              id=\"txtPassword\" class=\"form-control\" placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\"\r\n              ng-model=\"login.loginInfo.loginPw\" ng-required=\"true\" />\r\n          </div>\r\n        </div>\r\n        <div class=\"idpw-text-box\">\r\n          <div class=\"checkbox\">\r\n            <input id=\"ckID\" type=\"checkbox\" name=\"ckID\" ng-checked=\"login.loginInfo.saveId === \'1\'\" ng-model=\"login.loginInfo.saveId\" ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\"  tabindex=\"3\" />\r\n            <label for=\"ckID\">아이디 저장 </label>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"n-login-btn\">\r\n          <button class=\"bts btn btn-lg btn-primary btn-block\"\r\n            type=\"submit\">Login</button>\r\n        </div>\r\n        <div class=\"mt-20\">\r\n          <ul class=\"n-login-ui-find\">\r\n                     <li><a ui-sref=\"signup\">{{ \'Menu.SIGNUP\' | translate }}</a></li>\r\n            <li><span ng-click=\"login.findIdPwd(\'id\')\">아이디 찾기</span></li>\r\n            <li><span ng-click=\"login.findIdPwd(\'pwd\')\">비밀번호 찾기</span></li>\r\n          </ul>\r\n        </div>\r\n      </form>\r\n    </div>\r\n    <!-- //n-login-body --><!-- //n-login-box --><!-- //n-login-wrap --> <!-- <div class=\"login_area\">\r\n  <div class=\"logins\">\r\n    <div class=\"logins_box\">\r\n      <div class=\"loginbox\">\r\n        <div class=\"login_txt\">\r\n          <strong class=\"tit\">\r\n            <img src=\"assets/images/login/login_tit.png\" alt=\"Log In\">\r\n          </strong>\r\n          <p class=\"txt\">\r\n            <span ng-bind=\"login.appName\"></span>\r\n            <span>Happy communication</span>\r\n            <br>bridge\r\n            <br>Solution\r\n          </p>\r\n          <div class=\"sel\">\r\n            <div class=\"selectbox\" style=\"width:140px;\">\r\n              <select ng-change=\"login.onChangeHandler()\" name=\"selectCombo\" ng-model=\"login.language\">\r\n                <option value=\"ko\" selected=\"\">\r\n                  한국어\r\n                </option>\r\n                <option value=\"en\">\r\n                  English\r\n                </option>\r\n                <option value=\"ja\">\r\n                  日本語\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（简体中文）\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（繁體）\r\n                </option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <form class=\"login_box\" id=\"login_box\" ng-submit=\"login.doLogin()\">\r\n          <strong class=\"logos\">\r\n            <img src=\"assets/images/login/login_logo.png\" alt=\"SOFTZION CRM\">\r\n          </strong>\r\n          <div class=\"logs_cont\">\r\n            <p class=\"logos_des\" translate=\"LOGIN.MSG.REQ_SIGNIN\"></p>\r\n            <div class=\"logs_area\">\r\n              <div class=\"radio-group\">\r\n                <input type=\"radio\" id=\"one\" name=\"selector\" checked=\"checked\">\r\n                <label for=\"one\" translate=\"LOGIN.LABEL.NAME\"></label>\r\n                <input type=\"radio\" id=\"two\" name=\"selector\">\r\n                <label for=\"two\" translate=\"LOGIN.LABEL.SNUMB\"></label>\r\n              </div>\r\n              <ul class=\"logs_txt\">\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.ID\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"ID\" ng-model=\"login.loginInfo.loginId\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_pw\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PW\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD\"\r\n                    ng-model=\"login.loginInfo.loginPw\" ng-required=\"true\">\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <div class=\"btns btn-group\">\r\n            <button class=\"bts\" type=\"submit\">{{ \'LOGIN.BTN.LOGIN\' | translate }}</button>\r\n            <div><span><a ui-sref=\"signup\">{{ \'Menu.SIGNUP\' | translate }}</a></span> | <span ng-click=\"login.findIdPwd(\'id\')\">아이디 찾기</span> | <span ng-click=\"login.findIdPwd(\'pwd\')\">비밀번호 찾기</span> </div>\r\n            <div class=\"checks\">\r\n              <input type=\"checkbox\" id=\"c1\" checked=\"checked\">\r\n              <label for=\"c1\"><span></span>Remember me.</label>\r\n            </div>\r\n            <div class=\"pwd-id\">\r\n\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <span class=\"login_footer\" translate=\"LOGIN.MSG.COPYRIGHT\"></span>\r\n</div>\r\n -->");
$templateCache.put("components/login/salemeet-signup-step-one.html","<style>.teacher_schedule li {\r\n    width: 50%;\r\n    float: left;\r\n    padding: 0 0 10px;\r\n  }</style><form id=form1 name=form1><div id=container_user style=\"padding: 30px 0 0; margin-bottom: 70px\"><div class=\"container_inner register\" style=\"padding: 50px 0 70px;  border:0 !important\"><!-- 서브타이틀 --><p class=user_subtitle>회원가입</p><!-- //서브타이틀 --><div class=content><div class=membership_cont><div class=\"sec2 last\"><div><ul class=tab><li class=current><a>회원사 선택</a></li><li><a>기본정보 입력</a></li><li><a>회원가입 완료</a></li></ul></div><table class=\"table mg_auto table_1\"><!--tr>\r\n                  <th scope=\"row\" class=\"required\" style=\"height: 100px;\">회원사명 <br /></th>\r\n                  <td style=\"text-align: left; height: 100px;\">\r\n                    <div class=\"form-group\">\r\n                      <div class=\"input-group custom-search-form\">\r\n                        <input type=\"text\" readonly=\"readonly\" class=\"form-control\" ng-model=\"vc.tenantId\" ng-click=\"vc.srchTenantModal();\">\r\n                        <input type=\"hidden\" ng-model=\"vc.tenantId\">\r\n                        <span class=\"input-group-btn\">\r\n                          <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.srchTenantModal();\">\r\n                            <i class=\"fa fa-search\"></i>\r\n                          </button>\r\n                          <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.eraseTenant();\">\r\n                            <i class=\"fa fa-eraser\"></i>\r\n                          </button>\r\n                        </span>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                </tr--><tr><th scope=row class=required style=\"height: 100px\">회원사코드<br></th><td style=\"text-align: left; height: 100px\"><div class=form-group><input type=text class=form-control ng-model=vc.tenantId></div></td></tr></table><div class=btn_area style=\"margin-top: 30px\"><button class=\"signupBtn commonBtn5 type2 etc2\" type=submit ng-click=vc.salemeetSignupStepTwo()>다음단계</button> <button type=button class=\"signupBtn commonBtn5 type3\" ng-click=vc.salemeetGoCancel()>취소</button></div></div></div></div></div></div></form><!-- <div class=\"login_area\">\r\n  <div class=\"logins\">\r\n    <div class=\"logins_box\">\r\n      <div class=\"loginbox\">\r\n        <div class=\"login_txt\">\r\n          <strong class=\"tit\">\r\n            Signup\r\n          </strong>\r\n          <p class=\"txt\">\r\n            <span ng-bind=\"signup.appName\"></span>\r\n            <span>Happy communication</span>\r\n            <br>bridge\r\n            <br>Solution\r\n          </p>\r\n          <div class=\"sel\">\r\n            <div class=\"selectbox\" style=\"width:140px;\">\r\n              <select ng-change=\"signup.onChangeHandler()\" name=\"selectCombo\" ng-model=\"signup.language\">\r\n                <option value=\"ko\" selected=\"\">\r\n                  한국어\r\n                </option>\r\n                <option value=\"en\">\r\n                  English\r\n                </option>\r\n                <option value=\"ja\">\r\n                  日本語\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（简体中文）\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（繁體）\r\n                </option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <form class=\"login_box\" id=\"login_box\" ng-submit=\"signup.doSignup()\">\r\n          <strong class=\"logos\">\r\n            <img src=\"assets/images/login/login_logo.png\" alt=\"SOFTZION CRM\">\r\n          </strong>\r\n          <div class=\"logs_cont\">\r\n            <p class=\"logos_des\" translate=\"LOGIN.MSG.REQ_SIGNUP\"></p>\r\n            <div class=\"signup_area\">\r\n              <ul class=\"logs_txt\">\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.ID\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"ID\" ng-model=\"signup.loginInfo.LoginId\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.NAME\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.NAME\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"Name\" ng-model=\"signup.loginInfo.UserNm\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PW\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD\" ng-model=\"signup.loginInfo.Password\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PWCONFIRM\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PWCONFIRM\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD2\" ng-model=\"signup.loginInfo.Password2\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'Menu.COMPANYCODE\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'Menu.COMPANYCODE\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"TenantId\" ng-model=\"signup.loginInfo.TenantId\" ng-required=\"true\">\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"rows btns btn-group\">\r\n            <button class=\"bts\" type=\"submit\">{{ \'Menu.SIGNUP\' | translate }}</button>\r\n            <div class=\"pull-right\"><a ui-sref=\"login\">{{ \'LOGIN.BTN.LOGIN\' | translate }}</a></div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <span class=\"login_footer\" translate=\"LOGIN.MSG.COPYRIGHT\"></span>\r\n</div>\r\n -->");
$templateCache.put("components/login/salemeet-signup-step-two.html","<form id=form1 name=form1><div id=container_user style=\"padding: 30px 0 0; margin-bottom: 70px\" ng-if=vc.joinVisible><div class=\"container_inner register\" style=\"padding: 50px 0 70px;  border:0 !important\"><!-- 서브타이틀 --><p class=user_subtitle>회원가입</p><!-- //서브타이틀 --><div class=content><div class=membership_cont><div class=\"sec2 last\"><div><ul class=tab><li id=tab1><a>회원사 선택</a></li><li id=tab2 class=current><a>기본정보 입력</a></li><li id=tab3><a>회원가입 완료</a></li></ul></div><div id=tab_contents ng-show=!vc.result><table class=\"table mg_auto table_1\"><tr><th scope=row class=required>회원사명 <span style=color:#f69679>*</span></th><td style=\"text-align: left\"><span ng-bind=vc.tenantNm></span></td></tr><tr><th scope=row class=required>아이디 <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=text id=userId name=id class=\"w245 signupText\" title=아이디 placeholder=\"아이디를 입력해 주세요\" ng-model=vc.UserId required maxlength=25> <button type=button ng-click=vc.chkDupLoginId() class=\"signupBtn commonBtn2 type3\" ng-disabled=\"vc.UserId == null || vc.UserId.length < 5\">중복확인</button><p class=txt2>아이디는 5~25자의 영문 소문자, 숫자, 특수문자(_), (-)만 사용해야 합니다.</p></td></tr><tr><th scope=row class=required>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}} <span style=color:#f69679>*</span></th><td style=\"text-align: left\"><input type=text class=signupText id=name name=memberName title=성명 maxlength=50 placeholder=\"이름을 입력해 주세요.\" ng-model=vc.data.UserNm required style=width:200px></td></tr><tr><th scope=row class=required>비밀번호<span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=password class=signupPwd id=password name=password title=비밀번호 placeholder=\"비밀번호를 입력해 주세요.\" ng-model=vc.data.Password required maxlength=16></td></tr><tr><th scope=row class=required>비밀번호 확인 <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=password class=signupPwd id=userPwdCheck name=userPwdCheck title=\"비밀번호 확인\" placeholder=\"비밀번호를 다시 입력해 주세요.\" ng-model=vc.data.Password2 required maxlength=16><ul><li>* 비밀번호는 8~16자의 영문 대, 소문자, 숫자, 특수문자 중 3개를 조합하여 사용합니다.</li><li>* 사용 가능 특수문자: ` . ~ ! @ # $ % ^ * ( ) - _ = +</li></ul></td></tr><tr><th scope=row class=required>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}} <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=text id=email1 class=\"signupText w200\" title=이메일 maxlength=20 placeholder=\"이메일을 입력해 주세요.\" ng-model=vc.data.Email1 required> <span class=blank>@</span> <input type=text id=email2 class=\"signupText w160\" title=이메일 maxlength=25 ng-model=vc.data.Email2 required><select id=userEmail2Select class=\"w108 signupText\" title=이메일 ng-change=vc.setEmail() ng-model=vc.data.Email3><option value=\"\">직접입력</option><option value=naver.com>naver.com</option><option value=gmail.com>gmail.com</option><option value=hanmail.net>hanmail.net</option><option value=daum.net>daum.net</option><option value=nate.com>nate.com</option><option value=hotmail.com>hotmail.com</option></select></td></tr><tr><th scope=row class=required>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}} <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><select id=userTelM1 name=userTelM1 title=휴대번호 class=\"signupText num_check first_select w108\" ng-model=vc.data.Mobile1><option value=010>010</option><option value=011>011</option><option value=016>016</option><option value=017>017</option><option value=018>018</option><option value=019>019</option></select><span class=blank>-</span> <input type=text id=userTelM2 class=\"num_check w108 signupText\" title=휴대번호 ng-model=vc.data.Mobile2 maxlength=4> <span class=blank>-</span> <input type=text id=userTelM3 class=\"num_check w108 signupText\" title=휴대번호 ng-model=vc.data.Mobile3 maxlength=4></td></tr></table><ul class=agree_area><li><p><!-- 회사의 <a href=\"/#/reserve/policy\" style=\"color: blue;\" target=\"_blank\">이용약관</a>과 <a href=\"/#/reserve/private\" style=\"color: blue;\" target=\"_blank\">개인정보보호정책</a>에 동의합니다. --> 회사의 <a style=\"cursor: pointer; color: blue\">이용약관</a>과 <a style=\"cursor: pointer; color: blue\">개인정보보호정책</a>에 동의합니다.</p><div><input type=radio id=termsY name=termsYn class=radioBtn value=Y title=약관동의><label for=termsY class=radioYbtn>동의함</label><input type=radio id=termsN name=termsYn class=radioBtn value=N title=약관동의 checked><label for=termsN class=radioNbtn>동의안함</label></div></li></ul><div class=btn_area style=\"margin-top: 30px\"><button class=\"signupBtn commonBtn5 type2 etc2\" ng-click=vc.setData()>회원가입</button> <button type=button class=\"signupBtn commonBtn5 type3\" ng-click=vc.salemeetGoCancel()>취소</button></div></div><div id=tab_success ng-show=vc.result><h1>회원가입을 축하드립니다.</h1><button type=button class=\"signupBtn commonBtn5 type3\" style=\"margin-top: 30px\" ng-click=vc.salemeetGoCancel()>로그인</button></div></div></div></div></div></div></form>");
$templateCache.put("components/login/salemeet.html","<div class=n-login-wrap><div class=n-login-box><a class=\"btn-example btn btn-outline btn-danger\" href=#Notice id=notice style=\"display: none\"></a><div class=box-top-deco><p class=deco-text>SALEMEETSALEMEETSALEMEETSALEMEETSALEMEET</p></div><div class=n-login-body><form class=login_box id=login_box ng-submit=login.doLogin()><div class=\"title mb-30\"><img src=/assets/images/login/salemeetLogo.png alt=\"\"></div><div class=idpw-box-input><div class=id><input name=txtLoginID title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" type=text maxlength=20 id=txtLoginID class=form-control placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" style=\"ime-mode: inactive; margin-bottom: 10px\" ng-model=login.loginInfo.loginId ng-required=true></div><div class=pw><input name=txtPassword title=\"{{\'LOGIN.TITLE.I.n-login-bodyNST_PW\'|translate}}\" type=password maxlength=20 id=txtPassword class=form-control placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" ng-model=login.loginInfo.loginPw ng-required=true></div></div><div class=idpw-text-box><div class=checkbox><input id=ckID type=checkbox name=ckID ng-checked=\"login.loginInfo.saveId === \'1\'\" ng-model=login.loginInfo.saveId ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" tabindex=3><label for=ckID>아이디 저장</label></div></div><div class=n-login-btn><button class=\"bts btn btn-lg btn-primary btn-block\" type=submit>Login</button></div><div class=mt-20><ul class=n-login-ui-find><li><a ui-sref=salemeetsignup>{{ \'Menu.SIGNUP\' | translate }}</a></li><li><span ng-click=\"login.findIdPwd(\'id\')\">아이디 찾기</span></li><li><span ng-click=\"login.findIdPwd(\'pwd\')\">비밀번호 찾기</span></li></ul></div></form></div></div></div><script>window.document.title = \'SALEMEET\';</script><!-- <div class=\"login_area\">\r\n  <div class=\"logins\">\r\n    <div class=\"logins_box\">\r\n      <div class=\"loginbox\">\r\n        <div class=\"login_txt\">\r\n          <strong class=\"tit\">\r\n            <img src=\"assets/images/login/login_tit.png\" alt=\"Log In\">\r\n          </strong>\r\n          <p class=\"txt\">\r\n            <span ng-bind=\"login.appName\"></span>\r\n            <span>Happy communication</span>\r\n            <br>bridge\r\n            <br>Solution\r\n          </p>\r\n          <div class=\"sel\">\r\n            <div class=\"selectbox\" style=\"width:140px;\">\r\n              <select ng-change=\"login.onChangeHandler()\" name=\"selectCombo\" ng-model=\"login.language\">\r\n                <option value=\"ko\" selected=\"\">\r\n                  한국어\r\n                </option>\r\n                <option value=\"en\">\r\n                  English\r\n                </option>\r\n                <option value=\"ja\">\r\n                  日本語\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（简体中文）\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（繁體）\r\n                </option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <form class=\"login_box\" id=\"login_box\" ng-submit=\"login.doLogin()\">\r\n          <strong class=\"logos\">\r\n            <img src=\"assets/images/login/login_logo.png\" alt=\"SOFTZION CRM\">\r\n          </strong>\r\n          <div class=\"logs_cont\">\r\n            <p class=\"logos_des\" translate=\"LOGIN.MSG.REQ_SIGNIN\"></p>\r\n            <div class=\"logs_area\">\r\n              <div class=\"radio-group\">\r\n                <input type=\"radio\" id=\"one\" name=\"selector\" checked=\"checked\">\r\n                <label for=\"one\" translate=\"LOGIN.LABEL.NAME\"></label>\r\n                <input type=\"radio\" id=\"two\" name=\"selector\">\r\n                <label for=\"two\" translate=\"LOGIN.LABEL.SNUMB\"></label>\r\n              </div>\r\n              <ul class=\"logs_txt\">\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.ID\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"ID\" ng-model=\"login.loginInfo.loginId\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_pw\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PW\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD\"\r\n                    ng-model=\"login.loginInfo.loginPw\" ng-required=\"true\">\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <div class=\"btns btn-group\">\r\n            <button class=\"bts\" type=\"submit\">{{ \'LOGIN.BTN.LOGIN\' | translate }}</button>\r\n            <div><span><a ui-sref=\"signup\">{{ \'Menu.SIGNUP\' | translate }}</a></span> | <span ng-click=\"login.findIdPwd(\'id\')\">아이디 찾기</span> | <span ng-click=\"login.findIdPwd(\'pwd\')\">비밀번호 찾기</span> </div>\r\n            <div class=\"checks\">\r\n              <input type=\"checkbox\" id=\"c1\" checked=\"checked\">\r\n              <label for=\"c1\"><span></span>Remember me.</label>\r\n            </div>\r\n            <div class=\"pwd-id\">\r\n\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <span class=\"login_footer\" translate=\"LOGIN.MSG.COPYRIGHT\"></span>\r\n</div>\r\n -->");
$templateCache.put("components/login/signup-step-one.html","<style>.teacher_schedule li {\r\n    width: 50%;\r\n    float: left;\r\n    padding: 0 0 10px;\r\n  }</style><form id=form1 name=form1><div id=container_user style=\"padding: 30px 0 0; margin-bottom: 70px\"><div class=\"container_inner register\" style=\"padding: 50px 0 70px;  border:0 !important\"><!-- 서브타이틀 --><p class=user_subtitle>salevis 회원가입</p><!-- //서브타이틀 --><div class=content><div class=membership_cont><div class=\"sec2 last\"><div><ul class=tab><li class=current><a>회원사 선택</a></li><li><a>기본정보 입력</a></li><li><a>회원가입 완료</a></li></ul></div><table class=\"table mg_auto table_1\"><tr><th scope=row class=required style=\"height: 100px\">회원사명<br></th><td style=\"text-align: left; height: 100px\"><div class=form-group><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control ng-model=vc.tenantNm ng-click=vc.srchTenantModal();> <input type=hidden ng-model=vc.tenantId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchTenantModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseTenant();><i class=\"fa fa-eraser\"></i></button></span></div></div></td></tr></table><div class=btn_area style=\"margin-top: 30px\"><button class=\"signupBtn commonBtn5 type2 etc2\" type=submit ng-click=vc.signupStepTwo()>다음단계</button> <button type=button class=\"signupBtn commonBtn5 type3\" ng-click=vc.goCancel()>취소</button></div></div></div></div></div></div></form><!-- <div class=\"login_area\">\r\n  <div class=\"logins\">\r\n    <div class=\"logins_box\">\r\n      <div class=\"loginbox\">\r\n        <div class=\"login_txt\">\r\n          <strong class=\"tit\">\r\n            Signup\r\n          </strong>\r\n          <p class=\"txt\">\r\n            <span ng-bind=\"signup.appName\"></span>\r\n            <span>Happy communication</span>\r\n            <br>bridge\r\n            <br>Solution\r\n          </p>\r\n          <div class=\"sel\">\r\n            <div class=\"selectbox\" style=\"width:140px;\">\r\n              <select ng-change=\"signup.onChangeHandler()\" name=\"selectCombo\" ng-model=\"signup.language\">\r\n                <option value=\"ko\" selected=\"\">\r\n                  한국어\r\n                </option>\r\n                <option value=\"en\">\r\n                  English\r\n                </option>\r\n                <option value=\"ja\">\r\n                  日本語\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（简体中文）\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（繁體）\r\n                </option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <form class=\"login_box\" id=\"login_box\" ng-submit=\"signup.doSignup()\">\r\n          <strong class=\"logos\">\r\n            <img src=\"assets/images/login/login_logo.png\" alt=\"SOFTZION CRM\">\r\n          </strong>\r\n          <div class=\"logs_cont\">\r\n            <p class=\"logos_des\" translate=\"LOGIN.MSG.REQ_SIGNUP\"></p>\r\n            <div class=\"signup_area\">\r\n              <ul class=\"logs_txt\">\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.ID\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"ID\" ng-model=\"signup.loginInfo.LoginId\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.NAME\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.NAME\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"Name\" ng-model=\"signup.loginInfo.UserNm\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PW\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD\" ng-model=\"signup.loginInfo.Password\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PWCONFIRM\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PWCONFIRM\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD2\" ng-model=\"signup.loginInfo.Password2\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'Menu.COMPANYCODE\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'Menu.COMPANYCODE\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"TenantId\" ng-model=\"signup.loginInfo.TenantId\" ng-required=\"true\">\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"rows btns btn-group\">\r\n            <button class=\"bts\" type=\"submit\">{{ \'Menu.SIGNUP\' | translate }}</button>\r\n            <div class=\"pull-right\"><a ui-sref=\"login\">{{ \'LOGIN.BTN.LOGIN\' | translate }}</a></div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <span class=\"login_footer\" translate=\"LOGIN.MSG.COPYRIGHT\"></span>\r\n</div>\r\n -->");
$templateCache.put("components/login/signup-step-two.html","<style>.teacher_schedule li {\r\n    width: 50%;\r\n    float: left;\r\n    padding: 0 0 10px;\r\n  }</style><form id=form1 name=form1><div id=container_user style=\"padding: 30px 0 0; margin-bottom: 70px\"><div class=\"container_inner register\" style=\"padding: 50px 0 70px;  border:0 !important\"><!-- 서브타이틀 --><p class=user_subtitle>salevis 회원가입</p><!-- //서브타이틀 --><div class=content><div class=membership_cont><div class=\"sec2 last\"><div><ul class=tab><li id=tab1><a>회원사 선택</a></li><li id=tab2 class=current><a>기본정보 입력</a></li><li id=tab3><a>회원가입 완료</a></li></ul></div><div id=tab_contents ng-show=!vc.result><table class=\"table mg_auto table_1\"><tr><th scope=row class=required>아이디 <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=text id=userId name=id class=\"w245 signupText\" title=아이디 placeholder=\"아이디를 입력해 주세요\" ng-model=vc.UserId required maxlength=25> <button type=button ng-click=vc.chkDupLoginId() class=\"signupBtn commonBtn2 type3\" ng-disabled=\"vc.UserId == null || vc.UserId.length < 5\">중복확인</button><p class=txt2>아이디는 5~25자의 영문 소문자, 숫자, 특수문자(_), (-)만 사용해야 합니다.</p></td></tr><tr><th scope=row class=required>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}} <span style=color:#f69679>*</span></th><td style=\"text-align: left\"><input type=text class=signupText id=name name=memberName title=성명 maxlength=50 placeholder=\"이름을 입력해 주세요.\" ng-model=vc.data.UserNm required style=width:200px></td></tr><!--                   <tr class=\"tr-select\">\r\n                    <th scope=\"row\" class=\"required\">성별</th>\r\n                      <td style=\"text-align: left;\">\r\n                        <common-code-custom code-list=\"li.CodeList\" code-model=\"vc.data[\'Gender\']\" callback=\"vc.onModelChanged\"></common-code-custom>\r\n                    </td>\r\n                  </tr> --><tr><th scope=row class=required>비밀번호<span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=password class=signupPwd id=password name=password title=비밀번호 placeholder=\"비밀번호를 입력해 주세요.\" ng-model=vc.data.Password required maxlength=16></td></tr><tr><th scope=row class=required>비밀번호 확인 <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=password class=signupPwd id=userPwdCheck name=userPwdCheck title=\"비밀번호 확인\" placeholder=\"비밀번호를 다시 입력해 주세요.\" ng-model=vc.data.Password2 required maxlength=16><ul><li>* 비밀번호는 8~16자의 영문 대, 소문자, 숫자, 특수문자 중 3개를 조합하여 사용합니다.</li><li>* 사용 가능 특수문자: ` . ~ ! @ # $ % ^ * ( ) - _ = +</li></ul></td></tr><tr><th scope=row class=required>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}} <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><input type=text id=email1 class=\"signupText w200\" title=이메일 maxlength=20 placeholder=\"이메일을 입력해 주세요.\" ng-model=vc.data.Email1 required> <span class=blank>@</span> <input type=text id=email2 class=\"signupText w160\" title=이메일 maxlength=25 ng-model=vc.data.Email2 required><select id=userEmail2Select class=\"w108 signupText\" title=이메일 ng-change=vc.setEmail() ng-model=vc.data.Email3><option value=\"\">직접입력</option><option value=naver.com>naver.com</option><option value=gmail.com>gmail.com</option><option value=hanmail.net>hanmail.net</option><option value=daum.net>daum.net</option><option value=nate.com>nate.com</option><option value=hotmail.com>hotmail.com</option></select></td></tr><tr><th scope=row class=required>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}} <span style=color:#f69679>*</span><br></th><td style=\"text-align: left\"><select id=userTelM1 name=userTelM1 title=휴대번호 class=\"signupText num_check first_select w108\" ng-model=vc.data.Mobile1><option value=010>010</option><option value=011>011</option><option value=016>016</option><option value=017>017</option><option value=018>018</option><option value=019>019</option></select><span class=blank>-</span> <input type=text id=userTelM2 class=\"num_check w108 signupText\" title=휴대번호 ng-model=vc.data.Mobile2 maxlength=4> <span class=blank>-</span> <input type=text id=userTelM3 class=\"num_check w108 signupText\" title=휴대번호 ng-model=vc.data.Mobile3 maxlength=4></td></tr><tr ng-repeat=\"li in vc.allColumns\" ng-if=\"li.CustomColumnYN == \'Y\'\"><th scope=row class=required>{{ li.ColumnLogicalNm }}</th><td><input ng-if=\"li.ColumnLogicalDataType == \'10\'\" type=text class=signupText ng-change=vc.onModelChanged() ng-model=vc.data[li.ColumnPhysicalNm]> <input ng-if=\"li.ColumnLogicalDataType == \'20\'\" type=number class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.data[li.ColumnPhysicalNm]><div ng-if=\"li.ColumnLogicalDataType == \'40\'\" class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-init=\"vc.RegDate[$index] = $root.getDate(vc.data[li.ColumnPhysicalNm])\" ng-model=vc.RegDate[$index] ng-change=\"vc.onDateChanged(li.ColumnPhysicalNm, $index);\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><common-code-custom ng-if=\"li.ColumnLogicalDataType == \'50\'\" code-list=li.CodeList code-model=vc.data[li.ColumnPhysicalNm] callback=vc.onModelChanged></common-code-custom></td></tr></table><p><!-- 회사의 <a href=\"/#/reserve/policy\" style=\"color: blue;\" target=\"_blank\">이용약관</a>과 <a href=\"/#/reserve/private\" style=\"color: blue;\" target=\"_blank\">개인정보보호정책</a>에 동의합니다. --> 회사의 <a style=\"cursor: pointer; color: blue\">이용약관</a>과 <a style=\"cursor: pointer; color: blue\">개인정보보호정책</a>에 동의합니다.</p><div class=btn_area style=\"margin-top: 30px\"><button class=\"signupBtn commonBtn5 type2 etc2\" ng-click=vc.setData()>회원가입</button> <button type=button class=\"signupBtn commonBtn5 type3\" ng-click=vc.goCancel()>취소</button></div></div><div id=tab_success ng-show=vc.result><h1>회원가입을 축하드립니다.</h1><button type=button class=\"signupBtn commonBtn5 type3\" ng-click=vc.goCancel()>로그인</button></div></div></div></div></div></div></form>");
$templateCache.put("components/login/winnersjm.html","<div class=n-login-wrap><div class=n-login-box><a class=\"btn-example btn btn-outline btn-danger\" href=#Notice id=notice style=\"display: none\"></a><div class=box-top-deco><p class=deco-text>WINNERSJMWINNERSJMWINNERSJMWINNERSJM</p></div><div class=n-login-body><form class=login_box id=login_box ng-submit=login.doLogin()><div class=\"title mb-30\"><img src=/assets/images/login/WJM_logo.png alt=\"\"></div><div class=idpw-box-input><div class=id><input name=txtLoginID title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" type=text maxlength=20 id=txtLoginID class=form-control placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" style=\"ime-mode: inactive; margin-bottom: 10px\" ng-model=login.loginInfo.loginId ng-required=true></div><div class=pw><input name=txtPassword title=\"{{\'LOGIN.TITLE.I.n-login-bodyNST_PW\'|translate}}\" type=password maxlength=20 id=txtPassword class=form-control placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" ng-model=login.loginInfo.loginPw ng-required=true></div></div><div class=idpw-text-box><div class=checkbox><input id=ckID type=checkbox name=ckID ng-checked=\"login.loginInfo.saveId === \'1\'\" ng-model=login.loginInfo.saveId ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" tabindex=3><label for=ckID>아이디 저장</label></div></div><div class=n-login-btn><button class=\"bts btn btn-lg btn-primary btn-block\" type=submit>Login</button></div><div class=mt-20><ul class=n-login-ui-find><li><a ui-sref=salemeetsignup>{{ \'Menu.SIGNUP\' | translate }}</a></li><li><span ng-click=\"login.findIdPwd(\'id\')\">아이디 찾기</span></li><li><span ng-click=\"login.findIdPwd(\'pwd\')\">비밀번호 찾기</span></li></ul></div></form></div></div></div><script>window.document.title = \'SALEMEET\';</script><!-- <div class=\"login_area\">\r\n  <div class=\"logins\">\r\n    <div class=\"logins_box\">\r\n      <div class=\"loginbox\">\r\n        <div class=\"login_txt\">\r\n          <strong class=\"tit\">\r\n            <img src=\"assets/images/login/login_tit.png\" alt=\"Log In\">\r\n          </strong>\r\n          <p class=\"txt\">\r\n            <span ng-bind=\"login.appName\"></span>\r\n            <span>Happy communication</span>\r\n            <br>bridge\r\n            <br>Solution\r\n          </p>\r\n          <div class=\"sel\">\r\n            <div class=\"selectbox\" style=\"width:140px;\">\r\n              <select ng-change=\"login.onChangeHandler()\" name=\"selectCombo\" ng-model=\"login.language\">\r\n                <option value=\"ko\" selected=\"\">\r\n                  한국어\r\n                </option>\r\n                <option value=\"en\">\r\n                  English\r\n                </option>\r\n                <option value=\"ja\">\r\n                  日本語\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（简体中文）\r\n                </option>\r\n                <option value=\"zh\">\r\n                  中文（繁體）\r\n                </option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <form class=\"login_box\" id=\"login_box\" ng-submit=\"login.doLogin()\">\r\n          <strong class=\"logos\">\r\n            <img src=\"assets/images/login/login_logo.png\" alt=\"SOFTZION CRM\">\r\n          </strong>\r\n          <div class=\"logs_cont\">\r\n            <p class=\"logos_des\" translate=\"LOGIN.MSG.REQ_SIGNIN\"></p>\r\n            <div class=\"logs_area\">\r\n              <div class=\"radio-group\">\r\n                <input type=\"radio\" id=\"one\" name=\"selector\" checked=\"checked\">\r\n                <label for=\"one\" translate=\"LOGIN.LABEL.NAME\"></label>\r\n                <input type=\"radio\" id=\"two\" name=\"selector\">\r\n                <label for=\"two\" translate=\"LOGIN.LABEL.SNUMB\"></label>\r\n              </div>\r\n              <ul class=\"logs_txt\">\r\n                <li class=\"log_id\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.ID\'|translate}}\"></span>\r\n                  <input type=\"text\" placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" id=\"ID\" ng-model=\"login.loginInfo.loginId\" ng-required=\"true\">\r\n                </li>\r\n                <li class=\"log_pw\">\r\n                  <span class=\"icon\" title=\"{{\'LOGIN.LABEL.PW\'|translate}}\"></span>\r\n                  <input type=\"password\" placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" title=\"{{\'LOGIN.TITLE.INST_PW\'|translate}}\" id=\"PASSWD\"\r\n                    ng-model=\"login.loginInfo.loginPw\" ng-required=\"true\">\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <div class=\"btns btn-group\">\r\n            <button class=\"bts\" type=\"submit\">{{ \'LOGIN.BTN.LOGIN\' | translate }}</button>\r\n            <div><span><a ui-sref=\"signup\">{{ \'Menu.SIGNUP\' | translate }}</a></span> | <span ng-click=\"login.findIdPwd(\'id\')\">아이디 찾기</span> | <span ng-click=\"login.findIdPwd(\'pwd\')\">비밀번호 찾기</span> </div>\r\n            <div class=\"checks\">\r\n              <input type=\"checkbox\" id=\"c1\" checked=\"checked\">\r\n              <label for=\"c1\"><span></span>Remember me.</label>\r\n            </div>\r\n            <div class=\"pwd-id\">\r\n\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <span class=\"login_footer\" translate=\"LOGIN.MSG.COPYRIGHT\"></span>\r\n</div>\r\n -->");
$templateCache.put("components/survey/counsel-agree.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>{{vc.title}}</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><textarea class=form-control style=height:200px readonly ng-if=\'vc.type == \"I\"\'>\r\n1. 수집ㆍ이용목적\r\n- 근로자지원 프로그램(EAP) 서비스를 임직원에게 제공할 목적\r\n- 위탁기간 동안 서비스 홍보 및 참여자에게 원활한 정보를 제공하기 위한 목적\r\n- 수집된 정보는 귀사의 성과관리 및 안정적인 서비스운영을 위해 수집됩니다.\r\n\r\n2. 수집항목\r\n- 수집항목 : 소속, 직급, 성명, 전화번호, E-mail 등\r\n- 수집내용 : 정보주체의 상담일시, 상담장소, 호소주제(상세내용 제외)\r\n- 스트레스 수준, 필요 시 의료적 정보(약물치료 경험 및 복용약물 등)\r\n\r\n3. 개인정보의 보유 및 이용기간\r\n- ㈜위너스제이엠이 수집한 정보는 서비스 종료 후 일괄 파기됩니다.\r\n\r\n4. 정보주체의 권리\r\n- 서비스를 제공받는 모든 임직원은 개인정보제공 및 활용을 거부할 권리가 있으나 서비스 이용에 제한을 받을 수 있습니다.\r\n\r\n5. 보안 유지\r\n- 귀하가 ㈜위너스제이엠에 제공한 개인정보 및 상담 내용은 철저하게 보안을 유지합니다.\r\n          </textarea><textarea class=form-control style=height:170px readonly ng-if=\'vc.type == \"M\"\'>\r\n1. 제공목적\r\n- 근로자지원 프로그램(EAP) 서비스를 원활이 제공하기 위한 목적\r\n- 수신 동의 시 EAP서비스에 대한 홍보목적에만(뉴스레터, 이벤트성 홍보물 등) 활용됩니다.\r\n\r\n2. 수집항목\r\n수집항목 : 소속, 직급, 성명, 전화번호, E-mail 등\r\n\r\n3. 수신동의 후 원치 않을 경우 언제든지 요청하면 수신거부가 가능합니다.\r\n          </textarea></div></div></div><div class=row><div class=col-lg-12><span ng-if=\'vc.type == \"I\"\'>☞ ㈜위너스제이엠에서 개인정보를 수집ㆍ이용하는 것에 동의하십니까?</span> <span ng-if=\'vc.type == \"M\"\'>☞ ㈜위너스제이엠으로부터 마케팅정보를 수신하는 것에 동의하십니까?</span></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=\"vc.ok(\'Y\')\">동의</button> <button class=\"btn btn-primary mb-10\" ng-click=\"vc.ok(\'N\')\">미동의</button> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()>닫기</button></div></div>");
$templateCache.put("components/survey/counsel.html","<div style=\"max-width: 960px; padding:30px\"><!--\r\n style=\"width:956px; height:693px;\"\r\n --><div class=page><div class=row><div class=col-lg-12><h3 class=page-header>상담신청</h3></div></div><div class=pagecontent><div class=\"page-body ng-scope\" style=padding:10px><div class=row ng-if=\"counsel.msg != \'\'\"><div class=col-md-12>{{counsel.msg}}</div></div><div class=row ng-if=\"counsel.msg == \'\'\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>고객명</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=counsel.data.Name></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>휴대폰</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=counsel.data.Mobile></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>이메일</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=counsel.data.Email></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>업체</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=counsel.data.ClientNm></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>부서</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=counsel.data.Department></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>직급</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=counsel.data.Position></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>나이</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=counsel.data.Age></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>상담희망방법</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=counsel.data.Area placeholder=\"전화/ 화상/ 대면\"></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>상담희망일정</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=counsel.data.Schedule></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label class=txt-req>상담주제</label><div class=counsel-chk><ul><li><input ng-checked-=\"counsel.data.TopicYN1 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN1 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 부부관계</li><li><input ng-checked-=\"counsel.data.TopicYN2 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN2 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 자녀문제</li><li><input ng-checked-=\"counsel.data.TopicYN3 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN3 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 부모문제</li><li><input ng-checked-=\"counsel.data.TopicYN4 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN4 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 우울</li><li><input ng-checked-=\"counsel.data.TopicYN5 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN5 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 불안</li><li><input ng-checked-=\"counsel.data.TopicYN6 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN6 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 분노</li><li><input ng-checked-=\"counsel.data.TopicYN7 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN7 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 중독</li><li><input ng-checked-=\"counsel.data.TopicYN8 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN8 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 대인관계</li><li><input ng-checked-=\"counsel.data.TopicYN9 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN9 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 직장</li><li><input ng-checked-=\"counsel.data.TopicYN10 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN10 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 스트레스</li><li><input ng-checked-=\"counsel.data.TopicYN11 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN11 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 성격고민</li><li><input ng-checked-=\"counsel.data.TopicYN12 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.TopicYN12 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 기타</li></ul></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label class=txt-req>내용</label><textarea class=form-control style=height:100px ng-model=counsel.data.Memo></textarea></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><div style=\"margin-left:20px; line-height: 25px !Important\"><label class=txt-req>개인정보수집 동의(필수)</label>&nbsp; &nbsp; <input ng-checked-=\"counsel.data.InfoAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.InfoAgreeYN ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 동의 <input ng-checked-=\"counsel.data.InfoAgreeYN == \'N\'\" ng-false-value=\"\'Y\'\" ng-model=counsel.data.InfoAgreeYN ng-true-value=\"\'N\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 미동의 <button class=\"btn btn-default ml-10\" ng-click=\"counsel.openAgreePop(\'I\');\" type=button>내용보기</button></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><div style=\"margin-left:20px; line-height: 25px !Important\"><label>마케팅정보 수신 동의(선택)</label><input ng-checked-=\"counsel.data.MktAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=counsel.data.MktAgreeYN ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 동의 <input ng-checked-=\"counsel.data.MktAgreeYN == \'N\'\" ng-false-value=\"\'Y\'\" ng-model=counsel.data.MktAgreeYN ng-true-value=\"\'N\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 미동의 <button class=\"btn btn-default ml-10\" ng-click=\"counsel.openAgreePop(\'M\');\" type=button>내용보기</button></div></div></div></div><div class=row style=padding-top:10px><div class=\"col-lg-12 text-center\"><button class=\"btn btn-default btn-svy\" ng-click=counsel.setData() ng-if=\"counsel.msg == \'\'\"><i class=\"fa fa-save\"></i> 저장</button></div></div></div><div class=\"page-footer ng-scope\"><!--button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" onclick=\"open(location, \'_self\').close(); self.close();\"><i\r\n          class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}\r\n        </button--></div></div></div></div></div>");
$templateCache.put("components/survey/emaildeny.html","<div style=\"max-width: 960px; padding:30px\"><div class=page><div class=row><div class=col-lg-12><h3 class=page-header>수신거부</h3></div></div><div class=pagecontent><div class=\"page-body ng-scope\" style=padding:10px><div class=row><div class=col-md-12>{{emaildeny.msg}}</div></div></div></div></div></div>");
$templateCache.put("components/survey/survey.html","<div style=\"max-width: 960px; padding:0; margin:0 auto\"><!--\r\n style=\"width:956px; height:693px;\"\r\n --><div class=page><div class=row><div class=dataloader ng-show=survey.dataloader></div><div class=col-lg-12><div class=row ng-show=\"survey.svyInfo.logoSrc != null && survey.svyInfo.logoSrc != \'\'\" style=\"padding-top: 5px\"><div class=col-md-12><img ng-src={{survey.svyInfo.logoSrc}} style=width:100px></div></div><h3 class=\"page-header svy-title\"><span ng-if=\"survey.svyInfo.SvyNm != \'\'\">{{survey.svyInfo.SvyNm}}</span> <span ng-if=\"survey.svyInfo.SvyNm == null || survey.svyInfo.SvyNm == \'\'\">{{wjmSurvey.getLangData(\"L00001\", survey.svyInfo.SvyLang)}}</span></h3></div></div><div class=pagecontent><div class=\"page-body ng-scope\" ng-show=survey.isErr style=padding:10px><div class=row style=padding:10px><div class=col-md-12>{{survey.errMsg}}</div></div></div><div class=\"page-body ng-scope\" ng-show=!survey.isErr style=padding-top:10px><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding><!--[{{survey.svyPagesTypeTxt}}]--> &nbsp;</strong><div class=pull-right>{{survey.svyPagesTxt}}&nbsp;&nbsp;&nbsp;&nbsp; <a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=row ng-if=\"survey.svyPagesType == \'1\'\"><div class=col-lg-12><span ng-bind-html=survey.svyInfo.TopCont|htmlString></span> <span id=testt></span></div></div><div class=row ng-if=\"survey.svyPagesType == \'2\'\"><div class=col-lg-12 style=\"padding:20px; max-width: 900px\"><!--<div class=\"row\" ng-repeat=\"qt in survey.svyQsts | filter : {PageNo: survey.svyPagesCur} : true\">--><div class=row ng-repeat=\"qt in survey.svyQstsCur\"><!-- 선택형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'1\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, survey.svyInfo.QstIconType, survey.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><p ng-repeat=\"it in survey.svyQstItems | filter : {qtId: qt.qtId} : true\" style=padding-top:10px><label ng-class=\"wjmSurvey.getItemSelClass(survey.svyResps[qt.qtId][0], it.itId, qt.SelType, survey.svyResps[qt.qtId][$index])\"><input type=radio ng-model=survey.svyResps[qt.qtId][0] ng-value=it.itId class=rdosvy style=margin-top:-3px ng-checked=\"survey.setBeginQtId(qt, it)\" ng-if=\"qt.SelType==\'S\'\"> <input type=checkbox ng-model=survey.svyResps[qt.qtId][$index] ng-true-value=\"{{\'\\\'\'+ it.itId + \'\\\'\'}}\" ng-false-value=undefined class=rdosvy ng-checked=\"survey.setBeginQtId(qt, it, $index)\" style=margin-top:-3px ng-if=\"qt.SelType==\'M\'\"> &nbsp;&nbsp;<!--{{it.QstItemNo}}. -->{{it.QstItemContents}} <input type=text ng-show=\'it.OtherRespYN == \"Y\" && qt.SelType==\"S\"\' ng-model=survey.svyRespsSbj[qt.qtId][0] class=\"form-control svy-qstitem\" maxlength=100 style=\"margin-top:5px;margin-left:15px !Important; max-width:80% !Important\" kr-input> <input type=text ng-show=\'it.OtherRespYN == \"Y\" && qt.SelType==\"M\"\' ng-model=survey.svyRespsSbj[qt.qtId][$index] class=\"form-control svy-qstitem\" maxlength=100 style=\"margin-top:5px;margin-left:15px !Important; max-width:80% !Important\" kr-input></label></p></div><!-- 입력형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'2\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, survey.svyInfo.QstIconType, survey.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><div style=padding-top:10px><textarea ng-show=\"qt.InputType != null && qt.InputType == \'T\'\" ng-model=survey.svyResps[qt.qtId][0] ng-change=\"survey.chkSbjBytes(qt.qtId, 2000)\" class=\"form-control svy-qstitem\" style=height:100px maxlength=1000 kr-textarea placeholder={{qt.InputHint}} ng-blur=\"survey.setBeginQtId(qt, null)\"></textarea><div class=text-right ng-show=\"qt.InputType != null && qt.InputType == \'T\'\">{{(survey.CutMsg[qt.qtId] ? survey.CutMsg[qt.qtId] : 0)}} / 2000 bytes (1000자)</div><input type=text ng-show=\"qt.InputType != null && qt.InputType == \'I\'\" ng-model=survey.svyResps[qt.qtId][0] class=\"form-control svy-qstitem\" maxlength=1000 style=\"max-width:80% !Important\" kr-input placeholder={{qt.InputHint}} ng-blur=\"survey.setBeginQtId(qt, null)\"></div></div><!-- 우선순위형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'3\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, survey.svyInfo.QstIconType, survey.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><div class=row><div class=col-sm-6 style=padding-bottom:10px><p ng-repeat=\"it in survey.svyQstItems | filter : {qtId: qt.qtId} : true\" style=padding-top:10px class=svy-qstitem>{{it.QstItemNo}}. {{it.QstItemContents}}</p></div><div class=col-sm-6><p ng-repeat=\"n in [].constructor(qt.QstTopCnt) track by $index\" style=padding-top:10px><select class=\"form-control svy-qstitem\" ng-model=survey.svyResps[qt.qtId][$index] ng-options=\"li.itId as li.QstItemContents for li in survey.svyQstItems | filter : {qtId: qt.qtId} : true\" ng-change=\"survey.setBeginQtId(qt, null, $index)\"><option value=\"\">--{{$index + 1}}{{wjmSurvey.getLangData(\"L00002\", survey.svyInfo.SvyLang)}}--</option></select></p></div></div></div><!-- 이미지형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'4\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, survey.svyInfo.QstIconType, survey.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><p style=\"width:100%; padding-top:10px; text-align:center\" ng-show=\"qt.qtImgSrc != null && qt.qtImgSrc != \'\'\"><img ng-src={{qt.qtImgSrc}} style=\"max-width: 100%\"></p><p ng-repeat=\"it in survey.svyQstItems | filter : {qtId: qt.qtId} : true\" style=padding-top:5px><label ng-class=\"wjmSurvey.getItemSelClass(survey.svyResps[qt.qtId][0], it.itId)\"><input type=radio ng-model=survey.svyResps[qt.qtId][0] ng-value=it.itId class=rdosvy style=margin-top:-3px ng-checked=\"survey.setBeginQtId(qt, it)\">&nbsp;<span ng-show=\"it.itImgSrc != null && it.itImgSrc != \'\'\">&nbsp;&nbsp;&nbsp;<img ng-src={{it.itImgSrc}}>&nbsp;&nbsp;</span><!--{{it.QstItemNo}}. --> {{it.QstItemContents}}</label></p></div><!-- 척도형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'5\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, survey.svyInfo.QstIconType, survey.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><div class=row ng-repeat=\"it in survey.svyQstItems | filter : {qtId: qt.qtId} : true\" style=padding-top:10px><div class=col-lg-3><span class=rdosvy-label>{{it.QstItemContents}}</span></div><div class=col-lg-6><ul style=\"display: table; width:100%\"><li style=\"display:table-cell; text-align: center\" ng-repeat=\"n in [].constructor(qt.ScaleMax) track by $index\"><label class=rdosvy-label><input type=radio ng-model=survey.svyResps[qt.qtId][$parent.$index] ng-value=\"it.itId + \'|\' + (qt.ScaleOrder==\'A\' ? $index + 1 : qt.ScaleMax - $index)\" class=rdosvy style=margin-top:-3px ng-checked=\"survey.setBeginQtId(qt, null)\"> <span ng-if=\"qt.ScaleOrder==\'A\'\">{{$index + 1}}</span><span ng-if=\"qt.ScaleOrder==\'D\'\">{{qt.ScaleMax - $index}}</span></label></li></ul></div><div class=\"col-lg-3 text-right\"><span class=rdosvy-label>{{it.QstItemContents2}}</span></div></div></div><!-- 분류정보 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'C\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, survey.svyInfo.QstIconType, survey.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><div ng-if=\"qt.ClassfyCd == \'NM\'\" style=padding-top:10px><div class=\"form-group form-inline\"><input type=text ng-model=survey.svyResps[qt.qtId][0] class=\"form-control svy-qstitem\" maxlength=30 style=\"margin-left:0 !Important; max-width:158px !Important\" kr-input></div></div><div ng-if=\"qt.ClassfyCd == \'MB\'\" style=padding-top:10px><div class=\"form-group form-inline\"><input class=\"form-control svy-qstitem\" style=\"margin-left:0 !Important; max-width:158px !Important\" ng-model=survey.svyResps[qt.qtId][0] ng-blur=\"wjmSurvey.blurMobile(survey.svyResps, qt.qtId);\" type=tel></div></div><div ng-if=\"qt.ClassfyCd == \'EM\'\" style=padding-top:10px><div class=form-inline><div style=display:inline-block;vertical-align:top;padding-bottom:5px><input type=text ng-model=survey.svyResps[qt.qtId][0] class=\"form-control svy-qstitem\" maxlength=30 style=\"margin:0 10px 0 0; width:200px !Important; float:left\" kr-input>@</div><div style=display:inline-block><input type=text ng-model=survey.svyResps[qt.qtId][1] class=\"form-control svy-qstitem\" maxlength=30 style=\"margin:0 5px 0 0; width:110px !Important; float:left\" ng-disabled=\"survey.svyResps[qt.qtId][2] != null && survey.svyResps[qt.qtId][2] != \'\'\" kr-input><select ng-model=survey.svyResps[qt.qtId][2] class=\"form-control svy-qstitem\" style=\"margin: 0; width:110px !Important\" ng-options=\"li.val as li.txt for li in survey.clientEmailList\" ng-change=\"survey.chgQstEmailDomain(survey.svyResps, qt.qtId)\"><option value=\"\">{{wjmSurvey.getLangData(\"L00025\", survey.svyInfo.SvyLang)}}</option></select></div></div></div><div ng-if=\"qt.ClassfyCd == \'GD\'\"><p style=padding-top:10px><label ng-class=\"wjmSurvey.getItemSelClass(survey.svyResps[qt.qtId][0], \'M\')\"><input type=radio ng-model=survey.svyResps[qt.qtId][0] ng-value=\"\'M\'\" class=rdosvy style=margin-top:-3px>&nbsp;&nbsp;<!--{{it.QstItemNo}}. -->{{wjmSurvey.getLangData(\"L00026\", survey.svyInfo.SvyLang)}}</label></p><p style=padding-top:10px><label ng-class=\"wjmSurvey.getItemSelClass(survey.svyResps[qt.qtId][0], \'F\')\"><input type=radio ng-model=survey.svyResps[qt.qtId][0] ng-value=\"\'F\'\" class=rdosvy style=margin-top:-3px>&nbsp;&nbsp;<!--{{it.QstItemNo}}. -->{{wjmSurvey.getLangData(\"L00027\", survey.svyInfo.SvyLang)}}</label></p></div><div ng-if=\"qt.ClassfyCd != \'NM\' && qt.ClassfyCd != \'MB\' && qt.ClassfyCd != \'EM\' && qt.ClassfyCd != \'GD\'\"><p style=padding-top:10px><select class=\"form-control svy-qstitem\" ng-model=survey.svyResps[qt.qtId][0] ng-change=survey.setBeginQtId(qt) ng-options=\"li.itId as li.QstItemContents for li in survey.svyQstItems | filter : {qtId: qt.qtId} : true\"><option value=\"\">--{{wjmSurvey.getLangData(\"L00028\", survey.svyInfo.SvyLang)}}--</option></select></p></div></div><!-- 설명글 --><div style=\"padding:10px 0 50px 0\" ng-if=\"qt.QstType == \'R\'\"><pre class=\"txt-pre svy-qstitem\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}>{{qt.QstSubject}}</pre></div></div></div></div><div class=row ng-if=\"survey.svyPagesType == \'3\'\"><div class=col-lg-12 ng-show=\"survey.svyInfo.BtmType == \'100\'\"><span ng-bind-html=survey.svyInfo.BtmCont|htmlString></span></div><div class=col-lg-12 ng-show=\"survey.svyInfo.BtmType == \'200\'\"><span ng-bind-html=survey.LvCont|htmlString></span></div><div class=col-lg-12 ng-show=\"survey.svyInfo.ContactTxtYN == \'Y\'\" style=padding-top:10px><span ng-bind-html=survey.svyInfo.ContactTxt|htmlString></span></div></div></div></div><div class=row style=padding-top:10px><div class=\"col-lg-12 text-center\"><button class=\"btn btn-default btn-svy\" ng-click=\"survey.setSvyPagesType(\'PREV\')\" ng-if=\"survey.showSvyBtn(\'PREV\')\"><i class=\"fa fa-arrow-left\"></i> {{wjmSurvey.getLangData(\"L00003\", survey.svyInfo.SvyLang)}}</button> <button class=\"btn btn-default btn-svy\" ng-click=\"survey.setSvyPagesType(\'NEXT\')\" ng-if=\"survey.showSvyBtn(\'NEXT\')\"><i class=\"fa fa-arrow-right\"></i> {{wjmSurvey.getLangData(\"L00004\", survey.svyInfo.SvyLang)}}</button> <button class=\"btn btn-default btn-svy\" ng-click=\"survey.setSvyPagesType(\'END\')\" ng-if=\"survey.showSvyBtn(\'END\')\"><i class=\"fa fa-save\"></i> {{wjmSurvey.getLangData(\"L00005\", survey.svyInfo.SvyLang)}}</button></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=btm-svy>Copyrightⓒ2020 WINNERSJM Co., Ltd. All rights reserved.</div></div></div><div class=\"page-footer ng-scope\" style=padding-top:10px><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" onclick=\"open(location, \'_self\').close(); self.close()\"><i class=\"fa fa-times\"></i> {{wjmSurvey.getLangData(\"L00022\", survey.svyInfo.SvyLang)}}</button></div></div></div></div><style>@media (max-width:400px) {\r\n    .pagecontent img {\r\n      max-width: 100% !Important;\r\n      height: auto !Important;\r\n    }\r\n    .pagecontent table {\r\n      max-width: 100% !Important;\r\n    }\r\n  }</style>");
$templateCache.put("app/application/EAP-business-edit.html","<div class=\"page page-footable\" ng-controller=\"WjmEAPBEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>사업 문의 조회/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>사업문의 신청정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'CounselNum\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=20 ng-model=vc.data.CounselNum readonly></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate}}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.RegDate = (vc.RegDate | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\" readonly></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'CounselStatus\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'CounselStatus\'].CodeList\" code-model=vc.data.CounselStatus></common-code-custom></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Company\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Company></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Department\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Department></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=vc.data.Name></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=vc.data.Mobile></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Email></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Memo\'].ColumnLogicalNm | translate}}</label><textarea class=form-control style=height:100px ng-model=vc.data.Memo></textarea></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>개인정보수집</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input ng-checked-=\"vc.data.InfoAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 동의</div></div></div></div></div></div></div></div></form></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content -->");
$templateCache.put("app/application/EAP-business-list.html","<div class=\"page page-footable\" ng-controller=\"EAPBusinessListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>사업 문의<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Name placeholder=\"고객명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Name\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Name type=text><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CounselNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CounselNum type=text><label>{{vc.columnMap[\'CounselNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Manager\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CounselStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CounselStatus\'].CodeList\" code-model=vc.srch.CounselStatus></common-code-custom><label>{{vc.columnMap[\'CounselStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CounselDateFrom = (vc.CounselDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDateFrom ng-required=false placeholder=상담신청일시작 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CounselDateTo = (vc.CounselDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDateTo ng-required=false placeholder=상담신청일종료 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><!--\r\n                  <button class=\"btn btn-primary\" ng-click=\"vc.goAdd()\"><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button>\r\n                  --> <button class=\"btn btn-danger\" ng-click=vc.deleteList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.setPageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/application/EAP-counsel-edit.html","<div class=\"page page-footable\" ng-controller=\"EAPCounselEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>EAP상담 신청 조회/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>상담신청정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'CounselNum\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=20 ng-model=vc.data.CounselNum readonly></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate}}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.RegDate = (vc.RegDate | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\" readonly></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\" ng-controller=\"CommonCodeCustomCtrl as ccCtrl\"><label>{{vc.columnMap[\'CounselStatus\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'CounselStatus\'].CodeList\" code-model=vc.data.CounselStatus></common-code-custom></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=vc.data.Name></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=vc.data.Mobile></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Email></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Company\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Company></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Married\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Married></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Routine\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Routine></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Schedule\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Schedule></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>상담주제</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input ng-checked=\"vc.data.TopicYN0 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN0 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN0\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN1 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN1 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN1\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN2 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN2 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN2\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN3 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN3 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN3\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN4 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN4 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN4\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN5 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN5 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN5\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN6 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN6 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN6\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN7 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN7 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN7\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN8 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN8 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN8\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN9 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN9 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN9\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN10 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN10 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN10\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN11 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN11 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN11\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked=\"vc.data.TopicYN12 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN12 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\">{{vc.columnMap[\'TopicYN12\'].ColumnLogicalNm | translate}}</div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Memo\'].ColumnLogicalNm | translate}}</label><textarea class=form-control style=height:100px ng-model=vc.data.Memo></textarea></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>개인정보수집</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input ng-checked-=\"vc.data.InfoAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 동의</div></div></div></div></div></div></div></div></form></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content -->");
$templateCache.put("app/application/EAP-counsel-list.html","<div class=\"page page-footable\" ng-controller=\"EAPCounselListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>EAP상담 신청<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Name placeholder=\"고객명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Name\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Name type=text><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CounselNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CounselNum type=text><label>{{vc.columnMap[\'CounselNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Manager\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CounselStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CounselStatus\'].CodeList\" code-model=vc.srch.CounselStatus></common-code-custom><label>{{vc.columnMap[\'CounselStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CounselDateFrom = (vc.CounselDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDateFrom ng-required=false placeholder=상담신청일시작 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CounselDateTo = (vc.CounselDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDateTo ng-required=false placeholder=상담신청일종료 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><!--\r\n                  <button class=\"btn btn-primary\" ng-click=\"vc.goAdd()\"><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button>\r\n                  --> <button class=\"btn btn-danger\" ng-click=vc.deleteList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/application/expert-edit.html","<div class=\"page page-footable\" ng-controller=\"ExpertEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>전문가협약 신청 조회/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>상담신청정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'CounselNum\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=20 ng-model=vc.data.CounselNum readonly></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate}}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.RegDate = (vc.CounselDate | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\" readonly></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\" ng-controller=\"CommonCodeCustomCtrl as ccCtrl\"><label class=txt-req>{{vc.columnMap[\'CounselStatus\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'CounselStatus\'].CodeList\" code-model=vc.data.CounselStatus></common-code-custom></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=vc.data.Name></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Gender\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Gender></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Age\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Age></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=vc.data.Mobile></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Email></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Area\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Area></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Memo\'].ColumnLogicalNm | translate}}</label><textarea class=form-control style=height:100px ng-model=vc.data.Memo></textarea></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>개인정보수집</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input ng-checked-=\"vc.data.InfoAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 동의</div></div></div></div></div></div></div></div></form></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content -->");
$templateCache.put("app/application/expert-list.html","<div class=\"page page-footable\" ng-controller=\"ExpertListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>전문가협약 신청<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Name placeholder=\"고객명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Name\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Name type=text><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CounselNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CounselNum type=text><label>{{vc.columnMap[\'CounselNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Manager\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CounselStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CounselStatus\'].CodeList\" code-model=vc.srch.CounselStatus></common-code-custom><label>{{vc.columnMap[\'CounselStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CounselDateFrom = (vc.CounselDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDateFrom ng-required=false placeholder=상담신청일시작 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CounselDateTo = (vc.CounselDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDateTo ng-required=false placeholder=상담신청일종료 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><!--\r\n                  <button class=\"btn btn-primary\" ng-click=\"vc.goAdd()\"><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button>\r\n                  --> <button class=\"btn btn-danger\" ng-click=vc.deleteList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-master-detail.html","<div class=\"page page-footable\" ng-controller=\"BbsMasterDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.EM630\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>마스터아이디</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsMasterId></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>게시판명</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsNm></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>메타테이블 TableNm</label><div class=\"form-control txt_view\" ng-bind=vc.data.MetatableNm></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></div></div></div><div class=\"col-lg-12 col-md-12\"><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-master-edit.html","<div class=\"page page-footable\" ng-controller=\"BbsMasterEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.EM630\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>마스터아이디</label><input type=text class=form-control ng-model=vc.data.BbsMasterId readonly></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>게시판명</label><input type=text class=form-control ng-model=vc.data.BbsNm></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>메타테이블 TableNm</label><input type=text class=form-control ng-model=vc.data.MetatableNm></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><input type=text class=form-control ng-model=vc.data.RegUserNm readonly></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=form-control ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></div></div></div><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Remark></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-master-list.html","<div class=\"page page-footable\" ng-controller=\"BbsMasterListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>게시판 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size=\"40% + 2px\" pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.BbsNm placeholder=\"게시판명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.BbsNm type=text><label>게시판명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.EM630\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-click=\"vc.tablesort(\'X.BbsMasterId\')\" data-toggle=true class=text-center>마스터아이디 <span class=\"{{vc.sortClass(\'X.BbsMasterId\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.BbsNm\')\" data-toggle=true class=text-center>게시판명 <span class=\"{{vc.sortClass(\'X.BbsNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.MetatableNm\')\" data-toggle=true class=text-center>메타테이블 TableNm <span class=\"{{vc.sortClass(\'X.MetatableNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.RegUserNm\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC03\' | translate }} <span class=\"{{vc.sortClass(\'X.RegUserNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.RegDate\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC04\' | translate }} <span class=\"{{vc.sortClass(\'X.RegDate\')}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.BbsMasterId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':vc.keyId == li.BbsMasterId}\"><!-- Result Items --><td class=text-center><span ng-bind=li.BbsMasterId></span></td><td class=text-center><span ng-bind=li.BbsNm></span></td><td class=text-center><span ng-bind=li.MetatableNm></span></td><td class=text-center><span ng-bind=li.RegUserNm></span></td><td class=text-center><span>{{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/h0102-detail.html","<div class=\"page page-footable\" ng-controller=\"H0102DetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>PR Center 게시판</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.Title></span></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BoardTypeNm\']\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BoardTypeNm\'].ColumnLogicalNm | translate}}</label><span class=form-control ng-bind=vc.data.BoardTypeNm></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.RegUserNm></span></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.BbsPostId></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=\"vc.data.EdtDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtUserNm\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.EdtUserNm></span></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.ReadCnt></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.PublicYNNm></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.NoticeYNNm></span></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\" ng-if=\"vc.columnMap[\'Tags\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Tags\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.Tags></span></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 85px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Contents\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Contents\'].ColumnLogicalNm | translate }}</label></div></div></div><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Contents\']\"><div class=\"form-group form-inline\"><span class=txt_view ng-bind-html=vc.data.Contents|htmlString></span></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.COMMENT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><article class=streamline-post ng-repeat=\"li in vc.comment.lists\"><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\">{{li.RegUserNm}} <span><i class=\"fa fa-clock-o mr-5\"></i> {{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span> <span class=\"text-muted pull-right\" ng-hide=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editComment(li.BbsPostCommId)><i class=\"glyphicon glyphicon-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn-min btn btn-default\" ng-click=vc.deleteComment(li)><i class=\"glyphicon glyphicon-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> </span><span class=\"text-muted pull-right\" ng-show=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editCommentAction(li)><i class=\"glyphicon glyphicon-ok\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn-min btn btn-default\" ng-click=vc.editCommentCancel()><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=panel-body ng-hide=\"li.BbsPostCommId == vc.comment.editid\">{{li.Contents}}<table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100% ng-if=li.LogicalFileNm><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"></colgroup><tbody><tr><td><a href=\"\" ng-click=vc.openAttachment(li)>{{li.LogicalFileNm}}</a></td><td align=right><span class=file_size ng-bind=li.FileSize|filesize></span></td></tr></tbody></table></div><div class=panel-body ng-show=\"li.BbsPostCommId == vc.comment.editid\"><textarea class=form-control id=strReply rows=10 style=\"width:100%; height:40px; resize:none\" ng-model=vc.comment.editContents></textarea><span ng-show=\"li.AttachmentId != null && li.AttachmentId != \'\'\"><br>{{li.LogicalFileNm}}&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=vc.setDeleteFileToggle(li)><span ng-show=\"li.delState == \'\' \"><i class=icon-trash>{{ \'Menu.DELETE\' | translate }}</i></span><span ng-show=\"li.delState != \'\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></span></div></div></div></article><div class=streamline-form><form class=\"ng-pristine ng-valid\"><div class=\"form-group form-inner-label\" style=height:40px><div class=input-group><textarea class=form-control id=strReply placeholder=\"댓글 작성...\" rows=10 style=\"width:100%; height:40px; resize:none\" ng-model=vc.srchReply.Contents></textarea><span class=input-group-btn style=\"vertical-align: top\"><button class=\"btn btn-default\" type=button ng-click=vc.saveComment()>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" type=button ng-click=vc.openDilalog()>{{ \'Menu.ATTACHMENT\' | translate }}</button> </span><input id=file-5 style=\"display: none\" class=file type=file data-preview-file-type=any></div></div><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><tbody><tr id=filectl ng-repeat=\"obj in vc.uploadFileListReply\"><td><div ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></div><a href={{obj.link}} target=attach ng-show=obj.isLoaded>{{obj.fileName}}</a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a ng-show=\"obj.delState == \'\'\" href=\"\" ng-click=vc.onDelete(obj)><i class=icon-trash></i></a> <a ng-show=\"obj.delState != \'\' \" href=\"\" ng-click=vc.onDeleteCancel(obj)><i class=icon-cancel-square></i> {{ \'Menu.DELETE\' | translate }}</a></td></tr></tbody></table></form><div>&nbsp;</div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/h0102-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"H0102EditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>PR Center 게시판</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form name=theForm><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=theForm.Title.$invalid>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title name=Title minlength=2 required></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate}}<span class=point_red ng-show=\"vc.data.BoardType == \'\'\">*</span></label><common-code-custom code-list=\"vc.columnMap[\'BoardType\'].CodeList\" code-model=vc.data.BoardType></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><input type=text class=form-control ng-model=vc.data.RegUserNm readonly></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label><input type=text class=form-control ng-model=vc.data.BbsPostId readonly></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=\"vc.data.EdtDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtUserNm\'].ColumnLogicalNm | translate }}</label><input type=text class=form-control ng-model=vc.data.EdtUserNm readonly></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><input type=text class=form-control ng-model=vc.data.ReadCnt readonly></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=\"vc.data.PublicYN == \'\'\">*</span></label><common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=vc.data.PublicYN></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=\"vc.data.NoticeYN == \'\'\">*</span></label><common-code-custom code-list=\"vc.columnMap[\'NoticeYN\'].CodeList\" code-model=vc.data.NoticeYN></common-code-custom></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\" ng-if=\"vc.columnMap[\'Tags\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Tags\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Tags></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}<br><br><br><span style=\"color: #999; font-size: 12px\">* 최적픽셀<br>(305 x 200)</span></label><br><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}<br><br><br><span style=\"color: #999; font-size: 12px\">* 최적픽셀<br>(305 x 200)</span></label><div style=\"margin-left: 75px\" id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 75px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=form-group><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/board/h0102-list.html","<div class=\"page page-footable\" ng-controller=\"H0102ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{vc.BbsNm}}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size=\"40% + 2px\" pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>PR Center 게시판</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.BbsPostId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.BbsPostId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\" ng-bind-html=$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm])></span> <span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/h0102-mlist.html","<div class=\"page page-footable\" ng-controller=\"H0102ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><h1 class=page-header>{{ :: \'Menu.h0102\' | translate }}</h1><div class=\"pull-right dock-header-tx\"><span ng-click=\"vc.setResponsive(\'default\')\">기본</span> <span ng-click=\"vc.setResponsive(\'vertical\')\">좌우</span> <span ng-click=\"vc.setResponsive(\'horizon\')\">상하</span></div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div id=dockWrap><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div></div><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-info tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">{{ :: \'Menu.SEARCH\' | translate }} {{ :: \'Menu.CONDITION\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-4 col-sm-8 col-xs-8\"><div class=\"form-group form-inner-label\" ng-show=vc.srch.searchColumns.Title><input type=text class=\"form-control form-right\" ng-model=vc.srch.Title><label>{{ :: \'Menu.TITLE\' | translate }}</label></div></div><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4\"><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=vc.srch.Contents class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>{{ :: \'Menu.INCLUSION_OF_CONTENT\' | translate }}</md-checkbox></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-show=vc.srch.searchColumns.RegDate ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"{{ ::  \'Menu.REG_DATEFROM\' | translate }}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-show=vc.srch.searchColumns.RegDate ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateTo ng-change=\"vc.srch.RegDateTo = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"{{ ::  \'Menu.REG_DATETO\' | translate }}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2\"><input type=text class=form-control ng-show=vc.srch.searchColumns.RegUser_ ng-model=vc.srch.RegUser_ placeholder=등록자></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=pull-right><button class=\"btn btn-info\" activate-button ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}<!-- 입력값 초기화 후 자동 리스트 재조회 --></button></div></div></div></div></div></div></div><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.h0102\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead></thead><tbody></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /dockWrap --></div><!-- /page content --></div><ui-view></ui-view>");
$templateCache.put("app/board/h0103-detail.html","<div class=\"page page-footable\" ng-controller=\"H0103DetailCtrl as vc\"><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h1 class=page-header>고객목록</h1></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><ul class=\"nav nav-tabs mt-20\"><li class=active><a ng-click=vc.setChangeTab(0); data-toggle=tab>고객정보</a></li><li><a ng-click=vc.setChangeTab(1); data-toggle=tab>상담이력</a></li><li><a ng-click=vc.setChangeTab(2); data-toggle=tab>구매이력</a></li><li><a ng-click=vc.setChangeTab(3); data-toggle=tab>예약이력</a></li><li><a ng-click=vc.setChangeTab(4); data-toggle=tab>SMS이력</a></li><li><a ng-click=vc.setChangeTab(5); data-toggle=tab>설문이력</a></li></ul><!-- 고객정보 --><div class=tab-content ng-show=visbile><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group mt-10\"><div class=pull-right><button class=\"btn btn-default ng-binding ng-scope\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> 목록</button></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Clause | 회원약관</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /panel header --><!-- panel body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-12><div class=\"bs-callout bs-callout-info\" id=callout-navs-tabs-plugin><div class=member-comment-box><ul class=comment><li>시바산 제품은 시바산 아카데미의 교육을 이수 받은 전문가가 직접 관리/적용 하는 제품입니다. 시바산의 모든 제품은 문제성 피부의 개선을 목적으로 하는 코스메슈티컬 제품으로 안전성이 비교적 낮습니다.</li><li>따라서 본인의 컨디션 및 피부상태, 잘못된 사후 관리 등으로 여러 현상이 발생 할 수 있기 때문에 시바산 트리트먼트를 받는 기간 동안 전문가의 지시사항을 100% 이행하셔야 합니다.</li></ul></div><div class=member-comment-box--red><ul class=comment><li>시바산 트리트먼트는 관리 기간 동안 고영양 현상으로 인한 트러블과 같은 반응이 언제든 발생 할 수 있습니다. 이는 치료를 목적으로 하는 고영양성분의 약용 화장품이 갖는 특징으로 전문가의 적절한 피드백으로 피부의 개선을 보장하는 내용 외 별도의 법적 물적 보상은 없습니다.</li><li>당일 예약 취소, 변경 시 타겟팅 관리 횟수에서 1회가 차감됩니다.</li><li>불가피한 사유로 관리를 받을 수 없을 시 관리권, 제품의 환불 요청 시에는 타겟팅금액/관리횟수를 차감한 금액을 정산합니다.</li></ul></div></div></div></div><div class=row><div class=\"col-sm-12 col-sm-offset-3 col-md-12 col-md-offset-0 col-lg-12\"><div class=\"col-sm-3 col-md-4 col-lg-3 pl-0\"><div class=checkbox><label class=ng-binding><input class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false type=checkbox>위 약관에 동의합니다.</label></div></div><!-- /col --><div class=\"col-sm-2 col-md-4 col-lg-3 pr-0 pl-0\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=2019-00-00> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- /col --><div class=\"col-sm-2 col-md-4 col-lg-3 pr-0\"><div class=\"form-group form-inner-label\"><label class=ng-binding>이름</label><input type=text class=\"form-control form-right ng-pristine ng-valid ng-empty ng-touched\" ng-model=vc.srch.Title aria-invalid=false placeholder=\"\"></div></div><!-- /col --><div class=\"col-sm-2 col-md-4 col-lg-3\"><div class=\"form-group form-inner-label\"><label class=ng-binding>서명</label><input type=text class=\"form-control form-right ng-pristine ng-valid ng-empty ng-touched\" ng-model=vc.srch.Title aria-invalid=false placeholder=\"\"></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=form-group ng-show=vc.srch.editColumns.Contents><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 600px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><!-- //row --></form></div><!-- //panel body --></div><!-- //panel --></div><!-- //col --></div><!-- //row --><!-- row 개인정보 --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step1 | 개인 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>이름</label><input name=\"\" type=text maxlength=25 class=form-control></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input type=radio name=inlineRadioOptions id=inlineRadio1 value=option1 class=mr-5>남</label><label class=radio-inline><input type=radio name=inlineRadioOptions id=inlineRadio2 value=option2>여</label></div></div></div></div><!-- /col --><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>연락처</label><input name=\"\" type=text maxlength=25 class=form-control></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input type=radio name=sms id=option1 value=option1 class=mr-5>SMS 수신동의</label><label class=radio-inline><input type=radio name=sms id=option2 value=option2> SMS 수신거부</label></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input name=ctl00$ContentPage$FLD_ZIPCODE type=text maxlength=7 id=ContentPage_FLD_ZIPCODE class=form-control readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button onclick=\"return fnSearchZipcode(\'FLD_ZIPCODE\', \'FLD_ADDRESS1\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input name=ctl00$ContentPage$FLD_ZIPCODE type=text maxlength=7 id=ContentPage_FLD_ZIPCODE class=form-control></div></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>생년월일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"생년월일 선택\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><!-- /input-group --></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 xs-mb10\"><label class=radio-inline><input type=radio name=sms id=option1 value=option1 class=mr-5>음</label><label class=radio-inline><input type=radio name=sms id=option2 value=option2>양</label></div></div><!-- /col --></div><!-- /row   --></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>등록일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 선택\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><!-- /input-group --></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-12\"><div class=\"form-group form-inline xs-mb10\"><label>직업</label><input name=\"\" type=text maxlength=25 class=form-control></div></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>방문경로</label><div class=\"inline-box brd1 p-10 bd-rd4\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input type=radio name=inlineRadioOptions>블로그</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input type=radio name=inlineRadioOptions>카페</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input type=radio name=inlineRadioOptions>인스타그램</label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio name=inlineRadioOptions>소개 <input name=\"\" type=text maxlength=25 class=\"form-control wd181\" placeholder=\"소개인 ID\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio name=inlineRadioOptions>기타 <input name=\"\" type=text maxlength=25 class=\"form-control wd181\" placeholder=\"과거 이용 경험있음\"></label></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=sz-custom-select-tenant><section class=tile fullscreen=isFullscreen06><!-- ngIf: header.checkUse --><div class=\"form-group ng-scope\" ng-if=header.checkUse><div class=\"input-group custom-search-form\"><input type=text readonly class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" ng-model=header.TENANTNAME ng-click=header.srchTenantModal(); aria-invalid=false> <input type=hidden ng-model=header.TENANTID autocomplete=off class=\"ng-pristine ng-untouched ng-valid ng-not-empty\" aria-invalid=false> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=header.srchTenantModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=header.eraseTenant();><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- end ngIf: header.checkUse --></section></div></div><!-- /col --></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>특이사항</label><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"ex/ 알러지성 질환, 복용중인 약물, 신체질환\"></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>E-mail</label><input name=\"\" type=text maxlength=25 class=form-control placeholder=adcde@mail.co.kr></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>고객등급</label><select name=ctl00$ContentPage$FLD_BRANCHCODE id=ContentPage_FLD_BRANCHCODE class=form-control><option value=010>A</option><option value=020>B</option><option value=030>C</option></select></div></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>담당자</label><div class=input-group><input name=ctl00$ContentPage$FLD_ZIPCODE type=text maxlength=7 id=ContentPage_FLD_ZIPCODE class=form-control readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button onclick=\"return fnSearchPopup(\'U\',\'FLD_ASSIGNUSERID_\',\'FLD_ASSIGNUSERID\',\'\')\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button onclick=\"fnResetVal(\'FLD_ASSIGNUSERID_\',\'FLD_ASSIGNUSERID\')\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- /row --></div><!-- //panel body --></div><!-- //panel --></div><!-- //col --></div><!-- //row --><!-- row 과거 관리 및 시술이력 / 홈케어정보--><div class=row><!-- col 과거관리 및 시술 이력--><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step2 | 과거 관리 및 시술 이력</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-12 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>보습, 미백, 여드름,노화관리</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>MTS, 필링</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>레이저 시술</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>보톡스, 필러, 실리프팅</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-12 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=\"checkbox sm-mb0\"><label class=ng-binding><input type=checkbox>지방이식, 보형물 등의 삽입 성형 수술</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=form-group><div class=\"checkbox sm-mb0\"><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --></div><!-- /tile body --></div></div><!-- /과거관리 및 시술 이력 --><!-- col 홈케어 정보--><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>홈 케어 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5\"><label class=ng-binding><input type=checkbox>클렌징</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5\"><label class=ng-binding><input type=checkbox>데이</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb5 xs-mt10\"><label class=ng-binding><input type=checkbox>나이트</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb5 xs-mt10\"><label class=ng-binding><input type=checkbox>각질제거</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb0 xs-mt10\"><label class=ng-binding><input type=checkbox>기타(팩)</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --></div><!-- /tile body --></div></div><!-- /col 홈케어 정보--></div><!-- row 과거 관리 및 시술이력 / 홈케어정보--><!-- row 섹터별 특징 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step3 | 섹터별 특징</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 plr-0\"><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Sebum Area / 피지분포 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>White Acne Area / 좁쌀 여드름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Anti Acne Area / 염즘성 여드름</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Pore Area / 모공 확장 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Scar Area / 상처 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Melano Area / 색소 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Dry Area / 건조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Wrinkle Area / 옅은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Deep Wrinkle Area / 깊은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Fush Area / 홍조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Telangiectasia Area / 모세혈관 확장</label></div></div><!-- /col --></div></div></div><!-- /tile body --></div><!-- /panel --><!-- row 섹터별 특징 / 얼굴이미지--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>얼굴이미지</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"text-center pt-10 min-h312\"><img src=/assets/images/face-image.png alt=\"\" class=sector-img></div></div></div><!-- /tile body --></div><!-- /panel --></div><!-- /col 섹터별 특징 --><!-- row 현재의피부 상황 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step4 | 현재의 피부 상황 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">- 현재 피부 상태는 어떠한지에 대해서 고객이 직접 이야기하는 내용을 입력</div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의피부 상황 이야기--><!-- row 과거의 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step5 | 과거의 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">-현재피부가 과거에도 그랬는지 과거에는 피부가 어땠는지 입력<br>-과거에 피부가 좋았다면 그때는 어떤 이로운점이 있었는지 입력<br>-과거에 피부가 안좋았다면 그때는 어떤 점이 불편했는지 입력</div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /과거의 이야기--><!-- row 현재의 결심 그리고 미래에 대한 이야기--><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step6 | 현재의 결심 그리고 미래에 대한 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">-현재의 피부를 만약 고치지 않고 그대로 방치했을때 현재와 미래에 어떤 불이익, 안좋은상황이 올것인지에 대해 발설유도 하며 최악의 상황을 세세히 그려줌<br>-현재 피부는 어떤상태이니 어느정도의 노력과, 시간이 투자된다면, 어떤피부상태가 될것인지에 대해서 예상시켜줌<br>-그리고 피부가 그렇게 좋아졌을때 기분이 어떨것같은지, 현재 어떻게 바뀔것 같은지, 너의 미래는 어떻게 될것같은지에 대해 발설유도.<br></div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의 결심 그리고 미래에 대한 이야기--><!-- row 관리 처방--><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step7 | 관리처방</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-6 col-md-6 col-lg-6 col-xl-6\"><label class=ng-binding>전체품목</label><table class=\"table table-condensed table-typeA mt-5\"><colgroup><col style=\"width: 55%\"><col style=\"width: 35%\"><col style=\"width: 8%\"></colgroup><thead><tr><td>품목명</td><td>금액</td><td>선택</td></tr></thead><tbody><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> 선택</button></td></tr><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> 선택</button></td></tr><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> 선택</button></td></tr></tbody></table></div><!-- /col --><div class=\"col-xs-6 col-md-6 col-lg-6 col-xl-6 mt-10\"><label class=ng-binding>선택 품목</label><table class=\"table table-condensed table-typeA mt-5\"><colgroup><col style=\"width: 45%\"><col style=\"width: 24%\"><col style=\"width: 15%\"><col style=\"width: auto\"></colgroup><thead><tr><td>품목명</td><td>금액</td><td>횟수</td><td>삭제</td></tr></thead><tbody><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=\"\"></td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> 삭제</button></td></tr><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=\"\"></td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> 삭제</button></td></tr><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=\"\"></td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> 삭제</button></td></tr></tbody></table></div><!-- /col --></div><!-- /row --></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /관리 처방--><!-- row 복용약--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step8 | 복용약</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=col-sm-12><textarea class=form-control rows=5></textarea></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /복용약--><!-- row 고객관리 사진--><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step9 | 고객관리 사진</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /고객관리 사진--><!-- row 상담--><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile mb-10\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step10 | 상담</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-12\"><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>상담일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일 선택\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><!-- /input-group --></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>상담내용</label><textarea class=form-control rows=5></textarea></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>관련사진</label><div class=inline-box><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div></div><!-- //상담--></div><!-- //고객정보 --><!-- 상담이력 --><div class=tab-content ng-show=visbile1><!-- 팝업창 - 등록 --><div class=search-detail-wrap><div class=\"panel panel-default\"><div class=panel-heading>상담이력 등록</div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-12\"><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>상담일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일 선택\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><!-- /input-group --></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>상담내용</label><textarea class=form-control rows=5></textarea></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>관련사진</label><div class=inline-box><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div></div></div></div></div><!-- //팝업창 - 등록 --><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group mt-10\"><div class=pull-right><button class=\"btn btn-default ng-binding ng-scope\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> 목록</button> <button class=\"btn btn-primary ng-binding\"><i class=\"fa fa-edit\"></i> 등록</button> <button class=\"btn btn-danger ng-binding\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> 삭제</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>상담이력</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><colgroup><col style=width:8%><col style=width:30%;><col style=width:auto></colgroup><thead><tr><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>선택<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>상담일자<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>상담내용<span class=\"fa fa-sort\"></span></th></tr></thead><tbody><tr><td><input id=ContentPage_gvList_chk_0 type=checkbox name=ctl00$ContentPage$gvList$ctl02$chk></td><td>제목제목제목제목제목제목제목제목제목</td><td>내용내용내용내용내용내용내용내용내용내용</td></tr></tbody></table><div class=row><div class=col-md-6><!-- 조회수 및 건수 --><div class=\"dataTables_info txt_noti\" role=status aria-live=polite><div style=display:none><input name=ctl00$ContentPage$PagingNavi$tbTotal type=text value=4692 id=ContentPage_PagingNavi_tbTotal class=input> <input name=ctl00$ContentPage$PagingNavi$tbCPage type=text value=1 id=ContentPage_PagingNavi_tbCPage> <input name=ctl00$ContentPage$PagingNavi$tbMulti type=text value=0 id=ContentPage_PagingNavi_tbMulti> <input name=ctl00$ContentPage$PagingNavi$tbMultiLast type=text value=15 id=ContentPage_PagingNavi_tbMultiLast> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGESIZE type=text value=30 id=ContentPage_PagingNavi_FLD_PAGESIZE class=input> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGE type=text value=1 id=ContentPage_PagingNavi_FLD_PAGE> <input name=ctl00$ContentPage$PagingNavi$tbNavigateSize type=text value=10 id=ContentPage_PagingNavi_tbNavigateSize> <input name=ctl00$ContentPage$PagingNavi$tbLast type=text value=157 id=ContentPage_PagingNavi_tbLast></div><span id=ContentPage_PagingNavi_lbPage>조회수</span><select name=ctl00$ContentPage$PagingNavi$dlstRecCnt onchange=\"setTimeout(\'__doPostBack(\\\'ctl00$ContentPage$PagingNavi$dlstRecCnt\\\',\\\'\\\')\', 0)\" id=ContentPage_PagingNavi_dlstRecCnt style=\"border: 1px solid #ccc\"><option value=5>5</option><option value=10>10</option><option value=15>15</option><option value=20>20</option><option value=25>25</option><option selected value=30>30</option><option value=MAX>최대</option></select><span id=ContentPage_PagingNavi_lblPageInfo style=\"Z-INDEX: 102\">1/157</span> <span style=\"display: inline\"><span id=ContentPage_PagingNavi_lblTotal>[총 4,692건]</span></span></div><!-- //조회수 및 건수 --></div><div class=col-md-6><!-- Paging Bar --><div class=\"dataTables_paginate paging_simple_numbers\" id=datatable_tabletools_paginate><ul class=\"pagination paging pull-right\"><li class=disabled id=liFirst><a id=ContentPage_PagingNavi_rptPager_lnkFirstPage class=\"spr first\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkFirstPage\',\'\')\"></a></li><li class=disabled id=liPrev><a id=ContentPage_PagingNavi_rptPager_lnkPrevPage class=\"spr prev\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkPrevPage\',\'\')\"></a></li><li class=\"paginate_button active\"><a onclick=\"return false\" id=ContentPage_PagingNavi_rptPager_lnkPage_0 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl01$lnkPage\',\'\')\">1</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_1 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl02$lnkPage\',\'\')\">2</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_2 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl03$lnkPage\',\'\')\">3</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_3 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl04$lnkPage\',\'\')\">4</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_4 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl05$lnkPage\',\'\')\">5</a></li><li class=\"paginate_button next\" id=liNext><a id=ContentPage_PagingNavi_rptPager_lnkNextPage class=\"spr next\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkNextPage\',\'\')\"></a></li><li class=\"paginate_button next\" id=liLast><a id=ContentPage_PagingNavi_rptPager_lnkLastPage class=\"spr last\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkLastPage\',\'\')\"></a></li></ul></div><!-- Paging Bar --></div></div></div><!-- //panel-body --></div></div></div><!-- //row --></div><!-- //상담이력 --><!-- 구매이력 --><div class=tab-content ng-show=visbile2><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group mt-10\"><div class=pull-right><button class=\"btn btn-default ng-binding ng-scope\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> 목록</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>구매이력</strong><div class=pull-right><a data-toggle=collapse href=#collapse1 aria-expanded=true><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><colgroup><col style=width:8%><col style=width:30%;><col style=width:auto></colgroup><thead><tr><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>구매일자<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>제품명<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>수량<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>금액<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>결제수단<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>판매자<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>서포터<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>제품바코드<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>결제승인번호<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>카드번호(4자리)<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>영수증(사진)<span class=\"fa fa-sort\"></span></th></tr></thead><tbody><tr><td>2019-07-19</td><td>제품명제품명제품명</td><td>1</td><td>1,000,000</td><td>신용카드</td><td>김다미</td><td>문정원</td><td>2010122620190203</td><td>5486489351</td><td>7941</td><td>회사원_홍길동님.png</td></tr></tbody></table><div class=row><div class=col-md-6><!-- 조회수 및 건수 --><div class=\"dataTables_info txt_noti\" role=status aria-live=polite><div style=display:none><input name=ctl00$ContentPage$PagingNavi$tbTotal type=text value=4692 id=ContentPage_PagingNavi_tbTotal class=input> <input name=ctl00$ContentPage$PagingNavi$tbCPage type=text value=1 id=ContentPage_PagingNavi_tbCPage> <input name=ctl00$ContentPage$PagingNavi$tbMulti type=text value=0 id=ContentPage_PagingNavi_tbMulti> <input name=ctl00$ContentPage$PagingNavi$tbMultiLast type=text value=15 id=ContentPage_PagingNavi_tbMultiLast> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGESIZE type=text value=30 id=ContentPage_PagingNavi_FLD_PAGESIZE class=input> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGE type=text value=1 id=ContentPage_PagingNavi_FLD_PAGE> <input name=ctl00$ContentPage$PagingNavi$tbNavigateSize type=text value=10 id=ContentPage_PagingNavi_tbNavigateSize> <input name=ctl00$ContentPage$PagingNavi$tbLast type=text value=157 id=ContentPage_PagingNavi_tbLast></div><span id=ContentPage_PagingNavi_lbPage>조회수</span><select name=ctl00$ContentPage$PagingNavi$dlstRecCnt onchange=\"setTimeout(\'__doPostBack(\\\'ctl00$ContentPage$PagingNavi$dlstRecCnt\\\',\\\'\\\')\', 0)\" id=ContentPage_PagingNavi_dlstRecCnt style=\"border: 1px solid #ccc\"><option value=5>5</option><option value=10>10</option><option value=15>15</option><option value=20>20</option><option value=25>25</option><option selected value=30>30</option><option value=MAX>최대</option></select><span id=ContentPage_PagingNavi_lblPageInfo style=\"Z-INDEX: 102\">1/157</span> <span style=\"display: inline\"><span id=ContentPage_PagingNavi_lblTotal>[총 4,692건]</span></span></div><!-- //조회수 및 건수 --></div><div class=col-md-6><!-- Paging Bar --><div class=\"dataTables_paginate paging_simple_numbers\" id=datatable_tabletools_paginate><ul class=\"pagination paging pull-right\"><li class=disabled id=liFirst><a id=ContentPage_PagingNavi_rptPager_lnkFirstPage class=\"spr first\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkFirstPage\',\'\')\"></a></li><li class=disabled id=liPrev><a id=ContentPage_PagingNavi_rptPager_lnkPrevPage class=\"spr prev\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkPrevPage\',\'\')\"></a></li><li class=\"paginate_button active\"><a onclick=\"return false\" id=ContentPage_PagingNavi_rptPager_lnkPage_0 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl01$lnkPage\',\'\')\">1</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_1 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl02$lnkPage\',\'\')\">2</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_2 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl03$lnkPage\',\'\')\">3</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_3 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl04$lnkPage\',\'\')\">4</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_4 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl05$lnkPage\',\'\')\">5</a></li><li class=\"paginate_button next\" id=liNext><a id=ContentPage_PagingNavi_rptPager_lnkNextPage class=\"spr next\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkNextPage\',\'\')\"></a></li><li class=\"paginate_button next\" id=liLast><a id=ContentPage_PagingNavi_rptPager_lnkLastPage class=\"spr last\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkLastPage\',\'\')\"></a></li></ul></div><!-- Paging Bar --></div></div></div><!-- //panel-body --></div></div></div><!-- //row --></div><!-- //구매이력 --><!-- 예약이력 --><div class=tab-content ng-show=visbile3><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group mt-10\"><div class=pull-right><button class=\"btn btn-default ng-binding ng-scope\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> 목록</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>예약이력</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><colgroup><col style=width:auto><col style=width:auto><col style=width:auto><col style=width:auto></colgroup><thead><tr><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>예약일시<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>예약사유<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>관리명<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>횟수<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>담당자<span class=\"fa fa-sort\"></span></th></tr></thead><tbody><tr><td>2019-04-15 15:00</td><td>관리</td><td>관리명</td><td>3회차 (총 10회)</td><td>문정원 관리사</td></tr></tbody></table></div></div><!-- //row --><div class=row><div class=col-md-6><!-- 조회수 및 건수 --><div class=\"dataTables_info txt_noti\" role=status aria-live=polite><div style=display:none><input name=ctl00$ContentPage$PagingNavi$tbTotal type=text value=4692 id=ContentPage_PagingNavi_tbTotal class=input> <input name=ctl00$ContentPage$PagingNavi$tbCPage type=text value=1 id=ContentPage_PagingNavi_tbCPage> <input name=ctl00$ContentPage$PagingNavi$tbMulti type=text value=0 id=ContentPage_PagingNavi_tbMulti> <input name=ctl00$ContentPage$PagingNavi$tbMultiLast type=text value=15 id=ContentPage_PagingNavi_tbMultiLast> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGESIZE type=text value=30 id=ContentPage_PagingNavi_FLD_PAGESIZE class=input> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGE type=text value=1 id=ContentPage_PagingNavi_FLD_PAGE> <input name=ctl00$ContentPage$PagingNavi$tbNavigateSize type=text value=10 id=ContentPage_PagingNavi_tbNavigateSize> <input name=ctl00$ContentPage$PagingNavi$tbLast type=text value=157 id=ContentPage_PagingNavi_tbLast></div><span id=ContentPage_PagingNavi_lbPage>조회수</span><select name=ctl00$ContentPage$PagingNavi$dlstRecCnt onchange=\"setTimeout(\'__doPostBack(\\\'ctl00$ContentPage$PagingNavi$dlstRecCnt\\\',\\\'\\\')\', 0)\" id=ContentPage_PagingNavi_dlstRecCnt style=\"border: 1px solid #ccc\"><option value=5>5</option><option value=10>10</option><option value=15>15</option><option value=20>20</option><option value=25>25</option><option selected value=30>30</option><option value=MAX>최대</option></select><span id=ContentPage_PagingNavi_lblPageInfo style=\"Z-INDEX: 102\">1/157</span> <span style=\"display: inline\"><span id=ContentPage_PagingNavi_lblTotal>[총 4,692건]</span></span></div><!-- //조회수 및 건수 --></div><div class=col-md-6><!-- Paging Bar --><div class=\"dataTables_paginate paging_simple_numbers\" id=datatable_tabletools_paginate><ul class=\"pagination paging pull-right\"><li class=disabled id=liFirst><a id=ContentPage_PagingNavi_rptPager_lnkFirstPage class=\"spr first\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkFirstPage\',\'\')\"></a></li><li class=disabled id=liPrev><a id=ContentPage_PagingNavi_rptPager_lnkPrevPage class=\"spr prev\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkPrevPage\',\'\')\"></a></li><li class=\"paginate_button active\"><a onclick=\"return false\" id=ContentPage_PagingNavi_rptPager_lnkPage_0 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl01$lnkPage\',\'\')\">1</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_1 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl02$lnkPage\',\'\')\">2</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_2 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl03$lnkPage\',\'\')\">3</a></li><li class=\"paginate_button next\" id=liNext><a id=ContentPage_PagingNavi_rptPager_lnkNextPage class=\"spr next\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkNextPage\',\'\')\"></a></li><li class=\"paginate_button next\" id=liLast><a id=ContentPage_PagingNavi_rptPager_lnkLastPage class=\"spr last\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkLastPage\',\'\')\"></a></li></ul></div></div><!-- Paging Bar --></div><!-- //row --></div><!-- //panel-body --></div><!-- //panel --></div><!-- //col --></div><!-- //row --></div><!-- //tab-contents 예약이력 --><!-- SMS이력 --><div class=tab-content ng-show=visbile4><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group mt-10\"><div class=pull-right><button class=\"btn btn-default ng-binding ng-scope\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> 목록</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>SMS이력</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><colgroup><col style=width:auto><col style=width:auto><col style=width:auto><col style=width:auto></colgroup><thead><tr><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>발신일시<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>수신번호<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>발신번호<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>메시지<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>담당자<span class=\"fa fa-sort\"></span></th></tr></thead><tbody><tr><td>2019-04-15 15:00</td><td>010-1234-5678</td><td>02-1234-5678</td><td>고객님께서 문의하신 내용에 대한 답변입니다.</td><td>홍길동</td></tr></tbody></table></div></div><!-- //row --><div class=row><div class=col-md-6><!-- 조회수 및 건수 --><div class=\"dataTables_info txt_noti\" role=status aria-live=polite><div style=display:none><input name=ctl00$ContentPage$PagingNavi$tbTotal type=text value=4692 id=ContentPage_PagingNavi_tbTotal class=input> <input name=ctl00$ContentPage$PagingNavi$tbCPage type=text value=1 id=ContentPage_PagingNavi_tbCPage> <input name=ctl00$ContentPage$PagingNavi$tbMulti type=text value=0 id=ContentPage_PagingNavi_tbMulti> <input name=ctl00$ContentPage$PagingNavi$tbMultiLast type=text value=15 id=ContentPage_PagingNavi_tbMultiLast> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGESIZE type=text value=30 id=ContentPage_PagingNavi_FLD_PAGESIZE class=input> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGE type=text value=1 id=ContentPage_PagingNavi_FLD_PAGE> <input name=ctl00$ContentPage$PagingNavi$tbNavigateSize type=text value=10 id=ContentPage_PagingNavi_tbNavigateSize> <input name=ctl00$ContentPage$PagingNavi$tbLast type=text value=157 id=ContentPage_PagingNavi_tbLast></div><span id=ContentPage_PagingNavi_lbPage>조회수</span><select name=ctl00$ContentPage$PagingNavi$dlstRecCnt onchange=\"setTimeout(\'__doPostBack(\\\'ctl00$ContentPage$PagingNavi$dlstRecCnt\\\',\\\'\\\')\', 0)\" id=ContentPage_PagingNavi_dlstRecCnt style=\"border: 1px solid #ccc\"><option value=5>5</option><option value=10>10</option><option value=15>15</option><option value=20>20</option><option value=25>25</option><option selected value=30>30</option><option value=MAX>최대</option></select><span id=ContentPage_PagingNavi_lblPageInfo style=\"Z-INDEX: 102\">1/157</span> <span style=\"display: inline\"><span id=ContentPage_PagingNavi_lblTotal>[총 4,692건]</span></span></div><!-- //조회수 및 건수 --></div><div class=col-md-6><!-- Paging Bar --><div class=\"dataTables_paginate paging_simple_numbers\" id=datatable_tabletools_paginate><ul class=\"pagination paging pull-right\"><li class=disabled id=liFirst><a id=ContentPage_PagingNavi_rptPager_lnkFirstPage class=\"spr first\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkFirstPage\',\'\')\"></a></li><li class=disabled id=liPrev><a id=ContentPage_PagingNavi_rptPager_lnkPrevPage class=\"spr prev\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkPrevPage\',\'\')\"></a></li><li class=\"paginate_button active\"><a onclick=\"return false\" id=ContentPage_PagingNavi_rptPager_lnkPage_0 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl01$lnkPage\',\'\')\">1</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_1 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl02$lnkPage\',\'\')\">2</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_2 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl03$lnkPage\',\'\')\">3</a></li><li class=\"paginate_button next\" id=liNext><a id=ContentPage_PagingNavi_rptPager_lnkNextPage class=\"spr next\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkNextPage\',\'\')\"></a></li><li class=\"paginate_button next\" id=liLast><a id=ContentPage_PagingNavi_rptPager_lnkLastPage class=\"spr last\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkLastPage\',\'\')\"></a></li></ul></div></div><!-- Paging Bar --></div><!-- //row --></div><!-- //panel-body --></div><!-- //panel --></div><!-- //col --></div><!-- //row --></div><!-- //tab-contents SMS이력 --><!-- 설문이력 --><div class=tab-content ng-show=visbile5><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group mt-10\"><div class=pull-right><button class=\"btn btn-default ng-binding ng-scope\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> 목록</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문이력</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><colgroup><col style=width:auto><col style=width:auto><col style=width:auto><col style=width:auto></colgroup><thead><tr><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>설문자명<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>응답일<span class=\"fa fa-sort\"></span></th><th data-toggle=true class=\"text-center ng-binding\" ng-click=\"vc.tablesort(\'X.TableDesc\')\" role=button tabindex=0>응답점수<span class=\"fa fa-sort\"></span></th></tr></thead><tbody><tr><td>회원가입 테스트</td><td>2019-04-15 15:00</td><td>70</td></tr></tbody></table></div></div><!-- //row --><div class=row><div class=col-md-6><!-- 조회수 및 건수 --><div class=\"dataTables_info txt_noti\" role=status aria-live=polite><div style=display:none><input name=ctl00$ContentPage$PagingNavi$tbTotal type=text value=4692 id=ContentPage_PagingNavi_tbTotal class=input> <input name=ctl00$ContentPage$PagingNavi$tbCPage type=text value=1 id=ContentPage_PagingNavi_tbCPage> <input name=ctl00$ContentPage$PagingNavi$tbMulti type=text value=0 id=ContentPage_PagingNavi_tbMulti> <input name=ctl00$ContentPage$PagingNavi$tbMultiLast type=text value=15 id=ContentPage_PagingNavi_tbMultiLast> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGESIZE type=text value=30 id=ContentPage_PagingNavi_FLD_PAGESIZE class=input> <input name=ctl00$ContentPage$PagingNavi$FLD_PAGE type=text value=1 id=ContentPage_PagingNavi_FLD_PAGE> <input name=ctl00$ContentPage$PagingNavi$tbNavigateSize type=text value=10 id=ContentPage_PagingNavi_tbNavigateSize> <input name=ctl00$ContentPage$PagingNavi$tbLast type=text value=157 id=ContentPage_PagingNavi_tbLast></div><span id=ContentPage_PagingNavi_lbPage>조회수</span><select name=ctl00$ContentPage$PagingNavi$dlstRecCnt onchange=\"setTimeout(\'__doPostBack(\\\'ctl00$ContentPage$PagingNavi$dlstRecCnt\\\',\\\'\\\')\', 0)\" id=ContentPage_PagingNavi_dlstRecCnt style=\"border: 1px solid #ccc\"><option value=5>5</option><option value=10>10</option><option value=15>15</option><option value=20>20</option><option value=25>25</option><option selected value=30>30</option><option value=MAX>최대</option></select><span id=ContentPage_PagingNavi_lblPageInfo style=\"Z-INDEX: 102\">1/157</span> <span style=\"display: inline\"><span id=ContentPage_PagingNavi_lblTotal>[총 4,692건]</span></span></div><!-- //조회수 및 건수 --></div><div class=col-md-6><!-- Paging Bar --><div class=\"dataTables_paginate paging_simple_numbers\" id=datatable_tabletools_paginate><ul class=\"pagination paging pull-right\"><li class=disabled id=liFirst><a id=ContentPage_PagingNavi_rptPager_lnkFirstPage class=\"spr first\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkFirstPage\',\'\')\"></a></li><li class=disabled id=liPrev><a id=ContentPage_PagingNavi_rptPager_lnkPrevPage class=\"spr prev\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl00$lnkPrevPage\',\'\')\"></a></li><li class=\"paginate_button active\"><a onclick=\"return false\" id=ContentPage_PagingNavi_rptPager_lnkPage_0 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl01$lnkPage\',\'\')\">1</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_1 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl02$lnkPage\',\'\')\">2</a></li><li class=paginate_button><a id=ContentPage_PagingNavi_rptPager_lnkPage_2 href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl03$lnkPage\',\'\')\">3</a></li><li class=\"paginate_button next\" id=liNext><a id=ContentPage_PagingNavi_rptPager_lnkNextPage class=\"spr next\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkNextPage\',\'\')\"></a></li><li class=\"paginate_button next\" id=liLast><a id=ContentPage_PagingNavi_rptPager_lnkLastPage class=\"spr last\" href=\"javascript:__doPostBack(\'ctl00$ContentPage$PagingNavi$rptPager$ctl11$lnkLastPage\',\'\')\"></a></li></ul></div></div><!-- Paging Bar --></div><!-- //row --></div><!-- //panel-body --></div><!-- //panel --></div><!-- //col --></div><!-- //row --></div><!-- //tab-contents 설문이력 --></div><!-- //page-contents --></div><!-- //page -->");
$templateCache.put("app/board/h0103-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"H0103EditCtrl as vc\"><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>고객등록</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- /row --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Clause | 회원약관</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /panel header --><!-- panel body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-12><div class=\"bs-callout bs-callout-info\" id=callout-navs-tabs-plugin><div class=member-comment-box><ul class=comment><li>시바산 제품은 시바산 아카데미의 교육을 이수 받은 전문가가 직접 관리/적용 하는 제품입니다. 시바산의 모든 제품은 문제성 피부의 개선을 목적으로 하는 코스메슈티컬 제품으로 안전성이 비교적 낮습니다.</li><li>따라서 본인의 컨디션 및 피부상태, 잘못된 사후 관리 등으로 여러 현상이 발생 할 수 있기 때문에 시바산 트리트먼트를 받는 기간 동안 전문가의 지시사항을 100% 이행하셔야 합니다.</li></ul></div><div class=member-comment-box--red><ul class=comment><li>시바산 트리트먼트는 관리 기간 동안 고영양 현상으로 인한 트러블과 같은 반응이 언제든 발생 할 수 있습니다. 이는 치료를 목적으로 하는 고영양성분의 약용 화장품이 갖는 특징으로 전문가의 적절한 피드백으로 피부의 개선을 보장하는 내용 외 별도의 법적 물적 보상은 없습니다.</li><li>당일 예약 취소, 변경 시 타겟팅 관리 횟수에서 1회가 차감됩니다.</li><li>불가피한 사유로 관리를 받을 수 없을 시 관리권, 제품의 환불 요청 시에는 타겟팅금액/관리횟수를 차감한 금액을 정산합니다.</li></ul></div></div></div></div><div class=row><div class=\"col-sm-12 col-sm-offset-3 col-md-12 col-md-offset-0 col-lg-12\"><div class=\"col-sm-3 col-md-4 col-lg-3 pl-0\"><div class=checkbox><label class=ng-binding><input class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false type=checkbox>위 약관에 동의합니다.</label></div></div><!-- /col --><div class=\"col-sm-2 col-md-4 col-lg-3 pr-0 pl-0\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=2019-00-00> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- /col --><div class=\"col-sm-2 col-md-4 col-lg-3 pr-0\"><div class=\"form-group form-inner-label\"><label class=ng-binding>이름</label><input type=text class=\"form-control form-right ng-pristine ng-valid ng-empty ng-touched\" ng-model=vc.srch.Title aria-invalid=false placeholder=\"\"></div></div><!-- /col --><div class=\"col-sm-2 col-md-4 col-lg-3\"><div class=\"form-group form-inner-label\"><label class=ng-binding>서명</label><input type=text class=\"form-control form-right ng-pristine ng-valid ng-empty ng-touched\" ng-model=vc.srch.Title aria-invalid=false placeholder=\"\"></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=form-group ng-show=vc.srch.editColumns.Contents><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 600px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><!-- /col --></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- row 개인정보 --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step1 | 개인 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>이름</label><input name=\"\" type=text maxlength=25 class=form-control></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input type=radio name=inlineRadioOptions id=inlineRadio1 value=option1 class=mr-5>남</label><label class=radio-inline><input type=radio name=inlineRadioOptions id=inlineRadio2 value=option2>여</label></div></div></div></div><!-- /col --><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>연락처</label><input name=\"\" type=text maxlength=25 class=form-control></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input type=radio name=sms id=option1 value=option1 class=mr-5>SMS 수신동의</label><label class=radio-inline><input type=radio name=sms id=option2 value=option2> SMS 수신거부</label></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input name=ctl00$ContentPage$FLD_ZIPCODE type=text maxlength=7 id=ContentPage_FLD_ZIPCODE class=form-control readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button onclick=\"return fnSearchZipcode(\'FLD_ZIPCODE\', \'FLD_ADDRESS1\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input name=ctl00$ContentPage$FLD_ZIPCODE type=text maxlength=7 id=ContentPage_FLD_ZIPCODE class=form-control></div></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>생년월일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"생년월일 선택\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><!-- /input-group --></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 xs-mb10\"><label class=radio-inline><input type=radio name=sms id=option1 value=option1 class=mr-5>음</label><label class=radio-inline><input type=radio name=sms id=option2 value=option2>양</label></div></div><!-- /col --></div><!-- /row   --></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>등록일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"등록일 선택\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><!-- /input-group --></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-12\"><div class=\"form-group form-inline xs-mb10\"><label>직업</label><input name=\"\" type=text maxlength=25 class=form-control></div></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>방문경로</label><div class=\"inline-box brd1 p-10 bd-rd4\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input type=radio name=inlineRadioOptions>블로그</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input type=radio name=inlineRadioOptions>카페</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input type=radio name=inlineRadioOptions>인스타그램</label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio name=inlineRadioOptions>소개 <input name=\"\" type=text maxlength=25 class=\"form-control wd181\" placeholder=\"소개인 ID\"></label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio name=inlineRadioOptions>기타 <input name=\"\" type=text maxlength=25 class=\"form-control wd181\" placeholder=\"과거 이용 경험있음\"></label></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=sz-custom-select-tenant><section class=tile fullscreen=isFullscreen06><!-- ngIf: header.checkUse --><div class=\"form-group ng-scope\" ng-if=header.checkUse><div class=\"input-group custom-search-form\"><input type=text readonly class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" ng-model=header.TENANTNAME ng-click=header.srchTenantModal(); aria-invalid=false> <input type=hidden ng-model=header.TENANTID autocomplete=off class=\"ng-pristine ng-untouched ng-valid ng-not-empty\" aria-invalid=false> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=header.srchTenantModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=header.eraseTenant();><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- end ngIf: header.checkUse --></section></div></div><!-- /col --></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>특이사항</label><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"ex/ 알러지성 질환, 복용중인 약물, 신체질환\"></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>E-mail</label><input name=\"\" type=text maxlength=25 class=form-control placeholder=adcde@mail.co.kr></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>고객등급</label><select name=ctl00$ContentPage$FLD_BRANCHCODE id=ContentPage_FLD_BRANCHCODE class=form-control><option value=010>A</option><option value=020>B</option><option value=030>C</option></select></div></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>담당자</label><div class=input-group><input name=ctl00$ContentPage$FLD_ZIPCODE type=text maxlength=7 id=ContentPage_FLD_ZIPCODE class=form-control readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button onclick=\"return fnSearchPopup(\'U\',\'FLD_ASSIGNUSERID_\',\'FLD_ASSIGNUSERID\',\'\')\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button onclick=\"fnResetVal(\'FLD_ASSIGNUSERID_\',\'FLD_ASSIGNUSERID\')\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- /row --></div></div><!-- row 과거 관리 및 시술이력 / 홈케어정보--><div class=row><!-- col 과거관리 및 시술 이력--><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step2 | 과거 관리 및 시술 이력</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-12 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>보습, 미백, 여드름,노화관리</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>MTS, 필링</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>레이저 시술</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>보톡스, 필러, 실리프팅</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-12 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=\"checkbox sm-mb0\"><label class=ng-binding><input type=checkbox>지방이식, 보형물 등의 삽입 성형 수술</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=form-group><div class=\"checkbox sm-mb0\"><label class=ng-binding><input type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=\"부작용 상세 내용\"></div></div></div><!-- /col --></div></div><!-- /row --></div><!-- /tile body --></div></div><!-- /col 과거관리 및 시술 이력 --><!-- col 홈케어 정보--><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>홈 케어 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5\"><label class=ng-binding><input type=checkbox>클렌징</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5\"><label class=ng-binding><input type=checkbox>데이</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb5 xs-mt10\"><label class=ng-binding><input type=checkbox>나이트</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb5 xs-mt10\"><label class=ng-binding><input type=checkbox>각질제거</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb0 xs-mt10\"><label class=ng-binding><input type=checkbox>기타(팩)</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0\"><input name=\"\" type=text maxlength=25 class=form-control placeholder=제품명></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=사용방법></div></div></div><!-- /row --><!-- /row --></div><!-- /tile body --></div></div><!-- /col 홈케어 정보--></div><!-- row 과거 관리 및 시술이력 / 홈케어정보--><!-- row 섹터별 특징 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step3 | 섹터별 특징</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 plr-0\"><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Sebum Area / 피지분포 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>White Acne Area / 좁쌀 여드름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Anti Acne Area / 염즘성 여드름</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Pore Area / 모공 확장 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Scar Area / 상처 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Melano Area / 색소 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Dry Area / 건조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Wrinkle Area / 옅은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Deep Wrinkle Area / 깊은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Fush Area / 홍조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input type=checkbox>Telangiectasia Area / 모세혈관 확장</label></div></div><!-- /col --></div></div></div><!-- /tile body --></div><!-- /panel --><!-- row 섹터별 특징 / 얼굴이미지--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>얼굴이미지</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"text-center pt-10 min-h312\"><img src=/assets/images/face-image.png alt=\"\" class=sector-img></div></div></div><!-- /tile body --></div><!-- /panel --></div><!-- /col 섹터별 특징 --><!-- row 현재의피부 상황 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step4 | 현재의 피부 상황 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">- 현재 피부 상태는 어떠한지에 대해서 고객이 직접 이야기하는 내용을 입력</div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의피부 상황 이야기--><!-- row 과거의 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step5 | 과거의 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">-현재피부가 과거에도 그랬는지 과거에는 피부가 어땠는지 입력<br>-과거에 피부가 좋았다면 그때는 어떤 이로운점이 있었는지 입력<br>-과거에 피부가 안좋았다면 그때는 어떤 점이 불편했는지 입력</div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /과거의 이야기--><!-- row 현재의 결심 그리고 미래에 대한 이야기--><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step6 | 현재의 결심 그리고 미래에 대한 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=true></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">-현재의 피부를 만약 고치지 않고 그대로 방치했을때 현재와 미래에 어떤 불이익, 안좋은상황이 올것인지에 대해 발설유도 하며 최악의 상황을 세세히 그려줌<br>-현재 피부는 어떤상태이니 어느정도의 노력과, 시간이 투자된다면, 어떤피부상태가 될것인지에 대해서 예상시켜줌<br>-그리고 피부가 그렇게 좋아졌을때 기분이 어떨것같은지, 현재 어떻게 바뀔것 같은지, 너의 미래는 어떻게 될것같은지에 대해 발설유도.<br></div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의 결심 그리고 미래에 대한 이야기--><!-- row 관리 처방--><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step7 | 관리처방</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-6 col-md-6 col-lg-6 col-xl-6\"><label class=ng-binding>전체품목</label><table class=\"table table-condensed table-typeA mt-5\"><colgroup><col style=\"width: 55%\"><col style=\"width: 35%\"><col style=\"width: 8%\"></colgroup><thead><tr><td>품목명</td><td>금액</td><td>선택</td></tr></thead><tbody><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> 선택</button></td></tr><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> 선택</button></td></tr><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-ok\" aria-hidden=true></span> 선택</button></td></tr></tbody></table></div><!-- /col --><div class=\"col-xs-6 col-md-6 col-lg-6 col-xl-6 mt-10\"><label class=ng-binding>선택 품목</label><table class=\"table table-condensed table-typeA mt-5\"><colgroup><col style=\"width: 45%\"><col style=\"width: 24%\"><col style=\"width: 15%\"><col style=\"width: auto\"></colgroup><thead><tr><td>품목명</td><td>금액</td><td>횟수</td><td>삭제</td></tr></thead><tbody><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=\"\"></td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> 삭제</button></td></tr><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=\"\"></td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> 삭제</button></td></tr><tr><td>여드름 (재생크림 35ml 120,000 / 클렌징파우더 100ml 66,000)</td><td>5회 550,000 / 1회 150,000</td><td><input name=\"\" type=text maxlength=\"\" class=form-control placeholder=\"\"></td><td><button class=\"btn btn-default btn-default-sm ng-binding ng-scope\" activate-button=\"\" ng-click=\"\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> 삭제</button></td></tr></tbody></table></div><!-- /col --></div><!-- /row --></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /관리 처방--><!-- row 복용약--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step8 | 복용약</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=col-sm-12><textarea class=form-control rows=5></textarea></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /복용약--><!-- row 고객관리 사진--><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step9 | 고객관리 사진</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /고객관리 사진--><!-- row 상담--><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile mb-10\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Step10 | 상담</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-12\"><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>상담일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"상담일 선택\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><!-- /input-group --></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>상담내용</label><textarea class=form-control rows=5></textarea></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>관련사진</label><div class=inline-box><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /상담--></div><!-- /pagecontent --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page --><script type=text/javascript>var oEditors = [];\r\n\r\n        var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n        // 추가 글꼴 목록\r\n        //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n        nhn.husky.EZCreator.createInIFrame({\r\n          oAppRef: oEditors,\r\n          elPlaceHolder: \"strHtml\",\r\n          sSkinURI: \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n          htParams: {\r\n            bUseToolbar: true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n            bUseVerticalResizer: false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n            bUseModeChanger: true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n            //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n            //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n            fOnBeforeUnload: function () {\r\n              //alert(\"완료!\");\r\n            },\r\n            I18N_LOCALE: sLang\r\n          }, //boolean\r\n          fOnAppLoad: function () {\r\n            //예제 코드\r\n            //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n          },\r\n          fCreator: \"createSEditor2\"\r\n        });</script></div></div></div>");
$templateCache.put("app/board/h0103-list.html","<div class=\"page page-footable\" ng-controller=\"H0103ListCtrl as vc\"><!-- page header --><div class=\"row rel\"><div class=col-lg-12><div class=page-header>{{ :: \'고객등록\' | translate }}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size=\"40% + 2px\" pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><!-- 검색 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input type=text name=serchWord autocomplete=off placeholder=검색 class=mb-5><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색</div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline xs-mb0\"><label>이름</label><input name=\"\" type=text maxlength=25 class=form-control></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline xs-mb0\"><label>연락처</label><input name=\"\" type=text maxlength=25 class=form-control></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>고객등급</label><select name=ctl00$ContentPage$FLD_BRANCHCODE id=ContentPage_FLD_BRANCHCODE class=form-control><option value=010>A</option><option value=020>B</option><option value=030>C</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline xs-mb10\"><label>방문경로</label><div class=inline-box><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio name=inlineRadioOptions>블로그</label></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio name=inlineRadioOptions>카페</label></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio name=inlineRadioOptions>인스타그램</label></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio name=inlineRadioOptions>블로그</label></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio name=inlineRadioOptions>기타</label></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline sm-mb0\"><label>담당자</label><div class=input-group><input name=ctl00$ContentPage$FLD_ZIPCODE type=text maxlength=7 id=ContentPage_FLD_ZIPCODE class=form-control readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button onclick=\"return fnSearchPopup(\'U\',\'FLD_ASSIGNUSERID_\',\'FLD_ASSIGNUSERID\',\'\')\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button onclick=\"fnResetVal(\'FLD_ASSIGNUSERID_\',\'FLD_ASSIGNUSERID\')\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.getExcel()><i class=\"glyphicon glyphicon-search\"></i> 검색</button> <button class=\"btn btn-default ng-binding\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> 검색값 초기화</button> <button class=\"btn btn-default ng-binding pull-right\" activate-button=\"\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> 창닫기</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /search-detail-wrap --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- /검색영역 --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.h0102\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-repeat=\"liCol in vc.listColumns\" data-toggle=true style=\"width: {{liCol.ListColumnWidth}}\" class=\"text-center none\">{{liCol.ColumnLogicalNm}}</th></tr></thead><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.BbsPostId) style=\"cursor: pointer\" my-directive><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnPhysicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\')}}</td></tr><!-- Header --></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/notice-board-detail.html","<div class=\"page page-footable\" ng-controller=\"NoticeBoardDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.h0102\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Title></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsPostId></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtDate\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\">{{vc.data.EdtDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtUserNm\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.EdtUserNm></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.BoardType></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.ReadCnt></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.PublicYNNm></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.NoticeYNNm></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\" ng-if=\"vc.columnMap[\'Tags\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Tags\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Tags></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 85px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: 50%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span style=text-align:center ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td><span style=text-align:center class=file_size ng-bind=fli.size|filesize></span></td><td><span style=text-align:center class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Contents\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Contents\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" style=\"height:100px; overflow-y: hidden\" ng-bind-html=vc.data.Contents|htmlString></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.COMMENT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><article class=streamline-post ng-repeat=\"li in vc.comment.lists\"><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\">{{li.RegUserNm}} <span><i class=\"fa fa-clock-o mr-5\"></i> {{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span> <span class=\"text-muted pull-right\" ng-hide=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editComment(li.BbsPostCommId)><i class=\"glyphicon glyphicon-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn-min btn btn-default\" ng-click=vc.deleteComment(li)><i class=\"glyphicon glyphicon-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> </span><span class=\"text-muted pull-right\" ng-show=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editCommentAction(li)><i class=\"glyphicon glyphicon-ok\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn-min btn btn-default\" ng-click=vc.editCommentCancel()><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=panel-body ng-hide=\"li.BbsPostCommId == vc.comment.editid\">{{li.Contents}}<table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100% ng-if=li.LogicalFileNm><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"></colgroup><tbody><tr><td><a href=\"\" ng-click=vc.openAttachment(li)>{{li.LogicalFileNm}}</a></td><td align=right><span class=file_size ng-bind=li.FileSize|filesize></span></td></tr></tbody></table></div><div class=panel-body ng-show=\"li.BbsPostCommId == vc.comment.editid\"><textarea class=form-control id=strReply rows=10 style=\"width:100%; height:40px; resize:none\" ng-model=vc.comment.editContents></textarea><span ng-show=\"li.AttachmentId != null && li.AttachmentId != \'\'\"><br>{{li.LogicalFileNm}}&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=vc.setDeleteFileToggle(li)><span ng-show=\"li.delState == \'\' \"><i class=icon-trash>{{ \'Menu.DELETE\' | translate }}</i></span><span ng-show=\"li.delState != \'\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></span></div></div></div></article><div class=streamline-form><form class=\"ng-pristine ng-valid\"><div class=\"form-group form-inner-label\" style=height:40px><div class=input-group><textarea class=form-control id=strReply placeholder=\"댓글 작성...\" rows=10 style=\"width:100%; height:40px; resize:none\" ng-model=vc.srchReply.Contents></textarea><span class=input-group-btn style=\"vertical-align: top\"><button class=\"btn btn-default\" type=button ng-click=vc.saveComment()>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" type=button ng-click=vc.openDilalog()>{{ \'Menu.ATTACHMENT\' | translate }}</button> </span><input id=file-5 style=\"display: none\" class=file type=file data-preview-file-type=any></div></div><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><tbody><tr id=filectl ng-repeat=\"obj in vc.uploadFileListReply\"><td><div ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></div><a href={{obj.link}} target=attach ng-show=obj.isLoaded>{{obj.fileName}}</a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a ng-show=\"obj.delState == \'\'\" href=\"\" ng-click=vc.onDelete(obj)><i class=icon-trash></i></a> <a ng-show=\"obj.delState != \'\' \" href=\"\" ng-click=vc.onDeleteCancel(obj)><i class=icon-cancel-square></i> {{ \'Menu.DELETE\' | translate }}</a></td></tr></tbody></table></form><div>&nbsp;</div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/notice-board-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"NoticeBoardEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.h0102\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsPostId></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | date:\'yyyy-MM-dd h:mm a\':\'UTC\'}}</div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'BoardType\'].CodeList\" code-model=vc.data.BoardType></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.ReadCnt></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=vc.data.PublicYN></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'NoticeYN\'].CodeList\" code-model=vc.data.NoticeYN></common-code-custom></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\" ng-if=\"vc.columnMap[\'Tags\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Tags\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Tags></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div style=\"margin-left: 85px\" id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 85px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=form-group><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div></form><div class=row><!-- 사용자정의 컬럼 등록/수정 --><div class=\"form-group form-inline\"><form class=\"ng-pristine ng-valid\" ng-submit=\"\" name=vc.udcForm novalidate><formly-form model=vc.udcModel fields=vc.udcColumns options=vc.udcOptions form=vc.udcForm></formly-form></form></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/board/notice-board.html","<div class=\"page page-footable\" ng-controller=\"NoticeBoardCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>PR Center 게시판<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size=\"40% + 2px\" pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>{{ :: \'Menu.TITLE\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Contents type=text><label>{{ :: \'Menu.CONTENTS\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.h0102\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-repeat=\"liCol in vc.listColumns\" ng-click=\"vc.tablesort(\'T.\'+liCol.ColumnPhysicalNm)\" data-toggle=true style=\"width: {{liCol.ListColumnWidth}}\" class=\"text-center none\">{{liCol.ColumnLogicalNm}} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.BbsPostId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':vc.keyId == li.BbsPostId}\"><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnPhysicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd h:mm a\')}}</td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.setChangeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/popup-list.html","<div class=\"page page-footable\" ng-controller=\"PopupListCtrl as vc\"><!-- page header --><div class=\"row rel\"><div class=col-lg-12><div class=page-header>팝업 list<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size=\"40% + 2px\" pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=row><!-- 사용자 검색 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>사용자명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.UserNm placeholder=사용자명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 사용자 검색 끝--><!-- 단품(제품)조회 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>단품 조회</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.ProductNm placeholder=품목명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalPrd()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearPrd()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!--단품(제품)조회 끝--><!-- 주소검색 (다음) --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input type=text id=zipCode class=form-control ng-model=vc.srch.ZipCode readonly> {{vc.srch.ZipCode}} <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.getAddressInfo()><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 wd85\"><div class=form-group><input type=text id=addr1 ng-model=vc.srch.Addr1 class=form-control readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input type=text id=addr2 ng-model=vc.srch.Addr2 class=form-control></div></div></div><!-- 주소검색 (다음) --><!-- 관리권 검색 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>관리권명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.CareTktNm placeholder=관리권명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalCareTkt()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearCareTkt()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 관리권 검색 끝--><!-- 고객 검색 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>고객명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.CustNm placeholder=고객명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalCustomer()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearCustomer()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 고객 검색 끝--></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/basic/mng-calendar.html","<div class=\"page page-footable\" ng-controller=\"MngCalendarCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>영업일관리</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.saveData()><i class=\"fa fa-save\"></i> 저장</button></div></div></div><!-- <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"panel panel-default tile\">\r\n          <div class=\"panel-heading tile-header\">\r\n            <strong style=\"letter-spacing: 0.5px;\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong>\r\n          </div>\r\n          <div class=\"panel-body\">\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4\">\r\n                <label>년도</label>\r\n                <div class=\"btn-group\">\r\n                  <select ng-model=\"vc.srch.TargetYear\" ng-options=\"data.TargetYear as data.TargetYear for data in vc.yearsList\" class=\"form-control\" ng-change=\"vc.getList()\">\r\n                  </select>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-10 col-md-10 col-sm-4 col-xs-4\">\r\n                <label>월</label>\r\n                <div class=\"btn-group\">\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'01\'\">1</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'02\'\">2</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'03\'\">3</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'04\'\">4</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'05\'\">5</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'06\'\">6</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'07\'\">7</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'08\'\">8</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'09\'\">9</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'10\'\">10</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'11\'\">11</label>\r\n                  <label class=\"btn btn-sm btn-default\" ng-model=\"TargetMonth\" uib-btn-radio=\"\'12\'\">12</label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div> --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">캘린더</strong></div><div class=panel-body><div class=\"fc-toolbar fc-header-toolbar\"><div class=fc-left><div class=fc-button-group><button type=button class=\"fc-today-button fc-button fc-state-default fc-corner-left fc-state-disabled\">오늘</button> <button type=button class=\"fc-prev-button fc-button fc-state-default\" aria-label=prev style=\"margin-left: -4px\"><span class=\"fc-icon fc-icon-left-single-arrow\"></span></button> <button type=button class=\"fc-next-button fc-button fc-state-default fc-corner-right\" aria-label=next style=\"margin-left: -4px\"><span class=\"fc-icon fc-icon-right-single-arrow\"></span></button></div></div><div class=fc-center><h2>{{vc.yearMonth}}</h2></div></div><div class=mng_cal_tble><table class=\"table table-responsive table_blue reserve\" cellspacing=0 rules=all border=1 id=mytable><colgroup><col width=*><col width=*><col width=*><col width=*><col width=*><col width=*><col width=*></colgroup><thead><tr><th class=\"active text-center th-new\">일</th><th class=\"active text-center th-new\">월</th><th class=\"active text-center th-new\">화</th><th class=\"active text-center th-new\">수</th><th class=\"active text-center th-new\">목</th><th class=\"active text-center th-new\">금</th><th class=\"active text-center th-new\">토</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists2\"><td><span ng-class=vc.getDateClass(li.SunIndex) ng-bind=li.Sun></span><span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.SunIndex != null\" ng-model=vc.data.lists[li.SunIndex].HolidayYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span><span><input type=text class=\"form-control title-form-control\" ng-show=\"li.SunIndex != null\" ng-model=vc.data.lists[li.SunIndex].Description></span></td><td><span ng-class=vc.getDateClass(li.MonIndex) ng-bind=li.Mon></span><span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.MonIndex != null\" ng-model=vc.data.lists[li.MonIndex].HolidayYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span><span><input type=text class=\"form-control title-form-control\" ng-show=\"li.MonIndex != null\" ng-model=vc.data.lists[li.MonIndex].Description></span></td><td><span ng-class=vc.getDateClass(li.TueIndex) ng-bind=li.Tue></span><span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.TueIndex != null\" ng-model=vc.data.lists[li.TueIndex].HolidayYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span><span><input type=text class=\"form-control title-form-control\" ng-show=\"li.TueIndex != null\" ng-model=vc.data.lists[li.TueIndex].Description></span></td><td><span ng-class=vc.getDateClass(li.WedIndex) ng-bind=li.Wed></span><span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.WedIndex != null\" ng-model=vc.data.lists[li.WedIndex].HolidayYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span><span><input type=text class=\"form-control title-form-control\" ng-show=\"li.WedIndex != null\" ng-model=vc.data.lists[li.WedIndex].Description></span></td><td><span ng-class=vc.getDateClass(li.ThuIndex) ng-bind=li.Thu></span><span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.ThuIndex != null\" ng-model=vc.data.lists[li.ThuIndex].HolidayYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span><span><input type=text class=\"form-control title-form-control\" ng-show=\"li.ThuIndex != null\" ng-model=vc.data.lists[li.ThuIndex].Description></span></td><td><span ng-class=vc.getDateClass(li.FriIndex) ng-bind=li.Fri></span><span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.FriIndex != null\" ng-model=vc.data.lists[li.FriIndex].HolidayYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span><span><input type=text class=\"form-control title-form-control\" ng-show=\"li.FriIndex != null\" ng-model=vc.data.lists[li.FriIndex].Description></span></td><td><span ng-class=vc.getDateClass(li.SatIndex) ng-bind=li.Sat></span><span class=pull-right><md-checkbox role=checkbox aria-label={{li.Sun}} ng-show=\"li.SatIndex != null\" ng-model=vc.data.lists[li.SatIndex].HolidayYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></span><span><input type=text class=\"form-control title-form-control\" ng-show=\"li.SatIndex != null\" ng-model=vc.data.lists[li.SatIndex].Description></span></td></tr></tbody></table></div></div></div><!-- // table  --></div></div></div></div>");
$templateCache.put("app/boardmng/boardmng-detail.html","<div class=\"page page-footable\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.moduleType></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableDesc></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><span ng-repeat=\"column in boardMngDetail.metaTable.metaColumns track by $index\"><div class=row><div class=col-lg-3><div class=form-group><label>{{ \'Menu.EM710VC02\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnLogicalNm></div></div></div><div class=col-lg-3><div class=form-group><label ng-show=\"column.customColumnYN == \'Y\'\">{{ \'Menu.EM710VC03\' | translate }} <i class=\"fa fa-question-circle\" ng-click=boardMngDetail.showFieldNameRule() style=color:red></i></label><label style=\"color: red\" ng-show=\"column.customColumnYN == \'N\'\">{{ \'Menu.EM710VC03\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnPhysicalNm></div></div></div><div class=col-lg-2><div class=form-group><label>{{ \'Menu.EM710VC04\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnWidth></div></div></div><div class=col-lg-1><div class=form-group><label>{{ \'Menu.EM710VC05\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnSort></div></div></div><div class=col-lg-1><label>{{ \'Menu.EM710VC06\' | translate }}</label><div class=form-control-static><label><input type=checkbox ng-checked=\"column.listColumnShowYN == \'Y\'\" disabled required></label><label><input type=checkbox ng-checked=\"column.editColumnShowYN == \'Y\'\" disabled required></label></div></div><div class=col-lg-2><div class=pull-right style=\"height: 100%\"><button class=\"btn btn-primary btn-xs mb-10 mr-5\" ng-click=boardMngDetail.showColumnInfo(column)><i class=\"fa fa-sticky-note-o\">{{ \'Menu.EICON_DETAILPROPERTY\' | translate }}</i></button></div></div></div></span><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/boardmng/boardmng-detail_bak.html","<div class=\"page page-footable\"><!-- page header --><div class=row><div class=col-lg-12><h1 class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</h1></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.moduleType></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableDesc></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><span ng-repeat=\"column in boardMngDetail.metaTable.metaColumns track by $index\"><div class=row><div class=col-lg-3><div class=form-group><label>{{ \'Menu.EM710VC02\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnLogicalNm></div></div></div><div class=col-lg-3><div class=form-group><label ng-show=\"column.customColumnYN == \'Y\'\">{{ \'Menu.EM710VC03\' | translate }} <i class=\"fa fa-question-circle\" ng-click=boardMngDetail.showFieldNameRule() style=color:red></i></label><label style=\"color: red\" ng-show=\"column.customColumnYN == \'N\'\">{{ \'Menu.EM710VC03\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnPhysicalNm></div></div></div><div class=col-lg-2><div class=form-group><label>{{ \'Menu.EM710VC04\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnWidth></div></div></div><div class=col-lg-1><div class=form-group><label>{{ \'Menu.EM710VC05\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnSort></div></div></div><div class=col-lg-1><label>{{ \'Menu.EM710VC06\' | translate }}</label><div class=form-control-static><label><input type=checkbox ng-checked=\"column.listColumnShowYN == \'Y\'\" disabled required></label><label><input type=checkbox ng-checked=\"column.editColumnShowYN == \'Y\'\" disabled required></label></div></div><div class=col-lg-2><div class=pull-right style=\"height: 100%\"><button class=\"btn btn-primary btn-xs mb-10 mr-5\" ng-click=boardMngDetail.showColumnInfo(column)><i class=\"fa fa-sticky-note-o\">{{ \'Menu.EICON_DETAILPROPERTY\' | translate }}</i></button></div></div></div></span><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/boardmng/boardmng-edit.html","<div class=\"page page-footable\" id=toastContainer ng-controller=\"BoardMngEditCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.EDIT\' | translate }}</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><form name=metaTable><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button type=button class=\"btn btn-default\" ui-sref=\"app.boardmng.list({srch:\'{{vc.makeSrch()}}\'})\" ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\" metaTable.$valid && vc.saveMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group ng-if=\"vc.currentActionView==\'modify\'\"><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=vc.metaTable.tableNm></div></div><div class=form-group ng-if=\"vc.currentActionView==\'add\'\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><input class=\"form-control pre\" name=tableNm ng-disabled=\"$root.gVariable.srchTenantId != 0\" ng-maxlength=100 ng-minlength=3 ng-model=vc.metaTable.tableNm ng-model-options=\"{ updateOn: \'blur\' }\" ng-required=true type=text><div ng-show=metaTable.tableNm.$error.minlength class=\"col-xs-12 col-md-12 alert alert-warning\" role=alert>{{ \'Menu.EM710VA01\' | translate }}</div><div ng-show=metaTable.tableNm.$error.maxlength class=\"col-xs-12 col-md-12 alert alert-warning\" role=alert>{{ \'Menu.EM710VA02\' | translate }}</div><div ng-show=\"vc.usingTableNm.length > 0\" class=\"col-xs-12 col-md-12 alert alert-warning\" role=alert>{{vc.usingTableNm}} {{ \'Menu.EM710VA03\' | translate }}</div></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label style=\"color: red\">*</label><label>모듈유형</label><common-code-custom code-list=vc.moduleTypeList code-model=vc.metaTable.moduleType ng-disabled=\"$root.gVariable.srchTenantId != 0\" ng-required=true></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.EM710DC03\' | translate }}</label><textarea class=form-control row=3 cols=50 ng-model=vc.metaTable.tableDesc ng-disabled=\"$root.gVariable.srchTenantId != 0\"></textarea></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.openSortMetaColumn() ng-if=\"vc.metaTable.metaColumns.length > 0\" type=button><i class=\"fa fa-edit\"></i> 컬럼 표시순서 정렬</button></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><div class=pull-right style=\"height: 100%\"><div class=form-group><md-checkbox md-no-ink=\"\" ng-if=\"$root.gVariable.srchTenantId != \'0\'\" ng-change=vc.ChangeCustomColumn() ng-model=vc.srch.srchCustomColumns ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox style=\"margin-right: 30px\">{{ \'Menu.CUSTOMCOLUMN\' | translate }}</md-checkbox><button type=button class=\"btn btn-default\" ng-if=\"vc.srch.srchCustomColumns == \'Y\'\" ng-click=vc.addDelCustomColumns()><i class=\"fa fa-table\"></i> 커스텀컬럼 {{vc.metaTable.metaColumns.length == 0 ? \'추가\' : \'삭제\'}}</button> <button type=button class=\"btn btn-default\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\" ng-disabled=\"metaTable.tableNm.$invalid && vc.currentActionView ==\'add\'\" ng-click=vc.getTableColumns()><i class=\"fa fa-table\"></i> 기본 컬럼 조회</button> <button type=button class=\"btn btn-default\" ng-click=\"vc.addColumn(\'base\')\"><i class=\"fa fa-table\"></i> 기본 컬럼 추가</button> <button class=\"btn btn-default\" ng-click=\"vc.addColumn(\'add\')\" type=button><i class=\"fa fa-edit\"></i> 사용자정의 컬럼 추가</button> <button class=\"btn btn-primary\" ng-click=\"metaTable.$valid && vc.saveMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><!-- Header --><thead><tr><th data-toggle=true class=text-center><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC02\' | translate }}</label></th><th data-toggle=true class=text-center><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC03\' | translate }} <i class=\"fa fa-question-circle\" ng-click=vc.showFieldNameRule() style=color:red></i></label></th><th data-toggle=true class=text-center><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC04\' | translate }}</label></th><th data-toggle=true class=text-center><label>{{ \'Menu.EM710VC05\' | translate }}</label></th><th data-toggle=true class=text-center><label>{{ \'Menu.EM710VC06\' | translate }}</label></th><th data-toggle=true class=text-center><label>{{ \'Menu.EM710VT08\' | translate }}</label></th><th data-toggle=true class=text-center><label></label></th></tr></thead><tbody><tr ng-repeat=\"column in vc.metaTable.metaColumns track by $index\"><td><input type=text class=form-control ng-model=column.columnLogicalNm ng-change=vc.checkStateChange(column) name=columnLogicalNm required></td><td><common-code ng-if=\"column.customColumnYN == \'Y\'\" param-data=column.commoncodeDATA callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" required></common-code><input type=text ng-if=\"column.customColumnYN == \'N\'\" class=form-control ng-model=column.columnPhysicalNm ng-change=vc.checkStateChange(column) ng-readonly=\"column.customColumnYN == \'N\' && $root.gVariable.SysAdminYN != \'Y\'\"></td><td><input type=text class=form-control ng-model=column.listColumnWidth ng-change=vc.checkStateChange(column) required></td><td><input type=text class=form-control ng-model=column.listColumnSort ng-change=vc.checkStateChange(column) required></td><td><label><input type=checkbox ng-checked=\"column.listColumnShowYN == \'Y\'\" ng-model=column.listColumnShowYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> <span ng-if=\"column.listColumnShowLevel == \'showlevel1\'\">①항상</span> <span ng-if=\"column.listColumnShowLevel == \'showlevel2\'\">②768 이상</span> <span ng-if=\"column.listColumnShowLevel == \'showlevel3\'\">③992 이상</span> <span ng-if=\"column.listColumnShowLevel == \'showlevel0\'\">검색만표시</span></label></td><td><input type=checkbox ng-checked=\"column.editColumnShowYN == \'Y\'\" ng-model=column.editColumnShowYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td><button type=button class=\"btn btn-danger btn-min\" ng-click=vc.deleteColumn(column)><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=button class=\"btn btn-success btn-min\" ng-click=vc.openAttrSetup(column)><i class=\"fa fa-edit\">{{ \'Menu.EICON_DETAILEDIT\' | translate }}</i></button></td></tr></tbody></table><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group btn-bottom\"><div class=pull-right><button type=button class=\"btn btn-default\" ui-sref=\"app.boardmng.list({srch:\'{{vc.makeSrch()}}\'})\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\"metaTable.$valid && vc.saveMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/boardmng/boardmng-list.html","<div class=\"page page-footable\" ng-controller=\"BoardMngListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.EM700\' | translate }}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"물리 테이블/컬럼명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.tabelNm type=text><label>물리 테이블명</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.columnLogicalNm type=text><label>물리 컬럼명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goDetail(\'\')\" ng-if=\"$root.gVariable.srchTenantId == 0\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong>{{ \'Menu.LIST\' | translate }}</strong><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=dataloader ng-show=boardMngSave.dataloader></div><!-- Search Result --><table id=searchTextResults data-filter=#filter data-page-size={{vc.viewSizePerPage}} class=\"table table-striped table-bordered table-hover data_table table-custom\"><!-- Header --><thead><tr><th class=text-center data-toggle=true ng-click=\"vc.tablesort(\'X.TableNm\')\">물리 테이블명<span class=\"{{vc.sortClass(\'X.TableNm\')}}\"></span></th><th class=text-center data-toggle=true ng-click=\"vc.tablesort(\'X.TableDesc\')\">테이블 설명<span class=\"{{vc.sortClass(\'X.TableDesc\')}}\"></span></th></tr></thead><tbody><tr ng-repeat=\"li in vc.boardList\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.tableNm) ng-class=\"{\'bg-lightyellow\':selectedRow == li.tableNm}\"><!-- Result Items --><td class=text-left><span ng-bind=li.tableNm></span></td><td class=text-left><span ng-bind=li.tableDesc></span></td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.viewSizePerPageList\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalCount ng-model=vc.currentPage total-items=vc.totalCount previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/boardmng/modal-attr-detail.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"modal-title page-header\">{{ modalCtrl.title | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><form name=metaColumn novalidate><div class=row><div class=col-lg-4><div class=form-group><label>컬럼표시섹션</label><input type=text class=\"form-control pre\" ng-model=modalCtrl.column.columnSection></div></div><div class=col-lg-4><div class=form-group><label><input type=checkbox ng-checked-=\"modalCtrl.column.customColumnYN == \'Y\'\" ng-model=modalCtrl.column.customColumnYN ng-true-value=\"\'Y\'\" disabled ng-false-value=\"\'N\'\"> 사용자정의 컬럼 여부</label><label><input type=checkbox ng-checked-=\"modalCtrl.column.KeyColumnYN == \'Y\'\" ng-model=modalCtrl.column.keyColumnYN ng-true-value=\"\'Y\'\" disabled ng-false-value=\"\'N\'\"> 정렬가능 여부</label></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>물리컬럼이름</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnPhysicalNm></div></div></div><div class=col-lg-4><div class=form-group><label>물리컬럼데이터크기</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnPhysicalDataSize></div></div></div><div class=col-lg-4><div class=form-group><label>*물리컬럼데이터유형</label><select class=form-control ng-model=modalCtrl.selectedPhysicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\" disabled></select></div></div><div class=col-lg-4><div class=form-group><label>*논리컬럼데이터유형</label><select class=form-control ng-model=modalCtrl.selectedLogicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\" disabled></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 텍스트 정렬</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnTextAlign disabled></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>목록화면 표시여부</label><select class=form-control ng-model=modalCtrl.column.listColumnShowYN disabled><option value=Y>표시</option><option value=N>표시안함</option></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 표시 Level</label><select class=form-control ng-model=modalCtrl.column.listColumnShowLevel disabled><option value=1>1</option><option value=2>2</option><option value=3>3</option></select></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 폭</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.editColumnWidth></div></div></div><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 높이</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.editColumnHeight></div></div></div><div class=col-lg-4><div class=form-group><label>상세화면 표시여부</label><select class=form-control ng-model=modalCtrl.column.editColumnShowYN disabled><option value=Y>표시</option><option value=N>표시안함</option></select></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>속성 설명</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnDesc></div></div></div></div></div></form></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default\" ng-click=modalCtrl.onCancelClick()><i class=\"fa fa-close\"></i> 닫기</button></div></div>");
$templateCache.put("app/boardmng/modal-attr-setup.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"modal-title page-header\">{{ modalCtrl.title | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><form name=metaColumn novalidate><div class=row><div class=col-lg-4><div class=form-group><label>표시섹션</label><input type=text class=\"form-control pre\" ng-model=modalCtrl.column.columnSection></div></div><div class=col-lg-4><div class=form-group><label><input type=checkbox ng-checked-=\"modalCtrl.column.customColumnYN == \'Y\'\" ng-model=modalCtrl.column.customColumnYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> 사용자정의 컬럼 여부</label><label><input type=checkbox ng-checked-=\"modalCtrl.column.KeyColumnYN == \'Y\'\" ng-model=modalCtrl.column.keyColumnYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> 정렬가능 여부</label></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>물리이름</label><input type=text class=form-control ng-model=modalCtrl.column.columnPhysicalNm required></div></div><div class=col-lg-4><div class=form-group><label ng-show=modalCtrl.isSizableData() style=\"color: red\">*</label><label>물리데이터크기</label><input type=number class=\"form-control pre\" ng-value=0 ng-model=modalCtrl.column.columnPhysicalDataSize ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-required=modalCtrl.isSizableData()></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>물리데이터유형</label><select class=form-control ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.selectedPhysicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\"></select></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>물리참조이름</label><input type=text class=form-control ng-model=modalCtrl.column.columnPhysicalAsNm></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>논리데이터유형</label><select class=form-control ng-model=modalCtrl.selectedLogicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\"></select></div></div><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 높이</label><input type=text class=\"form-control pre\" ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.column.editColumnHeight></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>상세화면 폭</label><input type=text class=\"form-control pre\" ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.column.editColumnWidth></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>목록표시 방법</label><select class=form-control ng-model=modalCtrl.column.listColumnShowLevel><option value=showlevel1>①항상 표시</option><option value=showlevel2>②768 이상일때 표시</option><option value=showlevel3>③992 이상일때 표시</option><option value=showlevel0>검색영역에만 표시</option></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 텍스트 정렬</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnTextAlign required></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>목록화면 폭</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnWidth required></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>공통코드용 코드타입</label><input type=text class=form-control ng-model=modalCtrl.column.codeType></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>속성 설명</label><textarea class=form-control row=3 cols=50 ng-model=modalCtrl.column.columnDesc></textarea></div></div></div></form></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary\" ng-click=modalCtrl.onAddClick()><i class=\"fa fa-save\"></i> {{ \'Menu.APPLY\' | translate }}</button> <button class=\"btn btn-default\" ng-click=modalCtrl.onCancelClick()><i class=\"fa fa-close\"></i> {{ \'Menu.CLOSE\' | translate}}</button></div></div>");
$templateCache.put("app/boardmng/modal_attr_fieldnamerule.html","<div class=modal-header><h3 class=\"modal-title custom-font\">필드이름 규칙</h3></div><div class=modal-body><div class=tile><span ng-if=doing_async>...loading...</span><div class=\"b-a bg-default lter\"><ol><li>Varchar형 : ExtVarchar01 ~ ExtVarchar10</li><li>Integer형 : ExtInt01 ~ ExtInt10</li><li>Datetime형 : ExtDate01 ~ ExtDate10</li></ol></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=reorderCtrl.onClose()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div>");
$templateCache.put("app/boardmng/modal_attr_reorder.html","<style>.btn_order_box {\r\n  position: relative;\r\n  height: 17px;\r\n  width: 100%;\r\n  padding: 0 30px;\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.btn_order {\r\n  position: absolute;\r\n  height: 17px;\r\n  width: 80px;\r\n  right: 30px;\r\n  z-index: 9;\r\n}\r\n\r\n.btn_order .change_order {\r\n  width: 17px;\r\n  height: 17px;\r\n  display: block;\r\n  float: left;\r\n  background: url(\'/assets/images/icon/btn_change_order.png\') 0 0 no-repeat;\r\n  font-size: 0;\r\n  margin-right: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_first {\r\n  background-position: 0 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_pre {\r\n  background-position: 0 -17px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_next {\r\n  background-position: 0 -34px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_last {\r\n  background-position: 0 -51px;\r\n  cursor: pointer;\r\n}\r\n\r\nli.selected {\r\n  background: #f5f6f7;\r\n}</style><div class=modal-content><div class=\"modal-header ng-scope\"><h1 class=\"modal-title page-header\" ng-bind=reorderCtrl.title></h1></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"card_cont list_area\"><div class=\"b-a bg-default lter\"><ul><li data-ng-repeat=\"row in reorderCtrl.objModel\" ng-class=\"{selected:(reorderCtrl.selectedIdx == $index)}\" ng-click=reorderCtrl.onSelect($index)><span ng-bind=row.columnLogicalNm ng-if=\"row.dirty!=\'D\'\"></span>(<span ng-bind=row.columnPhysicalNm ng-if=\"row.dirty!=\'D\'\"></span>)</li></ul></div></div></div></div><div class=row><div class=col-lg-12><div class=btn_order_box><div class=btn_order><span class=\"change_order go_first\" ng-click=reorderCtrl.moveTop() translate>BTN.PAGINATION.FIRST</span> <span class=\"change_order go_pre\" ng-click=reorderCtrl.moveUp() translate>BTN.PAGINATION.PREV</span> <span class=\"change_order go_next\" ng-click=reorderCtrl.moveDown() translate>BTN.PAGINATION.NEXT</span> <span class=\"change_order go_last\" ng-click=reorderCtrl.moveBottom() translate>BTN.PAGINATION.LAST</span></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default\" ng-click=reorderCtrl.onClose()><i class=\"fa fa-shield\"></i> {{ \'Menu.CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=reorderCtrl.onSave()><i class=\"fa fa-save\"></i> {{ \'Menu.APPLY\' | translate }}</button></div></div>");
$templateCache.put("app/campaign/group-list.html","<style>md-sidenav { max-width: 100% !Important; }</style><div class=\"page page-footable\" ng-controller=\"GroupListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>그룹발송</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row style=padding-top:8px><div class=col-lg-3><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>그룹트리</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><md-sidenav md-component-id=left md-is-locked-open=true style=min-height:600px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">그룹목록</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.GrpNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav></div></div></div><div class=col-lg-9><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>그룹정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-default\" activate-button ng-click=vc.resetList()><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETLIST\' | translate }}</button> <button type=button class=\"btn btn-primary\" activate-button ng-click=try_adding_a_branch() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=submit class=\"btn btn-primary\" activate-button ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\" ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 그룹입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div><div class=col-lg-4><div class=\"form-group form-inline\"><label>그룹명</label><input type=text class=form-control ng-model=vc.data.GrpNm ng-change=vc.onChangeGrpNm() ng-required=true> <input type=hidden class=form-control ng-model=vc.data.GrpId> <input type=hidden class=form-control ng-model=vc.data.GrpLevel> <input type=hidden class=form-control ng-model=vc.data.ParentGrpId></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>정렬순서</label><input type=text class=form-control ng-model=vc.data.SortSeq ng-change=vc.onChanged()></div></div></div></form></div></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>그룹고객 목록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:10px><button class=\"btn btn-default\" activate-button ng-click=vc.addSmsModal() ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null && vc.grpcustTotalItems > 0\"><i class=\"fa fa-mobile-phone\"></i> SMS발송</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.addGrpcustAll() ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-edit\"></i> 전체고객추가</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.srchGrpcustModal() ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-edit\"></i> 고객추가</button> <button class=\"btn btn-danger\" activate-button ng-click=\"vc.deleteGrpcust(\'\')\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-trash-o\"></i> 선택고객삭제</button> <button class=\"btn btn-danger\" activate-button ng-click=\"vc.deleteGrpcust(\'ALL\')\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-trash-o\"></i> 전체고객삭제</button></div></div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T2.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.grpcustListColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T2.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.grpcustTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.grpcustListColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.grpcustLists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.grpcustListColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.grpcustTotalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.grpcustTotalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div></div></div><!-- pagecontent --></div>");
$templateCache.put("app/campaign/happycall-edit.html","<div class=\"page page-footable\" ng-controller=\"HappycallEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>해피콜 자동등록</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>도움말</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12>발송내용에 아래의 코드를 입력하면 실제 발송내용은 코드에 해당하는 고객 데이터로 치환됩니다.<br><strong>{고객명}</strong>, <strong>{예약일시}</strong></div></div></div></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>방문전 SMS발송 (예약시간 내용 확인)</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=\"form-control form-right\" maxlength=13 numbers-hyphen ng-model=vc.data.SendTelno_10></div></div><div class=col-lg-6><div class=form-group><input type=checkbox ng-model=vc.data.UseYN_10 ng-checked=\"vc.data.UseYN_10 ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label class=ng-binding>사용함</label></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발송시간</label><select ng-model=vc.data.SendTime_10 ng-options=\"data.value as data.text for data in vc.sendTimeList\" class=form-control></select></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>발송내용</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.SendMessage_10 ng-change=\"vc.chkSendMessage(\'10\')\"></textarea><div class=text-right>{{vc.SendMessageBytes_10}} / 90 bytes</div></div></div></div></div></div></div><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>방문후 SMS발송 (만족, 불만, 주의사항 확인)</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=\"form-control form-right\" maxlength=13 numbers-hyphen ng-model=vc.data.SendTelno_20></div></div><div class=col-lg-6><div class=form-group><input type=checkbox ng-model=vc.data.UseYN_20 ng-checked=\"vc.data.UseYN_20 ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label class=ng-binding>사용함</label></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발송시간</label><select ng-model=vc.data.SendTime_20 ng-options=\"data.value as data.text for data in vc.sendTimeList\" class=form-control></select></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>발송내용</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.SendMessage_20 ng-change=\"vc.chkSendMessage(\'20\')\"></textarea><div class=text-right>{{vc.SendMessageBytes_20}} / 90 bytes</div></div></div></div></div></div></div></div><div class=row><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>방문 3일 후 SMS발송 (관리 후 발생할 수 있는 문제, 홈 케어 여부 확인)</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=\"form-control form-right\" maxlength=13 numbers-hyphen ng-model=vc.data.SendTelno_30></div></div><div class=col-lg-6><div class=form-group><input type=checkbox ng-model=vc.data.UseYN_30 ng-checked=\"vc.data.UseYN_30 ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label class=ng-binding>사용함</label></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발송시간</label><select ng-model=vc.data.SendTime_30 ng-options=\"data.value as data.text for data in vc.sendTimeList\" class=form-control></select></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>발송내용</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.SendMessage_30 ng-change=\"vc.chkSendMessage(\'30\')\"></textarea><div class=text-right>{{vc.SendMessageBytes_30}} / 90 bytes</div></div></div></div></div></div></div><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>방문 7일 후 SMS발송 (홈 케어 여부 확인, 다음 방문일 인지)</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=\"form-control form-right\" maxlength=13 numbers-hyphen ng-model=vc.data.SendTelno_40></div></div><div class=col-lg-6><div class=form-group><input type=checkbox ng-model=vc.data.UseYN_40 ng-checked=\"vc.data.UseYN_40 ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label class=ng-binding>사용함</label></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발송시간</label><select ng-model=vc.data.SendTime_40 ng-options=\"data.value as data.text for data in vc.sendTimeList\" class=form-control></select></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>발송내용</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.SendMessage_40 ng-change=\"vc.chkSendMessage(\'40\')\"></textarea><div class=text-right>{{vc.SendMessageBytes_40}} / 90 bytes</div></div></div></div></div></div></div></div><div class=row><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>리스크 고객 SMS발송 (2주, 케어 문자)</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=\"form-control form-right\" maxlength=13 numbers-hyphen ng-model=vc.data.SendTelno_50></div></div><div class=col-lg-6><div class=form-group><input type=checkbox ng-model=vc.data.UseYN_50 ng-checked=\"vc.data.UseYN_50 ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label class=ng-binding>사용함</label></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발송시간</label><select ng-model=vc.data.SendTime_50 ng-options=\"data.value as data.text for data in vc.sendTimeList\" class=form-control></select></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>발송내용</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.SendMessage_50 ng-change=\"vc.chkSendMessage(\'50\')\"></textarea><div class=text-right>{{vc.SendMessageBytes_50}} / 90 bytes</div></div></div></div></div></div></div><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>리스크 고객 SMS발송 (4주, 케어 문자)</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=\"form-control form-right\" maxlength=13 numbers-hyphen ng-model=vc.data.SendTelno_60></div></div><div class=col-lg-6><div class=form-group><input type=checkbox ng-model=vc.data.UseYN_60 ng-checked=\"vc.data.UseYN_60 ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"><label class=ng-binding>사용함</label></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발송시간</label><select ng-model=vc.data.SendTime_60 ng-options=\"data.value as data.text for data in vc.sendTimeList\" class=form-control></select></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>발송내용</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.SendMessage_60 ng-change=\"vc.chkSendMessage(\'60\')\"></textarea><div class=text-right>{{vc.SendMessageBytes_60}} / 90 bytes</div></div></div></div></div></div></div></div></form><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div></div><!-- /page content -->");
$templateCache.put("app/campaign/monitoring-detail.html","<div class=\"page page-footable\" ng-controller=\"MonitoringDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>해피콜 모니터링 조회</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button><!--\r\n          <button class=\"btn btn-default\" ng-click=\"vc.goEdit()\">\r\n            <i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}\r\n          </button>\r\n          <button class=\"btn btn-danger\" ng-click=\"vc.setDelData()\">\r\n            <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n          </button>\r\n          --></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>상세정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-12><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" style=width:10%>발송일시</th><th class=\"text-center none\" style=width:10%>발신자번호</th><th class=\"text-center none\" style=width:10%>수신자번호</th><th class=\"text-center none\" style=width:10%>고객명</th><th class=\"text-center none\">내용</th><th class=\"text-center none\" style=width:10%>상태</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=6>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle>{{li.SendDate | date:\'yyyy-MM-dd HH:mm:ss\':\'UTC\'}}</td><td class=text-center style=vertical-align:middle>{{li.SendTelno}}</td><td class=text-center style=vertical-align:middle>{{li.Mobile}}</td><td class=text-center style=vertical-align:middle>{{li.CustNm}}</td><td class=text-center style=vertical-align:middle>{{li.SendMessage}}</td><td class=text-center style=vertical-align:middle>{{li.SendResult_}}</td></tr></table><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></form></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button><!--\r\n          <button class=\"btn btn-outline btn-default\" ng-click=\"vc.goEdit()\">\r\n            <i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}\r\n          </button>\r\n          <button class=\"btn btn-danger\" ng-click=\"vc.deleteData()\">\r\n            <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n          </button>\r\n          --></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/campaign/monitoring-list.html","<div class=\"page page-footable\" ng-controller=\"MonitoringListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>해피콜 모니터링<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-lg-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SendDateFrom placeholder=\"발송시작일 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색</div><div class=panel-body><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'SendDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SendDateFrom = (vc.SendDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.SendDateFrom ng-required=false placeholder=발송시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-12 ng-if=\"vc.columnMap[\'SendDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SendDateTo = (vc.SendDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.SendDateTo ng-required=false placeholder=발송종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-12><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div></div></div></div><!--\r\n              <div class=\"col-lg-6\">\r\n                <div class=\"pull-right\">\r\n                  <button class=\"btn btn-default\" ng-click=\"vc.getExcelFile()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}\r\n                  </button>\r\n                  <button class=\"btn btn-primary\" ng-click=\"vc.goAdd()\">\r\n                  <i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}\r\n                  </button>\r\n                  <button class=\"btn btn-danger\" ng-click=\"vc.deleteList()\">\r\n                  <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n                  </button>\r\n                </div>\r\n              </div>\r\n              --></div><!-- /검색영역 --></form><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-body><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!--\r\n                      <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"></th>\r\n                    --><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T2.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T2.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':(sendDate == li.SendDate && sendType == li.SendType && sendDtType == li.SendDtType)}\"><!-- Result Items --><!--\r\n                      <td class=\"text-center\" style=\"vertical-align:middle;\"><input type=\"checkbox\" ng-model=\"li.chkRow\" ng-change=\"chkRowChg()\">\r\n                        --><td class={{liCol.ListColumnTextAlign}} ng-click=\"vc.goDetail(li.SendDate, li.SendType, li.SendDtType)\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/campaign/single-edit.html","<!-- Html Editor --><!--\r\n<script type=\"text/javascript\" src=\"/assets/app/SE2/js/HuskyEZCreator.js\" charset=\"utf-8\"></script>\r\n--><div class=\"page page-footable\" ng-controller=\"SingleEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>개별발송</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> 발송</button></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>발송정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-6><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=\"form-control form-right\" maxlength=13 numbers-hyphen ng-model=vc.data.SendTelno></div></div><div class=col-lg-6><div class=form-group><input type=radio ng-model=vc.data.SendDateType value=100 ng-checked=true style=margin-top:-3px> 즉시발송 <input type=radio ng-model=vc.data.SendDateType value=200 style=margin-top:-3px> 예약발송</div></div></div><div class=row ng-show=\"vc.data.SendDateType == \'200\'\"><div class=col-lg-6><div class=\"form-group form-inline\"><label>발송일시</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SendDt = (vc.SendDt | date: \'yyyy-MM-dd\')\" ng-model=vc.SendDt ng-required=false placeholder=발송일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-3><div class=form-group><select ng-model=vc.data.SendHour ng-options=\"data.time as data.time for data in vc.sendHourList\" class=form-control></select></div></div><div class=col-lg-3><div class=form-group><select ng-model=vc.data.SendMin ng-options=\"data.time as data.time for data in vc.sendMinList\" class=form-control></select></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>발송내용</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.SendMessage ng-change=\"vc.chkSendMessage(\'10\')\"></textarea><div class=text-right style=padding-top:10px>{{vc.SendMessageBytes}} / 90 bytes <button class=\"btn btn-default\" ng-click=\"vc.srchFreModal(\'\')\" type=button>자주 사용하는 메세지 저장</button></div></div></div></div></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\">자주 사용하는 메세지</th><th class=\"text-center none\" style=width:10%>수정</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.qstTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan=2>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.freLists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle ng-click=vc.setFreMessage(li.Message)>{{li.Subject}}</td><td class=text-center style=vertical-align:middle><button class=\"btn btn-default\" ng-click=vc.srchFreModal(li.KeyId)>수정</button></td></tr></table></div></div></form></div></div></div></div><div class=row><div class=\"col-lg-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> 발송</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/campaign/single-list.html","<div class=\"page page-footable\" ng-controller=\"SingleListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>개별발송<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div class=pane-root fa-pane=\"\"><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.srchKeyword placeholder=\"고객명/연락처 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색</div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CustNm type=text><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustGrade\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CustGrade\'].CodeList\" code-model=vc.srch.CustGrade></common-code-custom><label>{{vc.columnMap[\'CustGrade\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'VisitPath\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'VisitPath\'].CodeList\" code-model=vc.srch.VisitPath></common-code-custom><label>{{vc.columnMap[\'VisitPath\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Manager\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><!--\r\n                  <button class=\"btn btn-primary\" ng-click=\"vc.goAdd()\">\r\n                    <i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}\r\n                  </button>\r\n                  <button class=\"btn btn-danger\" ng-click=\"vc.setDelList()\">\r\n                    <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n                  </button>\r\n                  --></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!--\r\n                      <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input ng-change=\"chkHeadChg()\"\r\n                                                                                               ng-model=\"vc.chkHead\"\r\n                                                                                               type=\"checkbox\"></th>\r\n                                                                                               --><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><!--\r\n                      <td class=\"text-center\" style=\"vertical-align:middle;\"><input ng-change=\"chkRowChg()\" ng-model=\"li.chkRow\" type=\"checkbox\">\r\n                      --><td class={{liCol.ListColumnTextAlign}} ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul boundary-links=true data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" items-per-page=vc.viewSize last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" max-size=vc.maxSize name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage num-pages=vc.numPages previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" rotate=false template-url=app/template/pagination.html total-items=vc.totalItems uib-pagination></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane ng-if=\"vc.layout != \'N\'\" pane-min=600px style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img alt=\"\" src=assets/images/icon-write-line.svg style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/chart-list.html","<!-- <style>\r\n.card-container .card {\r\n  min-height: 90px;\r\n}\r\n\r\n.pageheader {\r\n  margin: 0px;\r\n  padding: 0px;\r\n}\r\n\r\n.dashboard-top .banner {\r\n  background-color: #00b0f0;\r\n  background-image: url(\'/images/dashboard/dash-image.png\');\r\n  width: 100%;\r\n  height: 395px;\r\n  background-repeat: no-repeat;\r\n  background-size: auto 65%;\r\n  background-position: 5% bottom;\r\n}\r\n\r\n.dashboard-top .banner .main-title {\r\n  color: #FFF;\r\n  font-weight: 800;\r\n  font-size: 32px;\r\n  text-align: center;\r\n  margin-top: 90px;\r\n}\r\n\r\n.dashboard-top .banner .sub-title {\r\n  color: #FFF;\r\n  font-weight: 800;\r\n  font-size: 15px;\r\n  text-align: center;\r\n  margin-top: 60px;\r\n}\r\n\r\n.dashboard-top .banner .btnwrap {\r\n  text-align: center;\r\n  margin-top: 15px;\r\n}\r\n\r\n.dashboard-top .right-side>div {\r\n  height: 128px;\r\n  background: #0070c0;\r\n}\r\n\r\n.fixed-height-chart {\r\n  height: 200px !important;\r\n}\r\n\r\n.smstab>li>a {\r\n  width: 170px;\r\n}\r\n</style> --><style>.legendColorBox, .legendLabel {\r\n  border-top: none !important;\r\n}\r\n\r\n.legend>div {\r\n  opacity: 0 !important;\r\n}</style><div class=\"page page-footable\" ng-controller=\"Cafe24ChartListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header><i class=\"fa fa-bar-chart-o mr-10\" name=bar-chart-o></i>차트</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0 pr-0 ml-0 mr-0\"><div class=card-container><div class=\"panel panel-default\"><div class=\"col-md-12 mb-10\"><ul class=\"nav nav-tabs smstab\"><li><a href=\"\" ng-click=\"fnClkTab(\'1\')\">Main</a></li><li><a href=\"\" ng-click=\"fnClkTab(\'2\')\">유형별</a></li><li><a href=\"\" ng-click=\"fnClkTab(\'3\')\">카테고리별</a></li><li><a href=\"\" ng-click=\"fnClkTab(\'4\')\">지표관련</a></li></ul></div><!-- bar 1. VOC 접수 추이(월별) --><div class=\"col-lg-6 mb-20\" ng-show=dashboardMain><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">1. 판매추이 (월별)</div><div style=\"height: 19px !important\"></div><canvas id=base class=\"chart-bar fixed-height-chart\" chart-data=vc.monthvoc.data chart-labels=vc.monthvoc.labels chart-colors=vc.monthvoc.colors chart-dataset-override=vc.monthvoc.datasetOverride chart-options=vc.monthvoc.options></canvas></div></div><!-- bar 2. 전월대비 문의 증가 유형(Top 3) --><div class=\"col-lg-6 mb-20\" ng-show=dashboardMain><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">2. 전월대비 판매 증가 유형 Top 3</div><div style=\"height: 19px !important\"></div><canvas id=base class=\"chart-bar fixed-height-chart\" chart-data=vc.momupgvoc.data chart-labels=vc.momupgvoc.labels chart-colors=vc.momupgvoc.colors chart-dataset-override=vc.momupgvoc.datasetOverride chart-options=vc.momupgvoc.options></canvas></div></div><!-- bar 3. 실시간 문의 급증 유형(Top 5) --><div class=\"col-lg-6 mb-20\" ng-show=dashboardMain><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">3. 실시간 판매 급증 유형 Top 5 (최근 3일 기준)</div><canvas id=doughnut class=\"chart-doughnut fixed-height-chart\" chart-data=vc.upgvoc.data chart-labels=vc.upgvoc.labels chart-colors=vc.upgvoc.colors chart-dataset-override=vc.upgvoc.datasetOverride chart-options=vc.upgvoc.options style=height:100px></canvas><!-- <div class=\"mt-10 mb-10\" id=\"tab2\" style=\"height: 30px !important;\"></div> --></div></div><!-- bar 4. VOC 분류별 일반문의--><div class=\"col-lg-6 mb-20\" ng-show=dashboardVocType><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">4. 유형별 일반 Top 5</div><canvas id=doughnut class=\"chart-doughnut fixed-height-chart\" chart-data=vc.norvoc.data chart-labels=vc.norvoc.labels chart-colors=vc.norvoc.colors chart-dataset-override=vc.norvoc.datasetOverride chart-options=vc.norvoc.options style=\"height: 100px\"></canvas></div></div><!-- bar 4. VOC 분류별 불만 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardVocType><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">4. 유형별 기회 Top 5</div><canvas id=doughnut class=\"chart-doughnut fixed-height-chart\" chart-data=vc.disvoc.data chart-labels=vc.disvoc.labels chart-colors=vc.disvoc.colors chart-dataset-override=vc.disvoc.datasetOverride chart-options=vc.disvoc.options style=height:100px></canvas></div></div><!-- bar 4. VOC 분류별 핵심 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardVocType><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">4. 유형별 온라인 Top 5</div><canvas id=doughnut class=\"chart-doughnut fixed-height-chart\" chart-data=vc.corevoc.data chart-labels=vc.corevoc.labels chart-colors=vc.corevoc.colors chart-dataset-override=vc.corevoc.datasetOverride chart-options=vc.corevoc.options style=\"height: 100px\"></canvas></div></div><!-- bar 5. 월별 평균 처리일 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardVocType><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">5. 월별 평균 처리일</div><div style=\"height: 19px !important\"></div><canvas id=line class=\"chart chart-line fixed-height-chart\" chart-data=vc.avgcpdat.data chart-labels=vc.avgcpdat.labels chart-colors=vc.avgcpdat.colors chart-dataset-override=vc.avgcpdat.datasetOverride chart-options=vc.avgcpdat.options></canvas></div></div><!-- bar 6. 부서별 VOC 접수 현황 일반 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardVocDept><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">6. 카테고리별 일반 Top 5</div><canvas id=doughnut class=\"chart-doughnut fixed-height-chart\" chart-data=vc.givoc.data chart-labels=vc.givoc.labels chart-colors=vc.givoc.colors chart-dataset-override=vc.givoc.datasetOverride chart-options=vc.givoc.options style=\"height: 100px\"></canvas></div></div><!-- bar 6. 부서별 VOC 접수 현황 개선 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardVocDept><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">6. 카테고리별 기회 Top 5</div><canvas id=doughnut class=\"chart-doughnut fixed-height-chart\" chart-data=vc.impvoc.data chart-labels=vc.impvoc.labels chart-colors=vc.impvoc.colors chart-dataset-override=vc.impvoc.datasetOverride chart-options=vc.impvoc.options style=\"height: 100px\"></canvas></div></div><!-- bar 6. 부서별 VOC 접수 현황 불만 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardVocDept><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">6. 카테고리별 온라인 Top 5</div><canvas id=doughnut class=\"chart-doughnut fixed-height-chart\" chart-data=vc.cmpvoc.data chart-labels=vc.cmpvoc.labels chart-colors=vc.cmpvoc.colors chart-dataset-override=vc.cmpvoc.datasetOverride chart-options=vc.cmpvoc.options style=\"height: 100px\"></canvas></div></div><!-- bar 6. 부서별 VOC 접수 현황 칭찬 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardVocDept><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">6. 카테고리별 오프라인 Top 5</div><canvas id=doughnut class=\"chart-doughnut fixed-height-chart\" chart-data=vc.pravoc.data chart-labels=vc.pravoc.labels chart-colors=vc.pravoc.colors chart-dataset-override=vc.pravoc.datasetOverride chart-options=vc.pravoc.options style=height:100px></canvas></div></div><!-- bar 6. 부서별 VOC 접수 현황 사전예고 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardVocDept><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">6. 카테고리별 사전예약 Top 5</div><canvas id=doughnut class=\"chart-doughnut fixed-height-chart\" chart-data=vc.adnotivoc.data chart-labels=vc.adnotivoc.labels chart-colors=vc.adnotivoc.colors chart-dataset-override=vc.adnotivoc.datasetOverride chart-options=vc.adnotivoc.options style=\"height: 100px\"></canvas></div></div><!-- bar 7. 부서별 평균 처리시간 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardStatistics><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">7. 평균 처리시간 / 가장 긴 시간 Top 3 , 가장 짧은 시간 Top 3</div><canvas id=base class=\"chart-bar fixed-height-chart\" chart-data=vc.dpavgvoc.data chart-labels=vc.dpavgvoc.labels chart-colors=vc.dpavgvoc.colors chart-dataset-override=vc.dpavgvoc.datasetOverride chart-options=vc.dpavgvoc.options></canvas></div></div><!-- bar 8. 답변만족도 우수 부서 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardStatistics><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">8. 만족도 우수 아이템 Top 3</div><div style=\"height: 19px !important\"></div><canvas id=base class=\"chart-bar fixed-height-chart\" chart-data=vc.evvoc.data chart-labels=vc.evvoc.labels chart-colors=vc.evvoc.colors chart-dataset-override=vc.evvoc.datasetOverride chart-options=vc.evvoc.options></canvas></div></div><!-- bar 9. 처리일 3일 이상 처리 건 유형 --><div class=\"col-lg-6 mb-20\" ng-show=dashboardStatistics><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">9. 가격별 만족도 우수 Top 5</div><div style=\"height: 19px !important\"></div><canvas id=base class=\"chart-bar fixed-height-chart\" chart-data=vc.avgvoc.data chart-labels=vc.avgvoc.labels chart-colors=vc.avgvoc.colors chart-dataset-override=vc.avgvoc.datasetOverride chart-options=vc.avgvoc.options></canvas></div></div><!-- bar 10. 고객의 소리(VOC) 활용률(%) --><div class=\"col-lg-6 mb-20\" ng-show=dashboardStatistics><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">10. 재구매률(%)</div><div style=\"height: 19px !important\"></div><canvas id=bar class=\"chart-bar fixed-height-chart\" chart-data=vc.usevoc.data chart-labels=vc.usevoc.labels chart-colors=vc.usevoc.colors chart-dataset-override=vc.usevoc.datasetOverride chart-options=vc.usevoc.options></canvas></div></div><!-- bar 11. 국민신문고 접수 추이(월별) --><div class=\"col-lg-6 mb-20\" ng-show=dashboardStatistics><div class=\"ds_area box-basic pd-30 min-h-510p\"><div class=\"custom-font chart-title mb-20\">11. 환불 추이(월별)</div><div style=\"height: 19px !important\"></div><canvas id=base class=\"chart-bar fixed-height-chart\" chart-data=vc.epeoplevoc.data chart-labels=vc.epeoplevoc.labels chart-colors=vc.epeoplevoc.colors chart-dataset-override=vc.epeoplevoc.datasetOverride chart-options=vc.epeoplevoc.options></canvas></div></div></div></div></div></div><!-- pie row 끝 --></div></div>");
$templateCache.put("app/cafe24/customer-detail.html","<div class=\"page page-footable\" ng-controller=\"Cafe24CustomerDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.USER\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4\" ng-repeat=\"liCol in vc.allColumns\"><div class=\"form-group form-inline\"><label>{{liCol.ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType != \'40\'\" ng-bind-html=vc.data[liCol.ColumnPhysicalNm]|htmlString></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'40\'\" ng-bind-html=\"vc.data[liCol.ColumnPhysicalNm]|utcToLocal:\'yyyy-MM-dd HH:mm\'\"></div></div></div></div><div class=row><div class=\"form-group form-inline\"><div class=\"col-sm-12 col-md-12 col-sm-12 col-xs-12\"><span ng-bind-html=vc.data.description|htmlString></span></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/customer-list.html","<div class=\"page page-footable\" ng-controller=\"Cafe24CustomerListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.name placeholder=\"고객명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'group_name\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'group_name\'].CodeList\" code-model=vc.srch.group_no></common-code-custom><label>{{vc.columnMap[\'group_name\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'VisitPath\'].CodeList\" code-model=vc.srch.VisitPath></common-code-custom><label>라인별</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=form-group><label><input type=checkbox ng-model=vc.srch.ChkTodayJoin ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> 오늘 가입 고객</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ageStr type=text><label>연령시작일</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ageEnd type=text><label>연령종료일</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-tree code-list=vc.codeList reload-seq=vc.reloadSeq code-model=vc.GroupAndAction prevent-changing=true></common-code-tree><!--  <common-code-custom code-list=\"vc.columnMap[\'VisitPath\'].CodeList\"\r\n                                                code-model=\"vc.srch.VisitPath\"></common-code-custom> --><!-- <label>지역</label> --></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TagContents type=text><label>관심태그</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'EntryDtFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EntryDtFrom = (vc.EntryDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.EntryDtFrom ng-required=false placeholder=\"{{vc.columnMap[\'EntryDtFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'EntryDtTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EntryDtTo = (vc.EntryDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.EntryDtTo ng-required=false placeholder=\"{{vc.columnMap[\'EntryDtTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.member_id, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.member_id == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\"><img ng-src={{li[liCol.ColumnPhysicalNm]}}></span><span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/log-detail.html","<div class=\"page page-footable\" ng-controller=\"Cafe24LogDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>고객활동</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-repeat=\"liCol in vc.allColumns\"><div class=\"form-group form-inline\"><label>{{liCol.ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'10\'\" ng-bind-html=vc.data[liCol.ColumnPhysicalNm]|htmlString></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'20\'\" ng-bind=vc.data[liCol.ColumnPhysicalNm]></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'40\'\" ng-bind-html=\"vc.data[liCol.ColumnPhysicalNm]|utcToLocal:\'yyyy-MM-dd HH:mm\'\"></div></div></div></div><div class=row><div class=\"form-group form-inline\"><div class=\"col-sm-12 col-md-12 col-sm-12 col-xs-12\"><span ng-bind-html=vc.data.description|htmlString></span></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/log-list.html","<div class=\"page page-footable\" ng-controller=\"Cafe24LogListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객활동목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-9 col-xg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.mallId placeholder=\"쇼핑몰 아이디\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'LogType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'LogType\'].CodeList\" code-model=vc.srch.logType></common-code-custom><label>{{vc.columnMap[\'LogType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustLoginId\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.custLoginId type=text><label>{{vc.columnMap[\'CustLoginId\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateStr ng-change=\"vc.srch.regDateStr = (vc.RegDateStr | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=지우기 close-text=닫기 placeholder=\"등록일자 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateEnd ng-change=\"vc.srch.regDateEnd = (vc.RegDateEnd | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=지우기 close-text=닫기 placeholder=\"등록일자 끝\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.LogId) style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.LogId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd hh:mm\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\"><img ng-src={{li[liCol.ColumnPhysicalNm]}}></span><span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/loginbycafe24.html","<div class=n-login-wrap><div class=n-login-box><a class=\"btn-example btn btn-outline btn-danger\" href=#Notice id=notice style=\"display: none\"></a><div class=box-top-deco><p class=deco-text>CAFE24CAFE24CAFE24CAFE24CAFE24</p></div><div class=n-login-body><form class=login_box id=login_box><div class=\"title mb-30\"><img src=/assets/images/login/cafe24-logo.png alt=\"\"></div><h3>잠시만 기다려주세요.</h3><h4>인증처리 중입니다....</h4></form></div><!-- //n-login-body --></div><!-- //n-login-box --></div><!-- //n-login-wrap -->");
$templateCache.put("app/cafe24/manage-ui.html","<div class=\"page page-footable\"><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header><i class=\"fa fa-code mr-10\" name=bar-chart-o></i>UI관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button></div></div><!-- pie row 끝 --></div></div>");
$templateCache.put("app/cafe24/order-detail.html","<div class=\"page page-footable\" ng-controller=\"Cafe24OrderDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.USER\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>주문품목</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center>품목별 주문번호</th><th class=text-center>공급사</th><th class=text-center>상품명/옵션</th><th class=text-center>수량</th><th class=text-center>판매가</th><th class=text-center>상품별할인금액</th><th class=text-center>주문상태</th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.listItems\"><!-- Result Items --><td class=text-center><span>{{li.order_item_code}}/{{li.product_code}}</span></td><td class=text-center><span>{{li.supplier_name}}</span></td><td class=text-center><span>{{li.product_name}}/{{li.option_value}}</span></td><td class=text-center><span>{{li.quantity}}</span></td><td class=text-center><span>{{li.product_price | number}}</span></td><td class=text-center><span>{{li.additional_discount_price}}</span></td><td class=text-center><span>{{li.status_text}}</span></td></tr></table></div></div></div></div></div></div><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\" ng-repeat=\"liCol in vc.allColumns\"><div class=\"form-group form-inline\"><label>{{liCol.ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'10\'\" ng-bind-html=vc.data[liCol.ColumnPhysicalNm]|htmlString></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'20\'\" ng-bind=vc.data[liCol.ColumnPhysicalNm]></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'40\'\" ng-bind-html=\"vc.data[liCol.ColumnPhysicalNm]|utcToLocal:\'yyyy-MM-dd HH:mm\'\"></div></div></div></div><div class=row><div class=\"form-group form-inline\"><div class=\"col-sm-12 col-md-12 col-sm-12 col-xs-12\"><span ng-bind-html=vc.data.description|htmlString></span></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/order-list.html","<div class=\"page page-footable\" ng-controller=\"Cafe24OrderListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>주문목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.buyer_name placeholder=주문자이름 type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.OrderDateStr ng-change=\"vc.srch.order_date_str = (vc.OrderDateStr | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=지우기 close-text=닫기 placeholder=\"주문일자 시작\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.OrderDateEnd ng-change=\"vc.srch.order_date_end = (vc.OrderDateEnd | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=지우기 close-text=닫기 placeholder=\"주문일자 끝\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'VisitPath\'].CodeList\" code-model=vc.srch.VisitPath></common-code-custom><label>{{vc.columnMap[\'VisitPath\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.order_id) style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.order_id == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\"><img ng-src={{li[liCol.ColumnPhysicalNm]}}></span><span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/product-detail.html","<div class=\"page page-footable\" ng-controller=\"Cafe24ProductDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.USER\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-repeat=\"liCol in vc.allColumns\"><div class=\"form-group form-inline\"><label>{{liCol.ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'10\'\" ng-bind=vc.data[liCol.ColumnPhysicalNm]|htmlString></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'20\'\" ng-bind=vc.data[liCol.ColumnPhysicalNm]></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'40\'\" ng-bind-html=\"vc.data[liCol.ColumnPhysicalNm]|utcToLocal:\'yyyy-MM-dd HH:mm\'\"></div><div class=\"form-control-img txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'60\'\"><img ng-src={{vc.data[liCol.ColumnPhysicalNm]}}></div></div></div></div><div class=row><div class=\"form-group form-inline\"><div class=\"col-sm-12 col-md-12 col-sm-12 col-xs-12\"><span ng-bind-html=vc.data.description|htmlString></span></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/product-list.html","<div class=\"page page-footable\" ng-controller=\"Cafe24ProductListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>제품목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-9 col-xg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.product_name placeholder=상품명 type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'product_code\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.product_code type=text><label>{{vc.columnMap[\'product_code\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-12 col-sm-12 col-md-3 col-xg-3 col-xl-3\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.mall_id, li.product_no)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.product_no == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\"><img ng-src={{li[liCol.ColumnPhysicalNm]}} style=height:50px></span><span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/subscribe-customer-detail.html","<div class=\"page page-footable\" ng-controller=\"Cafe24SubscribeCustomerDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}<select-data-group></select-data-group></div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd hh:mm\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/subscribe-customer-list.html","<div class=\"page page-footable\" ng-controller=\"Cafe24SubscribeCustomerListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객별 구독 목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-9 col-xg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.member_id placeholder=\"고객 아이디\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SubscribeType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SubscribeType\'].CodeList\" code-model=vc.srch.SubscribeType></common-code-custom><label>{{vc.columnMap[\'SubscribeType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'name\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.name type=text><label>{{vc.columnMap[\'name\'].ColumnLogicalNm | translate}}</label></div></div><!--                         <div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\">\r\n                          <div class=\"form-group form-inner-label\">\r\n                            <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n                              <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{ :: format}}\"\r\n                                  ng-model=\"vc.StartDate\" ng-change=\"vc.srch.StartDate = (vc.StartDate | date: \'yyyy-MM-dd\')\"\r\n                                  is-open=\"opened\" datepicker-options=\"dateOptions\"\r\n                                  ng-required=\"false\" current-text=\"오늘\"\r\n                                  clear-text=\"지우기\" close-text=\"닫기\"\r\n                                  placeholder=\"{{vc.columnMap[\'StartDate\'].ColumnLogicalNm | translate}}\" />\r\n                              <span class=\"input-group-btn\">\r\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"open($event)\">\r\n                                  <i class=\"fa fa-calendar\"></i>\r\n                                </button>\r\n                              </span>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                        <div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\">\r\n                          <div class=\"form-group form-inner-label\">\r\n                            <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n                              <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{ :: format}}\"\r\n                              ng-model=\"vc.EndDate\" ng-change=\"vc.srch.EndDate = (vc.EndDate | date: \'yyyy-MM-dd\')\"\r\n                              is-open=\"opened\" datepicker-options=\"dateOptions\"\r\n                              ng-required=\"false\" current-text=\"오늘\" clear-text=\"지우기\" close-text=\"닫기\"\r\n                              placeholder=\"{{vc.columnMap[\'EndDate\'].ColumnLogicalNm | translate}}\" />\r\n                              <span class=\"input-group-btn\">\r\n                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"open($event)\">\r\n                                  <i class=\"fa fa-calendar\"></i>\r\n                                </button>\r\n                              </span>\r\n                            </div>\r\n                          </div>\r\n                        </div> --><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.member_id) ng-class=\"{\'bg-lightyellow\':li.member_id == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd hh:mm\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\"><img ng-src={{li[liCol.ColumnPhysicalNm]}}></span><span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/subscribe-detail.html","<div class=\"page page-footable\" ng-controller=\"Cafe24SubscribeDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.USER\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4\" ng-repeat=\"liCol in vc.allColumns\"><div class=\"form-group form-inline\"><label>{{liCol.ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType != \'40\'\" ng-bind-html=vc.data[liCol.ColumnPhysicalNm]|htmlString></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'40\'\" ng-bind-html=\"vc.data[liCol.ColumnPhysicalNm]|utcToLocal:\'yyyy-MM-dd HH:mm\'\"></div></div></div></div><div class=row><div class=\"form-group form-inline\"><div class=\"col-sm-12 col-md-12 col-sm-12 col-xs-12\"><span ng-bind-html=vc.data.description|htmlString></span></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/subscribe-list.html","<div class=\"page page-footable\" ng-controller=\"Cafe24SubscribeListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>구독목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-9 col-xg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.MemberId placeholder=\"고객 아이디\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SubscribeType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SubscribeType\'].CodeList\" code-model=vc.srch.SubscribeType></common-code-custom><label>{{vc.columnMap[\'SubscribeType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ProductNo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ProductNo type=text><label>{{vc.columnMap[\'ProductNo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.StartDate ng-change=\"vc.srch.StartDate = (vc.StartDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=지우기 close-text=닫기 placeholder=\"{{vc.columnMap[\'StartDate\'].ColumnLogicalNm | translate}}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.EndDate ng-change=\"vc.srch.EndDate = (vc.EndDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=지우기 close-text=닫기 placeholder=\"{{vc.columnMap[\'EndDate\'].ColumnLogicalNm | translate}}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.SubscribeId) ng-class=\"{\'bg-lightyellow\':li.SubscribeId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd hh:mm\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\"><img ng-src={{li[liCol.ColumnPhysicalNm]}}></span><span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/subscribe-prd-detail.html","<div class=\"page page-footable\" ng-controller=\"Cafe24SubscribePrdDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}<select-data-group></select-data-group></div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}} {{li.newItemClass}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/cafe24/subscribe-prd-list.html","<div class=\"page page-footable\" ng-controller=\"Cafe24SubscribePrdListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>상품별 구독 목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-9 col-xg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.product_name placeholder=\"{{vc.columnMap[\'product_name\'].ColumnLogicalNm | translate}}\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SubscribeType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SubscribeType\'].CodeList\" code-model=vc.srch.SubscribeType></common-code-custom><label>{{vc.columnMap[\'SubscribeType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'product_no\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.product_no type=text><label>{{vc.columnMap[\'product_no\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.product_no) ng-class=\"{\'bg-lightyellow\':li.product_no == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd hh:mm\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\"><img ng-src={{li[liCol.ColumnPhysicalNm]}} style=height:50px></span><span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/campaign2/campaign-edit.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div ng-controller=\"CampaignEditCtrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=page-header><div ng-switch on=vc.srch.cmpgnType><div ng-switch-when=GROUP>캠페인 등록/수정</div><div ng-switch-when=AUTO>자동 캠페인 등록/수정</div></div></div><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-if=\"vc.formType == \'EMAIL\'\" ng-click=vc.contentsModal()><i class=\"fa fa-desktop\"></i> 미리보기</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><!-- 캠페인명 --><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CmpgnNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CmpgnNm></div></div></div><div class=row><!-- 상태 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'CmpgnStatus\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'CmpgnStatus\'].CodeList\" code-model=vc.data.CmpgnStatus is-disabled=false></common-code-custom></div></div><!-- 담당자 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ManagerId\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><!-- 발송채널 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CmpgnChannel\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.data.CmpgnChannel is-disabled=false></common-code-custom></div></div></div><div class=row><!-- 시작일 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'StartDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.StartDate = (vc.StartDate | date: \'yyyy-MM-dd\')\" ng-model=vc.StartDate ng-required=false placeholder=\"{{vc.columnMap[\'StartDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 종료일 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EndDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.EndDate = (vc.EndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.EndDate ng-required=false placeholder=\"{{vc.columnMap[\'EndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 발송유형 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'SendType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'SendType\'].CodeList\" code-model=vc.data.SendType is-disabled=false code-exclude=vc.arrSendTypeExclude></common-code-custom></div></div></div><div class=row><div class=col-lg-4></div><div class=col-lg-4></div><div class=col-lg-4><div ng-switch on=vc.data.SendType><div ng-switch-when=REPEAT><!-- 반복 발송 --><div class=\"form-group form-inline\"><input type=text class=form-control ng-model=vc.data.SendDay style=width:50px;vertical-align:middle><span>일 간격.</span> <input type=text class=form-control ng-model=vc.data.SendHour style=width:50px;vertical-align:middle><span>시간 간격.</span> <input type=text class=form-control ng-model=vc.data.SendMinute style=width:50px;vertical-align:middle><span>분 간격.</span></div></div><div ng-switch-when=RESERVE><!-- 예약 발송 --><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SendDay = (vc.SendDay | date: \'yyyy-MM-dd\')\" ng-model=vc.SendDay ng-required=false placeholder=예약일 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button> </span><!-- 예약시간 : RESERVE_TIME --><common-code-custom code-list=\"vc.columnMap[\'SendHour\'].CodeList\" code-model=vc.data.SendHour is-disabled=false></common-code-custom></div></div><div ng-switch-default></div></div></div></div><!-- 설명 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CmpgnDesc\'].ColumnLogicalNm | translate}}</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.CmpgnDesc></textarea></div></div></div></form></div></div></div></div><!-- 서식정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>서식정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'FormId\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.FormNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchFormModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseForm();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div></form></div></div></div></div><!-- 대상고객 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>대상고객</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div ng-switch on=vc.srch.cmpgnType><div ng-switch-when=GROUP><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>수신자그룹</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GrpNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchGroupModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseGroup();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>대상자</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.GrpTotal readonly></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><button class=\"btn btn-default\" ng-click=vc.editGrpTarget()><i class=\"fa fa-list\"></i> 대상자 편집</button></div></div></div></div><div ng-switch-when=AUTO><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-hover\"><colgroup><col width=50px><col><col width=100px></colgroup><thead><tr><td colspan=3>검색조건</td></tr></thead><tbody><tr><td class=text-center><input type=checkbox name=tempId value=ALL></td><td class=text-left>전체회원</td><td class=text-center></td></tr><tr ng-repeat=\"li in vc.columnMap[\'ExtVarchar02\'].CodeList\"><td class=text-center><input type=checkbox name=tempId value={{li.Code}}></td><td class=text-left><span ng-bind=li.CodeValue></span></td><td class=text-center><common-code-custom code-list=\"vc.columnMap[\'ExtVarchar01\'].CodeList\" code-model=vm.TermOpr is-disabled=false></common-code-custom></td></tr></tbody></table></div></div></div></div></form></div></div></div></div><!-- 발송정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>발송정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div ng-switch on=vc.data.CmpgnChannel><div ng-switch-when=EMAIL><div class=row><!-- 발송정보 : 이메일/번호 --><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송정보</label><input type=text class=\"form-control form-right\" ng-model=vc.data.FromInfo></div></div></div></div><div ng-switch-default><div class=row><!-- 발송정보 : 이메일/번호 --><div class=col-lg-3><div class=\"form-group form-inline\"><label>발송정보</label><common-code-custom code-list=vc.sendNumberVerifyList code-model=vc.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=col-lg-3><div class=\"form-group form-inline\"><label>현재잔액</label><input type=text class=\"form-control form-right\" disabled value=10,000></div></div><!--                       <div class=\"col-lg-3\"> --><!--                         <div class=\"form-group form-inline\"> --><!--                           <label>차감예상금액</label> --><!--                           <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"5,000\"> --><!--                         </div> --><!--                       </div> --></div></div><div class=row><!-- 설명 --><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><!--                         <label>{{vc.columnMap[\'SendMessage\'].ColumnLogicalNm | translate}}</label> --><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=vc.data.SendMessage></textarea></div></div></div></div></form></div></div></div></div><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><script type=text/javascript>/**\r\n      var oEditors = [];\r\n      var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n      nhn.husky.EZCreator.createInIFrame({\r\n        oAppRef : oEditors,\r\n        elPlaceHolder : \"strHtml\",\r\n        sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n        htParams : {\r\n          bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n          bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n          bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n          fOnBeforeUnload : function() {\r\n            //alert(\"완료!\");\r\n          },\r\n          I18N_LOCALE : sLang\r\n        }, //boolean\r\n        fOnAppLoad : function() {\r\n          //예제 코드\r\n          //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n        },\r\n        fCreator : \"createSEditor2\"\r\n      });\r\n      **/</script>");
$templateCache.put("app/campaign2/campaign-list.html","<div class=\"page page-footable\" ng-controller=\"CampaignListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>캠페인목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><!-- 검색 영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>검색화면</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><input type=hidden class=form-control ng-model=vc.srch.GrpId><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>캠페인명</label><input type=text class=form-control ng-model=vc.srch.CmpgnNm ng-required=true></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>상태</label><common-code-custom code-list=\"vc.columnMap[\'CmpgnStatus\'].CodeList\" code-model=vc.srch.CmpgnStatus is-disabled=false></common-code-custom></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>담당자</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.srch.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>예약일</label><div class=row><div class=col-lg-6><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.StartDate = (vc.StartDate | date: \'yyyy-MM-dd\')\" ng-model=vc.StartDate ng-required=false placeholder=\"{{vc.columnMap[\'StartDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=col-lg-6><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EndDate = (vc.EndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.EndDate ng-required=false placeholder=\"{{vc.columnMap[\'EndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송메세지</label><input type=text class=form-control ng-model=vc.srch.SendMessage></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송채널</label><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.srch.CmpgnChannel is-disabled=false></common-code-custom></div></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getList();><i class=\"fa fa-search\"></i> 조회</button> <button type=button class=\"btn btn-default\" activate-button ng-click=vc.resetList();><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETLIST\' | translate }}</button> <button type=button class=\"btn btn-primary\" activate-button ng-click=\"vc.goAdd(\'GROUP\');\"><i class=\"fa fa-edit\"></i> 캠페인 등록</button> <button type=button class=\"btn btn-primary\" activate-button ng-click=\"vc.goAdd(\'AUTO\');\"><i class=\"fa fa-edit\"></i> 자동캠페인 등록</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode(); ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></form></div></div></div></div><!-- 목록 --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goEdit(li.KeyId, li.CmpgnType)\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/campaign2/campaignimpl-detail.html","<div class=\"page page-footable\" ng-controller=\"CampaignImplDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>캠페인결과 조회</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><div class=row file-dropzone><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><!-- 캠페인명 --><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>캠페인명</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CmpgnNm readonly></div></div></div><div class=row><!-- 상태 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>상태</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CmpgnStatus readonly></div></div><!-- 담당자 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>담당자</label><input type=text class=\"form-control form-right\" ng-model=vc.data.ManagerNm readonly></div></div><!-- 발송채널 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송채널</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CmpgnChannel readonly></div></div></div><div class=row><!-- 시작일 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>시작일</label><input type=text class=\"form-control form-right\" ng-model=vc.data.StartDatel readonly></div></div><!-- 종료일 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>종료일</label><input type=text class=\"form-control form-right\" ng-model=vc.data.EndDate readonly></div></div><!-- 발송유형 --><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송유형</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SendType readonly></div></div></div><div class=row ng-iff=vc.data.SendType><div class=col-lg-4></div><div class=col-lg-4></div><!-- 반복발송 --><div class=col-lg-4><div class=\"form-group form-inline\"><input type=text class=form-control ng-model=vc.data.SendDay style=width:50px;vertical-align:middle><span>일마다.</span><br><input type=text class=form-control ng-model=vc.data.SendHour style=width:50px;vertical-align:middle><span>시</span> <input type=text class=form-control ng-model=vc.data.SendMinute style=width:50px;vertical-align:middle><span>분에 반복 발송.</span></div></div></div><!-- 설명 --><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>설명</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.CmpgnDesc readonly></textarea></div></div></form></div></div></div></div></div><!-- 서식정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>서식정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-3><div class=\"form-group form-inline\"><label>서식명</label><input type=text class=\"form-control form-right\" ng-model=vc.data.FormNm readonly></div></div></div></form></div></div></div></div><!-- 대상고객 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>대상고객</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-3><div class=\"form-group form-inline\"><label>전체고객수</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TotalCust readonly></div></div><div class=col-lg-3><div class=\"form-group form-inline\"><label>대상고객수</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TargetCnt readonly></div></div><div class=col-lg-3><div class=\"form-group form-inline\"><label>전송완료</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SucceCnt readonly></div></div><div class=col-lg-3><div class=\"form-group form-inline\"><label>전송성공</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TotalOk readonly></div></div></div><div class=row><div class=col-lg-3><div class=\"form-group form-inline\"><label>번호오류</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TotalNg1 readonly></div></div><div class=col-lg-3><div class=\"form-group form-inline\"><label>수신거부</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TotalNg2 readonly></div></div><div class=col-lg-3><div class=\"form-group form-inline\"><label>중복제외</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TotalNg3 readonly></div></div><div class=col-lg-3><div class=\"form-group form-inline\"><label>기타오류</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TotalNg4 readonly></div></div></div></form></div></div></div></div><!-- 발송정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>발송정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\" ng-if=\"vc.data.CmpgnChannel == \'SMS\'\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><!-- 발송정보 : 이메일/번호 --><div class=col-lg-3><div class=\"form-group form-inline\"><label>발송번호</label><input type=text class=\"form-control form-right\" ng-model=vc.data.FromInfo></div></div></div><!-- 설명 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.SendMessage></textarea></div></div></div></form></div><div class=\"panel-body collapse in\" ng-if=\"vc.data.CmpgnChannel == \'EMAIL\'\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><!-- 발송정보 : 이메일/번호 --><div class=col-lg-3><div class=\"form-group form-inline\"><label>발송자 이메일</label><input type=text class=\"form-control form-right\" ng-model=vc.data.FromInfo></div></div></div><!-- 설명 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>내용</label><textarea rows=10 class=\"form-control form-right\" ng-model=vc.data.SendMessage></textarea></div></div></div></form></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content -->");
$templateCache.put("app/campaign2/campaignimpl-list.html","<div class=\"page page-footable\" ng-controller=\"CampaignImplListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>캠페인결과 목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><!-- 검색영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>검색화면</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><input type=hidden class=form-control ng-model=vc.srch.GrpId><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>캠페인명</label><input type=text class=form-control ng-model=vc.srch.CmpgnNm ng-required=true></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>담당자</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.srch.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송일</label><div class=row><div class=col-lg-6><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.StartDate = (vc.StartDate | date: \'yyyy-MM-dd\')\" ng-model=vc.StartDate ng-required=false placeholder=\"\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=col-lg-6><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EndDate = (vc.EndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.EndDate ng-required=false placeholder=\"\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송메세지</label><input type=text class=form-control ng-model=vc.srch.SendMessage></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>발송채널</label><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.srch.CmpgnChannel is-disabled=false></common-code-custom></div></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getList();><i class=\"fa fa-search\"></i> 조회</button> <button type=button class=\"btn btn-default\" activate-button ng-click=vc.resetList();><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETLIST\' | translate }}</button></div></div></form></div></div></div></div><!-- /검색영역 --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-body><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T2.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T2.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':(sendDate == li.SendDate && sendType == li.SendType && sendDtType == li.SendDtType)}\"><td class={{liCol.ListColumnTextAlign}} ng-click=vc.goDetail(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/campaign2/form-edit.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div ng-controller=\"FormEditCtrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-if=\"vc.formType == \'EMAIL\'\" ng-click=vc.contentsModal()><i class=\"fa fa-desktop\"></i> 미리보기</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>서식 등록/수정</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label><input ng-if=\"vc.formType == \'SMS\'\" type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.FormNm><div ng-if=\"vc.formType == \'EMAIL\'\" class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10\"><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.FormNm></div><div ng-if=\"vc.formType == \'EMAIL\'\" class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><button class=\"btn btn-default\" ng-click=vc.srchFormModal()><i class=\"fa fa-list\"></i> 기존서식 가져오기</button></div></div></div><!-- 설문선택 --><div class=col-lg-3><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'SurveyId\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SurveyNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchSurveyModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseSurvey();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'FormType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'FormType\'].CodeList\" code-model=vc.data.FormType is-disabled=true></common-code-custom></div></div></div><div class=row ng-if=\"vc.formType == \'SMS\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><div class=editorNotiBox>내용에 \"<b>{SurveyURL}</b>\"을 입력하면 설문URL으로 치환됩니다. ex) 새벽배송 1박스 문 앞(으)로 배송완료했습니다. 사진:<b>{SurveyURL}</b><br></div></div></div></div><!-- /row --><div class=row ng-if=\"vc.formType == \'SMS\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Contents\'].ColumnLogicalNm | translate }}</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.Contents ng-change=vc.chkSendMessage()></textarea><div class=text-right>{{vc.Contents}} / 2000 bytes</div></div></div></div><!-- EMAIL 수신거부/정보동의 체크박스--><div class=row ng-if=\"vc.formType == \'EMAIL\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><md-checkbox md-no-ink=\"\" ng-model=vc.data.RejectYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>수신거부 문구를 넣습니다.</md-checkbox></div></div></div><div class=row ng-if=\"vc.formType == \'EMAIL\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><md-checkbox md-no-ink=\"\" ng-model=vc.data.AgreeYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>회원수신동의 및 관련 문구를 넣습니다.</md-checkbox></div></div></div><div class=row ng-if=\"vc.formType == \'EMAIL\'\"><div class=col-lg-12><div class=col-lg-8><div class=\"form-group form-inline\"><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.FormAgreeMsg></textarea></div></div><div class=col-lg-4><button class=\"btn btn-primary\" ng-click=vc.setFromAgreeMsg()><i class=\"fa fa-save\"></i> 회원수신동의문구{{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row ng-if=\"vc.formType == \'EMAIL\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><div class=editorNotiBox>내용에 \"<b>{CustName}</b>\"을 입력하면 고객명으로 치환됩니다. ex) <b>{CustName}</b>님 안녕하세요.<br>텍스트, 이미지 선택후 에디터의 \"URL\"기능에 \"<b>{ClickURL}&goUrl=http://이동할URL</b>\"을 입력하면 클릭 반응이 수집됩니다.<br>텍스트, 이미지 선택후 에디터의 \"URL\"기능에 \"<b>{RejectURL}</b>\"을 입력하면 수신거부 팝업창 링크로 사용됩니다.<br>텍스트, 이미지 선택후 에디터의 \"URL\"기능에 \"<b>{SurveyURL}</b>\"을 입력하고 설문 서식을 사용하면 설문응답창 링크로 사용됩니다.</div></div></div></div><div class=row ng-show=\"vc.formType == \'EMAIL\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><!-- file upload--><div class=row ng-show=\"vc.formType ==\'EMAIL\'\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault2 class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --><!--               <div class=\"row\">\r\n                  <div class=\"form-group\" ng-show=\"vc.srch.editColumns.Contents\">\r\n                    <div class=\"col-sm-12\">\r\n                      <textarea id=\"strHtml\" rows=\"10\" style=\"width: 100%; height: 600px; display: \'none\';\"\r\n                        ng-model=\"vc.data.Contents\"></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div> --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><script type=text/javascript>var oEditors = [];\r\n\r\n      var sLang = \"en_US\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n      // 추가 글꼴 목록\r\n      //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n\r\n        nhn.husky.EZCreator.createInIFrame({\r\n          oAppRef : oEditors,\r\n          elPlaceHolder : \"strHtml\",\r\n          sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n          htParams : {\r\n            bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n            bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n            bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n            //bSkipXssFilter : true,    // client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n            //aAdditionalFontList : aAdditionalFontSet,   // 추가 글꼴 목록\r\n            fOnBeforeUnload : function() {\r\n              //alert(\"완료!\");\r\n            },\r\n            I18N_LOCALE : sLang\r\n          }, //boolean\r\n          fOnAppLoad : function() {\r\n            //예제 코드\r\n            //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n          },\r\n          fCreator : \"createSEditor2\"\r\n        });</script>");
$templateCache.put("app/campaign2/form-email-edit.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div ng-controller=\"FormEmailEditCtrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.contentsModal()><i class=\"fa fa-desktop\"></i> 미리보기</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>E-mail서식</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10\"><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.FormNm></div><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><button class=\"btn btn-default\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> 기존서식 가져오기</button></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'FormType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'FormType\'].CodeList\" code-model=vc.data.FormType is-disabled=true></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><md-checkbox md-no-ink=\"\" ng-model=vc.data.RejectYN ng-true-value=\"\'Y\'\" ng-false-value=N class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><div class=editorNotiBox>내용에 \"<b>{CustName}</b>\"을 입력하면 고객명으로 치환됩니다. ex) <b>{CustName}</b>님 안녕하세요.<br>텍스트, 이미지 선택후 에디터의 \"URL\"기능에 \"<b>{ClickURL}&goUrl=http://이동할URL</b>\"을 입력하면 클릭 반응이 수집됩니다.<br>텍스트, 이미지 선택후 에디터의 \"URL\"기능에 \"<b>{RejectURL}</b>\"을 입력하면 수신거부 팝업창 링크로 사용됩니다.<br>텍스트, 이미지 선택후 에디터의 \"URL\"기능에 \"<b>{SurveyURL}</b>\"을 입력하고 설문 서식을 사용하면 설문응답창 링크로 사용됩니다.</div></div></div></div><!-- /row --><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><!-- file upload--><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault2 class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --><!--               <div class=\"row\">\r\n                  <div class=\"form-group\" ng-show=\"vc.srch.editColumns.Contents\">\r\n                    <div class=\"col-sm-12\">\r\n                      <textarea id=\"strHtml\" rows=\"10\" style=\"width: 100%; height: 600px; display: \'none\';\"\r\n                        ng-model=\"vc.data.Contents\"></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div> --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"en_US\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,    // client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,   // 추가 글꼴 목록\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/campaign2/form-email-list.html","<div class=\"page page-footable\" ng-controller=\"FormEmailListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>E-Mail서식<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FormNm placeholder=\"서식명 검색\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'RegDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"{{vc.columnMap[\'RegDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/campaign2/form-list.html","<div class=\"page page-footable\" ng-controller=\"FormListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>서식목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FormNm placeholder=\"서식명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'RegDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"{{vc.columnMap[\'RegDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'FormType\'].CodeList\" code-model=vc.srch.FormType></common-code-custom><label>{{vc.columnMap[\'FormType\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goAdd(\'SMS\')\"><i class=\"fa fa-edit\"></i> SMS추가</button><!--                   <button class=\"btn btn-primary\" ng-click=\"vc.goAdd(\'KAKAO\')\">\r\n                    <i class=\"fa fa-edit\"></i> 카카오톡(친구톡)서식추가\r\n                  </button> --> <button class=\"btn btn-primary\" ng-click=\"vc.goAdd(\'EMAIL\')\"><i class=\"fa fa-edit\"></i> Email서식추가</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId,li.FormTypeId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/campaign2/form-sms-edit.html","<div ng-controller=\"FormSmsEditCtrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>SMS서식</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.FormNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'FormType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'FormType\'].CodeList\" code-model=vc.data.FormType is-disabled=true></common-code-custom></div></div></div><!-- /row --><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Contents\'].ColumnLogicalNm | translate }}</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.Contents ng-change=vc.chkSendMessage()></textarea><div class=text-right>{{vc.Contents}} / 2000 bytes</div></div></div></div><!-- file upload--><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault2 class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --><!--               <div class=\"row\">\r\n                  <div class=\"form-group\" ng-show=\"vc.srch.editColumns.Contents\">\r\n                    <div class=\"col-sm-12\">\r\n                      <textarea id=\"strHtml\" rows=\"10\" style=\"width: 100%; height: 600px; display: \'none\';\"\r\n                        ng-model=\"vc.data.Contents\"></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div> --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/campaign2/form-sms-list.html","<div class=\"page page-footable\" ng-controller=\"FormSmsListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS서식<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FormNm placeholder=\"서식명 검색\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'RegDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"{{vc.columnMap[\'RegDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/campaign2/group-list.html","<style>md-sidenav { max-width: 100% !Important; }</style><div class=\"page page-footable\" ng-controller=\"CustGroupListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>수신자관리</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row style=padding-top:8px><div class=col-lg-3><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>수신자그룹</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><md-sidenav md-component-id=left md-is-locked-open=true style=min-height:600px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">수신자그룹 목록</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.GrpNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav></div></div></div><div class=col-lg-9><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>수신자그룹정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-default\" activate-button ng-click=vc.resetList()><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETLIST\' | translate }}</button> <button type=button class=\"btn btn-primary\" activate-button ng-click=try_adding_a_branch() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=submit class=\"btn btn-primary\" activate-button ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\" ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 그룹입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div><div class=col-lg-4><div class=\"form-group form-inline\"><label>수신자그룹명</label><input type=text class=form-control ng-model=vc.data.GrpNm ng-change=vc.onChangeGrpNm() ng-required=true> <input type=hidden class=form-control ng-model=vc.data.GrpId> <input type=hidden class=form-control ng-model=vc.data.GrpLevel> <input type=hidden class=form-control ng-model=vc.data.ParentGrpId></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>정렬순서</label><input type=text class=form-control ng-model=vc.data.SortSeq ng-change=vc.onChanged()></div></div></div></form></div></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>수신자 목록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ui-keypress=\"{13:\'vc.getGrpcustList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CustNm placeholder=\"고객명 검색\" type=text><div class=\"search_layer mb-5\" ng-click=vc.getGrpcustList() style=\"width:45px !important\"><span class=cursor id=btn_layer_detail_search_open></span><i class=\"fa fa-search\"></i></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" activate-button ng-click=vc.srchTreeModal() ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-repeat\"></i> 선택고객이동</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.srchGrpcustModal() ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-edit\"></i> 고객추가</button> <button class=\"btn btn-danger\" activate-button ng-click=\"vc.deleteGrpcust(\'\')\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-trash-o\"></i> 선택고객삭제</button> <button class=\"btn btn-danger\" activate-button ng-click=\"vc.deleteGrpcust(\'ALL\')\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-trash-o\"></i> 전체고객삭제</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!--                 <div class=\"row\">\r\n                  <div class=\"col-lg-12 text-right\" style=\"padding-bottom:10px;\">\r\n                     <button class=\"btn btn-default\" activate-button ng-click=\"vc.addSmsModal()\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null && vc.grpcustTotalItems > 0\"><i class=\"fa fa-mobile-phone\"></i> SMS발송</button>\r\n                     <button class=\"btn btn-primary\" activate-button ng-click=\"vc.addGrpcustAll()\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-edit\"></i> 전체고객추가</button>\r\n                    <button class=\"btn btn-primary\" activate-button ng-click=\"vc.addGrpcustAll()\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-repeat\"></i> 선택고객이동</button>\r\n                    <button class=\"btn btn-primary\" activate-button ng-click=\"vc.srchGrpcustModal()\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-edit\"></i> 고객추가</button>\r\n                    <button class=\"btn btn-danger\" activate-button ng-click=\"vc.deleteGrpcust(\'\')\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-trash-o\"></i> 선택고객삭제</button>\r\n                    <button class=\"btn btn-danger\" activate-button ng-click=\"vc.deleteGrpcust(\'ALL\')\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-trash-o\"></i> 전체고객삭제</button>\r\n                  </div>\r\n                </div>\r\n --><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.grpcustListColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.grpcustTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.grpcustListColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.grpcustLists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.grpcustListColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.grpcustTotalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.grpcustTotalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div></div></div><!-- pagecontent --></div>");
$templateCache.put("app/chart/chart.html","<div class=row><div class=col-lg-12><h1 class=page-header>Charts</h1></div><!-- /.col-lg-12 --></div><div class=row><div class=\"col-lg-6 col-sm-12\" id=line-chart ng-controller=ChartCtrl><div class=\"panel panel-default\"><div class=panel-heading>Line Chart</div><div class=panel-body></div></div></div><div class=\"col-lg-6 col-sm-12\" id=bar-chart ng-controller=ChartCtrl><div class=\"panel panel-default\"><div class=panel-heading>Bar Chart</div><div class=panel-body></div></div></div></div><div class=row><div class=\"col-lg-6 col-sm-12\" id=doughnut-chart ng-controller=ChartCtrl><div class=\"panel panel-default\"><div class=panel-heading>Doughnut Chart</div><div class=panel-body><flot dataset=dataset0100 options=options0100 height=350px></flot></div></div></div><div class=\"col-lg-6 col-sm-12\" id=radar-chart ng-controller=ChartCtrl><div class=\"panel panel-default\"><div class=panel-heading>Radar Chart</div><div class=panel-body></div></div></div><div class=\"col-lg-6 col-sm-12\" id=pie-chart ng-controller=ChartCtrl><div class=\"panel panel-default\"><div class=panel-heading>Pie Chart</div><div class=panel-body></div></div></div><div class=\"col-lg-6 col-sm-12\" id=\"polar area-chart\" ng-controller=ChartCtrl><div class=\"panel panel-default\"><div class=panel-heading>Polar Area Chart</div><div class=panel-body></div></div></div><div class=\"col-lg-6 col-sm-12\" id=base-chart ng-controller=ChartCtrl><div class=\"panel panel-default\"><div class=panel-heading>Dynamic Chart</div><div class=panel-body><canvas id=base class=\"chart chart-base\" chart-type=dynamic.type data=dynamic.data labels=dynamic.labels legend=true></canvas></div></div><button type=button class=\"btn btn-primary pull-right\" ng-click=dynamic.toggle()>Toggle</button></div></div>");
$templateCache.put("app/community/news-detail.html","<div class=\"page page-footable\" ng-controller=\"NewsDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>뉴스레터</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>제목</label><span class=form-control ng-bind=vc.data.Title></span></div></div></div><div class=row><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>등록일</label><span class=form-control ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>조회수</label><span class=form-control ng-bind=vc.data.ReadCnt></span></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>공개여부</label><span class=form-control ng-bind=vc.data.PublicYN></span></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" style=\"margin-left:75px; padding:5px; border-collapse:collapse; border: 1px solid #ccc\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>내용</label></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" style=\"margin-left:75px; padding:5px; border-collapse:collapse; border: 1px solid #ccc\"><span class=txt_view ng-bind-html=vc.data.Contents|htmlString></span></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/community/news-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"NewsEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>뉴스레터</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form name=theForm><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>제목<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title name=Title minlength=2 required></div></div></div><div class=row><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>공개여부<span class=point_red>*</span></label><common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=vc.data.PublicYN></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}<br><br><br><span style=\"color: #999; font-size: 12px\">* 최적픽셀<br>(305 x 200)</span></label><br><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}<br><br><br><span style=\"color: #999; font-size: 12px\">* 최적픽셀<br>(305 x 200)</span></label><div style=\"margin-left: 75px\" id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 75px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>내용<span class=point_red>*</span></label></div></div></div><div class=row><div class=form-group><div class=col-sm-12 style=padding-left:85px><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/community/news-list.html","<div class=\"page page-footable\" ng-controller=\"NewsListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>뉴스레터<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size=\"40% + 2px\" pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>제목</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.BbsPostId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.BbsPostId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\" ng-bind-html=$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm])></span> <span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/community/notice-detail.html","<div class=\"page page-footable\" ng-controller=\"NoticeDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>공지사항</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>제목</label><span class=form-control ng-bind=vc.data.Title></span></div></div></div><div class=row><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>등록일</label><span class=form-control ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>조회수</label><span class=form-control ng-bind=vc.data.ReadCnt></span></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>공개여부</label><span class=form-control ng-bind=vc.data.PublicYN></span></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>팝업여부</label><span class=form-control ng-bind=vc.data.NoticeYN></span></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" style=\"margin-left:75px; padding:5px; border-collapse:collapse; border: 1px solid #ccc\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>내용</label></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" style=\"margin-left:75px; padding:5px; border-collapse:collapse; border: 1px solid #ccc\"><span class=txt_view ng-bind-html=vc.data.Contents|htmlString></span></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/community/notice-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"NoticeEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>공지사항</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form name=theForm><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>제목<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title name=Title minlength=2 required></div></div></div><div class=row><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>공개여부<span class=point_red>*</span></label><common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=vc.data.PublicYN></common-code-custom></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>팝업여부<span class=point_red>*</span></label><common-code-custom code-list=\"vc.columnMap[\'NoticeYN\'].CodeList\" code-model=vc.data.NoticeYN></common-code-custom></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>상단위치(px)</label><input type=text class=form-control ng-model=vc.data.UpendLC numbers-only maxlength=3></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>왼쪽위치(px)</label><input type=text class=form-control ng-model=vc.data.LeftLC numbers-only maxlength=3></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}<br><br><br><span style=\"color: #999; font-size: 12px\">* 최적픽셀<br>(305 x 200)</span></label><br><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}<br><br><br><span style=\"color: #999; font-size: 12px\">* 최적픽셀<br>(305 x 200)</span></label><div style=\"margin-left: 75px\" id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 75px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>내용<span class=point_red>*</span></label></div></div></div><div class=row><div class=form-group><div class=col-sm-12 style=padding-left:85px><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/community/notice-list.html","<div class=\"page page-footable\" ng-controller=\"NoticeListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>공지사항<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size=\"40% + 2px\" pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>제목</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.BbsPostId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.BbsPostId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\" ng-bind-html=$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm])></span> <span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/community/winners-detail.html","<div class=\"page page-footable\" ng-controller=\"WinnersDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>위너스소식</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>제목</label><span class=form-control ng-bind=vc.data.Title></span></div></div></div><div class=row><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>등록일</label><span class=form-control ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>조회수</label><span class=form-control ng-bind=vc.data.ReadCnt></span></div></div><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>공개여부</label><span class=form-control ng-bind=vc.data.PublicYN></span></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" style=\"margin-left:75px; padding:5px; border-collapse:collapse; border: 1px solid #ccc\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>내용</label></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" style=\"margin-left:75px; padding:5px; border-collapse:collapse; border: 1px solid #ccc\"><span class=txt_view ng-bind-html=vc.data.Contents|htmlString></span></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/community/winners-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"WinnersEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>위너스소식</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form name=theForm><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>제목<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title name=Title minlength=2 required></div></div></div><div class=row><div class=\"col-lg-3 col-md-6\"><div class=\"form-group form-inline\"><label>공개여부<span class=point_red>*</span></label><common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=vc.data.PublicYN></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}<br><br><br><span style=\"color: #999; font-size: 12px\">* 최적픽셀<br>(305 x 200)</span></label><br><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}<br><br><br><span style=\"color: #999; font-size: 12px\">* 최적픽셀<br>(305 x 200)</span></label><div style=\"margin-left: 75px\" id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 75px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>내용<span class=point_red>*</span></label></div></div></div><div class=row><div class=form-group><div class=col-sm-12 style=padding-left:85px><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/community/winners-list.html","<div class=\"page page-footable\" ng-controller=\"WinnersListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>위너스소식<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size=\"40% + 2px\" pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>제목</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.BbsPostId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.BbsPostId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-if=\"liCol.ColumnLogicalDataType == \'40\'\">{{li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\'}}</span> <span ng-if=\"liCol.ColumnLogicalDataType == \'60\'\" ng-bind-html=$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm])></span> <span ng-if=\"liCol.ColumnLogicalDataType != \'40\' && liCol.ColumnLogicalDataType != \'60\'\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-add-batch.html","<!-- 고객정보 --><div id=divCustomerTab1 ng-controller=\"CustomerAddBatchCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.setPrint() ng-if=\"vc.data.KeyId != \'\'\"><i class=\"fa fa-print\"></i> 인쇄</button><!-- <button class=\"btn btn-default\" ng-click=\"vc.setSaveToPdf()\" ng-if=\"vc.data.KeyId != \'\'\">\r\n              <i class=\"fa  fa-file-pdf-o\"></i> PDF저장\r\n            </button>--> <button class=\"btn btn-primary\" ng-click=vc.uploadFileCust()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Clause | 회원약관</strong><div cl ass=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /panel header --><!-- panel body --><div class=\"panel-body collapse in\" style=\"height: 320px\"><!-- 약관 --><div class=row><div class=col-lg-12><div class=\"bs-callout bs-callout-info\" id=callout-navs-tabs-plugin><div class=member-comment-box><ul class=comment><li>장피셜 제품은 장피셜 아카데미의 교육을 이수 받은 전문가가 직접 관리/적용 하는 제품입니다. 장피셜의 모든 제품은 문제성 피부의 개선을 목적으로 하는 코스메슈티컬 제품으로 안전성이 비교적 낮습니다.<br><br>따라서 본인의 컨디션 및 피부상태, 잘못된 사후 관리 등으로 여러 현상이 발생 할 수 있기 때문에 장피셜 트리트먼트를 받는 기간 동안 전문가의 지시사항을 100% 이행하셔야 합니다.</li></ul></div><div class=member-comment-box--red><ul class=comment><li>장피셜 트리트먼트는 관리 기간 동안 고영양 현상으로 인한 트러블과 같은 반응이 언제든 발생 할 수 있습니다. 이는 치료를 목적으로 하는 고영양성분의 약용 화장품이 갖는 특징으로 전문가의 적절한 피드백으로 피부의 개선을 보장하는 내용 외 별도의 법적 물적 보상은 없습니다.</li><li>당일 예약 취소, 변경 시 티겟팅 관리 횟수에서 1회가 차감됩니다.</li><li>불가피한 사유로 관리를 받을 수 없을 시 관리권, 제품의 환불 요청 시에는 티겟팅금액/관리횟수를 차감한 금액을 정산합니다.</li></ul></div></div></div></div><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12\"><div class=\"col-sm-3 col-md-4 col-lg-3 pl-0\"><div class=checkbox><label class=\"ng-binding inb wd-100p txt-right\">위 약관에 동의합니다.</label></div></div><!-- /col --><div class=\"col-sm-3 col-md-4 col-lg-3 pr-0 pl-0\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.AgreeDt = (vc.AgreeDt | date: \'yyyy-MM-dd\')\" ng-model=vc.AgreeDt ng-required=false placeholder=동의일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- /col --><div class=\"col-sm-2 col-md-4 col-lg-3 pr-0\"><div class=\"form-group form-inner-label\"><label class=ng-binding>고객명</label><input aria-invalid=false class=\"form-control form-right ng-pristine ng-valid ng-empty ng-touched\" maxlength=200 ng-model=vc.data.CustNm placeholder=\"\" type=text></div></div><!-- /col --><div class=\"col-sm-4 col-md-4 col-lg-3\"><div class=\"form-group form-inner-label\"><label class=ng-binding>(서명)</label><div class=input-group><canvas id=agreeSignPad></canvas><span class=\"input-group-btn cus-btn\"><button class=\"btn btn-default\" id=btn-agree-clear type=button><em class=\"fa fa-eraser\"></em></button></span></div></div></div><!-- /col --></div></div><!-- /row --><!-- /col --></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step1 | 개인 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>고객명</label><input class=form-control maxlength=200 ng-model=vc.data.CustNm type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input class=mr-5 id=rdoGenderM name=Gender ng-checked-=\"vc.data.Gender == \'M\'\" ng-model=vc.data.Gender type=radio value=M>남</label><label class=radio-inline><input id=rdoGenderF name=Gender ng-checked-=\"vc.data.Gender == \'F\'\" ng-model=vc.data.Gender type=radio value=F>여</label></div></div></div></div><!-- /col --><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>연락처</label><input class=form-control maxlength=13 ng-model=vc.data.Mobile numbers-hyphen type=text></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input class=mr-5 id=rdoSMSY name=SmsYN ng-checked-=\"vc.data.SmsYN == \'Y\'\" ng-model=vc.data.SmsYN type=radio value=Y>SMS 수신동의</label><label class=radio-inline><input id=rdoSMSN name=SmsYN ng-checked-=\"vc.data.SmsYN == \'N\'\" ng-model=vc.data.SmsYN type=radio value=N>SMS 수신거부</label></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input class=form-control id=ZipCode maxlength=7 ng-model=vc.data.ZipCode readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchZipCodeModal() type=button><i class=\"fa fa-search\"></i></button> </span><input class=form-control id=Addr1 maxlength=200 ng-model=vc.data.Addr1 type=text></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input class=form-control id=Addr2 maxlength=200 ng-model=vc.data.Addr2 type=text></div></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>생년월일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.BirthDay = (vc.BirthDay | date: \'yyyy-MM-dd\')\" ng-model=vc.BirthDay ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 xs-mb10\"><label class=radio-inline><input class=mr-5 id=rdoLnrSlrTypeL name=LnrSlrType ng-checked-=\"vc.data.LnrSlrType == \'L\'\" ng-model=vc.data.LnrSlrType type=radio value=L>음력</label><label class=radio-inline><input class=mr-5 id=rdoLnrSlrTypeS name=LnrSlrType ng-checked-=\"vc.data.LnrSlrType == \'S\'\" ng-model=vc.data.LnrSlrType type=radio value=S>양력</label></div></div><!-- /col --></div><!-- /row   --></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>등록일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.CustRegDt = (vc.CustRegDt | date: \'yyyy-MM-dd\')\" ng-model=vc.CustRegDt ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-12\"><div class=\"form-group form-inline xs-mb10\"><label>직업</label><input class=form-control maxlength=100 ng-model=vc.data.Job type=text></div></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>방문경로</label><div class=\"inline-box brd1 p-10 bd-rd4\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input id=rdoVisitPath100 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'100\'\" ng-model=vc.data.VisitPath type=radio value=100>블로그</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input id=rdoVisitPath200 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'200\'\" ng-model=vc.data.VisitPath type=radio value=200>카페</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input id=rdoVisitPath300 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'300\'\" ng-model=vc.data.VisitPath type=radio value=300>인스타그램</label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input id=rdoVisitPath400 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'400\'\" ng-model=vc.data.VisitPath type=radio value=400>소개 <input class=form-control maxlength=10 ng-disabled=\"vc.data.VisitPath != \'400\'\" ng-model=vc.data.VisitPathPromoId type=text></label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input id=rdoVisitPath500 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'500\'\" ng-model=vc.data.VisitPath type=radio value=500>기타 <input class=\"form-control wd181\" maxlength=100 ng-disabled=\"vc.data.VisitPath != \'500\'\" ng-model=vc.data.VisitPathEtc type=text></label></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=sz-custom-select-tenant><section class=tile fullscreen=isFullscreen06><!-- ngIf: header.checkUse --><div class=\"form-group ng-scope\" ng-if=header.checkUse><div class=\"input-group custom-search-form\"><input aria-invalid=false class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" ng-click=header.srchTenantModal(); ng-model=header.TENANTNAME readonly type=text> <input aria-invalid=false autocomplete=off class=\"ng-pristine ng-untouched ng-valid ng-not-empty\" ng-model=header.TENANTID type=hidden> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=header.srchTenantModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=header.eraseTenant(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- end ngIf: header.checkUse --></section></div></div><!-- /col --></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>특이사항</label><input class=form-control maxlength=200 ng-model=vc.data.SpcNote placeholder=\"e.g.) 알러지성 질환, 복용중인 약물, 신체 질환\" type=text></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>E-mail</label><input class=form-control maxlength=255 ng-model=vc.data.Email type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>파머등급</label><common-code-custom code-list=\"vc.columnMap[\'CustGrade\'].CodeList\" code-model=vc.data.CustGrade is-disabled=true></common-code-custom></div></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>담당자</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>추천인코드</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.RecomendrCd ng-disabled=\"vc.data.RecomendrCd != null && vc.data.RecomendrCd !=\'\'\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.checkedRecomendrCd() type=button><i class=\"glyphicon glyphicon glyphicon-ok\"></i></button></span></div></div></div></div><div class=row ng-if=\"vc.data.KeyId != \'\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>소개인원</label><input class=form-control ng-disabled=true type=text></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>내추천인코드</label><div class=input-group><button ng-if=\"$root.gVariable.srchTenantId == 0 && (vc.data.MyRecomendrCd == null || vc.data.MyRecomendrCd ==\'\')\" class=\"btn btn-default\" ng-click=vc.setCode()><span class=\"glyphicon glyphicon-check\">코드발급</span></button> <input type=text class=\"form-control form-right\" ng-if=\"$root.gVariable.srchTenantId != 0 || (vc.data.MyRecomendrCd != null && vc.data.MyRecomendrCd !=\'\')\" maxlength=255 ng-model=vc.data.MyRecomendrCd readonly></div></div></div></div><div class=row ng-if=\"vc.data.KeyId != \'\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>현재PP</label><input class=form-control ng-disabled=true type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>회원보유수</label><input class=form-control ng-disabled=true type=text></div></div></div></div></div><!-- /row --></div></div><!-- row 과거 관리 및 시술이력 / 홈케어정보--><div class=row><!-- col 과거관리 및 시술 이력--><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step2 | 과거 관리 및 시술 이력</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-12 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist01YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist01YN ng-true-value=\"\'Y\'\" type=checkbox>보습, 미백, 여드름,노화관리</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist01SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist01SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist01SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist01SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist02YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist02YN ng-true-value=\"\'Y\'\" type=checkbox>MTS, 필링</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist02SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist02SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist02SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist02SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist03YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist03YN ng-true-value=\"\'Y\'\" type=checkbox>레이저 시술</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist03SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist03SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist03SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist03SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist04YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist04YN ng-true-value=\"\'Y\'\" type=checkbox>보톡스, 필러, 실리프팅</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist04SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist04SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist04SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist04SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-12 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=\"checkbox sm-mb0\"><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist05YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist05YN ng-true-value=\"\'Y\'\" type=checkbox>지방이식, 보형물 등의 삽입 성형 수술</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=form-group><div class=\"checkbox sm-mb0\"><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist05SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist05SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist05SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist05SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --></div><!-- /tile body --></div></div><!-- /col 과거관리 및 시술 이력 --><!-- col 홈케어 정보--><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>홈 케어 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare01YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare01YN ng-true-value=\"\'Y\'\" type=checkbox>클렌징</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare01YN == \'N\'\" ng-model=vc.data.HomeCare01PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare01YN == \'N\'\" ng-model=vc.data.HomeCare01Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare02YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare02YN ng-true-value=\"\'Y\'\" type=checkbox>데이</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare02YN == \'N\'\" ng-model=vc.data.HomeCare02PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare02YN == \'N\'\" ng-model=vc.data.HomeCare02Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb5 xs-mt10\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare03YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare03YN ng-true-value=\"\'Y\'\" type=checkbox>나이트</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare03YN == \'N\'\" ng-model=vc.data.HomeCare03PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare03YN == \'N\'\" ng-model=vc.data.HomeCare03Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb5 xs-mt10\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare04YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare04YN ng-true-value=\"\'Y\'\" type=checkbox>각질제거</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare04YN == \'N\'\" ng-model=vc.data.HomeCare04PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare04YN == \'N\'\" ng-model=vc.data.HomeCare04Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb0 xs-mt10\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare05YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare05YN ng-true-value=\"\'Y\'\" type=checkbox>기타(팩)</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare05YN == \'N\'\" ng-model=vc.data.HomeCare05PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare05YN == \'N\'\" ng-model=vc.data.HomeCare05Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><!-- /row --></div><!-- /tile body --></div></div><!-- /col 홈케어 정보--></div><!-- row 과거 관리 및 시술이력 / 홈케어정보--><!-- row 섹터별 특징 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step3 | 섹터별 특징</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 plr-0\"><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector01YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector01YN ng-true-value=\"\'Y\'\" type=checkbox>Sebum Area / 피지분포 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector02YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector02YN ng-true-value=\"\'Y\'\" type=checkbox>White Acne Area / 좁쌀 여드름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector03YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector03YN ng-true-value=\"\'Y\'\" type=checkbox>Anti Acne Area / 염즘성 여드름</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector04YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector04YN ng-true-value=\"\'Y\'\" type=checkbox>Pore Area / 모공 확장 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector05YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector05YN ng-true-value=\"\'Y\'\" type=checkbox>Scar Area / 상처 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector06YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector06YN ng-true-value=\"\'Y\'\" type=checkbox>Melano Area / 색소 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector07YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector07YN ng-true-value=\"\'Y\'\" type=checkbox>Dry Area / 건조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector08YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector08YN ng-true-value=\"\'Y\'\" type=checkbox>Wrinkle Area / 옅은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector09YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector09YN ng-true-value=\"\'Y\'\" type=checkbox>Deep Wrinkle Area / 깊은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector10YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector10YN ng-true-value=\"\'Y\'\" type=checkbox>Fush Area / 홍조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector11YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector11YN ng-true-value=\"\'Y\'\" type=checkbox>Telangiectasia Area / 모세혈관 확장</label></div></div><!-- /col --></div></div></div><!-- /tile body --></div><!-- /panel --><!-- row 섹터별 특징 / 얼굴이미지--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step3 | 섹터별 특징 - Face</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"text-center pt-10 min-h312\"><div class=cus-edit-face><img src=assets/images/face-image.png><canvas height=495 id=faceSignPad></canvas><button class=\"btn btn-default\" id=btn-face-clear type=button><em class=\"fa fa-eraser\"></em></button></div></div></div></div><!-- /tile body --></div><!-- /panel --></div><!-- /col 섹터별 특징 --><!-- row 현재의피부 상황 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step4 | 현재의 피부 상황 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control ng-model=vc.data.CurSkinStory rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span aria-hidden=true class=\"glyphicon glyphicon-exclamation-sign\"></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">- 현재 피부 상태는 어떠한지에 대해서 고객이 직접 이야기하는 내용을 입력</div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의피부 상황 이야기--><!-- row 과거의 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step5 | 과거의 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control ng-model=vc.data.PastSkinStory rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span aria-hidden=true class=\"glyphicon glyphicon-exclamation-sign\"></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">-현재피부가 과거에도 그랬는지 과거에는 피부가 어땠는지 입력<br>-과거에 피부가 좋았다면 그때는 어떤 이로운점이 있었는지 입력<br>-과거에 피부가 안좋았다면 그때는 어떤 점이 불편했는지 입력</div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /과거의 이야기--><!-- row 현재의 결심 그리고 미래에 대한 이야기--><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step6 | 현재의 결심 그리고 미래에 대한 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control ng-model=vc.data.FutureSkinStory rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span aria-hidden=true class=\"glyphicon glyphicon-exclamation-sign\"></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">-현재의 피부를 만약 고치지 않고 그대로 방치했을때 현재와 미래에 어떤 불이익, 안좋은상황이 올것인지에 대해 발설유도 하며 최악의 상황을 세세히 그려줌<br>-현재 피부는 어떤상태이니 어느정도의 노력과, 시간이 투자된다면, 어떤피부상태가 될것인지에 대해서 예상시켜줌<br>-그리고 피부가 그렇게 좋아졌을때 기분이 어떨것같은지, 현재 어떻게 바뀔것 같은지, 너의 미래는 어떻게 될것같은지에 대해 발설유도.<br></div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의 결심 그리고 미래에 대한 이야기--><!-- row 관리 처방--><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step7 | 관리처방</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-6 col-md-6 col-lg-6 col-xl-6\"><label class=ng-binding>전체품목</label><table class=\"table table-condensed table-typeA mt-5\"><colgroup><col style=\"width: 55%\"><col style=\"width: 42%\"><col style=\"width: auto\"></colgroup><thead><tr><td>품목명</td><td>금액</td><td>선택</td></tr></thead><tbody><tr ng-repeat=\"li in vc.productList\"><td><span ng-bind=li.ProductNm></span></td><td class=txt-center><span comma-bind ng-bind=li.ProductAmt></span></td><td><button class=\"btn btn-default mt-10 mb-10\" ng-click=vc.setAddProduct(li)><span class=\"glyphicon glyphicon-check\">선택</span></button></td></tr></tbody></table></div><!-- /col --><div class=\"col-xs-6 col-md-6 col-lg-6 col-xl-6\"><label class=ng-binding>선택 품목</label><table class=\"table table-condensed table-typeA mt-5\"><colgroup><col style=\"width: 54%\"><col style=\"width: 20%\"><col style=\"width: 13%\"><col style=\"width: 13%\"></colgroup><thead><tr><td>품목명</td><td>금액</td><td>횟수</td><td>삭제</td></tr></thead><tbody><tr ng-repeat=\"li in vc.cvsMngPrscrptn\"><td><span ng-bind=li.ProductNm></span></td><td class=txt-center><span comma-bind ng-bind=li.ProductAmt></span></td><td><input class=\"form-control text-right\" maxlength=3 ng-model=li.MngCnt numbers-only=\"\" type=text></td><td class=text-center style=vertical-align:middle><button class=\"btn btn-default mt-10 mb-10\" ng-click=vc.setDelProduct(li)><i class=\"fa fa-times\"></i>삭제</button></td></tr></tbody></table></div><!-- /col --></div><!-- /row --></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /관리 처방--><!-- row 복용약--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step8 | 복용약</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=col-sm-12><textarea class=form-control maxlength=1000 ng-model=vc.data.Medication rows=5></textarea></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /복용약--><!-- row 고객관리 사진--><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step9 | 고객관리 사진</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><div><file-attach callback=vc.onFileCallback file-data=vc.uploadFileListCust></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form enctype=Multipart/Form-Data id=frmCust method=post runat=server><div class=\"vault-block ml-0 wd-100p\" id=vaultCust></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileListCust\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox aria-label=Check class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" md-no-ink=\"\" ng-false-value=\"\'\'\" ng-model=fli.delState ng-true-value=\"\'delete\'\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /고객관리 사진--><!-- row 상담--><div class=row ng-if=\"vc.srch.keyId == \'\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step10 | 상담</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-12\"><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>상담일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.CounselDt = (vc.CounselDt | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDt ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0\"><div class=\"form-group form-inline\"><label>상담내용</label><textarea class=form-control maxlength=1000 ng-model=vc.data.CounselContents rows=5></textarea></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><div><file-attach callback=vc.onFileCallback file-data=vc.uploadFileListCounsel></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form enctype=Multipart/Form-Data id=frmCounsel method=post runat=server><div class=\"vault-block ml-0 wd-100p\" id=vaultCounsel></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileListCounsel\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox aria-label=Check class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" md-no-ink=\"\" ng-false-value=\"\'\'\" ng-model=fli.delState ng-true-value=\"\'delete\'\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /상담--></div><!-- /pagecontent --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!--</form>--><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.setPrint() ng-if=\"vc.data.KeyId != \'\'\"><i class=\"fa fa-print\"></i> 인쇄</button><!--<button class=\"btn btn-default\" ng-click=\"vc.setSaveToPdf()\" ng-if=\"vc.data.KeyId != \'\'\">\r\n                  <i class=\"fa  fa-file-pdf-o\"></i> PDF\r\n                </button>--> <button activate-button class=\"btn btn-primary\" ng-click=vc.uploadFileCust()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page --></div></div>");
$templateCache.put("app/customer/customer-detail-print.html","<!DOCTYPE html><html lang=en><head><title>Jeanficial Inc | 장피셜</title><meta charset=utf-8><meta content=\"\" name=description><meta content=\"width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no\" name=viewport><meta content=-1 http-equiv=Expires><meta content=no-cache http-equiv=Pragma><meta content=No-Cache http-equiv=Cache-Control><!--\r\n    <link rel=\"stylesheet\" href=\"assets/css/common.css\">\r\n    <link rel=\"stylesheet\" href=\"assets/css/custom-media-width-size.css\">\r\n\r\n    <script src=\"assets/app/common/common.js\"></script>\r\n    <script src=\"https://cdn.jsdelivr.net/npm/signature_pad@2.3.0/dist/signature_pad.min.js\"></script>\r\n  --></head><body><iframe height=600px src=#/app/customer/customer-detail-tab1.html width=100%></iframe></body></html>");
$templateCache.put("app/customer/customer-detail-tab1.html","<style>.col-lg-6 {\r\n    width: 50% !important;\r\n    float: left;\r\n  }</style><!-- 고객정보 --><div class=divCustomerDetailTab1 id=divCustomerDetailTab1 ng-controller=\"CustomerDetailTab1Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Clause | 회원약관</strong></div><!-- /panel header --><!-- panel body --><div class=\"panel-body collapse in\" style=\"height: 380px\"><!-- 약관 --><div class=row><div class=col-lg-12><div class=\"bs-callout bs-callout-info\" id=callout-navs-tabs-plugin><div class=member-comment-box><ul class=comment><li>장피셜 제품은 장피셜 아카데미의 교육을 이수 받은 전문가가 직접 관리/적용 하는 제품입니다. 장피셜의 모든 제품은 문제성 피부의 개선을 목적으로 하는 코스메슈티컬 제품으로 안전성이 비교적 낮습니다.<br><br>따라서 본인의 컨디션 및 피부상태, 잘못된 사후 관리 등으로 여러 현상이 발생 할 수 있기 때문에 장피셜 트리트먼트를 받는 기간 동안 전문가의 지시사항을 100% 이행하셔야 합니다.</li></ul></div><div class=member-comment-box--red><ul class=comment><li>장피셜 트리트먼트는 관리 기간 동안 고영양 현상으로 인한 트러블과 같은 반응이 언제든 발생 할 수 있습니다. 이는 치료를 목적으로 하는 고영양성분의 약용 화장품이 갖는 특징으로 전문가의 적절한 피드백으로 피부의 개선을 보장하는 내용 외 별도의 법적 물적 보상은 없습니다.</li><li>당일 예약 취소, 변경 시 티겟팅 관리 횟수에서 1회가 차감됩니다.</li><li>불가피한 사유로 관리를 받을 수 없을 시 관리권, 제품의 환불 요청 시에는 티겟팅금액/관리횟수를 차감한 금액을 정산합니다.</li></ul></div></div></div><div class=col-lg-12><ul class=cus-detail-agree><li><span>위 약관에 동의합니다.</span></li><li><span>{{vc.data.AgreeDt | date:\'yyyy-MM-dd\':\'+9:00\'}}</span></li><li style=\"height: 100px\"><span ng-bind=vc.data.CustNm></span><span style=display:inline-block><img id=agreeSignPadImg src={{vc.data.SignImage}} style=\"width: 399px; height: 80px\"></span></li><!--<li >\r\n\r\n                </li>--><li><span><canvas id=agreeSignPad style=\"display: none\"></canvas></span></li></ul></div></div><!-- /col --></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step1 | 개인 정보</strong></div><!-- /tile header --><div class=\"panel-body collapse in\"><table class=cus-detail-table><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tr><th>고객명</th><td><span ng-bind=vc.data.CustNm class=\"print-span mr-10\"></span> <input class=mr-5 id=rdoGenderM name=Gender ng-checked-=\"vc.data.Gender == \'M\'\" ng-disabled=true ng-model=vc.data.Gender type=radio value=M>남 <input id=rdoGenderF name=Gender ng-checked-=\"vc.data.Gender == \'F\'\" ng-disabled=true ng-model=vc.data.Gender type=radio value=F>여</td><th>연락처</th><td><span ng-bind=vc.data.Mobile class=\"print-span mr-10\"></span><br><input class=mr-5 id=rdoSMSY name=SmsYN ng-checked-=\"vc.data.SmsYN == \'Y\'\" ng-disabled=true ng-model=vc.data.SmsYN type=radio value=Y>SMS 수신동의<input id=rdoSMSN name=SmsYN ng-checked-=\"vc.data.SmsYN == \'N\'\" ng-disabled=true ng-model=vc.data.SmsYN type=radio value=N>SMS 수신거부</td></tr><tr><th>주소</th><td colspan=3><span ng-bind=vc.data.ZipCode class=print-span></span> <span ng-bind=vc.data.Addr1 class=print-span></span></td></tr><tr><th>생년월일</th><td><span class=print-span>{{vc.data.BirthDay | date:\'yyyy-MM-dd\':\'+9:00\'}}</span><br><label class=radio-inline><input class=mr-5 id=rdoLnrSlrTypeL name=LnrSlrType ng-checked-=\"vc.data.LnrSlrType == \'L\'\" ng-disabled=true ng-model=vc.data.LnrSlrType type=radio value=L>음력</label><label class=radio-inline><input class=mr-5 id=rdoLnrSlrTypeS name=LnrSlrType ng-checked-=\"vc.data.LnrSlrType == \'S\'\" ng-disabled=true ng-model=vc.data.LnrSlrType type=radio value=S>양력</label></td><th>등록일</th><td><span class=print-span>{{vc.data.CustRegDt | date:\'yyyy-MM-dd\':\'+9:00\'}}</span></td></tr><tr><th>직업</th><td colspan=3><span ng-bind=vc.data.Job class=print-span></span></td></tr><tr><th>방문경로</th><td colspan=3><label class=radio-inline><input id=rdoVisitPath100 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'100\'\" ng-disabled=true ng-model=vc.data.VisitPath type=radio value=100>블로그</label><label class=radio-inline><input id=rdoVisitPath200 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'200\'\" ng-disabled=true ng-model=vc.data.VisitPath type=radio value=200>카페</label><label class=radio-inline><input id=rdoVisitPath300 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'300\'\" ng-disabled=true ng-model=vc.data.VisitPath type=radio value=300>인스타그램</label><br><label class=radio-inline><input id=rdoVisitPath400 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'400\'\" ng-disabled=true ng-model=vc.data.VisitPath type=radio value=400>소개 <input class=\"form-control inb\" maxlength=10 ng-disabled=true ng-model=vc.data.VisitPathPromoId type=text></label><label class=radio-inline><input id=rdoVisitPath500 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'500\'\" ng-disabled=true ng-model=vc.data.VisitPath type=radio value=500>기타 <input class=\"form-control inb\" maxlength=100 ng-disabled=true ng-model=vc.data.VisitPathEtc type=text></label></td></tr><tr><th>특이사항</th><td colspan=3><span ng-bind=vc.data.SpcNote class=print-span></span></td></tr><tr><th>E-mail</th><td><span ng-bind=vc.data.Email class=print-span></span></td><th>파머등급</th><td><common-code-custom code-list=\"vc.columnMap[\'CustGrade\'].CodeList\" code-model=vc.data.CustGrade is-disabled=true></common-code-custom></td></tr><tr><th>담당자</th><td><span ng-bind=vc.data.ManagerNm class=print-span></span></td><th>소개인원</th><td><span class=print-span>0</span></td></tr><tr><th>현재CC</th><td><span class=print-span>0</span></td><th>회원보유수</th><td><span class=print-span>0</span></td></tr></table><!-- /row --></div></div><div class=row><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>Step2 | 과거 관리 및 시술 이력</strong></div><div class=\"panel-body collapse in\"><table class=cus-detail-tableB><colgroup><col style=\"width: 60%\"><col style=\"width: 40%\"></colgroup><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist01YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist01YN ng-true-value=\"\'Y\'\" type=checkbox>보습, 미백, 여드름,노화관리</label></td><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist01SdEftYN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist01SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label><span ng-bind=vc.data.TrtmtHist01SdEftDtl class=cus-detail-input></span></td></tr><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist02YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist02YN ng-true-value=\"\'Y\'\" type=checkbox>MTS, 필링</label></td><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist02SdEftYN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist02SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label><span ng-bind=vc.data.TrtmtHist02SdEftDtl class=cus-detail-input></span></td></tr><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist03YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist03YN ng-true-value=\"\'Y\'\" type=checkbox>레이저 시술</label></td><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist03SdEftYN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist03SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label><span ng-bind=vc.data.TrtmtHist03SdEftDtl></span></td></tr><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist04YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist04YN ng-true-value=\"\'Y\'\" type=checkbox>보톡스, 필러, 실리프팅</label></td><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist04SdEftYN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist04SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label><span ng-bind=vc.data.TrtmtHist04SdEftDtl></span></td></tr><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist05YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist05YN ng-true-value=\"\'Y\'\" type=checkbox>지방이식, 보형물 등의 삽입 성형 수술</label></td><td><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist05SdEftYN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist05SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label><span ng-bind=vc.data.TrtmtHist05SdEftDtl></span></td></tr></table></div><!--panel-body--></div><!--panel--></div><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>홈케어 정보</strong></div><div class=\"panel-body collapse in\"><table class=cus-detail-tableB><colgroup><col style=\"width: 30%\"><col style=\"width: 35%\"><col style=\"width: 35%\"></colgroup><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare01YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare01YN ng-true-value=\"\'Y\'\" type=checkbox>클렌징</label></td><td><span ng-bind=vc.data.HomeCare01PrdNm></span></td><td><span ng-bind=vc.data.HomeCare01Usage></span></td></tr><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare02YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare02YN ng-true-value=\"\'Y\'\" type=checkbox>데이</label></td><td><span ng-bind=vc.data.HomeCare02PrdNm></span></td><td><span ng-bind=vc.data.HomeCare02Usage></span></td></tr><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare03YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare03YN ng-true-value=\"\'Y\'\" type=checkbox>나이트</label></td><td><span ng-bind=vc.data.HomeCare03PrdNm></span></td><td><span ng-bind=vc.data.HomeCare03Usage></span></td></tr><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare04YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare04YN ng-true-value=\"\'Y\'\" type=checkbox>각질제거</label></td><td><span ng-bind=vc.data.HomeCare04PrdNm></span></td><td><span ng-bind=vc.data.HomeCare04Usage></span></td></tr><tr><td><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare05YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare05YN ng-true-value=\"\'Y\'\" type=checkbox>기타(팩)</label></td><td><span ng-bind=vc.data.HomeCare05PrdNm></span></td><td><span ng-bind=vc.data.HomeCare05Usage></span></td></tr></table></div><!--panel-body--></div><!--panel--></div></div><!-- row 섹터별 특징 --><div class=row><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>Step3 | 섹터별 특징</strong></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"col-lg-12 plr-0\"><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector01YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector01YN ng-true-value=\"\'Y\'\" type=checkbox>Sebum Area / 피지분포 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector02YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector02YN ng-true-value=\"\'Y\'\" type=checkbox>White Acne Area / 좁쌀 여드름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector03YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector03YN ng-true-value=\"\'Y\'\" type=checkbox>Anti Acne Area / 염즘성 여드름</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector04YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector04YN ng-true-value=\"\'Y\'\" type=checkbox>Pore Area / 모공 확장 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector05YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector05YN ng-true-value=\"\'Y\'\" type=checkbox>Scar Area / 상처 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector06YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector06YN ng-true-value=\"\'Y\'\" type=checkbox>Melano Area / 색소 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector07YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector07YN ng-true-value=\"\'Y\'\" type=checkbox>Dry Area / 건조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector08YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector08YN ng-true-value=\"\'Y\'\" type=checkbox>Wrinkle Area / 옅은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector09YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector09YN ng-true-value=\"\'Y\'\" type=checkbox>Deep Wrinkle Area / 깊은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector10YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector10YN ng-true-value=\"\'Y\'\" type=checkbox>Fush Area / 홍조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector11YN == \'Y\'\" ng-disabled=true ng-false-value=\"\'N\'\" ng-model=vc.data.Sector11YN ng-true-value=\"\'Y\'\" type=checkbox>Telangiectasia Area / 모세혈관 확장</label></div></div><!-- /col --></div></div></div><!-- /tile body --></div><!-- /panel --><!-- row 섹터별 특징 / 얼굴이미지--><div class=col-lg-6><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>Step3 | 섹터별 특징 - Face</strong></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"text-center pt-10 min-h312\"><div class=cus-edit-face><img src=assets/images/face-image.png><canvas height=495 id=faceSignPad></canvas><!--<button class=\"btn btn-default\" id=\"btn-face-clear\" type=\"button\">\r\n                    <em class=\"fa fa-eraser\"></em>\r\n                  </button>--></div></div></div></div><!-- /tile body --></div><!-- /panel --></div><!-- /col 섹터별 특징 --><!-- row 현재의피부 상황 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step4 | 현재의 피부 상황 이야기</strong></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=col-lg-12><span ng-bind=vc.data.CurSkinStory style=white-space:pre-wrap></span></div><!--<div class=\"col-lg-12 brd-t1 mt-10 pt-10\">\r\n                <span class=\"text-warning pr-0\">\r\n                  <strong><span aria-hidden=\"true\" class=\"glyphicon glyphicon-exclamation-sign\"></span>\r\n                    TIP</strong> <br>\r\n                  - 현재 피부 상태는 어떠한지에 대해서 고객이 직접 이야기하는 내용을 입력\r\n                </span>\r\n              </div>--></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의피부 상황 이야기--><!-- row 과거의 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step5 | 과거의 이야기</strong></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=col-lg-12><span ng-bind=vc.data.PastSkinStory style=white-space:pre-wrap></span></div><!-- <div class=\"col-lg-12 brd-t1 mt-10 pt-10\">\r\n                 <span class=\"text-warning pr-0\">\r\n                  <strong><span aria-hidden=\"true\" class=\"glyphicon glyphicon-exclamation-sign\"></span>\r\n                     TIP</strong> <br>\r\n                 -현재피부가 과거에도 그랬는지 과거에는 피부가 어땠는지 입력 <br> -과거에 피부가 좋았다면 그때는 어떤 이로운점이 있었는지 입력 <br> -과거에 피부가 안좋았다면\r\n                 그때는\r\n                 어떤 점이 불편했는지 입력\r\n               </div>--></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /과거의 이야기--><!-- row 현재의 결심 그리고 미래에 대한 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step6 | 현재의 결심 그리고 미래에 대한 이야기</strong></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=col-lg-12><span ng-bind=vc.data.FutureSkinStory style=white-space:pre-wrap></span></div><!--<div class=\"col-lg-12 brd-t1 mt-10 pt-10\">\r\n                <span class=\"text-warning pr-0\">\r\n                 <strong><span aria-hidden=\"true\" class=\"glyphicon glyphicon-exclamation-sign\"></span>\r\n                    TIP</strong> <br>\r\n                -현재의 피부를 만약 고치지 않고 그대로 방치했을때 현재와 미래에 어떤 불이익, 안좋은상황이 올것인지에 대해 발설유도 하며 최악의 상황을 세세히 그려줌 <br> -현재\r\n                피부는 어떤상태이니 어느정도의 노력과, 시간이 투자된다면, 어떤피부상태가 될것인지에 대해서 예상시켜줌<br> -그리고 피부가 그렇게 좋아졌을때 기분이 어떨것같은지, 현재 어떻게\r\n                바뀔것 같은지, 너의 미래는 어떻게 될것같은지에 대해 발설유도.\r\n              </div>--></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의 결심 그리고 미래에 대한 이야기--><!-- row 관리 처방--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step7 | 관리처방</strong></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><!-- /col --><div class=col-sm-12><table class=\"table table-condensed table-typeA mt-5 fnt12\"><colgroup><col style=\"width: 54%\"><col style=\"width: 20%\"><col style=\"width: 13%\"></colgroup><thead><tr><td>품목명</td><td>금액</td><td>횟수</td></tr></thead><tbody><tr ng-repeat=\"li in vc.cvsMngPrscrptn\"><td><span ng-bind=li.ProductNm></span></td><td class=txt-center><span comma-bind ng-bind=li.ProductAmt></span></td><td class=txt-center><span ng-bind=li.MngCnt></span></td></tr></tbody></table></div><!-- /col --></div><!-- /row --></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /관리 처방--><!-- row 복용약--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step8 | 복용약</strong></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=col-sm-12><span ng-bind=vc.data.Medication style=white-space:pre-wrap></span></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /복용약--><!-- row 고객관리 사진--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step9 | 고객관리 사진</strong></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><!--  <div class=\"form-group form-inline\" ng-if=\"!vc.showUploader\">\r\n                      <div>\r\n                        <file-attach callback=\"vc.onFileCallback\" file-data=\"vc.uploadFileListCust\"></file-attach>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"form-group form-inline\" ng-if=\"vc.showUploader\">\r\n                      <form enctype=\"Multipart/Form-Data\" id=\"frmCust\" method=\"post\" runat=\"server\">\r\n                        <div class=\"vault-block ml-0 wd-100p\" id=\"vaultCust\"></div>\r\n                      </form>\r\n                    </div>--><div><table class=\"table table-hover table-striped invoice-list no-footer fnt12\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileListCust\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list>{{fli.fileName}}</span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td></tr></tbody></table></div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /고객관리 사진--><!-- /pagecontent --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!--</form>--></div><!-- /page --></div></div><!-- 서명 --><script language=JavaScript type=text/javascript>$(document).ready(function () {\r\n\r\n    var agreeSignPad;\r\n    var faceSignPad;\r\n    /*\r\n       // Sign Pad 초기화\r\n       fnSetInitSignPad();\r\n   */\r\n\r\n\r\n    /*  // 동의 서명\r\n       var agreeSignPad = new SignaturePad(document.getElementById(\'agreeSignPad\'), {\r\n         backgroundColor: \'rgba(255, 255, 255, 0)\',\r\n         penColor: \'rgb(255, 0, 0)\'\r\n       });\r\n\r\n       // 동의 서명 clear\r\n       var btnAgreeClear = document.getElementById(\'btn-agree-clear\');\r\n       btnAgreeClear.addEventListener(\'click\', function (event) {\r\n         agreeSignPad.clear();\r\n       });\r\n\r\n       // 얼굴\r\n       var faceSignPad = new SignaturePad(document.getElementById(\'faceSignPad\'), {\r\n         backgroundColor: \'rgba(255, 255, 255, 0)\',\r\n         penColor: \'rgb(255, 0, 0)\'\r\n       });\r\n\r\n       // 얼굴 clear\r\n       var btnFaceClear = document.getElementById(\'btn-face-clear\');\r\n       btnFaceClear.addEventListener(\'click\', function (event) {\r\n         faceSignPad.clear();\r\n       });*/\r\n\r\n  });\r\n\r\n  /**\r\n   * Sign Pad 초기화\r\n   *\r\n   */\r\n  function fnSetInitSignPad() {\r\n\r\n    // 동의 서명\r\n    agreeSignPad = new SignaturePad(document.getElementById(\'agreeSignPad\'), {\r\n      backgroundColor: \'rgba(255, 255, 255, 0)\',\r\n      penColor: \'rgb(255, 0, 0)\'\r\n    });\r\n\r\n    // 동의 서명 clear\r\n    /* var btnAgreeClear = document.getElementById(\'btn-agree-clear\');\r\n     btnAgreeClear.addEventListener(\'click\', function (event) {\r\n       agreeSignPad.clear();\r\n     });*/\r\n\r\n    // 얼굴\r\n    faceSignPad = new SignaturePad(document.getElementById(\'faceSignPad\'), {\r\n      backgroundColor: \'rgba(255, 255, 255, 0)\',\r\n      penColor: \'rgb(255, 0, 0)\'\r\n    });\r\n\r\n    // 얼굴 clear\r\n    /*  var btnFaceClear = document.getElementById(\'btn-face-clear\');\r\n      btnFaceClear.addEventListener(\'click\', function (event) {\r\n        faceSignPad.clear();\r\n      });*/\r\n\r\n  }\r\n\r\n  /**\r\n   * Image를 Data Uri로 변환\r\n   *\r\n   * @param {string} url - Image url\r\n   * @param {string} callback - callback 함수명\r\n   * @return Image data Uri\r\n   */\r\n  function fnGetImageDataUri(url, callback) {\r\n    var image = new Image();\r\n\r\n    image.onload = function () {\r\n      var canvas = document.createElement(\'canvas\');\r\n      canvas.width = 350;//this.naturalWidth; // or \'width\' if you want a special/scaled size\r\n      canvas.height = 495;//this.naturalHeight; // or \'height\' if you want a special/scaled size\r\n\r\n      canvas.getContext(\'2d\').drawImage(this, 0, 0);\r\n\r\n      // Get raw image data\r\n      //callback(canvas.toDataURL(\'image/png\').replace(/^data:image\\/(png|jpg);base64,/, \'\'));\r\n\r\n      // ... or get as Data URI\r\n      callback(canvas.toDataURL(\'image/png\'));\r\n    };\r\n\r\n    image.src = url;\r\n  }\r\n\r\n  /**\r\n   * Sign Pad Data 조회\r\n   *\r\n   * @param\r\n   * @return\r\n   */\r\n  function fnGetSignData(signType) {\r\n    var signData = \'\';\r\n\r\n    if (signType == \'A\') {\r\n      signData = agreeSignPad.toDataURL(\'image/png\');\r\n    } else {\r\n      signData = faceSignPad.toDataURL(\'image/png\');\r\n    }\r\n\r\n    return signData;\r\n  }\r\n\r\n\r\n  /**\r\n   * Sign Pad Data 표시\r\n   *\r\n   * @param\r\n   * @return\r\n   */\r\n  function fnSetSignData(signType, signData) {\r\n\r\n    if (signType == \'A\') {\r\n      //agreeSignPad.clear();\r\n      agreeSignPad.fromDataURL(signData);\r\n    } else {\r\n      //faceSignPad.clear();\r\n      faceSignPad.fromDataURL(signData);\r\n    }\r\n\r\n    return signData;\r\n  }\r\n\r\n\r\n  /**\r\n   * 인쇄\r\n   *\r\n   * @param\r\n   * @return\r\n   */\r\n  function fnSetPrint() {\r\n\r\n    $(\"#divCustomerDetailTab1\").printThis({\r\n        debug: true,               // show the iframe for debugging\r\n        importCSS: true,            // import parent page css\r\n        importStyle: true,         // import style tags\r\n        printContainer: false,       // print outer container/$.selector\r\n        loadCSS: \"/assets/css/common.css\",                // path to additional css file - use an array [] for multiple\r\n        pageTitle: \"고객정보\",              // add title to print page\r\n        removeInline: false,        // remove inline styles from print elements\r\n        removeInlineSelector: \"*\",  // custom selectors to filter inline styles. removeInline must be true\r\n        printDelay: 500,            // variable print delay\r\n        header: null,               // prefix to html\r\n        footer: null,               // postfix to html\r\n        base: false,                // preserve the BASE tag or accept a string for the URL\r\n        formValues: true,           // preserve input/form values\r\n        canvas: true,              // copy canvas content\r\n        doctypeString: \'\',       // enter a different doctype for older markup\r\n        removeScripts: false,       // remove script tags from print content\r\n        copyTagClasses: false,      // copy classes from the html & body tag\r\n        beforePrintEvent: null,     // function for printEvent in iframe\r\n        beforePrint: null,          // function called before iframe is filled\r\n        afterPrint: function () {\r\n          $(\"iframe[name=\'printIframe\']\").remove();\r\n          angular.element(document.getElementById(\'divCustomerDetailTab1\')).scope().goEdit();\r\n        }            // function called before iframe is removed\r\n      }\r\n    );\r\n  }\r\n\r\n\r\n  /**\r\n   * PDF 저장\r\n   *\r\n   * @param\r\n   * @return\r\n   */\r\n  function fnSetPdf() {\r\n\r\n    html2canvas(document.getElementById(\"divCustomerDetailTab1\"), {\r\n      onrendered: function (canvas) {\r\n        // 캔버스를 이미지로 변환\r\n        var imgData = canvas.toDataURL(\'image/png\');\r\n\r\n        var imgWidth = 210; // 이미지 가로 길이(mm) A4 기준\r\n        var pageHeight = imgWidth * 1.414;  // 출력 페이지 세로 길이 계산 A4 기준\r\n        var imgHeight = canvas.height * imgWidth / canvas.width;\r\n        var heightLeft = imgHeight;\r\n\r\n        var doc = new jsPDF(\'p\', \'mm\');\r\n        var position = 0;\r\n\r\n        // 첫 페이지 출력\r\n        doc.addImage(imgData, \'PNG\', 0, position, imgWidth, imgHeight);\r\n        heightLeft -= pageHeight;\r\n\r\n        // 한 페이지 이상일 경우 루프 돌면서 출력\r\n        while (heightLeft >= 20) {\r\n          position = heightLeft - imgHeight;\r\n          doc.addPage();\r\n          doc.addImage(imgData, \'PNG\', 0, position, imgWidth, imgHeight);\r\n          heightLeft -= pageHeight;\r\n        }\r\n\r\n        // 파일 저장\r\n        doc.save(\'고객정보.pdf\');\r\n      }\r\n    })\r\n\r\n\r\n  }</script>");
$templateCache.put("app/customer/customer-detail2-tab1.html","<!-- 고객정보 --><div id=divCustomerTab1 ng-controller=\"CustomerDetail2Tab1Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- Action Buttons --><!-- /row --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">개인 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>고객명</label><input class=form-control maxlength=200 ng-model=vc.data.CustNm type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input class=mr-5 id=rdoGenderM name=Gender ng-checked-=\"vc.data.Gender == \'M\'\" ng-model=vc.data.Gender type=radio value=M>남</label><label class=radio-inline><input id=rdoGenderF name=Gender ng-checked-=\"vc.data.Gender == \'F\'\" ng-model=vc.data.Gender type=radio value=F>여</label></div></div></div></div><!-- /col --><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>연락처</label><input class=form-control maxlength=13 ng-model=vc.data.Mobile numbers-hyphen type=text></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input class=mr-5 id=rdoSMSY name=SmsYN ng-checked-=\"vc.data.SmsYN == \'Y\'\" ng-model=vc.data.SmsYN type=radio value=Y>SMS 수신동의</label><label class=radio-inline><input id=rdoSMSN name=SmsYN ng-checked-=\"vc.data.SmsYN == \'N\'\" ng-model=vc.data.SmsYN type=radio value=N>SMS 수신거부</label></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input class=form-control id=ZipCode maxlength=7 ng-model=vc.data.ZipCode readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchZipCodeModal() type=button><i class=\"fa fa-search\"></i></button> </span><input class=form-control id=Addr1 maxlength=200 ng-model=vc.data.Addr1 type=text></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input class=form-control id=Addr2 maxlength=200 ng-model=vc.data.Addr2 type=text></div></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>생년월일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.BirthDay = (vc.BirthDay | date: \'yyyy-MM-dd\')\" ng-model=vc.BirthDay ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 xs-mb10\"><label class=radio-inline><input class=mr-5 id=rdoLnrSlrTypeL name=LnrSlrType ng-checked-=\"vc.data.LnrSlrType == \'L\'\" ng-model=vc.data.LnrSlrType type=radio value=L>음력</label><label class=radio-inline><input class=mr-5 id=rdoLnrSlrTypeS name=LnrSlrType ng-checked-=\"vc.data.LnrSlrType == \'S\'\" ng-model=vc.data.LnrSlrType type=radio value=S>양력</label></div></div><!-- /col --></div><!-- /row   --></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>등록일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.CustRegDt = (vc.CustRegDt | date: \'yyyy-MM-dd\')\" ng-model=vc.CustRegDt ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-12\"><div class=\"form-group form-inline xs-mb10\"><label>직업</label><input class=form-control maxlength=100 ng-model=vc.data.Job type=text></div></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>방문경로</label><div class=\"inline-box brd1 p-10 bd-rd4\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input id=rdoVisitPath100 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'100\'\" ng-model=vc.data.VisitPath type=radio value=100>블로그</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input id=rdoVisitPath200 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'200\'\" ng-model=vc.data.VisitPath type=radio value=200>카페</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input id=rdoVisitPath300 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'300\'\" ng-model=vc.data.VisitPath type=radio value=300>인스타그램</label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input id=rdoVisitPath400 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'400\'\" ng-model=vc.data.VisitPath type=radio value=400>소개 <input class=form-control maxlength=10 ng-disabled=\"vc.data.VisitPath != \'400\'\" ng-model=vc.data.VisitPathPromoId type=text></label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input id=rdoVisitPath500 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'500\'\" ng-model=vc.data.VisitPath type=radio value=500>기타 <input class=\"form-control wd181\" maxlength=100 ng-disabled=\"vc.data.VisitPath != \'500\'\" ng-model=vc.data.VisitPathEtc type=text></label></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=sz-custom-select-tenant><section class=tile fullscreen=isFullscreen06><!-- ngIf: header.checkUse --><div class=\"form-group ng-scope\" ng-if=header.checkUse><div class=\"input-group custom-search-form\"><input aria-invalid=false class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" ng-click=header.srchTenantModal(); ng-model=header.TENANTNAME readonly type=text> <input aria-invalid=false autocomplete=off class=\"ng-pristine ng-untouched ng-valid ng-not-empty\" ng-model=header.TENANTID type=hidden> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=header.srchTenantModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=header.eraseTenant(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- end ngIf: header.checkUse --></section></div></div><!-- /col --></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>특이사항</label><input class=form-control maxlength=200 ng-model=vc.data.SpcNote placeholder=\"e.g.) 알러지성 질환, 복용중인 약물, 신체 질환\" type=text></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>E-mail</label><input class=form-control maxlength=255 ng-model=vc.data.Email type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>파머등급</label><common-code-custom code-list=\"vc.columnMap[\'CustGrade\'].CodeList\" code-model=vc.data.CustGrade is-disabled=true></common-code-custom></div></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>담당자</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>추천인코드</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.RecomendrCd ng-disabled=\"vc.data.RecomendrCd != null && vc.data.RecomendrCd !=\'\'\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.checkedRecomendrCd() type=button><i class=\"glyphicon glyphicon glyphicon-ok\"></i></button></span></div></div></div></div><div class=row ng-if=\"vc.data.KeyId != \'\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>소개인원</label><input class=form-control ng-disabled=true type=text></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>내추천인코드</label><div class=input-group><button ng-if=\"$root.gVariable.srchTenantId == 0 && (vc.data.MyRecomendrCd == null || vc.data.MyRecomendrCd ==\'\')\" class=\"btn btn-default\" ng-click=vc.setCode()><span class=\"glyphicon glyphicon-check\">코드발급</span></button> <input type=text class=\"form-control form-right\" ng-if=\"$root.gVariable.srchTenantId != 0 || (vc.data.MyRecomendrCd != null && vc.data.MyRecomendrCd !=\'\')\" maxlength=255 ng-model=vc.data.MyRecomendrCd readonly></div></div></div></div><div class=row ng-if=\"vc.data.KeyId != \'\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>현재PP</label><input class=form-control ng-disabled=true type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>회원보유수</label><input class=form-control ng-disabled=true type=text></div></div></div></div></div><!-- /row --></div></div></div></div><!-- /pagecontent --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></div>");
$templateCache.put("app/customer/customer-detail2-tab2-modal.html","<div class=modal-content><div class=dataloader ng-show=vc.dataloader></div><div class=\"modal-header ng-scope\"><div class=page-header>구매상세이력</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=tile><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center>품목별 주문번호</th><th class=text-center>공급사</th><th class=text-center>상품명/옵션</th><th class=text-center>수량</th><th class=text-center>판매가</th><th class=text-center>상품별할인금액</th><th class=text-center>주문상태</th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.listItems\"><!-- Result Items --><td class=text-center><span>{{li.order_item_code}}/{{li.product_code}}</span></td><td class=text-center><span>{{li.supplier_name}}</span></td><td class=text-center><span>{{li.product_name}}/{{li.option_value}}</span></td><td class=text-center><span>{{li.quantity}}</span></td><td class=text-center><span>{{li.product_price | number}}</span></td><td class=text-center><span>{{li.additional_discount_price}}</span></td><td class=text-center><span>{{li.status_text}}</span></td></tr></table></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/customer/customer-detail2-tab2.html","<!-- 고객정보 --><div id=divCustomerTab1 ng-controller=\"CustomerDetail2Tab2Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- Action Buttons --><!-- /row --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">구매이력</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.showDetail(li.order_id)><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"max-width: 100px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\" title=\"{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul boundary-links=true data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" items-per-page=vc.viewSize last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" max-size=vc.maxSize name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage num-pages=vc.numPages previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" rotate=false template-url=app/template/pagination.html total-items=vc.totalItems uib-pagination></ul></div></div></div></div></div></div></div><!-- /pagecontent --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></div>");
$templateCache.put("app/customer/customer-detail2-tab3.html","<!-- 고객정보 --><div id=divCustomerTab1 ng-controller=\"CustomerDetail2Tab3Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- Action Buttons --><!-- /row --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">구독목록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goEdit(li.KeyId, li.DetailPageUrl, li.ListDetailPageUrl)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"max-width: 100px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\" title=\"{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul boundary-links=true data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" items-per-page=vc.viewSize last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" max-size=vc.maxSize name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage num-pages=vc.numPages previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" rotate=false template-url=app/template/pagination.html total-items=vc.totalItems uib-pagination></ul></div></div></div></div></div></div></div><!-- /pagecontent --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></div>");
$templateCache.put("app/customer/customer-detail2-tab4.html","<!-- 고객정보 --><div id=divCustomerTab1 ng-controller=\"CustomerDetail2Tab4Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- Action Buttons --><!-- /row --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">상품추천</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=col-lg-6><div>추천상품</div><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom\"><thead><tr><th data-toggle=true class=text-center>상품코드</th><th data-toggle=true class=text-center>상품명</th><th data-toggle=true class=text-center>빈도수</th></tr></thead><tbody ng-if=\"vc.data.recommended == null || vc.data.recommended.length == 0\"><tr class=tbnodata><td class=text-center colspan=3>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><tr ng-repeat=\"li in vc.data.recommended\" my-directive><td><span ng-bind=li.pid></span></td><td><span ng-bind=li.ProductName></span></td><td><span ng-bind=li.freq></span></td></tr></tbody></table></div><div class=col-lg-6><div id=wordcloud style=\"width:100%; min-height:300px\"></div><div>유사고객</div><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom\"><thead><tr><th data-toggle=true class=text-center>고객아이디</th><th data-toggle=true class=text-center>고객명</th><th data-toggle=true class=text-center>유사도(1~0)</th></tr></thead><tbody ng-if=\"vc.data.similarities == null || vc.data.similarities.length == 0\"><tr class=tbnodata><td class=text-center colspan=3>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><tr ng-repeat=\"li in vc.data.similarities\" my-directive><td><span ng-bind=li.cid></span></td><td><span ng-bind=li.CustomerName></span></td><td><span ng-bind=\"1 - li.distance | number\"></span></td></tr></tbody></table></div></div></div></div></div><!-- /pagecontent --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></div>");
$templateCache.put("app/customer/customer-detail2.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"CustomerDetail2Ctrl as vc\"><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><ul class=\"nav nav-tabs\" ng-show=\"vc.keyId != \'\'\"><li ng-class=\"vc.url == \'/tab1\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab1\');\" style=cursor:pointer>고객정보</a></li><li ng-class=\"vc.url == \'/tab2\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab2\');\" style=cursor:pointer>구매이력</a></li><li ng-class=\"vc.url == \'/tab3\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab3\');\" style=cursor:pointer>구독목록</a></li><li ng-class=\"vc.url == \'/tab4\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab4\');\" style=cursor:pointer>상품추천</a></li><li ng-class=\"vc.url == \'/tab5\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab5\');\" style=cursor:pointer>알림이력</a></li></ul><ui-view></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-edit-tab1.html","<!-- 고객정보 --><div id=divCustomerTab1 ng-controller=\"CustomerEditTab1Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.setPrint() ng-if=\"vc.data.KeyId != \'\'\"><i class=\"fa fa-print\"></i> 인쇄</button><!-- <button class=\"btn btn-default\" ng-click=\"vc.setSaveToPdf()\" ng-if=\"vc.data.KeyId != \'\'\">\r\n              <i class=\"fa  fa-file-pdf-o\"></i> PDF저장\r\n            </button>--> <button class=\"btn btn-primary\" ng-click=vc.uploadFileCust()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Clause | 회원약관</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /panel header --><!-- panel body --><div class=\"panel-body collapse in\" style=\"height: 320px\"><!-- 약관 --><div class=row><div class=col-lg-12><div class=\"bs-callout bs-callout-info\" id=callout-navs-tabs-plugin><div class=member-comment-box><ul class=comment><li>장피셜 제품은 장피셜 아카데미의 교육을 이수 받은 전문가가 직접 관리/적용 하는 제품입니다. 장피셜의 모든 제품은 문제성 피부의 개선을 목적으로 하는 코스메슈티컬 제품으로 안전성이 비교적 낮습니다.<br><br>따라서 본인의 컨디션 및 피부상태, 잘못된 사후 관리 등으로 여러 현상이 발생 할 수 있기 때문에 장피셜 트리트먼트를 받는 기간 동안 전문가의 지시사항을 100% 이행하셔야 합니다.</li></ul></div><div class=member-comment-box--red><ul class=comment><li>장피셜 트리트먼트는 관리 기간 동안 고영양 현상으로 인한 트러블과 같은 반응이 언제든 발생 할 수 있습니다. 이는 치료를 목적으로 하는 고영양성분의 약용 화장품이 갖는 특징으로 전문가의 적절한 피드백으로 피부의 개선을 보장하는 내용 외 별도의 법적 물적 보상은 없습니다.</li><li>당일 예약 취소, 변경 시 티겟팅 관리 횟수에서 1회가 차감됩니다.</li><li>불가피한 사유로 관리를 받을 수 없을 시 관리권, 제품의 환불 요청 시에는 티겟팅금액/관리횟수를 차감한 금액을 정산합니다.</li></ul></div></div></div></div><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12\"><div class=\"col-sm-3 col-md-4 col-lg-3 pl-0\"><div class=checkbox><label class=\"ng-binding inb wd-100p txt-right\">위 약관에 동의합니다.</label></div></div><!-- /col --><div class=\"col-sm-3 col-md-4 col-lg-3 pr-0 pl-0\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.AgreeDt = (vc.AgreeDt | date: \'yyyy-MM-dd\')\" ng-model=vc.AgreeDt ng-required=false placeholder=동의일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- /col --><div class=\"col-sm-2 col-md-4 col-lg-3 pr-0\"><div class=\"form-group form-inner-label\"><label class=ng-binding>고객명</label><input aria-invalid=false class=\"form-control form-right ng-pristine ng-valid ng-empty ng-touched\" maxlength=200 ng-model=vc.data.CustNm placeholder=\"\" type=text></div></div><!-- /col --><div class=\"col-sm-4 col-md-4 col-lg-3\"><div class=\"form-group form-inner-label\"><label class=ng-binding>(서명)</label><div class=input-group><canvas id=agreeSignPad></canvas><span class=\"input-group-btn cus-btn\"><button class=\"btn btn-default\" id=btn-agree-clear type=button><em class=\"fa fa-eraser\"></em></button></span></div></div></div><!-- /col --></div></div><!-- /row --><!-- /col --></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step1 | 개인 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>고객명</label><input class=form-control maxlength=200 ng-model=vc.data.CustNm type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input class=mr-5 id=rdoGenderM name=Gender ng-checked-=\"vc.data.Gender == \'M\'\" ng-model=vc.data.Gender type=radio value=M>남</label><label class=radio-inline><input id=rdoGenderF name=Gender ng-checked-=\"vc.data.Gender == \'F\'\" ng-model=vc.data.Gender type=radio value=F>여</label></div></div></div></div><!-- /col --><div class=\"col-sm-12 col-md-12 col-lg-6 xs-mb10\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb0\"><label>연락처</label><input class=form-control maxlength=13 ng-model=vc.data.Mobile numbers-hyphen type=text></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 sm-mb0\"><label class=radio-inline><input class=mr-5 id=rdoSMSY name=SmsYN ng-checked-=\"vc.data.SmsYN == \'Y\'\" ng-model=vc.data.SmsYN type=radio value=Y>SMS 수신동의</label><label class=radio-inline><input id=rdoSMSN name=SmsYN ng-checked-=\"vc.data.SmsYN == \'N\'\" ng-model=vc.data.SmsYN type=radio value=N>SMS 수신거부</label></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input class=form-control id=ZipCode maxlength=7 ng-model=vc.data.ZipCode readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchZipCodeModal() type=button><i class=\"fa fa-search\"></i></button> </span><input class=form-control id=Addr1 maxlength=200 ng-model=vc.data.Addr1 type=text></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input class=form-control id=Addr2 maxlength=200 ng-model=vc.data.Addr2 type=text></div></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>생년월일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.BirthDay = (vc.BirthDay | date: \'yyyy-MM-dd\')\" ng-model=vc.BirthDay ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group sm-mt3 xs-mb10\"><label class=radio-inline><input class=mr-5 id=rdoLnrSlrTypeL name=LnrSlrType ng-checked-=\"vc.data.LnrSlrType == \'L\'\" ng-model=vc.data.LnrSlrType type=radio value=L>음력</label><label class=radio-inline><input class=mr-5 id=rdoLnrSlrTypeS name=LnrSlrType ng-checked-=\"vc.data.LnrSlrType == \'S\'\" ng-model=vc.data.LnrSlrType type=radio value=S>양력</label></div></div><!-- /col --></div><!-- /row   --></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>등록일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.CustRegDt = (vc.CustRegDt | date: \'yyyy-MM-dd\')\" ng-model=vc.CustRegDt ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-12\"><div class=\"form-group form-inline xs-mb10\"><label>직업</label><input class=form-control maxlength=100 ng-model=vc.data.Job type=text></div></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>방문경로</label><div class=\"inline-box brd1 p-10 bd-rd4\"><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input id=rdoVisitPath100 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'100\'\" ng-model=vc.data.VisitPath type=radio value=100>블로그</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input id=rdoVisitPath200 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'200\'\" ng-model=vc.data.VisitPath type=radio value=200>카페</label></div><div class=\"col-xs-12 col-sm-3 col-md-4 col-lg-3\"><label class=radio-inline><input id=rdoVisitPath300 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'300\'\" ng-model=vc.data.VisitPath type=radio value=300>인스타그램</label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input id=rdoVisitPath400 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'400\'\" ng-model=vc.data.VisitPath type=radio value=400>소개 <input class=form-control maxlength=10 ng-disabled=\"vc.data.VisitPath != \'400\'\" ng-model=vc.data.VisitPathPromoId type=text></label></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input id=rdoVisitPath500 name=VisitPath ng-checked-=\"vc.data.VisitPath == \'500\'\" ng-model=vc.data.VisitPath type=radio value=500>기타 <input class=\"form-control wd181\" maxlength=100 ng-disabled=\"vc.data.VisitPath != \'500\'\" ng-model=vc.data.VisitPathEtc type=text></label></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=sz-custom-select-tenant><section class=tile fullscreen=isFullscreen06><!-- ngIf: header.checkUse --><div class=\"form-group ng-scope\" ng-if=header.checkUse><div class=\"input-group custom-search-form\"><input aria-invalid=false class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" ng-click=header.srchTenantModal(); ng-model=header.TENANTNAME readonly type=text> <input aria-invalid=false autocomplete=off class=\"ng-pristine ng-untouched ng-valid ng-not-empty\" ng-model=header.TENANTID type=hidden> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=header.srchTenantModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=header.eraseTenant(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- end ngIf: header.checkUse --></section></div></div><!-- /col --></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>특이사항</label><input class=form-control maxlength=200 ng-model=vc.data.SpcNote placeholder=\"e.g.) 알러지성 질환, 복용중인 약물, 신체 질환\" type=text></div></div></div></div><!-- /col --></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>E-mail</label><input class=form-control maxlength=255 ng-model=vc.data.Email type=text></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>파머등급</label><common-code-custom code-list=\"vc.columnMap[\'CustGrade\'].CodeList\" code-model=vc.data.CustGrade is-disabled=true></common-code-custom></div></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>담당자</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>추천인코드</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.RecomendrCd ng-disabled=\"vc.data.RecomendrCd != null && vc.data.RecomendrCd !=\'\'\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.checkedRecomendrCd() type=button><i class=\"glyphicon glyphicon glyphicon-ok\"></i></button></span></div></div></div></div><div class=row ng-if=\"vc.data.KeyId != \'\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>소개인원</label><input class=form-control ng-disabled=true type=text></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>내추천인코드</label><div class=input-group><button ng-if=\"$root.gVariable.srchTenantId == 0 && (vc.data.MyRecomendrCd == null || vc.data.MyRecomendrCd ==\'\')\" class=\"btn btn-default\" ng-click=vc.setCode()><span class=\"glyphicon glyphicon-check\">코드발급</span></button> <input type=text class=\"form-control form-right\" ng-if=\"$root.gVariable.srchTenantId != 0 || (vc.data.MyRecomendrCd != null && vc.data.MyRecomendrCd !=\'\')\" maxlength=255 ng-model=vc.data.MyRecomendrCd readonly></div></div></div></div><div class=row ng-if=\"vc.data.KeyId != \'\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>현재PP</label><input class=form-control ng-disabled=true type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>회원보유수</label><input class=form-control ng-disabled=true type=text></div></div></div></div></div><!-- /row --></div></div><!-- row 과거 관리 및 시술이력 / 홈케어정보--><div class=row><!-- col 과거관리 및 시술 이력--><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step2 | 과거 관리 및 시술 이력</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-12 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist01YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist01YN ng-true-value=\"\'Y\'\" type=checkbox>보습, 미백, 여드름,노화관리</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist01SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist01SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist01SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist01SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist02YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist02YN ng-true-value=\"\'Y\'\" type=checkbox>MTS, 필링</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist02SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist02SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist02SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist02SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist03YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist03YN ng-true-value=\"\'Y\'\" type=checkbox>레이저 시술</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist03SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist03SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist03SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist03SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist04YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist04YN ng-true-value=\"\'Y\'\" type=checkbox>보톡스, 필러, 실리프팅</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=\"form-group sm-mb0\"><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist04SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist04SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist04SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist04SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-5 col-md-12 col-lg-6 plr-0\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=\"checkbox sm-mb0\"><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist05YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist05YN ng-true-value=\"\'Y\'\" type=checkbox>지방이식, 보형물 등의 삽입 성형 수술</label></div></div></div><!-- /col --><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-6\"><div class=row><div class=\"col-xs-12 col-sm-2 col-md-3 col-lg-3 plr-0\"><div class=form-group><div class=\"checkbox sm-mb0\"><label class=ng-binding><input ng-checked-=\"vc.data.TrtmtHist05SdEftYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TrtmtHist05SdEftYN ng-true-value=\"\'Y\'\" type=checkbox>부작용</label></div></div></div><div class=\"col-xs-12 col-sm-10 col-md-9 col-lg-9 plr-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.TrtmtHist05SdEftYN == \'N\'\" ng-model=vc.data.TrtmtHist05SdEftDtl placeholder=\"부작용 상세 내용\" type=text></div></div></div><!-- /col --></div></div><!-- /row --></div><!-- /tile body --></div></div><!-- /col 과거관리 및 시술 이력 --><!-- col 홈케어 정보--><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding>홈 케어 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare01YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare01YN ng-true-value=\"\'Y\'\" type=checkbox>클렌징</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare01YN == \'N\'\" ng-model=vc.data.HomeCare01PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare01YN == \'N\'\" ng-model=vc.data.HomeCare01Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare02YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare02YN ng-true-value=\"\'Y\'\" type=checkbox>데이</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare02YN == \'N\'\" ng-model=vc.data.HomeCare02PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare02YN == \'N\'\" ng-model=vc.data.HomeCare02Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb5 xs-mt10\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare03YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare03YN ng-true-value=\"\'Y\'\" type=checkbox>나이트</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare03YN == \'N\'\" ng-model=vc.data.HomeCare03PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare03YN == \'N\'\" ng-model=vc.data.HomeCare03Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb5 xs-mt10\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare04YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare04YN ng-true-value=\"\'Y\'\" type=checkbox>각질제거</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0 sm-mb5\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare04YN == \'N\'\" ng-model=vc.data.HomeCare04PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare04YN == \'N\'\" ng-model=vc.data.HomeCare04Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-2 col-md-12 col-lg-2 plr-0\"><div class=\"checkbox mt-5 sm-mb0 xs-mt10\"><label class=ng-binding><input ng-checked-=\"vc.data.HomeCare05YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.HomeCare05YN ng-true-value=\"\'Y\'\" type=checkbox>기타(팩)</label></div></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 xs-mb5 pr-0 pl-0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare05YN == \'N\'\" ng-model=vc.data.HomeCare05PrdNm placeholder=제품명 type=text></div><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-5 pr-0 xs-pl0\"><input class=form-control maxlength=100 ng-disabled=\"vc.data.HomeCare05YN == \'N\'\" ng-model=vc.data.HomeCare05Usage placeholder=사용방법 type=text></div></div></div><!-- /row --><!-- /row --></div><!-- /tile body --></div></div><!-- /col 홈케어 정보--></div><!-- row 과거 관리 및 시술이력 / 홈케어정보--><!-- row 섹터별 특징 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step3 | 섹터별 특징</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 plr-0\"><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector01YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector01YN ng-true-value=\"\'Y\'\" type=checkbox>Sebum Area / 피지분포 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector02YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector02YN ng-true-value=\"\'Y\'\" type=checkbox>White Acne Area / 좁쌀 여드름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector03YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector03YN ng-true-value=\"\'Y\'\" type=checkbox>Anti Acne Area / 염즘성 여드름</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector04YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector04YN ng-true-value=\"\'Y\'\" type=checkbox>Pore Area / 모공 확장 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector05YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector05YN ng-true-value=\"\'Y\'\" type=checkbox>Scar Area / 상처 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector06YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector06YN ng-true-value=\"\'Y\'\" type=checkbox>Melano Area / 색소 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector07YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector07YN ng-true-value=\"\'Y\'\" type=checkbox>Dry Area / 건조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector08YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector08YN ng-true-value=\"\'Y\'\" type=checkbox>Wrinkle Area / 옅은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector09YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector09YN ng-true-value=\"\'Y\'\" type=checkbox>Deep Wrinkle Area / 깊은 주름 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector10YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector10YN ng-true-value=\"\'Y\'\" type=checkbox>Fush Area / 홍조 부위</label></div></div><!-- /col --><div class=form-group><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.data.Sector11YN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.Sector11YN ng-true-value=\"\'Y\'\" type=checkbox>Telangiectasia Area / 모세혈관 확장</label></div></div><!-- /col --></div></div></div><!-- /tile body --></div><!-- /panel --><!-- row 섹터별 특징 / 얼굴이미지--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step3 | 섹터별 특징 - Face</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=\"text-center pt-10 min-h312\"><div class=cus-edit-face><img src=assets/images/face-image.png><canvas height=495 id=faceSignPad></canvas><button class=\"btn btn-default\" id=btn-face-clear type=button><em class=\"fa fa-eraser\"></em></button></div></div></div></div><!-- /tile body --></div><!-- /panel --></div><!-- /col 섹터별 특징 --><!-- row 현재의피부 상황 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step4 | 현재의 피부 상황 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control ng-model=vc.data.CurSkinStory rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span aria-hidden=true class=\"glyphicon glyphicon-exclamation-sign\"></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">- 현재 피부 상태는 어떠한지에 대해서 고객이 직접 이야기하는 내용을 입력</div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의피부 상황 이야기--><!-- row 과거의 이야기--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step5 | 과거의 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control ng-model=vc.data.PastSkinStory rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span aria-hidden=true class=\"glyphicon glyphicon-exclamation-sign\"></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">-현재피부가 과거에도 그랬는지 과거에는 피부가 어땠는지 입력<br>-과거에 피부가 좋았다면 그때는 어떤 이로운점이 있었는지 입력<br>-과거에 피부가 안좋았다면 그때는 어떤 점이 불편했는지 입력</div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /과거의 이야기--><!-- row 현재의 결심 그리고 미래에 대한 이야기--><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step6 | 현재의 결심 그리고 미래에 대한 이야기</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6\"><textarea class=form-control ng-model=vc.data.FutureSkinStory rows=5></textarea></div><div class=\"col-xs-12 col-md-12 col-lg-6 col-xl-6 col-md-12-mt10 col-lg-12-mt0 pl-0 pr-0\"><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-12 col-xl-12 text-warning pr-0\"><strong><span aria-hidden=true class=\"glyphicon glyphicon-exclamation-sign\"></span> TIP</strong></div><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning\">-현재의 피부를 만약 고치지 않고 그대로 방치했을때 현재와 미래에 어떤 불이익, 안좋은상황이 올것인지에 대해 발설유도 하며 최악의 상황을 세세히 그려줌<br>-현재 피부는 어떤상태이니 어느정도의 노력과, 시간이 투자된다면, 어떤피부상태가 될것인지에 대해서 예상시켜줌<br>-그리고 피부가 그렇게 좋아졌을때 기분이 어떨것같은지, 현재 어떻게 바뀔것 같은지, 너의 미래는 어떻게 될것같은지에 대해 발설유도.<br></div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /현재의 결심 그리고 미래에 대한 이야기--><!-- row 관리 처방--><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step7 | 관리처방</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-6 col-md-6 col-lg-6 col-xl-6\"><label class=ng-binding>전체품목</label><table class=\"table table-condensed table-typeA mt-5\"><colgroup><col style=\"width: 55%\"><col style=\"width: 42%\"><col style=\"width: auto\"></colgroup><thead><tr><td>품목명</td><td>금액</td><td>선택</td></tr></thead><tbody><tr ng-repeat=\"li in vc.productList\"><td><span ng-bind=li.ProductNm></span></td><td class=txt-center><span comma-bind ng-bind=li.ProductAmt></span></td><td><button class=\"btn btn-default mt-10 mb-10\" ng-click=vc.setAddProduct(li)><span class=\"glyphicon glyphicon-check\">선택</span></button></td></tr></tbody></table></div><!-- /col --><div class=\"col-xs-6 col-md-6 col-lg-6 col-xl-6\"><label class=ng-binding>선택 품목</label><table class=\"table table-condensed table-typeA mt-5\"><colgroup><col style=\"width: 54%\"><col style=\"width: 20%\"><col style=\"width: 13%\"><col style=\"width: 13%\"></colgroup><thead><tr><td>품목명</td><td>금액</td><td>횟수</td><td>삭제</td></tr></thead><tbody><tr ng-repeat=\"li in vc.cvsMngPrscrptn\"><td><span ng-bind=li.ProductNm></span></td><td class=txt-center><span comma-bind ng-bind=li.ProductAmt></span></td><td><input class=\"form-control text-right\" maxlength=3 ng-model=li.MngCnt numbers-only=\"\" type=text></td><td class=text-center style=vertical-align:middle><button class=\"btn btn-default mt-10 mb-10\" ng-click=vc.setDelProduct(li)><i class=\"fa fa-times\"></i>삭제</button></td></tr></tbody></table></div><!-- /col --></div><!-- /row --></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /관리 처방--><!-- row 복용약--><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step8 | 복용약</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=col-sm-12><textarea class=form-control maxlength=1000 ng-model=vc.data.Medication rows=5></textarea></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /복용약--><!-- row 고객관리 사진--><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step9 | 고객관리 사진</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><div><file-attach callback=vc.onFileCallback file-data=vc.uploadFileListCust></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form enctype=Multipart/Form-Data id=frmCust method=post runat=server><div class=\"vault-block ml-0 wd-100p\" id=vaultCust></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileListCust\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox aria-label=Check class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" md-no-ink=\"\" ng-false-value=\"\'\'\" ng-model=fli.delState ng-true-value=\"\'delete\'\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /고객관리 사진--><!-- row 상담--><div class=row ng-if=\"vc.srch.keyId == \'\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">Step10 | 상담</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-12\"><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>상담일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.CounselDt = (vc.CounselDt | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDt ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0\"><div class=\"form-group form-inline\"><label>상담내용</label><textarea class=form-control maxlength=1000 ng-model=vc.data.CounselContents rows=5></textarea></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><div><file-attach callback=vc.onFileCallback file-data=vc.uploadFileListCounsel></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form enctype=Multipart/Form-Data id=frmCounsel method=post runat=server><div class=\"vault-block ml-0 wd-100p\" id=vaultCounsel></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileListCounsel\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox aria-label=Check class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" md-no-ink=\"\" ng-false-value=\"\'\'\" ng-model=fli.delState ng-true-value=\"\'delete\'\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- /col --></div><!-- /row /상담--></div><!-- /pagecontent --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!--</form>--><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.setPrint() ng-if=\"vc.data.KeyId != \'\'\"><i class=\"fa fa-print\"></i> 인쇄</button><!--<button class=\"btn btn-default\" ng-click=\"vc.setSaveToPdf()\" ng-if=\"vc.data.KeyId != \'\'\">\r\n                  <i class=\"fa  fa-file-pdf-o\"></i> PDF\r\n                </button>--> <button activate-button class=\"btn btn-primary\" ng-click=vc.uploadFileCust()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page --></div></div><!-- 서명 --><script language=JavaScript type=text/javascript>$(document).ready(function () {\r\n\r\n    var agreeSignPad;\r\n    var faceSignPad;\r\n    /*\r\n       // Sign Pad 초기화\r\n       fnSetInitSignPad();\r\n   */\r\n\r\n\r\n    /*  // 동의 서명\r\n       var agreeSignPad = new SignaturePad(document.getElementById(\'agreeSignPad\'), {\r\n         backgroundColor: \'rgba(255, 255, 255, 0)\',\r\n         penColor: \'rgb(255, 0, 0)\'\r\n       });\r\n\r\n       // 동의 서명 clear\r\n       var btnAgreeClear = document.getElementById(\'btn-agree-clear\');\r\n       btnAgreeClear.addEventListener(\'click\', function (event) {\r\n         agreeSignPad.clear();\r\n       });\r\n\r\n       // 얼굴\r\n       var faceSignPad = new SignaturePad(document.getElementById(\'faceSignPad\'), {\r\n         backgroundColor: \'rgba(255, 255, 255, 0)\',\r\n         penColor: \'rgb(255, 0, 0)\'\r\n       });\r\n\r\n       // 얼굴 clear\r\n       var btnFaceClear = document.getElementById(\'btn-face-clear\');\r\n       btnFaceClear.addEventListener(\'click\', function (event) {\r\n         faceSignPad.clear();\r\n       });*/\r\n\r\n  });\r\n\r\n  /**\r\n   * Sign Pad 초기화\r\n   *\r\n   */\r\n  function fnSetInitSignPad() {\r\n\r\n    // 동의 서명\r\n    agreeSignPad = new SignaturePad(document.getElementById(\'agreeSignPad\'), {\r\n      backgroundColor: \'rgba(255, 255, 255, 0)\',\r\n      penColor: \'rgb(255, 0, 0)\'\r\n    });\r\n\r\n    // 동의 서명 clear\r\n    var btnAgreeClear = document.getElementById(\'btn-agree-clear\');\r\n    btnAgreeClear.addEventListener(\'click\', function (event) {\r\n      agreeSignPad.clear();\r\n    });\r\n\r\n    // 얼굴\r\n    faceSignPad = new SignaturePad(document.getElementById(\'faceSignPad\'), {\r\n      backgroundColor: \'rgba(255, 255, 255, 0)\',\r\n      penColor: \'rgb(255, 0, 0)\'\r\n    });\r\n\r\n    // 얼굴 clear\r\n    var btnFaceClear = document.getElementById(\'btn-face-clear\');\r\n    btnFaceClear.addEventListener(\'click\', function (event) {\r\n      faceSignPad.clear();\r\n    });\r\n/*\r\ndebugger;\r\n*/\r\n    var ratio =  window.devicePixelRatio || 1;\r\n    var signPad = document.getElementById(\'agreeSignPad\');\r\n\r\n    signPad.width = signPad.offsetWidth * ratio;\r\n    signPad.height = signPad.offsetHeight * ratio;\r\n    signPad.getContext(\'2d\').scale(ratio, ratio);\r\n\r\n  }\r\n\r\n  /**\r\n   * Image를 Data Uri로 변환\r\n   *\r\n   * @param {string} url - Image url\r\n   * @param {string} callback - callback 함수명\r\n   * @return Image data Uri\r\n   */\r\n  function fnGetImageDataUri(url, callback) {\r\n    var image = new Image();\r\n\r\n    image.onload = function () {\r\n      var canvas = document.createElement(\'canvas\');\r\n      canvas.width = 290;//this.naturalWidth; // or \'width\' if you want a special/scaled size\r\n      canvas.height = 435;//this.naturalHeight; // or \'height\' if you want a special/scaled size\r\n\r\n      canvas.getContext(\'2d\').drawImage(this, 0, 0);\r\n\r\n      // Get raw image data\r\n      //callback(canvas.toDataURL(\'image/png\').replace(/^data:image\\/(png|jpg);base64,/, \'\'));\r\n\r\n      // ... or get as Data URI\r\n      callback(canvas.toDataURL(\'image/png\'));\r\n    };\r\n\r\n    image.src = url;\r\n  }\r\n\r\n  /**\r\n   * Sign Pad Data 조회\r\n   *\r\n   * @param\r\n   * @return\r\n   */\r\n  function fnGetSignData(signType) {\r\n    var signData = \'\';\r\n\r\n    if (signType == \'A\') {\r\n      signData = agreeSignPad.toDataURL(\'image/png\');\r\n    } else {\r\n      signData = faceSignPad.toDataURL(\'image/png\');\r\n    }\r\n\r\n    return signData;\r\n  }\r\n\r\n\r\n  /**\r\n   * Sign Pad Data 표시\r\n   *\r\n   * @param\r\n   * @return\r\n   */\r\n  function fnSetSignData(signType, signData) {\r\n\r\n    if (signType == \'A\') {\r\n      //agreeSignPad.clear();\r\n      agreeSignPad.fromDataURL(signData);\r\n    } else {\r\n      //faceSignPad.clear();\r\n      faceSignPad.fromDataURL(signData);\r\n    }\r\n\r\n    return signData;\r\n  }\r\n\r\n\r\n  /**\r\n   * 인쇄\r\n   *\r\n   * @param\r\n   * @return\r\n   */\r\n  function fnSetPrint() {\r\n\r\n\r\n  }</script>");
$templateCache.put("app/customer/customer-edit-tab2.html","<!-- 상담이력 --><div ng-controller=\"CustomerEditTab2Ctrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class={{liCol.ListColumnTextAlign}} ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns\" style=\"max-width: 100px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm\')}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul boundary-links=true data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" items-per-page=vc.viewSize last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" max-size=vc.maxSize name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage num-pages=vc.numPages previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" rotate=false template-url=app/template/pagination.html total-items=vc.totalItems uib-pagination></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/customer/customer-edit-tab3.html","<!-- 구매이력 --><div ng-controller=\"CustomerEditTab3Ctrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=\"row mt-10\"><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'ReceiptImg\'\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm\')}} </span></span><span ng-if=\"liCol.ColumnPhysicalNm == \'ReceiptImg\' && li[\'ReceiptImg\'] != \'\'\"><a href=\"{{li[\'ReceiptImg\']}}\" target=attach>다운로드</a></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul boundary-links=true data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" items-per-page=vc.viewSize last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" max-size=vc.maxSize name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage num-pages=vc.numPages previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" rotate=false template-url=app/template/pagination.html total-items=vc.totalItems uib-pagination></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/customer/customer-edit-tab4.html","<!-- 예약이력 --><div ng-controller=\"CustomerEditTab4Ctrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=\"row mt-10\"><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm\')}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul boundary-links=true data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" items-per-page=vc.viewSize last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" max-size=vc.maxSize name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage num-pages=vc.numPages previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" rotate=false template-url=app/template/pagination.html total-items=vc.totalItems uib-pagination></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/customer/customer-edit-tab5.html","<!-- SMS이력 --><div ng-controller=\"CustomerEditTab5Ctrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=\"row mt-10\"><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\" style=\"max-width: 100px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm\')}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul boundary-links=true data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" items-per-page=vc.viewSize last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" max-size=vc.maxSize name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage num-pages=vc.numPages previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" rotate=false template-url=app/template/pagination.html total-items=vc.totalItems uib-pagination></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/customer/customer-edit-tab6.html","<!-- 설문이력 --><div ng-controller=\"CustomerEditTab6Ctrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=\"row mt-10\"><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm\')}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul boundary-links=true data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" items-per-page=vc.viewSize last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" max-size=vc.maxSize name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage num-pages=vc.numPages previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" rotate=false template-url=app/template/pagination.html total-items=vc.totalItems uib-pagination></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/customer/customer-edit.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"CustomerEditCtrl as vc\"><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- page content --><div class=pagecontent><ul class=\"nav nav-tabs\" ng-show=\"vc.keyId != \'\'\"><li ng-class=\"vc.url == \'/tab1\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab1\');\" style=cursor:pointer>고객정보</a></li><li ng-class=\"vc.url == \'/tab2\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab2\');\" style=cursor:pointer>상담이력</a></li><li ng-class=\"vc.url == \'/tab3\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab3\');\" style=cursor:pointer>구매이력</a></li><li ng-class=\"vc.url == \'/tab4\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab4\');\" style=cursor:pointer>예약이력</a></li><li ng-class=\"vc.url == \'/tab5\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab5\');\" style=cursor:pointer>SMS이력</a></li><li ng-class=\"vc.url == \'/tab6\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'tab6\');\" style=cursor:pointer>설문이력</a></li></ul><ui-view></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/customer/customer-list.html","<div class=\"page page-footable\" ng-controller=\"CustomerListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객조회<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div class=pane-root fa-pane=\"\"><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.srchKeyword placeholder=\"고객명/연락처 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CustNm type=text><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustGrade\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CustGrade\'].CodeList\" code-model=vc.srch.CustGrade></common-code-custom><label>{{vc.columnMap[\'CustGrade\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'VisitPath\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'VisitPath\'].CodeList\" code-model=vc.srch.VisitPath></common-code-custom><label>{{vc.columnMap[\'VisitPath\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ManagerNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'ManagerNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> 신규등록</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\">{{$root.gVariable.listKeyId}}<!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':$root.gVariable.listKeyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goEdit(li.KeyId, li.DetailPageUrl, li.ListDetailPageUrl, li.LoginId)\" ng-repeat=\"liCol in vc.listColumns\" style=\"max-width: 100px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\" title=\"{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul boundary-links=true data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" items-per-page=vc.viewSize last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" max-size=vc.maxSize name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage num-pages=vc.numPages previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" rotate=false template-url=app/template/pagination.html total-items=vc.totalItems uib-pagination></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane ng-if=\"vc.layout != \'N\'\" pane-min=600px style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img alt=\"\" src=assets/images/icon-write-line.svg style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dashboard/cafe24dashboard.html","<div class=\"page page-footable\" ng-controller=\"Cafe24dashboardCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><div class=\"page-header brd-b0 mb-0\">Dashboard</div></div></div><!-- page content --><div class=\"pagecontent fnt14\"><!-- row --><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=row><div class=col-lg-12><div class=\"dashbrd-notice-box mr-0 box-basic\">* Cafe24 쇼핑몰의 데이터를 실시간으로 연동하시려면, 시스템관리 > 공통설정관리에서 \'카페24연동\' 항목을 \'사용\'으로 설정해 주세요.<div ng-if=\"vc.cafe24data.CodeValue == \'Y\'\">* 현재 연동설정이 되어 있습니다. 10분에 1회씩 동기화작업이 진행됩니다.</div><div ng-if=\"vc.cafe24data.CodeValue != \'Y\'\">* 현재 연동설정이 되어 있지 않습니다.</div></div></div><div class=col-lg-6><!-- col --><div class=\"col-lg-12 dashboard-panel-box box-basic mb-10\"><div class=\"col-lg-3 inbox\"><strong>고객수</strong><p class=\"text-center text-strong mb-0\">{{vc.cafe24data.custom+erCnt | number}}</p></div><div class=\"col-lg-3 inbox\"><strong>상품수</strong><p class=\"text-center text-strong mb-0\">{{vc.cafe24data.productCnt | number}}</p></div><div class=\"col-lg-3 inbox\"><strong>총 판매건수</strong><p class=\"text-center text-strong mb-0\">{{vc.cafe24data.orderCnt | number}}</p></div><div class=\"col-lg-3 inbox\"><strong>총 판매금액</strong><p class=\"text-center text-strong mb-0\">{{vc.cafe24data.orderPrice | number}}</p></div></div><!-- //col --><!-- col --><div class=\"col-lg-12 box-basic pd-30\"><div>* 데이터분석 방법<br>&nbsp;&nbsp;&nbsp;1) 쇼핑몰데이터분석 > 데이터그룹관리에서 데이터그룹과 작업을 등록<br>&nbsp;&nbsp;&nbsp;2) 쇼핑몰데이터분석 > 분석실행</div><div ng-if=\"vc.totalItems > 0\">* 현재 분석결과가 있습니다.</div><div ng-if=\"vc.totalItems == 0\">* 현재 분석결과가 없습니다.</div><div class=\"form-group mt-20\"><div class=input-group><common-code-tree code-list=vc.dagrouplists reload-seq=vc.reloadSeq code-model=vc.GroupAndAction prevent-changing=true></common-code-tree><span class=input-group-btn><button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" ng-click=vc.getList()><i class=\"fa fa-refresh\"></i> 조회</button></span></div></div><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" style=\"width: 20%\">클러스터</th><th class=\"text-center none\" style=\"width: 15%\">R</th><th class=\"text-center none\" style=\"width: 15%\">F</th><th class=\"text-center none\" style=\"width: 15%\">M</th><th class=\"text-center none\" style=\"width: 20%\">설명</th><th class=\"text-center none\" style=\"width: 10%\">고객수</th><th class=\"text-center none\" style=\"width: 100px\">비율</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems[0] == 0\"><tr class=tbnodata><td class=text-center colspan=7>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><td class=text-center><span>{{li.ClusterNo}}</span></td><td class=text-right><span>{{li.Recency | number}}({{li.RecencyScore}})</span></td><td class=text-right><span>{{li.Frequency | number}}({{li.FrequencyScore}})</span></td><td class=text-right><span>{{li.Monetary | number}}({{li.MonetaryScore}})</span></td><td class=text-center><span>{{li.Description}}</span></td><td class=text-right><span>{{li.cnt | number}}</span></td><td class=text-center><uib-progressbar class=\"progress-xxs not-rounded mb-0 inline-block\" value=li.per type=greensea style=\"width: 100%; margin-right: 5px\"></uib-progressbar><small>{{li.per | number:0}}%</small></td></tr></table></div><!-- //col --><!-- col --><div class=\"col-lg-12 dashboard-panel-box box-basic mt-10\"><div class=\"col-lg-3 inbox\"><strong>고객수</strong><p class=\"text-center text-strong mb-0\">{{vc.data.cnt[0] | number}}</p></div><div class=\"col-lg-4 inbox\"><strong>상품수</strong><p class=\"text-center text-strong mb-0\">{{vc.data.cnt[1] | number}}</p></div><div class=\"col-lg-5 inbox\"><strong>총판매</strong><p class=\"text-center text-strong mb-0\">{{vc.data.cnt[2] | number}}</p></div></div><!-- /col --></div><div class=col-lg-6><div id=regTitle0 class=box-basic></div></div></div><div class=\"col-lg-8 mt-10 pl-0\"><div class=\"col-lg-12 sz-search box-basic pd-30 pl-0\"><canvas id=line class=\"chart chart-line fixed-height-chart dashboard-chart height-214 pt-20\" chart-data=vc.chart.mixdata chart-labels=vc.chart.mixlabels chart-colors=vc.chart.mixcolors chart-dataset-override=vc.chart.mixdatasetOverride chart-options=vc.chart.options></canvas></div><div class=\"col-lg-12 sz-search box-basic pd-30 pl-0 mt-10\"><canvas id=line class=\"chart chart-line fixed-height-chart dashboard-chart height-214\" chart-data=vc.chart.mixdata2 chart-labels=vc.chart.mixlabels2 chart-colors=vc.chart.mixcolors chart-dataset-override=vc.chart.mixdatasetOverride chart-options=vc.chart.options></canvas></div></div><div class=\"col-lg-4 sz-search mt-10 pd-30 box-basic mr-0\"><div id=regTitle11></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/dashboard.html","<div class=\"page page-footable\" id=dashboard ng-controller=\"DashboardCtrl as vc\"><div class=\"col-md-12 mb-15 mt-10\"><h1 class=page-header>Dashboard</h1></div><div class=dataloader ng-show=vc.dataloader></div></div>");
$templateCache.put("app/dashboard/survey-dashboard.html","<div class=\"page page-footable\" ng-controller=\"WjmDashboardCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><div class=page-header>진단 현황</div></div></div><!-- page content --><div class=pagecontent><!-- row --><div class=dataloader ng-show=vc.dataloader></div><div class=row ng-show=\"vc.roleType == \'ADM\'\"><div class=col-lg-6><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading><div class=col-xs-6>진단 진행(건수별) 추이</div><div><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.srch2.SurveyNm readonly style=height:19px placeholder=-전체설문-> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchSurveyModal(); style=\"min-height:18px !Important\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseSurvey(); style=\"min-height:18px !Important\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=panel-body><canvas id=line class=\"chart chart-line fixed-height-chart\" chart-data=vc.chart.data1 chart-labels=vc.chart.labels1 chart-series=vc.chart.series1 chart-dataset-override=vc.chart.datasetOverride1 chart-options=vc.chart.options1></canvas></div></div></div></div></div><div class=col-lg-6><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>진단 진행(타입별) 추이</div><div class=panel-body><canvas id=bar class=\"chart chart-bar fixed-height-chart\" chart-data=vc.chart.data2 chart-labels=vc.chart.labels2 chart-series=vc.chart.series2 chart-dataset-override=vc.chart.datasetOverride2 chart-options=vc.chart.options2></canvas></div></div></div></div></div></div><div class=row ng-show=\"vc.roleType != \'ADM\'\"><div class=col-lg-8><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>진단 인원증가 추이</div><div class=panel-body><!-- fixed-height-chart --><canvas style=height:405px class=\"chart chart-line\" chart-data=vc.chart.data3 chart-labels=vc.chart.labels3 chart-series=vc.chart.series3 chart-dataset-override=vc.chart.datasetOverride3 chart-options=vc.chart.options3></canvas></div></div></div></div></div><div class=col-lg-4><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>스트레스 진단 분포</div><div class=panel-body><div id=container style=\"width: auto\"></div><!--<div id=\"regTitle0\" style=\"margin-top:-100px; height:500px;\"></div>--></div></div></div></div></div></div><div class=row ng-show=\"vc.roleType == \'ADM\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>진단센터 현황</div><div class=panel-body><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">등록된 심리검사</th><th class=\"text-center none showlevel1\">작성중인 프로젝트</th><th class=\"text-center none showlevel1\">진행중인 프로젝트</th><th class=\"text-center none showlevel1\">진행완료 프로젝트</th></tr></thead><tbody><tr class=tbnodata ng-if=\"vc.svyTotalItems == 0\"><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr><tr ng-repeat=\"li in vc.svyLists\"><td class=\"text-center showlevel1\">{{li.GubunNm}}</td><td class=\"text-center showlevel1\" ng-click=\"vc.goSvyList(\'\')\">{{li.TotCnt}}</td><td class=\"text-center showlevel1\" ng-click=\"vc.goSvyList(\'1\')\">{{li.EditCnt}}</td><td class=\"text-center showlevel1\" ng-click=\"vc.goSvyList(\'2\')\">{{li.BeginCnt}}</td><td class=\"text-center showlevel1\" ng-click=\"vc.goSvyList(\'3\')\">{{li.EndCnt}}</td></tr></tbody></table></div></div></div></div><div class=row ng-show=\"vc.roleType != \'ADM\'\"><div class=col-lg-8 style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>접속정보</div><div class=panel-body style=min-height:300px>{{vc.userNm}} 담당자님 안녕하세요!<br><img ng-src={{vc.dashImgSrc}} style=padding-top:10px></div></div></div><div class=col-lg-4 style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>상담사별 상담건수</div><div class=panel-body style=\"height:300px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">상담사명</th><th class=\"text-center none showlevel1\">상담사코드</th><th class=\"text-center none showlevel1\">상담건수</th></tr></thead><tbody><tr class=tbnodata ng-if=\"vc.counselorTotalItems == 0\"><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr><tr ng-repeat=\"li in vc.counselorLists\"><td class=\"text-center showlevel1\">{{li.UserNm}}</td><td class=\"text-center showlevel1\">{{li.CounselorCode}}</td><td class=\"text-center showlevel1\">{{li.CounselCnt}}</td></tr></tbody></table></div></div></div></div><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>프로젝트 현황</div><div class=panel-body><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SvyNm placeholder=\"프로젝트명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none; position:absolute\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNum type=text><label>{{vc.columnMap[\'SvyNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ManagerNm\'] && vc.roleType == \'ADM\'\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'ManagerNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNm type=text><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyBeginDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SvyBeginDate = (vc.SvyBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyBeginDate ng-required=false placeholder=\"{{vc.columnMap[\'SvyBeginDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyEndDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SvyEndDate = (vc.SvyEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyEndDate ng-required=false placeholder=\"{{vc.columnMap[\'SvyEndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SvyStatus\'].CodeList\" code-model=vc.srch.SvyStatus></common-code-custom><label>{{vc.columnMap[\'SvyStatus\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><!--\r\n                    <button class=\"btn btn-default\" ng-click=\"vc.getExcelFile()\"><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button>\r\n                    --> <button class=\"btn btn-primary\" ng-click=vc.goAdd() ng-show=\"vc.roleType == \'ADM\'\"><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteList() ng-show=\"vc.roleType == \'ADM\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- Search Result --><div class=table-responsive><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><tbody><tr class=tbnodata ng-if=\"vc.prjTotalItems == 0\"><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr><!--<tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer;\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\">--><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox ng-disabled=\"li.SvyStatusCd != \'1\' && li.SvyStatusCd != \'2\'\"></td><!--<td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goView(li.KeyId)\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">\r\n                  {{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm]\r\n                  | utcToLocal:\'yyyy-MM-dd\')}}--><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\" ng-click=\"vc.goView(liCol.ColumnPhysicalNm, li)\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></tbody></table></div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/cvssales/cvssales-detail.html","<div class=\"page page-footable\" ng-controller=\"CvsSalesDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>정산</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div ng-if=\"vc.tabId == 1\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-if=\"vc.data.AprvStatus !=\'A\'\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>매출 상세</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\" ng-if=\"vc.data.SalesType == \'100\' || vc.data.SalesType == null\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PurchDate\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.PurchDate readonly></div></div></div><!--승인 버튼 관리자만 가능--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'AprvStatus\'].ColumnLogicalNm | translate }}</label><div class=input-group><button ng-if=\"$root.gVariable.SysAdminYN == \'Y\' && vc.data.AprvStatus ==\'W\'\" class=\"btn btn-default\" ng-click=vc.updateStatus()><span class=\"glyphicon glyphicon-check\">승인</span></button> <input type=text class=\"form-control form-right\" ng-if=\"($root.gVariable.SysAdminYN != \'Y\' && vc.data.AprvStatus != null && vc.data.AprvStatus != \'\') || ($root.gVariable.SysAdminYN == \'Y\' && vc.data.AprvStatus ==\'A\')\" maxlength=255 ng-model=vc.data.AprvStatusNm readonly></div></div></div></div><div class=row><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=\"$root.gVariable.SysAdminYN == \'Y\'\"><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GoodsNm readonly></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-only ng-model=vc.data.ProductQty readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.ProductAmt readonly></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayMeth\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PayMeth\'].CodeList\" code-model=vc.data.PayMeth is-disabled=true></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PurchType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PurchType\'].CodeList\" code-model=vc.data.PurchType is-disabled=true></common-code-custom></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --><!-- 일반판매 일 경우--><!-- tile body --><div class=\"panel-body collapse in\" ng-if=\"vc.data.SalesType ==\'300\'\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.CustomerNm readonly></div></div></div><!--승인 버튼 관리자만 가능--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'AprvStatus\'].ColumnLogicalNm | translate }}</label><div class=input-group><button ng-if=\"$root.gVariable.SysAdminYN == \'Y\' && vc.data.AprvStatus ==\'W\'\" class=\"btn btn-default\" ng-click=vc.updateStatus()><span class=\"glyphicon glyphicon-check\">승인</span></button> <input type=text class=\"form-control form-right\" ng-if=\"$root.gVariable.SysAdminYN != \'Y\' || vc.data.AprvStatus ==\'A\' || vc.data.AprvStatus ==\'H\'\" maxlength=255 ng-model=vc.data.AprvStatusNm readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PurchDate\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.PurchDate readonly></div></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GoodsNm readonly></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changePrdAmt() maxlength=255 numbers-only ng-model=vc.data.ProductQty readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.ProductAmt readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=form-group><label>{{ vc.columnMap[\'SellType\'].ColumnLogicalNm | translate }}</label><label ng-repeat=\"li in vc.columnMap[\'SellType\'].CodeList\"><input type=radio ng-model=vc.data.SellType ng-disabled=true value={{li.Code}}>{{li.CodeValue}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.SellType !=\'100\'\" ng-model=vc.data.CustNm readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'Cntct\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.SellType !=\'100\'\" ng-model=vc.data.Cntct readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'InflowPath\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.SellType !=\'100\'\" ng-model=vc.data.InflowPath readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductBarCdNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-only ng-model=vc.data.ProductBarCdNo readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayMeth\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PayMeth\'].CodeList\" code-model=vc.data.PayMeth is-disabled=true></common-code-custom></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'PayAprvNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.PayMeth != \'200\'\" ng-model=vc.data.PayAprvNo readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CardNo4Digits\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=4 ng-disabled=\"vc.data.PayMeth != \'200\'\" numbers-only ng-model=vc.data.CardNo4Digits readonly></div></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!-- file upload--><div class=row><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12\"><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" aria-label=Check ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></form></div><!--관리권--><!-- tile body --><div class=\"panel-body collapse in\" ng-if=\"vc.data.SalesType ==\'200\'\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.CustomerNm readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PurchDate\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.PurchDate readonly></div></div></div><!--승인 버튼 관리자만 가능--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'AprvStatus\'].ColumnLogicalNm | translate }}</label><div class=input-group><button ng-if=\"$root.gVariable.SysAdminYN == \'Y\' && vc.data.AprvStatus ==\'W\'\" class=\"btn btn-default\" ng-click=vc.updateStatus()><span class=\"glyphicon glyphicon-check\">승인</span></button> <input type=text class=\"form-control form-right\" ng-if=\"$root.gVariable.SysAdminYN != \'Y\' || vc.data.AprvStatus ==\'A\' || vc.data.AprvStatus ==\'H\'\" maxlength=255 ng-model=vc.data.AprvStatusNm readonly></div></div></div></div><div class=row><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CareTktNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.CareTktNm readonly></div></div></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GoodsNm readonly></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CareTktQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changeTktAmt() maxlength=255 numbers-only ng-model=vc.data.CareTktQty readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CareTktAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.CareTktAmt readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changePrdAmt() maxlength=255 numbers-only ng-model=vc.data.ProductQty readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.ProductAmt readonly></div></div></div></div><div class=row><div class=\"col-lg-3 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SellerNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SellerNm readonly></div></div></div><div class=\"col-lg-3 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SptUserNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SptUserNm readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductBarCdNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-only ng-model=vc.data.ProductBarCdNo readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayMeth\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PayMeth\'].CodeList\" is-disabled=true code-model=vc.data.PayMeth></common-code-custom></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'PayAprvNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.PayMeth != \'200\'\" ng-model=vc.data.PayAprvNo readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CardNo4Digits\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=4 ng-disabled=\"vc.data.PayMeth != \'200\'\" numbers-only ng-model=vc.data.CardNo4Digits readonly></div></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!-- file upload--><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" aria-label=Check ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></form></div></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-if=\"vc.data.AprvStatus !=\'A\'\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvssales/cvssales-edit.html","<div class=\"page page-footable\" ng-controller=\"CvsSalesEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>정산</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div ng-if=\"vc.tabId == 1\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>매출 상세</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\" ng-if=\"vc.data.SalesType == \'100\' || vc.data.SalesType == null\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PurchDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.PurchDate = (vc.PurchDate | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!--승인 버튼 관리자만 가능--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'AprvStatus\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.AprvStatusNm readonly></div></div></div></div><div class=row><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=\"$root.gVariable.SysAdminYN == \'Y\'\"><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GoodsNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchPrdModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.erasePrd();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changePrdAmt() maxlength=255 numbers-only ng-model=vc.data.ProductQty></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.ProductAmt readonly></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayMeth\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PayMeth\'].CodeList\" code-model=vc.data.PayMeth></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PurchType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PurchType\'].CodeList\" code-model=vc.data.PurchType></common-code-custom></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --><!-- 일반판매 일 경우--><!-- tile body --><div class=\"panel-body collapse in\" ng-if=\"vc.data.SalesType ==\'300\'\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CustId\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.CustomerNm readonly></div></div></div><!--승인 버튼 관리자만 가능--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'AprvStatus\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.AprvStatusNm readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PurchDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.PurchDate = (vc.PurchDate | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GoodsNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchPrdModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.erasePrd();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changePrdAmt() maxlength=255 numbers-only ng-model=vc.data.ProductQty></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.ProductAmt readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=form-group><label>{{ vc.columnMap[\'SellType\'].ColumnLogicalNm | translate }}</label><label ng-repeat=\"li in vc.columnMap[\'SellType\'].CodeList\"><input type=radio ng-model=vc.data.SellType value={{li.Code}}>{{li.CodeValue}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.SellType !=\'100\'\" ng-model=vc.data.CustNm></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'Cntct\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.SellType !=\'100\'\" ng-model=vc.data.Cntct></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'InflowPath\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.SellType !=\'100\'\" ng-model=vc.data.InflowPath></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductBarCdNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-only ng-model=vc.data.ProductBarCdNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayMeth\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PayMeth\'].CodeList\" code-model=vc.data.PayMeth></common-code-custom></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'PayAprvNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.PayMeth != \'200\'\" ng-model=vc.data.PayAprvNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CardNo4Digits\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=4 ng-disabled=\"vc.data.PayMeth != \'200\'\" numbers-only ng-model=vc.data.CardNo4Digits></div></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!-- file upload--><div class=row><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" aria-label=Check ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></form></div><!--관리권--><!-- tile body --><div class=\"panel-body collapse in\" ng-if=\"vc.data.SalesType ==\'200\'\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CustId\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.CustomerNm readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PurchDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.PurchDate = (vc.PurchDate | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!--승인 버튼 관리자만 가능--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'AprvStatus\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.AprvStatusNm readonly></div></div></div></div><div class=row><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CareTktId\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.CareTktNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchCareTktModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseCareTkt();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GoodsNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchPrdModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.erasePrd();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CareTktQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changeTktAmt() maxlength=255 numbers-only ng-model=vc.data.CareTktQty></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CareTktAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.CareTktAmt readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changePrdAmt() maxlength=255 numbers-only ng-model=vc.data.ProductQty></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.ProductAmt readonly></div></div></div></div><div class=row><div class=\"col-lg-3 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SellerId\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SellerNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchSellerModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseSeller();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-lg-3 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SptUserId\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SptUserNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchSptUserModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseSptUser();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductBarCdNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-only ng-model=vc.data.ProductBarCdNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayMeth\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PayMeth\'].CodeList\" code-model=vc.data.PayMeth></common-code-custom></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'PayAprvNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.PayMeth != \'200\'\" ng-model=vc.data.PayAprvNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CardNo4Digits\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=4 ng-disabled=\"vc.data.PayMeth != \'200\'\" numbers-only ng-model=vc.data.CardNo4Digits></div></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!-- file upload--><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" aria-label=Check ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></form></div></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvssales/cvssales-list.html","<div class=\"page page-footable\" ng-controller=\"CvsSalesListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>정산<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.MainSrchNm placeholder=\"품목/관리권 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PurchDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.PurchDtFrom = (vc.PurchDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDtFrom ng-required=false placeholder=매출시작일 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PurchDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.PurchDtTo = (vc.PurchDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDtTo ng-required=false placeholder=매출종료일 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'GoodsNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.GoodsNm readonly type=text><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchPrdModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.erasePrd(); ng-disabled=\"gVariable.TenantId == \'0\'\" type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CareTktNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CareTktNm readonly type=text><label>{{vc.columnMap[\'CareTktNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchCareTktModal(); ng-disabled=\"gVariable.TenantId == \'0\'\" type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseCareTkt(); ng-disabled=\"gVariable.TenantId == \'0\'\" type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><!-- <input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"> --></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg(li)></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goDetail(li.KeyId) ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvssales/cvssalesgen-edit.html","<div class=\"page page-footable\" ng-controller=\"CvsSalesGenEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>판매등록(일반판매)</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div ng-if=\"vc.tabId == 1\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>매출 상세</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.CustomerNm readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PurchDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.PurchDate = (vc.PurchDate | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GoodsNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchPrdModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.erasePrd();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changePrdAmt() maxlength=255 numbers-only ng-model=vc.data.ProductQty></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.ProductAmt readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=form-group><label>{{ vc.columnMap[\'SellType\'].ColumnLogicalNm | translate }}</label><label ng-repeat=\"li in vc.columnMap[\'SellType\'].CodeList\"><input type=radio ng-model=vc.data.SellType value={{li.Code}}>{{li.CodeValue}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.SellType !=\'100\'\" ng-model=vc.data.CustNm></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'Cntct\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.SellType !=\'100\'\" ng-model=vc.data.Cntct></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'InflowPath\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.SellType !=\'100\'\" ng-model=vc.data.InflowPath></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductBarCdNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-only ng-model=vc.data.ProductBarCdNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayMeth\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PayMeth\'].CodeList\" code-model=vc.data.PayMeth></common-code-custom></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'PayAprvNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.PayMeth != \'200\'\" ng-model=vc.data.PayAprvNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CardNo4Digits\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=4 ng-disabled=\"vc.data.PayMeth != \'200\'\" numbers-only ng-model=vc.data.CardNo4Digits></div></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!-- file upload--><div class=row><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" aria-label=Check ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvssales/cvssalesgen-list.html","<div class=\"page page-footable\" ng-controller=\"CvsSalesGenListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>판매등록(일반판매)<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.srchKeyword placeholder=\"고객명/연락처 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CustNm type=text><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustGrade\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CustGrade\'].CodeList\" code-model=vc.srch.CustGrade></common-code-custom><label>{{vc.columnMap[\'CustGrade\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'VisitPath\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'VisitPath\'].CodeList\" code-model=vc.srch.VisitPath></common-code-custom><label>{{vc.columnMap[\'VisitPath\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Manager\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvssales/cvssalesorder-list.html","<div class=\"page page-footable\" ng-controller=\"CvssalesorderListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>주문 목록<!--\r\n        <div class=\"pull-right dock-header-tx\" style=\"word-spacing: -6px;\">\r\n          <span ng-click=\"vc.setChangeLayout(\'N\')\"><i class=\"fa fa-square fa-border\"></i></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'V\')\"><i class=\"fa fa-columns fa-border\"></i></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'H\')\"><i class=\"fa fa-columns fa-rotate-270 fa-border\"></i></span>\r\n        </div>\r\n        --></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-lg-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.MemNm placeholder=\"주문자 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색</div><div class=panel-body><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'RegDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDtFrom = (vc.RegDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDtFrom ng-required=false placeholder=주문시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-12 ng-if=\"vc.columnMap[\'RegDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDtTo = (vc.RegDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDtTo ng-required=false placeholder=주문종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!--<div class=\"col-lg-12\" ng-if=\"vc.columnMap[\'DeliveryCompleteDt\']\">--><div class=col-lg-12><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.DeliveryCompleteDtFrom = (vc.DeliveryCompleteDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.DeliveryCompleteDtFrom ng-required=false placeholder=배송완료시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!--<div class=\"col-lg-12\" ng-if=\"vc.columnMap[\'DeliveryCompleteDt\']\">--><div class=col-lg-12><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.DeliveryCompleteDtTo = (vc.DeliveryCompleteDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.DeliveryCompleteDtTo ng-required=false placeholder=배송완료종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!--<div class=\"col-lg-12\" ng-if=\"vc.columnMap[\'GoodsNm\']\">--><div class=col-lg-12><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.GoodsNm readonly type=text><!--<label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label>--><label>주문제품</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchPrdModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.erasePrd(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=col-lg-12 ng-if=\"vc.columnMap[\'MemNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.MemNm type=text><label>{{vc.columnMap[\'MemNm\'].ColumnLogicalNm | translate}}</label></div></div></div><div class=row><div class=col-lg-12><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div></div></div></div><div class=col-lg-6><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><!--\r\n                  <button class=\"btn btn-primary\" ng-click=\"vc.goAdd()\">\r\n                    <i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}\r\n                  </button>\r\n                  <button class=\"btn btn-danger\" ng-click=\"vc.deleteList()\">\r\n                    <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n                  </button>\r\n                  --></div></div></div><!-- /검색영역 --></form><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-body><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!--\r\n                      <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"></th>\r\n                      --><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T2.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T2.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><!--\r\n                      <td class=\"text-center\" style=\"vertical-align:middle;\"><input type=\"checkbox\" ng-model=\"li.chkRow\" ng-change=\"chkRowChg()\">\r\n                      --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd HH:mm:ss\':\'UTC\')}} <input type=button value=배송추적 ng-show=\"liCol.ColumnPhysicalNm == \'invoiceNo\' && li[liCol.ColumnPhysicalNm] != \'\'\" ng-click=vc.popInvoice(li[liCol.ColumnPhysicalNm])></td></tr></table><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div><!--\r\n        <div fa-pane pane-min=\"600px\" ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\">\r\n          <ui-view>\r\n          </ui-view>\r\n        </div>\r\n        --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvssales/cvssalesstock-edit.html","<div class=\"page page-footable\" ng-controller=\"CvssalesstockEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>재고 입/출고</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button><!--\r\n            <button class=\"btn btn-danger\" ng-click=\"vc.setDelData()\">\r\n              <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n            </button>\r\n            --></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>재고 입/출고</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-4 ng-show=\"vc.srch.srchTenantId != 0\"><div class=\"form-group form-inline xs-mb10\"><label>일자</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.InvntryDate = (vc.InvntryDate | date: \'yyyy-MM-dd\')\" ng-model=vc.InvntryDate ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>제품명</label><div class=input-group><input class=\"form-control form-right\" ng-model=vc.data.GoodsNm readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchPrdModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.erasePrd(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4 ng-show=\"vc.srch.srchTenantId != 0\"><div class=\"form-group form-inline\"><label>제품바코드</label><input type=text class=\"form-control form-right\" ng-model=vc.data.ProductBarCdNo maxlength=50></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>수량(입/출고 수량)</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TotalStock maxlength=11 numbers-hyphen></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>구분</label><common-code-custom code-list=vc.StockTypeCodeList code-model=vc.data.StockType></common-code-custom></div></div><div class=col-lg-4 ng-show=\"vc.srch.srchTenantId != 0\"><div class=\"form-group form-inline\"><label>출고구분</label><common-code-custom code-list=vc.DelivTypeCodeList code-model=vc.data.DelivType></common-code-custom></div></div></div></form></div></div></div></div><div class=row><div class=\"col-lg-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button><!--\r\n            <button class=\"btn btn-danger\" ng-click=\"vc.delData()\">\r\n              <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n            </button>\r\n            --></div></div></div></div></div><!-- /page content --><!-- 쇼핑몰 연동용 iframe --><iframe id=shopFrame name=shopFrame>");
$templateCache.put("app/cvssales/cvssalesstock-list.html","<div class=\"page page-footable\" ng-controller=\"CvssalesstockListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>재고 목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-lg-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.DefGoodsNm placeholder=\"제품명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색</div><div class=panel-body><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'StockInDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.StockInDateFrom = (vc.StockInDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.StockInDateFrom ng-required=false placeholder=최근입고시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-12 ng-if=\"vc.columnMap[\'StockInDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.StockInDateTo = (vc.StockInDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.StockInDateTo ng-required=false placeholder=최근입고종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-12 ng-if=\"vc.columnMap[\'StockOutDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.StockOutDateFrom = (vc.StockOutDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.StockOutDateFrom ng-required=false placeholder=최근출고시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-12 ng-if=\"vc.columnMap[\'StockOutDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.StockOutDateTo = (vc.StockOutDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.StockOutDateTo ng-required=false placeholder=최근출고종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-12 ng-if=\"vc.columnMap[\'GoodsNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.GoodsNm readonly type=text><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchPrdModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.erasePrd(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!--<div class=\"col-lg-12\" ng-if=\"vc.columnMap[\'ProductBarCdNo\']\">--><div class=col-lg-12><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ProductBarCdNo type=text><!--<label>{{vc.columnMap[\'ProductBarCdNo\'].ColumnLogicalNm | translate}}</label>--><label>제품바코드</label></div></div></div><div class=row><div class=col-lg-12><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div></div></div></div><div class=col-lg-6><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> 입/출고</button><!--\r\n                  <button class=\"btn btn-danger\" ng-click=\"vc.deleteList()\">\r\n                    <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n                  </button>\r\n                  --></div></div></div><!-- /검색영역 --></form><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-body><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!--\r\n                      <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"></th>\r\n                      --><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T2.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T2.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':selectedRow == li.GoodsNo}\"><!-- Result Items --><!--\r\n                      <td class=\"text-center\" style=\"vertical-align:middle;\"><input type=\"checkbox\" ng-model=\"li.chkRow\" ng-change=\"chkRowChg()\">\r\n                      --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\" ng-click=\"vc.goEdit(li.GoodsNo, li.GoodsNm)\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvssales/cvssalestkt-edit.html","<div class=\"page page-footable\" ng-controller=\"CvsSalesTktEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>판매등록(관리권)</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div ng-if=\"vc.tabId == 1\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>매출 상세</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.CustomerNm readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PurchDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.PurchDate = (vc.PurchDate | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CareTktNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.CareTktNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchCareTktModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseCareTkt();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GoodsNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchPrdModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.erasePrd();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CareTktQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changeTktAmt() maxlength=255 numbers-only ng-model=vc.data.CareTktQty></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CareTktAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.CareTktAmt readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductQty\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-change=vc.changePrdAmt() maxlength=255 numbers-only ng-model=vc.data.ProductQty></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductAmt\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.ProductAmt readonly></div></div></div></div><div class=row><div class=\"col-lg-3 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SellerNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SellerNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchSellerModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseSeller();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-lg-3 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SptUserNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SptUserNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchSptUserModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseSptUser();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'ProductBarCdNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-only ng-model=vc.data.ProductBarCdNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PayMeth\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PayMeth\'].CodeList\" code-model=vc.data.PayMeth></common-code-custom></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'PayAprvNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-disabled=\"vc.data.PayMeth != \'200\'\" ng-model=vc.data.PayAprvNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'CardNo4Digits\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=4 ng-disabled=\"vc.data.PayMeth != \'200\'\" numbers-only ng-model=vc.data.CardNo4Digits></div></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div><!-- file upload--><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>영수증</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" aria-label=Check ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvssales/cvssalestkt-list.html","<div class=\"page page-footable\" ng-controller=\"CvsSalesTktListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>판매등록(관리권)<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.srchKeyword placeholder=\"고객명/연락처 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CustNm type=text><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustGrade\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CustGrade\'].CodeList\" code-model=vc.srch.CustGrade></common-code-custom><label>{{vc.columnMap[\'CustGrade\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'VisitPath\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'VisitPath\'].CodeList\" code-model=vc.srch.VisitPath></common-code-custom><label>{{vc.columnMap[\'VisitPath\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Manager\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvsreserv/cvsreserv-edit.html","<div class=\"page page-footable\" ng-controller=\"CvsreservEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>예약 등록</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>예약정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div id=calendar style=\"float:center; width:100%\"></div></div></div></div></div><!-- /col --></div><!-- /row --></div><!-- /page content --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\"><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/cvsreserv/cvsreserv-list.html","<div class=\"page page-footable\" ng-controller=\"CvsreservListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>예약 등록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.srchKeyword placeholder=\"고객명/연락처 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ReservDateFrom = (vc.ReservDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.ReservDateFrom ng-required=false placeholder=예약시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ReservDateTo = (vc.ReservDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.ReservDateTo ng-required=false placeholder=예약종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CustNm type=text><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ReservReason\'].CodeList\" code-model=vc.srch.ReservReason></common-code-custom><label>{{vc.columnMap[\'ReservReason\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>예약정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div id=calendar style=\"float:center; width:100%\" ng-controller=\"CvsreservEditCtrl as vc\"></div></div></div></div></div><!-- /col --></div></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvsreserv/cvsreserv-view-list.html","<div class=\"page page-footable\" ng-controller=\"CvsreservViewListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>예약 현황<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.srchKeyword placeholder=\"고객명/연락처 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ReservDateFrom = (vc.ReservDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.ReservDateFrom ng-required=false placeholder=예약시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ReservDateTo = (vc.ReservDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.ReservDateTo ng-required=false placeholder=예약종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CustNm type=text><label>{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ReservReason\'].CodeList\" code-model=vc.srch.ReservReason></common-code-custom><label>{{vc.columnMap[\'ReservReason\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><!-- row --><div class=row ng-controller=\"CvsreservViewCtrl as vc\"><!-- col --><div class=\"col-md-8 col-lg-8\"><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>예약정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div><!-- /tile header --></div><div class=\"panel-body collapse in\"><!-- 풀캘린더 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div id=calendar style=\"float:center; width:100%\"></div></div></div><!-- 목록 --><div class=row id=reservList><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table></div></div></div><!-- /tile body --></div><!-- /tile --></div><div class=\"col-md-8 col-lg-4\"><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>휴면고객 (최종 방문 2주~4주 이상 경과)</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div><!-- /tile header --></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.inactListColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.inactListColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.inactLists\" style=\"cursor: pointer\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.inactListColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/cvsreserv/cvsreserv-view.html","<div class=\"page page-footable\" ng-controller=\"CvsreservViewCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>예약 현황</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\"><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><!-- row --><div class=row><!-- col --><div class=\"col-md-8 col-lg-8\"><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>예약정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div><!-- /tile header --></div><div class=\"panel-body collapse in\"><!-- 풀캘린더 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div id=calendar style=\"float:center; width:100%\"></div></div></div><!-- 목록 --><div class=row id=reservList><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table></div></div></div><!-- /tile body --></div><!-- /tile --></div><div class=\"col-md-8 col-lg-4\"><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>휴면고객 (최종 방문 2주~4주 이상 경과)</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div><!-- /tile header --></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.inactListColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.inactListColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.inactLists\" style=\"cursor: pointer\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.inactListColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/sms-send-number-edit.html","<div class=\"page page-footable\" ng-controller=\"SmsSendNumberEditCtrl as vc\"><div class=row><div class=col-lg-12><div class=page-header>SMS 발송번호 인증 관리</div></div></div><!-- /page header --><!-- Action Buttons --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setUpdate() ng-if=\"vc.data.CertYN == \'N\'\"><i class=\"fa fa-list\"></i> 인증 승인</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>SMS 발송번호 인증 관리</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'SiteId\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SiteId disabled></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantId disabled></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" value=\"{{vc.data.RegDate | utcToLocal:\'yyyy-MM-dd HH:mm\'}}\" disabled></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'SendNumber\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SendNumber disabled></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'CertType\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CertTypeNm disabled></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'CertYN\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CertYNNm disabled></div></div></div><div class=row ng-show=\" vc.data.CertType ==\'MOBILE\' \"><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"font-size: 11px\">{{ vc.columnMap[\'ImpUid\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.ImpUid disabled></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"font-size: 11px\">{{ vc.columnMap[\'MerchantUid\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.MerchantUid disabled></div></div></div><!-- file upload--><div class=row ng-show=\" vc.data.CertType ==\'DOCUMENT\' \"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div></div>");
$templateCache.put("app/message/sms-send-number-list.html","<div class=\"page page-footable\" ng-controller=\"SmsSendNumberListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS 발송번호 인증 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SendNumber placeholder=\"발신번호 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'RegDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"{{vc.columnMap[\'RegDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CertType\'].CodeList\" code-model=vc.srch.CertType></common-code-custom><label>{{vc.columnMap[\'CertType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CertYN\'].CodeList\" code-model=vc.srch.CertYN></common-code-custom><label>{{vc.columnMap[\'CertYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=7>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId,li.FormTypeId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/sms-send-number-save.html","<div class=\"page page-footable\" ng-controller=\"SmsSendNumberSaveCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS 발송번호 인증<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>발신번호인증</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=form-control ng-model=vc.data.SendNumber ng-required=true></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>인증방법</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=\"휴대폰 본인인증\"><label class=custom-radio-btn title=\"휴대폰 본인인증\"><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-valid-parse ng-touched\" type=radio value=MOBILE ng-model=vc.data.CertType ng-checked=\"vc.data.CertType == \'MOBILE\'\" ng-change=\"vc.setChangeRadioBtn(\'MOBILE\');\" aria-invalid=false checked> <span class=helping-el></span> <span class=\"label-text ng-binding\">휴대폰 본인인증</span></label></div><div class=\"radio-inline ng-scope\" title=\"통신서비스 이용증명원\"><label class=custom-radio-btn title=\"통신서비스 이용증명원\"><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=DOCUMENT ng-model=vc.data.CertType ng-checked=\"vc.data.CertType == \'DOCUMENT\'\" ng-change=\"vc.setChangeRadioBtn(\'DOCUMENT\');\" aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">통신서비스 이용증명원</span></label></div></div></div></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-primary\" activate-button ng-click=vc.setVerifyData();><i class=\"fa fa-edit\"></i> 등록</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.setDelList(); ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><div class=\"form-group form-inline\" ng-if=vc.showUploader><label></label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div></div></form></div></div></div></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=7>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-action-compare.html","<div class=\"page page-footable\" ng-controller=\"AnalysisActionCompareCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><div class=page-header>분석결과 작업별 비교</div></div></div><!-- page content --><div class=pagecontent><!-- row --><div class=row><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><div class=row><div class=\"col-lg-6 sz-search\"><div class=dataloader ng-show=vc.dataloader[0]></div><div class=form-group><div class=input-group><common-code-tree code-list=vc.dagrouplists reload-seq=vc.reloadSeq code-model=vc.GroupAndAction[0] prevent-changing=true code-changed=vc.getList0></common-code-tree></div></div><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" style=\"width: 20%\">클러스터</th><th class=\"text-center none\" style=\"width: 15%\">R</th><th class=\"text-center none\" style=\"width: 15%\">F</th><th class=\"text-center none\" style=\"width: 15%\">M</th><th class=\"text-center none\" style=\"width: 20%\">설명</th><th class=\"text-center none\" style=\"width: 10%\">고객수</th><th class=\"text-center none\" style=\"width: 100px\">비율</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems[0] == 0\"><tr class=tbnodata><td class=text-center colspan=7>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists[0]\"><td class=text-center><span>{{li.ClusterNo}}</span></td><td class=text-right><span>{{li.Recency | number}}({{li.RecencyScore}})</span></td><td class=text-right><span>{{li.Frequency | number}}({{li.FrequencyScore}})</span></td><td class=text-right><span>{{li.Monetary | number}}({{li.MonetaryScore}})</span></td><td class=text-center><span>{{li.Description}}</span></td><td class=text-right><span>{{li.cnt | number}}</span></td><td class=text-center><uib-progressbar class=\"progress-xxs not-rounded mb-0 inline-block\" value=li.per type=greensea style=\"width: 100%; margin-right: 5px\"></uib-progressbar><small>{{li.per | number:0}}%</small></td></tr></table><div class=\"row mt-10\"><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\"><div class=bg-blue><!-- row --><div class=row style=padding:10px><!-- col --><div class=col-xs-3><i class=\"fa fa-users fa-2x\"></i></div><!-- /col --><!-- col --><div class=col-xs-9><p class=\"text-center text-strong mb-0\">{{vc.data[0].cnt[0] | number}}</p><p class=\"text-center text-strong mb-0\">고객수</p></div><!-- /col --></div><!-- /row --></div></div><!-- /col --><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\"><div class=bg-blue><!-- row --><div class=row style=padding:10px><!-- col --><div class=col-xs-3><i class=\"fa fa-gift fa-2x\"></i></div><!-- /col --><!-- col --><div class=col-xs-9><p class=\"text-center text-strong mb-0\">{{vc.data[0].cnt[1] | number}}</p><p class=\"text-center text-strong mb-0\">상품수</p></div><!-- /col --></div><!-- /row --></div></div><!-- /col --><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\"><div class=bg-blue><!-- row --><div class=row style=padding:10px><!-- col --><div class=col-xs-3><i class=\"fa fa-usd fa-2x\"></i></div><!-- /col --><!-- col --><div class=col-xs-9><p class=\"text-center text-strong mb-0\">{{vc.data[0].cnt[2] | number}}</p><p class=\"text-center text-strong mb-0\">총판매</p></div><!-- /col --></div><!-- /row --></div></div><!-- /col --></div></div><!-- Search Result --><div class=\"col-lg-6 sz-search\"><div class=dataloader ng-show=vc.dataloader[1]></div><div class=form-group><div class=input-group><common-code-tree code-list=vc.dagrouplists reload-seq=vc.reloadSeq code-model=vc.GroupAndAction[1] prevent-changing=true code-changed=vc.getList1></common-code-tree></div></div><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" style=\"width: 20%\">클러스터</th><th class=\"text-center none\" style=\"width: 15%\">R</th><th class=\"text-center none\" style=\"width: 15%\">F</th><th class=\"text-center none\" style=\"width: 15%\">M</th><th class=\"text-center none\" style=\"width: 20%\">설명</th><th class=\"text-center none\" style=\"width: 10%\">고객수</th><th class=\"text-center none\" style=\"width: 100px\">비율</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems[1] == 0\"><tr class=tbnodata><td class=text-center colspan=7>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists[1]\"><td class=text-center><span>{{li.ClusterNo}}</span></td><td class=text-right><span>{{li.Recency | number}}({{li.RecencyScore}})</span></td><td class=text-right><span>{{li.Frequency | number}}({{li.FrequencyScore}})</span></td><td class=text-right><span>{{li.Monetary | number}}({{li.MonetaryScore}})</span></td><td class=text-center><span>{{li.Description}}</span></td><td class=text-right><span>{{li.cnt | number}}</span></td><td class=text-center><uib-progressbar class=\"progress-xxs not-rounded mb-0 inline-block\" value=li.per type=greensea style=\"width: 100%; margin-right: 5px\"></uib-progressbar><small>{{li.per | number:0}}%</small></td></tr></table><div class=\"row mt-10\"><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\"><div class=bg-lightred><!-- row --><div class=row style=padding:10px><!-- col --><div class=col-xs-3><i class=\"fa fa-users fa-2x\"></i></div><!-- /col --><!-- col --><div class=col-xs-9><p class=\"text-center text-strong mb-0\">{{vc.data[1].cnt[0] | number}}</p><p class=\"text-center text-strong mb-0\">고객수</p></div><!-- /col --></div><!-- /row --></div></div><!-- /col --><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\"><div class=bg-lightred><!-- row --><div class=row style=padding:10px><!-- col --><div class=col-xs-3><i class=\"fa fa-gift fa-2x\"></i></div><!-- /col --><!-- col --><div class=col-xs-9><p class=\"text-center text-strong mb-0\">{{vc.data[1].cnt[1] | number}}</p><p class=\"text-center text-strong mb-0\">상품수</p></div><!-- /col --></div><!-- /row --></div></div><!-- /col --><!-- col --><div class=\"card-container col-lg-4 col-sm-6 col-sm-12\"><div class=bg-lightred><!-- row --><div class=row style=padding:10px><!-- col --><div class=col-xs-3><i class=\"fa fa-usd fa-2x\"></i></div><!-- /col --><!-- col --><div class=col-xs-9><p class=\"text-center text-strong mb-0\">{{vc.data[1].cnt[2] | number}}</p><p class=\"text-center text-strong mb-0\">총판매</p></div><!-- /col --></div><!-- /row --></div></div><!-- /col --></div></div></div><div class=\"row mt-10\"><div class=\"col-lg-12 sz-search\"><canvas id=line class=\"chart chart-line fixed-height-chart\" chart-data=vc.chart.mixdata chart-labels=vc.chart.mixlabels chart-colors=vc.chart.mixcolors chart-dataset-override=vc.chart.mixdatasetOverride chart-options=vc.chart.options></canvas></div></div><div class=\"row mt-10\"><div class=\"col-lg-12 sz-search\"><canvas id=line class=\"chart chart-line fixed-height-chart\" chart-data=vc.chart.mixdata2 chart-labels=vc.chart.mixlabels2 chart-colors=vc.chart.mixcolors chart-dataset-override=vc.chart.mixdatasetOverride chart-options=vc.chart.options></canvas></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-cluster-compare-result.html","<div class=\"page page-footable\" ng-controller=\"AnalysisClusterCompareResultCtrl as vc\"><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>고객등급 변화</h3></div><!-- /.col-lg-12 --></div><!-- page content --><div class=pagecontent><!-- row --><div class=row><div class=dataloader ng-show=vc.dataloader></div><div class=col-lg-12><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=\"row mt-10\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CustomerId placeholder=\"아이디 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustomerId\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CustomerId type=text><label>{{vc.columnMap[\'CustomerId\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ClusterNo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ClusterNo type=text><label>{{vc.columnMap[\'ClusterNo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Description\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Description type=text><label>{{vc.columnMap[\'Description\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form></div></div><div class=row><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                    <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                    <div class=\"pull-right\">\r\n                      <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                      </a>\r\n                    </div>\r\n                  </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.RelateDataId)><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-cluster-compare.html","<div class=\"page page-footable\" ng-controller=\"AnalysisClusterCompareCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객등급 변화별 비교<select-data-group code-changed=vc.getList></select-data-group><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><!-- row --><div class=row><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><div class=row><div class=\"col-lg-6 sz-search\"><div class=dataloader ng-show=vc.dataloader[0]></div><div class=form-group><div class=input-group><common-code-tree code-list=vc.dagrouplists reload-seq=vc.reloadSeq code-model=vc.GroupAndAction[0] prevent-changing=true code-changed=vc.getList0></common-code-tree></div></div><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" style=\"width: 5%\">비교</th><th class=\"text-center none\" style=\"width: 20%\">클러스터</th><th class=\"text-center none\" style=\"width: 15%\">R</th><th class=\"text-center none\" style=\"width: 15%\">F</th><th class=\"text-center none\" style=\"width: 15%\">M</th><th class=\"text-center none\" style=\"width: 15%\">설명</th><th class=\"text-center none\" style=\"width: 10%\">고객수</th><th class=\"text-center none\" style=\"width: 100px\">비율</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems[0] == 0\"><tr class=tbnodata><td class=text-center colspan=7>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists[0]\"><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow></td><td class=text-center><span>{{li.ClusterNo}}</span></td><td class=text-right><span>{{li.Recency | number}}({{li.RecencyScore}})</span></td><td class=text-right><span>{{li.Frequency | number}}({{li.FrequencyScore}})</span></td><td class=text-right><span>{{li.Monetary | number}}({{li.MonetaryScore}})</span></td><td class=text-center><span>{{li.Description}}</span></td><td class=text-right><span>{{li.cnt | number}}</span></td><td class=text-center><uib-progressbar class=\"progress-xxs not-rounded mb-0 inline-block\" value=li.per type=greensea style=\"width: 100%; margin-right: 5px\"></uib-progressbar><small>{{li.per | number:0}}%</small></td></tr></table></div><!-- Search Result --><div class=\"col-lg-6 sz-search\"><div class=dataloader ng-show=vc.dataloader[1]></div><div class=form-group><div class=input-group><common-code-tree code-list=vc.dagrouplists reload-seq=vc.reloadSeq code-model=vc.GroupAndAction[1] prevent-changing=true code-changed=vc.getList1></common-code-tree></div></div><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" style=\"width: 5%\">비교</th><th class=\"text-center none\" style=\"width: 20%\">클러스터</th><th class=\"text-center none\" style=\"width: 15%\">R</th><th class=\"text-center none\" style=\"width: 15%\">F</th><th class=\"text-center none\" style=\"width: 15%\">M</th><th class=\"text-center none\" style=\"width: 15%\">설명</th><th class=\"text-center none\" style=\"width: 10%\">고객수</th><th class=\"text-center none\" style=\"width: 100px\">비율</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems[1] == 0\"><tr class=tbnodata><td class=text-center colspan=7>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists[1]\"><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow></td><td class=text-center><span>{{li.ClusterNo}}</span></td><td class=text-right><span>{{li.Recency | number}}({{li.RecencyScore}})</span></td><td class=text-right><span>{{li.Frequency | number}}({{li.FrequencyScore}})</span></td><td class=text-right><span>{{li.Monetary | number}}({{li.MonetaryScore}})</span></td><td class=text-center><span>{{li.Description}}</span></td><td class=text-right><span>{{li.cnt | number}}</span></td><td class=text-center><uib-progressbar class=\"progress-xxs not-rounded mb-0 inline-block\" value=li.per type=greensea style=\"width: 100%; margin-right: 5px\"></uib-progressbar><small>{{li.per | number:0}}%</small></td></tr></table></div></div><div class=row><div class=col-lg-12><span class=\"input-group-btn pull-right mt-5 mr-45\"><button activate-button=\"\" class=\"btn btn-default mt-2\" ng-click=vc.getCompareResult()><i class=\"fa fa-refresh\"></i> 조회</button></span></div></div></div></div></div></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-cluster-three-plot.html","<div class=\"page page-footable\" ng-controller=\"AnalysisClusterThreePlotCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><div class=page-header>고객등급시각화<select-data-group code-changed=vc.reloadAll></select-data-group></div></div></div><!-- page content --><div class=pagecontent><div class=row><div class=dataloader ng-show=vc.dataloader></div></div><!-- row --><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=\"row mt-10\"><div class=\"col-lg-12 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.maxR placeholder=최대R type=text numbers-only comma> <input class=mb5 ng-model=vc.srch.maxF placeholder=최대F type=text numbers-only comma> <input class=mb5 ng-model=vc.srch.maxM placeholder=최대M type=text numbers-only comma><div class=\"search_action_only mb-5\" ng-click=vc.refreshList(1)><span class=cursor><i class=\"fa fa-search\"></i></span></div></div><!-- /col --></div><!-- 검색영역 --></form><div class=row><div class=col-lg-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-6 col-lg-6\"><div id=container style=\"width: auto\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-6 col-lg-6\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" style=\"width: 10%\">색상</th><th class=\"text-center none\" style=\"width: 10%\">클러스터</th><th class=\"text-center none\" style=\"width: 15%\">R</th><th class=\"text-center none\" style=\"width: 15%\">F</th><th class=\"text-center none\" style=\"width: 15%\">M</th><th class=\"text-center none\" style=\"width: 20%\">설명</th><th class=\"text-center none\" style=\"width: 10%\">고객수</th><th class=\"text-center none\" style=\"width: 100px\">비율</th></tr></thead><!-- /Header --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=8>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.clusterLists\"><td class=text-center><i class=\"fa fa-square\" style=color:#{{vc.colorMark[li.ClusterNo]}}></i> <input type=checkbox ng-change=vc.refreshList(0) ng-checked=\"vc.showCluster[li.ClusterNo] == \'Y\'\" ng-model=vc.showCluster[li.ClusterNo] ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" ng-if=\"vc.srch.resultType == \'rfmCluster3d\' && li.ClusterNo != \'9999\'\"></td><td class=text-center><span>{{li.ClusterNo}}</span></td><td class=text-right><span>{{li.Recency | number}}({{li.RecencyScore}})</span></td><td class=text-right><span>{{li.Frequency | number}}({{li.FrequencyScore}})</span></td><td class=text-right><span>{{li.Monetary | number}}({{li.MonetaryScore}})</span></td><td class=text-center><span>{{li.Description}}</span></td><td class=text-right><span>{{li.cnt | number}}</span></td><td class=text-center><uib-progressbar class=\"progress-xxs not-rounded mb-0 inline-block\" value=li.per type=greensea style=\"width: 100%; margin-right: 5px\"></uib-progressbar><small>{{li.per | number:0}}%</small></td></tr></tbody></table></div></div><div class=row><div class=col-lg-4 ng-click=\"vc.getSearch(\'rfmCluster3d\')\"><div class=text-center>RFM 3D차트(군집화 구별)</div><div id=regTitle0></div></div><div class=col-lg-4 ng-click=\"vc.getSearch(\'rfmScore3d\')\"><div class=text-center>RFM 스토어 3D 차트</div><div id=regTitle1></div></div><div class=col-lg-4 ng-click=\"vc.getSearch(\'rfmOutlier3d\')\"><div class=text-center>RFM Outlier 3D 차트</div><div id=regTitle2></div></div></div><div class=row><div class=col-lg-4><div class=text-center>일반고객 vs. Outlier 매출분석 (단위: 만)</div><div id=regTitle3></div></div><div class=col-lg-4><div class=text-center>클러스터별 recency 현황</div><div id=regTitle4></div></div><div class=col-lg-4><div class=text-center>클러스터별 frequency 현황</div><div id=regTitle5></div></div></div><div class=row><div class=col-lg-4><div class=text-center>클러스터별 monetary 현황</div><div id=regTitle6></div></div><div class=col-lg-4><div class=text-center>광역시/도별 고객수</div><div id=regTitle7></div></div><div class=col-lg-4><div class=text-center>광역시/도별 매출 현황 (단위: 만)</div><div id=regTitle8></div></div></div><div class=row><div class=col-lg-4><div class=text-center>지역별 고객분포</div><div id=regTitle9></div></div><div class=col-lg-4><div class=text-center>지역별 매출분포</div><div id=regTitle10></div></div><div class=col-lg-4><div class=text-center>WORD CLOUD</div><div id=regTitle11></div></div></div></div></div></div></div><!-- /page content --></div><i class=\"fa fa-square\" style=color:#41b6e6></i> <i class=\"fa fa-square\" style=color:#ff585d></i> <i class=\"fa fa-square\" style=color:#ffb549></i> <i class=\"fa fa-square\" style=color:#001871></i> <i class=\"fa fa-square\" style=color:#515bd4></i> <i class=\"fa fa-square\" style=color:#8134af></i> <i class=\"fa fa-square\" style=color:#dd2a7b></i> <i class=\"fa fa-square\" style=color:#3d3b2c></i>");
$templateCache.put("app/dataanalysis/analysis-customerrank-list.html","<div class=\"page page-footable\" ng-controller=\"AnalysisCustomerrankListCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><div class=page-header>고객등급<select-data-group code-changed=vc.getList></select-data-group></div></div></div><!-- page content --><div class=pagecontent><!-- row --><div class=row><div class=dataloader ng-show=vc.dataloader></div><div class=col-lg-12><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=\"row mt-10\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CustomerId placeholder=\"아이디 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustomerId\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CustomerId type=text><label>{{vc.columnMap[\'CustomerId\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ClusterNo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ClusterNo type=text><label>{{vc.columnMap[\'ClusterNo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Description\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Description type=text><label>{{vc.columnMap[\'Description\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form></div></div><div class=row><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                    <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                    <div class=\"pull-right\">\r\n                      <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                      </a>\r\n                    </div>\r\n                  </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.RelateDataId)><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-customerrecommend-detail.html","<div class=\"page page-footable\" ng-controller=\"AnalysisCustomerrecommendDetailCtrl as vc\"><!-- page content --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>추천상품</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div>추천상품</div><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom\"><thead><tr><th data-toggle=true class=text-center>상품코드</th><th data-toggle=true class=text-center>상품명</th><th data-toggle=true class=text-center>빈도수</th></tr></thead><tbody ng-if=\"vc.data.recommended == null || vc.data.recommended.length == 0\"><tr class=tbnodata><td class=text-center colspan=3>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><tr ng-repeat=\"li in vc.data.recommended\" my-directive><td><span ng-bind=li.pid></span></td><td><span ng-bind=li.ProductName></span></td><td><span ng-bind=li.freq></span></td></tr></tbody></table></div><div class=col-lg-6><div id=wordcloud style=\"width:100%; min-height:300px\"></div><div>유사고객</div><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom\"><thead><tr><th data-toggle=true class=text-center>고객아이디</th><th data-toggle=true class=text-center>고객명</th><th data-toggle=true class=text-center>유사도(1~0)</th></tr></thead><tbody ng-if=\"vc.data.similarities == null || vc.data.similarities.length == 0\"><tr class=tbnodata><td class=text-center colspan=3>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><tr ng-repeat=\"li in vc.data.similarities\" my-directive><td><span ng-bind=li.cid></span></td><td><span ng-bind=li.CustomerName></span></td><td><span ng-bind=\"1 - li.distance | number\"></span></td></tr></tbody></table></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-customerrecommend-list.html","<div class=\"page page-footable\" ng-controller=\"AnalysisCustomerrecommendListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객별 추천상품<select-data-group code-changed=vc.getList></select-data-group><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.customerName placeholder=\"{{vc.columnMap[\'customerName\'].ColumnLogicalNm | translate}} 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtFrom = (vc.JoinDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtFrom ng-required=false placeholder=가입시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtTo = (vc.JoinDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtTo ng-required=false placeholder=가입종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'customerID\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.customerID type=text><label>{{vc.columnMap[\'customerID\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'paymentTotal\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.paymentTotal type=text><label>{{vc.columnMap[\'paymentTotal\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'orderCount\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.orderCount type=text><label>{{vc.columnMap[\'orderCount\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                    <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                    <div class=\"pull-right\">\r\n                      <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                      </a>\r\n                    </div>\r\n                  </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.customerID) ng-class=\"{\'bg-lightyellow\':li.customerID == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-execute.html","<div class=\"page page-footable\" ng-controller=\"AnalysisExecuteCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.EM960\' | translate }}<select-data-group></select-data-group><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.runProcess()><i class=\"fa fa-edit\"></i> {{ \'Menu.STARTANALYSIS\' | translate }}</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>분석 실행 및 인사이트 결과</div><div class=\"panel-body collapse in\" id=collapse1><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><div><b>* 분석실행을 하면 선택된 데이터그룹의 데이터에서 작업명에 지정된 기간의 데이터의 분석을 실행합니다.</b></div><div><b>(현재 데이터그룹은 <font color=red>{{$root.gVariable.dataGroupNm}}</font>, 작업명과 기간은 <font color=red>{{$root.gVariable.dataActionNm}}</font> 입니다.</b></div><div><b>* 분석실행을 하면 기존의 분석결과는 모두 삭제되고 새로운 결과가 기록됩니다.</b></div><div>&nbsp;</div><div class=custom-font><strong>분석실행 결과</strong></div></div><!-- /tile header --><div class=tile-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\">이전실행 이력<table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center>결과유형</th><th class=text-center>건수</th><th class=text-center>생성일시</th><th class=text-center>담당자</th></tr></thead><!-- /Header --><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.prevResult\" ng-click=vc.goDetail(li.ResultType)><!-- Result Items --><td class=text-center>{{\'MASALES.\' + li.ResultType | translate}}</td><td class=text-center>{{li.Cnt}}</td><td class=text-center>{{li.RegDate | utcToLocal:\'yyyy-MM-dd\'}}</td><td class=text-center>{{li.RegUserNm}}</td></tr></tbody></table></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\">분석실행 결과<table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center>결과유형</th><th class=text-center>건수</th><th class=text-center>생성일시</th></tr></thead><!-- /Header --><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.response.saved\" ng-click=vc.goDetail(li.ResultType)><!-- Result Items --><td class=text-center>{{\'MASALES.\' + li.ResultType | translate}}</td><td class=text-center>{{li.Cnt}}</td><td class=text-center>{{li.RegDate * 1000 | utcToLocal:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div></div><div class=\"row mt-10\"><div class=col-lg-12>분석실행 결과<pre ng-bind=vc.response.status></pre></div></div></div></div></div></div><!-- /row --></div></div></div></div></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-recommend-detail.html","<div class=\"page page-footable\" ng-controller=\"AnalysisRecommendDetailCtrl as vc\"><!-- page content --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>상품별추천상품</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div>추천상품</div><table id=searchTextResults data-filter=#filter data-page-size=100 data-pagination=true class=\"table table-custom\"><thead><tr><th data-toggle=true class=text-center>상품코드</th><th data-toggle=true class=text-center>상품명</th><th data-toggle=true class=text-center>유사도(1~0)</th></tr></thead><tbody ng-if=\"vc.data.recommended == null || vc.data.recommended.length == 0\"><tr class=tbnodata><td class=text-center colspan=3>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><tr ng-repeat=\"li in vc.data.recommended\" my-directive><td><span ng-bind=li.pid></span></td><td><span ng-bind=li.ProductName></span></td><td><span ng-bind=\"1 - li.distance | number\"></span></td></tr></tbody></table></div><div class=col-lg-6><div id=wordcloud style=\"width:100%; min-height:300px\"></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-recommend-list.html","<div class=\"page page-footable\" ng-controller=\"AnalysisRecommendListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>상품별추천상품<select-data-group code-changed=vc.getList></select-data-group><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.productName placeholder=\"{{vc.columnMap[\'productName\'].ColumnLogicalNm | translate}} 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtFrom = (vc.JoinDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtFrom ng-required=false placeholder=가입시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtTo = (vc.JoinDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtTo ng-required=false placeholder=가입종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productCode\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productCode type=text><label>{{vc.columnMap[\'productCode\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productSeason\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productSeason type=text><label>{{vc.columnMap[\'productSeason\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productCategory\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productCategory type=text><label>{{vc.columnMap[\'productCategory\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productFit\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productFit type=text><label>{{vc.columnMap[\'productFit\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productSize\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productSize type=text><label>{{vc.columnMap[\'productSize\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.productCode) ng-class=\"{\'bg-lightyellow\':li.productCode == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-result.html","<div class=\"page page-footable\" ng-controller=\"AnalysisResultCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- col --><div class=col-lg-12><div class=text-center>{{\'MASALES.\' + vc.resultType | translate}}</div><div id=regTitle0></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-rfmcentroids-edit.html","<div class=\"page page-footable\" ng-controller=\"AnalysisRfmcentroidsEditCtrl as vc\"><!-- page content --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>고객등급기준정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>클러스터번호</label><span type=text class=\"form-control form-right\" ng-bind=vc.data.ClusterNo></span></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>등급설명</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Description></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/analysis-rfmcentroids-list.html","<div class=\"page page-footable\" ng-controller=\"AnalysisRfmcentroidsListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객등급기준<select-data-group code-changed=vc.getList></select-data-group><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" style=\"width: 10%\">클러스터</th><th class=\"text-center none\" style=\"width: 10%\">R</th><th class=\"text-center none\" style=\"width: 10%\">F</th><th class=\"text-center none\" style=\"width: 10%\">M</th><th class=\"text-center none\" style=\"width: 10%\">R 스코어</th><th class=\"text-center none\" style=\"width: 10%\">F 스코어</th><th class=\"text-center none\" style=\"width: 10%\">M 스코어</th><th class=\"text-center none\" style=\"width: 10%\">등급설명</th><th class=\"text-center none\" style=\"width: 10%\">고객수</th><th class=\"text-center none\" style=\"width: 100px\">비율</th></tr></thead><!-- /Header --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=10>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goEdit(li.RelateDataId) ng-class=\"{\'bg-lightyellow\':li.RelateDataId == selectedRow}\"><td class=text-center><span>{{li.ClusterNo}}</span></td><td class=text-right><span>{{li.Recency | number}}</span></td><td class=text-right><span>{{li.Frequency | number}}</span></td><td class=text-right><span>{{li.Monetary | number}}</span></td><td class=text-center><span>{{li.RecencyScore}}</span></td><td class=text-center><span>{{li.FrequencyScore}}</span></td><td class=text-center><span>{{li.MonetaryScore}}</span></td><td class=text-center><span>{{li.Description}}</span></td><td class=text-right><span>{{li.cnt | number}}</span></td><td class=text-center><uib-progressbar class=\"progress-xxs not-rounded mb-0 inline-block\" value=li.per type=greensea style=\"width: 100%; margin-right: 5px\"></uib-progressbar><small>{{li.per | number:0}}%</small></td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/da-customer-detail.html","<div class=\"page page-footable\" ng-controller=\"DaCustomerDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}<select-data-group></select-data-group></div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}} {{li.newItemClass}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/da-customer-list.html","<div class=\"page page-footable\" ng-controller=\"DaCustomerListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객목록<select-data-group code-changed=vc.getList></select-data-group><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.customerName placeholder=\"{{vc.columnMap[\'customerName\'].ColumnLogicalNm | translate}} 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtFrom = (vc.JoinDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtFrom ng-required=false placeholder=가입시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtTo = (vc.JoinDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtTo ng-required=false placeholder=가입종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'customerID\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.customerID type=text><label>{{vc.columnMap[\'customerID\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'paymentTotal\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.paymentTotal type=text><label>{{vc.columnMap[\'paymentTotal\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'orderCount\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.orderCount type=text><label>{{vc.columnMap[\'orderCount\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.customerID) ng-class=\"{\'bg-lightyellow\':li.customerID == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/da-goods-detail.html","<div class=\"page page-footable\" ng-controller=\"DaGoodsDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><div class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}<select-data-group></select-data-group></div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/da-goods-list.html","<div class=\"page page-footable\" ng-controller=\"DaGoodsListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>상품목록<select-data-group code-changed=vc.getList></select-data-group><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.productName placeholder=\"{{vc.columnMap[\'productName\'].ColumnLogicalNm | translate}} 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtFrom = (vc.JoinDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtFrom ng-required=false placeholder=가입시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtTo = (vc.JoinDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtTo ng-required=false placeholder=가입종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productCode\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productCode type=text><label>{{vc.columnMap[\'productCode\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productSeason\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productSeason type=text><label>{{vc.columnMap[\'productSeason\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productCategory\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productCategory type=text><label>{{vc.columnMap[\'productCategory\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productFit\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productFit type=text><label>{{vc.columnMap[\'productFit\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productSize\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productSize type=text><label>{{vc.columnMap[\'productSize\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.productCode) ng-class=\"{\'bg-lightyellow\':li.productCode == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/da-sales-detail.html","<div class=\"page page-footable\" ng-controller=\"SalesDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\" ng-repeat=\"liCol in vc.allColumns\"><div class=\"form-group form-inline\"><label>{{liCol.ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'10\'\" ng-bind=vc.data[liCol.ColumnPhysicalNm]|htmlString></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'20\'\" ng-bind=vc.data[liCol.ColumnPhysicalNm]|number></div><div class=\"form-control txt_view\" ng-if=\"liCol.ColumnLogicalDataType == \'40\'\" ng-bind-html=\"vc.data[liCol.ColumnPhysicalNm]|utcToLocal:\'yyyy-MM-dd HH:mm\'\"></div></div></div></div><div class=row><div class=\"form-group form-inline\"><div class=\"col-sm-12 col-md-12 col-sm-12 col-xs-12\"><span ng-bind-html=vc.data.description|htmlString></span></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/da-sales-list.html","<div class=\"page page-footable\" ng-controller=\"DaSalesListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>판매목록<select-data-group code-changed=vc.getList></select-data-group><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.customerName placeholder=\"{{vc.columnMap[\'customerName\'].ColumnLogicalNm | translate}} 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'orderDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.orderDateFrom = (vc.orderDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.orderDateFrom ng-required=false placeholder=주문시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'orderDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.orderDateTo = (vc.orderDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.orderDateTo ng-required=false placeholder=주문종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'customerID\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.customerID type=text><label>{{vc.columnMap[\'customerID\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'customerLevel\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.customerLevel type=text><label>{{vc.columnMap[\'customerLevel\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'orderNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.orderNum type=text><label>{{vc.columnMap[\'orderNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productCode\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productCode type=text><label>{{vc.columnMap[\'productCode\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'productName\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.productName type=text><label>{{vc.columnMap[\'productName\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.RelateDataId) ng-class=\"{\'bg-lightyellow\':li.RelateDataId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/datagroup-detail.html","<div class=\"page page-footable\" ng-controller=\"DatagroupDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.ID\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantId></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.NAME\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.CEO\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.CEO></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.PERSONINCHARGE\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Contact></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.TENANTDIR\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantDir></div></div></div><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/datagroup-edit.html","<div class=\"page page-footable\" ng-controller=\"DatagroupEditCtrl as vc\"><!-- page content --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><div class=pagecontent><!--     <div class=\"row\">\r\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\">\r\n        <div class=\"pull-right\">\r\n          <button class=\"btn btn-default\" ng-click=\"vc.goList()\" ng-if=\"vc.layout == \'N\'\">\r\n            <i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}\r\n          </button>\r\n          <button class=\"btn btn-primary\" ng-click=\"vc.setDataConfirm()\">\r\n            <i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}\r\n          </button>\r\n          <button class=\"btn btn-danger\" ng-click=\"vc.setDelData()\">\r\n            <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div> --><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>데이터그룹정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'DatagroupNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.DatagroupNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'MaShopId\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.tenantData.ExtVarchar03 disabled></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'MaShopNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.MaShopNm></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BeginDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.BeginDate = (vc.BeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.BeginDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'EndDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.EndDate = (vc.EndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.EndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label><i class=\"fa fa-check-square-o\" style=color:red></i>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=vc.columnMap.UseYN.CodeList code-model=vc.data.UseYN></common-code-custom></div></div></div><div class=row><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ExtVarchar02\'].ColumnLogicalNm | translate }}</label><select class=form-control ng-model=vc.data.ExtVarchar02 ng-options=\"cf.Code as cf.CodeValue for cf in vc.columnMap[\'ExtVarchar02\'].CodeList\" disabled></select></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>작업목록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-default\" ng-click=\"vc.addAction(\'A\')\"><i class=\"fa fa-list\"></i> 작업추가</button></div></div></div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumnsAction\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th><th class=\"text-center none\" style=\"width: 3%\"></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumnsAction.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td style=\"text-align: center\"><span ng-if=\"li.Type != \'A\' && vc.modify == \'N\'\">{{li.ActionNm}}</span> <input ng-if=\"li.Type == \'A\' || vc.modify == \'Y\'\" type=text class=form-control ng-model=li.ActionNm name=ActionNm></td><td style=\"text-align: center\"><input type=checkbox ng-click=vc.checkUse(li) ng-checked=\"li.UseYN == \'Y\'\" ng-model=li.UseYN name=UseYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td style=\"text-align: center\"><span ng-if=\"li.Type != \'A\' && vc.modify == \'N\'\">{{li.BeginDate}}</span><div ng-if=\"li.Type == \'A\' || vc.modify == \'Y\'\" class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"li.BeginDate = (li.ctrlBeginDate | date: \'yyyy-MM-dd\')\" ng-model=li.ctrlBeginDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></td><td style=\"text-align: center\"><span ng-if=\"li.Type != \'A\' && vc.modify == \'N\'\">{{li.EndDate}}</span><div ng-if=\"li.Type == \'A\' || vc.modify == \'Y\'\" class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"li.EndDate = (li.ctrlEndDate | date: \'yyyy-MM-dd\')\" ng-model=li.ctrlEndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></td><td style=\"text-align: center\"><span>{{li.RegDate | utcToLocal:\'yyyy-MM-dd\'}}</span></td><td style=\"text-align: center\"><button class=\"btn btn-danger btn-min ng-binding\" ng-click=vc.deleteActionList(li)><i class=\"fa fa-trash-o\">삭제</i></button></td><!--                 <td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\" class=\"\">\r\n                  <span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm]\r\n                  | utcToLocal:\'yyyy-MM-dd\')}}</span>\r\n                  <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=\"color:red;\" aria-hidden=\"false\"></i></span>\r\n                </td> --></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setDataConfirm()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.delData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dataanalysis/datagroup-list.html","<div class=\"page page-footable\" ng-controller=\"DatagroupListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>데이터그룹관리<select-data-group code-changed=vc.getList></select-data-group><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.DatagroupNm placeholder=\"데이터그룹명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtFrom = (vc.JoinDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtFrom ng-required=false placeholder=가입시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtTo = (vc.JoinDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtTo ng-required=false placeholder=가입종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Ceo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Ceo type=text><label>{{vc.columnMap[\'Ceo\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goEdit(li.RelateDataId) ng-class=\"{\'bg-lightyellow\':li.RelateDataId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/panels-wells/panels-wells.html","<div class=row><div class=col-lg-12><h1 class=page-header>Panels and Wells</h1></div><!-- /.col-lg-12 --></div><!-- /.row --><div class=row><div class=col-lg-4><div class=\"panel panel-default\"><div class=panel-heading>Default Panel</div><div class=panel-body><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div><div class=panel-footer>Panel Footer</div></div></div><!-- /.col-lg-4 --><div class=col-lg-4><div class=\"panel panel-primary\"><div class=panel-heading>Primary Panel</div><div class=panel-body><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div><div class=panel-footer>Panel Footer</div></div></div><!-- /.col-lg-4 --><div class=col-lg-4><div class=\"panel panel-success\"><div class=panel-heading>Success Panel</div><div class=panel-body><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div><div class=panel-footer>Panel Footer</div></div></div><!-- /.col-lg-4 --></div><!-- /.row --><div class=row><div class=col-lg-4><div class=\"panel panel-info\"><div class=panel-heading>Info Panel</div><div class=panel-body><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div><div class=panel-footer>Panel Footer</div></div></div><!-- /.col-lg-4 --><div class=col-lg-4><div class=\"panel panel-warning\"><div class=panel-heading>Warning Panel</div><div class=panel-body><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div><div class=panel-footer>Panel Footer</div></div></div><!-- /.col-lg-4 --><div class=col-lg-4><div class=\"panel panel-danger\"><div class=panel-heading>Danger Panel</div><div class=panel-body><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div><div class=panel-footer>Panel Footer</div></div></div><!-- /.col-lg-4 --></div><!-- /.row --><div class=row><div class=col-lg-4><div class=\"panel panel-green\"><div class=panel-heading>Green Panel</div><div class=panel-body><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div><div class=panel-footer>Panel Footer</div></div><!-- /.col-lg-4 --></div><div class=col-lg-4><div class=\"panel panel-yellow\"><div class=panel-heading>Yellow Panel</div><div class=panel-body><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div><div class=panel-footer>Panel Footer</div></div><!-- /.col-lg-4 --></div><div class=col-lg-4><div class=\"panel panel-red\"><div class=panel-heading>Red Panel</div><div class=panel-body><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div><div class=panel-footer>Panel Footer</div></div><!-- /.col-lg-4 --></div></div><!-- /.row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Collapsible Accordion Panel Group</div><!-- .panel-heading --><div class=panel-body><div class=panel-group id=accordion><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a data-toggle=collapse data-parent=#accordion href=#collapseOne>Collapsible Group Item #1</a></h4></div><div id=collapseOne class=\"panel-collapse collapse in\"><div class=panel-body>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a data-toggle=collapse data-parent=#accordion href=#collapseTwo>Collapsible Group Item #2</a></h4></div><div id=collapseTwo class=\"panel-collapse collapse\"><div class=panel-body>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title><a data-toggle=collapse data-parent=#accordion href=#collapseThree>Collapsible Group Item #3</a></h4></div><div id=collapseThree class=\"panel-collapse collapse\"><div class=panel-body>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div></div></div></div></div><!-- .panel-body --></div><!-- /.panel --></div><!-- /.col-lg-12 --></div><!-- /.row --><div class=row><div class=col-lg-6><div class=\"panel panel-default\"><div class=panel-heading>Basic Tabs</div><!-- /.panel-heading --><div class=panel-body><!-- Nav tabs --><ul class=\"nav nav-tabs\"><li class=active><a href=#home data-toggle=tab>Home</a></li><li><a href=#profile data-toggle=tab>Profile</a></li><li><a href=#messages data-toggle=tab>Messages</a></li><li><a href=#settings data-toggle=tab>Settings</a></li></ul><!-- Tab panes --><div class=tab-content><div class=\"tab-pane fade in active\" id=home><h4>Home Tab</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></div><div class=\"tab-pane fade\" id=profile><h4>Profile Tab</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></div><div class=\"tab-pane fade\" id=messages><h4>Messages Tab</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></div><div class=\"tab-pane fade\" id=settings><h4>Settings Tab</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></div></div></div><!-- /.panel-body --></div><!-- /.panel --></div><!-- /.col-lg-6 --><div class=col-lg-6><div class=\"panel panel-default\"><div class=panel-heading>Pill Tabs</div><!-- /.panel-heading --><div class=panel-body><!-- Nav tabs --><ul class=\"nav nav-pills\"><li class=active><a href=#home-pills data-toggle=tab>Home</a></li><li><a href=#profile-pills data-toggle=tab>Profile</a></li><li><a href=#messages-pills data-toggle=tab>Messages</a></li><li><a href=#settings-pills data-toggle=tab>Settings</a></li></ul><!-- Tab panes --><div class=tab-content><div class=\"tab-pane fade in active\" id=home-pills><h4>Home Tab</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></div><div class=\"tab-pane fade\" id=profile-pills><h4>Profile Tab</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></div><div class=\"tab-pane fade\" id=messages-pills><h4>Messages Tab</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></div><div class=\"tab-pane fade\" id=settings-pills><h4>Settings Tab</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></div></div></div><!-- /.panel-body --></div><!-- /.panel --></div><!-- /.col-lg-6 --></div><!-- /.row --><div class=row><div class=col-lg-4><div class=well><h4>Normal Well</h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div></div><!-- /.col-lg-4 --><div class=col-lg-4><div class=\"well well-lg\"><h4>Large Well</h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div></div><!-- /.col-lg-4 --><div class=col-lg-4><div class=\"well well-sm\"><h4>Small Well</h4><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue.</p></div></div><!-- /.col-lg-4 --></div><!-- /.row --><div class=row><div class=col-lg-12><div class=jumbotron><h1>Jumbotron</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing, posuere lectus et, fringilla augue. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tincidunt est vitae ultrices accumsan. Aliquam ornare lacus adipiscing.</p><p><a class=\"btn btn-primary btn-lg\" role=button>Learn more</a></p></div></div><!-- /.col-lg-12 --></div>");
$templateCache.put("app/popup/popup-edit.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"PopupsEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>팝업관리 조회/수정</h3><div style=\"position: absolute; top: 0; right: 10px\"><button class=\"btn btn-default\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.preview()><i class=\"glyphicon glyphicon-search\"></i>미리보기</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=vc.data.PopupId><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>팝업관리</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"table table-bordered table-striped\"><tbody><tr><td class=text-center><b>{{vc.columnMap.Title.ColumnLogicalNm}}</b></td><td><input type=text class=form-control ng-model=vc.data.Title style=\"width: 500px\"></td></tr><tr><td class=text-center><b>{{vc.columnMap.UseYN.ColumnLogicalNm}}</b></td><td><input type=radio name=UseYN ng-model=vc.data.UseYN value=Y style=\"margin-bottom: 5px !important; cursor: pointer\"><label>&nbsp; Y &nbsp;&nbsp;&nbsp;</label><input type=radio name=UseYN ng-model=vc.data.UseYN value=N style=\"margin-bottom: 5px !important; cursor: pointer\"><label>&nbsp; N</label></td></tr><tr><td class=text-center><b>{{vc.columnMap.WidthSize.ColumnLogicalNm}}(px)</b></td><td><input type=text class=form-control ng-model=vc.data.WidthSize style=\"width: 300px\"></td></tr><tr><td class=text-center><b>{{vc.columnMap.VrticleSize.ColumnLogicalNm}}(px)</b></td><td><input type=text class=form-control ng-model=vc.data.VrticleSize style=\"width: 300px\"></td></tr><tr><td class=text-center><b>{{vc.columnMap.UpendLC.ColumnLogicalNm}}(px)</b></td><td><input type=text class=form-control ng-model=vc.data.UpendLC style=\"width: 300px\"></td></tr><tr><td class=text-center><b>{{vc.columnMap.LeftLC.ColumnLogicalNm}}(px)</b></td><td><input type=text class=form-control ng-model=vc.data.LeftLC style=\"width: 300px\"></td></tr><tr><td class=text-center><b>{{vc.columnMap.Contents.ColumnLogicalNm}}</b></td><td><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea><script type=text/javascript>var oEditors = [];\r\n\r\n                        var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n                        // 추가 글꼴 목록\r\n                        //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n                        nhn.husky.EZCreator.createInIFrame({\r\n                          oAppRef : oEditors,\r\n                          elPlaceHolder : \"strHtml\",\r\n                          sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n                          htParams : {\r\n                            bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n                            bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n                            bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n                            //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n                            //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n                            fOnBeforeUnload : function() {\r\n                              //alert(\"완료!\");\r\n                            },\r\n                            I18N_LOCALE : sLang\r\n                          }, //boolean\r\n                          fOnAppLoad : function() {\r\n                            //예제 코드\r\n                            //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n                          },\r\n                          fCreator : \"createSEditor2\"\r\n                        });</script></td></tr></tbody></table></div></div></div></div><div class=row ng-if=\"vc.layout != \'N\'\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.preview()><i class=\"glyphicon glyphicon-search\"></i>미리보기</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=vc.data.PopupId><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/popup/popup-list.html","<div class=\"page page-footable\" ng-controller=\"PopupsListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>팝업 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Name placeholder=\"제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Name type=text><label>{{vc.columnMap[\'Title\'].ColumnLogicalNm | translate}}</label></div></div><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-danger\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.PopupId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.setPageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/project/gantt-list-google.html","<div class=\"page page-footable\" ng-controller=\"GanttListGoogleCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><div class=page-header>Gantt 차트</div></div></div><!-- page content --><div class=pagecontent><!-- row --><div class=row><script type=text/javascript>google.charts.load(\'current\', {\'packages\':[\'gantt\']});\r\n        google.charts.setOnLoadCallback(drawChart);\r\n\r\n        function daysToMilliseconds(days) {\r\n          return days * 24 * 60 * 60 * 1000;\r\n        }\r\n\r\n        function drawChart() {\r\n\r\n          var data = new google.visualization.DataTable();\r\n          data.addColumn(\'string\', \'Task ID\');\r\n          data.addColumn(\'string\', \'Task Name\');\r\n          data.addColumn(\'date\', \'Start Date\');\r\n          data.addColumn(\'date\', \'End Date\');\r\n          data.addColumn(\'number\', \'Duration\');\r\n          data.addColumn(\'number\', \'Percent Complete\');\r\n          data.addColumn(\'string\', \'Dependencies\');\r\n\r\n          data.addRows([\r\n            [\'Research\', \'Find sources\',\r\n             new Date(2015, 0, 1), new Date(2015, 0, 5), null,  100,  null],\r\n            [\'Write\', \'Write paper\',\r\n             null, new Date(2015, 0, 9), daysToMilliseconds(3), 25, \'Research,Outline\'],\r\n            [\'Cite\', \'Create bibliography\',\r\n             null, new Date(2015, 0, 7), daysToMilliseconds(1), 20, \'Research\'],\r\n            [\'Complete\', \'Hand in paper\',\r\n             null, new Date(2015, 0, 10), daysToMilliseconds(1), 0, \'Cite,Write\'],\r\n            [\'Outline\', \'Outline paper\',\r\n             null, new Date(2015, 0, 6), daysToMilliseconds(1), 100, \'Research\']\r\n          ]);\r\n\r\n          var options = {\r\n            height: 275\r\n          };\r\n\r\n          var chart = new google.visualization.Gantt(document.getElementById(\'chart_div\'));\r\n\r\n          chart.draw(data, options);\r\n        }</script><div class=col-lg-12><div id=chart_div></div></div></div></div></div>");
$templateCache.put("app/project/gantt-list.html","<div class=\"page page-footable\" ng-controller=\"GanttListCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><div class=page-header>Gantt 차트</div></div></div><!-- page content --><div class=pagecontent><!-- row --><div class=row><div gantt data=data></div></div></div></div>");
$templateCache.put("app/reports/ccreport01-detail.html","<div class=\"page page-footable\" ng-controller=\"CCReport01DetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>당월 지급 예정 PP 상세</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--           <div class=\"panel-heading tile-header\">\r\n            <strong style=\"letter-spacing: 0.5px;\"\r\n              class=\"ng-binding\">리스크 고객 목록</strong>\r\n            <div class=\"pull-right\">\r\n              <a href=\"\" tile-control-toggle=\"\"> <i class=\"fa fa-minus fa-lg\"></i></a>\r\n            </div>\r\n          </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/reports/ccreport01-list.html","<div class=\"page page-footable\" ng-controller=\"CCReport01ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>당월 지급 예정 PP 현황<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 placeholder=\"\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=vc.setCalcDate() ng-model=vc.CalcDate ng-required=false placeholder=\"{{vc.columnMap[\'CalcDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>당월 지급 예정 CC 현황</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td ng-click=vc.goDetail(li.KeyId) class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\" style=\"background-color:{{vc.keyId == li.KeyId ? \'#ffffcc\': \'\'}}\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reports/ccreport02-list.html","<div class=\"page page-footable\" ng-controller=\"CCReport02ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>PP 정산<!--         <div class=\"pull-right dock-header-tx list-split\">\r\n          <span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=\"assets/images/icon-sp-list.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=\"assets/images/icon-sp-rl.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=\"assets/images/icon-sp-tb.png\"></span>\r\n        </div> --></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 placeholder=\"\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.PayDateFrom = (vc.PayDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.PayDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'PayDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.PayDateTo = (vc.PayDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.PayDateTo ng-required=false placeholder=\"{{vc.columnMap[\'PayDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.ApplyDateFrom = (vc.ApplyDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.ApplyDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'ApplyDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.ApplyDateTo = (vc.ApplyDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.ApplyDateTo ng-required=false placeholder=\"{{vc.columnMap[\'ApplyDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>PP 정산</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th><th class=\"text-center none\">지급완료</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr><tr></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\')}}</td><td style=\"text-align: center\"><button ng-click=vc.updatePayDate(li) class=\"btn btn-default mt-10 mb-10\" ng-disabled=\"li.PayDate != null\"><span class=\"glyphicon glyphicon-check\">지급완료</span></button></td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reports/salesreport01-list.html","<div class=\"page page-footable\" ng-controller=\"SalesReport01ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>매출 현황</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.srchGoodsNm placeholder=\"제품명 검색\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=form-group><label class=-inline ng-repeat=\"li in vc.columnMap[\'PurchDate\'].CodeList\"><input ng-model=vc.srch.srchType type=radio value={{li.Code}} ng-change=vc.setSrchType() ng-checked=\"vc.srch.srchType == li.Code\">{{li.CodeValue}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PurchDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.PurchDateFrom = (vc.PurchDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDateFrom ng-required=false placeholder=매출시작일 type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PurchDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.PurchDateTo = (vc.PurchDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDateTo ng-required=false placeholder=매출종료일 type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'GoodsNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.GoodsNm readonly type=text><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchPrdModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.erasePrd(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CareTktNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CareTktNm readonly type=text><label>{{vc.columnMap[\'CareTktNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchCareTktModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseCareTkt(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'MasterNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.MasterNm readonly type=text><label>{{vc.columnMap[\'MasterNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchMasterModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseMaster(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PharmaNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.PharmaNm readonly type=text><label>{{vc.columnMap[\'PharmaNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchPharmaModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.erasePharma(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SellerNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SellerNm readonly type=text><label>{{vc.columnMap[\'SellerNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchSellerModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSeller(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>매출 현황</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\')}}</td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reports/salesreport02-list.html","<div class=\"page page-footable\" ng-controller=\"SalesReport02ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>순이익 현황</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.srchGoodsNm placeholder=\"제품명 검색\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PurchDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.PurchDateFrom = (vc.PurchDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDateFrom ng-required=false placeholder=매출시작일 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PurchDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.PurchDateTo = (vc.PurchDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDateTo ng-required=false placeholder=매출종료일 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'GoodsNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.GoodsNm readonly type=text><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchPrdModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.erasePrd(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CareTktNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CareTktNm readonly type=text><label>{{vc.columnMap[\'CareTktNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchCareTktModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseCareTkt(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TenantId\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TenantNm readonly type=text><label>{{vc.columnMap[\'TenantId\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchTenantModal(); type=button ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseTenant(); type=button ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SellerId\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SellerNm readonly type=text><label>{{vc.columnMap[\'SellerId\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchSellerModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSeller(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>순이익 현황</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" ng-if=\"li[\'GoodsNm\'] != \'Total\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\')}}</td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" ng-if=\"li[\'GoodsNm\'] == \'Total\'\"><span style=\"font-weight: bold\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\')}}</span></td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reports/salesreport03-list.html","<div class=\"page page-footable\" ng-controller=\"SalesReport03ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>고객 유입 구분</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 placeholder=\"\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustRegDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CustRegDtFrom = (vc.CustRegDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.CustRegDtFrom ng-required=false placeholder=등록시작일 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CustRegDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CustRegDtTo = (vc.CustRegDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.CustRegDtTo ng-required=false placeholder=등록종료일 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ProductId\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ProductNm readonly type=text><label>{{vc.columnMap[\'ProductId\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchPrdModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.erasePrd();><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CareTktId\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CareTktNm readonly type=text><label>{{vc.columnMap[\'CareTktId\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchCareTktModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseCareTkt();><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SellerId\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SellerNm readonly type=text><label>{{vc.columnMap[\'SellerId\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchSellerModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSeller();><i class=\"fa fa-eraser\"></i></button></span></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>고객 유입 구분</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" ng-if=\"li[\'CustRegDt\'] != \'Total\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" ng-if=\"li[\'CustRegDt\'] == \'Total\'\"><span style=\"font-weight: bold\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span></td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reports/salesreport04-list.html","<div class=\"page page-footable\" ng-controller=\"SalesReport04ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>신규/재방문<!--         <div class=\"pull-right dock-header-tx list-split\">\r\n          <span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=\"assets/images/icon-sp-list.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=\"assets/images/icon-sp-rl.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=\"assets/images/icon-sp-tb.png\"></span>\r\n        </div> --></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 placeholder=\"\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=form-group><label class=-inline ng-repeat=\"li in vc.columnMap[\'CounselDt\'].CodeList\"><input ng-model=vc.srch.srchType type=radio value={{li.Code}} ng-change=vc.setSrchType() ng-checked=\"vc.srch.srchType == li.Code\">{{li.CodeValue}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.CounselDtFrom = (vc.CounselDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDtFrom ng-required=false placeholder=상담시작일 type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.CounselDtTo = (vc.CounselDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDtTo ng-required=false placeholder=상담종료일 type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>신규/재방문 현황</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\')}}</td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reports/salesreport05-list.html","<div class=\"page page-footable\" ng-controller=\"SalesReport05ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>관리권/일반판매 매출<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.srchGoodsNm placeholder=\"제품명 검색\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=form-group><label class=-inline ng-repeat=\"li in vc.columnMap[\'PurchDate\'].CodeList\"><input ng-model=vc.srch.srchType type=radio value={{li.Code}} ng-change=vc.setSrchType() ng-checked=\"vc.srch.srchType == li.Code\">{{li.CodeValue}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PurchDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.PurchDateFrom = (vc.PurchDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDateFrom ng-required=false placeholder=매출시작일 type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PurchDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.PurchDateTo = (vc.PurchDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.PurchDateTo ng-required=false placeholder=매출종료일 type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'GoodsNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.GoodsNm readonly type=text><label>{{vc.columnMap[\'GoodsNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchPrdModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.erasePrd();><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CareTktNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CareTktNm readonly type=text><label>{{vc.columnMap[\'CareTktNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchCareTktModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseCareTkt();><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SellerNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SellerNm readonly type=text><label>{{vc.columnMap[\'SellerNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchSellerModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSeller();><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SalesType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SalesType\'].CodeList\" code-model=vc.srch.SalesType></common-code-custom><label>{{vc.columnMap[\'SalesType\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>관리권/일반판매 매출 구분</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\">{{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reports/salesreport06-detail.html","<div class=\"page page-footable\" ng-controller=\"SalesReport06DetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>리스크 고객 목록</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>리스크 고객 목록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><label>그룹명</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-model=vc.srch.GrpId ng-options=\"c.Code as c.CodeValue for c in vc.groupLists\"><option value=\"\">-선택-</option></select><button class=\"btn btn-default\" ng-click=vc.setGrpCust()><i class=\"fa fa-edit\"></i> 그룹고객 투입</button> <button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reports/salesreport06-list.html","<div class=\"page page-footable\" ng-controller=\"SalesReport06ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>리스크고객<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 placeholder=\"\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=form-group><label class=-inline ng-repeat=\"li in vc.commonCode\"><input ng-model=vc.srch.srchType type=radio value={{li.Code}} ng-change=vc.setSrchType() ng-checked=\"vc.srch.srchType == li.Code\">{{li.CodeValue}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.CalDtFrom = (vc.CalDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.CalDtFrom ng-required=false placeholder=최종방문시작일 type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-change=\"vc.srch.CalDtTo = (vc.CalDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.CalDtTo ng-required=false placeholder=최종방문종료일 type=text datepicker-append-to-body=true uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>리스크 고객 현황</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" ng-repeat=\"liCol in vc.listColumns | orderBy:\'idx\'\">{{ :: liCol.CodeValue | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td ng-repeat=\"liCol in vc.listColumns | orderBy:\'idx\'\" style=\"text-align: center; width: 10%\" ng-click=\"liCol.Code != \'CalDt\' ? vc.goDetail(liCol.Code, li.CalDt) : \'\'\">{{li[liCol.Code]}}</td></tr></table></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reserve/reserve-daily.html","<div class=\"page page-footable\" ng-controller=\"ReserveDailyCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>일별회의실현황</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.openMeetingRoom()><i class=\"fa fa-institution\"></i> 월별 예약현황</button></div></div></div><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-info tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-2 col-md-4 col-sm-6 col-xs-6\"><div class=form-group><div class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty ng-valid-date\" uib-datepicker-popup=yyyy-MM-dd ng-model=vc.tmCalDt ng-change=vc.getSearch() is-open=opened datepicker-options=dateOptions current-text=오늘 clear-text=취소 close-text=닫기 placeholder=에약일 aria-invalid=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div></div><!-- panel-body --></div><!--panel panel-default --></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-info tile\"><div class=\"panel-body collapse in\"><!-- col --><div class=col-md-12><div class=table-responsive><tree-grid tree-data=tree_data tree-control=my_tree col-defs=col_defs expand-on=expanding_property on-select=my_tree_handler(branch) expand-level=4 icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-minus\" icon-collapse=\"fa fa-minus\"></tree-grid></div></div><!-- col-md-12  --></div></div><!-- // table  --></div></div></div></div>");
$templateCache.put("app/reserve/reserve-detail.html","<div class=\"page page-footable\" ng-controller=\"ReserveDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>회의실예약 관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>시간</label><div class=\"form-control txt_view\" ng-bind=vc.data.ReserveTime></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>등록자</label><div class=\"form-control txt_view\"><span ng-if=vc.data.DeptNm>[{{vc.data.DeptNm}}] </span>{{vc.data.UserNm}}</div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>전화번호</label><div class=\"form-control txt_view\"><span ng-show=\"vc.data.TelNo && vc.data.TelNo != \'null\'\">{{vc.data.TelNo}}</span></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>핸드폰</label><div class=\"form-control txt_view\"><span ng-show=\"vc.data.Mobile && vc.data.Mobile != \'null\'\">{{vc.data.Mobile}}</span></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>이용목적</label><div class=\"form-control txt_view\"><span ng-show=\"vc.data.Comment && vc.data.Comment != \'null\'\">{{vc.data.Comment}}</span></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>상태</label><div class=\"form-control txt_view\" ng-bind=vc.data.ApprYN></div></div></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/reserve/reserve-edit.html","<div class=\"page page-footable\" ng-controller=\"ReserveEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>회의실예약 관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.LoginId readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.UserNm></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UserType\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'UserType\'].CodeList\" code-model=vc.data.UserType></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchTenantModal(); ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseTenant(); ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'DeptNm\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.DeptNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchDeptModal(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseDept(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ \'Password\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Password></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ \'Confirm Password\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Password2></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>{{ \'Menu.ROLEGROUP\' | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.UserRoleNms readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchUserroleModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseUserRole();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Mobile></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TelNo></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Email></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ \'Menu.ORNOTTOUSE\' | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.data.UseYN></common-code-custom></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block vault-company></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" aria-label=Check ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --><div class=row><div class=form-group ng-show=vc.srch.editColumns.Contents><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 600px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reserve/reserve-list.html","<div class=\"page page-footable\" ng-controller=\"ReserveListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>회의실예약 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size={{$root.gVariable.layoutBoardSize}} pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Comment placeholder=\"이용목적 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer(\'500\')\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-tree code-type=\"\'MEETINGROOM\'\" reload-seq=vc.reloadSeq code-model=vc.srch.MeetingRoom></common-code-tree></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'LoginId\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.LoginId></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UserType\'].CodeList\" code-model=vc.srch.UserType></common-code-custom><label>{{vc.columnMap[\'UserType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'DeptNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.DeptNm readonly><label>{{vc.columnMap[\'DeptNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" type=button ng-click=vc.srchDeptModal(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseDept(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ApprYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ApprYN\'].CodeList\" code-model=vc.srch.ApprYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserNm\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.UserNm><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.Mobile><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TelNo\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.TelNo><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.Email><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.openMeetingRoom()><i class=\"fa fa-institution\"></i> 월별 예약현황</button><!-- <button class=\"btn btn-default\" activate-button ng-click=\"vc.getExcel()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i>{{\'Menu.EXCEL\' | translate}}\r\n                  </button> --> <button class=\"btn btn-primary\" activate-button ng-click=vc.apprAll()><i class=\"fa fa-check\"></i> 선택승인</button> <button class=\"btn btn-lightred\" activate-button ng-click=vc.apprCancelAll()><i class=\"fa fa-close\"></i> 선택승인취소</button><!-- <button class=\"btn btn-primary\" ng-click=\"vc.goEdit()\">\r\n                    <i class=\"fa fa-edit\"></i>{{\'Menu.ADD\' | translate}}\r\n                  </button> --></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- form --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>목록</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th style=width:5% class=text-center title=checkedAll><input type=checkbox ng-change=vc.checkAll() ng-model=vc.checkedAll ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"ng-pristine ng-valid ng-empty ng-touched\" aria-invalid=false></th><th ng-repeat=\"liCol in vc.listColumns\" ng-click=\"vc.tablesort(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" style=\"width: {{liCol.ListColumnWidth}}\" class=\"text-center none\">{{ :: liCol.ColumnLogicalNm | translate }} <span ng-show=\"liCol.KeyColumnYN == \'Y\'\" class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" my-directive style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.ReserveId == vc.keyId}\"><!-- Result Items --><td class=text-center><input type=checkbox ng-checked=\"li.ChkYN == \'Y\'\" ng-model=li.ChkYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=false></td><td class={{liCol.ListColumnTextAlign}} ng-click=vc.goDetail(li.ReserveId) style=\"cursor: pointer\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd h:mm a\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/reserve/reservecode-list.html","<div class=\"page page-footable\" ng-controller=\"ReservecodeListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>회의실설정</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}} file-dropzone><div class=pane-root fa-pane=\"\"><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CodeValue placeholder=코드명 type=text><div class=\"search_layer mb-2\" ng-click=vc.nextSearch() style=\"width:45px !important\"><span class=cursor id=btn_layer_detail_search_open><i class=\"fa fa-search\"></i></span></div></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>회의실설정</div><div class=\"panel-body collapse in\" id=collapse1><section layout=row flex><md-sidenav class=sidenav-left md-component-id=left md-is-locked-open=true style=min-height:600px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">회의실코드</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=4 select-text=vc.srch.CodeValue icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav><md-content flex layout-padding><form class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=row><div class=col-lg-2><div class=form-group><md-checkbox md-no-ink=\"\" ng-disabled=\"$root.gVariable.srchTenantId == \'0\' || vc.data.Code == \'000\' || vc.data.CodeType != \'000\' || vc.data.New == \'Y\' || vc.data.SysCodeYN == \'Y\'\" ng-click=vc.ChangeCustomCode() ng-checked=\"vc.data.CustomCode == 0 ? false:true\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>커스텀코드</md-checkbox></div></div><div class=col-lg-2><div class=form-group><md-checkbox md-no-ink=\"\" ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\' || $root.gVariable.srchTenantId != \'0\' || vc.data.TenantId != \'0\'\" ng-model=vc.data.SysCodeYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>시스템코드</md-checkbox></div></div><div class=pull-right><button class=\"btn btn-primary\" activate-button type=button ng-click=try_adding_a_branch() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-edit\"></i>{{ \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i>{{ \'Menu.DELETE\' | translate }}</button><!-- <button class=\"btn btn-primary mr-10\" activate-button type=\"submit\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\" ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i>{{ \'Menu.SAVE\' | translate }}</button> --> <button class=\"btn btn-primary mr-10\" ng-click=vc.uploadFile() ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\" ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i>{{ \'Menu.SAVE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 코드입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div><div class=col-lg-4 style=\"display: none\"><div class=form-group><label>{{ \'Menu.EM660DT01\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CommonCodeId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT02\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue ng-change=vc.onChangeCodeValue() ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT03\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Code ng-change=vc.onChangeCode() ng-required=true ng-disabled=codeDisabled></div></div><div class=col-lg-4 style=\"display: none\"><div class=form-group><label>{{ \'Menu.EM660DT04\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeLevel ng-required=true ng-disabled=true></div></div><div class=col-lg-4 style=\"display: none\"><div class=form-group><label>{{ \'Menu.EM660DT05\' | translate }}</label><input type=text class=form-control ng-model=vc.data.ParentCommonCodeId ng-required=true ng-change=vc.onChanged() ng-disabled=true></div></div><div class=col-lg-4 style=\"display: none\"><div class=form-group><label>{{ \'Menu.CODETYPE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeType ng-required=true ng-change=vc.onChanged() ng-disabled=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT07\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Sort ng-change=vc.onChanged()></div></div><div class=col-lg-4 style=\"display: none\"><div class=form-group><label>FullPath</label><input type=text class=form-control ng-model=vc.data.CodeValue01 ng-disabled=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.ORNOTTOUSE\' | translate }}</label><common-code param-data=vc.UseYNData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\"></common-code></div></div><div class=col-lg-4><div class=form-group><label>예약 가능여부</label><common-code param-data=vc.ReserveYNData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\"></common-code></div></div></div><!-- file upload--><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><div><file-attach callback=vc.onFileCallback file-data=vc.uploadFileList></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form enctype=Multipart/Form-Data id=frmReservecode method=post runat=server><div class=\"vault-block ml-0 wd-100p\" id=vault></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox aria-label=Check class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" md-no-ink=\"\" ng-false-value=\"\'\'\" ng-model=fli.delState ng-true-value=\"\'delete\'\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></form></md-content></section><!-- row --></div></div></div></div></div></div></div></div><!-- pagecontent --></div>");
$templateCache.put("app/template/pagination.html","<ul class=pagination><li ng-if=::boundaryLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\"><a href class=\"spr first\" ng-click=\"selectPage(1, $event)\"><span class=hide>맨앞으로</span></a></li><li ng-if=::directionLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\"><a href class=\"spr prev\" ng-click=\"selectPage(page - 1, $event)\"><span class=hide>이전</span></a></li><li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=pagination-page><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li><li ng-if=::directionLinks ng-class=\"{disabled: noNext()||ngDisabled}\"><a href class=\"spr next\" ng-click=\"selectPage(page + 1, $event)\"><span class=hide>다음</span></a></li><li ng-if=::boundaryLinks ng-class=\"{disabled: noNext()||ngDisabled}\"><a href class=\"spr last\" ng-click=\"selectPage(totalPages, $event)\"><span class=hide>맨뒤로</span></a></li></ul>");
$templateCache.put("app/system/cafe24-deleteuser.html","<div class=\"page page-footable\" ng-controller=\"Cafe24DeleteUserCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.USER\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label>테스트</label></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4\"><button activate-button class=\"btn btn-info\" ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> 엑셀차트</button></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/caretkt-edit.html","<div class=\"page page-footable\" ng-controller=\"CaretktEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>관리권 관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><ul class=\"nav nav-tabs mt-20\"><li class=active><a ng-click=vc.setChangeTab(0); data-toggle=tab>관리권 정보</a></li></ul><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>관리권정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CareTktNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CareTktNm maxlength=200></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'MngCnt\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=11 numbers-only ng-model=vc.data.MngCnt></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Price\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=20 comma ng-model=vc.data.Price></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'MngTgt\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.MngTgt></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'Remark\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=1000 ng-model=vc.data.Remark></div></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label>전체 품목</label><table class=\"table table-condensed table-typeA mt-5\"><colgroup><col style=\"width: 55%\"><col style=\"width: 35%\"><col style=\"width: 8%\"></colgroup><!-- Header --><thead><tr><th><span>품목명</span></th><th><span>금액</span></th><th><span>선택</span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.PrdLists\"><!-- Result Items --><td>{{li.GoodsNm}}</td><td>{{li.GoodsPrice}}</td><td><button type=button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" ng-click=vc.addPrd(li)><span class=\"glyphicon glyphicon-check\">선택</span></button></td></tr></table></div><div class=\"col-xs-6 col-md-6 col-lg-6 col-xl-6 mt-10\"><label>선택 품목</label><table class=\"table table-condensed table-typeA mt-5\"><!-- Header --><thead><tr><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.prdListColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th><th><span>삭제</span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.tktPrdLists\"><!-- Result Items --><td><input type=text class=\"form-control form-right\" maxlength=200 numbers-only ng-model=li.MngSeq></td><td><span>{{li.GoodsNm}}</span></td><td><span>{{li.GoodsPrice}}</span></td><td><span>{{li.MngAmt}}</span></td><td><input type=text class=\"form-control form-right\" maxlength=200 ng-change=vc.changePrdCnt(li) numbers-only ng-model=li.MngCnt></td><td><button type=button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" ng-click=vc.prdDelete(li)><span class=\"glyphicon glyphicon-remove\">삭제</span></button></td></tr></table></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/caretkt-list.html","<div class=\"page page-footable\" ng-controller=\"CareTktListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ :: \'관리권 관리\' | translate }}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CareTktNm placeholder=\"관리권명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CareTktNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CareTktNm type=text><label>{{vc.columnMap[\'CareTktNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.MngTgt type=text><label>관리대상</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Remark\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Remark type=text><label>{{vc.columnMap[\'Remark\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'EntryDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EntryDtFrom = (vc.EntryDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.EntryDtFrom ng-required=false placeholder=입사시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'EntryDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EntryDtTo = (vc.EntryDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.EntryDtTo ng-required=false placeholder=입사종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'WorkStyle\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'WorkStyle\'].CodeList\" code-model=vc.srch.WorkStyle></common-code-custom><label>{{vc.columnMap[\'WorkStyle\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UserType\'].CodeList\" code-model=vc.srch.UserType></common-code-custom><label>{{vc.columnMap[\'UserType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'DeptNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.DeptNm readonly type=text><label>{{vc.columnMap[\'DeptNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchDeptModal(); ng-disabled=\"gVariable.TenantId == \'0\'\" type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseDept(); ng-disabled=\"gVariable.TenantId == \'0\'\" type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TelNo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TelNo type=text><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Email type=text><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UseYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.srch.UseYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class={{liCol.ListColumnTextAlign}} ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/common-properties.html","<div class=\"page page-footable\" ng-controller=\"CommonPropertiesCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><h1 class=page-header>공통설정관리</h1></div></div><!-- page content --><div class=pagecontent><form id=form1 name=form1><!-- row --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"$root.gVariable.SysAdminYN == \'Y\'\" ng-click=vc.addNew()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.saveListComment()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>공통설정관리</div><div class=\"panel-body collapse in\" id=collapse1><!-- Search Result --><div class=pull-right><span>※ Background 색상이 <i class=\"fa fa-square\" style=color:#fde8e8></i>인 항목은 커스텀코드입니다.</span></div><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><colgroup><col style=\"width: 10%\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"></colgroup><thead><tr><th class=text-center>항목명</th><th class=text-center ng-if=\"$root.gVariable.srchTenantId == \'0\'\">코드타입</th><th class=text-center ng-if=\"$root.gVariable.srchTenantId == \'0\'\">코드</th><th class=text-center>코드값</th><th class=\"text-center showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\">공통코드타입</th><th class=\"text-center showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\">정렬순서</th><th class=\"text-center showlevel3\">등록일</th><th class=\"text-center showlevel3\">수정일</th><th class=text-center>{{$root.gVariable.srchTenantId != \'0\' ? \'커스텀코드삭제\' : \'삭제\'}}</th><th class=text-center>커스텀코드생성</th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" my-directive><!-- Result Items --><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input class=form-control type=text ng-model=li.Remark ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\" required></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.CodeType ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\" required></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.Code ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\" required></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input class=form-control type=text ng-model=li.CodeValue required ng-if=\"li.CodeList == null || $root.gVariable.srchTenantId == \'0\'\"><common-code-custom code-list=li.CodeList code-model=li.CodeValue ng-if=\"li.CodeList != null && $root.gVariable.srchTenantId != \'0\'\"></common-code-custom></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.CommonCodeType ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\"></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.Sort required></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\"><span>{{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\"><span>{{li.EdtDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input type=checkbox ng-show=\"(li.TenantId == $root.gVariable.srchTenantId) && (li.TenantId != \'0\' || $root.gVariable.SysAdminYN == \'Y\')\" ng-model=li.DelYN ng-change=vc.checkChanged(li) ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input type=checkbox ng-show=\"(li.TenantId == \'0\' && $root.gVariable.srchTenantId != \'0\') || (li.TenantId != \'0\')\" ng-disabled=\"li.isNew == \'Y\' || li.TenantId != \'0\' || $root.gVariable.SysAdminYN != \'Y\'\" ng-model=li.makeCustomYN ng-change=vc.checkChanged(li) ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td></tr></table></div></div></div></div><!-- row --></form></div><!-- /page content --></div>");
$templateCache.put("app/system/commoncode-list.html","<div class=\"page page-footable\" ng-controller=\"CommoncodeListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.EM660\' | translate }}</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div class=pane-root fa-pane=\"\"><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CodeValue placeholder=코드명 type=text><div class=\"search_layer mb-2\" ng-click=vc.nextSearch() style=\"width:45px !important\"><span class=cursor id=btn_layer_detail_search_open><i class=\"fa fa-search\"></i></span></div></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>{{ \'Menu.EM660\' | translate }}</div><div class=\"panel-body collapse in\" id=collapse1><section layout=row flex><md-sidenav class=sidenav-left md-component-id=left md-is-locked-open=true><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">{{ \'Menu.ALL\' | translate }}{{ \'Menu.COMMON_CODE\' | translate }}</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl style=min-height:600px><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.CodeValue icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav><md-content flex layout-padding><form class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-submit=vc.saveData()><div class=row><div class=col-lg-2><div class=form-group><md-checkbox md-no-ink=\"\" ng-disabled=\"$root.gVariable.srchTenantId == \'0\' || vc.data.Code == \'000\' || vc.data.CodeType != \'000\' || vc.data.New == \'Y\' || vc.data.SysCodeYN == \'Y\'\" ng-click=vc.ChangeCustomCode() ng-checked=\"vc.data.CustomCode == 0 ? false:true\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>커스텀코드</md-checkbox></div></div><div class=col-lg-2><div class=form-group><md-checkbox md-no-ink=\"\" ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\' || $root.gVariable.srchTenantId != \'0\' || vc.data.TenantId != \'0\'\" ng-model=vc.data.SysCodeYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>시스템코드</md-checkbox></div></div><div class=pull-right><button class=\"btn btn-primary\" activate-button type=button ng-click=try_adding_a_branch() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-edit\"></i>{{ \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i>{{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary mr-10\" activate-button type=submit ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\" ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i>{{ \'Menu.SAVE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 코드입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT01\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CommonCodeId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT02\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue ng-change=vc.onChangeCodeValue() ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT03\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Code ng-change=vc.onChangeCode() ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT04\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeLevel ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT05\' | translate }}</label><input type=text class=form-control ng-model=vc.data.ParentCommonCodeId ng-required=true ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.CODETYPE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeType ng-required=true ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT07\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Sort ng-required=true ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT10\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue01></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT11\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue02></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT12\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue03></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT13\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue04></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT14\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue05></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT15\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue06></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT16\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue07></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT17\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue08></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT18\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue09></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT19\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue10></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.ORNOTTOUSE\' | translate }}</label><common-code param-data=vc.UseYNData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\"></common-code></div></div></div><div class=row><div class=col-lg-12><ul><li>* 분류로 사용되는 항목 : 코드 = \'000\', 코드타입 = \'000\'</li><li>* 코드명으로 사용되는 항목 : 코드 = 코드타입, 코드타입 = \'000\'</li><li>* 코드의 각항목 사용되는 항목 : 코드 = 코드값, 코드타입 = 코드타입</li></ul></div></div></form></md-content></section><!-- row --></div></div></div></div><!-- row --></div></div></div></div><!-- pagecontent --></div>");
$templateCache.put("app/system/company-detail.html","<div class=\"page page-footable\" ng-controller=\"CompanyDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.ID\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantId></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.NAME\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.CEO\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.CEO></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.PERSONINCHARGE\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Contact></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.TENANTDIR\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantDir></div></div></div><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/company-edit-tab1.html","<div ng-controller=\"CompanyEditTab1Ctrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>Shop정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Ceo\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.Ceo></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BizRegNo\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.BizRegNo></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.TelNo></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.Email></div></div></div><!-- /row --><!-- 주소검색 (다음) --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input type=text id=zipCode class=form-control ng-model=vc.data.ZipCode readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.getAddressInfo()><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 wd85\"><div class=form-group><input type=text id=addr1 ng-model=vc.data.Addr1 class=form-control readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input type=text id=addr2 ng-model=vc.data.Addr2 class=form-control></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'TenantStatus\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'TenantStatus\'].CodeList\" code-model=vc.data.TenantStatus></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'JoinDt\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.JoinDt = (vc.JoinDt | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDt ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'LeaveDt\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.LeaveDt = (vc.LeaveDt | date: \'yyyy-MM-dd\')\" ng-model=vc.LeaveDt ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>메뉴그룹</label><div class=input-group><div class=\"radio-inline pl-0 pr-20\" ng-repeat=\"mt in vc.radioMenuType\"><input type=checkbox class=clr ng-model=mt.checked ng-disabled=\"$root.gVariable.srchTenantId != \'0\'\"> {{ mt.codeNm}}</div></div></div></div></div><!-- file upload--><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault2 class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --><!--               <div class=\"row\">\r\n              <div class=\"form-group\" ng-show=\"vc.srch.editColumns.Contents\">\r\n                <div class=\"col-sm-12\">\r\n                  <textarea id=\"strHtml\" rows=\"10\" style=\"width: 100%; height: 600px; display: \'none\';\"\r\n                    ng-model=\"vc.data.Contents\"></textarea>\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setdelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/system/company-edit-tab2.html","<div ng-controller=\"CompanyEditTab2Ctrl as vc\"><!-- Action Buttons --><!-- row --><div class=dataloader ng-show=vc.dataloader></div><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--         <div class=\"panel-heading tile-header\">\r\n          <strong style=\"letter-spacing: 0.5px;\"\r\n            class=\"ng-binding\">사용자 목록</strong>\r\n          <div class=\"pull-right\">\r\n            <a href=\"\" tile-control-toggle=\"\"> <i class=\"fa fa-minus fa-lg\"></i></a>\r\n          </div>\r\n        </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumPnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/system/company-edit.html","<div class=\"page page-footable\" ng-controller=\"CompanyEditCtrl as vc\"><!-- page content --><div class=pagecontent><ul class=\"nav nav-tabs\"><li ng-class=\"vc.url == \'/tab1\' ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab1\');\" data-toggle=tab>Shop정보</a></li><li ng-class=\"vc.url == \'/tab2\' ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab2\');\" data-toggle=tab>사용자 목록</a></li></ul><ui-view></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/system/company-list.html","<div class=\"page page-footable\" ng-controller=\"CompanyListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>Shop관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.TenantNm placeholder=\"Shop명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtFrom = (vc.JoinDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtFrom ng-required=false placeholder=가입시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'JoinDt\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.JoinDtTo = (vc.JoinDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.JoinDtTo ng-required=false placeholder=가입종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Ceo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Ceo type=text><label>{{vc.columnMap[\'Ceo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TenantStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'TenantStatus\'].CodeList\" code-model=vc.srch.TenantStatus></common-code-custom><label>{{vc.columnMap[\'TenantStatus\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-if=\"$root.gVariable.srchTenantId == 0\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/contents-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"ContentsEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>컨텐츠 정보</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><ul class=\"nav nav-tabs mt-20\"><li class=active><a ng-click=vc.setChangeTab(0); data-toggle=tab>컨텐츠정보</a></li></ul><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.contentsModal()><i class=\"fa fa-desktop\"></i> 미리보기</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.delData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Subject\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.Subject></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Category\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.Category></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\" ng-if=vc.isYoutubeContent><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'CntntsType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'CntntsType\'].CodeList\" code-model=vc.data.CntntsType></common-code-custom></div></div></div><div class=row><div class=col-sm-12><div class=\"form-group form-inline\"><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea><div class=editorNotiBox>Youtube 동영상 등록 방법 : <b>[video?youtubeURL]</b><br><b>(EX)</b> [video?https://youtu.be/1wGipjrMBWg]</div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block vault-company></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" aria-label=Check ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.delData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"en_US\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,    // client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,   // 추가 글꼴 목록\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/system/contents-list.html","<div class=\"page page-footable\" ng-controller=\"ContentsListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>컨텐츠 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Subject placeholder=\"제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색</div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Category\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Category type=text><label>{{vc.columnMap[\'Category\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CntntsType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CntntsType\'].CodeList\" code-model=vc.srch.CntntsType></common-code-custom><label>{{vc.columnMap[\'CntntsType\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\" ng-click=vc.goEdit(li.KeyId)>{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/department-detail.html","<div class=\"page page-footable\" ng-controller=\"DepartmentDetailCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.DEPTLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> Salevis</a></li><li><a>{{ \'Menu.MANAGEMENT\' | translate }}</a></li><li><a>{{ \'Menu.DEPTLIST\' | translate }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.DEPTLIST\' | translate }} {{ \'Menu.MODIFY\' | translate }}</strong></h4></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button ui-sref=app.system.department-list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10\" activate-button ui-sref=\"app.system.department-edit({DeptId:\'{{vc.srch.DeptId}}\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><table class=\"table table-togglable table-hover\"><colgroup><col width=160><col width=*></colgroup><tbody><tr><th scope=row>{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.NAME\' | translate }}</th><td><span ng-bind=vc.data.DeptNm></span></td></tr><tr><th scope=row>{{ \'Menu.PARENT\' | translate }}{{ \'Menu.DEPARTMENT\' | translate }}</th><td><span ng-bind=vc.data.ParentDeptNm></span></td></tr><tr><th scope=row>{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.SORTORDER\' | translate }}</th><td><span ng-bind=vc.data.Sort></span></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONDATE\' | translate }}</th><td><span ng-bind=vc.data.RegDate></span></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th><td><span ng-bind=vc.data.RegUserNm></span></td></tr></tbody></table></div></section></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/department-edit.html","<div class=\"page page-footable\" ng-controller=\"DepartmentEditCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.DEPTLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> Salevis</a></li><li><a>{{ \'Menu.MANAGEMENT\' | translate }}</a></li><li><a>{{ \'Menu.DEPTLIST\' | translate }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.REGISTRATIONUSER\' | translate }}/{{ \'Menu.EDIT\' | translate }}</strong></h4></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button ui-sref=app.system.department-list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.saveDetail()><i class=\"fa fa-check\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><form class=\"form-horizontal ng-pristine ng-valid\" role=form><div class=form-group><label for=id class=\"col-sm-2 control-label\">{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.NAME\' | translate }} :</label><div class=col-sm-10><input type=text class=form-control ng-model=vc.data.DeptNm></div></div><div class=form-group><label for=id class=\"col-sm-2 control-label\">{{ \'Menu.PARENT\' | translate }}{{ \'Menu.DEPARTMENT\' | translate }} :</label><div class=col-sm-10><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control ng-model=vc.data.ParentDeptNm placeholder=부서> <input type=hidden ng-model=vc.data.ParentDeptId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchDeptModal(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseDept(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=form-group><label for=id class=\"col-sm-2 control-label\">{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.SORTORDER\' | translate }} :</label><div class=col-sm-10><input type=number class=form-control ng-model=vc.data.Sort></div></div></form></div><!-- /tile body --></section><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/department-list.html","<div class=\"page page-footable\" ng-controller=\"DepartmentListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.DEPTLIST\' | translate }}</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><!-- col --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-info title-header\"><div class=panel-heading>{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}<div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\" id=collapse1><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4\"><div class=input-group><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.DeptNm><label>{{ \'Menu.DEPARTMENTNAME\' | translate }}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" activate-button ng-click=vc.nextSearch()><i class=\"fa fa-search\"></i></button></span></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-8 col-xl-8\"><div class=pull-right><button class=\"btn btn-info\" activate-button ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETSEARCH\' | translate }}</button> <button class=\"btn btn-default\" activate-button ng-click=vc.resetList()><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETLIST\' | translate }}</button></div></div></div><!-- panel-body --></div><!--panel panel-default --></div></div><!-- row --><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>{{ \'Menu.DEPTLIST\' | translate }}</div><div class=\"panel-body collapse in\" id=collapse1><section layout=row flex><md-sidenav class=sidenav-left md-component-id=left md-is-locked-open=true style=min-height:600px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">{{ \'Menu.ALL\' | translate }}{{ \'Menu.DEPARTMENT\' | translate }}</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=2 select-text=vc.srch.DeptNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav><md-content flex layout-padding><form class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-submit=vc.saveData()><div class=row><div class=pull-right><button class=\"btn btn-primary\" activate-button type=button ng-click=try_adding_a_branch() ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-edit\"></i>{{ \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-trash-o\"></i>{{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" activate-button type=submit ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i>{{ \'Menu.SAVE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 코드입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div></div><div class=row><div class=col-lg-4><div class=form-group><label>부서아이디</label><input type=text class=form-control ng-model=vc.data.DeptId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>부서명</label><input type=text class=form-control ng-change=vc.onChangeDeptNm() ng-model=vc.data.DeptNm ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>DEPTH</label><input type=text class=form-control ng-model=vc.data.Depth ng-required=true></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>SORT</label><input type=text class=form-control ng-model=vc.data.Sort ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>상위부서아이디</label><input type=text class=form-control ng-model=vc.data.ParentDeptId ng-required=true></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>추가1</label><input type=text class=form-control ng-model=vc.data.DeptValue01></div></div><div class=col-lg-4><div class=form-group><label>추가2</label><input type=text class=form-control ng-model=vc.data.DeptValue02></div></div><div class=col-lg-4><div class=form-group><label>추가3</label><input type=text class=form-control ng-model=vc.data.DeptValue03></div></div></div></form></md-content></section><!-- row --></div></div></div></div><!-- row --></div><!-- pagecontent --></div>");
$templateCache.put("app/system/makequery-list.html","<div class=\"page page-footable\" ng-controller=\"MakeQueryListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>쿼리생성기</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Mapper ID</div><div class=\"panel-body collapse in\"><input type=text style=\"border :solid 1px #EEE; width:100%; padding: 3px\" ng-model=vc.mapperId ng-change=vc.changeMapperId()></div></div></div></div><!-- row --><div class=row><style>table th, table td {padding: 3px;}\r\n        #queryView span {display: block;}</style><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Table</div><div class=\"panel-body collapse in\"><table><colgroup><col style=width:30%><col style=width:30%></colgroup><thead><tr><th class=text-center>Table</th><th class=text-center>Alias</th><th class=text-center>M</th><th class=text-center>IJ</th><th class=text-center>LJ</th></tr></thead><tbody><tr ng-repeat=\"li in vc.tables\"><!-- Result Items --><td class=text-left><span ng-bind=li.tbNm></span></td><td class=text-center><input type=text ng-model=li.aliasNm ng-blur=vc.blurAlis(li) ng-change=vc.changeAlis(li) style=\"border :solid 1px #EEE; width:100%; padding: 3px\"></td><td class=text-center><input type=checkbox ng-model=li.mChecked ng-click=vc.setMainTable(li)></td><td class=text-center><input type=checkbox ng-model=li.ijChecked ng-click=vc.setJoinTable(li)></td><td class=text-center><input type=checkbox ng-model=li.ljChecked ng-click=vc.setJoinTable(li)></td></tr></tbody></table></div></div></div><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Column</div><div class=\"panel-body collapse in\"><table><colgroup><col style=width:10%><col style=width:90%></colgroup><thead><tr><th class=text-center>V</th><th class=text-center>Column</th></tr></thead><tbody><tr ng-repeat=\"li in vc.cols\"><!-- Result Items --><td class=text-center><input type=checkbox ng-model=li.checkedYn ng-click=vc.setChangeCols(li)></td><td class=text-left>{{li.aliasNm}}.{{ li.colNm}}</td></tr></tbody></table></div></div></div><div class=\"col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Query <span ng-click=vc.copyFn()>(복사하기)</span></div><div class=\"panel-body collapse in\" id=queryView ng-if=vc.checkDrawView><span>&lt;?xml version=\"1.0\" encoding=\"UTF-8\" ?></span> <span>&lt;!DOCTYPE mapper PUBLIC \"-//mybatis.org//DTD Mapper 3.0//EN\" \"/usr/local/dtd/mybatis-3-mapper.dtd\"></span><br><span ng-bind-html=vc.namespace></span><br><span>&nbsp;&nbsp;&lt;sql id=\"where{{vc.tbMain.tableNm}}Data\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;where&gt;</span><div ng-repeat=\"li in vc.cols\" ng-if=li.checkedYn>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"li.dataType==\'char\' && li.colNm !=\'DelYN\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = #{ {{li.colNm}} } &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'char\' && li.colNm ==\'DelYN\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = \'Y\' &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'int\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = #{ {{li.colNm}} } &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'varchar\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} LIKE CONCAT(\'%\', #{ {{li.colNm}} }, \'%\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'text\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} LIKE CONCAT(\'%\', #{ {{li.colNm}} }, \'%\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'date\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = #{ {{li.colNm}} } &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'datetime\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = &lt;![CDATA[&gt;=]]&gt; STR_TO_DATE( #{ {{li.colNm}} } , \'%Y-%m-%d %H:%i:%s\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'datetime\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = &lt;![CDATA[&lt;=]]&gt; STR_TO_DATE( #{ {{li.colNm}} } , \'%Y-%m-%d %H:%i:%s\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'timestamp\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = &lt;![CDATA[&gt;=]]&gt; STR_TO_DATE( #{ {{li.colNm}} } , \'%Y-%m-%d %H:%i:%s\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'timestamp\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = &lt;![CDATA[&lt;=]]&gt; STR_TO_DATE( #{ {{li.colNm}} } , \'%Y-%m-%d %H:%i:%s\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'bigint\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = CONV(#{ {{li.colNm}} }, 36, 10)) &lt;/if&gt;</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/where&gt;</span> <span>&nbsp;&nbsp;&lt;/sql&gt;</span><br><span>&nbsp;&nbsp;&lt;select id=\"get{{vc.tbMain.tableNm}}ListCnt\" parameterType=\"map\" resultType=\"int\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SELECT</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;count(*) as totalItems</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FROM {{vc.tbMain.tableNm}} {{vc.tbMain.aliasNm}}</span><div ng-repeat=\"li in vc.tbJoins\"><span ng-if=li.ijChecked>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;INNER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span> <span ng-if=li.ljChecked>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LEFT OUTER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&nbsp;&nbsp;&lt;/select&gt;</span><br><span>&nbsp;&nbsp;&lt;select id=\"get{{vc.tbMain.tableNm}}List\" parameterType=\"map\" resultType=\"map\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;SELECT</span><div ng-repeat=\"li in vc.cols\" ng-if=li.checkedYn>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0 && li.dataType != \'bigint\'\">T.{{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index == 0 && li.dataType == \'bigint\'\">CONV(T.{{li.colNm}},10,36) AS {{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType != \'bigint\'\">, T.{{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType == \'bigint\'\">, CONV(T.{{li.colNm}},10,36) AS {{li.colNm}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;FROM (</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SELECT</span><div ng-repeat=\"li in vc.cols\" ng-if=li.checkedYn>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0\">&nbsp;&nbsp;{{li.aliasNm}}.{{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index != 0\">&nbsp;&nbsp;, {{li.aliasNm}}.{{li.colNm}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FROM {{vc.tbMain.tableNm}} {{vc.tbMain.aliasNm}}</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ORDER BY {{vc.tbMain.aliasNm}}.RegDate DESC <span>&nbsp;&nbsp;&nbsp;&nbsp;) T</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;INNER JOIN (SELECT @rowNum:=0) T2</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'viewSize != null and viewSize != 0 and page != null\'&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LIMIT #{offSet}, #{viewSize}</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/if&gt; <span>&nbsp;&nbsp;&lt;/select&gt;</span><br><span>&nbsp;&nbsp;&lt;select id=\"get{{vc.tbMain.tableNm}}Detail\" parameterType=\"map\" resultType=\"map\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;SELECT</span><div ng-repeat=\"li in vc.cols\" ng-if=li.checkedYn>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0\">&nbsp;&nbsp;{{li.aliasNm}}.{{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index != 0\">&nbsp;&nbsp;, {{li.aliasNm}}.{{li.colNm}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;FROM {{vc.tbMain.tableNm}} {{vc.tbMain.aliasNm}}</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&nbsp;&nbsp;&lt;/select&gt;</span><br><span>&nbsp;&nbsp;&lt;insert id=\"insert{{vc.tbMain.tableNm}}\" parameterType=\"map\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;selectKey keyProperty=\"RelateDataId\" resultType=\"java.lang.String\" order=\"BEFORE\"&gt;<br><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SELECT conv(FLOOR(100000000000000 + RAND() * 899999999999999), 10, 36) AS RelateDataId<br><span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/selectKey&gt;<br><br><span>&nbsp;&nbsp;&nbsp;&nbsp;INSERT INTO {{vc.tbMain.tableNm}} </span><span>&nbsp;&nbsp;&nbsp;&nbsp;(</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.selectType == \'m\' && li.checkedYn && li.colNm.toLowerCase() != \'edtdate\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'edtuser\' && li.colNm.toLowerCase() != \'deluser\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0\">&lt;if test=\'RelateDataId != null\'&gt;&nbsp;&nbsp;{{li.colNm}}&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType != \'bigint\' && li.colNm.toLowerCase() != \'delyn\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;, {{li.colNm}}&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType == \'bigint\' && li.colNm.toLowerCase() != \'delyn\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;, {{li.colNm}}&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'delyn\'\">, {{li.colNm}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;) VALUES (</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.selectType == \'m\' && li.checkedYn && li.colNm.toLowerCase() != \'edtdate\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'edtuser\' && li.colNm.toLowerCase() != \'deluser\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0\">&lt;if test=\'RelateDataId != null\'&gt;&nbsp;&nbsp;CONV(#{RelateDataId}, 36, 10)&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType != \'bigint\' && li.colNm.toLowerCase() != \'delyn\' && li.colNm.toLowerCase() != \'regdate\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;,#{ {{li.colNm}} }&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType == \'bigint\' && li.colNm.toLowerCase() != \'reguser\' && li.colNm.toLowerCase() != \'tenantid\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;,CONV(#{ {{li.colNm}} }, 36, 10)&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'regdate\'\">, NOW() </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'reguser\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;,CONV(#{ SESSION_USERID }, 36, 10)&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'delyn\'\">, \'N\' </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'tenantid\'\">, conv(#{ srchTenantId }, 36, 10)</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;)</span> <span>&nbsp;&nbsp;&lt;/insert&gt;</span><br><!-- <set>\r\n              <if test=\'CustId != null\'>CustId = CONV(#{CustId}, 36, 10),</if>\r\n              <if test=\'CustNm != null\'>CustNm = #{CustNm},</if>\r\n              <if test=\'AprvStatus != null\'>AprvStatus = #{AprvStatus},</if>\r\n              <if test=\'PurchDate != null\'>PurchDate = #{PurchDate},</if>\r\n              <if test=\'SalesType != null\'>SalesType = #{SalesType},</if>\r\n              <if test=\'PurchType != null\'>PurchType = #{PurchType},</if>\r\n              <if test=\'CareTktId != null\'>CareTktId = CONV(#{CareTktId}, 36, 10),</if>\r\n              <if test=\'CareTktQty != null\'>CareTktQty = #{CareTktQty},</if>\r\n              <if test=\'CareTktUnitPrc != null\'>CareTktUnitPrc = #{CareTktUnitPrc},</if>\r\n              <if test=\'CareTktAmt != null\'>CareTktAmt = #{CareTktAmt},</if>\r\n              <if test=\'ProductId != null\'>ProductId = #{ProductId},</if>\r\n              <if test=\'ProductQty != null\'>ProductQty = #{ProductQty},</if>\r\n              <if test=\'ProductUnitPrc != null\'>ProductUnitPrc = #{ProductUnitPrc},</if>\r\n              <if test=\'ProductAmt != null\'>ProductAmt = #{ProductAmt},</if>\r\n              <if test=\'SellType != null\'>SellType = #{SellType},</if>\r\n              <if test=\'Cntct != null\'>Cntct = #{Cntct},</if>\r\n              <if test=\'InflowPath != null\'>InflowPath = #{InflowPath},</if>\r\n              <if test=\'PayMeth != null\'>PayMeth = #{PayMeth},</if>\r\n              <if test=\'SellerId != null\'>SellerId = CONV(#{SellerId}, 36, 10),</if>\r\n              <if test=\'SptUserId != null\'>SptUserId = CONV(#{SptUserId}, 36, 10),</if>\r\n              <if test=\'ProductBarCdNo != null\'>ProductBarCdNo = #{ProductBarCdNo},</if>\r\n              <if test=\'PayAprvNo != null\'>PayAprvNo = #{PayAprvNo},</if>\r\n              <if test=\'CardNo4Digits != null\'>CardNo4Digits = #{CardNo4Digits},</if>\r\n              <if test=\'SESSION_SYSADMIN == \"Y\" and TenantId != null and TenantId != \"\"\'>\r\n                  TenantId = conv(#{TenantId}, 36, 10),\r\n              </if>\r\n              EdtDate = CURRENT_TIMESTAMP,\r\n              EdtUser = CONV(#{SESSION_USERID}, 36, 10)\r\n          </set> --> <span>&nbsp;&nbsp;&lt;update id=\"update{{vc.tbMain.tableNm}}\" parameterType=\"map\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;UPDATE {{vc.tbMain.tableNm}}</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;set></span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.selectType == \'m\' && li.checkedYn && li.colNm.toLowerCase() != \'regdate\' && li.colNm.toLowerCase() != \'reguser\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"li.dataType == \'bigint\' && li.colNm.toLowerCase() != \'tenantid\'\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'>{{li.colNm}} = CONV(#{ {{li.colNm}} }, 36, 10),&lt;/if> </span><span style=\"display: inline-block\" ng-if=\"li.dataType != \'bigint\' && li.colNm.toLowerCase() != \'tenantid\'\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'>{{li.colNm}} = #{ {{li.colNm}} },&lt;/if> </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'tenantid\'\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'>{{li.colNm}} = CONV(#{srchTenantId}, 36, 10),&lt;/if></span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;/set></span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&nbsp;&nbsp;&lt;/update&gt;</span><br><span ng-bind-html=vc.mapperend></span></span></span></span></span></span></div></div></div></div><!-- row --></div><!-- pagecontent --></div>");
$templateCache.put("app/system/mastergradefee-list.html","<div class=\"page page-footable\" ng-controller=\"MasterGradeFeeListCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><h1 class=page-header>마스터 등급 및 수수료 관리</h1></div></div><!-- page content --><div class=pagecontent><form id=form1 name=frmMain><!-- row --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><!--<button class=\"btn btn-default\" ng-click=\"vc.addNew()\">\r\n              <i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}\r\n            </button>--> <button class=\"btn btn-primary\" ng-click=vc.saveListConfirm()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><ul class=\"nav nav-tabs mt-20\"><li ng-class=\"vc.url == \'/tab1\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'/tab1\');\" style=cursor:pointer>오너</a></li><li ng-class=\"vc.url == \'/tab2\' ? \'active\' : \'\'\"><a data-toggle=tab ng-click=\"vc.setChangeTab(\'/tab2\');\" style=cursor:pointer>파트너</a></li></ul><div class=\"panel panel-default\"><div class=\"panel-body collapse in\" id=collapse1><div id=divOwner ng-show=\"vc.url == \'/tab1\'\"><!-- 오너  --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><colgroup><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 5%\"><col style=\"width: 10%\"><col style=\"width: 8%\"><col style=\"width: 8%\"><col style=\"width: 8%\"><col style=\"width: 8%\"><col style=\"width: 8%\"></colgroup><thead><tr><td bgcolor=#f5f5f5 class=tx-center colspan=5><span>승급조건</span></td><td bgcolor=#f5f5f5 class=tx-center colspan=5><span>수수료 포인트</span></td></tr><tr><th bgcolor=#f5f5f5 class=text-center>등급</th><th bgcolor=#f5f5f5 class=text-center>본인 매출금액</th><th bgcolor=#f5f5f5 class=text-center>팀 매출금액</th><th bgcolor=#f5f5f5 class=text-center>하위 마스터<br>인원 수</th><th bgcolor=#f5f5f5 class=text-center>특수조건</th><th bgcolor=#f5f5f5 class=text-center title=\"(본인 주문금액에 %부여)\">본인 파머포인트(OPP)</th><th bgcolor=#f5f5f5 class=text-center title=\"(팀 전체 매출금액에 등급별 %부여)\">팀 파머포인트(TPP)</th><th bgcolor=#f5f5f5 class=text-center title=\"(하위 파머 모집시 초도 제품에 대한 %부여)\">초도 매출 파머포인트(FPP)</th><th bgcolor=#f5f5f5 class=text-center title=\"(등급별 구분없음)\">샵 매출(일반판매)<br>파머포인트(TPP)</th><th bgcolor=#f5f5f5 class=text-center title=\"(등급별 구분없음)\">샵 매출(관리권)<br>파머포인트(TPP)</th></tr></thead><tr my-directive ng-repeat=\"li in vc.listsOwner\" style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.UserGradeNm></span></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma ng-model=li.OwnerSalesAmt type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma ng-model=li.TeamSalesAmt type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma ng-model=li.SubMasterCnt type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" maxlength=1000 ng-model=li.SpclCnd type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma maxlength=3 ng-model=li.OppFee type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma maxlength=3 ng-model=li.TppFee type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma maxlength=3 ng-model=li.FppFee type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma maxlength=3 ng-model=li.SppGenFee type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma maxlength=3 ng-model=li.SppMngFee type=text></td></tr></table></div><div id=divPartner ng-show=\"vc.url == \'/tab2\'\"><!-- 파트너 --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><colgroup><col style=\"width: 10%\"><col style=\"width: 30%\"><col style=\"width: 60%\"></colgroup><thead><tr><th bgcolor=#f5f5f5 class=text-center>등급</th><th bgcolor=#f5f5f5 class=text-center>보유 고객수</th><th bgcolor=#f5f5f5 class=text-center>보유 고객 매출금액</th></tr></thead><tr my-directive ng-repeat=\"li in vc.listsPartner\" style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.UserGradeNm></span></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma ng-model=li.HoldCustCnt type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma ng-model=li.HoldCustSalesAmt type=text></td></tr></table></div></div></div></div></div><!-- row --></form></div><!-- /page content --></div>");
$templateCache.put("app/system/menu-manage-list.html","<style>.left-context, .right-context {\r\n  padding-top:5px;\r\n}\r\n\r\n.left-context .panel-body{\r\n  background:#e7edf3;\r\n}\r\n.left-context .panel-default {\r\n  margin-top:0px;\r\n  margin-bottom:0px;\r\n}\r\n.left-context .no-style {padding:0px; border:none;}\r\n.as-sortable-item {\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  /* to disable context menu on iOS devices */\r\n  -webkit-touch-callout: none;\r\n  /* margin-top: 2px; */\r\n  position:relative;\r\n}\r\n.as-sortable-item, .as-sortable-placeholder {\r\n    display: block;\r\n}\r\n.as-sortable-item-text {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 6px 0px 6px 6px;\r\n}\r\n.as-sortable-item-handle {\r\n    cursor: move;\r\n    cursor: -webkit-grab;\r\n    cursor: -moz-grab;\r\n}\r\n.subTextmenu {\r\n  position: absolute;\r\n  right: 7px;\r\n  top: 7px;\r\n  font-size: 12px;\r\n  color : #bdbdbd;\r\n  display: none;\r\n}\r\n.subTextmenu span:hover {\r\n  color: #378AD8\r\n}\r\n.as-sortable-placeholder {}\r\n.as-sortable-drag {\r\n    position: absolute;\r\n    pointer-events: none;\r\n    z-index: 9999;\r\n}\r\n.as-sortable-hidden {\r\n    display: none !important;\r\n}\r\n.as-sortable-un-selectable {\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -khtml-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n.left-context *:focus {\r\n    outline: none;\r\n}\r\n#sortableOptions1 {\r\n  padding:5px;\r\n}\r\n.edit-layout {\r\n  display: none;\r\n  position:relative;\r\n  border: solid 1px #c5cdd7;\r\n  padding : 4px 0px 4px 15px;\r\n}\r\n.edit-layout input {\r\n  width: 100%;\r\n  padding : 4px 0px 4px 3px;\r\n  border : solid 1px #d8d8d8;\r\n}\r\n.edit-layout input:focus {\r\n  border : solid 1px #64aef8;\r\n}\r\n.edit-layout .subBtnWrap {\r\n  position:absolute;\r\n  right : 3px;\r\n  top : 9px;\r\n}\r\n.edit-layout .subBtnWrap span {\r\n  color : #999;\r\n  border: solid 1px #ccc;\r\n  padding:5px 10px 5px 10px;\r\n}\r\n.edit-layout .subBtnWrap span.okBtn {\r\n  border: solid 1px #EC5621;\r\n  background : #EC5621;\r\n  color : #FFF;\r\n}\r\n.edit-layout .subBtnWrap span.disable {\r\n  color : #ccc;\r\n  border: solid 1px #eee;\r\n  background : #EEE;\r\n}\r\n\r\n.importantHidden {display: none !important;}\r\n\r\n#iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n\r\n.disable-master {\r\n  background:#c9c9c9 !important;\r\n  color :#999;\r\n}\r\n\r\n.right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n\r\n.depth-two {display: none;}\r\n.depth-three {display: none;}\r\n\r\n\r\n.right-panel-fixed-size-top {\r\n  position:fixed;\r\n  top: 60px;\r\n  padding-right:15px !important;\r\n}\r\n\r\n.right-panel-fixed-size-bottom {\r\n  position:fixed;\r\n  bottom: 0px;\r\n  padding-right:15px !important;\r\n  bottom:0px;\r\n}\r\n\r\n.visible-use-group {\r\n  background:#FFF  !important;\r\n}\r\n.visible-group {\r\n  /* background:#c6e2ff  !important; */\r\n}\r\n\r\n.visible-group .as-sortable-item-text {\r\n  background:#c6e2ff  !important;\r\n  display: block;\r\n}\r\n\r\n.invisible-group {\r\n  display: none !important;\r\n}\r\n\r\n.visible {\r\n  display:block;\r\n}\r\n\r\n#mapperWrap input {\r\n  border: solid 1px #d8d8d8;\r\n  padding : 3px 8px;\r\n  width: 100%;\r\n}\r\n\r\n#roleTable input[type=text] {\r\n  border: solid 1px #d8d8d8;\r\n  padding : 3px 8px;\r\n  width: 100%;\r\n}\r\n\r\n#conditionsTable input[type=text] {\r\n  border: solid 1px #d8d8d8;\r\n  padding : 3px 8px;\r\n  width: 100%;\r\n}\r\n\r\n.menu-name-tx {cursor:pointer;}\r\n.depth-three i {cursor:pointer;}\r\n\r\n.noti-pre {\r\n  border:solid 1px #EEE;\r\n  margin-top:8px;\r\n  background:#EEE;\r\n  padding: 8px;\r\n}\r\n\r\n.noti-pre span {\r\n  display:block;\r\n}</style><div ng-controller=\"MenuManageCtrl as vc\" class=menuManageView><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><h1 class=page-header>메뉴 관리</h1></div></div><div class=row><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-4 col-xl-3 left-context\"><div class=panel-default><div class=panel-body id=sortableOptions style=\"padding:3px 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-if=vc.SysAdmin style=\"padding: 0 3px\"><select class=form-control ng-model=vc.selectedGroupOptions ng-options=\"option.commonCodeId as option.codeNm for option in vc.radioMenuType\" ng-change=vc.onChamgeGroupView(vc.selectedGroupOptions)><option value=\"\">전체메뉴</option></select></div><div id=sortableContainer><!-- as-sortable : is-disabled=\"true\" --><div class=\"sortable-row col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=\"padding: 0 3px\" as-sortable=vc.sortableOptions ng-model=vc.menuList><div style=background:#FFF ng-mouseover=\"vc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"vc.hiddenSubMenu(\'menutreeTopSubMenu\')\"><div is-disabled=false class=as-sortable-item-text>{{ vc.menuTitle }}<div class=subTextmenu style=\"color:#378adb; top:7px\" id=menutreeTopSubMenu><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-click=\"vc.addChild(0,\'menutreeTopSubMenu\')\">추가</span></div></div></div></div><!-- Start Menu Tree --><div ng-repeat=\"item in vc.menuList\" as-sortable-item=vc.sortableOptions style=\"padding:0px; border:none; margin-left:15px\" class={{item.extendGroupClass}}><div as-sortable-item-handle=\"\"><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=vc.setDetailView(item) ng-mouseover=\"vc.showSubMenu(\'subMenu_\'+item.menuId)\" ng-mouseleave=\"vc.hiddenSubMenu(\'subMenu_\'+item.menuId)\" menu-sort={{item.sort}} menu-sortpath={{item.sortPath}} ng-if=\"item.delYn!=\'Y\'\" id=\"{{\'atMenu_\' + item.menuId }}\"><i class=\"fa fa-fw fa-plus extend-btn\" ng-if=\"item.child.length > 0\" ng-click=\"vc.extendMenu(\'atMenu_\' + item.menuId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item.child.length == 0\"></i> <i class=\"fa fa-fw {{ item.icon }}\"></i> <span class=menu-name-tx>{{item.menuNm}}</span><div class=subTextmenu id=subMenu_{{item.menuId}} menu-sort={{item.sort}} menu-sortpath={{item.sortPath}}><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-if=\"item.useYn == \'\' || item.useYn == \'N\'\" ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>활성 | </span><span ng-if=\"item.useYn == \'Y\'\" ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>비활성 | </span><span ng-click=\"vc.addChild(1, item.menuId)\">추가</span> | <span ng-click=\"vc.delChild(1, item)\">삭제</span></div><div ng-if=\"vc.SysAdmin && vc.viewMode == \'T\'\"><div ng-if=\"item.useYn == \'N\'\"><span ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>활성</span></div><div ng-if=\"item.useYn == \'Y\'\"><span ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>비활성</span></div></div><!-- <span ng-click=\"vc.editChild(1, item)\">Edit</span> --></div></div></div><div class=sortable-row as-sortable=vc.sortableOptions ng-model=item.child style=margin-left:15px><div ng-repeat=\"item2 in item.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF><div class=\"as-sortable-item-text {{item2.disableClass}} depth-two\" style=background:#FFF ng-click=vc.setDetailView(item2) ng-mouseover=\"vc.showSubMenu(\'subMenu_\'+item2.menuId)\" ng-mouseleave=\"vc.hiddenSubMenu(\'subMenu_\'+item2.menuId)\" menu-sort={{item2.sort}} menu-sortpath={{item2.sortPath}} ng-if=\"item2.delYn!=\'Y\'\" id=\"{{\'atMenu_\' + item2.menuId }}\"><i class=\"fa fa-fw fa-plus extend-btn\" ng-if=\"item2.child.length > 0\" ng-click=\"vc.extendMenu(\'atMenu_\' + item2.menuId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item2.child.length == 0\"></i> <i class=\"fa fa-fw {{ item2.icon }}\"></i> <span class=menu-name-tx>{{item2.menuNm}}</span><div class=subTextmenu id=subMenu_{{item2.menuId}} menu-sort={{item2.sort}} menu-sortpath={{item2.sortPath}}><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-if=\"item2.useYn == \'\' || item2.useYn == \'N\'\" ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>활성 | </span><span ng-if=\"item2.useYn == \'Y\'\" ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>비활성 | </span><span ng-click=\"vc.addChild(2, item2.menuId)\">추가</span> | <span ng-click=\"vc.delChild(2, item2)\">삭제</span></div><div ng-if=\"vc.SysAdmin && vc.viewMode == \'T\'\"><div ng-if=\"item2.useYn == \'N\'\"><span ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>활성</span></div><div ng-if=\"item2.useYn == \'Y\'\"><span ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>비활성</span></div></div><!-- <span ng-click=\"vc.editChild(2, item2)\">Edit</span> --></div></div></div><div class=sortable-row as-sortable=vc.sortableOptions ng-model=item2.child style=margin-left:30px><div ng-repeat=\"item3 in item2.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF ng-click=vc.setDetailView(item3) ng-mouseover=\"vc.showSubMenu(\'subMenu_\'+item3.menuId)\" ng-mouseleave=\"vc.hiddenSubMenu(\'subMenu_\'+item3.menuId)\" menu-sort={{item3.sort}} menu-sortpath={{item3.sortPath}} ng-if=\"item3.delYn!=\'Y\'\"><div class=\"as-sortable-item-text {{item3.disableClass}} depth-three\" id=\"{{\'atMenu_\' + item3.menuId }}\"><i class=\"fa fa-fw {{ item3.icon }}\"></i> <span class=menu-name-tx>{{item3.menuNm}}</span><div class=subTextmenu id=subMenu_{{item3.menuId}} menu-sort={{item3.sort}} menu-sortpath={{item3.sortPath}}><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-if=\"item3.useYn == \'\' || item3.useYn == \'N\'\" ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>활성 | </span><span ng-if=\"item3.useYn == \'Y\'\" ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>비활성 | </span><span ng-click=\"vc.delChild(3, item3)\">삭제</span></div><div ng-if=\"vc.SysAdmin && vc.viewMode == \'T\'\"><div ng-if=\"item3.useYn == \'N\'\"><span ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>활성</span></div><div ng-if=\"item3.useYn == \'Y\'\"><span ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>비활성</span></div></div><!-- <span ng-click=\"vc.editChild(3, item3)\">Edit</span> --></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item2.menuId}} menu-path={{item2.path}} menu-sort={{item2.sort}} menu-sortpath={{item2.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=vc.menuTitleChange() ng-model=vc.depth03title input-enter=\"vc.addMenuItem(3, \'editor\'+item2.menuId))\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=cancelBtn ng-click=\"vc.cancelMenuItem(3, \'editor\'+item2.menuId)\">취소</span> <span class=\"okBtn disable\" ng-click=\"vc.addMenuItem(3, \'editor\'+item2.menuId)\">확인</span></div><div style=clear:both></div></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item.menuId}} menu-path={{item.path}} menu-sort={{item.sort}} menu-sortpath={{item.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=vc.menuTitleChange() ng-model=vc.depth02title input-enter=\"vc.addMenuItem(2, \'editor\'+item.menuId))\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=cancelBtn ng-click=\"vc.cancelMenuItem(2, \'editor\'+item.menuId)\">취소</span> <span class=\"okBtn disable\" ng-click=\"vc.addMenuItem(2, \'editor\'+item.menuId)\">확인</span></div><div style=clear:both></div></div></div></div></div><div><div class=edit-layout style=\"background:#FFF; margin-left:15px\" id=editorDepth01><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=vc.menuTitleChange() ng-model=vc.depth01title input-enter=\"vc.addMenuItem(1, \'editorDepth01\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=cancelBtn ng-click=\"vc.cancelMenuItem(1, \'editorDepth01\')\">취소</span> <span class=\"okBtn disable\" ng-click=\"vc.addMenuItem(1, \'editorDepth01\')\">확인</span></div><div style=clear:both></div></div></div><!-- End Menu Tree --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding: 0px\"><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.setChangeMenuList(); style=\"width:100%; margin-top:6px; height:35px\"><i class=\"fa fa-edit\"></i> 리스트 순서 변경</button></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-7 col-md-6 col-lg-8 col-xl-9 right-context\"><div class=\"panel panel-default\" style=border:none><div class=\"panel-body root-panel-body\" style=padding:0px><ul class=\"nav nav-tabs\"><li class=active><a ng-click=vc.setChangeTab(0); data-toggle=tab style=\"cursor: pointer\">기본정보</a></li><li><a ng-click=vc.setChangeTab(1); data-toggle=tab style=\"cursor: pointer\">권한정보</a></li></ul><div class=tab-content><!-- Start First Tab Content --><div class=\"tab-pane fade {{ vc.showTabView[0] }}\"><!-- Start 메뉴그룹 --><div class=row ng-if=\"vc.SysAdmin \"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>메뉴그룹</div><div class=panel-body style=padding:8px><!-- Start Body --><div class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><label class=\"radio-inline pl-0 pr-15\" ng-repeat=\"mt in vc.radioMenuType\"><input type=checkbox class=clr ng-model=mt.checked ng-disabled=\"vc.mSrchTenentID != \'0\'\"> {{ mt.codeNm}}</label></div><!-- End Body --></div></div></div></div><!-- End 메뉴그룹 --><!-- Start 메뉴정보 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>메뉴정보</div><div class=panel-body><!-- Start Body --><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-4 col-xl-4\"><div class=form-group><label class=ng-binding>메뉴명</label><div><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vc.menuInfo.menuNm aria-invalid=false></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-4 col-xl-4\" ng-if=vc.SysAdmin><div class=form-group><label class=ng-binding>다국어 키</label><div><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vc.menuInfo.translateCode aria-invalid=false></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-4 col-xl-4\" ng-if=vc.menuInfo.levelYn><div class=form-group><label class=ng-binding>접근권한등급</label><div><select class=form-control ng-model=vc.menuInfo.roleLevel ng-options=\"option.commonCodeId as option.codeNm for option in vc.roleLevelList\"><option value=\"\">권한등급</option></select></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-if=vc.menuInfo.levelYn><div class=noti-pre><span>* 접근권한등급이 Level 0일 경우 권한정보에 영향을 받지않고 활성화 됩니다.</span> <span>* 접근권한등급이 지정되지 않을경우 사용자의 기본 등급인 1의 값으로 설정됩니다.</span></div></div><!-- End Body --></div></div></div></div><!-- End 메뉴정보 --><!-- Start 연관페이지 --><div class=row ng-if=\"vc.SysAdmin  && vc.mSrchTenentID == 0\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>연관페이지</div><div class=panel-body><!-- Start Body --><table id=searchTextResults class=\"table table-custom minWidth-1200\"><thead><tr><th data-toggle=true class=tx-center style=width:50px>메인</th><th data-toggle=true class=tx-center>페이지명</th><th data-toggle=true class=tx-center>페이지URL</th><th data-toggle=true class=tx-center ng-if=\"vc.viewMode == \'A\'\">매개변수</th><th data-toggle=true class=tx-center>새창여부</th><th data-toggle=true class=tx-center ng-if=\"vc.viewMode == \'A\'\">삭제</th></tr></thead><tbody ng-if=vc.menuInfo.pages><tr ng-repeat=\"li in vc.menuInfo.pages\" style=\"cursor: pointer\"><td class=text-center><div class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=margin-top:-8px><label class=radio-inline><input type=radio name=pageMain id=page ng-model=li.mainYn value={{$index}} ng-checked=\"li.mainYn == \'Y\'\"></label></div></td><td class=text-center><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=li.screenNm aria-invalid=false></td><td class=text-left><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=li.pageUrl aria-invalid=false></td><td class=text-left ng-if=\"vc.viewMode == \'A\'\"><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=li.pageUrlParam aria-invalid=false></td><td class=tx-center><select class=form-control ng-model=li.newWindowYn ng-options=\"option.value as option.codeNm for option in vc.selectNewWindowYn\" ng-change=vc.onChangeNewWindowYn(li)></select></td><td class=tx-center ng-if=\"vc.viewMode == \'A\'\"><span ng-if=\"li.delYn == \'N\'\" ng-click=\"vc.delPage(li, $index)\">삭제</span> <span ng-if=\"li.delYn == \'Y\'\" ng-click=\"vc.delPage(li, $index)\">취소</span></td></tr></tbody><tbody ng-if=\"vc.menuInfo.length == 0 || vc.menuInfo.pages.length == 0\"><tr><td colspan=6 class=tx-center style=padding:8px>연관페이지가 있을 경우 등록하세요.</td></tr></tbody></table><!-- End Body --></div><div class=\"panel-footer tx-right\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addPage()><i class=\"fa fa-edit\"></i> 페이지 추가</button></div></div></div></div><!-- End 연관페이지 --><!-- Start 연관설문 --><div class=row ng-if=\"vc.SysAdmin  && vc.mSrchTenentID == 0 && vc.mobileOnlyYN == \'Y\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>연관설문</div><div class=panel-body><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.menuSvyChkHead ng-change=menuSvyChkHeadChg()></th><th class=\"text-center none\" style=width:10%>제목</th><th class=\"text-center none\" style=width:10%>구분</th><th class=\"text-center none\" style=width:10%>통과점수</th><th class=\"text-center none\" style=width:10%>신규가입표시여부</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.menuSvyTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan=5>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.menuSvyLists\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.menuSvyChkRow ng-change=menuSvyChkRowChg()></td><td class=text-center style=vertical-align:middle>{{li.SvyNm}}</td><td class=text-center style=vertical-align:middle>{{li.SvyType_}}</td><td class=text-center style=vertical-align:middle>{{li.PassScore}}</td><td class=text-center style=vertical-align:middle>{{li.JoinShowYN}}</td></tr></table></div><div class=\"panel-footer tx-right\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addMenuSvyModal()><i class=\"fa fa-edit\"></i> 설문 추가</button> <button class=\"btn btn-danger\" ng-click=vc.deleteMenuSvyList()><i class=\"fa fa-trash-o\"></i> 설문 삭제</button></div></div></div></div><!-- End 연관설문 --><!-- Start 아이콘 --><div class=row id=iconWrap><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>아이콘 <a href=http://fa2png.io/r/font-awesome/ target=_blank><i class=\"fa fa-info\"></i></a></div><div class=panel-body><!-- Start Body --><div ng-repeat=\"item in vc.fontList\" class=\"col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-3 {{item.active}}\"><span ng-click=vc.setChangeIcon(item.name);><i class=\"fa {{ item.name }}\"></i> {{item.name}}</span></div><!-- End Body --></div><div class=panel-footer ng-if=vc.SysAdmin><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-6 col-xl-5\" style=\"padding-top:3px; padding-right:0px\"><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vc.addInputFa aria-invalid=false></div><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1\" style=padding-top:3px><i id=viewFontIcon class=\"fa {{vc.addInputFa}}\" style=font-size:30px></i></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-6 tx-right\" style=\"padding-top:3px; padding-right:3px\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.setFa()><i class=\"fa fa-edit\"></i> Font Awesome 추가</button></div><div style=clear:both></div></div></div></div></div><!-- End 아이콘 --><!-- Start 메모 --><div class=row id=iconWrap><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>메뉴 설명</div><div class=panel-body><textarea class=form-control row=3 cols=50 ng-model=vc.menuInfo.remark></textarea></div></div></div></div><!-- End 메모 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=margin-top:8px><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.invalidBaseInfo()><i class=\"fa fa-edit\"></i> 저장</button></div></div><!-- End First Tab Content --></div><div class=\"tab-pane fade {{ vc.showTabView[1] }}\"><!-- Start 연관페이지 선택 --><div class=row ng-if=vc.SysAdmin><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>연관 페이지 선택</div><div class=panel-body><!-- Start Body --><div class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><label class=radio-inline ng-repeat=\"pi in vc.menuInfo.pages\"><input type=radio name=optionMenuType id=tenantPageType ng-model=pi.choicePage value={{pi.menuPageId}} ng-click=vc.loadPageData(pi)> {{ pi.screenNm}}({{ pi.pageUrl}})</label></div><!-- End Body --></div></div></div></div><!-- END 연관페이지 선택 --><!-- Start SQLMapper 관리 --><div class=row ng-if=\"vc.SysAdmin  && vc.mSrchTenentID == 0\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>SQL Mapper 관리</div><div class=panel-body><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding-top:3px; padding-right:3px\" ng-if=\"vc.choiceRolePage != \'\'\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.getLoadSqlMapper()><i class=\"fa fa-edit\"></i> File 불러오기</button> <button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addSqlMapper()><i class=\"fa fa-edit\"></i> Mapper 추가</button></div><table class=\"footable table\" id=mapperWrap><thead><tr><th class=tx-center>SQLMapper</th><th class=tx-center style=width:80px>사용여부</th><th class=tx-center style=width:80px>삭제</th></tr></thead><tbody><tr ng-repeat=\"li in vc.rolesInfo.sqlMapper\"><td class=text-left style=padding-left:5px><input type=text ng-model=li.sqlCode></td><td class=text-center><input type=checkbox ng-model=li.useYn></td><td class=text-center><span ng-if=\"li.delYn == \'N\'\" ng-click=\"li.delYn = \'Y\'\">삭제</span> <span ng-if=\"li.delYn == \'Y\'\" ng-click=\"li.delYn = \'N\'\">취소</span></td></tr></tbody></table><div class=noti-pre>* 페이지 추가 : 해당 페이지의 ctrl.js 파일을 로드시 postApi로 지정된 SqlMapper를 불러올 수 있습니다.</div><!-- Start Body --><!-- End Body --></div></div></div></div><!-- END SQLMapper 관리 --><!-- Start 프로그램 관리 --><div class=row ng-if=\"vc.SysAdmin && vc.mSrchTenentID == 0\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>상세조건 관리</div><div class=panel-body><!-- Start Body --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding-top:3px; padding-right:3px\" ng-if=\"vc.choiceRolePage != \'\'\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addCondition()><i class=\"fa fa-edit\"></i> 조건 추가히기</button></div><table id=conditionsTable class=\"footable table table-custom\"><thead><tr><th data-toggle=true class=tx-center style=width:30%>조건</th><th data-toggle=true class=tx-center style=width:30%>비교값</th><th data-toggle=true class=tx-center style=width:30%>패스여부</th><th data-toggle=true class=tx-center style=width:30%>삭제</th></tr></thead><tbody><tr ng-repeat=\"li in vc.rolesInfo.conditions\" style=\"cursor: pointer\"><td class=text-center><input type=text ng-model=li.condition></td><td class=text-center><input type=text ng-model=li.value></td><td class=text-center><input type=checkbox ng-model=li.useYn></td><td class=text-center><span ng-if=\"li.delYn == \'N\'\" ng-click=\"li.delYn = \'Y\'\">삭제</span> <span ng-if=\"li.delYn == \'Y\'\" ng-click=\"li.delYn = \'N\'\">취소</span></td></tr></tbody></table><div class=noti-pre><span>* \'조건 = 비교값\' 혹은 \'조건 ≠ 비교값\' 의 설정은 패스여부의 체크박스를 통하여 수정할 수 있습니다.</span> <span>* SESSION, srchTenantId 혹은 기타 전달 값을 통하여 비교연산을 하실 수 있습니다.</span></div><!-- End Body --></div></div></div></div><!-- END 프로그램 관리 --><!-- Start 역할관리 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>화면권한관리</div><div class=panel-body><!-- Start Body --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding-top:3px; padding-right:3px\" ng-if=\"vc.choiceRolePage != \'\'\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.setChangeEdtLabel()><i class=\"fa fa-edit\"></i> {{vc.checkEdtLabelText}}</button></div><table id=roleTable class=\"footable table table-custom\" style=\"table-layout: fixed\"><thead><tr><th class=tx-center>역할명</th><th class=tx-center>조회</th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn01Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn01Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn02Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn02Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn03Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn03Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn04Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn04Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn05Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn05Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn06Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn06Text ng-if=vc.checkEdtLabel></th></tr></thead><tbody><tr ng-repeat=\"li in vc.rolesInfo.screen\"><td class=text-left><span>{{li.RoleNm}}</span></td><td class=text-center><input type=checkbox ng-model=li.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td></tr></tbody></table><!-- End Body --></div></div></div></div><!-- End 역할관리 --><div class=row ng-if=\"vc.choiceRolePage != \'\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=margin-top:8px><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.setRoleData();><i class=\"fa fa-edit\"></i> 저장</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/system/pharmagradefee-list.html","<div class=\"page page-footable\" ng-controller=\"PharmaGradeFeeListCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><h1 class=page-header>파머 등급 및 수수료 관리</h1></div></div><!-- page content --><div class=pagecontent><form id=form1 name=frmMain><!-- row --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><!--<button class=\"btn btn-default\" ng-click=\"vc.addNew()\">\r\n              <i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}\r\n            </button>--> <button class=\"btn btn-primary\" ng-click=vc.saveListConfirm()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>파머 등급 및 수수료</div><div class=\"panel-body collapse in\" id=collapse1><!-- Search Result --><div class=pull-right></div><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><colgroup><col style=\"width: 10%\"><col style=\"width: 20%\"><col style=\"width: 20%\"><col style=\"width: 20%\"><col style=\"width: 20%\"><col style=\"width: 10%\"></colgroup><thead><tr><td bgcolor=#f5f5f5 class=tx-center colspan=3><span>승급조건</span></td><td bgcolor=#f5f5f5 class=tx-center colspan=2><span>수수료 포인트</span></td></tr><tr><th bgcolor=#f5f5f5 class=text-center>등급</th><th bgcolor=#f5f5f5 class=text-center>모집인원(명)</th><th bgcolor=#f5f5f5 class=text-center title=\"(본인과 본인이 모집한 서포터의 총 매출금액)\">그룹 월 매출금액(만원)</th><th bgcolor=#f5f5f5 class=text-center title=\"(본인이 제품 구매시 일정금액 페이백)\">본인 파머포인트(OPP)</th><th bgcolor=#f5f5f5 class=text-center title=\"(본인이 모집한 서포터 총 매출금액에 5%)\">그룹 수수료</th></tr></thead><!-- /Header --><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center><span ng-bind=li.CustGradeNm></span></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma ng-model=li.RcritPersCntStart type=text width=50%> ~ <input class=\"form-control text-right\" comma ng-model=li.RcritPersCntEnd type=text width=50%></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma ng-model=li.GrpSalesAmtStart type=text> ~ <input class=\"form-control text-right\" comma ng-model=li.GrpSalesAmtEnd type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" comma ng-model=li.OPP type=text></td><td class=text-left style=vertical-align:middle><input class=\"form-control text-right\" maxlength=1000 ng-model=li.GrpFee type=text></td></tr></table></div></div></div></div><!-- row --></form></div><!-- /page content --></div>");
$templateCache.put("app/system/role-detail.html","<div class=\"page page-footable\" ng-controller=\"RoleDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.EM630\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleId></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | date:\'yyyy-MM-dd\'}}</div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.MAINPAGE\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.MainPage></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.MAINPAGESRCH\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.MainPageSrch></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.SORTORDER\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Sort></div></div></div><div class=\"col-lg-12 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/role-edit.html","<div class=\"page page-footable\" ng-controller=\"RoleEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.EM630\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-6><div class=form-group><label>{{ \'Menu.EM630DC01\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RoleId readonly></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.EM630DC02\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RoleNm></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.EM630DC03\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RegUserNm readonly></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.EM630DC04\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RegDate readonly></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.MAINPAGE\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.MainPage></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.MAINPAGESRCH\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.MainPageSrch></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.SORTORDER\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Sort></div></div><div class=col-lg-12><div class=form-group><label>{{ \'Menu.REMARKS\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Remark></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/role-list.html","<div class=\"page page-footable\" ng-controller=\"RoleListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ :: \'Menu.EM630\' | translate }}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size=\"40% + 2px\" pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.RoleNm placeholder=\"역할명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.RoleNm type=text><label>{{ :: \'Menu.EM630DT01\' | translate }}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=\"vc.goEdit(\'\')\"><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.EM630\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><!--  <th ng-click=\"vc.tablesort(\'X.RoleId\')\" data-toggle=\"true\" class=\"text-center\">{{ \'Menu.EM630DC01\' | translate }}  <span class=\"{{vc.sortClass(\'X.RoleId\')}}\"></span></th>--><th ng-click=\"vc.tablesort(\'X.RoleNm\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC02\' | translate }} <span class=\"{{vc.sortClass(\'X.RoleNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.RegUserNm\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC03\' | translate }} <span class=\"{{vc.sortClass(\'X.RegUserNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.RegDate\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC04\' | translate }} <span class=\"{{vc.sortClass(\'X.RegDate\')}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goEdit(li.RoleId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':selectedRow == li.RoleId}\"><!-- Result Items --><!-- <td class=\"text-center\"><span ng-bind=\"li.RoleId\"></span></td>--><td class=text-center><span ng-bind=li.RoleNm></span></td><td class=text-center><span ng-bind=li.RegUserNm></span></td><td class=text-center><span>{{li.RegDate | utcToLocal:\'yyyy-MM-dd\'}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/rolescreen-detail.html","<div class=\"page page-footable\" ng-controller=\"RolescreenDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴권한관리</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a>{{ \'Menu.SYSTEM\' | translate }}</a></li><li><a ui-sref=app.system.rolescreen-list>메뉴권한관리</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>메뉴권한관리 {{ \'Menu.DETAIL\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button ui-sref=app.system.rolescreen-list() ng-show=\"vc.stateParams.TenantId != \'\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10\" activate-button ui-sref=\"app.system.rolescreen-edit({TenantId:\'{{vc.stateParams.TenantId}}\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.ID\' | translate }}</label><input type=text class=form-control ng-readonly=\"vc.data.TenantId != \'\'\" ng-model=vc.data.TenantId ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }}{{ \'Menu.NAME\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.PERSONINCHARGE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Contact ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.CEO\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CEO ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.TENANTDIR\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantDir ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label></label><input type=text class=form-control ng-required=true readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.REMARKS\' | translate }}</label><textarea class=form-control row=3 cols=50 ng-model=vc.data.Remark readonly></textarea></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.data.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div></div>");
$templateCache.put("app/system/rolescreen-edit.html","<div class=\"page page-footable\" ng-controller=\"RolescreenEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴권한관리</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a>{{ \'Menu.SYSTEM\' | translate }}</a></li><li><a ui-sref=app.system.rolescreen-list>메뉴권한관리</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm\"><h4 class=custom-font><strong>메뉴권한관리 {{ \'Menu.ADD\' | translate }}/{{ \'Menu.EDIT\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><form id=form ng-submit=vc.setData()><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.rolescreen-list() ng-show=\"vc.stateParams.TenantId != \'\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=submit><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.ID\' | translate }}</label><input type=text class=form-control ng-readonly=\"vc.data.TenantId != \'\'\" ng-model=vc.data.TenantId ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }}{{ \'Menu.NAME\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantNm ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.PERSONINCHARGE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Contact ng-required=true></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.CEO\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CEO ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.TENANTDIR\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantDir ng-required=true></div></div><div class=col-lg-4><div class=form-group><label></label><input type=text class=form-control></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.ATTACHEDFILE\' | translate }} : {{ \'Menu.USERIMAGE\' | translate }} 100 * 130 px [ {{ \'Menu.MAX\' | translate }} 300MB, {{ \'Menu.NO_ENROLLMENT_COUNT\' | translate }}]</label><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div><!-- /tile body --></form></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div></div>");
$templateCache.put("app/system/rolescreen-list.html","<div class=\"page page-footable\" ng-controller=\"RolescreenListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>역할별 화면권한관리</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><div class=dataloader ng-show=vc.dataloader></div><div class=col-lg-12><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.ScreenNm placeholder=\"화면명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><select class=form-control ng-model=vc.srch.role ng-options=\"opt.RoleId as opt.RoleNm for opt in vc.roleList\"><option value=\"\">---- {{ \'Menu.ALL\' | translate }} ----</option></select><label>{{ \'Menu.ROLEGROUP\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ScreenNm type=text><label>{{ \'Menu.SCREENNAME\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.PageUrl type=text><label>프로그램명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.saveList()><i class=\"fa fa-save\"></i> 저장</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-info tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">권한별 화면목록</strong><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\" id=collapse1><div class=row><div class=col-lg-12><table id=searchTextResults class=\"table table-custom table-hover\"><thead><tr><th data-toggle=true class=text-center>{{ \'Menu.ROLEGROUP\' | translate }} {{ \'Menu.NAME\' | translate }}</th><th data-toggle=true class=text-center>메뉴명</th><th data-toggle=true class=text-center>{{ \'Menu.SCREENNAME\' | translate }}</th><th class=text-left><label><input type=checkbox ng-change=\"vc.checkBtn(\'ViewYN\')\" ng-model=vc.checkAllBtn.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">조회</label></th><th class=text-left><label><input type=checkbox ng-change=\"vc.checkBtn(\'Btn01YN\')\" ng-model=vc.checkAllBtn.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button01</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button02</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button03</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button04</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button05</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button06</label></th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><input type=hidden ng-model=li.RoleScrId><td class=text-left><span ng-bind=li.RoleNm></span></td><td class=text-left><span ng-bind=li.MenuNm title={{li.Sort}} ng-if=\"li.MainYN == \'Y\'\" ng-class=\"\'menudepth\' + li.Depth\"></span></td><td class=text-left><span ng-bind=li.ScreenNm title={{li.PageUrl}}></span></td><td class=text-left><input type=checkbox ng-model=li.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-left><label><input type=checkbox ng-model=li.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn01Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn02Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn03Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn04Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn05Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn06Text}}</label></td></tr></tbody></table></div></div></div></div><!-- // table  --></div></div></div></div></div></div>");
$templateCache.put("app/system/screen-detail.html","<div class=\"page page-footable\" ng-controller=\"ScreenDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>메뉴관리 {{ \'Menu.DETAIL\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleId></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | date:\'yyyy-MM-dd\'}}</div></div></div><div class=\"col-lg-12 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div><div class=\"page page-footable\" ng-controller=\"ScreenDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴관리</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a>{{ \'Menu.SYSTEM\' | translate }}</a></li><li><a ui-sref=app.system.screen-list>메뉴관리</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>메뉴관리 {{ \'Menu.DETAIL\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.screen-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.system.screen-edit({ScreenId:\'{{vc.data.ScreenId}}\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>아이디</label><input type=text class=form-control ng-model=vc.data.ScreenId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>구분</label><input type=text class=form-control ng-model=vc.data.ModuleType ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>이름</label><input type=text class=form-control ng-model=vc.data.ScreenNm ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>페이지명</label><input type=text class=form-control ng-model=vc.data.PageFileNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>코드</label><input type=text class=form-control ng-model=vc.data.ScreenCd ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>메뉴구분</label><input type=text class=form-control ng-model=vc.data.ScreenType ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>등록일</label><input type=text class=form-control ng-model=vc.data.RegDate ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>등록자</label><input type=text class=form-control ng-model=vc.data.RegUserNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>수정일</label><input type=text class=form-control ng-model=vc.data.EdtDate ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>수정자</label><input type=text class=form-control ng-model=vc.data.EdtUserNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>메뉴번호</label><input type=text class=form-control ng-model=vc.data.MenuNo ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>아이콘</label><input type=text class=form-control ng-model=vc.data.IconType ng-required=true readonly></div></div></div></div><!-- /tile-body --></div><!-- /title --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/screen-edit.html","<div class=\"page page-footable\" ng-controller=\"ScreenEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>메뉴관리 {{ \'Menu.ADD\' | translate }}/{{ \'Menu.EDIT\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form id=form ng-submit=vc.setData()><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>화면명</label><input type=text class=form-control ng-model=vc.data.ScreenNm ng-required=true></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>페이지명</label><input type=text class=form-control ng-model=vc.data.PageUrl ng-required=true></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>파라메터</label><input type=text class=form-control ng-model=vc.data.PageUrlParam></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>아이콘</label><input type=text class=form-control ng-model=vc.data.IconType></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>SQLMapper</label><input type=text class=form-control ng-model=vc.data.SqlId></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>허용파라메터</label><input type=text class=form-control ng-model=vc.data.ParamPass></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>거부파라메터</label><input type=text class=form-control ng-model=vc.data.ParamRefuse></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button01 설명</label><input type=text class=form-control ng-model=vc.data.Btn01Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button02 설명</label><input type=text class=form-control ng-model=vc.data.Btn02Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button03 설명</label><input type=text class=form-control ng-model=vc.data.Btn03Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button04 설명</label><input type=text class=form-control ng-model=vc.data.Btn04Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button05 설명</label><input type=text class=form-control ng-model=vc.data.Btn05Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button06 설명</label><input type=text class=form-control ng-model=vc.data.Btn06Text></div></div></div><div class=row><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>등록일</label><input type=text class=form-control value=\"{{vc.data.RegDate | date:\'yyyy-MM-dd h:mm a\':\'UTC\'}}\" readonly></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>등록자</label><input type=text class=form-control ng-model=vc.data.RegUserNm readonly></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>수정일</label><input type=text class=form-control value=\"{{vc.data.EdtDate | date:\'yyyy-MM-dd h:mm a\':\'UTC\'}}\" readonly></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>수정자</label><input type=text class=form-control ng-model=vc.data.EdtUserNm readonly></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/screen-list.html","<div class=\"page page-footable\" ng-controller=\"ScreenListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>화면관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.ScreenNm placeholder=\"화면명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ScreenNm type=text><label>{{ \'Menu.SCREENNAME\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.PageUrl type=text><label>프로그램명</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SqlId type=text><label>SQLMapper</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.EM630\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-click=\"vc.tablesort(\'X.ScreenNm\')\" data-toggle=true class=text-center>화면명 <span class=\"{{vc.sortClass(\'X.ScreenNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.PageUrl\')\" data-toggle=true class=text-center>프로그램명 <span class=\"{{vc.sortClass(\'X.PageUrl\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.PageUrlParam\')\" data-toggle=true class=text-center>파라메터 <span class=\"{{vc.sortClass(\'X.PageUrlParam\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.SqlId\')\" data-toggle=true class=text-center>SQLMapper <span class=\"{{vc.sortClass(\'X.SqlId\')}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goEdit(li.ScreenId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':selectedRow == li.ScreenId}\"><!-- Result Items --><td><span ng-bind=li.ScreenNm></span></td><td><span ng-bind=li.PageUrl></span></td><td><span ng-bind=li.PageUrlParam></span></td><td><span ng-bind=li.SqlId></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/seminar-edit-tab1.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div ng-controller=\"SeminarEditTab1Ctrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button><!--             <button class=\"btn btn-danger\" ng-click=\"vc.setDelData()\">\r\n              <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n            </button> --></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>세미나정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SeminarNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SeminarNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'SeminarType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'SeminarType\'].CodeList\" code-model=vc.data.SeminarType></common-code-custom></div></div></div><div class=row><div class=col-sm-12><div class=\"form-group form-inline\"><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SeminarStartDt\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SeminarStartDt = (vc.SeminarStartDt | date: \'yyyy-MM-dd\')\" ng-model=vc.SeminarStartDt ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SeminarEndDt = (vc.SeminarEndDt | date: \'yyyy-MM-dd\')\" ng-model=vc.SeminarEndDt ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Place\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Place></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ApplStartDt\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.ApplStartDt = (vc.ApplStartDt | date: \'yyyy-MM-dd\')\" ng-model=vc.ApplStartDt ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.ApplEndDt = (vc.ApplEndDt | date: \'yyyy-MM-dd\')\" ng-model=vc.ApplEndDt ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'EntryFee\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.EntryFee></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'SvyId\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchSurveyModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseSurvey();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'AtndncPers\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.AtndncPers></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ApplCnt\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.ApplCnt readonly></div></div></div><!-- file upload--><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault2 class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --><!--               <div class=\"row\">\r\n                  <div class=\"form-group\" ng-show=\"vc.srch.editColumns.Contents\">\r\n                    <div class=\"col-sm-12\">\r\n                      <textarea id=\"strHtml\" rows=\"10\" style=\"width: 100%; height: 600px; display: \'none\';\"\r\n                        ng-model=\"vc.data.Contents\"></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div> --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.delData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><script type=text/javascript>var oEditors = [];\r\n\r\n      var sLang = \"en_US\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n      // 추가 글꼴 목록\r\n      //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n\r\n      nhn.husky.EZCreator.createInIFrame({\r\n        oAppRef : oEditors,\r\n        elPlaceHolder : \"strHtml\",\r\n        sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n        htParams : {\r\n          bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n          bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n          bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n          //bSkipXssFilter : true,    // client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n          //aAdditionalFontList : aAdditionalFontSet,   // 추가 글꼴 목록\r\n          fOnBeforeUnload : function() {\r\n            //alert(\"완료!\");\r\n          },\r\n          I18N_LOCALE : sLang\r\n        }, //boolean\r\n        fOnAppLoad : function() {\r\n          //예제 코드\r\n          //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n        },\r\n        fCreator : \"createSEditor2\"\r\n      });</script>");
$templateCache.put("app/system/seminar-edit-tab2.html","<div ng-controller=\"SeminarEditTab2Ctrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div></div></div>");
$templateCache.put("app/system/seminar-edit-tab3.html","<div ng-controller=\"SeminarEditTab3Ctrl as vc\"><!-- Action Buttons --><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 text-right\"><div style=\"padding:10px 0 10px 0\"><label>총 응답수: {{vc.RstCnt}}</label></div></div></div><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12\" id=bar-chart><div class=\"panel panel-default\"><div class=panel-heading>설문응답결과</div><div class=panel-body><div class=row><div class=col-lg-6 ng-repeat=\"li in vc.qstChtLists\"><div class=mb-15><strong>{{li.QstNo}}. {{li.QstSubject}}</strong></div><canvas class=chart-bar chart-data=vc.chtInfo[$index].data chart-labels=vc.chtInfo[$index].labels chart-colors=vc.chtInfo[$index].colors chart-dataset-override=vc.chtInfo[$index].datasetOverride chart-options=vc.chtInfo[$index].options></canvas></div></div></div></div></div></div></div>");
$templateCache.put("app/system/seminar-edit.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"SeminarEditCtrl as vc\"><!-- page content --><div class=pagecontent><ul class=\"nav nav-tabs\"><li ng-class=\"vc.url == \'/tab1\' ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab1\');\" data-toggle=tab>세미나정보</a></li><li ng-class=\"vc.url == \'/tab2\' ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab2\');\" data-toggle=tab>세미나참석자</a></li><li ng-class=\"vc.url == \'/tab3\' ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab3\');\" data-toggle=tab>설문응답결과</a></li></ul><ui-view></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/system/seminar-list.html","<div class=\"page page-footable\" ng-controller=\"SeminarListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>세미나 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SeminarNm placeholder=\"제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'LoginId\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.LoginId type=text><label>{{vc.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.UserNm type=text><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SeminarType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SeminarType\'].CodeList\" code-model=vc.srch.SeminarType></common-code-custom><label>{{vc.columnMap[\'SeminarType\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/survey-edit.html","<div class=\"page page-footable\" ng-controller=\"SurveyEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>설문 등록/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><ul class=\"nav nav-tabs mt-20\"><li ng-class=\"vc.tabId == 1 ? \'active\' : \'\'\"><a ng-click=vc.setChangeTab(1); data-toggle=tab>설문정보</a></li><li ng-class=\"vc.tabId == 2 ? \'active\' : \'\'\" ng-show=\"vc.data.keyId != \'\'\"><a ng-click=vc.setChangeTab(2); data-toggle=tab>문제정보</a></li><li ng-class=\"vc.tabId == 3 ? \'active\' : \'\'\" ng-show=\"vc.data.keyId != \'\' && vc.data.JoinShowYN ==\'N\' && vc.data.SvyType != \'400\'\"><a ng-click=vc.setChangeTab(3); data-toggle=tab>테스트대상자</a></li><li ng-class=\"vc.tabId == 4 ? \'active\' : \'\'\" ng-show=\"vc.data.keyId != \'\'\"><a ng-click=vc.setChangeTab(4); data-toggle=tab>설문응답결과</a></li></ul><div ng-if=\"vc.tabId == 1\"><div class=row><div class=\"col-lg-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData() ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-show=vc.isMaster()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNm maxlength=50></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'SvyType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'SvyType\'].CodeList\" code-model=vc.data.SvyType></common-code-custom></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PassScore\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.PassScore maxlength=3 numbers-hyphen></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'JoinShowYN\'].ColumnLogicalNm | translate}}</label><input type=checkbox ng-model=vc.data.JoinShowYN ng-checked=\"vc.data.JoinShowYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" style=\"width:20px !Important\"></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Remark\'].ColumnLogicalNm | translate }}</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.Remark maxlength=500></textarea></div></div></div></form></div></div></div></div><div class=row><div class=\"col-lg-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData() ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-show=vc.isMaster()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><div ng-if=\"vc.tabId == 2\"><div class=row><div class=\"col-lg-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.addQstModal(\'100\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 객관식추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.addQstModal(\'300\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 주관식추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.addQstModal(\'200\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 다중선택추가</button> <button class=\"btn btn-default\" ng-click=vc.preModal()><i class=\"fa fa-list\"></i> 설문미리보기</button> <button class=\"btn btn-danger\" ng-click=vc.deleteQstList() ng-show=vc.isMaster()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>문제정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-12><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.qstChkHead ng-change=qstChkHeadChg()></th><th class=\"text-center none\" style=width:10%>No</th><th class=\"text-center none\">문제</th><th class=\"text-center none\" style=width:10%>문항갯수</th><th class=\"text-center none\" style=width:10%>유형</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.qstTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan=5>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.qstLists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.qstChkRow ng-change=qstChkRowChg()></td><td class=text-center style=vertical-align:middle ng-click=\"vc.addQstModal(li.QstType, li.KeyId2)\">{{li.QstNo}}</td><td class=text-center style=vertical-align:middle ng-click=\"vc.addQstModal(li.QstType, li.KeyId2)\">{{li.QstSubject}}</td><td class=text-center style=vertical-align:middle ng-click=\"vc.addQstModal(li.QstType, li.KeyId2)\">{{li.QstCnt}}</td><td class=text-center style=vertical-align:middle ng-click=\"vc.addQstModal(li.QstType, li.KeyId2)\">{{li.QstType_}}</td></tr></table></div></div></form></div></div></div></div><div class=row><div class=\"col-lg-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.addQstModal(\'100\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 객관식추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.addQstModal(\'300\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 주관식추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.addQstModal(\'200\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 다중선택추가</button> <button class=\"btn btn-default\" ng-click=vc.preModal()><i class=\"fa fa-list\"></i> 설문미리보기</button> <button class=\"btn btn-danger\" ng-click=vc.deleteQstList() ng-show=vc.isMaster()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><div ng-if=\"vc.tabId == 3\"><div class=row><div class=\"col-lg-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.addTgtModal(\'100\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 마스터추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.addTgtModal(\'200\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 멤버추가</button> <button class=\"btn btn-danger\" ng-click=vc.deleteTgtList() ng-show=vc.isMaster()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>테스트대상자</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-12><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.tgtChkHead ng-change=tgtChkHeadChg()></th><th class=\"text-center none\" style=width:10%>Shop명</th><th class=\"text-center none\" style=width:10%>구분</th><th class=\"text-center none\" style=width:10%>이름</th><th class=\"text-center none\" style=width:10%>연락처</th><th class=\"text-center none\" style=width:10%>등록/입사일자</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.tgtTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan=6>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.tgtLists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.tgtChkRow ng-change=tgtChkRowChg()></td><td class=text-center style=vertical-align:middle>{{li.TenantNm}}</td><td class=text-center style=vertical-align:middle>{{li.TgtType}}</td><td class=text-center style=vertical-align:middle>{{li.TgtNm}}</td><td class=text-center style=vertical-align:middle>{{li.TgtMobile}}</td><td class=text-center style=vertical-align:middle>{{li.TgtBirthday}}</td></tr></table></div></div></form></div></div></div></div><div class=row><div class=\"col-lg-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.addTgtModal(\'100\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 마스터추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.addTgtModal(\'200\', \'\')\" ng-show=vc.isMaster()><i class=\"fa fa-save\"></i> 멤버추가</button> <button class=\"btn btn-danger\" ng-click=vc.deleteTgtList() ng-show=vc.isMaster()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><div ng-if=\"vc.tabId == 4\"><div class=row><div class=\"col-lg-12 text-right\"><div style=\"padding:10px 0 10px 0\"><label>총 응답수: {{vc.RstCnt}}</label></div></div></div><div class=row><div class=col-lg-12 id=bar-chart><div class=\"panel panel-default\"><div class=panel-heading>설문응답결과</div><div class=panel-body><div class=row><div class=col-lg-6 ng-repeat=\"li in vc.qstChtLists\"><div class=mb-15><strong>{{li.QstNo}}. {{li.QstSubject}}</strong></div><canvas class=chart-bar chart-data=vc.chtInfo[$index].data chart-labels=vc.chtInfo[$index].labels chart-colors=vc.chtInfo[$index].colors chart-dataset-override=vc.chtInfo[$index].datasetOverride chart-options=vc.chtInfo[$index].options></canvas></div></div></div></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/survey-list.html","<div class=\"page page-footable\" ng-controller=\"SurveyListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>설문 목록<div class=\"pull-right dock-header-tx\" style=\"word-spacing: -6px\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><i class=\"fa fa-square fa-border\"></i></span> <span ng-click=\"vc.setChangeLayout(\'V\')\"><i class=\"fa fa-columns fa-border\"></i></span> <span ng-click=\"vc.setChangeLayout(\'H\')\"><i class=\"fa fa-columns fa-rotate-270 fa-border\"></i></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-lg-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SvyNm placeholder=\"제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색</div><div class=panel-body><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'SvyNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNm type=text><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=col-lg-12 ng-if=\"vc.columnMap[\'SvyType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SvyType\'].CodeList\" code-model=vc.srch.SvyType></common-code-custom><label>{{vc.columnMap[\'SvyType\'].ColumnLogicalNm | translate}}</label></div></div></div><div class=row><div class=col-lg-12><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div></div></div></div><div class=col-lg-6><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd() ng-show=vc.isMaster()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteList() ng-show=vc.isMaster()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /검색영역 --></form><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-body><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-if=\"liCol.ColumnPhysicalNm != \'SvyType\'\" ng-click=\"vc.setSortColumn(\'T2.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN) && liCol.ColumnPhysicalNm != \'SvyType\'\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T2.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class={{liCol.ListColumnTextAlign}} ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns\" ng-if=\"liCol.ColumnPhysicalNm != \'SvyType\'\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/user-detail.html","<div class=\"page page-footable\" ng-controller=\"UserDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.USER\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.LoginId></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.UserNm></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UserType\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.UserTypeNm></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'DeptNm\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.DeptNm></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TenantNm></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{ \'Menu.ROLEGROUP\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.UserRoleNms></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Mobile></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.TelNo></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Email></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.UseYNNm></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 85px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=\"form-group form-inline\" ng-show=vc.srch.viewColumns.Contents><div class=\"col-sm-12 col-md-12 col-sm-12 col-xs-12\"><span ng-bind-html=vc.data.Contents|htmlString></span></div></div></div><div class=row><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/user-edit-tab1.html","<div ng-controller=\"UserEditTab1Ctrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>사용자정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label><input ng-if=\"vc.data.KeyId != null && vc.data.KeyId != \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId readonly><div class=input-group><input ng-if=\"vc.data.KeyId== null || vc.data.KeyId == \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId maxlength=20> <span class=input-group-btn ng-if=\"vc.data.KeyId == null || vc.data.KeyId == \'\'\"><button class=\"btn btn-default\" ng-click=vc.getIsDupLoginId() type=button><i class=\"glyphicon glyphicon glyphicon-ok\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.UserNm></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=\"$root.gVariable.SysAdminYN == \'Y\'\"><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchTenantModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseTenant();><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"form-group form-inline\" ng-if=\"$root.gVariable.SysAdminYN != \'Y\'\"><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>비밀번호</label><input type=password class=\"form-control form-right\" ng-if=\"vc.srch.keyId != null && vc.srch.keyId != \'\' && vc.srch.keyId != undefined\" maxlength=20 ng-model=vc.data.Password readonly> <input type=password class=\"form-control form-right\" ng-if=\"vc.srch.keyId == null || vc.srch.keyId == \'\' || vc.srch.keyId == undefined\" maxlength=20 ng-model=vc.data.Password required> <input></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>비밀번호 확인</label><input type=password class=\"form-control form-right\" maxlength=20 ng-model=vc.data.Password2 ng-if=\"vc.srch.keyId != null && vc.srch.keyId != \'\' && vc.srch.keyId != undefined\" readonly> <input type=password class=\"form-control form-right\" maxlength=20 ng-model=vc.data.Password2 ng-if=\"vc.srch.keyId == null || vc.srch.keyId == \'\' || vc.srch.keyId == undefined\" required></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-change=vc.getIsDupEmail() maxlength=255 ng-model=vc.data.Email></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label></label><span style=\"color : red\">영문자, 숫자, 특수문자 중 3가지 조합(대소문자 구분함) / 최소 8자 ~ 최대 14자 (띄어쓰기 제외) / 특수문자 !@#$%^&*()-_;:&lt;&gt;,.[]{} 사용 가능<br>동일한 문자(숫자 포함) 3자 이상 연속 금지 ex) aaa, 111 / 연속적으로 증감되는 숫자, 문자 금지 Ex) abc, 123 / 생년월일 숫자와 4자 이상 중복되는 경우 사용불가</span></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-hyphen ng-model=vc.data.TelNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-hyphen ng-model=vc.data.Mobile></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'EmgCntct\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-hyphen ng-model=vc.data.EmgCntct></div></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-9\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BirthDay\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.BirthDay = (vc.BirthDay | date: \'yyyy-MM-dd\')\" ng-model=vc.BirthDay ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=form-group><label ng-repeat=\"li in vc.columnMap[\'LnrSlrType\'].CodeList\"><input type=radio ng-model=vc.data.LnrSlrType value={{li.Code}}>{{li.CodeValue}}</label></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'EntryDt\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.EntryDt = (vc.EntryDt | date: \'yyyy-MM-dd\')\" ng-model=vc.EntryDt ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RetireDt\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.RetireDt = (vc.RetireDt | date: \'yyyy-MM-dd\')\" ng-model=vc.RetireDt ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'WorkStatus\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'WorkStatus\'].CodeList\" code-model=vc.data.WorkStatus></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'WorkStyle\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'WorkStyle\'].CodeList\" code-model=vc.data.WorkStyle></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.data.UseYN></common-code-custom></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>{{ \'Menu.ROLE\' | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.UserRoleNms readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchUserroleModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseUserRole();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- file upload--><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><div class=row ng-show=false><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault2 class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><!-- /row --><!--               <div class=\"row\">\r\n                  <div class=\"form-group\" ng-show=\"vc.srch.editColumns.Contents\">\r\n                    <div class=\"col-sm-12\">\r\n                      <textarea id=\"strHtml\" rows=\"10\" style=\"width: 100%; height: 600px; display: \'none\';\"\r\n                        ng-model=\"vc.data.Contents\"></textarea>\r\n                    </div>\r\n                  </div>\r\n                </div> --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>부가정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'UserGrade\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UserGrade\'].CodeList\" code-model=vc.data.UserGrade></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PreTaxSalary\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=255 comma ng-model=vc.data.PreTaxSalary></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Incntv\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" numbers-only ng-model=vc.data.Incntv></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=form-group><label class=checkbox-inline>근무요일</label><div style=\"padding-left: 20%; position: absolute; display: inline-block\"><label class=ng-binding><input type=checkbox ng-model=vc.data.MonWorkYN ng-checked=\"vc.data.MonWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{vc.columnMap[\'MonWorkYN\'].ColumnLogicalNm | translate }}</label><label class=ng-binding><input type=checkbox ng-model=vc.data.TueWorkYN ng-checked=\"vc.data.TueWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{vc.columnMap[\'TueWorkYN\'].ColumnLogicalNm | translate }}</label><label class=ng-binding><input type=checkbox ng-model=vc.data.WedWorkYN ng-checked=\"vc.data.WedWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{vc.columnMap[\'WedWorkYN\'].ColumnLogicalNm | translate }}</label><label class=ng-binding><input type=checkbox ng-model=vc.data.ThuWorkYN ng-checked=\"vc.data.ThuWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{vc.columnMap[\'ThuWorkYN\'].ColumnLogicalNm | translate }}</label><label class=ng-binding><input type=checkbox ng-model=vc.data.FriWorkYN ng-checked=\"vc.data.FriWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{vc.columnMap[\'FriWorkYN\'].ColumnLogicalNm | translate }}</label><label class=ng-binding><input type=checkbox ng-model=vc.data.SatWorkYN ng-checked=\"vc.data.SatWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{vc.columnMap[\'SatWorkYN\'].ColumnLogicalNm | translate }}</label><label class=ng-binding><input type=checkbox ng-model=vc.data.SunWorkYN ng-checked=\"vc.data.SunWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{vc.columnMap[\'SunWorkYN\'].ColumnLogicalNm | translate }}</label></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'AttendTime\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'AttendTime\'].CodeList\" code-model=vc.data.AttendTime></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'OffWorkTime\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'OffWorkTime\'].CodeList\" code-model=vc.data.OffWorkTime></common-code-custom></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BankNm\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=20 ng-model=vc.data.BankNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'AcctNo\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=20 numbers-hyphen ng-model=vc.data.AcctNo></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RecomendrCd\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.RecomendrCd ng-disabled=\"vc.data.RecomendrCd != null && vc.data.RecomendrCd !=\'\'\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.checkedRecomendrCd() type=button><i class=\"glyphicon glyphicon glyphicon-ok\"></i></button></span></div></div></div><!--승인 버튼 관리자만 가능--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'MyRecomendrCd\'].ColumnLogicalNm | translate }}</label><div class=input-group><button ng-if=\"$root.gVariable.srchTenantId == \'0\' && (vc.data.MyRecomendrCd == null || vc.data.MyRecomendrCd ==\'\')\" class=\"btn btn-default\" ng-click=vc.setCode()><span class=\"glyphicon glyphicon-check\">코드발급</span></button> <input type=text class=\"form-control form-right\" ng-if=\"(vc.data.MyRecomendrCd != null && vc.data.MyRecomendrCd !=\'\') || $root.gVariable.srchTenantId != \'0\' \" maxlength=255 ng-model=vc.data.MyRecomendrCd readonly></div></div></div></div><div class=row><div class=form-group ng-show=vc.srch.editColumns.Contents><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 600px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/system/user-edit-tab2.html","<div ng-controller=\"UserEditTab2Ctrl as vc\"><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div></div></div>");
$templateCache.put("app/system/user-edit-tab3.html","<div ng-controller=\"UserEditTab3Ctrl as vc\"><div class=row><div class=\"col-lg-12 col-lg-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th><th class=text-center style=\"width: 6%\">수수료 계산</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+2}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns\"><span ng-if=\"liCol.InputType ==\'N\'\">{{li[liCol.ColumnPhysicalAsNm] ? (li[liCol.ColumnPhysicalAsNm] | number) : (li[liCol.ColumnPhysicalNm] | number) }}</span><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"liCol.InputType == \'Y\' && liCol.ColumnPhysicalNm == \'StdYm\'\"><div class=form-group><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=vc.options datepicker-mode=vc.datepickerMode is-open=opened ng-model=li[liCol.ColumnPhysicalNm] ng-required=false placeholder=기준월 type=text uib-datepicker-popup={{vc.dateFormat}}> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"liCol.InputType == \'Y\' && liCol.ColumnPhysicalNm == \'EtcSalesAmt\'\"><div class=form-group><input type=text class=\"form-control form-right\" comma ng-model=li[liCol.ColumnPhysicalNm]></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"liCol.InputType == \'Y\' && liCol.ColumnPhysicalNm == \'PayFixFee\'\"><div class=form-group><input type=text class=\"form-control form-right\" comma ng-model=li[liCol.ColumnPhysicalNm]></div></div></td><td style=\"text-align: center\"><button class=\"btn btn-default mt-10 mb-10\" ng-click=vc.getUserFeeCalc(li)><i class=\"fa fa-calculator\"></i> 수수료 계산</button></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div></div></div>");
$templateCache.put("app/system/user-edit.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"UserEditCtrl as vc\"><!-- page content --><div class=pagecontent><ul class=\"nav nav-tabs\"><li ng-class=\"vc.url == \'/tab1\' ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab1\');\" data-toggle=tab>사용자정보</a></li><li ng-class=\"vc.url == \'/tab2\' ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab2\');\" data-toggle=tab>세미나이력</a></li><li ng-class=\"vc.tabId == \'/tab3\' ? \'active\' : \'\'\"><a ng-click=\"vc.setChangeTab(\'tab3\');\" data-toggle=tab>수수료이력</a></li></ul><ui-view></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/system/user-list.html","<div class=\"page page-footable\" ng-controller=\"UserListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ :: \'Menu.USER\' | translate }}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.UserNm placeholder=\"사용자명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'LoginId\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.LoginId type=text><label>{{vc.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.UserNm type=text><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'EntryDtFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EntryDtFrom = (vc.EntryDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.EntryDtFrom ng-required=false placeholder=\"{{vc.columnMap[\'EntryDtFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'EntryDtTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EntryDtTo = (vc.EntryDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.EntryDtTo ng-required=false placeholder=\"{{vc.columnMap[\'EntryDtTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'WorkStyle\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'WorkStyle\'].CodeList\" code-model=vc.srch.WorkStyle></common-code-custom><label>{{vc.columnMap[\'WorkStyle\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UserType\'].CodeList\" code-model=vc.srch.UserType></common-code-custom><label>{{vc.columnMap[\'UserType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'DeptNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.DeptNm readonly type=text><label>{{vc.columnMap[\'DeptNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchDeptModal(); ng-disabled=\"gVariable.TenantId == \'0\'\" type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseDept(); ng-disabled=\"gVariable.TenantId == \'0\'\" type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TelNo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TelNo type=text><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Email type=text><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UseYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.srch.UseYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/analysis.html","<div class=\"page page-footable\" ng-controller=\"AnalysisCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header ng-if=\" ! vc.isReport\">데이터 분석</h3><h3 class=page-header ng-if=vc.isReport>보고서 생성</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right ng-if=\" ! vc.isReport\"><span style=\"font-weight: bold\" ng-if=\"vc.tgtList.length > 0\">[ 분석결과 : {{vc.tgtList.length}} 명 ] </span><button class=\"btn btn-default\" ng-click=\"vc.goTargetList(\'Anal\')\" ng-if=\"vc.tgtList.length > 0\"><i class=\"fa fa-mail-reply\"></i> 대상자 목록</button> <button class=\"btn btn-primary\" ng-click=vc.getTgtData()><i class=\"fa fa-bar-chart-o\"></i> 대상자 분석</button> <button class=\"btn btn-default\" ng-click=\"vc.getFile(\'F\')\"><i class=\"fa fa-file-excel-o\"></i> 분류별 빈도표</button> <button class=\"btn btn-primary\" ng-click=vc.getRespData()><i class=\"fa fa-bar-chart-o\"></i> 응답정보 분석</button> <button class=\"btn btn-default\" ng-click=\"vc.getFile(\'A\')\"><i class=\"fa fa-file-excel-o\"></i> 차트 엑셀</button> <button class=\"btn btn-default\" ng-click=vc.goPage() ng-if=\"vc.srch.SvyIds.length > 0\"><i class=\"fa fa-list\"></i> 뒤로</button></div><div class=pull-right ng-if=vc.isReport><span style=\"font-weight: bold\" ng-if=\"vc.tgtList.length > 0\">[ 분석결과 : {{vc.tgtList.length}} 명 ] </span><button class=\"btn btn-default\" ng-click=\"vc.goTargetList(\'Anal\')\" ng-if=\"vc.tgtList.length > 0\"><i class=\"fa fa-mail-reply\"></i> 대상자 목록</button> <button class=\"btn btn-primary\" ng-click=vc.getTgtData()><i class=\"fa fa-bar-chart-o\"></i> 분석</button> <button class=\"btn btn-primary\" ng-click=\"vc.getFile(\'O\')\"><i class=\"fa fa-file-excel-o\"></i> 생성</button> <button class=\"btn btn-default\" ng-click=vc.goPage() ng-if=\"vc.srch.SvyIds.length > 0\"><i class=\"fa fa-list\"></i> 뒤로</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>공통 분석조건</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>설문제목</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.srchAnal.SvyNms placeholder=\"\" readonly type=text> <span class=\"input-group-btn input-group-btn2\" ng-if=\" ! vc.isReport\"><button class=\"btn btn-default\" ng-click=vc.srchSurveyModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSurvey(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>분류정보</label><div style=\"margin-left:75px; line-height: 25px !Important\"><select class=form-control ng-model=vc.srchAnal.Gender ng-options=\"cd.Code as cd.CodeValue for cd in vc.gdList\" style=\"width:15% !Important; margin:0 !Important\"><option value=\"\">성별 전체</option></select><select class=form-control ng-model=vc.srchAnal.Age ng-if=\"vc.agList.length > 0\" ng-options=\"cf.ClassfyId as cf.ClassfyNm for cf in vc.agList\" style=\"width:15% !Important; margin:0 !Important\"><option value=\"\">연령대 전체</option></select><select class=form-control ng-model=vc.srchAnal.Position ng-if=\"vc.psList.length > 0\" ng-options=\"cf.ClassfyId as cf.ClassfyNm for cf in vc.psList\" style=\"width:15% !Important; margin:0 !Important\"><option value=\"\">직급 전체</option></select><select class=form-control ng-model=vc.srchAnal.Group1 ng-if=\"vc.gr1List.length > 0\" ng-options=\"cf.ClassfyId as cf.ClassfyNm for cf in vc.gr1List\" style=\"width:15% !Important; margin:0 !Important\"><option value=\"\">그룹1 전체</option></select><select class=form-control ng-model=vc.srchAnal.Group2 ng-if=\"vc.gr2List.length > 0\" ng-options=\"cf.ClassfyId as cf.ClassfyNm for cf in vc.gr2List\" style=\"width:15% !Important; margin:0 !Important\"><option value=\"\">그룹2 전체</option></select><select class=form-control ng-model=vc.srchAnal.Group3 ng-if=\"vc.gr3List.length > 0\" ng-options=\"cf.ClassfyId as cf.ClassfyNm for cf in vc.gr3List\" style=\"width:15% !Important; margin:0 !Important\"><option value=\"\">그룹3 전체</option></select><select class=form-control ng-model=vc.srchAnal.Group4 ng-if=\"vc.gr4List.length > 0\" ng-options=\"cf.ClassfyId as cf.ClassfyNm for cf in vc.gr4List\" style=\"width:15% !Important; margin:0 !Important\"><option value=\"\">그룹4 전체</option></select>{{vm.srchAnal.ClassfyInfoId}}</div></div></div></div><div class=row ng-if=vc.srchAnal.SvyTypeId><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>진단결과</label><div style=\"margin-left:75px; line-height: 25px !Important\"><select class=form-control ng-model=vc.srchAnal.LvCd01 ng-if=\"vc.secLvList[0].length > 0 && vc.srch.SecLevelCnt == 2\" ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.secLvList[0]\" style=\"width:20% !Important; margin:0 !Important\"></select><select class=form-control ng-model=vc.srchAnal.LvCd02 ng-if=\"vc.secLvList[1].length > 0 && vc.srch.SecLevelCnt == 2\" ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.secLvList[1]\" style=\"width:20% !Important; margin:0 !Important\"></select><select class=form-control ng-model=vc.srchAnal.LvCd03 ng-if=\"vc.secLvList[2].length > 0 && vc.srch.SecLevelCnt == 2\" ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.secLvList[2]\" style=\"width:20% !Important; margin:0 !Important\"></select><select class=form-control ng-model=vc.srchAnal.LvCd04 ng-if=\"vc.secLvList[3].length > 0 && vc.srch.SecLevelCnt == 2\" ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.secLvList[3]\" style=\"width:20% !Important; margin:0 !Important\"></select><select class=form-control ng-model=vc.srchAnal.LvCd05 ng-if=\"vc.secLvList[4].length > 0 && vc.srch.SecLevelCnt == 2\" ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.secLvList[4]\" style=\"width:20% !Important; margin:0 !Important\"></select><select class=form-control ng-model=vc.srchAnal.LvCd ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.lvList\" style=\"width:10% !Important; margin:0 !Important\"><option value=\"\">전체</option></select></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>문항1</label><input class=form-control ng-model=vc.srchAnal.QstSubject11 readonly type=text><div style=\"margin-left:75px; line-height: 25px !Important\"><select class=form-control ng-model=vc.srchAnal.QstId11 ng-options=\"cd.QstId as cd.Qst for cd in vc.qstList\" style=\"width:40% !Important; margin:0 !Important\" ng-change=vc.setQstItem(11)><option value=\"\">교차문항1</option></select><select class=form-control ng-model=vc.srchAnal.QstItemId11 ng-options=\"cd.QstItemId as cd.QstItem for cd in vc.itemList11\" style=\"width:40% !Important; margin:0 !Important\"><option value=\"\">보기</option></select><select class=form-control ng-model=vc.srchAnal.QstItemSelYN11 style=\"width:15% !Important; margin:0 !Important\"><option value=Y>선택함</option><option value=N>선택안함</option></select></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>AND 문항2</label><input class=form-control ng-model=vc.srchAnal.QstSubject12 readonly type=text><div style=\"margin-left:75px; line-height: 25px !Important\"><select class=form-control ng-model=vc.srchAnal.QstId12 ng-options=\"cd.QstId as cd.Qst for cd in vc.qstList\" style=\"width:40% !Important; margin:0 !Important\" ng-change=vc.setQstItem(12)><option value=\"\">교차문항2</option></select><select class=form-control ng-model=vc.srchAnal.QstItemId12 ng-options=\"cd.QstItemId as cd.QstItem for cd in vc.itemList12\" style=\"width:40% !Important; margin:0 !Important\"><option value=\"\">보기</option></select><select class=form-control ng-model=vc.srchAnal.QstItemSelYN12 style=\"width:15% !Important; margin:0 !Important\"><option value=Y>선택함</option><option value=N>선택안함</option></select></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>AND 문항3</label><input class=form-control ng-model=vc.srchAnal.QstSubject13 readonly type=text><div style=\"margin-left:75px; line-height: 25px !Important\"><select class=form-control ng-model=vc.srchAnal.QstId13 ng-options=\"cd.QstId as cd.Qst for cd in vc.qstList\" style=\"width:40% !Important; margin:0 !Important\" ng-change=vc.setQstItem(13)><option value=\"\">교차문항3</option></select><select class=form-control ng-model=vc.srchAnal.QstItemId13 ng-options=\"cd.QstItemId as cd.QstItem for cd in vc.itemList13\" style=\"width:40% !Important; margin:0 !Important\"><option value=\"\">보기</option></select><select class=form-control ng-model=vc.srchAnal.QstItemSelYN13 style=\"width:15% !Important; margin:0 !Important\"><option value=Y>선택함</option><option value=N>선택안함</option></select></div></div></div></div></div></div></div></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>문항 보기별 분석</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group form-inline\"><label>연관문항1</label><select class=form-control ng-model=vc.srchAnal.QstId21 ng-options=\"cd.QstId as cd.Qst for cd in vc.qstList\" ng-change=vc.setQstItem(21)><option value=\"\">선택</option></select></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group form-inline\"><label>연관문항2</label><select class=form-control ng-model=vc.srchAnal.QstId22 ng-options=\"cd.QstId as cd.Qst for cd in vc.qstList\" ng-change=vc.setQstItem(22)><option value=\"\">선택</option></select></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group form-inline\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.getAssociData()><i class=\"fa fa-bar-chart-o\"></i> 문항 보기별 분석</button> <button class=\"btn btn-default\" ng-click=vc.getAssociExcel()><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div></div></div><div class=row ng-if=\"vc.assoRespList.length > 0\"><div class=\"row pl-30 col-lg-12 col-md-12 col-sm-12 col-xs-12\"><!-- 선택형 --><div ng-if=\"vc.srchAnal.QstType1 == \'1\' || vc.srchAnal.QstType2 == \'C\'\"><div class=row><input class=form-control ng-model=vc.srchAnal.QstSubject21 readonly type=text></div><div ng-repeat=\"it1 in vc.itemList21\"><div class=\"row pt-10 pb-5 pr-20 pl-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"width:70%; float:left\">{{it1.QstItemNo}}. {{it1.QstItemContents}}</div><div style=\"width:30%; float:left; text-align:right\" ng-if=\"vc.assoRespList.length > 0\"><a href=\"\" ng-click=\"vc.goTargetList(\'AssociAnal\', it1.QstItemId, \'\')\">{{(vc.assoRespList | filter: {QstItemId1: it1.QstItemId} : true).length}}명</a></div></div><div class=\"row pl-50 pb-5 pr-20 pt-5\" ng-if=\"vc.itemList22.length> 0\"><!-- 선택형 --><div ng-if=\"vc.srchAnal.QstType2 == \'1\' || vc.srchAnal.QstType2 == \'C\'\"><div class=row><input class=form-control ng-model=vc.srchAnal.QstSubject22 readonly type=text></div><div class=\"row pt-10 pb-5 pr-20 pl-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"it2 in vc.itemList22\"><div style=\"width:70%; float:left\">{{it2.QstItemNo}}. {{it2.QstItemContents}}</div><div style=\"width:30%; float:left; text-align:right\" ng-if=\"vc.assoRespList.length > 0\"><a href=\"\" ng-click=\"vc.goTargetList(\'AssociAnal\', it1.QstItemId, it2.QstItemId)\">{{(vc.assoRespList | filter: {QstItemId1: it1.QstItemId, QstItemId2: it2.QstItemId} : true).length}}명</a></div></div></div></div></div></div></div></div></div></div></div></div><!-- /row --><!-- row --><div class=row ng-if=\" ! vc.isReport\"><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer><strong style=\"letter-spacing: 0.5px\" class=ng-binding>엑셀 차트 데이터</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=\"row pl-10 pr-10\"><table width=100% class=\"table table-striped table-bordered table-hover data_table table-custom\"><colgroup><col style=\"width: 10%\" ng-if=\" ! vc.isReport\"><col style=\"width: 10%\" ng-if=\" ! vc.isReport\"><col style=\"width: 20%\" ng-if=vc.isReport><col><col style=\"width: 15%\"><col style=\"width: 10%\"><col style=\"width: 15%\"></colgroup><thead><tr><th class=text-center>사용</th><th class=text-center>순서</th><th class=text-center>데이터유형</th><th class=text-center>차트</th><th class=text-center>데이터</th></tr></thead><tr ng-repeat=\"li in vc.dataTypeList\" ng-if=li.dataChk><td class=text-center><input type=checkbox ng-model=li.useChk></td><td class=text-center><select class=form-control ng-model=li.typeSort ng-options=\"num for num in vc.dataTypeSort\">{{num}}</select></td><td class=pl-10>{{li.typeNm}}</td><td class=text-center ng-if=\"li.chtType == \'C\'\"><select class=form-control ng-model=li.typeChtCd><option value=\"\">- 선택 -</option><option value=pie>파이</option><option value=line>꺾은 선</option><option value=horizontalBar>가로 막대</option><option value=bar>세로 막대</option></select></td><td class=text-center ng-if=\"li.chtType == \'L\'\"><select class=form-control ng-model=li.typeChtCd><option value=\"\">- 선택 -</option><option value=pie>파이</option><option value=line>꺾은 선</option><option value=horizontalBar>가로 막대</option><option value=bar>세로 막대</option></select></td><td class=text-center ng-if=\"li.chtType == \'S1\'\"></td><td class=text-center><button type=button class=\"btn btn-default\" ng-click=vc.goPreview(li)><i class=\"fa fa-image\"></i> 미리보기</button></td></tr></table></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/survey/classfy-info-edit.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"ClassfyInfoEditCtrl as vc\"><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>분류정보 관리</h3></div></div><!-- page content --><div class=pagecontent><ui-view><div ng-controller=\"ClassfyInfoEditCtrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>분류정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-9\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ClassfyInfoNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.ClassfyInfoNm></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline sm-mb0\"><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.data.UseYN></common-code-custom></div></div></div></form></div><!-- /tile body --></div><!-- /tile --><!-- Action Buttons --><div class=row ng-if=\"vc.srch.keyId != \'\'\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><div class=form-group><div style=\"float:left; padding-right:2px\"><input type=file name=excelFile class=form-control></div><button class=\"btn btn-primary\" ng-click=vc.doUpload()>일괄 업로드</button> <button class=\"btn btn-default\" ng-click=vc.doDownload()>양식 다운로드</button></div></div></div></div><div class=row ng-if=\"vc.srch.keyId != \'\'\"><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>분류</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><md-sidenav md-component-id=left md-is-locked-open=true><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl style=min-height:150px><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.ClassfyNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav><form ng-submit=vc.saveData()><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-default\" activate-button ng-click=vc.resetList()><i class=\"fa fa-refresh\"></i> 초기화</button> <button type=button class=\"btn btn-primary\" activate-button ng-click=try_adding_a_branch() ng-if=\"vc.treedata.ClassfyLevel == \'1\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-if=\"vc.treedata.ClassfyLevel == \'2\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=submit class=\"btn btn-primary\" activate-button ng-if=\"vc.treedata.New == \'Y\' || vc.treedata.Edit == \'Y\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><div class=row ng-if=\"vc.treedata.New == \'Y\' || vc.treedata.ClassfyLevel == \'2\'\"><div class=\"col-lg-12 text-danger\" ng-show=\"vc.treedata.New == \'Y\' || vc.treedata.Edit == \'Y\'\">* 편집 후 저장 버튼을 눌러 주세요.</div><div class=col-lg-9><div class=\"form-group form-inline\"><label>분류명</label><input type=text class=form-control ng-model=vc.treedata.ClassfyNm ng-change=vc.onChangeClassfyNm() ng-required=true> <input type=hidden class=form-control ng-model=vc.treedata.ClassfyId> <input type=hidden class=form-control ng-model=vc.treedata.ClassfyCd> <input type=hidden class=form-control ng-model=vc.treedata.ClassfyLevel></div></div><div class=col-lg-3><div class=\"form-group form-inline\"><label>정렬순서</label><input type=text class=form-control ng-model=vc.treedata.SortSeq ng-change=vc.onChanged() maxlength=3 numbers-only=\"\"></div></div></div></form></div></div></div></div><!-- /col --></div><!-- /row --></div></div></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/survey/classfy-info-list.html","<div class=\"page page-footable\" ng-controller=\"ClassfyInfoListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>분류정보 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.ClassfyInfoNm placeholder=\"분류정보명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ClassfyInfoNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ClassfyInfoNm type=text><label>{{vc.columnMap[\'ClassfyInfoNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ManagerNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'ManagerNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UseYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.srch.UseYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/client-edit.html","<div class=\"page page-footable\" ng-controller=\"ClientEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>업체정보 등록/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>업체 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.UserNm></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ \'Menu.ROLE\' | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.UserRoleNms readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchUserroleModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseUserRole();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.data.UseYN></common-code-custom></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>아이디</label><input ng-if=\"vc.data.KeyId != null && vc.data.KeyId != \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId readonly><div class=input-group><input ng-if=\"vc.data.KeyId== null || vc.data.KeyId == \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId maxlength=20> <span class=input-group-btn ng-if=\"vc.data.KeyId == null || vc.data.KeyId == \'\'\"><button class=\"btn btn-default\" ng-click=vc.getIsDupLoginId() type=button><i class=\"glyphicon glyphicon glyphicon-ok\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-hyphen ng-model=vc.data.Mobile></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.Email></div></div></div><div class=row ng-if=\"vc.data.KeyId == null || vc.data.KeyId == \'\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><div class=input-group>최초 비밀번호는 아이디와 동일하게 생성됩니다. 업체 로그인 후 우측 상단의 [내 정보]에서 수정 후 사용하시길 권합니다.</div></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></div></div><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>업체 이미지 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\" ng-if=!vc.showUploader><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><label>첨부<br>(로고)</label><div id=vault class=vault-block></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>목록<br>(로고)</label><div style=\"padding-left:75px; margin-top:-6px\"><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col width=54><col width=*><col width=140><col width=54></colgroup><thead><tr><th><span>이미지</span></th><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><img ng-src={{fli.src}} style=\"width:40px; height:40px\"></td><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\" ng-if=!vc.showUploader><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><label>첨부<br>(대시보드)</label><div id=vault2 class=vault-block vault-company></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>목록<br>(대시보드)</label><div style=\"padding-left:75px; margin-top:-6px\"><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col width=54><col width=*><col width=140><col width=54></colgroup><thead><tr><th><span>이미지</span></th><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}}><td><img ng-src={{fli.src}} style=\"width:40px; height:40px\"></td><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/survey/client-list.html","<div class=\"page page-footable\" ng-controller=\"ClientListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>업체정보 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.UserNm placeholder=\"업체명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.UserNm type=text><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UseYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.srch.UseYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.sendEmail()><i class=\"fa fa-envelope-o\"></i> 접속정보 발송</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/client-result-list.html","<div class=\"page page-footable\" ng-controller=\"WjmClientResultListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>진단 결과</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">프로젝트명</th><th class=\"text-center none showlevel1\">결과분석</th><th class=\"text-center none showlevel1\">설문시작일</th><th class=\"text-center none showlevel1\">설문종료일</th><th class=\"text-center none showlevel1\">상태</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody><tr class=tbnodata ng-if=\"vc.totalItems == 0\"><td class=text-center colspan=5>{{ \'MSG.NO_DATA\' | translate }}</td></tr><tr ng-repeat=\"li in vc.lists\"><td class=\"text-center showlevel1\">{{li.SvyNm}}</td><td class=\"text-center showlevel1\" ng-click=vc.getAnalysis(li.KeyId)><span ng-show=\"li.KeyId == vc.srch.keyId\" style=\"font-weight: bold; color:red\">+ </span>[분석]</td><td class=\"text-center showlevel1\">{{li.SvyBeginDate | utcToLocal:\'yyyy-MM-dd\'}}</td><td class=\"text-center showlevel1\">{{li.SvyEndDate | utcToLocal:\'yyyy-MM-dd\'}}</td><td class=\"text-center showlevel1\">{{li.SvyStatus}}</td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div><div class=row ng-show=\"vc.srch.keyId != null\"><div class=row><!-- 좌측 --><div class=col-lg-6><!-- 전체 참여율 --><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>전체 참여율 {{vc.listC.length}}</div><div class=panel-body ng-if=vc.listC><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtC chart-labels=vc.chart.lbC chart-options=vc.chart.opt></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">대상수(명)</th></tr></thead><tbody><tr><td class=\"text-center showlevel1\">참여</td><td class=\"text-center showlevel1\">{{vc.listC.RespCnt}}({{vc.listC.RespRate}}%)</td></tr><tr><td class=\"text-center showlevel1\">미참여</td><td class=\"text-center showlevel1\">{{vc.listC.NoRespCnt}}({{vc.listC.NoRespRate}}%)</td></tr></tbody></table></div></div></div></div></div></div><!-- 우측 --><div class=col-lg-6><!-- 성별 참여율 --><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>성별 참여율</div><div class=panel-body ng-if=\"vc.listGD != null && vc.listGD.length > 0\"><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtGD chart-labels=vc.chart.lbGD chart-options=vc.chart.opt></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">대상수(명)</th></tr></thead><tbody><tr ng-repeat=\"li in vc.listGD\"><td class=\"text-center showlevel1\">{{li.Resp}}</td><td class=\"text-center showlevel1\">{{li.RespCnt}}({{li.RespRate}}%)</td></tr></tbody></table></div></div></div></div></div></div></div><!-- 연령대 참여율 --><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-heading>연령대 참여율</div><div class=panel-body ng-if=\"vc.listAG != null && vc.listAG.length > 0\"><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtAG chart-labels=vc.chart.lbAG chart-options=vc.chart.opt></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">대상수(명)</th></tr></thead><tbody><tr ng-repeat=\"li in vc.listAG\"><td class=\"text-center showlevel1\">{{li.Resp}}</td><td class=\"text-center showlevel1\">{{li.RespCnt}}({{li.RespRate}}%)</td></tr></tbody></table></div></div></div></div></div><!-- 직급 참여율 --><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-heading>직급 참여율</div><div class=panel-body ng-if=\"vc.listPS != null && vc.listPS.length > 0\"><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtPS chart-labels=vc.chart.lbPS chart-options=vc.chart.opt></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">대상수(명)</th></tr></thead><tbody><tr ng-repeat=\"li in vc.listPS\"><td class=\"text-center showlevel1\">{{li.Resp}}</td><td class=\"text-center showlevel1\">{{li.RespCnt}}({{li.RespRate}}%)</td></tr></tbody></table></div></div></div></div></div><!-- 그룹1 참여율 --><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-heading>그룹1 참여율</div><div class=panel-body ng-if=\"vc.listGR1 != null && vc.listGR1.length > 0\"><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtGR1 chart-labels=vc.chart.lbGR1 chart-options=vc.chart.opt></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">대상수(명)</th></tr></thead><tbody><tr ng-repeat=\"li in vc.listGR1\"><td class=\"text-center showlevel1\">{{li.Resp}}</td><td class=\"text-center showlevel1\">{{li.RespCnt}}({{li.RespRate}}%)</td></tr></tbody></table></div></div></div></div></div><!-- 그룹2 참여율 --><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-heading>그룹2 참여율</div><div class=panel-body ng-if=\"vc.listGR2 != null && vc.listGR2.length > 0\"><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtGR2 chart-labels=vc.chart.lbGR2 chart-options=vc.chart.opt></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">대상수(명)</th></tr></thead><tbody><tr ng-repeat=\"li in vc.listGR2\"><td class=\"text-center showlevel1\">{{li.Resp}}</td><td class=\"text-center showlevel1\">{{li.RespCnt}}({{li.RespRate}}%)</td></tr></tbody></table></div></div></div></div></div><!-- 그룹3 참여율 --><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-heading>그룹3 참여율</div><div class=panel-body ng-if=\"vc.listGR3 != null && vc.listGR3.length > 0\"><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtGR3 chart-labels=vc.chart.lbGR3 chart-options=vc.chart.opt></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">대상수(명)</th></tr></thead><tbody><tr ng-repeat=\"li in vc.listGR3\"><td class=\"text-center showlevel1\">{{li.Resp}}</td><td class=\"text-center showlevel1\">{{li.RespCnt}}({{li.RespRate}}%)</td></tr></tbody></table></div></div></div></div></div><!-- 그룹4 참여율 --><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-heading>그룹4 참여율</div><div class=panel-body ng-if=\"vc.listGR4 != null && vc.listGR4.length > 0\"><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtGR4 chart-labels=vc.chart.lbGR4 chart-options=vc.chart.opt></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">대상수(명)</th></tr></thead><tbody><tr ng-repeat=\"li in vc.listGR4\"><td class=\"text-center showlevel1\">{{li.Resp}}</td><td class=\"text-center showlevel1\">{{li.RespCnt}}({{li.RespRate}}%)</td></tr></tbody></table></div></div></div></div></div><!-- 전체 진단결과 --><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-heading>전체 진단결과</div><div class=panel-body ng-if=\"vc.listL.length != null && vc.listL.length != 0\"><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtL chart-labels=vc.chart.lbL chart-options=vc.chart.opt chart-colors=vc.chart.color></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">구분</th><th class=\"text-center none showlevel1\">대상수(명)</th></tr></thead><tbody><tr class=tbnodata ng-if=\"vc.listL.length == null || vc.listL.length == 0\"><td class=text-center colspan=2>{{ \'MSG.NO_DATA\' | translate }}</td></tr><tr ng-repeat=\"li in vc.listL\"><td class=\"text-center showlevel1\">{{li.Resp}}</td><td class=\"text-center showlevel1\">{{li.RespCnt}}({{li.RespRate}}%)</td></tr></tbody></table></div></div></div></div></div><!-- 상담사별 상담건수 --><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-heading>상담사별 상담건수</div><div class=panel-body ng-if=\"vc.listCC.length != null && vc.listCC.length != 0\"><div class=row><div class=col-lg-6><canvas class=\"chart chart-pie\" chart-data=vc.chart.dtCC chart-labels=vc.chart.lbCC chart-options=vc.chart.opt></canvas></div><div class=col-lg-6><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">상담사명</th><th class=\"text-center none showlevel1\">상담사코드</th><th class=\"text-center none showlevel1\">상담건수</th></tr></thead><tbody><tr ng-repeat=\"li in vc.listCC\"><td class=\"text-center showlevel1\">{{li.UserNm}}</td><td class=\"text-center showlevel1\">{{li.CounselorCode}}</td><td class=\"text-center showlevel1\">{{li.CounselCnt}}</td></tr></tbody></table></div></div></div></div></div><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=panel-heading>대상고객 목록</div><div class=panel-body style=\"overflow:auto; height:400px\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th class=\"text-center none showlevel1\">이름</th><th class=\"text-center none showlevel1\">성별</th><th class=\"text-center none showlevel1\">연령대</th><th class=\"text-center none showlevel1\">직급</th><th class=\"text-center none showlevel1\">그룹1</th><th class=\"text-center none showlevel1\">그룹2</th><th class=\"text-center none showlevel1\">그룹3</th><th class=\"text-center none showlevel1\">그룹4</th><th class=\"text-center none showlevel1\">진단결과</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody><tr class=tbnodata ng-if=\"vc.tgtList.length == null || vc.tgtList.length == 0\"><td class=text-center colspan=9>{{ \'MSG.NO_DATA\' | translate }}</td></tr><tr ng-repeat=\"li in vc.tgtList\"><td class=\"text-center showlevel1\">{{li.Name.substr(0,1)}}**</td><td class=\"text-center showlevel1\">{{li.RespGD}}</td><td class=\"text-center showlevel1\">{{li.RespAG}}</td><td class=\"text-center showlevel1\">{{li.RespPS}}</td><td class=\"text-center showlevel1\">{{li.RespGR1}}</td><td class=\"text-center showlevel1\">{{li.RespGR2}}</td><td class=\"text-center showlevel1\">{{li.RespGR3}}</td><td class=\"text-center showlevel1\">{{li.RespGR4}}</td><td class=\"text-center showlevel1\">{{li.LvCd}}</td></tr></tbody></table></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/contact-edit.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"WjmContactEditCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>상담문의 문구 수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer title=펼치기/접기><strong style=\"letter-spacing: 0.5px\" class=ng-binding>내용</strong><div class=pull-right><i class=\"fa fa-minus fa-lg\"></i></div></div><div class=\"panel-body collapse in\" id=se2_toggle_2><!-- 에디터의 경우 로딩전 접혔을경우 안나옴 --><div class=row><div class=col-lg-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: none\" ng-model=vc.data.ContactTxt></textarea></div></div></div></div></div></div></form></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n  var sLang = \"ko_KR\";\r\n    nhn.husky.EZCreator.createInIFrame({\r\n      oAppRef : oEditors,\r\n      elPlaceHolder : \"strHtml\",\r\n      sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n      htParams : {\r\n        bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n        bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n        bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n        fOnBeforeUnload : function() {\r\n        },\r\n        I18N_LOCALE : sLang\r\n      },\r\n      fOnAppLoad : function() {\r\n      },\r\n      fCreator : \"createSEditor2\"\r\n    });</script>");
$templateCache.put("app/survey/counsel-edit.html","<div class=\"page page-footable\" ng-controller=\"WjmCounselEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>상담 신청 조회/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>상담신청정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'CounselNum\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=20 ng-model=vc.data.CounselNum readonly></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=20 ng-model=vc.RegDate readonly></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'CounselStatus\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'CounselStatus\'].CodeList\" code-model=vc.data.CounselStatus></common-code-custom></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=vc.data.Name></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=13 ng-model=vc.data.Mobile></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Email></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline sm-mb0\"><label>{{vc.columnMap[\'ClientNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.ClientNm></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Department\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Department></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Position\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Position></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Age\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Age></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Area\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Area></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Schedule\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=50 ng-model=vc.data.Schedule></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>상담주제</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input ng-checked-=\"vc.data.TopicYN0 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN0 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN0\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN1 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN1 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN1\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN2 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN2 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN2\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN3 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN3 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN3\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN4 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN4 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN4\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN5 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN5 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN5\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN6 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN6 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN6\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN7 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN7 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN7\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN8 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN8 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN8\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN9 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN9 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN9\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN10 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN10 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN10\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN11 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN11 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN11\'].ColumnLogicalNm | translate}}&nbsp;&nbsp; <input ng-checked-=\"vc.data.TopicYN12 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.TopicYN12 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'TopicYN12\'].ColumnLogicalNm | translate}}</div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Memo\'].ColumnLogicalNm | translate}}</label><textarea class=form-control style=height:100px ng-model=vc.data.Memo></textarea></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><div style=\"margin-left:20px; line-height: 25px !Important\"><label>개인정보수집 동의</label>&nbsp; &nbsp; <input ng-checked-=\"vc.data.InfoAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 동의 <input ng-checked-=\"vc.data.InfoAgreeYN == \'N\'\" ng-false-value=\"\'Y\'\" ng-model=vc.data.InfoAgreeYN ng-true-value=\"\'N\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 미동의</div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><div style=\"margin-left:20px; line-height: 25px !Important\"><label>마케팅정보 수신 동의</label><input ng-checked-=\"vc.data.MktAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.MktAgreeYN ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 동의 <input ng-checked-=\"vc.data.MktAgreeYN == \'N\'\" ng-false-value=\"\'Y\'\" ng-model=vc.data.MktAgreeYN ng-true-value=\"\'N\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> 미동의</div></div></div></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/survey/counsel-list.html","<div class=\"page page-footable\" ng-controller=\"WjmCounselListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>상담 신청<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Name placeholder=\"고객명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Name\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Name type=text><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CounselNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CounselNum type=text><label>{{vc.columnMap[\'CounselNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ClientNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ClientNm type=text><label>{{vc.columnMap[\'ClientNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CounselStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CounselStatus\'].CodeList\" code-model=vc.srch.CounselStatus></common-code-custom><label>{{vc.columnMap[\'CounselStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CounselDateFrom = (vc.CounselDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDateFrom ng-required=false placeholder=상담신청일시작 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CounselDateTo = (vc.CounselDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDateTo ng-required=false placeholder=상담신청일종료 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><!--\r\n                  <button class=\"btn btn-primary\" ng-click=\"vc.goAdd()\"><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button>\r\n                  --> <button class=\"btn btn-danger\" ng-click=vc.deleteList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/counselor-edit.html","<div class=\"page page-footable\" ng-controller=\"CounselorEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>상담사정보 등록/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>상담사 추가/수정</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>상담사명</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.UserNm></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.data.UseYN></common-code-custom></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>업체명</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.ComUserNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchComUserModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseComUser();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>분류명</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.ClassfyInfoNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchClassfyInfoModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseClassfyInfo();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CounselorCode\'].ColumnLogicalNm | translate }}</label><select class=form-control ng-model=vc.data.CounselorCode ng-options=\"li.ClassfyId as li.ClassfyNm for li in vc.CounselorCodeList\"><option value=\"\">--선택--</option></select></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>아이디</label><input ng-if=\"vc.data.KeyId != null && vc.data.KeyId != \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId readonly><div class=input-group><input ng-if=\"vc.data.KeyId== null || vc.data.KeyId == \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId maxlength=20> <span class=input-group-btn ng-if=\"vc.data.KeyId == null || vc.data.KeyId == \'\'\"><button class=\"btn btn-default\" ng-click=vc.getIsDupLoginId() type=button><i class=\"glyphicon glyphicon glyphicon-ok\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline xs-mb10\"><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-hyphen ng-model=vc.data.Mobile></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.Email></div></div></div><div class=row ng-if=\"vc.data.KeyId == null || vc.data.KeyId == \'\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><div class=input-group>최초 비밀번호는 아이디와 동일하게 생성됩니다. 상담사 로그인 후 우측 상단의 [내 정보]에서 수정 후 사용하시길 권합니다.</div></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></div></div><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>상담사 이미지 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\" ng-if=!vc.showUploader><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><label>첨부<br>(로고)</label><div id=vault class=vault-block></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>목록<br>(로고)</label><div style=\"padding-left:75px; margin-top:-6px\"><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col width=54><col width=*><col width=140><col width=54></colgroup><thead><tr><th><span>이미지</span></th><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><img ng-src={{fli.src}} style=\"width:40px; height:40px\"></td><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\" ng-if=!vc.showUploader><file-attach file-data=vc.uploadFileList2 callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><label>첨부<br>(대시보드)</label><div id=vault2 class=vault-block vault-company></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>목록<br>(대시보드)</label><div style=\"padding-left:75px; margin-top:-6px\"><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col width=54><col width=*><col width=140><col width=54></colgroup><thead><tr><th><span>이미지</span></th><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList2\"><tr id=filectl_{{fli.id}}><td><img ng-src={{fli.src}} style=\"width:40px; height:40px\"></td><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/survey/counselor-list.html","<div class=\"page page-footable\" ng-controller=\"CounselorListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>상담사정보 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.UserNm placeholder=\"상담사명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.UserNm type=text><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ComUserNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ComUserNm type=text><label>{{vc.columnMap[\'ComUserNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CounselorCode_\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.CounselorCode_ type=text><label>{{vc.columnMap[\'CounselorCode_\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UseYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.srch.UseYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><div style=\"float:left; padding-right:2px\"><input type=file name=excelFile class=form-control></div><button class=\"btn btn-primary\" ng-click=vc.chkUpload()>일괄 업로드</button> <button class=\"btn btn-default\" ng-click=vc.doDownload()>양식 다운로드</button> <button class=\"btn btn-default\" ng-click=vc.sendEmail()><i class=\"fa fa-envelope-o\"></i> 접속정보 발송</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/form-edit.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"WjmFormEditCtrl as vc\" ng-init=vc.init()><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>서식 등록/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData() style=display:none ng-disabled=vc.isDisable()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.data.keyId != \'\'\" ng-disabled=vc.isDisable()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setCopyData() ng-if=\"vc.data.keyId != \'\'\"><i class=\"fa fa-copy\"></i> 복사후편집</button> <button class=\"btn btn-default\" ng-click=vc.goPreview()><i class=\"fa fa-list\"></i> 미리보기</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>서식정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-8><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.FormNm></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'FormType\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'FormType\'].CodeList\" code-model=vc.data.FormType></common-code-custom></div></div></div><div class=row style=display:none><div class=col-lg-4><div class=\"form-group form-inline sm-mb0\"><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>언어</label><div style=margin-left:70px><input type=radio ng-model=vc.data.SvyLang ng-checked=true style=\"width:25px !Important; margin:0 !Important\">한글 &nbsp;&nbsp; <input type=radio ng-model=vc.data.SvyLang value=ENG style=\"width:15px !Important; margin:0 !Important\">영어</div></div></div></div><!--\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label class=\"txt-req\">{{vc.columnMap[\'SvyBeginDate\'].ColumnLogicalNm | translate}}</label>\r\n                    <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n                      <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                             current-text=\"오늘\"\r\n                             datepicker-options=\"dateOptions\"\r\n                             is-open=\"opened\"\r\n                             ng-change=\"vc.data.SvyBeginDate = (vc.SvyBeginDate | date: \'yyyy-MM-dd\')\"\r\n                             ng-model=\"vc.SvyBeginDate\"\r\n                             ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                             uib-datepicker-popup=\"{{ :: format}}\"/>\r\n                      <span class=\"input-group-btn\">\r\n                          <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                            <i class=\"fa fa-calendar\"></i>\r\n                          </button>\r\n                        </span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label class=\"txt-req\">{{vc.columnMap[\'SvyEndDate\'].ColumnLogicalNm | translate}}</label>\r\n                    <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n                      <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                             current-text=\"오늘\"\r\n                             datepicker-options=\"dateOptions\"\r\n                             is-open=\"opened\"\r\n                             ng-change=\"vc.data.SvyEndDate = (vc.SvyEndDate | date: \'yyyy-MM-dd\')\"\r\n                             ng-model=\"vc.SvyEndDate\"\r\n                             ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                             uib-datepicker-popup=\"{{ :: format}}\"/>\r\n                      <span class=\"input-group-btn\">\r\n                        <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                          <i class=\"fa fa-calendar\"></i>\r\n                        </button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                --><!--\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label class=\"txt-req\" style=\"font-size:11px;\">{{vc.columnMap[\'SvyEndMsg\'].ColumnLogicalNm | translate}}</label>\r\n                    <input type=\"text\" class=\"form-control form-right\" maxlength=\"200\" ng-model=\"vc.data.SvyEndMsg\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              --></div></div></div></div><div class=row ng-show=\"vc.data.FormType == null || vc.data.FormType == \'\' || vc.data.FormType == \'100\'\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer title=펼치기/접기><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문옵션</strong><div class=pull-right><i class=\"fa fa-minus fa-lg\"></i></div></div><!--<div class=\"panel-body collapse in\">--><div class=\"panel-body collapse out\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'QstPassYN\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.QstPassYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">허용 &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstPassYN value=N style=\"width:15px !Important; margin:0 !Important\"> 미허용</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RespLimitYN\'].ColumnLogicalNm | translate}}</label><div style=margin-left:70px><input type=radio ng-model=vc.data.RespLimitYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">무제한 &nbsp;&nbsp; <input type=radio ng-model=vc.data.RespLimitYN value=N style=\"width:15px !Important; margin:0 !Important\">제한<!--\r\n                      <input type=\"text\" class=\"form-control form-right\" maxlength=\"5\" numbers-only=\"\" ng-model=\"vc.data.RespLimitCnt\" style=\"width:50px; margin:0 !Important; display:inline-block;\">\r\n                      건으로 제한\r\n                      --></div></div></div><!--\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label style=\"font-size:11px;\">{{vc.columnMap[\'RespLimitEndMsg\'].ColumnLogicalNm | translate}}</label>\r\n                    <input type=\"text\" class=\"form-control form-right\" maxlength=\"200\" ng-model=\"vc.data.RespLimitEndMsg\">\r\n                  </div>\r\n                </div>\r\n                --><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'LineColor\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input type=text class=\"form-control form-right\" maxlength=6 ng-model=vc.data.LineColor> <span class=input-group-btn><span id=spanLineColorData style=background-color:{{vc.data.LineColorData}};cursor:default class=\"btn btn-default\"></span> <button class=\"btn btn-default\" ng-click=vc.srchLineColor() type=button><i class=\"fa fa-search\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'QstNumYN\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.QstNumYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\"> 표시함 &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstNumYN value=N style=\"width:15px !Important; margin:0 !Important\"> 표시안함</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label style=font-size:11px>{{vc.columnMap[\'QstIconType\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.QstIconType value=N ng-checked=true style=\"width:25px !Important; margin:0 !Important\"> 사용안함 &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstIconType value=10 style=\"width:15px !Important; margin:0 !Important\"> <i ng-bind-html=wjmSurvey.qstIcon1|htmlString></i> &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstIconType value=20 style=\"width:15px !Important; margin:0 !Important\"> <i ng-bind-html=wjmSurvey.qstIcon2|htmlString></i> &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstIconType value=30 style=\"width:15px !Important; margin:0 !Important\"> <i ng-bind-html=wjmSurvey.qstIcon3|htmlString></i> &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstIconType value=40 style=\"width:15px !Important; margin:0 !Important\"> <i ng-bind-html=wjmSurvey.qstIcon4|htmlString></i></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BoxColor\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input type=text class=\"form-control form-right\" maxlength=6 ng-model=vc.data.BoxColor> <span class=input-group-btn><span id=spanBoxColorData style=background-color:{{vc.data.BoxColorData}};cursor:default class=\"btn btn-default\"></span> <button class=\"btn btn-default\" ng-click=vc.srchBoxColor() type=button><i class=\"fa fa-search\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'LinkCRMYN\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.LinkCRMYN value=Y style=\"width:25px !Important; margin:0 !Important\"> 고객정보 연동 &nbsp;&nbsp; <input type=radio ng-model=vc.data.LinkCRMYN value=N ng-checked=true style=\"width:15px !Important; margin:0 !Important\"> 고객정보 비연동</div></div></div><div class=col-lg-8><div class=\"form-group form-inline\"><label style=font-size:11px>마케팅활용동의</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input ng-checked-=\"vc.data.InfoAgreeYN1 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN1 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'InfoAgreeYN1\'].ColumnLogicalNm | translate}} &nbsp;&nbsp; <input ng-checked-=\"vc.data.InfoAgreeYN2 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN2 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'InfoAgreeYN2\'].ColumnLogicalNm | translate}} &nbsp;&nbsp; <input ng-checked-=\"vc.data.InfoAgreeYN3 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN3 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'InfoAgreeYN3\'].ColumnLogicalNm | translate}} &nbsp;&nbsp; <input ng-checked-=\"vc.data.InfoAgreeYN4 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN4 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'InfoAgreeYN4\'].ColumnLogicalNm | translate}}</div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer title=펼치기/접기><strong style=\"letter-spacing: 0.5px\" class=ng-binding>소개글</strong><div class=pull-right><i class=\"fa fa-minus fa-lg\"></i></div></div><div class=\"panel-body collapse in\" id=se2_toggle_1><!-- 에디터의 경우 로딩전 접혔을경우 안나옴 --><div class=row><div class=col-lg-12><div class=\"col-lg-12 text-warning mb-10\" ng-show=\"vc.data.FormType == \'200\'\">치환문구 : {SvyNm} 설문제목 // {SvyDate} 설문기간 // {SvyLink} 설문링크 // {ClientNm} 업체명 // {LogoSrc} 업체로고 // {DenyLink} 수신거부링크</div><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: none\" ng-model=vc.data.TopCont></textarea></div></div><!--\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-12 btn-group\">\r\n                  <div class=\"pull-right\">\r\n                    <button class=\"btn btn-default\" ng-click=\"vc.setSvyDate()\">\r\n                      <i class=\"fa fa-plus\"></i> 설문기간추가\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              --></div></div></div></div><div class=row ng-show=\"vc.data.FormType == \'100\'\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer title=펼치기/접기><strong style=\"letter-spacing: 0.5px\" class=ng-binding>문항편집</strong><div class=pull-right><i class=\"fa fa-minus fa-lg\"></i></div></div><div class=\"panel-body collapse out\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyTypeId\'].ColumnLogicalNm | translate }}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.SvyTypeNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchSvyTypeModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSvyType() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4 style=display:none><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ClassfyInfoId\'].ColumnLogicalNm | translate }}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ClassfyInfoNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchClassfyInfoModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseClassfyInfo() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-12 style=padding:20px><div class=row style=\"background-color:#eee; border-top:1px solid #aaa\"><div class=col-sm-4><div class=\"form-group form-inline\"><label>문항유형</label><common-code-custom code-list=\"vc.columnMap[\'QstType\'].CodeList\" code-model=vc.batchQstType></common-code-custom></div></div><div class=col-sm-4><div class=\"form-group form-inline\"><label style=font-size:11px>페이지당반복수</label><div class=\"input-group custom-search-form\"><input type=text class=\"form-control form-right\" maxlength=2 numbers-only=\"\" ng-model=vc.batchCnt> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.setBatchQst()><i class=\"fa fa-plus\"></i> 일괄생성</button></span></div></div></div></div><div class=row style=\"background-color:#eee; border-top:1px solid #aaa; border-bottom:1px solid #aaa\"><div class=col-lg-4><div class=\"form-group form-inline\"><label>페이지</label><div class=\"input-group custom-search-form\"><select class=\"form-control inline-select\" ng-model=vc.svyPagesCur ng-options=\"li.PageNo as li.PageNo for li in vc.svyPages\"><option value=\"\">--선택--</option></select><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.setSvyPageAdd()><i class=\"fa fa-plus\"></i> 마지막에추가</button> <button class=\"btn btn-default\" ng-click=vc.setSvyPagePrevAdd()><i class=\"fa fa-plus\"></i> 이전에추가</button> <button class=\"btn btn-default\" ng-click=vc.setSvyPageDel()><i class=\"fa fa-remove\"></i> 페이지삭제</button></span></div></div></div><div class=col-sm-4><div class=\"form-group form-inline\"><label>문항유형</label><div class=\"input-group custom-search-form\"><common-code-custom code-list=\"vc.columnMap[\'QstType\'].CodeList\" code-model=vc.addQstType id=inline-select-common></common-code-custom><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.setSvyQstAdd()><i class=\"fa fa-plus\"></i> 문항추가</button></span></div></div></div></div></div></div><div class=row><div class=col-lg-12 style=\"padding:20px; max-width: 1000px\"><div class=row ng-repeat=\"qt in vc.svyQsts | filter : {PageNo: vc.svyPagesCur, stat: \'!D\'} : true\"><!-- 선택형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'1\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\"><input type=radio name=rdo{{it.qtId}} style=margin-top:-3px disabled ng-if=\"qt.SelType==\'S\'\"> <input type=checkbox name=rdo{{it.qtId}} style=margin-top:-3px disabled ng-if=\"qt.SelType==\'M\'\"><!--{{it.QstItemNo}}. --> {{it.QstItemContents}} <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(it.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <input type=text class=form-control maxlength=100 ng-show=\'it.OtherRespYN == \"Y\"\' style=\"margin-left:15px !Important; max-width:80% !Important\" disabled></p></div></div><!-- 입력형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'2\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><textarea class=form-control style=height:100px ng-show=\'qt.InputType == \"T\"\' maxlength=1000 disabled placeholder={{qt.InputHint}}></textarea><input type=text class=form-control maxlength=100 ng-show=\'qt.InputType == \"I\"\' style=\"max-width:80% !Important\" disabled placeholder={{qt.InputHint}}></div></div><!-- 우선순위형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'3\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div class=row style=padding-top:10px><div class=col-sm-6 style=padding-bottom:10px><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\">{{it.QstItemNo}}. {{it.QstItemContents}} <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(it.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span></p></div><div class=col-sm-6><p ng-repeat=\"n in [].constructor(qt.QstTopCnt) track by $index\" style=padding-bottom:5px><select class=form-control disabled><option>--{{$index + 1}}순위 선택--</option></select></p></div></div></div><!-- 이미지형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'4\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><p style=padding-bottom:10px ng-show=\"qt.qtImgSrc != null && qt.qtImgSrc != \'\'\"><img ng-src={{qt.qtImgSrc}}></p><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\" style=padding-bottom:5px><input type=radio name=rdo{{it.qtId}} style=margin-top:-3px disabled><span ng-show=\"it.itImgSrc != null && it.itImgSrc != \'\'\">&nbsp;&nbsp;&nbsp;<img ng-src={{it.itImgSrc}}>&nbsp;&nbsp;</span><!--{{it.QstItemNo}}. --> {{it.QstItemContents}} <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(it.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span></p></div></div><!-- 척도형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'5\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><div class=row ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\"><div class=col-lg-3>{{it.QstItemContents}}</div><div class=col-lg-6><ul style=\"display: table; width:100%\"><li style=\"display:table-cell; text-align: center\" ng-repeat=\"n in [].constructor(qt.ScaleMax) track by $index\"><input type=radio name=rdo{{it.itId}} style=margin-top:-3px disabled> <span ng-if=\"qt.ScaleOrder==\'A\'\">{{$index + 1}}</span><span ng-if=\"qt.ScaleOrder==\'D\'\">{{qt.ScaleMax - $index}}</span></li></ul></div><div class=\"col-lg-3 text-right\">{{it.QstItemContents2}}</div></div></div></div><!-- 분류정보 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'C\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><div ng-if=\"qt.ClassfyCd == \'NM\'\"><div class=\"form-group form-inline\"><input type=text class=form-control maxlength=30 style=\"margin-left:0 !Important; max-width:158px !Important\" disabled></div></div><div ng-if=\"qt.ClassfyCd == \'MB\'\"><!--\r\n                          <div class=\"form-inline\">\r\n                            <div class=\"form-group\">\r\n                              <select class=\"form-control\" style=\"margin-left:0 !Important; width:100% !Important;\" disabled>\r\n                                <option value=\"010\">010</option>\r\n                                <option value=\"011\">011</option>\r\n                              </select>\r\n                            </div>\r\n                            <div class=\"form-group\">\r\n                              <input type=\"text\" class=\"form-control\" maxlength=\"4\" number-only=\"\" style=\"margin-left:0 !Important; width:100% !Important;\" disabled>\r\n                            </div>\r\n                            <div class=\"form-group\">\r\n                              <input type=\"text\" class=\"form-control\" maxlength=\"4\" number-only=\"\" style=\"margin-left:0 !Important; width:100% !Important;\" disabled>\r\n                            </div>\r\n                          </div>\r\n                          --><div class=\"form-group form-inline\"><input type=text class=form-control maxlength=13 style=\"margin-left:0 !Important; max-width:158px !Important\" disabled></div></div><div ng-if=\"qt.ClassfyCd == \'EM\'\"><div class=form-inline><div class=form-group><input type=text class=form-control maxlength=30 style=\"margin-left:0 !Important; width:100% !Important\" disabled></div><div class=form-group>@</div><div class=form-group><input type=text class=form-control maxlength=30 style=\"margin-left:0 !Important; width:100% !Important\" disabled></div><div class=form-group><select class=form-control style=\"margin-left:0 !Important; width:100% !Important\" disabled><option value=\"\">직접입력</option></select></div></div><!--\r\n                          <div class=\"form-group form-inline\">\r\n                            <input type=\"text\" class=\"form-control\" maxlength=\"60\" style=\"margin-left:0 !Important; max-width:258px !Important;\" disabled>\r\n                          </div>\r\n                          --></div><div ng-if=\"qt.ClassfyCd == \'GD\'\"><p><input type=radio name=rdoGD style=margin-top:-3px disabled><!--{{it.QstItemNo}}. --> 남</p><p><input type=radio name=rdoGD style=margin-top:-3px disabled><!--{{it.QstItemNo}}. --> 여</p></div><div ng-if=\"qt.ClassfyCd != \'NM\' && qt.ClassfyCd != \'MB\' && qt.ClassfyCd != \'EM\' && qt.ClassfyCd != \'GD\'\"><!--\r\n                          <select class=\"form-control\" disabled>\r\n                            <option value=\"\">--선택--</option>\r\n                          </select>\r\n                          --><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\"><input type=radio name=rdo{{it.qtId}} style=margin-top:-3px disabled><!--{{it.QstItemNo}}. --> {{it.QstItemContents}} <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(it.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span></p></div></div></div><!-- 설명글 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'R\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8>{{wjmSurvey.getQstTypeNm(qt.QstType)}} 하단의 설명글이 표시됩니다.<!--이곳을 드레그하여 문항을 이동합니다.--></div><div class=\"col-lg-4 text-right\"><!--<span class=\"glyphicon glyphicon-arrow-right\" ng-show=\"vc.getGotoInfoFrom(qt.GoToQstId)\" title=\"출발분기가 설정된 문항입니다.\"></span>--> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <span class=\"fa fa-sign-out\" ng-show=\"qt.QstEndType == \'F\'\" title=\"종료가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><pre class=txt-pre>{{qt.QstSubject}}</pre></div></div></div></div></div></div></div></div></div><div class=row ng-show=\"vc.data.FormType == null || vc.data.FormType == \'\' || vc.data.FormType == \'100\'\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer title=펼치기/접기><strong style=\"letter-spacing: 0.5px\" class=ng-binding>끝맺음말</strong><div class=pull-right><i class=\"fa fa-minus fa-lg\"></i></div></div><div class=\"panel-body collapse in\" id=se2_toggle_2><!-- 에디터의 경우 로딩전 접혔을경우 안나옴 --><div class=row><div class=col-lg-12><div class=\"col-lg-12 text-warning mb-10\">치환문구 : {TgtNm} 응답자명</div><textarea id=strHtml2 rows=10 style=\"width: 100%; height: 300px; display: none\" ng-model=vc.data.BtmCont></textarea></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BtmType\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.BtmType value=100 ng-checked=true style=\"width:25px !Important; margin:0 !Important\"> 편집한 내용 &nbsp;&nbsp; <input type=radio ng-model=vc.data.BtmType value=200 style=\"width:15px !Important; margin:0 !Important\"> 기준점에 따른 미니결과</div></div></div></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData() style=display:none ng-disabled=vc.isDisable()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.data.keyId != \'\'\" ng-disabled=vc.isDisable()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setCopyData() ng-if=\"vc.data.keyId != \'\'\"><i class=\"fa fa-copy\"></i> 복사후편집</button> <button class=\"btn btn-default\" ng-click=vc.goPreview()><i class=\"fa fa-list\"></i> 미리보기</button></div></div></div></form></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n  var sLang = \"ko_KR\";\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      fOnBeforeUnload : function() {\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n      $(\"#se2_toggle_1\").removeClass(\"in\").addClass(\"out\");\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml2\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      fOnBeforeUnload : function() {\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n      $(\"#se2_toggle_2\").removeClass(\"in\").addClass(\"out\");\r\n      $(\".btn_save\").show();\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/survey/form-list.html","<div class=\"page page-footable\" ng-controller=\"WjmFormListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>서식 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.FormNm placeholder=\"서식명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'FormNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.FormNm type=text><label>{{vc.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'FormType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'FormType\'].CodeList\" code-model=vc.srch.FormType></common-code-custom><label>{{vc.columnMap[\'FormType\'].ColumnLogicalNm | translate}}</label></div></div><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><!--\r\n                  <button class=\"btn btn-default\" ng-click=\"vc.getExcelFile()\"><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button>\r\n                  --> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox ng-disabled=\"li.UseCnt != \'0\'\"></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/image-edit.html","<div class=\"page page-footable\" ng-controller=\"WjmImageEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>문항이미지 등록/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>문항이미지 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 text-warning mb-10\">* 설문에서 원본 크기의 이미지가 보여지므로 알맞은 크기의 이미지를 업로드 하시기 바랍니다.<br>* 모바일 설문의 경우 가로 450px 이하를 권장합니다.</div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ImgNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.ImgNm></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\" ng-if=!vc.showUploader><!--<label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label>--><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><!--<label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label>--><label>이미지첨부</label><div id=vault class=vault-block vault-company></div></form></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>이미지목록</label><div style=\"padding-left:75px; margin-top:-6px\"><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col width=54><col width=*><col width=140><!--<col width=\"140\">--><col width=54></colgroup><thead><tr><th><span>이미지</span></th><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><!--<th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th>--><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><img ng-src={{fli.src}} style=\"width:40px; height:40px\"></td><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><!--<td align=right><span class=\"file_size\" ng-bind=\"fli.downloadCnt|number\"></span></td>--><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.srch.keyId != \'\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/survey/image-list.html","<div class=\"page page-footable\" ng-controller=\"WjmImageListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>문항이미지 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.ImgNm placeholder=\"이미지그룹명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ImgNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ImgNm type=text><label>{{vc.columnMap[\'ImgNm\'].ColumnLogicalNm | translate}}</label></div></div><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><!--\r\n                  <button class=\"btn btn-default\" ng-click=\"vc.getExcelFile()\"><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button>\r\n                  --> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/report-detail.html","<div class=\"page page-footable\" ng-controller=\"WjmReportDetailCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12 ng-if=\"vc.layout == \'N\'\"><div class=page-header>보고서 관리</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\" ng-if=\"vc.data.RptType == \'P\'\"><input class=mb5 ng-model=vc.srch2.Email placeholder=\"이메일 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Name\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch2.Name type=text><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch2.Email type=text><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch2.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ResultStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ResultStatus\'].CodeList\" code-model=vc.srch2.ResultStatus></common-code-custom><label>{{vc.columnMap[\'ResultStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SendBeginDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch2.SendBeginDate = (vc.SendBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SendBeginDate ng-required=false placeholder=\"{{vc.columnMap[\'SendBeginDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SendEndDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch2.SendEndDate = (vc.SendEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SendEndDate ng-required=false placeholder=\"{{vc.columnMap[\'SendEndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegBeginDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch2.RegBeginDate = (vc.RegBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.RegBeginDate ng-required=false placeholder=\"{{vc.columnMap[\'RegBeginDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegEndDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch2.RegEndDate = (vc.RegEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.RegEndDate ng-required=false placeholder=\"{{vc.columnMap[\'RegEndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch2></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div ng-class=\"vc.data.RptType == \'P\' ? \'col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\' : \'col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\'\"><div class=pull-right><button class=\"btn btn-default\" ng-click=\"vc.sendRpt(\'email\')\" ng-if=\"vc.data.RptType == \'P\'\"><i class=\"fa fa-mail-reply\"></i> 이메일 발송</button> <button class=\"btn btn-default\" ng-click=\"vc.sendRpt(\'sms\')\" ng-if=\"vc.data.RptType == \'P\'\"><i class=\"fa fa-mail-reply\"></i> 문자 발송</button> <button class=\"btn btn-default\" ng-click=vc.getFile()><i class=\"fa fa-folder-open-o\"></i> 다운로드</button> <button class=\"btn btn-default\" ng-click=vc.getData() ng-if=\"vc.data.downYN == \'N\'\"><i class=\"fa fa-refresh\"></i> 새로고침</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=\"vc.goPage(\'L\')\" ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=vc.data.SvyId><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNm readonly></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RptNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RptNm></div></div></div><div class=row><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" ng-if=vc.data.SvyId><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RptNum\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RptNum readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" ng-if=\"vc.data.RptType == \'P\'\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PsnRptStatus\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.PsnRptStatus readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ManagerNm\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn ng-if=\" ! vc.data.SvyId\"><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div></div><!-- tile body --><div class=\"panel-body collapse in\" ng-if=\"vc.data.RptType == \'P\'\"><!-- 버튼 그룹 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 btn-group2 mb-10\"><div class=pull-right><div class=form-group><div style=\"float:left; padding-right:2px\"><input type=file name=excelFile class=form-control ng-if=\" ! vc.data.SvyId\"></div><button class=\"btn btn-primary\" ng-click=vc.doUpload() ng-if=\" ! vc.data.SvyId\"><i class=\"fa fa-upload\"></i> 대상자 정보 갱신</button> <button class=\"btn btn-primary\" ng-click=vc.doDownload() ng-if=\" ! vc.data.SvyId\"><i class=\"fa fa-download\"></i> 양식 다운로드</button><div class=\"tile pull-right\"><button class=\"btn btn-danger tile-header\" tile-control-toggle><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button><div class=\"collapse delete-pick\"><ul><li ng-click=vc.setDelList()>데이터</li><li ng-click=vc.setDelFile()>보고서파일</li></ul></div></div></div></div></div></div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm:ss\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch2.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/report-list.html","<div class=\"page page-footable\" ng-controller=\"WjmReportListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>보고서 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.RptNm placeholder=\"보고서명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RptNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.RptNum type=text><label>{{vc.columnMap[\'RptNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RptNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.RptNm type=text><label>{{vc.columnMap[\'RptNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNm readonly type=text><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" ng-click=vc.srchSurveyModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSurvey(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Manager\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Manager readonly type=text><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RptType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'RptType\'].CodeList\" code-model=vc.srch.RptType></common-code-custom><label>{{vc.columnMap[\'RptType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"생성일시 검색시작일\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"생성일시 검색종료일\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><div class=\"tile pull-right\"><button class=\"btn btn-danger tile-header\" tile-control-toggle><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button><div class=\"collapse delete-pick\"><ul><li ng-click=vc.setDelList()>데이터</li><li ng-click=vc.setDelFile()>보고서파일</li></ul></div></div></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/report-mng-detail.html","<div class=\"page page-footable\" ng-controller=\"WjmReportMngDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>보고서 생성 관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.genOgnRpt() ng-if=\"vc.data.UseOgnRptYN == \'Y\'\"><i class=\"fa fa-mail-reply\"></i> 조직보고서 생성</button> <button class=\"btn btn-default\" ng-click=vc.genPsnRpt() ng-if=\"vc.data.UsePsnRptYN == \'Y\' && vc.data.PsnRptStatus != \'W\'\"><i class=\"fa fa-edit\"></i> 개인보고서 수동생성</button> <button class=\"btn btn-default\" ng-click=vc.getData()><i class=\"fa fa-refresh\"></i> 새로고침</button> <button class=\"btn btn-default\" ng-click=\"vc.goPage(\'L\')\" ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNm readonly></div></div></div><div class=row><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyDate\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyDate readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TgtCnt\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TgtCnt readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyStatus\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyStatus readonly></div></div></div><div class=row><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" ng-if=\"vc.data.UsePsnRptYN == \'Y\'\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'PsnRptStatus_\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.PsnRptStatus_ readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" ng-if=\"vc.data.UseOgnRptYN == \'Y\'\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'OgnRptStatus_\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.OgnRptStatus_ readonly></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/survey/report-mng-list.html","<div class=\"page page-footable\" ng-controller=\"WjmReportMngListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>보고서 생성 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SvyNm placeholder=\"설문제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNum type=text><label>{{vc.columnMap[\'SvyNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ManagerNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'ManagerNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNm type=text><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyBeginDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SvyBeginDate = (vc.SvyBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyBeginDate ng-required=false placeholder=\"{{vc.columnMap[\'SvyBeginDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyEndDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SvyEndDate = (vc.SvyEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyEndDate ng-required=false placeholder=\"{{vc.columnMap[\'SvyEndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'PsnRptStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'PsnRptStatus\'].CodeList\" code-model=vc.srch.PsnRptStatus></common-code-custom><label>{{vc.columnMap[\'PsnRptStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'OgnRptStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'OgnRptStatus\'].CodeList\" code-model=vc.srch.OgnRptStatus></common-code-custom><label>{{vc.columnMap[\'OgnRptStatus\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/report-search.html","<div class=\"page page-footable\" ng-controller=\"WjmReportSearchCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>보고서 검색</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Email placeholder=\"이메일 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Name\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Name type=text><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Email type=text><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SendBeginDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SendBeginDate = (vc.SendBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SendBeginDate ng-required=false placeholder=\"{{vc.columnMap[\'SendBeginDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SendEndDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SendEndDate = (vc.SendEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SendEndDate ng-required=false placeholder=\"{{vc.columnMap[\'SendEndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ResultStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ResultStatus\'].CodeList\" code-model=vc.srch.ResultStatus></common-code-custom><label>{{vc.columnMap[\'ResultStatus\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getFile()><i class=\"fa fa-list\"></i> 다운로드</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0 && vc.srch.chkSrch == \'Y\'\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody ng-if=\"vc.srch.chkSrch == \'N\'\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>보고서를 검색해 주세요.</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\" ng-if=\"vc.totalItems > 0\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.getFile(li) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm:ss\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/report-upload.html","<div class=\"page page-footable\" ng-controller=\"WjmReportUploadCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>외부 보고서 업로드</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary btn_save\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>보고서 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>보고서명</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.RptNm placeholder=\"\" ng-readonly=vc.chkRpt type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchRptModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseRpt() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>업체명</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn ng-if=\" ! vc.chkRpt\"><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>파일 첨부</label><div id=vault class=vault-block vault-company></div></form></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><div style=\"padding-left:75px; margin-top:-6px; height:500px; overflow:auto\"><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col width=*><col width=140></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list>{{fli.fileName}}</span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-primary btn_save\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/survey/result-detail.html","<div class=\"page page-footable\" ng-controller=\"WjmResultDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>결과 관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goTargetList()><i class=\"fa fa-mail-reply\"></i> 참여자별 결과보기</button> <button class=\"btn btn-default\" ng-click=\"vc.goPage(\'T\')\"><i class=\"fa fa-bar-chart-o\"></i> 참여추이 분석</button> <button class=\"btn btn-default\" ng-click=\"vc.goPage(\'L\')\" ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNm readonly></div></div></div><div class=row><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyDate\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyDate readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyStatus\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyStatus readonly></div></div></div><div class=row><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RespRltCnt\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RespRltCnt readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RespRltRate\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RespRltRate readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RespRltPCnt\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RespRltPCnt readonly></div></div></div></div></div></div></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>소개글</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><span ng-bind-html=vc.data.TopCont|htmlString></span></div></div></div></div></div></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>문항별 결과</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"form-group form-inline mb-10\"><div style=\"text-align: right; line-height: 25px !Important\" ng-show=vc.isOk><select class=form-control ng-model=vc.chtCd style=\"width:10% !Important; margin:0 !Important\"><option value=pie>파이</option><option value=line>꺾은 선</option><option value=horizontalBar>가로 막대</option><option value=bar>세로 막대</option></select><button class=\"btn btn-default mr-5\" ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> 엑셀</button><select class=form-control ng-model=vc.svyPagesCur style=\"width:10% !Important; margin:0 !Important\" ng-options=\"li.PageNo as li.Label for li in vc.svyPages\"><option value=\"\">-- 페이지 --</option></select></div></div></div></div><div class=row><div class=col-lg-12><div class=row ng-repeat=\"qt in vc.svyQsts\r\n                | filter : (vc.svyPagesCur == \'ALL\' ? \'\' : {PageNo: vc.svyPagesCur}) : (vc.svyPagesCur == \'ALL\' ? false : true)\"><!-- 선택형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'1\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"it in vc.svyQstItems | filter: {qtId: qt.qtId} : true\"><div style=\"width:70%; float:left\">{{it.QstItemNo}}. {{it.QstItemContents}}</div><div style=\"width:20%; float:left\" ng-if=vc.respListItm[it.itId]><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListItm[it.itId].RespRltRate}}%\">&nbsp;</div>{{vc.respListItm[it.itId].RespRltRate}}%</div><div style=\"width:20%; float:left\" ng-if=\" ! vc.respListItm[it.itId]\">0%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=vc.respListItm[it.itId]><a href=\"\" ng-click=\"vc.goTargetList(qt.QstType, it.itId)\">{{vc.respListItm[it.itId].RespRltCnt}}명</a></div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\" ! vc.respListItm[it.itId]\">0명</div></div></div><!-- 입력형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'2\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"width:70%; float:left\"><a href=\"\" ng-click=vc.showSbjList(qt.qtId);>[답변 목록 보기]</a></div><div style=\"width:20%; float:left\"><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListSbj[qt.qtId].RespRltRate}}%\">&nbsp;</div>{{vc.respListSbj[qt.qtId].RespRltRate}}%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\"vc.respListSbj[qt.qtId].RespRltCnt != 0\"><a href=\"\" ng-click=\"vc.goTargetList(qt.QstType, qt.qtId)\">{{vc.respListSbj[qt.qtId].RespRltCnt}}명</a></div></div><div class=\"pl-30 pt-10 pr-30\" ng-if=\"vc.showSbjQstId == qt.qtId\" ng-repeat=\"sbj in vc.respList | filter: {SvyQstId: qt.qtId} : true\"><div style=\"border-bottom:1px dotted #dedede\">{{sbj.SbjctResp}}</div></div></div><!-- 우선순위형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'3\'\"><div class=\"row w40 pt-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><div class=\"row pl-20 pb-10\" ng-repeat=\"it in vc.svyQstItems | filter: {qtId: qt.qtId} : true\"><div class=\"pt-10 pb-5\">{{it.QstItemNo}}. {{it.QstItemContents}}</div><div class=\"row pl-30 pt-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"num in qt.Nums\"><div style=\"width:70%; float:left\">{{num}} 순위</div><div style=\"width:20%; float:left\" ng-if=\"vc.respListTop[it.itId+\'_\'+num]\"><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListTop[it.itId+\'_\'+num].RespRltRate}}%\">&nbsp;</div>{{vc.respListTop[it.itId+\'_\'+num].RespRltRate}}%</div><div style=\"width:20%; float:left\" ng-if=\" ! vc.respListTop[it.itId+\'_\'+num]\">0%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\"vc.respListTop[it.itId+\'_\'+num]\"><a href=\"\" ng-click=\"vc.goTargetList(qt.QstType, it.itId, num)\">{{vc.respListTop[it.itId+\'_\'+num].RespRltCnt}}명</a></div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\" ! vc.respListTop[it.itId+\'_\'+num]\">0명</div></div></div></div><!-- 이미지형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'4\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><div style=padding-bottom:10px ng-show=\"qt.qtImgSrc != null && qt.qtImgSrc != \'\'\"><img ng-src={{qt.qtImgSrc}} style=margin-top:10px></div><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"it in vc.svyQstItems | filter: {qtId: qt.qtId} : true\"><div style=\"width:5%; float:left\" ng-show=\"it.itImgSrc != null && it.itImgSrc != \'\'\"><img ng-src={{it.itImgSrc}}></div><div style=\"width:60%; float:left\">{{it.QstItemNo}}. {{it.QstItemContents}}</div><div style=\"width:20%; float:left\" ng-if=vc.respListItm[it.itId]><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListItm[it.itId].RespRltRate}}%\">&nbsp;</div>{{vc.respListItm[it.itId].RespRltRate}}%</div><div style=\"width:20%; float:left\" ng-if=\" ! vc.respListItm[it.itId]\">0%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=vc.respListItm[it.itId]><a href=\"\" ng-click=\"vc.goTargetList(qt.QstType, it.itId)\">{{vc.respListItm[it.itId].RespRltCnt}}명</a></div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\" ! vc.respListItm[it.itId]\">0명</div></div></div><!-- 척도형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'5\'\"><div class=\"row w40 pt-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}} [척도형]</div></div><div class=\"row pl-20 pb-10\" ng-repeat=\"it in vc.svyQstItems | filter: {qtId: qt.qtId} : true\"><div class=\"pt-10 pb-5\">{{it.QstItemNo}}. {{it.QstItemContents}} ↔ {{it.QstItemContents2}}</div><div class=\"row pl-30 pt-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"num in qt.Nums\"><div style=\"width:70%; float:left\">{{num}}</div><div style=\"width:20%; float:left\" ng-if=\"vc.respListTop[it.itId+\'_\'+num]\"><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListTop[it.itId+\'_\'+num].RespRltRate}}%\">&nbsp;</div>{{vc.respListTop[it.itId+\'_\'+num].RespRltRate}}%</div><div style=\"width:20%; float:left\" ng-if=\" ! vc.respListTop[it.itId+\'_\'+num]\">0%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\"vc.respListTop[it.itId+\'_\'+num]\"><a href=\"\" ng-click=\"vc.goTargetList(qt.QstType, it.itId, num)\">{{vc.respListTop[it.itId+\'_\'+num].RespRltCnt}}명</a></div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\" ! vc.respListTop[it.itId+\'_\'+num]\">0명</div></div></div></div><!-- 분류정보 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'C\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><div><div ng-if=\"qt.ClassfyCd == \'NM\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"width:70%; float:left\"><a href=\"\" ng-click=vc.showSbjList(qt.qtId);>[답변 목록 보기]</a></div><div style=\"width:20%; float:left\"><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListSbj[qt.qtId].RespRltRate}}%\">&nbsp;</div>{{vc.respListSbj[qt.qtId].RespRltRate}}%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\"vc.respListSbj[qt.qtId].RespRltCnt != 0\">{{vc.respListSbj[qt.qtId].RespRltCnt}}명</div></div><div class=\"pl-30 pt-10 pr-30\" ng-if=\"vc.showSbjQstId == qt.qtId\" ng-repeat=\"sbj in vc.respList | filter: {SvyQstId: qt.qtId} : true\"><div style=\"border-bottom:1px dotted #dedede\">{{sbj.SbjctResp}}</div></div></div><div ng-if=\"qt.ClassfyCd == \'MB\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"width:70%; float:left\"><a href=\"\" ng-click=vc.showSbjList(qt.qtId);>[답변 목록 보기]</a></div><div style=\"width:20%; float:left\"><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListSbj[qt.qtId].RespRltRate}}%\">&nbsp;</div>{{vc.respListSbj[qt.qtId].RespRltRate}}%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\"vc.respListSbj[qt.qtId].RespRltCnt != 0\"><a href=\"\" ng-click=\"vc.goTargetList(\'MB\', qt.qtId)\">{{vc.respListSbj[qt.qtId].RespRltCnt}}명</a></div></div><div class=\"pl-30 pt-10 pr-30\" ng-if=\"vc.showSbjQstId == qt.qtId\" ng-repeat=\"sbj in vc.respList | filter: {SvyQstId: qt.qtId} : true\"><div style=\"border-bottom:1px dotted #dedede\">{{sbj.SbjctResp}}</div></div></div><div ng-if=\"qt.ClassfyCd == \'EM\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"width:70%; float:left\"><a href=\"\" ng-click=vc.showSbjList(qt.qtId);>[답변 목록 보기]</a></div><div style=\"width:20%; float:left\"><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListSbj[qt.qtId].RespRltRate}}%\">&nbsp;</div>{{vc.respListSbj[qt.qtId].RespRltRate}}%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\"vc.respListSbj[qt.qtId].RespRltCnt != 0\"><a href=\"\" ng-click=\"vc.goTargetList(\'EM\', qt.qtId)\">{{vc.respListSbj[qt.qtId].RespRltCnt}}명</a></div></div><div class=\"pl-30 pt-10 pr-30\" ng-if=\"vc.showSbjQstId == qt.qtId\" ng-repeat=\"sbj in vc.respList | filter: {SvyQstId: qt.qtId} : true\"><div style=\"border-bottom:1px dotted #dedede\">{{sbj.SbjctResp}}</div></div></div><div ng-if=\"qt.ClassfyCd == \'GD\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"width:70%; float:left\">남</div><div style=\"width:20%; float:left\"><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListSbj[qt.qtId +\'_M\'].RespRltRate}}%\">&nbsp;</div>{{vc.respListSbj[qt.qtId +\'_M\'].RespRltRate}}%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\"vc.respListSbj[qt.qtId +\'_M\'].RespRltCnt != 0\"><a href=\"\" ng-click=\"vc.goTargetList(\'GD\', qt.qtId, \'M\')\">{{vc.respListSbj[qt.qtId +\'_M\'].RespRltCnt}}명</a></div></div><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"width:70%; float:left\">여</div><div style=\"width:20%; float:left\"><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListSbj[qt.qtId +\'_F\'].RespRltRate}}%\">&nbsp;</div>{{vc.respListSbj[qt.qtId +\'_F\'].RespRltRate}}%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\"vc.respListSbj[qt.qtId +\'_F\'].RespRltCnt != 0\"><a href=\"\" ng-click=\"vc.goTargetList(\'GD\', qt.qtId, \'F\')\">{{vc.respListSbj[qt.qtId +\'_F\'].RespRltCnt}}명</a></div></div></div><div ng-if=\"qt.ClassfyCd != \'NM\' && qt.ClassfyCd != \'MB\' && qt.ClassfyCd != \'EM\' && qt.ClassfyCd != \'GD\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"it in vc.svyQstItems | filter: {qtId: qt.qtId} : true\"><div style=\"width:70%; float:left\">{{it.QstItemNo}}. {{it.QstItemContents}}</div><div style=\"width:20%; float:left\" ng-if=vc.respListItm[it.itId]><div class=mr-5 style=\"float:left; background:#dddddd; width:{{vc.respListItm[it.itId].RespRltRate}}%\">&nbsp;</div>{{vc.respListItm[it.itId].RespRltRate}}%</div><div style=\"width:20%; float:left\" ng-if=\" ! vc.respListItm[it.itId]\">0%</div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=vc.respListItm[it.itId]><a href=\"\" ng-click=\"vc.goTargetList(qt.QstType, it.itId)\">{{vc.respListItm[it.itId].RespRltCnt}}명</a></div><div class=pr-30 style=\"width:10%; float:left; text-align:right\" ng-if=\" ! vc.respListItm[it.itId]\">0명</div></div></div></div></div><!-- 설명글 --><div style=\"padding:10px 0 50px 0\" ng-if=\"qt.QstType == \'R\'\"><pre class=txt-pre>{{qt.QstSubject}}</pre></div></div></div></div></div></div></div></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>끝맺음말</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><span ng-bind-html=vc.data.BtmCont|htmlString></span></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/survey/result-list.html","<div class=\"page page-footable\" ng-controller=\"WjmResultListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>결과 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SvyNm placeholder=\"설문제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNum type=text><label>{{vc.columnMap[\'SvyNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ManagerNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'ManagerNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNm type=text><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyBeginDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SvyBeginDate = (vc.SvyBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyBeginDate ng-required=false placeholder=\"{{vc.columnMap[\'SvyBeginDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyEndDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SvyEndDate = (vc.SvyEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyEndDate ng-required=false placeholder=\"{{vc.columnMap[\'SvyEndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SvyStatus\'].CodeList\" code-model=vc.srch.SvyStatus></common-code-custom><label>{{vc.columnMap[\'SvyStatus\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goAnalysis()><i class=\"fa fa-mail-reply\"></i> 데이터 분석</button> <button class=\"btn btn-default\" ng-click=vc.getRawData()><i class=\"fa fa-file-excel-o\"></i> RawData 엑셀</button> <button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button><!--button class=\"btn btn-danger\" ng-click=\"vc.setDelList()\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button--></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/resv-send-list.html","<div class=\"page page-footable\" ng-controller=\"ResvSendListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>예약발송 대기 목록</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SvyNm placeholder=\"설문제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNm readonly type=text><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" ng-click=vc.srchSurveyModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSurvey(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CmpgnChannel\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.srch.CmpgnChannel></common-code-custom><label>{{vc.columnMap[\'CmpgnChannel\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ResvDateFrom = (vc.ResvDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.ResvDateFrom ng-required=false placeholder=\"예약일시 검색시작일\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ResvDateTo = (vc.ResvDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.ResvDateTo ng-required=false placeholder=\"예약일시 검색종료일\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-danger\" ng-click=vc.cancel()><i class=\"fa fa-trash-o\"></i> 예약발송 취소</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm:ss\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/sms-statistic.html","<div class=\"page page-footable\" ng-controller=\"SMSStatisticCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS 금액통계<!-- <div class=\"pull-right dock-header-tx list-split\">\r\n          <span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=\"assets/images/icon-sp-list.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=\"assets/images/icon-sp-rl.png\"></span>\r\n          <span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=\"assets/images/icon-sp-tb.png\"></span>\r\n        </div> --></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><!-- <div fa-pane fa-pane pane-anchor=\"{{vc.anchor}}\" pane-handle=\"4\" pane-max=\"80% + 2px\" pane-min=\"{{vc.paneMin}}\" pane-size=\"40% + 2px\"> --><div class=dataloader ng-show=vc.dataloader></div><!-- 검색 영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>검색화면</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><div class=row><!-- <div class=\"col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2\">\r\n	                      <div class=\"form-group form-inline\">\r\n                          <label>{{vc.columnMap.Distinc.ColumnLogicalNm}}</label>\r\n                          <common-code-custom code-list=\"vc.columnMap.Distinc.CodeList\" code-model=\"vc.srch.Distinc\" is-disabled=\"false\"></common-code-custom>\r\n	                      </div>\r\n	                    </div> --><div class=\"col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2\"><div class=\"form-group form-inline\"><label>{{vc.columnMap.SendType.ColumnLogicalNm}}</label><common-code-custom code-list=\"vc.columnMap[\'SendType\'].CodeList\" code-model=vc.srch.SendType is-disabled=false></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap.RegDate.ColumnLogicalNm}}</label><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>~</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap.CmpgnNm.ColumnLogicalNm}}</label><input type=text class=form-control ng-model=vc.srch.CmpgnNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 text-right\" style=\"margin-top: 4px\"><button type=button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> 조회</button></div></div></form></div></div></div></div><!-- 목록 --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th><th class=text-center style=width:10%>실패건수</th><th class=text-center style=width:10%>금액</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+2}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=\"vc.goEdit(li.KeyId, li.CmpgnType)\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | date :\'yyyy-MM-dd\')}}</td><td class=text-center>{{li.SendCnt - li.SendSucc}}</td><td class=text-center><span comma-bind ng-bind=\"li.SendSucc * vc.sendFee[li.CmpgnChannel]\"></span> 원</td></tr><!-- <tr ng-if=\"vc.lists.length > 0\" class=\"bg-lightyellow\">\r\n                      <td colspan=\"3\" class=\"text-center\">합계</td>\r\n                      <td class=\"text-center\"><span comma-bind ng-bind=\"vc.total.send\"></span></td>\r\n                      <td class=\"text-center\"><span comma-bind ng-bind=\"vc.total.succ\"></span></td>\r\n                      <td class=\"text-center\"><span comma-bind ng-bind=\"vc.total.fail\"></span></td>\r\n                      <td class=\"text-center\"><span comma-bind ng-bind=\"vc.total.amt\"></span>원</td>\r\n                    </tr> --><tr ng-if=\"vc.lists.length > 0\"><td colspan={{vc.listColumns.length+2}} class=bg-lightyellow><div class=pull-right><span>SMS(단문) 합계 : <span comma-bind ng-bind=vc.total.sms.cnt class=color-blue></span>건, <span comma-bind ng-bind=vc.total.sms.pri class=color-blue></span>원</span> // <span>MMS(장문) 합계 : <span comma-bind ng-bind=vc.total.mms.cnt class=color-blue></span>건, <span comma-bind ng-bind=vc.total.mms.pri class=color-blue></span>원</span> // <span>MMS(이미지) 합계 : <span comma-bind ng-bind=vc.total.img.cnt class=color-blue></span>건, <span comma-bind ng-bind=vc.total.img.pri class=color-blue></span>원</span> // <span>총합 : <span comma-bind ng-bind=vc.total.pri class=color-blue></span>원</span></div></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- </div> --></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/survey-detail.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"WjmSurveyViewCtrl as vc\"><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>설문 조회</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent><ui-view><div ng-controller=\"WjmSurveyViewCtrl as vc\"><!-- Action Buttons --><div class=row style=padding-bottom:5px><div class=col-lg-12><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-primary\" ng-click=vc.setData() ng-disabled=\"vc.data.SvyStatus != \'1\' && vc.data.SvyStatus != \'2\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setDelData() ng-disabled=\"vc.data.SvyStatus != \'1\' && vc.data.SvyStatus != \'2\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goCopyEdit()><i class=\"fa fa-copy\"></i> 복사후편집</button> <button class=\"btn btn-primary\" ng-click=vc.goCopyFormEdit()><i class=\"fa fa-save\"></i> 서식으로등록</button></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=pull-right><button class=\"btn btn-primary\" style=\"background-color:#fff; color:#ff6a00 !Important; border-color:#ff6a00\" ng-click=vc.setBegin(2) ng-show=\"vc.data.SvyStatus != \'2\'\"><i class=\"fa fa-arrow-right\"></i> 설문시작하기</button> <button class=\"btn btn-primary\" ng-click=\"vc.goSend(\'SMS\')\"><i class=\"fa fa-mail-reply\"></i> SMS발송</button> <button class=\"btn btn-primary\" ng-click=\"vc.goSend(\'EMAIL\')\"><i class=\"fa fa-mail-reply\"></i> 이메일발송</button> <button class=\"btn btn-primary\" ng-click=vc.goUrlPost()><i class=\"fa fa-internet-explorer\"></i> URL게시</button> <button class=\"btn btn-primary\" ng-click=vc.getExcelFile()><i class=\"fa fa-search\"></i> 설문지다운로드</button> <button class=\"btn btn-primary\" style=\"background-color:#fff; color:#ff6a00 !Important; border-color:#ff6a00\" ng-click=vc.setBegin(3) ng-show=\"vc.data.SvyStatus == \'2\'\"><i class=\"fa fa-arrow-right\"></i> 설문완료하기</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in pl-20\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-8><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SvyNm></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyNum\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNum readonly></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'SvyBeginDate\'].ColumnLogicalNm | translate}}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SvyBeginDate = (vc.SvyBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyBeginDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'SvyEndDate\'].ColumnLogicalNm | translate}}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SvyEndDate = (vc.SvyEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyEndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyStatus\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'SvyStatus\'].CodeList\" code-model=vc.data.SvyStatus is-disabled=true></common-code-custom></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>소개글</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><span ng-bind-html=vc.data.TopCont|htmlString></span></div></div></div></div></div></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>문항</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"pull-right mb-10\"><select class=form-control ng-model=vc.svyPagesCur ng-options=\"li.PageNo as li.Label for li in vc.svyPages\"><option value=\"\">-- 페이지 --</option></select></div></div></div><div class=row><div class=col-lg-12><div class=row ng-repeat=\"qt in vc.svyQsts\r\n                    | filter : (vc.svyPagesCur == \'ALL\' ? \'\' : {PageNo: vc.svyPagesCur}) : (vc.svyPagesCur == \'ALL\' ? false : true)\"><!-- 선택형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'1\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}} [선택형]</div></div><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"it in vc.svyQstItems | filter: {qtId: qt.qtId} : true\"><div style=\"width:70%; float:left\">{{it.QstItemNo}}. {{it.QstItemContents}}</div></div></div><!-- 입력형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'2\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}} [입력형]</div></div><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"border-bottom:1px dotted #dedede\">답변을 입력해주세요.</div></div></div><!-- 우선순위형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'3\'\"><div class=\"row w40 pt-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}} [우선순위형]</div></div><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"it in vc.svyQstItems | filter: {qtId: qt.qtId} : true\"><div style=\"width:70%; float:left\">{{it.QstItemNo}}. {{it.QstItemContents}}</div></div></div><!-- 이미지형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'4\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}} [이미지형]</div></div><div style=padding-bottom:10px ng-show=\"qt.qtImgSrc != null && qt.qtImgSrc != \'\'\"><img ng-src={{qt.qtImgSrc}} style=margin-top:10px></div><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"it in vc.svyQstItems | filter: {qtId: qt.qtId} : true\"><div style=\"width:5%; float:left\" ng-show=\"it.itImgSrc != null && it.itImgSrc != \'\'\"><img ng-src={{it.itImgSrc}}></div><div style=\"width:60%; float:left\">{{it.QstItemNo}}. {{it.QstItemContents}}</div></div></div><!-- 척도형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'5\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}} [척도형]</div></div><div class=\"row pl-10\" ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId} : true\" style=padding-top:10px><div class=col-lg-3>{{it.QstItemContents}}</div><div class=col-lg-6><ul style=\"display: table; width:100%\"><li style=\"display:table-cell; text-align: center\" ng-repeat=\"n in [].constructor(qt.ScaleMax) track by $index\"><input type=radio disabled style=margin-top:-3px> <span ng-if=\"qt.ScaleOrder==\'A\'\">{{$index + 1}}</span> <span ng-if=\"qt.ScaleOrder==\'D\'\">{{qt.ScaleMax - $index}}</span></li></ul></div><div class=\"col-lg-3 text-right\">{{it.QstItemContents2}}</div></div></div><!-- 분류정보 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'C\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}} [분류정보]</div></div><div><div ng-if=\"qt.ClassfyCd == \'NM\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\">답변을 입력해주세요.</div></div><div ng-if=\"qt.ClassfyCd == \'MB\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\">답변을 입력해주세요.</div></div><div ng-if=\"qt.ClassfyCd == \'EM\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\">답변을 입력해주세요.</div></div><div ng-if=\"qt.ClassfyCd == \'GD\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"width:70%; float:left\">남</div></div><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\"><div style=\"width:70%; float:left\">여</div></div></div><div ng-if=\"qt.ClassfyCd != \'NM\' && qt.ClassfyCd != \'MB\' && qt.ClassfyCd != \'EM\' && qt.ClassfyCd != \'GD\'\"><div class=\"row pl-20 pt-10\" style=\"border-bottom:1px dotted #dedede\" ng-repeat=\"it in vc.svyQstItems | filter: {qtId: qt.qtId} : true\"><div style=\"width:70%; float:left\">{{it.QstItemNo}}. {{it.QstItemContents}}</div></div></div></div></div><!-- 설명글 --><div style=\"padding:10px 0 20px 0\" ng-if=\"qt.QstType == \'R\'\"><pre class=txt-pre>{{qt.QstSubject}} [설명글]</pre></div></div></div></div></div></div></div></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>끝맺음말</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><span ng-bind-html=vc.data.BtmCont|htmlString></span></div><div class=col-lg-12 style=padding-top:10px ng-show=\"vc.data.ContactTxtYN == \'Y\'\"><span ng-bind-html=vc.data.ContactTxt|htmlString></span></div></div></div></div></div></div><!-- /row --></div></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/survey/survey-edit.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"WjmSurveyEditCtrl as vc\" ng-init=vc.init()><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>설문 등록/수정</h3></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.data.keyId != \'\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData() style=display:none ng-disabled=vc.isDisable()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goPreview()><i class=\"fa fa-list\"></i> 미리보기</button></div></div></div><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-8><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SvyNm></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyNum\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNum readonly></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline sm-mb0\"><label>{{vc.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.FormNm placeholder=\"\" readonly type=text> <span class=input-group-btn>{{vc.data.SvyStatus}} <button class=\"btn btn-default\" ng-click=vc.srchFormModal() type=button ng-disabled=\"vc.data.SvyStatus != null && vc.data.SvyStatus != \'1\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseForm() type=button ng-disabled=\"vc.data.SvyStatus != null && vc.data.SvyStatus != \'1\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline sm-mb0\"><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ManagerNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button ng-disabled=\"vc.data.SvyStatus != null && vc.data.SvyStatus != \'1\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button ng-disabled=\"vc.data.SvyStatus != null && vc.data.SvyStatus != \'1\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'TargetCnt\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=5 numbers-only=\"\" ng-model=vc.data.TargetCnt></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'SvyBeginDate\'].ColumnLogicalNm | translate}}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SvyBeginDate = (vc.SvyBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyBeginDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'SvyEndDate\'].ColumnLogicalNm | translate}}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SvyEndDate = (vc.SvyEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyEndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!--\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label class=\"txt-req\" style=\"font-size:11px;\">{{vc.columnMap[\'SvyEndMsg\'].ColumnLogicalNm | translate}}</label>\r\n                    <input type=\"text\" class=\"form-control form-right\" maxlength=\"200\" ng-model=\"vc.data.SvyEndMsg\">\r\n                  </div>\r\n                </div>\r\n                --><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>{{vc.columnMap[\'Gubun\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'Gubun\'].CodeList\" code-model=vc.data.Gubun></common-code-custom></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label class=txt-req>언어</label><div style=margin-left:70px><input type=radio ng-model=vc.data.SvyLang ng-checked=true style=\"width:25px !Important; margin:0 !Important\">한글 &nbsp;&nbsp; <input type=radio ng-model=vc.data.SvyLang value=ENG style=\"width:15px !Important; margin:0 !Important\">영어</div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer title=펼치기/접기><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문옵션</strong><div class=pull-right><i class=\"fa fa-minus fa-lg\"></i></div></div><!--<div class=\"panel-body collapse in\">--><div class=\"panel-body collapse out\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'QstPassYN\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.QstPassYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">허용 &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstPassYN value=N style=\"width:15px !Important; margin:0 !Important\"> 미허용</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RespLimitYN\'].ColumnLogicalNm | translate}}</label><div style=margin-left:70px><input type=radio ng-model=vc.data.RespLimitYN value=N ng-checked=true style=\"width:25px !Important; margin:0 !Important\">무제한 &nbsp;&nbsp; <input type=radio ng-model=vc.data.RespLimitYN value=Y style=\"width:15px !Important; margin:0 !Important\">제한<!--\r\n                      <input type=\"text\" class=\"form-control form-right\" maxlength=\"5\" numbers-only=\"\" ng-model=\"vc.data.RespLimitCnt\" style=\"width:50px; margin:0 !Important; display:inline-block;\">\r\n                      건으로 제한\r\n                      --></div></div></div><!--\r\n                <div class=\"col-lg-4\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label style=\"font-size:11px;\">{{vc.columnMap[\'RespLimitEndMsg\'].ColumnLogicalNm | translate}}</label>\r\n                    <input type=\"text\" class=\"form-control form-right\" maxlength=\"200\" ng-model=\"vc.data.RespLimitEndMsg\">\r\n                  </div>\r\n                </div>\r\n                --><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'LineColor\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input type=text class=\"form-control form-right\" maxlength=6 ng-model=vc.data.LineColor> <span class=input-group-btn><span id=spanLineColorData style=background-color:{{vc.data.LineColorData}};cursor:default class=\"btn btn-default\"></span> <button class=\"btn btn-default\" ng-click=vc.srchLineColor() type=button><i class=\"fa fa-search\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'QstNumYN\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.QstNumYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\"> 표시함 &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstNumYN value=N style=\"width:15px !Important; margin:0 !Important\"> 표시안함</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label style=font-size:11px>{{vc.columnMap[\'QstIconType\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.QstIconType value=N ng-checked=true style=\"width:25px !Important; margin:0 !Important\"> 사용안함 &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstIconType value=10 style=\"width:15px !Important; margin:0 !Important\"> <i ng-bind-html=wjmSurvey.qstIcon1|htmlString></i> &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstIconType value=20 style=\"width:15px !Important; margin:0 !Important\"> <i ng-bind-html=wjmSurvey.qstIcon2|htmlString></i> &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstIconType value=30 style=\"width:15px !Important; margin:0 !Important\"> <i ng-bind-html=wjmSurvey.qstIcon3|htmlString></i> &nbsp;&nbsp; <input type=radio ng-model=vc.data.QstIconType value=40 style=\"width:15px !Important; margin:0 !Important\"> <i ng-bind-html=wjmSurvey.qstIcon4|htmlString></i></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BoxColor\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input type=text class=\"form-control form-right\" maxlength=6 ng-model=vc.data.BoxColor> <span class=input-group-btn><span id=spanBoxColorData style=background-color:{{vc.data.BoxColorData}};cursor:default class=\"btn btn-default\"></span> <button class=\"btn btn-default\" ng-click=vc.srchBoxColor() type=button><i class=\"fa fa-search\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'LinkCRMYN\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.LinkCRMYN value=Y style=\"width:25px !Important; margin:0 !Important\"> 고객정보 연동 &nbsp;&nbsp; <input type=radio ng-model=vc.data.LinkCRMYN value=N ng-checked=true style=\"width:15px !Important; margin:0 !Important\"> 고객정보 비연동</div></div></div><div class=col-lg-8><div class=\"form-group form-inline\"><label style=font-size:11px>마케팅활용동의</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input ng-checked-=\"vc.data.InfoAgreeYN1 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN1 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'InfoAgreeYN1\'].ColumnLogicalNm | translate}} &nbsp;&nbsp; <input ng-checked-=\"vc.data.InfoAgreeYN2 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN2 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'InfoAgreeYN2\'].ColumnLogicalNm | translate}} &nbsp;&nbsp; <input ng-checked-=\"vc.data.InfoAgreeYN3 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN3 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'InfoAgreeYN3\'].ColumnLogicalNm | translate}} &nbsp;&nbsp; <input ng-checked-=\"vc.data.InfoAgreeYN4 == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.InfoAgreeYN4 ng-true-value=\"\'Y\'\" type=checkbox style=\"width:25px !Important; margin:0 !Important\"> {{vc.columnMap[\'InfoAgreeYN4\'].ColumnLogicalNm | translate}}</div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer title=펼치기/접기><strong style=\"letter-spacing: 0.5px\" class=ng-binding>소개글</strong><div class=pull-right><i class=\"fa fa-minus fa-lg\"></i></div></div><div class=\"panel-body collapse in\" id=se2_toggle_1><!-- 에디터의 경우 로딩전 접혔을경우 안나옴 --><div class=row><div class=col-lg-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: none\" ng-model=vc.data.TopCont></textarea></div></div><div class=row><div class=\"col-lg-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.setSvyDate()><i class=\"fa fa-plus\"></i> 설문기간추가</button></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer title=펼치기/접기><strong style=\"letter-spacing: 0.5px\" class=ng-binding>문항편집</strong><div class=pull-right><i class=\"fa fa-minus fa-lg\"></i></div></div><div class=\"panel-body collapse out\"><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyTypeNm\'].ColumnLogicalNm | translate }}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.SvyTypeNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchSvyTypeModal() type=button ng-disabled=\"(vc.data.FormId != null && vc.data.FormId != \'\') || (vc.data.SvyStatus != null && vc.data.SvyStatus != \'1\')\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSvyType() type=button ng-disabled=\"(vc.data.FormId != null && vc.data.FormId != \'\') || (vc.data.SvyStatus != null && vc.data.SvyStatus != \'1\')\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ClassfyInfoNm\'].ColumnLogicalNm | translate }}</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=vc.data.ClassfyInfoNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchClassfyInfoModal() type=button ng-disabled=\"vc.data.SvyStatus != null && vc.data.SvyStatus != \'1\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseClassfyInfo() type=button ng-disabled=\"vc.data.SvyStatus != null && vc.data.SvyStatus != \'1\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-12 style=padding:20px><div class=row style=\"background-color:#eee; border-top:1px solid #aaa\"><div class=col-sm-4><div class=\"form-group form-inline\"><label>문항유형</label><common-code-custom code-list=\"vc.columnMap[\'QstType\'].CodeList\" code-model=vc.batchQstType></common-code-custom></div></div><div class=col-sm-4><div class=\"form-group form-inline\"><label style=font-size:11px>페이지당반복수</label><div class=\"input-group custom-search-form\"><input type=text class=\"form-control form-right\" maxlength=2 numbers-only=\"\" ng-model=vc.batchCnt> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.setBatchQst()><i class=\"fa fa-plus\"></i> 일괄생성</button></span></div></div></div></div><div class=row style=\"background-color:#eee; border-top:1px solid #aaa; border-bottom:1px solid #aaa\"><div class=col-lg-4><div class=\"form-group form-inline\"><label>페이지</label><div class=\"input-group custom-search-form\"><select class=\"form-control inline-select\" ng-model=vc.svyPagesCur ng-options=\"li.PageNo as li.PageNo for li in vc.svyPages\"><option value=\"\">--선택--</option></select><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.setSvyPageAdd()><i class=\"fa fa-plus\"></i> 마지막에추가</button> <button class=\"btn btn-default\" ng-click=vc.setSvyPagePrevAdd()><i class=\"fa fa-plus\"></i> 이전에추가</button> <button class=\"btn btn-default\" ng-click=vc.setSvyPageDel()><i class=\"fa fa-remove\"></i> 페이지삭제</button></span></div></div></div><div class=col-sm-4><div class=\"form-group form-inline\"><label>문항유형</label><div class=\"input-group custom-search-form\"><common-code-custom code-list=\"vc.columnMap[\'QstType\'].CodeList\" code-model=vc.addQstType id=inline-select-common></common-code-custom><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.setSvyQstAdd()><i class=\"fa fa-plus\"></i> 문항추가</button></span></div></div></div></div></div></div><div class=row><div class=col-lg-12 style=\"padding:20px; max-width: 1000px\"><div class=row ng-repeat=\"qt in vc.svyQsts | filter : {PageNo: vc.svyPagesCur, stat: \'!D\'} : true\"><!-- 선택형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'1\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"fa fa-lock\" ng-show=\"qt.QstLock == \'Y\'\" title=\"서식으로 불러온 문항은 일부 편집기능이 제한됩니다.\"></span> <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\"><input type=radio name=rdo{{it.qtId}} style=margin-top:-3px disabled ng-if=\"qt.SelType==\'S\'\"> <input type=checkbox name=rdo{{it.qtId}} style=margin-top:-3px disabled ng-if=\"qt.SelType==\'M\'\"><!--{{it.QstItemNo}}. --> {{it.QstItemContents}} <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(it.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <input type=text class=form-control maxlength=100 ng-show=\'it.OtherRespYN == \"Y\"\' style=\"margin-left:15px !Important; max-width:80% !Important\" disabled></p></div></div><!-- 입력형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'2\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"fa fa-lock\" ng-show=\"qt.QstLock == \'Y\'\" title=\"서식으로 불러온 문항은 일부 편집기능이 제한됩니다.\"></span> <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><textarea class=form-control style=height:100px ng-show=\'qt.InputType == \"T\"\' maxlength=1000 disabled placeholder={{qt.InputHint}}></textarea><input type=text class=form-control maxlength=100 ng-show=\'qt.InputType == \"I\"\' style=\"max-width:80% !Important\" disabled placeholder={{qt.InputHint}}></div></div><!-- 우선순위형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'3\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"fa fa-lock\" ng-show=\"qt.QstLock == \'Y\'\" title=\"서식으로 불러온 문항은 일부 편집기능이 제한됩니다.\"></span> <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div class=row style=padding-top:10px><div class=col-sm-6 style=padding-bottom:10px><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\">{{it.QstItemNo}}. {{it.QstItemContents}} <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(it.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span></p></div><div class=col-sm-6><p ng-repeat=\"n in [].constructor(qt.QstTopCnt) track by $index\" style=padding-bottom:5px><select class=form-control disabled><option>--{{$index + 1}}순위 선택--</option></select></p></div></div></div><!-- 이미지형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'4\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"fa fa-lock\" ng-show=\"qt.QstLock == \'Y\'\" title=\"서식으로 불러온 문항은 일부 편집기능이 제한됩니다.\"></span> <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><p style=padding-bottom:10px ng-show=\"qt.qtImgSrc != null && qt.qtImgSrc != \'\'\"><img ng-src={{qt.qtImgSrc}}></p><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\" style=padding-bottom:5px><input type=radio name=rdo{{it.qtId}} style=margin-top:-3px disabled><span ng-show=\"it.itImgSrc != null && it.itImgSrc != \'\'\">&nbsp;&nbsp;&nbsp;<img ng-src={{it.itImgSrc}}>&nbsp;&nbsp;</span><!--{{it.QstItemNo}}. --> {{it.QstItemContents}} <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(it.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span></p></div></div><!-- 척도형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'5\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"fa fa-lock\" ng-show=\"qt.QstLock == \'Y\'\" title=\"서식으로 불러온 문항은 일부 편집기능이 제한됩니다.\"></span> <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><div class=row ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\"><div class=col-lg-3>{{it.QstItemContents}}</div><div class=col-lg-6><ul style=\"display: table; width:100%\"><li style=\"display:table-cell; text-align: center\" ng-repeat=\"n in [].constructor(qt.ScaleMax) track by $index\"><input type=radio name=rdo{{it.itId}} style=margin-top:-3px disabled> <span ng-if=\"qt.ScaleOrder==\'A\'\">{{$index + 1}}</span><span ng-if=\"qt.ScaleOrder==\'D\'\">{{qt.ScaleMax - $index}}</span></li></ul></div><div class=\"col-lg-3 text-right\">{{it.QstItemContents2}}</div></div></div></div><!-- 분류정보 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'C\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8><pre class=txt-pre-tit>{{qt.QstNo}}. {{qt.QstSubject}} {{wjmSurvey.getQstTypeNm(qt.QstType)}}</pre></div><div class=\"col-lg-4 text-right\"><span class=\"fa fa-lock\" ng-show=\"qt.QstLock == \'Y_\' || qt.QstLock == \'Y\'\" title=\"서식으로 불러온 문항은 일부 편집기능이 제한됩니다.(분류정보만 저장전까지 편집가능)\"></span> <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(qt.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstGoto(qt.qtId) style=margin-top:-3px><i class=\"fa fa-chain\"></i> 분기</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y_\' || qt.QstLock == \'Y\'\"><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y_\' || qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><div ng-if=\"qt.ClassfyCd == \'NM\'\"><div class=\"form-group form-inline\"><input type=text class=form-control maxlength=30 style=\"margin-left:0 !Important; max-width:158px !Important\" disabled></div></div><div ng-if=\"qt.ClassfyCd == \'MB\'\"><div class=\"form-group form-inline\"><input type=text class=form-control maxlength=13 style=\"margin-left:0 !Important; max-width:158px !Important\" disabled></div></div><div ng-if=\"qt.ClassfyCd == \'EM\'\"><div class=form-inline><div class=form-group><input type=text class=form-control maxlength=30 style=\"margin-left:0 !Important; width:100% !Important\" disabled></div><div class=form-group>@</div><div class=form-group><input type=text class=form-control maxlength=30 style=\"margin-left:0 !Important; width:100% !Important\" disabled></div><div class=form-group><select class=form-control style=\"margin-left:0 !Important; width:100% !Important\" disabled><option value=\"\">직접입력</option></select></div></div></div><div ng-if=\"qt.ClassfyCd == \'GD\'\"><p><input type=radio name=rdoGD style=margin-top:-3px disabled><!--{{it.QstItemNo}}. --> 남</p><p><input type=radio name=rdoGD style=margin-top:-3px disabled><!--{{it.QstItemNo}}. --> 여</p></div><div ng-if=\"qt.ClassfyCd != \'NM\' && qt.ClassfyCd != \'MB\' && qt.ClassfyCd != \'EM\' && qt.ClassfyCd != \'GD\'\"><!--\r\n                          <select class=\"form-control\" style=\"margin-left:0 !Important; max-width:158px !Important;\" disabled>\r\n                            <option value=\"\">--선택--</option>\r\n                          </select>\r\n                          --><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\"><input type=radio name=rdo{{it.qtId}} style=margin-top:-3px disabled> {{it.QstItemContents}} <span class=\"glyphicon glyphicon-arrow-right\" ng-show=vc.getGotoInfoFrom(it.GoToQstId) title=\"출발분기가 설정된 문항입니다.\"></span></p><p style=color:#999;font-size:10px;padding-top:10px>(실제 응답시에는 선택박스로 표시됩니다.)</p></div></div></div><!-- 설명글 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'R\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\"><div class=col-lg-8>{{wjmSurvey.getQstTypeNm(qt.QstType)}} 하단의 설명글이 표시됩니다.<!--이곳을 드레그하여 문항을 이동합니다.--></div><div class=\"col-lg-4 text-right\"><span class=\"fa fa-lock\" ng-show=\"qt.QstLock == \'Y\'\" title=\"서식으로 불러온 문항은 일부 편집기능이 제한됩니다.\"></span><!--<span class=\"glyphicon glyphicon-arrow-right\" ng-show=\"vc.getGotoInfoFrom(qt.GoToQstId)\" title=\"출발분기가 설정된 문항입니다.\"></span>--> <span class=\"glyphicon glyphicon-arrow-left\" ng-show=vc.getGotoInfoTo(qt.qtId) title=\"도착분기가 설정된 문항입니다.\"></span> <span class=\"fa fa-sign-out\" ng-show=\"qt.QstEndType == \'F\'\" title=\"종료가 설정된 문항입니다.\"></span> <button class=\"btn btn-default\" ng-click=vc.setSvyQstEdit(qt.qtId) style=margin-top:-3px><i class=\"fa fa-edit\"></i> 편집</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstMove(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"glyphicon glyphicon-move\"></i> 이동</button> <button class=\"btn btn-default\" ng-click=vc.setSvyQstDel(qt.qtId) style=margin-top:-3px ng-disabled=\"qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div style=padding-top:10px><pre class=txt-pre>{{qt.QstSubject}}</pre></div></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\" tile-control-toggle=\"\" style=cursor:pointer title=펼치기/접기><strong style=\"letter-spacing: 0.5px\" class=ng-binding>끝맺음말</strong><div class=pull-right><i class=\"fa fa-minus fa-lg\"></i></div></div><div class=\"panel-body collapse in\" id=se2_toggle_2><!-- 에디터의 경우 로딩전 접혔을경우 안나옴 --><div class=row><div class=col-lg-12><div class=\"col-lg-12 text-warning mb-10\">치환문구 : {TgtNm} 응답자명</div><textarea id=strHtml2 rows=10 style=\"width: 100%; height: 300px; display: none\" ng-model=vc.data.BtmCont></textarea></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BtmType\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.BtmType value=100 ng-checked=true style=\"width:25px !Important; margin:0 !Important\"> 편집한 내용 &nbsp;&nbsp; <input type=radio ng-model=vc.data.BtmType value=200 style=\"width:15px !Important; margin:0 !Important\"> 기준점에 따른 미니결과</div></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ContactTxtYN\'].ColumnLogicalNm | translate}}</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.data.ContactTxtYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">사용 &nbsp;&nbsp; <input type=radio ng-model=vc.data.ContactTxtYN value=N style=\"width:15px !Important; margin:0 !Important\"> 미사용</div></div></div></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.data.keyId != \'\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn_save\" ng-click=vc.setData() style=display:none ng-disabled=vc.isDisable()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goPreview()><i class=\"fa fa-list\"></i> 미리보기</button></div></div></div></form></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n  var sLang = \"ko_KR\";\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      fOnBeforeUnload : function() {\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n      $(\"#se2_toggle_1\").removeClass(\"in\").addClass(\"out\");\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml2\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      fOnBeforeUnload : function() {\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n      $(\"#se2_toggle_2\").removeClass(\"in\").addClass(\"out\");\r\n      $(\".btn_save\").show();\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/survey/survey-email-send.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"SurveyEmailSendCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>이메일 발송</h3></div><!-- /.col-lg-12 --></div><!-- Action Buttons --><!-- /page header --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-envelope-o\"></i> 발송</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>이메일 발송</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><!--위너스제이엠 이메일 화면--><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>설문</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SurveyNm readonly> <span class=input-group-btn ng-if=\"vc.data.RptId == null\"><button class=\"btn btn-default\" type=button ng-click=vc.srchSurveyModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseSurvey();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>서식</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.FormNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchFormModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseFrom();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row ng-if=\"vc.data.RptId == null\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>수신인</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GrpNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchGrpTreeModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseGroup();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>대상자</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.GrpTotal readonly></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"vc.data.RptId == null\"><div class=\"form-group form-inline\"><button class=\"btn btn-default\" ng-click=vc.editTargetList()><i class=\"fa fa-list\"></i> 대상자 편집</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>회신메일</label><select ng-model=vc.data.Favorite ng-options=\"data.Code as data.CodeValue for data in vc.favEmailList\" class=form-control ng-change=vc.changeEmail()><option value=\"\">--선택--</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-3\"><div class=form-group><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.FromInfo ng-disabled=\"vc.data.Favorite !=\'setValue\'\"></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-4\"><div class=\"form-group form-inline\"><button class=\"btn btn-default\" ng-click=vc.setFavEmail() ng-disabled=\"vc.data.Favorite !=\'setValue\'\"><i class=\"fa fa-list\"></i> 자주쓰는메일 등록</button> <button class=\"btn btn-default\" ng-click=vc.srchFavoriyModal()><i class=\"fa fa-list\"></i> 자주쓰는메일 관리</button></div></div></div><div class=row ng-if=\"vc.data.Favorite ==\'setValue\'\"><div class=col-lg-4></div><div class=\"col-xl-8 text-warning mb-10\">* 직접 입력할 경우 자주쓰는메일에 등록 후 사용하셔야 정상적으로 발송됩니다.</div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>발송일시</label><div class=\"inline-box brd1 p-5 bd-rd4\"><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-6\"><label class=radio-inline><input type=radio ng-model=vc.data.SendDtType value=100 ng-checked=true> 즉시발송</label></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-6\"><label class=radio-inline><input type=radio ng-model=vc.data.SendDtType value=200> 예약발송</label></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-2\" ng-if=\"vc.data.SendDtType == \'200\'\"><div class=form-group><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SendDt = (vc.SendDt | date: \'yyyy-MM-dd\')\" ng-model=vc.SendDt ng-required=false placeholder=발송일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-2\" ng-if=\"vc.data.SendDtType == \'200\'\"><div class=form-group><select ng-model=vc.data.SendHour ng-options=\"data.time as data.time for data in vc.sendHourList\" class=form-control><option value=\"\">시간</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-2\" ng-if=\"vc.data.SendDtType == \'200\'\"><div class=form-group><select ng-model=vc.data.SendMin ng-options=\"data.time as data.time for data in vc.sendMinList\" class=form-control><option value=\"\">분</option></select></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>메일제목</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SendTitle></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><!--/위너스제이엠 이메일 화면--></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><input type=text id=txtSvyUrl ng-model=vc.data.SvyUrl style=display:none><!-- type = hidden 인경우 값을 가져오지 못함 --></div><script type=text/javascript>var oEditors = [];\r\n\r\n      var sLang = \"en_US\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n      // 추가 글꼴 목록\r\n      //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n\r\n        nhn.husky.EZCreator.createInIFrame({\r\n          oAppRef : oEditors,\r\n          elPlaceHolder : \"strHtml\",\r\n          sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n          htParams : {\r\n            bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n            bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n            bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n            bSkipXssFilter : true,    // client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n            //aAdditionalFontList : aAdditionalFontSet,   // 추가 글꼴 목록\r\n            fOnBeforeUnload : function() {\r\n              //alert(\"완료!\");\r\n            },\r\n            I18N_LOCALE : sLang\r\n          }, //boolean\r\n          fOnAppLoad : function() {\r\n            //예제 코드\r\n            oEditors.getById[\"strHtml\"].exec(\"PASTE_HTML\", [$(\"#txtSvyUrl\").val()]);\r\n          },\r\n          fCreator : \"createSEditor2\"\r\n        });</script>");
$templateCache.put("app/survey/survey-group-list.html","<style>md-sidenav { max-width: 100% !Important; }</style><div class=\"page page-footable\" ng-controller=\"SurveyTargetListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>수신인 관리</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.GrpNm placeholder=수신인명 type=text><div class=\"search_layer mb-2\" ng-click=vc.nextSearch() style=\"width:45px !important\"><span class=cursor id=btn_layer_detail_search_open><i class=\"fa fa-search\"></i></span></div></div><!-- /col --></div><!-- 검색영역 --></form><div class=row style=padding-top:8px><div class=col-lg-3><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>수신인 그룹</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><md-sidenav md-component-id=left md-is-locked-open=true><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">수신인명</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl style=min-height:600px><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.GrpNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav></div></div></div><div class=col-lg-9><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>그룹정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-default\" activate-button ng-click=vc.resetList()><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETLIST\' | translate }}</button> <button type=button class=\"btn btn-primary\" activate-button ng-click=try_adding_a_branch() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=submit class=\"btn btn-primary\" activate-button ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\" ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 수신인입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div><div class=col-lg-6><div class=\"form-group form-inline\"><label>수신인명</label><input type=text class=form-control ng-model=vc.data.GrpNm ng-change=vc.onChangeGrpNm() ng-required=true> <input type=hidden class=form-control ng-model=vc.data.GrpId> <input type=hidden class=form-control ng-model=vc.data.GrpLevel> <input type=hidden class=form-control ng-model=vc.data.ParentGrpId></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>업체</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.ManagerNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchUserModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseUser();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>정렬순서</label><input type=text class=form-control ng-model=vc.data.SortSeq ng-change=vc.onChanged()></div></div></div></form></div></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>수신인 목록</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 btn-group2\"><div class=pull-right><div class=form-group><div style=\"float:left; padding-right:2px\"><input type=file name=excelFile class=form-control></div><button class=\"btn btn-primary\" ng-click=vc.doUpload()><i class=\"fa fa-file-o\"></i> 일괄 업로드</button> <button class=\"btn btn-primary\" ng-click=vc.excelform()><i class=\"fa fa-file-o\"></i> 양식 다운로드</button></div></div></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:10px><button class=\"btn btn-primary\" activate-button ng-click=vc.GroupCustEditModal() ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-edit\"></i> 고객추가</button> <button class=\"btn btn-danger\" activate-button ng-click=\"vc.deleteGrpcust(\'\')\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-trash-o\"></i> 선택고객삭제</button> <button class=\"btn btn-danger\" activate-button ng-click=\"vc.deleteGrpcust(\'ALL\')\" ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-trash-o\"></i> 전체고객삭제</button> <button class=\"btn btn-danger\" activate-button ng-click=vc.alertMsg() ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-trash-o\"></i> 거부/오류대상삭제</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.srchTreeModal() ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-edit\"></i> 다른 수신인에 추가</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.getExcelFile() ng-show=\"vc.data.New != \'Y\' && vc.data.GrpId != null\"><i class=\"fa fa-file-excel-o\"></i> 엑셀</button></div></div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T2.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.grpcustListColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T2.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.grpcustTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.grpcustListColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.grpcustLists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.grpcustListColumns\">{{liCol.ColumnLogicalDataType != \'40\' ? li[liCol.ColumnPhysicalNm] : (li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\':\'UTC\')}}</td></tr></table><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.grpcustTotalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.grpcustTotalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div></div></div></div></div></div></div><!-- pagecontent --></div>");
$templateCache.put("app/survey/survey-list.html","<div class=\"page page-footable\" ng-controller=\"WjmSurveyListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>설문 목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SvyNm placeholder=\"설문제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNum\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNum type=text><label>{{vc.columnMap[\'SvyNum\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ManagerNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ManagerNm readonly type=text><label>{{vc.columnMap[\'ManagerNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNm type=text><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyBeginDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SvyBeginDate = (vc.SvyBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyBeginDate ng-required=false placeholder=\"{{vc.columnMap[\'SvyBeginDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyEndDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.SvyEndDate = (vc.SvyEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SvyEndDate ng-required=false placeholder=\"{{vc.columnMap[\'SvyEndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SvyStatus\'].CodeList\" code-model=vc.srch.SvyStatus></common-code-custom><label>{{vc.columnMap[\'SvyStatus\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox ng-disabled=\"li.SvyStatusCd != \'1\' && li.SvyStatusCd != \'2\'\"></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/survey-send-result-list.html","<div class=\"page page-footable\" ng-controller=\"SurveySendResultListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>결과 관리</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Name placeholder=\"이름 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Email type=text><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SendType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SendType\'].CodeList\" code-model=vc.srch.SendType></common-code-custom><label>{{vc.columnMap[\'SendType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ResultStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ResultStatus\'].CodeList\" code-model=vc.srch.ResultStatus></common-code-custom><label>{{vc.columnMap[\'ResultStatus\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm:ss\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/survey-send-totresult-list.html","<div class=\"page page-footable\" ng-controller=\"SurveySendTotResultListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>전체 발송 이력 관리</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SvyNm placeholder=\"설문제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNm readonly type=text><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" ng-click=vc.srchSurveyModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSurvey(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CmpgnChannel\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.srch.CmpgnChannel></common-code-custom><label>{{vc.columnMap[\'CmpgnChannel\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ToNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ToNm type=text><label>{{vc.columnMap[\'ToNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Email type=text><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ResultStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ResultStatus\'].CodeList\" code-model=vc.srch.ResultStatus></common-code-custom><label>{{vc.columnMap[\'ResultStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"발송일시 검색시작일\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"발송일시 검색종료일\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goView(li) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm:ss\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/survey-sms-send.html","<div class=\"page page-footable\" ng-controller=\"SurveySmsSendCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row><div class=col-lg-12><h3 class=page-header>SMS 발송</h3></div><!-- /.col-lg-12 --></div><!-- Action Buttons --><!-- /page header --><div class=pagecontent file-dropzone><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-mobile-phone\"></i> 발송</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>SMS 발송</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><!--위너스제이엠 SMS발송 화면--><div class=row><!--좌측 선택화면 --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>설문</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.SurveyNm readonly> <span class=input-group-btn ng-if=\"vc.data.RptId == null\"><button class=\"btn btn-default\" type=button ng-click=vc.srchSurveyModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseSurvey();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row ng-if=\"vc.data.RptId == null\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>수신인</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.GrpNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchGrpTreeModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseGroup();><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>대상자</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.GrpTotal readonly></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"vc.data.RptId == null\"><div class=\"form-group form-inline\"><button class=\"btn btn-default\" ng-click=vc.editTargetList()><i class=\"fa fa-list\"></i> 대상자 편집</button></div></div></div><div class=row><div class=\"col-xs-6 col-sm-4 col-md-4 col-lg-4\"><div class=\"form-group form-inline\"><label>회신번호</label><select ng-model=vc.data.Favorite ng-options=\"data.SendNumber as data.SendNumber for data in vc.favTelnoList\" class=form-control ng-change=vc.changeTelno()><option value=\"\">--선택--</option></select></div></div><!--div class=\"col-xs-6 col-sm-3 col-md-3 col-lg-3\">\r\n                          <div class=\"form-group\">\r\n                            <input type=\"text\" class=\"form-control form-right\" maxlength=\"100\" ng-model=\"vc.data.FromInfo\" ng-disabled=\"vc.data.Favorite !=\'setValue\'\">\r\n                          </div>\r\n                        </div>\r\n                        <div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5\">\r\n                          <div class=\"form-group form-inline\">\r\n                            <button class=\"btn btn-default\" ng-click=\"vc.setFavTelNo()\" ng-disabled=\"vc.data.Favorite !=\'setValue\'\">\r\n                              <i class=\"fa fa-list\"></i> 자주쓰는번호 등록\r\n                            </button>\r\n                            <button class=\"btn btn-default\" ng-click=\"vc.srchFavoriyModal()\">\r\n                              <i class=\"fa fa-list\"></i> 자주쓰는번호 관리\r\n                            </button>\r\n                          </div>\r\n                        </div--></div><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>발송일시</label><div class=\"inline-box brd1 p-5 bd-rd4\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio ng-model=vc.data.SendDtType value=100 ng-checked=true> 즉시발송</label></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><label class=radio-inline><input type=radio ng-model=vc.data.SendDtType value=200> 예약발송</label></div></div></div></div><div class=\"col-xs-4 col-sm-2 col-md-2 col-lg-2\" ng-if=\"vc.data.SendDtType == \'200\'\"><div class=form-group><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SendDt = (vc.SendDt | date: \'yyyy-MM-dd\')\" ng-model=vc.SendDt ng-required=false placeholder=발송일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-4 col-sm-2 col-md-2 col-lg-2\" ng-if=\"vc.data.SendDtType == \'200\'\"><div class=form-group><select ng-model=vc.data.SendHour ng-options=\"data.time as data.time for data in vc.sendHourList\" class=form-control><option value=\"\">시간</option></select></div></div><div class=\"col-xs-4 col-sm-2 col-md-2 col-lg-2\" ng-if=\"vc.data.SendDtType == \'200\'\"><div class=form-group><select ng-model=vc.data.SendMin ng-options=\"data.time as data.time for data in vc.sendMinList\" class=form-control><option value=\"\">분</option></select></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>충전금액</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.limitAmt comma readonly></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>사용금액</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.Amt comma readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>발송유형</label><select class=form-control ng-model=vc.data.SendType ng-options=\"cd.Code as cd.CodeValue for cd in vc.sendTypeList\"></select></div></div></div><div class=row ng-show=\"vc.data.SendType == \'MMS_IMG\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><p style=\"padding-left: 75px; color: #cacaca\">MMS 첨부이미지 [JPG 1건, 최대 300KB]</p></div></div></div><!-- file upload--><div class=row ng-show=\"vc.data.SendType == \'MMS_IMG\'\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label title=\"{{ \'Menu.ATTACHEDFILE\' | translate }}\">{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id=vault class=vault-block></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><!--/좌측 선택화면 --><!--우측 미리보기 화면--><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=row ng-show=\"vc.data.SendType != \'SMS\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>제목</label><input type=text class=form-control ng-model=vc.data.SendTitle></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>내용</label><textarea rows=10 class=\"form-control form-right\" ng-model=vc.data.SendMessage ng-change=vc.chkSendMessage(vc.bytesCheck)></textarea><div class=text-right>{{vc.Contents}} / {{vc.data.SendType ==\'SMS\' ? vc.changeSendType(\'SMS\') : vc.data.SendType ==\'MMS\' ? vc.changeSendType(\'MMS\') : vc.data.SendType ==\'MMS_IMG\' ? vc.changeSendType(\'MMS_IMG\') : vc.changeSendType(\'Null\')}} bytes</div></div></div></div></div><!--/우측 미리보기 화면--></div><!--/위너스제이엠 SMS발송 화면--></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div>");
$templateCache.put("app/survey/survey-type-edit.html","<!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"SurveyTypeEditCtrl as vc\"><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>설문유형 및 기준점 관리</h3></div></div><!-- page content --><div class=pagecontent><ui-view><div ng-controller=\"SurveyTypeEditCtrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData() ng-disabled=\"vc.data.ChkSvy == \'Y\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-disabled=\"vc.data.ChkSvy == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문유형</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in pl-20\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-9\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyTypeNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SvyTypeNm></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyTypeCd\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-change=vc.getIsDupSvyTypeCd() maxlength=4 ng-model=vc.data.SvyTypeCd></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ScoringType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'ScoringType\'].CodeList\" code-model=vc.data.ScoringType></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\" ng-if=\"vc.data.ScoringType != \'N\'\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TotType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'TotType\'].CodeList\" code-model=vc.data.TotType></common-code-custom></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.data.UseYN></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UsePsnRptYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UsePsnRptYN\'].CodeList\" code-model=vc.data.UsePsnRptYN></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'UseOgnRptYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'UseOgnRptYN\'].CodeList\" code-model=vc.data.UseOgnRptYN></common-code-custom></div></div></div></form></div><!-- /tile body --></div><!-- /tile --><style>md-sidenav { max-width: 100% !Important; }</style><div class=row ng-if=\"vc.srch.keyId != \'\'\"><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>문항영역</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><md-sidenav md-component-id=left md-is-locked-open=true><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl style=min-height:100px><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.QstSecNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav><form ng-submit=vc.saveData()><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-default\" activate-button ng-click=vc.resetList()><i class=\"fa fa-refresh\"></i> 초기화</button> <button type=button class=\"btn btn-primary\" activate-button ng-click=try_adding_a_branch() ng-if=\"vc.addBtnShow && vc.treedata.QstSecLevel != \'2\'\" ng-disabled=\"vc.data.ChkSvy == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-if=vc.treedata.QstSecId ng-disabled=\"vc.data.ChkSvy == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=submit class=\"btn btn-primary\" activate-button ng-if=\"vc.treedata.New == \'Y\' || vc.treedata.Edit == \'Y\'\" ng-disabled=\"vc.data.ChkSvy == \'Y\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button type=button class=\"btn btn-primary\" activate-button ng-click=\"vc.goScoreLvModal(\'sec\')\" ng-if=\"vc.data.ScoringType != \'N\'\"><i class=\"fa fa-edit\"></i> 기준점</button> <button type=button class=\"btn btn-primary\" activate-button ng-click=\"vc.goScoreLvModal(\'tot\')\" ng-if=\"vc.data.ScoringType != \'N\'\"><i class=\"fa fa-edit\"></i> 기준총점</button></div></div><div class=row ng-if=\"vc.treedata.New == \'Y\' || vc.treedata.QstSecId\"><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.treedata.New == \'Y\' || vc.treedata.Edit == \'Y\'\">* 편집 후 저장 버튼을 눌러 주세요.</div><div class=col-lg-6><div class=\"form-group form-inline\"><label>문항영역명</label><input type=text class=form-control ng-model=vc.treedata.QstSecNm ng-change=vc.onChangeQstSecNm() ng-required=true ng-disabled=\"vc.data.ChkSvy == \'Y\'\"> <input type=hidden class=form-control ng-model=vc.treedata.QstSecId> <input type=hidden class=form-control ng-model=vc.treedata.QstSecLevel> <input type=hidden class=form-control ng-model=vc.treedata.ParentQstSecId></div></div></div><div class=row><div class=col-lg-3><div class=\"form-group form-inline\"><label>정렬순서</label><input type=text class=form-control ng-model=vc.treedata.SortSeq ng-disabled=\"vc.data.ChkSvy == \'Y\'\" ng-change=vc.onChanged() maxlength=3 numbers-only=\"\" required></div></div><div class=col-lg-3 ng-if=\"vc.treedata.QstSecLevel != \'2\' && (vc.data.ScoringType == \'C\' || vc.data.ScoringType == \'U\')\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SecScoringType\'].ColumnLogicalNm | translate }}</label><select class=form-control ng-model=vc.treedata.ScoringType ng-change=vc.onChanged() ng-disabled=\"vc.data.ChkSvy == \'Y\'\" ng-options=\"cd.Code as cd.CodeValue for cd in vc.columnMap[\'SecScoringType\'].CodeList\" required><option value=\"\">---- 선택 ----</option></select></div></div><div class=col-lg-3 ng-if=\"vc.treedata.QstSecLevel != \'2\' && (vc.treedata.ScoringType == \'C\')\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TotalType\'].ColumnLogicalNm | translate }}</label><select class=form-control ng-model=vc.treedata.TotalType ng-change=vc.onChanged() ng-disabled=\"vc.data.ChkSvy == \'Y\'\" ng-options=\"cd.Code as cd.CodeValue for cd in vc.columnMap[\'TotalType\'].CodeList\" required><option value=\"\">---- 선택 ----</option></select></div></div></div></div></form></div></div></div></div><!-- /col --></div><!-- /row --></div></div></ui-view></div><!-- /page content --></div>");
$templateCache.put("app/survey/survey-type-list.html","<div class=\"page page-footable\" ng-controller=\"SurveyTypeListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>설문유형 및 기준점 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size=\"40% + 2px\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SvyTypeNm placeholder=\"설문유형명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyTypeNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyTypeNm type=text><label>{{vc.columnMap[\'SvyTypeNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UseYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.srch.UseYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/target-result-edit.html","<div class=\"page page-footable\" ng-controller=\"TargetResultEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>참여자별 결과</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goScoreLvModal() ng-if=\"vc.chkScore && vc.data.RespStatus == \'R\'\"><i class=\"fa fa-bar-chart-o\"></i> 영역별 결과보기</button> <button class=\"btn btn-primary\" ng-click=vc.chkSave()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=\"vc.goPage(\'L\')\" ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>참여정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNm readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyNum\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNum readonly></div></div></div><div class=row><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TgtInfo\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TgtInfo readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ScoreLv\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.ScoreLv readonly></div></div></div><div class=row><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SendType\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SendType readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SendCnt\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SendCnt readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RespStatus_\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RespStatus_ readonly></div></div></div><div class=row><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SendDate\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SendDate readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'OpenDate\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.OpenDate readonly></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RespDate\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RespDate readonly></div></div></div></div></div></div></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>응답정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"pull-right mb-10\"><select class=form-control ng-model=vc.svyPagesCur ng-options=\"li.PageNo as li.Label for li in vc.svyPages\"><option value=\"\">-- 페이지 --</option></select></div></div></div><div class=row><div class=col-lg-12><div class=row ng-repeat=\"qt in vc.svyQsts\r\n                | filter : (vc.svyPagesCur == \'ALL\' ? \'\' : {PageNo: vc.svyPagesCur}) : (vc.svyPagesCur == \'ALL\' ? false : true)\"><!-- 선택형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'1\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><p class=\"row pl-20 pt-10\" ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId} : true\"><input ng-checked=\"vc.respList[it.qtId].SvyQstItemId == it.itId\" ng-change=\"vc.chkChange(vc.respList, qt.qtId);\" ng-model=vc.respList[qt.qtId].SvyQstItemId ng-value=it.itId ng-if=\"qt.SelType==\'S\'\" type=radio name=rdo{{it.qtId}} style=margin-top:-3px> <input ng-checked=\"vc.respListTop[qt.qtId+\'_\'+($index+1)].SvyQstItemId == it.itId\" ng-change=\"vc.chkChange(vc.respListTop, qt.qtId+\'_\'+($index+1));\" ng-model=\"vc.respListTop[qt.qtId+\'_\'+($index+1)].SvyQstItemId\" ng-if=\"qt.SelType==\'M\'\" ng-true-value=\"{{\'\\\'\'+ it.itId + \'\\\'\'}}\" ng-false-value=undefined type=checkbox name=cb{{it.qtId}} style=margin-top:-3px> {{it.QstItemNo}}. {{it.QstItemContents}} <input type=text ng-show=\'it.OtherRespYN == \"Y\" && qt.SelType==\"S\"\' ng-change=\"vc.chkChange(vc.respList, qt.qtId);\" ng-model=vc.respList[qt.qtId].SbjctResp class=form-control maxlength=100 style=\"margin-left:15px !Important; max-width:80% !Important\"> <input type=text ng-show=\'it.OtherRespYN == \"Y\" && qt.SelType==\"M\"\' ng-change=\"vc.chkChange(vc.respListTop, qt.qtId+\'_\'+($index+1));\" ng-model=\"vc.respListTop[qt.qtId+\'_\'+($index+1)].SbjctResp\" class=form-control maxlength=100 style=\"margin-left:15px !Important; max-width:80% !Important\"></p></div><!-- 입력형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'2\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><div class=\"row p-10\"><textarea class=form-control style=height:100px maxlength=1000 ng-model=vc.respList[qt.qtId].SbjctResp ng-change=\"vc.chkChange(vc.respList, qt.qtId);\">\r\n                        {{vc.respList[qt.qtId].SbjctResp}}</textarea></div></div><!-- 우선순위형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'3\'\"><div class=\"row w40 pt-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><div class=\"row pl-30 pt-10\"><div class=\"row pb-5\" ng-repeat=\"n in [].constructor(qt.QstTopCnt) track by $index\"><div class=pr-10 style=float:left>{{$index + 1}} 순위</div><div class=col-lg-4 style=float:left><select class=form-control ng-model=\"vc.respListTop[qt.qtId+\'_\'+($index+1)].SvyQstItemId\" ng-change=\"vc.chkChange(vc.respListTop, qt.qtId+\'_\'+($index+1));\" ng-options=\"li.itId as li.QstItemContents for li in vc.svyQstItems | filter : {qtId: qt.qtId} : true\"><option value=\"\">--{{$index + 1}}순위 선택--</option></select></div></div></div></div><!-- 이미지형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'4\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><p style=padding-bottom:10px ng-show=\"qt.qtImgSrc != null && qt.qtImgSrc != \'\'\"><img ng-src={{qt.qtImgSrc}} style=\"width:80px; height:80px; margin-top:10px\"></p><div class=\"row pl-20 pt-10\" ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId} : true\"><div style=float:left><input ng-checked=\"vc.respList[it.qtId].SvyQstItemId == it.itId\" ng-change=\"vc.chkChange(vc.respList, qt.qtId);\" ng-model=vc.respList[qt.qtId].SvyQstItemId ng-value=it.itId type=radio name=rdo{{it.qtId}} style=margin-top:-3px></div><div style=\"float:left; padding-bottom:10px\" ng-show=\"it.itImgSrc != null && it.itImgSrc != \'\'\"><img ng-src={{it.itImgSrc}} style=\"width:50px; height:50px\"></div><div style=float:left>{{it.QstItemNo}}. {{it.QstItemContents}}</div></div></div><!-- 척도형 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'5\'\"><div class=\"row w40 pt-10 pb-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}} [척도형]</div></div><div class=\"row pl-10\" ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId} : true\" style=padding-top:10px><div class=col-lg-3>{{it.QstItemContents}}</div><div class=col-lg-6><ul style=\"display: table; width:100%\"><li style=\"display:table-cell; text-align: center\" ng-repeat=\"n in [].constructor(qt.ScaleMax) track by $index\"><label class=rdosvy-label><input type=radio ng-change=\"vc.chkChange(vc.respListTop, qt.qtId+\'_\'+($parent.$index+1));\" ng-checked=\"vc.respListTop[qt.qtId+\'_\'+($parent.$index+1)].SbjctResp == (qt.ScaleOrder==\'A\' ? $index + 1 : qt.ScaleMax - $index)\" ng-model=\"vc.respListTop[qt.qtId+\'_\'+($parent.$index+1)].SbjctResp\" ng-value=\"(qt.ScaleOrder==\'A\' ? $index + 1 : qt.ScaleMax - $index)\" style=margin-top:-3px> <span ng-if=\"qt.ScaleOrder==\'A\'\">{{$index + 1}}</span> <span ng-if=\"qt.ScaleOrder==\'D\'\">{{qt.ScaleMax - $index}}</span></label></li></ul></div><div class=\"col-lg-3 text-right\">{{it.QstItemContents2}}</div></div></div><!-- 분류정보 --><div class=\"col-lg-12 pb-20\" ng-if=\"qt.QstType == \'C\'\"><div class=\"row w40 pt-10\" style=\"background-color: #f4f4f4\"><div class=col-lg-12>{{qt.QstNo}}. {{qt.QstSubject}}</div></div><div class=\"row pl-10 pt-10\"><div ng-if=\"qt.ClassfyCd == \'NM\'\"><div class=col-lg-4><input type=text class=form-control maxlength=30 ng-model=vc.respList[qt.qtId].SbjctResp ng-change=\"vc.chkChange(vc.respList, qt.qtId);\"></div></div><div ng-if=\"qt.ClassfyCd == \'MB\'\"><div class=col-lg-4><input type=text class=form-control maxlength=30 number-only=\"\" ng-model=vc.respList[qt.qtId].SbjctResp ng-change=\"vc.chkChange(vc.respList, qt.qtId);\"></div></div><div ng-if=\"qt.ClassfyCd == \'EM\'\"><div class=col-lg-4><input type=text class=form-control maxlength=30 ng-model=vc.respList[qt.qtId].SbjctResp ng-change=\"vc.chkChange(vc.respList, qt.qtId);\"></div></div><div ng-if=\"qt.ClassfyCd == \'GD\'\"><div class=col-lg-4><p class=pt-10><input type=radio ng-model=vc.respList[qt.qtId].ObjctResp ng-change=\"vc.chkChange(vc.respList, qt.qtId);\" ng-value=\"\'M\'\" style=margin-top:-3px ng-checked=\"vc.respList[qt.qtId].ObjctResp == \'M\'\">남</p><p class=pt-10><input type=radio ng-model=vc.respList[qt.qtId].ObjctResp ng-change=\"vc.chkChange(vc.respList, qt.qtId);\" ng-value=\"\'F\'\" style=margin-top:-3px ng-checked=\"vc.respList[qt.qtId].ObjctResp == \'F\'\">여</p></div></div><div ng-if=\"qt.ClassfyCd != \'NM\' && qt.ClassfyCd != \'MB\' && qt.ClassfyCd != \'EM\' && qt.ClassfyCd != \'GD\'\"><div class=col-lg-4><select class=form-control ng-model=vc.respList[qt.qtId].SvyQstItemId ng-change=\"vc.chkChange(vc.respList, qt.qtId);\" ng-options=\"it.itId as it.QstItemContents for it in vc.svyQstItems | filter : {qtId: qt.qtId} : true\"><option value=\"\">--선택--</option></select></div></div></div></div><!-- 설명글 --><div class=\"pt-20 pb-20\" ng-if=\"qt.QstType == \'R\'\"><pre class=txt-pre>{{qt.QstSubject}}</pre></div></div></div></div></div></div></div></div><!-- /row --><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goScoreLvModal() ng-if=\"vc.chkScore && vc.data.RespStatus == \'R\'\"><i class=\"fa fa-list\"></i> 영역별 점수보기</button> <button class=\"btn btn-primary\" ng-click=vc.chkSave()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=\"vc.goPage(\'L\')\" ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --></div><!-- /page content --></div>");
$templateCache.put("app/survey/target-result-list.html","<div class=\"page page-footable\" ng-controller=\"TargetResultListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>참여자별 결과 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Name placeholder=\"응답자명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SvyNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SvyNm readonly type=text><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" ng-click=vc.srchSurveyModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseSurvey(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Name\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Name type=text><label>{{vc.columnMap[\'Name\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Email type=text><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RespBeginDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RespBeginDate = (vc.RespBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.RespBeginDate ng-required=false placeholder=\"{{vc.columnMap[\'RespBeginDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RespEndDate\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RespEndDate = (vc.RespEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.RespEndDate ng-required=false placeholder=\"{{vc.columnMap[\'RespEndDate\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ResultStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ResultStatus\'].CodeList\" code-model=vc.srch.ResultStatus></common-code-custom><label>{{vc.columnMap[\'ResultStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RespStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'RespStatus\'].CodeList\" code-model=vc.srch.RespStatus></common-code-custom><label>{{vc.columnMap[\'RespStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'SendType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'SendType\'].CodeList\" code-model=vc.srch.SendType></common-code-custom><label>{{vc.columnMap[\'SendType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RespBeginDate = (vc.RespBeginDate | date: \'yyyy-MM-dd\')\" ng-model=vc.RespBeginDate ng-required=false placeholder=\"응답일시 검색시작일\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RespEndDate = (vc.RespEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.RespEndDate ng-required=false placeholder=\"응답일시 검색종료일\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getRawData()><i class=\"fa fa-file-excel-o\"></i> RawData 엑셀</button> <button class=\"btn btn-default\" ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=\"vc.setDelList(\'T\')\"><i class=\"fa fa-trash-o\"></i> 대상자 삭제</button> <button class=\"btn btn-danger\" ng-click=\"vc.setDelList(\'R\')\"><i class=\"fa fa-trash-o\"></i> 응답정보 삭제</button> <button class=\"btn btn-default\" ng-click=\"vc.goPage(\'back\')\" ng-if=\"vc.srch.goBack != null\"><i class=\"fa fa-list\"></i> 뒤로</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-11 col-md-12 col-lg-12 col-xl-12 text-warning mb-10\">* 응답완료일 경우 응답정보를 조회/수정하는 화면으로, 그 외는 대상자 정보 수정 화면으로 이동합니다.</div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=vc.chkHead type=checkbox></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goPage(li.RespStatus,li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm:ss\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/survey/trend-analysis.html","<div class=\"page page-footable\" ng-controller=\"TrendAnalysisCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>참여추이 분석</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=\"vc.goPage(\'V\')\"><i class=\"fa fa-list\"></i> 뒤로</button> <button class=\"btn btn-default\" ng-click=\"vc.goPage(\'L\')\" ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>설문정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.SvyNm></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyDate\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.SvyDate></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'SvyStatus\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\" ng-bind=vc.data.SvyStatus></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'RespRltCnt\'].ColumnLogicalNm | translate}}</label><div class=\"form-control txt_view\"><span ng-bind=vc.data.RespRltCnt></span> (<span ng-bind=vc.data.RespRltRate></span>)</div></div></div></div></div></div></div></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{vc.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("home/main/main.html","<div><!-- page content --><!--메인 전체 --><div class=main_wrap><!-- 왼쪽 비주얼 --><div class=aside_l><!--<p class=\"mtxt1\"></p>--><p class=mtxt2><span>더휴먼데이터센터</span>는<br><span>조직, 사람, 일에 대해 연구</span>하는<br><span>컨설팅 전문가 그룹</span>입니다.</p><p class=mtxt3><span>Let\'s make People better</span><br>임직원의 일상이 바뀌다</p></div><!-- //왼쪽 비주얼 --><!-- 오른쪽 전체 --><div class=aside_r><!--오른쪽배너 --><ul class=right_bn><li><p><a ui-sref=home.about><span>About us</span><br>생활을 변화하다</a></p></li><li><p><a ui-sref=home.business><span>Business</span><br>조직이 변화하다</a></p></li></ul><!--//오른쪽배너 --><!--로그인 --><form class=login_box id=login_box ng-submit=login.doLogin()><div class=login ng-controller=\" MainCtrl as vc\"><div ng-if=!vc.isLoggedIn()><h3>Login</h3><div><input type=text style=width:33% placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" class=input_txt name=txtLoginID title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" type=text maxlength=20 ng-model=login.loginInfo.loginId ng-required=true> <input name=txtPassword title=\"{{\'LOGIN.TITLE.I.n-login-bodyNST_PW\'|translate}}\" type=password maxlength=20 ng-model=login.loginInfo.loginPw ng-required=true style=width:33% placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" class=input_txt> <input type=submit value=로그인 class=bt_blue></div><div class=idpw-text-box style=\"padding-top: 10px\"><div class=checkbox style=\"padding:0 0 0 20px; margin:0\"><input id=ckID type=checkbox name=ckID ng-checked=\"login.loginInfo.saveId === \'1\'\" ng-model=login.loginInfo.saveId ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" tabindex=3><label for=ckID>아이디 저장</label></div></div></div><div ng-if=vc.isLoggedIn()><h3>{{vc.userNm}}님 환영합니다.({{vc.userId}})</h3><button type=button class=\"btn btn-light\" ng-click=vc.goDataCenter()>데이터센터</button> <button type=button class=\"btn btn-light\" ng-click=vc.doLogout()>로그아웃</button></div></div></form><!--//로그인 --><!--게시판 --><div class=board_main ng-controller=\"PrCentreCtrl as vc\"><h3>PR Center</h3><ul class=board_list><li ng-repeat=\"item in vc.lists\" ng-click=vc.goDetail(item.BbsPostId)><a ng-if=\"$index < 6\"><span class=cate_new>- [{{item.BoardTypeNm}}]</span> {{item.Title}}</a></li></ul></div><!--//게시판 --></div><!-- //오른쪽 전체 --></div><!--//메인 전체 --><!-- /page content --></div>");
$templateCache.put("home/support/support.html","<div ng-controller=\"SupportCtrl as vc\"><!-- page content --><!--메인 전체 --><div class=main_wrap><!-- 왼쪽 비주얼 --><div class=aside_l><!--<p class=\"mtxt1\"></p>--><p class=mtxt2><span>더휴먼데이터센터</span>는<br><span>조직, 사람, 일에 대해 연구</span>하는<br><span>컨설팅 전문가 그룹</span>입니다.</p><p class=mtxt3><span>Let\'s make People better</span><br>임직원의 일상이 바뀌다</p></div><!-- //왼쪽 비주얼 --><!-- 오른쪽 전체 --><div class=aside_r><!--오른쪽배너 --><ul class=right_bn><li><p><a ui-sref=home.about><span>About us</span><br>생활을 변화하다</a></p></li><li><p><a ui-sref=home.business><span>Business</span><br>조직이 변화하다</a></p></li></ul><!--//오른쪽배너 --><!--로그인 --><h3>Login</h3><div>서비스 안정화 작업을 위하여 서비스가 일시 중지된 상태입니다.</div><div>서비스 이용에 불편을 끼쳐드려 죄송합니다.</div><div>빠른 시간 이내에 점검을 완료하여 서비스가 정상화될 수 있도록 하겠습니다.</div><div>서비스 복구 시, 복구 안내 알림를 받고자 하는 E-mail주소를 입력해주세요.</div><div><form class=\"form wow fadeInUp\" role=form name=theForm><ul class=form><li><div>E-mail주소<span class=point_red ng-show=theForm.email.$invalid>*</span></div><div><input type=text class=input_txt2 placeholder=\"E-mail주소를 입력해 주세요.\" name=email ng-model=vc.srch.email minlength=5 maxlength=30 required></div></li></ul></form><input type=submit value=확인 class=bt_blue></div><!--//로그인 --></div><!-- //오른쪽 전체 --></div><!--//메인 전체 --><!-- /page content --></div>");
$templateCache.put("components/biz-component/buttons/buttons.html","<div class=row><div class=col-lg-12><h1 class=page-header>Buttons</h1></div><!-- /.col-lg-12 --></div><!-- /.row --><div class=row><div class=col-lg-6><div class=\"panel panel-default\"><div class=panel-heading>Default Buttons</div><!-- /.panel-heading --><div class=panel-body><h4>Normal Buttons</h4><p><button type=button class=\"btn btn-default\">Default</button> <button type=button class=\"btn btn-primary\">Primary</button> <button type=button class=\"btn btn-success\">Success</button> <button type=button class=\"btn btn-info\">Info</button> <button type=button class=\"btn btn-warning\">Warning</button> <button type=button class=\"btn btn-danger\">Danger</button> <button type=button class=\"btn btn-link\">Link</button></p><br><h4>Disabled Buttons</h4><p><button type=button class=\"btn btn-default disabled\">Default</button> <button type=button class=\"btn btn-primary disabled\">Primary</button> <button type=button class=\"btn btn-success disabled\">Success</button> <button type=button class=\"btn btn-info disabled\">Info</button> <button type=button class=\"btn btn-warning disabled\">Warning</button> <button type=button class=\"btn btn-danger disabled\">Danger</button> <button type=button class=\"btn btn-link disabled\">Link</button></p><br><h4>Button Sizes</h4><p><button type=button class=\"btn btn-primary btn-lg\">Large button</button> <button type=button class=\"btn btn-primary\">Default button</button> <button type=button class=\"btn btn-primary btn-sm\">Small button</button> <button type=button class=\"btn btn-primary btn-xs\">Mini button</button><br><br><button type=button class=\"btn btn-primary btn-lg btn-block\">Block level button</button></p></div><!-- /.panel-body --></div><!-- /.panel --><div class=\"panel panel-default\"><div class=panel-heading>Circle Icon Buttons with Font Awesome Icons</div><!-- /.panel-heading --><div class=panel-body><h4>Normal Circle Buttons</h4><button type=button class=\"btn btn-default btn-circle\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-primary btn-circle\"><i class=\"fa fa-list\"></i></button> <button type=button class=\"btn btn-success btn-circle\"><i class=\"fa fa-link\"></i></button> <button type=button class=\"btn btn-info btn-circle\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-warning btn-circle\"><i class=\"fa fa-times\"></i></button> <button type=button class=\"btn btn-danger btn-circle\"><i class=\"fa fa-heart\"></i></button><br><br><h4>Large Circle Buttons</h4><button type=button class=\"btn btn-default btn-circle btn-lg\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-primary btn-circle btn-lg\"><i class=\"fa fa-list\"></i></button> <button type=button class=\"btn btn-success btn-circle btn-lg\"><i class=\"fa fa-link\"></i></button> <button type=button class=\"btn btn-info btn-circle btn-lg\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-warning btn-circle btn-lg\"><i class=\"fa fa-times\"></i></button> <button type=button class=\"btn btn-danger btn-circle btn-lg\"><i class=\"fa fa-heart\"></i></button><br><br><h4>Extra Large Circle Buttons</h4><button type=button class=\"btn btn-default btn-circle btn-xl\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-primary btn-circle btn-xl\"><i class=\"fa fa-list\"></i></button> <button type=button class=\"btn btn-success btn-circle btn-xl\"><i class=\"fa fa-link\"></i></button> <button type=button class=\"btn btn-info btn-circle btn-xl\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-warning btn-circle btn-xl\"><i class=\"fa fa-times\"></i></button> <button type=button class=\"btn btn-danger btn-circle btn-xl\"><i class=\"fa fa-heart\"></i></button></div><!-- /.panel-body --></div><!-- /.panel --></div><!-- /.col-lg-6 --><div class=col-lg-6><div class=\"panel panel-default\"><div class=panel-heading>Outline Buttons with Smooth Transition</div><!-- /.panel-heading --><div class=panel-body><h4>Outline Buttons</h4><p><button type=button class=\"btn btn-outline btn-default\">Default</button> <button type=button class=\"btn btn-outline btn-primary\">Primary</button> <button type=button class=\"btn btn-outline btn-success\">Success</button> <button type=button class=\"btn btn-outline btn-info\">Info</button> <button type=button class=\"btn btn-outline btn-warning\">Warning</button> <button type=button class=\"btn btn-outline btn-danger\">Danger</button> <button type=button class=\"btn btn-outline btn-link\">Link</button></p><br><h4>Outline Button Sizes</h4><p><button type=button class=\"btn btn-outline btn-primary btn-lg\">Large button</button> <button type=button class=\"btn btn-outline btn-primary\">Default button</button> <button type=button class=\"btn btn-outline btn-primary btn-sm\">Small button</button> <button type=button class=\"btn btn-outline btn-primary btn-xs\">Mini button</button><br><br><button type=button class=\"btn btn-outline btn-primary btn-lg btn-block\">Block level button</button></p></div><!-- /.panel-body --></div><!-- /.panel --><div class=\"panel panel-default\"><div class=panel-heading>Social Buttons with Font Awesome Icons</div><!-- /.panel-heading --><div class=panel-body><h4>Social Buttons</h4><a class=\"btn btn-block btn-social btn-bitbucket\"><i class=\"fa fa-bitbucket\"></i> Sign in with Bitbucket </a><a class=\"btn btn-block btn-social btn-dropbox\"><i class=\"fa fa-dropbox\"></i> Sign in with Dropbox </a><a class=\"btn btn-block btn-social btn-facebook\"><i class=\"fa fa-facebook\"></i> Sign in with Facebook </a><a class=\"btn btn-block btn-social btn-flickr\"><i class=\"fa fa-flickr\"></i> Sign in with Flickr </a><a class=\"btn btn-block btn-social btn-github\"><i class=\"fa fa-github\"></i> Sign in with GitHub </a><a class=\"btn btn-block btn-social btn-google-plus\"><i class=\"fa fa-google-plus\"></i> Sign in with Google </a><a class=\"btn btn-block btn-social btn-instagram\"><i class=\"fa fa-instagram\"></i> Sign in with Instagram </a><a class=\"btn btn-block btn-social btn-linkedin\"><i class=\"fa fa-linkedin\"></i> Sign in with LinkedIn </a><a class=\"btn btn-block btn-social btn-pinterest\"><i class=\"fa fa-pinterest\"></i> Sign in with Pinterest </a><a class=\"btn btn-block btn-social btn-tumblr\"><i class=\"fa fa-tumblr\"></i> Sign in with Tumblr </a><a class=\"btn btn-block btn-social btn-twitter\"><i class=\"fa fa-twitter\"></i> Sign in with Twitter </a><a class=\"btn btn-block btn-social btn-vk\"><i class=\"fa fa-vk\"></i> Sign in with VK</a><hr><div class=text-center><a class=\"btn btn-social-icon btn-bitbucket\"><i class=\"fa fa-bitbucket\"></i></a> <a class=\"btn btn-social-icon btn-dropbox\"><i class=\"fa fa-dropbox\"></i></a> <a class=\"btn btn-social-icon btn-facebook\"><i class=\"fa fa-facebook\"></i></a> <a class=\"btn btn-social-icon btn-flickr\"><i class=\"fa fa-flickr\"></i></a> <a class=\"btn btn-social-icon btn-github\"><i class=\"fa fa-github\"></i></a> <a class=\"btn btn-social-icon btn-google-plus\"><i class=\"fa fa-google-plus\"></i></a> <a class=\"btn btn-social-icon btn-instagram\"><i class=\"fa fa-instagram\"></i></a> <a class=\"btn btn-social-icon btn-linkedin\"><i class=\"fa fa-linkedin\"></i></a> <a class=\"btn btn-social-icon btn-pinterest\"><i class=\"fa fa-pinterest\"></i></a> <a class=\"btn btn-social-icon btn-tumblr\"><i class=\"fa fa-tumblr\"></i></a> <a class=\"btn btn-social-icon btn-twitter\"><i class=\"fa fa-twitter\"></i></a> <a class=\"btn btn-social-icon btn-vk\"><i class=\"fa fa-vk\"></i></a></div></div><!-- /.panel-body --></div><!-- /.panel --></div><!-- /.col-lg-6 --></div>");
$templateCache.put("components/modal/campaign/favori-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>자주쓰는 {{modalCtrl.SaveTypeNm}} 관리</div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>{{modalCtrl.SaveTypeNm}}</label><input type=text class=form-control ng-model=modalCtrl.srch.Favorite placeholder={{modalCtrl.SaveTypeNm}}></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=modalCtrl.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"modalCtrl.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in modalCtrl.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{modalCtrl.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"modalCtrl.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{modalCtrl.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.lists \"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}} {{li.newItemClass}}\" ng-repeat=\"liCol in modalCtrl.listColumns | filter: $root.listColumFilter\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table></div></div></div><!-- /row --><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=modalCtrl.setChangeViewSize() ng-model=modalCtrl.srch.viewSize ng-options=\"c for c in modalCtrl.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=modalCtrl.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=modalCtrl.setPageChanged() ng-model=modalCtrl.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=modalCtrl.totalItems uib-pagination boundary-links=true items-per-page=modalCtrl.viewSize max-size=modalCtrl.maxSize num-pages=modalCtrl.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-danger mb-10\" activate-button ng-click=modalCtrl.delInfo()><i class=\"fa fa-check\"></i> 선택정보 삭제</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/campaign/form-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>서식 {{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-9 col-md-9 col-lg-9 col-xl-9\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.FormNm placeholder=\"{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getFormList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'FormType\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'RegUser\'].ColumnLogicalNm | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.FormList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.FormNm></span></td><td class=text-center><span ng-bind=li.FormType></span></td><td class=text-center><span ng-bind=\"li.RegDate | date:\'yyyy-MM-dd\':\'UTC\'\"></span></td><td class=text-center><span ng-bind=li.RegUser></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getFormList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/campaign/form-modal2.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>서식 {{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.FormNm placeholder=\"{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'FormType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'FormType\'].CodeList\" code-model=modalCtrl.FormType is-disabled=false></common-code-custom></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getFormList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'FormType\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'RegUser\'].ColumnLogicalNm | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.FormList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.FormNm></span></td><td class=text-center><span ng-bind=li.FormType></span></td><td class=text-center><span ng-bind=\"li.RegDate | date:\'yyyy-MM-dd\':\'UTC\'\"></span></td><td class=text-center><span ng-bind=li.RegUser></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getFormList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/campaign/fre-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>자주 사용하는 메세지 등록/수정</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>제목</label><input type=text class=form-control ng-model=vc.data.Subject maxlength=50></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>발송내용</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.Message ng-change=vc.chkMessage()></textarea><div class=text-right>{{vc.MessageBytes}} / 90 bytes</div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger mb-10\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/campaign/grpcust-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>그룹고객 추가</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>이름</label><input type=text class=form-control ng-model=vc.srch.CustNm></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>연락처</label><input type=text class=form-control ng-model=vc.srch.Mobile></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>고객등급</label><common-code-custom code-list=vc.CustGradeCodeList code-model=vc.srch.CustGrade></common-code-custom></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>방문경로</label><common-code-custom code-list=vc.VisitPathCodeList code-model=vc.srch.VisitPath></common-code-custom></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>담당자</label><div class=input-group><input type=text class=form-control ng-model=vc.srch.ManagerNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>추출고객수</label><div class=input-group><input type=text class=form-control ng-model=vc.data.CustCnt readonly></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.getData()><i class=\"glyphicon glyphicon-search\"></i> 추출</button> <button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> 그룹고객추가</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/campaign/sms-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>그룹발송</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=\"form-control form-right\" maxlength=13 numbers-hyphen ng-model=vc.data.SendTelno></div></div><div class=col-lg-6><div class=form-group><input type=radio ng-model=vc.data.SendDateType value=100 ng-checked=true style=margin-top:-3px> 즉시발송 <input type=radio ng-model=vc.data.SendDateType value=200 style=margin-top:-3px> 예약발송</div></div></div><div class=row ng-show=\"vc.data.SendDateType == \'200\'\"><div class=col-lg-6><div class=\"form-group form-inline\"><label>발송일시</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SendDt = (vc.SendDt | date: \'yyyy-MM-dd\')\" ng-model=vc.SendDt ng-required=false placeholder=발송일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=col-lg-3><div class=form-group><select ng-model=vc.data.SendHour ng-options=\"data.time as data.time for data in vc.sendHourList\" class=form-control></select></div></div><div class=col-lg-3><div class=form-group><select ng-model=vc.data.SendMin ng-options=\"data.time as data.time for data in vc.sendMinList\" class=form-control></select></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>발송내용</label><textarea rows=5 class=\"form-control form-right\" ng-model=vc.data.SendMessage ng-change=\"vc.chkSendMessage(\'10\')\"></textarea><div class=text-right style=padding-top:10px>{{vc.SendMessageBytes}} / 90 bytes <button class=\"btn btn-default\" ng-click=\"vc.srchFreModal(\'\')\" type=button>자주 사용하는 메세지 저장</button></div></div></div></div><div class=row style=padding-top:8px><div class=col-lg-12><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\">자주 사용하는 메세지</th><th class=\"text-center none\" style=width:10%>수정</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.qstTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan=2>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.freLists\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle ng-click=vc.setFreMessage(li.Message)>{{li.Subject}}</td><td class=text-center style=vertical-align:middle><button class=\"btn btn-default\" ng-click=vc.srchFreModal(li.KeyId)>수정</button></td></tr></table></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> 발송</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/campaign/srch-cust-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>수신자그룹 고객 추가</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>고객명</label><input type=text class=form-control ng-model=modalCtrl.srch.CustNm placeholder=고객명></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>영업담당자</label><div class=input-group><input class=\"form-control form-right\" ng-model=modalCtrl.srch.ManagerNm readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=modalCtrl.srchUserModal()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=modalCtrl.eraseUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- //row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><common-code-custom code-list=\"modalCtrl.columnMap[\'SalesType\'].CodeList\" code-model=modalCtrl.srch.SalesType></common-code-custom><label>고객구분</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><common-code-custom code-list=\"modalCtrl.columnMap[\'CustGrade\'].CodeList\" code-model=modalCtrl.srch.CustGrade></common-code-custom><label>고객등급</label></div></div></div><!-- //row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>휴대폰</label><input type=text class=form-control ng-model=modalCtrl.srch.Mobile placeholder=휴대폰></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>이메일</label><input type=text class=form-control ng-model=modalCtrl.srch.Email placeholder=이메일></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>생년월일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.BirthDayFrom = (modalCtrl.BirthDayFrom | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.BirthDayFrom ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label style=text-align:center>~</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.BirthDayTo = (modalCtrl.BirthDayTo | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.BirthDayTo ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><common-code-custom code-list=\"modalCtrl.columnMap[\'Gender\'].CodeList\" code-model=modalCtrl.srch.Gender></common-code-custom><label>성별</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><common-code-custom code-list=\"modalCtrl.columnMap[\'AgeRange\'].CodeList\" code-model=modalCtrl.srch.AgeRange></common-code-custom><label>연령대</label></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>등록시작일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.CustRegDtFrom = (modalCtrl.CustRegDtFrom | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.CustRegDtFrom ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>등록종료일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.CustRegDtTo = (modalCtrl.CustRegDtTo | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.CustRegDtTo ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group pull-right\"><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=modalCtrl.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"modalCtrl.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in modalCtrl.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{modalCtrl.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"modalCtrl.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{modalCtrl.listColumns.length}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.lists \"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}} {{li.newItemClass}}\" ng-repeat=\"liCol in modalCtrl.listColumns | filter: $root.listColumFilter\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table></div></div></div><!-- /row --><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=modalCtrl.setChangeViewSize() ng-model=modalCtrl.srch.viewSize ng-options=\"c for c in modalCtrl.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=modalCtrl.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=modalCtrl.setPageChanged() ng-model=modalCtrl.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=modalCtrl.totalItems uib-pagination boundary-links=true items-per-page=modalCtrl.viewSize max-size=modalCtrl.maxSize num-pages=modalCtrl.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-danger mb-10\" activate-button ng-click=\"modalCtrl.addGrpcust(\'\')\"><i class=\"fa fa-check\"></i> 선택고객추가</button> <button class=\"btn btn-danger mb-10\" activate-button ng-click=\"modalCtrl.addGrpcust(\'ALL\')\"><i class=\"fa fa-check\"></i> 목록전체고객추가</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/campaign/survey-target-edit-modal2.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>발송 대상자 편집</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 btn-group2\"><div class=pull-right><div class=form-group><div style=\"float:left; padding-right:2px\"><input type=file name=excelFile class=form-control></div><button class=\"btn btn-primary\" ng-click=modalCtrl.doUpload()><i class=\"fa fa-upload\"></i> 일괄 업로드</button> <button class=\"btn btn-primary\" ng-click=modalCtrl.excelform()><i class=\"fa fa-download\"></i> 양식 다운로드</button></div></div></div></div><div class=\"row pb-5\"><div class=\"col-lg-12 text-right\"><label>발송기간</label><div class=input-group ng-controller=DatepickerDemoCtrl style=\"width:130px; display: inline-block; margin-bottom:-10px\"><input class=form-control clear-text=취소 close-text=닫기 style=width:100px current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.SendDate1 = (modalCtrl.BeginDate | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.BeginDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div><div class=input-group ng-controller=DatepickerDemoCtrl style=\"width:130px; display: inline-block; margin-bottom:-10px\"><input class=form-control clear-text=취소 close-text=닫기 style=width:100px current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.SendDate2 = (modalCtrl.EndDate | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.EndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div><button class=\"btn btn-primary\" activate-button ng-click=modalCtrl.chkSendDate() style=margin-right:20px>적용</button> <button class=\"btn btn-primary\" activate-button ng-click=modalCtrl.GroupCustEditModal()><i class=\"fa fa-user\"></i> 개별추가</button> <button class=\"btn btn-primary\" ng-click=modalCtrl.inputDirect()><i class=\"fa fa-users\"></i> 목록추가</button> <button class=\"btn btn-danger\" activate-button ng-click=\"modalCtrl.deleteGrpcust(\'\')\"><i class=\"fa fa-trash-o\"></i> 선택제외</button> <button class=\"btn btn-danger\" activate-button ng-click=\"modalCtrl.deleteGrpcust(\'ALL\')\"><i class=\"fa fa-trash-o\"></i> 전체제외</button> <button class=\"btn btn-danger\" activate-button ng-click=modalCtrl.deleteErrorCust()><i class=\"fa fa-trash-o\"></i> 오류제외</button> <button class=\"btn btn-primary\" activate-button ng-click=modalCtrl.initList()>초기화</button></div></div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=modalCtrl.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none\" ng-click=\"modalCtrl.setSortColumn(liCol.ColumnPhysicalNm, false)\" ng-repeat=\"liCol in modalCtrl.grpcustListColumns\">{{liCol.ColumnLogicalNm | translate }} <span class={{modalCtrl.setSortDirect(liCol.ColumnPhysicalNm)}}></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"modalCtrl.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{modalCtrl.grpcustListColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"(liIndex, li) in modalCtrl.viewList\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center ng-repeat=\"liCol in modalCtrl.grpcustListColumns\" ng-click=\"modalCtrl.GroupCustEditModal(liIndex, li.SvyTgtId)\">{{li[liCol.ColumnPhysicalNm]}}</td></tr></table></div></div><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=modalCtrl.setChangeViewSize() ng-model=modalCtrl.srch.viewSize ng-options=\"c for c in modalCtrl.listSize\"></select></div></div><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=modalCtrl.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=modalCtrl.setPageChanged() ng-model=modalCtrl.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=modalCtrl.totalItems uib-pagination boundary-links=true items-per-page=modalCtrl.viewSize max-size=modalCtrl.maxSize num-pages=modalCtrl.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>확인</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/campaign/tree-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>수신자 선택</h3></div><div class=\"modal-body ng-scope\"><md-sidenav md-component-id=left md-is-locked-open=true style=min-height:400px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">수신자그룹 목록</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.GrpNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/contents/contents-modal.html","<div class=modal-content style=\"max-width: 100%; min-width: 899px; display: table; border-radius:6px\" modal-drag><div class=\"modal-header ng-scope\" style=border-radius:6px><h3 class=page-header>컨텐츠 미리보기</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=form-group><div ng-bind-html=modalCtrl.Contents></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div></div>");
$templateCache.put("components/modal/careTkt/care-tkt-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>관리권 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label>관리권명</label><input type=text class=form-control ng-model=modalCtrl.srch.CareTktNm placeholder=관리권명></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label>비고</label><input type=text class=form-control ng-model=modalCtrl.srch.Remark placeholder=비고></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group pull-right\"><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=25% style=\"align-content: center\"><col width=10%><col width=25%><col width=40%></colgroup><thead><tr><th class=\"text-center none\"><span>관리권명</span></th><th class=\"text-center none\"><span>횟수</span></th><th class=\"text-center none\"><span>가격</span></th><th class=\"text-center none\"><span>비고</span></th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.careTktlists\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td><span ng-bind=li.CareTktNm></span></td><td><span ng-bind=li.MngCnt></span></td><td class=\"text- none\"><span comma-bind ng-bind=li.Price></span></td><td class=\"text- none\"><span ng-bind=li.Remark></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.srch.viewSize ng-model=modalCtrl.currentPage ng-change=modalCtrl.pageChanged() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/customer/counselhist-modal.html","<div class=\"modal-content wd80p\" modal-drag><div class=dataloader ng-show=vc.dataloader></div><div class=\"modal-header ng-scope\"><h3 class=page-header>상담정보</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group form-inline\"><label>상담일자</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.CounselDt = (vc.CounselDt | date: \'yyyy-MM-dd\')\" ng-model=vc.CounselDt ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>상담내용</label><div class=col-lg-12><textarea class=form-control maxlength=1000 ng-model=vc.data.CounselContents rows=5></textarea></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\" ng-if=!vc.showUploader><div><file-attach callback=vc.onFileCallback file-data=vc.uploadFileListCounsel></file-attach></div></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form enctype=Multipart/Form-Data id=frmCounsel method=post runat=server><div class=\"vault-block ml-0 wd-100p\" id=vaultCounsel></div></form></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileListCounsel\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox aria-label=Check class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" md-no-ink=\"\" ng-false-value=\"\'\'\" ng-model=fli.delState ng-true-value=\"\'delete\'\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.uploadFileCounsel()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div>");
$templateCache.put("components/modal/customer/customer-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>고객 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label>고객명</label><input type=text class=form-control ng-model=modalCtrl.srch.CustNm placeholder=고객명></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label>연락처</label><input type=text class=form-control ng-model=modalCtrl.srch.Mobile placeholder=연락처></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group pull-right\"><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=30% style=\"align-content: center\"><col width=20%><col width=20%><col width=30%></colgroup><thead><tr><th class=\"text-center none\"><span>이름</span></th><th class=\"text-center none\"><span>성별</span></th><th class=\"text-center none\"><span>생일</span></th><th class=\"text-center none\"><span>연락처</span></th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.customerlists\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td><span ng-bind=li.CustNm></span></td><td><span ng-bind=li.Gender></span></td><td><span ng-bind=\"li.BirthDay | utcToLocal:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=li.Mobile></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.srch.viewSize ng-model=modalCtrl.currentPage ng-change=modalCtrl.pageChanged() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/cvsreserv/cvsreserv-info-modal.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>예약정보</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CustId\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.CustNm placeholder=\"{{vc.columnMap[\'CustNm\'].ColumnLogicalNm | translate}}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchCustomerModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseCustomer();><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Manager\'].ColumnLogicalNm | translate}}</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.data.ManagerNm placeholder=\"{{vc.columnMap[\'ManagerNm\'].ColumnLogicalNm | translate}}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchUserModal()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ReservDate\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.ReservDate = (vc.chkDate | date: \'yyyy-MM-dd\')\" ng-model=vc.chkDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"col-xs-7 col-sm-7 col-md-7 col-lg-7\"><div class=\"form-group form-inline\"><label>예약시간</label><common-code-custom code-list=\"vc.columnMap[\'ReservTime\'].CodeList\" code-model=vc.data.ReservHour></common-code-custom></div></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5\"><div class=form-group><select ng-model=vc.data.ReservMin ng-change=vc.changeViewSize() class=form-control ng-options=\"c for c in vc.ReservMinCodeList\"><option value=\"\">--선택--</option></select></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReservReason\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'ReservReason\'].CodeList\" code-model=vc.data.ReservReason></common-code-custom></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'CareTktId\'].ColumnLogicalNm | translate }}</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.data.CareTktNm placeholder=\"{{vc.columnMap[\'CareTktNm\'].ColumnLogicalNm | translate }}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchCareTktModal()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseCareTkt()><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"col-xs-8 col-sm-8 col-md-8 col-lg-8\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'MngCnt\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=20 numbers-hyphen ng-model=vc.data.MngCnt></div></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4\"><div class=form-group><input type=text class=\"form-control form-right\" maxlength=20 numbers-hyphen ng-model=vc.data.TotMngCnt readonly></div></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-danger mb-10\" ng-click=vc.setDelData()><i class=\"fa fa-check\"></i> 삭제</button> <button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div>");
$templateCache.put("components/modal/dataanalysis/data-group-action-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">{{ \'Menu.TASK\' | translate }} 변경</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><common-code-tree code-list=vc.dagrouplists code-model=vc.GroupAndAction prevent-changing=true></common-code-tree></div></div><!-- //row --></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/dataanalysis/data-group-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=\"modal-title custom-font\">{{ \'Menu.TASK\' | translate }} {{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=modalCtrl.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in modalCtrl.searchFieldTypeList\" ng-init=modalCtrl.selSearchType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=modalCtrl.searchValue placeholder=\"{{ \'Menu.EM410DT02\' | translate }}\"></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=modalCtrl.getClientList()><i class=\"fa fa-search\"></i> {{ \'Menu.SEARCH\' | translate }}</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=modalCtrl.viewSizePerPage ng-change=modalCtrl.changeViewSize() ng-options=\"c for c in modalCtrl.viewSizePerPageList\" class=input-sm></select></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th>{{ \'Menu.BASIC_TASK\' | translate }}</th><th>{{ \'Menu.DATAGROUP_NAME\' | translate }}</th><th>{{ \'Menu.TASK_NAME\' | translate }}</th><th>{{ \'Menu.START_DATE\' | translate }}</th><th>{{ \'Menu.END_DATE\' | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.ShopList\" ng-click=modalCtrl.select(li); style=\"cursor: pointer\"><td class=text-center><i class=\"fa fa-check-square-o\" ng-show=\"li.RelateDataId == modalCtrl.selectedLi.RelateDataId\" style=color:blue></i><i class=\"fa fa-check-square-o\" ng-show=\"li.UseYN == \'Y\'\" style=color:red></i></td><td><span ng-bind=li.DatagroupNm></span></td><td><span ng-bind=li.MaShopId></span></td><td><span ng-bind=\"li.BeginDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></td><td><span ng-bind=\"li.EndDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></td></tr></tbody></table></div><!-- /row --><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=modalCtrl.totalItems ng-model=modalCtrl.currentPage total-items=modalCtrl.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=modalCtrl.pageChanged() direction-links=true boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html rotate=false max-size=modalCtrl.maxSize items-per-page=modalCtrl.viewSize></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok() ng-disabled=\"modalCtrl.selectedLi.RelateDataId == null\"><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/excel/upload-excel-user-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>{{ \'Menu.EXCEL\' | translate }} {{ \'Menu.FILE_UPLOAD\' | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-7><div class=\"form-group form-inline\"><label>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=col-lg-5><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th></th><th>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</th><th>{{ \'Menu.PERSONINCHARGE\' | translate }}</th><th>{{ \'Menu.TEL\' | translate }}</th><th>{{ \'Menu.EMAIL\' | translate }}</th><th>{{ \'Menu.COMPANYSTATUS\' | translate }}</th><th>{{ \'Menu.JOINDATE\' | translate }}</th><th>{{ \'Menu.WITHDRAWALDATE\' | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><i class=\"fa fa-check-square-o\" ng-show=\"li.TenantId == vc.selectedTenantId\" style=color:red></td><td><span ng-bind=li.TenantNm></span></td><td><span ng-bind=li.Contact></span></td><td><span ng-bind=li.TelNo></span></td><td><span ng-bind=li.Email></span></td><td><span ng-bind=li.TenantStatus></span></td><td><span ng-bind=li.JoinDate></span></td><td><span ng-bind=li.ExitDate></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/department/dept-modal.html","<div class=modal-content modal-drag><div class=dataloader ng-show=vc.dataloader></div><div class=\"modal-header ng-scope\"><div class=page-header>{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.CHOOSE\' | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=tile><span ng-if=doing_async>...loading...</span><div class=\"b-a bg-default lter\"><md-content layout-padding-sm><abn-tree tree-data=my_data tree-control=my_tree on-select=dept_tree_handler(branch) expand-level=2 icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/preview/preview.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>미리보기</h3></div><div class=\"modal-body ng-scope\"><div><img src={{vc.data.url}} alt=\"\"></div><div class=blockor></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div>");
$templateCache.put("components/modal/findIdPwd/findIdPwd-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header ng-if=\"modalCtrl.find == \'id\'\">아이디 찾기</h3><h3 class=page-header ng-if=\"modalCtrl.find == \'pwd\'\">비밀번호 찾기</h3></div><div class=\"modal-body ng-scope\" ng-if=!modalCtrl.success><div class=row ng-if=\"modalCtrl.find == \'id\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><label>사용자명</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=사용자명></div></div></div><div class=row ng-if=\"modalCtrl.find == \'pwd\'\"><div class=col-lg-12><div class=\"form-group form-inline\"><label>아이디</label><input type=text class=form-control ng-model=modalCtrl.LoginId placeholder=아이디></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>이메일</label><input type=text class=form-control ng-model=modalCtrl.Email placeholder=이메일></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.sendMail()><i class=\"fa fa-check\"></i> 아이디/비밀번호 찾기</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div><div class=\"modal-body ng-scope\" ng-if=\"modalCtrl.success && modalCtrl.find == \'pwd\' && !modalCtrl.setPass\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>인증번호</label><input type=text class=form-control ng-model=modalCtrl.crtfcNo placeholder=인증번호></div></div><div class=\"col-xs-12 col-sm-2 col-md-2 col-lg-2\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.getCrtfcNo()><i class=\"fa fa-check\"></i>인증하기</button></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3\" ng-if=\"modalCtrl.success && modalCtrl.pass\"><span style=color:red>인증되었습니다.</span></div></div><div class=row ng-if=\"modalCtrl.success && modalCtrl.pass\"><div class=col-lg-12><div class=\"form-group form-inline\"><label>비밀번호</label><input type=password class=\"form-control form-right\" maxlength=20 ng-model=modalCtrl.data.Password required></div></div></div><div class=row ng-if=\"modalCtrl.success && modalCtrl.pass\"><div class=col-lg-12><div class=\"form-group form-inline\"><label>PW확인</label><input type=password class=\"form-control form-right\" maxlength=20 ng-model=modalCtrl.data.Password2 required></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.setData()><i class=\"fa fa-check\"></i>비밀번호변경</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div><div class=\"modal-body ng-scope\" ng-if=\"modalCtrl.success && modalCtrl.find ==\'id\'\"><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><h3 style=\"text-align: center\">{{modalCtrl.data.UserNm}}님의 아이디는 {{modalCtrl.data.LoginId}} 입니다.</h3></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>확인</button></div></div><div class=\"modal-body ng-scope\" ng-if=\"modalCtrl.success && modalCtrl.setPass\"><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><h3 style=\"text-align: center\">비밀번호가 변경되었습니다.</h3></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>확인</button></div></div></div>");
$templateCache.put("components/modal/mypage/mypage-modal.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>내정보 수정</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label><input ng-if=\"modalCtrl.data.KeyId!= null && modalCtrl.data.KeyId != \'\'\" type=text class=\"form-control form-right\" ng-model=modalCtrl.data.LoginId readonly> <input ng-if=\"modalCtrl.data.KeyId== null || modalCtrl.data.KeyId == \'\'\" type=text class=\"form-control form-right\" ng-model=modalCtrl.data.LoginId maxlength=20 ng-blur=modalCtrl.chkDupLoginId()></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=modalCtrl.data.UserNm></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>비밀번호</label><input type=password class=\"form-control form-right\" minlength=8 maxlength=14 ng-model=modalCtrl.data.Password></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>비밀번호확인</label><input type=password class=\"form-control form-right\" minlength=8 maxlength=14 ng-model=modalCtrl.data.Password2></div></div></div><div class=row><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.TenantNm readonly></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{ modalCtrl.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=modalCtrl.data.Email></div></div></div><!-- /row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{modalCtrl.columnMap[\'TelNo\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-hyphen ng-model=modalCtrl.data.TelNo></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{modalCtrl.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-hyphen ng-model=modalCtrl.data.Mobile></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'BirthDay\'].ColumnLogicalNm | translate }}</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.data.BirthDay = (modalCtrl.BirthDay | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.BirthDay ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=form-group><label class=radio-inline ng-repeat=\"li in modalCtrl.columnMap[\'LnrSlrType\'].CodeList\"><input type=radio ng-model=modalCtrl.data.LnrSlrType value={{li.Code}}>{{li.CodeValue}}</label></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{modalCtrl.columnMap[\'EmgCntct\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-hyphen ng-model=modalCtrl.data.EmgCntct></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'BankNm\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=20 ng-model=modalCtrl.data.BankNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'AcctNo\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=20 numbers-hyphen ng-model=modalCtrl.data.AcctNo></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'AttendTime\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'AttendTime\'].CodeList\" code-model=modalCtrl.data.AttendTime></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'OffWorkTime\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'OffWorkTime\'].CodeList\" code-model=modalCtrl.data.OffWorkTime></common-code-custom></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=form-group><label>근무요일</label><div style=\"padding-left: 20%; position: absolute; display: inline-block\"><label class=\"ng-binding radio-inline\"><input type=checkbox ng-model=modalCtrl.data.MonWorkYN ng-checked=\"modalCtrl.data.MonWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{modalCtrl.columnMap[\'MonWorkYN\'].ColumnLogicalNm | translate }}</label><label class=\"ng-binding radio-inline\"><input type=checkbox ng-model=modalCtrl.data.TueWorkYN ng-checked=\"modalCtrl.data.TueWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{modalCtrl.columnMap[\'TueWorkYN\'].ColumnLogicalNm | translate }}</label><label class=\"ng-binding radio-inline\"><input type=checkbox ng-model=modalCtrl.data.WedWorkYN ng-checked=\"modalCtrl.data.WedWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{modalCtrl.columnMap[\'WedWorkYN\'].ColumnLogicalNm | translate }}</label><label class=\"ng-binding radio-inline\"><input type=checkbox ng-model=modalCtrl.data.ThuWorkYN ng-checked=\"modalCtrl.data.ThuWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{modalCtrl.columnMap[\'ThuWorkYN\'].ColumnLogicalNm | translate }}</label><label class=\"ng-binding radio-inline\"><input type=checkbox ng-model=modalCtrl.data.FriWorkYN ng-checked=\"modalCtrl.data.FriWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{modalCtrl.columnMap[\'FriWorkYN\'].ColumnLogicalNm | translate }}</label><label class=\"ng-binding radio-inline\"><input type=checkbox ng-model=modalCtrl.data.SatWorkYN ng-checked=\"modalCtrl.data.SatWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{modalCtrl.columnMap[\'SatWorkYN\'].ColumnLogicalNm | translate }}</label><label class=\"ng-binding radio-inline\"><input type=checkbox ng-model=modalCtrl.data.SunWorkYN ng-checked=\"modalCtrl.data.SunWorkYN ==\'Y\' ? true:false\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{modalCtrl.columnMap[\'SunWorkYN\'].ColumnLogicalNm | translate }}</label></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=form-group><span style=\"color : red\">영문자, 숫자, 특수문자 중 3가지 조합(대소문자 구분함)<br>최소 8자 ~ 최대 14자 (띄어쓰기 제외) / 특수문자 !@#$%^&*()-_;:&lt;&gt;,.[]{} 사용 가능<br>동일한 문자(숫자 포함) 3자 이상 연속 금지 ex) aaa, 111 / 연속적으로 증감되는 숫자, 문자 금지 Ex) abc, 123<br>생년월일 숫자와 4자 이상 중복되는 경우 사용불가</span></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.setData()><i class=\"fa fa-check\"></i> 수정</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div>");
$templateCache.put("components/modal/mypage/wjm-mypage-modal.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>내정보 수정</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.LoginId readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>업체명</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.UserNm readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>비밀번호</label><input type=password class=\"form-control form-right\" minlength=8 maxlength=14 ng-model=modalCtrl.data.Password></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>비밀번호확인</label><input type=password class=\"form-control form-right\" minlength=8 maxlength=14 ng-model=modalCtrl.data.Password2></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><label>{{ modalCtrl.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=modalCtrl.data.Email></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline xs-mb10\"><label>{{modalCtrl.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=255 numbers-hyphen ng-model=modalCtrl.data.Mobile></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><div class=input-group>영문자, 숫자, 특수문자를 모두 포함하여 8~14자리로 생성<br>(대소문자 구분, 특수문자 !@#$%^&*()-_;:&lt;&gt;,.[]{} 사용 가능, 3자 이상 연속으로 동일하거나 증감하는 문자 사용불가 ex) 111, aaa, 123, abc)</div></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.setData()><i class=\"fa fa-check\"></i> 수정</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div>");
$templateCache.put("components/modal/product/product-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>제품(단품) 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-6 col-sm-7 col-md-7 col-lg-7 col-xl-7\"><div class=\"form-group form-inline\"><label>품목명</label><input type=text class=form-control ng-model=modalCtrl.srch.ProductNm placeholder=품목명></div></div><div class=\"col-xs-6 col-sm-5 col-md-5 col-lg-5 col-xl-5\"><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=20% style=\"align-content: center\"><col width=50%><col width=20%><col width=10%></colgroup><thead><tr><th class=\"text-center none\"><span>품목코드</span></th><th class=\"text-center none\"><span>품목명</span></th><th class=\"text-center none\"><span>금액</span></th><th class=\"text-center none\"><span>재고</span></th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.productlists\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td><span ng-bind=li.GoodsNo></span></td><td><span ng-bind=li.GoodsNm></span></td><td class=text-none><span comma-bind ng-bind=li.GoodsPrice></span></td><td class=text-center><span ng-bind=li.TotalStock ng-class=\"{total_stock_red: li.TotalStock == 0}\"></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.srch.viewSize ng-model=modalCtrl.currentPage ng-change=modalCtrl.pageChanged() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/product/productall-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>제품(단품) 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-7><div class=\"form-group form-inline\"><label>품목명</label><input type=text class=form-control ng-model=modalCtrl.srch.ProductNm placeholder=품목명></div></div><div class=col-lg-5><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=20% style=\"align-content: center\"><col width=50%><col width=20%><col width=10%></colgroup><thead><tr><th class=\"text-center none\"><span>품목코드</span></th><th class=\"text-center none\"><span>품목명</span></th><th class=\"text-center none\"><span>금액</span></th><th class=\"text-center none\"><span>재고</span></th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.productlists\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td><span ng-bind=li.GoodsNo></span></td><td><span ng-bind=li.GoodsNm></span></td><td class=text-none><span comma-bind ng-bind=li.GoodsPrice></span></td><td class=text-center><span ng-bind=li.TotalStock ng-class=\"{total_stock_red: li.TotalStock == 0}\"></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.srch.viewSize ng-model=modalCtrl.currentPage ng-change=modalCtrl.pageChanged() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/classfyinfo-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>분류정보 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getClassfyInfoList()\'}\"><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9\"><div class=\"form-group form-inline\"><label>분류정보명</label><input type=text class=form-control ng-model=modalCtrl.ClassfyInfoNm placeholder=\"{{modalCtrl.columnMap[\'ClassfyInfoNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getClassfyInfoList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>분류정보명</th><th data-toggle=true class=text-center>업체명</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.ClassfyInfoList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.ClassfyInfoNm></span></td><td class=text-center><span ng-bind=li.ManagerNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getClassfyInfoList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/menusvy-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>연관설문 추가</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-5><div class=\"form-group form-inline\"><label>제목</label><input type=text class=form-control ng-model=vc.srch.SvyNm placeholder=제목></div></div><div class=col-lg-5><div class=\"form-group form-inline\"><label>유형</label><common-code-custom code-list=vc.SvyTypeCodeList code-model=vc.srch.SvyType></common-code-custom></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=1%><col width=*><col width=20%><!--\r\n              <col width=\"10%\">\r\n              <col width=\"15%\">\r\n              --></colgroup><thead><tr><th class=text-center style=vertical-align:middle><input type=checkbox ng-model=vc.svyChkHead ng-change=svyChkHeadChg()></th><th class=\"text-center none\"><span>제목</span></th><th class=\"text-center none\"><span>구분</span></th><!--\r\n              <th class=\"text-center none\"><span>통과점수</span></th>\r\n              <th class=\"text-center none\"><span>신규가입표시여부</span></th>\r\n              --></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.svyLists\"><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.svyChkRow ng-change=svyChkRowChg()></td><td><span ng-bind=li.SvyNm></span></td><td><span ng-bind=li.SvyType_></span></td><!--\r\n              <td><span ng-bind=\"li.PassScore\"></span></td>\r\n              <td><span ng-bind=\"li.JoinShowYN\"></span></td>\r\n              --></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-check\"></i>선택설문 추가</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/pre-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>설문 미리보기</div></div><div class=\"modal-body ng-scope\"><div class=row ng-repeat=\"li in vc.qstLists\"><div class=col-lg-12><div class=row style=padding-bottom:5px><div class=col-lg-12><strong>{{li.QstNo}}. {{li.QstSubject}}</strong></div></div><div class=row style=padding-bottom:20px><div class=col-lg-12><div ng-show=\"li.QstType == \'100\'\"><ul><li ng-repeat=\"li2 in vc.qstItemLists[$index]\"><input type=radio ng-model=\"vc[\'rdo_\' + $parent.$index]\" value={{$index}} ng-checked=false style=margin-top:-3px> {{li2.QstItemNo}}. {{li2.QstItemContents}}</li></ul></div><div ng-show=\"li.QstType == \'300\'\"><textarea rows=3 class=\"form-control form-right\" maxlength=100></textarea></div><div ng-show=\"li.QstType == \'200\'\"><ul><li ng-repeat=\"li2 in vc.qstItemLists[$index]\"><input type=checkbox ng-model=\"vc[\'rdo_\' + $parent.$index + \'_\' + $index]\" value={{$index}} style=margin-top:-3px> {{li2.QstItemNo}}. {{li2.QstItemContents}}</li></ul></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/qst-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>설문문제 등록/수정</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>No</label><input type=text class=form-control ng-model=vc.data.QstNo maxlength=3 numbers-hyphen></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>유형</label><common-code-custom code-list=vc.QstTypeCodeList code-model=vc.data.QstType is-disabled=true></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>제목</label><input type=text class=form-control ng-model=vc.data.QstSubject maxlength=50></div></div></div><div class=row ng-show=\"vc.data.QstType == \'300\'\"><div class=col-lg-6><div class=\"form-group form-inline\"><label>배점</label><input type=text class=form-control ng-model=vc.data.QstItemScore maxlength=3 numbers-hyphen></div></div></div><div class=row ng-show=\"vc.data.QstType != \'300\'\"><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=100 class=\"table table-hover\"><colgroup><col width=10%><col width=*><col width=10%><col width=10%></colgroup><thead><tr><th>No</th><th>내용</th><th>배점</th><th></th></tr></thead><tbody><tr ng-repeat=\"li in vc.qstItemLists\"><td><input type=text class=form-control ng-model=li.QstItemNo maxlength=3 numbers-hyphen></td><td><input type=text class=form-control ng-model=li.QstItemContents maxlength=100></td><td><input type=text class=form-control ng-model=li.QstItemScore maxlength=3 numbers-hyphen></td><td><button class=\"btn btn-default\" ng-click=vc.setDelQstItemData(li.KeyId3)>삭제</button></td></tr><tr><td><input type=text class=form-control ng-model=vc.data.NewQstItemNo maxlength=3 numbers-hyphen></td><td><input type=text class=form-control ng-model=vc.data.NewQstItemContents maxlength=100></td><td><input type=text class=form-control ng-model=vc.data.NewQstItemScore maxlength=3 numbers-hyphen></td><td></td></tr></tbody></table></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setQstData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}/행추가</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/survey-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>설문지 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-5><div class=\"form-group form-inline\"><label>제목</label><input type=text class=form-control ng-model=modalCtrl.srch.SvyNm placeholder=제목></div></div><div class=col-lg-5><div class=\"form-group form-inline\"><label>{{ modalCtrl.columnMap[\'SvyType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'SvyType\'].CodeList\" code-model=modalCtrl.srch.SvyType></common-code-custom></div></div><div class=col-lg-2><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=70% style=\"align-content: center\"><col width=30%></colgroup><thead><tr><th class=\"text-center none\"><span>제목</span></th><th class=\"text-center none\"><span>구분</span></th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.svyLists\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td><span ng-bind=li.SvyNm></span></td><td><span ng-bind=li.SvyType_></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.srch.viewSize ng-model=modalCtrl.currentPage ng-change=modalCtrl.pageChanged() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/svytype-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>설문유형 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getSvyTypeList()\'}\"><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9\"><div class=\"form-group form-inline\"><label>설문유형명</label><input type=text class=form-control ng-model=modalCtrl.SvyTypeNm placeholder=\"{{modalCtrl.columnMap[\'SvyTypeNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getSvyTypeList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>설문유형명</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.SvyTypeList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.SvyTypeNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getSvyTypeList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/tgt-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>{{vc.pageTitle}} 추가</div></div><div class=\"modal-body ng-scope\"><div ng-show=\"vc.srch.tgtType == \'100\'\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>이름</label><input type=text class=form-control ng-model=vc.srch.UserNm></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>연락처</label><input type=text class=form-control ng-model=vc.srch.Mobile></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>등급</label><common-code-custom code-list=vc.UserGradeCodeList code-model=vc.srch.UserGrade></common-code-custom></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>지역(시/도)</label><input type=text class=form-control ng-model=vc.srch.Addr1></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>나이(시작)</label><input type=text class=form-control ng-model=vc.srch.AgeFrom numbers-hyphen maxlength=3></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>나이(종료)</label><input type=text class=form-control ng-model=vc.srch.AgeTo numbers-hyphen maxlength=3></div></div></div></div><div ng-show=\"vc.srch.tgtType == \'200\'\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>이름</label><input type=text class=form-control ng-model=vc.srch.CustNm></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>연락처</label><input type=text class=form-control ng-model=vc.srch.Mobile numbers-hyphen></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>성별</label><common-code-custom code-list=vc.GenderCodeList code-model=vc.srch.Gender></common-code-custom></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>등급</label><common-code-custom code-list=vc.CustGradeCodeList code-model=vc.srch.CustGrade></common-code-custom></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>나이(시작)</label><input type=text class=form-control ng-model=vc.srch.AgeFrom numbers-hyphen maxlength=3></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>나이(종료)</label><input type=text class=form-control ng-model=vc.srch.AgeTo numbers-hyphen maxlength=3></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>지역(시/도)</label><input type=text class=form-control ng-model=vc.srch.Addr1></div></div></div></div><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>Shop명</label><div class=input-group><input type=text class=form-control ng-model=vc.srch.TenantNm readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchTenantModal(); type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseTenant(); type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>추출대상수</label><div class=input-group><input type=text class=form-control ng-model=vc.data.TgtCnt readonly></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.getData()><i class=\"glyphicon glyphicon-search\"></i> 추출</button> <button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> 테스트대상추가</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> {{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-anal-preview-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>데이터 미리보기</h3></div><div class=\"modal-body ng-scope\" id=divToImage><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-repeat=\"cht in vc.chtList\" ng-if=\"cht.cntTot > 0\"><div ng-if=\"vc.dataType.typeChtCd != \'\'\"><canvas class=chart-base chart-type=cht.type chart-data=cht.data chart-series=cht.series chart-labels=cht.labels chart-colors=cht.colors chart-options=cht.options></canvas></div></div></div><div class=\"row pt-10 pb-10\" ng-if=\"vc.chtList.length == 1\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table id=dtTable class=\"table table-striped table-bordered table-hover data_table table-custom\"><tr><th class=text-center>구분</th><th class=text-center>대상수(명)</th></tr><tr ng-repeat=\"li in vc.chtList[0].dataList\"><td class=text-center><span ng-bind=li.Type></span></td><td class=text-center><span ng-bind=li.Rate></span></td></tr></table></div></div><div class=\"row pt-10 pb-10\" ng-if=\"vc.chtList.length > 1\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table id=dtTable class=\"table table-striped table-bordered table-hover data_table table-custom\"><tr><th class=text-center>구분</th><th class=text-center ng-repeat=\"cht in vc.chtList\"><span ng-bind=cht.title></span></th></tr><tr ng-repeat=\"li in vc.chtList[0].dataList\"><td class=text-center><span ng-bind=li.Type></span></td><td class=text-center ng-repeat=\"cht in vc.chtList\"><span ng-bind=\"(cht.dataList | filter: {LvCd: li.LvCd} : true)[0].Rate\"></span></td></tr></table></div></div><div class=row style=\"overflow:auto; height:200px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table id=dtList class=\"table table-striped table-bordered table-hover data_table table-custom\"><tr><th class=text-center>대상자</th><th class=text-center ng-if=vc.gdChk>성별</th><th class=text-center ng-if=vc.agChk>연령대</th><th class=text-center ng-if=vc.psChk>직급</th><th class=text-center ng-if=vc.gr1Chk>그룹1</th><th class=text-center ng-if=vc.gr2Chk>그룹2</th><th class=text-center ng-if=vc.gr3Chk>그룹3</th><th class=text-center ng-if=vc.gr4Chk>그룹4</th><th class=text-center>진단결과</th></tr><tr ng-repeat=\"li in vc.tgtList\"><td class=text-center><span ng-bind=li.Name></span></td><td class=text-center ng-if=vc.gdChk><span ng-bind=li.GdNm></span></td><td class=text-center ng-if=vc.agChk><span ng-bind=li.AgNm></span></td><td class=text-center ng-if=vc.psChk><span ng-bind=li.PsNm></span></td><td class=text-center ng-if=vc.gr1Chk><span ng-bind=li.Gr1Nm></span></td><td class=text-center ng-if=vc.gr2Chk><span ng-bind=li.Gr2Nm></span></td><td class=text-center ng-if=vc.gr3Chk><span ng-bind=li.Gr3Nm></span></td><td class=text-center ng-if=vc.gr4Chk><span ng-bind=li.Gr4Nm></span></td><td class=text-center><span ng-bind=li.LvTxt></span></td></tr></table></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" id=btnSaveImage><i class=\"fa fa-image\"></i> 이미지 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div><!-- 이미지로 --><script language=JavaScript type=text/javascript>$(\'#btnSaveImage\').click(function () {\r\n    html2canvas($(\"#divToImage\"), {\r\n      onrendered: function(canvas) {\r\n        var fileNm = \"ChartImage.png\";\r\n        if (window.navigator.msSaveOrOpenBlob) { // IE 10+\r\n          window.navigator.msSaveOrOpenBlob(canvas.msToBlob(), fileNm);\r\n        } else {\r\n          var a = document.createElement(\"a\");\r\n          a.href = canvas.toDataURL(\"image/png\");\r\n          a.download = fileNm;\r\n          a.click();\r\n        }\r\n      }\r\n    });\r\n  });</script>");
$templateCache.put("components/modal/survey/wjm-form-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>서식 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getList()\'}\"><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9\"><div class=\"form-group form-inline\"><label>서식명</label><input type=text class=form-control ng-model=modalCtrl.FormNm placeholder=\"{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><!--<th data-toggle=\"true\" class=\"text-center\">서식유형</th>--><th data-toggle=true class=text-center>서식명</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.lists\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><!--<td class=\"text-center\"><span ng-bind=\"li.FormTypeNm\"></span></td>--><td class=text-center><span ng-bind=li.FormNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-group-edit-modal.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>수신인 추가/수정</h3></div><form id=form1 name=form1><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>수신인</label><input type=text class=\"form-control form-right\" ng-model=vc.srch.GrpNm readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>이름</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CustNm maxlength=100></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>휴대폰</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Mobile ng-change=\"vc.getIsDup(\'M\')\" maxlength=255></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>이메일</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Email ng-change=\"vc.getIsDup(\'E\')\" maxlength=255></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div>");
$templateCache.put("components/modal/survey/wjm-group-edit-modal2.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>대상자 추가/수정</h3></div><form id=form1 name=form1><input type=hidden class=\"form-control form-right\" readonly><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>이름</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CustNm maxlength=100></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>휴대폰</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Mobile maxlength=255></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>이메일</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Email maxlength=255></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div>");
$templateCache.put("components/modal/survey/wjm-group-edit-modal3.html","<link rel=stylesheet href=/assets/SlickGrid-2.1.0/slick.grid.css type=text/css><link rel=stylesheet href=/assets/SlickGrid-2.1.0/css/smoothness/jquery-ui-1.8.16.custom.css type=text/css><link rel=stylesheet href=/assets/SlickGrid-2.1.0/examples/examples.css type=text/css><style>.slick-cell.copied {\r\n        /*background: blue;\r\n        background: rgba(0, 0, 255, 0.2);\r\n        -webkit-transition: 0.5s background;*/\r\n    }\r\n\r\n    .header-column-alignCenter {\r\n        text-align: center;\r\n        font-size: 12px;\r\n        padding: 0px !Important;\r\n    }\r\n\r\n    .cell-column-alignCenter {\r\n        text-align: center;\r\n        font-size: 12px;\r\n        padding: 0px !Important;\r\n    }</style><div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>대상자 추가</h3></div><form id=form1 name=form1><input type=hidden class=\"form-control form-right\" readonly><div class=\"modal-body ng-scope\"><div class=row><div class=col-sm-12><div class=\"panel panel-default\"><div class=\"panel-body collapse in\" id=collapse1><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-10\"><ul><li>* 엑셀에서 여러 행의 데이터를 복사 후, 아래 셀을 클릭하여 붙여넣기 할 수 있습니다.</li><li>* 중복된 {{vc.sendTypeNm}} 정보는 자동으로 제외됩니다.</li></ul></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div style=\"width: 480px; margin: auto; overflow: hidden\"><div id=myGrid style=\"width: 100%; height: 380px\"></div></div></div></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div><script src=/assets/SlickGrid-2.1.0/lib/firebugx.js></script><script src=/assets/SlickGrid-2.1.0/lib/jquery-1.7.min.js></script><script src=/assets/SlickGrid-2.1.0/lib/jquery-ui-1.8.16.custom.min.js></script><script src=/assets/SlickGrid-2.1.0/lib/jquery.event.drag-2.2.js></script><script src=/assets/SlickGrid-2.1.0/slick.core.js></script><script src=/assets/SlickGrid-2.1.0/plugins/slick.autotooltips.js></script><script src=/assets/SlickGrid-2.1.0/plugins/slick.cellrangedecorator.js></script><script src=/assets/SlickGrid-2.1.0/plugins/slick.cellrangeselector.js></script><script src=/assets/SlickGrid-2.1.0/plugins/slick.cellexternalcopymanager.js></script><script src=/assets/SlickGrid-2.1.0/plugins/slick.cellselectionmodel.js></script><script src=/assets/SlickGrid-2.1.0/slick.editors.js></script><script src=/assets/SlickGrid-2.1.0/slick.formatters.js></script><script src=/assets/SlickGrid-2.1.0/slick.grid.js></script><script>var grid;\r\n    var data = [];\r\n\r\n    var options = {\r\n        editable: true,\r\n        enableAddRow: true,\r\n        enableCellNavigation: true,\r\n        asyncEditorLoading: false,\r\n        autoEdit: true\r\n    };\r\n\r\n    var undoRedoBuffer = {\r\n        commandQueue: [],\r\n        commandCtr: 0,\r\n\r\n        queueAndExecuteCommand: function (editCommand) {\r\n            this.commandQueue[this.commandCtr] = editCommand;\r\n            this.commandCtr++;\r\n            editCommand.execute();\r\n        },\r\n\r\n        undo: function () {\r\n            if (this.commandCtr == 0)\r\n                return;\r\n\r\n            this.commandCtr--;\r\n            var command = this.commandQueue[this.commandCtr];\r\n\r\n            if (command && Slick.GlobalEditorLock.cancelCurrentEdit()) {\r\n                command.undo();\r\n            }\r\n        },\r\n        redo: function () {\r\n            if (this.commandCtr >= this.commandQueue.length)\r\n                return;\r\n            var command = this.commandQueue[this.commandCtr];\r\n            this.commandCtr++;\r\n            if (command && Slick.GlobalEditorLock.cancelCurrentEdit()) {\r\n                command.execute();\r\n            }\r\n        }\r\n    }\r\n\r\n    // undo shortcut\r\n    $(document).keydown(function (e) {\r\n        if (e.which == 90 && (e.ctrlKey || e.metaKey)) {    // CTRL + (shift) + Z\r\n            if (e.shiftKey) {\r\n                undoRedoBuffer.redo();\r\n            } else {\r\n                undoRedoBuffer.undo();\r\n            }\r\n        }\r\n    });\r\n\r\n    var pluginOptions = {\r\n        clipboardCommandHandler: function (editCommand) { undoRedoBuffer.queueAndExecuteCommand.call(undoRedoBuffer, editCommand); },\r\n        includeHeaderWhenCopying: false\r\n    };\r\n\r\n    var columns = [\r\n      { id: \"name\", name: \"이름\", field: \"name\", width: 160, editor: Slick.Editors.Text, headerCssClass: \"header-column-alignCenter\", cssClass: \"cell-column-alignCenter\" },\r\n      { id: \"mobile\", name: \"휴대폰\", field: \"mobile\", width: 160, editor: Slick.Editors.Text, headerCssClass: \"header-column-alignCenter\", cssClass: \"cell-column-alignCenter\" },\r\n      { id: \"email\", name: \"이메일\", field: \"email\", width: 160, editor: Slick.Editors.Text, headerCssClass: \"header-column-alignCenter\", cssClass: \"cell-column-alignCenter\" }\r\n    ];\r\n\r\n\r\n    $(function () {\r\n        // 초기 정보 셋팅\r\n        var directDataRowArr;\r\n        // var $objDirectData = $(opener.document).find(\"#ContentPage_hdnInsertDirectData\");\r\n\r\n        // if ($objDirectData.val() != \"\") {\r\n        //     directDataRowArr = $objDirectData.val().split(\';\');\r\n\r\n        //     for (var i = 0; i < directDataRowArr.length; i++) {\r\n        //         var d = (data[i] = {});\r\n        //         d[\"mobile\"] = directDataRowArr[i];\r\n        //     }\r\n        // }\r\n        //else {\r\n        //    var d = (data[0] = {});\r\n        //    d[\"mobile\"] = \"010-0000-0000\";\r\n        //}\r\n\r\n        grid = new Slick.Grid(\"#myGrid\", data, columns, options);\r\n        grid.setSelectionModel(new Slick.CellSelectionModel());\r\n        grid.registerPlugin(new Slick.AutoTooltips());\r\n\r\n        // set keyboard focus on the grid\r\n        grid.getCanvasNode().focus();\r\n\r\n        grid.registerPlugin(new Slick.CellExternalCopyManager(pluginOptions));\r\n\r\n        grid.onAddNewRow.subscribe(function (e, args) {\r\n            var item = args.item;\r\n            var column = args.column;\r\n            grid.invalidateRow(data.length);\r\n            data.push(item);\r\n            grid.updateRowCount();\r\n            grid.render();\r\n        });\r\n    })</script>");
$templateCache.put("components/modal/survey/wjm-pre-modal.html","<!--\r\nstyle=\"width:956px; height:693px;\"\r\n--><div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>미리보기</div></div><div class=row ng-show=\"vc.svyInfo.logoSrc != null && vc.svyInfo.logoSrc != \'\'\" style=\"padding: 15px 15px 0 15px\"><div class=col-lg-12><img ng-src={{vc.svyInfo.logoSrc}} style=width:100px></div></div><div class=row><div class=col-lg-12 style=\"padding:15px 25px 0 25px !Important\"><h3 class=svy-title><span ng-if=\"vc.svyInfo.SvyNm != \'\'\">{{vc.svyInfo.SvyNm}}</span> <span ng-if=\"vc.svyInfo.SvyNm == null || vc.svyInfo.SvyNm == \'\'\">{{wjmSurvey.getLangData(\"L00001\", vc.svyInfo.SvyLang)}}</span></h3></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding><!--[{{vc.svyPagesTypeTxt}}]--> &nbsp;</strong><div class=pull-right>{{vc.svyPagesTxt}}&nbsp;&nbsp;&nbsp;&nbsp; <a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=row ng-if=\"vc.svyPagesType == \'1\'\"><div class=col-lg-12><span ng-bind-html=vc.svyInfo.TopCont|htmlString></span></div></div><div class=row ng-if=\"vc.svyPagesType == \'2\'\"><div class=col-lg-12 style=\"padding:20px; max-width: 900px\"><div class=row ng-repeat=\"qt in vc.svyQstsCur | filter : {stat: \'!D\'} : true\"><!-- 선택형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'1\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, vc.svyInfo.QstIconType, vc.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\" style=padding-top:10px><label ng-class=\"wjmSurvey.getItemSelClass(vc.svyResps[qt.qtId][0], it.itId, qt.SelType, vc.svyResps[qt.qtId][$index])\"><input type=radio ng-model=vc.svyResps[qt.qtId][0] ng-value=it.itId class=rdosvy style=margin-top:-3px ng-checked=\"vc.setBeginQtId(qt, it)\" ng-if=\"qt.SelType==\'S\'\"> <input type=checkbox ng-model=vc.svyResps[qt.qtId][$index] ng-true-value=\"{{\'\\\'\'+ it.itId + \'\\\'\'}}\" ng-false-value=undefined class=rdosvy ng-checked=\"vc.setBeginQtId(qt, it, $index)\" style=margin-top:-3px ng-if=\"qt.SelType==\'M\'\"> &nbsp;&nbsp;<!--{{it.QstItemNo}}. -->{{it.QstItemContents}} <input type=text ng-show=\'it.OtherRespYN == \"Y\" && qt.SelType==\"S\"\' ng-model=vc.svyRespsSbj[qt.qtId][0] class=\"form-control svy-qstitem\" maxlength=100 style=\"margin-top:5px;margin-left:15px !Important; max-width:80% !Important\" kr-input> <input type=text ng-show=\'it.OtherRespYN == \"Y\" && qt.SelType==\"M\"\' ng-model=vc.svyRespsSbj[qt.qtId][$index] class=\"form-control svy-qstitem\" maxlength=100 style=\"margin-top:5px;margin-left:15px !Important; max-width:80% !Important\" kr-input></label></p></div><!-- 입력형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'2\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, vc.svyInfo.QstIconType, vc.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><div style=padding-top:10px><textarea ng-show=\"qt.InputType != null && qt.InputType == \'T\'\" ng-model=vc.svyResps[qt.qtId][0] ng-change=\"vc.chkSbjBytes(qt.qtId, 1000)\" class=\"form-control svy-qstitem\" style=height:100px maxlength=1000 ng-blur=\"survey.setBeginQtId(qt, null)\" kr-input placeholder={{qt.InputHint}}></textarea><div class=text-right ng-show=\"qt.InputType != null && qt.InputType == \'T\'\">{{(vc.CutMsg[qt.qtId] ? vc.CutMsg[qt.qtId] : 0)}} / 2000 bytes</div><input type=text ng-show=\"qt.InputType != null && qt.InputType == \'I\'\" ng-model=vc.svyResps[qt.qtId][0] class=\"form-control svy-qstitem\" maxlength=100 style=\"max-width:80% !Important\" ng-blur=\"survey.setBeginQtId(qt, null)\" kr-input placeholder={{qt.InputHint}}></div></div><!-- 우선순위형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'3\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, vc.svyInfo.QstIconType, vc.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><div class=row><div class=col-sm-6 style=padding-bottom:10px><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\" style=padding-top:10px class=svy-qstitem>{{it.QstItemNo}}. {{it.QstItemContents}}</p></div><div class=col-sm-6><p ng-repeat=\"n in [].constructor(qt.QstTopCnt) track by $index\" style=padding-top:10px><select class=\"form-control svy-qstitem\" ng-model=vc.svyResps[qt.qtId][$index] ng-options=\"li.itId as li.QstItemContents for li in vc.svyQstItems | filter : {qtId: qt.qtId} : true\" ng-change=\"survey.setBeginQtId(qt, null, $index)\"><option value=\"\">--{{$index + 1}}{{wjmSurvey.getLangData(\"L00002\", vc.svyInfo.SvyLang)}}--</option></select></p></div></div></div><!-- 이미지형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'4\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, vc.svyInfo.QstIconType, vc.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><p style=padding-top:10px ng-show=\"qt.qtImgSrc != null && qt.qtImgSrc != \'\'\"><img ng-src={{qt.qtImgSrc}} style=\"width:140px; height:140px\"></p><p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\" style=padding-top:5px><label ng-class=\"wjmSurvey.getItemSelClass(vc.svyResps[qt.qtId][0], it.itId)\"><input type=radio ng-model=vc.svyResps[qt.qtId][0] ng-value=it.itId class=rdosvy style=margin-top:-3px ng-checked=\"vc.setBeginQtId(qt, it)\">&nbsp;<span ng-show=\"it.itImgSrc != null && it.itImgSrc != \'\'\">&nbsp;&nbsp;&nbsp;<img ng-src={{it.itImgSrc}} style=\"width:70px; height:70px\">&nbsp;&nbsp;</span><!--{{it.QstItemNo}}. --> {{it.QstItemContents}}</label></p></div><!-- 척도형 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'5\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, vc.svyInfo.QstIconType, vc.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><div class=row ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\" style=padding-top:10px><div class=col-lg-3><span class=rdosvy-label>{{it.QstItemContents}}</span></div><div class=col-lg-6><ul style=\"display: table; width:100%\"><li style=\"display:table-cell; text-align: center\" ng-repeat=\"n in [].constructor(qt.ScaleMax) track by $index\"><label class=rdosvy-label><input type=radio ng-model=vc.svyResps[qt.qtId][$parent.$index] ng-value=\"it.itId + \'|\' + (qt.ScaleOrder==\'A\' ? $index + 1 : qt.ScaleMax - $index)\" class=rdosvy style=margin-top:-3px ng-checked=\"survey.setBeginQtId(qt, null)\"> <span ng-if=\"qt.ScaleOrder==\'A\'\">{{$index + 1}}</span><span ng-if=\"qt.ScaleOrder==\'D\'\">{{qt.ScaleMax - $index}}</span></label></li></ul></div><div class=\"col-lg-3 text-right\"><span class=rdosvy-label>{{it.QstItemContents2}}</span></div></div></div><!-- 분류정보 --><div class=col-lg-12 style=padding-bottom:50px ng-if=\"qt.QstType == \'C\'\"><div class=row style=\"min-height:40px; padding:10px 0 10px 0; background-color: #f4f4f4\" id=divQstSubject_{{qt.qtId}}><div class=col-lg-12><pre class=\"txt-pre-tit svy-qst\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}><span ng-bind-html=\"wjmSurvey.getQstStyle(qt.QstNo, vc.svyInfo.QstIconType, vc.svyInfo.QstNumYN)|htmlString\"></span>{{qt.QstSubject}}</pre></div></div><div ng-if=\"qt.ClassfyCd == \'NM\'\" style=padding-top:10px><div class=\"form-group form-inline\"><input type=text ng-model=vc.svyResps[qt.qtId][0] class=\"form-control svy-qstitem\" maxlength=30 style=\"margin-left:0 !Important; max-width:158px !Important\" kr-input></div></div><div ng-if=\"qt.ClassfyCd == \'MB\'\" style=padding-top:10px><div class=\"form-group form-inline\"><input type=text ng-model=vc.svyResps[qt.qtId][0] class=\"form-control svy-qstitem\" ng-blur=\"wjmSurvey.blurMobile(vc.svyResps, qt.qtId);\" maxlength=13 style=\"margin-left:0 !Important; max-width:158px !Important\" kr-input></div></div><div ng-if=\"qt.ClassfyCd == \'EM\'\" style=padding-top:10px><div class=form-inline><div style=display:inline-block;vertical-align:top;padding-bottom:5px><input type=text ng-model=vc.svyResps[qt.qtId][0] class=\"form-control svy-qstitem\" maxlength=30 style=\"margin:0 5px 0 0; width:200px !Important; float:left\" kr-input>@</div><div style=display:inline-block><input type=text ng-model=vc.svyResps[qt.qtId][1] class=\"form-control svy-qstitem\" maxlength=30 style=\"margin:0 5px 0 0; width:110px !Important; float:left\" ng-disabled=\"vc.svyResps[qt.qtId][2] != null && survey.svyResps[qt.qtId][2] != \'\'\" kr-input><select ng-model=vc.svyResps[qt.qtId][2] class=\"form-control svy-qstitem\" style=\"margin: 0; width:110px !Important\" ng-options=\"li.val as li.txt for li in wjmSurvey.qstEmailDomainList\" ng-change=\"survey.chgQstEmailDomain(vc.svyResps, qt.qtId)\"><option value=\"\">{{wjmSurvey.getLangData(\"L00025\", vc.svyInfo.SvyLang)}}</option></select></div></div></div><div ng-if=\"qt.ClassfyCd == \'GD\'\"><p style=padding-top:10px><label ng-class=\"wjmSurvey.getItemSelClass(vc.svyResps[qt.qtId][0], \'M\')\"><input type=radio ng-model=vc.svyResps[qt.qtId][0] ng-value=\"\'M\'\" class=rdosvy style=margin-top:-3px>&nbsp;&nbsp;<!--{{it.QstItemNo}}. -->{{wjmSurvey.getLangData(\"L00026\", vc.svyInfo.SvyLang)}}</label></p><p style=padding-top:10px><label ng-class=\"wjmSurvey.getItemSelClass(vc.svyResps[qt.qtId][0], \'F\')\"><input type=radio ng-model=vc.svyResps[qt.qtId][0] ng-value=\"\'F\'\" class=rdosvy style=margin-top:-3px>&nbsp;&nbsp;<!--{{it.QstItemNo}}. -->{{wjmSurvey.getLangData(\"L00027\", vc.svyInfo.SvyLang)}}</label></p></div><div ng-if=\"qt.ClassfyCd != \'NM\' && qt.ClassfyCd != \'MB\' && qt.ClassfyCd != \'EM\' && qt.ClassfyCd != \'GD\'\"><!--\r\n                          <p ng-repeat=\"it in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\" style=\"padding-top:10px;\">\r\n                            <label ng-class=\"wjmSurvey.getItemSelClass(vc.svyResps[qt.qtId][0], it.itId)\">\r\n                              <input type=\"radio\" ng-model=\"vc.svyResps[qt.qtId][0]\" ng-value=\"it.itId\" ng-checked=\"vc.setBeginQtId(qt, it)\" class=\"rdosvy\" style=\"margin-top:-3px;\">&nbsp;&nbsp;{{it.QstItemContents}}\r\n                            </label>\r\n                          </p>\r\n                          --><p style=padding-top:10px><select class=\"form-control svy-qstitem\" ng-model=vc.svyResps[qt.qtId][0] ng-change=vc.setBeginQtId(qt) ng-options=\"li.itId as li.QstItemContents for li in vc.svyQstItems | filter : {qtId: qt.qtId, stat: \'!D\'} : true\"><option value=\"\">--{{wjmSurvey.getLangData(\"L00028\", vc.svyInfo.SvyLang)}}--</option></select></p></div></div><!-- 설명글 --><div style=\"padding:10px 0 50px 0\" ng-if=\"qt.QstType == \'R\'\"><pre class=\"txt-pre svy-qstitem\" style={{wjmSurvey.getQstPreStyle(qt.QstFontSize)}}>{{qt.QstSubject}}</pre></div></div></div></div><div class=row ng-if=\"vc.svyPagesType == \'3\'\"><div class=col-lg-12 ng-show=\"vc.svyInfo.BtmType == \'100\'\"><span ng-bind-html=vc.svyInfo.BtmCont|htmlString></span></div><div class=col-lg-12 ng-show=\"vc.svyInfo.BtmType == \'200\'\">- 미니결과 예시 -<br>이 내용은 기본으로 세팅되는 값입니다.<br><br>귀하의 점수는 000입니다.<br><br>상담신청 추후 링크 연결하기<br>상담전화걸기<br></div><div class=col-lg-12 ng-show=\"vc.svyInfo.ContactTxtYN == \'Y\'\" style=padding-top:10px><span ng-bind-html=vc.svyInfo.ContactTxt|htmlString></span></div></div></div></div><div class=row style=padding-top:10px><div class=\"col-lg-12 text-center\"><!--<div class=\"col-lg-12 btn-bottom text-center\">--> <button class=\"btn btn-default btn-svy\" ng-click=\"vc.setSvyPagesType(\'PREV\')\" ng-if=\"vc.showSvyBtn(\'PREV\')\"><i class=\"fa fa-arrow-left\"></i> {{wjmSurvey.getLangData(\"L00003\", vc.svyInfo.SvyLang)}}</button> <button class=\"btn btn-default btn-svy\" ng-click=\"vc.setSvyPagesType(\'NEXT\')\" ng-if=\"vc.showSvyBtn(\'NEXT\')\"><i class=\"fa fa-arrow-right\"></i> {{wjmSurvey.getLangData(\"L00004\", vc.svyInfo.SvyLang)}}</button> <button class=\"btn btn-default btn-svy\" ng-click=\"vc.setSvyPagesType(\'END\')\" ng-if=\"vc.showSvyBtn(\'END\')\"><i class=\"fa fa-save\"></i> {{wjmSurvey.getLangData(\"L00005\", vc.svyInfo.SvyLang)}}</button></div></div></div></div></div></div></div><div class=row><div class=col-lg-12><div class=btm-svy>Copyrightⓒ2020 WINNERSJM Co., Ltd. All rights reserved.</div></div></div><div class=\"modal-footer ng-scope\"><!--\r\n    <button class=\"btn btn-primary mb-10\" ng-click=\"vc.apply()\">\r\n      <i class=\"fa fa-save\"></i> 적용\r\n    </button>\r\n    --> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-qst-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>문항 편집 {{wjmSurvey.getQstTypeNm(vc.qt.QstType)}}</div></div><div class=\"modal-body ng-scope\"><!-- 선택형 --><div ng-if=\"vc.qt.QstType == \'1\'\"><div class=row style=padding-bottom:10px><div class=col-sm-12><div class=\"form-group form-inline\"><label>문항영역</label><select class=form-control ng-model=vc.qt.QstSecId ng-options=\"li.SecId2 as li.SecNm1 for li in vc.qstSecList\" ng-change=vc.chgQstSec() ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=\"\">--선택--</option></select></div></div></div><div class=row style=padding-bottom:10px ng-if=\"vc.pageType == \'FORM\'\"><div class=col-lg-6><div class=\"form-group form-inline\"><label>문항번호</label><input type=text class=form-control ng-model=vc.qt.QstNo readonly></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label uib-tooltip=\"동일한 설문유형 내 공통 문항번호. 통계 및 보고서에서 사용됩니다.\">유형문항번호</label><input type=text class=form-control ng-model=vc.qt.OrgQstNo numbers-only=\"\"></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>질문내용</label><!--<input type=\"text\" class=\"form-control\" ng-model=\"vc.qt.QstSubject\" maxlength=\"50\" ng-click=\"vc.clickQstSubject()\" ng-blur=\"vc.blurQstSubject()\">--><textarea ng-model=vc.qt.QstSubject class=form-control style=height:75px maxlength=500 ng-click=vc.clickQstSubject() ng-blur=vc.blurQstSubject()></textarea></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-4><div class=\"form-group form-inline\"><label>선택종류</label><select class=form-control ng-model=vc.qt.SelType ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=S>단일선택</option><option value=M>다중선택</option></select></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>미응답허용</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.qt.QstPassYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">허용 &nbsp;&nbsp; <input type=radio ng-model=vc.qt.QstPassYN value=N style=\"width:15px !Important; margin:0 !Important\"> 미허용</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>문항폰트크기</label><select class=form-control ng-model=vc.qt.QstFontSize ng-options=\"li.val as li.txt for li in wjmSurvey.qstFontSizeList\"></select></div></div></div><div class=row style=padding-bottom:10px ng-show=\"vc.qt.SelType==\'M\'\"><div class=col-lg-6><div class=\"form-group form-inline\"><label>최소선택수</label><select class=form-control ng-model=vc.qt.SelMin ng-options=\"li.QstItemNo as li.QstItemNo for li in vc.it\" ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"></select></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>최대선택수</label><select class=form-control ng-model=vc.qt.SelMax ng-options=\"li.QstItemNo as li.QstItemNo for li in vc.it\" ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"></select></div></div></div><div style=\"background-color: #f4f4f4; padding:10px\"><div class=row style=padding-bottom:5px><div class=\"col-xs-1 text-center\">번호</div><div class=\"col-xs-6 text-center\">내용</div><div class=\"col-xs-1 text-center\">배점</div><div class=\"col-xs-2 text-center\">영역</div><div class=col-xs-2>기타입력</div></div><div class=row ng-repeat=\"it in vc.it | filter : {stat: \'!D\'} : true\" style=padding-bottom:5px><div class=\"col-xs-1 text-center\">{{it.QstItemNo}}</div><div class=col-xs-6><input type=text class=form-control ng-model=it.QstItemContents maxlength=100 ng-click=vc.clickQstItemContents(it) ng-blur=vc.blurQstItemContents(it)></div><div class=col-xs-1><input type=text class=\"form-control text-right\" ng-model=it.QstItemScore maxlength=5 ng-click=vc.clickQstItemScore(it) ng-blur=vc.blurQstItemScore(it) ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"></div><div class=col-xs-2 ng-if=\"vc.qt.ScoringType != \'P\'\"><select class=form-control ng-model=it.QstSecId ng-options=\"li.SecId2 as li.SecNm2 for li in vc.qstSecList2\" ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=\"\">--선택--</option></select></div><div class=col-xs-2 ng-if=\"vc.qt.ScoringType == \'P\'\"><select class=form-control ng-model=it.QstSecId ng-options=\"li.SecId2 as li.SecNm1 for li in vc.qstSecList\" ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=\"\">--선택--</option></select></div><div class=\"col-xs-1 text-center\"><input type=checkbox style=margin-top:10px ng-checked=\'it.OtherRespYN == \"Y\"\' ng-model=it.OtherRespYN ng-true-value=\'\"Y\"\' ng-false-value=\'\"N\"\' ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"></div><div class=col-xs-1><button class=\"btn btn-default\" ng-click=vc.setSvyQstItemDel(it.itId) ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div class=row style=padding-top:10px><div class=\"col-lg-12 text-right\"><button class=\"btn btn-default\" ng-click=vc.setSvyQstItemAdd() ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><i class=\"fa fa-plus\"></i> 보기추가</button></div></div></div></div><!-- 입력형 --><div ng-if=\"vc.qt.QstType == \'2\'\"><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>질문내용</label><!--<input type=\"text\" class=\"form-control\" ng-model=\"vc.qt.QstSubject\" maxlength=\"50\" ng-click=\"vc.clickQstSubject()\" ng-blur=\"vc.blurQstSubject()\">--><textarea ng-model=vc.qt.QstSubject class=form-control style=height:75px maxlength=500 ng-click=vc.clickQstSubject() ng-blur=vc.blurQstSubject()></textarea></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>힌트내용</label><input type=text class=form-control ng-model=vc.qt.InputHint maxlength=200></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-4><div class=\"form-group form-inline\"><label>입력유형</label><select class=form-control ng-model=vc.qt.InputType ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=I>단답형(InputBox)</option><option value=T>서술형(TextArea)</option></select></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>미응답허용</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.qt.QstPassYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">허용 &nbsp;&nbsp; <input type=radio ng-model=vc.qt.QstPassYN value=N style=\"width:15px !Important; margin:0 !Important\"> 미허용</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>문항폰트크기</label><select class=form-control ng-model=vc.qt.QstFontSize ng-options=\"li.val as li.txt for li in wjmSurvey.qstFontSizeList\"></select></div></div></div><!--\r\n      <div style=\"background-color: #f4f4f4; padding:10px;\">\r\n        <div class=\"row\" style=\"padding-bottom:5px;\">\r\n          <div class=\"col-lg-12\">\r\n            <textarea class=\"form-control\" style=\"height:100px;\" maxlength=\"1000\" disabled></textarea>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      --></div><!-- 우선순위형 --><div ng-if=\"vc.qt.QstType == \'3\'\"><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>질문내용</label><!--<input type=\"text\" class=\"form-control\" ng-model=\"vc.qt.QstSubject\" maxlength=\"50\" ng-click=\"vc.clickQstSubject()\" ng-blur=\"vc.blurQstSubject()\">--><textarea ng-model=vc.qt.QstSubject class=form-control style=height:75px maxlength=500 ng-click=vc.clickQstSubject() ng-blur=vc.blurQstSubject()></textarea></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-4><div class=\"form-group form-inline\"><label>선택개수</label><select class=form-control ng-model=vc.qt.QstTopCnt ng-options=\"li.QstItemNo as li.QstItemNo for li in vc.it\" ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=\"\">--선택--</option></select></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>미응답허용</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.qt.QstPassYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">허용 &nbsp;&nbsp; <input type=radio ng-model=vc.qt.QstPassYN value=N style=\"width:15px !Important; margin:0 !Important\"> 미허용</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>문항폰트크기</label><select class=form-control ng-model=vc.qt.QstFontSize ng-options=\"li.val as li.txt for li in wjmSurvey.qstFontSizeList\"></select></div></div></div><div style=\"background-color: #f4f4f4; padding:10px\"><div class=row style=padding-bottom:5px><div class=\"col-xs-1 text-center\">번호</div><div class=\"col-xs-9 text-center\">내용</div><!--\r\n          <div class=\"col-xs-2 text-center\">배점</div>\r\n          --><div class=\"col-xs-2 text-center\"></div></div><div class=row ng-repeat=\"it in vc.it | filter : {stat: \'!D\'} : true\" style=padding-bottom:5px><div class=\"col-xs-1 text-center\">{{it.QstItemNo}}</div><div class=col-xs-9><input type=text class=form-control ng-model=it.QstItemContents maxlength=50 ng-click=vc.clickQstItemContents(it) ng-blur=vc.blurQstItemContents(it)></div><!--\r\n          <div class=\"col-xs-2\"><input type=\"text\" class=\"form-control text-right\" ng-model=\"it.QstItemScore\" numbers-only=\"\" maxlength=\"5\" ng-click=\"vc.clickQstItemScore(it)\" ng-blur=\"vc.blurQstItemScore(it)\"></div>\r\n          --><div class=col-xs-2><button class=\"btn btn-default\" ng-click=vc.setSvyQstItemDel(it.itId) ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div class=row style=padding-top:10px><div class=\"col-lg-12 text-right\"><button class=\"btn btn-default\" ng-click=vc.setSvyQstItemAdd() ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><i class=\"fa fa-plus\"></i> 보기추가</button></div></div></div></div><!-- 이미지형 --><div ng-if=\"vc.qt.QstType == \'4\'\"><div class=row style=padding-bottom:10px><div class=col-sm-12><div class=\"form-group form-inline\"><label>문항영역</label><select class=form-control ng-model=vc.qt.QstSecId ng-options=\"li.QstSecId as li.QstSecNm for li in vc.qstSecList\" ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=\"\">--선택--</option></select></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>질문내용</label><!--<input type=\"text\" class=\"form-control\" ng-model=\"vc.qt.QstSubject\" maxlength=\"50\" ng-click=\"vc.clickQstSubject()\" ng-blur=\"vc.blurQstSubject()\">--><textarea ng-model=vc.qt.QstSubject class=form-control style=height:75px maxlength=500 ng-click=vc.clickQstSubject() ng-blur=vc.blurQstSubject()></textarea><p style=padding-top:5px><select class=form-control ng-model=vc.qt.QstImgId ng-options=\"li.AttachmentId as li.ImgNm for li in vc.imageList\" ng-change=vc.chgQstImgId(vc.qt) ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=\"\">--질문 이미지선택--</option></select></p></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-4 style=padding-left:85px><img ng-src={{vc.qt.qtImgSrc}} style=\"width:80px; height:80px\"></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>미응답허용</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.qt.QstPassYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">허용 &nbsp;&nbsp; <input type=radio ng-model=vc.qt.QstPassYN value=N style=\"width:15px !Important; margin:0 !Important\"> 미허용</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>문항폰트크기</label><select class=form-control ng-model=vc.qt.QstFontSize ng-options=\"li.val as li.txt for li in wjmSurvey.qstFontSizeList\"></select></div></div></div><div style=\"background-color: #f4f4f4; padding:10px\"><div class=row style=padding-bottom:5px><div class=\"col-xs-1 text-center\">번호</div><div class=\"col-xs-2 text-center\">이미지</div><div class=\"col-xs-5 text-center\">내용</div><div class=\"col-xs-2 text-center\">배점</div><div class=\"col-xs-2 text-center\"></div></div><div class=row ng-repeat=\"it in vc.it | filter : {stat: \'!D\'} : true\" style=padding-bottom:5px><div class=\"col-xs-1 text-center\">{{it.QstItemNo}}</div><div class=\"col-xs-2 text-center\"><img ng-src={{it.itImgSrc}} style=\"width:40px; height:40px\"></div><div class=col-xs-5><input type=text class=form-control ng-model=it.QstItemContents maxlength=100 ng-click=vc.clickQstItemContents(it) ng-blur=vc.blurQstItemContents(it)><p style=padding-top:5px><select class=form-control ng-model=it.QstItemImgId ng-options=\"li.AttachmentId as li.ImgNm for li in vc.imageList\" ng-change=vc.chgQstItemImgId(it) ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=\"\">--보기 이미지선택--</option></select></p></div><div class=col-xs-2><input type=text class=\"form-control text-right\" ng-model=it.QstItemScore maxlength=5 ng-click=vc.clickQstItemScore(it) ng-blur=vc.blurQstItemScore(it) ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"></div><div class=col-xs-2><button class=\"btn btn-default\" ng-click=vc.setSvyQstItemDel(it.itId) ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div class=row style=padding-top:10px><div class=\"col-lg-12 text-right\"><button class=\"btn btn-default\" ng-click=vc.setSvyQstItemAdd() ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><i class=\"fa fa-plus\"></i> 보기추가</button></div></div></div></div><!-- 척도형 --><div ng-if=\"vc.qt.QstType == \'5\'\"><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>질문내용</label><textarea ng-model=vc.qt.QstSubject class=form-control style=height:75px maxlength=500 ng-click=vc.clickQstSubject() ng-blur=vc.blurQstSubject()></textarea></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-4><div class=\"form-group form-inline\"><label>척도수</label><select class=form-control ng-model=vc.qt.ScaleMax ng-options=\"li.val as li.txt for li in wjmSurvey.qstScaleMaxList\" ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"></select></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>척도순서</label><select class=form-control ng-model=vc.qt.ScaleOrder ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=A>정순</option><option value=D>역순</option></select></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-4><div class=\"form-group form-inline\"><label>미응답허용</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.qt.QstPassYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">허용 &nbsp;&nbsp; <input type=radio ng-model=vc.qt.QstPassYN value=N style=\"width:15px !Important; margin:0 !Important\"> 미허용</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>문항폰트크기</label><select class=form-control ng-model=vc.qt.QstFontSize ng-options=\"li.val as li.txt for li in wjmSurvey.qstFontSizeList\"></select></div></div></div><div style=\"background-color: #f4f4f4; padding:10px\"><div class=row style=padding-bottom:5px><div class=\"col-xs-5 text-center\">내용1</div><div class=\"col-xs-5 text-center\">내용2</div><div class=\"col-xs-2 text-center\"></div></div><div class=row ng-repeat=\"it in vc.it | filter : {stat: \'!D\'} : true\" style=padding-bottom:5px><div class=col-xs-5><input type=text class=form-control ng-model=it.QstItemContents maxlength=50 ng-click=vc.clickQstItemContents(it) ng-blur=vc.blurQstItemContents(it)></div><div class=col-xs-5><!--<input type=\"text\" class=\"form-control\" ng-model=\"it.QstItemContents2\" maxlength=\"50\" ng-click=\"vc.clickQstItemContents2(it)\" ng-blur=\"vc.blurQstItemContents2(it)\">            --> <input type=text class=form-control ng-model=it.QstItemContents2 maxlength=50></div><div class=col-xs-2><button class=\"btn btn-default\" ng-click=vc.setSvyQstItemDel(it.itId) ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><i class=\"fa fa-remove\"></i> 삭제</button></div></div><div class=row style=padding-top:10px><div class=\"col-lg-12 text-right\"><button class=\"btn btn-default\" ng-click=vc.setSvyQstItemAdd() ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><i class=\"fa fa-plus\"></i> 보기추가</button></div></div></div></div><!-- 분류형 --><div ng-if=\"vc.qt.QstType == \'C\'\"><div class=row style=padding-bottom:10px><div class=col-sm-12><div class=\"form-group form-inline\"><label>분류유형</label><select class=form-control ng-model=vc.qt.ClassfyCd ng-options=\"li.ClassfyId as li.ClassfyNm for li in vc.classfyListLev1\"><option value=\"\">--선택--</option></select></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>질문내용</label><!--<input type=\"text\" class=\"form-control\" ng-model=\"vc.qt.QstSubject\" maxlength=\"50\" ng-click=\"vc.clickQstSubject()\" ng-blur=\"vc.blurQstSubject()\">--><textarea ng-model=vc.qt.QstSubject class=form-control style=height:75px maxlength=500 ng-click=vc.clickQstSubject() ng-blur=vc.blurQstSubject()></textarea></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-4><div class=\"form-group form-inline\"><label>미응답허용</label><div style=\"margin-left:70px; line-height: 25px !Important\"><input type=radio ng-model=vc.qt.QstPassYN value=Y ng-checked=true style=\"width:25px !Important; margin:0 !Important\">허용 &nbsp;&nbsp; <input type=radio ng-model=vc.qt.QstPassYN value=N style=\"width:15px !Important; margin:0 !Important\"> 미허용</div></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>문항폰트크기</label><select class=form-control ng-model=vc.qt.QstFontSize ng-options=\"li.val as li.txt for li in wjmSurvey.qstFontSizeList\"></select></div></div></div><div style=\"background-color: #f4f4f4; padding:10px\"><div class=row style=\"width:100%; padding-bottom:5px; margin:0px auto\"><div class=col-lg-12 style=padding-bottom:5px>- 아래와 같은 모습으로 보여집니다. <span ng-show=\"vc.pageType == \'FORM\'\"><br>- 업체의 분류를 사용하는 경우에는 분류유형을 선택하지 않고 등록 후 설문작성시 선택해주세요.</span></div><div class=col-lg-12 ng-if=\"vc.qt.ClassfyCd == \'NM\'\"><div class=\"form-group form-inline\"><input type=text class=form-control maxlength=30 style=\"margin-left:0 !Important; max-width:158px !Important\"></div></div><div class=col-lg-12 ng-if=\"vc.qt.ClassfyCd == \'MB\'\"><!--\r\n            <div class=\"form-inline\">\r\n              <div class=\"form-group\">\r\n                <select class=\"form-control\" style=\"margin-left:0 !Important; width:100% !Important;\">\r\n                  <option value=\"010\">010</option>\r\n                  <option value=\"011\">011</option>\r\n                </select>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <input type=\"text\" class=\"form-control\" maxlength=\"4\" number-only=\"\" style=\"margin-left:0 !Important; width:100% !Important;\">\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <input type=\"text\" class=\"form-control\" maxlength=\"4\" number-only=\"\" style=\"margin-left:0 !Important; width:100% !Important;\">\r\n              </div>\r\n            </div>\r\n            --><div class=\"form-group form-inline\"><input type=text class=form-control maxlength=13 style=\"margin-left:0 !Important; max-width:158px !Important\"></div></div><div class=col-lg-12 ng-if=\"vc.qt.ClassfyCd == \'EM\'\"><div class=form-inline><div class=form-group><input type=text class=form-control maxlength=30 style=\"margin-left:0 !Important; width:100% !Important\"></div><div class=form-group>@</div><div class=form-group><input type=text ng-model=vc.qstEmailDomain class=form-control maxlength=30 style=\"margin-left:0 !Important; width:100% !Important\" ng-disabled=\"vc.qstEmailDomainList != null && vc.qstEmailDomainList != \'\'\"></div><div class=form-group><select class=form-control ng-model=vc.qstEmailDomainList style=\"margin-left:0 !Important; width:100% !Important\" ng-options=\"li.val as li.txt for li in vc.clientEmailList\" ng-change=vc.chgQstEmailDomain()><option value=\"\">직접입력</option></select></div></div><!--\r\n            <div class=\"form-group form-inline\">\r\n              <input type=\"text\" class=\"form-control\" maxlength=\"60\" style=\"margin-left:0 !Important; max-width:258px !Important;\">\r\n            </div>\r\n            --></div><div class=col-lg-12 ng-if=\"vc.qt.ClassfyCd == \'GD\'\"><div style=padding-top:10px><p><input type=radio name=rdoGD style=margin-top:-3px disabled><!--{{it.QstItemNo}}. --> 남</p><p><input type=radio name=rdoGD style=margin-top:-3px disabled><!--{{it.QstItemNo}}. --> 여</p></div></div><div class=col-lg-12 ng-if=\"vc.qt.ClassfyCd != \'NM\' && vc.qt.ClassfyCd != \'MB\' && vc.qt.ClassfyCd != \'EM\' && vc.qt.ClassfyCd != \'GD\' && vc.qt.ClassfyCd != \'\'\"><div style=padding-top:10px><!--p ng-repeat=\"it in vc.classfyListLev2 | filter : {ClassfyCd: vc.qt.ClassfyCd, stat: \'!D\'} : true\">\r\n                <input type=\"radio\" name=\"rdo{{it.ClassfyId}}\" style=\"margin-top:-3px;\" disabled> {{it.ClassfyNm}}\r\n              </p--><select class=form-control ng-model=vc.foo ng-options=\"li.ClassfyId as li.ClassfyNm for li in vc.classfyListLev2 | filter : {ClassfyCd: vc.qt.ClassfyCd, stat: \'!D\'} : true\" style=\"margin-left:0 !Important; max-width:158px !Important\"><option value=\"\">--선택--</option></select></div></div></div></div></div><!-- 설명글 --><div ng-if=\"vc.qt.QstType == \'R\'\"><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>설명내용</label><textarea ng-model=vc.qt.QstSubject class=form-control style=height:100px maxlength=1000 ng-click=vc.clickQstSubject() ng-blur=vc.blurQstSubject()></textarea></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-6><div class=\"form-group form-inline\"><label>설명폰트크기</label><select class=form-control ng-model=vc.qt.QstFontSize ng-options=\"li.val as li.txt for li in wjmSurvey.qstFontSizeList\"></select></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>종료설정</label><select class=form-control ng-model=vc.qt.QstEndType ng-disabled=\"vc.pageType != \'FORM\' && vc.qt.QstLock == \'Y\'\"><option value=\"\">-선택-</option><!--<option value=\"S\">정상종료(결과있음)</option>--><option value=F>실패종료(결과없음)</option></select></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.apply()><i class=\"fa fa-save\"></i> 적용</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-qstgoto-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>분기 설정 {{wjmSurvey.getQstTypeNm(vc.qt.QstType)}}</div></div><div class=\"modal-body ng-scope\"><!-- 선택형, 우선순위형, 분류정보 --><div><div class=row style=padding-bottom:10px><div class=col-xs-8><span class=form-control readonly>{{vc.qt.QstNo}}. {{vc.qt.QstSubject}}</span></div><div class=col-xs-4><select class=form-control ng-model=vc.qt.GoToQstId ng-options=\"li.qtId as li.gotoTxt for li in vc.gotoList\" ng-change=vc.chgQstGotoList()><option value=\"\">--문항분기 선택--</option></select></div></div><div style=\"background-color: #f4f4f4; padding:10px\" ng-if=\"vc.qt.QstType == \'1\' || vc.qt.QstType == \'3\' || vc.qt.QstType == \'4\' || vc.qt.QstType == \'C\'\"><div class=row ng-repeat=\"it in vc.it\" style=padding-bottom:5px><div class=col-xs-8><span class=form-control readonly>{{it.QstItemNo}}. {{it.QstItemContents}}</span></div><div class=col-xs-4><select class=form-control ng-model=it.GoToQstId ng-options=\"li.qtId as li.gotoTxt for li in vc.gotoList\" ng-change=vc.chgQstItemGotoList($index)><option value=\"\">--{{it.QstItemNo}}. 보기분기 선택--</option></select></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.apply()><i class=\"fa fa-save\"></i> 적용</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-qstmove-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>이동 설정</div></div><div class=\"modal-body ng-scope\"><div><div class=row style=padding-bottom:10px><div class=col-lg-12><span class=form-control readonly>{{vc.qt.QstNo}}. {{vc.qt.QstSubject}}</span></div></div><div class=row style=padding-bottom:10px><div class=col-lg-8><select class=form-control ng-model=vc.data.moveQtId ng-options=\"li.qtId as li.moveTxt for li in vc.moveList\" ng-change=vc.chgQstMoveList()><option value=\"\">--이동기준 문항 선택--</option></select></div><div class=col-lg-4><div style=\"line-height: 25px !Important\"><input type=radio ng-model=vc.data.moveOrder value=BEFORE ng-checked=true style=\"width:25px !Important; margin:0 !Important\">이전 &nbsp;&nbsp; <input type=radio ng-model=vc.data.moveOrder value=AFTER style=\"width:15px !Important; margin:0 !Important\"> 이후</div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.apply()><i class=\"fa fa-save\"></i> 적용</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-report-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>보고서 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getList()\'}\"><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9\"><div class=\"form-group form-inline\"><label>보고서명</label><input type=text class=form-control ng-model=modalCtrl.RptNm placeholder=\"{{modalCtrl.columnMap[\'RpteNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>보고서명</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.List\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.RptNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-scorelv-lvcont-modal.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>미니결과 등록/수정</h3></div><form id=form1 name=form1><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-lg-12 text-warning mb-10\">치환문구 : {TgtNm} 응답자명 // {TotScore} 총점 // {TotLv} 진단결과 // {SecScore1~5} 영역점수 // {SecLv1~5} 영역결과 // {CounselLink} 상담링크</div></div><div class=row><div class=col-lg-12><textarea id=strHtml rows=10 style=\"width:100%; height:300px; display: \'none\'\" ng-model=vc.data.LvCont></textarea></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div><script type=text/javascript>var oEditors = [];\r\n  var sLang = \"ko_KR\";\r\n    nhn.husky.EZCreator.createInIFrame({\r\n      oAppRef : oEditors,\r\n      elPlaceHolder : \"strHtml\",\r\n      sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n      htParams : {\r\n        bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n        bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n        bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n        fOnBeforeUnload : function() {\r\n        },\r\n        I18N_LOCALE : sLang\r\n      },\r\n      fOnAppLoad : function() {\r\n      },\r\n      fCreator : \"createSEditor2\"\r\n    });</script>");
$templateCache.put("components/modal/survey/wjm-scorelv-sec-modal.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>기준점 관리</h3></div><form id=form1 name=form1><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9\"><div class=\"form-group form-inline\"><label>설문유형</label><input type=text class=\"form-control form-right\" ng-model=vc.srch.SvyTypeNm readonly></div></div></div><div class=row ng-if=\"vc.srch.isTot == \'N\'\"><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3\"><div class=\"form-group form-inline\"><label>문항영역</label><select class=form-control ng-model=vc.srch.QstSecId ng-change=vc.getList() ng-options=\"sec.QstSecId as sec.QstSecNm for sec in vc.qstSecList\"><option value=\"\">---- 전체 ----</option></select></div></div></div><div class=row><div class=col-md-12><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><div class=pull-right style=\"height: 100%\"><div class=form-group><button type=button class=\"btn btn-default\" ng-click=vc.addNew()><i class=\"fa fa-table\"></i> 추가</button> <button type=button class=\"btn btn-default\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></div></div></div><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><colgroup ng-if=\"vc.srch.isTot == \'N\'\"><col><col style=\"width: 5%\"><col style=\"width: 10%\"><col style=\"width: 15%\"><col style=\"width: 8%\"><col style=\"width: 10%\"><col style=\"width: 7%\"><col style=\"width: 7%\"><col style=\"width: 5%\"></colgroup><colgroup ng-if=\"vc.srch.isTot == \'Y\'\"><col style=\"width: 5%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 5%\"><col style=\"width: 15%\"></colgroup><thead><tr><th class=text-center ng-if=\"vc.srch.isTot == \'N\'\">영역</th><th class=text-center>번호</th><th class=text-center>구분1</th><th class=text-center>구분2</th><th class=text-center>성별</th><th class=text-center>최저점</th><th class=text-center>최고점</th><th class=text-center>삭제</th><th class=text-center ng-if=\"vc.srch.isTot == \'Y\'\">끝맺음말</th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" my-directive><!-- Result Items --><td ng-if=\"vc.srch.isTot == \'N\'\"><select class=form-control ng-model=li.QstSecId ng-options=\"sec.QstSecId as sec.QstSecNm for sec in vc.qstSecList\" required><option value=\"\">---- 선택 ----</option></select></td><td><input type=text class=form-control ng-model=li.LvNum maxlength=2 required></td><td><select class=form-control ng-model=li.LvCd ng-options=\"cd.Code as cd.CodeValue for cd in vc.scoreLvList\" required><option value=\"\">---- 선택 ----</option></select></td><td><input type=text class=form-control ng-model=li.LvTxt maxlength=45 required></td><td><select class=form-control ng-model=li.Gender ng-options=\"cd.Code as cd.CodeValue for cd in vc.genderList\"><option value=\"\">---- 선택 ----</option></select></td><td><input type=text class=form-control ng-model=li.MinScore maxlength=4 required></td><td><input type=text class=form-control ng-model=li.MaxScore maxlength=4 required></td><td class=text-center><input type=checkbox ng-model=li.DelYN ng-change=vc.checkChanged(li) ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center style=width:15% ng-if=\"vc.srch.isTot == \'Y\'\"><button type=button class=\"btn btn-success btn-min\" ng-if=\"li.isNew != \'Y\'\" ng-click=vc.goEditLvCont(li.KeyId)><i class=\"fa fa-edit\"></i>> 미니결과</button></td></tr></table></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.saveList()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div>");
$templateCache.put("components/modal/survey/wjm-scorelv-tot-modal.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>기준총점 관리</h3></div><form id=form1 name=form1><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9\"><div class=\"form-group form-inline\"><label>설문유형</label><input type=text class=\"form-control form-right\" ng-model=vc.srch.SvyTypeNm readonly></div></div></div><div class=row><div class=col-md-12><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><div class=pull-right style=\"height: 100%\"><div class=form-group><button type=button class=\"btn btn-default\" ng-click=vc.addNew()><i class=\"fa fa-table\"></i> 추가</button> <button type=button class=\"btn btn-default\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></div></div></div><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-if=\"vc.secLen >= 1\" class=text-center><select class=form-control ng-model=vc.secHeader[0] ng-options=\"sec.QstSecId as sec.QstSecNm for sec in vc.qstSecList\" disabled></select></th><th ng-if=\"vc.secLen >= 2\" class=text-center><select class=form-control ng-model=vc.secHeader[1] ng-options=\"sec.QstSecId as sec.QstSecNm for sec in vc.qstSecList\" disabled></select></th><th ng-if=\"vc.secLen >= 3\" class=text-center><select class=form-control ng-model=vc.secHeader[2] ng-options=\"sec.QstSecId as sec.QstSecNm for sec in vc.qstSecList\" disabled></select></th><th ng-if=\"vc.secLen >= 4\" class=text-center><select class=form-control ng-model=vc.secHeader[3] ng-options=\"sec.QstSecId as sec.QstSecNm for sec in vc.qstSecList\" disabled></select></th><th ng-if=\"vc.secLen == 5\" class=text-center><select class=form-control ng-model=vc.secHeader[4] ng-options=\"sec.QstSecId as sec.QstSecNm for sec in vc.qstSecList\" disabled></select></th><th class=text-center>구분1</th><th class=text-center>구분2</th><th class=text-center>삭제</th><th class=text-center>끝맺음말</th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" my-directive><!-- Result Items --><td ng-if=\"vc.secLen >= 1\"><select class=form-control ng-model=li.LvCd01 ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.lvList[0]\"><option value=\"\">---- 선택 ----</option></select></td><td ng-if=\"vc.secLen >= 2\"><select class=form-control ng-model=li.LvCd02 ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.lvList[1]\"><option value=\"\">---- 선택 ----</option></select></td><td ng-if=\"vc.secLen >= 3\"><select class=form-control ng-model=li.LvCd03 ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.lvList[2]\"><option value=\"\">---- 선택 ----</option></select></td><td ng-if=\"vc.secLen >= 4\"><select class=form-control ng-model=li.LvCd04 ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.lvList[3]\"><option value=\"\">---- 선택 ----</option></select></td><td ng-if=\"vc.secLen == 5\"><select class=form-control ng-model=li.LvCd05 ng-options=\"lv.LvCd as lv.LvTxt for lv in vc.lvList[4]\"><option value=\"\">---- 선택 ----</option></select></td><td><select class=form-control ng-model=li.LvCd ng-options=\"cd.Code as cd.CodeValue for cd in vc.scoreLvList\"><option value=\"\">---- 선택 ----</option></select></td><td><input type=text class=form-control ng-model=li.LvTxt maxlength=45></td><td class=text-center><input type=checkbox ng-model=li.DelYN ng-change=vc.checkChanged(li) ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center style=width:15%><button type=button class=\"btn btn-success btn-min\" ng-if=\"li.isNew != \'Y\'\" ng-click=vc.goEditLvCont(li.KeyId)><i class=\"fa fa-edit\"></i>> 미니결과</button></td></tr></table></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.saveList()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div>");
$templateCache.put("components/modal/survey/wjm-send-totresult-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>전체 발송 이력 조회</div></div><div class=\"modal-body ng-scope\"><div><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>제목</label><div class=\"form-control txt_view\" ng-bind=vc.tit></div></div></div></div><div class=row style=padding-bottom:10px><div class=col-lg-12><div class=\"form-group form-inline\"><label>내용</label><div ng-bind-html=vc.cont></div></div></div></div></div></div><div class=\"modal-footer ng-scope\"><!--\r\n    <button class=\"btn btn-primary mb-10\" ng-click=\"vc.apply()\">\r\n      <i class=\"fa fa-save\"></i> 적용\r\n    </button>\r\n    --> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-survey-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>설문 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getList()\'}\"><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9\"><div class=\"form-group form-inline\"><label>설문제목</label><input type=text class=form-control ng-model=modalCtrl.SvyNm placeholder=\"{{modalCtrl.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>설문제목</th><th data-toggle=true class=text-center>설문시작일</th><th data-toggle=true class=text-center>설문종료일</th><th data-toggle=true class=text-center>상태</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.SvyList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.SvyNm></span></td><td class=text-center><span ng-bind=\"li.SvyBeginDate | utcToLocal:\'yyyy-MM-dd\'\"></span></td><td class=text-center><span ng-bind=\"li.SvyEndDate | utcToLocal:\'yyyy-MM-dd\'\"></span></td><td class=text-center><span ng-bind=li.SvyStatus></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-survey-multisel-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>설문 다중 선택</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getList()\'}\"><div class=row><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>설문제목</label><input type=text class=form-control ng-model=modalCtrl.SvyNm placeholder=\"{{modalCtrl.columnMap[\'SvyNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>서식</label><div class=\"input-group custom-search-form\"><input class=form-control ng-model=modalCtrl.FormNm placeholder=\"\" readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=modalCtrl.srchFormModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=modalCtrl.eraseForm() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input ng-change=chkHeadChg() ng-model=modalCtrl.chkHead type=checkbox></th><th data-toggle=true class=text-center>설문제목</th><th data-toggle=true class=text-center>설문시작일</th><th data-toggle=true class=text-center>설문종료일</th><th data-toggle=true class=text-center>상태</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.lists\" style=\"cursor: pointer\"><td class=text-center style=vertical-align:middle><input ng-change=chkRowChg() ng-model=li.chkRow type=checkbox></td><td class=text-center ng-click=chkRowChg(li);><span ng-bind=li.SvyNm></span></td><td class=text-center><span ng-bind=\"li.SvyBeginDate | utcToLocal:\'yyyy-MM-dd\'\"></span></td><td class=text-center><span ng-bind=\"li.SvyEndDate | utcToLocal:\'yyyy-MM-dd\'\"></span></td><td class=text-center><span ng-bind=li.SvyStatus></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/survey/wjm-target-edit-modal.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>대상자 추가/수정</h3></div><form id=form1 name=form1><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>설문제목</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNm readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>설문번호</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SvyNum readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>이름</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Name maxlength=100></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>휴대폰</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Mobile ng-change=\"vc.getIsDup(\'M\')\" maxlength=255></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9\"><div class=\"form-group form-inline\"><label>이메일</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Email ng-change=\"vc.getIsDup(\'E\')\" maxlength=255></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div>");
$templateCache.put("components/modal/survey/wjm-target-scorelv-modal.html","<div class=\"modal-content wd80p\" modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>영역별 점수</h3></div><form id=form1 name=form1><div class=\"modal-body ng-scope\"><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center>문항영역명</th><th class=text-center>점수</th><th class=text-center>진단결과</th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" my-directive><!-- Result Items --><td>{{li.QstSecNm}}</td><td>{{li.Score}}</td><td>{{li.Lv}}</td></tr></table></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div>");
$templateCache.put("components/modal/survey/wjm-urlpost-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>URL 게시</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-md-10><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>설문URL</label><textarea ng-model=vc.data.SvyUrl class=form-control style=height:50px></textarea></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>설문URL링크</label><textarea ng-model=vc.data.SvyUrlLink class=form-control style=height:50px></textarea></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>설문URL<br>소스코드삽입</label><textarea ng-model=vc.data.SvyUrlCode class=form-control style=height:50px></textarea></div></div></div></div><div class=col-md-2><qrcode data={{vc.data.SvyUrl}} size=100></qrcode></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.close()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/tenant/tenant-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>관리샵 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>Shop명</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>법인대표자</label><input type=text class=form-control ng-model=vc.srch.Ceo placeholder=법인대표자></div></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2\" style=\"text-align: right\"><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th></th><th>Shop명</th><th>지역구분</th><th>법인대표자</th><th>전화번호</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><i class=\"fa fa-check-square-o\" ng-show=\"li.TenantId == vc.selectedTenantId\" style=color:red></td><td><span ng-bind=li.TenantNm></span></td><td><span ng-bind=li.Addr1></span></td><td><span ng-bind=li.Ceo></span></td><td><span ng-bind=li.TelNo></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/tenant/tenant2-modal-view.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>{{ \'Menu.MEMBERCOMPANY\' | translate }}{{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-7><div class=\"form-group form-inline\"><label>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=col-lg-5><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</th><th>{{ \'Menu.PERSONINCHARGE\' | translate }}</th><th>{{ \'Menu.TEL\' | translate }}</th><th>{{ \'Menu.EMAIL\' | translate }}</th><th>{{ \'Menu.COMPANYSTATUS\' | translate }}</th><th>{{ \'Menu.JOINDATE\' | translate }}</th><th>{{ \'Menu.WITHDRAWALDATE\' | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><span ng-bind=li.TenantNm></span></td><td><span ng-bind=li.Contact></span></td><td><span ng-bind=li.TelNo></span></td><td><span ng-bind=li.Email></span></td><td><span ng-bind=li.TenantStatus></span></td><td><span ng-bind=li.JoinDate></span></td><td><span ng-bind=li.ExitDate></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/users/user-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>{{ \'Menu.USER\' | translate }} {{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getUserList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.LoginId placeholder=\"{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=\"{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'WorkStyle\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'WorkStyle\'].CodeList\" code-model=modalCtrl.WorkStyle></common-code-custom></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center ng-if=!modalCtrl.MobileYn>{{modalCtrl.columnMap[\'EntryDt\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center ng-if=!modalCtrl.MobileYn>{{modalCtrl.columnMap[\'WorkStyle\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'WorkStatus\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center ng-if=!modalCtrl.MobileYn>{{modalCtrl.columnMap[\'UserGrade\'].ColumnLogicalNm | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.LoginId></span></td><td class=text-center><span ng-bind=li.UserNm></span></td><td class=text-center><span ng-bind=li.Mobile></span></td><td class=text-center ng-if=!modalCtrl.MobileYn><span ng-bind=\"li.EntryDt | date:\'yyyy-MM-dd\':\'UTC\'\"></span></td><td class=text-center ng-if=!modalCtrl.MobileYn><span ng-bind=li.WorkStyle></span></td><td class=text-center><span ng-bind=li.WorkStatus></span></td><td class=text-center ng-if=!modalCtrl.MobileYn><span ng-bind=li.UserGrade></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/users/wjm-counselor-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>상담사 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getUserList()\'}\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>상담사명</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=\"{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>상담사명</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.UserNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/users/wjm-user-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><h3 class=page-header>업체 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getUserList()\'}\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>업체명</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=\"{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>업체명</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.UserNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=app/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/userRole/userrole-modal.html","<div class=modal-content modal-drag><div class=\"modal-header ng-scope\"><div class=page-header>{{\'Menu.ROLE\' | translate}} {{\'Menu.SEARCH\' | translate}}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=vc.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in vc.searchFieldTypeList\" ng-init=vc.selSearchType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=vc.searchValue placeholder=검색어></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.viewSizePerPage ng-change=vc.changeViewSize() ng-options=\"c for c in vc.viewSizePerPageList\" class=input-sm></select></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><md-contact-chips ng-model=vc.UserRoles md-contacts=vc.querySearch($query) md-contact-name=RoleNm md-contact-image=image md-contact-email=email md-require-match=true md-highlight-flags=i filter-selected=vc.filterSelected md-on-remove=vc.onRemoveChip($item) placeholder=역할></md-contact-chips><md-list class=fixedRows><md-subheader class=md-no-sticky>**추가할 역할을 선택하세요**</md-subheader><md-list-item class=contact-item ng-repeat=\"(index, role) in vc.data.list\" ng-if=!vc.IsRole(role) ng-click=vc.addRole(role.RoleId)><div class=\"md-list-item-text compact\" draggable=true>{{role.RoleNm}}</div></md-list-item></md-list></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/ui-component/timeline/timeline.html","<div class=panel-body><ul class=timeline><li><div class=timeline-badge><i class=\"fa fa-check\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4><p><small class=text-muted><i class=\"fa fa-clock-o\"></i> 11 hours ago via Twitter</small></p></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis.</p></div></div></li><li class=timeline-inverted><div class=\"timeline-badge warning\"><i class=\"fa fa-credit-card\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem dolorem quibusdam, tenetur commodi provident cumque magni voluptatem libero, quis rerum. Fugiat esse debitis optio, tempore. Animi officiis alias, officia repellendus.</p><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium maiores odit qui est tempora eos, nostrum provident explicabo dignissimos debitis vel! Adipisci eius voluptates, ad aut recusandae minus eaque facere.</p></div></div></li><li><div class=\"timeline-badge danger\"><i class=\"fa fa-bomb\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellendus numquam facilis enim eaque, tenetur nam id qui vel velit similique nihil iure molestias aliquam, voluptatem totam quaerat, magni commodi quisquam.</p></div></div></li><li class=timeline-inverted><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates est quaerat asperiores sapiente, eligendi, nihil. Itaque quos, alias sapiente rerum quas odit! Aperiam officiis quidem delectus libero, omnis ut debitis!</p></div></div></li><li><div class=\"timeline-badge info\"><i class=\"fa fa-save\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nobis minus modi quam ipsum alias at est molestiae excepturi delectus nesciunt, quibusdam debitis amet, beatae consequuntur impedit nulla qui! Laborum, atque.</p><hr><div class=btn-group><button type=button class=\"btn btn-primary btn-sm dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-gear\"></i> <span class=caret></span></button><ul class=dropdown-menu role=menu><li><a href=#>Action</a></li><li><a href=#>Another action</a></li><li><a href=#>Something else here</a></li><li class=divider></li><li><a href=#>Separated link</a></li></ul></div></div></div></li><li><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi fuga odio quibusdam. Iure expedita, incidunt unde quis nam! Quod, quisquam. Officia quam qui adipisci quas consequuntur nostrum sequi. Consequuntur, commodi.</p></div></div></li><li class=timeline-inverted><div class=\"timeline-badge success\"><i class=\"fa fa-graduation-cap\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt obcaecati, quaerat tempore officia voluptas debitis consectetur culpa amet, accusamus dolorum fugiat, animi dicta aperiam, enim incidunt quisquam maxime neque eaque.</p></div></div></li></ul></div>");
$templateCache.put("components/ui-component/factory/galert-factory.html","<md-dialog md-theme=default ng-class=dialog.css class=\"md-default-theme md-transition-in\" role=alertdialog tabindex=-1 aria-describedby=dialogContent_8 style=\"min-width: 100%\"><md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_8 style=text-align:center><img ng-src=assets/images/{{alertIco}}.png><div class=\"md-dialog-content-body ng-scope mt-10\" style=\"text-align: center\"><p class=ng-binding ng-bind-html=alertMessage></p></div></md-dialog-content><md-dialog-actions style=\"text-align: center; border-top:solid 1px #DDD\"><button class=\"md-primary md-button md-default-theme md-ink-ripple md-autofocus\" type=button ng-click=onClose() md-autofocus=true aria-label=\"Got it!\" style=\"margin: 0 auto; width:100%\"><span ng-bind=closeBtn style=\"color:#{{alertColor}}; font-size:15px; font-weight:800\"></span></button></md-dialog-actions></md-dialog>");
$templateCache.put("components/ui-component/factory/gconfirm-factory.html","<md-dialog class=\"md-default-theme md-transition-in\" role=dialog tabindex=-1 aria-describedby=dialogContent_9 style=\"min-width: 100%\"><md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_9 style=text-align:center><img ng-src=assets/images/{{alertIco}}.png><div class=\"md-dialog-content-body ng-scope mt-10\" style=\"text-align: center\"><p class=ng-binding ng-bind-html=alertMessage></p></div></md-dialog-content><md-dialog-actions style=\"text-align: center; border-top:solid 1px #DDD\"><button class=\"md-primary md-button ng-scope md-default-theme md-ink-ripple\" type=button ng-click=onClose() style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=closeBtn style=\"color:#333; font-size:15px; font-weight:800\"></span></button> <button class=\"md-primary md-button md-default-theme md-ink-ripple\" type=button ng-click=onOk() md-autofocus=true style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=okBtn style=\"color:#{{alertColor}}; font-size:15px; font-weight:800\"></span></button></md-dialog-actions></md-dialog>");
$templateCache.put("app/dashboard/stats/stats.html","<div class=\"col-lg-3 col-md-6\"><div class=\"panel panel-{{ states.colour }}\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-{{ states.type }} fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ states.number }}</div><div>{{ states.comments }}</div></div></div></div><a ui-sref=dashboard.home><div class=panel-footer><span class=pull-left>View Details</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div>");
$templateCache.put("scripts/directives/common-code/common-code.html","<select class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler() name=selectCombo ng-model=ccCtrl.data ng-options=\"opt.CodeValue for opt in ccCtrl.list track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=min-width:100px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select>");
$templateCache.put("scripts/directives/common-code-tree/common-code-tree.html","<div class=\"form-group form-inner-label\"><span style=float:left ng-repeat=\"li in ccCtrl.CodeLevel\"><select ng-disabled=\"ccCtrl.list[$index].length == 0\" class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler($index) name=selectCombo ng-model=ccCtrl.CommonCode[$index] ng-options=\"opt.CodeValue for opt in ccCtrl.list[$index] track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></span></div>");
$templateCache.put("scripts/directives/common-code-custom/common-code-custom.html","<select class=form-control name=selectCombo ng-change=ccCtrl.onChangeHandler() ng-model=ccCtrl.codeModel ng-options=\"opt.Code as opt.CodeValue for opt in ccCtrl.list\" style=min-width:100px ng-disabled=ccCtrl.isDisabled><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select>");
$templateCache.put("scripts/directives/select-data-group/select-data-group.html","<span class=data-group-str ng-click=ccCtrl.changeDatagroup()><b>:::: 데이터그룹 <font color=red>{{ccCtrl.DatagroupNm}}</font> &gt; 작업명 <font color=red>{{ccCtrl.ActionNm}}</font> <i class=\"fa fa-search\"></i></b></span>");
$templateCache.put("scripts/directives/search-condition/search-condition.html","<span class=search-condition-str><b>검색결과 <font color=red>{{ccCtrl.countStr}}</font>건</b> {{ccCtrl.searchConditionStr}}</span>");
$templateCache.put("scripts/directives/udc/udc-detail.html","<div ng-repeat=\"li in vc.metaList\" class={{li.EditColumnWidth}} ng-if=\"li.CustomColumnYN == \'Y\'\"><div class=\"form-group form-inline\"><label title=\"{{ li.ColumnLogicalNm }}\">{{ li.ColumnLogicalNm }}</label><div ng-if=\"li.ColumnLogicalDataType != \'40\'\" class=\"form-control txt_view\" ng-bind=vc.metaModel[li.ColumnPhysicalNm]></div><div class=\"form-control txt_view\" ng-bind=\"vc.metaModel[li.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\'\" ng-if=\"li.ColumnLogicalDataType == \'40\'\"></div></div></div>");
$templateCache.put("scripts/directives/udc/udc-edit.html","<div ng-repeat=\"li in vc.metaList\" class={{li.EditColumnWidth}} ng-if=\"li.CustomColumnYN == \'Y\'\"><div class=\"form-group form-inline\"><label title=\"{{ li.ColumnLogicalNm }}\">{{ li.ColumnLogicalNm }}</label><input ng-if=\"li.ColumnLogicalDataType == \'10\'\" type=text class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]> <input ng-if=\"li.ColumnLogicalDataType == \'20\'\" type=number class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]><div ng-if=\"li.ColumnLogicalDataType == \'40\'\" class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-init=\"vc.RegDate[$index] = $root.getDate(vc.metaModel[li.ColumnPhysicalNm])\" ng-model=vc.RegDate[$index] ng-change=\"vc.onDateChanged(li.ColumnPhysicalNm, $index);\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><common-code-custom ng-if=\"li.ColumnLogicalDataType == \'50\'\" code-list=li.CodeList code-model=vc.metaModel[li.ColumnPhysicalNm] callback=vc.onModelChanged></common-code-custom></div></div>");
$templateCache.put("scripts/directives/udc/udc-search.html","<div ng-repeat=\"li in vc.metaList\" class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"li.CustomColumnYN == \'Y\'\"><div class=\"form-group form-inner-label\"><input ng-if=\"li.ColumnLogicalDataType == \'10\'\" type=text class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]> <input ng-if=\"li.ColumnLogicalDataType == \'20\'\" type=number class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]><div ng-if=\"li.ColumnLogicalDataType == \'40\'\" class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-init=\"vc.RegDate[$index] = $root.getDate(vc.metaModel[li.ColumnPhysicalNm])\" ng-model=vc.RegDate[$index] ng-change=\"vc.onDateChanged(li.ColumnPhysicalNm, $index);\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div><common-code-custom ng-if=\"li.ColumnLogicalDataType == \'50\'\" code-list=li.CodeList code-model=vc.metaModel[li.ColumnPhysicalNm] callback=vc.onModelChanged></common-code-custom><label title=\"{{ li.ColumnLogicalNm }}\">{{ li.ColumnLogicalNm }}</label></div></div>");
$templateCache.put("scripts/file-attach/directive/file-attach.html","<div class=form-right><table class=\"table b-a b-solid bg-white\"><thead><tr><th width=50%>Name</th><th>Size</th><th>Progress</th><th>Status</th><th>Actions</th></tr></thead><tbody><tr id=filectl_{{obj.id}} ng-repeat=\"obj in faCtrl.fileData\" ng-if=!obj.delStatus><td><span ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></span> <a href={{obj.link}} target=attach ng-show=obj.isLoaded><span class=file_list ng-bind=obj.fileName></span></a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a href=\"\" ng-click=faCtrl.onDelete(obj)><span ng-show=\"obj.delState == \'\'\"><i class=icon-trash></i> {{ \'Menu.DELETE\' | translate }}</span><span ng-show=\"obj.delState == \'delete\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></td></tr></tbody></table><div tabindex=500 class=\"btn btn-info btn-file pull-right\" ng-click=faCtrl.openDilalog()><i class=icon-file-plus></i>{{ \'Menu.ATTACHMENT\' | translate }}</div><input id=file-5 style=\"display: none\" class=file type=file multiple data-preview-file-type=any data-upload-url=# placeholder=\"\"></div>");
$templateCache.put("components/ui-component/layout/header/header.html","<nav class=\"navbar navbar-default navbar-static-top\" role=navigation style=\"margin-bottom: 0\"><div class=navbar-header><!-- <button type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\".navbar-collapse\"> --><div class=\"navbar-toggle sz-custom-navbar-toggle\"><a href=\"\"><i class=\"fa fa-outdent\"></i></a></div><div class=sz-custom-select-tenant><section class=tile fullscreen=isFullscreen06><div class=form-group ng-if=header.checkUse><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control ng-model=header.TENANTNAME ng-click=header.srchTenantModal();> <input type=hidden ng-model=header.TENANTID> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=header.srchTenantModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=header.eraseTenant();><i class=\"fa fa-eraser\"></i></button></span></div></div></section></div><a class=navbar-brand href=/ target=_parent><img src=/assets/images/login/crm-top-logo.png alt=\"\" style=\"width:auto; height:25px\"></a><!-- <a class=\"navbar-brand\" href=\"/#/app/cafe24dashboard\">{{\'PRODUCT.COMPANY\'|translate}}</a> --><div style=clear:both></div><header-notification></header-notification></div><!-- /.navbar-header --></nav>");
$templateCache.put("components/ui-component/layout/sidebar/sidebar.html","<div class=\"navbar-default sidebar side_wrapper\" role=navigation id=navigationListWrap data-mcs-theme=light-thick><div class=\"sidebar-nav navbar-collapse\"><ul class=\"nav in\" id=side-menu><li ng-repeat=\"item in sidebar.menuList\" ng-class=\"{active: sidebar.collapseVar==item.idx}\"><a ui-sref={{item.pageUrl}}{{item.pageUrlParam}} ui-sref-opts=\"{reload:\'{{item.pageUrl}}\'}\" ng-if=\"item.child.length == 0\" ng-click=sidebar.check(item.idx)><i class=\"fa {{item.icon}} fa-fw\"></i> <span class=menuTx>{{item.name}}</span> </a><a ng-if=\"item.child.length > 0\" ng-click=sidebar.check(item.idx)><i class=\"fa {{item.icon}} fa-fw\"></i> <span class=menuTx>{{item.name}}</span> <span class=\"fa arrow\"></span></a><ul ng-if=\"item.child.length > 0\" class=\"nav nav-second-level\" uib-collapse=\"sidebar.collapseVar!={{item.idx}}\"><li ng-repeat=\"item2 in item.child\" ng-class=\"{active: sidebar.secondCollapseVar==item2.idx}\"><a ui-sref=\"{{item2.pageUrl}}{{ item2.pageUrlParam }}\" ui-sref-opts=\"{reload:\'{{item2.pageUrl}}\'}\" ng-if=\"item2.child.length == 0\" ng-click=sidebar.secondCheck(item2.idx)><i class=\"fa {{item2.icon}}\"></i> <span class=menuTx></span>{{item2.name}} </a><a ng-if=\"item2.child.length > 0\" ng-click=sidebar.secondCheck(item2.idx)><i class=\"fa {{item2.icon}}\"></i> <span class=menuTx>{{item2.name}}</span> <span class=\"fa arrow\"></span></a><ul ng-if=\"item2.child.length > 0\" class=\"nav nav-third-level\" uib-collapse=\"sidebar.secondCollapseVar!={{item2.idx}}\"><li ng-repeat=\"item3 in item2.child\" ng-class=\"{active: sidebar.threeCollapseVar==item3.idx}\"><a ui-sref={{item3.pageUrl}}{{item3.pageUrlParam}} ui-sref-opts=\"{reload:\'{{item3.pageUrl}}\'}\" ng-click=sidebar.threeCheck(item3.idx)><i class=\"fa {{item3.icon}}\"></i> <span class=menuTx>{{item3.name}}</span></a></li></ul></li></ul></li><!-- <sidebar-search></sidebar-search> --><!--\r\n          <li ng-class=\"{active: sidebar.collapseVar==2}\">\r\n            <a href=\"\" ng-click=\"sidebar.check(2)\">\r\n                <i class=\"fa fa-sitemap fa-fw\"></i> <span class=\"menuTx\">Multi-Level Dropdown</span>\r\n                <span class=\"fa arrow\"></span>\r\n            </a>\r\n            <ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.collapseVar!=2\">\r\n                <li>\r\n                    <a href=\"\"><span class=\"menuTx\">Second Level Item</span></a>\r\n                </li>\r\n                <li>\r\n                    <a href=\"\"><span class=\"menuTx\">Second Level Item</span></a>\r\n                </li>\r\n                <li ng-init=\"third=!third\" ng-class=\"{active: sidebar.multiCollapseVar==3}\">\r\n                    <a href=\"\" ng-click=\"sidebar.multiCheck(3)\"><span class=\"menuTx\">Third Level</span>\r\n                        <span class=\"fa arrow\"></span>\r\n                    </a>\r\n                    <ul class=\"nav nav-third-level\" uib-collapse=\"sidebar.multiCollapseVar!=3\">\r\n                        <li>\r\n                            <a href=\"\"><span class=\"menuTx\">Third Level Item</span></a>\r\n                        </li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n          </li>\r\n\r\n            <li ui-sref-active=\"active\">\r\n                <a ui-sref=\"app.dashboard\">\r\n                  <i class=\"fa fa-dashboard fa-fw\"></i> <span class=\"menuTx\">Dashboard</span>\r\n                </a>\r\n            </li>\r\n\r\n            <li ui-sref-active=\"active\">\r\n              <a ui-sref=\"app.system.menumanage-list\">\r\n                <i class=\"fa fa-dashboard fa-fw\"></i> <span class=\"menuTx\">메뉴관리</span>\r\n              </a>\r\n          </li>\r\n            <li ui-sref-active=\"active\">\r\n                <a ui-sref=\"app.chart\">\r\n                  <i class=\"fa fa-bar-chart-o fa-fw\"></i> <span class=\"menuTx\">Charts</span>\r\n                </a>\r\n            </li>\r\n            <li ng-class=\"{active: sidebar.collapseVar==1}\">\r\n              <a href=\"\" ng-click=\"sidebar.check(1)\">\r\n                  <i class=\"fa fa-table fa-fw\"></i> <span class=\"menuTx\">Tables</span>\r\n                    <span class=\"fa arrow\"></span>\r\n              </a>\r\n              <ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.collapseVar!=1\">\r\n                  <li ui-sref-active=\"active\">\r\n                      <a ui-sref=\"app.bbspost.h0102-list({BbsMasterId:\'1\',srch:\'\'})\" >{{\'Menu.h0102\' | translate }}</a>\r\n                  </li>\r\n                  <li ui-sref-active=\"active\">\r\n                      <a ui-sref=\"app.panelsWells\"><span class=\"menuTx\">Panels and Wells</span></a>\r\n                  </li>\r\n                  <li ui-sref-active=\"active\">\r\n                      <a ui-sref=\"app.buttons\"><span class=\"menuTx\">Buttons</span></a>\r\n                  </li>\r\n                  <li ui-sref-active=\"active\">\r\n                      <a ui-sref=\"dashboard.notifications\"><span class=\"menuTx\">Notifications</span></a>\r\n                  </li>\r\n                  <li ui-sref-active=\"active\">\r\n                      <a ui-sref=\"dashboard.typography\"><span class=\"menuTx\">Typography</span></a>\r\n                  </li>\r\n                  <li ui-sref-active=\"active\">\r\n                      <a ui-sref=\"dashboard.icons\"><span class=\"menuTx\">Icons</span></a>\r\n                  </li>\r\n                  <li ui-sref-active=\"active\">\r\n                      <a ui-sref=\"dashboard.grid\"><span class=\"menuTx\">Grid</span></a>\r\n                  </li>\r\n              </ul>\r\n            </li>\r\n            <li ui-sref-active=\"active\">\r\n                <a ui-sref=\"dashboard.form\">\r\n                    <i class=\"fa fa-edit fa-fw\"></i><span class=\"menuTx\">Forms</span></a>\r\n            </li>\r\n            <li ng-class=\"{active: sidebar.collapseVar==1}\">\r\n                <a href=\"\" ng-click=\"sidebar.check(1)\">\r\n                    <i class=\"fa fa-wrench fa-fw\"></i><span class=\"menuTx\">UI Elements</span>\r\n                    <span class=\"fa arrow\"></span>\r\n                </a>\r\n                <ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.collapseVar!=1\">\r\n                    <li ui-sref-active=\"active\">\r\n                        <a ui-sref=\"app.panelsWells\"><span class=\"menuTx\">Panels and Wells</span></a>\r\n                    </li>\r\n                    <li ui-sref-active=\"active\">\r\n                        <a ui-sref=\"app.buttons\"><span class=\"menuTx\">Buttons</span></a>\r\n                    </li>\r\n                    <li ui-sref-active=\"active\">\r\n                        <a ui-sref=\"dashboard.notifications\"><span class=\"menuTx\">Notifications</span></a>\r\n                    </li>\r\n                    <li ui-sref-active=\"active\">\r\n                        <a ui-sref=\"dashboard.typography\"><span class=\"menuTx\">Typography</span></a>\r\n                    </li>\r\n                    <li ui-sref-active=\"active\">\r\n                        <a ui-sref=\"dashboard.icons\"> <span class=\"menuTx\">Icons</span></a>\r\n                    </li>\r\n                    <li ui-sref-active=\"active\">\r\n                        <a ui-sref=\"dashboard.grid\"><span class=\"menuTx\">Grid</span></a>\r\n                    </li>\r\n                </ul>\r\n\r\n            </li>\r\n\r\n            <li ng-class=\"{active:sidebar.collapseVar==4}\">\r\n                <a href=\"\" ng-click=\"sidebar.check(4)\">\r\n                    <i class=\"fa fa-files-o fa-fw\"></i> <span class=\"menuTx\">Sample Pages</span>\r\n                    <span class=\"fa arrow\"></span>\r\n                </a>\r\n                <ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.collapseVar!=4\">\r\n                    <li ng-class=\"{active: sidebar.selectedMenu==\'blank\'}\">\r\n                        <a ui-sref=\"dashboard.blank\" ng-click=\"sidebar.selectedMenu=\'blank\'\"><span class=\"menuTx\">Blank Page</span></a>\r\n                    </li>\r\n                    <li>\r\n                        <a ui-sref=\"login\"><span class=\"menuTx\">Login Page</span></a>\r\n                    </li>\r\n                </ul>\r\n\r\n            </li>\r\n            <li ng-class=\"{active:sidebar.collapseVar==5}\">\r\n              <a href=\"\" ng-click=\"sidebar.check(5)\">\r\n                  <i class=\"fa fa-files-o fa-fw\"></i> <span class=\"menuTx\">시스템 관리</span>\r\n                  <span class=\"fa arrow\"></span>\r\n              </a>\r\n              <ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.collapseVar!=5\">\r\n                <li ui-sref-active=\"active\">\r\n                  <a ui-sref=\"app.system.user-list({srch:\'\'})\"><span class=\"menuTx\">사용자 관리</span></a>\r\n                </li>\r\n                <li ui-sref-active=\"active\">\r\n                  <a ui-sref=\"app.system.department-list\"><span class=\"menuTx\">부서 관리</span></a>\r\n                </li>\r\n                <li ui-sref-active=\"active\">\r\n                  <a ui-sref=\"app.system.company-list\"><span class=\"menuTx\">역활 관리</span></a>\r\n                </li>\r\n                <li ui-sref-active=\"active\">\r\n                  <a ui-sref=\"app.system.screen-list\"><span class=\"menuTx\">메뉴 관리</span></a>\r\n                </li>\r\n                <li ui-sref-active=\"active\">\r\n                  <a ui-sref=\"app.system.role-list\"><span class=\"menuTx\">메뉴 권한 관리</span></a>\r\n                </li>\r\n                <li ui-sref-active=\"active\">\r\n                  <a ui-sref=\"app.system.commoncode-list\"><span class=\"menuTx\">공통코드 관리</span></a>\r\n                </li>\r\n                <li ui-sref-active=\"active\">\r\n                  <a ui-sref=\"app.system.rolescreen-list\"><span class=\"menuTx\">회사 관리</span></a>\r\n                </li>\r\n              </ul>\r\n\r\n          </li>\r\n          <li ng-class=\"{active:sidebar.collapseVar==6}\">\r\n            <a href=\"\" ng-click=\"sidebar.check(6)\">\r\n                <i class=\"fa fa-files-o fa-fw\"></i> <span class=\"menuTx\">{{\'Menu.EM700\' | translate }}</span>\r\n                <span class=\"fa arrow\"></span>\r\n            </a>\r\n            <ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.collapseVar!=6\">\r\n              <li ui-sref-active=\"active\">\r\n                <a ui-sref=\"app.boardmng.list\" ui-sref-opts=\"{reload:\'app.boardmng.list\'}\">\r\n                  <span class=\"menuTx\">{{\'Menu.EM710\' | translate }}</span></a>\r\n              </li>\r\n            </ul>\r\n\r\n          </li>\r\n          <li ng-class=\"{active: sidebar.collapseVar==2}\">\r\n              <a href=\"\" ng-click=\"sidebar.check(2)\">\r\n                  <i class=\"fa fa-sitemap fa-fw\"></i> <span class=\"menuTx\">Multi-Level Dropdown</span>\r\n                  <span class=\"fa arrow\"></span>\r\n              </a>\r\n              <ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.collapseVar!=2\">\r\n                  <li>\r\n                      <a href=\"\"><span class=\"menuTx\">Second Level Item</span></a>\r\n                  </li>\r\n                  <li>\r\n                      <a href=\"\"><span class=\"menuTx\">Second Level Item</span></a>\r\n                  </li>\r\n                  <li ng-init=\"third=!third\" ng-class=\"{active: sidebar.multiCollapseVar==3}\">\r\n                      <a href=\"\" ng-click=\"sidebar.multiCheck(3)\"><span class=\"menuTx\">Third Level</span>\r\n                          <span class=\"fa arrow\"></span>\r\n                      </a>\r\n                      <ul class=\"nav nav-third-level\" uib-collapse=\"sidebar.multiCollapseVar!=3\">\r\n                          <li>\r\n                              <a href=\"\"><span class=\"menuTx\">Third Level Item</span></a>\r\n                          </li>\r\n                          <li>\r\n                              <a href=\"\"><span class=\"menuTx\">Third Level Item</span></a>\r\n                          </li>\r\n                          <li>\r\n                              <a href=\"\"><span class=\"menuTx\">Third Level Item</span></a>\r\n                          </li>\r\n                          <li>\r\n                              <a href=\"\"><span class=\"menuTx\">Third Level Item</span></a>\r\n                          </li>\r\n\r\n                      </ul>\r\n\r\n                  </li>\r\n              </ul>\r\n\r\n          </li>\r\n          <li>\r\n                <a href=\"http://www.strapui.com/\">\r\n                  <span class=\"menuTx\">Premium Angular Themes</span></a>\r\n            </li>\r\n          --></ul></div><!-- /.sidebar-collapse --></div>");
$templateCache.put("components/ui-component/layout/header/header-notification/header-notification.html","<ul class=\"nav navbar-top-links navbar-right\"><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown><i class=\"fa fa-user fa-fw\"></i> {{vc.user.UserName}} <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-user\"><li><a href=\"\" ng-click=vc.myPage()><i class=\"fa fa-user fa-fw\"></i> 내 정보</a></li><li class=divider></li><li><a href=\"\" ng-click=vc.doLogout()><i class=\"fa fa-sign-out fa-fw\"></i> Logout</a></li></ul><!-- /.dropdown-user --></li><!-- /.dropdown --></ul>");
$templateCache.put("components/ui-component/layout/sidebar/sidebar-search/sidebar-search.html","<li class=sidebar-search><div class=\"input-group custom-search-form\"><input type=text class=form-control placeholder=Search...> <span class=input-group-btn><button class=\"btn btn-default\" type=button><i class=\"fa fa-search\"></i></button></span></div></li>");
$templateCache.put("i.html","<!doctype html><html ng-app=salevis4-web><head><title ng-bind=$root.title>더휴먼데이터센터</title><meta charset=utf-8><meta name=description content=\"\"><meta name=viewport content=\"width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no\"><meta http-equiv=Expires content=-1><meta http-equiv=Pragma content=no-cache><meta http-equiv=Cache-Control content=No-Cache><link rel=stylesheet href=assets/css/app.css><!-- Place favicon.ico and apple-touch-icon.png in the root directory --><!-- build:css({.tmp/serve,src}) styles/vendor.css --><!-- bower:css --><link rel=stylesheet href=../bower_components/angular-bootstrap-colorpicker/css/colorpicker.css><link rel=stylesheet href=../bower_components/bootstrap/dist/css/bootstrap.css><link rel=stylesheet href=../bower_components/angular-bootstrap-nav-tree/dist/abn_tree.css><link rel=stylesheet href=../bower_components/chosen/chosen.min.css><link rel=stylesheet href=../bower_components/font-awesome/css/font-awesome.css><link rel=stylesheet href=../bower_components/intro.js/introjs.css><link rel=stylesheet href=../bower_components/leaflet/dist/leaflet.css><link rel=stylesheet href=../bower_components/angular-loading-bar/build/loading-bar.css><link rel=stylesheet href=../bower_components/angular-material/angular-material.css><link rel=stylesheet href=../bower_components/rickshaw/rickshaw.min.css><link rel=stylesheet href=../bower_components/angular-toastr/dist/angular-toastr.css><link rel=stylesheet href=../bower_components/fullcalendar/fullcalendar.css><link rel=stylesheet href=../bower_components/angular-ui-grid/ui-grid.css><link rel=stylesheet href=../bower_components/angular-ui-select/dist/select.css><link rel=stylesheet href=../bower_components/angular-ui-tree/dist/angular-ui-tree.min.css><link rel=stylesheet href=../bower_components/animate.css/animate.css><link rel=stylesheet href=../bower_components/bootstrap-daterangepicker/daterangepicker.css><link rel=stylesheet href=../bower_components/leaflet-draw/dist/leaflet.draw.css><link rel=stylesheet href=../bower_components/material-design-iconic-font/dist/css/material-design-iconic-font.css><link rel=stylesheet href=../bower_components/morrisjs/morris.css><link rel=stylesheet href=../bower_components/ng-table/dist/ng-table.min.css><link rel=stylesheet href=../bower_components/ng-tags-input/ng-tags-input.min.css><link rel=stylesheet href=../bower_components/ngImgCrop/compile/minified/ng-img-crop.css><link rel=stylesheet href=../bower_components/simple-line-icons/css/simple-line-icons.css><link rel=stylesheet href=../bower_components/weather-icons/css/weather-icons.css><link rel=stylesheet href=../bower_components/weather-icons/css/weather-icons.min.css><link rel=stylesheet href=../bower_components/weather-icons/css/weather-icons-wind.css><link rel=stylesheet href=../bower_components/weather-icons/css/weather-icons-wind.min.css><link rel=stylesheet href=../bower_components/dragular/dist/dragular.min.css><link rel=stylesheet href=../bower_components/magnific-popup/dist/magnific-popup.css><link rel=stylesheet href=../bower_components/owl.carousel/dist/assets/owl.carousel.css><link rel=stylesheet href=../bower_components/owl.carousel/dist/assets/owl.theme.default.css><link rel=stylesheet href=../bower_components/angular-bootstrap-grid-tree/src/treeGrid.css><!-- endbower --><!-- endbuild --><!-- build:css({.tmp/serve,src}) styles/app.css --><!-- inject:css --><link rel=stylesheet href=index.css><link rel=stylesheet href=sb-admin-2.css><link rel=stylesheet href=timeline.css><link rel=stylesheet href=styles/loading.css><link rel=stylesheet href=styles/main.css><link rel=stylesheet href=styles/pagination.css><link rel=stylesheet href=styles/slick-theme.css><link rel=stylesheet href=styles/slick.css><link rel=stylesheet href=styles/sz-common.css><link rel=stylesheet href=styles/sz-reserve.css><link rel=stylesheet href=styles/vault.css><link rel=stylesheet href=components/login/login.css><link rel=stylesheet href=styles/module/borderLayout.css><link rel=stylesheet href=scripts/scrollStyle/jquery.mCustomScrollbar.css><!-- endinject --><!-- endbuild --></head><body><!--[if lt IE 10]>\r\n    <p class=\"browsehappy\">최신 웹 브라우저로 업그레이드 하시기 바랍니다. (권장: Internet Explorer 11 이상, Google Chrome 76 이상). <a\r\n      href=\"http://browsehappy.com/\">최신 웹 브라우저 다운로드</a></p>\r\n    <![endif]--><div ui-view><div class=loading-container><div class=loading></div><div id=loading-text>loading...</div></div></div><!-- build:js(src) scripts/vendor.js --><!-- bower:js --><script src=../bower_components/jquery/jquery.js></script><script src=../bower_components/angular/angular.js></script><script src=../bower_components/angular-animate/angular-animate.js></script><script src=../bower_components/angular-aria/angular-aria.js></script><script src=../bower_components/angular-bootstrap/ui-bootstrap-tpls.js></script><script src=../bower_components/angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module.js></script><script src=../bower_components/bootstrap/dist/js/bootstrap.js></script><script src=../bower_components/angular-bootstrap-nav-tree/dist/abn_tree_directive.js></script><script src=../bower_components/chosen/chosen.jquery.js></script><script src=../bower_components/angular-chosen-localytics/chosen.js></script><script src=../bower_components/angular-cookies/angular-cookies.js></script><script src=../bower_components/datatables.net/js/jquery.dataTables.js></script><script src=../bower_components/angular-datatables/dist/angular-datatables.js></script><script src=../bower_components/angular-datatables/dist/plugins/bootstrap/angular-datatables.bootstrap.js></script><script src=../bower_components/angular-datatables/dist/plugins/colreorder/angular-datatables.colreorder.js></script><script src=../bower_components/angular-datatables/dist/plugins/columnfilter/angular-datatables.columnfilter.js></script><script src=../bower_components/angular-datatables/dist/plugins/colvis/angular-datatables.colvis.js></script><script src=../bower_components/angular-datatables/dist/plugins/fixedcolumns/angular-datatables.fixedcolumns.js></script><script src=../bower_components/angular-datatables/dist/plugins/fixedheader/angular-datatables.fixedheader.js></script><script src=../bower_components/angular-datatables/dist/plugins/scroller/angular-datatables.scroller.js></script><script src=../bower_components/angular-datatables/dist/plugins/tabletools/angular-datatables.tabletools.js></script><script src=../bower_components/d3/d3.js></script><script src=../bower_components/angular-file-upload/dist/angular-file-upload.min.js></script><script src=../bower_components/angular-flot/angular-flot.js></script><script src=../bower_components/angular-fontawesome/dist/angular-fontawesome.js></script><script src=../bower_components/angular-fullscreen/src/angular-fullscreen.js></script><script src=../bower_components/angular-simple-logger/dist/angular-simple-logger.js></script><script src=../bower_components/lodash/lodash.js></script><script src=../bower_components/angular-google-maps/dist/angular-google-maps.js></script><script src=../bower_components/angular-i18n/angular-locale_ko-kr.js></script><script src=../bower_components/intro.js/intro.js></script><script src=../bower_components/angular-intro.js/src/angular-intro.js></script><script src=../bower_components/angular-ipsum/dist/ipsum.min.js></script><script src=../bower_components/leaflet/dist/leaflet-src.js></script><script src=../bower_components/angular-leaflet-directive/dist/angular-leaflet-directive.js></script><script src=../bower_components/angular-loading-bar/build/loading-bar.js></script><script src=../bower_components/masonry/dist/masonry.pkgd.js></script><script src=../bower_components/ev-emitter/ev-emitter.js></script><script src=../bower_components/imagesloaded/imagesloaded.js></script><script src=../bower_components/jquery-bridget/jquery-bridget.js></script><script src=../bower_components/angular-masonry/angular-masonry.js></script><script src=../bower_components/angular-messages/angular-messages.js></script><script src=../bower_components/angular-material/angular-material.js></script><script src=../bower_components/moment/moment.js></script><script src=../bower_components/angular-momentjs/angular-momentjs.js></script><script src=../bower_components/qrcode-generator/js/qrcode.js></script><script src=../bower_components/qrcode-generator/js/qrcode_UTF8.js></script><script src=../bower_components/angular-qrcode/angular-qrcode.js></script><script src=../bower_components/angular-resource/angular-resource.js></script><script src=../bower_components/rickshaw/rickshaw.js></script><script src=../bower_components/angular-rickshaw/rickshaw.js></script><script src=../bower_components/angular-sanitize/angular-sanitize.js></script><script src=../bower_components/angular-smart-table/dist/smart-table.js></script><script src=../bower_components/angular-toastr/dist/angular-toastr.tpls.js></script><script src=../bower_components/angular-touch/angular-touch.js></script><script src=../bower_components/angular-translate/angular-translate.js></script><script src=../bower_components/angular-translate-loader-static-files/angular-translate-loader-static-files.js></script><script src=../bower_components/angular-translate-storage-cookie/angular-translate-storage-cookie.js></script><script src=../bower_components/angular-translate-storage-local/angular-translate-storage-local.js></script><script src=../bower_components/jquery-ui/ui/jquery-ui.js></script><script src=../bower_components/fullcalendar/fullcalendar.js></script><script src=../bower_components/angular-ui-calendar/src/calendar.js></script><script src=../bower_components/angular-ui-grid/ui-grid.js></script><script src=../bower_components/angular-ui-router/release/angular-ui-router.js></script><script src=../bower_components/angular-ui-router/release/stateEvents.js></script><script src=../bower_components/angular-ui-select/dist/select.js></script><script src=../bower_components/angular-ui-tree/dist/angular-ui-tree.js></script><script src=../bower_components/angular-ui-utils/ui-utils.js></script><script src=../bower_components/chart.js/dist/Chart.js></script><script src=../bower_components/angular-chart.js/dist/angular-chart.js></script><script src=../bower_components/chartjs-plugin-annotation/chartjs-plugin-annotation.js></script><script src=../bower_components/bootstrap-daterangepicker/daterangepicker.js></script><script src=../bower_components/es5-shim/es5-shim.js></script><script src=../bower_components/flot/jquery.flot.js></script><script src=../bower_components/flot/jquery.flot.resize.js></script><script src=../bower_components/flot-spline/js/jquery.flot.spline.js></script><script src=../bower_components/flot.tooltip/js/jquery.flot.tooltip.js></script><script src=../bower_components/html.sortable/dist/html.sortable.js></script><script src=../bower_components/jquery.easy-pie-chart/dist/angular.easypiechart.js></script><script src=../bower_components/jquery.inputmask/dist/jquery.inputmask.bundle.js></script><script src=../bower_components/jquery.slimscroll/jquery.slimscroll.js></script><script src=../bower_components/jquery.slimscroll/jquery.slimscroll.min.js></script><script src=../bower_components/jquery.sparkline/index.js></script><script src=../bower_components/json3/lib/json3.js></script><script src=../bower_components/leaflet-draw/dist/leaflet.draw.js></script><script src=../bower_components/leaflet-heat/dist/leaflet-heat.js></script><script src=../bower_components/leaflet-plugins/control/Distance.js></script><script src=../bower_components/leaflet-plugins/control/Layers.Load.js></script><script src=../bower_components/leaflet-plugins/control/Permalink.js></script><script src=../bower_components/leaflet-plugins/control/Permalink.Layer.js></script><script src=../bower_components/leaflet-plugins/control/Permalink.Line.js></script><script src=../bower_components/leaflet-plugins/control/Permalink.Marker.js></script><script src=../bower_components/leaflet-plugins/layer/Icon.Canvas.js></script><script src=../bower_components/leaflet-plugins/layer/Layer.Deferred.js></script><script src=../bower_components/leaflet-plugins/layer/Marker.Rotate.js></script><script src=../bower_components/leaflet-plugins/layer/Marker.Text.js></script><script src=../bower_components/leaflet-plugins/layer/OpenStreetBugs.js></script><script src=../bower_components/leaflet-plugins/layer/vector/GPX.js></script><script src=../bower_components/leaflet-plugins/layer/vector/GPX.Speed.js></script><script src=../bower_components/leaflet-plugins/layer/vector/KML.js></script><script src=../bower_components/leaflet-plugins/layer/vector/OSM.js></script><script src=../bower_components/leaflet-plugins/layer/tile/Bing.js></script><script src=../bower_components/leaflet-plugins/layer/tile/Google.js></script><script src=../bower_components/leaflet-plugins/layer/tile/Yandex.js></script><script src=../bower_components/eve-raphael/eve.js></script><script src=../bower_components/raphael/raphael.js></script><script src=../bower_components/mocha/mocha.js></script><script src=../bower_components/morrisjs/morris.js></script><script src=../bower_components/ng-bs-daterangepicker/src/ng-bs-daterangepicker.js></script><script src=../bower_components/ng-table/dist/ng-table.min.js></script><script src=../bower_components/ng-tags-input/ng-tags-input.min.js></script><script src=../bower_components/ngImgCrop/compile/minified/ng-img-crop.js></script><script src=../bower_components/oclazyload/dist/ocLazyLoad.js></script><script src=../bower_components/textAngular/dist/textAngular-rangy.min.js></script><script src=../bower_components/textAngular/dist/textAngular-sanitize.js></script><script src=../bower_components/textAngular/dist/textAngular.js></script><script src=../bower_components/textAngular/dist/textAngularSetup.js></script><script src=../bower_components/dragular/dist/dragular.min.js></script><script src=../bower_components/magnific-popup/dist/jquery.magnific-popup.js></script><script src=../bower_components/owl.carousel/dist/owl.carousel.js></script><script src=../bower_components/api-check/dist/api-check.min.js></script><script src=../bower_components/angular-formly/dist/formly.min.js></script><script src=../bower_components/angular-formly-templates-bootstrap/dist/angular-formly-templates-bootstrap.min.js></script><script src=../bower_components/angular-bootstrap-grid-tree/src/tree-grid-directive.js></script><script src=../bower_components/printThis/printThis.js></script><script src=../bower_components/threejs/build/three.js></script><script src=../bower_components/waypoints/waypoints.js></script><script src=../bower_components/html2canvas/build/html2canvas.js></script><script src=../bower_components/raven-js/dist/raven.js></script><!-- endbower --><!-- endbuild --><!-- build:js({.tmp/serve,.tmp/partials,src}) scripts/app.js --><!-- inject:js --><script src=scripts/index.module.js></script><script src=scripts/global-fn.js></script><script src=scripts/index.config.js></script><script src=scripts/index.constants.js></script><script src=scripts/index.route.js></script><script src=scripts/index.run.js></script><script src=scripts/slick.min.js></script><script src=scripts/sz-common-fnc.js></script><script src=scripts/vault.js></script><script src=sb-admin-2.js></script><script src=app/app.component.js></script><script src=app/app.route.js></script><script src=home/contacts-ctrl.js></script><script src=home/home.component.js></script><script src=home/home.route.js></script><script src=home/prcenter-ctrl.js></script><script src=home/prcenter-view-ctrl.js></script><script src=reserve/meeting-daily-modal-ctrl.js></script><script src=reserve/meeting-detail-ctrl.js></script><script src=reserve/meeting-detail-modal-ctrl.js></script><script src=reserve/meeting-detail2-ctrl.js></script><script src=reserve/meeting-room-api-srv.js></script><script src=reserve/meeting-room-ctrl.js></script><script src=reserve/meeting-roomimage-modal-ctrl.js></script><script src=reserve/my-reserve-list-ctrl.js></script><script src=reserve/reserve.component.js></script><script src=reserve/reserve.route.js></script><script src=components/modal/modal-api-srv.js></script><script src=components/survey/counsel-agree-ctrl.js></script><script src=components/survey/counsel-api-srv.js></script><script src=components/survey/counsel.component.js></script><script src=components/survey/emaildeny.component.js></script><script src=components/survey/survey-api-srv.js></script><script src=components/survey/survey.component.js></script><script src=components/login/login-api-srv.js></script><script src=components/login/login.component.js></script><script src=components/login/logout.component.js></script><script src=components/login/signup-step-one.component.js></script><script src=components/login/signup-step-two.component.js></script><script src=components/branch-apps/apps.component.js></script><script src=app/application/application.route.js></script><script src=app/application/EAP-business-edit-ctrl.js></script><script src=app/application/EAP-business-list-ctrl.js></script><script src=app/application/EAP-counsel-edit-ctrl.js></script><script src=app/application/EAP-counsel-list-ctrl.js></script><script src=app/application/expert-edit-ctrl.js></script><script src=app/application/expert-list-ctrl.js></script><script src=app/basic/mng-calendar-ctrl.js></script><script src=app/basic/mng-calendar.route.js></script><script src=app/board/bbs-master-detail-ctrl.js></script><script src=app/board/bbs-master-edit-ctrl.js></script><script src=app/board/bbs-master-list-ctrl.js></script><script src=app/board/board.route.js></script><script src=app/board/h0102-api-srv.js></script><script src=app/board/h0102-detail-ctrl.js></script><script src=app/board/h0102-edit-ctrl.js></script><script src=app/board/h0102-list-ctrl.js></script><script src=app/board/h0103-api-srv.js></script><script src=app/board/h0103-detail-ctrl.js></script><script src=app/board/h0103-edit-ctrl.js></script><script src=app/board/h0103-list-ctrl.js></script><script src=app/board/notice-board-ctrl.js></script><script src=app/board/notice-board-detail-ctrl.js></script><script src=app/board/notice-board-edit-ctrl.js></script><script src=app/board/popup-list-ctrl.js></script><script src=app/boardmng/boardmng-api-srv.js></script><script src=app/boardmng/boardmng-detail-ctrl.js></script><script src=app/boardmng/boardmng-edit-ctrl.js></script><script src=app/boardmng/boardmng-list-ctrl.js></script><script src=app/boardmng/boardmng.route.js></script><script src=app/boardmng/column-attr-reorder-ctrl.js></script><script src=app/boardmng/column-attr-setup-ctrl.js></script><script src=app/campaign/campaign.route.js></script><script src=app/campaign/group-list-ctrl.js></script><script src=app/campaign/happycall-edit-ctrl.js></script><script src=app/campaign/monitoring-detail-ctrl.js></script><script src=app/campaign/monitoring-list-ctrl.js></script><script src=app/campaign/single-edit-ctrl.js></script><script src=app/campaign/single-list-ctrl.js></script><script src=app/campaign2/campaign-edit-ctrl.js></script><script src=app/campaign2/campaign-list-ctrl.js></script><script src=app/campaign2/campaign.route.js></script><script src=app/campaign2/campaignimpl-detail-ctrl.js></script><script src=app/campaign2/campaignimpl-list-ctrl.js></script><script src=app/campaign2/form-edit-ctrl.js></script><script src=app/campaign2/form-email-edit-ctrl.js></script><script src=app/campaign2/form-email-list-ctrl.js></script><script src=app/campaign2/form-list-ctrl.js></script><script src=app/campaign2/form-sms-edit-ctrl.js></script><script src=app/campaign2/form-sms-list-ctrl.js></script><script src=app/campaign2/group-list-ctrl.js></script><script src=app/chart/chart-ctrl.js></script><script src=app/cafe24/cafe24.route.js></script><script src=app/cafe24/chart-list-ctrl.js></script><script src=app/cafe24/customer-detail-ctrl.js></script><script src=app/cafe24/customer-list-ctrl.js></script><script src=app/cafe24/log-detail-ctrl.js></script><script src=app/cafe24/log-list-ctrl.js></script><script src=app/cafe24/loginbycafe24-api-srv.js></script><script src=app/cafe24/loginbycafe24.component.js></script><script src=app/cafe24/order-detail-ctrl.js></script><script src=app/cafe24/order-list-ctrl.js></script><script src=app/cafe24/product-detail-ctrl.js></script><script src=app/cafe24/product-list-ctrl.js></script><script src=app/cafe24/subscribe-customer-detail-ctrl.js></script><script src=app/cafe24/subscribe-customer-list-ctrl.js></script><script src=app/cafe24/subscribe-detail-ctrl.js></script><script src=app/cafe24/subscribe-list-ctrl.js></script><script src=app/cafe24/subscribe-prd-detail-ctrl.js></script><script src=app/cafe24/subscribe-prd-list-ctrl.js></script><script src=app/community/community-api-srv.js></script><script src=app/community/community.route.js></script><script src=app/community/news-detail-ctrl.js></script><script src=app/community/news-edit-ctrl.js></script><script src=app/community/news-list-ctrl.js></script><script src=app/community/notice-detail-ctrl.js></script><script src=app/community/notice-edit-ctrl.js></script><script src=app/community/notice-list-ctrl.js></script><script src=app/community/winners-detail-ctrl.js></script><script src=app/community/winners-edit-ctrl.js></script><script src=app/community/winners-list-ctrl.js></script><script src=app/customer/customer-add-batch-ctrl.js></script><script src=app/customer/customer-detail-tab1-ctrl.js></script><script src=app/customer/customer-detail2-ctrl.js></script><script src=app/customer/customer-detail2-tab1-ctrl.js></script><script src=app/customer/customer-detail2-tab2-ctrl.js></script><script src=app/customer/customer-detail2-tab2-modal-ctrl.js></script><script src=app/customer/customer-detail2-tab3-ctrl.js></script><script src=app/customer/customer-detail2-tab4-ctrl.js></script><script src=app/customer/customer-edit-ctrl.js></script><script src=app/customer/customer-edit-tab1-ctrl.js></script><script src=app/customer/customer-edit-tab2-ctrl.js></script><script src=app/customer/customer-edit-tab3-ctrl.js></script><script src=app/customer/customer-edit-tab4-ctrl.js></script><script src=app/customer/customer-edit-tab5-ctrl.js></script><script src=app/customer/customer-edit-tab6-ctrl.js></script><script src=app/customer/customer-list-ctrl.js></script><script src=app/customer/customer.route.js></script><script src=app/dashboard/cafe24dashboard-ctrl.js></script><script src=app/dashboard/dashboard-ctrl.js></script><script src=app/dashboard/dashboard.route.js></script><script src=app/dashboard/survey-dashboard-ctrl.js></script><script src=app/cvssales/cvssales-detail-ctrl.js></script><script src=app/cvssales/cvssales-edit-ctrl.js></script><script src=app/cvssales/cvssales-list-ctrl.js></script><script src=app/cvssales/cvssales.route.js></script><script src=app/cvssales/cvssalesgen-edit-ctrl.js></script><script src=app/cvssales/cvssalesgen-list-ctrl.js></script><script src=app/cvssales/cvssalesorder-list-ctrl.js></script><script src=app/cvssales/cvssalesstock-edit-ctrl.js></script><script src=app/cvssales/cvssalesstock-list-ctrl.js></script><script src=app/cvssales/cvssalestkt-edit-ctrl.js></script><script src=app/cvssales/cvssalestkt-list-ctrl.js></script><script src=app/cvsreserv/cvsreserv-edit-ctrl.js></script><script src=app/cvsreserv/cvsreserv-list-ctrl.js></script><script src=app/cvsreserv/cvsreserv-view-ctrl.js></script><script src=app/cvsreserv/cvsreserv-view-list-ctrl.js></script><script src=app/cvsreserv/cvsreserv.route.js></script><script src=app/panels-wells/panels-wells.component.js></script><script src=app/message/message.route.js></script><script src=app/message/sms-send-number-edit-ctrl.js></script><script src=app/message/sms-send-number-list-ctrl.js></script><script src=app/message/sms-send-number-save-ctrl.js></script><script src=app/dataanalysis/analysis-action-compare-ctrl.js></script><script src=app/dataanalysis/analysis-cluster-compare-ctrl.js></script><script src=app/dataanalysis/analysis-cluster-compare-result.js></script><script src=app/dataanalysis/analysis-cluster-three-plot-ctrl.js></script><script src=app/dataanalysis/analysis-customerrank-list-ctrl.js></script><script src=app/dataanalysis/analysis-customerrecommend-detail-ctrl.js></script><script src=app/dataanalysis/analysis-customerrecommend-list-ctrl.js></script><script src=app/dataanalysis/analysis-execute-ctrl.js></script><script src=app/dataanalysis/analysis-recommend-detail-ctrl.js></script><script src=app/dataanalysis/analysis-recommend-list-ctrl.js></script><script src=app/dataanalysis/analysis-result-ctrl.js></script><script src=app/dataanalysis/analysis-rfmcentroids-edit-ctrl.js></script><script src=app/dataanalysis/analysis-rfmcentroids-list-ctrl.js></script><script src=app/dataanalysis/da-customer-detail-ctrl.js></script><script src=app/dataanalysis/da-customer-list-ctrl.js></script><script src=app/dataanalysis/da-goods-detail-ctrl.js></script><script src=app/dataanalysis/da-goods-list-ctrl.js></script><script src=app/dataanalysis/da-sales-detail-ctrl.js></script><script src=app/dataanalysis/da-sales-list-ctrl.js></script><script src=app/dataanalysis/dataanalysis.route.js></script><script src=app/dataanalysis/datagroup-detail-ctrl.js></script><script src=app/dataanalysis/datagroup-edit-ctrl.js></script><script src=app/dataanalysis/datagroup-list-ctrl.js></script><script src=app/reserve/reserve-daily-ctrl.js></script><script src=app/reserve/reserve-detail-ctrl.js></script><script src=app/reserve/reserve-edit-ctrl.js></script><script src=app/reserve/reserve-list-ctrl.js></script><script src=app/reserve/reserve.route.js></script><script src=app/reserve/reservecode-list-ctrl.js></script><script src=app/popup/popup-edit-ctrl.js></script><script src=app/popup/popup-list-ctrl.js></script><script src=app/popup/popup.route.js></script><script src=app/reports/ccreport01-detail-ctrl.js></script><script src=app/reports/ccreport01-list-ctrl.js></script><script src=app/reports/ccreport02-list-ctrl.js></script><script src=app/reports/reports.route.js></script><script src=app/reports/salesreport01-list-ctrl.js></script><script src=app/reports/salesreport02-list-ctrl.js></script><script src=app/reports/salesreport03-list-ctrl.js></script><script src=app/reports/salesreport04-list-ctrl.js></script><script src=app/reports/salesreport05-list-ctrl.js></script><script src=app/reports/salesreport06-detail-ctrl.js></script><script src=app/reports/salesreport06-list-ctrl.js></script><script src=app/project/gantt-list-ctrl.js></script><script src=app/project/gantt-list-google-ctrl.js></script><script src=app/project/project.route.js></script><script src=app/survey/analysis-ctrl.js></script><script src=app/survey/chartjs-plugin-labels.js></script><script src=app/survey/classfy-info-edit-ctrl.js></script><script src=app/survey/classfy-info-list-ctrl.js></script><script src=app/survey/client-edit-ctrl.js></script><script src=app/survey/client-list-ctrl.js></script><script src=app/survey/client-result-list-ctrl.js></script><script src=app/survey/contact-edit-ctrl.js></script><script src=app/survey/counsel-edit-ctrl.js></script><script src=app/survey/counsel-list-ctrl.js></script><script src=app/survey/counselor-edit-ctrl.js></script><script src=app/survey/counselor-list-ctrl.js></script><script src=app/survey/form-edit-ctrl.js></script><script src=app/survey/form-list-ctrl.js></script><script src=app/survey/image-edit-ctrl.js></script><script src=app/survey/image-list-ctrl.js></script><script src=app/survey/report-detail-ctrl.js></script><script src=app/survey/report-list-ctrl.js></script><script src=app/survey/report-mng-detail-ctrl.js></script><script src=app/survey/report-mng-list-ctrl.js></script><script src=app/survey/report-search-ctrl.js></script><script src=app/survey/report-upload-ctrl.js></script><script src=app/survey/result-detail-ctrl.js></script><script src=app/survey/result-list-ctrl.js></script><script src=app/survey/resv-send-list-ctrl.js></script><script src=app/survey/sms-statistic-ctrl.js></script><script src=app/survey/survey-detail-ctrl.js></script><script src=app/survey/survey-edit-ctrl.js></script><script src=app/survey/survey-email-send-ctrl.js></script><script src=app/survey/survey-group-list-ctrl.js></script><script src=app/survey/survey-list-ctrl.js></script><script src=app/survey/survey-send-result-list-ctrl.js></script><script src=app/survey/survey-send-totresult-list-ctrl.js></script><script src=app/survey/survey-sms-send-ctrl.js></script><script src=app/survey/survey-type-edit-ctrl.js></script><script src=app/survey/survey-type-list-ctrl.js></script><script src=app/survey/survey.route.js></script><script src=app/survey/target-result-edit-ctrl.js></script><script src=app/survey/target-result-list-ctrl.js></script><script src=app/survey/trend-analysis-ctrl.js></script><script src=app/system/cafe24-deleteuser-ctrl.js></script><script src=app/system/caretkt-edit-ctrl.js></script><script src=app/system/caretkt-list-ctrl.js></script><script src=app/system/common-properties-ctrl.js></script><script src=app/system/commoncode-api-srv.js></script><script src=app/system/commoncode-list-ctrl.js></script><script src=app/system/company-api-srv.js></script><script src=app/system/company-detail-ctrl.js></script><script src=app/system/company-edit-ctrl.js></script><script src=app/system/company-edit-tab1-ctrl.js></script><script src=app/system/company-edit-tab2-ctrl.js></script><script src=app/system/company-list-ctrl.js></script><script src=app/system/contents-edit-ctrl.js></script><script src=app/system/contents-list-ctrl.js></script><script src=app/system/department-api-srv.js></script><script src=app/system/department-detail-ctrl.js></script><script src=app/system/department-edit-ctrl.js></script><script src=app/system/department-list-ctrl.js></script><script src=app/system/makequery-list-ctrl.js></script><script src=app/system/mastergradefee-list-ctrl.js></script><script src=app/system/menu-manage-list-ctrl.js></script><script src=app/system/pharmagradefee-list-ctrl.js></script><script src=app/system/role-api-srv.js></script><script src=app/system/role-detail-ctrl.js></script><script src=app/system/role-edit-ctrl.js></script><script src=app/system/role-list-ctrl.js></script><script src=app/system/rolescreen-api-srv.js></script><script src=app/system/rolescreen-detail-ctrl.js></script><script src=app/system/rolescreen-edit-ctrl.js></script><script src=app/system/rolescreen-list-ctrl.js></script><script src=app/system/screen-api-srv.js></script><script src=app/system/screen-detail-ctrl.js></script><script src=app/system/screen-edit-ctrl.js></script><script src=app/system/screen-list-ctrl.js></script><script src=app/system/seminar-edit-ctrl.js></script><script src=app/system/seminar-edit-tab1-ctrl.js></script><script src=app/system/seminar-edit-tab2-ctrl.js></script><script src=app/system/seminar-edit-tab3-ctrl.js></script><script src=app/system/seminar-list-ctrl.js></script><script src=app/system/survey-edit-ctrl.js></script><script src=app/system/survey-list-ctrl.js></script><script src=app/system/system-code-api-srv.js></script><script src=app/system/system.route.js></script><script src=app/system/user-detail-ctrl.js></script><script src=app/system/user-edit-ctrl.js></script><script src=app/system/user-edit-tab1-ctrl.js></script><script src=app/system/user-edit-tab2-ctrl.js></script><script src=app/system/user-edit-tab3-ctrl.js></script><script src=app/system/user-list-ctrl.js></script><script src=home/main/main-ctrl.js></script><script src=home/support/support-ctrl.js></script><script src=scripts/directives/asSortable.js></script><script src=scripts/directives/file-dropzoon.js></script><script src=scripts/directives/input-enter-directives.js></script><script src=scripts/directives/kr-input.js></script><script src=scripts/directives/kr-textarea.js></script><script src=scripts/directives/modal-draggable.js></script><script src=scripts/directives/permission.js></script><script src=scripts/directives/tilecontroltoggle.js></script><script src=scripts/filters/byte-check.js></script><script src=scripts/filters/filesize-filter.js></script><script src=scripts/filters/html-string.js></script><script src=scripts/filters/local-to-utc.js></script><script src=scripts/filters/nl2br-string.js></script><script src=scripts/filters/to-locale-date.js></script><script src=scripts/filters/to-locale-datetime.js></script><script src=scripts/filters/utc-to-local.js></script><script src=scripts/file-attach/file-iframe-attach-listener.js></script><script src=scripts/material/sidenav.js></script><script src=scripts/module/borderLayout.js></script><script src=scripts/module/dock.js></script><script src=scripts/pages/header-ctrl.js></script><script src=scripts/scrollStyle/jquery.mCustomScrollbar.js></script><script src=scripts/service/auth-services.js></script><script src=scripts/service/custom-field-api.js></script><script src=scripts/service/helper-service.js></script><script src=scripts/service/iframe-proxy.js></script><script src=scripts/service/post-api.js></script><script src=scripts/service/wjmreport.js></script><script src=scripts/service/wjmsurvey.js></script><script src=components/biz-component/buttons/buttons.component.js></script><script src=components/modal/campaign/favori-modal-ctrl.js></script><script src=components/modal/campaign/form-modal-ctrl.js></script><script src=components/modal/campaign/form-modal2-ctrl.js></script><script src=components/modal/campaign/fre-modal-ctrl.js></script><script src=components/modal/campaign/grpcust-modal-ctrl.js></script><script src=components/modal/campaign/sms-modal-ctrl.js></script><script src=components/modal/campaign/srch-cust-modal-ctrl.js></script><script src=components/modal/campaign/survey-target-edit-modal2-ctrl.js></script><script src=components/modal/campaign/tree-modal-ctrl.js></script><script src=components/modal/careTkt/care-tkt-modal-ctrl.js></script><script src=components/modal/contents/contents-modal-ctrl.js></script><script src=components/modal/cvsreserv/cvsreserv-info-modal-ctrl.js></script><script src=components/modal/customer/counselhist-modal-ctrl.js></script><script src=components/modal/customer/customer-modal-ctrl.js></script><script src=components/modal/dataanalysis/data-group-action-modal-ctrl.js></script><script src=components/modal/dataanalysis/data-group-modal-ctrl.js></script><script src=components/modal/department/dept-modal-ctrl.js></script><script src=components/modal/excel/upload-excel-user-modal-ctrl.js></script><script src=components/modal/findIdPwd/findIdPwd-modal-ctrl.js></script><script src=components/modal/mypage/mypage-modal-ctrl.js></script><script src=components/modal/preview/preview-ctrl.js></script><script src=components/modal/product/product-modal-ctrl.js></script><script src=components/modal/product/productall-modal-ctrl.js></script><script src=components/modal/tenant/tenant-modal-ctrl.js></script><script src=components/modal/tenant/tenant2-modal-ctrl.js></script><script src=components/modal/userRole/userrole-modal-ctrl.js></script><script src=components/modal/survey/classfyinfo-modal-ctrl.js></script><script src=components/modal/survey/menusvy-modal-ctrl.js></script><script src=components/modal/survey/pre-modal-ctrl.js></script><script src=components/modal/survey/qst-modal-ctrl.js></script><script src=components/modal/survey/survey-modal-ctrl.js></script><script src=components/modal/survey/svytype-modal-ctrl.js></script><script src=components/modal/survey/tgt-modal-ctrl.js></script><script src=components/modal/survey/wjm-anal-preview-modal-ctrl.js></script><script src=components/modal/survey/wjm-form-modal-ctrl.js></script><script src=components/modal/survey/wjm-group-edit-modal-ctrl.js></script><script src=components/modal/survey/wjm-group-edit-modal2-ctrl.js></script><script src=components/modal/survey/wjm-group-edit-modal3-ctrl.js></script><script src=components/modal/survey/wjm-pre-modal-ctrl.js></script><script src=components/modal/survey/wjm-qst-modal-ctrl.js></script><script src=components/modal/survey/wjm-qstgoto-modal-ctrl.js></script><script src=components/modal/survey/wjm-qstmove-modal-ctrl.js></script><script src=components/modal/survey/wjm-report-modal-ctrl.js></script><script src=components/modal/survey/wjm-scorelv-lvcont-modal-ctrl.js></script><script src=components/modal/survey/wjm-scorelv-sec-modal-ctrl.js></script><script src=components/modal/survey/wjm-scorelv-tot-modal-ctrl.js></script><script src=components/modal/survey/wjm-send-totresult-modal-ctrl.js></script><script src=components/modal/survey/wjm-survey-modal-ctrl.js></script><script src=components/modal/survey/wjm-survey-multisel-modal-ctrl.js></script><script src=components/modal/survey/wjm-target-edit-modal-ctrl.js></script><script src=components/modal/survey/wjm-target-scorelv-modal-ctrl.js></script><script src=components/modal/survey/wjm-urlpost-modal-ctrl.js></script><script src=components/modal/users/user-modal-ctrl.js></script><script src=components/modal/users/wjm-counselor-modal-ctrl.js></script><script src=components/modal/users/wjm-user-modal-ctrl.js></script><script src=components/ui-component/factory/dock.js></script><script src=components/ui-component/factory/galert-factory.js></script><script src=components/ui-component/factory/gconfirm-factory.js></script><script src=components/ui-component/factory/modal-factory.js></script><script src=components/ui-component/factory/sort-array-factory.js></script><script src=components/ui-component/factory/static-variable-factory.js></script><script src=components/ui-component/factory/uuid-factory.js></script><script src=components/ui-component/controllers/ui-general.js></script><script src=components/ui-component/timeline/timeline.component.js></script><script src=app/dashboard/stats/stats.component.js></script><script src=scripts/directives/common-code-custom/common-code-custom-ctrl.js></script><script src=scripts/directives/common-code-custom/common-code-custom-directive.js></script><script src=scripts/directives/common-code/common-api-srv.js></script><script src=scripts/directives/common-code/common-code-ctrl.js></script><script src=scripts/directives/common-code/common-code-directive.js></script><script src=scripts/directives/common-code-tree/common-code-tree-api-srv.js></script><script src=scripts/directives/common-code-tree/common-code-tree-ctrl.js></script><script src=scripts/directives/common-code-tree/common-code-tree-directive.js></script><script src=scripts/directives/search-condition/search-condition-ctrl.js></script><script src=scripts/directives/search-condition/search-condition-directive.js></script><script src=scripts/directives/select-data-group/select-data-group-ctrl.js></script><script src=scripts/directives/select-data-group/select-data-group-directive.js></script><script src=scripts/directives/udc/udc-detail-ctrl.js></script><script src=scripts/directives/udc/udc-detail-directive.js></script><script src=scripts/directives/udc/udc-edit-ctrl.js></script><script src=scripts/directives/udc/udc-edit-directive.js></script><script src=scripts/directives/udc/udc-search-ctrl.js></script><script src=scripts/directives/udc/udc-search-directive.js></script><script src=scripts/file-attach/directive/file-attach-directive.js></script><script src=scripts/file-attach/directive/file-drop-zone.js></script><script src=scripts/file-attach/controller/file-attach-controller.js></script><script src=scripts/file-attach/factory/file-attach-data-util.js></script><script src=scripts/file-attach/factory/file-upload-listener.js></script><script src=scripts/file-attach/service/file-upload-service.js></script><script src=components/ui-component/layout/header/header.component.js></script><script src=components/ui-component/layout/sidebar/sidebar.component.js></script><script src=components/ui-component/layout/header/header-notification/header-notification.component.js></script><script src=components/ui-component/layout/sidebar/sidebar-search/sidebar-search.component.js></script><!-- endinject --><!-- inject:partials --><!-- angular templates will be automatically converted in js and inserted here --><!-- endinject --><!-- endbuild --><link rel=stylesheet href=assets/css/common.css><link rel=stylesheet href=assets/css/custom-media-width-size.css><link rel=stylesheet href=assets/css/fullcalendar.min.css><link rel=stylesheet href=assets/css/main.css><link rel=stylesheet href=assets/css/style.css><link rel=stylesheet href=assets/css/animate.css><script src=assets/global-constant.js></script><script src=assets/app/common/common.js></script><!--<script src=\"http://dmaps.daum.net/map_js_init/postcode.v2.js\"></script>--><!-- SSL 적용시 호출 --><script src=https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js></script><script src=assets/app/common/FileSaver.min.js></script><script src=assets/app/common/xlsx.full.min.js></script><script src=assets/app/common/fullcalendar.min.js></script><script src=assets/app/common/locale-all.js></script><script src=assets/app/common/signature_pad.min.js></script><script crossorigin=anonymous integrity=sha384-/x1aHz0nKRd6zVUazsV6CbQvjJvr6zQL2CHbQZf3yoLkezyEtZUpqUNnOLW9Nt3v src=https://browser.sentry-cdn.com/5.9.1/bundle.min.js></script><script crossorigin=anonymous src=https://browser.sentry-cdn.com/5.9.1/angular.min.js></script><script src=assets/app/vendor/d3.v3.min.js charset=utf-8></script><script src=assets/app/vendor/d3.layout.cloud.js charset=utf-8></script><script src=../bower_components/css-element-queries/src/ResizeSensor.js></script><script src=../bower_components/css-element-queries/src/ElementQueries.js></script><script type=text/javascript src=https://www.gstatic.com/charts/loader.js></script><script src=assets/app/vendor/html2canvas.js></script><script src=assets/app/vendor/html2canvas.min.js></script><script src=assets/app/common/wow.min.js></script><!--폰트아이콘--><script src=https://kit.fontawesome.com/48797d4313.js crossorigin=anonymous></script><script>Sentry.init({\r\n        dsn: \'https://16048dd690ce403199d465f9e650c996@o484328.ingest.sentry.io/5537304\',\r\n        integrations: [\r\n          new Sentry.Integrations.Angular(),\r\n        ],\r\n      });</script><!-- <script src=\"http://cdnjs.cloudflare.com/ajax/libs/waypoints/2.0.3/waypoints.min.js\"></script> bower.json에 추가--><script src=assets/app/common/jquery.counterup.min.js></script><script>new WOW().init();</script><!--\r\n    # PG결제\r\n      - API : https://www.iamport.kr/getstarted\r\n      - DOC : https://docs.iamport.kr/\r\n  --><script src=https://cdn.iamport.kr/js/iamport.payment-1.1.5.js></script><script>Sentry.init({\r\n      dsn: \'https://16048dd690ce403199d465f9e650c996@o484328.ingest.sentry.io/5537304\',\r\n      integrations: [\r\n        new Sentry.Integrations.Angular(),\r\n      ],\r\n    });\r\n\r\n    //결제초기화 : 상점ID\r\n    IMP.init(\"imp31731325\");</script></body></html>");
$templateCache.put("index.html","<!doctype html><head><title>더휴먼데이터센터</title><frameset rows=*,8 rows1=*,30 rows2_disabled=*,60 frameborder=0 framespacing=0 name=fst><frame src=i.html name=main frameborder=0 noresize><noframes><p></p></noframes></frameset></head>");
$templateCache.put("m.html","<!doctype html><html ng-app=salevis4-web><head><title ng-bind=$root.title>더휴먼데이터센터</title><meta charset=utf-8><meta name=description content=\"\"><meta name=viewport content=\"width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no\"><meta http-equiv=Expires content=-1><meta http-equiv=Pragma content=no-cache><meta http-equiv=Cache-Control content=No-Cache><link rel=stylesheet href=assets/css/app.css><!-- Place favicon.ico and apple-touch-icon.png in the root directory --><!-- build:css({.tmp/serve,src}) styles/vendor.css --><!-- bower:css --><link rel=stylesheet href=../bower_components/angular-bootstrap-colorpicker/css/colorpicker.css><link rel=stylesheet href=../bower_components/bootstrap/dist/css/bootstrap.css><link rel=stylesheet href=../bower_components/angular-bootstrap-nav-tree/dist/abn_tree.css><link rel=stylesheet href=../bower_components/chosen/chosen.min.css><link rel=stylesheet href=../bower_components/font-awesome/css/font-awesome.css><link rel=stylesheet href=../bower_components/intro.js/introjs.css><link rel=stylesheet href=../bower_components/leaflet/dist/leaflet.css><link rel=stylesheet href=../bower_components/angular-loading-bar/build/loading-bar.css><link rel=stylesheet href=../bower_components/angular-material/angular-material.css><link rel=stylesheet href=../bower_components/rickshaw/rickshaw.min.css><link rel=stylesheet href=../bower_components/angular-toastr/dist/angular-toastr.css><link rel=stylesheet href=../bower_components/fullcalendar/fullcalendar.css><link rel=stylesheet href=../bower_components/angular-ui-grid/ui-grid.css><link rel=stylesheet href=../bower_components/angular-ui-select/dist/select.css><link rel=stylesheet href=../bower_components/angular-ui-tree/dist/angular-ui-tree.min.css><link rel=stylesheet href=../bower_components/animate.css/animate.css><link rel=stylesheet href=../bower_components/bootstrap-daterangepicker/daterangepicker.css><link rel=stylesheet href=../bower_components/leaflet-draw/dist/leaflet.draw.css><link rel=stylesheet href=../bower_components/material-design-iconic-font/dist/css/material-design-iconic-font.css><link rel=stylesheet href=../bower_components/morrisjs/morris.css><link rel=stylesheet href=../bower_components/ng-table/dist/ng-table.min.css><link rel=stylesheet href=../bower_components/ng-tags-input/ng-tags-input.min.css><link rel=stylesheet href=../bower_components/ngImgCrop/compile/minified/ng-img-crop.css><link rel=stylesheet href=../bower_components/simple-line-icons/css/simple-line-icons.css><link rel=stylesheet href=../bower_components/weather-icons/css/weather-icons.css><link rel=stylesheet href=../bower_components/weather-icons/css/weather-icons.min.css><link rel=stylesheet href=../bower_components/weather-icons/css/weather-icons-wind.css><link rel=stylesheet href=../bower_components/weather-icons/css/weather-icons-wind.min.css><link rel=stylesheet href=../bower_components/dragular/dist/dragular.min.css><link rel=stylesheet href=../bower_components/magnific-popup/dist/magnific-popup.css><link rel=stylesheet href=../bower_components/owl.carousel/dist/assets/owl.carousel.css><link rel=stylesheet href=../bower_components/owl.carousel/dist/assets/owl.theme.default.css><link rel=stylesheet href=../bower_components/angular-bootstrap-grid-tree/src/treeGrid.css><!-- endbower --><!-- endbuild --><!-- build:css({.tmp/serve,src}) styles/app.css --><!-- inject:css --><link rel=stylesheet href=index.css><link rel=stylesheet href=sb-admin-2.css><link rel=stylesheet href=timeline.css><link rel=stylesheet href=styles/loading.css><link rel=stylesheet href=styles/main.css><link rel=stylesheet href=styles/pagination.css><link rel=stylesheet href=styles/slick-theme.css><link rel=stylesheet href=styles/slick.css><link rel=stylesheet href=styles/sz-common.css><link rel=stylesheet href=styles/sz-reserve.css><link rel=stylesheet href=styles/vault.css><link rel=stylesheet href=components/login/login.css><link rel=stylesheet href=styles/module/borderLayout.css><link rel=stylesheet href=scripts/scrollStyle/jquery.mCustomScrollbar.css><!-- endinject --><!-- endbuild --></head><body><!--[if lt IE 10]>\r\n    <p class=\"browsehappy\">최신 웹 브라우저로 업그레이드 하시기 바랍니다. (권장: Internet Explorer 11 이상, Google Chrome 76 이상). <a\r\n      href=\"http://browsehappy.com/\">최신 웹 브라우저 다운로드</a></p>\r\n    <![endif]--><div ui-view><div class=loading-container><div class=loading></div><div id=loading-text>loading...</div></div></div><!-- build:js(src) scripts/vendor.js --><!-- bower:js --><script src=../bower_components/jquery/jquery.js></script><script src=../bower_components/angular/angular.js></script><script src=../bower_components/angular-animate/angular-animate.js></script><script src=../bower_components/angular-aria/angular-aria.js></script><script src=../bower_components/angular-bootstrap/ui-bootstrap-tpls.js></script><script src=../bower_components/angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module.js></script><script src=../bower_components/bootstrap/dist/js/bootstrap.js></script><script src=../bower_components/angular-bootstrap-nav-tree/dist/abn_tree_directive.js></script><script src=../bower_components/chosen/chosen.jquery.js></script><script src=../bower_components/angular-chosen-localytics/chosen.js></script><script src=../bower_components/angular-cookies/angular-cookies.js></script><script src=../bower_components/datatables.net/js/jquery.dataTables.js></script><script src=../bower_components/angular-datatables/dist/angular-datatables.js></script><script src=../bower_components/angular-datatables/dist/plugins/bootstrap/angular-datatables.bootstrap.js></script><script src=../bower_components/angular-datatables/dist/plugins/colreorder/angular-datatables.colreorder.js></script><script src=../bower_components/angular-datatables/dist/plugins/columnfilter/angular-datatables.columnfilter.js></script><script src=../bower_components/angular-datatables/dist/plugins/colvis/angular-datatables.colvis.js></script><script src=../bower_components/angular-datatables/dist/plugins/fixedcolumns/angular-datatables.fixedcolumns.js></script><script src=../bower_components/angular-datatables/dist/plugins/fixedheader/angular-datatables.fixedheader.js></script><script src=../bower_components/angular-datatables/dist/plugins/scroller/angular-datatables.scroller.js></script><script src=../bower_components/angular-datatables/dist/plugins/tabletools/angular-datatables.tabletools.js></script><script src=../bower_components/d3/d3.js></script><script src=../bower_components/angular-file-upload/dist/angular-file-upload.min.js></script><script src=../bower_components/angular-flot/angular-flot.js></script><script src=../bower_components/angular-fontawesome/dist/angular-fontawesome.js></script><script src=../bower_components/angular-fullscreen/src/angular-fullscreen.js></script><script src=../bower_components/angular-simple-logger/dist/angular-simple-logger.js></script><script src=../bower_components/lodash/lodash.js></script><script src=../bower_components/angular-google-maps/dist/angular-google-maps.js></script><script src=../bower_components/angular-i18n/angular-locale_ko-kr.js></script><script src=../bower_components/intro.js/intro.js></script><script src=../bower_components/angular-intro.js/src/angular-intro.js></script><script src=../bower_components/angular-ipsum/dist/ipsum.min.js></script><script src=../bower_components/leaflet/dist/leaflet-src.js></script><script src=../bower_components/angular-leaflet-directive/dist/angular-leaflet-directive.js></script><script src=../bower_components/angular-loading-bar/build/loading-bar.js></script><script src=../bower_components/masonry/dist/masonry.pkgd.js></script><script src=../bower_components/ev-emitter/ev-emitter.js></script><script src=../bower_components/imagesloaded/imagesloaded.js></script><script src=../bower_components/jquery-bridget/jquery-bridget.js></script><script src=../bower_components/angular-masonry/angular-masonry.js></script><script src=../bower_components/angular-messages/angular-messages.js></script><script src=../bower_components/angular-material/angular-material.js></script><script src=../bower_components/moment/moment.js></script><script src=../bower_components/angular-momentjs/angular-momentjs.js></script><script src=../bower_components/qrcode-generator/js/qrcode.js></script><script src=../bower_components/qrcode-generator/js/qrcode_UTF8.js></script><script src=../bower_components/angular-qrcode/angular-qrcode.js></script><script src=../bower_components/angular-resource/angular-resource.js></script><script src=../bower_components/rickshaw/rickshaw.js></script><script src=../bower_components/angular-rickshaw/rickshaw.js></script><script src=../bower_components/angular-sanitize/angular-sanitize.js></script><script src=../bower_components/angular-smart-table/dist/smart-table.js></script><script src=../bower_components/angular-toastr/dist/angular-toastr.tpls.js></script><script src=../bower_components/angular-touch/angular-touch.js></script><script src=../bower_components/angular-translate/angular-translate.js></script><script src=../bower_components/angular-translate-loader-static-files/angular-translate-loader-static-files.js></script><script src=../bower_components/angular-translate-storage-cookie/angular-translate-storage-cookie.js></script><script src=../bower_components/angular-translate-storage-local/angular-translate-storage-local.js></script><script src=../bower_components/jquery-ui/ui/jquery-ui.js></script><script src=../bower_components/fullcalendar/fullcalendar.js></script><script src=../bower_components/angular-ui-calendar/src/calendar.js></script><script src=../bower_components/angular-ui-grid/ui-grid.js></script><script src=../bower_components/angular-ui-router/release/angular-ui-router.js></script><script src=../bower_components/angular-ui-router/release/stateEvents.js></script><script src=../bower_components/angular-ui-select/dist/select.js></script><script src=../bower_components/angular-ui-tree/dist/angular-ui-tree.js></script><script src=../bower_components/angular-ui-utils/ui-utils.js></script><script src=../bower_components/chart.js/dist/Chart.js></script><script src=../bower_components/angular-chart.js/dist/angular-chart.js></script><script src=../bower_components/chartjs-plugin-annotation/chartjs-plugin-annotation.js></script><script src=../bower_components/bootstrap-daterangepicker/daterangepicker.js></script><script src=../bower_components/es5-shim/es5-shim.js></script><script src=../bower_components/flot/jquery.flot.js></script><script src=../bower_components/flot/jquery.flot.resize.js></script><script src=../bower_components/flot-spline/js/jquery.flot.spline.js></script><script src=../bower_components/flot.tooltip/js/jquery.flot.tooltip.js></script><script src=../bower_components/html.sortable/dist/html.sortable.js></script><script src=../bower_components/jquery.easy-pie-chart/dist/angular.easypiechart.js></script><script src=../bower_components/jquery.inputmask/dist/jquery.inputmask.bundle.js></script><script src=../bower_components/jquery.slimscroll/jquery.slimscroll.js></script><script src=../bower_components/jquery.slimscroll/jquery.slimscroll.min.js></script><script src=../bower_components/jquery.sparkline/index.js></script><script src=../bower_components/json3/lib/json3.js></script><script src=../bower_components/leaflet-draw/dist/leaflet.draw.js></script><script src=../bower_components/leaflet-heat/dist/leaflet-heat.js></script><script src=../bower_components/leaflet-plugins/control/Distance.js></script><script src=../bower_components/leaflet-plugins/control/Layers.Load.js></script><script src=../bower_components/leaflet-plugins/control/Permalink.js></script><script src=../bower_components/leaflet-plugins/control/Permalink.Layer.js></script><script src=../bower_components/leaflet-plugins/control/Permalink.Line.js></script><script src=../bower_components/leaflet-plugins/control/Permalink.Marker.js></script><script src=../bower_components/leaflet-plugins/layer/Icon.Canvas.js></script><script src=../bower_components/leaflet-plugins/layer/Layer.Deferred.js></script><script src=../bower_components/leaflet-plugins/layer/Marker.Rotate.js></script><script src=../bower_components/leaflet-plugins/layer/Marker.Text.js></script><script src=../bower_components/leaflet-plugins/layer/OpenStreetBugs.js></script><script src=../bower_components/leaflet-plugins/layer/vector/GPX.js></script><script src=../bower_components/leaflet-plugins/layer/vector/GPX.Speed.js></script><script src=../bower_components/leaflet-plugins/layer/vector/KML.js></script><script src=../bower_components/leaflet-plugins/layer/vector/OSM.js></script><script src=../bower_components/leaflet-plugins/layer/tile/Bing.js></script><script src=../bower_components/leaflet-plugins/layer/tile/Google.js></script><script src=../bower_components/leaflet-plugins/layer/tile/Yandex.js></script><script src=../bower_components/eve-raphael/eve.js></script><script src=../bower_components/raphael/raphael.js></script><script src=../bower_components/mocha/mocha.js></script><script src=../bower_components/morrisjs/morris.js></script><script src=../bower_components/ng-bs-daterangepicker/src/ng-bs-daterangepicker.js></script><script src=../bower_components/ng-table/dist/ng-table.min.js></script><script src=../bower_components/ng-tags-input/ng-tags-input.min.js></script><script src=../bower_components/ngImgCrop/compile/minified/ng-img-crop.js></script><script src=../bower_components/oclazyload/dist/ocLazyLoad.js></script><script src=../bower_components/textAngular/dist/textAngular-rangy.min.js></script><script src=../bower_components/textAngular/dist/textAngular-sanitize.js></script><script src=../bower_components/textAngular/dist/textAngular.js></script><script src=../bower_components/textAngular/dist/textAngularSetup.js></script><script src=../bower_components/dragular/dist/dragular.min.js></script><script src=../bower_components/magnific-popup/dist/jquery.magnific-popup.js></script><script src=../bower_components/owl.carousel/dist/owl.carousel.js></script><script src=../bower_components/api-check/dist/api-check.min.js></script><script src=../bower_components/angular-formly/dist/formly.min.js></script><script src=../bower_components/angular-formly-templates-bootstrap/dist/angular-formly-templates-bootstrap.min.js></script><script src=../bower_components/angular-bootstrap-grid-tree/src/tree-grid-directive.js></script><script src=../bower_components/printThis/printThis.js></script><script src=../bower_components/threejs/build/three.js></script><script src=../bower_components/waypoints/waypoints.js></script><script src=../bower_components/html2canvas/build/html2canvas.js></script><script src=../bower_components/raven-js/dist/raven.js></script><!-- endbower --><!-- endbuild --><!-- build:js({.tmp/serve,.tmp/partials,src}) scripts/app.js --><!-- inject:js --><script src=scripts/index.module.js></script><script src=scripts/global-fn.js></script><script src=scripts/index.config.js></script><script src=scripts/index.constants.js></script><script src=scripts/index.route.js></script><script src=scripts/index.run.js></script><script src=scripts/slick.min.js></script><script src=scripts/sz-common-fnc.js></script><script src=scripts/vault.js></script><script src=sb-admin-2.js></script><script src=app/app.component.js></script><script src=app/app.route.js></script><script src=home/contacts-ctrl.js></script><script src=home/home.component.js></script><script src=home/home.route.js></script><script src=home/prcenter-ctrl.js></script><script src=home/prcenter-view-ctrl.js></script><script src=reserve/meeting-daily-modal-ctrl.js></script><script src=reserve/meeting-detail-ctrl.js></script><script src=reserve/meeting-detail-modal-ctrl.js></script><script src=reserve/meeting-detail2-ctrl.js></script><script src=reserve/meeting-room-api-srv.js></script><script src=reserve/meeting-room-ctrl.js></script><script src=reserve/meeting-roomimage-modal-ctrl.js></script><script src=reserve/my-reserve-list-ctrl.js></script><script src=reserve/reserve.component.js></script><script src=reserve/reserve.route.js></script><script src=components/modal/modal-api-srv.js></script><script src=components/survey/counsel-agree-ctrl.js></script><script src=components/survey/counsel-api-srv.js></script><script src=components/survey/counsel.component.js></script><script src=components/survey/emaildeny.component.js></script><script src=components/survey/survey-api-srv.js></script><script src=components/survey/survey.component.js></script><script src=components/login/login-api-srv.js></script><script src=components/login/login.component.js></script><script src=components/login/logout.component.js></script><script src=components/login/signup-step-one.component.js></script><script src=components/login/signup-step-two.component.js></script><script src=components/branch-apps/apps.component.js></script><script src=app/application/application.route.js></script><script src=app/application/EAP-business-edit-ctrl.js></script><script src=app/application/EAP-business-list-ctrl.js></script><script src=app/application/EAP-counsel-edit-ctrl.js></script><script src=app/application/EAP-counsel-list-ctrl.js></script><script src=app/application/expert-edit-ctrl.js></script><script src=app/application/expert-list-ctrl.js></script><script src=app/basic/mng-calendar-ctrl.js></script><script src=app/basic/mng-calendar.route.js></script><script src=app/board/bbs-master-detail-ctrl.js></script><script src=app/board/bbs-master-edit-ctrl.js></script><script src=app/board/bbs-master-list-ctrl.js></script><script src=app/board/board.route.js></script><script src=app/board/h0102-api-srv.js></script><script src=app/board/h0102-detail-ctrl.js></script><script src=app/board/h0102-edit-ctrl.js></script><script src=app/board/h0102-list-ctrl.js></script><script src=app/board/h0103-api-srv.js></script><script src=app/board/h0103-detail-ctrl.js></script><script src=app/board/h0103-edit-ctrl.js></script><script src=app/board/h0103-list-ctrl.js></script><script src=app/board/notice-board-ctrl.js></script><script src=app/board/notice-board-detail-ctrl.js></script><script src=app/board/notice-board-edit-ctrl.js></script><script src=app/board/popup-list-ctrl.js></script><script src=app/boardmng/boardmng-api-srv.js></script><script src=app/boardmng/boardmng-detail-ctrl.js></script><script src=app/boardmng/boardmng-edit-ctrl.js></script><script src=app/boardmng/boardmng-list-ctrl.js></script><script src=app/boardmng/boardmng.route.js></script><script src=app/boardmng/column-attr-reorder-ctrl.js></script><script src=app/boardmng/column-attr-setup-ctrl.js></script><script src=app/campaign/campaign.route.js></script><script src=app/campaign/group-list-ctrl.js></script><script src=app/campaign/happycall-edit-ctrl.js></script><script src=app/campaign/monitoring-detail-ctrl.js></script><script src=app/campaign/monitoring-list-ctrl.js></script><script src=app/campaign/single-edit-ctrl.js></script><script src=app/campaign/single-list-ctrl.js></script><script src=app/campaign2/campaign-edit-ctrl.js></script><script src=app/campaign2/campaign-list-ctrl.js></script><script src=app/campaign2/campaign.route.js></script><script src=app/campaign2/campaignimpl-detail-ctrl.js></script><script src=app/campaign2/campaignimpl-list-ctrl.js></script><script src=app/campaign2/form-edit-ctrl.js></script><script src=app/campaign2/form-email-edit-ctrl.js></script><script src=app/campaign2/form-email-list-ctrl.js></script><script src=app/campaign2/form-list-ctrl.js></script><script src=app/campaign2/form-sms-edit-ctrl.js></script><script src=app/campaign2/form-sms-list-ctrl.js></script><script src=app/campaign2/group-list-ctrl.js></script><script src=app/chart/chart-ctrl.js></script><script src=app/cafe24/cafe24.route.js></script><script src=app/cafe24/chart-list-ctrl.js></script><script src=app/cafe24/customer-detail-ctrl.js></script><script src=app/cafe24/customer-list-ctrl.js></script><script src=app/cafe24/log-detail-ctrl.js></script><script src=app/cafe24/log-list-ctrl.js></script><script src=app/cafe24/loginbycafe24-api-srv.js></script><script src=app/cafe24/loginbycafe24.component.js></script><script src=app/cafe24/order-detail-ctrl.js></script><script src=app/cafe24/order-list-ctrl.js></script><script src=app/cafe24/product-detail-ctrl.js></script><script src=app/cafe24/product-list-ctrl.js></script><script src=app/cafe24/subscribe-customer-detail-ctrl.js></script><script src=app/cafe24/subscribe-customer-list-ctrl.js></script><script src=app/cafe24/subscribe-detail-ctrl.js></script><script src=app/cafe24/subscribe-list-ctrl.js></script><script src=app/cafe24/subscribe-prd-detail-ctrl.js></script><script src=app/cafe24/subscribe-prd-list-ctrl.js></script><script src=app/community/community-api-srv.js></script><script src=app/community/community.route.js></script><script src=app/community/news-detail-ctrl.js></script><script src=app/community/news-edit-ctrl.js></script><script src=app/community/news-list-ctrl.js></script><script src=app/community/notice-detail-ctrl.js></script><script src=app/community/notice-edit-ctrl.js></script><script src=app/community/notice-list-ctrl.js></script><script src=app/community/winners-detail-ctrl.js></script><script src=app/community/winners-edit-ctrl.js></script><script src=app/community/winners-list-ctrl.js></script><script src=app/customer/customer-add-batch-ctrl.js></script><script src=app/customer/customer-detail-tab1-ctrl.js></script><script src=app/customer/customer-detail2-ctrl.js></script><script src=app/customer/customer-detail2-tab1-ctrl.js></script><script src=app/customer/customer-detail2-tab2-ctrl.js></script><script src=app/customer/customer-detail2-tab2-modal-ctrl.js></script><script src=app/customer/customer-detail2-tab3-ctrl.js></script><script src=app/customer/customer-detail2-tab4-ctrl.js></script><script src=app/customer/customer-edit-ctrl.js></script><script src=app/customer/customer-edit-tab1-ctrl.js></script><script src=app/customer/customer-edit-tab2-ctrl.js></script><script src=app/customer/customer-edit-tab3-ctrl.js></script><script src=app/customer/customer-edit-tab4-ctrl.js></script><script src=app/customer/customer-edit-tab5-ctrl.js></script><script src=app/customer/customer-edit-tab6-ctrl.js></script><script src=app/customer/customer-list-ctrl.js></script><script src=app/customer/customer.route.js></script><script src=app/dashboard/cafe24dashboard-ctrl.js></script><script src=app/dashboard/dashboard-ctrl.js></script><script src=app/dashboard/dashboard.route.js></script><script src=app/dashboard/survey-dashboard-ctrl.js></script><script src=app/cvssales/cvssales-detail-ctrl.js></script><script src=app/cvssales/cvssales-edit-ctrl.js></script><script src=app/cvssales/cvssales-list-ctrl.js></script><script src=app/cvssales/cvssales.route.js></script><script src=app/cvssales/cvssalesgen-edit-ctrl.js></script><script src=app/cvssales/cvssalesgen-list-ctrl.js></script><script src=app/cvssales/cvssalesorder-list-ctrl.js></script><script src=app/cvssales/cvssalesstock-edit-ctrl.js></script><script src=app/cvssales/cvssalesstock-list-ctrl.js></script><script src=app/cvssales/cvssalestkt-edit-ctrl.js></script><script src=app/cvssales/cvssalestkt-list-ctrl.js></script><script src=app/cvsreserv/cvsreserv-edit-ctrl.js></script><script src=app/cvsreserv/cvsreserv-list-ctrl.js></script><script src=app/cvsreserv/cvsreserv-view-ctrl.js></script><script src=app/cvsreserv/cvsreserv-view-list-ctrl.js></script><script src=app/cvsreserv/cvsreserv.route.js></script><script src=app/panels-wells/panels-wells.component.js></script><script src=app/message/message.route.js></script><script src=app/message/sms-send-number-edit-ctrl.js></script><script src=app/message/sms-send-number-list-ctrl.js></script><script src=app/message/sms-send-number-save-ctrl.js></script><script src=app/dataanalysis/analysis-action-compare-ctrl.js></script><script src=app/dataanalysis/analysis-cluster-compare-ctrl.js></script><script src=app/dataanalysis/analysis-cluster-compare-result.js></script><script src=app/dataanalysis/analysis-cluster-three-plot-ctrl.js></script><script src=app/dataanalysis/analysis-customerrank-list-ctrl.js></script><script src=app/dataanalysis/analysis-customerrecommend-detail-ctrl.js></script><script src=app/dataanalysis/analysis-customerrecommend-list-ctrl.js></script><script src=app/dataanalysis/analysis-execute-ctrl.js></script><script src=app/dataanalysis/analysis-recommend-detail-ctrl.js></script><script src=app/dataanalysis/analysis-recommend-list-ctrl.js></script><script src=app/dataanalysis/analysis-result-ctrl.js></script><script src=app/dataanalysis/analysis-rfmcentroids-edit-ctrl.js></script><script src=app/dataanalysis/analysis-rfmcentroids-list-ctrl.js></script><script src=app/dataanalysis/da-customer-detail-ctrl.js></script><script src=app/dataanalysis/da-customer-list-ctrl.js></script><script src=app/dataanalysis/da-goods-detail-ctrl.js></script><script src=app/dataanalysis/da-goods-list-ctrl.js></script><script src=app/dataanalysis/da-sales-detail-ctrl.js></script><script src=app/dataanalysis/da-sales-list-ctrl.js></script><script src=app/dataanalysis/dataanalysis.route.js></script><script src=app/dataanalysis/datagroup-detail-ctrl.js></script><script src=app/dataanalysis/datagroup-edit-ctrl.js></script><script src=app/dataanalysis/datagroup-list-ctrl.js></script><script src=app/reserve/reserve-daily-ctrl.js></script><script src=app/reserve/reserve-detail-ctrl.js></script><script src=app/reserve/reserve-edit-ctrl.js></script><script src=app/reserve/reserve-list-ctrl.js></script><script src=app/reserve/reserve.route.js></script><script src=app/reserve/reservecode-list-ctrl.js></script><script src=app/popup/popup-edit-ctrl.js></script><script src=app/popup/popup-list-ctrl.js></script><script src=app/popup/popup.route.js></script><script src=app/reports/ccreport01-detail-ctrl.js></script><script src=app/reports/ccreport01-list-ctrl.js></script><script src=app/reports/ccreport02-list-ctrl.js></script><script src=app/reports/reports.route.js></script><script src=app/reports/salesreport01-list-ctrl.js></script><script src=app/reports/salesreport02-list-ctrl.js></script><script src=app/reports/salesreport03-list-ctrl.js></script><script src=app/reports/salesreport04-list-ctrl.js></script><script src=app/reports/salesreport05-list-ctrl.js></script><script src=app/reports/salesreport06-detail-ctrl.js></script><script src=app/reports/salesreport06-list-ctrl.js></script><script src=app/project/gantt-list-ctrl.js></script><script src=app/project/gantt-list-google-ctrl.js></script><script src=app/project/project.route.js></script><script src=app/survey/analysis-ctrl.js></script><script src=app/survey/chartjs-plugin-labels.js></script><script src=app/survey/classfy-info-edit-ctrl.js></script><script src=app/survey/classfy-info-list-ctrl.js></script><script src=app/survey/client-edit-ctrl.js></script><script src=app/survey/client-list-ctrl.js></script><script src=app/survey/client-result-list-ctrl.js></script><script src=app/survey/contact-edit-ctrl.js></script><script src=app/survey/counsel-edit-ctrl.js></script><script src=app/survey/counsel-list-ctrl.js></script><script src=app/survey/counselor-edit-ctrl.js></script><script src=app/survey/counselor-list-ctrl.js></script><script src=app/survey/form-edit-ctrl.js></script><script src=app/survey/form-list-ctrl.js></script><script src=app/survey/image-edit-ctrl.js></script><script src=app/survey/image-list-ctrl.js></script><script src=app/survey/report-detail-ctrl.js></script><script src=app/survey/report-list-ctrl.js></script><script src=app/survey/report-mng-detail-ctrl.js></script><script src=app/survey/report-mng-list-ctrl.js></script><script src=app/survey/report-search-ctrl.js></script><script src=app/survey/report-upload-ctrl.js></script><script src=app/survey/result-detail-ctrl.js></script><script src=app/survey/result-list-ctrl.js></script><script src=app/survey/resv-send-list-ctrl.js></script><script src=app/survey/sms-statistic-ctrl.js></script><script src=app/survey/survey-detail-ctrl.js></script><script src=app/survey/survey-edit-ctrl.js></script><script src=app/survey/survey-email-send-ctrl.js></script><script src=app/survey/survey-group-list-ctrl.js></script><script src=app/survey/survey-list-ctrl.js></script><script src=app/survey/survey-send-result-list-ctrl.js></script><script src=app/survey/survey-send-totresult-list-ctrl.js></script><script src=app/survey/survey-sms-send-ctrl.js></script><script src=app/survey/survey-type-edit-ctrl.js></script><script src=app/survey/survey-type-list-ctrl.js></script><script src=app/survey/survey.route.js></script><script src=app/survey/target-result-edit-ctrl.js></script><script src=app/survey/target-result-list-ctrl.js></script><script src=app/survey/trend-analysis-ctrl.js></script><script src=app/system/cafe24-deleteuser-ctrl.js></script><script src=app/system/caretkt-edit-ctrl.js></script><script src=app/system/caretkt-list-ctrl.js></script><script src=app/system/common-properties-ctrl.js></script><script src=app/system/commoncode-api-srv.js></script><script src=app/system/commoncode-list-ctrl.js></script><script src=app/system/company-api-srv.js></script><script src=app/system/company-detail-ctrl.js></script><script src=app/system/company-edit-ctrl.js></script><script src=app/system/company-edit-tab1-ctrl.js></script><script src=app/system/company-edit-tab2-ctrl.js></script><script src=app/system/company-list-ctrl.js></script><script src=app/system/contents-edit-ctrl.js></script><script src=app/system/contents-list-ctrl.js></script><script src=app/system/department-api-srv.js></script><script src=app/system/department-detail-ctrl.js></script><script src=app/system/department-edit-ctrl.js></script><script src=app/system/department-list-ctrl.js></script><script src=app/system/makequery-list-ctrl.js></script><script src=app/system/mastergradefee-list-ctrl.js></script><script src=app/system/menu-manage-list-ctrl.js></script><script src=app/system/pharmagradefee-list-ctrl.js></script><script src=app/system/role-api-srv.js></script><script src=app/system/role-detail-ctrl.js></script><script src=app/system/role-edit-ctrl.js></script><script src=app/system/role-list-ctrl.js></script><script src=app/system/rolescreen-api-srv.js></script><script src=app/system/rolescreen-detail-ctrl.js></script><script src=app/system/rolescreen-edit-ctrl.js></script><script src=app/system/rolescreen-list-ctrl.js></script><script src=app/system/screen-api-srv.js></script><script src=app/system/screen-detail-ctrl.js></script><script src=app/system/screen-edit-ctrl.js></script><script src=app/system/screen-list-ctrl.js></script><script src=app/system/seminar-edit-ctrl.js></script><script src=app/system/seminar-edit-tab1-ctrl.js></script><script src=app/system/seminar-edit-tab2-ctrl.js></script><script src=app/system/seminar-edit-tab3-ctrl.js></script><script src=app/system/seminar-list-ctrl.js></script><script src=app/system/survey-edit-ctrl.js></script><script src=app/system/survey-list-ctrl.js></script><script src=app/system/system-code-api-srv.js></script><script src=app/system/system.route.js></script><script src=app/system/user-detail-ctrl.js></script><script src=app/system/user-edit-ctrl.js></script><script src=app/system/user-edit-tab1-ctrl.js></script><script src=app/system/user-edit-tab2-ctrl.js></script><script src=app/system/user-edit-tab3-ctrl.js></script><script src=app/system/user-list-ctrl.js></script><script src=home/main/main-ctrl.js></script><script src=home/support/support-ctrl.js></script><script src=scripts/directives/asSortable.js></script><script src=scripts/directives/file-dropzoon.js></script><script src=scripts/directives/input-enter-directives.js></script><script src=scripts/directives/kr-input.js></script><script src=scripts/directives/kr-textarea.js></script><script src=scripts/directives/modal-draggable.js></script><script src=scripts/directives/permission.js></script><script src=scripts/directives/tilecontroltoggle.js></script><script src=scripts/filters/byte-check.js></script><script src=scripts/filters/filesize-filter.js></script><script src=scripts/filters/html-string.js></script><script src=scripts/filters/local-to-utc.js></script><script src=scripts/filters/nl2br-string.js></script><script src=scripts/filters/to-locale-date.js></script><script src=scripts/filters/to-locale-datetime.js></script><script src=scripts/filters/utc-to-local.js></script><script src=scripts/file-attach/file-iframe-attach-listener.js></script><script src=scripts/material/sidenav.js></script><script src=scripts/module/borderLayout.js></script><script src=scripts/module/dock.js></script><script src=scripts/pages/header-ctrl.js></script><script src=scripts/scrollStyle/jquery.mCustomScrollbar.js></script><script src=scripts/service/auth-services.js></script><script src=scripts/service/custom-field-api.js></script><script src=scripts/service/helper-service.js></script><script src=scripts/service/iframe-proxy.js></script><script src=scripts/service/post-api.js></script><script src=scripts/service/wjmreport.js></script><script src=scripts/service/wjmsurvey.js></script><script src=components/biz-component/buttons/buttons.component.js></script><script src=components/modal/campaign/favori-modal-ctrl.js></script><script src=components/modal/campaign/form-modal-ctrl.js></script><script src=components/modal/campaign/form-modal2-ctrl.js></script><script src=components/modal/campaign/fre-modal-ctrl.js></script><script src=components/modal/campaign/grpcust-modal-ctrl.js></script><script src=components/modal/campaign/sms-modal-ctrl.js></script><script src=components/modal/campaign/srch-cust-modal-ctrl.js></script><script src=components/modal/campaign/survey-target-edit-modal2-ctrl.js></script><script src=components/modal/campaign/tree-modal-ctrl.js></script><script src=components/modal/careTkt/care-tkt-modal-ctrl.js></script><script src=components/modal/contents/contents-modal-ctrl.js></script><script src=components/modal/cvsreserv/cvsreserv-info-modal-ctrl.js></script><script src=components/modal/customer/counselhist-modal-ctrl.js></script><script src=components/modal/customer/customer-modal-ctrl.js></script><script src=components/modal/dataanalysis/data-group-action-modal-ctrl.js></script><script src=components/modal/dataanalysis/data-group-modal-ctrl.js></script><script src=components/modal/department/dept-modal-ctrl.js></script><script src=components/modal/excel/upload-excel-user-modal-ctrl.js></script><script src=components/modal/findIdPwd/findIdPwd-modal-ctrl.js></script><script src=components/modal/mypage/mypage-modal-ctrl.js></script><script src=components/modal/preview/preview-ctrl.js></script><script src=components/modal/product/product-modal-ctrl.js></script><script src=components/modal/product/productall-modal-ctrl.js></script><script src=components/modal/tenant/tenant-modal-ctrl.js></script><script src=components/modal/tenant/tenant2-modal-ctrl.js></script><script src=components/modal/userRole/userrole-modal-ctrl.js></script><script src=components/modal/survey/classfyinfo-modal-ctrl.js></script><script src=components/modal/survey/menusvy-modal-ctrl.js></script><script src=components/modal/survey/pre-modal-ctrl.js></script><script src=components/modal/survey/qst-modal-ctrl.js></script><script src=components/modal/survey/survey-modal-ctrl.js></script><script src=components/modal/survey/svytype-modal-ctrl.js></script><script src=components/modal/survey/tgt-modal-ctrl.js></script><script src=components/modal/survey/wjm-anal-preview-modal-ctrl.js></script><script src=components/modal/survey/wjm-form-modal-ctrl.js></script><script src=components/modal/survey/wjm-group-edit-modal-ctrl.js></script><script src=components/modal/survey/wjm-group-edit-modal2-ctrl.js></script><script src=components/modal/survey/wjm-group-edit-modal3-ctrl.js></script><script src=components/modal/survey/wjm-pre-modal-ctrl.js></script><script src=components/modal/survey/wjm-qst-modal-ctrl.js></script><script src=components/modal/survey/wjm-qstgoto-modal-ctrl.js></script><script src=components/modal/survey/wjm-qstmove-modal-ctrl.js></script><script src=components/modal/survey/wjm-report-modal-ctrl.js></script><script src=components/modal/survey/wjm-scorelv-lvcont-modal-ctrl.js></script><script src=components/modal/survey/wjm-scorelv-sec-modal-ctrl.js></script><script src=components/modal/survey/wjm-scorelv-tot-modal-ctrl.js></script><script src=components/modal/survey/wjm-send-totresult-modal-ctrl.js></script><script src=components/modal/survey/wjm-survey-modal-ctrl.js></script><script src=components/modal/survey/wjm-survey-multisel-modal-ctrl.js></script><script src=components/modal/survey/wjm-target-edit-modal-ctrl.js></script><script src=components/modal/survey/wjm-target-scorelv-modal-ctrl.js></script><script src=components/modal/survey/wjm-urlpost-modal-ctrl.js></script><script src=components/modal/users/user-modal-ctrl.js></script><script src=components/modal/users/wjm-counselor-modal-ctrl.js></script><script src=components/modal/users/wjm-user-modal-ctrl.js></script><script src=components/ui-component/factory/dock.js></script><script src=components/ui-component/factory/galert-factory.js></script><script src=components/ui-component/factory/gconfirm-factory.js></script><script src=components/ui-component/factory/modal-factory.js></script><script src=components/ui-component/factory/sort-array-factory.js></script><script src=components/ui-component/factory/static-variable-factory.js></script><script src=components/ui-component/factory/uuid-factory.js></script><script src=components/ui-component/controllers/ui-general.js></script><script src=components/ui-component/timeline/timeline.component.js></script><script src=app/dashboard/stats/stats.component.js></script><script src=scripts/directives/common-code-custom/common-code-custom-ctrl.js></script><script src=scripts/directives/common-code-custom/common-code-custom-directive.js></script><script src=scripts/directives/common-code/common-api-srv.js></script><script src=scripts/directives/common-code/common-code-ctrl.js></script><script src=scripts/directives/common-code/common-code-directive.js></script><script src=scripts/directives/common-code-tree/common-code-tree-api-srv.js></script><script src=scripts/directives/common-code-tree/common-code-tree-ctrl.js></script><script src=scripts/directives/common-code-tree/common-code-tree-directive.js></script><script src=scripts/directives/search-condition/search-condition-ctrl.js></script><script src=scripts/directives/search-condition/search-condition-directive.js></script><script src=scripts/directives/select-data-group/select-data-group-ctrl.js></script><script src=scripts/directives/select-data-group/select-data-group-directive.js></script><script src=scripts/directives/udc/udc-detail-ctrl.js></script><script src=scripts/directives/udc/udc-detail-directive.js></script><script src=scripts/directives/udc/udc-edit-ctrl.js></script><script src=scripts/directives/udc/udc-edit-directive.js></script><script src=scripts/directives/udc/udc-search-ctrl.js></script><script src=scripts/directives/udc/udc-search-directive.js></script><script src=scripts/file-attach/directive/file-attach-directive.js></script><script src=scripts/file-attach/directive/file-drop-zone.js></script><script src=scripts/file-attach/controller/file-attach-controller.js></script><script src=scripts/file-attach/factory/file-attach-data-util.js></script><script src=scripts/file-attach/factory/file-upload-listener.js></script><script src=scripts/file-attach/service/file-upload-service.js></script><script src=components/ui-component/layout/header/header.component.js></script><script src=components/ui-component/layout/sidebar/sidebar.component.js></script><script src=components/ui-component/layout/header/header-notification/header-notification.component.js></script><script src=components/ui-component/layout/sidebar/sidebar-search/sidebar-search.component.js></script><!-- endinject --><!-- inject:partials --><!-- angular templates will be automatically converted in js and inserted here --><!-- endinject --><!-- endbuild --><link rel=stylesheet href=assets/css/common.css><link rel=stylesheet href=assets/css/custom-media-width-size.css><link rel=stylesheet href=assets/css/fullcalendar.min.css><link rel=stylesheet href=assets/css/main.css><link rel=stylesheet href=assets/css/style.css><link rel=stylesheet href=assets/css/animate.css><script src=assets/global-constant.js></script><script src=assets/app/common/common.js></script><!--<script src=\"http://dmaps.daum.net/map_js_init/postcode.v2.js\"></script>--><!-- SSL 적용시 호출 --><script src=https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js></script><script src=assets/app/common/FileSaver.min.js></script><script src=assets/app/common/xlsx.full.min.js></script><script src=assets/app/common/fullcalendar.min.js></script><script src=assets/app/common/locale-all.js></script><script src=assets/app/common/signature_pad.min.js></script><script crossorigin=anonymous integrity=sha384-/x1aHz0nKRd6zVUazsV6CbQvjJvr6zQL2CHbQZf3yoLkezyEtZUpqUNnOLW9Nt3v src=https://browser.sentry-cdn.com/5.9.1/bundle.min.js></script><script crossorigin=anonymous src=https://browser.sentry-cdn.com/5.9.1/angular.min.js></script><script src=assets/app/vendor/d3.v3.min.js charset=utf-8></script><script src=assets/app/vendor/d3.layout.cloud.js charset=utf-8></script><script src=../bower_components/css-element-queries/src/ResizeSensor.js></script><script src=../bower_components/css-element-queries/src/ElementQueries.js></script><script type=text/javascript src=https://www.gstatic.com/charts/loader.js></script><script src=assets/app/vendor/html2canvas.js></script><script src=assets/app/vendor/html2canvas.min.js></script><script src=assets/app/common/wow.min.js></script><!--폰트아이콘--><script src=https://kit.fontawesome.com/48797d4313.js crossorigin=anonymous></script><script>Sentry.init({\r\n      dsn: \'https://16048dd690ce403199d465f9e650c996@o484328.ingest.sentry.io/5537304\',\r\n      integrations: [\r\n        new Sentry.Integrations.Angular(),\r\n      ],\r\n\r\n      tracesSampleRate: 1.0,\r\n    });</script><!-- <script src=\"http://cdnjs.cloudflare.com/ajax/libs/waypoints/2.0.3/waypoints.min.js\"></script> bower.json에 추가--><script src=assets/app/common/jquery.counterup.min.js></script><script>new WOW().init();</script></body></html>");}]);